(function (scope) {
    "use strict";
    function F(arity, fun, wrapper) {
        wrapper.a = arity;
        wrapper.f = fun;
        return wrapper;
    }
    function F2(fun) {
        var curried = function (a) {
            return function (b) {
                return fun(a, b);
            };
        };
        curried.a2 = fun;
        return curried;
    }
    function F3(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return fun(a, b, c);
                };
            };
        };
        curried.a3 =
            fun;
        return curried;
    }
    function F4(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return fun(a, b, c, d);
                    };
                };
            };
        };
        curried.a4 = fun;
        return curried;
    }
    function F5(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return fun(a, b, c, d, e);
                        };
                    };
                };
            };
        };
        curried.a5 = fun;
        return curried;
    }
    function F6(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return fun(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
        curried.a6 = fun;
        return curried;
    }
    function F7(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) { return fun(a, b, c, d, e, f, g); };
                            };
                        };
                    };
                };
            };
        };
        curried.
            a7 = fun;
        return curried;
    }
    function F8(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return fun(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
        curried.a8 = fun;
        return curried;
    }
    function F9(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return function (i) {
                                            return fun(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
        curried
            .a9 = fun;
        return curried;
    }
    function A2(fun, a, b) {
        return fun.a2 ? fun.a2(a, b) : fun(a)(b);
    }
    function A3(fun, a, b, c) {
        return fun.a3 ? fun.a3(a, b, c) : fun(a)(b)(c);
    }
    function A4(fun, a, b, c, d) {
        return fun.a4 ? fun.a4(a, b, c, d) : fun(a)(b)(c)(d);
    }
    function A5(fun, a, b, c, d, e) {
        return fun.a5 ? fun.a5(a, b, c, d, e)
            : fun(a)(b)(c)(d)(e);
    }
    function A6(fun, a, b, c, d, e, f) {
        return fun.a6 ? fun.a6(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
    }
    function A7(fun, a, b, c, d, e, f, g) {
        return fun.a7 ? fun.a7(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
    }
    function A8(fun, a, b, c, d, e, f, g, h) {
        return fun.a8 ? fun.a8(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
    }
    function A9(fun, a, b, c, d, e, f, g, h, i) {
        return fun.a9 ? fun.a9(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
    }
    function _Utils_eq(x, y) {
        for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) { }
        return isEqual;
    }
    function _Utils_eqHelp(x, y, depth, stack) {
        if (x === y) {
            return true;
        }
        if (typeof x !== "object" || x === null || y === null) {
            typeof x === "function" && _Debug_crash(5);
            return false;
        }
        if (depth > 100) {
            stack.push(_Utils_Tuple2(x, y));
            return true;
        }
        if (x.$ < 0) {
            x = $elm$core$Dict$toList(x);
            y = $elm$core$Dict$toList(y);
        }
        for (var key in x) {
            if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
                return false;
            }
        }
        return true;
    }
    var _Utils_equal = F2(_Utils_eq);
    var _Utils_notEqual_fn = function (a, b) { return !_Utils_eq(a, b); }, _Utils_notEqual = F2(_Utils_notEqual_fn);
    function _Utils_cmp(x, y, ord) {
        if (typeof x !== "object") {
            return x === y ? 0 : x < y ? -1 : 1;
        }
        if (typeof x.$ === "undefined") {
            return (ord = _Utils_cmp(x.a, y.a))
                ? ord
                : (ord = _Utils_cmp(x.b, y.b))
                    ? ord
                    : _Utils_cmp(x.c, y.c);
        }
        for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) { }
        return ord || (x.b ? 1 : y.b ? -1 : 0);
    }
    var _Utils_lt_fn = function (a, b) { return _Utils_cmp(a, b) < 0; }, _Utils_lt = F2(_Utils_lt_fn);
    var _Utils_le_fn = function (a, b) { return _Utils_cmp(a, b) < 1; }, _Utils_le = F2(_Utils_le_fn);
    var _Utils_gt_fn = function (a, b) { return _Utils_cmp(a, b) > 0; }, _Utils_gt = F2(_Utils_gt_fn);
    var _Utils_ge_fn = function (a, b) { return _Utils_cmp(a, b) >= 0; }, _Utils_ge = F2(_Utils_ge_fn);
    var _Utils_compare_fn = function (x, y) {
        var n = _Utils_cmp(x, y);
        return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
    }, _Utils_compare = F2(_Utils_compare_fn);
    var _Utils_Tuple0 = 0;
    var _Utils_Tuple0_UNUSED = { $: "#0" };
    function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
    function _Utils_Tuple2_UNUSED(a, b) { return { $: "#2", a: a, b: b }; }
    function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
    function _Utils_Tuple3_UNUSED(a, b, c) { return { $: "#3", a: a, b: b, c: c }; }
    function _Utils_chr(c) { return c; }
    function _Utils_chr_UNUSED(c) { return new String(c); }
    function _Utils_update(oldRecord, updatedFields) {
        var newRecord = {};
        for (var key in oldRecord) {
            newRecord[key] = oldRecord[key];
        }
        for (var key in updatedFields) {
            newRecord[key] = updatedFields[key];
        }
        return newRecord;
    }
    var _Utils_append = F2(_Utils_ap);
    function _Utils_ap(xs, ys) {
        if (typeof xs === "string") {
            return xs + ys;
        }
        if (!xs.b) {
            return ys;
        }
        var root = _List_Cons(xs.a, ys);
        xs = xs.b;
        for (var curr = root; xs.b; xs = xs.b) {
            curr = curr.b = _List_Cons(xs.a, ys);
        }
        return root;
    }
    var _List_Nil = { $: 0, a: null, b: null };
    var _List_Nil_UNUSED = { $: "[]" };
    function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
    function _List_Cons_UNUSED(hd, tl) { return { $: "::", a: hd, b: tl }; }
    var _List_cons = F2(_List_Cons);
    function _List_fromArray(arr) {
        var out = _List_Nil;
        for (var i = arr.length; i--;) {
            out = _List_Cons(arr[i], out);
        }
        return out;
    }
    function _List_toArray(xs) {
        for (var out = []; xs.b; xs = xs.b) {
            out.push(xs.a);
        }
        return out;
    }
    var _List_map2_fn = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) {
            arr.push(A2(f, xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2_fn_unwrapped = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) {
            arr.push(f(xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2 = F3(_List_map2_fn);
    var _List_map3_fn = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A3(f, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3_fn_unwrapped = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3 = F4(_List_map3_fn);
    var _List_map4_fn = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4_fn_unwrapped = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4 = F5(_List_map4_fn);
    var _List_map5_fn = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5_fn_unwrapped = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5 = F6(_List_map5_fn);
    var _List_sortBy_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            return _Utils_cmp(f(a), f(b));
        }));
    }, _List_sortBy = F2(_List_sortBy_fn);
    var _List_sortWith_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = A2(f, a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith_fn_unwrapped = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = f(a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith = F2(_List_sortWith_fn);
    var _JsArray_empty = [];
    function _JsArray_singleton(value) {
        return [value];
    }
    function _JsArray_length(array) {
        return array.length;
    }
    var _JsArray_initialize_fn = function (size, offset, func) {
        var result = new Array(size);
        for (var i = 0; i < size; i++) {
            result[i] = func(offset + i);
        }
        return result;
    }, _JsArray_initialize = F3(_JsArray_initialize_fn);
    var _JsArray_initializeFromList_fn = function (max, ls) {
        var result = new Array(max);
        for (var i = 0; i < max && ls.b; i++) {
            result[i] = ls.a;
            ls = ls.b;
        }
        result.length = i;
        return _Utils_Tuple2(result, ls);
    }, _JsArray_initializeFromList = F2(_JsArray_initializeFromList_fn);
    var _JsArray_unsafeGet_fn = function (index, array) {
        return array[index];
    }, _JsArray_unsafeGet = F2(_JsArray_unsafeGet_fn);
    var _JsArray_unsafeSet_fn = function (index, value, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[index] = value;
        return result;
    }, _JsArray_unsafeSet = F3(_JsArray_unsafeSet_fn);
    var _JsArray_push_fn = function (value, array) {
        var length = array.length;
        var result = new Array(length + 1);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[length] = value;
        return result;
    }, _JsArray_push = F2(_JsArray_push_fn);
    var _JsArray_foldl_fn = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldl_fn_unwrapped = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldl = F3(_JsArray_foldl_fn);
    var _JsArray_foldr_fn = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldr_fn_unwrapped = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldr = F3(_JsArray_foldr_fn);
    var _JsArray_map_fn = function (func, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(array[i]);
        }
        return result;
    }, _JsArray_map = F2(_JsArray_map_fn);
    var _JsArray_indexedMap_fn = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = A2(func, offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap_fn_unwrapped = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap = F3(_JsArray_indexedMap_fn);
    var _JsArray_slice_fn = function (from, to, array) {
        return array.slice(from, to);
    }, _JsArray_slice = F3(_JsArray_slice_fn);
    var _JsArray_appendN_fn = function (n, dest, source) {
        var destLen = dest.length;
        var itemsToCopy = n - destLen;
        if (itemsToCopy > source.length) {
            itemsToCopy = source.length;
        }
        var size = destLen + itemsToCopy;
        var result = new Array(size);
        for (var i = 0; i < destLen; i++) {
            result[i] = dest[i];
        }
        for (var i = 0; i < itemsToCopy; i++) {
            result[i + destLen] = source[i];
        }
        return result;
    }, _JsArray_appendN = F3(_JsArray_appendN_fn);
    var _Debug_log_fn = function (tag, value) {
        return value;
    }, _Debug_log = F2(_Debug_log_fn);
    var _Debug_log_UNUSED_fn = function (tag, value) {
        console.log(tag + ": " + _Debug_toString(value));
        return value;
    }, _Debug_log_UNUSED = F2(_Debug_log_UNUSED_fn);
    function _Debug_todo(moduleName, region) {
        return function (message) {
            _Debug_crash(8, moduleName, region, message);
        };
    }
    function _Debug_todoCase(moduleName, region, value) {
        return function (message) {
            _Debug_crash(9, moduleName, region, value, message);
        };
    }
    function _Debug_toString(value) {
        return "<internals>";
    }
    function _Debug_toString_UNUSED(value) {
        return _Debug_toAnsiString(false, value);
    }
    function _Debug_toAnsiString(ansi, value) {
        if (typeof value === "function") {
            return _Debug_internalColor(ansi, "<function>");
        }
        if (typeof value === "boolean") {
            return _Debug_ctorColor(ansi, value ? "True" : "False");
        }
        if (typeof value === "number") {
            return _Debug_numberColor(ansi, value + "");
        }
        if (value instanceof String) {
            return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
        }
        if (typeof value === "string") {
            return _Debug_stringColor(ansi, "\"" + _Debug_addSlashes(value, false) + "\"");
        }
        if (typeof value === "object" && "$" in value) {
            var tag = value.$;
            if (typeof tag === "number") {
                return _Debug_internalColor(ansi, "<internals>");
            }
            if (tag[0] === "#") {
                var output = [];
                for (var k in value) {
                    if (k === "$")
                        continue;
                    output.push(_Debug_toAnsiString(ansi, value[k]));
                }
                return "(" + output.join(",") + ")";
            }
            if (tag === "Set_elm_builtin") {
                return _Debug_ctorColor(ansi, "Set")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
            }
            if (tag === "RBNode_elm_builtin" || tag === "RBEmpty_elm_builtin") {
                return _Debug_ctorColor(ansi, "Dict")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
            }
            if (tag === "Array_elm_builtin") {
                return _Debug_ctorColor(ansi, "Array")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
            }
            if (tag === "::" || tag === "[]") {
                var output = "[";
                value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
                for (; value.b; value = value.b) {
                    output += "," + _Debug_toAnsiString(ansi, value.a);
                }
                return output + "]";
            }
            var output = "";
            for (var i in value) {
                if (i === "$")
                    continue;
                var str = _Debug_toAnsiString(ansi, value[i]);
                var c0 = str[0];
                var parenless = c0 === "{" || c0 === "(" || c0 === "[" || c0 === "<" || c0 === "\"" || str.indexOf(" ") < 0;
                output += " " + (parenless ? str : "(" + str + ")");
            }
            return _Debug_ctorColor(ansi, tag) + output;
        }
        if (typeof DataView === "function" && value instanceof DataView) {
            return _Debug_stringColor(ansi, "<" + value.byteLength + " bytes>");
        }
        if (typeof File !== "undefined" && value instanceof File) {
            return _Debug_internalColor(ansi, "<" + value.name + ">");
        }
        if (typeof value === "object") {
            var output = [];
            for (var key in value) {
                var field = key[0] === "_" ? key.slice(1) : key;
                output.push(_Debug_fadeColor(ansi, field) + " = " + _Debug_toAnsiString(ansi, value[key]));
            }
            if (output.length === 0) {
                return "{}";
            }
            return "{ " + output.join(", ") + " }";
        }
        return _Debug_internalColor(ansi, "<internals>");
    }
    function _Debug_addSlashes(str, isChar) {
        var s = str
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\t/g, "\\t")
            .replace(/\r/g, "\\r")
            .replace(/\v/g, "\\v")
            .replace(/\0/g, "\\0");
        if (isChar) {
            return s.replace(/\'/g, "\\'");
        }
        else {
            return s.replace(/\"/g, "\\\"");
        }
    }
    function _Debug_ctorColor(ansi, string) {
        return ansi ? "\u001B[96m" + string + "\u001B[0m" : string;
    }
    function _Debug_numberColor(ansi, string) {
        return ansi ? "\u001B[95m" + string + "\u001B[0m" : string;
    }
    function _Debug_stringColor(ansi, string) {
        return ansi ? "\u001B[93m" + string + "\u001B[0m" : string;
    }
    function _Debug_charColor(ansi, string) {
        return ansi ? "\u001B[92m" + string + "\u001B[0m" : string;
    }
    function _Debug_fadeColor(ansi, string) {
        return ansi ? "\u001B[37m" + string + "\u001B[0m" : string;
    }
    function _Debug_internalColor(ansi, string) {
        return ansi ? "\u001B[36m" + string + "\u001B[0m" : string;
    }
    function _Debug_toHexDigit(n) {
        return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
    }
    function _Debug_crash(identifier) {
        throw new Error("https://github.com/elm/core/blob/1.0.0/hints/" + identifier + ".md");
    }
    function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
        switch (identifier) {
            case 0:
                throw new Error("What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById(\"elm-node\")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.");
            case 1:
                throw new Error("Browser.application programs cannot handle URLs like this:\n\n    " + document.location.href + "\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.");
            case 2:
                var jsonErrorString = fact1;
                throw new Error("Problem with the flags given to your Elm program on initialization.\n\n" + jsonErrorString);
            case 3:
                var portName = fact1;
                throw new Error("There can only be one port named `" + portName + "`, but your program has multiple.");
            case 4:
                var portName = fact1;
                var problem = fact2;
                throw new Error("Trying to send an unexpected type of value through port `" + portName + "`:\n" + problem);
            case 5:
                throw new Error("Trying to use `(==)` on functions.\nThere is no way to know if functions are \"the same\" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.");
            case 6:
                var moduleName = fact1;
                throw new Error("Your page is loading multiple Elm scripts with a module named " + moduleName + ". Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!");
            case 8:
                var moduleName = fact1;
                var region = fact2;
                var message = fact3;
                throw new Error("TODO in module `" + moduleName + "` " + _Debug_regionToString(region) + "\n\n" + message);
            case 9:
                var moduleName = fact1;
                var region = fact2;
                var value = fact3;
                var message = fact4;
                throw new Error("TODO in module `" + moduleName + "` from the `case` expression "
                    + _Debug_regionToString(region) + "\n\nIt received the following value:\n\n    "
                    + _Debug_toString(value).replace("\n", "\n    ")
                    + "\n\nBut the branch that handles it says:\n\n    " + message.replace("\n", "\n    "));
            case 10:
                throw new Error("Bug in https://github.com/elm/virtual-dom/issues");
            case 11:
                throw new Error("Cannot perform mod 0. Division by zero error.");
        }
    }
    function _Debug_regionToString(region) {
        if (region.x.m6 === region.u.m6) {
            return "on line " + region.x.m6;
        }
        return "on lines " + region.x.m6 + " through " + region.u.m6;
    }
    var _Basics_add_fn = function (a, b) { return a + b; }, _Basics_add = F2(_Basics_add_fn);
    var _Basics_sub_fn = function (a, b) { return a - b; }, _Basics_sub = F2(_Basics_sub_fn);
    var _Basics_mul_fn = function (a, b) { return a * b; }, _Basics_mul = F2(_Basics_mul_fn);
    var _Basics_fdiv_fn = function (a, b) { return a / b; }, _Basics_fdiv = F2(_Basics_fdiv_fn);
    var _Basics_idiv_fn = function (a, b) { return (a / b) | 0; }, _Basics_idiv = F2(_Basics_idiv_fn);
    var _Basics_pow_fn = Math.pow, _Basics_pow = F2(_Basics_pow_fn);
    var _Basics_remainderBy_fn = function (b, a) { return a % b; }, _Basics_remainderBy = F2(_Basics_remainderBy_fn);
    var _Basics_modBy_fn = function (modulus, x) {
        var answer = x % modulus;
        return modulus === 0
            ? _Debug_crash(11)
            :
                ((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
                    ? answer + modulus
                    : answer;
    }, _Basics_modBy = F2(_Basics_modBy_fn);
    var _Basics_pi = Math.PI;
    var _Basics_e = Math.E;
    var _Basics_cos = Math.cos;
    var _Basics_sin = Math.sin;
    var _Basics_tan = Math.tan;
    var _Basics_acos = Math.acos;
    var _Basics_asin = Math.asin;
    var _Basics_atan = Math.atan;
    var _Basics_atan2_fn = Math.atan2, _Basics_atan2 = F2(_Basics_atan2_fn);
    function _Basics_toFloat(x) { return x; }
    function _Basics_truncate(n) { return n | 0; }
    function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
    var _Basics_ceiling = Math.ceil;
    var _Basics_floor = Math.floor;
    var _Basics_round = Math.round;
    var _Basics_sqrt = Math.sqrt;
    var _Basics_log = Math.log;
    var _Basics_isNaN = isNaN;
    function _Basics_not(bool) { return !bool; }
    var _Basics_and_fn = function (a, b) { return a && b; }, _Basics_and = F2(_Basics_and_fn);
    var _Basics_or_fn = function (a, b) { return a || b; }, _Basics_or = F2(_Basics_or_fn);
    var _Basics_xor_fn = function (a, b) { return a !== b; }, _Basics_xor = F2(_Basics_xor_fn);
    var _String_cons_fn = function (chr, str) {
        return chr + str;
    }, _String_cons = F2(_String_cons_fn);
    function _String_uncons(string) {
        var word = string.charCodeAt(0);
        return !isNaN(word)
            ? $elm$core$Maybe$Just(55296 <= word && word <= 56319
                ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
                : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1)))
            : $elm$core$Maybe$Nothing;
    }
    var _String_append_fn = function (a, b) {
        return a + b;
    }, _String_append = F2(_String_append_fn);
    function _String_length(str) {
        return str.length;
    }
    var _String_map_fn = function (func, string) {
        var len = string.length;
        var array = new Array(len);
        var i = 0;
        while (i < len) {
            var word = string.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                array[i] = func(_Utils_chr(string[i] + string[i + 1]));
                i += 2;
                continue;
            }
            array[i] = func(_Utils_chr(string[i]));
            i++;
        }
        return array.join("");
    }, _String_map = F2(_String_map_fn);
    var _String_filter_fn = function (isGood, str) {
        var arr = [];
        var len = str.length;
        var i = 0;
        while (i < len) {
            var char = str[i];
            var word = str.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += str[i];
                i++;
            }
            if (isGood(_Utils_chr(char))) {
                arr.push(char);
            }
        }
        return arr.join("");
    }, _String_filter = F2(_String_filter_fn);
    function _String_reverse(str) {
        var len = str.length;
        var arr = new Array(len);
        var i = 0;
        while (i < len) {
            var word = str.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                arr[len - i] = str[i + 1];
                i++;
                arr[len - i] = str[i - 1];
                i++;
            }
            else {
                arr[len - i] = str[i];
                i++;
            }
        }
        return arr.join("");
    }
    var _String_foldl_fn = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldl_fn_unwrapped = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldl = F3(_String_foldl_fn);
    var _String_foldr_fn = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldr_fn_unwrapped = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldr = F3(_String_foldr_fn);
    var _String_split_fn = function (sep, str) {
        return str.split(sep);
    }, _String_split = F2(_String_split_fn);
    var _String_join_fn = function (sep, strs) {
        return strs.join(sep);
    }, _String_join = F2(_String_join_fn);
    var _String_slice_fn = function (start, end, str) {
        return str.slice(start, end);
    }, _String_slice = F3(_String_slice_fn);
    function _String_trim(str) {
        return str.trim();
    }
    function _String_trimLeft(str) {
        return str.replace(/^\s+/, "");
    }
    function _String_trimRight(str) {
        return str.replace(/\s+$/, "");
    }
    function _String_words(str) {
        return _List_fromArray(str.trim().split(/\s+/g));
    }
    function _String_lines(str) {
        return _List_fromArray(str.split(/\r\n|\r|\n/g));
    }
    function _String_toUpper(str) {
        return str.toUpperCase();
    }
    function _String_toLower(str) {
        return str.toLowerCase();
    }
    var _String_any_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (isGood(_Utils_chr(char))) {
                return true;
            }
        }
        return false;
    }, _String_any = F2(_String_any_fn);
    var _String_all_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (!isGood(_Utils_chr(char))) {
                return false;
            }
        }
        return true;
    }, _String_all = F2(_String_all_fn);
    var _String_contains_fn = function (sub, str) {
        return str.indexOf(sub) > -1;
    }, _String_contains = F2(_String_contains_fn);
    var _String_startsWith_fn = function (sub, str) {
        return str.indexOf(sub) === 0;
    }, _String_startsWith = F2(_String_startsWith_fn);
    var _String_endsWith_fn = function (sub, str) {
        return str.length >= sub.length &&
            str.lastIndexOf(sub) === str.length - sub.length;
    }, _String_endsWith = F2(_String_endsWith_fn);
    var _String_indexes_fn = function (sub, str) {
        var subLen = sub.length;
        if (subLen < 1) {
            return _List_Nil;
        }
        var i = 0;
        var is = [];
        while ((i = str.indexOf(sub, i)) > -1) {
            is.push(i);
            i = i + subLen;
        }
        return _List_fromArray(is);
    }, _String_indexes = F2(_String_indexes_fn);
    function _String_fromNumber(number) {
        return number + "";
    }
    function _String_toInt(str) {
        var total = 0;
        var code0 = str.charCodeAt(0);
        var start = code0 == 43 || code0 == 45 ? 1 : 0;
        for (var i = start; i < str.length; ++i) {
            var code = str.charCodeAt(i);
            if (code < 48 || 57 < code) {
                return $elm$core$Maybe$Nothing;
            }
            total = 10 * total + code - 48;
        }
        return i == start
            ? $elm$core$Maybe$Nothing
            : $elm$core$Maybe$Just(code0 == 45 ? -total : total);
    }
    function _String_toFloat(s) {
        if (s.length === 0 || /[\sxbo]/.test(s)) {
            return $elm$core$Maybe$Nothing;
        }
        var n = +s;
        return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
    }
    function _String_fromList(chars) {
        return _List_toArray(chars).join("");
    }
    function _Char_toCode(char) {
        var code = char.charCodeAt(0);
        if (55296 <= code && code <= 56319) {
            return (code - 55296) * 1024 + char.charCodeAt(1) - 56320 + 65536;
        }
        return code;
    }
    function _Char_fromCode(code) {
        return _Utils_chr((code < 0 || 1114111 < code)
            ? "\uFFFD"
            :
                (code <= 65535)
                    ? String.fromCharCode(code)
                    :
                        (code -= 65536,
                            String.fromCharCode(Math.floor(code / 1024) + 55296, code % 1024 + 56320)));
    }
    function _Char_toUpper(char) {
        return _Utils_chr(char.toUpperCase());
    }
    function _Char_toLower(char) {
        return _Utils_chr(char.toLowerCase());
    }
    function _Char_toLocaleUpper(char) {
        return _Utils_chr(char.toLocaleUpperCase());
    }
    function _Char_toLocaleLower(char) {
        return _Utils_chr(char.toLocaleLowerCase());
    }
    function _Json_succeed(msg) {
        return {
            $: 0,
            a: msg
        };
    }
    function _Json_fail(msg) {
        return {
            $: 1,
            a: msg
        };
    }
    function _Json_decodePrim(decoder) {
        return { $: 2, b: decoder };
    }
    var _Json_decodeInt = _Json_decodePrim(function (value) {
        return (typeof value !== "number")
            ? _Json_expecting("an INT", value)
            :
                (-2147483647 < value && value < 2147483647 && (value | 0) === value)
                    ? $elm$core$Result$Ok(value)
                    :
                        (isFinite(value) && !(value % 1))
                            ? $elm$core$Result$Ok(value)
                            : _Json_expecting("an INT", value);
    });
    var _Json_decodeBool = _Json_decodePrim(function (value) {
        return (typeof value === "boolean")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a BOOL", value);
    });
    var _Json_decodeFloat = _Json_decodePrim(function (value) {
        return (typeof value === "number")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a FLOAT", value);
    });
    var _Json_decodeValue = _Json_decodePrim(function (value) {
        return $elm$core$Result$Ok(_Json_wrap(value));
    });
    var _Json_decodeString = _Json_decodePrim(function (value) {
        return (typeof value === "string")
            ? $elm$core$Result$Ok(value)
            : (value instanceof String)
                ? $elm$core$Result$Ok(value + "")
                : _Json_expecting("a STRING", value);
    });
    function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
    function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
    function _Json_decodeNull(value) { return { $: 5, c: value }; }
    var _Json_decodeField_fn = function (field, decoder) {
        return {
            $: 6,
            d: field,
            b: decoder
        };
    }, _Json_decodeField = F2(_Json_decodeField_fn);
    var _Json_decodeIndex_fn = function (index, decoder) {
        return {
            $: 7,
            e: index,
            b: decoder
        };
    }, _Json_decodeIndex = F2(_Json_decodeIndex_fn);
    function _Json_decodeKeyValuePairs(decoder) {
        return {
            $: 8,
            b: decoder
        };
    }
    function _Json_mapMany(f, decoders) {
        return {
            $: 9,
            f: f,
            g: decoders
        };
    }
    var _Json_andThen_fn = function (callback, decoder) {
        return {
            $: 10,
            b: decoder,
            h: callback
        };
    }, _Json_andThen = F2(_Json_andThen_fn);
    function _Json_oneOf(decoders) {
        return {
            $: 11,
            g: decoders
        };
    }
    var _Json_map1_fn = function (f, d1) {
        return _Json_mapMany(f, [d1]);
    }, _Json_map1 = F2(_Json_map1_fn);
    var _Json_map2_fn = function (f, d1, d2) {
        return _Json_mapMany(f, [d1, d2]);
    }, _Json_map2 = F3(_Json_map2_fn);
    var _Json_map3_fn = function (f, d1, d2, d3) {
        return _Json_mapMany(f, [d1, d2, d3]);
    }, _Json_map3 = F4(_Json_map3_fn);
    var _Json_map4_fn = function (f, d1, d2, d3, d4) {
        return _Json_mapMany(f, [d1, d2, d3, d4]);
    }, _Json_map4 = F5(_Json_map4_fn);
    var _Json_map5_fn = function (f, d1, d2, d3, d4, d5) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
    }, _Json_map5 = F6(_Json_map5_fn);
    var _Json_map6_fn = function (f, d1, d2, d3, d4, d5, d6) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
    }, _Json_map6 = F7(_Json_map6_fn);
    var _Json_map7_fn = function (f, d1, d2, d3, d4, d5, d6, d7) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
    }, _Json_map7 = F8(_Json_map7_fn);
    var _Json_map8_fn = function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
    }, _Json_map8 = F9(_Json_map8_fn);
    var _Json_runOnString_fn = function (decoder, string) {
        try {
            var value = JSON.parse(string);
            return _Json_runHelp(decoder, value);
        }
        catch (e) {
            return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("This is not valid JSON! " + e.message, _Json_wrap(string)));
        }
    }, _Json_runOnString = F2(_Json_runOnString_fn);
    var _Json_run_fn = function (decoder, value) {
        return _Json_runHelp(decoder, _Json_unwrap(value));
    }, _Json_run = F2(_Json_run_fn);
    function _Json_runHelp(decoder, value) {
        switch (decoder.$) {
            case 2:
                return decoder.b(value);
            case 5:
                return (value === null)
                    ? $elm$core$Result$Ok(decoder.c)
                    : _Json_expecting("null", value);
            case 3:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("a LIST", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
            case 4:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
            case 6:
                var field = decoder.d;
                if (typeof value !== "object" || value === null || !(field in value)) {
                    return _Json_expecting("an OBJECT with a field named `" + field + "`", value);
                }
                var result = _Json_runHelp(decoder.b, value[field]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(field, result.a));
            case 7:
                var index = decoder.e;
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                if (index >= value.length) {
                    return _Json_expecting("a LONGER array. Need index " + index + " but only see " + value.length + " entries", value);
                }
                var result = _Json_runHelp(decoder.b, value[index]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(index, result.a));
            case 8:
                if (typeof value !== "object" || value === null || _Json_isArray(value)) {
                    return _Json_expecting("an OBJECT", value);
                }
                var keyValuePairs = _List_Nil;
                for (var key in value) {
                    if (value.hasOwnProperty(key)) {
                        var result = _Json_runHelp(decoder.b, value[key]);
                        if (!$elm$core$Result$isOk(result)) {
                            return $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(key, result.a));
                        }
                        keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
                    }
                }
                return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
            case 9:
                var answer = decoder.f;
                var decoders = decoder.g;
                for (var i = 0; i < decoders.length; i++) {
                    var result = _Json_runHelp(decoders[i], value);
                    if (!$elm$core$Result$isOk(result)) {
                        return result;
                    }
                    answer = answer(result.a);
                }
                return $elm$core$Result$Ok(answer);
            case 10:
                var result = _Json_runHelp(decoder.b, value);
                return (!$elm$core$Result$isOk(result))
                    ? result
                    : _Json_runHelp(decoder.h(result.a), value);
            case 11:
                var errors = _List_Nil;
                for (var temp = decoder.g; temp.b; temp = temp.b) {
                    var result = _Json_runHelp(temp.a, value);
                    if ($elm$core$Result$isOk(result)) {
                        return result;
                    }
                    errors = _List_Cons(result.a, errors);
                }
                return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
            case 1:
                return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn(decoder.a, _Json_wrap(value)));
            case 0:
                return $elm$core$Result$Ok(decoder.a);
        }
    }
    function _Json_runArrayDecoder(decoder, value, toElmValue) {
        var len = value.length;
        var array = new Array(len);
        for (var i = 0; i < len; i++) {
            var result = _Json_runHelp(decoder, value[i]);
            if (!$elm$core$Result$isOk(result)) {
                return $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(i, result.a));
            }
            array[i] = result.a;
        }
        return $elm$core$Result$Ok(toElmValue(array));
    }
    function _Json_isArray(value) {
        return Array.isArray(value) || (typeof FileList !== "undefined" && value instanceof FileList);
    }
    function _Json_toElmArray(array) {
        return $elm$core$Array$initialize_fn(array.length, function (i) { return array[i]; });
    }
    function _Json_expecting(type, value) {
        return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("Expecting " + type, _Json_wrap(value)));
    }
    function _Json_equality(x, y) {
        if (x === y) {
            return true;
        }
        if (x.$ !== y.$) {
            return false;
        }
        switch (x.$) {
            case 0:
            case 1:
                return x.a === y.a;
            case 2:
                return x.b === y.b;
            case 5:
                return x.c === y.c;
            case 3:
            case 4:
            case 8:
                return _Json_equality(x.b, y.b);
            case 6:
                return x.d === y.d && _Json_equality(x.b, y.b);
            case 7:
                return x.e === y.e && _Json_equality(x.b, y.b);
            case 9:
                return x.f === y.f && _Json_listEquality(x.g, y.g);
            case 10:
                return x.h === y.h && _Json_equality(x.b, y.b);
            case 11:
                return _Json_listEquality(x.g, y.g);
        }
    }
    function _Json_listEquality(aDecoders, bDecoders) {
        var len = aDecoders.length;
        if (len !== bDecoders.length) {
            return false;
        }
        for (var i = 0; i < len; i++) {
            if (!_Json_equality(aDecoders[i], bDecoders[i])) {
                return false;
            }
        }
        return true;
    }
    var _Json_encode_fn = function (indentLevel, value) {
        return JSON.stringify(_Json_unwrap(value), null, indentLevel) + "";
    }, _Json_encode = F2(_Json_encode_fn);
    function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
    function _Json_unwrap_UNUSED(value) { return value.a; }
    function _Json_wrap(value) { return value; }
    function _Json_unwrap(value) { return value; }
    function _Json_emptyArray() { return []; }
    function _Json_emptyObject() { return {}; }
    var _Json_addField_fn = function (key, value, object) {
        object[key] = _Json_unwrap(value);
        return object;
    }, _Json_addField = F3(_Json_addField_fn);
    function _Json_addEntry(func) {
        return F2(function (entry, array) {
            array.push(_Json_unwrap(func(entry)));
            return array;
        });
    }
    var _Json_encodeNull = _Json_wrap(null);
    function _Scheduler_succeed(value) {
        return {
            $: 0,
            a: value
        };
    }
    function _Scheduler_fail(error) {
        return {
            $: 1,
            a: error
        };
    }
    function _Scheduler_binding(callback) {
        return {
            $: 2,
            b: callback,
            c: null
        };
    }
    var _Scheduler_andThen_fn = function (callback, task) {
        return {
            $: 3,
            b: callback,
            d: task
        };
    }, _Scheduler_andThen = F2(_Scheduler_andThen_fn);
    var _Scheduler_onError_fn = function (callback, task) {
        return {
            $: 4,
            b: callback,
            d: task
        };
    }, _Scheduler_onError = F2(_Scheduler_onError_fn);
    function _Scheduler_receive(callback) {
        return {
            $: 5,
            b: callback
        };
    }
    var _Scheduler_guid = 0;
    function _Scheduler_rawSpawn(task) {
        var proc = {
            $: 0,
            e: _Scheduler_guid++,
            f: task,
            g: null,
            h: []
        };
        _Scheduler_enqueue(proc);
        return proc;
    }
    function _Scheduler_spawn(task) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
        });
    }
    function _Scheduler_rawSend(proc, msg) {
        proc.h.push(msg);
        _Scheduler_enqueue(proc);
    }
    var _Scheduler_send_fn = function (proc, msg) {
        return _Scheduler_binding(function (callback) {
            _Scheduler_rawSend(proc, msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Scheduler_send = F2(_Scheduler_send_fn);
    function _Scheduler_kill(proc) {
        return _Scheduler_binding(function (callback) {
            var task = proc.f;
            if (task.$ === 2 && task.c) {
                task.c();
            }
            proc.f = null;
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }
    var _Scheduler_working = false;
    var _Scheduler_queue = [];
    function _Scheduler_enqueue(proc) {
        _Scheduler_queue.push(proc);
        if (_Scheduler_working) {
            return;
        }
        _Scheduler_working = true;
        while (proc = _Scheduler_queue.shift()) {
            _Scheduler_step(proc);
        }
        _Scheduler_working = false;
    }
    function _Scheduler_step(proc) {
        while (proc.f) {
            var rootTag = proc.f.$;
            if (rootTag === 0 || rootTag === 1) {
                while (proc.g && proc.g.$ !== rootTag) {
                    proc.g = proc.g.i;
                }
                if (!proc.g) {
                    return;
                }
                proc.f = proc.g.b(proc.f.a);
                proc.g = proc.g.i;
            }
            else if (rootTag === 2) {
                proc.f.c = proc.f.b(function (newRoot) {
                    proc.f = newRoot;
                    _Scheduler_enqueue(proc);
                });
                return;
            }
            else if (rootTag === 5) {
                if (proc.h.length === 0) {
                    return;
                }
                proc.f = proc.f.b(proc.h.shift());
            }
            else {
                proc.g = {
                    $: rootTag === 3 ? 0 : 1,
                    b: proc.f.b,
                    i: proc.g
                };
                proc.f = proc.f.d;
            }
        }
    }
    function _Process_sleep(time) {
        return _Scheduler_binding(function (callback) {
            var id = setTimeout(function () {
                callback(_Scheduler_succeed(_Utils_Tuple0));
            }, time);
            return function () { clearTimeout(id); };
        });
    }
    var _Platform_worker_fn = function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.mM, impl.pw, impl.o4, function () { return function () { }; });
    }, _Platform_worker = F4(_Platform_worker_fn);
    function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
        var result = _Json_run_fn(flagDecoder, _Json_wrap(args ? args["flags"] : undefined));
        $elm$core$Result$isOk(result) || _Debug_crash(2);
        var managers = {};
        var initPair = init(result.a);
        var model = initPair.a;
        var stepper = stepperBuilder(sendToApp, model);
        var ports = _Platform_setupEffects(managers, sendToApp);
        function sendToApp(msg, viewMetadata) {
            var pair = A2(update, msg, model);
            stepper(model = pair.a, viewMetadata);
            _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
        }
        _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
        return ports ? { ports: ports } : {};
    }
    var _Platform_preload;
    function _Platform_registerPreload(url) {
        _Platform_preload.add(url);
    }
    var _Platform_effectManagers = {};
    function _Platform_setupEffects(managers, sendToApp) {
        var ports;
        for (var key in _Platform_effectManagers) {
            var manager = _Platform_effectManagers[key];
            if (manager.a) {
                ports = ports || {};
                ports[key] = manager.a(key, sendToApp);
            }
            managers[key] = _Platform_instantiateManager(manager, sendToApp);
        }
        return ports;
    }
    function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
        return {
            b: init,
            c: onEffects,
            d: onSelfMsg,
            e: cmdMap,
            f: subMap
        };
    }
    function _Platform_instantiateManager(info, sendToApp) {
        var router = {
            g: sendToApp,
            h: undefined
        };
        var onEffects = info.c;
        var onSelfMsg = info.d;
        var cmdMap = info.e;
        var subMap = info.f;
        function loop(state) {
            return _Scheduler_andThen_fn(loop, _Scheduler_receive(function (msg) {
                var value = msg.a;
                if (msg.$ === 0) {
                    return A3(onSelfMsg, router, value, state);
                }
                return cmdMap && subMap
                    ? A4(onEffects, router, value.i, value.j, state)
                    : A3(onEffects, router, cmdMap ? value.i : value.j, state);
            }));
        }
        return router.h = _Scheduler_rawSpawn(_Scheduler_andThen_fn(loop, info.b));
    }
    var _Platform_sendToApp_fn = function (router, msg) {
        return _Scheduler_binding(function (callback) {
            router.g(msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Platform_sendToApp = F2(_Platform_sendToApp_fn);
    var _Platform_sendToSelf_fn = function (router, msg) {
        return _Scheduler_send_fn(router.h, {
            $: 0,
            a: msg
        });
    }, _Platform_sendToSelf = F2(_Platform_sendToSelf_fn);
    function _Platform_leaf(home) {
        return function (value) {
            return {
                $: 1,
                k: home,
                l: value
            };
        };
    }
    function _Platform_batch(list) {
        return {
            $: 2,
            m: list
        };
    }
    var _Platform_map_fn = function (tagger, bag) {
        return {
            $: 3,
            n: tagger,
            o: bag
        };
    }, _Platform_map = F2(_Platform_map_fn);
    var _Platform_effectsQueue = [];
    var _Platform_effectsActive = false;
    function _Platform_enqueueEffects(managers, cmdBag, subBag) {
        _Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });
        if (_Platform_effectsActive)
            return;
        _Platform_effectsActive = true;
        for (var fx; fx = _Platform_effectsQueue.shift();) {
            _Platform_dispatchEffects(fx.p, fx.q, fx.r);
        }
        _Platform_effectsActive = false;
    }
    function _Platform_dispatchEffects(managers, cmdBag, subBag) {
        var effectsDict = {};
        _Platform_gatherEffects(true, cmdBag, effectsDict, null);
        _Platform_gatherEffects(false, subBag, effectsDict, null);
        for (var home in managers) {
            _Scheduler_rawSend(managers[home], {
                $: "fx",
                a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
            });
        }
    }
    function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
        switch (bag.$) {
            case 1:
                var home = bag.k;
                var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
                effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
                return;
            case 2:
                for (var list = bag.m; list.b; list = list.b) {
                    _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
                }
                return;
            case 3:
                _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
                    s: bag.n,
                    t: taggers
                });
                return;
        }
    }
    function _Platform_toEffect(isCmd, home, taggers, value) {
        function applyTaggers(x) {
            for (var temp = taggers; temp; temp = temp.t) {
                x = temp.s(x);
            }
            return x;
        }
        var map = isCmd
            ? _Platform_effectManagers[home].e
            : _Platform_effectManagers[home].f;
        return A2(map, applyTaggers, value);
    }
    function _Platform_insert(isCmd, newEffect, effects) {
        effects = effects || { i: _List_Nil, j: _List_Nil };
        isCmd
            ? (effects.i = _List_Cons(newEffect, effects.i))
            : (effects.j = _List_Cons(newEffect, effects.j));
        return effects;
    }
    function _Platform_checkPortName(name) {
        if (_Platform_effectManagers[name]) {
            _Debug_crash(3, name);
        }
    }
    function _Platform_outgoingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            e: _Platform_outgoingPortMap,
            u: converter,
            a: _Platform_setupOutgoingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_outgoingPortMap_fn = function (tagger, value) { return value; }, _Platform_outgoingPortMap = F2(_Platform_outgoingPortMap_fn);
    function _Platform_setupOutgoingPort(name) {
        var subs = [];
        var converter = _Platform_effectManagers[name].u;
        var init = _Process_sleep(0);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
            for (; cmdList.b; cmdList = cmdList.b) {
                var currentSubs = subs;
                var value = _Json_unwrap(converter(cmdList.a));
                for (var i = 0; i < currentSubs.length; i++) {
                    currentSubs[i](value);
                }
            }
            return init;
        });
        function subscribe(callback) {
            subs.push(callback);
        }
        function unsubscribe(callback) {
            subs = subs.slice();
            var index = subs.indexOf(callback);
            if (index >= 0) {
                subs.splice(index, 1);
            }
        }
        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }
    function _Platform_incomingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            f: _Platform_incomingPortMap,
            u: converter,
            a: _Platform_setupIncomingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_incomingPortMap_fn = function (tagger, finalTagger) {
        return function (value) {
            return tagger(finalTagger(value));
        };
    }, _Platform_incomingPortMap = F2(_Platform_incomingPortMap_fn);
    function _Platform_setupIncomingPort(name, sendToApp) {
        var subs = _List_Nil;
        var converter = _Platform_effectManagers[name].u;
        var init = _Scheduler_succeed(null);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, subList, state) {
            subs = subList;
            return init;
        });
        function send(incomingValue) {
            var result = _Json_run_fn(converter, _Json_wrap(incomingValue));
            $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
            var value = result.a;
            for (var temp = subs; temp.b; temp = temp.b) {
                sendToApp(temp.a(value));
            }
        }
        return { send: send };
    }
    function _Platform_export(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsProd(scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsProd(obj, exports) {
        for (var name in exports) {
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6)
                    : _Platform_mergeExportsProd(obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    function _Platform_export_UNUSED(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsDebug("Elm", scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsDebug(moduleName, obj, exports) {
        for (var name in exports) {
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6, moduleName)
                    : _Platform_mergeExportsDebug(moduleName + "." + name, obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    var _VirtualDom_divertHrefToApp;
    var _VirtualDom_doc = typeof document !== "undefined" ? document : {};
    function _VirtualDom_appendChild(parent, child) {
        parent.appendChild(child);
    }
    var _VirtualDom_init_fn = function (virtualNode, flagDecoder, debugMetadata, args) {
        var node = args["node"];
        node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () { }), node);
        return {};
    }, _VirtualDom_init = F4(_VirtualDom_init_fn);
    function _VirtualDom_text(string) {
        return {
            $: 0,
            a: string
        };
    }
    var _VirtualDom_nodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) {
                var kid = kidList.a;
                descendantsCount += (kid.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 1,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_nodeNS = F2(_VirtualDom_nodeNS_fn);
    var _VirtualDom_node_a0 = undefined, _VirtualDom_node = _VirtualDom_nodeNS(_VirtualDom_node_a0);
    var _VirtualDom_keyedNodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) {
                var kid = kidList.a;
                descendantsCount += (kid.b.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 2,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_keyedNodeNS = F2(_VirtualDom_keyedNodeNS_fn);
    var _VirtualDom_keyedNode_a0 = undefined, _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(_VirtualDom_keyedNode_a0);
    function _VirtualDom_custom(factList, model, render, diff) {
        return {
            $: 3,
            d: _VirtualDom_organizeFacts(factList),
            g: model,
            h: render,
            i: diff
        };
    }
    var _VirtualDom_map_fn = function (tagger, node) {
        return {
            $: 4,
            j: tagger,
            k: node,
            b: 1 + (node.b || 0)
        };
    }, _VirtualDom_map = F2(_VirtualDom_map_fn);
    function _VirtualDom_thunk(refs, thunk) {
        return {
            $: 5,
            l: refs,
            m: thunk,
            k: undefined
        };
    }
    var _VirtualDom_lazy_fn = function (func, a) {
        return _VirtualDom_thunk([func, a], function () {
            return func(a);
        });
    }, _VirtualDom_lazy = F2(_VirtualDom_lazy_fn);
    var _VirtualDom_lazy2_fn = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return A2(func, a, b);
        });
    }, _VirtualDom_lazy2_fn_unwrapped = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return func(a, b);
        });
    }, _VirtualDom_lazy2 = F3(_VirtualDom_lazy2_fn);
    var _VirtualDom_lazy3_fn = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return A3(func, a, b, c);
        });
    }, _VirtualDom_lazy3_fn_unwrapped = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return func(a, b, c);
        });
    }, _VirtualDom_lazy3 = F4(_VirtualDom_lazy3_fn);
    var _VirtualDom_lazy4_fn = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return A4(func, a, b, c, d);
        });
    }, _VirtualDom_lazy4_fn_unwrapped = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return func(a, b, c, d);
        });
    }, _VirtualDom_lazy4 = F5(_VirtualDom_lazy4_fn);
    var _VirtualDom_lazy5_fn = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return A5(func, a, b, c, d, e);
        });
    }, _VirtualDom_lazy5_fn_unwrapped = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return func(a, b, c, d, e);
        });
    }, _VirtualDom_lazy5 = F6(_VirtualDom_lazy5_fn);
    var _VirtualDom_lazy6_fn = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return A6(func, a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6_fn_unwrapped = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return func(a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6 = F7(_VirtualDom_lazy6_fn);
    var _VirtualDom_lazy7_fn = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return A7(func, a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7_fn_unwrapped = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return func(a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7 = F8(_VirtualDom_lazy7_fn);
    var _VirtualDom_lazy8_fn = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return A8(func, a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8_fn_unwrapped = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return func(a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8 = F9(_VirtualDom_lazy8_fn);
    var _VirtualDom_on_fn = function (key, handler) {
        return {
            $: "a0",
            n: key,
            o: handler
        };
    }, _VirtualDom_on = F2(_VirtualDom_on_fn);
    var _VirtualDom_style_fn = function (key, value) {
        return {
            $: "a1",
            n: key,
            o: value
        };
    }, _VirtualDom_style = F2(_VirtualDom_style_fn);
    var _VirtualDom_property_fn = function (key, value) {
        return {
            $: "a2",
            n: key,
            o: value
        };
    }, _VirtualDom_property = F2(_VirtualDom_property_fn);
    var _VirtualDom_attribute_fn = function (key, value) {
        return {
            $: "a3",
            n: key,
            o: value
        };
    }, _VirtualDom_attribute = F2(_VirtualDom_attribute_fn);
    var _VirtualDom_attributeNS_fn = function (namespace, key, value) {
        return {
            $: "a4",
            n: key,
            o: { f: namespace, o: value }
        };
    }, _VirtualDom_attributeNS = F3(_VirtualDom_attributeNS_fn);
    var _VirtualDom_RE_script = /^script$/i;
    var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
    var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function _VirtualDom_noScript(tag) {
        return _VirtualDom_RE_script.test(tag) ? "p" : tag;
    }
    function _VirtualDom_noOnOrFormAction(key) {
        return _VirtualDom_RE_on_formAction.test(key) ? "data-" + key : key;
    }
    function _VirtualDom_noInnerHtmlOrFormAction(key) {
        return key == "innerHTML" || key == "formAction" ? "data-" + key : key;
    }
    function _VirtualDom_noJavaScriptUri(value) {
        return _VirtualDom_RE_js.test(value)
            ? ""
            : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri(value) {
        return _VirtualDom_RE_js_html.test(value)
            ? ""
            : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlJson(value) {
        return (typeof _Json_unwrap(value) === "string" && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
            ? _Json_wrap("") : value;
    }
    var _VirtualDom_mapAttribute_fn = function (func, attr) {
        return (attr.$ === "a0")
            ? _VirtualDom_on_fn(attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
    }, _VirtualDom_mapAttribute = F2(_VirtualDom_mapAttribute_fn);
    function _VirtualDom_mapHandler(func, handler) {
        var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
        return {
            $: handler.$,
            a: !tag
                ? _Json_map1_fn(func, handler.a) : _Json_map2_fn(tag < 3
                ? _VirtualDom_mapEventTuple
                : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
        };
    }
    var _VirtualDom_mapEventTuple_fn = function (func, tuple) {
        return _Utils_Tuple2(func(tuple.a), tuple.b);
    }, _VirtualDom_mapEventTuple = F2(_VirtualDom_mapEventTuple_fn);
    var _VirtualDom_mapEventRecord_fn = function (func, record) {
        return {
            no: func(record.no),
            h8: record.h8,
            hP: record.hP
        };
    }, _VirtualDom_mapEventRecord = F2(_VirtualDom_mapEventRecord_fn);
    function _VirtualDom_organizeFacts(factList) {
        for (var facts = {}; factList.b; factList = factList.b) {
            var entry = factList.a;
            var tag = entry.$;
            var key = entry.n;
            var value = entry.o;
            if (tag === "a2") {
                (key === "className")
                    ? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
                    : facts[key] = _Json_unwrap(value);
                continue;
            }
            var subFacts = facts[tag] || (facts[tag] = {});
            (tag === "a3" && key === "class")
                ? _VirtualDom_addClass(subFacts, key, value)
                : subFacts[key] = value;
        }
        return facts;
    }
    function _VirtualDom_addClass(object, key, newClass) {
        var classes = object[key];
        object[key] = classes ? classes + " " + newClass : newClass;
    }
    function _VirtualDom_render(vNode, eventNode) {
        var tag = vNode.$;
        if (tag === 5) {
            return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
        }
        if (tag === 0) {
            return _VirtualDom_doc.createTextNode(vNode.a);
        }
        if (tag === 4) {
            var subNode = vNode.k;
            var tagger = vNode.j;
            while (subNode.$ === 4) {
                typeof tagger !== "object"
                    ? tagger = [tagger, subNode.j]
                    : tagger.push(subNode.j);
                subNode = subNode.k;
            }
            var subEventRoot = { j: tagger, p: eventNode };
            var domNode = _VirtualDom_render(subNode, subEventRoot);
            domNode.elm_event_node_ref = subEventRoot;
            return domNode;
        }
        if (tag === 3) {
            var domNode = vNode.h(vNode.g);
            _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
            return domNode;
        }
        var domNode = vNode.f
            ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
            : _VirtualDom_doc.createElement(vNode.c);
        if (_VirtualDom_divertHrefToApp && vNode.c == "a") {
            domNode.addEventListener("click", _VirtualDom_divertHrefToApp(domNode));
        }
        _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
        for (var kids = vNode.e, i = 0; i < kids.length; i++) {
            _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
        }
        return domNode;
    }
    function _VirtualDom_applyFacts(domNode, eventNode, facts) {
        for (var key in facts) {
            var value = facts[key];
            key === "a1"
                ? _VirtualDom_applyStyles(domNode, value)
                :
                    key === "a0"
                        ? _VirtualDom_applyEvents(domNode, eventNode, value)
                        :
                            key === "a3"
                                ? _VirtualDom_applyAttrs(domNode, value)
                                :
                                    key === "a4"
                                        ? _VirtualDom_applyAttrsNS(domNode, value)
                                        :
                                            ((key !== "value" && key !== "checked") || domNode[key] !== value) && (domNode[key] = value);
        }
    }
    function _VirtualDom_applyStyles(domNode, styles) {
        var domNodeStyle = domNode.style;
        for (var key in styles) {
            domNodeStyle[key] = styles[key];
        }
    }
    function _VirtualDom_applyAttrs(domNode, attrs) {
        for (var key in attrs) {
            var value = attrs[key];
            typeof value !== "undefined"
                ? domNode.setAttribute(key, value)
                : domNode.removeAttribute(key);
        }
    }
    function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
        for (var key in nsAttrs) {
            var pair = nsAttrs[key];
            var namespace = pair.f;
            var value = pair.o;
            typeof value !== "undefined"
                ? domNode.setAttributeNS(namespace, key, value)
                : domNode.removeAttributeNS(namespace, key);
        }
    }
    function _VirtualDom_applyEvents(domNode, eventNode, events) {
        var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
        for (var key in events) {
            var newHandler = events[key];
            var oldCallback = allCallbacks[key];
            if (!newHandler) {
                domNode.removeEventListener(key, oldCallback);
                allCallbacks[key] = undefined;
                continue;
            }
            if (oldCallback) {
                var oldHandler = oldCallback.q;
                if (oldHandler.$ === newHandler.$) {
                    oldCallback.q = newHandler;
                    continue;
                }
                domNode.removeEventListener(key, oldCallback);
            }
            oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
            domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported
                && { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 });
            allCallbacks[key] = oldCallback;
        }
    }
    var _VirtualDom_passiveSupported;
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function () { _VirtualDom_passiveSupported = true; }
        }));
    }
    catch (e) { }
    function _VirtualDom_makeCallback(eventNode, initialHandler) {
        function callback(event) {
            var handler = callback.q;
            var result = _Json_runHelp(handler.a, event);
            if (!$elm$core$Result$isOk(result)) {
                return;
            }
            var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
            var value = result.a;
            var message = !tag ? value : tag < 3 ? value.a : value.no;
            var stopPropagation = tag == 1 ? value.b : tag == 3 && value.h8;
            var currentEventNode = (stopPropagation && event.stopPropagation(),
                (tag == 2 ? value.b : tag == 3 && value.hP) && event.preventDefault(),
                eventNode);
            var tagger;
            var i;
            while (tagger = currentEventNode.j) {
                if (typeof tagger == "function") {
                    message = tagger(message);
                }
                else {
                    for (var i = tagger.length; i--;) {
                        message = tagger[i](message);
                    }
                }
                currentEventNode = currentEventNode.p;
            }
            currentEventNode(message, stopPropagation);
        }
        callback.q = initialHandler;
        return callback;
    }
    function _VirtualDom_equalEvents(x, y) {
        return x.$ == y.$ && _Json_equality(x.a, y.a);
    }
    function _VirtualDom_diff(x, y) {
        var patches = [];
        _VirtualDom_diffHelp(x, y, patches, 0);
        return patches;
    }
    function _VirtualDom_pushPatch(patches, type, index, data) {
        var patch = {
            $: type,
            r: index,
            s: data,
            t: undefined,
            u: undefined
        };
        patches.push(patch);
        return patch;
    }
    function _VirtualDom_diffHelp(x, y, patches, index) {
        if (x === y) {
            return;
        }
        var xType = x.$;
        var yType = y.$;
        if (xType !== yType) {
            if (xType === 1 && yType === 2) {
                y = _VirtualDom_dekey(y);
                yType = 1;
            }
            else {
                _VirtualDom_pushPatch(patches, 0, index, y);
                return;
            }
        }
        switch (yType) {
            case 5:
                var xRefs = x.l;
                var yRefs = y.l;
                var i = xRefs.length;
                var same = i === yRefs.length;
                while (same && i--) {
                    same = xRefs[i] === yRefs[i];
                }
                if (same) {
                    y.k = x.k;
                    return;
                }
                y.k = y.m();
                var subPatches = [];
                _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
                subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
                return;
            case 4:
                var xTaggers = x.j;
                var yTaggers = y.j;
                var nesting = false;
                var xSubNode = x.k;
                while (xSubNode.$ === 4) {
                    nesting = true;
                    typeof xTaggers !== "object"
                        ? xTaggers = [xTaggers, xSubNode.j]
                        : xTaggers.push(xSubNode.j);
                    xSubNode = xSubNode.k;
                }
                var ySubNode = y.k;
                while (ySubNode.$ === 4) {
                    nesting = true;
                    typeof yTaggers !== "object"
                        ? yTaggers = [yTaggers, ySubNode.j]
                        : yTaggers.push(ySubNode.j);
                    ySubNode = ySubNode.k;
                }
                if (nesting && xTaggers.length !== yTaggers.length) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
                    _VirtualDom_pushPatch(patches, 2, index, yTaggers);
                }
                _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
                return;
            case 0:
                if (x.a !== y.a) {
                    _VirtualDom_pushPatch(patches, 3, index, y.a);
                }
                return;
            case 1:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
                return;
            case 2:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
                return;
            case 3:
                if (x.h !== y.h) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
                factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
                var patch = y.i(x.g, y.g);
                patch && _VirtualDom_pushPatch(patches, 5, index, patch);
                return;
        }
    }
    function _VirtualDom_pairwiseRefEqual(as, bs) {
        for (var i = 0; i < as.length; i++) {
            if (as[i] !== bs[i]) {
                return false;
            }
        }
        return true;
    }
    function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
        if (x.c !== y.c || x.f !== y.f) {
            _VirtualDom_pushPatch(patches, 0, index, y);
            return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        diffKids(x, y, patches, index);
    }
    function _VirtualDom_diffFacts(x, y, category) {
        var diff;
        for (var xKey in x) {
            if (xKey === "a1" || xKey === "a0" || xKey === "a3" || xKey === "a4") {
                var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
                if (subDiff) {
                    diff = diff || {};
                    diff[xKey] = subDiff;
                }
                continue;
            }
            if (!(xKey in y)) {
                diff = diff || {};
                diff[xKey] =
                    !category
                        ? (typeof x[xKey] === "string" ? "" : null)
                        :
                            (category === "a1")
                                ? ""
                                :
                                    (category === "a0" || category === "a3")
                                        ? undefined
                                        :
                                            { f: x[xKey].f, o: undefined };
                continue;
            }
            var xValue = x[xKey];
            var yValue = y[xKey];
            if (xValue === yValue && xKey !== "value" && xKey !== "checked"
                || category === "a0" && _VirtualDom_equalEvents(xValue, yValue)) {
                continue;
            }
            diff = diff || {};
            diff[xKey] = yValue;
        }
        for (var yKey in y) {
            if (!(yKey in x)) {
                diff = diff || {};
                diff[yKey] = y[yKey];
            }
        }
        return diff;
    }
    function _VirtualDom_diffKids(xParent, yParent, patches, index) {
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        if (xLen > yLen) {
            _VirtualDom_pushPatch(patches, 6, index, {
                v: yLen,
                i: xLen - yLen
            });
        }
        else if (xLen < yLen) {
            _VirtualDom_pushPatch(patches, 7, index, {
                v: xLen,
                e: yKids
            });
        }
        for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
            var xKid = xKids[i];
            _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
            index += xKid.b || 0;
        }
    }
    function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
        var localPatches = [];
        var changes = {};
        var inserts = [];
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        var xIndex = 0;
        var yIndex = 0;
        var index = rootIndex;
        while (xIndex < xLen && yIndex < yLen) {
            var x = xKids[xIndex];
            var y = yKids[yIndex];
            var xKey = x.a;
            var yKey = y.a;
            var xNode = x.b;
            var yNode = y.b;
            var newMatch = undefined;
            var oldMatch = undefined;
            if (xKey === yKey) {
                index++;
                _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
                index += xNode.b || 0;
                xIndex++;
                yIndex++;
                continue;
            }
            var xNext = xKids[xIndex + 1];
            var yNext = yKids[yIndex + 1];
            if (xNext) {
                var xNextKey = xNext.a;
                var xNextNode = xNext.b;
                oldMatch = yKey === xNextKey;
            }
            if (yNext) {
                var yNextKey = yNext.a;
                var yNextNode = yNext.b;
                newMatch = xKey === yNextKey;
            }
            if (newMatch && oldMatch) {
                index++;
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            if (newMatch) {
                index++;
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                index += xNode.b || 0;
                xIndex += 1;
                yIndex += 2;
                continue;
            }
            if (oldMatch) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 1;
                continue;
            }
            if (xNext && xNextKey === yNextKey) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            break;
        }
        while (xIndex < xLen) {
            index++;
            var x = xKids[xIndex];
            var xNode = x.b;
            _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
            index += xNode.b || 0;
            xIndex++;
        }
        while (yIndex < yLen) {
            var endInserts = endInserts || [];
            var y = yKids[yIndex];
            _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
            yIndex++;
        }
        if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
            _VirtualDom_pushPatch(patches, 8, rootIndex, {
                w: localPatches,
                x: inserts,
                y: endInserts
            });
        }
    }
    var _VirtualDom_POSTFIX = "_elmW6BL";
    function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
        var entry = changes[key];
        if (!entry) {
            entry = {
                c: 0,
                z: vnode,
                r: yIndex,
                s: undefined
            };
            inserts.push({ r: yIndex, A: entry });
            changes[key] = entry;
            return;
        }
        if (entry.c === 1) {
            inserts.push({ r: yIndex, A: entry });
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
            entry.r = yIndex;
            entry.s.s = {
                w: subPatches,
                A: entry
            };
            return;
        }
        _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
    }
    function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
        var entry = changes[key];
        if (!entry) {
            var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
            changes[key] = {
                c: 1,
                z: vnode,
                r: index,
                s: patch
            };
            return;
        }
        if (entry.c === 0) {
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
            _VirtualDom_pushPatch(localPatches, 9, index, {
                w: subPatches,
                A: entry
            });
            return;
        }
        _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
    }
    function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
        _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
    }
    function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
        var patch = patches[i];
        var index = patch.r;
        while (index === low) {
            var patchType = patch.$;
            if (patchType === 1) {
                _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
            }
            else if (patchType === 8) {
                patch.t = domNode;
                patch.u = eventNode;
                var subPatches = patch.s.w;
                if (subPatches.length > 0) {
                    _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                }
            }
            else if (patchType === 9) {
                patch.t = domNode;
                patch.u = eventNode;
                var data = patch.s;
                if (data) {
                    data.A.s = domNode;
                    var subPatches = data.w;
                    if (subPatches.length > 0) {
                        _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                    }
                }
            }
            else {
                patch.t = domNode;
                patch.u = eventNode;
            }
            i++;
            if (!(patch = patches[i]) || (index = patch.r) > high) {
                return i;
            }
        }
        var tag = vNode.$;
        if (tag === 4) {
            var subNode = vNode.k;
            while (subNode.$ === 4) {
                subNode = subNode.k;
            }
            return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
        }
        var vKids = vNode.e;
        var childNodes = domNode.childNodes;
        for (var j = 0; j < vKids.length; j++) {
            low++;
            var vKid = tag === 1 ? vKids[j] : vKids[j].b;
            var nextLow = low + (vKid.b || 0);
            if (low <= index && index <= nextLow) {
                i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
                if (!(patch = patches[i]) || (index = patch.r) > high) {
                    return i;
                }
            }
            low = nextLow;
        }
        return i;
    }
    function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
        if (patches.length === 0) {
            return rootDomNode;
        }
        _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
        return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
    }
    function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
        for (var i = 0; i < patches.length; i++) {
            var patch = patches[i];
            var localDomNode = patch.t;
            var newNode = _VirtualDom_applyPatch(localDomNode, patch);
            if (localDomNode === rootDomNode) {
                rootDomNode = newNode;
            }
        }
        return rootDomNode;
    }
    function _VirtualDom_applyPatch(domNode, patch) {
        switch (patch.$) {
            case 0:
                return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
            case 4:
                _VirtualDom_applyFacts(domNode, patch.u, patch.s);
                return domNode;
            case 3:
                domNode.replaceData(0, domNode.length, patch.s);
                return domNode;
            case 1:
                return _VirtualDom_applyPatchesHelp(domNode, patch.s);
            case 2:
                if (domNode.elm_event_node_ref) {
                    domNode.elm_event_node_ref.j = patch.s;
                }
                else {
                    domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
                }
                return domNode;
            case 6:
                var data = patch.s;
                for (var i = 0; i < data.i; i++) {
                    domNode.removeChild(domNode.childNodes[data.v]);
                }
                return domNode;
            case 7:
                var data = patch.s;
                var kids = data.e;
                var i = data.v;
                var theEnd = domNode.childNodes[i];
                for (; i < kids.length; i++) {
                    domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
                }
                return domNode;
            case 9:
                var data = patch.s;
                if (!data) {
                    domNode.parentNode.removeChild(domNode);
                    return domNode;
                }
                var entry = data.A;
                if (typeof entry.r !== "undefined") {
                    domNode.parentNode.removeChild(domNode);
                }
                entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
                return domNode;
            case 8:
                return _VirtualDom_applyPatchReorder(domNode, patch);
            case 5:
                return patch.s(domNode);
            default:
                _Debug_crash(10);
        }
    }
    function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
        var parentNode = domNode.parentNode;
        var newNode = _VirtualDom_render(vNode, eventNode);
        if (!newNode.elm_event_node_ref) {
            newNode.elm_event_node_ref = domNode.elm_event_node_ref;
        }
        if (parentNode && newNode !== domNode) {
            parentNode.replaceChild(newNode, domNode);
        }
        return newNode;
    }
    function _VirtualDom_applyPatchReorder(domNode, patch) {
        var data = patch.s;
        var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
        domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
        var inserts = data.x;
        for (var i = 0; i < inserts.length; i++) {
            var insert = inserts[i];
            var entry = insert.A;
            var node = entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u);
            domNode.insertBefore(node, domNode.childNodes[insert.r]);
        }
        if (frag) {
            _VirtualDom_appendChild(domNode, frag);
        }
        return domNode;
    }
    function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
        if (!endInserts) {
            return;
        }
        var frag = _VirtualDom_doc.createDocumentFragment();
        for (var i = 0; i < endInserts.length; i++) {
            var insert = endInserts[i];
            var entry = insert.A;
            _VirtualDom_appendChild(frag, entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u));
        }
        return frag;
    }
    function _VirtualDom_virtualize(node) {
        if (node.nodeType === 3) {
            return _VirtualDom_text(node.textContent);
        }
        if (node.nodeType !== 1) {
            return _VirtualDom_text("");
        }
        var attrList = _List_Nil;
        var attrs = node.attributes;
        for (var i = attrs.length; i--;) {
            var attr = attrs[i];
            var name = attr.name;
            var value = attr.value;
            attrList = _List_Cons(_VirtualDom_attribute_fn(name, value), attrList);
        }
        var tag = node.tagName.toLowerCase();
        var kidList = _List_Nil;
        var kids = node.childNodes;
        for (var i = kids.length; i--;) {
            kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
        }
        return A3(_VirtualDom_node, tag, attrList, kidList);
    }
    function _VirtualDom_dekey(keyedNode) {
        var keyedKids = keyedNode.e;
        var len = keyedKids.length;
        var kids = new Array(len);
        for (var i = 0; i < len; i++) {
            kids[i] = keyedKids[i].b;
        }
        return {
            $: 1,
            c: keyedNode.c,
            d: keyedNode.d,
            e: kids,
            f: keyedNode.f,
            b: keyedNode.b
        };
    }
    var _Debugger_element;
    var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.mM, impl.pw, impl.o4, function (sendToApp, initialModel) {
            var view = impl.gl;
            var domNode = args["node"];
            var currNode = _VirtualDom_virtualize(domNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                var nextNode = view(model);
                var patches = _VirtualDom_diff(currNode, nextNode);
                domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
                currNode = nextNode;
            });
        });
    });
    var _Debugger_document;
    var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.mM, impl.pw, impl.o4, function (sendToApp, initialModel) {
            var divertHrefToApp = impl.hZ && impl.hZ(sendToApp);
            var view = impl.gl;
            var title = _VirtualDom_doc.title;
            var bodyNode = _VirtualDom_doc.body;
            var currNode = _VirtualDom_virtualize(bodyNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                _VirtualDom_divertHrefToApp = divertHrefToApp;
                var doc = view(model);
                var nextNode = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "body")(_List_Nil)(doc.d);
                var patches = _VirtualDom_diff(currNode, nextNode);
                bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
                currNode = nextNode;
                _VirtualDom_divertHrefToApp = 0;
                (title !== doc.eM) && (_VirtualDom_doc.title = title = doc.eM);
            });
        });
    });
    var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== "undefined"
        ? cancelAnimationFrame
        : function (id) { clearTimeout(id); };
    var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== "undefined"
        ? requestAnimationFrame
        : function (callback) { return setTimeout(callback, 1000 / 60); };
    function _Browser_makeAnimator(model, draw) {
        draw(model);
        var state = 0;
        function updateIfNeeded() {
            state = state === 1
                ? 0
                : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
        }
        return function (nextModel, isSync) {
            model = nextModel;
            isSync
                ? (draw(model),
                    state === 2 && (state = 1))
                : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
                    state = 2);
        };
    }
    function _Browser_application(impl) {
        var onUrlChange = impl.n5;
        var onUrlRequest = impl.n6;
        var key = function () { key.a(onUrlChange(_Browser_getUrl())); };
        return _Browser_document({
            hZ: function (sendToApp) {
                key.a = sendToApp;
                _Browser_window.addEventListener("popstate", key);
                _Browser_window.navigator.userAgent.indexOf("Trident") < 0 || _Browser_window.addEventListener("hashchange", key);
                return F2(function (domNode, event) {
                    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute("download")) {
                        event.preventDefault();
                        var href = domNode.href;
                        var curr = _Browser_getUrl();
                        var next = $elm$url$Url$fromString(href).a;
                        sendToApp(onUrlRequest((next
                            && curr.kC === next.kC
                            && curr.jz === next.jz
                            && curr.og.a === next.og.a)
                            ? $elm$browser$Browser$Internal(next)
                            : $elm$browser$Browser$External(href)));
                    }
                });
            },
            mM: function (flags) {
                return A3(impl.mM, flags, _Browser_getUrl(), key);
            },
            gl: impl.gl,
            pw: impl.pw,
            o4: impl.o4
        });
    }
    function _Browser_getUrl() {
        return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
    }
    var _Browser_go_fn = function (key, n) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            n && history.go(n);
            key();
        }));
    }, _Browser_go = F2(_Browser_go_fn);
    var _Browser_pushUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.pushState({}, "", url);
            key();
        }));
    }, _Browser_pushUrl = F2(_Browser_pushUrl_fn);
    var _Browser_replaceUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.replaceState({}, "", url);
            key();
        }));
    }, _Browser_replaceUrl = F2(_Browser_replaceUrl_fn);
    var _Browser_fakeNode = { addEventListener: function () { }, removeEventListener: function () { } };
    var _Browser_doc = typeof document !== "undefined" ? document : _Browser_fakeNode;
    var _Browser_window = typeof window !== "undefined" ? window : _Browser_fakeNode;
    var _Browser_on_fn = function (node, eventName, sendToSelf) {
        return _Scheduler_spawn(_Scheduler_binding(function (callback) {
            function handler(event) { _Scheduler_rawSpawn(sendToSelf(event)); }
            node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
            return function () { node.removeEventListener(eventName, handler); };
        }));
    }, _Browser_on = F3(_Browser_on_fn);
    var _Browser_decodeEvent_fn = function (decoder, event) {
        var result = _Json_runHelp(decoder, event);
        return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
    }, _Browser_decodeEvent = F2(_Browser_decodeEvent_fn);
    function _Browser_visibilityInfo() {
        return (typeof _VirtualDom_doc.hidden !== "undefined")
            ? { fr: "hidden", lP: "visibilitychange" }
            :
                (typeof _VirtualDom_doc.mozHidden !== "undefined")
                    ? { fr: "mozHidden", lP: "mozvisibilitychange" }
                    :
                        (typeof _VirtualDom_doc.msHidden !== "undefined")
                            ? { fr: "msHidden", lP: "msvisibilitychange" }
                            :
                                (typeof _VirtualDom_doc.webkitHidden !== "undefined")
                                    ? { fr: "webkitHidden", lP: "webkitvisibilitychange" }
                                    : { fr: "hidden", lP: "visibilitychange" };
    }
    function _Browser_rAF() {
        return _Scheduler_binding(function (callback) {
            var id = _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(Date.now()));
            });
            return function () {
                _Browser_cancelAnimationFrame(id);
            };
        });
    }
    function _Browser_now() {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(Date.now()));
        });
    }
    function _Browser_withNode(id, doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                var node = document.getElementById(id);
                callback(node
                    ? _Scheduler_succeed(doStuff(node))
                    : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
            });
        });
    }
    function _Browser_withWindow(doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(doStuff()));
            });
        });
    }
    var _Browser_call_fn = function (functionName, id) {
        return _Browser_withNode(id, function (node) {
            node[functionName]();
            return _Utils_Tuple0;
        });
    }, _Browser_call = F2(_Browser_call_fn);
    function _Browser_getViewport() {
        return {
            kN: _Browser_getScene(),
            lf: {
                pH: _Browser_window.pageXOffset,
                pJ: _Browser_window.pageYOffset,
                ir: _Browser_doc.documentElement.clientWidth,
                g$: _Browser_doc.documentElement.clientHeight
            }
        };
    }
    function _Browser_getScene() {
        var body = _Browser_doc.body;
        var elem = _Browser_doc.documentElement;
        return {
            ir: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
            g$: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
        };
    }
    var _Browser_setViewport_fn = function (x, y) {
        return _Browser_withWindow(function () {
            _Browser_window.scroll(x, y);
            return _Utils_Tuple0;
        });
    }, _Browser_setViewport = F2(_Browser_setViewport_fn);
    function _Browser_getViewportOf(id) {
        return _Browser_withNode(id, function (node) {
            return {
                kN: {
                    ir: node.scrollWidth,
                    g$: node.scrollHeight
                },
                lf: {
                    pH: node.scrollLeft,
                    pJ: node.scrollTop,
                    ir: node.clientWidth,
                    g$: node.clientHeight
                }
            };
        });
    }
    var _Browser_setViewportOf_fn = function (id, x, y) {
        return _Browser_withNode(id, function (node) {
            node.scrollLeft = x;
            node.scrollTop = y;
            return _Utils_Tuple0;
        });
    }, _Browser_setViewportOf = F3(_Browser_setViewportOf_fn);
    function _Browser_getElement(id) {
        return _Browser_withNode(id, function (node) {
            var rect = node.getBoundingClientRect();
            var x = _Browser_window.pageXOffset;
            var y = _Browser_window.pageYOffset;
            return {
                kN: _Browser_getScene(),
                lf: {
                    pH: x,
                    pJ: y,
                    ir: _Browser_doc.documentElement.clientWidth,
                    g$: _Browser_doc.documentElement.clientHeight
                },
                d2: {
                    pH: x + rect.left,
                    pJ: y + rect.top,
                    ir: rect.width,
                    g$: rect.height
                }
            };
        });
    }
    function _Browser_reload(skipCache) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            _VirtualDom_doc.location.reload(skipCache);
        }));
    }
    function _Browser_load(url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            try {
                _Browser_window.location = url;
            }
            catch (err) {
                _VirtualDom_doc.location.reload(false);
            }
        }));
    }
    function _Url_percentEncode(string) {
        return encodeURIComponent(string);
    }
    function _Url_percentDecode(string) {
        try {
            return $elm$core$Maybe$Just(decodeURIComponent(string));
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }
    var _Parser_isSubString_fn = function (smallString, offset, row, col, bigString) {
        var smallLength = smallString.length;
        var isGood = offset + smallLength <= bigString.length;
        for (var i = 0; isGood && i < smallLength;) {
            var code = bigString.charCodeAt(offset);
            isGood =
                smallString[i++] === bigString[offset++]
                    && (code === 10
                        ? (row++, col = 1)
                        : (col++, (code & 63488) === 55296 ? smallString[i++] === bigString[offset++] : 1));
        }
        return _Utils_Tuple3(isGood ? offset : -1, row, col);
    }, _Parser_isSubString = F5(_Parser_isSubString_fn);
    var _Parser_isSubChar_fn = function (predicate, offset, string) {
        return (string.length <= offset
            ? -1
            :
                (string.charCodeAt(offset) & 63488) === 55296
                    ? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
                    :
                        (predicate(_Utils_chr(string[offset]))
                            ? ((string[offset] === "\n") ? -2 : (offset + 1))
                            : -1));
    }, _Parser_isSubChar = F3(_Parser_isSubChar_fn);
    var _Parser_isAsciiCode_fn = function (code, offset, string) {
        return string.charCodeAt(offset) === code;
    }, _Parser_isAsciiCode = F3(_Parser_isAsciiCode_fn);
    var _Parser_chompBase10_fn = function (offset, string) {
        for (; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (code < 48 || 57 < code) {
                return offset;
            }
        }
        return offset;
    }, _Parser_chompBase10 = F2(_Parser_chompBase10_fn);
    var _Parser_consumeBase_fn = function (base, offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var digit = string.charCodeAt(offset) - 48;
            if (digit < 0 || base <= digit)
                break;
            total = base * total + digit;
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase = F3(_Parser_consumeBase_fn);
    var _Parser_consumeBase16_fn = function (offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (48 <= code && code <= 57) {
                total = 16 * total + code - 48;
            }
            else if (65 <= code && code <= 70) {
                total = 16 * total + code - 55;
            }
            else if (97 <= code && code <= 102) {
                total = 16 * total + code - 87;
            }
            else {
                break;
            }
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase16 = F2(_Parser_consumeBase16_fn);
    var _Parser_findSubString_fn = function (smallString, offset, row, col, bigString) {
        var newOffset = bigString.indexOf(smallString, offset);
        var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
        while (offset < target) {
            var code = bigString.charCodeAt(offset++);
            code === 10
                ? (col = 1, row++)
                : (col++, (code & 63488) === 55296 && offset++);
        }
        return _Utils_Tuple3(newOffset, row, col);
    }, _Parser_findSubString = F5(_Parser_findSubString_fn);
    var _Regex_never = /.^/;
    var _Regex_fromStringWith_fn = function (options, string) {
        var flags = "g";
        if (options.j3) {
            flags += "m";
        }
        if (options.lM) {
            flags += "i";
        }
        try {
            return $elm$core$Maybe$Just(new RegExp(string, flags));
        }
        catch (error) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Regex_fromStringWith = F2(_Regex_fromStringWith_fn);
    var _Regex_contains_fn = function (re, string) {
        return string.match(re) !== null;
    }, _Regex_contains = F2(_Regex_contains_fn);
    var _Regex_findAtMost_fn = function (n, re, str) {
        var out = [];
        var number = 0;
        var string = str;
        var lastIndex = re.lastIndex;
        var prevLastIndex = -1;
        var result;
        while (number++ < n && (result = re.exec(string))) {
            if (prevLastIndex == re.lastIndex)
                break;
            var i = result.length - 1;
            var subs = new Array(i);
            while (i > 0) {
                var submatch = result[i];
                subs[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            out.push($elm$regex$Regex$Match_fn(result[0], result.index, number, _List_fromArray(subs)));
            prevLastIndex = re.lastIndex;
        }
        re.lastIndex = lastIndex;
        return _List_fromArray(out);
    }, _Regex_findAtMost = F3(_Regex_findAtMost_fn);
    var _Regex_replaceAtMost_fn = function (n, re, replacer, string) {
        var count = 0;
        function jsReplacer(match) {
            if (count++ >= n) {
                return match;
            }
            var i = arguments.length - 3;
            var submatches = new Array(i);
            while (i > 0) {
                var submatch = arguments[i];
                submatches[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            return replacer($elm$regex$Regex$Match_fn(match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
        }
        return string.replace(re, jsReplacer);
    }, _Regex_replaceAtMost = F4(_Regex_replaceAtMost_fn);
    var _Regex_splitAtMost_fn = function (n, re, str) {
        var string = str;
        var out = [];
        var start = re.lastIndex;
        var restoreLastIndex = re.lastIndex;
        while (n--) {
            var result = re.exec(string);
            if (!result)
                break;
            out.push(string.slice(start, result.index));
            start = re.lastIndex;
        }
        out.push(string.slice(start));
        re.lastIndex = restoreLastIndex;
        return _List_fromArray(out);
    }, _Regex_splitAtMost = F3(_Regex_splitAtMost_fn);
    var _Regex_infinity = Infinity;
    function _Time_now(millisToPosix) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(millisToPosix(Date.now())));
        });
    }
    var _Time_setInterval_fn = function (interval, task) {
        return _Scheduler_binding(function (callback) {
            var id = setInterval(function () { _Scheduler_rawSpawn(task); }, interval);
            return function () { clearInterval(id); };
        });
    }, _Time_setInterval = F2(_Time_setInterval_fn);
    function _Time_here() {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed($elm$time$Time$Zone_fn(-(new Date().getTimezoneOffset()), _List_Nil)));
        });
    }
    function _Time_getZoneName() {
        return _Scheduler_binding(function (callback) {
            try {
                var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
            }
            catch (e) {
                var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
            }
            callback(_Scheduler_succeed(name));
        });
    }
    var _Http_toTask_fn = function (router, toTask, request) {
        return _Scheduler_binding(function (callback) {
            function done(response) {
                callback(toTask(request.e.a(response)));
            }
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("error", function () { done($elm$http$Http$NetworkError_); });
            xhr.addEventListener("timeout", function () { done($elm$http$Http$Timeout_); });
            xhr.addEventListener("load", function () { done(_Http_toResponse(request.e.b, xhr)); });
            $elm$core$Maybe$isJust(request.eQ) && _Http_track(router, xhr, request.eQ.a);
            try {
                xhr.open(request.f, request.g, true);
            }
            catch (e) {
                return done($elm$http$Http$BadUrl_(request.g));
            }
            _Http_configureRequest(xhr, request);
            request.d.a && xhr.setRequestHeader("Content-Type", request.d.a);
            xhr.send(request.d.b);
            return function () { xhr.c = true; xhr.abort(); };
        });
    }, _Http_toTask = F3(_Http_toTask_fn);
    function _Http_configureRequest(xhr, request) {
        for (var headers = request.d9; headers.b; headers = headers.b) {
            xhr.setRequestHeader(headers.a.a, headers.a.b);
        }
        xhr.timeout = request.eK.a || 0;
        xhr.responseType = request.e.d;
        xhr.withCredentials = request.lw;
    }
    function _Http_toResponse(toBody, xhr) {
        return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
    }
    function _Http_toMetadata(xhr) {
        return {
            g: xhr.responseURL,
            oW: xhr.status,
            oX: xhr.statusText,
            d9: _Http_parseHeaders(xhr.getAllResponseHeaders())
        };
    }
    function _Http_parseHeaders(rawHeaders) {
        if (!rawHeaders) {
            return $elm$core$Dict$empty;
        }
        var headers = $elm$core$Dict$empty;
        var headerPairs = rawHeaders.split("\r\n");
        for (var i = headerPairs.length; i--;) {
            var headerPair = headerPairs[i];
            var index = headerPair.indexOf(": ");
            if (index > 0) {
                var key = headerPair.substring(0, index);
                var value = headerPair.substring(index + 2);
                headers = $elm$core$Dict$update_fn(key, function (oldValue) {
                    return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
                        ? value + ", " + oldValue.a
                        : value);
                }, headers);
            }
        }
        return headers;
    }
    var _Http_expect_fn = function (type, toBody, toValue) {
        return {
            $: 0,
            d: type,
            b: toBody,
            a: toValue
        };
    }, _Http_expect = F3(_Http_expect_fn);
    var _Http_mapExpect_fn = function (func, expect) {
        return {
            $: 0,
            d: expect.d,
            b: expect.b,
            a: function (x) { return func(expect.a(x)); }
        };
    }, _Http_mapExpect = F2(_Http_mapExpect_fn);
    function _Http_toDataView(arrayBuffer) {
        return new DataView(arrayBuffer);
    }
    var _Http_emptyBody = { $: 0 };
    var _Http_pair_fn = function (a, b) { return { $: 0, a: a, b: b }; }, _Http_pair = F2(_Http_pair_fn);
    function _Http_toFormData(parts) {
        for (var formData = new FormData(); parts.b; parts = parts.b) {
            var part = parts.a;
            formData.append(part.a, part.b);
        }
        return formData;
    }
    var _Http_bytesToBlob_fn = function (mime, bytes) {
        return new Blob([bytes], { type: mime });
    }, _Http_bytesToBlob = F2(_Http_bytesToBlob_fn);
    function _Http_track(router, xhr, tracker) {
        xhr.upload.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
                oO: event.loaded,
                oS: event.total
            }))));
        });
        xhr.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
                op: event.loaded,
                oS: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
            }))));
        });
    }
    var _Bitwise_and_fn = function (a, b) {
        return a & b;
    }, _Bitwise_and = F2(_Bitwise_and_fn);
    var _Bitwise_or_fn = function (a, b) {
        return a | b;
    }, _Bitwise_or = F2(_Bitwise_or_fn);
    var _Bitwise_xor_fn = function (a, b) {
        return a ^ b;
    }, _Bitwise_xor = F2(_Bitwise_xor_fn);
    function _Bitwise_complement(a) {
        return ~a;
    }
    ;
    var _Bitwise_shiftLeftBy_fn = function (offset, a) {
        return a << offset;
    }, _Bitwise_shiftLeftBy = F2(_Bitwise_shiftLeftBy_fn);
    var _Bitwise_shiftRightBy_fn = function (offset, a) {
        return a >> offset;
    }, _Bitwise_shiftRightBy = F2(_Bitwise_shiftRightBy_fn);
    var _Bitwise_shiftRightZfBy_fn = function (offset, a) {
        return a >>> offset;
    }, _Bitwise_shiftRightZfBy = F2(_Bitwise_shiftRightZfBy_fn);
    var _File_decoder = _Json_decodePrim(function (value) {
        return (typeof File !== "undefined" && value instanceof File)
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a FILE", value);
    });
    function _File_name(file) { return file.name; }
    function _File_mime(file) { return file.type; }
    function _File_size(file) { return file.size; }
    function _File_lastModified(file) {
        return $elm$time$Time$millisToPosix(file.lastModified);
    }
    var _File_downloadNode;
    function _File_getDownloadNode() {
        return _File_downloadNode || (_File_downloadNode = document.createElement("a"));
    }
    var _File_download_fn = function (name, mime, content) {
        return _Scheduler_binding(function (callback) {
            var blob = new Blob([content], { type: mime });
            if (navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(blob, name);
                return;
            }
            var node = _File_getDownloadNode();
            var objectUrl = URL.createObjectURL(blob);
            node.href = objectUrl;
            node.download = name;
            _File_click(node);
            URL.revokeObjectURL(objectUrl);
        });
    }, _File_download = F3(_File_download_fn);
    function _File_downloadUrl(href) {
        return _Scheduler_binding(function (callback) {
            var node = _File_getDownloadNode();
            node.href = href;
            node.download = "";
            node.origin === location.origin || (node.target = "_blank");
            _File_click(node);
        });
    }
    function _File_makeBytesSafeForInternetExplorer(bytes) {
        return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    }
    function _File_click(node) {
        if (typeof MouseEvent === "function") {
            node.dispatchEvent(new MouseEvent("click"));
        }
        else {
            var event = document.createEvent("MouseEvents");
            event.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            document.body.appendChild(node);
            node.dispatchEvent(event);
            document.body.removeChild(node);
        }
    }
    var _File_node;
    function _File_uploadOne(mimes) {
        return _Scheduler_binding(function (callback) {
            _File_node = document.createElement("input");
            _File_node.type = "file";
            _File_node.accept = $elm$core$String$join_fn(",", mimes);
            _File_node.addEventListener("change", function (event) {
                callback(_Scheduler_succeed(event.target.files[0]));
            });
            _File_click(_File_node);
        });
    }
    function _File_uploadOneOrMore(mimes) {
        return _Scheduler_binding(function (callback) {
            _File_node = document.createElement("input");
            _File_node.type = "file";
            _File_node.multiple = true;
            _File_node.accept = $elm$core$String$join_fn(",", mimes);
            _File_node.addEventListener("change", function (event) {
                var elmFiles = _List_fromArray(event.target.files);
                callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
            });
            _File_click(_File_node);
        });
    }
    function _File_toString(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsText(blob);
            return function () { reader.abort(); };
        });
    }
    function _File_toBytes(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(new DataView(reader.result)));
            });
            reader.readAsArrayBuffer(blob);
            return function () { reader.abort(); };
        });
    }
    function _File_toUrl(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsDataURL(blob);
            return function () { reader.abort(); };
        });
    }
    var $author$project$Msg$LinkClicked = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Msg$UrlChanged = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Basics$EQ = 1;
    var $elm$core$Basics$GT = 2;
    var $elm$core$Basics$LT = 0;
    var $elm$core$List$cons = _List_cons;
    var $elm$core$Dict$foldr_fn = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldr_fn(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr_fn_unwrapped = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldr_fn_unwrapped(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr = F3($elm$core$Dict$foldr_fn);
    var $elm$core$Dict$toList = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, list) {
            return _List_Cons(_Utils_Tuple2(key, value), list);
        }, _List_Nil, dict);
    };
    var $elm$core$Dict$keys = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, keyList) {
            return _List_Cons(key, keyList);
        }, _List_Nil, dict);
    };
    var $elm$core$Set$toList = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$keys(dict);
    };
    var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
    var $elm$core$Array$foldr_fn = function (func, baseCase, _v0) {
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function (node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return _JsArray_foldr_fn(helper, acc, subTree);
            }
            else {
                var values = node.a;
                return _JsArray_foldr_fn(func, acc, values);
            }
        });
        return _JsArray_foldr_fn(helper, _JsArray_foldr_fn(func, baseCase, tail), tree);
    }, $elm$core$Array$foldr = F3($elm$core$Array$foldr_fn);
    var $elm$core$Array$toList = function (array) {
        return $elm$core$Array$foldr_fn($elm$core$List$cons, _List_Nil, array);
    };
    var $elm$core$Result$Err = function (a) {
        return { $: 1, a: a };
    };
    var $elm$json$Json$Decode$Failure_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$json$Json$Decode$Failure = F2($elm$json$Json$Decode$Failure_fn);
    var $elm$json$Json$Decode$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$json$Json$Decode$Field = F2($elm$json$Json$Decode$Field_fn);
    var $elm$json$Json$Decode$Index_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$json$Json$Decode$Index = F2($elm$json$Json$Decode$Index_fn);
    var $elm$core$Result$Ok = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$OneOf = function (a) {
        return { $: 2, a: a };
    };
    var $elm$core$Basics$False = 1;
    var $elm$core$Basics$add = _Basics_add;
    var $elm$core$Maybe$Just = function (a) { return { $: 0, a: a }; };
    var $elm$core$Maybe$Nothing = { $: 1, a: null };
    var $elm$core$String$all = _String_all;
    var $elm$core$Basics$and = _Basics_and;
    var $elm$core$Basics$append = _Utils_append;
    var $elm$json$Json$Encode$encode = _Json_encode;
    var $elm$core$String$fromInt = _String_fromNumber;
    var $elm$core$String$join_fn = function (sep, chunks) {
        return _String_join_fn(sep, _List_toArray(chunks));
    }, $elm$core$String$join = F2($elm$core$String$join_fn);
    var $elm$core$String$split_fn = function (sep, string) {
        return _List_fromArray(_String_split_fn(sep, string));
    }, $elm$core$String$split = F2($elm$core$String$split_fn);
    var $elm$json$Json$Decode$indent = function (str) {
        return $elm$core$String$join_fn("\n    ", $elm$core$String$split_fn("\n", str));
    };
    var $elm$core$List$foldl_fn = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = A2(func, x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl_fn_unwrapped = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = func(x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl = F3($elm$core$List$foldl_fn);
    var $elm$core$List$length = function (xs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, i) {
            return i + 1;
        }, 0, xs);
    };
    var $elm$core$List$map2 = _List_map2;
    var $elm$core$Basics$le = _Utils_le;
    var $elm$core$Basics$sub = _Basics_sub;
    var $elm$core$List$rangeHelp_fn = function (lo, hi, list) {
        rangeHelp: while (true) {
            if (_Utils_cmp(lo, hi) < 1) {
                var $temp$lo = lo, $temp$hi = hi - 1, $temp$list = _List_Cons(hi, list);
                lo = $temp$lo;
                hi = $temp$hi;
                list = $temp$list;
                continue rangeHelp;
            }
            else {
                return list;
            }
        }
    }, $elm$core$List$rangeHelp = F3($elm$core$List$rangeHelp_fn);
    var $elm$core$List$range_fn = function (lo, hi) {
        return $elm$core$List$rangeHelp_fn(lo, hi, _List_Nil);
    }, $elm$core$List$range = F2($elm$core$List$range_fn);
    var $elm$core$List$indexedMap_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; xs.b; i++, xs = xs.b) {
            var next = _List_Cons(A2(f, i, xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$indexedMap_fn_unwrapped = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; xs.b; i++, xs = xs.b) {
            var next = _List_Cons(f(i, xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$indexedMap = F2($elm$core$List$indexedMap_fn);
    var $elm$core$Char$toCode = _Char_toCode;
    var $elm$core$Char$isLower = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (97 <= code) && (code <= 122);
    };
    var $elm$core$Char$isUpper = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 90) && (65 <= code);
    };
    var $elm$core$Basics$or = _Basics_or;
    var $elm$core$Char$isAlpha = function (_char) {
        return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
    };
    var $elm$core$Char$isDigit = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 57) && (48 <= code);
    };
    var $elm$core$Char$isAlphaNum = function (_char) {
        return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
    };
    var $elm$core$List$reverse = function (list) {
        return $elm$core$List$foldl_fn($elm$core$List$cons, _List_Nil, list);
    };
    var $elm$core$String$uncons = _String_uncons;
    var $elm$json$Json$Decode$errorOneOf_fn = function (i, error) {
        return "\n\n(" + ($elm$core$String$fromInt(i + 1) + (") " + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
    }, $elm$json$Json$Decode$errorOneOf = F2($elm$json$Json$Decode$errorOneOf_fn);
    var $elm$json$Json$Decode$errorToString = function (error) {
        return $elm$json$Json$Decode$errorToStringHelp_fn(error, _List_Nil);
    };
    var $elm$json$Json$Decode$errorToStringHelp_fn = function (error, context) {
        errorToStringHelp: while (true) {
            switch (error.$) {
                case 0:
                    var f = error.a;
                    var err = error.b;
                    var isSimple = function () {
                        var _v1 = $elm$core$String$uncons(f);
                        if (_v1.$ === 1) {
                            return false;
                        }
                        else {
                            var _v2 = _v1.a;
                            var _char = _v2.a;
                            var rest = _v2.b;
                            return $elm$core$Char$isAlpha(_char) && _String_all_fn($elm$core$Char$isAlphaNum, rest);
                        }
                    }();
                    var fieldName = isSimple ? ("." + f) : ("['" + (f + "']"));
                    var $temp$error = err, $temp$context = _List_Cons(fieldName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 1:
                    var i = error.a;
                    var err = error.b;
                    var indexName = "[" + ($elm$core$String$fromInt(i) + "]");
                    var $temp$error = err, $temp$context = _List_Cons(indexName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 2:
                    var errors = error.a;
                    if (!errors.b) {
                        return "Ran into a Json.Decode.oneOf with no possibilities" + function () {
                            if (!context.b) {
                                return "!";
                            }
                            else {
                                return " at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                            }
                        }();
                    }
                    else {
                        if (!errors.b.b) {
                            var err = errors.a;
                            var $temp$error = err, $temp$context = context;
                            error = $temp$error;
                            context = $temp$context;
                            continue errorToStringHelp;
                        }
                        else {
                            var starter = function () {
                                if (!context.b) {
                                    return "Json.Decode.oneOf";
                                }
                                else {
                                    return "The Json.Decode.oneOf at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                                }
                            }();
                            var introduction = starter + (" failed in the following " + ($elm$core$String$fromInt($elm$core$List$length(errors)) + " ways:"));
                            return $elm$core$String$join_fn("\n\n", _List_Cons(introduction, $elm$core$List$indexedMap_fn($elm$json$Json$Decode$errorOneOf, errors)));
                        }
                    }
                default:
                    var msg = error.a;
                    var json = error.b;
                    var introduction = function () {
                        if (!context.b) {
                            return "Problem with the given value:\n\n";
                        }
                        else {
                            return "Problem with the value at json" + ($elm$core$String$join_fn("", $elm$core$List$reverse(context)) + ":\n\n    ");
                        }
                    }();
                    return introduction + ($elm$json$Json$Decode$indent(_Json_encode_fn(4, json)) + ("\n\n" + msg));
            }
        }
    }, $elm$json$Json$Decode$errorToStringHelp = F2($elm$json$Json$Decode$errorToStringHelp_fn);
    var $elm$core$Array$branchFactor = 32;
    var $elm$core$Array$Array_elm_builtin_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $elm$core$Array$Array_elm_builtin = F4($elm$core$Array$Array_elm_builtin_fn);
    var $elm$core$Elm$JsArray$empty = _JsArray_empty;
    var $elm$core$Basics$ceiling = _Basics_ceiling;
    var $elm$core$Basics$fdiv = _Basics_fdiv;
    var $elm$core$Basics$logBase_fn = function (base, number) {
        return _Basics_log(number) / _Basics_log(base);
    }, $elm$core$Basics$logBase = F2($elm$core$Basics$logBase_fn);
    var $elm$core$Basics$toFloat = _Basics_toFloat;
    var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling($elm$core$Basics$logBase_fn(2, $elm$core$Array$branchFactor));
    var $elm$core$Array$empty = $elm$core$Array$Array_elm_builtin_fn(0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
    var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
    var $elm$core$Array$Leaf = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Basics$apL_fn = function (f, x) {
        return f(x);
    }, $elm$core$Basics$apL = F2($elm$core$Basics$apL_fn);
    var $elm$core$Basics$apR_fn = function (x, f) {
        return f(x);
    }, $elm$core$Basics$apR = F2($elm$core$Basics$apR_fn);
    var $elm$core$Basics$eq = _Utils_equal;
    var $elm$core$Basics$floor = _Basics_floor;
    var $elm$core$Elm$JsArray$length = _JsArray_length;
    var $elm$core$Basics$gt = _Utils_gt;
    var $elm$core$Basics$max_fn = function (x, y) {
        return (_Utils_cmp(x, y) > 0) ? x : y;
    }, $elm$core$Basics$max = F2($elm$core$Basics$max_fn);
    var $elm$core$Basics$mul = _Basics_mul;
    var $elm$core$Array$SubTree = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
    var $elm$core$Array$compressNodes_fn = function (nodes, acc) {
        compressNodes: while (true) {
            var _v0 = _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodes);
            var node = _v0.a;
            var remainingNodes = _v0.b;
            var newAcc = _List_Cons($elm$core$Array$SubTree(node), acc);
            if (!remainingNodes.b) {
                return $elm$core$List$reverse(newAcc);
            }
            else {
                var $temp$nodes = remainingNodes, $temp$acc = newAcc;
                nodes = $temp$nodes;
                acc = $temp$acc;
                continue compressNodes;
            }
        }
    }, $elm$core$Array$compressNodes = F2($elm$core$Array$compressNodes_fn);
    var $elm$core$Tuple$first = function (_v0) {
        var x = _v0.a;
        return x;
    };
    var $elm$core$Array$treeFromBuilder_fn = function (nodeList, nodeListSize) {
        treeFromBuilder: while (true) {
            var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
            if (newNodeSize === 1) {
                return _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodeList).a;
            }
            else {
                var $temp$nodeList = $elm$core$Array$compressNodes_fn(nodeList, _List_Nil), $temp$nodeListSize = newNodeSize;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue treeFromBuilder;
            }
        }
    }, $elm$core$Array$treeFromBuilder = F2($elm$core$Array$treeFromBuilder_fn);
    var $elm$core$Array$builderToArray_fn = function (reverseNodeList, builder) {
        if (!builder.W) {
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.ac), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.ac);
        }
        else {
            var treeLen = builder.W * $elm$core$Array$branchFactor;
            var depth = $elm$core$Basics$floor($elm$core$Basics$logBase_fn($elm$core$Array$branchFactor, treeLen - 1));
            var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.ag) : builder.ag;
            var tree = $elm$core$Array$treeFromBuilder_fn(correctNodeList, builder.W);
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.ac) + treeLen, $elm$core$Basics$max_fn(5, depth * $elm$core$Array$shiftStep), tree, builder.ac);
        }
    }, $elm$core$Array$builderToArray = F2($elm$core$Array$builderToArray_fn);
    var $elm$core$Basics$idiv = _Basics_idiv;
    var $elm$core$Basics$lt = _Utils_lt;
    var $elm$core$Array$initializeHelp_fn = function (fn, fromIndex, len, nodeList, tail) {
        initializeHelp: while (true) {
            if (fromIndex < 0) {
                return $elm$core$Array$builderToArray_fn(false, { ag: nodeList, W: (len / $elm$core$Array$branchFactor) | 0, ac: tail });
            }
            else {
                var leaf = $elm$core$Array$Leaf(_JsArray_initialize_fn($elm$core$Array$branchFactor, fromIndex, fn));
                var $temp$fn = fn, $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor, $temp$len = len, $temp$nodeList = _List_Cons(leaf, nodeList), $temp$tail = tail;
                fn = $temp$fn;
                fromIndex = $temp$fromIndex;
                len = $temp$len;
                nodeList = $temp$nodeList;
                tail = $temp$tail;
                continue initializeHelp;
            }
        }
    }, $elm$core$Array$initializeHelp = F5($elm$core$Array$initializeHelp_fn);
    var $elm$core$Basics$remainderBy = _Basics_remainderBy;
    var $elm$core$Array$initialize_fn = function (len, fn) {
        if (len <= 0) {
            return $elm$core$Array$empty;
        }
        else {
            var tailLen = len % $elm$core$Array$branchFactor;
            var tail = _JsArray_initialize_fn(tailLen, len - tailLen, fn);
            var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
            return $elm$core$Array$initializeHelp_fn(fn, initialFromIndex, len, _List_Nil, tail);
        }
    }, $elm$core$Array$initialize = F2($elm$core$Array$initialize_fn);
    var $elm$core$Basics$True = 0;
    var $elm$core$Result$isOk = function (result) {
        if (!result.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$json$Json$Decode$map = _Json_map1;
    var $elm$json$Json$Decode$map2 = _Json_map2;
    var $elm$json$Json$Decode$succeed = _Json_succeed;
    var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
        switch (handler.$) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $elm$browser$Browser$External = function (a) {
        return { $: 1, a: a };
    };
    var $elm$browser$Browser$Internal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Basics$identity = function (x) {
        return x;
    };
    var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
    var $elm$url$Url$Http = 0;
    var $elm$url$Url$Https = 1;
    var $elm$url$Url$Url_fn = function (protocol, host, port_, path, query, fragment) {
        return { jq: fragment, jz: host, ks: path, og: port_, kC: protocol, kD: query };
    }, $elm$url$Url$Url = F6($elm$url$Url$Url_fn);
    var $elm$core$String$contains = _String_contains;
    var $elm$core$String$length = _String_length;
    var $elm$core$String$slice = _String_slice;
    var $elm$core$String$dropLeft_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(n, $elm$core$String$length(string), string);
    }, $elm$core$String$dropLeft = F2($elm$core$String$dropLeft_fn);
    var $elm$core$String$indexes = _String_indexes;
    var $elm$core$String$isEmpty = function (string) {
        return string === "";
    };
    var $elm$core$String$left_fn = function (n, string) {
        return (n < 1) ? "" : _String_slice_fn(0, n, string);
    }, $elm$core$String$left = F2($elm$core$String$left_fn);
    var $elm$core$String$toInt = _String_toInt;
    var $elm$url$Url$chompBeforePath_fn = function (protocol, path, params, frag, str) {
        if ($elm$core$String$isEmpty(str) || _String_contains_fn("@", str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn(":", str);
            if (!_v0.b) {
                return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
            }
            else {
                if (!_v0.b.b) {
                    var i = _v0.a;
                    var _v1 = $elm$core$String$toInt($elm$core$String$dropLeft_fn(i + 1, str));
                    if (_v1.$ === 1) {
                        return $elm$core$Maybe$Nothing;
                    }
                    else {
                        var port_ = _v1;
                        return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, $elm$core$String$left_fn(i, str), port_, path, params, frag));
                    }
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }
    }, $elm$url$Url$chompBeforePath = F5($elm$url$Url$chompBeforePath_fn);
    var $elm$url$Url$chompBeforeQuery_fn = function (protocol, params, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("/", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforePath_fn(protocol, "/", params, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforePath_fn(protocol, $elm$core$String$dropLeft_fn(i, str), params, frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeQuery = F4($elm$url$Url$chompBeforeQuery_fn);
    var $elm$url$Url$chompBeforeFragment_fn = function (protocol, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("?", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Nothing, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeFragment = F3($elm$url$Url$chompBeforeFragment_fn);
    var $elm$url$Url$chompAfterProtocol_fn = function (protocol, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("#", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Nothing, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompAfterProtocol = F2($elm$url$Url$chompAfterProtocol_fn);
    var $elm$core$String$startsWith = _String_startsWith;
    var $elm$url$Url$fromString = function (str) {
        return _String_startsWith_fn("http://", str) ? $elm$url$Url$chompAfterProtocol_fn(0, $elm$core$String$dropLeft_fn(7, str)) : (_String_startsWith_fn("https://", str) ? $elm$url$Url$chompAfterProtocol_fn(1, $elm$core$String$dropLeft_fn(8, str)) : $elm$core$Maybe$Nothing);
    };
    var $elm$core$Basics$never = function (_v0) {
        never: while (true) {
            var nvr = _v0;
            var $temp$_v0 = nvr;
            _v0 = $temp$_v0;
            continue never;
        }
    };
    var $elm$core$Task$Perform = $elm$core$Basics$identity;
    var $elm$core$Task$succeed = _Scheduler_succeed;
    var $elm$core$Task$init = $elm$core$Task$succeed(0);
    var $elm$core$List$foldrHelper_fn = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return A2(fn, a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return A2(fn, a, A2(fn, b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn(fn, acc, ctr + 1, r4);
                        return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper_fn_unwrapped = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return fn(a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return fn(a, fn(b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return fn(a, fn(b, fn(c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn_unwrapped(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn_unwrapped(fn, acc, ctr + 1, r4);
                        return fn(a, fn(b, fn(c, fn(d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper = F4($elm$core$List$foldrHelper_fn);
    var $elm$core$List$foldr_fn = function (fn, acc, ls) {
        return $elm$core$List$foldrHelper_fn(fn, acc, 0, ls);
    }, $elm$core$List$foldr = F3($elm$core$List$foldr_fn);
    var $elm$core$List$map_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs
            = xs.b) {
            var next = _List_Cons(f(xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$map = F2($elm$core$List$map_fn);
    var $elm$core$Task$andThen = _Scheduler_andThen;
    var $elm$core$Task$map_fn = function (func, taskA) {
        return _Scheduler_andThen_fn(function (a) {
            return $elm$core$Task$succeed(func(a));
        }, taskA);
    }, $elm$core$Task$map = F2($elm$core$Task$map_fn);
    var $elm$core$Task$map2_fn = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(A2(func, a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2_fn_unwrapped = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(func(a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2 = F3($elm$core$Task$map2_fn);
    var $elm$core$Task$sequence = function (tasks) {
        return $elm$core$List$foldr_fn($elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
    };
    var $elm$core$Platform$sendToApp = _Platform_sendToApp;
    var $elm$core$Task$spawnCmd_fn = function (router, _v0) {
        var task = _v0;
        return _Scheduler_spawn(_Scheduler_andThen_fn($elm$core$Platform$sendToApp(router), task));
    }, $elm$core$Task$spawnCmd = F2($elm$core$Task$spawnCmd_fn);
    var $elm$core$Task$onEffects_fn = function (router, commands, state) {
        return $elm$core$Task$map_fn(function (_v0) {
            return 0;
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Task$spawnCmd(router), commands)));
    }, $elm$core$Task$onEffects = F3($elm$core$Task$onEffects_fn);
    var $elm$core$Task$onSelfMsg_fn = function (_v0, _v1, _v2) {
        return $elm$core$Task$succeed(0);
    }, $elm$core$Task$onSelfMsg = F3($elm$core$Task$onSelfMsg_fn);
    var $elm$core$Task$cmdMap_fn = function (tagger, _v0) {
        var task = _v0;
        return $elm$core$Task$map_fn(tagger, task);
    }, $elm$core$Task$cmdMap = F2($elm$core$Task$cmdMap_fn);
    _Platform_effectManagers["Task"] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
    var $elm$core$Task$command = _Platform_leaf("Task");
    var $elm$core$Task$perform_fn = function (toMessage, task) {
        return $elm$core$Task$command($elm$core$Task$map_fn(toMessage, task));
    }, $elm$core$Task$perform = F2($elm$core$Task$perform_fn);
    var $elm$browser$Browser$application = _Browser_application;
    var $author$project$Dialog$ErrorDialog = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Msg$LoginPageMsgReceived = function (a) {
        return { $: 31, a: a };
    };
    var $author$project$Msg$SetDialog = function (a) {
        return { $: 35, a: a };
    };
    var $author$project$Msg$TimeUpdated = function (a) {
        return { $: 3, a: a };
    };
    var $elm$core$Basics$always_fn = function (a, _v0) {
        return a;
    }, $elm$core$Basics$always = F2($elm$core$Basics$always_fn);
    var $elm$core$Basics$composeR_fn = function (f, g, x) {
        return g(f(x));
    }, $elm$core$Basics$composeR = F3($elm$core$Basics$composeR_fn);
    var $author$project$Types$Flags$Flags = function (edition) {
        return function (apps) {
            return function (functions) {
                return function (moveRows) {
                    return function (editColumnSchema) {
                        return function (auditing) {
                            return function (proUpgrade) {
                                return function (dbFromAiPrompt) {
                                    return function (dbDescription) {
                                        return function (tableDescription) {
                                            return function (toolbar) {
                                                return function (usersPage) {
                                                    return function (serverEnvVars) {
                                                        return function (dbEnvVars) {
                                                            return { lz: apps, iH: auditing, l3: dbDescription, i0: dbEnvVars, i1: dbFromAiPrompt, fh: editColumnSchema, ja: edition, mB: functions, fH: moveRows, oh: proUpgrade, kP: serverEnvVars, o7: tableDescription, pt: toolbar, ip: usersPage };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm_community$json_extra$Json$Decode$Extra$andMap_a0 = $elm$core$Basics$apR, $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm_community$json_extra$Json$Decode$Extra$andMap_a0);
    var $author$project$Types$Edition$Dedicated = { $: 1 };
    var $author$project$Types$Billing$Free = { $: 0 };
    var $author$project$Types$Edition$Shared = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$andThen = _Json_andThen;
    var $elm$json$Json$Decode$fail = _Json_fail;
    var $elm$json$Json$Decode$string = _Json_decodeString;
    var $author$project$Types$Edition$decoder = _Json_andThen_fn(function (s) {
        switch (s) {
            case "dedicated":
                return $elm$json$Json$Decode$succeed($author$project$Types$Edition$Dedicated);
            case "shared":
                return $elm$json$Json$Decode$succeed($author$project$Types$Edition$Shared($author$project$Types$Billing$Free));
            default:
                var other = s;
                return $elm$json$Json$Decode$fail("Unknown Edition \"" + (other + "\"."));
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Types$Flags$default = {
        lz: false,
        iH: false,
        l3: true,
        i0: false,
        i1: true,
        fh: false,
        ja: $author$project$Types$Edition$Shared($author$project$Types$Billing$Free),
        mB: true,
        fH: false,
        oh: true,
        kP: false,
        o7: true,
        pt: false,
        ip: false
    };
    var $elm$json$Json$Decode$field = _Json_decodeField;
    var $elm$json$Json$Decode$list = _Json_decodeList;
    var $elm$core$List$any_fn = function (isOkay, list) {
        any: while (true) {
            if (!list.b) {
                return false;
            }
            else {
                var x = list.a;
                var xs = list.b;
                if (isOkay(x)) {
                    return true;
                }
                else {
                    var $temp$isOkay = isOkay, $temp$list = xs;
                    isOkay = $temp$isOkay;
                    list = $temp$list;
                    continue any;
                }
            }
        }
    }, $elm$core$List$any = F2($elm$core$List$any_fn);
    var $elm$core$List$member_fn = function (x, xs) {
        return $elm$core$List$any_fn(function (a) {
            return _Utils_eq(a, x);
        }, xs);
    }, $elm$core$List$member = F2($elm$core$List$member_fn);
    var $author$project$Types$Flags$decode = function () {
        var decodeFeature = F2(function (feature, default_) {
            return _Json_map1_fn(A2($elm$core$Basics$composeR, $elm$core$List$member(feature), $elm$core$Basics$or(default_)), _Json_decodeField_fn("features", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
        });
        return _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "dbEnvVars", $author$project$Types$Flags$default.i0), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "serverEnvVars", $author$project$Types$Flags$default.kP), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "usersPage", $author$project$Types$Flags$default.ip), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "toolbar", $author$project$Types$Flags$default.pt), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "tableDescription", $author$project$Types$Flags$default.o7), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "dbDescription", $author$project$Types$Flags$default.l3), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "dbFromAiPrompt", $author$project$Types$Flags$default.i1), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "proUpgrade", $author$project$Types$Flags$default.oh), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "auditing", $author$project$Types$Flags$default.iH), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "editColumnSchema", $author$project$Types$Flags$default.fh), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "moveRows", $author$project$Types$Flags$default.fH), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "functions", $author$project$Types$Flags$default.mB), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, A2(decodeFeature, "apps", $author$project$Types$Flags$default.lz), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("edition", $author$project$Types$Edition$decoder), $elm$json$Json$Decode$succeed($author$project$Types$Flags$Flags)))))))))))))));
    }();
    var $author$project$Types$SessionToken$SessionToken = $elm$core$Basics$identity;
    var $author$project$Types$SessionToken$decode = _Json_map1_fn($elm$core$Basics$identity, _Json_decodeField_fn("sessionToken", $elm$json$Json$Decode$string));
    var $elm$json$Json$Decode$decodeValue = _Json_run;
    var $elm_community$result_extra$Result$Extra$error = function (result) {
        if (!result.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var err = result.a;
            return $elm$core$Maybe$Just(err);
        }
    };
    var $author$project$Msg$AdminPageMsgReceived = function (a) {
        return { $: 28, a: a };
    };
    var $author$project$Msg$AppsPageMsgReceived = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Msg$DashboardsPageMsgReceived = function (a) {
        return { $: 26, a: a };
    };
    var $author$project$Msg$FunctionsPageMsgReceived = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$Route$NotFound = { $: 0 };
    var $author$project$Msg$QueriesPageMsgReceived = function (a) {
        return { $: 23, a: a };
    };
    var $author$project$Pages$Apps$RouteChanged_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Apps$RouteChanged = F2($author$project$Pages$Apps$RouteChanged_fn);
    var $author$project$Pages$Dashboards$RouteChanged_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Dashboards$RouteChanged = F2($author$project$Pages$Dashboards$RouteChanged_fn);
    var $author$project$Pages$Functions$RouteChanged_fn = function (a, b, c) {
        return { $: 9, a: a, b: b, c: c };
    }, $author$project$Pages$Functions$RouteChanged = F3($author$project$Pages$Functions$RouteChanged_fn);
    var $author$project$Shared$RouteRefresh = { $: 7 };
    var $author$project$Pages$Tables$Routed = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Teams$Routed = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Users$Routed = $elm$core$Basics$identity;
    var $author$project$Pages$Login$RoutedFrom_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Pages$Login$RoutedFrom = F2($author$project$Pages$Login$RoutedFrom_fn);
    var $author$project$Msg$SettingsPageMsgReceived = function (a) {
        return { $: 27, a: a };
    };
    var $author$project$Msg$SharedMsg = function (a) {
        return { $: 43, a: a };
    };
    var $author$project$Msg$TablesPageMsgReceived = function (a) {
        return { $: 21, a: a };
    };
    var $author$project$Msg$TeamsPageMsgReceived = function (a) {
        return { $: 34, a: a };
    };
    var $author$project$Msg$UsersPageMsgReceived = function (a) {
        return { $: 33, a: a };
    };
    var $elm$core$Platform$Cmd$batch = _Platform_batch;
    var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
    var $author$project$Util$cmdOr_fn = function (a, b) {
        return _Utils_eq(a, $elm$core$Platform$Cmd$none) ? b : a;
    }, $author$project$Util$cmdOr = F2($author$project$Util$cmdOr_fn);
    var $author$project$Util$cmdOrList_a0 = $author$project$Util$cmdOr, $author$project$Util$cmdOrList_a1 = $elm$core$Platform$Cmd$none, $author$project$Util$cmdOrList = A2($elm$core$List$foldr, $author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1);
    var $author$project$Route$Admin = function (a) {
        return { $: 26, a: a };
    };
    var $author$project$Route$Affiliate = { $: 2 };
    var $author$project$Route$App_fn = function (a, b) {
        return { $: 22, a: a, b: b };
    }, $author$project$Route$App = F2($author$project$Route$App_fn);
    var $author$project$Route$Apps_fn = function (a, b) {
        return { $: 21, a: a, b: b };
    }, $author$project$Route$Apps = F2($author$project$Route$Apps_fn);
    var $author$project$Route$Dashboards_fn = function (a, b) {
        return { $: 24, a: a, b: b };
    }, $author$project$Route$Dashboards = F2($author$project$Route$Dashboards_fn);
    var $author$project$Route$Database = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$Route$Download = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Route$Duplicate = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Route$DuplicateReadonly = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Route$ForgotPassword = { $: 7 };
    var $author$project$Route$Functions_fn = function (a, b) {
        return { $: 23, a: a, b: b };
    }, $author$project$Route$Functions = F2($author$project$Route$Functions_fn);
    var $author$project$Route$GraphiQL = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Route$Home = { $: 1 };
    var $author$project$Route$Login = { $: 6 };
    var $author$project$Route$Playground = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Route$Pricing = { $: 3 };
    var $author$project$Route$Queries_fn = function (a, b) {
        return { $: 19, a: a, b: b };
    }, $author$project$Route$Queries = F2($author$project$Route$Queries_fn);
    var $author$project$Route$RegenerateDbId = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Route$RegenerateReadonlyId = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Route$Settings_fn = function (a, b) {
        return { $: 25, a: a, b: b };
    }, $author$project$Route$Settings = F2($author$project$Route$Settings_fn);
    var $author$project$Route$Signup = { $: 5 };
    var $author$project$Route$Tables_fn = function (a, b, c, d) {
        return { $: 17, a: a, b: b, c: c, d: d };
    }, $author$project$Route$Tables = F4($author$project$Route$Tables_fn);
    var $author$project$Route$Teams = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Route$Trial = { $: 4 };
    var $author$project$Route$Users = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Route$Views_fn = function (a, b, c, d) {
        return { $: 18, a: a, b: b, c: c, d: d };
    }, $author$project$Route$Views = F4($author$project$Route$Views_fn);
    var $elm$core$Maybe$andThen_fn = function (callback, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return callback(value);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$andThen = F2($elm$core$Maybe$andThen_fn);
    var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
    var $elm$url$Url$Parser$State_fn = function (visited, unvisited, params, frag, value) {
        return { ci: frag, cy: params, b6: unvisited, pB: value, cJ: visited };
    }, $elm$url$Url$Parser$State = F5($elm$url$Url$Parser$State_fn);
    var $elm$url$Url$Parser$custom_fn = function (tipe, stringToSomething) {
        return function (_v0) {
            var visited = _v0.cJ;
            var unvisited = _v0.b6;
            var params = _v0.cy;
            var frag = _v0.ci;
            var value = _v0.pB;
            if (!unvisited.b) {
                return _List_Nil;
            }
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                var _v2 = stringToSomething(next);
                if (!_v2.$) {
                    var nextValue = _v2.a;
                    return _List_fromArray([
                        $elm$url$Url$Parser$State_fn(_List_Cons(next, visited), rest, params, frag, value(nextValue))
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }
        };
    }, $elm$url$Url$Parser$custom = F2($elm$url$Url$Parser$custom_fn);
    var $author$project$Util$flip_fn = function (f, b, a) {
        return A2(f, a, b);
    }, $author$project$Util$flip_fn_unwrapped = function (f, b, a) {
        return f(a, b);
    }, $author$project$Util$flip = F3($author$project$Util$flip_fn);
    var $elm$url$Url$Parser$fragment = function (toFrag) {
        return function (_v0) {
            var visited = _v0.cJ;
            var unvisited = _v0.b6;
            var params = _v0.cy;
            var frag = _v0.ci;
            var value = _v0.pB;
            return _List_fromArray([
                $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, value(toFrag(frag)))
            ]);
        };
    };
    var $author$project$Pages$Admin$Route$Billing = { $: 3 };
    var $author$project$Pages$Admin$Route$Databases = { $: 1 };
    var $author$project$Pages$Admin$Route$Home = { $: 0 };
    var $author$project$Pages$Admin$Route$Settings = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Admin$Settings$Route$Environment = 1;
    var $author$project$Pages$Admin$Settings$Route$Functions = 0;
    var $elm$url$Url$Parser$mapState_fn = function (func, _v0) {
        var visited = _v0.cJ;
        var unvisited = _v0.b6;
        var params = _v0.cy;
        var frag = _v0.ci;
        var value = _v0.pB;
        return $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, func(value));
    }, $elm$url$Url$Parser$mapState = F2($elm$url$Url$Parser$mapState_fn);
    var $elm$url$Url$Parser$map_fn = function (subValue, _v0) {
        var parseArg = _v0;
        return function (_v1) {
            var visited = _v1.cJ;
            var unvisited = _v1.b6;
            var params = _v1.cy;
            var frag = _v1.ci;
            var value = _v1.pB;
            return $elm$core$List$map_fn($elm$url$Url$Parser$mapState(value), parseArg($elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, subValue)));
        };
    }, $elm$url$Url$Parser$map = F2($elm$url$Url$Parser$map_fn);
    var $elm$core$List$append_fn = function (xs, ys) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs = xs.b) {
            var next = _List_Cons(xs.a, _List_Nil);
            end.b = next;
            end = next;
        }
        end.b = ys;
        return tmp.b;
    }, $elm$core$List$append = F2($elm$core$List$append_fn);
    var $elm$core$List$concat = function (lists) {
        if (!lists.b) {
            return _List_Nil;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; lists.b.b; lists = lists.b) {
            var xs = lists.a;
            for (; xs.b; xs = xs.b) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        end.b = lists.a;
        return tmp.b;
    };
    var $elm$core$List$concatMap_fn = function (f, lists) {
        if (!lists.b) {
            return _List_Nil;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; lists.b.
            b; lists = lists.b) {
            var xs = f(lists.a);
            for (; xs.b; xs = xs.b) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        end.b = f(lists.a);
        return tmp.b;
    }, $elm$core$List$concatMap = F2($elm$core$List$concatMap_fn);
    var $elm$url$Url$Parser$oneOf = function (parsers) {
        return function (state) {
            return $elm$core$List$concatMap_fn(function (_v0) {
                var parser = _v0;
                return parser(state);
            }, parsers);
        };
    };
    var $elm$url$Url$Parser$s = function (str) {
        return function (_v0) {
            var visited = _v0.cJ;
            var unvisited = _v0.b6;
            var params = _v0.cy;
            var frag = _v0.ci;
            var value = _v0.pB;
            if (!unvisited.b) {
                return _List_Nil;
            }
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                return _Utils_eq(next, str) ? _List_fromArray([
                    $elm$url$Url$Parser$State_fn(_List_Cons(next, visited), rest, params, frag, value)
                ]) : _List_Nil;
            }
        };
    };
    var $elm$url$Url$Parser$slash_fn = function (_v0, _v1) {
        var parseBefore = _v0;
        var parseAfter = _v1;
        return function (state) {
            return $elm$core$List$concatMap_fn(parseAfter, parseBefore(state));
        };
    }, $elm$url$Url$Parser$slash = F2($elm$url$Url$Parser$slash_fn);
    var $elm$url$Url$Parser$top = function (state) {
        return _List_fromArray([state]);
    };
    var $author$project$Pages$Admin$Settings$Route$fromString = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just(0), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("functions"), $elm$url$Url$Parser$top)),
        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just(1), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("environment"), $elm$url$Url$Parser$top))
    ]));
    var $author$project$Pages$Admin$Route$fromString = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($author$project$Pages$Admin$Route$Home, $elm$url$Url$Parser$top),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Admin$Route$Databases, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("databases"), $elm$url$Url$Parser$top)),
        $elm$url$Url$Parser$oneOf(_List_fromArray([
            $elm$url$Url$Parser$map_fn($author$project$Pages$Admin$Route$Settings($elm$core$Maybe$Nothing), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("settings"), $elm$url$Url$Parser$top)),
            $elm$url$Url$Parser$map_fn($author$project$Pages$Admin$Route$Settings, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("settings"), $author$project$Pages$Admin$Settings$Route$fromString))
        ])),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Admin$Route$Billing, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("billing"), $elm$url$Url$Parser$top))
    ]));
    var $elm$url$Url$Parser$int = $elm$url$Url$Parser$custom_fn("NUMBER", $elm$core$String$toInt);
    var $author$project$Types$User$Username = $elm$core$Basics$identity;
    var $author$project$Types$User$nameFromString = $elm$core$Basics$identity;
    var $author$project$Pages$Dashboards$Route$EditChart_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Dashboards$Route$EditChart = F2($author$project$Pages$Dashboards$Route$EditChart_fn);
    var $author$project$Pages$Dashboards$Route$EditDashboard = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Dashboards$Route$NewChart = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Dashboards$Route$Overview = { $: 0 };
    var $author$project$Pages$Dashboards$Route$ViewDashboard = function (a) {
        return { $: 1, a: a };
    };
    var $elm$url$Url$Parser$string = $elm$url$Url$Parser$custom_fn("STRING", $elm$core$Maybe$Just);
    var $author$project$Pages$Dashboards$Route$parse = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($author$project$Pages$Dashboards$Route$Overview, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("overview"), $elm$url$Url$Parser$top)),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Dashboards$Route$ViewDashboard, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$top)),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Dashboards$Route$EditDashboard, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("edit"), $elm$url$Url$Parser$top))),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Dashboards$Route$NewChart, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("chart"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("new"), $elm$url$Url$Parser$top)))),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Dashboards$Route$EditChart, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("chart"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("edit"), $elm$url$Url$Parser$top)))))
    ]));
    var $author$project$Pages$Functions$Route$Function = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Functions$Route$Overview = { $: 0 };
    var $author$project$Pages$Functions$Route$Versions_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Pages$Functions$Route$Versions = F2($author$project$Pages$Functions$Route$Versions_fn);
    var $author$project$Pages$Functions$Route$parse = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($author$project$Pages$Functions$Route$Overview, $elm$url$Url$Parser$top),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Functions$Route$Function, $elm$url$Url$Parser$string),
        $elm$url$Url$Parser$map_fn(A2($author$project$Util$flip, $author$project$Pages$Functions$Route$Versions, $elm$core$Maybe$Nothing), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$s("versions"))),
        $elm$url$Url$Parser$map_fn($author$project$Pages$Functions$Route$Versions, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("versions"), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, $elm$url$Url$Parser$string))))
    ]));
    var $author$project$Pages$Settings$Route$Database = 1;
    var $author$project$Pages$Settings$Route$Environment = 2;
    var $author$project$Pages$Settings$Route$General = 0;
    var $author$project$Pages$Settings$Route$parse = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn(1, $elm$url$Url$Parser$s("database")),
        $elm$url$Url$Parser$map_fn(0, $elm$url$Url$Parser$s("general")),
        $elm$url$Url$Parser$map_fn(2, $elm$url$Url$Parser$s("environment"))
    ]));
    var $author$project$Pages$Teams$Route$Billing = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Teams$Route$Overview = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Teams$Route$Settings = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Teams$Route$Teams = { $: 0 };
    var $author$project$Pages$Teams$Route$Tokens_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Teams$Route$Tokens = F2($author$project$Pages$Teams$Route$Tokens_fn);
    var $author$project$Types$ApiToken$ApiTokenId = $elm$core$Basics$identity;
    var $author$project$Types$ApiToken$idFromInt = $elm$core$Basics$identity;
    var $elm$url$Url$percentDecode = _Url_percentDecode;
    var $author$project$Pages$Teams$Route$parse = function () {
        var string = $elm$url$Url$Parser$custom_fn("STRING", $elm$url$Url$percentDecode);
        return $elm$url$Url$Parser$oneOf(_List_fromArray([
            $elm$url$Url$Parser$map_fn($author$project$Pages$Teams$Route$Teams, $elm$url$Url$Parser$top),
            $elm$url$Url$Parser$map_fn($author$project$Pages$Teams$Route$Overview, string),
            $elm$url$Url$Parser$map_fn($author$project$Pages$Teams$Route$Settings, $elm$url$Url$Parser$slash_fn(string, $elm$url$Url$Parser$s("settings"))),
            $elm$url$Url$Parser$map_fn($author$project$Pages$Teams$Route$Tokens, $elm$url$Url$Parser$slash_fn(string, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("tokens"), $elm$url$Url$Parser$map_fn($author$project$Types$ApiToken$idFromInt, $elm$url$Url$Parser$int)))),
            $elm$url$Url$Parser$map_fn($author$project$Pages$Teams$Route$Billing, $elm$url$Url$Parser$slash_fn(string, $elm$url$Url$Parser$s("billing")))
        ]));
    }();
    var $elm$url$Url$Parser$getFirstMatch = function (states) {
        getFirstMatch: while (true) {
            if (!states.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var state = states.a;
                var rest = states.b;
                var _v1 = state.b6;
                if (!_v1.b) {
                    return $elm$core$Maybe$Just(state.pB);
                }
                else {
                    if ((_v1.a === "") && (!_v1.b.b)) {
                        return $elm$core$Maybe$Just(state.pB);
                    }
                    else {
                        var $temp$states = rest;
                        states = $temp$states;
                        continue getFirstMatch;
                    }
                }
            }
        }
    };
    var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
        if (!segments.b) {
            return _List_Nil;
        }
        else {
            if ((segments.a === "") && (!segments.b.b)) {
                return _List_Nil;
            }
            else {
                var segment = segments.a;
                var rest = segments.b;
                return _List_Cons(segment, $elm$url$Url$Parser$removeFinalEmpty(rest));
            }
        }
    };
    var $elm$url$Url$Parser$preparePath = function (path) {
        var _v0 = $elm$core$String$split_fn("/", path);
        if (_v0.b && (_v0.a === "")) {
            var segments = _v0.b;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
        else {
            var segments = _v0;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
    };
    var $elm$url$Url$Parser$addToParametersHelp_fn = function (value, maybeList) {
        if (maybeList.$ === 1) {
            return $elm$core$Maybe$Just(_List_fromArray([value]));
        }
        else {
            var list = maybeList.a;
            return $elm$core$Maybe$Just(_List_Cons(value, list));
        }
    }, $elm$url$Url$Parser$addToParametersHelp = F2($elm$url$Url$Parser$addToParametersHelp_fn);
    var $elm$core$Basics$compare = _Utils_compare;
    var $elm$core$Dict$get_fn = function (targetKey, dict) {
        get: while (true) {
            if (dict.$ === -2) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var _v1 = _Utils_compare_fn(targetKey, key);
                switch (_v1) {
                    case 0:
                        var $temp$targetKey = targetKey, $temp$dict = left;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                    case 1:
                        return $elm$core$Maybe$Just(value);
                    default:
                        var $temp$targetKey = targetKey, $temp$dict = right;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                }
            }
        }
    }, $elm$core$Dict$get = F2($elm$core$Dict$get_fn);
    var $elm$core$Dict$Black = 1;
    var $elm$core$Dict$RBNode_elm_builtin_fn = function (a, b, c, d, e) {
        return { $: -1, a: a, b: b, c: c, d: d, e: e };
    }, $elm$core$Dict$RBNode_elm_builtin = F5($elm$core$Dict$RBNode_elm_builtin_fn);
    var $elm$core$Dict$RBEmpty_elm_builtin = { $: -2 };
    var $elm$core$Dict$Red = 0;
    var $elm$core$Dict$balance_fn = function (color, key, value, left, right) {
        if ((right.$ === -1) && (!right.a)) {
            var _v1 = right.a;
            var rK = right.b;
            var rV = right.c;
            var rLeft = right.d;
            var rRight = right.e;
            if ((left.$ === -1) && (!left.a)) {
                var _v3 = left.a;
                var lK = left.b;
                var lV = left.c;
                var lLeft = left.d;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBNode_elm_builtin_fn(1, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rLeft, rRight));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, rK, rV, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, left, rLeft), rRight);
            }
        }
        else {
            if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
                var _v5 = left.a;
                var lK = left.b;
                var lV = left.c;
                var _v6 = left.d;
                var _v7 = _v6.a;
                var llK = _v6.b;
                var llV = _v6.c;
                var llLeft = _v6.d;
                var llRight = _v6.e;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, lRight, right));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, left, right);
            }
        }
    }, $elm$core$Dict$balance = F5($elm$core$Dict$balance_fn);
    var $elm$core$Dict$insertHelp_fn = function (key, value, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
        }
        else {
            var nColor = dict.a;
            var nKey = dict.b;
            var nValue = dict.c;
            var nLeft = dict.d;
            var nRight = dict.e;
            var _v1 = _Utils_compare_fn(key, nKey);
            switch (_v1) {
                case 0:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$insertHelp_fn(key, value, nLeft), nRight);
                case 1:
                    return $elm$core$Dict$RBNode_elm_builtin_fn(nColor, nKey, value, nLeft, nRight);
                default:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, nLeft, $elm$core$Dict$insertHelp_fn(key, value, nRight));
            }
        }
    }, $elm$core$Dict$insertHelp = F3($elm$core$Dict$insertHelp_fn);
    var $elm$core$Dict$insert_fn = function (key, value, dict) {
        var _v0 = $elm$core$Dict$insertHelp_fn(key, value, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$insert = F3($elm$core$Dict$insert_fn);
    var $elm$core$Dict$getMin = function (dict) {
        getMin: while (true) {
            if ((dict.$ === -1) && (dict.d.$ === -1)) {
                var left = dict.d;
                var $temp$dict = left;
                dict = $temp$dict;
                continue getMin;
            }
            else {
                return dict;
            }
        }
    };
    var $elm$core$Dict$moveRedLeft = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var lLeft = _v1.d;
                var lRight = _v1.e;
                var _v2 = dict.e;
                var rClr = _v2.a;
                var rK = _v2.b;
                var rV = _v2.c;
                var rLeft = _v2.d;
                var _v3 = rLeft.a;
                var rlK = rLeft.b;
                var rlV = rLeft.c;
                var rlL = rLeft.d;
                var rlR = rLeft.e;
                var rRight = _v2.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, rlK, rlV, $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), rlL), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rlR, rRight));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v4 = dict.d;
                var lClr = _v4.a;
                var lK = _v4.b;
                var lV = _v4.c;
                var lLeft = _v4.d;
                var lRight = _v4.e;
                var _v5 = dict.e;
                var rClr = _v5.a;
                var rK = _v5.b;
                var rV = _v5.c;
                var rLeft = _v5.d;
                var rRight = _v5.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$moveRedRight = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var _v2 = _v1.d;
                var _v3 = _v2.a;
                var llK = _v2.b;
                var llV = _v2.c;
                var llLeft = _v2.d;
                var llRight = _v2.e;
                var lRight = _v1.e;
                var _v4 = dict.e;
                var rClr = _v4.a;
                var rK = _v4.b;
                var rV = _v4.c;
                var rLeft = _v4.d;
                var rRight = _v4.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, lRight, $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight)));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v5 = dict.d;
                var lClr = _v5.a;
                var lK = _v5.b;
                var lV = _v5.c;
                var lLeft = _v5.d;
                var lRight = _v5.e;
                var _v6 = dict.e;
                var rClr = _v6.a;
                var rK = _v6.b;
                var rV = _v6.c;
                var rLeft = _v6.d;
                var rRight = _v6.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$removeHelpPrepEQGT_fn = function (targetKey, dict, color, key, value, left, right) {
        if ((left.$ === -1) && (!left.a)) {
            var _v1 = left.a;
            var lK = left.b;
            var lV = left.c;
            var lLeft = left.d;
            var lRight = left.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, lK, lV, lLeft, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, lRight, right));
        }
        else {
            _v2$2: while (true) {
                if ((right.$ === -1) && (right.a === 1)) {
                    if (right.d.$ === -1) {
                        if (right.d.a === 1) {
                            var _v3 = right.a;
                            var _v4 = right.d;
                            var _v5 = _v4.a;
                            return $elm$core$Dict$moveRedRight(dict);
                        }
                        else {
                            break _v2$2;
                        }
                    }
                    else {
                        var _v6 = right.a;
                        var _v7 = right.d;
                        return $elm$core$Dict$moveRedRight(dict);
                    }
                }
                else {
                    break _v2$2;
                }
            }
            return dict;
        }
    }, $elm$core$Dict$removeHelpPrepEQGT = F7($elm$core$Dict$removeHelpPrepEQGT_fn);
    var $elm$core$Dict$removeMin = function (dict) {
        if ((dict.$ === -1) && (dict.d.$ === -1)) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var lColor = left.a;
            var lLeft = left.d;
            var right = dict.e;
            if (lColor === 1) {
                if ((lLeft.$ === -1) && (!lLeft.a)) {
                    var _v3 = lLeft.a;
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
                }
                else {
                    var _v4 = $elm$core$Dict$moveRedLeft(dict);
                    if (_v4.$ === -1) {
                        var nColor = _v4.a;
                        var nKey = _v4.b;
                        var nValue = _v4.c;
                        var nLeft = _v4.d;
                        var nRight = _v4.e;
                        return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
                    }
                    else {
                        return $elm$core$Dict$RBEmpty_elm_builtin;
                    }
                }
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    };
    var $elm$core$Dict$removeHelp_fn = function (targetKey, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_cmp(targetKey, key) < 0) {
                if ((left.$ === -1) && (left.a === 1)) {
                    var _v4 = left.a;
                    var lLeft = left.d;
                    if ((lLeft.$ === -1) && (!lLeft.a)) {
                        var _v6 = lLeft.a;
                        return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                    }
                    else {
                        var _v7 = $elm$core$Dict$moveRedLeft(dict);
                        if (_v7.$ === -1) {
                            var nColor = _v7.a;
                            var nKey = _v7.b;
                            var nValue = _v7.c;
                            var nLeft = _v7.d;
                            var nRight = _v7.e;
                            return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeHelp_fn(targetKey, nLeft), nRight);
                        }
                        else {
                            return $elm$core$Dict$RBEmpty_elm_builtin;
                        }
                    }
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                }
            }
            else {
                return $elm$core$Dict$removeHelpEQGT_fn(targetKey, $elm$core$Dict$removeHelpPrepEQGT_fn(targetKey, dict, color, key, value, left, right));
            }
        }
    }, $elm$core$Dict$removeHelp = F2($elm$core$Dict$removeHelp_fn);
    var $elm$core$Dict$removeHelpEQGT_fn = function (targetKey, dict) {
        if (dict.$ === -1) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_eq(targetKey, key)) {
                var _v1 = $elm$core$Dict$getMin(right);
                if (_v1.$ === -1) {
                    var minKey = _v1.b;
                    var minValue = _v1.c;
                    return $elm$core$Dict$balance_fn(color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
                }
                else {
                    return $elm$core$Dict$RBEmpty_elm_builtin;
                }
            }
            else {
                return $elm$core$Dict$balance_fn(color, key, value, left, $elm$core$Dict$removeHelp_fn(targetKey, right));
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    }, $elm$core$Dict$removeHelpEQGT = F2($elm$core$Dict$removeHelpEQGT_fn);
    var $elm$core$Dict$remove_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$removeHelp_fn(key, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$remove = F2($elm$core$Dict$remove_fn);
    var $elm$core$Dict$update_fn = function (targetKey, alter, dictionary) {
        var _v0 = alter($elm$core$Dict$get_fn(targetKey, dictionary));
        if (!_v0.$) {
            var value = _v0.a;
            return $elm$core$Dict$insert_fn(targetKey, value, dictionary);
        }
        else {
            return $elm$core$Dict$remove_fn(targetKey, dictionary);
        }
    }, $elm$core$Dict$update = F3($elm$core$Dict$update_fn);
    var $elm$url$Url$Parser$addParam_fn = function (segment, dict) {
        var _v0 = $elm$core$String$split_fn("=", segment);
        if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
            var rawKey = _v0.a;
            var _v1 = _v0.b;
            var rawValue = _v1.a;
            var _v2 = $elm$url$Url$percentDecode(rawKey);
            if (_v2.$ === 1) {
                return dict;
            }
            else {
                var key = _v2.a;
                var _v3 = $elm$url$Url$percentDecode(rawValue);
                if (_v3.$ === 1) {
                    return dict;
                }
                else {
                    var value = _v3.a;
                    return $elm$core$Dict$update_fn(key, $elm$url$Url$Parser$addToParametersHelp(value), dict);
                }
            }
        }
        else {
            return dict;
        }
    }, $elm$url$Url$Parser$addParam = F2($elm$url$Url$Parser$addParam_fn);
    var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
    var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
        if (maybeQuery.$ === 1) {
            return $elm$core$Dict$empty;
        }
        else {
            var qry = maybeQuery.a;
            return $elm$core$List$foldr_fn($elm$url$Url$Parser$addParam, $elm$core$Dict$empty, $elm$core$String$split_fn("&", qry));
        }
    };
    var $elm$url$Url$Parser$parse_fn = function (_v0, url) {
        var parser = _v0;
        return $elm$url$Url$Parser$getFirstMatch(parser($elm$url$Url$Parser$State_fn(_List_Nil, $elm$url$Url$Parser$preparePath(url.ks), $elm$url$Url$Parser$prepareQuery(url.kD), url.jq, $elm$core$Basics$identity)));
    }, $elm$url$Url$Parser$parse = F2($elm$url$Url$Parser$parse_fn);
    var $elm$url$Url$Parser$query = function (_v0) {
        var queryParser = _v0;
        return function (_v1) {
            var visited = _v1.cJ;
            var unvisited = _v1.b6;
            var params = _v1.cy;
            var frag = _v1.ci;
            var value = _v1.pB;
            return _List_fromArray([
                $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, value(queryParser(params)))
            ]);
        };
    };
    var $elm$url$Url$Parser$questionMark_fn = function (parser, queryParser) {
        return $elm$url$Url$Parser$slash_fn(parser, $elm$url$Url$Parser$query(queryParser));
    }, $elm$url$Url$Parser$questionMark = F2($elm$url$Url$Parser$questionMark_fn);
    var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
    var $elm$core$Maybe$withDefault_fn = function (_default, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return value;
        }
        else {
            return _default;
        }
    }, $elm$core$Maybe$withDefault = F2($elm$core$Maybe$withDefault_fn);
    var $elm$url$Url$Parser$Query$custom_fn = function (key, func) {
        return function (dict) {
            return func($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn(key, dict)));
        };
    }, $elm$url$Url$Parser$Query$custom = F2($elm$url$Url$Parser$Query$custom_fn);
    var $elm$url$Url$Parser$Query$string = function (key) {
        return $elm$url$Url$Parser$Query$custom_fn(key, function (stringList) {
            if (stringList.b && (!stringList.b.b)) {
                var str = stringList.a;
                return $elm$core$Maybe$Just(str);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        });
    };
    var $author$project$Types$Database$DatabaseId = $elm$core$Basics$identity;
    var $author$project$Types$Database$wrapId = $elm$core$Basics$identity;
    var $author$project$Route$fromUrl = function () {
        var string = $elm$url$Url$Parser$custom_fn("STRING", $elm$url$Url$percentDecode);
        return $elm$url$Url$Parser$parse($elm$url$Url$Parser$oneOf(_List_fromArray([
            $elm$url$Url$Parser$map_fn($author$project$Route$Home, $elm$url$Url$Parser$top),
            $elm$url$Url$Parser$map_fn($author$project$Route$Affiliate, $elm$url$Url$Parser$s("affiliate")),
            $elm$url$Url$Parser$map_fn($author$project$Route$Pricing, $elm$url$Url$Parser$s("pricing")),
            $elm$url$Url$Parser$map_fn($author$project$Route$Trial, $elm$url$Url$Parser$s("trial")),
            $elm$url$Url$Parser$map_fn($author$project$Route$Signup, $elm$url$Url$Parser$s("signup")),
            $elm$url$Url$Parser$map_fn($author$project$Route$Login, $elm$url$Url$Parser$s("login")),
            $elm$url$Url$Parser$map_fn($author$project$Route$ForgotPassword, $elm$url$Url$Parser$s("forgot-password")),
            $elm$url$Url$Parser$map_fn($author$project$Route$Users, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("users"), $elm$url$Url$Parser$oneOf(_List_fromArray([
                $elm$url$Url$Parser$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$User$nameFromString, $elm$core$Maybe$Just), string),
                $elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top)
            ])))),
            $elm$url$Url$Parser$map_fn($author$project$Route$Teams, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("teams"), $author$project$Pages$Teams$Route$parse)),
            $elm$url$Url$Parser$map_fn($author$project$Route$Admin, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("admin"), $author$project$Pages$Admin$Route$fromString)),
            $elm$url$Url$Parser$map_fn($author$project$Route$DuplicateReadonly, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("readonly"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("duplicate")))),
            $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("dbs"), $elm$url$Url$Parser$oneOf(_List_fromArray([
                $elm$url$Url$Parser$map_fn($author$project$Route$Playground, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("playground"))),
                $elm$url$Url$Parser$map_fn($author$project$Route$Download, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("download"))),
                $elm$url$Url$Parser$map_fn($author$project$Route$Duplicate, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("duplicate"))),
                $elm$url$Url$Parser$map_fn($author$project$Route$RegenerateDbId, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("regenerate-db-id"))),
                $elm$url$Url$Parser$map_fn($author$project$Route$RegenerateReadonlyId, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("regenerate-readonly-id"))),
                $elm$url$Url$Parser$map_fn($author$project$Route$Database, $elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string)),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn($author$project$Route$Tables, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("tables"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$oneOf(_List_fromArray([
                        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, $elm$url$Url$Parser$int),
                        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top)
                    ])), $elm$url$Url$Parser$fragment($elm$core$Maybe$andThen($elm$core$String$toInt))))))),
                    $elm$url$Url$Parser$map_fn($author$project$Route$Tables, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("tables"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top))))))
                ])),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn($author$project$Route$Views, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("views"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$oneOf(_List_fromArray([
                        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, $elm$url$Url$Parser$int),
                        $elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top)
                    ])), $elm$url$Url$Parser$fragment($elm$core$Maybe$andThen($elm$core$String$toInt))))))),
                    $elm$url$Url$Parser$map_fn($author$project$Route$Views, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("views"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Nothing, $elm$url$Url$Parser$top))))))
                ])),
                $elm$url$Url$Parser$map_fn($author$project$Route$Queries, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("queries"), $elm$url$Url$Parser$Query$string("tab")))),
                $elm$url$Url$Parser$map_fn($author$project$Route$GraphiQL, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("graphiql"))),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn(A2($author$project$Util$flip, $author$project$Route$Apps, $elm$core$Maybe$Nothing), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("apps"))),
                    $elm$url$Url$Parser$map_fn($author$project$Route$Apps, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("apps"), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, string))))
                ])),
                $elm$url$Url$Parser$map_fn($author$project$Route$App, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("app"), string))),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn($author$project$Route$Functions, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("functions"), $author$project$Pages$Functions$Route$parse)))
                ])),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn(A2($author$project$Util$flip, $author$project$Route$Dashboards, $elm$core$Maybe$Nothing), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("dashboards"))),
                    $elm$url$Url$Parser$map_fn($author$project$Route$Dashboards, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("dashboards"), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, $author$project$Pages$Dashboards$Route$parse))))
                ])),
                $elm$url$Url$Parser$oneOf(_List_fromArray([
                    $elm$url$Url$Parser$map_fn(A2($author$project$Util$flip, $author$project$Route$Settings, $elm$core$Maybe$Nothing), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$s("settings"))),
                    $elm$url$Url$Parser$map_fn($author$project$Route$Settings, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$map_fn($author$project$Types$Database$wrapId, string), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("settings"), $elm$url$Url$Parser$map_fn($elm$core$Maybe$Just, $author$project$Pages$Settings$Route$parse))))
                ]))
            ])))
        ])));
    }();
    var $author$project$Route$isUsersRoute = function (route) {
        if (route.$ === 8) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$json$Json$Encode$null = _Json_encodeNull;
    var $author$project$Ports$loadPlayground = _Platform_outgoingPort("loadPlayground", function ($) {
        return $elm$json$Json$Encode$null;
    });
    var $elm$core$Basics$composeL_fn = function (g, f, x) {
        return g(f(x));
    }, $elm$core$Basics$composeL = F3($elm$core$Basics$composeL_fn);
    var $author$project$Util$msgCmd_a0 = $elm$core$Task$perform($elm$core$Basics$identity), $author$project$Util$msgCmd_a1 = $elm$core$Task$succeed, $author$project$Util$msgCmd = A2($elm$core$Basics$composeL, $author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1);
    var $elm$core$Basics$not = _Basics_not;
    var $author$project$Shared$RouteTo = function (a) {
        return { $: 5, a: a };
    };
    var $elm_community$list_extra$List$Extra$find_fn = function (predicate, list) {
        find: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var first = list.a;
                var rest = list.b;
                if (predicate(first)) {
                    return $elm$core$Maybe$Just(first);
                }
                else {
                    var $temp$predicate = predicate, $temp$list = rest;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue find;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$find = F2($elm_community$list_extra$List$Extra$find_fn);
    var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
        if (m.$ === 1) {
            return false;
        }
        else {
            return true;
        }
    };
    var $elm$core$Process$sleep = _Process_sleep;
    var $author$project$Util$msgCmdDelayed_fn = function (ms, msg) {
        return $elm$core$Task$perform_fn($elm$core$Basics$always(msg), $elm$core$Process$sleep(ms));
    }, $author$project$Util$msgCmdDelayed = F2($author$project$Util$msgCmdDelayed_fn);
    var $elm$core$Tuple$pair_fn = function (a, b) {
        return _Utils_Tuple2(a, b);
    }, $elm$core$Tuple$pair = F2($elm$core$Tuple$pair_fn);
    var $author$project$Msg$sharedCmd_a0 = $author$project$Msg$SharedMsg, $author$project$Msg$sharedCmd_a1 = $author$project$Util$msgCmd, $author$project$Msg$sharedCmd = A2($elm$core$Basics$composeR, $author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1);
    var $elm_community$maybe_extra$Maybe$Extra$unwrap_fn = function (_default, f, m) {
        if (m.$ === 1) {
            return _default;
        }
        else {
            var a = m.a;
            return f(a);
        }
    }, $elm_community$maybe_extra$Maybe$Extra$unwrap = F3($elm_community$maybe_extra$Maybe$Extra$unwrap_fn);
    var $author$project$Main$onError_fn = function (maybeDialogTitle, errors) {
        if (_Utils_eq(errors, _List_Nil)) {
            return $elm$core$Platform$Cmd$none;
        }
        else {
            var unauthorized = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$list_extra$List$Extra$find_fn($elm$core$String$startsWith("Unauthorized:"), errors));
            var errorDialog = A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Tuple$pair, $elm$core$String$join_fn("\n\n", errors)), A2($elm$core$Basics$composeR, $author$project$Dialog$ErrorDialog, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Msg$SetDialog, $author$project$Util$msgCmdDelayed(0)))));
            return unauthorized ? $elm$core$Platform$Cmd$batch(_List_fromArray([
                errorDialog("Authorization Error"),
                $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteTo($author$project$Route$Login))
            ])) : $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, errorDialog, maybeDialogTitle);
        }
    }, $author$project$Main$onError = F2($author$project$Main$onError_fn);
    var $author$project$Msg$DatabaseRequested_fn = function (a, b) {
        return { $: 16, a: a, b: b };
    }, $author$project$Msg$DatabaseRequested = F2($author$project$Msg$DatabaseRequested_fn);
    var $author$project$Msg$Reset = { $: 2 };
    var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
        if (data.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$core$Maybe$map_fn = function (f, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return $elm$core$Maybe$Just(f(value));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$map = F2($elm$core$Maybe$map_fn);
    var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
        return { $: 2, a: a };
    };
    var $krisajenkins$remotedata$RemoteData$Loading = { $: 1 };
    var $krisajenkins$remotedata$RemoteData$NotAsked = { $: 0 };
    var $krisajenkins$remotedata$RemoteData$Success = function (a) {
        return { $: 3, a: a };
    };
    var $krisajenkins$remotedata$RemoteData$map_fn = function (f, data) {
        switch (data.$) {
            case 3:
                var value = data.a;
                return $krisajenkins$remotedata$RemoteData$Success(f(value));
            case 1:
                return $krisajenkins$remotedata$RemoteData$Loading;
            case 0:
                return $krisajenkins$remotedata$RemoteData$NotAsked;
            default:
                var error = data.a;
                return $krisajenkins$remotedata$RemoteData$Failure(error);
        }
    }, $krisajenkins$remotedata$RemoteData$map = F2($krisajenkins$remotedata$RemoteData$map_fn);
    var $krisajenkins$remotedata$RemoteData$withDefault_fn = function (_default, data) {
        if (data.$ === 3) {
            var x = data.a;
            return x;
        }
        else {
            return _default;
        }
    }, $krisajenkins$remotedata$RemoteData$withDefault = F2($krisajenkins$remotedata$RemoteData$withDefault_fn);
    var $krisajenkins$remotedata$RemoteData$toMaybe_a0 = $krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just), $krisajenkins$remotedata$RemoteData$toMaybe_a1 = $krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing), $krisajenkins$remotedata$RemoteData$toMaybe = A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1);
    var $author$project$Main$requireDatabase_fn = function (maybeSuccessMsg, id, model) {
        var dbLoading = $krisajenkins$remotedata$RemoteData$isLoading(model.j);
        var dbLoaded = function () {
            var maybeIdFromState = $elm$core$Maybe$map_fn(function ($) {
                return $.bR;
            }, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.j));
            return _Utils_eq($elm$core$Maybe$Just(id), maybeIdFromState);
        }();
        return (dbLoaded || dbLoading) ? $elm$core$Platform$Cmd$none : $elm$core$Platform$Cmd$batch(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$DatabaseRequested_fn(maybeSuccessMsg, id)),
            $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$Reset)
        ]));
    }, $author$project$Main$requireDatabase = F3($author$project$Main$requireDatabase_fn);
    var $author$project$Pages$Tables$DataRequested = function (a) {
        return { $: 7, a: a };
    };
    var $elm$core$Basics$neq = _Utils_notEqual;
    var $elm$core$List$all_fn = function (isOkay, list) {
        all: while (true) {
            if (!list.b) {
                return true;
            }
            else {
                var x = list.a;
                if (!isOkay(x)) {
                    return false;
                }
                list = list.b;
                continue all;
            }
        }
    }, $elm$core$List$all = F2($elm$core$List$all_fn);
    var $author$project$Types$Table$find = function (tableName) {
        return $elm_community$list_extra$List$Extra$find(function (table) {
            return _Utils_eq(table.M, tableName);
        });
    };
    var $author$project$Types$Table$getColumns = function (tableName) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Table$find(tableName), A2($elm$core$Basics$composeR, $elm$core$Maybe$map(function ($) {
            return $.iT;
        }), $elm$core$Maybe$withDefault(_List_Nil)));
    };
    var $krisajenkins$remotedata$RemoteData$unwrap_fn = function (_default, _function, remoteData) {
        if (remoteData.$ === 3) {
            var data = remoteData.a;
            return _function(data);
        }
        else {
            return _default;
        }
    }, $krisajenkins$remotedata$RemoteData$unwrap = F3($krisajenkins$remotedata$RemoteData$unwrap_fn);
    var $author$project$Types$Database$getColumns = function (tableName) {
        return A2($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, A2($elm$core$Basics$composeR, function ($) {
            return $.eH;
        }, $author$project$Types$Table$getColumns(tableName)));
    };
    var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
        if (data.$ === 3) {
            var x = data.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$Database$tableLoaded_fn = function (tableName, database) {
        var columns = A2($author$project$Types$Database$getColumns, tableName, database);
        return (!_Utils_eq(columns, _List_Nil)) && $elm$core$List$all_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.y;
        }, $krisajenkins$remotedata$RemoteData$isSuccess), columns);
    }, $author$project$Types$Database$tableLoaded = F2($author$project$Types$Database$tableLoaded_fn);
    var $author$project$Types$Column$isLoading_a0 = function ($) {
        return $.y;
    }, $author$project$Types$Column$isLoading_a1 = $krisajenkins$remotedata$RemoteData$isLoading, $author$project$Types$Column$isLoading = A2($elm$core$Basics$composeR, $author$project$Types$Column$isLoading_a0, $author$project$Types$Column$isLoading_a1);
    var $author$project$Types$Database$tableLoading_fn = function (tableName, database) {
        var columns = A2($author$project$Types$Database$getColumns, tableName, database);
        return (!_Utils_eq(columns, _List_Nil)) && $elm$core$List$all_fn($author$project$Types$Column$isLoading, columns);
    }, $author$project$Types$Database$tableLoading = F2($author$project$Types$Database$tableLoading_fn);
    var $author$project$Types$Database$toDatabaseId_a0 = $krisajenkins$remotedata$RemoteData$toMaybe, $author$project$Types$Database$toDatabaseId_a1 = $elm$core$Maybe$map(function ($) {
        return $.bR;
    }), $author$project$Types$Database$toDatabaseId = A2($elm$core$Basics$composeR, $author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1);
    var $author$project$Main$requireTable_fn = function (model, dbId, tableName) {
        if (!_Utils_eq($elm$core$Maybe$Just(dbId), $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, model.j))) {
            return $elm$core$Platform$Cmd$none;
        }
        else {
            var tableLoading = $author$project$Types$Database$tableLoading_fn(tableName, model.j);
            var tableLoaded = $author$project$Types$Database$tableLoaded_fn(tableName, model.j);
            var dbLoading = $krisajenkins$remotedata$RemoteData$isLoading(model.j);
            return (tableLoaded || (tableLoading || dbLoading)) ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$TablesPageMsgReceived($author$project$Pages$Tables$DataRequested(tableName)));
        }
    }, $author$project$Main$requireTable = F3($author$project$Main$requireTable_fn);
    var $author$project$Pages$Admin$Routed = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Admin$routed = $author$project$Pages$Admin$Routed;
    var $author$project$Pages$Settings$Routed_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Settings$Routed = F2($author$project$Pages$Settings$Routed_fn);
    var $author$project$Pages$Settings$routed = $author$project$Pages$Settings$Routed;
    var $author$project$Pages$Queries$Routed = { $: 1 };
    var $author$project$Pages$Queries$routedMsg = $author$project$Pages$Queries$Routed;
    var $author$project$Main$handleUrlChange_fn = function (url, model) {
        var shared = model.b;
        var cmd = function () {
            var _v0 = _Utils_Tuple2($author$project$Route$fromUrl(url), url.og);
            _v0$0: while (true) {
                if (_v0.a.$ === 1) {
                    if ((!_v0.b.$) && (_v0.b.a === 4186)) {
                        break _v0$0;
                    }
                    else {
                        var _v1 = _v0.a;
                        return $elm$core$Platform$Cmd$none;
                    }
                }
                else {
                    if ((!_v0.b.$) && (_v0.b.a === 4186)) {
                        break _v0$0;
                    }
                    else {
                        var route = _v0.a.a;
                        switch (route.$) {
                            case 0:
                                return $elm$core$Platform$Cmd$none;
                            case 1:
                                return $elm$core$Platform$Cmd$none;
                            case 2:
                                return $elm$core$Platform$Cmd$none;
                            case 3:
                                return $elm$core$Platform$Cmd$none;
                            case 4:
                                return $elm$core$Platform$Cmd$none;
                            case 5:
                                return $elm$core$Platform$Cmd$none;
                            case 6:
                                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$LoginPageMsgReceived($author$project$Pages$Login$RoutedFrom_fn(model.p, $elm$core$Maybe$Just(model.b.eu))));
                            case 7:
                                return $elm$core$Platform$Cmd$none;
                            case 8:
                                var maybeUsername = route.a;
                                return ($author$project$Route$isUsersRoute(route) && (!model.b.aQ.mx.ip)) ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$UsersPageMsgReceived(maybeUsername));
                            case 9:
                                var subRoute = route.a;
                                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$TeamsPageMsgReceived($author$project$Pages$Teams$Routed(subRoute)));
                            case 10:
                                return $elm$core$Platform$Cmd$none;
                            case 11:
                                return $elm$core$Platform$Cmd$none;
                            case 12:
                                return $elm$core$Platform$Cmd$none;
                            case 13:
                                return $elm$core$Platform$Cmd$none;
                            case 14:
                                return $elm$core$Platform$Cmd$none;
                            case 15:
                                return $elm$core$Platform$Cmd$none;
                            case 16:
                                var id = route.a;
                                return $author$project$Main$requireDatabase_fn($elm$core$Maybe$Nothing, id, model);
                            case 17:
                                var id = route.a;
                                var tableName = route.b;
                                return $elm$core$List$foldr_fn($author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1, _List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Just($author$project$Msg$SharedMsg($author$project$Shared$RouteRefresh)), id, model),
                                    $elm$core$Platform$Cmd$batch(_List_fromArray([
                                        $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($author$project$Main$requireTable, model, id), tableName),
                                        $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$TablesPageMsgReceived($author$project$Pages$Tables$Routed(route)))
                                    ]))
                                ]));
                            case 18:
                                var id = route.a;
                                var viewName = route.b;
                                return $elm$core$List$foldr_fn($author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1, _List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Just($author$project$Msg$SharedMsg($author$project$Shared$RouteRefresh)), id, model),
                                    $elm$core$Platform$Cmd$batch(_List_fromArray([
                                        $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($author$project$Main$requireTable, model, id), viewName),
                                        $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$TablesPageMsgReceived($author$project$Pages$Tables$Routed(route)))
                                    ]))
                                ]));
                            case 19:
                                var id = route.a;
                                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Nothing, id, model),
                                    $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$QueriesPageMsgReceived($author$project$Pages$Queries$routedMsg))
                                ]));
                            case 20:
                                var id = route.a;
                                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Nothing, id, model),
                                    $author$project$Ports$loadPlayground(0)
                                ]));
                            case 21:
                                var id = route.a;
                                var maybeAppId = route.b;
                                return $elm$core$List$foldr_fn($author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1, _List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Just($author$project$Msg$SharedMsg($author$project$Shared$RouteRefresh)), id, model),
                                    $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$AppsPageMsgReceived($author$project$Pages$Apps$RouteChanged_fn(id, maybeAppId)))
                                ]));
                            case 22:
                                return $elm$core$Platform$Cmd$none;
                            case 23:
                                var dbId = route.a;
                                var subRoute = route.b;
                                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$FunctionsPageMsgReceived($author$project$Pages$Functions$RouteChanged_fn(model.b.eu, subRoute, dbId))),
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Nothing, dbId, model)
                                ]));
                            case 24:
                                var id = route.a;
                                var dashboardRoute = route.b;
                                return $elm$core$List$foldr_fn($author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1, _List_fromArray([
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Just($author$project$Msg$SharedMsg($author$project$Shared$RouteRefresh)), id, model),
                                    $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$DashboardsPageMsgReceived($author$project$Pages$Dashboards$RouteChanged_fn(id, dashboardRoute)))
                                ]));
                            case 25:
                                var dbId = route.a;
                                var maybeSubRoute = route.b;
                                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$SettingsPageMsgReceived($author$project$Pages$Settings$Routed_fn(dbId, maybeSubRoute))),
                                    $author$project$Main$requireDatabase_fn($elm$core$Maybe$Nothing, dbId, model)
                                ]));
                            default:
                                var subRoute = route.a;
                                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$AdminPageMsgReceived($author$project$Pages$Admin$routed(subRoute)));
                        }
                    }
                }
            }
            return $author$project$Main$onError_fn($elm$core$Maybe$Just("Port Error"), _List_fromArray(["Don't use the Elm development server directly," + (" but via the Airsequel development server" + " at http://localhost:4185")]));
        }();
        return _Utils_Tuple2(_Utils_update(model, {
            b: _Utils_update(shared, {
                kx: $elm$core$Maybe$Just(model.b.eu),
                eu: $elm$core$Maybe$withDefault_fn($author$project$Route$NotFound, $author$project$Route$fromUrl(url)),
                g: url
            })
        }), cmd);
    }, $author$project$Main$handleUrlChange = F2($author$project$Main$handleUrlChange_fn);
    var $author$project$Msg$OverlayMsgReceived = function (a) {
        return { $: 36, a: a };
    };
    var $author$project$Msg$UserMenuMsgReceived = function (a) {
        return { $: 42, a: a };
    };
    var $author$project$Overlay$init_fn = function (container, toMsg) {
        return { gA: container, a$: $elm$core$Maybe$Nothing, gd: toMsg };
    }, $author$project$Overlay$init = F2($author$project$Overlay$init_fn);
    var $author$project$Components$Billing$Yearly = 0;
    var $author$project$Components$Billing$emptyPriceData = { iX: $elm$core$Maybe$Nothing, b0: $elm$core$Maybe$Nothing, a0: $elm$core$Maybe$Nothing, b1: $elm$core$Maybe$Nothing, ky: $elm$core$Maybe$Nothing };
    var $author$project$Components$Billing$init = function (edition) {
        return { cV: $elm$core$Maybe$Nothing, ja: edition, aU: $author$project$Components$Billing$emptyPriceData, aJ: $author$project$Components$Billing$emptyPriceData, aV: $author$project$Components$Billing$emptyPriceData, al: 0, ld: $elm$core$Maybe$Nothing };
    };
    var $author$project$Pages$Admin$Databases$init = { l1: $krisajenkins$remotedata$RemoteData$NotAsked };
    var $author$project$Types$ServerSettings$ServerSettings_fn = function (allowedHosts, envVars) {
        return { iD: allowedHosts, gQ: envVars };
    }, $author$project$Types$ServerSettings$ServerSettings = F2($author$project$Types$ServerSettings$ServerSettings_fn);
    var $author$project$Types$ServerSettings$empty = $author$project$Types$ServerSettings$ServerSettings_fn(_List_Nil, _List_Nil);
    var $author$project$Pages$Admin$Settings$init = { dx: $elm$core$Maybe$Nothing, a$: $elm$core$Maybe$Nothing, kR: $krisajenkins$remotedata$RemoteData$NotAsked, aL: $author$project$Types$ServerSettings$empty, eT: _List_Nil };
    var $author$project$Pages$Admin$init = {
        dP: $author$project$Components$Billing$init($author$project$Types$Edition$Dedicated),
        dZ: $author$project$Pages$Admin$Databases$init,
        hY: $author$project$Pages$Admin$Settings$init
    };
    var $author$project$Pages$Apps$init = { dG: $elm$core$Maybe$Nothing, lz: $krisajenkins$remotedata$RemoteData$NotAsked, i2: $elm$core$Maybe$Nothing, ml: _List_Nil, cm: $elm$core$Maybe$Nothing, la: false };
    var $author$project$Types$ChartType$BarChart_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Types$ChartType$BarChart = F2($author$project$Types$ChartType$BarChart_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$NEA = F3($basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement = function (first) {
        return $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, 0, $elm$core$Array$empty);
    };
    var $author$project$Types$Chart$init = {
        bu: $author$project$Types$ChartType$BarChart_fn("", $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement("")),
        ea: false,
        bR: "",
        ef: 30,
        kZ: "",
        eM: ""
    };
    var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
    var $elm$core$Set$empty = $elm$core$Dict$empty;
    var $author$project$Types$Dashboard$init = { aa: $elm$core$Set$empty, bR: "", eM: "" };
    var $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn = function (mapTitle, mapCharts, c) {
        return {
            aa: mapCharts(c.aa),
            bR: c.bR,
            eM: mapTitle(c.eM)
        };
    }, $author$project$Pages$Dashboards$Forms$dashboardTransForm = F3($author$project$Pages$Dashboards$Forms$dashboardTransForm_fn);
    var $author$project$Types$Validated$setValue = function (a) {
        return { fl: $elm$core$Maybe$Nothing, pB: a };
    };
    var $author$project$Pages$Dashboards$Forms$initDashboardForm_a0 = $author$project$Types$Validated$setValue, $author$project$Pages$Dashboards$Forms$initDashboardForm_a1 = $author$project$Types$Validated$setValue, $author$project$Pages$Dashboards$Forms$initDashboardForm = A2($author$project$Pages$Dashboards$Forms$dashboardTransForm, $author$project$Pages$Dashboards$Forms$initDashboardForm_a0, $author$project$Pages$Dashboards$Forms$initDashboardForm_a1);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$toList = function (_v0) {
        var first = _v0.a;
        var rest = _v0.c;
        return _List_Cons(first, $elm$core$Array$toList(rest));
    };
    var $author$project$Types$ChartType$toHeaders = function (chartType) {
        switch (chartType.$) {
            case 0:
                var x = chartType.a;
                var y = chartType.b;
                return _List_Cons(x, $basti1302$elm_non_empty_array$Array$NonEmpty$toList(y));
            case 1:
                var x = chartType.a;
                var y = chartType.b;
                return _List_Cons(x, $basti1302$elm_non_empty_array$Array$NonEmpty$toList(y));
            default:
                var val = chartType.a;
                return _List_fromArray([val]);
        }
    };
    var $author$project$Pages$Dashboards$Forms$toChartForm = function (chart) {
        return {
            bu: $author$project$Types$Validated$setValue(chart.bu),
            d9: $author$project$Types$Validated$setValue($author$project$Types$ChartType$toHeaders(chart.bu)),
            ea: chart.ea,
            bR: chart.bR,
            ef: $author$project$Types$Validated$setValue($elm$core$String$fromInt(chart.ef)),
            kZ: $author$project$Types$Validated$setValue(chart.kZ),
            eM: $author$project$Types$Validated$setValue(chart.eM)
        };
    };
    var $author$project$Pages$Dashboards$init = {
        dL: $elm$core$Dict$empty,
        ao: $author$project$Pages$Dashboards$Forms$toChartForm($author$project$Types$Chart$init),
        aa: $krisajenkins$remotedata$RemoteData$NotAsked,
        by: $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn($author$project$Pages$Dashboards$Forms$initDashboardForm_a0, $author$project$Pages$Dashboards$Forms$initDashboardForm_a1, $author$project$Types$Dashboard$init),
        aD: $krisajenkins$remotedata$RemoteData$NotAsked,
        cm: $elm$core$Maybe$Nothing,
        eg: $elm$core$Dict$empty,
        fZ: $elm$core$Maybe$Nothing,
        la: false
    };
    var $author$project$Components$Description$init = { gO: $elm$core$Maybe$Nothing };
    var $author$project$Components$TableSchema$init = { aR: $elm$core$Set$empty };
    var $author$project$Pages$Database$init = { a9: $elm$core$Maybe$Nothing, i6: $author$project$Components$Description$init, eG: $author$project$Components$TableSchema$init, la: false };
    var $dillonkearns$elm_form$Form$init = $elm$core$Dict$empty;
    var $author$project$Pages$ForgotPassword$init = function (maybeUser) {
        return {
            bs: $krisajenkins$remotedata$RemoteData$NotAsked,
            d6: $dillonkearns$elm_form$Form$init,
            fA: !_Utils_eq(maybeUser, $elm$core$Maybe$Nothing),
            kx: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Pages$Functions$OverlayMsg = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Pages$Functions$init = {
        dx: $elm$core$Maybe$Nothing,
        dV: $elm$core$Maybe$Nothing,
        aE: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Pages$Functions$OverlayMsg),
        ml: $elm$core$Maybe$Nothing,
        mB: $krisajenkins$remotedata$RemoteData$NotAsked,
        cm: $elm$core$Maybe$Nothing,
        P: $elm$core$Dict$empty,
        la: false
    };
    var $author$project$Pages$Home$init = { mR: false, bD: $elm$core$Maybe$Nothing };
    var $author$project$Pages$Login$init = function (maybeUser) {
        return {
            d6: $dillonkearns$elm_form$Form$init,
            fA: !_Utils_eq(maybeUser, $elm$core$Maybe$Nothing),
            bd: false,
            kx: $elm$core$Maybe$Nothing,
            dh: _List_Nil
        };
    };
    var $PaackEng$paack_remotedata$Remote$Recyclable$NeverAsked = { $: 0 };
    var $author$project$Pages$Queries$QueryTab$NoWrap = 0;
    var $author$project$Api$Response$Success = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Queries$QueryTab$init_fn = function (viewToOverwrite, aiEditor) {
        return {
            dC: aiEditor,
            kI: { cN: 0 },
            a2: $PaackEng$paack_remotedata$Remote$Recyclable$NeverAsked,
            oV: $author$project$Api$Response$Success(""),
            dt: viewToOverwrite
        };
    }, $author$project$Pages$Queries$QueryTab$init = F2($author$project$Pages$Queries$QueryTab$init_fn);
    var $author$project$Pages$Queries$QueryTab$default = function (aiEditor) {
        return $author$project$Pages$Queries$QueryTab$init_fn($elm$core$Maybe$Nothing, aiEditor);
    };
    var $author$project$Pages$Queries$AiEditorExecuting_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Pages$Queries$AiEditorExecuting = F2($author$project$Pages$Queries$AiEditorExecuting_fn);
    var $author$project$Pages$Queries$AiEditorGenerating_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Queries$AiEditorGenerating = F2($author$project$Pages$Queries$AiEditorGenerating_fn);
    var $author$project$Pages$Queries$AiEditorMsgReceived = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Queries$SQLQueryErrored = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Queries$SQLQuerySucceeded = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Pages$Queries$QueryTab$defaultQuery = "select *\nfrom sqlite_master";
    var $elm$core$List$filter_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs = xs.b) {
            if (f(xs.a)) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        return tmp.
            b;
    }, $elm$core$List$filter = F2($elm$core$List$filter_fn);
    var $elm$core$List$head = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(x);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$String$toLower = _String_toLower;
    var $author$project$Pages$Queries$getRiskyQueryAction = function (query) {
        var keywords = _List_fromArray(["drop", "delete"]);
        return $elm$core$List$head($elm$core$List$filter_fn(A2($author$project$Util$flip, $elm$core$String$contains, $elm$core$String$toLower(query)), keywords));
    };
    var $author$project$Components$AiEditor$DialogMsgReceived = function (a) {
        return { $: 10, a: a };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$HCode = $elm$core$Basics$identity;
    var $elm$core$Result$map_fn = function (func, ra) {
        if (!ra.$) {
            var a = ra.a;
            return $elm$core$Result$Ok(func(a));
        }
        else {
            var e = ra.a;
            return $elm$core$Result$Err(e);
        }
    }, $elm$core$Result$map = F2($elm$core$Result$map_fn);
    var $elm$parser$Parser$DeadEnd_fn = function (row, col, problem) {
        return { iR: col, oi: problem, kJ: row };
    }, $elm$parser$Parser$DeadEnd = F3($elm$parser$Parser$DeadEnd_fn);
    var $elm$parser$Parser$problemToDeadEnd = function (p) {
        return $elm$parser$Parser$DeadEnd_fn(p.kJ, p.iR, p.oi);
    };
    var $elm$parser$Parser$Advanced$bagToList_fn = function (bag, list) {
        bagToList: while (true) {
            switch (bag.$) {
                case 0:
                    return list;
                case 1:
                    var bag1 = bag.a;
                    var x = bag.b;
                    var $temp$bag = bag1, $temp$list = _List_Cons(x, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
                default:
                    var bag1 = bag.a;
                    var bag2 = bag.b;
                    var $temp$bag = bag1, $temp$list = $elm$parser$Parser$Advanced$bagToList_fn(bag2, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
            }
        }
    }, $elm$parser$Parser$Advanced$bagToList = F2($elm$parser$Parser$Advanced$bagToList_fn);
    var $elm$parser$Parser$Advanced$run_fn = function (_v0, src) {
        var parse = _v0;
        var _v1 = parse({ iR: 1, bx: _List_Nil, w: 1, fK: 0, kJ: 1, h6: src });
        if (!_v1.$) {
            var value = _v1.b;
            return $elm$core$Result$Ok(value);
        }
        else {
            var bag = _v1.b;
            return $elm$core$Result$Err($elm$parser$Parser$Advanced$bagToList_fn(bag, _List_Nil));
        }
    }, $elm$parser$Parser$Advanced$run = F2($elm$parser$Parser$Advanced$run_fn);
    var $elm$parser$Parser$run_fn = function (parser, source) {
        var _v0 = $elm$parser$Parser$Advanced$run_fn(parser, source);
        if (!_v0.$) {
            var a = _v0.a;
            return $elm$core$Result$Ok(a);
        }
        else {
            var problems = _v0.a;
            return $elm$core$Result$Err($elm$core$List$map_fn($elm$parser$Parser$problemToDeadEnd, problems));
        }
    }, $elm$parser$Parser$run = F2($elm$parser$Parser$run_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Default = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle = function (syntax) {
        return _Utils_Tuple2(0, "nolang");
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
        return { mA: fragments, c4: $elm$core$Maybe$Nothing };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak = { $: 2 };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Comment = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment_fn = function (toStyle, _v0) {
        var syntax = _v0.a;
        var text = _v0.b;
        switch (syntax.$) {
            case 0:
                return { lq: "", ow: 0, C: text };
            case 1:
                return { lq: "", ow: 1, C: text };
            case 2:
                return { lq: "", ow: 0, C: text };
            default:
                var c = syntax.a;
                var _v2 = toStyle(c);
                var requiredStyle = _v2.a;
                var additionalClass = _v2.b;
                return { lq: additionalClass, ow: requiredStyle, C: text };
        }
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp_fn = function (toStyle, _v0, _v1) {
        var syntax = _v0.a;
        var text = _v0.b;
        var lines = _v1.a;
        var fragments = _v1.b;
        var maybeLastSyntax = _v1.c;
        if (_Utils_eq(syntax, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak)) {
            return _Utils_Tuple3(_List_Cons($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(fragments), lines), _List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment_fn(toStyle, _Utils_Tuple2(syntax, text))
            ]), $elm$core$Maybe$Nothing);
        }
        else {
            if (_Utils_eq($elm$core$Maybe$Just(syntax), maybeLastSyntax)) {
                if (fragments.b) {
                    var headFrag = fragments.a;
                    var tailFrags = fragments.b;
                    return _Utils_Tuple3(lines, _List_Cons(_Utils_update(headFrag, {
                        C: _Utils_ap(text, headFrag.C)
                    }), tailFrags), maybeLastSyntax);
                }
                else {
                    return _Utils_Tuple3(lines, _List_Cons($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment_fn(toStyle, _Utils_Tuple2(syntax, text)), fragments), maybeLastSyntax);
                }
            }
            else {
                return _Utils_Tuple3(lines, _List_Cons($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment_fn(toStyle, _Utils_Tuple2(syntax, text)), fragments), $elm$core$Maybe$Just(syntax));
            }
        }
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines_fn = function (toStyle, revTokens) {
        return function (_v0) {
            var lines = _v0.a;
            var frags = _v0.b;
            return _List_Cons($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(frags), lines);
        }($elm$core$List$foldl_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle), _Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing), revTokens));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines_fn);
    var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
    var $elm$parser$Parser$Advanced$Bad_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Bad = F2($elm$parser$Parser$Advanced$Bad_fn);
    var $elm$parser$Parser$Advanced$Good_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $elm$parser$Parser$Advanced$Good = F3($elm$parser$Parser$Advanced$Good_fn);
    var $elm$parser$Parser$Advanced$loopHelp_fn = function (p, state, callback, s0) {
        loopHelp: while (true) {
            var _v0 = callback(state);
            var parse = _v0;
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p1 = _v1.a;
                var step = _v1.b;
                var s1 = _v1.c;
                if (!step.$) {
                    var newState = step.a;
                    var $temp$p = p || p1, $temp$state = newState, $temp$callback = callback, $temp$s0 = s1;
                    p = $temp$p;
                    state = $temp$state;
                    callback = $temp$callback;
                    s0 = $temp$s0;
                    continue loopHelp;
                }
                else {
                    var result = step.a;
                    return $elm$parser$Parser$Advanced$Good_fn(p || p1, result, s1);
                }
            }
            else {
                var p1 = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p || p1, x);
            }
        }
    }, $elm$parser$Parser$Advanced$loopHelp = F4($elm$parser$Parser$Advanced$loopHelp_fn);
    var $elm$parser$Parser$Advanced$loop_fn = function (state, callback) {
        return function (s) {
            return $elm$parser$Parser$Advanced$loopHelp_fn(false, state, callback, s);
        };
    }, $elm$parser$Parser$Advanced$loop = F2($elm$parser$Parser$Advanced$loop_fn);
    var $elm$parser$Parser$Advanced$map_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(a), s1);
            }
            else {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
        };
    }, $elm$parser$Parser$Advanced$map = F2($elm$parser$Parser$Advanced$map_fn);
    var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
    var $elm$parser$Parser$Advanced$Done = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$Advanced$Loop = function (a) {
        return { $: 0, a: a };
    };
    var $elm$parser$Parser$toAdvancedStep = function (step) {
        if (!step.$) {
            var s = step.a;
            return $elm$parser$Parser$Advanced$Loop(s);
        }
        else {
            var a = step.a;
            return $elm$parser$Parser$Advanced$Done(a);
        }
    };
    var $elm$parser$Parser$loop_fn = function (state, callback) {
        return $elm$parser$Parser$Advanced$loop_fn(state, function (s) {
            return $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$toAdvancedStep, callback(s));
        });
    }, $elm$parser$Parser$loop = F2($elm$parser$Parser$loop_fn);
    var $elm$parser$Parser$Done = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$Loop = function (a) {
        return { $: 0, a: a };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal = { $: 0 };
    var $elm$parser$Parser$UnexpectedChar = { $: 11 };
    var $elm$parser$Parser$Advanced$AddRight_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$AddRight = F2($elm$parser$Parser$Advanced$AddRight_fn);
    var $elm$parser$Parser$Advanced$DeadEnd_fn = function (row, col, problem, contextStack) {
        return { iR: col, lV: contextStack, oi: problem, kJ: row };
    }, $elm$parser$Parser$Advanced$DeadEnd = F4($elm$parser$Parser$Advanced$DeadEnd_fn);
    var $elm$parser$Parser$Advanced$Empty = { $: 0 };
    var $elm$parser$Parser$Advanced$fromState_fn = function (s, x) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(s.kJ, s.iR, x, s.bx));
    }, $elm$parser$Parser$Advanced$fromState = F2($elm$parser$Parser$Advanced$fromState_fn);
    var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
    var $elm$core$Basics$negate = function (n) {
        return -n;
    };
    var $elm$parser$Parser$Advanced$chompIf_fn = function (isGood, expecting) {
        return function (s) {
            var newOffset = _Parser_isSubChar_fn(isGood, s.fK, s.h6);
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : (newOffset === -2 ? $elm$parser$Parser$Advanced$Good_fn(true, 0, { iR: 1, bx: s.bx, w: s.w, fK: s.fK + 1, kJ: s.kJ + 1, h6: s.h6 }) : $elm$parser$Parser$Advanced$Good_fn(true, 0, { iR: s.iR + 1, bx: s.bx, w: s.w, fK: newOffset, kJ: s.kJ, h6: s.h6 }));
        };
    }, $elm$parser$Parser$Advanced$chompIf = F2($elm$parser$Parser$Advanced$chompIf_fn);
    var $elm$parser$Parser$chompIf = function (isGood) {
        return $elm$parser$Parser$Advanced$chompIf_fn(isGood, $elm$parser$Parser$UnexpectedChar);
    };
    var $elm$parser$Parser$Advanced$mapChompedString_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, A2(func, _String_slice_fn(s0.fK, s1.fK, s0.h6), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(_String_slice_fn(s0.fK, s1.fK, s0.h6), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString = F2($elm$parser$Parser$Advanced$mapChompedString_fn);
    var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
        return $elm$parser$Parser$Advanced$mapChompedString_fn($elm$core$Basics$always, parser);
    };
    var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
    var $elm$parser$Parser$Advanced$Append_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Append = F2($elm$parser$Parser$Advanced$Append_fn);
    var $elm$parser$Parser$Advanced$oneOfHelp_fn = function (s0, bag, parsers) {
        oneOfHelp: while (true) {
            if (!parsers.b) {
                return $elm$parser$Parser$Advanced$Bad_fn(false, bag);
            }
            else {
                var parse = parsers.a;
                var remainingParsers = parsers.b;
                var _v1 = parse(s0);
                if (!_v1.$) {
                    var step = _v1;
                    return step;
                }
                else {
                    var step = _v1;
                    var p = step.a;
                    var x = step.b;
                    if (p) {
                        return step;
                    }
                    else {
                        var $temp$s0 = s0, $temp$bag = $elm$parser$Parser$Advanced$Append_fn(bag, x), $temp$parsers = remainingParsers;
                        s0 = $temp$s0;
                        bag = $temp$bag;
                        parsers = $temp$parsers;
                        continue oneOfHelp;
                    }
                }
            }
        }
    }, $elm$parser$Parser$Advanced$oneOfHelp = F3($elm$parser$Parser$Advanced$oneOfHelp_fn);
    var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
        return function (s) {
            return $elm$parser$Parser$Advanced$oneOfHelp_fn(s, $elm$parser$Parser$Advanced$Empty, parsers);
        };
    };
    var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
    var $elm$parser$Parser$Advanced$succeed = function (a) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Good_fn(false, a, s);
        };
    };
    var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
    var $elm$parser$Parser$ExpectingSymbol = function (a) {
        return { $: 8, a: a };
    };
    var $elm$parser$Parser$Advanced$Token_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Token = F2($elm$parser$Parser$Advanced$Token_fn);
    var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
    var $elm$parser$Parser$Advanced$token = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(str);
        return function (s) {
            var _v1 = _Parser_isSubString_fn(str, s.fK, s.kJ, s.iR, s.h6);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : $elm$parser$Parser$Advanced$Good_fn(progress, 0, { iR: newCol, bx: s.bx, w: s.w, fK: newOffset, kJ: newRow, h6: s.h6 });
        };
    };
    var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
    var $elm$parser$Parser$symbol = function (str) {
        return $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$ExpectingSymbol(str)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$lineBreak = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n");
    }, $elm$parser$Parser$symbol("\n"));
    var $elm$parser$Parser$Advanced$chompWhileHelp_fn = function (isGood, offset, row, col, s0) {
        chompWhileHelp: while (true) {
            var newOffset = _Parser_isSubChar_fn(isGood, offset, s0.h6);
            if (newOffset === -1) {
                return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s0.fK, offset) < 0, 0, { iR: col, bx: s0.bx, w: s0.w, fK: offset, kJ: row, h6: s0.h6 });
            }
            else {
                if (newOffset === -2) {
                    var $temp$isGood = isGood, $temp$offset = offset + 1, $temp$row = row + 1, $temp$col = 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
                else {
                    var $temp$isGood = isGood, $temp$offset = newOffset, $temp$row = row, $temp$col = col + 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
            }
        }
    }, $elm$parser$Parser$Advanced$chompWhileHelp = F5($elm$parser$Parser$Advanced$chompWhileHelp_fn);
    var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
        return function (s) {
            return $elm$parser$Parser$Advanced$chompWhileHelp_fn(isGood, s.fK, s.kJ, s.iR, s);
        };
    };
    var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
    var $elm$parser$Parser$Advanced$map2_fn = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, A2(func, a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2_fn_unwrapped = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, func(a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2 = F3($elm$parser$Parser$Advanced$map2_fn);
    var $elm$parser$Parser$Advanced$ignorer_fn = function (keepParser, ignoreParser) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$always, keepParser, ignoreParser);
    }, $elm$parser$Parser$Advanced$ignorer = F2($elm$parser$Parser$Advanced$ignorer_fn);
    var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf(isNotRelevant)), $elm$parser$Parser$chompWhile(isNotRelevant));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
        return (c === " ") || (c === "\t");
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$space = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$whitespace = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$space, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$lineBreak]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$mainLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$whitespace),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b), revTokens));
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Basics$always(true)))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toRevTokens = $elm$parser$Parser$loop_fn(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines_a0 = $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toRevTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines_a1 = $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$toLines, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang_a1 = $elm$core$Result$map($elm$core$Basics$identity), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang_a1);
    var $author$project$Components$Editor$init_fn = function (maybeMinLines, maybeParser, content) {
        return {
            gB: content,
            dY: 0,
            eb: content,
            ei: $elm$core$Maybe$withDefault_fn(18, maybeMinLines),
            fQ: $elm$core$Maybe$withDefault_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang, maybeParser)
        };
    }, $author$project$Components$Editor$init = F3($author$project$Components$Editor$init_fn);
    var $author$project$Components$AiEditor$init = function (cfg) {
        return {
            iA: cfg.iA,
            ls: cfg.ls,
            lt: cfg.lt,
            lu: cfg.lu,
            iU: cfg.iU,
            e7: cfg.e7,
            l8: cfg.l8,
            aE: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Components$AiEditor$DialogMsgReceived),
            gO: $author$project$Components$Editor$init_fn(cfg.mg, cfg.mh, cfg.gB),
            gR: false,
            gY: false,
            bC: cfg.bC,
            ek: cfg.ek,
            nT: cfg.nT,
            el: cfg.el,
            fM: cfg.fM,
            m: cfg.m,
            gd: cfg.gd
        };
    };
    var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$property_fn = function (key, value) {
        return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (":" + value));
    }, $rtfeldman$elm_css$Css$property = F2($rtfeldman$elm_css$Css$property_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_full = $rtfeldman$elm_css$Css$property_fn("max-height", "100%");
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style1 = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style2 = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style3 = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style4 = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style5 = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style6 = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style7 = 8;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(2, "sql-n");
            case 1:
                return _Utils_Tuple2(3, "sql-s");
            case 2:
                return _Utils_Tuple2(4, "sql-k");
            case 3:
                return _Utils_Tuple2(5, "sql-o");
            case 4:
                return _Utils_Tuple2(6, "sql-f");
            case 5:
                return _Utils_Tuple2(7, "sql-p");
            default:
                return _Utils_Tuple2(8, "sql-l");
        }
    };
    var $elm$parser$Parser$Advanced$andThen_fn = function (callback, _v0) {
        var parseA = _v0;
        return function (s0) {
            var _v1 = parseA(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                var _v2 = callback(a);
                var parseB = _v2;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, b, s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$andThen = F2($elm$parser$Parser$Advanced$andThen_fn);
    var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment = { $: 1 };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
        return c === "\n";
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn = function (isNotRelevant, previousParser) {
        return $elm$parser$Parser$Advanced$ignorer_fn(previousParser, $elm$parser$Parser$chompWhile(isNotRelevant));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$inlineComment = $elm$parser$Parser$oneOf($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$parser$Parser$symbol, A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak)), A2($elm$core$Basics$composeR, $elm$parser$Parser$getChompedString, $elm$parser$Parser$map(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
        ]);
    })))), _List_fromArray(["--", "$", "#"])));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen_fn = function (f, list, plist) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (n) {
            return f(_Utils_ap(n, list));
        }, plist);
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen_fn = function (f, list, pn) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (n) {
            return f(_List_Cons(n, list));
        }, pn);
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen_fn);
    var $elm$parser$Parser$ExpectingEnd = { $: 10 };
    var $elm$parser$Parser$Advanced$end = function (x) {
        return function (s) {
            return _Utils_eq($elm$core$String$length(s.h6), s.fK) ? $elm$parser$Parser$Advanced$Good_fn(false, 0, s) : $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable_fn = function (options, revAList) {
        var defaultMap = options.i4;
        var isNotRelevant = options.jM;
        var end = options.u;
        var innerParsers = options.jF;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(_List_Cons(defaultMap(end), revAList)), $elm$parser$Parser$symbol(end)),
            $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(revAList), $elm$parser$Parser$end),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, $elm$parser$Parser$oneOf(innerParsers)),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, $elm$parser$Parser$Advanced$map_fn(defaultMap, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn(isNotRelevant, $elm$parser$Parser$chompIf($elm$core$Basics$always(true))))))
        ]));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable_fn = function (nestLevel, options, revAList) {
        var defaultMap = options.i4;
        var isNotRelevant = options.jM;
        var start = options.x;
        var end = options.u;
        var innerParsers = options.jF;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$andThen_fn(function (n) {
                return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable_fn(nestLevel - 1, options, n);
            }, $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(_List_Cons(defaultMap(end), revAList)), $elm$parser$Parser$symbol(end))),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen_fn(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options), revAList, $elm$parser$Parser$Advanced$map_fn(defaultMap, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn(isNotRelevant, $elm$parser$Parser$symbol(start))))),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, $elm$parser$Parser$oneOf(innerParsers)),
            $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(revAList), $elm$parser$Parser$end),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen_fn(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options), revAList, $elm$parser$Parser$Advanced$map_fn(defaultMap, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn(isNotRelevant, $elm$parser$Parser$chompIf($elm$core$Basics$always(true))))))
        ]));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable_fn);
    var $elm$parser$Parser$Problem = function (a) {
        return { $: 12, a: a };
    };
    var $elm$parser$Parser$Advanced$problem = function (x) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$problem = function (msg) {
        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(msg));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp_fn = function (options, revAList) {
        var start = options.x;
        var end = options.u;
        var isNotRelevant = options.jM;
        var _v0 = _Utils_Tuple2($elm$core$String$uncons(options.x), $elm$core$String$uncons(options.u));
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return $elm$parser$Parser$problem("Trying to parse a delimited helper, but the start token cannot be an empty string!");
        }
        else {
            if (_v0.b.$ === 1) {
                var _v2 = _v0.b;
                return $elm$parser$Parser$problem("Trying to parse a delimited helper, but the end token cannot be an empty string!");
            }
            else {
                var _v3 = _v0.a.a;
                var startChar = _v3.a;
                var _v4 = _v0.b.a;
                var endChar = _v4.a;
                return options.jK ? $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable_fn(1, _Utils_update(options, {
                    jM: function (c) {
                        return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
                    }
                }), revAList) : $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable_fn(_Utils_update(options, {
                    jM: function (c) {
                        return isNotRelevant(c) && (!_Utils_eq(c, endChar));
                    }
                }), revAList);
            }
        }
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited = function (options) {
        var start = options.x;
        var isNotRelevant = options.jM;
        var defaultMap = options.i4;
        return $elm$parser$Parser$Advanced$andThen_fn(function (n) {
            return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp_fn(options, _List_fromArray([n]));
        }, $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(defaultMap(start)), $elm$parser$Parser$symbol(start)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n")
        ]);
    }, $elm$parser$Parser$symbol("\n"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited({
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
        },
        u: "*/",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList]),
        jK: false,
        jM: A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
        x: "/*"
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$multilineComment]));
    var $elm$core$Dict$member_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$get_fn(key, dict);
        if (!_v0.$) {
            return true;
        }
        else {
            return false;
        }
    }, $elm$core$Dict$member = F2($elm$core$Dict$member_fn);
    var $elm$core$Set$member_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$member_fn(key, dict);
    }, $elm$core$Set$member = F2($elm$core$Set$member_fn);
    var $elm$core$Set$insert_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$insert_fn(key, 0, dict);
    }, $elm$core$Set$insert = F2($elm$core$Set$insert_fn);
    var $elm$core$Set$fromList = function (list) {
        return $elm$core$List$foldl_fn($elm$core$Set$insert, $elm$core$Set$empty, list);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuatorSet = $elm$core$Set$fromList(_List_fromArray([";", "[", "]", "(", ")", "`", ",", "."]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuatorSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isIdentifierChar = function (c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar(c));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C = function (a) {
        return { $: 3, a: a };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Function = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Keyword = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Literal = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Operator = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$functionSet = $elm$core$Set$fromList(_List_fromArray(["AVG", "COUNT", "FIRST", "FORMAT", "LAST", "LCASE", "LEN", "MAX", "MID", "MIN", "MOD", "NOW", "ROUND", "SUM", "UCASE"]));
    var $elm$core$String$toUpper = _String_toUpper;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isFunction = function (str) {
        return $elm$core$Set$member_fn($elm$core$String$toUpper(str), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$functionSet);
    };
    var $elm$regex$Regex$Match_fn = function (match, index, number, submatches) {
        return { i: index, j_: match, nF: number, o$: submatches };
    }, $elm$regex$Regex$Match = F4($elm$regex$Regex$Match_fn);
    var $elm$regex$Regex$contains = _Regex_contains;
    var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
    var $elm$regex$Regex$never = _Regex_never;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordPattern = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, _Regex_fromStringWith_fn({ lM: true, j3: false }, "^(ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURNS?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)$"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordPattern, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword_a0);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$literalSet = $elm$core$Set$fromList(_List_fromArray(["TRUE", "FALSE", "NULL"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isLiteral = function (str) {
        return $elm$core$Set$member_fn($elm$core$String$toUpper(str), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$literalSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$operatorPattern = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, _Regex_fromStringWith_fn({ lM: true, j3: false }, "^([-+*\\/=%^~]|&&?|\\|\\|?|!=?|<(?:=>?|<|>)?|>[>=]?|AND|BETWEEN|IN|LIKE|NOT|OR|IS|DIV|REGEXP|RLIKE|SOUNDS LIKE|XOR)$"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$operatorPattern, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator_a0);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser_fn = function (revTokens, s) {
        return _Regex_contains_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator_a0, s) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), s), revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isFunction(s) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), s), revTokens)) : (_Regex_contains_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword_a0, s) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), s), revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isLiteral(s) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), s), revTokens)) : $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s), revTokens)))));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n");
    }, $elm$parser$Parser$symbol("\n"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Number = 0;
    var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(false, x);
            }
            else {
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(false, a, s1);
            }
        };
    };
    var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
    var $elm$core$Char$isHexDigit = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$hexNumber = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol("0x"))), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($elm$core$Char$isHexDigit));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber = function (c) {
        return $elm$core$Char$isDigit(c) || (c === ".");
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber)), $elm$parser$Parser$chompWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol("-"))), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$number = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0), b);
    }, $elm$parser$Parser$getChompedString($elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$hexNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]))));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Punctuation = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuationChar = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$String = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
        return c === "\\";
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(_List_fromArray(["'", "\"", "\\", "n", "r", "t", "b", "f", "v"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol("\\"))), $elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$sqlEscapable = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter = {
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), b);
        },
        u: "'",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$sqlEscapable]),
        jK: false,
        jM: function (c) {
            return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
        },
        x: "'"
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter, { u: "\"", x: "\"" }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$doubleQuote]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$checkContext = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_List_Cons(s, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space),
            $elm$parser$Parser$Advanced$andThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$checkContext, $elm$parser$Parser$Advanced$map_fn(function (s) {
                return _List_Cons(s, revTokens);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak)),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_Utils_ap(s, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringBody = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_Utils_ap(s, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$mainLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuationChar),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$number),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_Utils_ap(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn(function (n) {
                return $elm$parser$Parser$loop_fn(_Utils_ap(n, revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringBody);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral)),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser(revTokens), $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isIdentifierChar)))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toRevTokens = $elm$parser$Parser$loop_fn(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines_a0 = $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toRevTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines_a1 = $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql_a1 = $elm$core$Result$map($elm$core$Basics$identity), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql_a1);
    var $author$project$Pages$Queries$initAiEditor = function (maybeSchema) {
        var content = $elm$core$Maybe$withDefault_fn($author$project$Pages$Queries$QueryTab$defaultQuery, maybeSchema);
        return $author$project$Components$AiEditor$init({
            iA: "",
            ls: $elm$core$Maybe$Just("Generate Query"),
            lt: $elm$core$Maybe$Nothing,
            lu: $elm$core$Maybe$Nothing,
            iU: $elm$core$Maybe$Just("Execute Query"),
            gB: content,
            e7: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $author$project$Pages$Queries$getRiskyQueryAction, $elm$core$Maybe$map(function (action) {
                return "Your query seems to contain a " + (action + (" statement and therefore might" + " delete data."));
            }))),
            l8: $elm$core$Maybe$Just(content),
            mg: $elm$core$Maybe$Just(12),
            mh: $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql),
            bC: F2(function (toMsg_, query) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Queries$AiEditorExecuting_fn(toMsg_, query));
            }),
            ek: $elm$core$Maybe$Nothing,
            nT: A2($elm$core$Basics$composeR, $author$project$Pages$Queries$SQLQueryErrored, $author$project$Util$msgCmd),
            el: F2(function (toMsg_, prompt) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Queries$AiEditorGenerating_fn(toMsg_, prompt));
            }),
            fM: A2($elm$core$Basics$composeR, $author$project$Pages$Queries$SQLQuerySucceeded, $author$project$Util$msgCmd),
            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_full]),
            gd: $author$project$Pages$Queries$AiEditorMsgReceived
        });
    };
    var $author$project$Pages$Queries$init = {
        ff: "",
        cm: $elm$core$Maybe$Nothing,
        n: $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement($author$project$Pages$Queries$QueryTab$default($author$project$Pages$Queries$initAiEditor($elm$core$Maybe$Nothing))),
        eG: $author$project$Components$TableSchema$init,
        la: false
    };
    var $author$project$Pages$Settings$init = { dx: $elm$core$Maybe$Nothing, cZ: $elm$core$Maybe$Nothing, kR: $krisajenkins$remotedata$RemoteData$NotAsked, aL: $elm$core$Maybe$Nothing, eT: _List_Nil };
    var $author$project$Pages$Signup$init = { d6: $dillonkearns$elm_form$Form$init, dh: _List_Nil, ew: false, cC: false };
    var $author$project$Pages$Tables$AddTableOverlayMsgReceived = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Tables$TableMenuMsgReceived = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Types$TableEdit$empty = { M: "", kp: $elm$core$Maybe$Nothing, o8: $elm$core$Maybe$Nothing };
    var $author$project$Pages$Tables$init = {
        dy: "",
        dz: "",
        aA: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Pages$Tables$AddTableOverlayMsgReceived),
        cc: $elm$core$Dict$empty,
        ce: $elm$core$Maybe$Nothing,
        aH: $elm$core$Maybe$Nothing,
        bz: $elm$core$Maybe$Nothing,
        dc: _List_Nil,
        a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Pages$Tables$TableMenuMsgReceived),
        bm: $author$project$Types$TableEdit$empty,
        an: $elm$core$Maybe$Nothing,
        Z: $elm$core$Dict$empty,
        la: false,
        b7: $elm$core$Dict$empty
    };
    var $author$project$Pages$Teams$OverlayMsg = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Types$Billing$Pro = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Types$Billing$BillingDetails_fn = function (subscriptionId, emailAddress) {
        return { jc: emailAddress, o3: subscriptionId };
    }, $author$project$Types$Billing$BillingDetails = F2($author$project$Types$Billing$BillingDetails_fn);
    var $author$project$Types$Billing$emptyBillingDetails = $author$project$Types$Billing$BillingDetails_fn(0, "");
    var $author$project$Pages$Teams$Settings$init = { b4: $elm$core$Maybe$Nothing, bn: $krisajenkins$remotedata$RemoteData$NotAsked, dn: $elm$core$Maybe$Nothing, bo: false, cF: $elm$core$Maybe$Nothing, ps: $krisajenkins$remotedata$RemoteData$NotAsked };
    var $author$project$Pages$Teams$Tokens$init = { k2: $krisajenkins$remotedata$RemoteData$NotAsked };
    var $author$project$Pages$Teams$init = {
        dO: $author$project$Components$Billing$init($author$project$Types$Edition$Shared($author$project$Types$Billing$Pro($author$project$Types$Billing$emptyBillingDetails))),
        mR: false,
        a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Pages$Teams$OverlayMsg),
        bD: $elm$core$Maybe$Nothing,
        hY: $author$project$Pages$Teams$Settings$init,
        dn: $elm$core$Maybe$Nothing,
        eP: $author$project$Pages$Teams$Tokens$init
    };
    var $author$project$Pages$Trial$init = { jb: "", eq: "", es: "", b2: $krisajenkins$remotedata$RemoteData$NotAsked, eE: "" };
    var $author$project$Pages$Users$init = {};
    var $elm$time$Time$Posix = $elm$core$Basics$identity;
    var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
    var $author$project$Model$init = function (shared) {
        return {
            gn: $author$project$Pages$Admin$init,
            gp: $author$project$Pages$Apps$init,
            gD: $author$project$Pages$Dashboards$init,
            j: $krisajenkins$remotedata$RemoteData$NotAsked,
            gF: $author$project$Pages$Database$init,
            mc: $elm$core$Maybe$Nothing,
            ml: _List_Nil,
            jm: _List_Nil,
            jn: _List_Nil,
            gU: $author$project$Pages$ForgotPassword$init($elm$core$Maybe$Nothing),
            gW: $author$project$Pages$Functions$init,
            g1: $author$project$Pages$Home$init,
            hn: $author$project$Pages$Login$init($elm$core$Maybe$Nothing),
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Msg$OverlayMsgReceived),
            hQ: $author$project$Pages$Queries$init,
            hY: $author$project$Pages$Settings$init,
            b: shared,
            h_: $author$project$Pages$Signup$init,
            eI: $author$project$Pages$Tables$init,
            f9: $author$project$Pages$Teams$init,
            pf: $elm$time$Time$millisToPosix(0),
            im: $author$project$Pages$Trial$init,
            bF: _List_Nil,
            a3: $elm$core$Maybe$Nothing,
            p: $elm$core$Maybe$Nothing,
            eU: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Msg$UserMenuMsgReceived),
            gj: $author$project$Pages$Users$init
        };
    };
    var $author$project$Config$enterprise = { mx: $author$project$Types$Flags$default, fC: 20, fD: 500, fE: 6000 };
    var $author$project$Config$free = { mx: $author$project$Types$Flags$default, fC: 2, fD: 10, fE: 3000 };
    var $author$project$Config$pro = { mx: $author$project$Types$Flags$default, fC: 10, fD: 100, fE: 6000 };
    var $author$project$Config$init = function (flags) {
        var _v0 = flags.ja;
        if (!_v0.$) {
            var billing = _v0.a;
            if (!billing.$) {
                return _Utils_update($author$project$Config$free, { mx: flags });
            }
            else {
                return _Utils_update($author$project$Config$pro, { mx: flags });
            }
        }
        else {
            return _Utils_update($author$project$Config$enterprise, { mx: flags });
        }
    };
    var $author$project$Shared$init_fn = function (flags, url, key, maybeToken) {
        return {
            aQ: $author$project$Config$init(flags),
            jQ: key,
            kx: $elm$core$Maybe$Nothing,
            eu: $elm$core$Maybe$withDefault_fn($author$project$Route$NotFound, $author$project$Route$fromUrl(url)),
            k2: maybeToken,
            g: url
        };
    }, $author$project$Shared$init = F4($author$project$Shared$init_fn);
    var $elm$core$Maybe$map2_fn = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(A2(func, a, b));
            }
        }
    }, $elm$core$Maybe$map2_fn_unwrapped = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(func(a, b));
            }
        }
    }, $elm$core$Maybe$map2 = F3($elm$core$Maybe$map2_fn);
    var $elm$core$Tuple$mapSecond_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(x, func(y));
    }, $elm$core$Tuple$mapSecond = F2($elm$core$Tuple$mapSecond_fn);
    var $elm$time$Time$Name = function (a) {
        return { $: 0, a: a };
    };
    var $elm$time$Time$Offset = function (a) {
        return { $: 1, a: a };
    };
    var $elm$time$Time$Zone_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$time$Time$Zone = F2($elm$time$Time$Zone_fn);
    var $elm$time$Time$customZone = $elm$time$Time$Zone;
    var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
    var $elm$core$Result$toMaybe = function (result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Maybe$Just(v);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Login$TokenReceived_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Login$TokenReceived = F2($author$project$Pages$Login$TokenReceived_fn);
    var $author$project$Pages$Login$tokenReceivedMsg_fn = function (username, token) {
        return $author$project$Pages$Login$TokenReceived_fn(username, $author$project$Api$Response$Success(token));
    }, $author$project$Pages$Login$tokenReceivedMsg = F2($author$project$Pages$Login$tokenReceivedMsg_fn);
    var $author$project$Util$withCmd_fn = function (cmdNew, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([cmdNew, cmd])));
    }, $author$project$Util$withCmd = F2($author$project$Util$withCmd_fn);
    var $elm$core$Result$withDefault_fn = function (def, result) {
        if (!result.$) {
            var a = result.a;
            return a;
        }
        else {
            return def;
        }
    }, $elm$core$Result$withDefault = F2($elm$core$Result$withDefault_fn);
    var $author$project$Main$init_fn = function (flagsV, url, key) {
        var maybeSessionToken = $elm$core$Result$toMaybe(_Json_run_fn($author$project$Types$SessionToken$decode, flagsV));
        var maybeGetUserCmd = function () {
            var maybeUsername = $elm$core$Result$toMaybe(_Json_run_fn(_Json_decodeField_fn("username", $elm$json$Json$Decode$string), flagsV));
            return $elm$core$Maybe$map2_fn_unwrapped(function (username, sessionToken) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$LoginPageMsgReceived($author$project$Pages$Login$tokenReceivedMsg_fn(username, sessionToken)));
            }, maybeUsername, maybeSessionToken);
        }();
        var flagsRes = _Json_run_fn($author$project$Types$Flags$decode, flagsV);
        var flagsErrorDialogCmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Msg$SetDialog, $author$project$Util$msgCmd)), $elm$core$Maybe$map_fn(function (s) {
            return $author$project$Dialog$ErrorDialog(_Utils_Tuple2("Error decoding flags", $elm$json$Json$Decode$errorToString(s)));
        }, $elm_community$result_extra$Result$Extra$error(flagsRes)));
        var flags = $elm$core$Result$withDefault_fn($author$project$Types$Flags$default, flagsRes);
        var shared = $author$project$Shared$init_fn(flags, url, key, maybeSessionToken);
        return $author$project$Util$withCmd_fn(flagsErrorDialogCmd, $author$project$Util$withCmd_fn($elm$core$Task$perform_fn($author$project$Msg$TimeUpdated, $elm$time$Time$now), function () {
            if (maybeGetUserCmd.$ === 1) {
                return $elm$core$Basics$identity;
            }
            else {
                var getUserCmd = maybeGetUserCmd.a;
                return $elm$core$Tuple$mapSecond($elm$core$Basics$always(getUserCmd));
            }
        }()($author$project$Main$handleUrlChange_fn(url, $author$project$Model$init(shared)))));
    }, $author$project$Main$init = F3($author$project$Main$init_fn);
    var $author$project$Msg$FileUploadProgressed = function (a) {
        return { $: 8, a: a };
    };
    var $elm$core$Platform$Sub$batch = _Platform_batch;
    var $elm$time$Time$Every_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$time$Time$Every = F2($elm$time$Time$Every_fn);
    var $elm$time$Time$State_fn = function (taggers, processes) {
        return { kA: processes, k_: taggers };
    }, $elm$time$Time$State = F2($elm$time$Time$State_fn);
    var $elm$time$Time$init = $elm$core$Task$succeed($elm$time$Time$State_fn($elm$core$Dict$empty, $elm$core$Dict$empty));
    var $elm$time$Time$addMySub_fn = function (_v0, state) {
        var interval = _v0.a;
        var tagger = _v0.b;
        var _v1 = $elm$core$Dict$get_fn(interval, state);
        if (_v1.$ === 1) {
            return $elm$core$Dict$insert_fn(interval, _List_fromArray([tagger]), state);
        }
        else {
            var taggers = _v1.a;
            return $elm$core$Dict$insert_fn(interval, _List_Cons(tagger, taggers), state);
        }
    }, $elm$time$Time$addMySub = F2($elm$time$Time$addMySub_fn);
    var $elm$core$Process$kill = _Scheduler_kill;
    var $elm$core$Dict$foldl_fn = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldl_fn(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl_fn_unwrapped = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldl_fn_unwrapped(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl = F3($elm$core$Dict$foldl_fn);
    var $elm$core$Dict$merge_fn = function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
        var stepState = F3(function (rKey, rValue, _v0) {
            stepState: while (true) {
                var list = _v0.a;
                var result = _v0.b;
                if (!list.b) {
                    return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                }
                else {
                    var _v2 = list.a;
                    var lKey = _v2.a;
                    var lValue = _v2.b;
                    var rest = list.b;
                    if (_Utils_cmp(lKey, rKey) < 0) {
                        var $temp$rKey = rKey, $temp$rValue = rValue, $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));
                        rKey = $temp$rKey;
                        rValue = $temp$rValue;
                        _v0 = $temp$_v0;
                        continue stepState;
                    }
                    else {
                        if (_Utils_cmp(lKey, rKey) > 0) {
                            return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                        }
                        else {
                            return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
                        }
                    }
                }
            }
        });
        var _v3 = $elm$core$Dict$foldl_fn(stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);
        var leftovers = _v3.a;
        var intermediateResult = _v3.b;
        return $elm$core$List$foldl_fn_unwrapped(function (_v4, result) {
            var k = _v4.a;
            var v = _v4.b;
            return A3(leftStep, k, v, result);
        }, intermediateResult, leftovers);
    }, $elm$core$Dict$merge = F6($elm$core$Dict$merge_fn);
    var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
    var $elm$time$Time$setInterval = _Time_setInterval;
    var $elm$core$Process$spawn = _Scheduler_spawn;
    var $elm$time$Time$spawnHelp_fn = function (router, intervals, processes) {
        if (!intervals.b) {
            return $elm$core$Task$succeed(processes);
        }
        else {
            var interval = intervals.a;
            var rest = intervals.b;
            var spawnTimer = $elm$core$Process$spawn(_Time_setInterval_fn(interval, _Platform_sendToSelf_fn(router, interval)));
            var spawnRest = function (id) {
                return $elm$time$Time$spawnHelp_fn(router, rest, $elm$core$Dict$insert_fn(interval, id, processes));
            };
            return _Scheduler_andThen_fn(spawnRest, spawnTimer);
        }
    }, $elm$time$Time$spawnHelp = F3($elm$time$Time$spawnHelp_fn);
    var $elm$time$Time$onEffects_fn = function (router, subs, _v0) {
        var processes = _v0.kA;
        var rightStep = F3(function (_v6, id, _v7) {
            var spawns = _v7.a;
            var existing = _v7.b;
            var kills = _v7.c;
            return _Utils_Tuple3(spawns, existing, _Scheduler_andThen_fn(function (_v5) {
                return kills;
            }, $elm$core$Process$kill(id)));
        });
        var newTaggers = $elm$core$List$foldl_fn($elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
        var leftStep = F3(function (interval, taggers, _v4) {
            var spawns = _v4.a;
            var existing = _v4.b;
            var kills = _v4.c;
            return _Utils_Tuple3(_List_Cons(interval, spawns), existing, kills);
        });
        var bothStep = F4(function (interval, taggers, id, _v3) {
            var spawns = _v3.a;
            var existing = _v3.b;
            var kills = _v3.c;
            return _Utils_Tuple3(spawns, $elm$core$Dict$insert_fn(interval, id, existing), kills);
        });
        var _v1 = $elm$core$Dict$merge_fn(leftStep, bothStep, rightStep, newTaggers, processes, _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, $elm$core$Task$succeed(0)));
        var spawnList = _v1.a;
        var existingDict = _v1.b;
        var killTask = _v1.c;
        return _Scheduler_andThen_fn(function (newProcesses) {
            return $elm$core$Task$succeed($elm$time$Time$State_fn(newTaggers, newProcesses));
        }, _Scheduler_andThen_fn(function (_v2) {
            return $elm$time$Time$spawnHelp_fn(router, spawnList, existingDict);
        }, killTask));
    }, $elm$time$Time$onEffects = F3($elm$time$Time$onEffects_fn);
    var $elm$time$Time$onSelfMsg_fn = function (router, interval, state) {
        var _v0 = $elm$core$Dict$get_fn(interval, state.k_);
        if (_v0.$ === 1) {
            return $elm$core$Task$succeed(state);
        }
        else {
            var taggers = _v0.a;
            var tellTaggers = function (time) {
                return $elm$core$Task$sequence($elm$core$List$map_fn(function (tagger) {
                    return _Platform_sendToApp_fn(router, tagger(time));
                }, taggers));
            };
            return _Scheduler_andThen_fn(function (_v1) {
                return $elm$core$Task$succeed(state);
            }, _Scheduler_andThen_fn(tellTaggers, $elm$time$Time$now));
        }
    }, $elm$time$Time$onSelfMsg = F3($elm$time$Time$onSelfMsg_fn);
    var $elm$time$Time$subMap_fn = function (f, _v0) {
        var interval = _v0.a;
        var tagger = _v0.b;
        return $elm$time$Time$Every_fn(interval, A2($elm$core$Basics$composeL, f, tagger));
    }, $elm$time$Time$subMap = F2($elm$time$Time$subMap_fn);
    _Platform_effectManagers["Time"] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
    var $elm$time$Time$subscription = _Platform_leaf("Time");
    var $elm$time$Time$every_fn = function (interval, tagger) {
        return $elm$time$Time$subscription($elm$time$Time$Every_fn(interval, tagger));
    }, $elm$time$Time$every = F2($elm$time$Time$every_fn);
    var $elm$core$Platform$Sub$map = _Platform_map;
    var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
    var $author$project$Pages$Tables$GraphGridMsgReceived = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$GraphGrid$FileUploadProgressed = function (a) {
        return { $: 6, a: a };
    };
    var $elm$http$Http$MySub_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$http$Http$MySub = F2($elm$http$Http$MySub_fn);
    var $elm$http$Http$State_fn = function (reqs, subs) {
        return { kG: reqs, kY: subs };
    }, $elm$http$Http$State = F2($elm$http$Http$State_fn);
    var $elm$http$Http$init = $elm$core$Task$succeed($elm$http$Http$State_fn($elm$core$Dict$empty, _List_Nil));
    var $elm$http$Http$BadStatus__fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$http$Http$BadStatus_ = F2($elm$http$Http$BadStatus__fn);
    var $elm$http$Http$BadUrl_ = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$GoodStatus__fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $elm$http$Http$GoodStatus_ = F2($elm$http$Http$GoodStatus__fn);
    var $elm$http$Http$NetworkError_ = { $: 2 };
    var $elm$http$Http$Receiving = function (a) {
        return { $: 1, a: a };
    };
    var $elm$http$Http$Sending = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$Timeout_ = { $: 1 };
    var $elm$core$Maybe$isJust = function (maybe) {
        if (!maybe.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$http$Http$updateReqs_fn = function (router, cmds, reqs) {
        updateReqs: while (true) {
            if (!cmds.b) {
                return $elm$core$Task$succeed(reqs);
            }
            else {
                var cmd = cmds.a;
                var otherCmds = cmds.b;
                if (!cmd.$) {
                    var tracker = cmd.a;
                    var _v2 = $elm$core$Dict$get_fn(tracker, reqs);
                    if (_v2.$ === 1) {
                        var $temp$router = router, $temp$cmds = otherCmds, $temp$reqs = reqs;
                        router = $temp$router;
                        cmds = $temp$cmds;
                        reqs = $temp$reqs;
                        continue updateReqs;
                    }
                    else {
                        var pid = _v2.a;
                        return _Scheduler_andThen_fn(function (_v3) {
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, $elm$core$Dict$remove_fn(tracker, reqs));
                        }, $elm$core$Process$kill(pid));
                    }
                }
                else {
                    var req = cmd.a;
                    return _Scheduler_andThen_fn(function (pid) {
                        var _v4 = req.eQ;
                        if (_v4.$ === 1) {
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, reqs);
                        }
                        else {
                            var tracker = _v4.a;
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, $elm$core$Dict$insert_fn(tracker, pid, reqs));
                        }
                    }, $elm$core$Process$spawn(_Http_toTask_fn(router, $elm$core$Platform$sendToApp(router), req)));
                }
            }
        }
    }, $elm$http$Http$updateReqs = F3($elm$http$Http$updateReqs_fn);
    var $elm$http$Http$onEffects_fn = function (router, cmds, subs, state) {
        return _Scheduler_andThen_fn(function (reqs) {
            return $elm$core$Task$succeed($elm$http$Http$State_fn(reqs, subs));
        }, $elm$http$Http$updateReqs_fn(router, cmds, state.kG));
    }, $elm$http$Http$onEffects = F4($elm$http$Http$onEffects_fn);
    var $elm$core$List$maybeCons_fn = function (f, mx, xs) {
        var _v0 = f(mx);
        if (!_v0.$) {
            var x = _v0.a;
            return _List_Cons(x, xs);
        }
        else {
            return xs;
        }
    }, $elm$core$List$maybeCons = F3($elm$core$List$maybeCons_fn);
    var $elm$core$List$filterMap_fn = function (f, xs) {
        return $elm$core$List$foldr_fn($elm$core$List$maybeCons(f), _List_Nil, xs);
    }, $elm$core$List$filterMap = F2($elm$core$List$filterMap_fn);
    var $elm$http$Http$maybeSend_fn = function (router, desiredTracker, progress, _v0) {
        var actualTracker = _v0.a;
        var toMsg = _v0.b;
        return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(_Platform_sendToApp_fn(router, toMsg(progress))) : $elm$core$Maybe$Nothing;
    }, $elm$http$Http$maybeSend = F4($elm$http$Http$maybeSend_fn);
    var $elm$http$Http$onSelfMsg_fn = function (router, _v0, state) {
        var tracker = _v0.a;
        var progress = _v0.b;
        return _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence($elm$core$List$filterMap_fn(A3($elm$http$Http$maybeSend, router, tracker, progress), state.kY)));
    }, $elm$http$Http$onSelfMsg = F3($elm$http$Http$onSelfMsg_fn);
    var $elm$http$Http$Cancel = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$Request = function (a) {
        return { $: 1, a: a };
    };
    var $elm$http$Http$cmdMap_fn = function (func, cmd) {
        if (!cmd.$) {
            var tracker = cmd.a;
            return $elm$http$Http$Cancel(tracker);
        }
        else {
            var r = cmd.a;
            return $elm$http$Http$Request({
                lw: r.lw,
                d: r.d,
                e: _Http_mapExpect_fn(func, r.e),
                d9: r.d9,
                f: r.f,
                eK: r.eK,
                eQ: r.eQ,
                g: r.g
            });
        }
    }, $elm$http$Http$cmdMap = F2($elm$http$Http$cmdMap_fn);
    var $elm$http$Http$subMap_fn = function (func, _v0) {
        var tracker = _v0.a;
        var toMsg = _v0.b;
        return $elm$http$Http$MySub_fn(tracker, A2($elm$core$Basics$composeR, toMsg, func));
    }, $elm$http$Http$subMap = F2($elm$http$Http$subMap_fn);
    _Platform_effectManagers["Http"] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
    var $elm$http$Http$command = _Platform_leaf("Http");
    var $elm$http$Http$subscription = _Platform_leaf("Http");
    var $elm$http$Http$track_fn = function (tracker, toMsg) {
        return $elm$http$Http$subscription($elm$http$Http$MySub_fn(tracker, toMsg));
    }, $elm$http$Http$track = F2($elm$http$Http$track_fn);
    var $author$project$GraphGrid$subscriptions = function (model) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Sub$none, A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, A2($author$project$Util$flip, $elm$http$Http$track, $author$project$GraphGrid$FileUploadProgressed)), model.bp);
    };
    var $author$project$Pages$Tables$subscriptions = function (model) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Sub$none, A2($elm$core$Basics$composeR, $author$project$GraphGrid$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Tables$GraphGridMsgReceived)), model.aH);
    };
    var $author$project$Main$subscriptions = function (model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$time$Time$every_fn(1000 * 60, $author$project$Msg$TimeUpdated),
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Sub$none, A2($author$project$Util$flip, $elm$http$Http$track, $author$project$Msg$FileUploadProgressed), $elm$core$Maybe$andThen_fn(function ($) {
                return $.bR;
            }, model.a3)),
            _Platform_map_fn($author$project$Msg$TablesPageMsgReceived, $author$project$Pages$Tables$subscriptions(model.eI))
        ]));
    };
    var $author$project$Msg$AddTextNotification = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Shared$ClearUserData = { $: 2 };
    var $author$project$Msg$CreateDB_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Msg$CreateDB = F2($author$project$Msg$CreateDB_fn);
    var $author$project$Types$UploadType$CreateEmpty = { $: 0 };
    var $author$project$Pages$Tables$DataLoaded = { $: 6 };
    var $author$project$Msg$DatabaseDeletionResponded = function (a) {
        return { $: 49, a: a };
    };
    var $author$project$Msg$DatabaseOwnerReceived_fn = function (a, b, c) {
        return { $: 15, a: a, b: b, c: c };
    }, $author$project$Msg$DatabaseOwnerReceived = F3($author$project$Msg$DatabaseOwnerReceived_fn);
    var $author$project$Msg$DatabaseOwnerSubmitted_fn = function (a, b, c) {
        return { $: 14, a: a, b: b, c: c };
    }, $author$project$Msg$DatabaseOwnerSubmitted = F3($author$project$Msg$DatabaseOwnerSubmitted_fn);
    var $author$project$Msg$DatabasePageMsgReceived = function (a) {
        return { $: 22, a: a };
    };
    var $author$project$Msg$DatabaseRenamed = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Msg$DatabaseSettingsReceived = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Msg$DatabaseSettingsStateUpdated = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Msg$ForgotPasswordPageMsgReceived = function (a) {
        return { $: 32, a: a };
    };
    var $author$project$Msg$GotDbData_fn = function (a, b, c) {
        return { $: 17, a: a, b: b, c: c };
    }, $author$project$Msg$GotDbData = F3($author$project$Msg$GotDbData_fn);
    var $author$project$Msg$GotFile_fn = function (a, b, c, d) {
        return { $: 7, a: a, b: b, c: c, d: d };
    }, $author$project$Msg$GotFile = F4($author$project$Msg$GotFile_fn);
    var $author$project$Msg$HomePageMsgReceived = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Types$UploadType$Initial = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Types$ErrorDisplay$None = 0;
    var $author$project$Msg$Pick_fn = function (a, b, c) {
        return { $: 6, a: a, b: b, c: c };
    }, $author$project$Msg$Pick = F3($author$project$Msg$Pick_fn);
    var $author$project$Msg$RemoveTableCells = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$Types$UploadType$Replacement = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Shared$RouteReplace = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Msg$SignupPageMsgReceived = function (a) {
        return { $: 30, a: a };
    };
    var $author$project$Msg$TablesAffected = function (a) {
        return { $: 18, a: a };
    };
    var $author$project$Msg$TeamCreated = function (a) {
        return { $: 44, a: a };
    };
    var $author$project$Msg$TeamDeleted = function (a) {
        return { $: 45, a: a };
    };
    var $author$project$Msg$TeamHydratedReceived_fn = function (a, b) {
        return { $: 47, a: a, b: b };
    }, $author$project$Msg$TeamHydratedReceived = F2($author$project$Msg$TeamHydratedReceived_fn);
    var $author$project$Msg$TeamHydratedRequested = function (a) {
        return { $: 46, a: a };
    };
    var $author$project$Msg$TrialPageMsgReceived = function (a) {
        return { $: 29, a: a };
    };
    var $author$project$Msg$Uploaded_fn = function (a, b, c, d) {
        return { $: 9, a: a, b: b, c: c, d: d };
    }, $author$project$Msg$Uploaded = F4($author$project$Msg$Uploaded_fn);
    var $author$project$Msg$UserLoggedIn_fn = function (a, b) {
        return { $: 39, a: a, b: b };
    }, $author$project$Msg$UserLoggedIn = F2($author$project$Msg$UserLoggedIn_fn);
    var $author$project$Msg$UserLoggedOut = { $: 40 };
    var $author$project$Types$User$addTeam_fn = function (team, user) {
        return _Utils_update(user, {
            pc: _List_Cons(team, user.pc)
        });
    }, $author$project$Types$User$addTeam = F2($author$project$Types$User$addTeam_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_out = $rtfeldman$elm_css$Css$property_fn("transition-timing-function", "cubic-bezier(0, 0, 0.2, 1)");
    var $rtfeldman$elm_css$Css$prop1_fn = function (key, arg) {
        return $rtfeldman$elm_css$Css$property_fn(key, arg.pB);
    }, $rtfeldman$elm_css$Css$prop1 = F2($rtfeldman$elm_css$Css$prop1_fn);
    var $rtfeldman$elm_css$Css$fill_a0 = "fill", $rtfeldman$elm_css$Css$fill = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$fill_a0);
    var $rtfeldman$elm_css$Css$cssFunction_fn = function (funcName, args) {
        return funcName + ("(" + ($elm$core$String$join_fn(",", args) + ")"));
    }, $rtfeldman$elm_css$Css$cssFunction = F2($rtfeldman$elm_css$Css$cssFunction_fn);
    var $elm$core$String$fromFloat = _String_fromNumber;
    var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
    var $elm$core$Basics$pi = _Basics_pi;
    var $rtfeldman$elm_css$Css$degreesToRadians = function (degrees) {
        return (degrees * 180) / $elm$core$Basics$pi;
    };
    var $elm$core$Basics$abs = function (n) {
        return (n < 0) ? (-n) : n;
    };
    var $elm$core$Basics$degrees = function (angleInDegrees) {
        return (angleInDegrees * $elm$core$Basics$pi) / 180;
    };
    var $elm$core$Basics$modBy = _Basics_modBy;
    var $rtfeldman$elm_css$Css$fmod_fn = function (f, n) {
        var integer = $elm$core$Basics$floor(f);
        return (_Basics_modBy_fn(n, integer) + f) - integer;
    }, $rtfeldman$elm_css$Css$fmod = F2($rtfeldman$elm_css$Css$fmod_fn);
    var $rtfeldman$elm_css$Css$hslToRgb_fn = function (hueVal, saturationVal, lightness) {
        var normHue = hueVal / $elm$core$Basics$degrees(60);
        var chroma = (1 - $elm$core$Basics$abs((2 * lightness) - 1)) * saturationVal;
        var m = lightness - (chroma / 2);
        var x = chroma * (1 - $elm$core$Basics$abs($rtfeldman$elm_css$Css$fmod_fn(normHue, 2) - 1));
        var _v0 = (normHue < 0) ? _Utils_Tuple3(0, 0, 0) : ((normHue < 1) ? _Utils_Tuple3(chroma, x, 0) : ((normHue < 2) ? _Utils_Tuple3(x, chroma, 0) : ((normHue < 3) ? _Utils_Tuple3(0, chroma, x) : ((normHue < 4) ? _Utils_Tuple3(0, x, chroma) : ((normHue < 5) ? _Utils_Tuple3(x, 0, chroma) : ((normHue < 6) ? _Utils_Tuple3(chroma, 0, x) : _Utils_Tuple3(0, 0, 0)))))));
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        return _Utils_Tuple3(r + m, g + m, b + m);
    }, $rtfeldman$elm_css$Css$hslToRgb = F3($rtfeldman$elm_css$Css$hslToRgb_fn);
    var $rtfeldman$elm_css$Css$hslaToRgba_fn = function (value, hueVal, saturationVal, lightness, hslAlpha) {
        var _v0 = $rtfeldman$elm_css$Css$hslToRgb_fn($rtfeldman$elm_css$Css$degreesToRadians(hueVal), saturationVal, lightness);
        var red = _v0.a;
        var green = _v0.b;
        var blue = _v0.c;
        return {
            dF: hslAlpha,
            dQ: $elm$core$Basics$floor(blue),
            bw: 0,
            d8: $elm$core$Basics$floor(green),
            er: $elm$core$Basics$floor(red),
            pB: value
        };
    }, $rtfeldman$elm_css$Css$hslaToRgba = F5($rtfeldman$elm_css$Css$hslaToRgba_fn);
    var $rtfeldman$elm_css$Css$numericalPercentageToString = function (value) {
        return $elm$core$String$fromFloat(value * 100) + "%";
    };
    var $rtfeldman$elm_css$Css$hsl_fn = function (hueVal, saturationVal, lightnessVal) {
        var valuesList = _List_fromArray([
            $elm$core$String$fromFloat(hueVal),
            $rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
            $rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal)
        ]);
        var value = $rtfeldman$elm_css$Css$cssFunction_fn("hsl", valuesList);
        return $rtfeldman$elm_css$Css$hslaToRgba_fn(value, hueVal, saturationVal, lightnessVal, 1);
    }, $rtfeldman$elm_css$Css$hsl = F3($rtfeldman$elm_css$Css$hsl_fn);
    var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
        return $rtfeldman$elm_css$Css$property_fn("background-color", c.pB);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border = $rtfeldman$elm_css$Css$property_fn("border-width", "1px");
    var $rtfeldman$elm_css$Css$borderColor = function (c) {
        return $rtfeldman$elm_css$Css$property_fn("border-color", c.pB);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid = $rtfeldman$elm_css$Css$property_fn("border-style", "solid");
    var $rtfeldman$elm_css$Css$color = function (c) {
        return $rtfeldman$elm_css$Css$property_fn("color", c.pB);
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3($rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn);
    var $elm$virtual_dom$VirtualDom$attribute_fn = function (key, value) {
        return _VirtualDom_attribute_fn(_VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    }, $elm$virtual_dom$VirtualDom$attribute = F2($elm$virtual_dom$VirtualDom$attribute_fn);
    var $elm$core$List$isEmpty = function (xs) {
        if (!xs.b) {
            return true;
        }
        else {
            return false;
        }
    };
    var $rtfeldman$elm_css$Css$Structure$compactHelp_fn = function (declaration, _v0) {
        var keyframesByName = _v0.a;
        var declarations = _v0.b;
        switch (declaration.$) {
            case 0:
                var _v2 = declaration.a;
                var properties = _v2.c;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 1:
                var styleBlocks = declaration.b;
                return $elm$core$List$all_fn(function (_v3) {
                    var properties = _v3.c;
                    return $elm$core$List$isEmpty(properties);
                }, styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 2:
                var otherDeclarations = declaration.b;
                return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 3:
                return _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 4:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 5:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 6:
                var record = declaration.a;
                return $elm$core$String$isEmpty(record.l5) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2($elm$core$Dict$insert_fn(record.M, record.l5, keyframesByName), declarations);
            case 7:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 8:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            default:
                var tuples = declaration.a;
                return $elm$core$List$all_fn(function (_v4) {
                    var properties = _v4.b;
                    return $elm$core$List$isEmpty(properties);
                }, tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
        }
    }, $rtfeldman$elm_css$Css$Structure$compactHelp = F2($rtfeldman$elm_css$Css$Structure$compactHelp_fn);
    var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
        return { $: 6, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn = function (keyframesByName, compactedDeclarations) {
        return $elm$core$List$append_fn($elm$core$List$map_fn(function (_v0) {
            var name = _v0.a;
            var decl = _v0.b;
            return $rtfeldman$elm_css$Css$Structure$Keyframes({ l5: decl, M: name });
        }, $elm$core$Dict$toList(keyframesByName)), compactedDeclarations);
    }, $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn);
    var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
        var _v0 = $elm$core$List$foldr_fn($rtfeldman$elm_css$Css$Structure$compactHelp, _Utils_Tuple2($elm$core$Dict$empty, _List_Nil), declarations);
        var keyframesByName = _v0.a;
        var compactedDeclarations = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn(keyframesByName, compactedDeclarations);
    };
    var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
        var charset = _v0.iQ;
        var imports = _v0.jB;
        var namespaces = _v0.j4;
        var declarations = _v0.l6;
        return {
            iQ: charset,
            l6: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
            jB: imports,
            j4: namespaces
        };
    };
    var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (str) {
            return "@charset \"" + (str + "\"");
        }, charset));
    };
    var $rtfeldman$elm_css$Css$String$mapJoinHelp_fn = function (map, sep, strs, result) {
        mapJoinHelp: while (true) {
            if (!strs.b) {
                return result;
            }
            else {
                if (!strs.b.b) {
                    var first = strs.a;
                    return result + (map(first) + "");
                }
                else {
                    var first = strs.a;
                    var rest = strs.b;
                    var $temp$map = map, $temp$sep = sep, $temp$strs = rest, $temp$result = result + (map(first) + (sep + ""));
                    map = $temp$map;
                    sep = $temp$sep;
                    strs = $temp$strs;
                    result = $temp$result;
                    continue mapJoinHelp;
                }
            }
        }
    }, $rtfeldman$elm_css$Css$String$mapJoinHelp = F4($rtfeldman$elm_css$Css$String$mapJoinHelp_fn);
    var $rtfeldman$elm_css$Css$String$mapJoin_fn = function (map, sep, strs) {
        return $rtfeldman$elm_css$Css$String$mapJoinHelp_fn(map, sep, strs, "");
    }, $rtfeldman$elm_css$Css$String$mapJoin = F3($rtfeldman$elm_css$Css$String$mapJoin_fn);
    var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
        return "(" + (expression.jj + ($elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($elm$core$Basics$append(": "), expression.pB)) + ")"));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
        switch (mediaType) {
            case 0:
                return "print";
            case 1:
                return "screen";
            default:
                return "speech";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
        var prefixWith = F3(function (str, mediaType, expressions) {
            return str + (" " + $elm$core$String$join_fn(" and ", _List_Cons($rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType), $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
        });
        switch (mediaQuery.$) {
            case 0:
                var expressions = mediaQuery.a;
                return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, " and ", expressions);
            case 1:
                var mediaType = mediaQuery.a;
                var expressions = mediaQuery.b;
                return A3(prefixWith, "only", mediaType, expressions);
            case 2:
                var mediaType = mediaQuery.a;
                var expressions = mediaQuery.b;
                return A3(prefixWith, "not", mediaType, expressions);
            default:
                var str = mediaQuery.a;
                return str;
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString_fn = function (name, mediaQuery) {
        return "@import \"" + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + "\""));
    }, $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2($rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString_fn);
    var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
        var name = _v0.a;
        var mediaQueries = _v0.b;
        return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name), "\n", mediaQueries);
    };
    var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
        var prefix = _v0.a;
        var str = _v0.b;
        return "@namespace " + (prefix + ("\"" + (str + "\"")));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
        return $rtfeldman$elm_css$Css$String$mapJoin_fn(function (_v0) {
            var prop = _v0;
            return prop + ";";
        }, "", properties);
    };
    var $elm$core$String$append = _String_append;
    var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
        var str = _v0;
        return "::" + str;
    };
    var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
        switch (combinator) {
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
        switch (repeatableSimpleSelector.$) {
            case 0:
                var str = repeatableSimpleSelector.a;
                return "." + str;
            case 1:
                var str = repeatableSimpleSelector.a;
                return "#" + str;
            case 2:
                var str = repeatableSimpleSelector.a;
                return ":" + str;
            default:
                var str = repeatableSimpleSelector.a;
                return "[" + (str + "]");
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
        switch (simpleSelectorSequence.$) {
            case 0:
                var str = simpleSelectorSequence.a;
                var repeatableSimpleSelectors = simpleSelectorSequence.b;
                return _Utils_ap(str, $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors));
            case 1:
                var repeatableSimpleSelectors = simpleSelectorSequence.a;
                return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? "*" : $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors);
            default:
                var str = simpleSelectorSequence.a;
                var repeatableSimpleSelectors = simpleSelectorSequence.b;
                return _Utils_ap(str, $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors));
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
        var combinator = _v0.a;
        var sequence = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (" " + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
        var simpleSelectorSequence = _v0.a;
        var chain = _v0.b;
        var pseudoElement = _v0.c;
        var segments = _List_Cons($rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence), $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
        var pseudoElementsString = $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
        return _String_append_fn($elm$core$String$join_fn(" ", segments), pseudoElementsString);
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
        var firstSelector = _v0.a;
        var otherSelectors = _v0.b;
        var properties = _v0.c;
        var selectorStr = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$selectorToString, ",", _List_Cons(firstSelector, otherSelectors));
        return selectorStr + ("{" + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + "}"));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
        switch (decl.$) {
            case 0:
                var styleBlock = decl.a;
                return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
            case 1:
                var mediaQueries = decl.a;
                var styleBlocks = decl.b;
                var query = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ", ", mediaQueries);
                var blocks = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, "\n", styleBlocks);
                return "@media " + (query + ("{" + (blocks + "}")));
            case 2:
                return "TODO";
            case 3:
                return "TODO";
            case 4:
                return "TODO";
            case 5:
                return "TODO";
            case 6:
                var name = decl.a.M;
                var declaration = decl.a.l5;
                return "@keyframes " + (name + ("{" + (declaration + "}")));
            case 7:
                return "TODO";
            case 8:
                return "TODO";
            default:
                return "TODO";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
        var charset = _v0.iQ;
        var imports = _v0.jB;
        var namespaces = _v0.j4;
        var declarations = _v0.l6;
        return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$importToString, "\n", imports) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$namespaceToString, "\n", namespaces) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, "\n", declarations) + "")));
    };
    var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
        return { $: 8, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
        return { $: 5, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
        return { $: 4, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$Selector_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Structure$Selector = F3($rtfeldman$elm_css$Css$Structure$Selector_fn);
    var $rtfeldman$elm_css$Css$Structure$StyleBlock_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Structure$StyleBlock = F3($rtfeldman$elm_css$Css$Structure$StyleBlock_fn);
    var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$SupportsRule_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$SupportsRule = F2($rtfeldman$elm_css$Css$Structure$SupportsRule_fn);
    var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
        return { $: 7, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$MediaRule_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$MediaRule = F2($rtfeldman$elm_css$Css$Structure$MediaRule_fn);
    var $rtfeldman$elm_css$Css$Structure$mapLast_fn = function (update, list) {
        if (!list.b) {
            return list;
        }
        else {
            if (!list.b.b) {
                var only = list.a;
                return _List_fromArray([
                    update(only)
                ]);
            }
            else {
                var first = list.a;
                var rest = list.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$mapLast_fn(update, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$mapLast = F2($rtfeldman$elm_css$Css$Structure$mapLast_fn);
    var $rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn = function (property, _v0) {
        var firstSelector = _v0.a;
        var otherSelectors = _v0.b;
        var properties = _v0.c;
        return $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _Utils_ap(properties, _List_fromArray([property])));
    }, $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2($rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn);
    var $rtfeldman$elm_css$Css$Structure$appendProperty_fn = function (property, declarations) {
        if (!declarations.b) {
            return declarations;
        }
        else {
            if (!declarations.b.b) {
                switch (declarations.a.$) {
                    case 0:
                        var styleBlock = declarations.a.a;
                        return _List_fromArray([
                            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn(property, styleBlock))
                        ]);
                    case 1:
                        var _v1 = declarations.a;
                        var mediaQueries = _v1.a;
                        var styleBlocks = _v1.b;
                        return _List_fromArray([
                            $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, $rtfeldman$elm_css$Css$Structure$mapLast_fn($rtfeldman$elm_css$Css$Structure$withPropertyAppended(property), styleBlocks))
                        ]);
                    default:
                        return declarations;
                }
            }
            else {
                var first = declarations.a;
                var rest = declarations.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(property, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$appendProperty = F2($rtfeldman$elm_css$Css$Structure$appendProperty_fn);
    var $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn = function (f, styleBlock) {
        if (!styleBlock.b.b) {
            var only = styleBlock.a;
            var properties = styleBlock.c;
            return _List_fromArray([
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(only, _List_Nil, properties),
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(f(only), _List_Nil, _List_Nil)
            ]);
        }
        else {
            var first = styleBlock.a;
            var rest = styleBlock.b;
            var properties = styleBlock.c;
            var newRest = $elm$core$List$map_fn(f, rest);
            var newFirst = f(first);
            return _List_fromArray([
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(first, rest, properties),
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(newFirst, newRest, _List_Nil)
            ]);
        }
    }, $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$applyPseudoElement_fn = function (pseudo, _v0) {
        var sequence = _v0.a;
        var selectors = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$Selector_fn(sequence, selectors, $elm$core$Maybe$Just(pseudo));
    }, $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2($rtfeldman$elm_css$Css$Structure$applyPseudoElement_fn);
    var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector_fn = function (pseudo, styleBlock) {
        return $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn($rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo), styleBlock);
    }, $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$CustomSelector_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$CustomSelector = F2($rtfeldman$elm_css$Css$Structure$CustomSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2($rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn);
    var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$appendRepeatable_fn = function (selector, sequence) {
        switch (sequence.$) {
            case 0:
                var typeSelector = sequence.a;
                var list = sequence.b;
                return $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn(typeSelector, _Utils_ap(list, _List_fromArray([selector])));
            case 1:
                var list = sequence.a;
                return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_Utils_ap(list, _List_fromArray([selector])));
            default:
                var str = sequence.a;
                var list = sequence.b;
                return $rtfeldman$elm_css$Css$Structure$CustomSelector_fn(str, _Utils_ap(list, _List_fromArray([selector])));
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2($rtfeldman$elm_css$Css$Structure$appendRepeatable_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn = function (selector, list) {
        if (!list.b) {
            return _List_Nil;
        }
        else {
            if (!list.b.b) {
                var _v1 = list.a;
                var combinator = _v1.a;
                var sequence = _v1.b;
                return _List_fromArray([
                    _Utils_Tuple2(combinator, $rtfeldman$elm_css$Css$Structure$appendRepeatable_fn(selector, sequence))
                ]);
            }
            else {
                var first = list.a;
                var rest = list.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn(selector, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector_fn = function (repeatableSimpleSelector, selector) {
        if (!selector.b.b) {
            var sequence = selector.a;
            var pseudoElement = selector.c;
            return $rtfeldman$elm_css$Css$Structure$Selector_fn($rtfeldman$elm_css$Css$Structure$appendRepeatable_fn(repeatableSimpleSelector, sequence), _List_Nil, pseudoElement);
        }
        else {
            var firstSelector = selector.a;
            var tuples = selector.b;
            var pseudoElement = selector.c;
            return $rtfeldman$elm_css$Css$Structure$Selector_fn(firstSelector, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn(repeatableSimpleSelector, tuples), pseudoElement);
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector_fn = function (selector, styleBlock) {
        return $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn($rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector), styleBlock);
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
        collectSelectors: while (true) {
            if (!declarations.b) {
                return _List_Nil;
            }
            else {
                if (!declarations.a.$) {
                    var _v1 = declarations.a.a;
                    var firstSelector = _v1.a;
                    var otherSelectors = _v1.b;
                    var rest = declarations.b;
                    return _Utils_ap(_List_Cons(firstSelector, otherSelectors), $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
                }
                else {
                    var rest = declarations.b;
                    var $temp$declarations = rest;
                    declarations = $temp$declarations;
                    continue collectSelectors;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Structure$DocumentRule_fn = function (a, b, c, d, e) {
        return { $: 3, a: a, b: b, c: c, d: d, e: e };
    }, $rtfeldman$elm_css$Css$Structure$DocumentRule = F5($rtfeldman$elm_css$Css$Structure$DocumentRule_fn);
    var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn = function (update, declarations) {
        _v0$12: while (true) {
            if (!declarations.b) {
                return declarations;
            }
            else {
                if (!declarations.b.b) {
                    switch (declarations.a.$) {
                        case 0:
                            var styleBlock = declarations.a.a;
                            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration, update(styleBlock));
                        case 1:
                            if (declarations.a.b.b) {
                                if (!declarations.a.b.b.b) {
                                    var _v1 = declarations.a;
                                    var mediaQueries = _v1.a;
                                    var _v2 = _v1.b;
                                    var styleBlock = _v2.a;
                                    return _List_fromArray([
                                        $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, update(styleBlock))
                                    ]);
                                }
                                else {
                                    var _v3 = declarations.a;
                                    var mediaQueries = _v3.a;
                                    var _v4 = _v3.b;
                                    var first = _v4.a;
                                    var rest = _v4.b;
                                    var _v5 = $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, _List_fromArray([
                                        $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, rest)
                                    ]));
                                    if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
                                        var _v6 = _v5.a;
                                        var newMediaQueries = _v6.a;
                                        var newStyleBlocks = _v6.b;
                                        return _List_fromArray([
                                            $rtfeldman$elm_css$Css$Structure$MediaRule_fn(newMediaQueries, _List_Cons(first, newStyleBlocks))
                                        ]);
                                    }
                                    else {
                                        var newDeclarations = _v5;
                                        return newDeclarations;
                                    }
                                }
                            }
                            else {
                                break _v0$12;
                            }
                        case 2:
                            var _v7 = declarations.a;
                            var str = _v7.a;
                            var nestedDeclarations = _v7.b;
                            return _List_fromArray([
                                $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, nestedDeclarations))
                            ]);
                        case 3:
                            var _v8 = declarations.a;
                            var str1 = _v8.a;
                            var str2 = _v8.b;
                            var str3 = _v8.c;
                            var str4 = _v8.d;
                            var styleBlock = _v8.e;
                            return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4), update(styleBlock));
                        case 4:
                            return declarations;
                        case 5:
                            return declarations;
                        case 6:
                            return declarations;
                        case 7:
                            return declarations;
                        case 8:
                            return declarations;
                        default:
                            return declarations;
                    }
                }
                else {
                    break _v0$12;
                }
            }
        }
        var first = declarations.a;
        var rest = declarations.b;
        return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, rest));
    }, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn);
    var $elm$core$String$cons = _String_cons;
    var $robinheghan$murmur3$Murmur3$HashData_fn = function (shift, seed, hash, charsProcessed) {
        return { cS: charsProcessed, c3: hash, cB: seed, dl: shift };
    }, $robinheghan$murmur3$Murmur3$HashData = F4($robinheghan$murmur3$Murmur3$HashData_fn);
    var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
    var $robinheghan$murmur3$Murmur3$c2 = 461845907;
    var $elm$core$Bitwise$and = _Bitwise_and;
    var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
    var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
    var $robinheghan$murmur3$Murmur3$multiplyBy_fn = function (b, a) {
        return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
    }, $robinheghan$murmur3$Murmur3$multiplyBy = F2($robinheghan$murmur3$Murmur3$multiplyBy_fn);
    var $elm$core$Bitwise$or = _Bitwise_or;
    var $robinheghan$murmur3$Murmur3$rotlBy_fn = function (b, a) {
        return (a << b) | (a >>> (32 - b));
    }, $robinheghan$murmur3$Murmur3$rotlBy = F2($robinheghan$murmur3$Murmur3$rotlBy_fn);
    var $elm$core$Bitwise$xor = _Bitwise_xor;
    var $robinheghan$murmur3$Murmur3$finalize = function (data) {
        var acc = (!(!data.c3)) ? (data.cB ^ $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c2, $robinheghan$murmur3$Murmur3$rotlBy_fn(15, $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c1, data.c3)))) : data.cB;
        var h0 = acc ^ data.cS;
        var h1 = $robinheghan$murmur3$Murmur3$multiplyBy_fn(2246822507, h0 ^ (h0 >>> 16));
        var h2 = $robinheghan$murmur3$Murmur3$multiplyBy_fn(3266489909, h1 ^ (h1 >>> 13));
        return (h2 ^ (h2 >>> 16)) >>> 0;
    };
    var $elm$core$String$foldl = _String_foldl;
    var $robinheghan$murmur3$Murmur3$mix_fn = function (h1, k1) {
        return $robinheghan$murmur3$Murmur3$multiplyBy_fn(5, $robinheghan$murmur3$Murmur3$rotlBy_fn(13, h1 ^ $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c2, $robinheghan$murmur3$Murmur3$rotlBy_fn(15, $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
    }, $robinheghan$murmur3$Murmur3$mix = F2($robinheghan$murmur3$Murmur3$mix_fn);
    var $robinheghan$murmur3$Murmur3$hashFold_fn = function (c, data) {
        var res = data.c3 | ((255 & $elm$core$Char$toCode(c)) << data.dl);
        var _v0 = data.dl;
        if (_v0 === 24) {
            return {
                cS: data.cS + 1,
                c3: 0,
                cB: $robinheghan$murmur3$Murmur3$mix_fn(data.cB, res),
                dl: 0
            };
        }
        else {
            return { cS: data.cS + 1, c3: res, cB: data.cB, dl: data.dl + 8 };
        }
    }, $robinheghan$murmur3$Murmur3$hashFold = F2($robinheghan$murmur3$Murmur3$hashFold_fn);
    var $robinheghan$murmur3$Murmur3$hashString_fn = function (seed, str) {
        return $robinheghan$murmur3$Murmur3$finalize(_String_foldl_fn($robinheghan$murmur3$Murmur3$hashFold, $robinheghan$murmur3$Murmur3$HashData_fn(0, seed, 0, 0), str));
    }, $robinheghan$murmur3$Murmur3$hashString = F2($robinheghan$murmur3$Murmur3$hashString_fn);
    var $rtfeldman$elm_css$Hash$initialSeed = 15739;
    var $elm$core$String$fromList = _String_fromList;
    var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
        unsafeToDigit: while (true) {
            switch (num) {
                case 0:
                    return "0";
                case 1:
                    return "1";
                case 2:
                    return "2";
                case 3:
                    return "3";
                case 4:
                    return "4";
                case 5:
                    return "5";
                case 6:
                    return "6";
                case 7:
                    return "7";
                case 8:
                    return "8";
                case 9:
                    return "9";
                case 10:
                    return "a";
                case 11:
                    return "b";
                case 12:
                    return "c";
                case 13:
                    return "d";
                case 14:
                    return "e";
                case 15:
                    return "f";
                default:
                    var $temp$num = num;
                    num = $temp$num;
                    continue unsafeToDigit;
            }
        }
    };
    var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn = function (digits, num) {
        unsafePositiveToDigits: while (true) {
            if (num < 16) {
                return _List_Cons($rtfeldman$elm_hex$Hex$unsafeToDigit(num), digits);
            }
            else {
                var $temp$digits = _List_Cons($rtfeldman$elm_hex$Hex$unsafeToDigit(_Basics_modBy_fn(16, num)), digits), $temp$num = (num / 16) | 0;
                digits = $temp$digits;
                num = $temp$num;
                continue unsafePositiveToDigits;
            }
        }
    }, $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn);
    var $rtfeldman$elm_hex$Hex$toString = function (num) {
        return $elm$core$String$fromList((num < 0) ? _List_Cons("-", $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn(_List_Nil, -num)) : $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn(_List_Nil, num));
    };
    var $rtfeldman$elm_css$Hash$fromString = function (str) {
        return _String_cons_fn("_", $rtfeldman$elm_hex$Hex$toString($robinheghan$murmur3$Murmur3$hashString_fn($rtfeldman$elm_css$Hash$initialSeed, str)));
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
        last: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!list.b.b) {
                    var singleton = list.a;
                    return $elm$core$Maybe$Just(singleton);
                }
                else {
                    var rest = list.b;
                    var $temp$list = rest;
                    list = $temp$list;
                    continue last;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
        lastDeclaration: while (true) {
            if (!declarations.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!declarations.b.b) {
                    var x = declarations.a;
                    return $elm$core$Maybe$Just(_List_fromArray([x]));
                }
                else {
                    var xs = declarations.b;
                    var $temp$declarations = xs;
                    declarations = $temp$declarations;
                    continue lastDeclaration;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
        oneOf: while (true) {
            if (!maybes.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var maybe = maybes.a;
                var rest = maybes.b;
                if (maybe.$ === 1) {
                    var $temp$maybes = rest;
                    maybes = $temp$maybes;
                    continue oneOf;
                }
                else {
                    return maybe;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
        return { $: 9, a: a };
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
        var expandTuples = function (tuplesToExpand) {
            if (!tuplesToExpand.b) {
                return _List_Nil;
            }
            else {
                var properties = tuplesToExpand.a;
                var rest = tuplesToExpand.b;
                return _List_Cons(properties, expandTuples(rest));
            }
        };
        var newTuples = expandTuples(tuples);
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
        ]);
    };
    var $elm$core$List$singleton = function (value) {
        return _List_fromArray([value]);
    };
    var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule_fn = function (mediaQueries, declaration) {
        if (!declaration.$) {
            var styleBlock = declaration.a;
            return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, _List_fromArray([styleBlock]));
        }
        else {
            return declaration;
        }
    }, $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2($rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule_fn);
    var $elm$core$List$tail = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(xs);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$List$takeReverse_fn = function (n, list, kept) {
        takeReverse: while (true) {
            if (n <= 0) {
                return kept;
            }
            else {
                if (!list.b) {
                    return kept;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs, $temp$kept = _List_Cons(x, kept);
                    n = $temp$n;
                    list = $temp$list;
                    kept = $temp$kept;
                    continue takeReverse;
                }
            }
        }
    }, $elm$core$List$takeReverse = F3($elm$core$List$takeReverse_fn);
    var $elm$core$List$takeTailRec_fn = function (n, list) {
        return $elm$core$List$reverse($elm$core$List$takeReverse_fn(n, list, _List_Nil));
    }, $elm$core$List$takeTailRec = F2($elm$core$List$takeTailRec_fn);
    var $elm$core$List$takeFast_fn = function (ctr, n, list) {
        if (n <= 0) {
            return _List_Nil;
        }
        else {
            var _v0 = _Utils_Tuple2(n, list);
            _v0$1: while (true) {
                _v0$5: while (true) {
                    if (!_v0.b.b) {
                        return list;
                    }
                    else {
                        if (_v0.b.b.b) {
                            switch (_v0.a) {
                                case 1:
                                    break _v0$1;
                                case 2:
                                    var _v2 = _v0.b;
                                    var x = _v2.a;
                                    var _v3 = _v2.b;
                                    var y = _v3.a;
                                    return _List_fromArray([x, y]);
                                case 3:
                                    if (_v0.b.b.b.b) {
                                        var _v4 = _v0.b;
                                        var x = _v4.a;
                                        var _v5 = _v4.b;
                                        var y = _v5.a;
                                        var _v6 = _v5.b;
                                        var z = _v6.a;
                                        return _List_fromArray([x, y, z]);
                                    }
                                    else {
                                        break _v0$5;
                                    }
                                default:
                                    if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                                        var _v7 = _v0.b;
                                        var x = _v7.a;
                                        var _v8 = _v7.b;
                                        var y = _v8.a;
                                        var _v9 = _v8.b;
                                        var z = _v9.a;
                                        var _v10 = _v9.b;
                                        var w = _v10.a;
                                        var tl = _v10.b;
                                        return (ctr > 1000) ? _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeTailRec_fn(n - 4, tl))))) : _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeFast_fn(ctr + 1, n - 4, tl)))));
                                    }
                                    else {
                                        break _v0$5;
                                    }
                            }
                        }
                        else {
                            if (_v0.a === 1) {
                                break _v0$1;
                            }
                            else {
                                break _v0$5;
                            }
                        }
                    }
                }
                return list;
            }
            var _v1 = _v0.b;
            var x = _v1.a;
            return _List_fromArray([x]);
        }
    }, $elm$core$List$takeFast = F3($elm$core$List$takeFast_fn);
    var $elm$core$List$take_fn = function (n, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; i < n && xs.b; xs = xs.
            b, i++) {
            var next = _List_Cons(xs.a, _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$take = F2($elm$core$List$take_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule_fn = function (str1, str2, str3, str4, declaration) {
        if (!declaration.$) {
            var structureStyleBlock = declaration.a;
            return $rtfeldman$elm_css$Css$Structure$DocumentRule_fn(str1, str2, str3, str4, structureStyleBlock);
        }
        else {
            return declaration;
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule_fn = function (mediaQueries, declaration) {
        switch (declaration.$) {
            case 0:
                var structureStyleBlock = declaration.a;
                return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, _List_fromArray([structureStyleBlock]));
            case 1:
                var newMediaQueries = declaration.a;
                var structureStyleBlocks = declaration.b;
                return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(_Utils_ap(mediaQueries, newMediaQueries), structureStyleBlocks);
            case 2:
                var str = declaration.a;
                var declarations = declaration.b;
                return $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, $elm$core$List$map_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries), declarations));
            case 3:
                var str1 = declaration.a;
                var str2 = declaration.b;
                var str3 = declaration.c;
                var str4 = declaration.d;
                var structureStyleBlock = declaration.e;
                return $rtfeldman$elm_css$Css$Structure$DocumentRule_fn(str1, str2, str3, str4, structureStyleBlock);
            case 4:
                return declaration;
            case 5:
                return declaration;
            case 6:
                return declaration;
            case 7:
                return declaration;
            case 8:
                return declaration;
            default:
                return declaration;
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
        var declarations = _v0;
        return declarations;
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn = function (nestedStyles, rest, f, declarations) {
        var withoutParent = function (decls) {
            return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail(decls));
        };
        var nextResult = $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $elm$core$Maybe$withDefault_fn(_List_Nil, $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
        var newDeclarations = function () {
            var _v14 = _Utils_Tuple2($elm$core$List$head(nextResult), $rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
            if ((!_v14.a.$) && (!_v14.b.$)) {
                var nextResultParent = _v14.a.a;
                var originalParent = _v14.b.a;
                return _Utils_ap($elm$core$List$take_fn($elm$core$List$length(declarations) - 1, declarations), _List_fromArray([
                    (!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
                ]));
            }
            else {
                return declarations;
            }
        }();
        var insertStylesToNestedDecl = function (lastDecl) {
            return $elm$core$List$concat($rtfeldman$elm_css$Css$Structure$mapLast_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles), $elm$core$List$map_fn($elm$core$List$singleton, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(f, lastDecl))));
        };
        var initialResult = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(insertStylesToNestedDecl, $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
        return _Utils_ap(newDeclarations, _Utils_ap(withoutParent(initialResult), withoutParent(nextResult)));
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4($rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn = function (styles, declarations) {
        if (!styles.b) {
            return declarations;
        }
        else {
            switch (styles.a.$) {
                case 0:
                    var property = styles.a.a;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(property, declarations));
                case 1:
                    var _v4 = styles.a;
                    var selector = _v4.a;
                    var nestedStyles = _v4.b;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn(nestedStyles, rest, $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector), declarations);
                case 2:
                    var _v5 = styles.a;
                    var selectorCombinator = _v5.a;
                    var snippets = _v5.b;
                    var rest = styles.b;
                    var chain = F2(function (_v9, _v10) {
                        var originalSequence = _v9.a;
                        var originalTuples = _v9.b;
                        var originalPseudoElement = _v9.c;
                        var newSequence = _v10.a;
                        var newTuples = _v10.b;
                        var newPseudoElement = _v10.c;
                        return $rtfeldman$elm_css$Css$Structure$Selector_fn(originalSequence, _Utils_ap(originalTuples, _List_Cons(_Utils_Tuple2(selectorCombinator, newSequence), newTuples)), $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(_List_fromArray([newPseudoElement, originalPseudoElement])));
                    });
                    var expandDeclaration = function (declaration) {
                        switch (declaration.$) {
                            case 0:
                                var _v7 = declaration.a;
                                var firstSelector = _v7.a;
                                var otherSelectors = _v7.b;
                                var nestedStyles = _v7.c;
                                var newSelectors = $elm$core$List$concatMap_fn(function (originalSelector) {
                                    return $elm$core$List$map_fn(chain(originalSelector), _List_Cons(firstSelector, otherSelectors));
                                }, $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
                                var newDeclarations = function () {
                                    if (!newSelectors.b) {
                                        return _List_Nil;
                                    }
                                    else {
                                        var first = newSelectors.a;
                                        var remainder = newSelectors.b;
                                        return _List_fromArray([
                                            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(first, remainder, _List_Nil))
                                        ]);
                                    }
                                }();
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(nestedStyles, newDeclarations);
                            case 1:
                                var mediaQueries = declaration.a;
                                var styleBlocks = declaration.b;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn(mediaQueries, styleBlocks);
                            case 2:
                                var str = declaration.a;
                                var otherSnippets = declaration.b;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn(str, otherSnippets);
                            case 3:
                                var str1 = declaration.a;
                                var str2 = declaration.b;
                                var str3 = declaration.c;
                                var str4 = declaration.d;
                                var styleBlock = declaration.e;
                                return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
                            case 4:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$PageRule(properties)
                                ]);
                            case 5:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$FontFace(properties)
                                ]);
                            case 6:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$Viewport(properties)
                                ]);
                            case 7:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
                                ]);
                            default:
                                var tuples = declaration.a;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
                        }
                    };
                    return $elm$core$List$concat(_Utils_ap(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, declarations)
                    ]), $elm$core$List$map_fn(expandDeclaration, $elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
                case 3:
                    var _v11 = styles.a;
                    var pseudoElement = _v11.a;
                    var nestedStyles = _v11.b;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn(nestedStyles, rest, $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement), declarations);
                case 5:
                    var str = styles.a.a;
                    var rest = styles.b;
                    var name = $rtfeldman$elm_css$Hash$fromString(str);
                    var newProperty = "animation-name:" + name;
                    var newDeclarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(newProperty, declarations));
                    return $elm$core$List$append_fn(newDeclarations, _List_fromArray([
                        $rtfeldman$elm_css$Css$Structure$Keyframes({ l5: str, M: name })
                    ]));
                case 4:
                    var _v12 = styles.a;
                    var mediaQueries = _v12.a;
                    var nestedStyles = _v12.b;
                    var rest = styles.b;
                    var extraDeclarations = function () {
                        var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
                        if (!_v13.b) {
                            return _List_Nil;
                        }
                        else {
                            var firstSelector = _v13.a;
                            var otherSelectors = _v13.b;
                            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries), $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(nestedStyles, $elm$core$List$singleton($rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _List_Nil)))));
                        }
                    }();
                    return _Utils_ap($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, declarations), extraDeclarations);
                default:
                    var otherStyles = styles.a.a;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(_Utils_ap(otherStyles, rest), declarations);
            }
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
        var firstSelector = _v2.a;
        var otherSelectors = _v2.b;
        var styles = _v2.c;
        return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(styles, _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _List_Nil))
        ]));
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
        if (!snippetDeclarations.b) {
            return _List_Nil;
        }
        else {
            var first = snippetDeclarations.a;
            var rest = snippetDeclarations.b;
            return _Utils_ap($rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first), $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn = function (mediaQueries, styleBlocks) {
        var handleStyleBlock = function (styleBlock) {
            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
        };
        return $elm$core$List$concatMap_fn(handleStyleBlock, styleBlocks);
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn = function (str, snippets) {
        var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract($elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, declarations)
        ]);
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
        switch (snippetDeclaration.$) {
            case 0:
                var styleBlock = snippetDeclaration.a;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
            case 1:
                var mediaQueries = snippetDeclaration.a;
                var styleBlocks = snippetDeclaration.b;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn(mediaQueries, styleBlocks);
            case 2:
                var str = snippetDeclaration.a;
                var snippets = snippetDeclaration.b;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn(str, snippets);
            case 3:
                var str1 = snippetDeclaration.a;
                var str2 = snippetDeclaration.b;
                var str3 = snippetDeclaration.c;
                var str4 = snippetDeclaration.d;
                var styleBlock = snippetDeclaration.e;
                return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
            case 4:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$PageRule(properties)
                ]);
            case 5:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$FontFace(properties)
                ]);
            case 6:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$Viewport(properties)
                ]);
            case 7:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
                ]);
            default:
                var tuples = snippetDeclaration.a;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
        var charset = _v0.iQ;
        var imports = _v0.jB;
        var namespaces = _v0.j4;
        var snippets = _v0.kT;
        var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract($elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
        return { iQ: charset, l6: declarations, jB: imports, j4: namespaces };
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
        return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint($rtfeldman$elm_css$Css$Structure$compactStylesheet($rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
    };
    var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn);
    var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn = function (styles, sequence) {
        var selector = $rtfeldman$elm_css$Css$Structure$Selector_fn(sequence, _List_Nil, $elm$core$Maybe$Nothing);
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn(selector, _List_Nil, styles))
        ]);
    }, $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn);
    var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
        return { iQ: $elm$core$Maybe$Nothing, jB: _List_Nil, j4: _List_Nil, kT: snippets };
    };
    var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = "\u0007";
    var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_fromArray([
        $rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
    ]));
    var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
        if (!styles.b) {
            return "";
        }
        else {
            var otherwise = styles;
            return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile($rtfeldman$elm_css$Css$Preprocess$stylesheet(_List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn(styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
            ])));
        }
    };
    var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
        var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
        var classProperty = $elm$virtual_dom$VirtualDom$attribute_fn("", "");
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(classProperty, true, cssTemplate);
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_prose = $rtfeldman$elm_css$Css$property_fn("max-width", "65ch");
    var $rtfeldman$elm_css$VirtualDom$Styled$Node_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$VirtualDom$Styled$Node = F3($rtfeldman$elm_css$VirtualDom$Styled$Node_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
    var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
    var $rtfeldman$elm_css$Html$Styled$p_a0 = "p", $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$p_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4 = $rtfeldman$elm_css$Css$property_fn("padding", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto = $rtfeldman$elm_css$Css$property_fn("pointer-events", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_10 = $rtfeldman$elm_css$Css$property_fn("padding-right", "2.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md = $rtfeldman$elm_css$Css$property_fn("border-radius", "0.375rem");
    var $rtfeldman$elm_css$Css$Structure$CustomQuery = function (a) {
        return { $: 3, a: a };
    };
    var $rtfeldman$elm_css$Css$Preprocess$WithMedia_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2($rtfeldman$elm_css$Css$Preprocess$WithMedia_fn);
    var $rtfeldman$elm_css$Css$Media$withMediaQuery = function (queries) {
        return $rtfeldman$elm_css$Css$Preprocess$WithMedia($elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$CustomQuery, queries));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm = $rtfeldman$elm_css$Css$Media$withMediaQuery(_List_fromArray(["(min-width: 640px)"]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_96 = $rtfeldman$elm_css$Css$property_fn("width", "24rem");
    var $author$project$Overlay$notificationElement = function (elements) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(55, 0.7, 0.92)),
                $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(55, 0.7, 0.4)),
                $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(55, 0.7, 0.4)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_10,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_prose,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_96])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto
            ]))
        ]), elements);
    };
    var $author$project$Overlay$RemoveView = function (a) {
        return { $: 5, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$div_a0 = "div", $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$div_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$fixed = $rtfeldman$elm_css$Css$property_fn("position", "fixed");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex = $rtfeldman$elm_css$Css$property_fn("display", "flex");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col = $rtfeldman$elm_css$Css$property_fn("flex-direction", "column");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2 = $rtfeldman$elm_css$Css$property_fn("gap", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_end = $rtfeldman$elm_css$Css$property_fn("align-items", "flex-end");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none = $rtfeldman$elm_css$Css$property_fn("pointer-events", "none");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen = $rtfeldman$elm_css$Css$property_fn("width", "100vw");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute = $rtfeldman$elm_css$Css$property_fn("position", "absolute");
    var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
        return { $: 6, a: a };
    };
    var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
    var $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn = function (key, value) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn($elm$virtual_dom$VirtualDom$attribute_fn(key, value), false, "");
    }, $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$d_a0 = "d", $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0 = "fill", $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$height_a0 = "height", $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0);
    var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS_fn = function (a, b, c, d) {
        return { $: 1, a: a, b: b, c: c, d: d };
    }, $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4($rtfeldman$elm_css$VirtualDom$Styled$NodeNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
    var $rtfeldman$elm_css$Svg$Styled$node_a0 = "http://www.w3.org/2000/svg", $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS($rtfeldman$elm_css$Svg$Styled$node_a0);
    var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node("path");
    var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node("svg");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0 = "viewBox", $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$width_a0 = "width", $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0);
    var $author$project$Svg$closeCircled = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "24px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "24px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor")
        ]), attributes), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M0 0h24v24H0z"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "none")
            ]), _List_Nil),
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12\n                2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41\n                8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer = $rtfeldman$elm_css$Css$property_fn("cursor", "pointer");
    var $elm$virtual_dom$VirtualDom$Normal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
    var $rtfeldman$elm_css$VirtualDom$Styled$on_fn = function (eventName, handler) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(_VirtualDom_on_fn(eventName, handler), false, "");
    }, $rtfeldman$elm_css$VirtualDom$Styled$on = F2($rtfeldman$elm_css$VirtualDom$Styled$on_fn);
    var $rtfeldman$elm_css$Html$Styled$Events$on_fn = function (event, decoder) {
        return $rtfeldman$elm_css$VirtualDom$Styled$on_fn(event, $elm$virtual_dom$VirtualDom$Normal(decoder));
    }, $rtfeldman$elm_css$Html$Styled$Events$on = F2($rtfeldman$elm_css$Html$Styled$Events$on_fn);
    var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("click", $elm$json$Json$Decode$succeed(msg));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative = $rtfeldman$elm_css$Css$property_fn("position", "relative");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_2 = $rtfeldman$elm_css$Css$property_fn("right", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_2 = $rtfeldman$elm_css$Css$property_fn("top", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_30 = $rtfeldman$elm_css$Css$property_fn("z-index", "30");
    var $author$project$Overlay$wrapWithCloseButton_fn = function (styles, msg, element) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
        ]), _List_fromArray([
            $author$project$Svg$closeCircled(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_30,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ])),
            element
        ]));
    }, $author$project$Overlay$wrapWithCloseButton = F3($author$project$Overlay$wrapWithCloseButton_fn);
    var $author$project$Overlay$notificationWrapper_fn = function (model, closeButtonStyles) {
        return A2($elm$core$Basics$composeR, $elm$core$List$indexedMap(function (idx) {
            return A2($author$project$Overlay$wrapWithCloseButton, _List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto, closeButtonStyles), model.gd($author$project$Overlay$RemoveView(idx)));
        }), $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$fixed, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_end, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
        ])));
    }, $author$project$Overlay$notificationWrapper = F2($author$project$Overlay$notificationWrapper_fn);
    var $elm_community$list_extra$List$Extra$reverseAppend_fn = function (list1, list2) {
        return $elm$core$List$foldl_fn($elm$core$List$cons, list2, list1);
    }, $elm_community$list_extra$List$Extra$reverseAppend = F2($elm_community$list_extra$List$Extra$reverseAppend_fn);
    var $elm_community$list_extra$List$Extra$removeHelp_fn = function (list, x, xs, previousElements) {
        removeHelp: while (true) {
            if (!xs.b) {
                return list;
            }
            else {
                var y = xs.a;
                var ys = xs.b;
                if (_Utils_eq(x, y)) {
                    return $elm_community$list_extra$List$Extra$reverseAppend_fn(previousElements, ys);
                }
                else {
                    var $temp$list = list, $temp$x = x, $temp$xs = ys, $temp$previousElements = _List_Cons(y, previousElements);
                    list = $temp$list;
                    x = $temp$x;
                    xs = $temp$xs;
                    previousElements = $temp$previousElements;
                    continue removeHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$removeHelp = F4($elm_community$list_extra$List$Extra$removeHelp_fn);
    var $elm_community$list_extra$List$Extra$remove_fn = function (x, xs) {
        return $elm_community$list_extra$List$Extra$removeHelp_fn(xs, x, xs, _List_Nil);
    }, $elm_community$list_extra$List$Extra$remove = F2($elm_community$list_extra$List$Extra$remove_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("transition-property", "opacity"),
        $rtfeldman$elm_css$Css$property_fn("transition-timing-function", "cubic-bezier(0.4, 0, 0.2, 1)"),
        $rtfeldman$elm_css$Css$property_fn("transition-duration", "150ms")
    ]));
    var $author$project$Overlay$addNotification_fn = function (notification, model) {
        var element = $author$project$Overlay$notificationElement(notification);
        return _Utils_update(model, {
            a$: $elm$core$Maybe$Just({
                cb: $elm$core$Platform$Cmd$none,
                bR: "notification-overlay",
                b_: $elm$core$Maybe$Nothing,
                b$: true,
                cH: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_out]),
                ay: $elm$core$List$append_fn(_List_fromArray([element]), $elm_community$list_extra$List$Extra$remove_fn(element, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                    return $.ay;
                }, model.a$))),
                it: $author$project$Overlay$notificationWrapper_fn(model, _List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fill_a0, $rtfeldman$elm_css$Css$hsl_fn(55, 0.7, 0.4))
                ])),
                pH: 0,
                pJ: 0
            })
        });
    }, $author$project$Overlay$addNotification = F2($author$project$Overlay$addNotification_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
        return { $: 4, a: a };
    };
    var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
    var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled($elm$virtual_dom$VirtualDom$text(str));
    };
    var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
    var $author$project$Overlay$addTextNotification = function (txt) {
        return (txt === "") ? $elm$core$Basics$identity : $author$project$Overlay$addNotification(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(txt)
        ]));
    };
    var $author$project$Types$Team$TeamDatabase$applyDatabaseSettings_fn = function (settings, db) {
        return _Utils_update(db, {
            mk: $elm$core$Maybe$Just(settings.mk),
            pE: settings.pE
        });
    }, $author$project$Types$Team$TeamDatabase$applyDatabaseSettings = F2($author$project$Types$Team$TeamDatabase$applyDatabaseSettings_fn);
    var $author$project$Model$closeDialog = function (model) {
        return _Utils_update(model, { mc: $elm$core$Maybe$Nothing });
    };
    var $author$project$Types$Database$decodeId = _Json_map1_fn($elm$core$Basics$identity, _Json_decodeField_fn("id", $elm$json$Json$Decode$string));
    var $elm$http$Http$expectStringResponse_fn = function (toMsg, toResult) {
        return _Http_expect_fn("", $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
    }, $elm$http$Http$expectStringResponse = F2($elm$http$Http$expectStringResponse_fn);
    var $author$project$Api$Response$Failure = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Api$Response$fromResult = function (result) {
        if (!result.$) {
            var value = result.a;
            return $author$project$Api$Response$Success(value);
        }
        else {
            var errors = result.a;
            return $author$project$Api$Response$Failure(errors);
        }
    };
    var $elm$http$Http$BadBody = function (a) {
        return { $: 4, a: a };
    };
    var $elm$http$Http$BadStatus = function (a) {
        return { $: 3, a: a };
    };
    var $elm$http$Http$BadUrl = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$NetworkError = { $: 2 };
    var $elm$http$Http$Timeout = { $: 1 };
    var $elm$json$Json$Decode$decodeString = _Json_runOnString;
    var $author$project$Util$httpErrorToString = function (httpError) {
        switch (httpError.$) {
            case 0:
                var url = httpError.a;
                return "This is not a valid URL: \"" + (url + "\"");
            case 1:
                return "Request timed out";
            case 2:
                return "Problems with the network occurred";
            case 3:
                var code = httpError.a;
                return "An HTTP error with code \"" + ($elm$core$String$fromInt(code) + "\" occurred");
            default:
                var content = httpError.a;
                return "The response could not be processed:\n" + content;
        }
    };
    var $elm$core$String$replace_fn = function (before, after, string) {
        return $elm$core$String$join_fn(after, $elm$core$String$split_fn(before, string));
    }, $elm$core$String$replace = F3($elm$core$String$replace_fn);
    var $author$project$Util$httpResponseDecoder_fn = function (sucessDecoder, response) {
        switch (response.$) {
            case 0:
                var url = response.a;
                return $elm$core$Result$Err(_List_fromArray([
                    $author$project$Util$httpErrorToString($elm$http$Http$BadUrl(url))
                ]));
            case 1:
                return $elm$core$Result$Err(_List_fromArray([
                    $author$project$Util$httpErrorToString($elm$http$Http$Timeout)
                ]));
            case 2:
                return $elm$core$Result$Err(_List_fromArray([
                    $author$project$Util$httpErrorToString($elm$http$Http$NetworkError)
                ]));
            case 3:
                var metadata = response.a;
                var body = response.b;
                var errorsDecoder = _Json_map1_fn($elm$core$List$map(A2($elm$core$String$replace, "\\\"", "\"")), _Json_decodeField_fn("errors", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
                var _v1 = _Json_runOnString_fn(errorsDecoder, body);
                if (!_v1.$) {
                    var errors = _v1.a;
                    return $elm$core$Result$Err(errors);
                }
                else {
                    return $elm$core$Result$Err(_List_fromArray([
                        $author$project$Util$httpErrorToString($elm$http$Http$BadStatus(metadata.oW))
                    ]));
                }
            default:
                var body = response.b;
                var _v2 = _Json_runOnString_fn(sucessDecoder, body);
                if (!_v2.$) {
                    var value = _v2.a;
                    return $elm$core$Result$Ok(value);
                }
                else {
                    var err = _v2.a;
                    return $elm$core$Result$Err(_List_fromArray([
                        $author$project$Util$httpErrorToString($elm$http$Http$BadBody($elm$json$Json$Decode$errorToString(err)))
                    ]));
                }
        }
    }, $author$project$Util$httpResponseDecoder = F2($author$project$Util$httpResponseDecoder_fn);
    var $author$project$Api$expect = function (msg) {
        return A2($elm$core$Basics$composeR, $author$project$Util$httpResponseDecoder, $elm$http$Http$expectStringResponse(A2($elm$core$Basics$composeR, $author$project$Api$Response$fromResult, msg)));
    };
    var $elm$http$Http$jsonBody = function (value) {
        return _Http_pair_fn("application/json", _Json_encode_fn(0, value));
    };
    var $elm$json$Json$Encode$object = function (pairs) {
        return _Json_wrap($elm$core$List$foldl_fn_unwrapped(function (_v0, obj) {
            var k = _v0.a;
            var v = _v0.b;
            return _Json_addField_fn(k, v, obj);
        }, _Json_emptyObject(0), pairs));
    };
    var $elm$http$Http$Header_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$http$Http$Header = F2($elm$http$Http$Header_fn);
    var $elm$http$Http$header = $elm$http$Http$Header;
    var $author$project$Types$SessionToken$toString = function (_v0) {
        var token = _v0;
        return token;
    };
    var $author$project$Types$SessionToken$toHttpHeader = function (token) {
        return $elm$http$Http$Header_fn("Authorization", "Bearer " + $author$project$Types$SessionToken$toString(token));
    };
    var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
        if (m.$ === 1) {
            return _List_Nil;
        }
        else {
            var x = m.a;
            return _List_fromArray([x]);
        }
    };
    var $author$project$Api$headersFromMaybeToken_a0 = $elm$core$Maybe$map($author$project$Types$SessionToken$toHttpHeader), $author$project$Api$headersFromMaybeToken_a1 = $elm_community$maybe_extra$Maybe$Extra$toList, $author$project$Api$headersFromMaybeToken = A2($elm$core$Basics$composeR, $author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1);
    var $elm$http$Http$request = function (r) {
        return $elm$http$Http$command($elm$http$Http$Request({ lw: false, d: r.d, e: r.e, d9: r.d9, f: r.f, eK: r.eK, eQ: r.eQ, g: r.g }));
    };
    var $author$project$Api$requestWithMaybeToken_fn = function (maybeToken, cfg) {
        return $elm$http$Http$request({
            d: cfg.d,
            e: cfg.e,
            d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
            f: cfg.f,
            eK: $elm$core$Maybe$Nothing,
            eQ: $elm$core$Maybe$Nothing,
            g: cfg.g
        });
    }, $author$project$Api$requestWithMaybeToken = F2($author$project$Api$requestWithMaybeToken_fn);
    var $elm$json$Json$Encode$string = _Json_wrap;
    var $elm_community$maybe_extra$Maybe$Extra$cons_fn = function (item, list) {
        if (!item.$) {
            var v = item.a;
            return _List_Cons(v, list);
        }
        else {
            return list;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$cons = F2($elm_community$maybe_extra$Maybe$Extra$cons_fn);
    var $elm_community$maybe_extra$Maybe$Extra$values_a0 = $elm_community$maybe_extra$Maybe$Extra$cons, $elm_community$maybe_extra$Maybe$Extra$values_a1 = _List_Nil, $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1);
    var $author$project$Api$createDatabase_fn = function (msg, maybeToken, maybeTeam, maybeQuery, name) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object($elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                $elm$core$Maybe$Just(_Utils_Tuple2("name", $elm$json$Json$Encode$string(name))),
                $elm$core$Maybe$Just(_Utils_Tuple2("fileFormat", $elm$json$Json$Encode$string("sqlite"))),
                $elm$core$Maybe$map_fn($elm$core$Tuple$pair("team"), $elm$core$Maybe$map_fn($elm$json$Json$Encode$string, $elm$core$Maybe$map_fn(function ($) {
                    return $.M;
                }, maybeTeam))),
                $elm$core$Maybe$map_fn($elm$core$Tuple$pair("query"), $elm$core$Maybe$map_fn($elm$json$Json$Encode$string, maybeQuery))
            ])))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$Database$decodeId),
            f: "POST",
            g: "/api/dbs"
        });
    }, $author$project$Api$createDatabase = F5($author$project$Api$createDatabase_fn);
    var $author$project$Dialog$CustomizedDialog = function (a) {
        return { $: 6, a: a };
    };
    var $justinmimbs$time_extra$Time$Extra$Day = 11;
    var $rtfeldman$elm_css$Html$Styled$a_a0 = "a", $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$a_a0);
    var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2($rtfeldman$elm_css$Css$Preprocess$ExtendSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
        return { $: 2, a: a };
    };
    var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
        return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector($rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
    };
    var $rtfeldman$elm_css$Css$active = $rtfeldman$elm_css$Css$pseudoClass("active");
    var $elm$json$Json$Decode$at_fn = function (fields, decoder) {
        return $elm$core$List$foldr_fn($elm$json$Json$Decode$field, decoder, fields);
    }, $elm$json$Json$Decode$at = F2($elm$json$Json$Decode$at_fn);
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn = function (property, embedColor, opacityVarName, color) {
        if (!color.$) {
            var mode = color.a;
            var r = color.b;
            var g = color.c;
            var b = color.d;
            var opacity = color.e;
            var _v1 = _Utils_Tuple2(opacity, opacityVarName);
            if (!_v1.a.$) {
                var op = _v1.a.a;
                return $rtfeldman$elm_css$Css$property_fn(property, embedColor(mode + ("(" + (r + (" " + (g + (" " + (b + (" / " + (op + ")"))))))))));
            }
            else {
                if (!_v1.b.$) {
                    var _v2 = _v1.a;
                    var varName = _v1.b.a;
                    return $rtfeldman$elm_css$Css$batch(_List_fromArray([
                        $rtfeldman$elm_css$Css$property_fn(varName, "1"),
                        $rtfeldman$elm_css$Css$property_fn(property, embedColor(mode + ("(" + (r + (" " + (g + (" " + (b + (" / var(" + (varName + "))"))))))))))
                    ]));
                }
                else {
                    var _v3 = _v1.a;
                    var _v4 = _v1.b;
                    return $rtfeldman$elm_css$Css$property_fn(property, embedColor(mode + ("(" + (r + (" " + (g + (" " + (b + " / 1.0)"))))))));
                }
            }
        }
        else {
            var keyword = color.a;
            return $rtfeldman$elm_css$Css$property_fn(property, keyword);
        }
    }, $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor = F4($matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color = function (color) {
        return $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("background-color", function (c) {
            return c;
        }, $elm$core$Maybe$Just("--tw-bg-opacity"), color);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color = function (color) {
        return $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("border-color", function (c) {
            return c;
        }, $elm$core$Maybe$Just("--tw-border-opacity"), color);
    };
    var $rtfeldman$elm_css$Css$Structure$Child = 2;
    var $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2($rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn);
    var $rtfeldman$elm_css$Css$Global$children_a0 = 2, $rtfeldman$elm_css$Css$Global$children = $rtfeldman$elm_css$Css$Preprocess$NestSnippet($rtfeldman$elm_css$Css$Global$children_a0);
    var $rtfeldman$elm_css$Css$Structure$Descendant = 3;
    var $rtfeldman$elm_css$Css$Global$descendants_a0 = 3, $rtfeldman$elm_css$Css$Global$descendants = $rtfeldman$elm_css$Css$Preprocess$NestSnippet($rtfeldman$elm_css$Css$Global$descendants_a0);
    var $rtfeldman$elm_css$Css$Global$everything = function (styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn(styles, $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium = $rtfeldman$elm_css$Css$property_fn("font-weight", "500");
    var $rtfeldman$elm_css$Html$Styled$form_a0 = "form", $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$form_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4 = $rtfeldman$elm_css$Css$property_fn("gap", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8 = $rtfeldman$elm_css$Css$property_fn("height", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full = $rtfeldman$elm_css$Css$property_fn("height", "100%");
    var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass("hover");
    var $elm$virtual_dom$VirtualDom$property_fn = function (key, value) {
        return _VirtualDom_property_fn(_VirtualDom_noInnerHtmlOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlJson(value));
    }, $elm$virtual_dom$VirtualDom$property = F2($elm$virtual_dom$VirtualDom$property_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$property_fn = function (key, value) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn($elm$virtual_dom$VirtualDom$property_fn(key, value), false, "");
    }, $rtfeldman$elm_css$VirtualDom$Styled$property = F2($rtfeldman$elm_css$VirtualDom$Styled$property_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn = function (key, string) {
        return $rtfeldman$elm_css$VirtualDom$Styled$property_fn(key, $elm$json$Json$Encode$string(string));
    }, $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
        return $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn("href", url);
    };
    var $rtfeldman$elm_css$Css$invalid = $rtfeldman$elm_css$Css$pseudoClass("invalid");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center = $rtfeldman$elm_css$Css$property_fn("align-items", "center");
    var $rtfeldman$elm_css$Css$Structure$TypeSelector = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Global$typeSelector_fn = function (selectorStr, styles) {
        var sequence = $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn(selectorStr, _List_Nil);
        var sel = $rtfeldman$elm_css$Css$Structure$Selector_fn(sequence, _List_Nil, $elm$core$Maybe$Nothing);
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn(sel, _List_Nil, styles))
        ]);
    }, $rtfeldman$elm_css$Css$Global$typeSelector = F2($rtfeldman$elm_css$Css$Global$typeSelector_fn);
    var $rtfeldman$elm_css$Css$Global$label_a0 = "label", $rtfeldman$elm_css$Css$Global$label = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$label_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_4xl = $rtfeldman$elm_css$Css$property_fn("max-width", "56rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm = $rtfeldman$elm_css$Css$property_fn("max-width", "24rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-webkit-text-decoration-line", "none"),
        $rtfeldman$elm_css$Css$property_fn("text-decoration-line", "none")
    ]));
    var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
        return { $: 2, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn = function (event, decoder) {
        return $rtfeldman$elm_css$VirtualDom$Styled$on_fn(event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
    }, $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2($rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "1rem")
    ]));
    var $elm$json$Json$Encode$bool = _Json_wrap;
    var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn = function (key, bool) {
        return $rtfeldman$elm_css$VirtualDom$Styled$property_fn(key, $elm$json$Json$Encode$bool(bool));
    }, $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2($rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$required_a0 = "required", $rtfeldman$elm_css$Html$Styled$Attributes$required = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$required_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded = $rtfeldman$elm_css$Css$property_fn("border-radius", "0.25rem");
    var $rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0 = "disabled", $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden = $rtfeldman$elm_css$Css$property_fn("display", "none");
    var $rtfeldman$elm_css$Html$Styled$Attributes$id_a0 = "id", $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$id_a0);
    var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
    var $rtfeldman$elm_css$VirtualDom$Styled$style_fn = function (key, val) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(_VirtualDom_style_fn(key, val), false, "");
    }, $rtfeldman$elm_css$VirtualDom$Styled$style = F2($rtfeldman$elm_css$VirtualDom$Styled$style_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
    var $elm_community$maybe_extra$Maybe$Extra$unpack_fn = function (_default, f, m) {
        if (m.$ === 1) {
            return _default(0);
        }
        else {
            var a = m.a;
            return f(a);
        }
    }, $elm_community$maybe_extra$Maybe$Extra$unpack = F3($elm_community$maybe_extra$Maybe$Extra$unpack_fn);
    var $author$project$Util$maybeAttr_a0 = function (_v0) {
        return $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "");
    }, $author$project$Util$maybeAttr = $elm_community$maybe_extra$Maybe$Extra$unpack($author$project$Util$maybeAttr_a0);
    var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
        return _Utils_Tuple2(x, true);
    };
    var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn_fn = function (event, decoder) {
        return $rtfeldman$elm_css$VirtualDom$Styled$on_fn(event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
    }, $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2($rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn_fn);
    var $rtfeldman$elm_css$Html$Styled$Events$targetValue = $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "value"]), $elm$json$Json$Decode$string);
    var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
        return $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn_fn("input", _Json_map1_fn($rtfeldman$elm_css$Html$Styled$Events$alwaysStop, _Json_map1_fn(tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
    };
    var $rtfeldman$elm_css$Html$Styled$option_a0 = "option", $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$option_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2 = $rtfeldman$elm_css$Css$property_fn("padding", "0.5rem");
    var $rtfeldman$elm_css$Html$Styled$select_a0 = "select", $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$select_a0);
    var $rtfeldman$elm_css$Html$Styled$Attributes$selected_a0 = "selected", $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0);
    var $author$project$Util$styleIf_fn = function (condition, style) {
        return condition ? style : $rtfeldman$elm_css$Css$batch(_List_Nil);
    }, $author$project$Util$styleIf = F2($author$project$Util$styleIf_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$value_a0 = "value", $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$value_a0);
    var $author$project$Components$stringSelect = function (opts) {
        var placeholderOption = function () {
            var noPlaceholder = opts.df === "";
            var hasEmptyOption = $elm$core$List$member_fn("", opts.cx);
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, opts.ev === ""),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, true),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Util$styleIf_fn(noPlaceholder && hasEmptyOption, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(opts.df)
            ]));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$select_a0, _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, $elm$core$Maybe$withDefault_fn("string-select", opts.bR)),
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onInput, opts.cv),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, _Utils_eq(opts.cx, _List_Nil)),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                $rtfeldman$elm_css$Css$batch(opts.m)
            ]))
        ]), opts.cP), _List_Cons(placeholderOption, $elm$core$List$map_fn(function (o) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, o),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, _Utils_eq(o, opts.ev))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(o)
            ]));
        }, opts.cx)));
    };
    var $rtfeldman$elm_css$Css$Structure$AdjacentSibling = 0;
    var $rtfeldman$elm_css$Css$Global$adjacentSiblings_a0 = 0, $rtfeldman$elm_css$Css$Global$adjacentSiblings = $rtfeldman$elm_css$Css$Preprocess$NestSnippet($rtfeldman$elm_css$Css$Global$adjacentSiblings_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block = $rtfeldman$elm_css$Css$property_fn("display", "block");
    var $rtfeldman$elm_css$Html$Styled$button_a0 = "button", $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$button_a0);
    var $rtfeldman$elm_css$Html$Styled$Attributes$for_a0 = "htmlFor", $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$for_a0);
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn = function (a, b, c, d, e) {
        return { $: 0, a: a, b: b, c: c, d: d, e: e };
    }, $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color = F5($matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn);
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable = { $: 1 };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "229", "231", "235", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $rtfeldman$elm_css$Html$Styled$input_a0 = "input", $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$input_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("top", "0px"),
        $rtfeldman$elm_css$Css$property_fn("right", "0px"),
        $rtfeldman$elm_css$Css$property_fn("bottom", "0px"),
        $rtfeldman$elm_css$Css$property_fn("left", "0px")
    ]));
    var $rtfeldman$elm_css$Html$Styled$label_a0 = "label", $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$label_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0 = $rtfeldman$elm_css$Css$property_fn("opacity", "0");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100 = $rtfeldman$elm_css$Css$property_fn("opacity", "1");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-webkit-user-select", "none"),
        $rtfeldman$elm_css$Css$property_fn("-moz-user-select", "none"),
        $rtfeldman$elm_css$Css$property_fn("user-select", "none")
    ]));
    var $rtfeldman$elm_css$Svg$Styled$animate = $rtfeldman$elm_css$Svg$Styled$node("animate");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0 = "attributeName", $rtfeldman$elm_css$Svg$Styled$Attributes$attributeName = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0 = "begin", $rtfeldman$elm_css$Svg$Styled$Attributes$begin = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0 = "dur", $rtfeldman$elm_css$Svg$Styled$Attributes$dur = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0);
    var $rtfeldman$elm_css$Svg$Styled$g = $rtfeldman$elm_css$Svg$Styled$node("g");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0 = "keyTimes", $rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0);
    var $rtfeldman$elm_css$Svg$Styled$rect = $rtfeldman$elm_css$Svg$Styled$node("rect");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0 = "repeatCount", $rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0 = "rx", $rtfeldman$elm_css$Svg$Styled$Attributes$rx = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0 = "ry", $rtfeldman$elm_css$Svg$Styled$Attributes$ry = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$style_a0 = "style", $rtfeldman$elm_css$Svg$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0 = "transform", $rtfeldman$elm_css$Svg$Styled$Attributes$transform = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$values = function (value) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("values", value);
    };
    var $rtfeldman$elm_css$Svg$Styled$Attributes$x_a0 = "x", $rtfeldman$elm_css$Svg$Styled$Attributes$x = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$y_a0 = "y", $rtfeldman$elm_css$Svg$Styled$Attributes$y = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0);
    var $author$project$Svg$spinner = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "\n            margin: auto;\n            background: none none repeat scroll 0% 0%;\n            display: block;\n            --darkreader-inline-bgcolor: #1f2223;\n            --darkreader-inline-bgimage: none;\n            shape-rendering: auto;\n            "),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "50px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "50px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "24 24 55 55"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "#0661eb")
        ]), attributes), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(0 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.9166666666666666s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(30 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.8333333333333334s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(60 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.75s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(90 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.6666666666666666s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(120 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.5833333333333334s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(150 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.5s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(180 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.4166666666666667s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(210 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.3333333333333333s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(240 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.25s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(270 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.16666666666666666s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(300 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "-0.08333333333333333s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ])),
            A2($rtfeldman$elm_css$Svg$Styled$g, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$transform_a0, "rotate(330 50 50)"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
            ]), _List_fromArray([
                A2($rtfeldman$elm_css$Svg$Styled$rect, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$x_a0, "47"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$y_a0, "24"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$rx_a0, "3"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$ry_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "6"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "12"),
                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "--darkreader-inline-fill: #40a0fa; animation-play-state: running; animation-delay: 0s;")
                ]), _List_fromArray([
                    A2($rtfeldman$elm_css$Svg$Styled$animate, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$attributeName_a0, "opacity"),
                        $rtfeldman$elm_css$Svg$Styled$Attributes$values("1;0"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$keyTimes_a0, "0;1"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$dur_a0, "1s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$begin_a0, "0s"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$repeatCount_a0, "indefinite"),
                        $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$style_a0, "animation-play-state: running; animation-delay: 0s;")
                    ]), _List_Nil)
                ]))
            ]))
        ]));
    };
    var $rtfeldman$elm_css$Css$Global$svg_a0 = "svg", $rtfeldman$elm_css$Css$Global$svg = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$svg_a0);
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$Opacity = function (a) {
        return { $: 0, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "0", "0", "0", $matheus23$elm_tailwind_modules_base$Tailwind$Color$Opacity("0"));
    var $rtfeldman$elm_css$Html$Styled$Attributes$type__a0 = "type", $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$type__a0);
    var $author$project$Components$submitButtonWithSpinner_fn = function (title, styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "toggle"),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                    A2($rtfeldman$elm_css$Css$pseudoClass, "checked", _List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$adjacentSiblings_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none])),
                                    $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$label_a0, _List_fromArray([
                                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                                            $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$svg_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100]))
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "submit"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, "toggle"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                    ]))
                ]), _List_fromArray([
                    $author$project$Svg$spinner(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                    ]))
                ]))
            ]))
        ]));
    }, $author$project$Components$submitButtonWithSpinner = F2($author$project$Components$submitButtonWithSpinner_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color = function (color) {
        return $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("color", function (c) {
            return c;
        }, $elm$core$Maybe$Just("--tw-text-opacity"), color);
    };
    var $elm$url$Url$Builder$toQueryPair = function (_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return key + ("=" + value);
    };
    var $elm$url$Url$Builder$toQuery = function (parameters) {
        if (!parameters.b) {
            return "";
        }
        else {
            return "?" + $elm$core$String$join_fn("&", $elm$core$List$map_fn($elm$url$Url$Builder$toQueryPair, parameters));
        }
    };
    var $elm$url$Url$Builder$absolute_fn = function (pathSegments, parameters) {
        return "/" + ($elm$core$String$join_fn("/", pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
    }, $elm$url$Url$Builder$absolute = F2($elm$url$Url$Builder$absolute_fn);
    var $author$project$Types$User$nameToString = function (_v0) {
        var username = _v0;
        return username;
    };
    var $elm$url$Url$percentEncode = _Url_percentEncode;
    var $elm$url$Url$Builder$relative_fn = function (pathSegments, parameters) {
        return _Utils_ap($elm$core$String$join_fn("/", pathSegments), $elm$url$Url$Builder$toQuery(parameters));
    }, $elm$url$Url$Builder$relative = F2($elm$url$Url$Builder$relative_fn);
    var $elm$url$Url$Builder$QueryParameter_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$url$Url$Builder$QueryParameter = F2($elm$url$Url$Builder$QueryParameter_fn);
    var $elm$url$Url$Builder$string_fn = function (key, value) {
        return $elm$url$Url$Builder$QueryParameter_fn($elm$url$Url$percentEncode(key), $elm$url$Url$percentEncode(value));
    }, $elm$url$Url$Builder$string = F2($elm$url$Url$Builder$string_fn);
    var $author$project$Pages$Dashboards$Route$toString = function (r) {
        switch (r.$) {
            case 0:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["overview"]), _List_Nil);
            case 1:
                var did = r.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([did]), _List_Nil);
            case 2:
                var did = r.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([did, "edit"]), _List_Nil);
            case 3:
                var did = r.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([did, "chart", "new"]), _List_Nil);
            default:
                var did = r.a;
                var cid = r.b;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([did, "chart", cid, "edit"]), _List_Nil);
        }
    };
    var $author$project$Pages$Functions$Route$toString = function (route) {
        switch (route.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var functionId = route.a;
                return $elm$core$Maybe$Just($elm$url$Url$Builder$absolute_fn(_List_fromArray([functionId]), _List_Nil));
            default:
                var functionId = route.a;
                var maybeVersionId = route.b;
                var versionIdPath = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function (versionId) {
                    return $elm$url$Url$Builder$absolute_fn(_List_fromArray([versionId]), _List_Nil);
                }, maybeVersionId);
                return $elm$core$Maybe$Just(_Utils_ap($elm$url$Url$Builder$absolute_fn(_List_fromArray([functionId, "versions"]), _List_Nil), versionIdPath));
        }
    };
    var $author$project$Types$ApiToken$idToInt = function (_v0) {
        var id = _v0;
        return id;
    };
    var $author$project$Pages$Teams$Route$toString = function (route) {
        switch (route.$) {
            case 0:
                return $elm$url$Url$Builder$absolute_fn(_List_Nil, _List_Nil);
            case 1:
                var teamName = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([teamName]), _List_Nil);
            case 2:
                var teamName = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([teamName, "settings"]), _List_Nil);
            case 3:
                var teamName = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([teamName, "billing"]), _List_Nil);
            default:
                var teamName = route.a;
                var tokenId = route.b;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([
                    teamName,
                    "tokens",
                    $elm$core$String$fromInt($author$project$Types$ApiToken$idToInt(tokenId))
                ]), _List_Nil);
        }
    };
    var $author$project$Pages$Admin$Settings$Route$toUrlPath = function (route) {
        if (!route) {
            return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["settings", "functions"]), _List_Nil);
        }
        else {
            return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["settings", "environment"]), _List_Nil);
        }
    };
    var $author$project$Pages$Admin$Route$toUrlPath = function (route) {
        switch (route.$) {
            case 0:
                return $elm$url$Url$Builder$absolute_fn(_List_Nil, _List_Nil);
            case 1:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["databases"]), _List_Nil);
            case 2:
                var subRoute = route.a;
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$url$Url$Builder$absolute_fn(_List_fromArray(["settings"]), _List_Nil), $author$project$Pages$Admin$Settings$Route$toUrlPath, subRoute);
            default:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["billing"]), _List_Nil);
        }
    };
    var $author$project$Pages$Settings$Route$toUrlPath = function (route) {
        switch (route) {
            case 1:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["database"]), _List_Nil);
            case 0:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["general"]), _List_Nil);
            default:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["environment"]), _List_Nil);
        }
    };
    var $author$project$Types$Database$unwrapId = function (_v0) {
        var id = _v0;
        return id;
    };
    var $author$project$Route$toUrlPath = function (route) {
        var absolute = F2(function (pathSegments, parameters) {
            return $elm$url$Url$Builder$absolute_fn($elm$core$List$map_fn($elm$url$Url$percentEncode, pathSegments), parameters);
        });
        switch (route.$) {
            case 0:
                return $elm$url$Url$Builder$relative_fn(_List_Nil, _List_Nil);
            case 1:
                return A2(absolute, _List_Nil, _List_Nil);
            case 2:
                return A2(absolute, _List_fromArray(["affiliate"]), _List_Nil);
            case 3:
                return A2(absolute, _List_fromArray(["pricing"]), _List_Nil);
            case 4:
                return A2(absolute, _List_fromArray(["trial"]), _List_Nil);
            case 5:
                return A2(absolute, _List_fromArray(["signup"]), _List_Nil);
            case 6:
                return A2(absolute, _List_fromArray(["login"]), _List_Nil);
            case 7:
                return A2(absolute, _List_fromArray(["forgot-password"]), _List_Nil);
            case 8:
                var maybeUsername = route.a;
                return $author$project$Util$flip_fn(absolute, _List_Nil, $elm$core$List$append_fn(_List_fromArray(["users"]), $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn($author$project$Types$User$nameToString, maybeUsername))));
            case 9:
                var subRoute = route.a;
                return _Utils_ap(A2(absolute, _List_fromArray(["teams"]), _List_Nil), $author$project$Pages$Teams$Route$toString(subRoute));
            case 26:
                var subRoute = route.a;
                return _Utils_ap(A2(absolute, _List_fromArray(["admin"]), _List_Nil), $author$project$Pages$Admin$Route$toUrlPath(subRoute));
            case 10:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "playground"
                ]), _List_Nil);
            case 11:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "download"
                ]), _List_Nil);
            case 12:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "duplicate"
                ]), _List_Nil);
            case 13:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "readonly",
                    $author$project$Types$Database$unwrapId(dbId),
                    "duplicate"
                ]), _List_Nil);
            case 14:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "regenerate-db-id"
                ]), _List_Nil);
            case 15:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "regenerate-readonly-id"
                ]), _List_Nil);
            case 16:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId)
                ]), _List_Nil);
            case 17:
                var dbId = route.a;
                var maybeTable = route.b;
                var maybeRowId = route.c;
                var maybeCol = route.d;
                var fragment = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$String$append("#")), maybeCol);
                return $author$project$Util$flip_fn($elm$core$String$append, fragment, A2(absolute, $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    $elm$core$Maybe$Just("dbs"),
                    $elm$core$Maybe$Just($author$project$Types$Database$unwrapId(dbId)),
                    $elm$core$Maybe$Just("tables"),
                    maybeTable,
                    $elm$core$Maybe$map_fn($elm$core$String$fromInt, maybeRowId)
                ])), _List_Nil));
            case 18:
                var dbId = route.a;
                var maybeTable = route.b;
                var maybeRowId = route.c;
                var maybeCol = route.d;
                var fragment = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$String$append("#")), maybeCol);
                return $author$project$Util$flip_fn($elm$core$String$append, fragment, A2(absolute, $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    $elm$core$Maybe$Just("dbs"),
                    $elm$core$Maybe$Just($author$project$Types$Database$unwrapId(dbId)),
                    $elm$core$Maybe$Just("views"),
                    maybeTable,
                    $elm$core$Maybe$map_fn($elm$core$String$fromInt, maybeRowId)
                ])), _List_Nil));
            case 19:
                var dbId = route.a;
                var maybeTabString = route.b;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "queries"
                ]), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, A2($elm$core$Basics$composeR, $elm$url$Url$Builder$string("tab"), $elm$core$List$singleton), maybeTabString));
            case 20:
                var dbId = route.a;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "graphiql"
                ]), _List_Nil);
            case 21:
                var dbId = route.a;
                var maybeAppid = route.b;
                return $author$project$Util$flip_fn(absolute, _List_Nil, $elm$core$List$append_fn(_List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "apps"
                ]), $elm_community$maybe_extra$Maybe$Extra$toList(maybeAppid)));
            case 22:
                var dbId = route.a;
                var appId = route.b;
                return A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "app",
                    appId
                ]), _List_Nil);
            case 23:
                var dbId = route.a;
                var subRoute = route.b;
                return _Utils_ap(A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "functions"
                ]), _List_Nil), $elm$core$Maybe$withDefault_fn("", $author$project$Pages$Functions$Route$toString(subRoute)));
            case 24:
                var dbId = route.a;
                var maybeSubRoute = route.b;
                return _Utils_ap(A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "dashboards"
                ]), _List_Nil), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Pages$Dashboards$Route$toString, maybeSubRoute));
            default:
                var dbId = route.a;
                var maybeSubRoute = route.b;
                return _Utils_ap(A2(absolute, _List_fromArray([
                    "dbs",
                    $author$project$Types$Database$unwrapId(dbId),
                    "settings"
                ]), _List_Nil), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Pages$Settings$Route$toUrlPath, maybeSubRoute));
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-webkit-text-decoration-line", "underline"),
        $rtfeldman$elm_css$Css$property_fn("text-decoration-line", "underline")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full = $rtfeldman$elm_css$Css$property_fn("width", "100%");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_100 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "254", "249", "195", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_200 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "254", "240", "138", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_300 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "253", "224", "71", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "133", "77", "14", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Components$assignDatabaseBanner = function (cfg) {
        var loginSignupButtons_ = function (_v0) {
            var toLink = F2(function (title, route) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(route)),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium,
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]));
            });
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                A2(toLink, "Log in", $author$project$Route$Login),
                $rtfeldman$elm_css$Html$Styled$text(" or "),
                A2(toLink, "sign up", $author$project$Route$Signup),
                $rtfeldman$elm_css$Html$Styled$text(" to assign this database to a team.")
            ]));
        };
        var assignDatabaseForm = function (user) {
            var decoder = _Json_map1_fn(A2($elm$core$Basics$composeR, cfg.hJ, A2($author$project$Util$flip, $elm$core$Tuple$pair, true)), $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "0", "value"]), $elm$json$Json$Decode$string));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("submit", decoder),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded]))
                    ])),
                    $rtfeldman$elm_css$Css$invalid(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$label_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $author$project$Components$stringSelect({
                    cP: _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true)
                    ]),
                    bR: $elm$core$Maybe$Just("team-select"),
                    cv: $elm$core$Maybe$Nothing,
                    cx: $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$neq(cfg.j0)), $elm$core$List$map_fn(function ($) {
                        return $.M;
                    }, user.pc)),
                    df: "",
                    ev: "",
                    m: _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800)
                    ])
                }),
                $author$project$Components$submitButtonWithSpinner_fn("Submit", _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_200)
                    ])),
                    $rtfeldman$elm_css$Css$active(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_300)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
                ]))
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_4xl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800),
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg.i6)
            ])),
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(loginSignupButtons_(0), assignDatabaseForm, cfg.hr)
        ]));
    };
    var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
    var $justinmimbs$time_extra$Time$Extra$Month = 2;
    var $justinmimbs$time_extra$Time$Extra$Week = 3;
    var $justinmimbs$date$Date$Day = 11;
    var $justinmimbs$date$Date$Friday = 8;
    var $justinmimbs$date$Date$Monday = 4;
    var $justinmimbs$date$Date$Month = 2;
    var $justinmimbs$date$Date$Quarter = 1;
    var $justinmimbs$date$Date$Saturday = 9;
    var $justinmimbs$date$Date$Sunday = 10;
    var $justinmimbs$date$Date$Thursday = 7;
    var $justinmimbs$date$Date$Tuesday = 5;
    var $justinmimbs$date$Date$Wednesday = 6;
    var $justinmimbs$date$Date$Week = 3;
    var $justinmimbs$date$Date$Year = 0;
    var $elm$time$Time$Fri = 4;
    var $elm$time$Time$Mon = 0;
    var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
    var $elm$time$Time$Sat = 5;
    var $elm$time$Time$Sun = 6;
    var $elm$time$Time$Thu = 3;
    var $elm$time$Time$Tue = 1;
    var $elm$time$Time$Wed = 2;
    var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
        var rd = _v0;
        var _v1 = _Basics_modBy_fn(7, rd);
        if (!_v1) {
            return 7;
        }
        else {
            var n = _v1;
            return n;
        }
    };
    var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
        switch (wd) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    };
    var $justinmimbs$date$Date$daysSincePreviousWeekday_fn = function (wd, date) {
        return _Basics_modBy_fn(7, ($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
    }, $justinmimbs$date$Date$daysSincePreviousWeekday = F2($justinmimbs$date$Date$daysSincePreviousWeekday_fn);
    var $justinmimbs$date$Date$isLeapYear = function (y) {
        return ((!_Basics_modBy_fn(4, y)) && (!(!_Basics_modBy_fn(100, y)))) || (!_Basics_modBy_fn(400, y));
    };
    var $justinmimbs$date$Date$daysBeforeMonth_fn = function (y, m) {
        var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
        switch (m) {
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    }, $justinmimbs$date$Date$daysBeforeMonth = F2($justinmimbs$date$Date$daysBeforeMonth_fn);
    var $justinmimbs$date$Date$floorDiv_fn = function (a, b) {
        return $elm$core$Basics$floor(a / b);
    }, $justinmimbs$date$Date$floorDiv = F2($justinmimbs$date$Date$floorDiv_fn);
    var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
        var y = y1 - 1;
        var leapYears = ($justinmimbs$date$Date$floorDiv_fn(y, 4) - $justinmimbs$date$Date$floorDiv_fn(y, 100)) + $justinmimbs$date$Date$floorDiv_fn(y, 400);
        return (365 * y) + leapYears;
    };
    var $justinmimbs$date$Date$firstOfMonth_fn = function (y, m) {
        return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + 1;
    }, $justinmimbs$date$Date$firstOfMonth = F2($justinmimbs$date$Date$firstOfMonth_fn);
    var $justinmimbs$date$Date$firstOfYear = function (y) {
        return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
    };
    var $elm$time$Time$Jan = 0;
    var $justinmimbs$date$Date$daysInMonth_fn = function (y, m) {
        switch (m) {
            case 0:
                return 31;
            case 1:
                return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $justinmimbs$date$Date$daysInMonth = F2($justinmimbs$date$Date$daysInMonth_fn);
    var $justinmimbs$date$Date$monthToNumber = function (m) {
        switch (m) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $elm$time$Time$Apr = 3;
    var $elm$time$Time$Aug = 7;
    var $elm$time$Time$Dec = 11;
    var $elm$time$Time$Feb = 1;
    var $elm$time$Time$Jul = 6;
    var $elm$time$Time$Jun = 5;
    var $elm$time$Time$Mar = 2;
    var $elm$time$Time$May = 4;
    var $elm$time$Time$Nov = 10;
    var $elm$time$Time$Oct = 9;
    var $elm$time$Time$Sep = 8;
    var $justinmimbs$date$Date$numberToMonth = function (mn) {
        var _v0 = $elm$core$Basics$max_fn(1, mn);
        switch (_v0) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    };
    var $justinmimbs$date$Date$toCalendarDateHelp_fn = function (y, m, d) {
        toCalendarDateHelp: while (true) {
            var monthDays = $justinmimbs$date$Date$daysInMonth_fn(y, m);
            var mn = $justinmimbs$date$Date$monthToNumber(m);
            if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
                var $temp$y = y, $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1), $temp$d = d - monthDays;
                y = $temp$y;
                m = $temp$m;
                d = $temp$d;
                continue toCalendarDateHelp;
            }
            else {
                return { i$: d, j2: m, lk: y };
            }
        }
    }, $justinmimbs$date$Date$toCalendarDateHelp = F3($justinmimbs$date$Date$toCalendarDateHelp_fn);
    var $justinmimbs$date$Date$divWithRemainder_fn = function (a, b) {
        return _Utils_Tuple2($justinmimbs$date$Date$floorDiv_fn(a, b), _Basics_modBy_fn(b, a));
    }, $justinmimbs$date$Date$divWithRemainder = F2($justinmimbs$date$Date$divWithRemainder_fn);
    var $justinmimbs$date$Date$year = function (_v0) {
        var rd = _v0;
        var _v1 = $justinmimbs$date$Date$divWithRemainder_fn(rd, 146097);
        var n400 = _v1.a;
        var r400 = _v1.b;
        var _v2 = $justinmimbs$date$Date$divWithRemainder_fn(r400, 36524);
        var n100 = _v2.a;
        var r100 = _v2.b;
        var _v3 = $justinmimbs$date$Date$divWithRemainder_fn(r100, 1461);
        var n4 = _v3.a;
        var r4 = _v3.b;
        var _v4 = $justinmimbs$date$Date$divWithRemainder_fn(r4, 365);
        var n1 = _v4.a;
        var r1 = _v4.b;
        var n = (!r1) ? 0 : 1;
        return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
    };
    var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
        var rd = _v0;
        var y = $justinmimbs$date$Date$year(rd);
        return {
            hL: rd - $justinmimbs$date$Date$daysBeforeYear(y),
            lk: y
        };
    };
    var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
        var rd = _v0;
        var date = $justinmimbs$date$Date$toOrdinalDate(rd);
        return $justinmimbs$date$Date$toCalendarDateHelp_fn(date.lk, 0, date.hL);
    };
    var $justinmimbs$date$Date$month_a0 = $justinmimbs$date$Date$toCalendarDate, $justinmimbs$date$Date$month_a1 = function ($) {
        return $.j2;
    }, $justinmimbs$date$Date$month = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1);
    var $justinmimbs$date$Date$monthToQuarter = function (m) {
        return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
    };
    var $justinmimbs$date$Date$quarter_a0 = $justinmimbs$date$Date$month, $justinmimbs$date$Date$quarter_a1 = $justinmimbs$date$Date$monthToQuarter, $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1);
    var $justinmimbs$date$Date$quarterToMonth = function (q) {
        return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
    };
    var $justinmimbs$date$Date$floor_fn = function (interval, date) {
        var rd = date;
        switch (interval) {
            case 0:
                return $justinmimbs$date$Date$firstOfYear($justinmimbs$date$Date$year(date));
            case 1:
                return $justinmimbs$date$Date$firstOfMonth_fn($justinmimbs$date$Date$year(date), $justinmimbs$date$Date$quarterToMonth($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date)));
            case 2:
                return $justinmimbs$date$Date$firstOfMonth_fn($justinmimbs$date$Date$year(date), $elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date));
            case 3:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(0, date);
            case 4:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(0, date);
            case 5:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(1, date);
            case 6:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(2, date);
            case 7:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(3, date);
            case 8:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(4, date);
            case 9:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(5, date);
            case 10:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(6, date);
            default:
                return date;
        }
    }, $justinmimbs$date$Date$floor = F2($justinmimbs$date$Date$floor_fn);
    var $elm$core$Basics$clamp_fn = function (low, high, number) {
        return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
    }, $elm$core$Basics$clamp = F3($elm$core$Basics$clamp_fn);
    var $justinmimbs$date$Date$fromCalendarDate_fn = function (y, m, d) {
        return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + $elm$core$Basics$clamp_fn(1, $justinmimbs$date$Date$daysInMonth_fn(y, m), d);
    }, $justinmimbs$date$Date$fromCalendarDate = F3($justinmimbs$date$Date$fromCalendarDate_fn);
    var $elm$time$Time$flooredDiv_fn = function (numerator, denominator) {
        return $elm$core$Basics$floor(numerator / denominator);
    }, $elm$time$Time$flooredDiv = F2($elm$time$Time$flooredDiv_fn);
    var $elm$time$Time$posixToMillis = function (_v0) {
        var millis = _v0;
        return millis;
    };
    var $elm$time$Time$toAdjustedMinutesHelp_fn = function (defaultOffset, posixMinutes, eras) {
        toAdjustedMinutesHelp: while (true) {
            if (!eras.b) {
                return posixMinutes + defaultOffset;
            }
            else {
                var era = eras.a;
                var olderEras = eras.b;
                if (_Utils_cmp(era.x, posixMinutes) < 0) {
                    return posixMinutes + era.fK;
                }
                else {
                    var $temp$defaultOffset = defaultOffset, $temp$posixMinutes = posixMinutes, $temp$eras = olderEras;
                    defaultOffset = $temp$defaultOffset;
                    posixMinutes = $temp$posixMinutes;
                    eras = $temp$eras;
                    continue toAdjustedMinutesHelp;
                }
            }
        }
    }, $elm$time$Time$toAdjustedMinutesHelp = F3($elm$time$Time$toAdjustedMinutesHelp_fn);
    var $elm$time$Time$toAdjustedMinutes_fn = function (_v0, time) {
        var defaultOffset = _v0.a;
        var eras = _v0.b;
        return $elm$time$Time$toAdjustedMinutesHelp_fn(defaultOffset, $elm$time$Time$flooredDiv_fn($elm$time$Time$posixToMillis(time), 60000), eras);
    }, $elm$time$Time$toAdjustedMinutes = F2($elm$time$Time$toAdjustedMinutes_fn);
    var $elm$core$Basics$ge = _Utils_ge;
    var $elm$time$Time$toCivil = function (minutes) {
        var rawDay = $elm$time$Time$flooredDiv_fn(minutes, 60 * 24) + 719468;
        var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
        var dayOfEra = rawDay - (era * 146097);
        var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
        var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
        var mp = (((5 * dayOfYear) + 2) / 153) | 0;
        var month = mp + ((mp < 10) ? 3 : (-9));
        var year = yearOfEra + (era * 400);
        return {
            i$: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
            j2: month,
            lk: year + ((month <= 2) ? 1 : 0)
        };
    };
    var $elm$time$Time$toDay_fn = function (zone, time) {
        return $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).i$;
    }, $elm$time$Time$toDay = F2($elm$time$Time$toDay_fn);
    var $elm$time$Time$toMonth_fn = function (zone, time) {
        var _v0 = $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).j2;
        switch (_v0) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, $elm$time$Time$toMonth = F2($elm$time$Time$toMonth_fn);
    var $elm$time$Time$toYear_fn = function (zone, time) {
        return $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).lk;
    }, $elm$time$Time$toYear = F2($elm$time$Time$toYear_fn);
    var $justinmimbs$date$Date$fromPosix_fn = function (zone, posix) {
        return $justinmimbs$date$Date$fromCalendarDate_fn($elm$time$Time$toYear_fn(zone, posix), $elm$time$Time$toMonth_fn(zone, posix), $elm$time$Time$toDay_fn(zone, posix));
    }, $justinmimbs$date$Date$fromPosix = F2($justinmimbs$date$Date$fromPosix_fn);
    var $justinmimbs$date$Date$toRataDie = function (_v0) {
        var rd = _v0;
        return rd;
    };
    var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
        var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
        return daysSinceEpoch * 86400000;
    };
    var $justinmimbs$time_extra$Time$Extra$timeFromClock_fn = function (hour, minute, second, millisecond) {
        return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
    }, $justinmimbs$time_extra$Time$Extra$timeFromClock = F4($justinmimbs$time_extra$Time$Extra$timeFromClock_fn);
    var $elm$time$Time$toHour_fn = function (zone, time) {
        return _Basics_modBy_fn(24, $elm$time$Time$flooredDiv_fn($elm$time$Time$toAdjustedMinutes_fn(zone, time), 60));
    }, $elm$time$Time$toHour = F2($elm$time$Time$toHour_fn);
    var $elm$time$Time$toMillis_fn = function (_v0, time) {
        return _Basics_modBy_fn(1000, $elm$time$Time$posixToMillis(time));
    }, $elm$time$Time$toMillis = F2($elm$time$Time$toMillis_fn);
    var $elm$time$Time$toMinute_fn = function (zone, time) {
        return _Basics_modBy_fn(60, $elm$time$Time$toAdjustedMinutes_fn(zone, time));
    }, $elm$time$Time$toMinute = F2($elm$time$Time$toMinute_fn);
    var $elm$time$Time$toSecond_fn = function (_v0, time) {
        return _Basics_modBy_fn(60, $elm$time$Time$flooredDiv_fn($elm$time$Time$posixToMillis(time), 1000));
    }, $elm$time$Time$toSecond = F2($elm$time$Time$toSecond_fn);
    var $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn = function (zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), $elm$time$Time$toSecond_fn(zone, posix), $elm$time$Time$toMillis_fn(zone, posix));
    }, $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2($justinmimbs$time_extra$Time$Extra$timeFromPosix_fn);
    var $justinmimbs$time_extra$Time$Extra$toOffset_fn = function (zone, posix) {
        var millis = $elm$time$Time$posixToMillis(posix);
        var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis($justinmimbs$date$Date$fromPosix_fn(zone, posix)) + $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix);
        return ((localMillis - millis) / 60000) | 0;
    }, $justinmimbs$time_extra$Time$Extra$toOffset = F2($justinmimbs$time_extra$Time$Extra$toOffset_fn);
    var $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn = function (zone, date, time) {
        var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
        var offset0 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, $elm$time$Time$millisToPosix(millis));
        var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
        var offset1 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, posix1);
        if (_Utils_eq(offset0, offset1)) {
            return posix1;
        }
        else {
            var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
            var offset2 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, posix2);
            return _Utils_eq(offset1, offset2) ? posix2 : posix1;
        }
    }, $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3($justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn);
    var $justinmimbs$time_extra$Time$Extra$floorDate_fn = function (dateInterval, zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$floor_fn(dateInterval, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), 0);
    }, $justinmimbs$time_extra$Time$Extra$floorDate = F3($justinmimbs$time_extra$Time$Extra$floorDate_fn);
    var $justinmimbs$time_extra$Time$Extra$floor_fn = function (interval, zone, posix) {
        switch (interval) {
            case 15:
                return posix;
            case 14:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), $elm$time$Time$toSecond_fn(zone, posix), 0));
            case 13:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), 0, 0));
            case 12:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), 0, 0, 0));
            case 11:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(11, zone, posix);
            case 2:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(2, zone, posix);
            case 0:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(0, zone, posix);
            case 1:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(1, zone, posix);
            case 3:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(3, zone, posix);
            case 4:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(4, zone, posix);
            case 5:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(5, zone, posix);
            case 6:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(6, zone, posix);
            case 7:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(7, zone, posix);
            case 8:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(8, zone, posix);
            case 9:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(9, zone, posix);
            default:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(10, zone, posix);
        }
    }, $justinmimbs$time_extra$Time$Extra$floor = F3($justinmimbs$time_extra$Time$Extra$floor_fn);
    var $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn = function (zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix) / 86400000;
    }, $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2($justinmimbs$time_extra$Time$Extra$toFractionalDay_fn);
    var $justinmimbs$time_extra$Time$Extra$toMonths_fn = function (zone, posix) {
        var wholeMonths = (12 * ($elm$time$Time$toYear_fn(zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber($elm$time$Time$toMonth_fn(zone, posix)) - 1);
        var fractionalMonth = ($elm$time$Time$toDay_fn(zone, posix) + $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn(zone, posix)) / 100;
        return wholeMonths + fractionalMonth;
    }, $justinmimbs$time_extra$Time$Extra$toMonths = F2($justinmimbs$time_extra$Time$Extra$toMonths_fn);
    var $justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn = function (zone, posix) {
        return $justinmimbs$date$Date$toRataDie($justinmimbs$date$Date$fromPosix_fn(zone, posix)) + $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn(zone, posix);
    }, $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2($justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn);
    var $elm$core$Basics$truncate = _Basics_truncate;
    var $justinmimbs$time_extra$Time$Extra$diff_fn = function (interval, zone, posix1, posix2) {
        diff: while (true) {
            switch (interval) {
                case 15:
                    return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
                case 14:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 1000) | 0;
                case 13:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 60000) | 0;
                case 12:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 3600000) | 0;
                case 11:
                    return ($justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn(zone, posix2) - $justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn(zone, posix1)) | 0;
                case 2:
                    return ($justinmimbs$time_extra$Time$Extra$toMonths_fn(zone, posix2) - $justinmimbs$time_extra$Time$Extra$toMonths_fn(zone, posix1)) | 0;
                case 0:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(2, zone, posix1, posix2) / 12) | 0;
                case 1:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(2, zone, posix1, posix2) / 3) | 0;
                case 3:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(11, zone, posix1, posix2) / 7) | 0;
                default:
                    var weekday = interval;
                    var $temp$interval = 3, $temp$zone = zone, $temp$posix1 = $justinmimbs$time_extra$Time$Extra$floor_fn(weekday, zone, posix1), $temp$posix2 = $justinmimbs$time_extra$Time$Extra$floor_fn(weekday, zone, posix2);
                    interval = $temp$interval;
                    zone = $temp$zone;
                    posix1 = $temp$posix1;
                    posix2 = $temp$posix2;
                    continue diff;
            }
        }
    }, $justinmimbs$time_extra$Time$Extra$diff = F4($justinmimbs$time_extra$Time$Extra$diff_fn);
    var $elm_community$maybe_extra$Maybe$Extra$filter_fn = function (f, m) {
        if (!m.$) {
            var a = m.a;
            return f(a) ? m : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$filter = F2($elm_community$maybe_extra$Maybe$Extra$filter_fn);
    var $elm_community$string_extra$String$Extra$pluralize_fn = function (singular, plural, count) {
        return (count === 1) ? ("1 " + singular) : ($elm$core$String$fromInt(count) + (" " + plural));
    }, $elm_community$string_extra$String$Extra$pluralize = F3($elm_community$string_extra$String$Extra$pluralize_fn);
    var $author$project$Types$Utc$toString = function (_v0) {
        var utc = _v0;
        return utc;
    };
    var $elm$core$Basics$round = _Basics_round;
    var $elm$core$String$toFloat = _String_toFloat;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = $elm$parser$Parser$Advanced$andThen_fn(function (str) {
        if ($elm$core$String$length(str) <= 9) {
            var _v0 = $elm$core$String$toFloat("0." + str);
            if (!_v0.$) {
                var floatVal = _v0.a;
                return $elm$parser$Parser$succeed($elm$core$Basics$round(floatVal * 1000));
            }
            else {
                return $elm$parser$Parser$problem("Invalid float: \"" + (str + "\""));
            }
        }
        else {
            return $elm$parser$Parser$problem("Expected at most 9 digits, but got " + $elm$core$String$fromInt($elm$core$String$length(str)));
        }
    }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts_fn = function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
        return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
    }, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts_fn);
    var $elm$parser$Parser$Advanced$keeper_fn = function (parseFunc, parseArg) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$apL, parseFunc, parseArg);
    }, $elm$parser$Parser$Advanced$keeper = F2($elm$parser$Parser$Advanced$keeper_fn);
    var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
        var helper = function (str) {
            if (_Utils_eq($elm$core$String$length(str), quantity)) {
                var _v0 = $elm$core$String$toInt(str);
                if (!_v0.$) {
                    var intVal = _v0.a;
                    return $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Done, $elm$parser$Parser$succeed(intVal));
                }
                else {
                    return $elm$parser$Parser$problem("Invalid integer: \"" + (str + "\""));
                }
            }
            else {
                return $elm$parser$Parser$Advanced$map_fn(function (nextChar) {
                    return $elm$parser$Parser$Loop(_String_append_fn(str, nextChar));
                }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
            }
        };
        return $elm$parser$Parser$loop_fn("", helper);
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
        return $elm$parser$Parser$problem("Invalid day: " + $elm$core$String$fromInt(day));
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
        return (!_Basics_modBy_fn(4, year)) && ((!(!_Basics_modBy_fn(100, year))) || (!_Basics_modBy_fn(400, year)));
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
        var y = y1 - 1;
        return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
        var year = _v0.a;
        var month = _v0.b;
        var dayInMonth = _v0.c;
        if (dayInMonth < 0) {
            return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
        }
        else {
            var succeedWith = function (extraMs) {
                var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
                var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
                var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
                return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
            };
            switch (month) {
                case 1:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
                case 2:
                    return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
                case 3:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
                case 4:
                    return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
                case 5:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
                case 6:
                    return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
                case 7:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
                case 8:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
                case 9:
                    return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
                case 10:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
                case 11:
                    return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
                case 12:
                    return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
                default:
                    return $elm$parser$Parser$problem("Invalid month: \"" + ($elm$core$String$fromInt(month) + "\""));
            }
        }
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = $elm$parser$Parser$Advanced$andThen_fn($rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(F3(function (year, month, day) {
        return _Utils_Tuple3(year, month, day);
    })), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol("-")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
        $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
    ]))), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol("-")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
        $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
    ]))));
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
        var utcOffsetMinutesFromParts = F3(function (multiplier, hours, minutes) {
            return (multiplier * (hours * 60)) + minutes;
        });
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return 0;
            }, $elm$parser$Parser$symbol("Z")),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(utcOffsetMinutesFromParts), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                    return 1;
                }, $elm$parser$Parser$symbol("+")),
                $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                    return -1;
                }, $elm$parser$Parser$symbol("-"))
            ]))), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(":")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
                $elm$parser$Parser$succeed(0)
            ]))),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$end)
        ])));
    }();
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = $elm$parser$Parser$Advanced$andThen_fn(function (datePart) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)), $elm$parser$Parser$symbol("T")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(":")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
            ]))), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(":")), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
                $elm$parser$Parser$succeed(0)
            ]))), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(".")), $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
                $elm$parser$Parser$succeed(0)
            ]))), $elm$parser$Parser$Advanced$ignorer_fn($rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts_fn(datePart, 0, 0, 0, 0, 0)), $elm$parser$Parser$end)
        ]));
    }, $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
        return $elm$parser$Parser$run_fn($rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
    };
    var $author$project$Types$Utc$toPosix_a0 = $author$project$Types$Utc$toString, $author$project$Types$Utc$toPosix_a1 = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe), $author$project$Types$Utc$toPosix = A2($elm$core$Basics$composeR, $author$project$Types$Utc$toPosix_a0, $author$project$Types$Utc$toPosix_a1);
    var $elm$time$Time$utc = $elm$time$Time$Zone_fn(0, _List_Nil);
    var $author$project$Components$assignExpiredDatabaseBanner = function (cfg) {
        var maxNumDays = 10;
        var maybeDaysRemaining = $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$lt(0), $elm$core$Maybe$map_fn($elm$core$Basics$sub(maxNumDays), $elm$core$Maybe$map_fn(function (createdTime) {
            return $justinmimbs$time_extra$Time$Extra$diff_fn(11, $elm$time$Time$utc, createdTime, cfg.pf);
        }, $elm$core$Maybe$andThen_fn($author$project$Types$Utc$toPosix, $elm$core$Maybe$map_fn(function ($) {
            return $.lW;
        }, cfg.nf)))));
        var expirationMessage = function () {
            if (maybeDaysRemaining.$ === 1) {
                return "This database has expired. Please assign it to a team " + "to regain access.";
            }
            else {
                var daysRemaining = maybeDaysRemaining.a;
                return "This database will automatically expire in " + ($elm_community$string_extra$String$Extra$pluralize_fn("day", "days", daysRemaining) + (". Please assign it to a team " + "to keep it accessible."));
            }
        }();
        return $author$project$Components$assignDatabaseBanner({ i6: expirationMessage, j0: $elm$core$Maybe$Nothing, hr: cfg.hr, hJ: cfg.hJ, m: cfg.m });
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none = $rtfeldman$elm_css$Css$property_fn("border-style", "none");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_50 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "254", "252", "232", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_600 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "202", "138", "4", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Main$databaseAssignmentDialog_fn = function (model, dbId) {
        return $author$project$Dialog$CustomizedDialog({
            cT: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800)
            ]),
            bv: false,
            gB: $author$project$Components$assignExpiredDatabaseBanner({
                nf: $elm$core$Maybe$Nothing,
                hr: model.p,
                hJ: A2($author$project$Msg$DatabaseOwnerSubmitted, $author$project$Msg$SetDialog($elm$core$Maybe$Nothing), dbId),
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none]),
                pf: model.pf
            }),
            cj: $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_600,
            m: _List_Nil,
            eM: "Database expired",
            eO: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_50)
            ])
        });
    }, $author$project$Main$databaseAssignmentDialog = F2($author$project$Main$databaseAssignmentDialog_fn);
    var $elm$http$Http$emptyBody = _Http_emptyBody;
    var $author$project$Api$deleteDatabase_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(dbId)),
            f: "DELETE",
            g: "/api/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$deleteDatabase = F3($author$project$Api$deleteDatabase_fn);
    var $author$project$Pages$Queries$EditView = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Pages$Queries$Selected_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Pages$Queries$Selected = F2($author$project$Pages$Queries$Selected_fn);
    var $author$project$Pages$Queries$editViewMsg_fn = function (dbId, table) {
        return $author$project$Pages$Queries$EditView($author$project$Pages$Queries$Selected_fn(dbId, table));
    }, $author$project$Pages$Queries$editViewMsg = F2($author$project$Pages$Queries$editViewMsg_fn);
    var $author$project$Types$ErrorDisplay$toCmd_fn = function (errorDisplay, _v0, errors) {
        var onNotification = _v0.nX;
        var onDialog = _v0.nQ;
        return $elm$core$List$isEmpty(errors) ? $elm$core$Platform$Cmd$none : function () {
            switch (errorDisplay) {
                case 0:
                    return $elm$core$Basics$always($elm$core$Platform$Cmd$none);
                case 1:
                    return A2($elm$core$Basics$composeR, $elm$core$List$map(A2($elm$core$Basics$composeR, onNotification, $author$project$Util$msgCmd)), $elm$core$Platform$Cmd$batch);
                default:
                    return A2($elm$core$Basics$composeR, $elm$core$String$join("\n\n"), A2($elm$core$Basics$composeR, onDialog, $author$project$Util$msgCmd));
            }
        }()(errors);
    }, $author$project$Types$ErrorDisplay$toCmd = F3($author$project$Types$ErrorDisplay$toCmd_fn);
    var $author$project$Msg$errorDisplayCmd_fn = function (errorDisplay, title) {
        return A2($author$project$Types$ErrorDisplay$toCmd, errorDisplay, {
            nQ: A2($elm$core$Basics$composeR, $elm$core$Tuple$pair(title), A2($elm$core$Basics$composeR, $author$project$Dialog$ErrorDialog, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Msg$SetDialog))),
            nX: $author$project$Msg$AddTextNotification
        });
    }, $author$project$Msg$errorDisplayCmd = F2($author$project$Msg$errorDisplayCmd_fn);
    var $author$project$Config$exampleDbId = "avatar_the_last_airbender";
    var $elm$file$File$Select$file_fn = function (mimes, toMsg) {
        return $elm$core$Task$perform_fn(toMsg, _File_uploadOne(mimes));
    }, $elm$file$File$Select$file = F2($elm$file$File$Select$file_fn);
    var $author$project$Route$getDashboardsRoute = function (route) {
        if (route.$ === 24) {
            var r = route.b;
            return r;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Route$getDatabaseId = function (route) {
        switch (route.$) {
            case 16:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 17:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 18:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 19:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 20:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 21:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 22:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 23:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 24:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 25:
                var dbId = route.a;
                return $elm$core$Maybe$Just(dbId);
            case 26:
                return $elm$core$Maybe$Nothing;
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Nothing;
            case 4:
                return $elm$core$Maybe$Nothing;
            case 5:
                return $elm$core$Maybe$Nothing;
            case 6:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            case 9:
                return $elm$core$Maybe$Nothing;
            case 10:
                return $elm$core$Maybe$Nothing;
            case 11:
                return $elm$core$Maybe$Nothing;
            case 12:
                return $elm$core$Maybe$Nothing;
            case 13:
                return $elm$core$Maybe$Nothing;
            case 14:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$Database$Database = function (id) {
        return function (readonlyId) {
            return function (fileName) {
                return function (fileFormat) {
                    return function (size) {
                        return function (createdUtc) {
                            return function (lastModifiedUtc) {
                                return function (tables) {
                                    return function (location) {
                                        return function (settings) {
                                            return function (description) {
                                                return function (owner) {
                                                    return function (userVersion) {
                                                        return function (schemaVersion) {
                                                            return { lW: createdUtc, i6: description, mv: fileFormat, mw: fileName, bR: id, m0: lastModifiedUtc, hm: location, ob: owner, oo: readonlyId, oK: schemaVersion, kR: settings, oS: size, eH: tables, pz: userVersion };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Types$Utc$Utc = $elm$core$Basics$identity;
    var $elm_community$result_extra$Result$Extra$isOk = function (x) {
        if (!x.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$Utc$fromString_a0 = $elm$core$Maybe$Just, $author$project$Types$Utc$fromString_a1 = A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter(A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm_community$result_extra$Result$Extra$isOk)), $elm$core$Maybe$map($elm$core$Basics$identity)), $author$project$Types$Utc$fromString = A2($elm$core$Basics$composeR, $author$project$Types$Utc$fromString_a0, $author$project$Types$Utc$fromString_a1);
    var $author$project$Types$Utc$decode = _Json_andThen_fn(A2($elm$core$Basics$composeR, $author$project$Types$Utc$fromString, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail("Failed decoding UTC"), $elm$json$Json$Decode$succeed)), $elm$json$Json$Decode$string);
    var $author$project$Types$Database$Location_fn = function (name, _long, lat) {
        return { m1: lat, m9: _long, M: name };
    }, $author$project$Types$Database$Location = F3($author$project$Types$Database$Location_fn);
    var $elm$json$Json$Decode$float = _Json_decodeFloat;
    var $elm$json$Json$Decode$map3 = _Json_map3;
    var $author$project$Types$Database$decodeLocation = _Json_map3_fn($author$project$Types$Database$Location, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), _Json_decodeField_fn("long", $elm$json$Json$Decode$float), _Json_decodeField_fn("lat", $elm$json$Json$Decode$float));
    var $author$project$Types$DatabaseSettings$DatabaseSettings_fn = function (auditing, schemaLocked, viewsTab, environment, envVars, visibility) {
        return { iH: auditing, gQ: envVars, mk: environment, bj: schemaLocked, pD: viewsTab, pE: visibility };
    }, $author$project$Types$DatabaseSettings$DatabaseSettings = F6($author$project$Types$DatabaseSettings$DatabaseSettings_fn);
    var $author$project$Types$DatabaseSettings$Visibility$Private = 0;
    var $elm$json$Json$Decode$bool = _Json_decodeBool;
    var $author$project$Types$DatabaseSettings$Visibility$Public = 1;
    var $author$project$Types$DatabaseSettings$Visibility$fromString = function (string) {
        switch (string) {
            case "private":
                return $elm$core$Maybe$Just(0);
            case "public":
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$DatabaseSettings$Visibility$decode = _Json_andThen_fn(function (visibility) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Decode$fail("Failed decoding visibility: " + visibility), $elm$json$Json$Decode$succeed, $author$project$Types$DatabaseSettings$Visibility$fromString(visibility));
    }, $elm$json$Json$Decode$string);
    var $author$project$Types$EnvironmentVariable$EnvironmentVariable_fn = function (createdAt, name, value) {
        return { iZ: createdAt, M: name, pB: value };
    }, $author$project$Types$EnvironmentVariable$EnvironmentVariable = F3($author$project$Types$EnvironmentVariable$EnvironmentVariable_fn);
    var $author$project$Types$EnvironmentVariable$decode = _Json_map3_fn($author$project$Types$EnvironmentVariable$EnvironmentVariable, _Json_decodeField_fn("created_utc", $elm$json$Json$Decode$string), _Json_decodeField_fn("name", $elm$json$Json$Decode$string), _Json_decodeField_fn("value", $elm$json$Json$Decode$string));
    var $elm$json$Json$Decode$map6 = _Json_map6;
    var $elm$json$Json$Decode$oneOf = _Json_oneOf;
    var $elm$json$Json$Decode$maybe = function (decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($elm$core$Maybe$Just, decoder),
            $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
        ]));
    };
    var $elm_community$json_extra$Json$Decode$Extra$withDefault_fn = function (fallback, decoder) {
        return _Json_map1_fn($elm$core$Maybe$withDefault(fallback), $elm$json$Json$Decode$maybe(decoder));
    }, $elm_community$json_extra$Json$Decode$Extra$withDefault = F2($elm_community$json_extra$Json$Decode$Extra$withDefault_fn);
    var $author$project$Types$DatabaseSettings$decoder = _Json_map6_fn($author$project$Types$DatabaseSettings$DatabaseSettings, $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(false, _Json_decodeField_fn("auditing", $elm$json$Json$Decode$bool)), $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(false, _Json_decodeField_fn("schemaLocked", $elm$json$Json$Decode$bool)), $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(false, _Json_decodeField_fn("viewsTab", $elm$json$Json$Decode$bool)), $elm_community$json_extra$Json$Decode$Extra$withDefault_fn("", _Json_decodeField_fn("environment", $elm$json$Json$Decode$string)), $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(_List_Nil, _Json_decodeField_fn("envVars", $elm$json$Json$Decode$list($author$project$Types$EnvironmentVariable$decode))), $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(0, _Json_decodeField_fn("visibility", $author$project$Types$DatabaseSettings$Visibility$decode)));
    var $author$project$Types$Table$Table_fn = function (tableType, name, columns, numberOfRows, maxCellLimitReached, rowidColumnName, description) {
        return { iT: columns, i6: description, cs: maxCellLimitReached, M: name, ka: numberOfRows, kK: rowidColumnName, o8: tableType };
    }, $author$project$Types$Table$Table = F7($author$project$Types$Table$Table_fn);
    var $author$project$Types$Column$Column = function (header) {
        return function (dataType) {
            return function (dataTypeSqlite) {
                return function (validations) {
                    return function (cells) {
                        return function (isPrimaryKey) {
                            return function (isUnique) {
                                return function (isOmittable) {
                                    return function (isGenerated) {
                                        return function (inputElement) {
                                            return { y: cells, l$: dataType, l0: dataTypeSqlite, jx: header, mN: inputElement, cn: isGenerated, jN: isOmittable, co: isPrimaryKey, hf: isUnique, pA: validations };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Types$SqliteDataType$ANY = 24;
    var $author$project$Types$SqliteDataType$BLOB = 3;
    var $author$project$Types$SqliteDataType$BLOB_FILE = 4;
    var $author$project$Types$SqliteDataType$BOOLEAN = 5;
    var $author$project$Types$SqliteDataType$INTEGER = 0;
    var $author$project$Types$SqliteDataType$REAL = 1;
    var $author$project$Types$SqliteDataType$REAL_MONEY = 6;
    var $author$project$Types$SqliteDataType$TEXT = 2;
    var $author$project$Types$SqliteDataType$TEXT_BASE64 = 9;
    var $author$project$Types$SqliteDataType$TEXT_CODE = 20;
    var $author$project$Types$SqliteDataType$TEXT_COLOR = 16;
    var $author$project$Types$SqliteDataType$TEXT_COUNTRY_ALPHA2 = 22;
    var $author$project$Types$SqliteDataType$TEXT_COUNTRY_ALPHA3 = 23;
    var $author$project$Types$SqliteDataType$TEXT_DATE = 10;
    var $author$project$Types$SqliteDataType$TEXT_DATETIME = 12;
    var $author$project$Types$SqliteDataType$TEXT_DURATION = 13;
    var $author$project$Types$SqliteDataType$TEXT_DURATION_ISO = 14;
    var $author$project$Types$SqliteDataType$TEXT_EMAIL = 7;
    var $author$project$Types$SqliteDataType$TEXT_JSON = 17;
    var $author$project$Types$SqliteDataType$TEXT_JSON_ARRAY = 19;
    var $author$project$Types$SqliteDataType$TEXT_JSON_OBJECT = 18;
    var $author$project$Types$SqliteDataType$TEXT_LOCATION = 21;
    var $author$project$Types$SqliteDataType$TEXT_PHONE = 15;
    var $author$project$Types$SqliteDataType$TEXT_TIME = 11;
    var $author$project$Types$SqliteDataType$TEXT_URL = 8;
    var $author$project$Types$SqliteDataType$decode = _Json_andThen_fn(function (string) {
        switch (string) {
            case "INTEGER":
                return $elm$json$Json$Decode$succeed(0);
            case "REAL":
                return $elm$json$Json$Decode$succeed(1);
            case "TEXT":
                return $elm$json$Json$Decode$succeed(2);
            case "BLOB":
                return $elm$json$Json$Decode$succeed(3);
            case "BLOB_FILE":
                return $elm$json$Json$Decode$succeed(4);
            case "BOOLEAN":
                return $elm$json$Json$Decode$succeed(5);
            case "REAL_MONEY":
                return $elm$json$Json$Decode$succeed(6);
            case "TEXT_EMAIL":
                return $elm$json$Json$Decode$succeed(7);
            case "TEXT_URL":
                return $elm$json$Json$Decode$succeed(8);
            case "TEXT_BASE64":
                return $elm$json$Json$Decode$succeed(9);
            case "TEXT_DATE":
                return $elm$json$Json$Decode$succeed(10);
            case "TEXT_TIME":
                return $elm$json$Json$Decode$succeed(11);
            case "TEXT_DATETIME":
                return $elm$json$Json$Decode$succeed(12);
            case "TEXT_DURATION":
                return $elm$json$Json$Decode$succeed(13);
            case "TEXT_DURATION_ISO":
                return $elm$json$Json$Decode$succeed(14);
            case "TEXT_PHONE":
                return $elm$json$Json$Decode$succeed(15);
            case "TEXT_COLOR":
                return $elm$json$Json$Decode$succeed(16);
            case "TEXT_JSON":
                return $elm$json$Json$Decode$succeed(17);
            case "TEXT_JSON_OBJECT":
                return $elm$json$Json$Decode$succeed(18);
            case "TEXT_JSON_ARRAY":
                return $elm$json$Json$Decode$succeed(19);
            case "TEXT_CODE":
                return $elm$json$Json$Decode$succeed(20);
            case "TEXT_LOCATION":
                return $elm$json$Json$Decode$succeed(21);
            case "TEXT_COUNTRY_ALPHA2":
                return $elm$json$Json$Decode$succeed(22);
            case "TEXT_COUNTRY_ALPHA3":
                return $elm$json$Json$Decode$succeed(23);
            case "ANY":
                return $elm$json$Json$Decode$succeed(24);
            default:
                return $elm$json$Json$Decode$fail("Unknown SqliteDataType: " + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Types$Cell$NullCell = { $: 0 };
    var $author$project$Types$DataType$Nullable = 0;
    var $author$project$Types$Cell$StringCell = function (a) {
        return { $: 1, a: a };
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
        return { $: 0, a: a };
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
    var $cuducos$elm_format_number$FormatNumber$Locales$base = {
        fb: ".",
        bM: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
        hz: "\u2212",
        hA: "",
        kv: "",
        kw: "",
        f6: 0,
        b5: "",
        ll: "",
        lm: ""
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber_fn = function (original, integers, decimals, prefix, suffix) {
        return { bM: decimals, jH: integers, kp: original, fS: prefix, f5: suffix };
    }, $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber_fn);
    var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
    var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
    var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
    var $elm$core$String$concat = function (strings) {
        return $elm$core$String$join_fn("", strings);
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
        var onlyZeros = _String_all_fn(function (_char) {
            return _char === "0";
        }, $elm$core$String$concat($elm$core$List$append_fn(formatted.jH, $elm$core$List$singleton(formatted.bM))));
        return onlyZeros ? 1 : ((formatted.kp < 0) ? 2 : 0);
    };
    var $elm$core$String$filter = _String_filter;
    var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
    var $elm$core$String$repeatHelp_fn = function (n, chunk, result) {
        return (n <= 0) ? result : $elm$core$String$repeatHelp_fn(n >> 1, _Utils_ap(chunk, chunk), (!(n & 1)) ? result : _Utils_ap(result, chunk));
    }, $elm$core$String$repeatHelp = F3($elm$core$String$repeatHelp_fn);
    var $elm$core$String$repeat_fn = function (n, chunk) {
        return $elm$core$String$repeatHelp_fn(n, chunk, "");
    }, $elm$core$String$repeat = F2($elm$core$String$repeat_fn);
    var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit_fn = function (desiredLength, value) {
        var length = $elm$core$String$length(value);
        var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
        return _Utils_ap(value, $elm$core$String$repeat_fn(missing, "0"));
    }, $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit_fn);
    var $elm$core$String$dropRight_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(0, -n, string);
    }, $elm$core$String$dropRight = F2($elm$core$String$dropRight_fn);
    var $elm$core$String$right_fn = function (n, string) {
        return (n < 1) ? "" : _String_slice_fn(-n, $elm$core$String$length(string), string);
    }, $elm$core$String$right = F2($elm$core$String$right_fn);
    var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
        return ($elm$core$String$right_fn(1, decimals) !== "0") ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros($elm$core$String$dropRight_fn(1, decimals));
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals_fn = function (locale, digits) {
        var _v0 = locale.bM;
        switch (_v0.$) {
            case 1:
                return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
            case 2:
                return digits;
            default:
                var min = _v0.a;
                return $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit_fn(min, digits);
        }
    }, $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals_fn);
    var $elm$core$Tuple$second = function (_v0) {
        var y = _v0.b;
        return y;
    };
    var $elm$core$String$foldr = _String_foldr;
    var $elm$core$String$toList = function (string) {
        return _String_foldr_fn($elm$core$List$cons, _List_Nil, string);
    };
    var $myrho$elm_round$Round$addSign_fn = function (signed, str) {
        var isNotZero = $elm$core$List$any_fn(function (c) {
            return (c !== "0") && (c !== ".");
        }, $elm$core$String$toList(str));
        return _Utils_ap((signed && isNotZero) ? "-" : "", str);
    }, $myrho$elm_round$Round$addSign = F2($myrho$elm_round$Round$addSign_fn);
    var $elm$core$Char$fromCode = _Char_fromCode;
    var $myrho$elm_round$Round$increaseNum = function (_v0) {
        var head = _v0.a;
        var tail = _v0.b;
        if (head === "9") {
            var _v1 = $elm$core$String$uncons(tail);
            if (_v1.$ === 1) {
                return "01";
            }
            else {
                var headtail = _v1.a;
                return _String_cons_fn("0", $myrho$elm_round$Round$increaseNum(headtail));
            }
        }
        else {
            var c = $elm$core$Char$toCode(head);
            return ((c >= 48) && (c < 57)) ? _String_cons_fn($elm$core$Char$fromCode(c + 1), tail) : "0";
        }
    };
    var $elm$core$Basics$isInfinite = _Basics_isInfinite;
    var $elm$core$Basics$isNaN = _Basics_isNaN;
    var $elm$core$String$fromChar = function (_char) {
        return _String_cons_fn(_char, "");
    };
    var $elm$core$String$padRight_fn = function (n, _char, string) {
        return _Utils_ap(string, $elm$core$String$repeat_fn(n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)));
    }, $elm$core$String$padRight = F3($elm$core$String$padRight_fn);
    var $elm$core$String$reverse = _String_reverse;
    var $myrho$elm_round$Round$splitComma = function (str) {
        var _v0 = $elm$core$String$split_fn(".", str);
        if (_v0.b) {
            if (_v0.b.b) {
                var before = _v0.a;
                var _v1 = _v0.b;
                var after = _v1.a;
                return _Utils_Tuple2(before, after);
            }
            else {
                var before = _v0.a;
                return _Utils_Tuple2(before, "0");
            }
        }
        else {
            return _Utils_Tuple2("0", "0");
        }
    };
    var $elm$core$Tuple$mapFirst_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(func(x), y);
    }, $elm$core$Tuple$mapFirst = F2($elm$core$Tuple$mapFirst_fn);
    var $myrho$elm_round$Round$toDecimal = function (fl) {
        var _v0 = $elm$core$String$split_fn("e", $elm$core$String$fromFloat($elm$core$Basics$abs(fl)));
        if (_v0.b) {
            if (_v0.b.b) {
                var num = _v0.a;
                var _v1 = _v0.b;
                var exp = _v1.a;
                var e = $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(_String_startsWith_fn("+", exp) ? $elm$core$String$dropLeft_fn(1, exp) : exp));
                var _v2 = $myrho$elm_round$Round$splitComma(num);
                var before = _v2.a;
                var after = _v2.b;
                var total = _Utils_ap(before, after);
                var zeroed = (e < 0) ? $elm$core$Maybe$withDefault_fn("0", $elm$core$Maybe$map_fn(function (_v3) {
                    var a = _v3.a;
                    var b = _v3.b;
                    return a + ("." + b);
                }, $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$String$fromChar), $elm$core$String$uncons(_Utils_ap($elm$core$String$repeat_fn($elm$core$Basics$abs(e), "0"), total))))) : $elm$core$String$padRight_fn(e + 1, "0", total);
                return _Utils_ap((fl < 0) ? "-" : "", zeroed);
            }
            else {
                var num = _v0.a;
                return _Utils_ap((fl < 0) ? "-" : "", num);
            }
        }
        else {
            return "";
        }
    };
    var $myrho$elm_round$Round$roundFun_fn = function (functor, s, fl) {
        if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
            return $elm$core$String$fromFloat(fl);
        }
        else {
            var signed = fl < 0;
            var _v0 = $myrho$elm_round$Round$splitComma($myrho$elm_round$Round$toDecimal($elm$core$Basics$abs(fl)));
            var before = _v0.a;
            var after = _v0.b;
            var r = $elm$core$String$length(before) + s;
            var normalized = _Utils_ap($elm$core$String$repeat_fn((-r) + 1, "0"), $elm$core$String$padRight_fn(r, "0", _Utils_ap(before, after)));
            var totalLen = $elm$core$String$length(normalized);
            var roundDigitIndex = $elm$core$Basics$max_fn(1, r);
            var increase = A2(functor, signed, _String_slice_fn(roundDigitIndex, totalLen, normalized));
            var remains = _String_slice_fn(0, roundDigitIndex, normalized);
            var num = increase ? $elm$core$String$reverse($elm$core$Maybe$withDefault_fn("1", $elm$core$Maybe$map_fn($myrho$elm_round$Round$increaseNum, $elm$core$String$uncons($elm$core$String$reverse(remains))))) : remains;
            var numLen = $elm$core$String$length(num);
            var numZeroed = (num === "0") ? num : ((s <= 0) ? _Utils_ap(num, $elm$core$String$repeat_fn($elm$core$Basics$abs(s), "0")) : ((_Utils_cmp(s, $elm$core$String$length(after)) < 0) ? (_String_slice_fn(0, numLen - s, num) + ("." + _String_slice_fn(numLen - s, numLen, num))) : _Utils_ap(before + ".", $elm$core$String$padRight_fn(s, "0", after))));
            return $myrho$elm_round$Round$addSign_fn(signed, numZeroed);
        }
    }, $myrho$elm_round$Round$roundFun_fn_unwrapped = function (functor, s, fl) {
        if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
            return $elm$core$String$fromFloat(fl);
        }
        else {
            var signed = fl < 0;
            var _v0 = $myrho$elm_round$Round$splitComma($myrho$elm_round$Round$toDecimal($elm$core$Basics$abs(fl)));
            var before = _v0.a;
            var after = _v0.b;
            var r = $elm$core$String$length(before) + s;
            var normalized = _Utils_ap($elm$core$String$repeat_fn((-r) + 1, "0"), $elm$core$String$padRight_fn(r, "0", _Utils_ap(before, after)));
            var totalLen = $elm$core$String$length(normalized);
            var roundDigitIndex = $elm$core$Basics$max_fn(1, r);
            var increase = functor(signed, _String_slice_fn(roundDigitIndex, totalLen, normalized));
            var remains = _String_slice_fn(0, roundDigitIndex, normalized);
            var num = increase ? $elm$core$String$reverse($elm$core$Maybe$withDefault_fn("1", $elm$core$Maybe$map_fn($myrho$elm_round$Round$increaseNum, $elm$core$String$uncons($elm$core$String$reverse(remains))))) : remains;
            var numLen = $elm$core$String$length(num);
            var numZeroed = (num === "0") ? num : ((s <= 0) ? _Utils_ap(num, $elm$core$String$repeat_fn($elm$core$Basics$abs(s), "0")) : ((_Utils_cmp(s, $elm$core$String$length(after)) < 0) ? (_String_slice_fn(0, numLen - s, num) + ("." + _String_slice_fn(numLen - s, numLen, num))) : _Utils_ap(before + ".", $elm$core$String$padRight_fn(s, "0", after))));
            return $myrho$elm_round$Round$addSign_fn(signed, numZeroed);
        }
    }, $myrho$elm_round$Round$roundFun = F3($myrho$elm_round$Round$roundFun_fn);
    var $myrho$elm_round$Round$round_a0 = F2(function (signed, str) {
        var _v0 = $elm$core$String$uncons(str);
        if (_v0.$ === 1) {
            return false;
        }
        else {
            if ("5" === _v0.a.a) {
                if (_v0.a.b === "") {
                    var _v1 = _v0.a;
                    return !signed;
                }
                else {
                    var _v2 = _v0.a;
                    return true;
                }
            }
            else {
                var _v3 = _v0.a;
                var _int = _v3.a;
                return function (i) {
                    return ((i > 53) && signed) || ((i >= 53) && (!signed));
                }($elm$core$Char$toCode(_int));
            }
        }
    }), $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun($myrho$elm_round$Round$round_a0);
    var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts_fn = function (locale, value) {
        var toString = function () {
            var _v1 = locale.bM;
            switch (_v1.$) {
                case 1:
                    var max = _v1.a;
                    return $myrho$elm_round$Round$round(max);
                case 0:
                    return $elm$core$String$fromFloat;
                default:
                    var exact = _v1.a;
                    return $myrho$elm_round$Round$round(exact);
            }
        }();
        var asList = $elm$core$String$split_fn(".", toString(value));
        var decimals = function () {
            var _v0 = $elm$core$List$tail(asList);
            if (!_v0.$) {
                var values = _v0.a;
                return $elm$core$Maybe$withDefault_fn("", $elm$core$List$head(values));
            }
            else {
                return "";
            }
        }();
        var integers = $elm$core$Maybe$withDefault_fn("", $elm$core$List$head(asList));
        return _Utils_Tuple2(integers, decimals);
    }, $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts_fn);
    var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
        var thousand = ($elm$core$String$length(integers) > 3) ? $elm$core$String$right_fn(3, integers) : integers;
        var reversedSplitHundreds = function (value) {
            return ($elm$core$String$length(value) > 2) ? _List_Cons($elm$core$String$right_fn(2, value), reversedSplitHundreds($elm$core$String$dropRight_fn(2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray([value]));
        };
        return $elm$core$List$reverse(_List_Cons(thousand, reversedSplitHundreds($elm$core$String$dropRight_fn(3, integers))));
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
        var reversedSplitThousands = function (value) {
            return ($elm$core$String$length(value) > 3) ? _List_Cons($elm$core$String$right_fn(3, value), reversedSplitThousands($elm$core$String$dropRight_fn(3, value))) : _List_fromArray([value]);
        };
        return $elm$core$List$reverse(reversedSplitThousands(integers));
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers_fn = function (system, integers) {
        if (!system) {
            return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(_String_filter_fn($elm$core$Char$isDigit, integers));
        }
        else {
            return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(_String_filter_fn($elm$core$Char$isDigit, integers));
        }
    }, $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2($cuducos$elm_format_number$FormatNumber$Parser$splitIntegers_fn);
    var $cuducos$elm_format_number$FormatNumber$Parser$parse_fn = function (locale, original) {
        var parts = $cuducos$elm_format_number$FormatNumber$Parser$splitInParts_fn(locale, original);
        var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers_fn(locale.f6, _String_filter_fn($elm$core$Char$isDigit, parts.a));
        var decimals = $cuducos$elm_format_number$FormatNumber$Parser$getDecimals_fn(locale, parts.b);
        var partial = $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber_fn(original, integers, decimals, "", "");
        var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
        switch (_v0) {
            case 2:
                return _Utils_update(partial, { fS: locale.hz, f5: locale.hA });
            case 0:
                return _Utils_update(partial, { fS: locale.kv, f5: locale.kw });
            default:
                return _Utils_update(partial, { fS: locale.ll, f5: locale.lm });
        }
    }, $cuducos$elm_format_number$FormatNumber$Parser$parse = F2($cuducos$elm_format_number$FormatNumber$Parser$parse_fn);
    var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals_fn = function (locale, decimals) {
        return (decimals === "") ? "" : _Utils_ap(locale.fb, decimals);
    }, $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2($cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals_fn);
    var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy_fn = function (locale, formatted) {
        var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
        var integers = $elm$core$String$join_fn(locale.b5, formatted.jH);
        var decimals = stringfyDecimals(formatted.bM);
        return $elm$core$String$concat(_List_fromArray([formatted.fS, integers, decimals, formatted.f5]));
    }, $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2($cuducos$elm_format_number$FormatNumber$Stringfy$stringfy_fn);
    var $cuducos$elm_format_number$FormatNumber$format_fn = function (locale, number_) {
        return $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy_fn(locale, $cuducos$elm_format_number$FormatNumber$Parser$parse_fn(locale, number_));
    }, $cuducos$elm_format_number$FormatNumber$format = F2($cuducos$elm_format_number$FormatNumber$format_fn);
    var $elm$json$Json$Decode$int = _Json_decodeInt;
    var $elm$json$Json$Decode$null = _Json_decodeNull;
    var $author$project$Util$Bool$toString = function (bool) {
        return bool ? "true" : "false";
    };
    var $elm$json$Json$Decode$value = _Json_decodeValue;
    var $author$project$Types$Cell$decoder = function (dataType) {
        var decodeNullability = F2(function (nullability, decoder_) {
            if (!nullability) {
                return $elm$json$Json$Decode$oneOf(_List_fromArray([
                    $elm$json$Json$Decode$null($author$project$Types$Cell$NullCell),
                    _Json_map1_fn($author$project$Types$Cell$StringCell, decoder_)
                ]));
            }
            else {
                return _Json_map1_fn($author$project$Types$Cell$StringCell, decoder_);
            }
        });
        if (!dataType.$) {
            switch (dataType.a.$) {
                case 0:
                    var nullability = dataType.a.a;
                    return A2(decodeNullability, nullability, _Json_map1_fn($elm$core$String$fromInt, $elm$json$Json$Decode$int));
                case 1:
                    var nullability = dataType.a.a;
                    var stringFromFloatUntruncated = $cuducos$elm_format_number$FormatNumber$format($cuducos$elm_format_number$FormatNumber$Locales$base);
                    return A2(decodeNullability, nullability, _Json_map1_fn(stringFromFloatUntruncated, $elm$json$Json$Decode$float));
                case 2:
                    var nullability = dataType.a.a;
                    return A2(decodeNullability, nullability, $elm$json$Json$Decode$string);
                case 3:
                    var nullability = dataType.a.a;
                    return A2(decodeNullability, nullability, _Json_map1_fn($author$project$Util$Bool$toString, $elm$json$Json$Decode$bool));
                default:
                    var _v1 = dataType.a;
                    var nullability = _v1.a;
                    return $elm$json$Json$Decode$oneOf($elm$core$List$map_fn(decodeNullability(nullability), _List_fromArray([
                        _Json_map1_fn($elm$core$String$fromInt, $elm$json$Json$Decode$int),
                        _Json_map1_fn($elm$core$String$fromFloat, $elm$json$Json$Decode$float),
                        $elm$json$Json$Decode$string,
                        _Json_map1_fn($author$project$Util$Bool$toString, $elm$json$Json$Decode$bool)
                    ])));
            }
        }
        else {
            return $elm$json$Json$Decode$oneOf($elm$core$List$map_fn(decodeNullability(0), _List_fromArray([
                _Json_map1_fn($elm$core$String$fromInt, $elm$json$Json$Decode$int),
                _Json_map1_fn($elm$core$String$fromFloat, $elm$json$Json$Decode$float),
                $elm$json$Json$Decode$string,
                _Json_map1_fn($author$project$Util$Bool$toString, $elm$json$Json$Decode$bool),
                _Json_map1_fn($elm$json$Json$Encode$encode(2), $elm$json$Json$Decode$value)
            ])));
        }
    };
    var $author$project$Types$DataType$BooleanType = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Types$DataType$CustomType_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Types$DataType$CustomType = F2($author$project$Types$DataType$CustomType_fn);
    var $author$project$Types$DataType$FloatType = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Types$DataType$IntType = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Types$DataType$NonNullable = 1;
    var $author$project$Types$DataType$StringType = function (a) {
        return { $: 2, a: a };
    };
    var $elm$json$Json$Decode$nullable = function (decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            _Json_map1_fn($elm$core$Maybe$Just, decoder)
        ]));
    };
    var $author$project$Types$DataType$decoder = function (isNonNullable) {
        var nullability = isNonNullable ? 1 : 0;
        var toDataType = function (dataType) {
            if (!dataType.$) {
                switch (dataType.a) {
                    case "String":
                        return $elm$json$Json$Decode$succeed($author$project$Types$DataType$StringType(nullability));
                    case "Int":
                        return $elm$json$Json$Decode$succeed($author$project$Types$DataType$IntType(nullability));
                    case "Float":
                        return $elm$json$Json$Decode$succeed($author$project$Types$DataType$FloatType(nullability));
                    case "Boolean":
                        return $elm$json$Json$Decode$succeed($author$project$Types$DataType$BooleanType(nullability));
                    default:
                        var name = dataType.a;
                        return $elm$json$Json$Decode$succeed($author$project$Types$DataType$CustomType_fn(nullability, name));
                }
            }
            else {
                return $elm$json$Json$Decode$succeed($author$project$Types$DataType$CustomType_fn(nullability, "Any"));
            }
        };
        return _Json_andThen_fn(toDataType, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
    };
    var $author$project$Types$InputElement$InputBoolean = { $: 3 };
    var $author$project$Types$InputElement$InputCode = { $: 17 };
    var $author$project$Types$InputElement$InputColor = { $: 13 };
    var $author$project$Types$InputElement$InputCountryAlpha2 = { $: 19 };
    var $author$project$Types$InputElement$InputCountryAlpha3 = { $: 20 };
    var $author$project$Types$InputElement$InputDate = { $: 5 };
    var $author$project$Types$InputElement$InputDateTime = { $: 7 };
    var $author$project$Types$InputElement$InputDuration = { $: 8 };
    var $author$project$Types$InputElement$InputDurationIso = { $: 9 };
    var $author$project$Types$InputElement$InputEmail = { $: 11 };
    var $author$project$Types$InputElement$InputFile = { $: 21 };
    var $author$project$Types$InputElement$InputInteger = { $: 0 };
    var $author$project$Types$InputElement$InputJson = { $: 14 };
    var $author$project$Types$InputElement$InputJsonArray = { $: 16 };
    var $author$project$Types$InputElement$InputJsonObject = { $: 15 };
    var $author$project$Types$InputElement$InputLocation = { $: 18 };
    var $author$project$Types$InputElement$InputNumber = { $: 1 };
    var $author$project$Types$InputElement$InputPhone = { $: 12 };
    var $author$project$Types$InputElement$InputSingleSelect = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Types$InputElement$InputText = { $: 2 };
    var $author$project$Types$InputElement$InputTime = { $: 6 };
    var $author$project$Types$InputElement$InputUrl = { $: 10 };
    var $author$project$Types$InputElement$list = _List_fromArray([
        $author$project$Types$InputElement$InputInteger,
        $author$project$Types$InputElement$InputNumber,
        $author$project$Types$InputElement$InputText,
        $author$project$Types$InputElement$InputBoolean,
        $author$project$Types$InputElement$InputSingleSelect(_List_Nil),
        $author$project$Types$InputElement$InputDate,
        $author$project$Types$InputElement$InputTime,
        $author$project$Types$InputElement$InputDateTime,
        $author$project$Types$InputElement$InputDuration,
        $author$project$Types$InputElement$InputDurationIso,
        $author$project$Types$InputElement$InputUrl,
        $author$project$Types$InputElement$InputEmail,
        $author$project$Types$InputElement$InputPhone,
        $author$project$Types$InputElement$InputColor,
        $author$project$Types$InputElement$InputJson,
        $author$project$Types$InputElement$InputJsonObject,
        $author$project$Types$InputElement$InputJsonArray,
        $author$project$Types$InputElement$InputCode,
        $author$project$Types$InputElement$InputLocation,
        $author$project$Types$InputElement$InputCountryAlpha2,
        $author$project$Types$InputElement$InputCountryAlpha3,
        $author$project$Types$InputElement$InputFile
    ]);
    var $author$project$Types$InputElement$toJsonString = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return "InputInteger";
            case 1:
                return "InputNumber";
            case 2:
                return "InputText";
            case 3:
                return "InputBoolean";
            case 4:
                return "InputSingleSelect";
            case 5:
                return "InputDate";
            case 6:
                return "InputTime";
            case 7:
                return "InputDateTime";
            case 8:
                return "InputDuration";
            case 9:
                return "InputDurationIso";
            case 10:
                return "InputUrl";
            case 11:
                return "InputEmail";
            case 12:
                return "InputPhone";
            case 13:
                return "InputColor";
            case 14:
                return "InputJson";
            case 15:
                return "InputJsonObject";
            case 16:
                return "InputJsonArray";
            case 17:
                return "InputCode";
            case 18:
                return "InputLocation";
            case 19:
                return "InputCountryAlpha2";
            case 20:
                return "InputCountryAlpha3";
            default:
                return "InputFile";
        }
    };
    var $author$project$Types$InputElement$fromJsonString = function (name) {
        return $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $author$project$Types$InputElement$toJsonString, $elm$core$Basics$eq(name)), $author$project$Types$InputElement$list);
    };
    var $author$project$Types$InputElement$setOptions_fn = function (inputElement, options) {
        switch (inputElement.$) {
            case 0:
                return inputElement;
            case 1:
                return inputElement;
            case 2:
                return inputElement;
            case 3:
                return inputElement;
            case 4:
                return $author$project$Types$InputElement$InputSingleSelect(options);
            case 5:
                return inputElement;
            case 6:
                return inputElement;
            case 7:
                return inputElement;
            case 8:
                return inputElement;
            case 9:
                return inputElement;
            case 10:
                return inputElement;
            case 11:
                return inputElement;
            case 12:
                return inputElement;
            case 13:
                return inputElement;
            case 14:
                return inputElement;
            case 15:
                return inputElement;
            case 16:
                return inputElement;
            case 17:
                return inputElement;
            case 18:
                return inputElement;
            case 19:
                return inputElement;
            case 20:
                return inputElement;
            default:
                return inputElement;
        }
    }, $author$project$Types$InputElement$setOptions = F2($author$project$Types$InputElement$setOptions_fn);
    var $author$project$Types$Cell$toMaybeString = function (cell) {
        if (!cell.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var string = cell.a;
            return $elm$core$Maybe$Just(string);
        }
    };
    var $author$project$Types$Validations$toOptions = function (validations) {
        var options = validations;
        return $elm$core$List$filterMap_fn($author$project$Types$Cell$toMaybeString, options);
    };
    var $author$project$Types$InputElement$decoder = function (validations) {
        var toInputElement = function (inputElement) {
            var addInputSingleSelectOptions = function (element) {
                if (element.$ === 4) {
                    return $author$project$Types$InputElement$setOptions_fn(element, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, $author$project$Types$Validations$toOptions, validations));
                }
                else {
                    return element;
                }
            };
            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Decode$fail("failed to parse input element: " + inputElement), $elm$json$Json$Decode$succeed, $elm$core$Maybe$map_fn(addInputSingleSelectOptions, $author$project$Types$InputElement$fromJsonString(inputElement)));
        };
        return _Json_andThen_fn(toInputElement, $elm$json$Json$Decode$string);
    };
    var $author$project$Types$Validations$OneOf = $elm$core$Basics$identity;
    var $author$project$Types$Validations$decoder = function (dataType) {
        return _Json_andThen_fn(function (type_) {
            if (type_ === "OneOf") {
                return _Json_map1_fn($elm$core$Basics$identity, _Json_decodeField_fn("values", $elm$json$Json$Decode$list($author$project$Types$Cell$decoder($elm$core$Maybe$Just(dataType)))));
            }
            else {
                return $elm$json$Json$Decode$fail("Failed to decode Validations: " + type_);
            }
        }, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    };
    var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
    var $author$project$Types$Column$decoder = function () {
        var decodeCells = function (dataType) {
            return _Json_map1_fn($krisajenkins$remotedata$RemoteData$succeed, $elm$json$Json$Decode$list($author$project$Types$Cell$decoder(dataType)));
        };
        var buildColumn = F2(function (dataType, validations) {
            return _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("inputElement", $author$project$Types$InputElement$decoder(validations)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(false, _Json_decodeField_fn("isGenerated", $elm$json$Json$Decode$bool)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm_community$json_extra$Json$Decode$Extra$withDefault_fn(false, _Json_decodeField_fn("isOmittable", $elm$json$Json$Decode$bool)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("isUnique", $elm$json$Json$Decode$bool), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("isPrimaryKey", $elm$json$Json$Decode$bool), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("items", $elm$json$Json$Decode$oneOf(_List_fromArray([
                $elm$json$Json$Decode$null($krisajenkins$remotedata$RemoteData$NotAsked),
                decodeCells($elm$core$Maybe$Just(dataType)),
                decodeCells($elm$core$Maybe$Nothing)
            ]))), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm$json$Json$Decode$succeed(validations), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("sqliteDataType", $author$project$Types$SqliteDataType$decode), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm$json$Json$Decode$succeed(dataType), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Types$Column$Column)))))))))));
        });
        return _Json_andThen_fn(function (isNonNull) {
            return _Json_andThen_fn(function (dataType) {
                return _Json_andThen_fn(buildColumn(dataType), _Json_decodeField_fn("validations", $elm$json$Json$Decode$maybe($author$project$Types$Validations$decoder(dataType))));
            }, _Json_decodeField_fn("gqlDataType", $author$project$Types$DataType$decoder(isNonNull)));
        }, _Json_decodeField_fn("isNonNull", $elm$json$Json$Decode$bool));
    }();
    var $author$project$Types$TableType$Table = 0;
    var $author$project$Types$TableType$View = 1;
    var $author$project$Types$TableType$decoder = _Json_andThen_fn(function (tableType) {
        switch (tableType) {
            case "Table":
                return $elm$json$Json$Decode$succeed(0);
            case "View":
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail("Failed decoding TableType");
        }
    }, $elm$json$Json$Decode$string);
    var $elm$json$Json$Decode$map7 = _Json_map7;
    var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
        return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
    };
    var $author$project$Types$Table$decoder = _Json_map7_fn($author$project$Types$Table$Table, _Json_decodeField_fn("tableType", $author$project$Types$TableType$decoder), _Json_decodeField_fn("name", $elm$json$Json$Decode$string), $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("columns", $elm$json$Json$Decode$list($author$project$Types$Column$decoder)),
        $elm$json$Json$Decode$succeed(_List_Nil)
    ])), _Json_decodeField_fn("numberOfRows", $elm$json$Json$Decode$int), _Json_decodeField_fn("maxCellLimitReached", $elm$json$Json$Decode$bool), _Json_decodeField_fn("rowidColumnName", $elm$json$Json$Decode$string), _Json_decodeField_fn("description", _Json_map1_fn($elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonEmpty), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
    var $author$project$Types$Database$decode = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("schemaVersion", $elm$json$Json$Decode$int), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("userVersion", $elm$json$Json$Decode$int), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("owner", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("description", _Json_map1_fn($elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonEmpty), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $author$project$Types$DatabaseSettings$decoder, _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("location", $author$project$Types$Database$decodeLocation), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("tables", $elm$json$Json$Decode$list($author$project$Types$Table$decoder)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("lastModifiedUtc", $author$project$Types$Utc$decode), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("createdUtc", $author$project$Types$Utc$decode), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("size", $elm$json$Json$Decode$int), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("fileFormat", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("fileName", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("readonlyId", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $author$project$Types$Database$decodeId, $elm$json$Json$Decode$succeed($author$project$Types$Database$Database)))))))))))))));
    var $author$project$Api$getDatabaseSchema_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$Database$decode),
            f: "GET",
            g: "/api/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$getDatabaseSchema = F3($author$project$Api$getDatabaseSchema_fn);
    var $author$project$Types$Team$Team_fn = function (name, numberOfDatabases, databases, billing) {
        return { lF: billing, l1: databases, M: name, nG: numberOfDatabases };
    }, $author$project$Types$Team$Team = F4($author$project$Types$Team$Team_fn);
    var $author$project$Types$Billing$decodeBillingDetails = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("email_address", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("subscription_id", $elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Types$Billing$BillingDetails)));
    var $author$project$Types$Billing$decode = _Json_andThen_fn(function (plan) {
        if (plan === "pro") {
            return _Json_map1_fn($author$project$Types$Billing$Pro, $author$project$Types$Billing$decodeBillingDetails);
        }
        else {
            return $elm$json$Json$Decode$fail("Invalid plan");
        }
    }, _Json_decodeField_fn("plan", $elm$json$Json$Decode$string));
    var $author$project$Types$Team$TeamDatabase$TeamDatabase_fn = function (environment, id, name, ownershipUtc, visibility) {
        return { mk: environment, bR: id, M: name, hM: ownershipUtc, pE: visibility };
    }, $author$project$Types$Team$TeamDatabase$TeamDatabase = F5($author$project$Types$Team$TeamDatabase$TeamDatabase_fn);
    var $author$project$Types$Team$TeamDatabase$decode = A3($elm$core$Basics$apR, _Json_decodeField_fn("visibility", $author$project$Types$DatabaseSettings$Visibility$decode), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("ownership_utc", $author$project$Types$Utc$decode), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("id", _Json_map1_fn($author$project$Types$Database$wrapId, $elm$json$Json$Decode$string)), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("environment", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)), $elm_community$json_extra$Json$Decode$Extra$andMap, $elm$json$Json$Decode$succeed($author$project$Types$Team$TeamDatabase$TeamDatabase))))));
    var $author$project$Types$Team$decode = function () {
        var decodeDatabases = _Json_decodeField_fn("databases", $elm$json$Json$Decode$list($author$project$Types$Team$TeamDatabase$decode));
        return A3($elm$core$Basics$apR, $elm$json$Json$Decode$maybe(_Json_decodeField_fn("billing", $author$project$Types$Billing$decode)), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_map1_fn(A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$succeed), $elm$json$Json$Decode$maybe(decodeDatabases)), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_decodeField_fn("numberOfDatabases", $elm$json$Json$Decode$int),
            _Json_map1_fn($elm$core$List$length, decodeDatabases)
        ])), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), $elm_community$json_extra$Json$Decode$Extra$andMap, $elm$json$Json$Decode$succeed($author$project$Types$Team$Team)))));
    }();
    var $author$project$Api$getTeam_fn = function (msg, maybeToken, teamName) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$Team$decode),
            f: "GET",
            g: "/api/teams/" + $elm$url$Url$percentEncode(teamName)
        });
    }, $author$project$Api$getTeam = F3($author$project$Api$getTeam_fn);
    var $author$project$Main$handlePageChange = function (model) {
        return _Utils_eq($elm$core$Maybe$Just(model.b.eu), model.b.kx) ? model : _Utils_update(model, { mc: $elm$core$Maybe$Nothing, bF: _List_Nil });
    };
    var $author$project$Types$Database$hasId_fn = function (id, database) {
        return _Utils_eq($elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, database), $elm$core$Maybe$Just(id));
    }, $author$project$Types$Database$hasId = F2($author$project$Types$Database$hasId_fn);
    var $author$project$Util$httpProgressToPercent = function (progress) {
        if (!progress.$) {
            var sent = progress.a.oO;
            var size = progress.a.oS;
            return $elm$core$Maybe$Just($elm$core$Basics$floor(100 / (size / sent)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$Team$increaseDatabaseCount = function (team) {
        return _Utils_update(team, { nG: team.nG + 1 });
    };
    var $author$project$Types$Upload$init_fn = function (id, type_) {
        return { bR: id, fT: $elm$core$Maybe$Nothing, gh: type_ };
    }, $author$project$Types$Upload$init = F2($author$project$Types$Upload$init_fn);
    var $author$project$Route$isAppRoute = function (route) {
        if (route.$ === 22) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isAppUrl = function (url) {
        return _Utils_eq($elm$core$Maybe$map_fn($author$project$Route$isAppRoute, $author$project$Route$fromUrl(url)), $elm$core$Maybe$Just(true));
    };
    var $author$project$Route$isDuplicateRoute = function (route) {
        switch (route.$) {
            case 12:
                return true;
            case 13:
                return true;
            default:
                return false;
        }
    };
    var $author$project$Route$isDuplicateUrl = function (url) {
        return _Utils_eq($elm$core$Maybe$map_fn($author$project$Route$isDuplicateRoute, $author$project$Route$fromUrl(url)), $elm$core$Maybe$Just(true));
    };
    var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
        if (data.$ === 2) {
            var x = data.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isPlaygroundRoute = function (route) {
        if (route.$ === 10) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isPlaygroundUrl = function (url) {
        return _Utils_eq($elm$core$Maybe$map_fn($author$project$Route$isPlaygroundRoute, $author$project$Route$fromUrl(url)), $elm$core$Maybe$Just(true));
    };
    var $author$project$Types$Billing$isPro = function (billing) {
        if (billing.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$Team$isPro = function (team) {
        return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn($author$project$Types$Billing$isPro, team.lF));
    };
    var $author$project$Route$isRegenerateDbIdRoute = function (route) {
        if (route.$ === 14) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isRegenerateReadonlyIdRoute = function (route) {
        if (route.$ === 15) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$UploadType$isReplacement = function (uploadType) {
        if (uploadType.$ === 3) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$browser$Browser$Navigation$load = _Browser_load;
    var $author$project$Api$logout_fn = function (msg, maybeToken) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object($elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$SessionToken$toString, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, $elm$core$Tuple$pair("sessionToken"))), maybeToken)))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "POST",
            g: "/api/logout"
        });
    }, $author$project$Api$logout = F2($author$project$Api$logout_fn);
    var $elm$core$Platform$Cmd$map = _Platform_map;
    var $author$project$Types$Team$mapDatabases_fn = function (f, team) {
        return _Utils_update(team, {
            l1: $krisajenkins$remotedata$RemoteData$map_fn(f, team.l1)
        });
    }, $author$project$Types$Team$mapDatabases = F2($author$project$Types$Team$mapDatabases_fn);
    var $author$project$Model$mapOverlay_fn = function (f, model) {
        return _Utils_update(model, {
            a$: f(model.a$)
        });
    }, $author$project$Model$mapOverlay = F2($author$project$Model$mapOverlay_fn);
    var $elm_community$list_extra$List$Extra$updateIf_fn = function (predicate, update, list) {
        return $elm$core$List$map_fn(function (item) {
            return predicate(item) ? update(item) : item;
        }, list);
    }, $elm_community$list_extra$List$Extra$updateIf = F3($elm_community$list_extra$List$Extra$updateIf_fn);
    var $author$project$Types$User$mapTeam_fn = function (teamName, f, user) {
        return _Utils_update(user, {
            pc: $elm_community$list_extra$List$Extra$updateIf_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.M;
            }, $elm$core$Basics$eq(teamName)), f, user.pc)
        });
    }, $author$project$Types$User$mapTeam = F3($author$project$Types$User$mapTeam_fn);
    var $author$project$Types$User$mapTeams_fn = function (f, user) {
        return _Utils_update(user, {
            pc: $elm$core$List$map_fn(f, user.pc)
        });
    }, $author$project$Types$User$mapTeams = F2($author$project$Types$User$mapTeams_fn);
    var $author$project$Types$Column$equals_fn = function (a, b) {
        return _Utils_eq(_Utils_update(a, { y: $krisajenkins$remotedata$RemoteData$NotAsked }), _Utils_update(b, { y: $krisajenkins$remotedata$RemoteData$NotAsked }));
    }, $author$project$Types$Column$equals = F2($author$project$Types$Column$equals_fn);
    var $author$project$Types$Table$equals_fn = function (a, b) {
        return _Utils_eq(_Utils_update(a, { iT: _List_Nil }), _Utils_update(b, { iT: _List_Nil })) && $elm$core$List$all_fn($elm$core$Basics$eq(true), _List_map2_fn($author$project$Types$Column$equals, a.iT, b.iT));
    }, $author$project$Types$Table$equals = F2($author$project$Types$Table$equals_fn);
    var $author$project$Types$Database$mapTables_fn = function (mapper, database) {
        return _Utils_update(database, {
            eH: $elm$core$List$map_fn(mapper, database.eH)
        });
    }, $author$project$Types$Database$mapTables = F2($author$project$Types$Database$mapTables_fn);
    var $author$project$Types$Database$merge = function (old) {
        return $author$project$Types$Database$mapTables(function (newTable) {
            return $elm$core$Maybe$withDefault_fn(newTable, $elm_community$list_extra$List$Extra$find_fn($author$project$Types$Table$equals(newTable), old.eH));
        });
    };
    var $elm_community$maybe_extra$Maybe$Extra$orElse_fn = function (ma, mb) {
        if (mb.$ === 1) {
            return ma;
        }
        else {
            return mb;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$orElse = F2($elm_community$maybe_extra$Maybe$Extra$orElse_fn);
    var $author$project$Overlay$FinalMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Overlay$NoOp = { $: 0 };
    var $author$project$Overlay$OverlayFocused = { $: 2 };
    var $author$project$Overlay$SetOverlay_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Overlay$SetOverlay = F2($author$project$Overlay$SetOverlay_fn);
    var $elm$core$Task$onError = _Scheduler_onError;
    var $elm$core$Task$attempt_fn = function (resultToMessage, task) {
        return $elm$core$Task$command(_Scheduler_onError_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), _Scheduler_andThen_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
    }, $elm$core$Task$attempt = F2($elm$core$Task$attempt_fn);
    var $rtfeldman$elm_css$Css$prop5_fn = function (key, argA, argB, argC, argD, argE) {
        return $rtfeldman$elm_css$Css$property_fn(key, argA.pB + (" " + (argB.pB + (" " + (argC.pB + (" " + (argD.pB + (" " + argE.pB))))))));
    }, $rtfeldman$elm_css$Css$prop5 = F6($rtfeldman$elm_css$Css$prop5_fn);
    var $rtfeldman$elm_css$Css$boxShadow5_a0 = "box-shadow", $rtfeldman$elm_css$Css$boxShadow5 = $rtfeldman$elm_css$Css$prop5($rtfeldman$elm_css$Css$boxShadow5_a0);
    var $elm$browser$Browser$Dom$focus_a0 = "focus", $elm$browser$Browser$Dom$focus = _Browser_call($elm$browser$Browser$Dom$focus_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_normal = $rtfeldman$elm_css$Css$property_fn("font-weight", "400");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_1 = $rtfeldman$elm_css$Css$property_fn("row-gap", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "249", "250", "251", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "75", "85", "99", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start = $rtfeldman$elm_css$Css$property_fn("align-items", "flex-start");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center = $rtfeldman$elm_css$Css$property_fn("justify-content", "center");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("outline", "2px solid transparent"),
        $rtfeldman$elm_css$Css$property_fn("outline-offset", "2px")
    ]));
    var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
    var $rtfeldman$elm_css$Css$PxUnits = 0;
    var $rtfeldman$elm_css$Css$Internal$lengthConverter_fn = function (units, unitLabel, numericValue) {
        return {
            iw: 0,
            iO: 0,
            c1: 0,
            aG: 0,
            hl: 0,
            c8: 0,
            bS: 0,
            c9: 0,
            da: 0,
            cp: 0,
            cq: 0,
            bB: 0,
            db: 0,
            bX: numericValue,
            dp: 0,
            ds: unitLabel,
            eS: units,
            pB: _Utils_ap($elm$core$String$fromFloat(numericValue), unitLabel)
        };
    }, $rtfeldman$elm_css$Css$Internal$lengthConverter = F3($rtfeldman$elm_css$Css$Internal$lengthConverter_fn);
    var $rtfeldman$elm_css$Css$px_a0 = 0, $rtfeldman$elm_css$Css$px_a1 = "px", $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1);
    var $rtfeldman$elm_css$Css$rgba_fn = function (r, g, b, alpha) {
        return {
            dF: alpha,
            dQ: b,
            bw: 0,
            d8: g,
            er: r,
            pB: $rtfeldman$elm_css$Css$cssFunction_fn("rgba", _Utils_ap($elm$core$List$map_fn($elm$core$String$fromInt, _List_fromArray([r, g, b])), _List_fromArray([
                $elm$core$String$fromFloat(alpha)
            ])))
        };
    }, $rtfeldman$elm_css$Css$rgba = F4($rtfeldman$elm_css$Css$rgba_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("tabIndex", $elm$core$String$fromInt(n));
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$target_a0 = "target", $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$target_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "0.875rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_start = $rtfeldman$elm_css$Css$property_fn("text-align", "start");
    var $rtfeldman$elm_css$Css$animationDuration = function (arg) {
        return $rtfeldman$elm_css$Css$prop1_fn("animation-duration", arg);
    };
    var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
        return { $: 5, a: a };
    };
    var $rtfeldman$elm_css$Css$animationName = function (arg) {
        return ((arg.pB === "none") || ((arg.pB === "inherit") || ((arg.pB === "unset") || (arg.pB === "initial")))) ? $rtfeldman$elm_css$Css$prop1_fn("animation-name", arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.pB);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2 = $rtfeldman$elm_css$Css$property_fn("border-bottom-width", "2px");
    var $rtfeldman$elm_css$Html$Styled$Attributes$class_a0 = "className", $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$class_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents = $rtfeldman$elm_css$Css$property_fn("display", "contents");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1 = $rtfeldman$elm_css$Css$property_fn("flex", "1 1 0%");
    var $rtfeldman$elm_css$Css$focus = $rtfeldman$elm_css$Css$pseudoClass("focus");
    var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
        var percentage = _v0.a;
        var properties = _v0.b;
        var propertiesStr = $rtfeldman$elm_css$Css$String$mapJoin_fn(function (_v1) {
            var prop = _v1;
            return prop + ";";
        }, "", properties);
        var percentageStr = $elm$core$String$fromInt(percentage) + "%";
        return percentageStr + ("{" + (propertiesStr + "}"));
    };
    var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
        return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Internal$printKeyframeSelector, "", tuples);
    };
    var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
        return $elm$core$List$isEmpty(tuples) ? { hi: 0, hD: 0, pB: "none" } : {
            hi: 0,
            hD: 0,
            pB: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
        };
    };
    var $rtfeldman$elm_css$Css$maxWidth_a0 = "max-width", $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$maxWidth_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden = $rtfeldman$elm_css$Css$property_fn("overflow", "hidden");
    var $rtfeldman$elm_css$Css$PercentageUnits = 0;
    var $rtfeldman$elm_css$Css$pct_a0 = 0, $rtfeldman$elm_css$Css$pct_a1 = "%", $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1);
    var $author$project$Util$preventDefaultOn = function (event) {
        return A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Tuple$pair, true), A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn(event)));
    };
    var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Animations$property_fn = function (key, value) {
        return key + (":" + value);
    }, $rtfeldman$elm_css$Css$Animations$property = F2($rtfeldman$elm_css$Css$Animations$property_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "239", "68", "68", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $rtfeldman$elm_css$Css$sec = function (amount) {
        return {
            i8: 0,
            pB: $elm$core$String$fromFloat(amount) + "s"
        };
    };
    var $rtfeldman$elm_css$Css$Global$selector_fn = function (selectorStr, styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn(styles, $rtfeldman$elm_css$Css$Structure$CustomSelector_fn(selectorStr, _List_Nil));
    }, $rtfeldman$elm_css$Css$Global$selector = F2($rtfeldman$elm_css$Css$Global$selector_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2 = $rtfeldman$elm_css$Css$property_fn("width", "0.5rem");
    var $author$project$Components$toClickProtected_fn = function (noOp, onClick, element) {
        var cover = function (_v0) {
            var slideAndHide = _List_fromArray([
                $rtfeldman$elm_css$Css$animationDuration($rtfeldman$elm_css$Css$sec(1)),
                $rtfeldman$elm_css$Css$property_fn("animation-fill-mode", "forwards"),
                $rtfeldman$elm_css$Css$property_fn("animation-timing-function", "ease-in"),
                $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                    _Utils_Tuple2(100, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform-origin", "left")
                    ]))
                ]))),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$adjacentSiblings_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$selector_fn(".covered *", _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500)
                    ]))
                ]))
            ]);
            var preventContextMenuOnMobile = A2($author$project$Util$preventDefaultOn, "contextmenu", noOp);
            var focusable = $rtfeldman$elm_css$VirtualDom$Styled$property_fn("focusable", $elm$json$Json$Encode$bool(true));
            var borderStyle = $rtfeldman$elm_css$Css$batch(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid
            ]));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                preventContextMenuOnMobile,
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("animationend", $elm$json$Json$Decode$succeed(onClick)),
                focusable,
                $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$property_fn("transform", "scaleX(2)"),
                    $rtfeldman$elm_css$Css$property_fn("transform-origin", "right"),
                    $rtfeldman$elm_css$Css$active(slideAndHide),
                    $rtfeldman$elm_css$Css$focus(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$selector_fn(".progress-indicator", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, borderStyle])),
                    focusable
                ]), _List_Nil),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex])),
                    focusable
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "progress-indicator"),
                        focusable,
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2,
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 33)),
                            borderStyle
                        ]))
                    ]), _List_Nil)
                ]))
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden]))
        ]), _List_fromArray([
            cover(0),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "covered"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([element]))
        ]));
    }, $author$project$Components$toClickProtected = F3($author$project$Components$toClickProtected_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$white = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "255", "255", "255", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap = $rtfeldman$elm_css$Css$property_fn("white-space", "nowrap");
    var $author$project$Overlay$popupMenu_fn = function (model, entries) {
        var menuEntries = function () {
            var styles = _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50)
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_start,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_normal,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
            ]);
            return $elm$core$List$map_fn(function (_v2) {
                var title = _v2.a;
                var msg = _v2.b;
                var covered = _v2.c;
                return (!_Utils_eq($elm$url$Url$fromString(title), $elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
                    $rtfeldman$elm_css$Html$Styled$Attributes$href(title),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank"),
                    $rtfeldman$elm_css$VirtualDom$Styled$property_fn("focusable", $elm$json$Json$Encode$bool(true))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Open URL")
                ])) : (covered ? A2($author$project$Components$toClickProtected, model.gd($author$project$Overlay$NoOp), model.gd($author$project$Overlay$FinalMsg(msg))) : $elm$core$Basics$identity)($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ])));
            }, entries);
        }();
        var menu = function (_v1) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                    $rtfeldman$elm_css$Css$prop5_fn($rtfeldman$elm_css$Css$boxShadow5_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 2), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 8), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, -2), $rtfeldman$elm_css$Css$rgba_fn(0, 0, 0, 0.2))
                ]))
            ]), menuEntries);
        };
        return _Utils_update(model, {
            a$: function () {
                if (_Utils_eq(menuEntries, _List_Nil)) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var onClickToNonFocusable = function (msg) {
                        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("click", _Json_andThen_fn(function (focusable) {
                            return _Utils_eq(focusable, $elm$core$Maybe$Just(true)) ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed(msg);
                        }, $elm$json$Json$Decode$maybe($elm$json$Json$Decode$at_fn(_List_fromArray(["target", "focusable"]), $elm$json$Json$Decode$bool))));
                    };
                    var onBlurToNonFocusable = function (msg) {
                        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("focusout", _Json_andThen_fn(function (focusable) {
                            return _Utils_eq(focusable, $elm$core$Maybe$Just(true)) ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed(msg);
                        }, $elm$json$Json$Decode$maybe($elm$json$Json$Decode$at_fn(_List_fromArray(["relatedTarget", "focusable"]), $elm$json$Json$Decode$bool))));
                    };
                    return $elm$core$Maybe$Just({
                        cb: $elm$core$Task$attempt_fn(function (_v0) {
                            return model.gd($author$project$Overlay$OverlayFocused);
                        }, _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, "menu-overlay-wrapper")),
                        bR: "menu-overlay",
                        b_: $elm$core$Maybe$Nothing,
                        b$: false,
                        cH: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_out]),
                        ay: _List_fromArray([
                            menu(0)
                        ]),
                        it: $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "menu-overlay-wrapper"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                            onClickToNonFocusable(model.gd($author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))),
                            onBlurToNonFocusable(model.gd($author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none]))
                        ])),
                        pH: 0,
                        pJ: 0
                    });
                }
            }()
        });
    }, $author$project$Overlay$popupMenu = F2($author$project$Overlay$popupMenu_fn);
    var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
    var $author$project$Types$Team$decreaseDatabaseCount = function (team) {
        return _Utils_update(team, { nG: team.nG - 1 });
    };
    var $author$project$Types$Team$filterDatabases_fn = function (f, team) {
        return _Utils_update(team, {
            l1: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$List$filter(f), team.l1)
        });
    }, $author$project$Types$Team$filterDatabases = F2($author$project$Types$Team$filterDatabases_fn);
    var $author$project$Types$Team$removeDatabase = function (dbId) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Team$filterDatabases(A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, $elm$core$Basics$neq(dbId))), $author$project$Types$Team$decreaseDatabaseCount);
    };
    var $author$project$Types$Table$mapColumns_fn = function (mapper, table) {
        return _Utils_update(table, {
            iT: $elm$core$List$map_fn(mapper, table.iT)
        });
    }, $author$project$Types$Table$mapColumns = F2($author$project$Types$Table$mapColumns_fn);
    var $elm_community$list_extra$List$Extra$notMember = function (x) {
        return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$member(x));
    };
    var $author$project$Types$Column$setNotAsked = function (column) {
        return _Utils_update(column, { y: $krisajenkins$remotedata$RemoteData$NotAsked });
    };
    var $author$project$Types$Database$removeTableCells = function (tables) {
        return $krisajenkins$remotedata$RemoteData$map($author$project$Types$Database$mapTables(function (table) {
            return A2($elm_community$list_extra$List$Extra$notMember, table.M, tables) ? table : $author$project$Types$Table$mapColumns_fn($author$project$Types$Column$setNotAsked, table);
        }));
    };
    var $author$project$Types$User$removeTeam_fn = function (team, user) {
        return _Utils_update(user, {
            pc: $elm$core$List$filter_fn($elm$core$Basics$neq(team), user.pc)
        });
    }, $author$project$Types$User$removeTeam = F2($author$project$Types$User$removeTeam_fn);
    var $elm$http$Http$filePart = _Http_pair;
    var $elm$http$Http$multipartBody = function (parts) {
        return _Http_pair_fn("", _Http_toFormData(parts));
    };
    var $author$project$Api$replaceDatabase_fn = function (msg, maybeToken, file, maybeId, dbId) {
        return $elm$http$Http$request({
            d: $elm$http$Http$multipartBody(_List_fromArray([
                _Http_pair_fn("database", file)
            ])),
            e: A2($author$project$Api$expect, msg, $author$project$Types$Database$decodeId),
            d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
            f: "PUT",
            eK: $elm$core$Maybe$Nothing,
            eQ: maybeId,
            g: "/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$replaceDatabase = F5($author$project$Api$replaceDatabase_fn);
    var $author$project$Model$reset = function (model) {
        var initialModel = $author$project$Model$init(model.b);
        return _Utils_update(initialModel, {
            hn: $author$project$Pages$Login$init(model.p),
            a$: model.a$,
            pf: model.pf,
            p: model.p
        });
    };
    var $author$project$Ports$saveToLocalStorage = _Platform_outgoingPort("saveToLocalStorage", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("key", $elm$json$Json$Encode$string($.jQ)),
            _Utils_Tuple2("value", $elm$core$Basics$identity($.pB))
        ]));
    });
    var $author$project$Types$DatabaseSettings$Visibility$toString = function (visibility) {
        if (!visibility) {
            return "private";
        }
        else {
            return "public";
        }
    };
    var $author$project$Types$DatabaseSettings$Visibility$encode_a0 = $author$project$Types$DatabaseSettings$Visibility$toString, $author$project$Types$DatabaseSettings$Visibility$encode_a1 = $elm$json$Json$Encode$string, $author$project$Types$DatabaseSettings$Visibility$encode = A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$Visibility$encode_a0, $author$project$Types$DatabaseSettings$Visibility$encode_a1);
    var $author$project$Types$EnvironmentVariable$encode = function (envVar) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(envVar.M)),
            _Utils_Tuple2("value", $elm$json$Json$Encode$string(envVar.pB))
        ]));
    };
    var $elm$json$Json$Encode$list_fn = function (func, entries) {
        return _Json_wrap($elm$core$List$foldl_fn(_Json_addEntry(func), _Json_emptyArray(0), entries));
    }, $elm$json$Json$Encode$list = F2($elm$json$Json$Encode$list_fn);
    var $author$project$Types$DatabaseSettings$encoder = function (settings) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("auditing", $elm$json$Json$Encode$bool(settings.iH)),
            _Utils_Tuple2("schemaLocked", $elm$json$Json$Encode$bool(settings.bj)),
            _Utils_Tuple2("viewsTab", $elm$json$Json$Encode$bool(settings.pD)),
            _Utils_Tuple2("environment", $elm$json$Json$Encode$string(settings.mk)),
            _Utils_Tuple2("envVars", $elm$json$Json$Encode$list_fn($author$project$Types$EnvironmentVariable$encode, settings.gQ)),
            _Utils_Tuple2("visibility", $elm$core$Basics$composeR_fn($author$project$Types$DatabaseSettings$Visibility$encode_a0, $author$project$Types$DatabaseSettings$Visibility$encode_a1, settings.pE))
        ]));
    };
    var $author$project$Api$setDatabaseSettings_fn = function (msg, maybeToken, dbId, databaseSettings) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$DatabaseSettings$encoder(databaseSettings)),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(databaseSettings)),
            f: "PATCH",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/settings")
        });
    }, $author$project$Api$setDatabaseSettings = F4($author$project$Api$setDatabaseSettings_fn);
    var $author$project$Types$Team$setDatabasesFailure_fn = function (errors, team) {
        return _Utils_update(team, {
            l1: $krisajenkins$remotedata$RemoteData$Failure(errors)
        });
    }, $author$project$Types$Team$setDatabasesFailure = F2($author$project$Types$Team$setDatabasesFailure_fn);
    var $author$project$Types$Team$setDatabasesLoading = function (team) {
        return _Utils_update(team, { l1: $krisajenkins$remotedata$RemoteData$Loading });
    };
    var $author$project$Types$Team$setDatabasesNotAsked = function (team) {
        return _Utils_update(team, { l1: $krisajenkins$remotedata$RemoteData$NotAsked });
    };
    var $author$project$Overlay$Dimension_fn = function (w, h) {
        return { ck: h, bq: w };
    }, $author$project$Overlay$Dimension = F2($author$project$Overlay$Dimension_fn);
    var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
    var $author$project$Overlay$setOrigin_fn = function (toMsg, id, model) {
        return $elm$core$Task$attempt_fn(function (elementResult) {
            return toMsg(model.gd(function () {
                if (elementResult.$ === 1) {
                    return $author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, model.a$);
                }
                else {
                    var element = elementResult.a.d2;
                    return $author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Just($author$project$Overlay$Dimension_fn(element.ir, element.g$)), $elm$core$Maybe$map_fn(function (overlay) {
                        return _Utils_update(overlay, { pH: overlay.pH + element.pH, pJ: overlay.pJ + element.pJ });
                    }, model.a$));
                }
            }()));
        }, $elm$browser$Browser$Dom$getElement(id));
    }, $author$project$Overlay$setOrigin = F3($author$project$Overlay$setOrigin_fn);
    var $author$project$Api$setOwner_fn = function (msg, maybeToken, owner, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("owner", $elm$json$Json$Encode$string(owner))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(owner)),
            f: "PATCH",
            g: "/api/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$setOwner = F4($author$project$Api$setOwner_fn);
    var $author$project$Types$Database$setOwner = function (owner) {
        return $krisajenkins$remotedata$RemoteData$map(function (db) {
            return _Utils_update(db, {
                ob: $elm$core$Maybe$Just(owner)
            });
        });
    };
    var $author$project$Types$Upload$setProgress_fn = function (progress, tracker) {
        return _Utils_update(tracker, {
            fT: $elm$core$Maybe$Just(progress)
        });
    }, $author$project$Types$Upload$setProgress = F2($author$project$Types$Upload$setProgress_fn);
    var $author$project$Types$Database$setSettings_fn = function (settings, database) {
        return _Utils_update(database, { kR: settings });
    }, $author$project$Types$Database$setSettings = F2($author$project$Types$Database$setSettings_fn);
    var $author$project$Types$Database$setTables_fn = function (tables, database) {
        return _Utils_update(database, { eH: tables });
    }, $author$project$Types$Database$setTables = F2($author$project$Types$Database$setTables_fn);
    var $author$project$Model$setUploaded = function (model) {
        return _Utils_update(model, { a3: $elm$core$Maybe$Nothing });
    };
    var $author$project$Types$DatabaseSettings$setVisibility_fn = function (visibility, settings) {
        return _Utils_update(settings, { pE: visibility });
    }, $author$project$Types$DatabaseSettings$setVisibility = F2($author$project$Types$DatabaseSettings$setVisibility_fn);
    var $elm$file$File$size = _File_size;
    var $author$project$Types$UploadType$toMimes = function (uploadType) {
        var sqlite = _List_fromArray(["application/vnd.sqlite3", "application/x-sqlite3"]);
        var csv = _List_fromArray(["text/csv"]);
        switch (uploadType.$) {
            case 2:
                if (!uploadType.a) {
                    var _v1 = uploadType.a;
                    return sqlite;
                }
                else {
                    var _v2 = uploadType.a;
                    return csv;
                }
            case 3:
                if (!uploadType.a) {
                    var _v3 = uploadType.a;
                    return sqlite;
                }
                else {
                    var _v4 = uploadType.a;
                    return csv;
                }
            default:
                return _List_Nil;
        }
    };
    var $author$project$Types$Database$toOwner_a0 = $krisajenkins$remotedata$RemoteData$toMaybe, $author$project$Types$Database$toOwner_a1 = $elm$core$Maybe$andThen(function ($) {
        return $.ob;
    }), $author$project$Types$Database$toOwner = A2($elm$core$Basics$composeR, $author$project$Types$Database$toOwner_a0, $author$project$Types$Database$toOwner_a1);
    var $author$project$Types$UploadType$toQuery = function (uploadType) {
        if (uploadType.$ === 1) {
            var query = uploadType.a;
            return $elm$core$Maybe$Just(query);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$url$Url$addPort_fn = function (maybePort, starter) {
        if (maybePort.$ === 1) {
            return starter;
        }
        else {
            var port_ = maybePort.a;
            return starter + (":" + $elm$core$String$fromInt(port_));
        }
    }, $elm$url$Url$addPort = F2($elm$url$Url$addPort_fn);
    var $elm$url$Url$addPrefixed_fn = function (prefix, maybeSegment, starter) {
        if (maybeSegment.$ === 1) {
            return starter;
        }
        else {
            var segment = maybeSegment.a;
            return _Utils_ap(starter, _Utils_ap(prefix, segment));
        }
    }, $elm$url$Url$addPrefixed = F3($elm$url$Url$addPrefixed_fn);
    var $elm$url$Url$toString = function (url) {
        var http = function () {
            var _v0 = url.kC;
            if (!_v0) {
                return "http://";
            }
            else {
                return "https://";
            }
        }();
        return $elm$url$Url$addPrefixed_fn("#", url.jq, $elm$url$Url$addPrefixed_fn("?", url.kD, _Utils_ap($elm$url$Url$addPort_fn(url.og, _Utils_ap(http, url.jz)), url.ks)));
    };
    var $author$project$Route$toUrlPathWithToken_fn = function (route, token) {
        return _String_append_fn($author$project$Route$toUrlPath(route), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", A2($elm$core$Basics$composeR, $author$project$Types$SessionToken$toString, $elm$core$String$append("?session-token=")), token));
    }, $author$project$Route$toUrlPathWithToken = F2($author$project$Route$toUrlPathWithToken_fn);
    var $author$project$Overlay$Position_fn = function (x, y) {
        return { pH: x, pJ: y };
    }, $author$project$Overlay$Position = F2($author$project$Overlay$Position_fn);
    var $author$project$Overlay$Rect_fn = function (x, y, w, h) {
        return { ck: h, bq: w, pH: x, pJ: y };
    }, $author$project$Overlay$Rect = F4($author$project$Overlay$Rect_fn);
    var $author$project$Overlay$ShowOverlay_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $author$project$Overlay$ShowOverlay = F3($author$project$Overlay$ShowOverlay_fn);
    var $elm_community$maybe_extra$Maybe$Extra$andMap_a0 = $elm$core$Basics$apR, $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm_community$maybe_extra$Maybe$Extra$andMap_a0);
    var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
    var $elm$core$Task$map3_fn = function (func, taskA, taskB, taskC) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return _Scheduler_andThen_fn(function (c) {
                    return $elm$core$Task$succeed(A3(func, a, b, c));
                }, taskC);
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map3_fn_unwrapped = function (func, taskA, taskB, taskC) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return _Scheduler_andThen_fn(function (c) {
                    return $elm$core$Task$succeed(func(a, b, c));
                }, taskC);
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map3 = F4($elm$core$Task$map3_fn);
    var $elm$core$List$drop_fn = function (n, list) {
        drop: while (true) {
            if (n <= 0) {
                return list;
            }
            else {
                if (!list.b) {
                    return list;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs;
                    n = $temp$n;
                    list = $temp$list;
                    continue drop;
                }
            }
        }
    }, $elm$core$List$drop = F2($elm$core$List$drop_fn);
    var $elm_community$list_extra$List$Extra$removeAt_fn = function (index, l) {
        if (index < 0) {
            return l;
        }
        else {
            var _v0 = $elm$core$List$drop_fn(index, l);
            if (!_v0.b) {
                return l;
            }
            else {
                var rest = _v0.b;
                return _Utils_ap($elm$core$List$take_fn(index, l), rest);
            }
        }
    }, $elm_community$list_extra$List$Extra$removeAt = F2($elm_community$list_extra$List$Extra$removeAt_fn);
    var $author$project$Overlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                var msg_ = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { a$: $elm$core$Maybe$Nothing }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, msg_));
            case 2:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 3:
                var maybeTrigger = msg.a;
                var maybeOverlay = msg.b;
                var getElementsCmd = function () {
                    var elementToPosition = function (_v1) {
                        var element = _v1.d2;
                        return $author$project$Overlay$Position_fn(element.pH, element.pJ);
                    };
                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (overlay) {
                        return $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, model.gd, A2($author$project$Overlay$ShowOverlay, maybeTrigger, overlay)), $elm$core$Task$map3_fn_unwrapped(function (a, b, c) {
                            return _Utils_Tuple3(a, b, c);
                        }, $elm$browser$Browser$Dom$getElement(overlay.bR), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Task$succeed($author$project$Overlay$Position_fn(0, 0)), A2($elm$core$Basics$composeR, $elm$browser$Browser$Dom$getElement, $elm$core$Task$map(elementToPosition)), model.gA), $elm$browser$Browser$Dom$getViewport));
                    }, maybeOverlay);
                }();
                return _Utils_Tuple2(_Utils_update(model, { a$: maybeOverlay }), getElementsCmd);
            case 4:
                var maybeTrigger = msg.a;
                var overlay = msg.b;
                var getElementsResult = msg.c;
                if (_Utils_eq(model.a$, $elm$core$Maybe$Nothing)) {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    if (getElementsResult.$ === 1) {
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }
                    else {
                        var _v3 = getElementsResult.a;
                        var overlayElement = _v3.a;
                        var containerPosition = _v3.b;
                        var viewport = _v3.c;
                        var preventOverflow = F3(function (getWH, getXY, xy) {
                            var viewportXY = getXY(viewport.lf);
                            var viewportWH = getWH(viewport.lf);
                            var minXY = viewportXY;
                            var elementWH = getWH(overlayElement.d2);
                            var maxXY = (viewportXY + viewportWH) - elementWH;
                            return $elm$core$Basics$clamp_fn(minXY, maxXY, xy);
                        });
                        var overlayMapped = $elm$core$Maybe$withDefault_fn($author$project$Overlay$Position_fn(overlay.pH, overlay.pJ), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, maybeTrigger, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just($author$project$Overlay$Rect_fn(overlay.pH, overlay.pJ, overlayElement.d2.ir, overlayElement.d2.g$)), overlay.b_)));
                        return _Utils_Tuple2(_Utils_update(model, {
                            a$: $elm$core$Maybe$Just(_Utils_update(overlay, {
                                b$: true,
                                pH: A3(preventOverflow, function ($) {
                                    return $.ir;
                                }, function ($) {
                                    return $.pH;
                                }, overlayMapped.pH) - containerPosition.pH,
                                pJ: A3(preventOverflow, function ($) {
                                    return $.g$;
                                }, function ($) {
                                    return $.pJ;
                                }, overlayMapped.pJ) - containerPosition.pJ
                            }))
                        }), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(function ($) {
                            return $.cb;
                        }, model.a$)));
                    }
                }
            default:
                var idx = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    a$: $elm$core$Maybe$map_fn(function (overlay) {
                        return _Utils_update(overlay, {
                            ay: $elm_community$list_extra$List$Extra$removeAt_fn(idx, overlay.ay)
                        });
                    }, model.a$)
                }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Overlay$update = F2($author$project$Overlay$update_fn);
    var $author$project$Pages$Admin$DatabasePageMsgReceived = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Admin$SettingsPageMsgReceived = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Admin$Databases$Routed = { $: 0 };
    var $author$project$Pages$Admin$Databases$routed = $author$project$Pages$Admin$Databases$Routed;
    var $author$project$Pages$Admin$Settings$Routed = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Admin$Settings$routed = $author$project$Pages$Admin$Settings$Routed;
    var $author$project$Components$Billing$update_fn = function (msg, model) {
        var formatMaybeFloat = function (maybeFloat) {
            return $elm$core$Maybe$map_fn(function (x) {
                return _String_contains_fn(".", x) ? x : (x + ".00");
            }, $elm$core$Maybe$map_fn($elm$core$String$fromFloat, maybeFloat));
        };
        switch (msg.$) {
            case 0:
                var priceData = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { aJ: priceData }), $elm$core$Platform$Cmd$none);
            case 1:
                var subtotalMaybe = msg.a;
                var _v1 = model.al;
                switch (_v1) {
                    case 0:
                        var modelPriceYearly = model.aV;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aV: _Utils_update(modelPriceYearly, {
                                a0: formatMaybeFloat(subtotalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    case 1:
                        var modelPriceHalfYearly = model.aU;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aU: _Utils_update(modelPriceHalfYearly, {
                                a0: formatMaybeFloat(subtotalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    default:
                        var modelPriceMonthly = model.aJ;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aJ: _Utils_update(modelPriceMonthly, {
                                a0: formatMaybeFloat(subtotalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                }
            case 2:
                var vatMaybe = msg.a;
                var _v2 = model.al;
                switch (_v2) {
                    case 0:
                        var modelPriceYearly = model.aV;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aV: _Utils_update(modelPriceYearly, {
                                b1: formatMaybeFloat(vatMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    case 1:
                        var modelPriceHalfYearly = model.aU;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aU: _Utils_update(modelPriceHalfYearly, {
                                b1: formatMaybeFloat(vatMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    default:
                        var modelPriceMonthly = model.aJ;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aJ: _Utils_update(modelPriceMonthly, {
                                b1: formatMaybeFloat(vatMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                }
            case 3:
                var totalMaybe = msg.a;
                var _v3 = model.al;
                switch (_v3) {
                    case 0:
                        var modelPriceYearly = model.aV;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aV: _Utils_update(modelPriceYearly, {
                                b0: formatMaybeFloat(totalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    case 1:
                        var modelPriceHalfYearly = model.aU;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aU: _Utils_update(modelPriceHalfYearly, {
                                b0: formatMaybeFloat(totalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                    default:
                        var modelPriceMonthly = model.aJ;
                        return _Utils_Tuple2(_Utils_update(model, {
                            aJ: _Utils_update(modelPriceMonthly, {
                                b0: formatMaybeFloat(totalMaybe)
                            })
                        }), $elm$core$Platform$Cmd$none);
                }
            case 4:
                var currencyMaybe = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { cV: currencyMaybe }), $elm$core$Platform$Cmd$none);
            default:
                var frequency = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { al: frequency }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Components$Billing$update = F2($author$project$Components$Billing$update_fn);
    var $author$project$Pages$Admin$Databases$DatabasesReveived = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Api$getServerDatabases_fn = function (msg, maybeToken) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, _Json_map2_fn($elm$core$Tuple$pair, _Json_decodeField_fn("databases", $elm$json$Json$Decode$list($author$project$Types$Database$decode)), _Json_decodeField_fn("numberOfDatabases", $elm$json$Json$Decode$int))),
            f: "GET",
            g: "/api/dbs"
        });
    }, $author$project$Api$getServerDatabases = F2($author$project$Api$getServerDatabases_fn);
    var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
        if (!data.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Pages$Admin$Databases$update_fn = function (cfg, msg, shared, model) {
        if (!msg.$) {
            var databasesNotAsked = $krisajenkins$remotedata$RemoteData$isNotAsked(model.l1);
            var databasesFailure = $krisajenkins$remotedata$RemoteData$isFailure(model.l1);
            return (databasesNotAsked || databasesFailure) ? _Utils_Tuple2(_Utils_update(model, { l1: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getServerDatabases_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Databases$DatabasesReveived, cfg.gd), shared.k2)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
        else {
            if (!msg.a.$) {
                var databases = msg.a.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    l1: $krisajenkins$remotedata$RemoteData$Success(databases)
                }), $elm$core$Platform$Cmd$none);
            }
            else {
                var errors = msg.a.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    l1: $krisajenkins$remotedata$RemoteData$Failure(errors)
                }), $elm$core$Platform$Cmd$none);
            }
        }
    }, $author$project$Pages$Admin$Databases$update = F4($author$project$Pages$Admin$Databases$update_fn);
    var $author$project$Components$EditorTitledOverlay$Closed = { $: 1 };
    var $author$project$Pages$Admin$Settings$EnvEditorOverlayMsg = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Admin$Settings$Navigated = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Components$EditorTitledOverlay$Opened = { $: 0 };
    var $author$project$Pages$Admin$Settings$SettingsEditModified = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Pages$Admin$Settings$SettingsLoaded = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Admin$Settings$SettingsUpdated = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Types$ServerSettings$decode = _Json_map2_fn($author$project$Types$ServerSettings$ServerSettings, _Json_decodeField_fn("allowedHosts", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)), $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("envVars", $elm$json$Json$Decode$list($author$project$Types$EnvironmentVariable$decode)),
        $elm$json$Json$Decode$succeed(_List_Nil)
    ])));
    var $author$project$Api$getServerSettings_fn = function (msg, maybeToken) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$ServerSettings$decode),
            f: "GET",
            g: "/api/settings"
        });
    }, $author$project$Api$getServerSettings = F2($author$project$Api$getServerSettings_fn);
    var $author$project$Components$EditorTitledOverlay$OverlayMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$EditorTitledOverlay$init = function (cfg) {
        return {
            gO: $author$project$Components$Editor$init_fn($elm$core$Maybe$Just(5), $elm$core$Maybe$Nothing, cfg.gB),
            fi: cfg.fi,
            fx: cfg.fx,
            bC: cfg.bC,
            nT: cfg.nT,
            fM: cfg.fM,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$EditorTitledOverlay$OverlayMsg, cfg.gd)),
            eM: cfg.eM,
            il: cfg.eM,
            gc: cfg.gc,
            gd: cfg.gd,
            la: false
        };
    };
    var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
        if (m.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Util$restoreActiveRoute = function (cfg) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, cfg.ou, cfg.ma), function (activeRoute) {
            return $elm$core$Platform$Cmd$batch($elm$core$List$reverse($elm$core$List$indexedMap_fn_unwrapped(function (i, route) {
                return (!i) ? cfg.ou(route) : cfg.ol(route);
            }, $author$project$Util$flip_fn($elm$core$List$append, _List_fromArray([activeRoute]), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, cfg.lo, cfg.dx)))));
        }, cfg.dx);
    };
    var $author$project$Pages$Admin$Settings$setActiveRoute_fn = function (maybeSubRoute, model) {
        return _Utils_update(model, { dx: maybeSubRoute });
    }, $author$project$Pages$Admin$Settings$setActiveRoute = F2($author$project$Pages$Admin$Settings$setActiveRoute_fn);
    var $author$project$Route$setAdminRoute_fn = function (adminRoute, route) {
        if (route.$ === 26) {
            return $elm$core$Maybe$Just($author$project$Route$Admin(adminRoute));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$setAdminRoute = F2($author$project$Route$setAdminRoute_fn);
    var $author$project$Route$setAdminSettingsRoute_fn = function (settingsRoute, route) {
        if (route.$ === 26) {
            return $elm$core$Maybe$Just($author$project$Route$Admin($author$project$Pages$Admin$Route$Settings($elm$core$Maybe$Just(settingsRoute))));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$setAdminSettingsRoute = F2($author$project$Route$setAdminSettingsRoute_fn);
    var $author$project$Types$ServerSettings$setAllowedHosts_fn = function (settings, allowedHosts) {
        return _Utils_update(settings, { iD: allowedHosts });
    }, $author$project$Types$ServerSettings$setAllowedHosts = F2($author$project$Types$ServerSettings$setAllowedHosts_fn);
    var $author$project$Types$ServerSettings$setEnvVars_fn = function (settings, envVars) {
        return _Utils_update(settings, { gQ: envVars });
    }, $author$project$Types$ServerSettings$setEnvVars = F2($author$project$Types$ServerSettings$setEnvVars_fn);
    var $author$project$Types$ServerSettings$encode = function (settings) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("allowedHosts", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, settings.iD)),
            _Utils_Tuple2("envVars", $elm$json$Json$Encode$list_fn($author$project$Types$EnvironmentVariable$encode, settings.gQ))
        ]));
    };
    var $elm$regex$Regex$fromString = function (string) {
        return _Regex_fromStringWith_fn({ lM: false, j3: false }, string);
    };
    var $elm_community$string_extra$String$Extra$regexFromString_a0 = $elm$regex$Regex$fromString, $elm_community$string_extra$String$Extra$regexFromString_a1 = $elm$core$Maybe$withDefault($elm$regex$Regex$never), $elm_community$string_extra$String$Extra$regexFromString = A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1);
    var $elm$regex$Regex$replace_a0 = _Regex_infinity, $elm$regex$Regex$replace = _Regex_replaceAtMost($elm$regex$Regex$replace_a0);
    var $elm$core$String$trim = _String_trim;
    var $elm_community$string_extra$String$Extra$clean = function (string) {
        return $elm$core$String$trim(_Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "\\s\\s+"), $elm$core$Basics$always(" "), string));
    };
    var $author$project$Types$ServerSettings$mapAllowedHosts_fn = function (mapper, serverSettings) {
        return _Utils_update(serverSettings, {
            iD: mapper(serverSettings.iD)
        });
    }, $author$project$Types$ServerSettings$mapAllowedHosts = F2($author$project$Types$ServerSettings$mapAllowedHosts_fn);
    var $author$project$Types$ServerSettings$sanitize = function (settings) {
        return $author$project$Types$ServerSettings$mapAllowedHosts_fn($elm$core$List$filterMap($elm_community$string_extra$String$Extra$nonEmpty), $author$project$Types$ServerSettings$mapAllowedHosts_fn($elm$core$List$map($elm_community$string_extra$String$Extra$clean), $author$project$Types$ServerSettings$mapAllowedHosts_fn($elm$core$List$map($elm$core$String$toLower), settings)));
    };
    var $author$project$Api$setServerSettings_fn = function (msg, maybeToken, serverSettings) {
        var sanitezedServerSettings = $author$project$Types$ServerSettings$sanitize(serverSettings);
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$ServerSettings$encode(sanitezedServerSettings)),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed($author$project$Types$ServerSettings$sanitize(sanitezedServerSettings))),
            f: "PATCH",
            g: "/api/settings"
        });
    }, $author$project$Api$setServerSettings = F3($author$project$Api$setServerSettings_fn);
    var $author$project$Pages$Admin$Route$setSettingsRoute = function (settingsRoute) {
        return $author$project$Pages$Admin$Route$Settings($elm$core$Maybe$Just(settingsRoute));
    };
    var $author$project$Components$EditorTitledOverlay$Responded = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Overlay$clear = function (model) {
        return _Utils_update(model, { a$: $elm$core$Maybe$Nothing });
    };
    var $author$project$Components$EditorTitledOverlay$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$EditorTitledOverlay$hasEmptyFields = function (model) {
        return (model.eM === "") || (model.gO.gB === "");
    };
    var $author$project$Components$EditorTitledOverlay$Applied = { $: 2 };
    var $author$project$Components$EditorTitledOverlay$EditorMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Components$EditorTitledOverlay$TitleTyped = function (a) {
        return { $: 4, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete = function (bool) {
        return $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn("autocomplete", bool ? "on" : "off");
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_opacity_5 = $rtfeldman$elm_css$Css$property_fn("--tw-bg-opacity", "0.05");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$black = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "0", "0", "0", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen = $rtfeldman$elm_css$Css$property_fn("height", "100vh");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0 = $rtfeldman$elm_css$Css$property_fn("left", "0px");
    var $author$project$Util$onClickWithId_fn = function (id, msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("click", _Json_andThen_fn(function (targetId) {
            return _Utils_eq(targetId, id) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail("");
        }, $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "id"]), $elm$json$Json$Decode$string)));
    }, $author$project$Util$onClickWithId = F2($author$project$Util$onClickWithId_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0 = $rtfeldman$elm_css$Css$property_fn("top", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_40 = $rtfeldman$elm_css$Css$property_fn("z-index", "40");
    var $author$project$Components$backdrop_fn = function (id_, maybeOnClick) {
        var backdropId = id_ + "-backdrop";
        return $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, backdropId),
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $author$project$Util$onClickWithId(backdropId), maybeOnClick),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$fixed,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$black),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_opacity_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_40
            ]))
        ]));
    }, $author$project$Components$backdrop = F2($author$project$Components$backdrop_fn);
    var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
        if (!expression) {
            return "+";
        }
        else {
            return "-";
        }
    };
    var $rtfeldman$elm_css$Css$calc_fn = function (firstExpr, expression, secondExpr) {
        var withoutCalcStr = function (l) {
            return _String_startsWith_fn("calc(", l.pB) ? $elm$core$String$dropLeft_fn(4, l.pB) : l.pB;
        };
        var calcs = withoutCalcStr(firstExpr) + (" " + ($rtfeldman$elm_css$Css$calcExpressionToString(expression) + (" " + withoutCalcStr(secondExpr))));
        var value = $rtfeldman$elm_css$Css$cssFunction_fn("calc", _List_fromArray([calcs]));
        return { iO: 0, c1: 0, aG: 0, hl: 0, c8: 0, bS: 0, c9: 0, da: 0, cp: 0, cq: 0, bB: 0, db: 0, dp: 0, pB: value };
    }, $rtfeldman$elm_css$Css$calc = F3($rtfeldman$elm_css$Css$calc_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "243", "244", "246", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "209", "213", "219", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "156", "163", "175", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "107", "114", "128", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_flex = $rtfeldman$elm_css$Css$property_fn("display", "inline-flex");
    var $author$project$Util$stopPropagationOn = function (event) {
        return A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Tuple$pair, true), A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn(event)));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("width", "-webkit-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "-moz-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "fit-content")
    ]));
    var $author$project$Components$iconButton = function (cfg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
            A2($author$project$Util$stopPropagationOn, "click", cfg.a_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            cfg.bA(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(cfg.bE)
            ]))
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between = $rtfeldman$elm_css$Css$property_fn("justify-content", "space-between");
    var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3($rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS_fn = function (a, b, c, d) {
        return { $: 3, a: a, b: b, c: c, d: d };
    }, $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4($rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS_fn);
    var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
    var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
    var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute_fn = function (transform, _v0) {
        var prop = _v0.a;
        var isCssStyle = _v0.b;
        var cssTemplate = _v0.c;
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(_VirtualDom_mapAttribute_fn(transform, prop), isCssStyle, cssTemplate);
    }, $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2($rtfeldman$elm_css$VirtualDom$Styled$mapAttribute_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$map_fn = function (transform, vdomNode) {
        switch (vdomNode.$) {
            case 0:
                var elemType = vdomNode.a;
                var properties = vdomNode.b;
                var children = vdomNode.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn(elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform), properties), $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$map(transform), children));
            case 1:
                var ns = vdomNode.a;
                var elemType = vdomNode.b;
                var properties = vdomNode.c;
                var children = vdomNode.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$NodeNS_fn(ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform), properties), $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$map(transform), children));
            case 2:
                var elemType = vdomNode.a;
                var properties = vdomNode.b;
                var children = vdomNode.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn(elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform), properties), $elm$core$List$map_fn(function (_v1) {
                    var key = _v1.a;
                    var child = _v1.b;
                    return _Utils_Tuple2(key, $rtfeldman$elm_css$VirtualDom$Styled$map_fn(transform, child));
                }, children));
            case 3:
                var ns = vdomNode.a;
                var elemType = vdomNode.b;
                var properties = vdomNode.c;
                var children = vdomNode.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS_fn(ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform), properties), $elm$core$List$map_fn(function (_v2) {
                    var key = _v2.a;
                    var child = _v2.b;
                    return _Utils_Tuple2(key, $rtfeldman$elm_css$VirtualDom$Styled$map_fn(transform, child));
                }, children));
            default:
                var vdom = vdomNode.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_map_fn(transform, vdom));
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$map = F2($rtfeldman$elm_css$VirtualDom$Styled$map_fn);
    var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
    var $rtfeldman$elm_css$Css$maxHeight_a0 = "max-height", $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$maxHeight_a0);
    var $rtfeldman$elm_css$Css$minWidth_a0 = "min-width", $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$minWidth_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0 = $rtfeldman$elm_css$Css$property_fn("min-height", "0px");
    var $rtfeldman$elm_css$Css$Subtraction = 1;
    var $rtfeldman$elm_css$Css$minus = 1;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_auto = $rtfeldman$elm_css$Css$property_fn("overflow-y", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4 = $rtfeldman$elm_css$Css$property_fn("padding-left", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5 = $rtfeldman$elm_css$Css$property_fn("padding-right", "0.375rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "3rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "3rem")
    ]));
    var $rtfeldman$elm_css$Css$RemUnits = 0;
    var $rtfeldman$elm_css$Css$rem_a0 = 0, $rtfeldman$elm_css$Css$rem_a1 = "rem", $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl = $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr = $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.25rem");
    var $rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0 = "spellcheck", $rtfeldman$elm_css$Html$Styled$Attributes$spellcheck = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0);
    var $author$project$Components$textButton_fn = function (styles, title, onClick) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $rtfeldman$elm_css$Css$batch(styles)
            ])),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(onClick)
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(title)
        ]));
    }, $author$project$Components$textButton = F3($author$project$Components$textButton_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left = $rtfeldman$elm_css$Css$property_fn("text-align", "left");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_100 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "219", "234", "254", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_50 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "239", "246", "255", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_2 = $rtfeldman$elm_css$Css$property_fn("border-width", "2px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_collapse = $rtfeldman$elm_css$Css$property_fn("border-collapse", "collapse");
    var $rtfeldman$elm_css$Css$disabled = $rtfeldman$elm_css$Css$pseudoClass("disabled");
    var $rtfeldman$elm_css$Css$EmUnits = 0;
    var $rtfeldman$elm_css$Css$em_a0 = 0, $rtfeldman$elm_css$Css$em_a1 = "em", $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1);
    var $rtfeldman$elm_css$Css$fontFamily_a0 = "font-family", $rtfeldman$elm_css$Css$fontFamily = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$fontFamily_a0);
    var $rtfeldman$elm_css$Css$fontSize_a0 = "font-size", $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$fontSize_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "55", "65", "81", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_7 = $rtfeldman$elm_css$Css$property_fn("height", "1.75rem");
    var $rtfeldman$elm_css$Css$hsla_fn = function (hueVal, saturationVal, lightnessVal, alpha) {
        var valuesList = _List_fromArray([
            $elm$core$String$fromFloat(hueVal),
            $rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
            $rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal),
            $elm$core$String$fromFloat(alpha)
        ]);
        var value = $rtfeldman$elm_css$Css$cssFunction_fn("hsla", valuesList);
        return $rtfeldman$elm_css$Css$hslaToRgba_fn(value, hueVal, saturationVal, lightnessVal, alpha);
    }, $rtfeldman$elm_css$Css$hsla = F4($rtfeldman$elm_css$Css$hsla_fn);
    var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
    var $rtfeldman$elm_css$Css$initial = { iC: 0, ak: 0, dK: 0, iI: 0, cQ: 0, iJ: 0, cR: 0, bI: 0, aP: 0, e1: 0, bw: 0, k: 0, S: 0, c1: 0, gS: 0, d4: 0, fo: 0, cg: 0, aG: 0, d5: 0, z: 0, ch: 0, fv: 0, jP: 0, hi: 0, hl: 0, c8: 0, bS: 0, c9: 0, da: 0, cp: 0, cq: 0, bB: 0, db: 0, fz: 0, q: 0, l: 0, hD: 0, nF: 0, bX: 0, fP: 0, de: 0, bi: 0, f7: 0, $7: 0, cD: 0, dp: 0, dq: 0, cE: 0, aW: 0, ds: "", eS: 0, pB: "initial", pE: 0, cL: 0 };
    var $rtfeldman$elm_css$Css$inherit = _Utils_update($rtfeldman$elm_css$Css$initial, { pB: "inherit" });
    var $rtfeldman$elm_css$Css$lineHeight_a0 = "line-height", $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$lineHeight_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_screen = $rtfeldman$elm_css$Css$property_fn("max-height", "100vh");
    var $rtfeldman$elm_css$Css$nthChild = function (str) {
        return $rtfeldman$elm_css$Css$pseudoClass("nth-child(" + (str + ")"));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50 = $rtfeldman$elm_css$Css$property_fn("opacity", "0.5");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_hidden = $rtfeldman$elm_css$Css$property_fn("overflow-x", "hidden");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_scroll = $rtfeldman$elm_css$Css$property_fn("overflow-y", "scroll");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_6 = $rtfeldman$elm_css$Css$property_fn("padding", "1.5rem");
    var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2($rtfeldman$elm_css$Css$Preprocess$WithPseudoElement_fn);
    var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
        return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$placeholder_color = function (color) {
        return $rtfeldman$elm_css$Css$batch(_List_fromArray([
            A2($rtfeldman$elm_css$Css$pseudoElement, "placeholder", _List_fromArray([
                $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("color", function (c) {
                    return c;
                }, $elm$core$Maybe$Just("--tw-placeholder-opacity"), color)
            ])),
            A2($rtfeldman$elm_css$Css$pseudoElement, "-moz-placeholder", _List_fromArray([
                $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("color", function (c) {
                    return c;
                }, $elm$core$Maybe$Just("--tw-placeholder-opacity"), color)
            ]))
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.75rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.75rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_100 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "254", "226", "226", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_200 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "254", "202", "202", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "252", "165", "165", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "185", "28", "28", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full = $rtfeldman$elm_css$Css$property_fn("border-radius", "9999px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_lg = $rtfeldman$elm_css$Css$property_fn("border-radius", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_sm = $rtfeldman$elm_css$Css$property_fn("border-radius", "0.125rem");
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$Keyword = function (a) {
        return { $: 1, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$current = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Keyword("currentColor");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_min = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("width", "-webkit-min-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "-moz-min-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "min-content")
    ]));
    var $author$project$Theme$styButton = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_min,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$current),
        $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
    ]));
    var $author$project$Theme$styDefaultButton = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $author$project$Theme$styButton,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600),
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
    ]));
    var $author$project$Theme$styPrimaryButton = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $author$project$Theme$styButton,
        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(225, 1, 0.44)),
        $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(225, 1, 0.92)),
        $rtfeldman$elm_css$Css$hover(_List_fromArray([
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(225, 1, 0.87))
        ])),
        $rtfeldman$elm_css$Css$active(_List_fromArray([
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(225, 1, 0.82))
        ]))
    ]));
    var $author$project$Theme$styPrimaryButtonSm = $rtfeldman$elm_css$Css$batch(_List_fromArray([$author$project$Theme$styPrimaryButton, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_72 = $rtfeldman$elm_css$Css$property_fn("width", "18rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_line = $rtfeldman$elm_css$Css$property_fn("white-space", "pre-line");
    var $author$project$Theme$theme = function () {
        var toSecondaryButton = A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$List$cons, _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_100),
            $rtfeldman$elm_css$Css$hover(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_200)
            ])),
            $rtfeldman$elm_css$Css$active(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300)
            ]))
        ])), $rtfeldman$elm_css$Css$batch);
        var popupShadow = $rtfeldman$elm_css$Css$prop5_fn($rtfeldman$elm_css$Css$boxShadow5_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 0), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 0), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 3), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 1), $rtfeldman$elm_css$Css$hsla_fn(0, 0, 0, 0.2));
        return {
            dT: {
                lN: function (active) {
                    return active ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_50) : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white);
                },
                lO: function (active) {
                    return active ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_100) : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100);
                },
                hk: $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
            },
            bN: {
                e2: $rtfeldman$elm_css$Css$batch(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8))
                ])),
                kJ: $rtfeldman$elm_css$Css$batch(_List_fromArray([
                    A2($rtfeldman$elm_css$Css$nthChild, "even", _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                    ])),
                    A2($rtfeldman$elm_css$Css$nthChild, "odd", _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                    ]))
                ])),
                kZ: $rtfeldman$elm_css$Css$batch(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_collapse, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_sm]))
            },
            mc: $rtfeldman$elm_css$Css$batch(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_6,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_72,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_96])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_screen,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_hidden,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_scroll,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_lg,
                popupShadow,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_line
            ])),
            jf: $rtfeldman$elm_css$Css$hsl_fn(0, 0.6, 0.8),
            jg: $rtfeldman$elm_css$Css$hsl_fn(0, 0.61, 0.34),
            jh: $rtfeldman$elm_css$Css$hsl_fn(0, 0.61, 0.34),
            fu: $rtfeldman$elm_css$Css$batch(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$placeholder_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
                $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
            ])),
            dd: $rtfeldman$elm_css$Css$hsl_fn(225, 1, 0.44),
            ho: $rtfeldman$elm_css$Css$hsl_fn(203, 1, 0.45),
            na: $rtfeldman$elm_css$Css$hsl_fn(203, 1, 0.6),
            nk: $rtfeldman$elm_css$Css$batch(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm
            ])),
            hO: function (hoverStyles) {
                return $rtfeldman$elm_css$Css$batch(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_7,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $author$project$Util$styleIf_fn(hoverStyles, $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $author$project$Util$styleIf_fn(hoverStyles, $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ])))
                ]));
            },
            of: popupShadow,
            oY: $author$project$Theme$styDefaultButton,
            kW: $author$project$Theme$styPrimaryButton,
            kX: $author$project$Theme$styPrimaryButtonSm,
            oZ: toSecondaryButton($author$project$Theme$styPrimaryButton),
            o_: toSecondaryButton($author$project$Theme$styPrimaryButtonSm)
        };
    }();
    var $author$project$Components$Editor$contentChanged = function (model) {
        return !_Utils_eq(model.gB, model.eb);
    };
    var $author$project$Components$EditorTitledOverlay$contentChanged = function (model) {
        return $author$project$Components$Editor$contentChanged(model.gO);
    };
    var $author$project$Components$EditorTitledOverlay$titleChanged = function (model) {
        return !_Utils_eq(model.eM, model.il);
    };
    var $author$project$Components$EditorTitledOverlay$unchanged = function (model) {
        return !($author$project$Components$EditorTitledOverlay$contentChanged(model) || $author$project$Components$EditorTitledOverlay$titleChanged(model));
    };
    var $rtfeldman$elm_css$Css$VhUnits = 0;
    var $rtfeldman$elm_css$Css$vh_a0 = 0, $rtfeldman$elm_css$Css$vh_a1 = "vh", $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1);
    var $author$project$Components$Editor$ContentTyped_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Components$Editor$ContentTyped = F2($author$project$Components$Editor$ContentTyped_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
    var $rtfeldman$elm_css$Html$Styled$Attributes$autofocus_a0 = "autofocus", $rtfeldman$elm_css$Html$Styled$Attributes$autofocus = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$autofocus_a0);
    var $rtfeldman$elm_css$Html$Styled$code_a0 = "code", $rtfeldman$elm_css$Html$Styled$code = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$code_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1 = $rtfeldman$elm_css$Css$property_fn("grid-column-start", "1");
    var $elm_community$string_extra$String$Extra$countOccurrences_fn = function (needle, haystack) {
        return ((!$elm$core$String$length(needle)) || (!$elm$core$String$length(haystack))) ? 0 : $elm$core$List$length(_String_indexes_fn(needle, haystack));
    }, $elm_community$string_extra$String$Extra$countOccurrences = F2($elm_community$string_extra$String$Extra$countOccurrences_fn);
    var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
        return $elm$core$List$isEmpty(list) ? { pB: "none" } : {
            pB: $elm$core$String$join_fn(", ", list)
        };
    };
    var $rtfeldman$elm_css$Css$fontFamilies_a0 = $rtfeldman$elm_css$Css$prop1("font-family"), $rtfeldman$elm_css$Css$fontFamilies_a1 = $rtfeldman$elm_css$Css$stringsToValue, $rtfeldman$elm_css$Css$fontFamilies = A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$fontFamilies_a0, $rtfeldman$elm_css$Css$fontFamilies_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono = $rtfeldman$elm_css$Css$property_fn("font-family", "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace");
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
    var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme = $elm$core$Basics$identity;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex = function (a) {
        return { $: 1, a: a };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor = { $: 0 };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor = function (background) {
        return { dJ: background, c6: false, c7: false, ee: false, C: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis_fn = function (text, background) {
        return { dJ: background, c6: false, c7: false, ee: false, C: text };
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor = function (text) {
        return { dJ: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor, c6: false, c7: false, ee: false, C: text };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$requiredStyles = {
        dB: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#eaffea")),
        dU: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#969896")),
        d$: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#24292e"), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#ffffff")),
        d0: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#ffecec")),
        c4: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#fffbdd")),
        ex: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#005cc5")),
        ey: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#df5000")),
        ez: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#d73a49")),
        eA: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#0086b3")),
        eB: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#63a35c")),
        eC: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#005cc5")),
        eD: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex("#795da3"))
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$theme = { lX: _List_Nil, ox: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$requiredStyles };
    var $elm$core$List$intersperse_fn = function (sep, xs) {
        if (!xs.b) {
            return xs;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        end.b = _List_Cons(xs.a, _List_Nil);
        end = end.b;
        xs = xs.b;
        for (; xs.b; xs = xs.b) {
            var valNode = _List_Cons(xs.a, _List_Nil);
            var sepNode = _List_Cons(sep, valNode);
            end.b = sepNode;
            end = valNode;
        }
        return tmp.b;
    }, $elm$core$List$intersperse = F2($elm$core$List$intersperse_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment = function (a) {
        switch (a) {
            case 0:
                return _Utils_Tuple2(4, "css-ar-i");
            case 1:
                return _Utils_Tuple2(6, "css-ar-p");
            case 2:
                return _Utils_Tuple2(4, "css-ar-k");
            default:
                return _Utils_Tuple2(5, "css-ar-v");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment = function (att) {
        switch (att) {
            case 0:
                return _Utils_Tuple2(6, "css-s-a-an");
            case 1:
                return _Utils_Tuple2(3, "css-s-a-av");
            default:
                return _Utils_Tuple2(4, "css-s-a-o");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment = function (s) {
        switch (s.$) {
            case 0:
                return _Utils_Tuple2(4, "css-s-e");
            case 1:
                return _Utils_Tuple2(6, "css-s-i");
            case 2:
                return _Utils_Tuple2(6, "css-s-cl");
            case 3:
                return _Utils_Tuple2(8, "css-s-c");
            case 4:
                return _Utils_Tuple2(4, "css-s-u");
            case 5:
                var att = s.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment(att);
            case 6:
                return _Utils_Tuple2(0, "css-s-pe");
            default:
                return _Utils_Tuple2(0, "css-s-pc");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle = function (syntax) {
        switch (syntax.$) {
            case 0:
                return _Utils_Tuple2(3, "css-s");
            case 1:
                var a = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment(a);
            case 2:
                var s = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment(s);
            case 3:
                return _Utils_Tuple2(5, "css-p");
            case 4:
                return _Utils_Tuple2(5, "css-pv");
            case 5:
                return _Utils_Tuple2(2, "css-n");
            default:
                return _Utils_Tuple2(4, "css-u");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(3, "elm-s");
            case 1:
                return _Utils_Tuple2(4, "elm-bs");
            case 2:
                return _Utils_Tuple2(5, "elm-gs");
            case 3:
                return _Utils_Tuple2(7, "elm-c");
            case 4:
                return _Utils_Tuple2(4, "elm-k");
            case 5:
                return _Utils_Tuple2(6, "elm-f");
            case 6:
                return _Utils_Tuple2(5, "elm-ts");
            default:
                return _Utils_Tuple2(2, "elm-n");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(2, "js-n");
            case 1:
                return _Utils_Tuple2(3, "js-s");
            case 2:
                return _Utils_Tuple2(4, "js-k");
            case 3:
                return _Utils_Tuple2(5, "js-dk");
            case 4:
                return _Utils_Tuple2(5, "js-fe");
            case 5:
                return _Utils_Tuple2(6, "js-f");
            case 6:
                return _Utils_Tuple2(7, "js-lk");
            case 7:
                return _Utils_Tuple2(8, "js-p");
            default:
                return _Utils_Tuple2(6, "js-ce");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(2, "py-n");
            case 1:
                return _Utils_Tuple2(3, "py-s");
            case 2:
                return _Utils_Tuple2(4, "py-k");
            case 3:
                return _Utils_Tuple2(5, "py-dk");
            case 5:
                return _Utils_Tuple2(6, "py-f");
            case 6:
                return _Utils_Tuple2(7, "py-lk");
            case 7:
                return _Utils_Tuple2(8, "py-p");
            default:
                return _Utils_Tuple2(0, "py-fe");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(4, "xml-t");
            case 1:
                return _Utils_Tuple2(6, "xml-a");
            default:
                return _Utils_Tuple2(3, "xlm-av");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector = function (syntax) {
        switch (syntax.$) {
            case 0:
                var elmSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle(elmSyntax).b;
            case 1:
                var xmlSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle(xmlSyntax).b;
            case 2:
                var jsSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle(jsSyntax).b;
            case 3:
                var cssSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle(cssSyntax).b;
            case 4:
                var pythonSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle(pythonSyntax).b;
            case 5:
                var sqlSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle(sqlSyntax).b;
            default:
                var noLangSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle(noLangSyntax).b;
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors = function (syntaxes) {
        return $elm$core$String$concat($elm$core$List$intersperse_fn(", ", $elm$core$List$map_fn($elm$core$Basics$append(".elmsh-"), $elm$core$List$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector, syntaxes))));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss_fn = function (property, color) {
        switch (color.$) {
            case 0:
                return "";
            case 1:
                var hex = color.a;
                return property + (hex + ";");
            case 2:
                var r = color.a;
                var g = color.b;
                var b = color.c;
                return $elm$core$String$concat(_List_fromArray([
                    property,
                    "rgb(",
                    $elm$core$String$fromInt(r),
                    ", ",
                    $elm$core$String$fromInt(g),
                    ",",
                    $elm$core$String$fromInt(b),
                    ");"
                ]));
            default:
                var r = color.a;
                var g = color.b;
                var b = color.c;
                var a = color.d;
                return $elm$core$String$concat(_List_fromArray([
                    property,
                    "rgba(",
                    $elm$core$String$fromInt(r),
                    ", ",
                    $elm$core$String$fromInt(g),
                    ",",
                    $elm$core$String$fromInt(b),
                    ", ",
                    $elm$core$String$fromFloat(a),
                    ");"
                ]));
        }
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse_fn = function (bool, str) {
        return bool ? str : "";
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss = function (_v0) {
        var isBold = _v0.c6;
        var isItalic = _v0.c7;
        var isUnderline = _v0.ee;
        var text = _v0.C;
        var background = _v0.dJ;
        return $elm$core$String$concat(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse_fn(isBold, "font-weight: bold;"),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse_fn(isItalic, "font-style: italic;"),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse_fn(isUnderline, "text-decoration: underline;"),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss_fn("color: ", text),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss_fn("background: ", background)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass = function (_v0) {
        var selectors = _v0.a;
        var style = _v0.b;
        return $elm$core$String$isEmpty(selectors) ? "" : (selectors + (" {" + ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss(style) + "}")));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss = function (classes) {
        return $elm$core$String$concat($elm$core$List$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass, classes));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss = function (_v0) {
        var requiredStyles = _v0.ox;
        var customStyles = _v0.lX;
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss(_Utils_ap(_List_fromArray([
            _Utils_Tuple2(".elmsh", requiredStyles.d$),
            _Utils_Tuple2(".elmsh-hl", requiredStyles.c4),
            _Utils_Tuple2(".elmsh-add", requiredStyles.dB),
            _Utils_Tuple2(".elmsh-del", requiredStyles.d0),
            _Utils_Tuple2(".elmsh-comm", requiredStyles.dU),
            _Utils_Tuple2(".elmsh1", requiredStyles.ex),
            _Utils_Tuple2(".elmsh2", requiredStyles.ey),
            _Utils_Tuple2(".elmsh3", requiredStyles.ez),
            _Utils_Tuple2(".elmsh4", requiredStyles.eA),
            _Utils_Tuple2(".elmsh5", requiredStyles.eB),
            _Utils_Tuple2(".elmsh6", requiredStyles.eC),
            _Utils_Tuple2(".elmsh7", requiredStyles.eD)
        ]), $elm$core$List$map_fn($elm$core$Tuple$mapFirst($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors), customStyles)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$css = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$theme);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$gitHub = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$GitHub$css;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$gitHub = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$gitHub;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid = $rtfeldman$elm_css$Css$property_fn("display", "grid");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block = $rtfeldman$elm_css$Css$property_fn("display", "inline-block");
    var $elm_community$string_extra$String$Extra$replaceSlice_fn = function (substitution, start, end, string) {
        return _Utils_ap(_String_slice_fn(0, start, string), _Utils_ap(substitution, _String_slice_fn(end, $elm$core$String$length(string), string)));
    }, $elm_community$string_extra$String$Extra$replaceSlice = F4($elm_community$string_extra$String$Extra$replaceSlice_fn);
    var $elm_community$string_extra$String$Extra$insertAt_fn = function (insert, pos, string) {
        return $elm_community$string_extra$String$Extra$replaceSlice_fn(insert, pos, pos, string);
    }, $elm_community$string_extra$String$Extra$insertAt = F3($elm_community$string_extra$String$Extra$insertAt_fn);
    var $rtfeldman$elm_css$Css$minHeight_a0 = "min-height", $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$minHeight_a0);
    var $rtfeldman$elm_css$Html$Styled$Events$keyCode = _Json_decodeField_fn("keyCode", $elm$json$Json$Decode$int);
    var $elm$json$Json$Decode$map5 = _Json_map5;
    var $author$project$Util$onKeyDown = function (cfg) {
        var keyToMsg = function (_v2) {
            var key = _v2.a;
            var _v3 = _v2.b;
            var shift = _v3.a;
            var ctrlMeta = _v3.b;
            var cursorPosition = _v2.c;
            switch (key) {
                case 9:
                    var _v1 = cfg.kn;
                    if (!_v1.$) {
                        var callback = _v1.a;
                        return $elm$json$Json$Decode$succeed(_Utils_Tuple2(callback(cursorPosition), true));
                    }
                    else {
                        return $elm$json$Json$Decode$fail("");
                    }
                case 13:
                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Decode$fail(""), A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Tuple$pair, true), $elm$json$Json$Decode$succeed), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(ctrlMeta), cfg.kf), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always((!shift) && (!ctrlMeta)), cfg.kj)));
                case 27:
                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Decode$fail(""), A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Tuple$pair, true), $elm$json$Json$Decode$succeed), cfg.hH);
                default:
                    return $elm$json$Json$Decode$fail("");
            }
        };
        return $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("keydown", _Json_andThen_fn(keyToMsg, _Json_map5_fn(F5(function (key, ctrl, shift, meta, cursorPosition) {
            return _Utils_Tuple3(key, _Utils_Tuple2(shift, ctrl || meta), cursorPosition);
        }), $rtfeldman$elm_css$Html$Styled$Events$keyCode, _Json_decodeField_fn("ctrlKey", $elm$json$Json$Decode$bool), _Json_decodeField_fn("shiftKey", $elm$json$Json$Decode$bool), _Json_decodeField_fn("metaKey", $elm$json$Json$Decode$bool), $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "selectionStart"]), $elm$json$Json$Decode$int),
            $elm$json$Json$Decode$succeed(0)
        ])))));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_30 = $rtfeldman$elm_css$Css$property_fn("opacity", "0.3");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto = $rtfeldman$elm_css$Css$property_fn("overflow", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_14 = $rtfeldman$elm_css$Css$property_fn("padding-left", "3.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_3 = $rtfeldman$elm_css$Css$property_fn("padding-right", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_4 = $rtfeldman$elm_css$Css$property_fn("padding-right", "1rem");
    var $rtfeldman$elm_css$Html$Styled$pre_a0 = "pre", $rtfeldman$elm_css$Html$Styled$pre = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$pre_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$resize_none = $rtfeldman$elm_css$Css$property_fn("resize", "none");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1 = $rtfeldman$elm_css$Css$property_fn("grid-row-start", "1");
    var $rtfeldman$elm_css$Html$Styled$Attributes$rows = function (n) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("rows", $elm$core$String$fromInt(n));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right = $rtfeldman$elm_css$Css$property_fn("text-align", "right");
    var $rtfeldman$elm_css$Html$Styled$textarea_a0 = "textarea", $rtfeldman$elm_css$Html$Styled$textarea = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$textarea_a0);
    var $elm$html$Html$Attributes$stringProperty_fn = function (key, string) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$string(string));
    }, $elm$html$Html$Attributes$stringProperty = F2($elm$html$Html$Attributes$stringProperty_fn);
    var $elm$html$Html$Attributes$class_a0 = "className", $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$class_a0);
    var $elm$html$Html$code = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "code"), $elm$html$Html$code_fn = $elm$html$Html$code.a2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Add = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Del = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Normal = 0;
    var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
    var $elm$html$Html$Attributes$classList = function (classes) {
        return $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", $elm$core$List$map_fn($elm$core$Tuple$first, $elm$core$List$filter_fn($elm$core$Tuple$second, classes))));
    };
    var $elm$html$Html$div = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "div"), $elm$html$Html$div_fn = $elm$html$Html$div.a2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString = function (required) {
        return "elmsh" + function () {
            switch (required) {
                case 0:
                    return "0";
                case 1:
                    return "-comm";
                case 2:
                    return "1";
                case 3:
                    return "2";
                case 4:
                    return "3";
                case 5:
                    return "4";
                case 6:
                    return "5";
                case 7:
                    return "6";
                default:
                    return "7";
            }
        }();
    };
    var $elm$html$Html$span = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "span"), $elm$html$Html$span_fn = $elm$html$Html$span.a2;
    var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView = function (_v0) {
        var text = _v0.C;
        var requiredStyle = _v0.ow;
        var additionalClass = _v0.lq;
        return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : $elm$html$Html$span_fn(_List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString(requiredStyle), !(!requiredStyle)),
                _Utils_Tuple2("elmsh-" + additionalClass, additionalClass !== "")
            ]))
        ]), _List_fromArray([
            $elm$html$Html$text(text)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView_fn = function (start, index, _v0) {
        var fragments = _v0.mA;
        var highlight = _v0.c4;
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2("elmsh-line", true),
                _Utils_Tuple2("elmsh-hl", _Utils_eq(highlight, $elm$core$Maybe$Just(0))),
                _Utils_Tuple2("elmsh-add", _Utils_eq(highlight, $elm$core$Maybe$Just(1))),
                _Utils_Tuple2("elmsh-del", _Utils_eq(highlight, $elm$core$Maybe$Just(2)))
            ])),
            $elm$virtual_dom$VirtualDom$attribute_fn("data-elmsh-lc", $elm$core$String$fromInt(start + index))
        ]), $elm$core$List$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView_fn);
    var $elm$html$Html$pre = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "pre"), $elm$html$Html$pre_fn = $elm$html$Html$pre.a2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml = function (lines) {
        return $elm$html$Html$code_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "elmsh")
        ]), $elm$core$List$concat($elm$core$List$map_fn(function (_v0) {
            var highlight = _v0.c4;
            var fragments = _v0.mA;
            return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? $elm$core$List$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray([
                $elm$html$Html$span_fn(_List_fromArray([
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2("elmsh-hl", _Utils_eq(highlight, $elm$core$Maybe$Just(0))),
                        _Utils_Tuple2("elmsh-add", _Utils_eq(highlight, $elm$core$Maybe$Just(1))),
                        _Utils_Tuple2("elmsh-del", _Utils_eq(highlight, $elm$core$Maybe$Just(2)))
                    ]))
                ]), $elm$core$List$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments))
            ]);
        }, lines)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml_fn = function (maybeStart, lines) {
        if (maybeStart.$ === 1) {
            return $elm$html$Html$pre_fn(_List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "elmsh")
            ]), _List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml(lines)
            ]));
        }
        else {
            var start = maybeStart.a;
            return $elm$html$Html$pre_fn(_List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "elmsh")
            ]), $elm$core$List$singleton($elm$html$Html$code_fn(_List_Nil, $elm$core$List$indexedMap_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView(start), lines))));
        }
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml_fn = function (maybeStart, _v0) {
        var lines = _v0;
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml_fn(maybeStart, lines);
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml_fn);
    var $elm$virtual_dom$VirtualDom$node = function (tag) {
        return _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, _VirtualDom_noScript(tag));
    };
    var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme = function (_v0) {
        var theme = _v0;
        return A3($elm$html$Html$node, "style", _List_Nil, _List_fromArray([
            $elm$html$Html$text(theme)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_10 = $rtfeldman$elm_css$Css$property_fn("width", "2.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre = $rtfeldman$elm_css$Css$property_fn("white-space", "pre");
    var $author$project$Components$Editor$viewBase_fn = function (styles, maybeToMsg, maybeOnCtrlMetaEnter, model) {
        var commonStyles = _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_3,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $rtfeldman$elm_css$Css$batch(styles),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, (model.ei * 1.25) + 1)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                $rtfeldman$elm_css$Css$property_fn("scroll-padding-left", "4em")
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$batch(commonStyles),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$selector_fn(".elmsh-line:before", _List_fromArray([
                            $rtfeldman$elm_css$Css$property_fn("content", "attr(data-elmsh-lc)"),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_10,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_4,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_30
                        ])),
                        $rtfeldman$elm_css$Css$Global$selector_fn(".elmsh code", _List_fromArray([
                            $elm$core$Basics$composeL_fn($rtfeldman$elm_css$Css$fontFamilies_a0, $rtfeldman$elm_css$Css$fontFamilies_a1, _List_fromArray(["ui-monospace", "SFMono-Regular", "Menlo", "Monaco", "Consolas", "Liberation Mono", "Courier New", "monospace !important"]))
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$fromUnstyled($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$gitHub)),
                $elm$core$Result$withDefault_fn($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$pre_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(model.gB)
                    ]))
                ])), $elm$core$Result$map_fn($rtfeldman$elm_css$Html$Styled$fromUnstyled, $elm$core$Result$map_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml($elm$core$Maybe$Just(1)), model.fQ(model.gB))))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$textarea_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$rows($elm$core$Basics$max_fn(model.ei, $elm_community$string_extra$String$Extra$countOccurrences_fn("\n", model.gB))),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.gB),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, function (toMsg) {
                    return $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, toMsg, $author$project$Components$Editor$ContentTyped(model.dY)));
                }, maybeToMsg),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$autofocus_a0, true),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                $rtfeldman$elm_css$VirtualDom$Styled$property_fn("selectionEnd", $elm$json$Json$Encode$string($elm$core$String$fromInt(model.dY))),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("data-gramm", "false"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("data-gramm_editor", "false"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("data-enable-grammarly", "false"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$batch(commonStyles),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_14,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$resize_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $rtfeldman$elm_css$Css$property_fn("caret-color", "black")
                ])),
                $author$project$Util$onKeyDown({
                    kf: maybeOnCtrlMetaEnter,
                    kj: $elm$core$Maybe$Nothing,
                    hH: $elm$core$Maybe$Nothing,
                    kn: $elm$core$Maybe$map_fn(function (toMsg) {
                        return function (cursorPos) {
                            return toMsg($author$project$Components$Editor$ContentTyped_fn(cursorPos + 2, $elm_community$string_extra$String$Extra$insertAt_fn("  ", cursorPos, model.gB)));
                        };
                    }, maybeToMsg)
                })
            ]), _List_Nil)
        ]));
    }, $author$project$Components$Editor$viewBase = F4($author$project$Components$Editor$viewBase_fn);
    var $author$project$Components$Editor$view_fn = function (styles, toMsg, onCtrlMetaEnter, model) {
        return $author$project$Components$Editor$viewBase_fn(styles, $elm$core$Maybe$Just(toMsg), $elm$core$Maybe$Just(onCtrlMetaEnter), model);
    }, $author$project$Components$Editor$view = F4($author$project$Components$Editor$view_fn);
    var $rtfeldman$elm_css$Css$VwUnits = 0;
    var $rtfeldman$elm_css$Css$vw_a0 = 0, $rtfeldman$elm_css$Css$vw_a1 = "vw", $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5 = $rtfeldman$elm_css$Css$property_fn("width", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6 = $rtfeldman$elm_css$Css$property_fn("width", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_none = $rtfeldman$elm_css$Css$property_fn("line-height", "1");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_4 = $rtfeldman$elm_css$Css$property_fn("left", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("top", "-0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5 = $rtfeldman$elm_css$Css$property_fn("padding-top", "0.375rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_0_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.125rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.125rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_4 = $rtfeldman$elm_css$Css$property_fn("right", "1rem");
    var $author$project$Components$wrapWithLabel_fn = function (cfg, element) {
        var toLabel = F2(function (label_, leftRightStyle) {
            return (label_ === "") ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_0_dot_5,
                    leftRightStyle,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_0_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                    $rtfeldman$elm_css$Css$batch(cfg.jU)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(label_)
            ]));
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            element,
            A2(toLabel, cfg.jS, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_4),
            A2(toLabel, cfg.jT, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_4)
        ]));
    }, $author$project$Components$wrapWithLabel = F2($author$project$Components$wrapWithLabel_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default = $rtfeldman$elm_css$Css$property_fn("cursor", "default");
    var $author$project$Components$wrapWithSpinner_fn = function (styles, spinner, element) {
        return spinner ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
        ]), _List_fromArray([
            $author$project$Svg$spinner(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, styles))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ]), _List_fromArray([element]))
        ])) : element;
    }, $author$project$Components$wrapWithSpinner = F3($author$project$Components$wrapWithSpinner_fn);
    var $author$project$Components$EditorTitledOverlay$editorView = function (model) {
        var toolbar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(model.fx)
            ])),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$closeCircled,
                a_: $author$project$Components$EditorTitledOverlay$Closed,
                m: _List_Nil,
                bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
            })
        ]));
        var toDialog = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 66)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 28)),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 32))
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $author$project$Theme$theme.of
            ]))
        ]));
        var toContent = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]));
        var titleInput = $author$project$Components$wrapWithLabel_fn({ jS: model.gc, jT: "", jU: _List_Nil, m: _List_Nil }, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.eM),
            $rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$EditorTitledOverlay$TitleTyped),
            $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
            ]))
        ]), _List_Nil));
        var confirmButton = function (cfg_) {
            return $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6]), cfg_.h5, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.kW,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $rtfeldman$elm_css$Css$batch(cfg_.m)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg_.a_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg_.cd)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg_.eM)
            ])));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, A3($author$project$Components$backdrop, "editor", $elm$core$Maybe$Just($author$project$Components$EditorTitledOverlay$Applied), _List_fromArray([
            toDialog(_List_fromArray([
                toolbar,
                toContent(_List_fromArray([
                    titleInput,
                    $author$project$Components$wrapWithLabel_fn({
                        jS: model.fi,
                        jT: "",
                        jU: _List_Nil,
                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_auto])
                    }, $author$project$Components$Editor$view_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full]), $author$project$Components$EditorTitledOverlay$EditorMsg, $author$project$Components$EditorTitledOverlay$Applied, model.gO)),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                    ]), _List_fromArray([
                        $author$project$Components$textButton_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]), "Cancel", $author$project$Components$EditorTitledOverlay$Closed),
                        confirmButton({
                            cd: $author$project$Components$EditorTitledOverlay$hasEmptyFields(model) || ($author$project$Components$EditorTitledOverlay$unchanged(model) || model.la),
                            a_: $author$project$Components$EditorTitledOverlay$Applied,
                            h5: model.la,
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12]),
                            eM: "Save"
                        })
                    ]))
                ]))
            ]))
        ])));
    };
    var $author$project$Overlay$showCentered_fn = function (view_, model) {
        return _Utils_update(model, {
            a$: $elm$core$Maybe$Just({
                cb: $elm$core$Platform$Cmd$none,
                bR: "custom-overlay",
                b_: $elm$core$Maybe$Nothing,
                b$: true,
                cH: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_out]),
                ay: _List_fromArray([view_]),
                it: $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$fixed, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "custom-overlay-wrapper"),
                    $author$project$Util$onClickWithId_fn("custom-overlay-wrapper", model.gd($author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)))
                ])),
                pH: 0,
                pJ: 0
            })
        });
    }, $author$project$Overlay$showCentered = F2($author$project$Overlay$showCentered_fn);
    var $author$project$Components$EditorTitledOverlay$initOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$showCentered_fn($author$project$Components$EditorTitledOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$EditorTitledOverlay$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Components$EditorTitledOverlay$setUpdating = F2($author$project$Components$EditorTitledOverlay$setUpdating_fn);
    var $author$project$Components$Editor$update_fn = function (msg, model) {
        var cursorPosition = msg.a;
        var content = msg.b;
        return _Utils_update(model, {
            gB: $elm$core$String$replace_fn("\t", "  ", content),
            dY: cursorPosition
        });
    }, $author$project$Components$Editor$update = F2($author$project$Components$Editor$update_fn);
    var $author$project$Overlay$updateView_fn = function (view_, model) {
        var _v0 = model.a$;
        if (_v0.$ === 1) {
            return model;
        }
        else {
            var overlay = _v0.a;
            return _Utils_update(model, {
                a$: $elm$core$Maybe$Just(_Utils_update(overlay, {
                    ay: _List_fromArray([view_])
                }))
            });
        }
    }, $author$project$Overlay$updateView = F2($author$project$Overlay$updateView_fn);
    var $author$project$Components$EditorTitledOverlay$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$EditorTitledOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Util$withModel_fn = function (fn, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(fn(model), cmd);
    }, $author$project$Util$withModel = F2($author$project$Util$withModel_fn);
    var $author$project$Components$EditorTitledOverlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$initOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                return $author$project$Components$EditorTitledOverlay$unchanged(model) ? $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : ($author$project$Components$EditorTitledOverlay$hasEmptyFields(model) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $author$project$Util$withCmd_fn(A2(model.bC, { gB: model.gO.gB, eM: model.eM }, $author$project$Components$EditorTitledOverlay$Responded), $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
            case 3:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$closeOverlay, $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
            case 4:
                var title = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { eM: title }), $elm$core$Platform$Cmd$none));
            case 5:
                var editorMsg = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$EditorTitledOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, {
                    gO: $author$project$Components$Editor$update_fn(editorMsg, model.gO)
                }), $elm$core$Platform$Cmd$none));
            default:
                var overlayMsg = msg.a;
                var _v2 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Components$EditorTitledOverlay$update = F2($author$project$Components$EditorTitledOverlay$update_fn);
    var $author$project$Pages$Admin$Settings$update_fn = function (onError, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var route = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setAdminRoute_fn($author$project$Pages$Admin$Route$setSettingsRoute(route), shared.eu)));
            case 1:
                var maybeSubRoute = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Admin$Settings$setActiveRoute(maybeSubRoute), $krisajenkins$remotedata$RemoteData$isNotAsked(model.kR) ? _Utils_Tuple2(_Utils_update(model, { kR: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getServerSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$Settings$SettingsLoaded), shared.k2)) : (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $author$project$Util$restoreActiveRoute({
                    dx: model.dx,
                    lo: $elm$core$Basics$always(_List_Nil),
                    ma: $elm$core$Maybe$Just(0),
                    ol: A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$setAdminSettingsRoute, shared.eu), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteTo, toSharedCmd))),
                    ou: A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$Navigated, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))
                })) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 2:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        aL: $author$project$Types$ServerSettings$setAllowedHosts_fn(settings, settings.iD)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), A2(onError, $elm$core$Maybe$Nothing, errors));
                }
            case 3:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        eT: _List_Nil
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { eT: errors }), A2(onError, $elm$core$Maybe$Nothing, errors));
                }
            case 4:
                var settingsEdit = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { aL: settingsEdit }), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(model, $author$project$Api$setServerSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$Settings$SettingsUpdated), shared.k2, model.aL));
            case 6:
                var maybeEnvVar = msg.a;
                var overlay = function () {
                    var envVarsWithoutSelected = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$neq(maybeEnvVar)), model.aL.gQ);
                    var isUniqueByNameValue = function (envVar) {
                        return $elm_community$maybe_extra$Maybe$Extra$isNothing($elm_community$list_extra$List$Extra$find_fn(function (_v2) {
                            var name = _v2.M;
                            var value = _v2.pB;
                            return _Utils_eq(name, envVar.M) && _Utils_eq(value, envVar.pB);
                        }, envVarsWithoutSelected));
                    };
                    return $author$project$Components$EditorTitledOverlay$init({
                        gB: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.pB;
                        }, maybeEnvVar),
                        fi: "value",
                        fx: "Set Environment Variable",
                        bC: F2(function (state, _v1) {
                            return $elm$core$Platform$Cmd$batch($elm$core$List$append_fn(_List_fromArray([
                                $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Admin$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Closed))
                            ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $elm$core$List$append(envVarsWithoutSelected), A2($elm$core$Basics$composeR, $author$project$Types$ServerSettings$setEnvVars(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$SettingsEditModified, $author$project$Util$msgCmd)))), $elm_community$maybe_extra$Maybe$Extra$filter_fn(isUniqueByNameValue, $elm$core$Maybe$Just($author$project$Types$EnvironmentVariable$EnvironmentVariable_fn("", state.eM, state.gB)))))));
                        }),
                        nT: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        fM: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        eM: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.M;
                        }, maybeEnvVar),
                        gc: "key",
                        gd: $author$project$Pages$Admin$Settings$EnvEditorOverlayMsg
                    });
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    a$: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Admin$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Opened))));
            default:
                var subMsg = msg.a;
                var _v3 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond($elm$core$Platform$Cmd$map(toMsg)), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$EditorTitledOverlay$update(subMsg), model.a$))));
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Pages$Admin$Settings$update_fn_unwrapped = function (onError, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var route = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setAdminRoute_fn($author$project$Pages$Admin$Route$setSettingsRoute(route), shared.eu)));
            case 1:
                var maybeSubRoute = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Admin$Settings$setActiveRoute(maybeSubRoute), $krisajenkins$remotedata$RemoteData$isNotAsked(model.kR) ? _Utils_Tuple2(_Utils_update(model, { kR: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getServerSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$Settings$SettingsLoaded), shared.k2)) : (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $author$project$Util$restoreActiveRoute({
                    dx: model.dx,
                    lo: $elm$core$Basics$always(_List_Nil),
                    ma: $elm$core$Maybe$Just(0),
                    ol: A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$setAdminSettingsRoute, shared.eu), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteTo, toSharedCmd))),
                    ou: A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$Navigated, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))
                })) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 2:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        aL: $author$project$Types$ServerSettings$setAllowedHosts_fn(settings, settings.iD)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), onError($elm$core$Maybe$Nothing, errors));
                }
            case 3:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        eT: _List_Nil
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { eT: errors }), onError($elm$core$Maybe$Nothing, errors));
                }
            case 4:
                var settingsEdit = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { aL: settingsEdit }), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(model, $author$project$Api$setServerSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$Settings$SettingsUpdated), shared.k2, model.aL));
            case 6:
                var maybeEnvVar = msg.a;
                var overlay = function () {
                    var envVarsWithoutSelected = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$neq(maybeEnvVar)), model.aL.gQ);
                    var isUniqueByNameValue = function (envVar) {
                        return $elm_community$maybe_extra$Maybe$Extra$isNothing($elm_community$list_extra$List$Extra$find_fn(function (_v2) {
                            var name = _v2.M;
                            var value = _v2.pB;
                            return _Utils_eq(name, envVar.M) && _Utils_eq(value, envVar.pB);
                        }, envVarsWithoutSelected));
                    };
                    return $author$project$Components$EditorTitledOverlay$init({
                        gB: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.pB;
                        }, maybeEnvVar),
                        fi: "value",
                        fx: "Set Environment Variable",
                        bC: F2(function (state, _v1) {
                            return $elm$core$Platform$Cmd$batch($elm$core$List$append_fn(_List_fromArray([
                                $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Admin$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Closed))
                            ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $elm$core$List$append(envVarsWithoutSelected), A2($elm$core$Basics$composeR, $author$project$Types$ServerSettings$setEnvVars(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$SettingsEditModified, $author$project$Util$msgCmd)))), $elm_community$maybe_extra$Maybe$Extra$filter_fn(isUniqueByNameValue, $elm$core$Maybe$Just($author$project$Types$EnvironmentVariable$EnvironmentVariable_fn("", state.eM, state.gB)))))));
                        }),
                        nT: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        fM: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        eM: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.M;
                        }, maybeEnvVar),
                        gc: "key",
                        gd: $author$project$Pages$Admin$Settings$EnvEditorOverlayMsg
                    });
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    a$: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Admin$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Opened))));
            default:
                var subMsg = msg.a;
                var _v3 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond($elm$core$Platform$Cmd$map(toMsg)), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$EditorTitledOverlay$update(subMsg), model.a$))));
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Pages$Admin$Settings$update = F6($author$project$Pages$Admin$Settings$update_fn);
    var $author$project$Pages$Admin$update_fn = function (onError, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 3:
                var route = msg.a;
                switch (route.$) {
                    case 0:
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 1:
                        return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Admin$DatabasePageMsgReceived($author$project$Pages$Admin$Databases$routed))));
                    case 2:
                        var maybeSubRoute = route.a;
                        return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Admin$SettingsPageMsgReceived($author$project$Pages$Admin$Settings$routed(maybeSubRoute)))));
                    default:
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 0:
                var subMsg = msg.a;
                var _v2 = $author$project$Pages$Admin$Databases$update_fn({
                    gd: A2($elm$core$Basics$composeR, $author$project$Pages$Admin$DatabasePageMsgReceived, toMsg)
                }, subMsg, shared, model.dZ);
                var subModel = _v2.a;
                var subCmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { dZ: subModel }), subCmd);
            case 1:
                var subMsg = msg.a;
                var _v3 = $author$project$Pages$Admin$Settings$update_fn(onError, toSharedCmd, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$SettingsPageMsgReceived), subMsg, shared, model.hY);
                var subModel = _v3.a;
                var subCmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { hY: subModel }), subCmd);
            default:
                var subMsg = msg.a;
                var _v4 = $author$project$Components$Billing$update_fn(subMsg, model.dP);
                var subModel = _v4.a;
                var subCmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, { dP: subModel }), subCmd);
        }
    }, $author$project$Pages$Admin$update = F6($author$project$Pages$Admin$update_fn);
    var $author$project$Pages$Apps$DeleteAppResponded_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $author$project$Pages$Apps$DeleteAppResponded = F2($author$project$Pages$Apps$DeleteAppResponded_fn);
    var $author$project$Pages$Apps$NavigateReplace = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Apps$UploadSelected_fn = function (a, b, c) {
        return { $: 9, a: a, b: b, c: c };
    }, $author$project$Pages$Apps$UploadSelected = F3($author$project$Pages$Apps$UploadSelected_fn);
    var $author$project$Pages$Apps$Uploaded = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Pages$Apps$AddAppMsg_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Pages$Apps$AddAppMsg = F2($author$project$Pages$Apps$AddAppMsg_fn);
    var $author$project$Pages$Apps$AppReceived = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Types$App$App_fn = function (name, latestVersion, versions) {
        return { m2: latestVersion, M: name, le: versions };
    }, $author$project$Types$App$App = F3($author$project$Types$App$App_fn);
    var $author$project$Types$App$decode = _Json_map3_fn($author$project$Types$App$App, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), _Json_decodeField_fn("latestVersion", $elm$json$Json$Decode$string), _Json_decodeField_fn("versions", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
    var $author$project$Api$createApp_fn = function (msg, maybeToken, dbId, name) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("name", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn("New App", name)))
            ]))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$App$decode),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/apps")
        });
    }, $author$project$Api$createApp = F4($author$project$Api$createApp_fn);
    var $author$project$Components$InputRequester$OverlayMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Components$InputRequester$init = function (cfg) {
        return {
            ln: cfg.ln,
            bC: cfg.bC,
            nT: cfg.nT,
            fM: cfg.fM,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$InputRequester$OverlayMsg, cfg.gd)),
            kt: cfg.kt,
            df: cfg.df,
            h7: "",
            gd: cfg.gd,
            la: false
        };
    };
    var $author$project$Pages$Apps$addAppNameRequester_fn = function (shared, dbId) {
        return $author$project$Components$InputRequester$init({
            ln: "Add",
            bC: F2(function (state, inputReqMsg) {
                return $author$project$Api$createApp_fn(A2($elm$core$Basics$composeR, inputReqMsg, $author$project$Pages$Apps$AddAppMsg(dbId)), shared.k2, dbId, $elm$core$Maybe$Just(state));
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, $author$project$Pages$Apps$AppReceived, $author$project$Util$msgCmd)),
            fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Apps$AppReceived, $author$project$Util$msgCmd)),
            kt: $elm$core$Maybe$Nothing,
            df: "App Name",
            gd: $author$project$Pages$Apps$AddAppMsg(dbId)
        });
    }, $author$project$Pages$Apps$addAppNameRequester = F2($author$project$Pages$Apps$addAppNameRequester_fn);
    var $author$project$Api$deleteApp_fn = function (msg, maybeToken, dbId, app) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(app)),
            f: "DELETE",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/apps/" + $elm$url$Url$percentEncode(app.M)))
        });
    }, $author$project$Api$deleteApp = F4($author$project$Api$deleteApp_fn);
    var $author$project$Pages$Apps$getAppByName = function (model) {
        return $elm$core$Maybe$andThen_fn($elm_community$list_extra$List$Extra$find(A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(model.dG)))), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.lz));
    };
    var $author$project$Pages$Apps$mergeUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: model.la || updating });
    }, $author$project$Pages$Apps$mergeUpdating = F2($author$project$Pages$Apps$mergeUpdating_fn);
    var $author$project$Pages$Apps$RenameAppMsg_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $author$project$Pages$Apps$RenameAppMsg = F3($author$project$Pages$Apps$RenameAppMsg_fn);
    var $author$project$Types$App$encode = function (app) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(app.M))
        ]));
    };
    var $author$project$Api$saveApp_fn = function (msg, maybeToken, dbId, app) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$App$encode(app)),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(app)),
            f: "PATCH",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/apps/" + $elm$url$Url$percentEncode(app.M)))
        });
    }, $author$project$Api$saveApp = F4($author$project$Api$saveApp_fn);
    var $author$project$Pages$Apps$renameAppNameRequester_fn = function (shared, dbId, app) {
        return $author$project$Components$InputRequester$init({
            ln: "Rename",
            bC: F2(function (state, inputReqMsg) {
                return $author$project$Api$saveApp_fn(A2($elm$core$Basics$composeR, inputReqMsg, A2($author$project$Pages$Apps$RenameAppMsg, app, dbId)), shared.k2, dbId, _Utils_update(app, { M: state }));
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, $author$project$Pages$Apps$AppReceived, $author$project$Util$msgCmd)),
            fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Apps$AppReceived, $author$project$Util$msgCmd)),
            kt: $elm$core$Maybe$Nothing,
            df: "App Name",
            gd: A2($author$project$Pages$Apps$RenameAppMsg, app, dbId)
        });
    }, $author$project$Pages$Apps$renameAppNameRequester = F3($author$project$Pages$Apps$renameAppNameRequester_fn);
    var $author$project$Pages$Apps$AppsReceived_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Pages$Apps$AppsReceived = F2($author$project$Pages$Apps$AppsReceived_fn);
    var $author$project$Api$getApps_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("apps", $elm$json$Json$Decode$list($author$project$Types$App$decode))),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/apps")
        });
    }, $author$project$Api$getApps = F3($author$project$Api$getApps_fn);
    var $author$project$Pages$Apps$requireApps_fn = function (shared, dbId, model) {
        var appsLoading = $krisajenkins$remotedata$RemoteData$isLoading(model.lz);
        var appsLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(model.lz);
        return (appsLoaded || appsLoading) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, { lz: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getApps_fn($author$project$Pages$Apps$AppsReceived(dbId), shared.k2, dbId));
    }, $author$project$Pages$Apps$requireApps = F3($author$project$Pages$Apps$requireApps_fn);
    var $author$project$Pages$Apps$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Pages$Apps$setUpdating = F2($author$project$Pages$Apps$setUpdating_fn);
    var $author$project$Components$InputRequester$Responded = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$InputRequester$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$InputRequester$Applied = { $: 3 };
    var $author$project$Components$InputRequester$Canceled = { $: 1 };
    var $author$project$Components$InputRequester$Updated = function (a) {
        return { $: 2, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "59", "130", "246", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "37", "99", "235", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $rtfeldman$elm_css$Html$Styled$fieldset_a0 = "fieldset", $rtfeldman$elm_css$Html$Styled$fieldset = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$fieldset_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto = $rtfeldman$elm_css$Css$property_fn("margin-left", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4 = $rtfeldman$elm_css$Css$property_fn("margin-top", "1rem");
    var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
        return _Utils_Tuple2(msg, true);
    };
    var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("submit", _Json_map1_fn($rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault, $elm$json$Json$Decode$succeed(msg)));
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0 = "pattern", $rtfeldman$elm_css$Html$Styled$Attributes$pattern = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0);
    var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0 = "placeholder", $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0.375rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_md = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow", "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow-colored", "0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color)"),
        $rtfeldman$elm_css$Css$property_fn("box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ]));
    var $author$project$Util$showElement_fn = function (condition, element) {
        return condition ? element : $rtfeldman$elm_css$Html$Styled$text("");
    }, $author$project$Util$showElement = F2($author$project$Util$showElement_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4 = $rtfeldman$elm_css$Css$property_fn("width", "1rem");
    var $author$project$Components$inputRequester = function (cfg) {
        var input_ = F5(function (title, pattern_, value_, setter_, styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "custom-overlay-focus"),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0, title),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$pattern, pattern_),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.fu,
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, cfg.fN, setter_))
            ]), _List_Nil);
        });
        var button_ = F2(function (title, attributes) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$focus(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ])), attributes), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]));
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onSubmit(cfg.bC)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_prose,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg.la)
            ]), _List_fromArray([
                A5(input_, cfg.df, cfg.kt, cfg.h7, cfg.hX, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ]), _List_fromArray([
                    A2(button_, "Cancel", _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
                        $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.ek)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto]))
                    ]), _List_fromArray([
                        A2(button_, cfg.ln, _List_Nil),
                        $author$project$Util$showElement_fn(cfg.la, $author$project$Svg$spinner(_List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4]))
                        ])))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$InputRequester$inputRequester = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, $author$project$Components$inputRequester({ ln: model.ln, bC: $author$project$Components$InputRequester$Applied, ek: $author$project$Components$InputRequester$Canceled, fN: $author$project$Components$InputRequester$Updated, kt: model.kt, df: model.df, hX: $elm$core$Basics$identity, h7: model.h7, la: model.la }));
    };
    var $author$project$Overlay$focusId = "custom-overlay-focus";
    var $author$project$Overlay$positionMapperBelow_fn = function (element, trigger) {
        return $author$project$Overlay$Position_fn((element.pH + (trigger.bq / 2)) - (element.bq / 2), (element.pJ + trigger.ck) + 5);
    }, $author$project$Overlay$positionMapperBelow = F2($author$project$Overlay$positionMapperBelow_fn);
    var $author$project$Overlay$showBelow_fn = function (view_, model) {
        return _Utils_update(model, {
            a$: $elm$core$Maybe$Just({
                cb: $elm$core$Task$attempt_fn(function (_v0) {
                    return model.gd($author$project$Overlay$OverlayFocused);
                }, _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, $author$project$Overlay$focusId)),
                bR: "custom-overlay",
                b_: $elm$core$Maybe$Just($author$project$Overlay$positionMapperBelow),
                b$: false,
                cH: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_out]),
                ay: _List_fromArray([view_]),
                it: A2($elm$core$Basics$composeR, $elm$core$List$head, $elm$core$Maybe$withDefault($rtfeldman$elm_css$Html$Styled$text(""))),
                pH: 0,
                pJ: 0
            })
        });
    }, $author$project$Overlay$showBelow = F2($author$project$Overlay$showBelow_fn);
    var $author$project$Components$InputRequester$initOverlay_fn = function (elementId, model) {
        return $author$project$Overlay$setOrigin_fn($elm$core$Basics$identity, elementId, $author$project$Overlay$showBelow_fn($author$project$Components$InputRequester$inputRequester(model), model.a$));
    }, $author$project$Components$InputRequester$initOverlay = F2($author$project$Components$InputRequester$initOverlay_fn);
    var $author$project$Components$InputRequester$setState_fn = function (state, model) {
        return _Utils_update(model, { h7: state });
    }, $author$project$Components$InputRequester$setState = F2($author$project$Components$InputRequester$setState_fn);
    var $author$project$Components$InputRequester$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Components$InputRequester$setUpdating = F2($author$project$Components$InputRequester$setUpdating_fn);
    var $author$project$Components$InputRequester$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$InputRequester$inputRequester(model), model.a$)
        });
    };
    var $author$project$Util$withCmdFromModel_fn = function (fn, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            fn(model),
            cmd
        ])));
    }, $author$project$Util$withCmdFromModel = F2($author$project$Util$withCmdFromModel_fn);
    var $author$project$Components$InputRequester$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                var elementId = msg.a;
                return $author$project$Util$withCmdFromModel_fn($author$project$Components$InputRequester$initOverlay(elementId), $author$project$Util$withModel_fn($author$project$Components$InputRequester$setState(""), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$InputRequester$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                var state = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$InputRequester$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$InputRequester$setState(state), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 3:
                return $author$project$Util$withCmd_fn(A2(model.bC, model.h7, $author$project$Components$InputRequester$Responded), $author$project$Util$withModel_fn($author$project$Components$InputRequester$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$InputRequester$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 4:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$InputRequester$closeOverlay, $author$project$Util$withModel_fn($author$project$Components$InputRequester$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$InputRequester$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$InputRequester$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
            default:
                var overlayMsg = msg.a;
                var _v2 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Components$InputRequester$update = F2($author$project$Components$InputRequester$update_fn);
    var $elm_community$list_extra$List$Extra$findMap_fn = function (f, list) {
        findMap: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var a = list.a;
                var tail = list.b;
                var _v1 = f(a);
                if (!_v1.$) {
                    var b = _v1.a;
                    return $elm$core$Maybe$Just(b);
                }
                else {
                    var $temp$f = f, $temp$list = tail;
                    f = $temp$f;
                    list = $temp$list;
                    continue findMap;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$findMap = F2($elm_community$list_extra$List$Extra$findMap_fn);
    var $author$project$Util$updateAndThenOneOf_fn = function (fns, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(model, cmd), $elm_community$list_extra$List$Extra$findMap_fn(function (fn) {
            var _v1 = fn(model);
            var model_ = _v1.a;
            var cmd_ = _v1.b;
            return _Utils_eq(cmd_, $elm$core$Platform$Cmd$none) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple2(model_, cmd_));
        }, fns));
    }, $author$project$Util$updateAndThenOneOf = F2($author$project$Util$updateAndThenOneOf_fn);
    var $author$project$Pages$Apps$updateApp_fn = function (app, model) {
        return _Utils_update(model, {
            lz: $krisajenkins$remotedata$RemoteData$map_fn(A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
                return $.M;
            }, $elm$core$Basics$eq(app.M)), $elm$core$Basics$always(app)), model.lz)
        });
    }, $author$project$Pages$Apps$updateApp = F2($author$project$Pages$Apps$updateApp_fn);
    var $author$project$Api$uploadApp_fn = function (msg, maybeToken, dbId, id, file) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$multipartBody(_List_fromArray([
                _Http_pair_fn("app", file)
            ])),
            e: A2($author$project$Api$expect, msg, $author$project$Types$App$decode),
            f: "PUT",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/apps/" + $elm$url$Url$percentEncode(id)))
        });
    }, $author$project$Api$uploadApp = F5($author$project$Api$uploadApp_fn);
    var $author$project$Pages$Apps$update_fn = function (onError, closeConfirmDialog, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var dbId = msg.a;
                var subMsg = msg.b;
                var _v1 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Apps$addAppNameRequester_fn(shared, dbId), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Add")), model.cm)));
                var inputRequester = _v1.a;
                var cmd = _v1.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Apps$mergeUpdating(inputRequester.la), _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd)));
            case 1:
                var app = msg.a;
                var dbId = msg.b;
                var subMsg = msg.c;
                var _v2 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Apps$renameAppNameRequester_fn(shared, dbId, app), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Rename")), model.cm)));
                var inputRequester = _v2.a;
                var cmd = _v2.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Apps$mergeUpdating(inputRequester.la), _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd)));
            case 2:
                var route = msg.a;
                return _Utils_Tuple2(model, toSharedCmd($author$project$Shared$RouteReplace(route)));
            case 3:
                var dbId = msg.a;
                var maybeAppId = msg.b;
                return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$map(toMsg), $author$project$Util$updateAndThenOneOf_fn(_List_fromArray([
                    A2($author$project$Pages$Apps$requireApps, shared, dbId)
                ]), _Utils_Tuple2(_Utils_update(model, { dG: maybeAppId }), $elm$core$Platform$Cmd$none)));
            case 5:
                var response = msg.b;
                if (!response.$) {
                    var apps = response.a;
                    return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$map(toMsg), _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$succeed(apps),
                        ml: _List_Nil
                    }), $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$Failure($elm$http$Http$BadBody("")),
                        ml: errors
                    }), A2(onError, $elm$core$Maybe$Just("Error"), errors));
                }
            case 4:
                if (!msg.a.$) {
                    var app = msg.a.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$updateApp(app), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                }
            case 6:
                var dbId = msg.a;
                return $author$project$Util$withCmd_fn(closeConfirmDialog, $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(true), _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$deleteApp, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Apps$DeleteAppResponded(dbId)), shared.k2, dbId), $author$project$Pages$Apps$getAppByName(model)))));
            case 7:
                var dbId = msg.a;
                var response = msg.b;
                if (!response.$) {
                    var app = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$remove(app), model.lz)
                    }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Apps$NavigateReplace($author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Nothing))))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
            case 8:
                var dbId = msg.a;
                var app = msg.b;
                return _Utils_Tuple2(model, $elm$file$File$Select$file_fn(_List_fromArray(["application/zip"]), A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Apps$UploadSelected, dbId, app))));
            case 9:
                var dbId = msg.a;
                var app = msg.b;
                var file = msg.c;
                return $author$project$Util$withCmd_fn($author$project$Api$uploadApp_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Apps$Uploaded), shared.k2, dbId, app.M, file), $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            default:
                var response = msg.a;
                if (!response.$) {
                    var app = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$updateApp(app), $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
        }
    }, $author$project$Pages$Apps$update_fn_unwrapped = function (onError, closeConfirmDialog, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var dbId = msg.a;
                var subMsg = msg.b;
                var _v1 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Apps$addAppNameRequester_fn(shared, dbId), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Add")), model.cm)));
                var inputRequester = _v1.a;
                var cmd = _v1.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Apps$mergeUpdating(inputRequester.la), _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd)));
            case 1:
                var app = msg.a;
                var dbId = msg.b;
                var subMsg = msg.c;
                var _v2 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Apps$renameAppNameRequester_fn(shared, dbId, app), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Rename")), model.cm)));
                var inputRequester = _v2.a;
                var cmd = _v2.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Apps$mergeUpdating(inputRequester.la), _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd)));
            case 2:
                var route = msg.a;
                return _Utils_Tuple2(model, toSharedCmd($author$project$Shared$RouteReplace(route)));
            case 3:
                var dbId = msg.a;
                var maybeAppId = msg.b;
                return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$map(toMsg), $author$project$Util$updateAndThenOneOf_fn(_List_fromArray([
                    A2($author$project$Pages$Apps$requireApps, shared, dbId)
                ]), _Utils_Tuple2(_Utils_update(model, { dG: maybeAppId }), $elm$core$Platform$Cmd$none)));
            case 5:
                var response = msg.b;
                if (!response.$) {
                    var apps = response.a;
                    return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$map(toMsg), _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$succeed(apps),
                        ml: _List_Nil
                    }), $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$Failure($elm$http$Http$BadBody("")),
                        ml: errors
                    }), onError($elm$core$Maybe$Just("Error"), errors));
                }
            case 4:
                if (!msg.a.$) {
                    var app = msg.a.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$updateApp(app), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(model, onError($elm$core$Maybe$Just("Error"), errors));
                }
            case 6:
                var dbId = msg.a;
                return $author$project$Util$withCmd_fn(closeConfirmDialog, $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(true), _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$deleteApp, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Apps$DeleteAppResponded(dbId)), shared.k2, dbId), $author$project$Pages$Apps$getAppByName(model)))));
            case 7:
                var dbId = msg.a;
                var response = msg.b;
                if (!response.$) {
                    var app = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(_Utils_update(model, {
                        lz: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$remove(app), model.lz)
                    }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Apps$NavigateReplace($author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Nothing))))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, onError($elm$core$Maybe$Just("Error"), errors)));
                }
            case 8:
                var dbId = msg.a;
                var app = msg.b;
                return _Utils_Tuple2(model, $elm$file$File$Select$file_fn(_List_fromArray(["application/zip"]), A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Apps$UploadSelected, dbId, app))));
            case 9:
                var dbId = msg.a;
                var app = msg.b;
                var file = msg.c;
                return $author$project$Util$withCmd_fn($author$project$Api$uploadApp_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Apps$Uploaded), shared.k2, dbId, app.M, file), $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            default:
                var response = msg.a;
                if (!response.$) {
                    var app = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$updateApp(app), $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Apps$setUpdating(false), _Utils_Tuple2(model, onError($elm$core$Maybe$Just("Error"), errors)));
                }
        }
    }, $author$project$Pages$Apps$update = F7($author$project$Pages$Apps$update_fn);
    var $author$project$Pages$Dashboards$ChartDeleted_fn = function (a, b, c, d) {
        return { $: 23, a: a, b: b, c: c, d: d };
    }, $author$project$Pages$Dashboards$ChartDeleted = F4($author$project$Pages$Dashboards$ChartDeleted_fn);
    var $author$project$Pages$Dashboards$ChartPatched_fn = function (a, b) {
        return { $: 22, a: a, b: b };
    }, $author$project$Pages$Dashboards$ChartPatched = F2($author$project$Pages$Dashboards$ChartPatched_fn);
    var $author$project$Pages$Dashboards$ChartReceived_fn = function (a, b, c) {
        return { $: 21, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$ChartReceived = F3($author$project$Pages$Dashboards$ChartReceived_fn);
    var $author$project$Pages$Dashboards$DashboardDeleted_fn = function (a, b, c) {
        return { $: 19, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$DashboardDeleted = F3($author$project$Pages$Dashboards$DashboardDeleted_fn);
    var $author$project$Pages$Dashboards$DashboardPatched_fn = function (a, b) {
        return { $: 18, a: a, b: b };
    }, $author$project$Pages$Dashboards$DashboardPatched = F2($author$project$Pages$Dashboards$DashboardPatched_fn);
    var $author$project$Pages$Dashboards$Navigate_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Pages$Dashboards$Navigate = F2($author$project$Pages$Dashboards$Navigate_fn);
    var $author$project$Pages$Dashboards$NavigateReplace_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Dashboards$NavigateReplace = F2($author$project$Pages$Dashboards$NavigateReplace_fn);
    var $author$project$Shared$RouteBack = { $: 3 };
    var $author$project$Pages$Dashboards$AddNewDashboardMsg = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Pages$Dashboards$DashboardReceived_fn = function (a, b) {
        return { $: 17, a: a, b: b };
    }, $author$project$Pages$Dashboards$DashboardReceived = F2($author$project$Pages$Dashboards$DashboardReceived_fn);
    var $author$project$Pages$Dashboards$ShowErrors = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Pages$Dashboards$Api$dashboardsRoute = function (dbId) {
        return "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/dashboards/");
    };
    var $author$project$Types$Dashboard$Dashboard_fn = function (id, title, charts) {
        return { aa: charts, bR: id, eM: title };
    }, $author$project$Types$Dashboard$Dashboard = F3($author$project$Types$Dashboard$Dashboard_fn);
    var $author$project$Types$Dashboard$decoder = _Json_map3_fn($author$project$Types$Dashboard$Dashboard, _Json_decodeField_fn("ulid", $elm$json$Json$Decode$string), _Json_decodeField_fn("title", $elm$json$Json$Decode$string), _Json_decodeField_fn("charts", _Json_map1_fn($elm$core$Set$fromList, $elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
    var $elm$core$Set$foldl_fn = function (func, initialState, _v0) {
        var dict = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (key, _v1, state) {
            return A2(func, key, state);
        }, initialState, dict);
    }, $elm$core$Set$foldl_fn_unwrapped = function (func, initialState, _v0) {
        var dict = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (key, _v1, state) {
            return func(key, state);
        }, initialState, dict);
    }, $elm$core$Set$foldl = F3($elm$core$Set$foldl_fn);
    var $elm$json$Json$Encode$set_fn = function (func, entries) {
        return _Json_wrap($elm$core$Set$foldl_fn(_Json_addEntry(func), _Json_emptyArray(0), entries));
    }, $elm$json$Json$Encode$set = F2($elm$json$Json$Encode$set_fn);
    var $author$project$Types$Dashboard$encode = function (d) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("title", $elm$json$Json$Encode$string(d.eM)),
            _Utils_Tuple2("charts", $elm$json$Json$Encode$set_fn($elm$json$Json$Encode$string, d.aa))
        ]));
    };
    var $author$project$Pages$Dashboards$Api$postDashboard_fn = function (toMsg, maybeToken, dbId, dashboard) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Dashboard$encode(dashboard)),
            e: A2($author$project$Api$expect, toMsg, $author$project$Types$Dashboard$decoder),
            f: "POST",
            g: $author$project$Pages$Dashboards$Api$dashboardsRoute(dbId)
        });
    }, $author$project$Pages$Dashboards$Api$postDashboard = F4($author$project$Pages$Dashboards$Api$postDashboard_fn);
    var $author$project$Pages$Dashboards$addDashboardNameRequester_fn = function (shared, maybeDbId) {
        var handleReceivedDashboard = function () {
            if (!maybeDbId.$) {
                var dbId = maybeDbId.a;
                return A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$DashboardReceived(dbId), $author$project$Util$msgCmd));
            }
            else {
                return $elm$core$Basics$always($elm$core$Platform$Cmd$none);
            }
        }();
        return $author$project$Components$InputRequester$init({
            ln: "Add",
            bC: F2(function (state, inputReqMsg) {
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (dbId) {
                    return $author$project$Pages$Dashboards$Api$postDashboard_fn(A2($elm$core$Basics$composeR, inputReqMsg, $author$project$Pages$Dashboards$AddNewDashboardMsg), shared.k2, dbId, { aa: $elm$core$Set$empty, bR: "", eM: state });
                }, maybeDbId);
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$ShowErrors, $author$project$Util$msgCmd),
            fM: handleReceivedDashboard,
            kt: $elm$core$Maybe$Nothing,
            df: "Dashboard Name",
            gd: $author$project$Pages$Dashboards$AddNewDashboardMsg
        });
    }, $author$project$Pages$Dashboards$addDashboardNameRequester = F2($author$project$Pages$Dashboards$addDashboardNameRequester_fn);
    var $author$project$Pages$Dashboards$Api$chartsRoute = function (dbId) {
        return "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/charts/");
    };
    var $author$project$Types$ChartType$encodeChartType = function (chartType) {
        return $elm$json$Json$Encode$string(function () {
            switch (chartType.$) {
                case 0:
                    return "BarChart";
                case 1:
                    return "LineChart";
                default:
                    return "Singleton";
            }
        }());
    };
    var $author$project$Types$ChartType$encodeHeaders = function (chartType) {
        switch (chartType.$) {
            case 0:
                var x = chartType.a;
                var y = chartType.b;
                return A2(A2($elm$core$Basics$composeL, $elm$json$Json$Encode$list, $elm$json$Json$Encode$list), $elm$json$Json$Encode$string, _List_fromArray([
                    _List_fromArray([x]),
                    $basti1302$elm_non_empty_array$Array$NonEmpty$toList(y)
                ]));
            case 1:
                var x = chartType.a;
                var y = chartType.b;
                return A2(A2($elm$core$Basics$composeL, $elm$json$Json$Encode$list, $elm$json$Json$Encode$list), $elm$json$Json$Encode$string, _List_fromArray([
                    _List_fromArray([x]),
                    $basti1302$elm_non_empty_array$Array$NonEmpty$toList(y)
                ]));
            default:
                var val = chartType.a;
                return A2(A2($elm$core$Basics$composeL, $elm$json$Json$Encode$list, $elm$json$Json$Encode$list), $elm$json$Json$Encode$string, _List_fromArray([
                    _List_fromArray([val])
                ]));
        }
    };
    var $elm$json$Json$Encode$int = _Json_wrap;
    var $author$project$Types$Chart$encode = function (c) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("ulid", $elm$json$Json$Encode$string(c.bR)),
            _Utils_Tuple2("title", $elm$json$Json$Encode$string(c.eM)),
            _Utils_Tuple2("table", $elm$json$Json$Encode$string(c.kZ)),
            _Utils_Tuple2("chartType", $author$project$Types$ChartType$encodeChartType(c.bu)),
            _Utils_Tuple2("headers", $author$project$Types$ChartType$encodeHeaders(c.bu)),
            _Utils_Tuple2("labelRotation", $elm$json$Json$Encode$int(c.ef)),
            _Utils_Tuple2("hideNullValues", $elm$json$Json$Encode$bool(c.ea))
        ]));
    };
    var $author$project$Pages$Dashboards$Api$deleteChart_fn = function (toMsg, maybeToken, dbId, chartId, chart) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Chart$encode(chart)),
            e: A2($author$project$Api$expect, toMsg, $elm$json$Json$Decode$succeed(0)),
            f: "DELETE",
            g: _Utils_ap($author$project$Pages$Dashboards$Api$chartsRoute(dbId), chartId)
        });
    }, $author$project$Pages$Dashboards$Api$deleteChart = F5($author$project$Pages$Dashboards$Api$deleteChart_fn);
    var $author$project$Pages$Dashboards$Api$deleteDashboard_fn = function (toMsg, maybeToken, dbId, dashboardId, dashboard) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Dashboard$encode(dashboard)),
            e: A2($author$project$Api$expect, toMsg, $elm$json$Json$Decode$succeed(0)),
            f: "DELETE",
            g: _Utils_ap($author$project$Pages$Dashboards$Api$dashboardsRoute(dbId), dashboardId)
        });
    }, $author$project$Pages$Dashboards$Api$deleteDashboard = F5($author$project$Pages$Dashboards$Api$deleteDashboard_fn);
    var $author$project$Util$dictWithIdInsert = function (a) {
        return A2($elm$core$Dict$insert, a.bR, a);
    };
    var $author$project$Types$Validated$getValue = function (v) {
        return v.pB;
    };
    var $author$project$Types$ChartType$LineChart_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Types$ChartType$LineChart = F2($author$project$Types$ChartType$LineChart_fn);
    var $author$project$Types$ChartType$Singleton = function (a) {
        return { $: 2, a: a };
    };
    var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
    var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
    var $elm$core$Array$getHelp_fn = function (shift, index, tree) {
        getHelp: while (true) {
            var pos = $elm$core$Array$bitMask & (index >>> shift);
            var _v0 = _JsArray_unsafeGet_fn(pos, tree);
            if (!_v0.$) {
                var subTree = _v0.a;
                var $temp$shift = shift - $elm$core$Array$shiftStep, $temp$index = index, $temp$tree = subTree;
                shift = $temp$shift;
                index = $temp$index;
                tree = $temp$tree;
                continue getHelp;
            }
            else {
                var values = _v0.a;
                return _JsArray_unsafeGet_fn($elm$core$Array$bitMask & index, values);
            }
        }
    }, $elm$core$Array$getHelp = F3($elm$core$Array$getHelp_fn);
    var $elm$core$Array$tailIndex = function (len) {
        return (len >>> 5) << 5;
    };
    var $elm$core$Array$get_fn = function (index, _v0) {
        var len = _v0.a;
        var startShift = _v0.b;
        var tree = _v0.c;
        var tail = _v0.d;
        return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(_JsArray_unsafeGet_fn($elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just($elm$core$Array$getHelp_fn(startShift, index, tree)));
    }, $elm$core$Array$get = F2($elm$core$Array$get_fn);
    var $elm$core$Array$length = function (_v0) {
        var len = _v0.a;
        return len;
    };
    var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
    var $elm$core$Elm$JsArray$slice = _JsArray_slice;
    var $elm$core$Array$appendHelpBuilder_fn = function (tail, builder) {
        var tailLen = $elm$core$Elm$JsArray$length(tail);
        var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.ac)) - tailLen;
        var appended = _JsArray_appendN_fn($elm$core$Array$branchFactor, builder.ac, tail);
        return (notAppended < 0) ? {
            ag: _List_Cons($elm$core$Array$Leaf(appended), builder.ag),
            W: builder.W + 1,
            ac: _JsArray_slice_fn(notAppended, tailLen, tail)
        } : ((!notAppended) ? {
            ag: _List_Cons($elm$core$Array$Leaf(appended), builder.ag),
            W: builder.W + 1,
            ac: $elm$core$Elm$JsArray$empty
        } : { ag: builder.ag, W: builder.W, ac: appended });
    }, $elm$core$Array$appendHelpBuilder = F2($elm$core$Array$appendHelpBuilder_fn);
    var $elm$core$Array$sliceLeft_fn = function (from, array) {
        var len = array.a;
        var tree = array.c;
        var tail = array.d;
        if (!from) {
            return array;
        }
        else {
            if (_Utils_cmp(from, $elm$core$Array$tailIndex(len)) > -1) {
                return $elm$core$Array$Array_elm_builtin_fn(len - from, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, _JsArray_slice_fn(from - $elm$core$Array$tailIndex(len), $elm$core$Elm$JsArray$length(tail), tail));
            }
            else {
                var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
                var helper = F2(function (node, acc) {
                    if (!node.$) {
                        var subTree = node.a;
                        return _JsArray_foldr_fn(helper, acc, subTree);
                    }
                    else {
                        var leaf = node.a;
                        return _List_Cons(leaf, acc);
                    }
                });
                var leafNodes = _JsArray_foldr_fn(helper, _List_fromArray([tail]), tree);
                var nodesToInsert = $elm$core$List$drop_fn(skipNodes, leafNodes);
                if (!nodesToInsert.b) {
                    return $elm$core$Array$empty;
                }
                else {
                    var head = nodesToInsert.a;
                    var rest = nodesToInsert.b;
                    var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
                    var initialBuilder = {
                        ag: _List_Nil,
                        W: 0,
                        ac: _JsArray_slice_fn(firstSlice, $elm$core$Elm$JsArray$length(head), head)
                    };
                    return $elm$core$Array$builderToArray_fn(true, $elm$core$List$foldl_fn($elm$core$Array$appendHelpBuilder, initialBuilder, rest));
                }
            }
        }
    }, $elm$core$Array$sliceLeft = F2($elm$core$Array$sliceLeft_fn);
    var $elm$core$Array$fetchNewTail_fn = function (shift, end, treeEnd, tree) {
        fetchNewTail: while (true) {
            var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
            var _v0 = _JsArray_unsafeGet_fn(pos, tree);
            if (!_v0.$) {
                var sub = _v0.a;
                var $temp$shift = shift - $elm$core$Array$shiftStep, $temp$end = end, $temp$treeEnd = treeEnd, $temp$tree = sub;
                shift = $temp$shift;
                end = $temp$end;
                treeEnd = $temp$treeEnd;
                tree = $temp$tree;
                continue fetchNewTail;
            }
            else {
                var values = _v0.a;
                return _JsArray_slice_fn(0, $elm$core$Array$bitMask & end, values);
            }
        }
    }, $elm$core$Array$fetchNewTail = F4($elm$core$Array$fetchNewTail_fn);
    var $elm$core$Array$hoistTree_fn = function (oldShift, newShift, tree) {
        hoistTree: while (true) {
            if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
                return tree;
            }
            else {
                var _v0 = _JsArray_unsafeGet_fn(0, tree);
                if (!_v0.$) {
                    var sub = _v0.a;
                    var $temp$oldShift = oldShift - $elm$core$Array$shiftStep, $temp$newShift = newShift, $temp$tree = sub;
                    oldShift = $temp$oldShift;
                    newShift = $temp$newShift;
                    tree = $temp$tree;
                    continue hoistTree;
                }
                else {
                    return tree;
                }
            }
        }
    }, $elm$core$Array$hoistTree = F3($elm$core$Array$hoistTree_fn);
    var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
    var $elm$core$Array$sliceTree_fn = function (shift, endIdx, tree) {
        var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
        var _v0 = _JsArray_unsafeGet_fn(lastPos, tree);
        if (!_v0.$) {
            var sub = _v0.a;
            var newSub = $elm$core$Array$sliceTree_fn(shift - $elm$core$Array$shiftStep, endIdx, sub);
            return (!$elm$core$Elm$JsArray$length(newSub)) ? _JsArray_slice_fn(0, lastPos, tree) : _JsArray_unsafeSet_fn(lastPos, $elm$core$Array$SubTree(newSub), _JsArray_slice_fn(0, lastPos + 1, tree));
        }
        else {
            return _JsArray_slice_fn(0, lastPos, tree);
        }
    }, $elm$core$Array$sliceTree = F3($elm$core$Array$sliceTree_fn);
    var $elm$core$Array$sliceRight_fn = function (end, array) {
        var len = array.a;
        var startShift = array.b;
        var tree = array.c;
        var tail = array.d;
        if (_Utils_eq(end, len)) {
            return array;
        }
        else {
            if (_Utils_cmp(end, $elm$core$Array$tailIndex(len)) > -1) {
                return $elm$core$Array$Array_elm_builtin_fn(end, startShift, tree, _JsArray_slice_fn(0, $elm$core$Array$bitMask & end, tail));
            }
            else {
                var endIdx = $elm$core$Array$tailIndex(end);
                var depth = $elm$core$Basics$floor($elm$core$Basics$logBase_fn($elm$core$Array$branchFactor, $elm$core$Basics$max_fn(1, endIdx - 1)));
                var newShift = $elm$core$Basics$max_fn(5, depth * $elm$core$Array$shiftStep);
                return $elm$core$Array$Array_elm_builtin_fn(end, newShift, $elm$core$Array$hoistTree_fn(startShift, newShift, $elm$core$Array$sliceTree_fn(startShift, endIdx, tree)), $elm$core$Array$fetchNewTail_fn(startShift, end, endIdx, tree));
            }
        }
    }, $elm$core$Array$sliceRight = F2($elm$core$Array$sliceRight_fn);
    var $elm$core$Array$translateIndex_fn = function (index, _v0) {
        var len = _v0.a;
        var posIndex = (index < 0) ? (len + index) : index;
        return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
    }, $elm$core$Array$translateIndex = F2($elm$core$Array$translateIndex_fn);
    var $elm$core$Array$slice_fn = function (from, to, array) {
        var correctTo = $elm$core$Array$translateIndex_fn(to, array);
        var correctFrom = $elm$core$Array$translateIndex_fn(from, array);
        return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : $elm$core$Array$sliceLeft_fn(correctFrom, $elm$core$Array$sliceRight_fn(correctTo, array));
    }, $elm$core$Array$slice = F3($elm$core$Array$slice_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$fromArray = function (array) {
        var maybeFirst = $elm$core$Array$get_fn(0, array);
        var length_ = $elm$core$Array$length(array);
        if (!maybeFirst.$) {
            var first = maybeFirst.a;
            return $elm$core$Maybe$Just($basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, 0, $elm$core$Array$slice_fn(1, length_ + 1, array)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$Array$fromListHelp_fn = function (list, nodeList, nodeListSize) {
        fromListHelp: while (true) {
            var _v0 = _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, list);
            var jsArray = _v0.a;
            var remainingItems = _v0.b;
            if (_Utils_cmp($elm$core$Elm$JsArray$length(jsArray), $elm$core$Array$branchFactor) < 0) {
                return $elm$core$Array$builderToArray_fn(true, { ag: nodeList, W: nodeListSize, ac: jsArray });
            }
            else {
                var $temp$list = remainingItems, $temp$nodeList = _List_Cons($elm$core$Array$Leaf(jsArray), nodeList), $temp$nodeListSize = nodeListSize + 1;
                list = $temp$list;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue fromListHelp;
            }
        }
    }, $elm$core$Array$fromListHelp = F3($elm$core$Array$fromListHelp_fn);
    var $elm$core$Array$fromList = function (list) {
        if (!list.b) {
            return $elm$core$Array$empty;
        }
        else {
            return $elm$core$Array$fromListHelp_fn(list, _List_Nil, 0);
        }
    };
    var $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a0 = $elm$core$Array$fromList, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a1 = $basti1302$elm_non_empty_array$Array$NonEmpty$fromArray, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList = A2($elm$core$Basics$composeR, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a0, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a1);
    var $author$project$Types$ChartType$withHeaders_fn = function (headers, chartType) {
        var initTwoDimensionalChart = function () {
            var y = $elm$core$Maybe$withDefault_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromElement(""), $elm$core$Maybe$andThen_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromList, $elm$core$List$tail(headers)));
            var x = $elm$core$List$head(headers);
            return A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$andMap(x), $elm_community$maybe_extra$Maybe$Extra$andMap($elm$core$Maybe$Just(y))));
        }();
        switch (chartType.$) {
            case 0:
                return initTwoDimensionalChart($author$project$Types$ChartType$BarChart);
            case 1:
                return initTwoDimensionalChart($author$project$Types$ChartType$LineChart);
            default:
                return $elm$core$Maybe$map_fn($author$project$Types$ChartType$Singleton, $elm$core$List$head(headers));
        }
    }, $author$project$Types$ChartType$withHeaders = F2($author$project$Types$ChartType$withHeaders_fn);
    var $author$project$Pages$Dashboards$Forms$fromChartForm = function (form) {
        return {
            bu: $elm$core$Maybe$withDefault_fn($author$project$Types$Validated$getValue(form.bu), $author$project$Types$ChartType$withHeaders_fn($author$project$Types$Validated$getValue(form.d9), $author$project$Types$Validated$getValue(form.bu))),
            ea: form.ea,
            bR: form.bR,
            ef: $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt($author$project$Types$Validated$getValue(form.ef))),
            kZ: $author$project$Types$Validated$getValue(form.kZ),
            eM: $author$project$Types$Validated$getValue(form.eM)
        };
    };
    var $author$project$Pages$Dashboards$getCharts = function (model) {
        return $krisajenkins$remotedata$RemoteData$withDefault_fn($elm$core$Dict$empty, model.aa);
    };
    var $author$project$Pages$Dashboards$Forms$getDashboard_a0 = $author$project$Types$Validated$getValue, $author$project$Pages$Dashboards$Forms$getDashboard_a1 = $author$project$Types$Validated$getValue, $author$project$Pages$Dashboards$Forms$getDashboard = A2($author$project$Pages$Dashboards$Forms$dashboardTransForm, $author$project$Pages$Dashboards$Forms$getDashboard_a0, $author$project$Pages$Dashboards$Forms$getDashboard_a1);
    var $author$project$Pages$Dashboards$getDashboards = function (model) {
        return $krisajenkins$remotedata$RemoteData$withDefault_fn($elm$core$Dict$empty, model.aD);
    };
    var $author$project$Pages$Dashboards$handleRemoteDataWith_fn = function (onError, model, onSuccess, data) {
        if (!data.$) {
            var charts = data.a;
            return onSuccess(charts);
        }
        else {
            var errors = data.a;
            return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error receiving chart"), errors));
        }
    }, $author$project$Pages$Dashboards$handleRemoteDataWith_fn_unwrapped = function (onError, model, onSuccess, data) {
        if (!data.$) {
            var charts = data.a;
            return onSuccess(charts);
        }
        else {
            var errors = data.a;
            return _Utils_Tuple2(model, onError($elm$core$Maybe$Just("Error receiving chart"), errors));
        }
    }, $author$project$Pages$Dashboards$handleRemoteDataWith = F4($author$project$Pages$Dashboards$handleRemoteDataWith_fn);
    var $author$project$Pages$Dashboards$ChartsReceived_fn = function (a, b) {
        return { $: 20, a: a, b: b };
    }, $author$project$Pages$Dashboards$ChartsReceived = F2($author$project$Pages$Dashboards$ChartsReceived_fn);
    var $author$project$Types$Chart$Chart_fn = function (id, title, table, chartType, labelRotation, hideNullValues) {
        return { bu: chartType, ea: hideNullValues, bR: id, ef: labelRotation, kZ: table, eM: title };
    }, $author$project$Types$Chart$Chart = F6($author$project$Types$Chart$Chart_fn);
    var $elm$core$Elm$JsArray$push = _JsArray_push;
    var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
    var $elm$core$Array$insertTailInTree_fn = function (shift, index, tail, tree) {
        var pos = $elm$core$Array$bitMask & (index >>> shift);
        if (_Utils_cmp(pos, $elm$core$Elm$JsArray$length(tree)) > -1) {
            if (shift === 5) {
                return _JsArray_push_fn($elm$core$Array$Leaf(tail), tree);
            }
            else {
                var newSub = $elm$core$Array$SubTree($elm$core$Array$insertTailInTree_fn(shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
                return _JsArray_push_fn(newSub, tree);
            }
        }
        else {
            var value = _JsArray_unsafeGet_fn(pos, tree);
            if (!value.$) {
                var subTree = value.a;
                var newSub = $elm$core$Array$SubTree($elm$core$Array$insertTailInTree_fn(shift - $elm$core$Array$shiftStep, index, tail, subTree));
                return _JsArray_unsafeSet_fn(pos, newSub, tree);
            }
            else {
                var newSub = $elm$core$Array$SubTree($elm$core$Array$insertTailInTree_fn(shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$singleton(value)));
                return _JsArray_unsafeSet_fn(pos, newSub, tree);
            }
        }
    }, $elm$core$Array$insertTailInTree = F4($elm$core$Array$insertTailInTree_fn);
    var $elm$core$Array$unsafeReplaceTail_fn = function (newTail, _v0) {
        var len = _v0.a;
        var startShift = _v0.b;
        var tree = _v0.c;
        var tail = _v0.d;
        var originalTailLen = $elm$core$Elm$JsArray$length(tail);
        var newTailLen = $elm$core$Elm$JsArray$length(newTail);
        var newArrayLen = len + (newTailLen - originalTailLen);
        if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
            var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
            if (overflow) {
                var newShift = startShift + $elm$core$Array$shiftStep;
                var newTree = $elm$core$Array$insertTailInTree_fn(newShift, len, newTail, $elm$core$Elm$JsArray$singleton($elm$core$Array$SubTree(tree)));
                return $elm$core$Array$Array_elm_builtin_fn(newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
            }
            else {
                return $elm$core$Array$Array_elm_builtin_fn(newArrayLen, startShift, $elm$core$Array$insertTailInTree_fn(startShift, len, newTail, tree), $elm$core$Elm$JsArray$empty);
            }
        }
        else {
            return $elm$core$Array$Array_elm_builtin_fn(newArrayLen, startShift, tree, newTail);
        }
    }, $elm$core$Array$unsafeReplaceTail = F2($elm$core$Array$unsafeReplaceTail_fn);
    var $elm$core$Array$appendHelpTree_fn = function (toAppend, array) {
        var len = array.a;
        var tree = array.c;
        var tail = array.d;
        var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
        var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
        var appended = _JsArray_appendN_fn($elm$core$Array$branchFactor, tail, toAppend);
        var newArray = $elm$core$Array$unsafeReplaceTail_fn(appended, array);
        if (notAppended < 0) {
            var nextTail = _JsArray_slice_fn(notAppended, itemsToAppend, toAppend);
            return $elm$core$Array$unsafeReplaceTail_fn(nextTail, newArray);
        }
        else {
            return newArray;
        }
    }, $elm$core$Array$appendHelpTree = F2($elm$core$Array$appendHelpTree_fn);
    var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
    var $elm$core$Array$builderFromArray = function (_v0) {
        var len = _v0.a;
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function (node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return _JsArray_foldl_fn(helper, acc, subTree);
            }
            else {
                return _List_Cons(node, acc);
            }
        });
        return {
            ag: _JsArray_foldl_fn(helper, _List_Nil, tree),
            W: (len / $elm$core$Array$branchFactor) | 0,
            ac: tail
        };
    };
    var $elm$core$Array$append_fn = function (a, _v0) {
        var aTail = a.d;
        var bLen = _v0.a;
        var bTree = _v0.c;
        var bTail = _v0.d;
        if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
            var foldHelper = F2(function (node, array) {
                if (!node.$) {
                    var tree = node.a;
                    return _JsArray_foldl_fn(foldHelper, array, tree);
                }
                else {
                    var leaf = node.a;
                    return $elm$core$Array$appendHelpTree_fn(leaf, array);
                }
            });
            return $elm$core$Array$appendHelpTree_fn(bTail, _JsArray_foldl_fn(foldHelper, a, bTree));
        }
        else {
            var foldHelper = F2(function (node, builder) {
                if (!node.$) {
                    var tree = node.a;
                    return _JsArray_foldl_fn(foldHelper, builder, tree);
                }
                else {
                    var leaf = node.a;
                    return $elm$core$Array$appendHelpBuilder_fn(leaf, builder);
                }
            });
            return $elm$core$Array$builderToArray_fn(true, $elm$core$Array$appendHelpBuilder_fn(bTail, _JsArray_foldl_fn(foldHelper, $elm$core$Array$builderFromArray(a), bTree)));
        }
    }, $elm$core$Array$append = F2($elm$core$Array$append_fn);
    var $elm$core$Array$push_fn = function (a, array) {
        var tail = array.d;
        return $elm$core$Array$unsafeReplaceTail_fn(_JsArray_push_fn(a, tail), array);
    }, $elm$core$Array$push = F2($elm$core$Array$push_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$append_fn = function (_v0, _v1) {
        var first1 = _v0.a;
        var selected1 = _v0.b;
        var rest1 = _v0.c;
        var first2 = _v1.a;
        var rest2 = _v1.c;
        var newRest = function (a) {
            return $elm$core$Array$append_fn(a, rest2);
        }($elm$core$Array$push_fn(first2, rest1));
        return $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first1, selected1, newRest);
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$append = F2($basti1302$elm_non_empty_array$Array$NonEmpty$append_fn);
    var $author$project$Types$ChartType$decode = _Json_andThen_fn(function (_v0) {
        var chartType = _v0.a;
        var headers = _v0.b;
        switch (chartType) {
            case "BarChart":
                if (((((headers.b && headers.a.b) && (!headers.a.b.b)) && headers.b.b) && headers.b.a.b) && (!headers.b.b.b)) {
                    var _v3 = headers.a;
                    var x = _v3.a;
                    var _v4 = headers.b;
                    var _v5 = _v4.a;
                    var y = _v5.a;
                    var ys = _v5.b;
                    return $elm$json$Json$Decode$succeed($author$project$Types$ChartType$BarChart_fn(x, $elm$core$Maybe$withDefault_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromElement(y), $elm$core$Maybe$map_fn($basti1302$elm_non_empty_array$Array$NonEmpty$append($basti1302$elm_non_empty_array$Array$NonEmpty$fromElement(y)), $elm$core$Basics$composeR_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a0, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a1, ys)))));
                }
                else {
                    return $elm$json$Json$Decode$fail("Invalid data for bar chart.");
                }
            case "LineChart":
                if (((((headers.b && headers.a.b) && (!headers.a.b.b)) && headers.b.b) && headers.b.a.b) && (!headers.b.b.b)) {
                    var _v7 = headers.a;
                    var x = _v7.a;
                    var _v8 = headers.b;
                    var _v9 = _v8.a;
                    var y = _v9.a;
                    var ys = _v9.b;
                    return $elm$json$Json$Decode$succeed($author$project$Types$ChartType$LineChart_fn(x, $elm$core$Maybe$withDefault_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromElement(y), $elm$core$Maybe$map_fn($basti1302$elm_non_empty_array$Array$NonEmpty$append($basti1302$elm_non_empty_array$Array$NonEmpty$fromElement(y)), $elm$core$Basics$composeR_fn($basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a0, $basti1302$elm_non_empty_array$Array$NonEmpty$fromList_a1, ys)))));
                }
                else {
                    return $elm$json$Json$Decode$fail("Invalid data for line chart.");
                }
            case "Singleton":
                if (((headers.b && headers.a.b) && (!headers.a.b.b)) && (!headers.b.b)) {
                    var _v11 = headers.a;
                    var val = _v11.a;
                    return $elm$json$Json$Decode$succeed($author$project$Types$ChartType$Singleton(val));
                }
                else {
                    return $elm$json$Json$Decode$fail("Invalid data for singleton.");
                }
            default:
                return $elm$json$Json$Decode$fail("Unknown chart type \"" + (chartType + "\"."));
        }
    }, _Json_map2_fn($elm$core$Tuple$pair, _Json_decodeField_fn("chartType", $elm$json$Json$Decode$string), _Json_decodeField_fn("headers", $elm$json$Json$Decode$list($elm$json$Json$Decode$list($elm$json$Json$Decode$string)))));
    var $author$project$Types$Chart$decoder = _Json_map6_fn($author$project$Types$Chart$Chart, _Json_decodeField_fn("ulid", $elm$json$Json$Decode$string), _Json_decodeField_fn("title", $elm$json$Json$Decode$string), _Json_decodeField_fn("table", $elm$json$Json$Decode$string), $author$project$Types$ChartType$decode, _Json_decodeField_fn("labelRotation", $elm$json$Json$Decode$int), _Json_decodeField_fn("hideNullValues", $elm$json$Json$Decode$bool));
    var $author$project$Pages$Dashboards$Api$requestCharts_fn = function (toMsg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, toMsg, _Json_decodeField_fn("charts", $elm$json$Json$Decode$list($author$project$Types$Chart$decoder))),
            f: "GET",
            g: $author$project$Pages$Dashboards$Api$chartsRoute(dbId)
        });
    }, $author$project$Pages$Dashboards$Api$requestCharts = F3($author$project$Pages$Dashboards$Api$requestCharts_fn);
    var $author$project$Pages$Dashboards$askForRemoteCharts_fn = function (toMsg, dbId, shared, model) {
        return _Utils_eq(model.aa, $krisajenkins$remotedata$RemoteData$NotAsked) ? _Utils_Tuple2(_Utils_update(model, { aa: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Pages$Dashboards$Api$requestCharts_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$ChartsReceived(dbId)), shared.k2, dbId)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    }, $author$project$Pages$Dashboards$askForRemoteCharts = F4($author$project$Pages$Dashboards$askForRemoteCharts_fn);
    var $author$project$Pages$Dashboards$DashboardsReceived_fn = function (a, b) {
        return { $: 16, a: a, b: b };
    }, $author$project$Pages$Dashboards$DashboardsReceived = F2($author$project$Pages$Dashboards$DashboardsReceived_fn);
    var $author$project$Pages$Dashboards$Api$requestDashboards_fn = function (toMsg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, toMsg, _Json_decodeField_fn("dashboards", $elm$json$Json$Decode$list($author$project$Types$Dashboard$decoder))),
            f: "GET",
            g: $author$project$Pages$Dashboards$Api$dashboardsRoute(dbId)
        });
    }, $author$project$Pages$Dashboards$Api$requestDashboards = F3($author$project$Pages$Dashboards$Api$requestDashboards_fn);
    var $author$project$Pages$Dashboards$askForRemoteDashboards_fn = function (toMsg, dbId, shared, model) {
        return _Utils_eq(model.aD, $krisajenkins$remotedata$RemoteData$NotAsked) ? _Utils_Tuple2(_Utils_update(model, { aD: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Pages$Dashboards$Api$requestDashboards_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$DashboardsReceived(dbId)), shared.k2, dbId)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    }, $author$project$Pages$Dashboards$askForRemoteDashboards = F4($author$project$Pages$Dashboards$askForRemoteDashboards_fn);
    var $author$project$Pages$Dashboards$Route$isEditingRoute = function (r) {
        switch (r.$) {
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return true;
            case 4:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Pages$Dashboards$saveRoute_fn = function (route, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, { fZ: route }), cmd);
    }, $author$project$Pages$Dashboards$saveRoute = F2($author$project$Pages$Dashboards$saveRoute_fn);
    var $author$project$Pages$Dashboards$Route$toDashboardId = function (r) {
        switch (r.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var did = r.a;
                return $elm$core$Maybe$Just(did);
            case 2:
                var did = r.a;
                return $elm$core$Maybe$Just(did);
            case 3:
                var did = r.a;
                return $elm$core$Maybe$Just(did);
            default:
                var did = r.a;
                return $elm$core$Maybe$Just(did);
        }
    };
    var $author$project$Util$updateAndThen_fn = function (fn, _v0) {
        var m = _v0.a;
        var c = _v0.b;
        return $elm$core$Tuple$mapSecond_fn(function (newCmds) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([c, newCmds]));
        }, fn(m));
    }, $author$project$Util$updateAndThen = F2($author$project$Util$updateAndThen_fn);
    var $author$project$Pages$Dashboards$handleRouting_fn = function (_v0, shared, model, route, dbId) {
        var toMsg = _v0.gd;
        return $author$project$Pages$Dashboards$saveRoute_fn(route, $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Dashboards$askForRemoteDashboards, toMsg, dbId, shared), function () {
            if (route.$ === 1) {
                var replaceRoute = A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$NavigateReplace(dbId), A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd));
                var pushRoute = A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$Navigate(dbId), A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd));
                return _Utils_Tuple2(model, $author$project$Util$restoreActiveRoute({
                    dx: model.fZ,
                    lo: function (activeRoute) {
                        return $author$project$Pages$Dashboards$Route$isEditingRoute(activeRoute) ? $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$Route$ViewDashboard, $elm$core$List$singleton), $author$project$Pages$Dashboards$Route$toDashboardId(activeRoute)) : _List_Nil;
                    },
                    ma: $elm$core$Maybe$Just($author$project$Pages$Dashboards$Route$Overview),
                    ol: pushRoute,
                    ou: replaceRoute
                }));
            }
            else {
                switch (route.a.$) {
                    case 2:
                        var did = route.a.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            by: _Utils_eq(model.by.bR, did) ? model.by : $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn($author$project$Pages$Dashboards$Forms$initDashboardForm_a0, $author$project$Pages$Dashboards$Forms$initDashboardForm_a1, $elm$core$Maybe$withDefault_fn($author$project$Types$Dashboard$init, $elm$core$Dict$get_fn(did, $author$project$Pages$Dashboards$getDashboards(model))))
                        }), $elm$core$Platform$Cmd$none);
                    case 3:
                        return $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Dashboards$askForRemoteCharts, toMsg, dbId, shared), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                    case 4:
                        var _v2 = route.a;
                        var cid = _v2.b;
                        return $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Dashboards$askForRemoteCharts, toMsg, dbId, shared), _Utils_Tuple2(_Utils_update(model, {
                            ao: _Utils_eq(model.ao.bR, cid) ? model.ao : $author$project$Pages$Dashboards$Forms$toChartForm($elm$core$Maybe$withDefault_fn($author$project$Types$Chart$init, $elm$core$Dict$get_fn(cid, $author$project$Pages$Dashboards$getCharts(model))))
                        }), $elm$core$Platform$Cmd$none));
                    case 0:
                        var _v3 = route.a;
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    default:
                        return $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Dashboards$askForRemoteCharts, toMsg, dbId, shared), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                }
            }
        }()));
    }, $author$project$Pages$Dashboards$handleRouting = F5($author$project$Pages$Dashboards$handleRouting_fn);
    var $author$project$Types$Chart$initWithTables = function (ts) {
        return {
            bu: $author$project$Types$ChartType$BarChart_fn("", $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement("")),
            ea: false,
            bR: "",
            ef: 30,
            kZ: $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function ($) {
                return $.M;
            }, $elm$core$List$head(ts))),
            eM: ""
        };
    };
    var $elm$core$Dict$fromList = function (assocs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, dict) {
            var key = _v0.a;
            var value = _v0.b;
            return $elm$core$Dict$insert_fn(key, value, dict);
        }, $elm$core$Dict$empty, assocs);
    };
    var $author$project$Util$listWithIdToDict_a0 = $elm$core$Dict$fromList, $author$project$Util$listWithIdToDict_a1 = $elm$core$List$map(function (c) {
        return _Utils_Tuple2(c.bR, c);
    }), $author$project$Util$listWithIdToDict = A2($elm$core$Basics$composeL, $author$project$Util$listWithIdToDict_a0, $author$project$Util$listWithIdToDict_a1);
    var $author$project$Pages$Dashboards$Api$patchChart_fn = function (toMsg, maybeToken, dbId, chartId, chart) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Chart$encode(chart)),
            e: A2($author$project$Api$expect, toMsg(chart), $elm$json$Json$Decode$succeed(0)),
            f: "PATCH",
            g: _Utils_ap($author$project$Pages$Dashboards$Api$chartsRoute(dbId), chartId)
        });
    }, $author$project$Pages$Dashboards$Api$patchChart = F5($author$project$Pages$Dashboards$Api$patchChart_fn);
    var $author$project$Pages$Dashboards$Api$patchDashboard_fn = function (toMsg, maybeToken, dbId, dashboardId, dashboard) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Dashboard$encode(dashboard)),
            e: A2($author$project$Api$expect, toMsg, $elm$json$Json$Decode$succeed(0)),
            f: "PATCH",
            g: _Utils_ap($author$project$Pages$Dashboards$Api$dashboardsRoute(dbId), dashboardId)
        });
    }, $author$project$Pages$Dashboards$Api$patchDashboard = F5($author$project$Pages$Dashboards$Api$patchDashboard_fn);
    var $author$project$Pages$Dashboards$Api$postChart_fn = function (toMsg, maybeToken, dbId, chart) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($author$project$Types$Chart$encode(chart)),
            e: A2($author$project$Api$expect, toMsg, $author$project$Types$Chart$decoder),
            f: "POST",
            g: $author$project$Pages$Dashboards$Api$chartsRoute(dbId)
        });
    }, $author$project$Pages$Dashboards$Api$postChart = F4($author$project$Pages$Dashboards$Api$postChart_fn);
    var $elm_community$list_extra$List$Extra$uniqueHelp_fn = function (f, existing, remaining, accumulator) {
        uniqueHelp: while (true) {
            if (!remaining.b) {
                return $elm$core$List$reverse(accumulator);
            }
            else {
                var first = remaining.a;
                var rest = remaining.b;
                var computedFirst = f(first);
                if ($elm$core$List$member_fn(computedFirst, existing)) {
                    var $temp$f = f, $temp$existing = existing, $temp$remaining = rest, $temp$accumulator = accumulator;
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
                else {
                    var $temp$f = f, $temp$existing = _List_Cons(computedFirst, existing), $temp$remaining = rest, $temp$accumulator = _List_Cons(first, accumulator);
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$uniqueHelp = F4($elm_community$list_extra$List$Extra$uniqueHelp_fn);
    var $elm_community$list_extra$List$Extra$unique = function (list) {
        return $elm_community$list_extra$List$Extra$uniqueHelp_fn($elm$core$Basics$identity, _List_Nil, list, _List_Nil);
    };
    var $author$project$Types$Validated$Validated_fn = function (value, error) {
        return { fl: error, pB: value };
    }, $author$project$Types$Validated$Validated = F2($author$project$Types$Validated$Validated_fn);
    var $author$project$Types$Validated$degree = function (string) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Types$Validated$Validated_fn(string, $elm$core$Maybe$Just("Must be number")), A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($author$project$Util$flip, $author$project$Types$Validated$Validated, $elm$core$Maybe$Nothing)), $elm$core$String$toInt(string));
    };
    var $author$project$Types$Validated$headers_fn = function (chartType, headerList) {
        var insufficentHeadersForChartType = function (_v1) {
            return _Utils_eq($author$project$Types$ChartType$withHeaders_fn(headerList, chartType), $elm$core$Maybe$Nothing);
        };
        var emptyHeader = $elm$core$List$member_fn("", headerList);
        var duplicateHeader = function (_v0) {
            return !_Utils_eq($elm_community$list_extra$List$Extra$unique(headerList), headerList);
        };
        return emptyHeader ? $author$project$Types$Validated$Validated_fn(headerList, $elm$core$Maybe$Just("Please select headers")) : (duplicateHeader(0) ? $author$project$Types$Validated$Validated_fn(headerList, $elm$core$Maybe$Just("Duplicate headers")) : (insufficentHeadersForChartType(0) ? $author$project$Types$Validated$Validated_fn(headerList, $elm$core$Maybe$Just("Invalid headers")) : $author$project$Types$Validated$Validated_fn(headerList, $elm$core$Maybe$Nothing)));
    }, $author$project$Types$Validated$headers = F2($author$project$Types$Validated$headers_fn);
    var $author$project$Types$Validated$nonEmptyString = function (c) {
        return {
            fl: (c === "") ? $elm$core$Maybe$Just("Must not be empty") : $elm$core$Maybe$Nothing,
            pB: c
        };
    };
    var $author$project$Types$Validated$hasError = function (v) {
        return $elm_community$maybe_extra$Maybe$Extra$isJust(v.fl);
    };
    var $author$project$Pages$Dashboards$Forms$toValidatedChartForm = function (form) {
        return _Utils_Tuple2(form, $elm$core$List$any_fn($elm$core$Basics$identity, _List_fromArray([
            $author$project$Types$Validated$hasError(form.eM),
            $author$project$Types$Validated$hasError(form.kZ),
            $author$project$Types$Validated$hasError(form.ef),
            $author$project$Types$Validated$hasError(form.d9)
        ])));
    };
    var $author$project$Pages$Dashboards$Forms$validateChartForm = function (form) {
        return $author$project$Pages$Dashboards$Forms$toValidatedChartForm(_Utils_update(form, {
            d9: $author$project$Types$Validated$headers_fn($author$project$Types$Validated$getValue(form.bu), $author$project$Types$Validated$getValue(form.d9)),
            ef: $author$project$Types$Validated$degree($author$project$Types$Validated$getValue(form.ef)),
            kZ: $author$project$Types$Validated$nonEmptyString($author$project$Types$Validated$getValue(form.kZ)),
            eM: $author$project$Types$Validated$nonEmptyString($author$project$Types$Validated$getValue(form.eM))
        }));
    };
    var $author$project$Pages$Dashboards$Forms$hasDashboardErros = function (df) {
        return $elm$core$Tuple$pair_fn(df, $elm$core$List$any_fn($elm$core$Basics$identity, _List_fromArray([
            $author$project$Types$Validated$hasError(df.eM)
        ])));
    };
    var $author$project$Pages$Dashboards$Forms$validateDashboardForm_a0 = $author$project$Pages$Dashboards$Forms$hasDashboardErros, $author$project$Pages$Dashboards$Forms$validateDashboardForm_a1 = A2($author$project$Pages$Dashboards$Forms$dashboardTransForm, A2($elm$core$Basics$composeL, $author$project$Types$Validated$nonEmptyString, function ($) {
        return $.pB;
    }), $elm$core$Basics$identity), $author$project$Pages$Dashboards$Forms$validateDashboardForm = A2($elm$core$Basics$composeL, $author$project$Pages$Dashboards$Forms$validateDashboardForm_a0, $author$project$Pages$Dashboards$Forms$validateDashboardForm_a1);
    var $author$project$Pages$Dashboards$viewDashboardCmd_fn = function (toMsg, dbId) {
        return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Util$msgCmd, toMsg), $author$project$Pages$Dashboards$NavigateReplace(dbId)), $author$project$Pages$Dashboards$Route$ViewDashboard);
    }, $author$project$Pages$Dashboards$viewDashboardCmd = F2($author$project$Pages$Dashboards$viewDashboardCmd_fn);
    var $author$project$Pages$Dashboards$update_fn = function (context, msg, shared, model) {
        var _v0 = context;
        var requireTable = _v0.ov;
        var toMsg = _v0.gd;
        var onError = _v0.nT;
        var handleRemoteData = A2($author$project$Pages$Dashboards$handleRemoteDataWith, onError, model);
        var requireChartTables = function (dbId) {
            return A2($elm$core$Basics$composeR, $elm$core$List$map(function ($) {
                return $.kZ;
            }), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$unique, A2($elm$core$Basics$composeR, $elm$core$List$map(requireTable(dbId)), $elm$core$Platform$Cmd$batch)));
        };
        var msgCmd = A2($elm$core$Basics$composeL, $author$project$Util$msgCmd, toMsg);
        switch (msg.$) {
            case 4:
                var dbId = msg.a;
                var did = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    by: $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn($author$project$Pages$Dashboards$Forms$initDashboardForm_a0, $author$project$Pages$Dashboards$Forms$initDashboardForm_a1, $elm$core$Maybe$withDefault_fn($author$project$Types$Dashboard$init, $elm$core$Dict$get_fn(did, $author$project$Pages$Dashboards$getDashboards(model))))
                }), msgCmd($author$project$Pages$Dashboards$Navigate_fn(dbId, $author$project$Pages$Dashboards$Route$EditDashboard(did))));
            case 0:
                var dbId_ = msg.a;
                var route = msg.b;
                return _Utils_Tuple2(model, context.ge($author$project$Shared$RouteTo($author$project$Route$Dashboards_fn(dbId_, $elm$core$Maybe$Just(route)))));
            case 1:
                var dbId_ = msg.a;
                var route = msg.b;
                return _Utils_Tuple2(model, context.ge($author$project$Shared$RouteReplace($author$project$Route$Dashboards_fn(dbId_, $elm$core$Maybe$Just(route)))));
            case 2:
                return _Utils_Tuple2(model, context.ge($author$project$Shared$RouteBack));
            case 3:
                var dbId = msg.a;
                var route = msg.b;
                return $author$project$Pages$Dashboards$handleRouting_fn(context, shared, model, route, dbId);
            case 5:
                var df = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { by: df }), $elm$core$Platform$Cmd$none);
            case 6:
                var dbId = msg.a;
                var did = msg.b;
                var df = msg.c;
                var dashboard = function (_v3) {
                    return $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn($author$project$Pages$Dashboards$Forms$getDashboard_a0, $author$project$Pages$Dashboards$Forms$getDashboard_a1, df);
                };
                var _v2 = $elm$core$Basics$composeL_fn($author$project$Pages$Dashboards$Forms$validateDashboardForm_a0, $author$project$Pages$Dashboards$Forms$validateDashboardForm_a1, df);
                var vdf = _v2.a;
                var err = _v2.b;
                return err ? _Utils_Tuple2(_Utils_update(model, { by: vdf }), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A3($author$project$Pages$Dashboards$viewDashboardCmd, toMsg, dbId, did),
                    $author$project$Pages$Dashboards$Api$patchDashboard_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$DashboardPatched(dashboard(0))), shared.k2, dbId, did, dashboard(0))
                ])));
            case 7:
                var dbId = msg.a;
                var did = msg.b;
                var df = msg.c;
                return _Utils_Tuple2(model, $author$project$Pages$Dashboards$Api$deleteDashboard_fn(A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$DashboardDeleted, dbId, did)), shared.k2, dbId, did, $author$project$Pages$Dashboards$Forms$dashboardTransForm_fn($author$project$Pages$Dashboards$Forms$getDashboard_a0, $author$project$Pages$Dashboards$Forms$getDashboard_a1, df)));
            case 8:
                var subMsg = msg.a;
                var _v4 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Dashboards$addDashboardNameRequester_fn(shared, context.ng), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Add")), model.cm)));
                var inputRequester = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester),
                    la: model.la || inputRequester.la
                }), _Platform_map_fn(toMsg, cmd));
            case 9:
                var dbId = msg.a;
                var did = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ao: $author$project$Pages$Dashboards$Forms$toChartForm($author$project$Types$Chart$initWithTables(context.eH))
                }), msgCmd($author$project$Pages$Dashboards$Navigate_fn(dbId, $author$project$Pages$Dashboards$Route$NewChart(did))));
            case 10:
                var dbId = msg.a;
                var did = msg.b;
                var cid = msg.c;
                return _Utils_Tuple2(_Utils_update(model, {
                    ao: $author$project$Pages$Dashboards$Forms$toChartForm($elm$core$Maybe$withDefault_fn($author$project$Types$Chart$init, $elm$core$Dict$get_fn(cid, $author$project$Pages$Dashboards$getCharts(model))))
                }), msgCmd($author$project$Pages$Dashboards$Navigate_fn(dbId, $author$project$Pages$Dashboards$Route$EditChart_fn(did, cid))));
            case 11:
                var dbId = msg.a;
                var cf = msg.b;
                return _Utils_Tuple2(_Utils_update(model, { ao: cf }), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, requireTable(dbId), $elm_community$string_extra$String$Extra$nonEmpty($author$project$Types$Validated$getValue(cf.kZ))));
            case 12:
                var dbId = msg.a;
                var did = msg.b;
                var cf = msg.c;
                var _v5 = $author$project$Pages$Dashboards$Forms$validateChartForm(cf);
                var vcf = _v5.a;
                var err = _v5.b;
                return err ? _Utils_Tuple2(_Utils_update(model, { ao: vcf }), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A3($author$project$Pages$Dashboards$viewDashboardCmd, toMsg, dbId, did),
                    $author$project$Pages$Dashboards$Api$postChart_fn(A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$ChartReceived, dbId, did)), shared.k2, dbId, $author$project$Pages$Dashboards$Forms$fromChartForm(cf))
                ])));
            case 13:
                var dbId = msg.a;
                var did = msg.b;
                var cid = msg.c;
                var cf = msg.d;
                var _v6 = $author$project$Pages$Dashboards$Forms$validateChartForm(cf);
                var vcf = _v6.a;
                var err = _v6.b;
                if (err) {
                    return _Utils_Tuple2(_Utils_update(model, { ao: vcf }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var updatedDashboards = $elm$core$Maybe$withDefault_fn($author$project$Pages$Dashboards$getDashboards(model), $elm$core$Maybe$map_fn(function (d) {
                        return $elm$core$Dict$insert_fn(did, d, $author$project$Pages$Dashboards$getDashboards(model));
                    }, $elm$core$Maybe$map_fn(function (d) {
                        return _Utils_update(d, {
                            aa: $elm$core$Set$insert_fn($author$project$Pages$Dashboards$Forms$fromChartForm(cf).bR, d.aa)
                        });
                    }, $elm$core$Dict$get_fn(did, $author$project$Pages$Dashboards$getDashboards(model)))));
                    return _Utils_Tuple2(_Utils_update(model, {
                        aD: $krisajenkins$remotedata$RemoteData$succeed(updatedDashboards)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A3($author$project$Pages$Dashboards$viewDashboardCmd, toMsg, dbId, did),
                        $author$project$Pages$Dashboards$Api$patchChart_fn(function (c) {
                            return A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$ChartPatched(c));
                        }, shared.k2, dbId, cid, $author$project$Pages$Dashboards$Forms$fromChartForm(cf))
                    ])));
                }
            case 14:
                var dbId = msg.a;
                var did = msg.b;
                var cid = msg.c;
                var df = msg.d;
                return _Utils_Tuple2(model, $author$project$Pages$Dashboards$Api$deleteChart_fn(A2($elm$core$Basics$composeL, toMsg, A3($author$project$Pages$Dashboards$ChartDeleted, dbId, did, cid)), shared.k2, dbId, cid, $author$project$Pages$Dashboards$Forms$fromChartForm(df)));
            case 17:
                var dbId = msg.a;
                var dashboardData = msg.b;
                return A2(handleRemoteData, function (d) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aD: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Util$dictWithIdInsert(d), model.aD)
                    }), A3($author$project$Pages$Dashboards$viewDashboardCmd, toMsg, dbId, d.bR));
                }, dashboardData);
            case 16:
                var dashboardsData = msg.b;
                return A2(handleRemoteData, function (dashboards) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aD: $krisajenkins$remotedata$RemoteData$succeed($elm$core$Basics$composeL_fn($author$project$Util$listWithIdToDict_a0, $author$project$Util$listWithIdToDict_a1, dashboards))
                    }), $elm$core$Platform$Cmd$none);
                }, dashboardsData);
            case 18:
                var dashboard = msg.a;
                var rd = msg.b;
                return A2(handleRemoteData, function (_v7) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aD: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Util$dictWithIdInsert(dashboard), model.aD)
                    }), $elm$core$Platform$Cmd$none);
                }, rd);
            case 19:
                var dbId = msg.a;
                var dashboardId = msg.b;
                var dashboardsData = msg.c;
                return A2(handleRemoteData, function (_v8) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aD: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$Dict$remove(dashboardId), model.aD)
                    }), msgCmd($author$project$Pages$Dashboards$Navigate_fn(dbId, $author$project$Pages$Dashboards$Route$Overview)));
                }, dashboardsData);
            case 20:
                var dbId = msg.a;
                var chartsData = msg.b;
                return A2(handleRemoteData, function (charts) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aa: $krisajenkins$remotedata$RemoteData$succeed($elm$core$Basics$composeL_fn($author$project$Util$listWithIdToDict_a0, $author$project$Util$listWithIdToDict_a1, charts))
                    }), A2(requireChartTables, dbId, charts));
                }, chartsData);
            case 21:
                var dbId = msg.a;
                var did = msg.b;
                var chartsData = msg.c;
                return A2(handleRemoteData, function (chart) {
                    var mDashboard = $elm$core$Maybe$map_fn(function (d) {
                        return _Utils_update(d, {
                            aa: $elm$core$Set$insert_fn(chart.bR, d.aa)
                        });
                    }, $elm$core$Dict$get_fn(did, $author$project$Pages$Dashboards$getDashboards(model)));
                    return _Utils_Tuple2(_Utils_update(model, {
                        aa: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Util$dictWithIdInsert(chart), model.aa)
                    }), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(function (dashboard) {
                        return $author$project$Pages$Dashboards$Api$patchDashboard_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$DashboardPatched(dashboard)), shared.k2, dbId, did, dashboard);
                    }, mDashboard)));
                }, chartsData);
            case 22:
                var chart = msg.a;
                var rd = msg.b;
                return A2(handleRemoteData, function (_v9) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aa: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Util$dictWithIdInsert(chart), model.aa)
                    }), $elm$core$Platform$Cmd$none);
                }, rd);
            case 23:
                var dbId = msg.a;
                var did = msg.b;
                var chartId = msg.c;
                var chartsData = msg.d;
                return A2(handleRemoteData, function (_v10) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aa: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$Dict$remove(chartId), model.aa)
                    }), msgCmd($author$project$Pages$Dashboards$NavigateReplace_fn(dbId, $author$project$Pages$Dashboards$Route$ViewDashboard(did))));
                }, chartsData);
            case 24:
                var chartId = msg.a;
                var data = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    dL: $elm$core$Dict$insert_fn(chartId, data, model.dL)
                }), $elm$core$Platform$Cmd$none);
            case 25:
                var chartId = msg.a;
                var data = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    eg: $elm$core$Dict$insert_fn(chartId, data, model.eg)
                }), $elm$core$Platform$Cmd$none);
            default:
                var errors = msg.a;
                return _Utils_Tuple2(model, A2(context.nT, $elm$core$Maybe$Just("Error"), errors));
        }
    }, $author$project$Pages$Dashboards$update = F4($author$project$Pages$Dashboards$update_fn);
    var $author$project$Pages$Database$DatabaseNameEditResponded_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $author$project$Pages$Database$DatabaseNameEditResponded = F2($author$project$Pages$Database$DatabaseNameEditResponded_fn);
    var $author$project$Pages$Database$DescriptionMsgReceived = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Database$DescriptionUpdated = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Database$NoOp = { $: 0 };
    var $author$project$Pages$Database$OwnerSet = { $: 10 };
    var $author$project$Pages$Database$ShowErrors = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Api$generateDatabaseDescription_fn = function (msg, maybeToken, prompt, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("prompt", $elm$json$Json$Encode$string(prompt))
            ]))),
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("completion", $elm$json$Json$Decode$string)),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/prompt/describe-database")
        });
    }, $author$project$Api$generateDatabaseDescription = F4($author$project$Api$generateDatabaseDescription_fn);
    var $author$project$Api$renameDatabase_fn = function (msg, maybeToken, dbId, name) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("name", $elm$json$Json$Encode$string(name))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "PATCH",
            g: "/api/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$renameDatabase = F4($author$project$Api$renameDatabase_fn);
    var $author$project$Api$setDatabaseDescription_fn = function (msg, maybeToken, description, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("description", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn("", description)))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(description)),
            f: "PATCH",
            g: "/api/dbs/" + $elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId))
        });
    }, $author$project$Api$setDatabaseDescription = F4($author$project$Api$setDatabaseDescription_fn);
    var $author$project$Types$Database$setDescription = function (description) {
        return $krisajenkins$remotedata$RemoteData$map(function (db) {
            return _Utils_update(db, { i6: description });
        });
    };
    var $author$project$Components$Description$EditorClosed = { $: 2 };
    var $author$project$Components$Description$EditorMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Components$Description$OnApply_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Components$Description$OnApply = F2($author$project$Components$Description$OnApply_fn);
    var $author$project$Components$Description$OnError = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$Description$OnGenerate_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Components$Description$OnGenerate = F2($author$project$Components$Description$OnGenerate_fn);
    var $author$project$Components$Description$OnSuccess = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Components$Description$initEditor = function (description) {
        return $author$project$Components$AiEditor$init({
            iA: "Create a markdown description",
            ls: $elm$core$Maybe$Nothing,
            lt: $elm$core$Maybe$Nothing,
            lu: $elm$core$Maybe$Just(true),
            iU: $elm$core$Maybe$Just("Save"),
            gB: description,
            e7: $elm$core$Maybe$Nothing,
            l8: $elm$core$Maybe$Just(""),
            mg: $elm$core$Maybe$Just(7),
            mh: $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$noLang),
            bC: F2(function (toMsg, content) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Components$Description$OnApply_fn(A2($elm$core$Basics$composeR, toMsg, $author$project$Components$Description$EditorMsg), content));
            }),
            ek: $elm$core$Maybe$Just($author$project$Components$Description$EditorClosed),
            nT: function (errors) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Components$Description$OnError(errors));
            },
            el: F2(function (toMsg, prompt) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Components$Description$OnGenerate_fn(A2($elm$core$Basics$composeR, toMsg, $author$project$Components$Description$EditorMsg), prompt));
            }),
            fM: function (updatedDescription) {
                return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Components$Description$OnSuccess(updatedDescription));
            },
            m: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 90))
            ]),
            gd: $author$project$Components$Description$EditorMsg
        });
    };
    var $author$project$Components$AiEditor$AiPromptResponded = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$AiEditor$Applied = { $: 2 };
    var $author$project$Components$AiEditor$CloseDialog = { $: 9 };
    var $author$project$Components$AiEditor$EditorOverwriteConfirmationRequired = { $: 7 };
    var $author$project$Components$AiEditor$EditorOverwriteConfirmed = { $: 8 };
    var $author$project$Components$AiEditor$Responded = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Components$AiEditor$closeDialog = function (model) {
        return _Utils_update(model, {
            aE: $author$project$Overlay$clear(model.aE)
        });
    };
    var $rtfeldman$elm_css$Css$Global$button_a0 = "button", $rtfeldman$elm_css$Css$Global$button = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$button_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8 = $rtfeldman$elm_css$Css$property_fn("margin-top", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_20 = $rtfeldman$elm_css$Css$property_fn("width", "5rem");
    var $author$project$Components$confirmDialogSimple = function (cfg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.mc]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(cfg.no),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$button_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_20]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.ek),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.oY]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn("Cancel", cfg.lL))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.hG),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.oZ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn("Proceed", cfg.iU))
                ]))
            ]))
        ]));
    };
    var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
        if (!mx.$) {
            var x = mx.a;
            return x;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$AiEditor$setAiPrompt_fn = function (state, model) {
        return _Utils_update(model, { iA: state });
    }, $author$project$Components$AiEditor$setAiPrompt = F2($author$project$Components$AiEditor$setAiPrompt_fn);
    var $author$project$Components$Editor$setContent_fn = function (model, content) {
        return _Utils_update(model, { gB: content });
    }, $author$project$Components$Editor$setContent = F2($author$project$Components$Editor$setContent_fn);
    var $author$project$Components$AiEditor$setEditor_fn = function (content, model) {
        return _Utils_update(model, {
            gO: $author$project$Components$Editor$setContent_fn(model.gO, content)
        });
    }, $author$project$Components$AiEditor$setEditor = F2($author$project$Components$AiEditor$setEditor_fn);
    var $author$project$Components$AiEditor$setExecuting_fn = function (updating, model) {
        return _Utils_update(model, { gR: updating });
    }, $author$project$Components$AiEditor$setExecuting = F2($author$project$Components$AiEditor$setExecuting_fn);
    var $author$project$Components$AiEditor$setGenerating_fn = function (generating, model) {
        return _Utils_update(model, { gY: generating });
    }, $author$project$Components$AiEditor$setGenerating = F2($author$project$Components$AiEditor$setGenerating_fn);
    var $author$project$Components$Editor$updateInitialContent = function (model) {
        return _Utils_update(model, { eb: model.gB });
    };
    var $author$project$Components$AiEditor$updateInitialContent = function (model) {
        return _Utils_update(model, {
            gO: $author$project$Components$Editor$updateInitialContent(model.gO)
        });
    };
    var $author$project$Components$AiEditor$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, model.gd($author$project$Components$AiEditor$Applied))), function (message) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        aE: $author$project$Overlay$showCentered_fn($author$project$Components$confirmDialogSimple({ lL: $elm$core$Maybe$Nothing, iU: $elm$core$Maybe$Nothing, no: message, ek: $author$project$Components$AiEditor$CloseDialog, hG: $author$project$Components$AiEditor$Applied }), model.aE)
                    }), $elm$core$Platform$Cmd$none);
                }, $elm_community$maybe_extra$Maybe$Extra$join($elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(model.gO.gB), model.e7)));
            case 2:
                return $author$project$Util$withCmd_fn($elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, model.gd($author$project$Components$AiEditor$CloseDialog)), $author$project$Util$withCmd_fn(A2(model.bC, $author$project$Components$AiEditor$Responded, model.gO.gB), $author$project$Util$withModel_fn($author$project$Components$AiEditor$setExecuting(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 3:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$AiEditor$updateInitialContent, $author$project$Util$withModel_fn($author$project$Components$AiEditor$setExecuting(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$AiEditor$setExecuting(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
                }
            case 4:
                var aiPrompt = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$AiEditor$setAiPrompt(aiPrompt), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 5:
                var editorHasDefaultContent = function () {
                    var defaultContent = $elm$core$Maybe$map_fn($elm$core$String$toLower, model.l8);
                    var content = $elm$core$String$toLower(model.gO.gB);
                    return _Utils_eq($elm$core$Maybe$Just(content), defaultContent);
                }();
                var editorEmpty = $elm$core$String$isEmpty(model.gO.gB);
                return ((editorEmpty || editorHasDefaultContent) ? A2($elm$core$Basics$composeR, $author$project$Util$withModel($author$project$Components$AiEditor$setGenerating(true)), $author$project$Util$withCmdFromModel(A2($elm$core$Basics$composeR, function ($) {
                    return $.iA;
                }, model.el($author$project$Components$AiEditor$AiPromptResponded)))) : $author$project$Util$withCmd($elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, model.gd($author$project$Components$AiEditor$EditorOverwriteConfirmationRequired))))(_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 6:
                var response = msg.a;
                if (!response.$) {
                    var generated = response.a;
                    return $author$project$Util$withModel_fn($author$project$Components$AiEditor$setEditor(generated), $author$project$Util$withModel_fn($author$project$Components$AiEditor$setGenerating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$AiEditor$setGenerating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
                }
            case 7:
                var dialog = $author$project$Components$confirmDialogSimple({ lL: $elm$core$Maybe$Nothing, iU: $elm$core$Maybe$Nothing, no: "Current content will be overwritten.", ek: $author$project$Components$AiEditor$CloseDialog, hG: $author$project$Components$AiEditor$EditorOverwriteConfirmed });
                return _Utils_Tuple2(_Utils_update(model, {
                    aE: $author$project$Overlay$showCentered_fn(dialog, model.aE)
                }), $elm$core$Platform$Cmd$none);
            case 8:
                return $author$project$Util$withCmdFromModel_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.iA;
                }, model.el($author$project$Components$AiEditor$AiPromptResponded)), $author$project$Util$withModel_fn($author$project$Components$AiEditor$setGenerating(true), $author$project$Util$withModel_fn($author$project$Components$AiEditor$closeDialog, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 9:
                return _Utils_Tuple2(_Utils_update(model, {
                    aE: $author$project$Overlay$clear(model.aE)
                }), $elm$core$Platform$Cmd$none);
            case 10:
                var subMsg = msg.a;
                var _v3 = $author$project$Overlay$update_fn(subMsg, model.aE);
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { aE: overlay }), _Platform_map_fn(model.gd, cmd));
            case 11:
                var editorMsg = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    gO: $author$project$Components$Editor$update_fn(editorMsg, model.gO)
                }), $elm$core$Platform$Cmd$none);
            default:
                var parentMsg = msg.a;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, parentMsg));
        }
    }, $author$project$Components$AiEditor$update = F2($author$project$Components$AiEditor$update_fn);
    var $author$project$Components$Description$update_fn = function (cfg, msg, model) {
        switch (msg.$) {
            case 0:
                var subMsg = msg.a;
                var _v1 = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(model.gO, $elm$core$Platform$Cmd$none), A2($elm$core$Basics$composeR, $author$project$Components$AiEditor$update(subMsg), $elm$core$Tuple$mapFirst($elm$core$Maybe$Just)), model.gO);
                var editor = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, { gO: editor }), _Platform_map_fn(cfg.gd, cmd));
            case 1:
                var description = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    gO: $elm$core$Maybe$Just($author$project$Components$Description$initEditor(description))
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, { gO: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$none);
            case 3:
                var msg_ = msg.a;
                var prompt = msg.b;
                return _Utils_Tuple2(model, A2(cfg.el, msg_, prompt));
            case 4:
                var msg_ = msg.a;
                var content = msg.b;
                return _Utils_Tuple2(model, A2(cfg.bC, msg_, content));
            case 5:
                var description = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { gO: $elm$core$Maybe$Nothing }), cfg.nP(description));
            default:
                var errors = msg.a;
                return _Utils_Tuple2(model, cfg.nU(errors));
        }
    }, $author$project$Components$Description$update = F3($author$project$Components$Description$update_fn);
    var $elm$core$Set$remove_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$remove_fn(key, dict);
    }, $elm$core$Set$remove = F2($elm$core$Set$remove_fn);
    var $author$project$Components$TableSchema$update_fn = function (msg, model) {
        switch (msg.$) {
            case 1:
                return { aR: $elm$core$Set$empty };
            case 0:
                var tableNameList = msg.a;
                return {
                    aR: $elm$core$Set$fromList(tableNameList)
                };
            default:
                var tableName = msg.a;
                return $elm$core$Set$member_fn(tableName, model.aR) ? {
                    aR: $elm$core$Set$remove_fn(tableName, model.aR)
                } : {
                    aR: $elm$core$Set$insert_fn(tableName, model.aR)
                };
        }
    }, $author$project$Components$TableSchema$update = F2($author$project$Components$TableSchema$update_fn);
    var $author$project$Pages$Database$update_fn = function (onError, onRenamed, setOwnerCmd, toMsg, msg, database, shared, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple3(model, database, $elm$core$Platform$Cmd$none);
            case 1:
                var subMsg = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eG: $author$project$Components$TableSchema$update_fn(subMsg, model.eG)
                }), database, $elm$core$Platform$Cmd$none);
            case 2:
                var subMsg = msg.a;
                var _v1 = $author$project$Components$Description$update_fn({
                    bC: F2(function (msg_, content) {
                        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$setDatabaseDescription, A2($elm$core$Basics$composeR, msg_, $author$project$Pages$Database$DescriptionMsgReceived), shared.k2, $elm_community$string_extra$String$Extra$nonEmpty(content)), $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, database));
                    }),
                    nP: A2($elm$core$Basics$composeR, $author$project$Pages$Database$DescriptionUpdated, $author$project$Util$msgCmd),
                    nU: A2($elm$core$Basics$composeR, $author$project$Pages$Database$ShowErrors, $author$project$Util$msgCmd),
                    el: F2(function (msg_, prompt) {
                        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$generateDatabaseDescription, A2($elm$core$Basics$composeR, msg_, $author$project$Pages$Database$DescriptionMsgReceived), shared.k2, prompt), $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, database));
                    }),
                    gd: $author$project$Pages$Database$DescriptionMsgReceived
                }, subMsg, model.i6);
                var description = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, { i6: description }), database, _Platform_map_fn(toMsg, cmd));
            case 3:
                var maybeString = msg.a;
                return _Utils_Tuple3(_Utils_update(model, { a9: maybeString }), database, $elm$core$Platform$Cmd$none);
            case 4:
                var name = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    a9: $elm$core$Maybe$Just(name)
                }), database, $elm$core$Task$attempt_fn(function (_v2) {
                    return toMsg($author$project$Pages$Database$NoOp);
                }, _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, "database-name-input")));
            case 5:
                var db = msg.a;
                if (_Utils_eq(model.a9, $elm$core$Maybe$Just(db.mw))) {
                    return _Utils_Tuple3(model, database, $elm$core$Platform$Cmd$none);
                }
                else {
                    var databaseNew = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(database, function (newName) {
                        return $krisajenkins$remotedata$RemoteData$succeed(_Utils_update(db, { mw: newName }));
                    }, model.a9);
                    var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$renameDatabase, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Database$DatabaseNameEditResponded(db)), shared.k2, db.bR), model.a9);
                    return _Utils_Tuple3(_Utils_update(model, { a9: $elm$core$Maybe$Nothing, la: true }), databaseNew, cmd);
                }
            case 6:
                var dbOld = msg.a;
                var response = msg.b;
                if (!response.$) {
                    return _Utils_Tuple3(_Utils_update(model, { la: false }), database, $krisajenkins$remotedata$RemoteData$unwrap_fn($elm$core$Platform$Cmd$none, onRenamed, database));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple3(_Utils_update(model, { la: false }), $krisajenkins$remotedata$RemoteData$succeed(dbOld), A2(onError, $elm$core$Maybe$Just("Error"), errors));
                }
            case 7:
                var description = msg.a;
                return _Utils_Tuple3(model, A2($author$project$Types$Database$setDescription, description, database), $elm$core$Platform$Cmd$none);
            case 8:
                var errors = msg.a;
                return _Utils_Tuple3(model, database, A2(onError, $elm$core$Maybe$Just("Error"), errors));
            case 9:
                var dbId = msg.a;
                var owner = msg.b;
                return _Utils_Tuple3(_Utils_update(model, { la: true }), database, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A3(setOwnerCmd, toMsg($author$project$Pages$Database$OwnerSet), dbId, owner)));
            default:
                return _Utils_Tuple3(_Utils_update(model, { la: false }), database, $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Pages$Database$update = F8($author$project$Pages$Database$update_fn);
    var $author$project$Pages$ForgotPassword$ConfirmationReceived = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Api$requestPasswordResetLink_fn = function (msg, email) {
        return $elm$http$Http$request({
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("email", $elm$json$Json$Encode$string(email))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            d9: _List_Nil,
            f: "POST",
            eK: $elm$core$Maybe$Nothing,
            eQ: $elm$core$Maybe$Nothing,
            g: "/api/users/reset-password"
        });
    }, $author$project$Api$requestPasswordResetLink = F2($author$project$Api$requestPasswordResetLink_fn);
    var $dillonkearns$elm_form$Form$initSingle = { F: $elm$core$Dict$empty, o1: false };
    var $dillonkearns$elm_form$Form$setSubmitAttempted_fn = function (fieldId, pageFormState) {
        return $elm$core$Dict$update_fn(fieldId, function (maybeForm) {
            if (!maybeForm.$) {
                var formState = maybeForm.a;
                return $elm$core$Maybe$Just(_Utils_update(formState, { o1: true }));
            }
            else {
                return $elm$core$Maybe$Just(_Utils_update($dillonkearns$elm_form$Form$initSingle, { o1: true }));
            }
        }, pageFormState);
    }, $dillonkearns$elm_form$Form$setSubmitAttempted = F2($dillonkearns$elm_form$Form$setSubmitAttempted_fn);
    var $dillonkearns$elm_form$Form$Validation$Blurred = 3;
    var $dillonkearns$elm_form$Form$Validation$Changed = 2;
    var $dillonkearns$elm_form$Form$Validation$Focused = 1;
    var $dillonkearns$elm_form$Form$Validation$NotVisited = 0;
    var $dillonkearns$elm_form$Form$statusRank = function (status) {
        switch (status) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $dillonkearns$elm_form$Form$increaseStatusTo_fn = function (increaseTo, currentStatus) {
        return (_Utils_cmp($dillonkearns$elm_form$Form$statusRank(increaseTo), $dillonkearns$elm_form$Form$statusRank(currentStatus)) > 0) ? increaseTo : currentStatus;
    }, $dillonkearns$elm_form$Form$increaseStatusTo = F2($dillonkearns$elm_form$Form$increaseStatusTo_fn);
    var $dillonkearns$elm_form$Form$updateForm_fn = function (fieldEvent, formState) {
        return _Utils_update(formState, {
            F: $elm$core$Dict$update_fn(fieldEvent.M, function (previousValue_) {
                var previousValue = $elm$core$Maybe$withDefault_fn({ oV: 0, pB: fieldEvent.pB }, previousValue_);
                return $elm$core$Maybe$Just(function () {
                    var _v0 = fieldEvent.mm;
                    switch (_v0.$) {
                        case 0:
                            var newValue = _v0.a;
                            return _Utils_update(previousValue, {
                                oV: $dillonkearns$elm_form$Form$increaseStatusTo_fn(2, previousValue.oV),
                                pB: newValue
                            });
                        case 1:
                            return _Utils_update(previousValue, {
                                oV: $dillonkearns$elm_form$Form$increaseStatusTo_fn(1, previousValue.oV)
                            });
                        default:
                            return _Utils_update(previousValue, {
                                oV: $dillonkearns$elm_form$Form$increaseStatusTo_fn(3, previousValue.oV)
                            });
                    }
                }());
            }, formState.F)
        });
    }, $dillonkearns$elm_form$Form$updateForm = F2($dillonkearns$elm_form$Form$updateForm_fn);
    var $dillonkearns$elm_form$Form$updateInternal_fn = function (fieldEvent, pageFormState) {
        return $elm$core$Dict$update_fn(fieldEvent.mz, function (previousValue_) {
            var previousValue = $elm$core$Maybe$withDefault_fn($dillonkearns$elm_form$Form$initSingle, previousValue_);
            return $elm$core$Maybe$Just($dillonkearns$elm_form$Form$updateForm_fn(fieldEvent, previousValue));
        }, pageFormState);
    }, $dillonkearns$elm_form$Form$updateInternal = F2($dillonkearns$elm_form$Form$updateInternal_fn);
    var $dillonkearns$elm_form$Form$update_fn = function (formMsg, formModel) {
        switch (formMsg.$) {
            case 2:
                var myMsg = formMsg.a;
                return _Utils_Tuple2(formModel, $elm$core$Task$perform_fn($elm$core$Basics$identity, $elm$core$Task$succeed(myMsg)));
            case 1:
                var value = formMsg.a;
                return _Utils_Tuple2($dillonkearns$elm_form$Form$updateInternal_fn(value, formModel), $elm$core$Platform$Cmd$none);
            default:
                var formData = formMsg.a;
                var maybeMsg = formMsg.b;
                return _Utils_Tuple2($dillonkearns$elm_form$Form$setSubmitAttempted_fn($elm$core$Maybe$withDefault_fn("form", formData.bR), formModel), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(function (userMsg) {
                    return $elm$core$Task$perform_fn($elm$core$Basics$identity, $elm$core$Task$succeed(userMsg));
                }, maybeMsg)));
        }
    }, $dillonkearns$elm_form$Form$update = F2($dillonkearns$elm_form$Form$update_fn);
    var $author$project$Pages$ForgotPassword$update_fn = function (toMsg, msg, model) {
        switch (msg.$) {
            case 0:
                var maybeUser = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    fA: !_Utils_eq(maybeUser, $elm$core$Maybe$Nothing)
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var formMsg = msg.a;
                var _v1 = $dillonkearns$elm_form$Form$update_fn(formMsg, model.d6);
                var formState = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, { d6: formState }), _Platform_map_fn(toMsg, cmd));
            case 2:
                var parsed = msg.a;
                if (!parsed.$) {
                    var email = parsed.a.jb;
                    return _Utils_Tuple2(_Utils_update(model, { bs: $krisajenkins$remotedata$RemoteData$Loading }), _Platform_map_fn(toMsg, $author$project$Api$requestPasswordResetLink_fn($author$project$Pages$ForgotPassword$ConfirmationReceived, email)));
                }
                else {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            default:
                if (!msg.a.$) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        bs: $krisajenkins$remotedata$RemoteData$Success(0)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        bs: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), $elm$core$Platform$Cmd$none);
                }
        }
    }, $author$project$Pages$ForgotPassword$update = F3($author$project$Pages$ForgotPassword$update_fn);
    var $author$project$Pages$Functions$AddFunction = function (a) {
        return { $: 26, a: a };
    };
    var $author$project$Pages$Functions$AddFunctionMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Functions$CloseDialog = { $: 23 };
    var $author$project$Pages$Functions$DeleteFunctionResponded = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Pages$Functions$DescriptionMsg_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Functions$DescriptionMsg = F2($author$project$Pages$Functions$DescriptionMsg_fn);
    var $author$project$Pages$Functions$ExecuteFunctionResponded_fn = function (a, b) {
        return { $: 22, a: a, b: b };
    }, $author$project$Pages$Functions$ExecuteFunctionResponded = F2($author$project$Pages$Functions$ExecuteFunctionResponded_fn);
    var $author$project$Pages$Functions$Navigate = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Functions$NavigateReplace = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Pages$Functions$RepublishFunctionVersionResponded = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$Pages$Functions$RevertChanges = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Pages$Functions$SaveFunctionResponded = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Pages$Functions$ShowErrors = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$Pages$Functions$UpdateFunction = function (a) {
        return { $: 27, a: a };
    };
    var $author$project$Pages$Functions$addFunction_fn = function (_function, model) {
        return _Utils_update(model, {
            mB: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$List$cons(_function), model.mB)
        });
    }, $author$project$Pages$Functions$addFunction = F2($author$project$Pages$Functions$addFunction_fn);
    var $author$project$Components$GqlResponse$clearResponse = function (model) {
        return _Utils_update(model, { aw: $elm$core$Maybe$Nothing });
    };
    var $author$project$Pages$Functions$FunctionTab$clearResponse = function (tab) {
        return _Utils_update(tab, {
            mE: $author$project$Components$GqlResponse$clearResponse(tab.mE)
        });
    };
    var $author$project$Pages$Functions$closeDialogs = function (model) {
        return _Utils_update(model, {
            aE: $author$project$Overlay$clear(model.aE),
            cm: $elm$core$Maybe$Nothing
        });
    };
    var $author$project$Types$Function$Function_fn = function (name, id, description, content, versions, runtime) {
        return { gB: content, i6: description, bR: id, M: name, oJ: runtime, le: versions };
    }, $author$project$Types$Function$Function = F6($author$project$Types$Function$Function_fn);
    var $author$project$Types$Function$Runtime$Python = 1;
    var $author$project$Types$Function$Runtime$TypeScript_Deno = 0;
    var $author$project$Types$Function$Runtime$list = _List_fromArray([0, 1]);
    var $author$project$Types$Function$Runtime$toJsonString = function (runtime) {
        if (!runtime) {
            return "deno";
        }
        else {
            return "python";
        }
    };
    var $author$project$Types$Function$Runtime$decode = _Json_andThen_fn(function (runtime) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Decode$fail("Unknown runtime: " + runtime), $elm$json$Json$Decode$succeed, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $author$project$Types$Function$Runtime$toJsonString, $elm$core$Basics$eq(runtime)), $author$project$Types$Function$Runtime$list));
    }, $elm$json$Json$Decode$string);
    var $author$project$Types$Function$decoder = _Json_map6_fn($author$project$Types$Function$Function, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), _Json_decodeField_fn("id", $elm$json$Json$Decode$string), _Json_decodeField_fn("description", _Json_map1_fn($elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonEmpty), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))), _Json_decodeField_fn("content", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)), _Json_decodeField_fn("versions", $elm$json$Json$Decode$list(_Json_map1_fn(function (id) {
        return { i_: $krisajenkins$remotedata$RemoteData$NotAsked, bR: id };
    }, $elm$json$Json$Decode$string))), _Json_decodeField_fn("runtime", $author$project$Types$Function$Runtime$decode));
    var $author$project$Types$Function$defaultContent = function (runtime) {
        if (!runtime) {
            return "export default async function (\n  context: {\n    functionId: string,\n    method: \"GET\" | \"POST\" |  \"PATCH\" | \"PUT\" | \"DELETE\",\n    headers: Record<string, string>,\n    data: Record<string, unknown>,\n  },\n) {\n  console.info(`You called function ${context.functionId}`)\n\n  console.info(`Provided headers: ${JSON.stringify(context.headers)}`)\n\n  // This is how to access environment variables defined in database settings:\n  console.info(process.env.MY_VAR)\n\n  switch (context.method) {\n    case \"GET\":\n      return { data: \"A GET request!\" }\n    case \"POST\":\n      return {\n        data: {\n          msg: \"A POST request\",\n          userData: context.data,\n        },\n      }\n    default:  // PATCH, PUT, and DELETE\n      return { data: \"A request!\" }\n  }\n}\n";
        }
        else {
            return "import json\nimport os\n\nasync def main(context):\n    function_id = context.functionId\n    method = context.method\n    headers = context.headers\n    data = context.data\n\n    print(f'You called function {function_id}')\n    print(f'Provided headers: {json.dumps(headers)}')\n\n    # Accessing environment variable\n    my_var = os.getenv('MY_VAR')\n    print(my_var)\n\n    # Handling different HTTP methods\n    if method == 'GET':\n        return {'data': 'A GET request!'}\n    elif method == 'POST':\n        return {\n            'data': {\n                'msg': 'A POST request',\n                'userData': data,\n            }\n        }\n    else:  # For PATCH, PUT, and DELETE\n        return {'data': 'A request!'}\n";
        }
    };
    var $author$project$Types$Function$Runtime$encode_a0 = $author$project$Types$Function$Runtime$toJsonString, $author$project$Types$Function$Runtime$encode_a1 = $elm$json$Json$Encode$string, $author$project$Types$Function$Runtime$encode = A2($elm$core$Basics$composeR, $author$project$Types$Function$Runtime$encode_a0, $author$project$Types$Function$Runtime$encode_a1);
    var $author$project$Api$createFunction_fn = function (msg, maybeToken, dbId, name, runtime, maybeContent) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("name", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn("New Function", name))),
                _Utils_Tuple2("runtime", $elm$core$Basics$composeR_fn($author$project$Types$Function$Runtime$encode_a0, $author$project$Types$Function$Runtime$encode_a1, runtime)),
                _Utils_Tuple2("content", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn($author$project$Types$Function$defaultContent(runtime), maybeContent)))
            ]))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$Function$decoder),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/functions")
        });
    }, $author$project$Api$createFunction = F6($author$project$Api$createFunction_fn);
    var $author$project$Api$deleteFunction_fn = function (msg, maybeToken, dbId, _function) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(_function)),
            f: "DELETE",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/functions/" + $elm$url$Url$percentEncode(_function.bR)))
        });
    }, $author$project$Api$deleteFunction = F4($author$project$Api$deleteFunction_fn);
    var $elm$http$Http$stringBody = _Http_pair;
    var $author$project$Api$executeFunction_fn = function (msg, maybeToken, data, _function) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: _Http_pair_fn("application/json", $elm$core$Maybe$withDefault_fn("{}", $elm_community$string_extra$String$Extra$nonEmpty($elm$core$String$trim(data)))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$value),
            f: "POST",
            g: "/fns/" + $elm$url$Url$percentEncode(_function.bR)
        });
    }, $author$project$Api$executeFunction = F4($author$project$Api$executeFunction_fn);
    var $dillonkearns$elm_form$Internal$Form$Form_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_form$Internal$Form$Form = F3($dillonkearns$elm_form$Internal$Form$Form_fn);
    var $dillonkearns$elm_form$Internal$Form$RegularField = 0;
    var $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_form$Pages$Internal$Form$Validation = F3($dillonkearns$elm_form$Pages$Internal$Form$Validation_fn);
    var $dillonkearns$elm_form$Form$addErrorsInternal_fn = function (name, newErrors, allErrors) {
        return $elm$core$Dict$update_fn(name, function (errors) {
            return $elm$core$Maybe$Just(_Utils_ap(newErrors, $elm$core$Maybe$withDefault_fn(_List_Nil, errors)));
        }, allErrors);
    }, $dillonkearns$elm_form$Form$addErrorsInternal = F3($dillonkearns$elm_form$Form$addErrorsInternal_fn);
    var $dillonkearns$elm_form$Form$FieldStatus$notVisited = 0;
    var $dillonkearns$elm_form$Form$field_fn = function (name, _v0, _v1) {
        var fieldParser = _v0.a;
        var kind = _v0.b;
        var definitions = _v1.a;
        var parseFn = _v1.b;
        var toInitialValues = _v1.c;
        return $dillonkearns$elm_form$Internal$Form$Form_fn(_List_Cons(_Utils_Tuple2(name, 0), definitions), F2(function (maybeData, formState) {
            var _v2 = function () {
                var _v3 = $elm$core$Dict$get_fn(name, formState.F);
                if (!_v3.$) {
                    var info = _v3.a;
                    return _Utils_Tuple2($elm$core$Maybe$Just(info.pB), info.oV);
                }
                else {
                    return _Utils_Tuple2($elm$core$Maybe$andThen_fn(function (data) {
                        return fieldParser.ec(data);
                    }, maybeData), $dillonkearns$elm_form$Form$FieldStatus$notVisited);
                }
            }();
            var rawFieldValue = _v2.a;
            var fieldStatus = _v2.b;
            var thing = {
                hj: _Utils_Tuple2(kind, fieldParser.kB),
                oV: fieldStatus,
                pB: rawFieldValue
            };
            var _v4 = fieldParser.gI(rawFieldValue);
            var maybeParsed = _v4.a;
            var errors = _v4.b;
            var parsedField = $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Just(thing), $elm$core$Maybe$Just(name), _Utils_Tuple2(maybeParsed, $elm$core$Dict$empty));
            var myFn = function (soFar) {
                var validationField = parsedField;
                return {
                    av: soFar.av(validationField),
                    aY: soFar.aY,
                    am: $dillonkearns$elm_form$Form$addErrorsInternal_fn(name, errors, soFar.am)
                };
            };
            return myFn(A2(parseFn, maybeData, formState));
        }), function (input) {
            var _v5 = fieldParser.ec(input);
            if (!_v5.$) {
                var initialValue = _v5.a;
                return _List_Cons(_Utils_Tuple2(name, $elm$core$Maybe$Just(initialValue)), toInitialValues(input));
            }
            else {
                return toInitialValues(input);
            }
        });
    }, $dillonkearns$elm_form$Form$field = F3($dillonkearns$elm_form$Form$field_fn);
    var $dillonkearns$elm_form$Form$form = function (combineAndView) {
        return $dillonkearns$elm_form$Internal$Form$Form_fn(_List_Nil, F2(function (_v0, _v1) {
            return { av: combineAndView, aY: true, am: $elm$core$Dict$empty };
        }), function (_v2) {
            return _List_Nil;
        });
    };
    var $dillonkearns$elm_form$Internal$Field$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_form$Internal$Field$Field = F2($dillonkearns$elm_form$Internal$Field$Field_fn);
    var $dillonkearns$elm_form$Form$Field$required_fn = function (missingError, _v0) {
        var field = _v0.a;
        var kind = _v0.b;
        return $dillonkearns$elm_form$Internal$Field$Field_fn({
            H: field.H,
            gI: function (rawValue) {
                var isEmpty = _Utils_eq(rawValue, $elm$core$Maybe$Just("")) || _Utils_eq(rawValue, $elm$core$Maybe$Nothing);
                var _v1 = field.gI(rawValue);
                var parsed = _v1.a;
                var allErrors = _v1.b;
                return _Utils_Tuple2($elm$core$Maybe$andThen_fn($elm$core$Basics$identity, parsed), isEmpty ? _List_Cons(missingError, allErrors) : allErrors);
            },
            A: field.A,
            ec: field.ec,
            kB: _List_Cons(_Utils_Tuple2("required", $elm$json$Json$Encode$bool(true)), field.kB)
        }, kind);
    }, $dillonkearns$elm_form$Form$Field$required = F2($dillonkearns$elm_form$Form$Field$required_fn);
    var $dillonkearns$elm_form$Internal$Input$Options_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_form$Internal$Input$Options = F2($dillonkearns$elm_form$Internal$Input$Options_fn);
    var $dillonkearns$elm_form$Form$Field$enumToString_fn = function (optionsMapping, a) {
        var _v0 = $elm$core$List$head($elm$core$List$filter_fn(function (_v1) {
            var b = _v1.b;
            return _Utils_eq(b, a);
        }, optionsMapping));
        if (!_v0.$) {
            var _v2 = _v0.a;
            var str = _v2.a;
            return str;
        }
        else {
            return "Missing enum";
        }
    }, $dillonkearns$elm_form$Form$Field$enumToString = F2($dillonkearns$elm_form$Form$Field$enumToString_fn);
    var $dillonkearns$elm_form$Form$Field$select_fn = function (optionsMapping, invalidError) {
        var dict = $elm$core$Dict$fromList(optionsMapping);
        var fromString = function (string) {
            return $elm$core$Dict$get_fn(string, dict);
        };
        return $dillonkearns$elm_form$Internal$Field$Field_fn({
            H: F2(function (_v0, _v1) {
                return 1;
            }),
            gI: function (rawValue) {
                if (rawValue.$ === 1) {
                    return _Utils_Tuple2($elm$core$Maybe$Just($elm$core$Maybe$Nothing), _List_Nil);
                }
                else {
                    if (rawValue.a === "") {
                        return _Utils_Tuple2($elm$core$Maybe$Just($elm$core$Maybe$Nothing), _List_Nil);
                    }
                    else {
                        var justValue = rawValue.a;
                        var parsed = fromString(justValue);
                        if (!parsed.$) {
                            var okParsed = parsed.a;
                            return _Utils_Tuple2($elm$core$Maybe$Just($elm$core$Maybe$Just(okParsed)), _List_Nil);
                        }
                        else {
                            return _Utils_Tuple2($elm$core$Maybe$Just($elm$core$Maybe$Nothing), _List_fromArray([
                                invalidError(justValue)
                            ]));
                        }
                    }
                }
            },
            A: $dillonkearns$elm_form$Form$Field$enumToString(optionsMapping),
            ec: function (_v4) {
                return $elm$core$Maybe$Nothing;
            },
            kB: _List_Nil
        }, $dillonkearns$elm_form$Internal$Input$Options_fn(fromString, $elm$core$List$map_fn($elm$core$Tuple$first, optionsMapping)));
    }, $dillonkearns$elm_form$Form$Field$select = F2($dillonkearns$elm_form$Form$Field$select_fn);
    var $dillonkearns$elm_form$Internal$Input$Input = $elm$core$Basics$identity;
    var $dillonkearns$elm_form$Internal$Input$Text = { $: 0 };
    var $dillonkearns$elm_form$Form$Field$text = $dillonkearns$elm_form$Internal$Field$Field_fn({
        H: $elm$core$Basics$compare,
        gI: function (rawValue) {
            return _Utils_Tuple2(_Utils_eq(rawValue, $elm$core$Maybe$Just("")) ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : $elm$core$Maybe$Just(rawValue), _List_Nil);
        },
        A: $elm$core$Basics$identity,
        ec: function (_v0) {
            return $elm$core$Maybe$Nothing;
        },
        kB: _List_Nil
    }, $dillonkearns$elm_form$Internal$Input$Text);
    var $author$project$Types$Function$Runtime$toString = function (runtime) {
        if (!runtime) {
            return "TypeScript (Deno 1.39)";
        }
        else {
            return "Python (3.10)";
        }
    };
    var $author$project$Pages$Functions$CreateFunctionForm$CreateFunctionForm_fn = function (name, runtime) {
        return { M: name, oJ: runtime };
    }, $author$project$Pages$Functions$CreateFunctionForm$CreateFunctionForm = F2($author$project$Pages$Functions$CreateFunctionForm$CreateFunctionForm_fn);
    var $dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn = function (key, values, dict) {
        return $elm$core$List$isEmpty(values) ? dict : $elm$core$Dict$insert_fn(key, values, dict);
    }, $dillonkearns$elm_form$Form$Validation$insertIfNonempty = F3($dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn);
    var $dillonkearns$elm_form$Form$Validation$mergeErrors_fn = function (errors1, errors2) {
        return $elm$core$Dict$merge_fn(F3(function (key, entries, soFar) {
            return $dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn(key, entries, soFar);
        }), F4(function (key, entries1, entries2, soFar) {
            return $dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn(key, _Utils_ap(entries1, entries2), soFar);
        }), F3(function (key, entries, soFar) {
            return $dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn(key, entries, soFar);
        }), errors1, errors2, $elm$core$Dict$empty);
    }, $dillonkearns$elm_form$Form$Validation$mergeErrors = F2($dillonkearns$elm_form$Form$Validation$mergeErrors_fn);
    var $dillonkearns$elm_form$Form$Validation$map2_fn = function (f, _v0, _v2) {
        var _v1 = _v0.c;
        var maybeParsedA = _v1.a;
        var errorsA = _v1.b;
        var _v3 = _v2.c;
        var maybeParsedB = _v3.a;
        var errorsB = _v3.b;
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _Utils_Tuple2($elm$core$Maybe$map2_fn(f, maybeParsedA, maybeParsedB), $dillonkearns$elm_form$Form$Validation$mergeErrors_fn(errorsA, errorsB)));
    }, $dillonkearns$elm_form$Form$Validation$map2 = F3($dillonkearns$elm_form$Form$Validation$map2_fn);
    var $dillonkearns$elm_form$Form$Validation$andMap_a0 = $elm$core$Basics$apR, $dillonkearns$elm_form$Form$Validation$andMap = $dillonkearns$elm_form$Form$Validation$map2($dillonkearns$elm_form$Form$Validation$andMap_a0);
    var $elm_community$result_extra$Result$Extra$filter_fn = function (err, predicate, result) {
        var _v0 = $elm$core$Result$map_fn(predicate, result);
        if (!_v0.$) {
            if (_v0.a) {
                return result;
            }
            else {
                return $elm$core$Result$Err(err);
            }
        }
        else {
            return result;
        }
    }, $elm_community$result_extra$Result$Extra$filter = F3($elm_community$result_extra$Result$Extra$filter_fn);
    var $dillonkearns$elm_form$Form$Validation$andThen_fn = function (andThenFn, _v0) {
        var _v1 = _v0.c;
        var maybeParsed = _v1.a;
        var errors = _v1.b;
        if (!maybeParsed.$) {
            var parsed = maybeParsed.a;
            return function (_v3) {
                var _v4 = _v3.c;
                var andThenParsed = _v4.a;
                var andThenErrors = _v4.b;
                return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _Utils_Tuple2(andThenParsed, $dillonkearns$elm_form$Form$Validation$mergeErrors_fn(errors, andThenErrors)));
            }(andThenFn(parsed));
        }
        else {
            return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _Utils_Tuple2($elm$core$Maybe$Nothing, errors));
        }
    }, $dillonkearns$elm_form$Form$Validation$andThen = F2($dillonkearns$elm_form$Form$Validation$andThen_fn);
    var $elm$core$Dict$singleton_fn = function (key, value) {
        return $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    }, $elm$core$Dict$singleton = F2($elm$core$Dict$singleton_fn);
    var $dillonkearns$elm_form$Form$Validation$fail_fn = function (parsed, _v0) {
        var key = _v0.b;
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Dict$singleton_fn($elm$core$Maybe$withDefault_fn("", key), _List_fromArray([parsed]))));
    }, $dillonkearns$elm_form$Form$Validation$fail = F2($dillonkearns$elm_form$Form$Validation$fail_fn);
    var $dillonkearns$elm_form$Form$Validation$succeed = function (parsed) {
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _Utils_Tuple2($elm$core$Maybe$Just(parsed), $elm$core$Dict$empty));
    };
    var $dillonkearns$elm_form$Form$Validation$fromResult = function (fieldResult) {
        return $dillonkearns$elm_form$Form$Validation$andThen_fn(function (parsedValue) {
            if (!parsedValue.$) {
                var okValue = parsedValue.a;
                return $dillonkearns$elm_form$Form$Validation$succeed(okValue);
            }
            else {
                var error = parsedValue.a;
                return $dillonkearns$elm_form$Form$Validation$fail_fn(error, fieldResult);
            }
        }, fieldResult);
    };
    var $dillonkearns$elm_form$Form$Validation$map_fn = function (mapFn, _v0) {
        var name = _v0.b;
        var _v1 = _v0.c;
        var maybeParsedA = _v1.a;
        var errorsA = _v1.b;
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, name, _Utils_Tuple2($elm$core$Maybe$map_fn(mapFn, maybeParsedA), errorsA));
    }, $dillonkearns$elm_form$Form$Validation$map = F2($dillonkearns$elm_form$Form$Validation$map_fn);
    var $author$project$Pages$Functions$CreateFunctionForm$validateForm_fn = function (name, runtime) {
        var isValidFunctionName = $elm$core$String$all(function (c) {
            return $elm$core$Char$isAlphaNum(c) || ((c === "-") || (c === "_"));
        });
        return $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, runtime, $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, $dillonkearns$elm_form$Form$Validation$fromResult($dillonkearns$elm_form$Form$Validation$map_fn(A2($elm$core$Basics$composeR, $elm$core$Result$Ok, A2($elm_community$result_extra$Result$Extra$filter, "Must be alphanumeric, -, or _", isValidFunctionName)), name)), $dillonkearns$elm_form$Form$Validation$succeed($author$project$Pages$Functions$CreateFunctionForm$CreateFunctionForm)));
    }, $author$project$Pages$Functions$CreateFunctionForm$validateForm = F2($author$project$Pages$Functions$CreateFunctionForm$validateForm_fn);
    var $elm$html$Html$Attributes$boolProperty_fn = function (key, bool) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$bool(bool));
    }, $elm$html$Html$Attributes$boolProperty = F2($elm$html$Html$Attributes$boolProperty_fn);
    var $elm$html$Html$Attributes$checked_a0 = "checked", $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$checked_a0);
    var $rtfeldman$elm_css$Html$Styled$Attributes$cols = function (n) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("cols", $elm$core$String$fromInt(n));
    };
    var $dillonkearns$elm_form$Form$FieldView$expectViewField = function (viewField) {
        expectViewField: while (true) {
            if (!viewField.$) {
                var justViewField = viewField.a;
                return justViewField;
            }
            else {
                var $temp$viewField = viewField;
                viewField = $temp$viewField;
                continue expectViewField;
            }
        }
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(prop, false, "");
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
    var $dillonkearns$elm_form$Internal$Input$inputTypeToString = function (inputType) {
        switch (inputType.$) {
            case 0:
                return "text";
            case 11:
                return "text";
            case 1:
                return "number";
            case 2:
                return "range";
            case 3:
                return "date";
            case 4:
                return "time";
            case 5:
                return "checkbox";
            case 6:
                return "tel";
            case 7:
                return "search";
            case 8:
                return "password";
            case 9:
                return "email";
            default:
                return "url";
        }
    };
    var $elm$html$Html$Attributes$name_a0 = "name", $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$name_a0);
    var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
    var $dillonkearns$elm_form$Form$FieldView$toHtmlProperties = function (properties) {
        return $elm$core$List$map_fn(function (_v0) {
            var key = _v0.a;
            var value = _v0.b;
            return $elm$virtual_dom$VirtualDom$property_fn(key, value);
        }, properties);
    };
    var $elm$html$Html$Attributes$type__a0 = "type", $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$type__a0);
    var $elm$html$Html$Attributes$value_a0 = "value", $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$value_a0);
    var $dillonkearns$elm_form$Form$FieldView$inputStyled_fn = function (attrs, _v0) {
        var viewField = _v0.a;
        var fieldName = _v0.b;
        var justViewField = $dillonkearns$elm_form$Form$FieldView$expectViewField(viewField);
        var rawField = {
            hj: justViewField.hj,
            M: $elm$core$Maybe$withDefault_fn("", fieldName),
            pB: justViewField.pB
        };
        var _v1 = rawField.hj;
        if (_v1.a.$ === 11) {
            var rows = _v1.a.a.hT;
            var cols = _v1.a.a.iS;
            var properties = _v1.b;
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$textarea_a0, _Utils_ap(attrs, _Utils_ap($elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, $dillonkearns$elm_form$Form$FieldView$toHtmlProperties(properties)), _Utils_ap($elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$rows, rows),
                $elm$core$Maybe$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$cols, cols)
            ])), $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, _List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$name_a0, rawField.M)
            ]))))), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn("", rawField.pB))
            ]));
        }
        else {
            var inputType = _v1.a;
            var properties = _v1.b;
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _Utils_ap(attrs, _Utils_ap($elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, $dillonkearns$elm_form$Form$FieldView$toHtmlProperties(properties)), $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, _List_fromArray([
                function () {
                    if (inputType.$ === 5) {
                        return $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, $elm$core$Maybe$withDefault_fn("", rawField.pB) === "on");
                    }
                    else {
                        return $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$value_a0, $elm$core$Maybe$withDefault_fn("", rawField.pB));
                    }
                }(),
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$name_a0, rawField.M),
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, $dillonkearns$elm_form$Internal$Input$inputTypeToString(inputType))
            ])))), _List_Nil);
        }
    }, $dillonkearns$elm_form$Form$FieldView$inputStyled = F2($dillonkearns$elm_form$Form$FieldView$inputStyled_fn);
    var $rtfeldman$elm_css$Css$onlyChild = $rtfeldman$elm_css$Css$pseudoClass("only-child");
    var $rtfeldman$elm_css$Html$Styled$Attributes$name_a0 = "name", $rtfeldman$elm_css$Html$Styled$Attributes$name = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$name_a0);
    var $dillonkearns$elm_form$Form$FieldView$radioStyled_fn = function (selectAttrs, enumToOption, _v0) {
        var viewField = _v0.a;
        var fieldName = _v0.b;
        var justViewField = $dillonkearns$elm_form$Form$FieldView$expectViewField(viewField);
        var rawField = {
            hj: justViewField.hj,
            M: $elm$core$Maybe$withDefault_fn("", fieldName),
            pB: justViewField.pB
        };
        var _v1 = rawField.hj.a;
        var parseValue = _v1.a;
        var possibleValues = _v1.b;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _Utils_ap(selectAttrs, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, $elm$core$Maybe$withDefault_fn("", rawField.pB)),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$name_a0, rawField.M)
        ])), $elm$core$List$filterMap_fn(function (possibleValue) {
            var parsed = parseValue(possibleValue);
            if (!parsed.$) {
                var justParsed = parsed.a;
                var renderedElement = A2(enumToOption, justParsed, function (userHtmlAttrs) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _Utils_ap($elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, _List_fromArray([
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "radio"),
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$value_a0, possibleValue),
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$name_a0, rawField.M),
                        $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, _Utils_eq(rawField.pB, $elm$core$Maybe$Just(possibleValue)))
                    ])), userHtmlAttrs), _List_Nil);
                });
                return $elm$core$Maybe$Just(renderedElement);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, possibleValues));
    }, $dillonkearns$elm_form$Form$FieldView$radioStyled_fn_unwrapped = function (selectAttrs, enumToOption, _v0) {
        var viewField = _v0.a;
        var fieldName = _v0.b;
        var justViewField = $dillonkearns$elm_form$Form$FieldView$expectViewField(viewField);
        var rawField = {
            hj: justViewField.hj,
            M: $elm$core$Maybe$withDefault_fn("", fieldName),
            pB: justViewField.pB
        };
        var _v1 = rawField.hj.a;
        var parseValue = _v1.a;
        var possibleValues = _v1.b;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _Utils_ap(selectAttrs, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, $elm$core$Maybe$withDefault_fn("", rawField.pB)),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$name_a0, rawField.M)
        ])), $elm$core$List$filterMap_fn(function (possibleValue) {
            var parsed = parseValue(possibleValue);
            if (!parsed.$) {
                var justParsed = parsed.a;
                var renderedElement = enumToOption(justParsed, function (userHtmlAttrs) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _Utils_ap($elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, _List_fromArray([
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "radio"),
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$value_a0, possibleValue),
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$name_a0, rawField.M),
                        $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, _Utils_eq(rawField.pB, $elm$core$Maybe$Just(possibleValue)))
                    ])), userHtmlAttrs), _List_Nil);
                });
                return $elm$core$Maybe$Just(renderedElement);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, possibleValues));
    }, $dillonkearns$elm_form$Form$FieldView$radioStyled = F3($dillonkearns$elm_form$Form$FieldView$radioStyled_fn);
    var $dillonkearns$elm_form$Form$Validation$fieldName = function (_v0) {
        var name = _v0.b;
        return $elm$core$Maybe$withDefault_fn("", name);
    };
    var $dillonkearns$elm_form$Form$errorsForField_fn = function (field_, _v0) {
        var errorsDict = _v0;
        return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn($dillonkearns$elm_form$Form$Validation$fieldName(field_), errorsDict));
    }, $dillonkearns$elm_form$Form$errorsForField = F2($dillonkearns$elm_form$Form$errorsForField_fn);
    var $rtfeldman$elm_css$Html$Styled$li_a0 = "li", $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$li_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none = $rtfeldman$elm_css$Css$property_fn("list-style-type", "none");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto = $rtfeldman$elm_css$Css$property_fn("margin-right", "auto");
    var $dillonkearns$elm_form$Form$Validation$expectViewField = function (viewField) {
        expectViewField: while (true) {
            if (!viewField.$) {
                var justViewField = viewField.a;
                return justViewField;
            }
            else {
                var $temp$viewField = viewField;
                viewField = $temp$viewField;
                continue expectViewField;
            }
        }
    };
    var $dillonkearns$elm_form$Form$Validation$statusFromRank = function (_int) {
        switch (_int) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 3;
        }
    };
    var $dillonkearns$elm_form$Form$Validation$fieldStatus = function (_v0) {
        var viewField = _v0.a;
        return $dillonkearns$elm_form$Form$Validation$statusFromRank($dillonkearns$elm_form$Form$Validation$expectViewField(viewField).oV);
    };
    var $dillonkearns$elm_form$Form$Validation$statusRank = function (status) {
        switch (status) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $dillonkearns$elm_form$Form$Validation$statusAtLeast_fn = function (status, field) {
        return _Utils_cmp($dillonkearns$elm_form$Form$Validation$statusRank($dillonkearns$elm_form$Form$Validation$fieldStatus(field)), $dillonkearns$elm_form$Form$Validation$statusRank(status)) > -1;
    }, $dillonkearns$elm_form$Form$Validation$statusAtLeast = F2($dillonkearns$elm_form$Form$Validation$statusAtLeast_fn);
    var $rtfeldman$elm_css$Html$Styled$ul_a0 = "ul", $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$ul_a0);
    var $author$project$Pages$Functions$CreateFunctionForm$viewErrors_fn = function (_v0, field) {
        var submitAttempted = _v0.o1;
        var errors = _v0.ml;
        var placeholder = function () {
            var zeroWidthString = $elm$core$String$fromChar("\u200B");
            return $rtfeldman$elm_css$Html$Styled$text(zeroWidthString);
        }();
        if (submitAttempted || $dillonkearns$elm_form$Form$Validation$statusAtLeast_fn(3, field)) {
            var _v1 = $dillonkearns$elm_form$Form$errorsForField_fn(field, errors);
            if (!_v1.b) {
                return placeholder;
            }
            else {
                var errorsForField = _v1;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto]))
                ]), $elm$core$List$map_fn(function (error) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(error)
                    ]));
                }, errorsForField));
            }
        }
        else {
            return placeholder;
        }
    }, $author$project$Pages$Functions$CreateFunctionForm$viewErrors = F2($author$project$Pages$Functions$CreateFunctionForm$viewErrors_fn);
    var $rtfeldman$elm_css$Css$width_a0 = "width", $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$width_a0);
    var $author$project$Pages$Functions$CreateFunctionForm$viewForm_fn = function (maybeOnCancel, name, runtime, formState) {
        var maxExpectedErrorWidth = $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 12.5);
        var toFieldWithError = F2(function (field, toFieldView) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, maxExpectedErrorWidth)
                ]))
            ]), _List_fromArray([
                toFieldView(field),
                $author$project$Pages$Functions$CreateFunctionForm$viewErrors_fn(formState, field)
            ]));
        });
        var button_ = F2(function (title, attributes) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$onlyChild(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$focus(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ])), attributes), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]));
        });
        return _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
            ]), _List_fromArray([
                A2(toFieldWithError, name, $dillonkearns$elm_form$Form$FieldView$inputStyled(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1, $author$project$Theme$theme.fu])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "custom-overlay-focus"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0, "Function Name")
                ]))),
                $dillonkearns$elm_form$Form$FieldView$radioStyled_fn_unwrapped(_List_Nil, function (runtimeOption, toRadio) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
                    ]), _List_fromArray([
                        toRadio(_List_Nil),
                        $rtfeldman$elm_css$Html$Styled$text($author$project$Types$Function$Runtime$toString(runtimeOption))
                    ]));
                }, runtime),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
                ]), _List_fromArray([
                    A2(button_, "Cancel", _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
                        $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onClick, maybeOnCancel)
                    ])),
                    $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6]), formState.o2, A2(button_, "Create", _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, formState.o2)
                    ])))
                ]))
            ]))
        ]);
    }, $author$project$Pages$Functions$CreateFunctionForm$viewForm = F4($author$project$Pages$Functions$CreateFunctionForm$viewForm_fn);
    var $dillonkearns$elm_form$Form$Field$withInitialValue_fn = function (toInitialValue, _v0) {
        var field = _v0.a;
        var kind = _v0.b;
        return $dillonkearns$elm_form$Internal$Field$Field_fn(_Utils_update(field, {
            ec: A2($elm$core$Basics$composeR, toInitialValue, A2($elm$core$Basics$composeR, field.A, $elm$core$Maybe$Just))
        }), kind);
    }, $dillonkearns$elm_form$Form$Field$withInitialValue = F2($dillonkearns$elm_form$Form$Field$withInitialValue_fn);
    var $author$project$Pages$Functions$CreateFunctionForm$form = function (maybeOnCancel) {
        return $dillonkearns$elm_form$Form$field_fn("runtime", $dillonkearns$elm_form$Form$Field$withInitialValue_fn(function (_v1) {
            return 0;
        }, $dillonkearns$elm_form$Form$Field$required_fn("Runtime required", $dillonkearns$elm_form$Form$Field$select_fn($elm$core$List$map_fn(function (r) {
            return _Utils_Tuple2($author$project$Types$Function$Runtime$toString(r), r);
        }, $author$project$Types$Function$Runtime$list), function (_v0) {
            return "Invalid";
        }))), $dillonkearns$elm_form$Form$field_fn("name", $dillonkearns$elm_form$Form$Field$required_fn("Function name required", $dillonkearns$elm_form$Form$Field$text), $dillonkearns$elm_form$Form$form(F2(function (name, runtime) {
            return {
                lT: $author$project$Pages$Functions$CreateFunctionForm$validateForm_fn(name, runtime),
                gl: A3($author$project$Pages$Functions$CreateFunctionForm$viewForm, maybeOnCancel, name, runtime)
            };
        }))));
    };
    var $author$project$Api$generateFunctionDescription_fn = function (msg, maybeToken, prompt, _function, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("prompt", $elm$json$Json$Encode$string(prompt)),
                _Utils_Tuple2("funcId", $elm$json$Json$Encode$string(_function.bR))
            ]))),
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("completion", $elm$json$Json$Decode$string)),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/prompt/describe-function")
        });
    }, $author$project$Api$generateFunctionDescription = F5($author$project$Api$generateFunctionDescription_fn);
    var $author$project$Pages$Functions$Route$toFunctionId = function (route) {
        switch (route.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var functionId = route.a;
                return $elm$core$Maybe$Just(functionId);
            default:
                var functionId = route.a;
                return $elm$core$Maybe$Just(functionId);
        }
    };
    var $author$project$Pages$Functions$getSelectedFunctionId = function (model) {
        return $elm$core$Maybe$andThen_fn($author$project$Pages$Functions$Route$toFunctionId, model.dx);
    };
    var $author$project$Pages$Functions$getActiveTab = function (model) {
        return $elm$core$Maybe$andThen_fn(A2($author$project$Util$flip, $elm$core$Dict$get, model.P), $author$project$Pages$Functions$getSelectedFunctionId(model));
    };
    var $author$project$Pages$Functions$getFunctionById_fn = function (model, id) {
        return $elm$core$Maybe$andThen_fn($elm_community$list_extra$List$Extra$find(A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, $elm$core$Basics$eq(id))), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.mB));
    }, $author$project$Pages$Functions$getFunctionById = F2($author$project$Pages$Functions$getFunctionById_fn);
    var $author$project$Pages$Functions$getSelectedFunction = function (model) {
        return $elm$core$Maybe$andThen_fn($author$project$Pages$Functions$getFunctionById(model), $author$project$Pages$Functions$getSelectedFunctionId(model));
    };
    var $author$project$Components$FormOverlay$OverlayMsg = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$FormOverlay$init = function (cfg) {
        return {
            fp: cfg.fp,
            d6: $dillonkearns$elm_form$Form$init,
            bC: cfg.bC,
            nT: cfg.nT,
            fM: cfg.fM,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$FormOverlay$OverlayMsg, cfg.gd)),
            dg: $elm$core$Maybe$Nothing,
            eM: cfg.eM,
            gd: cfg.gd,
            la: false
        };
    };
    var $author$project$Components$GqlResponse$ParsedResponse = 0;
    var $author$project$Components$GqlResponse$init = { d7: 0, bV: $elm$core$Maybe$Nothing, aw: $elm$core$Maybe$Nothing };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet = $elm$core$Set$fromList(_List_fromArray(["{", "}", "(", ")", "[", "]", ",", ";"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isGroupChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupChar = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isGroupChar)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar = function (c) {
        return c === "/";
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet = $elm$core$Set$fromList(_List_fromArray(["+", "-", "*", "/", "=", "!", "<", ">", "&", "|", "?", "^", ":", "~", "%", "."]));
    var $elm$core$Dict$union_fn = function (t1, t2) {
        return $elm$core$Dict$foldl_fn($elm$core$Dict$insert, t2, t1);
    }, $elm$core$Dict$union = F2($elm$core$Dict$union_fn);
    var $elm$core$Set$union_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$union_fn(dict1, dict2);
    }, $elm$core$Set$union = F2($elm$core$Set$union_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$punctuactorSet = $elm$core$Set$union_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isPunctuaction = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$punctuactorSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isStringLiteralChar = function (c) {
        return (c === "\"") || ((c === "'") || (c === "`"));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar = function (c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isPunctuaction(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isStringLiteralChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Function = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Keyword = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$LiteralKeyword = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Param = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$inlineComment = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak), $elm$parser$Parser$symbol("//"))));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n")
        ]);
    }, $elm$parser$Parser$symbol("\n"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited({
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
        },
        u: "*/",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList]),
        jK: false,
        jM: function (c) {
            return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
        },
        x: "/*"
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$comment = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$multilineComment]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
            $elm$parser$Parser$Advanced$map_fn(function (ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList),
            $elm$parser$Parser$Advanced$map_fn(function (ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$comment)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classExtendsLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(8), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classDeclarationLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$andThen_fn(function (n) {
                return (n === "extends") ? $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classExtendsLoop)) : $elm$parser$Parser$succeed($elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), n), revTokens)));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$argLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function (c) {
                return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ",") || (c === ")"))));
            }))),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function (c) {
                return (c === "/") || (c === ",");
            }))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), "*"), revTokens));
            }, $elm$parser$Parser$symbol("*")),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn(function (_v1) {
                return $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, "("), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$argLoop);
            }, $elm$parser$Parser$symbol("("))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$FunctionEval = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop_fn = function (identifier, revTokens, thisRevToken) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(thisRevToken),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Done(_Utils_ap(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, "("), thisRevToken), _List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), identifier), revTokens)));
            }, $elm$parser$Parser$symbol("(")),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(_Utils_ap(thisRevToken, _List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, identifier), revTokens))))
        ]));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$declarationKeywordSet = $elm$core$Set$fromList(_List_fromArray(["var", "const", "let"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isDeclarationKeyword = function (str) {
        return $elm$core$Set$member_fn(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$declarationKeywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordSet = $elm$core$Set$fromList(_List_fromArray(["break", "do", "instanceof", "typeof", "case", "else", "new", "catch", "finally", "return", "void", "continue", "for", "switch", "while", "debugger", "this", "with", "default", "if", "throw", "delete", "in", "try", "enum", "extends", "export", "import", "implements", "private", "public", "yield", "interface", "package", "protected"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isKeyword = function (str) {
        return $elm$core$Set$member_fn(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$literalKeywordSet = $elm$core$Set$fromList(_List_fromArray(["true", "false", "null", "undefined", "NaN", "Infinity"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isLiteralKeyword = function (str) {
        return $elm$core$Set$member_fn(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$literalKeywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser_fn = function (revTokens, n) {
        return ((n === "function") || (n === "static")) ? $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ((n === "class") ? $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classDeclarationLoop) : (((n === "this") || (n === "super")) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), n), revTokens)) : ((n === "constructor") ? $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isKeyword(n) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), n), revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), n), revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), n), revTokens)) : $elm$parser$Parser$loop_fn(_List_Nil, A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop, n, revTokens))))))));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Number = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$number = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isOperatorChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorChar = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isOperatorChar)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$String = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter = {
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), b);
        },
        u: "'",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable]),
        jK: false,
        jM: function (c) {
            return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
        },
        x: "'"
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter, { u: "\"", x: "\"" }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$templateString = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter, {
        u: "`",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable]),
        jM: function (c) {
            return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
        },
        x: "`"
    }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$stringLiteral = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$doubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$templateString]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$mainLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_Utils_ap(s, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$stringLiteral),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_List_Cons(s, revTokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$number]))),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser(revTokens), $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar)))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toRevTokens = $elm$parser$Parser$loop_fn(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines_a0 = $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toRevTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines_a1 = $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript_a1 = $elm$core$Result$map($elm$core$Basics$identity), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet = $elm$core$Set$fromList(_List_fromArray(["{", "}", "(", ")", "[", "]", ",", ";"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isGroupChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupChar = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isGroupChar)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar = function (c) {
        return c === "#";
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet = $elm$core$Set$fromList(_List_fromArray(["+", "-", "*", "/", "=", "!", "<", ">", "&", "|", "?", "^", ":", "~", "%", "."]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$punctuationSet = $elm$core$Set$union_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isPunctuation = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$punctuationSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isStringLiteralChar = function (c) {
        return (c === "\"") || (c === "'");
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar = function (c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isPunctuation(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isStringLiteralChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$DeclarationKeyword = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$FunctionEval = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Keyword = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$LiteralKeyword = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Function = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$inlineComment = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak), $elm$parser$Parser$symbol("#"))));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n")
        ]);
    }, $elm$parser$Parser$symbol("\n"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited({
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
        },
        u: "'''",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak]),
        jK: false,
        jM: function (c) {
            return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
        },
        x: "'''"
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$comment = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$multilineComment]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
            $elm$parser$Parser$Advanced$map_fn(function (ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak),
            $elm$parser$Parser$Advanced$map_fn(function (ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$comment)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$classDeclarationLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Param = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$argLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function (c) {
                return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ",") || (c === ")"))));
            }))),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function (c) {
                return (c === "/") || (c === ",");
            }))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionDeclarationLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b), revTokens));
            }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar))),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn(function (_v0) {
                return $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, "("), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$argLoop);
            }, $elm$parser$Parser$symbol("("))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionEvalLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Done(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, "("), revTokens));
            }, $elm$parser$Parser$symbol("(")),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordSet = $elm$core$Set$fromList(_List_fromArray(["finally", "is", "return", "continue", "for", "lambda", "try", "from", "nonlocal", "while", "and", "del", "global", "not", "with", "as", "elif", "if", "or", "yield", "assert", "else", "import", "pass", "break", "except", "in", "raise"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isKeyword = function (str) {
        return $elm$core$Set$member_fn(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$literalKeywordSet = $elm$core$Set$fromList(_List_fromArray(["True", "False", "None"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isLiteralKeyword = function (str) {
        return $elm$core$Set$member_fn(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$literalKeywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser_fn = function (revTokens, n) {
        return (n === "def") ? $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionDeclarationLoop) : ((n === "class") ? $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$classDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isKeyword(n) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), n), revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), n), revTokens)) : $elm$parser$Parser$loop_fn(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionEvalLoop))));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Number = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$number = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isOperatorChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorChar = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isOperatorChar)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$String = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter = {
        i4: function (b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), b);
        },
        u: "'",
        jF: _List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak]),
        jK: false,
        jM: function (c) {
            return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
        },
        x: "'"
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter, { u: "\"", x: "\"" }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$stringLiteral = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$doubleQuote]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$mainLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_Utils_ap(s, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$stringLiteral),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return $elm$parser$Parser$Loop(_List_Cons(s, revTokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$number]))),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser(revTokens), $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar)))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toRevTokens = $elm$parser$Parser$loop_fn(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines_a0 = $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toRevTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines_a1 = $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python_a1 = $elm$core$Result$map($elm$core$Basics$identity), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python_a1);
    var $author$project$Types$Function$Runtime$toParser = function (runtime) {
        if (!runtime) {
            return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript;
        }
        else {
            return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python;
        }
    };
    var $author$project$Pages$Functions$FunctionTab$init = function (_function) {
        return {
            lY: $author$project$Components$Editor$init_fn($elm$core$Maybe$Just(5), $elm$core$Maybe$Just($author$project$Types$Function$Runtime$toParser(_function.oJ)), "{}"),
            fa: $elm$core$Maybe$Nothing,
            i6: $author$project$Components$Description$init,
            gO: $author$project$Components$Editor$init_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Types$Function$Runtime$toParser(_function.oJ)), $elm$core$Maybe$withDefault_fn("", _function.gB)),
            gR: false,
            mE: $author$project$Components$GqlResponse$init,
            oJ: _function.oJ
        };
    };
    var $author$project$Pages$Functions$initTab_fn = function (_function, model) {
        return _Utils_update(model, {
            P: $elm$core$Dict$insert_fn(_function.bR, $author$project$Pages$Functions$FunctionTab$init(_function), model.P)
        });
    }, $author$project$Pages$Functions$initTab = F2($author$project$Pages$Functions$initTab_fn);
    var $author$project$Api$Response$map_fn = function (f, response) {
        if (!response.$) {
            var value = response.a;
            return $author$project$Api$Response$Success(f(value));
        }
        else {
            var errors = response.a;
            return $author$project$Api$Response$Failure(errors);
        }
    }, $author$project$Api$Response$map = F2($author$project$Api$Response$map_fn);
    var $author$project$Pages$Functions$mapTab_fn = function (_function, f, model) {
        return _Utils_update(model, {
            P: $elm$core$Dict$update_fn(_function.bR, $elm$core$Maybe$map(f), model.P)
        });
    }, $author$project$Pages$Functions$mapTab = F3($author$project$Pages$Functions$mapTab_fn);
    var $author$project$Pages$Functions$mapCurrentTab_fn = function (f, model) {
        var _v0 = $author$project$Pages$Functions$getSelectedFunction(model);
        if (_v0.$ === 1) {
            return model;
        }
        else {
            var functionSelected = _v0.a;
            return $author$project$Pages$Functions$mapTab_fn(functionSelected, f, model);
        }
    }, $author$project$Pages$Functions$mapCurrentTab = F2($author$project$Pages$Functions$mapCurrentTab_fn);
    var $1602$json_value$Json$Value$ArrayValue = function (a) {
        return { $: 1, a: a };
    };
    var $1602$json_value$Json$Value$BoolValue = function (a) {
        return { $: 2, a: a };
    };
    var $1602$json_value$Json$Value$NullValue = { $: 3 };
    var $1602$json_value$Json$Value$NumericValue = function (a) {
        return { $: 4, a: a };
    };
    var $1602$json_value$Json$Value$ObjectValue = function (a) {
        return { $: 0, a: a };
    };
    var $1602$json_value$Json$Value$StringValue = function (a) {
        return { $: 5, a: a };
    };
    var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
    var $elm$json$Json$Decode$lazy = function (thunk) {
        return _Json_andThen_fn(thunk, $elm$json$Json$Decode$succeed(0));
    };
    function $1602$json_value$Json$Value$cyclic$decoder() {
        var objectValueDecoder = _Json_map1_fn($1602$json_value$Json$Value$ObjectValue, _Json_andThen_fn(A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$json$Json$Decode$succeed), $elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$lazy(function (_v1) {
            return $1602$json_value$Json$Value$cyclic$decoder();
        }))));
        var arrayValueDecoder = _Json_map1_fn($1602$json_value$Json$Value$ArrayValue, $elm$json$Json$Decode$list($elm$json$Json$Decode$lazy(function (_v0) {
            return $1602$json_value$Json$Value$cyclic$decoder();
        })));
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            objectValueDecoder,
            arrayValueDecoder,
            $elm$json$Json$Decode$null($1602$json_value$Json$Value$NullValue),
            _Json_map1_fn($1602$json_value$Json$Value$StringValue, $elm$json$Json$Decode$string),
            _Json_map1_fn($1602$json_value$Json$Value$NumericValue, $elm$json$Json$Decode$float),
            _Json_map1_fn($1602$json_value$Json$Value$BoolValue, $elm$json$Json$Decode$bool)
        ]));
    }
    var $1602$json_value$Json$Value$decoder = $1602$json_value$Json$Value$cyclic$decoder();
    $1602$json_value$Json$Value$cyclic$decoder = function () {
        return $1602$json_value$Json$Value$decoder;
    };
    var $author$project$Pages$Functions$FunctionTab$mapDataEditor_fn = function (f, tab) {
        var dataEditor = f(tab.lY);
        return _Utils_update(tab, {
            lY: dataEditor,
            fa: function () {
                if (dataEditor.gB === "") {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var toError = A2($elm$core$Basics$composeR, $elm$core$String$append("Data must be an object, not "), A2($author$project$Util$flip, $elm$core$String$append, "."));
                    var _v0 = _Json_runOnString_fn($1602$json_value$Json$Value$decoder, dataEditor.gB);
                    if (!_v0.$) {
                        switch (_v0.a.$) {
                            case 0:
                                return $elm$core$Maybe$Nothing;
                            case 1:
                                return $elm$core$Maybe$Just(toError("an array"));
                            case 2:
                                return $elm$core$Maybe$Just(toError("a boolean"));
                            case 3:
                                var _v1 = _v0.a;
                                return $elm$core$Maybe$Just(toError("null"));
                            case 4:
                                return $elm$core$Maybe$Just(toError("a number"));
                            default:
                                return $elm$core$Maybe$Just(toError("a string"));
                        }
                    }
                    else {
                        var error = _v0.a;
                        return $elm$core$Maybe$Just($elm$json$Json$Decode$errorToString(error));
                    }
                }
            }()
        });
    }, $author$project$Pages$Functions$FunctionTab$mapDataEditor = F2($author$project$Pages$Functions$FunctionTab$mapDataEditor_fn);
    var $author$project$Pages$Functions$FunctionTab$mapDescription_fn = function (f, tab) {
        return _Utils_update(tab, {
            i6: f(tab.i6)
        });
    }, $author$project$Pages$Functions$FunctionTab$mapDescription = F2($author$project$Pages$Functions$FunctionTab$mapDescription_fn);
    var $author$project$Pages$Functions$FunctionTab$mapEditor_fn = function (f, tab) {
        return _Utils_update(tab, {
            gO: f(tab.gO)
        });
    }, $author$project$Pages$Functions$FunctionTab$mapEditor = F2($author$project$Pages$Functions$FunctionTab$mapEditor_fn);
    var $author$project$Pages$Functions$FunctionTab$mapGqlResponse_fn = function (f, tab) {
        return _Utils_update(tab, {
            mE: f(tab.mE)
        });
    }, $author$project$Pages$Functions$FunctionTab$mapGqlResponse = F2($author$project$Pages$Functions$FunctionTab$mapGqlResponse_fn);
    var $author$project$Pages$Functions$RenameFunctionMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Types$Function$addVersion_fn = function (versionId, _function) {
        return _Utils_update(_function, {
            le: $elm$core$List$append_fn(_List_fromArray([
                { i_: $krisajenkins$remotedata$RemoteData$NotAsked, bR: versionId }
            ]), _function.le)
        });
    }, $author$project$Types$Function$addVersion = F2($author$project$Types$Function$addVersion_fn);
    var $elm$json$Json$Decode$dict = function (decoder) {
        return _Json_map1_fn($elm$core$Dict$fromList, $elm$json$Json$Decode$keyValuePairs(decoder));
    };
    var $elm$json$Json$Encode$dict_fn = function (toKey, toValue, dictionary) {
        return _Json_wrap($elm$core$Dict$foldl_fn_unwrapped(function (key, value, obj) {
            return _Json_addField_fn(toKey(key), toValue(value), obj);
        }, _Json_emptyObject(0), dictionary));
    }, $elm$json$Json$Encode$dict = F3($elm$json$Json$Encode$dict_fn);
    var $elm$core$Dict$filter_fn = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return A2(isGood, k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter_fn_unwrapped = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return isGood(k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter = F2($elm$core$Dict$filter_fn);
    var $author$project$Util$Encode$diff_fn = function (a, b) {
        var toDict = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeValue($elm$json$Json$Decode$dict($elm$json$Json$Decode$value)), $elm$core$Result$withDefault($elm$core$Dict$empty));
        var bDict = toDict(b);
        var aDict = toDict(a);
        return $elm$json$Json$Encode$dict_fn($elm$core$Basics$identity, $elm$core$Basics$identity, $elm$core$Dict$filter_fn_unwrapped(function (key, val) {
            return !_Utils_eq($elm$core$Dict$get_fn(key, bDict), $elm$core$Maybe$Just(val));
        }, aDict));
    }, $author$project$Util$Encode$diff = F2($author$project$Util$Encode$diff_fn);
    var $author$project$Util$Encode$diffWith_fn = function (encode, a, b) {
        return $author$project$Util$Encode$diff_fn(encode(a), encode(b));
    }, $author$project$Util$Encode$diffWith = F3($author$project$Util$Encode$diffWith_fn);
    var $author$project$Util$Encode$diffMaybeWith_fn = function (encode, maybeA, b) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(encode(b), A2($author$project$Util$Encode$diffWith, encode, b), maybeA);
    }, $author$project$Util$Encode$diffMaybeWith = F3($author$project$Util$Encode$diffMaybeWith_fn);
    var $author$project$Types$Function$encoder = function (_function) {
        return $elm$json$Json$Encode$object($elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2("name", $elm$json$Json$Encode$string(_function.M))),
            $elm$core$Maybe$Just(_Utils_Tuple2("description", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn("", _function.i6)))),
            $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, $elm$core$Tuple$pair("content")), _function.gB),
            $elm$core$Maybe$Just(_Utils_Tuple2("runtime", $elm$core$Basics$composeR_fn($author$project$Types$Function$Runtime$encode_a0, $author$project$Types$Function$Runtime$encode_a1, _function.oJ)))
        ])));
    };
    var $author$project$Types$Function$setVersionRemoteData_fn = function (versionId, remoteData, _function) {
        return _Utils_update(_function, {
            le: $elm_community$list_extra$List$Extra$updateIf_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.bR;
            }, $elm$core$Basics$eq(versionId)), function (version) {
                return _Utils_update(version, { i_: remoteData });
            }, _function.le)
        });
    }, $author$project$Types$Function$setVersionRemoteData = F3($author$project$Types$Function$setVersionRemoteData_fn);
    var $author$project$Types$Function$setVersionData_fn = function (versionId, version, _function) {
        var data = {
            gB: $elm$core$Maybe$withDefault_fn("", version.gB),
            oJ: version.oJ
        };
        return $author$project$Types$Function$setVersionRemoteData_fn(versionId, $krisajenkins$remotedata$RemoteData$Success(data), _function);
    }, $author$project$Types$Function$setVersionData = F3($author$project$Types$Function$setVersionData_fn);
    var $author$project$Api$saveFunction_fn = function (msg, maybeToken, dbId, maybeFunctionOld, functionNew) {
        var functionDiffEncoded = $author$project$Util$Encode$diffMaybeWith_fn($author$project$Types$Function$encoder, maybeFunctionOld, functionNew);
        var decoder = function () {
            var decodeVersionId = _Json_decodeField_fn("id", $elm$json$Json$Decode$string);
            return _Json_map1_fn(function (versionId) {
                return $author$project$Types$Function$setVersionData_fn(versionId, functionNew, $author$project$Types$Function$addVersion_fn(versionId, functionNew));
            }, decodeVersionId);
        }();
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody(functionDiffEncoded),
            e: A2($author$project$Api$expect, msg, decoder),
            f: "PATCH",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/functions/" + $elm$url$Url$percentEncode(functionNew.bR)))
        });
    }, $author$project$Api$saveFunction = F5($author$project$Api$saveFunction_fn);
    var $author$project$Types$Function$setName_fn = function (name, _function) {
        return _Utils_update(_function, { M: name });
    }, $author$project$Types$Function$setName = F2($author$project$Types$Function$setName_fn);
    var $author$project$Pages$Functions$renameFunctionNameRequester_fn = function (maybeDbId, shared, model) {
        return $author$project$Components$InputRequester$init({
            ln: "Rename",
            bC: F2(function (state, inputReqMsg) {
                return $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn_unwrapped(function (dbId, _function) {
                    return $author$project$Api$saveFunction_fn(A2($elm$core$Basics$composeL, $author$project$Pages$Functions$RenameFunctionMsg, inputReqMsg), shared.k2, dbId, $elm$core$Maybe$Just(_function), $author$project$Types$Function$setName_fn(state, _function));
                }, maybeDbId, $author$project$Pages$Functions$getSelectedFunction(model)));
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$ShowErrors, $author$project$Util$msgCmd),
            fM: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$UpdateFunction, $author$project$Util$msgCmd),
            kt: $elm$core$Maybe$Nothing,
            df: "Function Name",
            gd: $author$project$Pages$Functions$RenameFunctionMsg
        });
    }, $author$project$Pages$Functions$renameFunctionNameRequester = F3($author$project$Pages$Functions$renameFunctionNameRequester_fn);
    var $author$project$Types$Function$copyVersionRemoteData_fn = function (fromVersionId, toVersionId, _function) {
        var maybeFromVersionData = $elm$core$Maybe$map_fn(function ($) {
            return $.i_;
        }, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, $elm$core$Basics$eq(fromVersionId)), _function.le));
        if (maybeFromVersionData.$ === 1) {
            return _function;
        }
        else {
            var fromVersionData = maybeFromVersionData.a;
            return $author$project$Types$Function$setVersionRemoteData_fn(toVersionId, fromVersionData, _function);
        }
    }, $author$project$Types$Function$copyVersionRemoteData = F3($author$project$Types$Function$copyVersionRemoteData_fn);
    var $author$project$Types$Function$restoreContentFromVersion_fn = function (versionId, _function) {
        var maybeVersionContent = $elm$core$Maybe$map_fn(function ($) {
            return $.gB;
        }, $elm$core$Maybe$andThen_fn($krisajenkins$remotedata$RemoteData$toMaybe, $elm$core$Maybe$map_fn(function ($) {
            return $.i_;
        }, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, $elm$core$Basics$eq(versionId)), _function.le))));
        return _Utils_update(_function, { gB: maybeVersionContent });
    }, $author$project$Types$Function$restoreContentFromVersion = F2($author$project$Types$Function$restoreContentFromVersion_fn);
    var $author$project$Api$republishFunctionVersion_fn = function (msg, maybeToken, dbId, _function, versionId) {
        var decoder = function () {
            var decodeVersionId = _Json_decodeField_fn("id", $elm$json$Json$Decode$string);
            return _Json_map1_fn(function (versionIdNew) {
                return $author$project$Types$Function$restoreContentFromVersion_fn(versionId, $author$project$Types$Function$copyVersionRemoteData_fn(versionId, versionIdNew, $author$project$Types$Function$addVersion_fn(versionIdNew, _function)));
            }, decodeVersionId);
        }();
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("version", $elm$json$Json$Encode$string(versionId)),
                _Utils_Tuple2("runtime", $elm$core$Basics$composeR_fn($author$project$Types$Function$Runtime$encode_a0, $author$project$Types$Function$Runtime$encode_a1, _function.oJ))
            ]))),
            e: A2($author$project$Api$expect, msg, decoder),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/functions/" + ($elm$url$Url$percentEncode(_function.bR) + "/republish")))
        });
    }, $author$project$Api$republishFunctionVersion = F5($author$project$Api$republishFunctionVersion_fn);
    var $author$project$Pages$Functions$FunctionReceived_fn = function (a, b) {
        return { $: 10, a: a, b: b };
    }, $author$project$Pages$Functions$FunctionReceived = F2($author$project$Pages$Functions$FunctionReceived_fn);
    var $author$project$Api$getFunction_fn = function (msg, maybeToken, dbId, fnId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$Function$decoder),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/functions/" + $elm$url$Url$percentEncode(fnId)))
        });
    }, $author$project$Api$getFunction = F4($author$project$Api$getFunction_fn);
    var $author$project$Pages$Functions$requireFunction_fn = function (toMsg, dbId, shared, model) {
        var maybeSelectedFunctionId = $author$project$Pages$Functions$getSelectedFunctionId(model);
        var functionsLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(model.mB);
        var functionLoaded = $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Maybe$andThen_fn(function ($) {
            return $.gB;
        }, $elm$core$Maybe$andThen_fn($author$project$Pages$Functions$getFunctionById(model), maybeSelectedFunctionId)));
        return (functionLoaded || (!functionsLoaded)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$getFunction, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$FunctionReceived(dbId)), shared.k2, dbId), maybeSelectedFunctionId));
    }, $author$project$Pages$Functions$requireFunction = F4($author$project$Pages$Functions$requireFunction_fn);
    var $author$project$Pages$Functions$FunctionsReceived_fn = function (a, b) {
        return { $: 18, a: a, b: b };
    }, $author$project$Pages$Functions$FunctionsReceived = F2($author$project$Pages$Functions$FunctionsReceived_fn);
    var $author$project$Api$getFunctions_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("functions", $elm$json$Json$Decode$list($author$project$Types$Function$decoder))),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/functions")
        });
    }, $author$project$Api$getFunctions = F3($author$project$Api$getFunctions_fn);
    var $author$project$Pages$Functions$requireFunctions_fn = function (toMsg, dbId, shared, model) {
        var functionsLoading = $krisajenkins$remotedata$RemoteData$isLoading(model.mB);
        var functionsLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(model.mB);
        return (functionsLoaded || functionsLoading) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, { mB: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getFunctions_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$FunctionsReceived(dbId)), shared.k2, dbId));
    }, $author$project$Pages$Functions$requireFunctions = F4($author$project$Pages$Functions$requireFunctions_fn);
    var $author$project$Pages$Functions$FunctionVersionReceived_fn = function (a, b, c) {
        return { $: 11, a: a, b: b, c: c };
    }, $author$project$Pages$Functions$FunctionVersionReceived = F3($author$project$Pages$Functions$FunctionVersionReceived_fn);
    var $author$project$Api$getFunctionVersion_fn = function (msg, maybeToken, dbId, _function, version) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$Function$decoder),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/functions/" + ($elm$url$Url$percentEncode(_function.bR) + ("/versions/" + $elm$url$Url$percentEncode(version)))))
        });
    }, $author$project$Api$getFunctionVersion = F5($author$project$Api$getFunctionVersion_fn);
    var $author$project$Pages$Functions$Route$toVersionId = function (route) {
        switch (route.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                var maybeVersionId = route.b;
                return maybeVersionId;
        }
    };
    var $author$project$Pages$Functions$getSelectedVersionId = function (model) {
        return $elm$core$Maybe$andThen_fn($author$project$Pages$Functions$Route$toVersionId, model.dx);
    };
    var $author$project$Pages$Functions$updateFunction_fn = function (_function, model) {
        return _Utils_update(model, {
            mB: $krisajenkins$remotedata$RemoteData$map_fn(A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
                return $.bR;
            }, $elm$core$Basics$eq(_function.bR)), $elm$core$Basics$always(_function)), model.mB)
        });
    }, $author$project$Pages$Functions$updateFunction = F2($author$project$Pages$Functions$updateFunction_fn);
    var $author$project$Pages$Functions$requireVersion_fn = function (toMsg, dbId, shared, model) {
        var maybeSelectedVersionId = $author$project$Pages$Functions$getSelectedVersionId(model);
        var maybeSelectedFunction = $author$project$Pages$Functions$getSelectedFunction(model);
        var versionLoaded = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($krisajenkins$remotedata$RemoteData$isSuccess, $elm$core$Maybe$map_fn(function ($) {
            return $.i_;
        }, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.bR;
        }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(maybeSelectedVersionId))), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
            return $.le;
        }, maybeSelectedFunction)))));
        var functionsLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(model.mB);
        return function () {
            if (versionLoaded || (!functionsLoaded)) {
                return $elm$core$Basics$identity;
            }
            else {
                var _v0 = _Utils_Tuple2(maybeSelectedFunction, maybeSelectedVersionId);
                if ((!_v0.a.$) && (!_v0.b.$)) {
                    var _function = _v0.a.a;
                    var versionId = _v0.b.a;
                    return A2($elm$core$Basics$composeR, $author$project$Util$withModel($author$project$Pages$Functions$updateFunction($author$project$Types$Function$setVersionRemoteData_fn(versionId, $krisajenkins$remotedata$RemoteData$Loading, _function))), $author$project$Util$withCmd($author$project$Api$getFunctionVersion_fn(A2($elm$core$Basics$composeR, A2($author$project$Pages$Functions$FunctionVersionReceived, _function, versionId), toMsg), shared.k2, dbId, _function, versionId)));
                }
                else {
                    return $elm$core$Basics$identity;
                }
            }
        }()(_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
    }, $author$project$Pages$Functions$requireVersion = F4($author$project$Pages$Functions$requireVersion_fn);
    var $author$project$Components$Editor$revertChanges = function (model) {
        return _Utils_update(model, { gB: model.eb });
    };
    var $author$project$Components$Editor$setParser_fn = function (parser, model) {
        return _Utils_update(model, { fQ: parser });
    }, $author$project$Components$Editor$setParser = F2($author$project$Components$Editor$setParser_fn);
    var $author$project$Pages$Functions$FunctionTab$revertChanges_fn = function (_function, tab) {
        return _Utils_update(tab, {
            gO: $author$project$Components$Editor$setParser_fn($author$project$Types$Function$Runtime$toParser(_function.oJ), $author$project$Components$Editor$revertChanges(tab.gO)),
            oJ: _function.oJ
        });
    }, $author$project$Pages$Functions$FunctionTab$revertChanges = F2($author$project$Pages$Functions$FunctionTab$revertChanges_fn);
    var $author$project$Pages$Functions$setActiveRoute_fn = function (subRoute, model) {
        return _Utils_update(model, {
            dx: $elm$core$Maybe$Just(subRoute)
        });
    }, $author$project$Pages$Functions$setActiveRoute = F2($author$project$Pages$Functions$setActiveRoute_fn);
    var $author$project$Types$Function$setContent_fn = function (content, _function) {
        return _Utils_update(_function, {
            gB: $elm$core$Maybe$Just(content)
        });
    }, $author$project$Types$Function$setContent = F2($author$project$Types$Function$setContent_fn);
    var $author$project$Pages$Functions$setCreateFunctionDialog_fn = function (createFunctionDialog, model) {
        return _Utils_update(model, {
            dV: $elm$core$Maybe$Just(createFunctionDialog)
        });
    }, $author$project$Pages$Functions$setCreateFunctionDialog = F2($author$project$Pages$Functions$setCreateFunctionDialog_fn);
    var $author$project$Types$Function$setDescription_fn = function (_function, description) {
        return _Utils_update(_function, { i6: description });
    }, $author$project$Types$Function$setDescription = F2($author$project$Types$Function$setDescription_fn);
    var $author$project$Pages$Functions$FunctionTab$setExecuting_fn = function (executing, tab) {
        return _Utils_update(tab, { gR: executing });
    }, $author$project$Pages$Functions$FunctionTab$setExecuting = F2($author$project$Pages$Functions$FunctionTab$setExecuting_fn);
    var $author$project$Pages$Functions$setInputRequester_fn = function (maybeInputRequester, model) {
        return _Utils_update(model, { cm: maybeInputRequester });
    }, $author$project$Pages$Functions$setInputRequester = F2($author$project$Pages$Functions$setInputRequester_fn);
    var $elm_community$json_extra$Json$Decode$Extra$optionalField_fn = function (fieldName, decoder) {
        var finishDecoding = function (json) {
            var _v0 = _Json_run_fn(_Json_decodeField_fn(fieldName, $elm$json$Json$Decode$value), json);
            if (!_v0.$) {
                var val = _v0.a;
                return _Json_map1_fn($elm$core$Maybe$Just, _Json_decodeField_fn(fieldName, decoder));
            }
            else {
                return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
            }
        };
        return _Json_andThen_fn(finishDecoding, $elm$json$Json$Decode$value);
    }, $elm_community$json_extra$Json$Decode$Extra$optionalField = F2($elm_community$json_extra$Json$Decode$Extra$optionalField_fn);
    var $author$project$Components$GqlResponse$decodeErrors = _Json_decodeField_fn("errors", $elm$json$Json$Decode$list(_Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm_community$json_extra$Json$Decode$Extra$optionalField_fn("output", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm_community$json_extra$Json$Decode$Extra$optionalField_fn("message", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, $elm_community$json_extra$Json$Decode$Extra$optionalField_fn("code", $elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed(F3(function (maybeCode, maybeMessage, maybeOutput) {
        return $elm$core$String$join_fn("\n\n", $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            $elm$core$Maybe$map_fn($elm$core$String$append("Code: "), $elm$core$Maybe$map_fn($elm$core$String$fromInt, maybeCode)),
            $elm$core$Maybe$map_fn($elm$core$String$append("Message:\n"), maybeMessage),
            $elm$core$Maybe$map_fn($elm$core$String$append("Output:\n"), maybeOutput)
        ])));
    })))))));
    var $author$project$Components$GqlResponse$parseResponse_fn = function (decoder, response) {
        return $elm$core$Maybe$andThen_fn($elm$core$Result$toMaybe, $elm$core$Maybe$map_fn($elm$json$Json$Decode$decodeString(decoder), $elm$core$Maybe$map_fn($elm$json$Json$Encode$encode(2), response)));
    }, $author$project$Components$GqlResponse$parseResponse = F2($author$project$Components$GqlResponse$parseResponse_fn);
    var $author$project$Components$GqlResponse$errorsEmpty_a0 = $author$project$Components$GqlResponse$parseResponse($author$project$Components$GqlResponse$decodeErrors), $author$project$Components$GqlResponse$errorsEmpty_a1 = $elm_community$maybe_extra$Maybe$Extra$isNothing, $author$project$Components$GqlResponse$errorsEmpty = A2($elm$core$Basics$composeR, $author$project$Components$GqlResponse$errorsEmpty_a0, $author$project$Components$GqlResponse$errorsEmpty_a1);
    var $elm$core$Dict$isEmpty = function (dict) {
        if (dict.$ === -2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$core$Dict$partition_fn = function (isGood, dict) {
        var add = F3(function (key, value, _v0) {
            var t1 = _v0.a;
            var t2 = _v0.b;
            return A2(isGood, key, value) ? _Utils_Tuple2($elm$core$Dict$insert_fn(key, value, t1), t2) : _Utils_Tuple2(t1, $elm$core$Dict$insert_fn(key, value, t2));
        });
        return $elm$core$Dict$foldl_fn(add, _Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty), dict);
    }, $elm$core$Dict$partition_fn_unwrapped = function (isGood, dict) {
        var add = F3(function (key, value, _v0) {
            var t1 = _v0.a;
            var t2 = _v0.b;
            return isGood(key, value) ? _Utils_Tuple2($elm$core$Dict$insert_fn(key, value, t1), t2) : _Utils_Tuple2(t1, $elm$core$Dict$insert_fn(key, value, t2));
        });
        return $elm$core$Dict$foldl_fn(add, _Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty), dict);
    }, $elm$core$Dict$partition = F2($elm$core$Dict$partition_fn);
    var $author$project$Util$Decode$recordValueWithout = function (fieldsToRemove) {
        return _Json_andThen_fn(function (data) {
            var _v0 = $elm$core$Dict$partition_fn_unwrapped(function (field, _v1) {
                return $elm$core$List$member_fn(field, fieldsToRemove);
            }, data);
            var removed = _v0.a;
            var retained = _v0.b;
            return $elm$core$Dict$isEmpty(retained) ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed({
                or: $elm$core$Maybe$map_fn(A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$Dict$isEmpty), $elm$core$Maybe$Just(removed))),
                oA: $elm$json$Json$Encode$dict_fn($elm$core$Basics$identity, $elm$core$Basics$identity, retained)
            });
        }, $elm$json$Json$Decode$dict($elm$json$Json$Decode$value));
    };
    var $author$project$Components$GqlResponse$decodeExtensions = _Json_decodeField_fn("extensions", _Json_map1_fn(function ($) {
        return $.oA;
    }, $author$project$Util$Decode$recordValueWithout(_List_fromArray(["logs"]))));
    var $author$project$Components$GqlResponse$extensionsEmpty_a0 = $author$project$Components$GqlResponse$parseResponse($author$project$Components$GqlResponse$decodeExtensions), $author$project$Components$GqlResponse$extensionsEmpty_a1 = $elm_community$maybe_extra$Maybe$Extra$isNothing, $author$project$Components$GqlResponse$extensionsEmpty = A2($elm$core$Basics$composeR, $author$project$Components$GqlResponse$extensionsEmpty_a0, $author$project$Components$GqlResponse$extensionsEmpty_a1);
    var $author$project$Components$GqlResponse$Log_fn = function (message, stream, utc) {
        return { no: message, h9: stream, lc: utc };
    }, $author$project$Components$GqlResponse$Log = F3($author$project$Components$GqlResponse$Log_fn);
    var $author$project$Components$GqlResponse$decodeLogs = function () {
        var decodeLog = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("utc", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("stream", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("message", $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Components$GqlResponse$Log))));
        return _Json_andThen_fn(function (logs) {
            return $elm$core$List$isEmpty(logs) ? $elm$json$Json$Decode$fail("No logs") : $elm$json$Json$Decode$succeed(logs);
        }, $elm$json$Json$Decode$at_fn(_List_fromArray(["extensions", "logs"]), $elm$json$Json$Decode$list(decodeLog)));
    }();
    var $author$project$Components$GqlResponse$logsEmpty_a0 = $author$project$Components$GqlResponse$parseResponse($author$project$Components$GqlResponse$decodeLogs), $author$project$Components$GqlResponse$logsEmpty_a1 = $elm_community$maybe_extra$Maybe$Extra$isNothing, $author$project$Components$GqlResponse$logsEmpty = A2($elm$core$Basics$composeR, $author$project$Components$GqlResponse$logsEmpty_a0, $author$project$Components$GqlResponse$logsEmpty_a1);
    var $author$project$Components$GqlResponse$Errors = 0;
    var $author$project$Components$GqlResponse$Extensions = 2;
    var $author$project$Components$GqlResponse$Logs = 1;
    var $author$project$Components$GqlResponse$metaDataFocusList = _List_fromArray([0, 1, 2]);
    var $author$project$Components$GqlResponse$setResponse_fn = function (response, model) {
        var metaDataFocusHasData = function (focus) {
            return function () {
                switch (focus) {
                    case 0:
                        return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$GqlResponse$errorsEmpty);
                    case 1:
                        return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$GqlResponse$logsEmpty);
                    default:
                        return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$GqlResponse$extensionsEmpty);
                }
            }()($elm$core$Maybe$Just(response));
        };
        var firstNonEmptyMetaDataFocusTab = $elm_community$list_extra$List$Extra$find_fn(metaDataFocusHasData, $author$project$Components$GqlResponse$metaDataFocusList);
        return _Utils_update(model, {
            bV: $elm_community$maybe_extra$Maybe$Extra$orElse_fn(firstNonEmptyMetaDataFocusTab, $elm_community$maybe_extra$Maybe$Extra$filter_fn(metaDataFocusHasData, model.bV)),
            aw: $elm$core$Maybe$Just(response)
        });
    }, $author$project$Components$GqlResponse$setResponse = F2($author$project$Components$GqlResponse$setResponse_fn);
    var $author$project$Pages$Functions$FunctionTab$setResponse_fn = function (response, tab) {
        return _Utils_update(tab, {
            mE: $author$project$Components$GqlResponse$setResponse_fn(response, tab.mE)
        });
    }, $author$project$Pages$Functions$FunctionTab$setResponse = F2($author$project$Pages$Functions$FunctionTab$setResponse_fn);
    var $author$project$Types$Function$setRuntime_fn = function (runtime, _function) {
        return _Utils_update(_function, { oJ: runtime });
    }, $author$project$Types$Function$setRuntime = F2($author$project$Types$Function$setRuntime_fn);
    var $author$project$Pages$Functions$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Pages$Functions$setUpdating = F2($author$project$Pages$Functions$setUpdating_fn);
    var $author$project$Pages$Functions$FunctionTab$toContent_a0 = function ($) {
        return $.gO;
    }, $author$project$Pages$Functions$FunctionTab$toContent_a1 = function ($) {
        return $.gB;
    }, $author$project$Pages$Functions$FunctionTab$toContent = A2($elm$core$Basics$composeR, $author$project$Pages$Functions$FunctionTab$toContent_a0, $author$project$Pages$Functions$FunctionTab$toContent_a1);
    var $author$project$Pages$Functions$FunctionTab$toData_a0 = function ($) {
        return $.lY;
    }, $author$project$Pages$Functions$FunctionTab$toData_a1 = function ($) {
        return $.gB;
    }, $author$project$Pages$Functions$FunctionTab$toData = A2($elm$core$Basics$composeR, $author$project$Pages$Functions$FunctionTab$toData_a0, $author$project$Pages$Functions$FunctionTab$toData_a1);
    var $author$project$Route$toFunctionsRoute = function (route) {
        if (route.$ === 23) {
            var subRoute = route.b;
            return $elm$core$Maybe$Just(subRoute);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_form$Form$toResult = function (validated) {
        if (!validated.$) {
            var value = validated.a;
            return $elm$core$Result$Ok(value);
        }
        else {
            var maybeParsed = validated.a;
            var errors = validated.b;
            return $elm$core$Result$Err(_Utils_Tuple2(maybeParsed, errors));
        }
    };
    var $author$project$Components$FormOverlay$Responded = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Components$FormOverlay$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$FormOverlay$Applied = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Components$FormOverlay$Closed = { $: 1 };
    var $author$project$Components$FormOverlay$FormMsg = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_form$Form$Post = 1;
    var $dillonkearns$elm_form$Form$options = function (id) {
        return { ln: $elm$core$Maybe$Nothing, c0: $elm$core$Maybe$Nothing, bR: id, fu: 0, f: 1, hJ: $elm$core$Maybe$Nothing, bk: $elm$core$Maybe$Nothing };
    };
    var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
    var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles_fn = function (_v0, styles) {
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                return styles;
            }
            else {
                return $elm$core$Dict$insert_fn(cssTemplate, $rtfeldman$elm_css$Hash$fromString(cssTemplate), styles);
            }
        }
        else {
            return styles;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute_fn = function (styles, _v0) {
        var val = _v0.a;
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                var classname = _v1.a;
                return $elm$virtual_dom$VirtualDom$property_fn("className", $elm$json$Json$Encode$string(classname));
            }
            else {
                return $elm$virtual_dom$VirtualDom$property_fn("className", $elm$json$Json$Encode$string("_unstyled"));
            }
        }
        else {
            return val;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS_fn = function (styles, _v0) {
        var val = _v0.a;
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                var classname = _v1.a;
                return $elm$virtual_dom$VirtualDom$attribute_fn("class", classname);
            }
            else {
                return $elm$virtual_dom$VirtualDom$attribute_fn("class", "_unstyled");
            }
        }
        else {
            return val;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS_fn);
    var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
        return _VirtualDom_keyedNodeNS_fn(_VirtualDom_keyedNode_a0, _VirtualDom_noScript(tag));
    };
    var $elm$virtual_dom$VirtualDom$keyedNodeNS_fn = function (namespace, tag) {
        return _VirtualDom_keyedNodeNS_fn(namespace, _VirtualDom_noScript(tag));
    }, $elm$virtual_dom$VirtualDom$keyedNodeNS = F2($elm$virtual_dom$VirtualDom$keyedNodeNS_fn);
    var $elm$virtual_dom$VirtualDom$nodeNS_fn = function (namespace, tag) {
        return _VirtualDom_nodeNS_fn(namespace, _VirtualDom_noScript(tag));
    }, $elm$virtual_dom$VirtualDom$nodeNS = F2($elm$virtual_dom$VirtualDom$nodeNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml_fn = function (_v6, _v7) {
        var key = _v6.a;
        var html = _v6.b;
        var pairs = _v7.a;
        var styles = _v7.b;
        switch (html.$) {
            case 4:
                var vdom = html.a;
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), styles);
            case 0:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v9 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v9.a;
                var finalStyles = _v9.b;
                var vdom = A3($elm$virtual_dom$VirtualDom$node, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            case 1:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v10 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v10.a;
                var finalStyles = _v10.b;
                var vdom = A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            case 2:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v11 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v11.a;
                var finalStyles = _v11.b;
                var vdom = A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            default:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v12 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v12.a;
                var finalStyles = _v12.b;
                var vdom = A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml_fn = function (html, _v0) {
        var nodes = _v0.a;
        var styles = _v0.b;
        switch (html.$) {
            case 4:
                var vdomNode = html.a;
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), styles);
            case 0:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v2 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v2.a;
                var finalStyles = _v2.b;
                var vdomNode = A3($elm$virtual_dom$VirtualDom$node, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            case 1:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v3 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v3.a;
                var finalStyles = _v3.b;
                var vdomNode = A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            case 2:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v4 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v4.a;
                var finalStyles = _v4.b;
                var vdomNode = A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            default:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v5 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v5.a;
                var finalStyles = _v5.b;
                var vdomNode = A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration_fn = function (template, classname, declaration) {
        return declaration + ("\n" + $elm$core$String$replace_fn($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
    }, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3($rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
        return $elm$core$Dict$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, "", dict);
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration_fn = function (scopingPrefix, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (template, classname, declaration) {
            return declaration + ("\n" + $elm$core$String$replace_fn("." + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, "#" + (scopingPrefix + ("." + classname)), template));
        }, "", dict);
    }, $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode_fn = function (maybeNonce, accumulatedStyles) {
        var cssText = function () {
            if (!accumulatedStyles.$) {
                var allStyles = accumulatedStyles.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
            }
            else {
                var scope = accumulatedStyles.a;
                var rootStyles = accumulatedStyles.b;
                var descendantStyles = accumulatedStyles.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration_fn(scope, rootStyles) + ("\n" + $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration_fn(scope + " ", descendantStyles));
            }
        }();
        return A3($elm$virtual_dom$VirtualDom$node, "span", _List_fromArray([
            $elm$virtual_dom$VirtualDom$attribute_fn("style", "display: none;"),
            $elm$virtual_dom$VirtualDom$attribute_fn("class", "elm-css-style-wrapper")
        ]), _List_fromArray([
            A3($elm$virtual_dom$VirtualDom$node, "style", function () {
                if (!maybeNonce.$) {
                    var nonce = maybeNonce.a;
                    return _List_fromArray([
                        $elm$virtual_dom$VirtualDom$attribute_fn("nonce", nonce)
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }(), $elm$core$List$singleton($elm$virtual_dom$VirtualDom$text(cssText)))
        ]));
    }, $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn = function (maybeNonce, elemType, properties, children) {
        var initialStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), children);
        var childNodes = _v0.a;
        var styles = _v0.b;
        var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode_fn(maybeNonce, $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles), properties);
        return A3($elm$virtual_dom$VirtualDom$node, elemType, unstyledProperties, _List_Cons(styleNode, $elm$core$List$reverse(childNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4($rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn = function (key, pairs) {
        containsKey: while (true) {
            if (!pairs.b) {
                return false;
            }
            else {
                var _v1 = pairs.a;
                var str = _v1.a;
                var rest = pairs.b;
                if (_Utils_eq(key, str)) {
                    return true;
                }
                else {
                    var $temp$key = key, $temp$pairs = rest;
                    key = $temp$key;
                    pairs = $temp$pairs;
                    continue containsKey;
                }
            }
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2($rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn = function (_default, pairs) {
        getUnusedKey: while (true) {
            if (!pairs.b) {
                return _default;
            }
            else {
                var _v1 = pairs.a;
                var firstKey = _v1.a;
                var rest = pairs.b;
                var newKey = "_" + firstKey;
                if ($rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn(newKey, rest)) {
                    var $temp$default = newKey, $temp$pairs = rest;
                    _default = $temp$default;
                    pairs = $temp$pairs;
                    continue getUnusedKey;
                }
                else {
                    return newKey;
                }
            }
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn = function (maybeNonce, accumulatedStyles, keyedChildNodes) {
        var styleNodeKey = $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn("_", keyedChildNodes);
        var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode_fn(maybeNonce, accumulatedStyles);
        return _Utils_Tuple2(styleNodeKey, finalNode);
    }, $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn = function (maybeNonce, elemType, properties, keyedChildren) {
        var initialStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), keyedChildren);
        var keyedChildNodes = _v0.a;
        var styles = _v0.b;
        var keyedStyleNode = $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn(maybeNonce, $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles), keyedChildNodes);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles), properties);
        return A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, unstyledProperties, _List_Cons(keyedStyleNode, $elm$core$List$reverse(keyedChildNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn = function (maybeNonce, ns, elemType, properties, keyedChildren) {
        var initialStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), keyedChildren);
        var keyedChildNodes = _v0.a;
        var styles = _v0.b;
        var keyedStyleNode = $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn(maybeNonce, $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles), keyedChildNodes);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles), properties);
        return A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, unstyledProperties, _List_Cons(keyedStyleNode, $elm$core$List$reverse(keyedChildNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn = function (maybeNonce, ns, elemType, properties, children) {
        var initialStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), children);
        var childNodes = _v0.a;
        var styles = _v0.b;
        var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode_fn(maybeNonce, $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles), properties);
        return A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, unstyledProperties, _List_Cons(styleNode, $elm$core$List$reverse(childNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
        switch (vdom.$) {
            case 4:
                var plainNode = vdom.a;
                return plainNode;
            case 0:
                var elemType = vdom.a;
                var properties = vdom.b;
                var children = vdom.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn($elm$core$Maybe$Nothing, elemType, properties, children);
            case 1:
                var ns = vdom.a;
                var elemType = vdom.b;
                var properties = vdom.c;
                var children = vdom.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn($elm$core$Maybe$Nothing, ns, elemType, properties, children);
            case 2:
                var elemType = vdom.a;
                var properties = vdom.b;
                var children = vdom.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn($elm$core$Maybe$Nothing, elemType, properties, children);
            default:
                var ns = vdom.a;
                var elemType = vdom.b;
                var properties = vdom.c;
                var children = vdom.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn($elm$core$Maybe$Nothing, ns, elemType, properties, children);
        }
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4_fn = function (fn, arg1, arg2, arg3, arg4) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A4(fn, arg1, arg2, arg3, arg4));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4_fn_unwrapped = function (fn, arg1, arg2, arg3, arg4) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2, arg3, arg4));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4 = F5($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy4_fn = function (fn, arg1, arg2, arg3, arg4) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy5_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4, fn, arg1, arg2, arg3, arg4));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy4 = F5($rtfeldman$elm_css$VirtualDom$Styled$lazy4_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy4 = $rtfeldman$elm_css$VirtualDom$Styled$lazy4;
    var $dillonkearns$elm_form$Internal$FieldEvent$FormFieldEvent = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_form$Form$Get = 0;
    var $dillonkearns$elm_form$Form$Invalid_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $dillonkearns$elm_form$Form$Invalid = F2($dillonkearns$elm_form$Form$Invalid_fn);
    var $dillonkearns$elm_form$Internal$FieldEvent$Submit_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_form$Internal$FieldEvent$Submit = F2($dillonkearns$elm_form$Internal$FieldEvent$Submit_fn);
    var $dillonkearns$elm_form$Internal$FieldEvent$UserMsg = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_form$Form$Valid = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$action = function (uri) {
        return $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn("action", uri);
    };
    var $dillonkearns$elm_form$Internal$FieldEvent$alwaysPreventDefault = function (msg) {
        return _Utils_Tuple2(msg, true);
    };
    var $dillonkearns$elm_form$Internal$FieldEvent$currentForm_fn = function (field_, decoder_) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$at_fn(_List_fromArray(["submitter", "form"]), decoder_),
            $elm$json$Json$Decode$at_fn(_List_fromArray(["currentTarget", field_]), decoder_)
        ]));
    }, $dillonkearns$elm_form$Internal$FieldEvent$currentForm = F2($dillonkearns$elm_form$Internal$FieldEvent$currentForm_fn);
    var $elm$json$Json$Decode$index = _Json_decodeIndex;
    var $dillonkearns$elm_form$Internal$FieldEvent$tuplesDecoder = $elm$json$Json$Decode$list(_Json_map2_fn($elm$core$Tuple$pair, _Json_decodeIndex_fn(0, $elm$json$Json$Decode$string), _Json_decodeIndex_fn(1, $elm$json$Json$Decode$string)));
    var $dillonkearns$elm_form$Internal$FieldEvent$fieldsDecoder = $elm$json$Json$Decode$maybe(_Json_decodeField_fn("fields", $dillonkearns$elm_form$Internal$FieldEvent$tuplesDecoder));
    var $elm$json$Json$Decode$map4 = _Json_map4;
    var $dillonkearns$elm_form$Internal$FieldEvent$Get = 0;
    var $dillonkearns$elm_form$Internal$FieldEvent$Post = 1;
    var $dillonkearns$elm_form$Internal$FieldEvent$methodDecoder = _Json_map1_fn(function (methodString) {
        var _v0 = $elm$core$String$toUpper(methodString);
        switch (_v0) {
            case "GET":
                return 0;
            case "POST":
                return 1;
            default:
                return 0;
        }
    }, $elm$json$Json$Decode$string);
    var $elm$html$Html$Events$preventDefaultOn_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
    }, $elm$html$Html$Events$preventDefaultOn = F2($elm$html$Html$Events$preventDefaultOn_fn);
    var $dillonkearns$elm_form$Internal$FieldEvent$formDataOnSubmit = $elm$html$Html$Events$preventDefaultOn_fn("submit", _Json_map1_fn($dillonkearns$elm_form$Internal$FieldEvent$alwaysPreventDefault, _Json_map4_fn(F4(function (fields, method, action, id) {
        return { ln: action, F: fields, bR: id, f: method };
    }), $dillonkearns$elm_form$Internal$FieldEvent$fieldsDecoder, $dillonkearns$elm_form$Internal$FieldEvent$currentForm_fn("method", $dillonkearns$elm_form$Internal$FieldEvent$methodDecoder), $dillonkearns$elm_form$Internal$FieldEvent$currentForm_fn("action", $elm$json$Json$Decode$string), $dillonkearns$elm_form$Internal$FieldEvent$currentForm_fn("id", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)))));
    var $dillonkearns$elm_form$Form$Errors = $elm$core$Basics$identity;
    var $elm$core$Dict$map_fn = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, A2(func, key, value), $elm$core$Dict$map_fn(func, left), $elm$core$Dict$map_fn(func, right));
        }
    }, $elm$core$Dict$map_fn_unwrapped = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, func(key, value), $elm$core$Dict$map_fn_unwrapped(func, left), $elm$core$Dict$map_fn_unwrapped(func, right));
        }
    }, $elm$core$Dict$map = F2($elm$core$Dict$map_fn);
    var $dillonkearns$elm_form$Form$convert = function (formState) {
        return {
            F: $elm$core$Dict$map_fn_unwrapped(function (_v0, value) {
                return {
                    oV: $dillonkearns$elm_form$Form$statusRank(value.oV),
                    pB: value.pB
                };
            }, formState.F),
            o1: formState.o1
        };
    };
    var $dillonkearns$elm_form$Form$initFormState = { F: $elm$core$Dict$empty, o1: false };
    var $dillonkearns$elm_form$Form$insertIfNonempty_fn = function (key, values, dict) {
        return $elm$core$List$isEmpty(values) ? dict : $elm$core$Dict$insert_fn(key, values, dict);
    }, $dillonkearns$elm_form$Form$insertIfNonempty = F3($dillonkearns$elm_form$Form$insertIfNonempty_fn);
    var $dillonkearns$elm_form$Form$mergeErrors_fn = function (errors1, errors2) {
        return $elm$core$Dict$merge_fn(F3(function (key, entries, soFar) {
            return $dillonkearns$elm_form$Form$insertIfNonempty_fn(key, entries, soFar);
        }), F4(function (key, entries1, entries2, soFar) {
            return $dillonkearns$elm_form$Form$insertIfNonempty_fn(key, _Utils_ap(entries1, entries2), soFar);
        }), F3(function (key, entries, soFar) {
            return $dillonkearns$elm_form$Form$insertIfNonempty_fn(key, entries, soFar);
        }), errors1, errors2, $elm$core$Dict$empty);
    }, $dillonkearns$elm_form$Form$mergeErrors = F2($dillonkearns$elm_form$Form$mergeErrors_fn);
    var $dillonkearns$elm_form$Form$mergeResults = function (parsed) {
        var _v0 = parsed.am;
        var _v1 = _v0.a;
        var name = _v1.b;
        var _v2 = _v1.c;
        var parsedThing = _v2.a;
        var combineErrors = _v2.b;
        var individualFieldErrors = _v0.b;
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn($elm$core$Maybe$Nothing, name, _Utils_Tuple2(parsedThing, $dillonkearns$elm_form$Form$mergeErrors_fn(combineErrors, individualFieldErrors)));
    };
    var $dillonkearns$elm_form$Form$unwrapValidation = function (_v0) {
        var _v1 = _v0.c;
        var maybeParsed = _v1.a;
        var errors = _v1.b;
        return _Utils_Tuple2(maybeParsed, errors);
    };
    var $dillonkearns$elm_form$Form$helperValues_fn = function (options_, toHiddenInput, formState, _v0) {
        var fieldDefinitions = _v0.a;
        var parser = _v0.b;
        var toInitialValues = _v0.c;
        var part2 = $elm$core$Maybe$withDefault_fn($elm$core$Maybe$withDefault_fn($dillonkearns$elm_form$Form$initFormState, $elm$core$Maybe$map_fn(function (fields) {
            return {
                F: $elm$core$Dict$fromList($elm$core$List$map_fn($elm$core$Tuple$mapSecond(function (value) {
                    return { oV: 0, pB: value };
                }), fields)),
                o1: true
            };
        }, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fR;
        }, function ($) {
            return $.F;
        }), options_.bk))), $elm$core$Dict$get_fn(options_.bR, formState.h7)).F;
        var initialValues = $elm$core$Dict$fromList($elm$core$List$filterMap_fn(function (_v8) {
            var key = _v8.a;
            var maybeValue = _v8.b;
            return $elm$core$Maybe$map_fn(function (value) {
                return _Utils_Tuple2(key, { oV: 0, pB: value });
            }, maybeValue);
        }, toInitialValues(options_.fu)));
        var hiddenInputs = $elm$core$List$filterMap_fn(function (_v6) {
            var name = _v6.a;
            var fieldDefinition = _v6.b;
            if (fieldDefinition === 1) {
                return $elm$core$Maybe$Just(toHiddenInput(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$name_a0, name),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "hidden"),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$value_a0, $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function ($) {
                        return $.pB;
                    }, $elm$core$Dict$get_fn(name, initialValues))))
                ])));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, fieldDefinitions);
        var fullFormState = $elm$core$Dict$union_fn(part2, initialValues);
        var rawFields = $elm$core$List$map_fn($elm$core$Tuple$mapSecond(function ($) {
            return $.pB;
        }), $elm$core$Dict$toList(fullFormState));
        var thisFormState = function (state) {
            return _Utils_update(state, { F: fullFormState });
        }($elm$core$Maybe$withDefault_fn($elm$core$Maybe$withDefault_fn($dillonkearns$elm_form$Form$initSingle, $elm$core$Maybe$map_fn(function (fields) {
            return {
                F: $elm$core$Dict$fromList($elm$core$List$map_fn($elm$core$Tuple$mapSecond(function (value) {
                    return { oV: 0, pB: value };
                }), fields)),
                o1: true
            };
        }, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fR;
        }, function ($) {
            return $.F;
        }), options_.bk))), $elm$core$Dict$get_fn(options_.bR, formState.h7)));
        var parsed1 = A2(parser, $elm$core$Maybe$Just(options_.fu), $dillonkearns$elm_form$Form$convert(thisFormState));
        var parsed = {
            aY: parsed1.aY,
            am: _Utils_Tuple2(parsed1.av.lT, parsed1.am),
            gl: parsed1.av.gl
        };
        var withServerErrors = $dillonkearns$elm_form$Form$mergeResults(_Utils_update(parsed, {
            am: $elm$core$Tuple$mapSecond_fn(function (errors1) {
                return $dillonkearns$elm_form$Form$mergeErrors_fn(errors1, $elm$core$Maybe$withDefault_fn($elm$core$Dict$empty, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.fR;
                }, function ($) {
                    return $.lQ;
                }), options_.bk)));
            }, parsed.am)
        }));
        var withoutServerErrors = $dillonkearns$elm_form$Form$mergeResults(parsed);
        var isValid = function () {
            if (!withoutServerErrors.c.a.$) {
                var _v5 = withoutServerErrors.c;
                var errors = _v5.b;
                return $elm$core$Dict$isEmpty(errors);
            }
            else {
                return false;
            }
        }();
        var context = {
            ml: $dillonkearns$elm_form$Form$unwrapValidation(withServerErrors).b,
            fu: options_.fu,
            o1: thisFormState.o1,
            o2: formState.o2
        };
        var children = parsed.gl(context);
        var _v1 = function () {
            var _v3 = withoutServerErrors.c;
            var parsedValue = _v3.a;
            var errors = _v3.b;
            return _Utils_Tuple2(parsedValue, errors);
        }();
        var maybeParsed = _v1.a;
        var errorsDict = _v1.b;
        return { gx: children, ml: errorsDict, F: rawFields, g0: hiddenInputs, mT: isValid, oc: maybeParsed };
    }, $dillonkearns$elm_form$Form$helperValues = F4($dillonkearns$elm_form$Form$helperValues_fn);
    var $dillonkearns$elm_form$Internal$FieldEvent$FieldEvent_fn = function (value, formId, name, event) {
        return { mm: event, mz: formId, M: name, pB: value };
    }, $dillonkearns$elm_form$Internal$FieldEvent$FieldEvent = F4($dillonkearns$elm_form$Internal$FieldEvent$FieldEvent_fn);
    var $dillonkearns$elm_form$Internal$FieldEvent$BlurEvent = { $: 2 };
    var $dillonkearns$elm_form$Internal$FieldEvent$FocusEvent = { $: 1 };
    var $dillonkearns$elm_form$Internal$FieldEvent$InputEvent = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_form$Pages$FormState$inputValueDecoder = _Json_andThen_fn(function (targetType) {
        switch (targetType) {
            case "button":
                return $elm$json$Json$Decode$fail("Input and focus events don't run on buttons.");
            case "checkbox":
                return _Json_map2_fn(F2(function (valueWhenChecked, isChecked) {
                    return isChecked ? valueWhenChecked : "";
                }), $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "value"]), $elm$json$Json$Decode$string), $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "checked"]), $elm$json$Json$Decode$bool));
            default:
                return $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "value"]), $elm$json$Json$Decode$string);
        }
    }, $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "type"]), $elm$json$Json$Decode$string));
    var $dillonkearns$elm_form$Pages$FormState$fieldDecoder = _Json_andThen_fn(function (type_) {
        switch (type_) {
            case "input":
                return _Json_map1_fn($dillonkearns$elm_form$Internal$FieldEvent$InputEvent, $dillonkearns$elm_form$Pages$FormState$inputValueDecoder);
            case "focusin":
                return $elm$json$Json$Decode$succeed($dillonkearns$elm_form$Internal$FieldEvent$FocusEvent);
            case "focusout":
                return $elm$json$Json$Decode$succeed($dillonkearns$elm_form$Internal$FieldEvent$BlurEvent);
            default:
                return $elm$json$Json$Decode$fail("Unexpected event.type");
        }
    }, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    var $dillonkearns$elm_form$Pages$FormState$fieldEventDecoder = _Json_map4_fn($dillonkearns$elm_form$Internal$FieldEvent$FieldEvent, $dillonkearns$elm_form$Pages$FormState$inputValueDecoder, $elm$json$Json$Decode$at_fn(_List_fromArray(["currentTarget", "id"]), $elm$json$Json$Decode$string), _Json_andThen_fn(function (name) {
        return (name === "") ? $elm$json$Json$Decode$fail("Events only run on fields with names.") : $elm$json$Json$Decode$succeed(name);
    }, $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "name"]), $elm$json$Json$Decode$string)), $dillonkearns$elm_form$Pages$FormState$fieldDecoder);
    var $elm$html$Html$Attributes$id_a0 = "id", $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$id_a0);
    var $elm$html$Html$Events$on_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$Normal(decoder));
    }, $elm$html$Html$Events$on = F2($elm$html$Html$Events$on_fn);
    var $dillonkearns$elm_form$Pages$FormState$listeners = function (formId) {
        return _List_fromArray([
            $elm$html$Html$Events$on_fn("focusin", $dillonkearns$elm_form$Pages$FormState$fieldEventDecoder),
            $elm$html$Html$Events$on_fn("focusout", $dillonkearns$elm_form$Pages$FormState$fieldEventDecoder),
            $elm$html$Html$Events$on_fn("input", $dillonkearns$elm_form$Pages$FormState$fieldEventDecoder),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$id_a0, formId)
        ]);
    };
    var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
    var $rtfeldman$elm_css$Html$Styled$Attributes$method_a0 = "method", $rtfeldman$elm_css$Html$Styled$Attributes$method = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$method_a0);
    var $dillonkearns$elm_form$Form$methodToString = function (method) {
        if (!method) {
            return "GET";
        }
        else {
            return "POST";
        }
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$novalidate_a0 = "noValidate", $rtfeldman$elm_css$Html$Styled$Attributes$novalidate = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$novalidate_a0);
    var $dillonkearns$elm_form$Form$renderStyledHelper_fn = function (formState, options_, attrs, form_) {
        var toHiddenInput = function (hiddenAttrs) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, hiddenAttrs), _List_Nil);
        };
        var _v0 = $dillonkearns$elm_form$Form$helperValues_fn(options_, toHiddenInput, formState, form_);
        var hiddenInputs = _v0.g0;
        var children = _v0.gx;
        var parsed = _v0.oc;
        var fields = _v0.F;
        var errors = _v0.ml;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _Utils_ap($elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, $elm$core$List$map_fn($elm$html$Html$Attributes$map(A2($elm$core$Basics$composeR, $dillonkearns$elm_form$Internal$FieldEvent$FormFieldEvent, formState.gd)), $dillonkearns$elm_form$Pages$FormState$listeners(options_.bR))), _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$method_a0, $dillonkearns$elm_form$Form$methodToString(options_.f)),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$novalidate_a0, true)
        ]), _Utils_ap($elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$map_fn($rtfeldman$elm_css$Html$Styled$Attributes$action, options_.ln)
        ])), _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(_VirtualDom_mapAttribute_fn(function (formDataThing) {
                var maybeFormMsg = $elm$core$Maybe$map_fn(function (onSubmit) {
                    return onSubmit({
                        ln: formDataThing.ln,
                        F: $elm$core$Maybe$withDefault_fn(fields, formDataThing.F),
                        f: function () {
                            var _v1 = formDataThing.f;
                            if (!_v1) {
                                return 0;
                            }
                            else {
                                return 1;
                            }
                        }(),
                        oc: function () {
                            if (!parsed.$) {
                                var justParsed = parsed.a;
                                return $elm$core$Dict$isEmpty(errors) ? $dillonkearns$elm_form$Form$Valid(justParsed) : $dillonkearns$elm_form$Form$Invalid_fn($elm$core$Maybe$Just(justParsed), errors);
                            }
                            else {
                                return $dillonkearns$elm_form$Form$Invalid_fn($elm$core$Maybe$Nothing, errors);
                            }
                        }()
                    });
                }, options_.hJ);
                return formState.gd($dillonkearns$elm_form$Internal$FieldEvent$Submit_fn(formDataThing, maybeFormMsg));
            }, $dillonkearns$elm_form$Internal$FieldEvent$formDataOnSubmit))
        ]), attrs)))), $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$map(A2($elm$core$Basics$composeR, $dillonkearns$elm_form$Internal$FieldEvent$UserMsg, formState.gd)), _Utils_ap(hiddenInputs, children)));
    }, $dillonkearns$elm_form$Form$renderStyledHelper = F4($dillonkearns$elm_form$Form$renderStyledHelper_fn);
    var $dillonkearns$elm_form$Form$renderStyledHtml_fn = function (state, options_, attrs, form_) {
        return $rtfeldman$elm_css$VirtualDom$Styled$lazy4_fn($dillonkearns$elm_form$Form$renderStyledHelper, state, options_, attrs, form_);
    }, $dillonkearns$elm_form$Form$renderStyledHtml = F4($dillonkearns$elm_form$Form$renderStyledHtml_fn);
    var $dillonkearns$elm_form$Form$withOnSubmit_fn = function (onSubmit, options_) {
        return {
            ln: options_.ln,
            c0: options_.c0,
            bR: options_.bR,
            fu: options_.fu,
            f: options_.f,
            hJ: $elm$core$Maybe$Just(onSubmit),
            bk: options_.bk
        };
    }, $dillonkearns$elm_form$Form$withOnSubmit = F2($dillonkearns$elm_form$Form$withOnSubmit_fn);
    var $author$project$Components$FormOverlay$formView = function (model) {
        var toolbar = function () {
            var _v0 = model.eM;
            if (_v0.$ === 1) {
                return $rtfeldman$elm_css$Html$Styled$text("");
            }
            else {
                var title_ = _v0.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(title_)
                    ])),
                    $author$project$Components$iconButton({
                        bA: $author$project$Svg$closeCircled,
                        a_: $author$project$Components$FormOverlay$Closed,
                        m: _List_Nil,
                        bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
                    })
                ]));
            }
        }();
        var toContent = $dillonkearns$elm_form$Form$renderStyledHtml_fn({ h7: model.d6, o2: model.la, gd: $author$project$Components$FormOverlay$FormMsg }, $dillonkearns$elm_form$Form$withOnSubmit_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.oc;
        }, $author$project$Components$FormOverlay$Applied), $dillonkearns$elm_form$Form$options("form-options")), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2]))
        ]), model.fp($elm$core$Maybe$Just($author$project$Components$FormOverlay$Closed)));
        var isPopover = !_Utils_eq(model.dg, $elm$core$Maybe$Nothing);
        var toBackdrop = isPopover ? $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ])) : $author$project$Components$backdrop_fn("form-overlay", $elm$core$Maybe$Just($author$project$Components$FormOverlay$Closed));
        var toDialog = function () {
            var shadowStyle = isPopover ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_md : $author$project$Theme$theme.of;
            return $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 66)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 12)),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 32))
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    shadowStyle
                ]))
            ]));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, toBackdrop(_List_fromArray([
            toDialog(_List_fromArray([toolbar, toContent]))
        ])));
    };
    var $author$project$Components$FormOverlay$initOverlay = function (model) {
        var positionMapper = _Utils_eq(model.dg, $elm$core$Maybe$Nothing) ? $author$project$Overlay$showCentered : $author$project$Overlay$showBelow;
        return $author$project$Overlay$setOrigin_fn($elm$core$Basics$identity, $elm$core$Maybe$withDefault_fn("", model.dg), A2(positionMapper, $author$project$Components$FormOverlay$formView(model), model.a$));
    };
    var $author$project$Components$FormOverlay$setPositionOriginElementId_fn = function (maybeElementId, model) {
        return _Utils_update(model, { dg: maybeElementId });
    }, $author$project$Components$FormOverlay$setPositionOriginElementId = F2($author$project$Components$FormOverlay$setPositionOriginElementId_fn);
    var $author$project$Components$FormOverlay$setState_fn = function (formState, model) {
        return _Utils_update(model, { d6: formState });
    }, $author$project$Components$FormOverlay$setState = F2($author$project$Components$FormOverlay$setState_fn);
    var $author$project$Components$FormOverlay$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Components$FormOverlay$setUpdating = F2($author$project$Components$FormOverlay$setUpdating_fn);
    var $author$project$Components$FormOverlay$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$FormOverlay$formView(model), model.a$)
        });
    };
    var $author$project$Components$FormOverlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                var elementId = msg.a;
                return $author$project$Util$withCmdFromModel_fn($author$project$Components$FormOverlay$initOverlay, $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setPositionOriginElementId($elm_community$string_extra$String$Extra$nonEmpty(elementId)), $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setState($dillonkearns$elm_form$Form$init), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$FormOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                var parsed = msg.a;
                if (!parsed.$) {
                    return $author$project$Util$withModel_fn($author$project$Components$FormOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setUpdating(true), _Utils_Tuple2(model, A2(model.bC, parsed, $author$project$Components$FormOverlay$Responded))));
                }
                else {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 3:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$FormOverlay$closeOverlay, $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$FormOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
            case 4:
                var overlayMsg = msg.a;
                var _v3 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
            default:
                var formMsg = msg.a;
                var _v4 = $dillonkearns$elm_form$Form$update_fn(formMsg, model.d6);
                var formState = _v4.a;
                var cmd = _v4.b;
                return $author$project$Util$withCmd_fn(_Platform_map_fn(model.gd, cmd), $author$project$Util$withModel_fn($author$project$Components$FormOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$FormOverlay$setState(formState), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
        }
    }, $author$project$Components$FormOverlay$update = F2($author$project$Components$FormOverlay$update_fn);
    var $author$project$Components$GqlResponse$update_fn = function (msg, model) {
        if (!msg.$) {
            var format = msg.a;
            return _Utils_update(model, { d7: format });
        }
        else {
            var focus = msg.a;
            return _Utils_update(model, {
                bV: $elm$core$Maybe$Just(focus)
            });
        }
    }, $author$project$Components$GqlResponse$update = F2($author$project$Components$GqlResponse$update_fn);
    var $author$project$Pages$Functions$FunctionTab$updateInitialDataEditorContent = function (tab) {
        return _Utils_update(tab, {
            lY: $author$project$Components$Editor$updateInitialContent(tab.lY)
        });
    };
    var $author$project$Pages$Functions$FunctionTab$updateInitialEditorContent = function (tab) {
        return _Utils_update(tab, {
            gO: $author$project$Components$Editor$updateInitialContent(tab.gO)
        });
    };
    var $author$project$Util$withMaybeCmd_fn = function (maybeCmd, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(model, cmd), A2($author$project$Util$flip, $author$project$Util$withCmd, _Utils_Tuple2(model, cmd)), maybeCmd);
    }, $author$project$Util$withMaybeCmd = F2($author$project$Util$withMaybeCmd_fn);
    var $author$project$Pages$Functions$update_fn = function (onError, closeConfirmDialog, maybeDbId, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                var _function = msg.a;
                var subMsg = msg.b;
                var _v1 = $elm$core$Dict$get_fn(_function.bR, model.P);
                if (_v1.$ === 1) {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    var tab = _v1.a;
                    var cfg = {
                        bC: F2(function (toMsg_, description_) {
                            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (dbId) {
                                return $author$project$Api$saveFunction_fn(A2($elm$core$Basics$composeR, $author$project$Api$Response$map(function ($) {
                                    return $.i6;
                                }), A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Functions$DescriptionMsg(_function), toMsg))), shared.k2, dbId, $elm$core$Maybe$Just(_function), $author$project$Types$Function$setDescription_fn(_function, $elm_community$string_extra$String$Extra$nonEmpty(description_)));
                            }, maybeDbId);
                        }),
                        nP: A2($elm$core$Basics$composeR, $author$project$Types$Function$setDescription(_function), A2($elm$core$Basics$composeR, $author$project$Pages$Functions$UpdateFunction, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))),
                        nU: onError($elm$core$Maybe$Nothing),
                        el: F2(function (toMsg_, prompt) {
                            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A4($author$project$Api$generateFunctionDescription, A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Functions$DescriptionMsg(_function), toMsg)), shared.k2, prompt, _function), maybeDbId);
                        }),
                        gd: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$DescriptionMsg(_function), toMsg)
                    };
                    var _v2 = $author$project$Components$Description$update_fn(cfg, subMsg, tab.i6);
                    var description = _v2.a;
                    var cmd = _v2.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        P: $elm$core$Dict$update_fn(_function.bR, $elm$core$Maybe$map($author$project$Pages$Functions$FunctionTab$mapDescription($elm$core$Basics$always(description))), model.P)
                    }), cmd);
                }
            case 2:
                var _function = msg.a;
                var editorMsg = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    P: $elm$core$Dict$update_fn(_function.bR, $elm$core$Maybe$map($author$project$Pages$Functions$FunctionTab$mapEditor($author$project$Components$Editor$update(editorMsg))), model.P)
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var _function = msg.a;
                var editorMsg = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    P: $elm$core$Dict$update_fn(_function.bR, $elm$core$Maybe$map($author$project$Pages$Functions$FunctionTab$mapDataEditor($author$project$Components$Editor$update(editorMsg))), model.P)
                }), $elm$core$Platform$Cmd$none);
            case 4:
                var _function = msg.a;
                var gqlResponseMsg = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    P: $elm$core$Dict$update_fn(_function.bR, $elm$core$Maybe$map($author$project$Pages$Functions$FunctionTab$mapGqlResponse($author$project$Components$GqlResponse$update(gqlResponseMsg))), model.P)
                }), $elm$core$Platform$Cmd$none);
            case 5:
                var subMsg = msg.a;
                var newCreateFunctionDialog = $author$project$Components$FormOverlay$init({
                    fp: $author$project$Pages$Functions$CreateFunctionForm$form,
                    bC: F2(function (form, toMsg_) {
                        return $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn_unwrapped(function (dbId, form_) {
                            return $author$project$Api$createFunction_fn(A2($elm$core$Basics$composeL, $author$project$Pages$Functions$AddFunctionMsg, toMsg_), shared.k2, dbId, $elm_community$string_extra$String$Extra$nonEmpty(form_.M), form_.oJ, $elm$core$Maybe$Nothing);
                        }, maybeDbId, $elm$core$Result$toMaybe($dillonkearns$elm_form$Form$toResult(form))));
                    }),
                    nT: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$ShowErrors, $author$project$Util$msgCmd),
                    fM: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$AddFunction, $author$project$Util$msgCmd),
                    eM: $elm$core$Maybe$Nothing,
                    gd: $author$project$Pages$Functions$AddFunctionMsg
                });
                var _v3 = $author$project$Components$FormOverlay$update_fn(subMsg, $elm$core$Maybe$withDefault_fn(newCreateFunctionDialog, model.dV));
                var formOverlay = _v3.a;
                var cmd = _v3.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(formOverlay.la), $author$project$Util$withModel_fn($author$project$Pages$Functions$setCreateFunctionDialog(formOverlay), _Utils_Tuple2(model, _Platform_map_fn(toMsg, cmd))));
            case 24:
                var overlayMsg = msg.a;
                var _v4 = $author$project$Overlay$update_fn(overlayMsg, model.aE);
                var overlay = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, { aE: overlay }), _Platform_map_fn(toMsg, cmd));
            case 6:
                var subMsg = msg.a;
                var _v5 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Functions$renameFunctionNameRequester_fn(maybeDbId, shared, model), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.ln;
                }, $elm$core$Basics$eq("Rename")), model.cm)));
                var inputRequester = _v5.a;
                var cmd = _v5.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(inputRequester.la), $author$project$Util$withModel_fn($author$project$Pages$Functions$setInputRequester($elm$core$Maybe$Just(inputRequester)), _Utils_Tuple2(model, _Platform_map_fn(toMsg, cmd))));
            case 7:
                var subRoute = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$Functions, subRoute), A2($elm$core$Basics$composeR, $author$project$Shared$RouteTo, toSharedCmd)), maybeDbId));
            case 8:
                var subRoute = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$Functions, subRoute), A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd)), maybeDbId));
            case 9:
                var prevRoute = msg.a;
                var subRoute = msg.b;
                var dbId = msg.c;
                return (_Utils_eq($author$project$Route$toFunctionsRoute(prevRoute), $elm$core$Maybe$Nothing) ? $author$project$Util$withCmd($author$project$Util$restoreActiveRoute({
                    dx: $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Functions$Route$toFunctionId, $elm_community$maybe_extra$Maybe$Extra$isJust), model.dx),
                    lo: $elm$core$Basics$always(_List_Nil),
                    ma: $elm$core$Maybe$Just($author$project$Pages$Functions$Route$Overview),
                    ol: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$Navigate, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd)),
                    ou: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$NavigateReplace, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))
                })) : $author$project$Util$updateAndThenOneOf(_List_fromArray([
                    A3($author$project$Pages$Functions$requireFunctions, toMsg, dbId, shared),
                    A3($author$project$Pages$Functions$requireFunction, toMsg, dbId, shared),
                    A3($author$project$Pages$Functions$requireVersion, toMsg, dbId, shared)
                ])))($author$project$Util$withModel_fn($author$project$Pages$Functions$closeDialogs, $author$project$Util$withModel_fn($author$project$Pages$Functions$setActiveRoute(subRoute), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 18:
                var dbId = msg.a;
                var response = msg.b;
                if (!response.$) {
                    var functions = response.a;
                    return $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Functions$requireFunction, toMsg, dbId, shared), _Utils_Tuple2(_Utils_update(model, {
                        mB: $krisajenkins$remotedata$RemoteData$succeed(functions)
                    }), $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        mB: $krisajenkins$remotedata$RemoteData$Failure($elm$http$Http$BadBody(""))
                    }), A2(onError, $elm$core$Maybe$Just("Error"), errors));
                }
            case 10:
                var dbId = msg.a;
                var response = msg.b;
                if (!response.$) {
                    var _function = response.a;
                    return $author$project$Util$updateAndThen_fn(A3($author$project$Pages$Functions$requireVersion, toMsg, dbId, shared), $author$project$Util$withModel_fn($author$project$Pages$Functions$initTab(_function), $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction(_function), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                }
            case 11:
                var _function = msg.a;
                var versionId = msg.b;
                var response = msg.c;
                if (!response.$) {
                    var version = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction($author$project$Types$Function$setVersionData_fn(versionId, version, _function)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction($author$project$Types$Function$setVersionRemoteData_fn(versionId, $krisajenkins$remotedata$RemoteData$Failure(errors), _function)), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
            case 12:
                var _function = msg.a;
                var dialog = $author$project$Components$confirmDialogSimple({
                    lL: $elm$core$Maybe$Nothing,
                    iU: $elm$core$Maybe$Nothing,
                    no: "All changes will be lost.",
                    ek: $author$project$Pages$Functions$CloseDialog,
                    hG: $author$project$Pages$Functions$RevertChanges(_function)
                });
                return _Utils_Tuple2(_Utils_update(model, {
                    aE: $author$project$Overlay$showCentered_fn(dialog, model.aE)
                }), $elm$core$Platform$Cmd$none);
            case 13:
                var _function = msg.a;
                return $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$revertChanges(_function)), _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Functions$CloseDialog))));
            case 14:
                var _function = msg.a;
                var dbId = msg.b;
                return $author$project$Util$withCmdFromModel_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.P;
                }, A2($elm$core$Basics$composeR, $elm$core$Dict$get(_function.bR), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, function (tab) {
                    return $author$project$Api$saveFunction_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Functions$SaveFunctionResponded, toMsg), shared.k2, dbId, $elm$core$Maybe$Just(_function), $author$project$Types$Function$setRuntime_fn(tab.oJ, $author$project$Types$Function$setContent_fn($elm$core$Basics$composeR_fn($author$project$Pages$Functions$FunctionTab$toContent_a0, $author$project$Pages$Functions$FunctionTab$toContent_a1, tab), _function)));
                }))), $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 15:
                var response = msg.a;
                if (!response.$) {
                    var _function = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction(_function), $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$clearResponse), $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$updateInitialEditorContent), $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
            case 16:
                var dbId = msg.a;
                var _function = msg.b;
                var versionId = msg.c;
                return $author$project$Util$withCmd_fn($author$project$Api$republishFunctionVersion_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Functions$RepublishFunctionVersionResponded, toMsg), shared.k2, dbId, _function, versionId), $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 17:
                var response = msg.a;
                if (!response.$) {
                    var _function = response.a;
                    return $author$project$Util$withCmd_fn($elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Functions$NavigateReplace($author$project$Pages$Functions$Route$Function(_function.bR)))), $author$project$Util$withModel_fn($author$project$Pages$Functions$initTab(_function), $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction(_function), $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
            case 19:
                var dbId = msg.a;
                return $author$project$Util$withCmd_fn(closeConfirmDialog, $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(true), _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$deleteFunction, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$DeleteFunctionResponded), shared.k2, dbId), $author$project$Pages$Functions$getSelectedFunction(model)))));
            case 20:
                var response = msg.a;
                if (!response.$) {
                    var _function = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(_Utils_update(model, {
                        mB: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$remove(_function), model.mB),
                        P: $elm$core$Dict$remove_fn(_function.bR, model.P)
                    }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Functions$NavigateReplace($author$project$Pages$Functions$Route$Overview)))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withModel_fn($author$project$Pages$Functions$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                }
            case 21:
                var _function = msg.a;
                var maybeExecuteFunctionCmd = $elm$core$Maybe$map2_fn(A2($author$project$Api$executeFunction, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$ExecuteFunctionResponded(_function)), shared.k2), $elm$core$Maybe$map_fn($author$project$Pages$Functions$FunctionTab$toData, $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.fa;
                }, $elm_community$maybe_extra$Maybe$Extra$isNothing), $author$project$Pages$Functions$getActiveTab(model))), $author$project$Pages$Functions$getSelectedFunction(model));
                var executing = !_Utils_eq(maybeExecuteFunctionCmd, $elm$core$Maybe$Nothing);
                return $author$project$Util$withMaybeCmd_fn(maybeExecuteFunctionCmd, $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$updateInitialDataEditorContent), $author$project$Util$withModel_fn($author$project$Pages$Functions$mapCurrentTab($author$project$Pages$Functions$FunctionTab$setExecuting(executing)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 22:
                var _function = msg.a;
                var response = msg.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Functions$mapCurrentTab($author$project$Pages$Functions$FunctionTab$setExecuting(false)), function () {
                    if (!response.$) {
                        var json = response.a;
                        return $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$setResponse(json)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                    }
                    else {
                        var errors = response.a;
                        return $author$project$Util$withModel_fn(A2($author$project$Pages$Functions$mapTab, _function, $author$project$Pages$Functions$FunctionTab$clearResponse), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors)));
                    }
                }());
            case 23:
                return _Utils_Tuple2(_Utils_update(model, {
                    aE: $author$project$Overlay$clear(model.aE)
                }), $elm$core$Platform$Cmd$none);
            case 25:
                var errors = msg.a;
                return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Error"), errors));
            case 26:
                var _function = msg.a;
                return $author$project$Util$withCmd_fn($elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Functions$NavigateReplace($author$project$Pages$Functions$Route$Function(_function.bR)))), $author$project$Util$withModel_fn($author$project$Pages$Functions$initTab(_function), $author$project$Util$withModel_fn($author$project$Pages$Functions$addFunction(_function), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
            case 27:
                var _function = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Functions$updateFunction(_function), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            default:
                var tab = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Functions$mapCurrentTab($elm$core$Basics$always(tab)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
        }
    }, $author$project$Pages$Functions$update = F8($author$project$Pages$Functions$update_fn);
    var $author$project$Types$ErrorDisplay$Dialog = 2;
    var $author$project$Components$AiEditorOverlay$Opened = { $: 0 };
    var $author$project$Pages$Home$QueryEditorMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Home$Uploaded_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $author$project$Pages$Home$Uploaded = F3($author$project$Pages$Home$Uploaded_fn);
    var $author$project$Types$UploadType$CreateFromQuery = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Components$AiEditorOverlay$EditorMsg = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Api$generateInitialQuery_fn = function (msg, maybeToken, prompt) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("prompt", $elm$json$Json$Encode$string(prompt))
            ]))),
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("completion", $elm$json$Json$Decode$string)),
            f: "POST",
            g: "/api/prompt/create-database"
        });
    }, $author$project$Api$generateInitialQuery = F3($author$project$Api$generateInitialQuery_fn);
    var $author$project$Components$AiEditorOverlay$Closed = { $: 1 };
    var $author$project$Components$AiEditorOverlay$OverlayMsg = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Components$AiEditorOverlay$init = function (cfg) {
        return {
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$OverlayMsg, cfg.gd)),
            h7: $author$project$Components$AiEditor$init({
                iA: cfg.iA,
                ls: cfg.ls,
                lt: cfg.lt,
                lu: cfg.lu,
                iU: cfg.iU,
                gB: cfg.gB,
                e7: cfg.lU,
                l8: cfg.l8,
                mg: cfg.mg,
                mh: cfg.mh,
                bC: cfg.bC,
                ek: $elm$core$Maybe$Just(cfg.gd($author$project$Components$AiEditorOverlay$Closed)),
                nT: cfg.nT,
                el: cfg.el,
                fM: cfg.fM,
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4]),
                gd: A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, cfg.gd)
            }),
            eM: cfg.eM,
            gd: cfg.gd
        };
    };
    var $author$project$Components$InitialQueryEditorOverlay$init_fn = function (toMsg, onResponse, aiPromptExpanded, maybeTeam, token) {
        var _v0 = function () {
            var minLinesSecondaryEditor = 3;
            var minLinesMainEditor = 10;
            var _v1 = _Utils_eq(aiPromptExpanded, $elm$core$Maybe$Nothing) ? _Utils_Tuple3("AI prompt", minLinesSecondaryEditor, minLinesMainEditor) : _Utils_Tuple3("SQL query", minLinesMainEditor, minLinesSecondaryEditor);
            var method = _v1.a;
            var minLinesQuery = _v1.b;
            var minLinesPrompt = _v1.c;
            return _Utils_Tuple3("Write your " + (method + " to create your database"), $elm$core$Maybe$Just(minLinesQuery), $elm$core$Maybe$Just(minLinesPrompt));
        }();
        var title = _v0.a;
        var queryEditorMinLines = _v0.b;
        var aiPromptEditorMinLines = _v0.c;
        return $author$project$Components$AiEditorOverlay$init({
            iA: "",
            ls: $elm$core$Maybe$Just("Generate SQL Query"),
            lt: aiPromptEditorMinLines,
            lu: aiPromptExpanded,
            iU: $elm$core$Maybe$Just("Create"),
            gB: "",
            lU: $elm$core$Maybe$Nothing,
            l8: $elm$core$Maybe$Nothing,
            mg: queryEditorMinLines,
            mh: $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql),
            bC: F2(function (msg_, query) {
                return $author$project$Api$createDatabase_fn(A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, toMsg)), token, maybeTeam, $elm$core$Maybe$Just(query), "New Database");
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, A2(onResponse, $author$project$Types$UploadType$CreateFromQuery(""), maybeTeam), $author$project$Util$msgCmd)),
            el: F2(function (msg_, prompt) {
                return $author$project$Api$generateInitialQuery_fn(A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, toMsg)), token, prompt);
            }),
            fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, A2(onResponse, $author$project$Types$UploadType$CreateFromQuery(""), maybeTeam), $author$project$Util$msgCmd)),
            eM: title,
            gd: toMsg
        });
    }, $author$project$Components$InitialQueryEditorOverlay$init_fn_unwrapped = function (toMsg, onResponse, aiPromptExpanded, maybeTeam, token) {
        var _v0 = function () {
            var minLinesSecondaryEditor = 3;
            var minLinesMainEditor = 10;
            var _v1 = _Utils_eq(aiPromptExpanded, $elm$core$Maybe$Nothing) ? _Utils_Tuple3("AI prompt", minLinesSecondaryEditor, minLinesMainEditor) : _Utils_Tuple3("SQL query", minLinesMainEditor, minLinesSecondaryEditor);
            var method = _v1.a;
            var minLinesQuery = _v1.b;
            var minLinesPrompt = _v1.c;
            return _Utils_Tuple3("Write your " + (method + " to create your database"), $elm$core$Maybe$Just(minLinesQuery), $elm$core$Maybe$Just(minLinesPrompt));
        }();
        var title = _v0.a;
        var queryEditorMinLines = _v0.b;
        var aiPromptEditorMinLines = _v0.c;
        return $author$project$Components$AiEditorOverlay$init({
            iA: "",
            ls: $elm$core$Maybe$Just("Generate SQL Query"),
            lt: aiPromptEditorMinLines,
            lu: aiPromptExpanded,
            iU: $elm$core$Maybe$Just("Create"),
            gB: "",
            lU: $elm$core$Maybe$Nothing,
            l8: $elm$core$Maybe$Nothing,
            mg: queryEditorMinLines,
            mh: $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql),
            bC: F2(function (msg_, query) {
                return $author$project$Api$createDatabase_fn(A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, toMsg)), token, maybeTeam, $elm$core$Maybe$Just(query), "New Database");
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, onResponse($author$project$Types$UploadType$CreateFromQuery(""), maybeTeam), $author$project$Util$msgCmd)),
            el: F2(function (msg_, prompt) {
                return $author$project$Api$generateInitialQuery_fn(A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, toMsg)), token, prompt);
            }),
            fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, onResponse($author$project$Types$UploadType$CreateFromQuery(""), maybeTeam), $author$project$Util$msgCmd)),
            eM: title,
            gd: toMsg
        });
    }, $author$project$Components$InitialQueryEditorOverlay$init = F5($author$project$Components$InitialQueryEditorOverlay$init_fn);
    var $author$project$Types$UploadType$isInitialUpload = function (uploadType) {
        if (uploadType.$ === 2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Api$Response$isSuccess = function (response) {
        if (!response.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Components$AiEditorOverlay$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$AiEditor$AiPromptApplied = { $: 5 };
    var $author$project$Components$AiEditor$AiPromptTyped = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$AiEditor$AppliedUnconfirmed = { $: 1 };
    var $author$project$Components$AiEditor$EditorMsgReceived = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Components$AiEditor$NoOp = { $: 0 };
    var $author$project$Components$AiEditor$ParentMsgReceived = function (a) {
        return { $: 12, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$size = function (n) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("size", $elm$core$String$fromInt(n));
    };
    var $rtfeldman$elm_css$Html$Styled$span_a0 = "span", $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$span_a0);
    var $author$project$Util$zeroWidthString = $elm$core$String$fromChar("\u200B");
    var $author$project$Components$expandingInput_fn = function (cfg, value_) {
        var wrapperNode = _Utils_eq(cfg.bC, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$div : $rtfeldman$elm_css$Html$Styled$form;
        var onBlurToTarget = function (msg) {
            var decoder_ = _Json_map1_fn($elm$core$Basics$always(msg), $elm$json$Json$Decode$at_fn(_List_fromArray(["relatedTarget", "tagName"]), $elm$json$Json$Decode$string));
            return $rtfeldman$elm_css$Html$Styled$Events$on_fn("blur", decoder_);
        };
        var contentNode = cfg.j3 ? $rtfeldman$elm_css$Html$Styled$textarea : $rtfeldman$elm_css$Html$Styled$input;
        return A2(wrapperNode, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$property_fn("scroll-padding", "0 0 2em 2em"),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre,
                        $rtfeldman$elm_css$Css$batch(cfg.m)
                    ]))
                ])),
                $rtfeldman$elm_css$Css$batch(cfg.iV)
            ])),
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onSubmit, cfg.bC)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(_Utils_ap(value_, $author$project$Util$zeroWidthString))
            ])),
            A2(contentNode, _Utils_ap(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
                $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                $rtfeldman$elm_css$Html$Styled$Attributes$size(1),
                $rtfeldman$elm_css$Html$Styled$Attributes$rows(1),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$resize_none,
                    $rtfeldman$elm_css$Css$property_fn("overflow", "-moz-hidden-unscrollable")
                ])),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, onBlurToTarget, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(cfg.iE), cfg.bC)),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(cfg.cv),
                $author$project$Util$onKeyDown({
                    kf: cfg.bC,
                    kj: $elm$core$Maybe$Nothing,
                    hH: $elm$core$Maybe$Just(cfg.ek),
                    kn: $elm$core$Maybe$Nothing
                })
            ]), cfg.cP), _List_Nil)
        ]));
    }, $author$project$Components$expandingInput = F2($author$project$Components$expandingInput_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_scroll = $rtfeldman$elm_css$Css$property_fn("overflow", "scroll");
    var $rtfeldman$elm_css$Html$Styled$details_a0 = "details", $rtfeldman$elm_css$Html$Styled$details = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$details_a0);
    var $rtfeldman$elm_css$Html$Styled$summary_a0 = "summary", $rtfeldman$elm_css$Html$Styled$summary = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$summary_a0);
    var $author$project$Components$toExpandable_fn = function (title, maybeExpanded) {
        if (!maybeExpanded.$) {
            var expanded = maybeExpanded.a;
            return A2($elm$core$Basics$composeR, $elm$core$List$append(_List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$summary_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]))
            ])), $rtfeldman$elm_css$Html$Styled$details(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents])),
                $rtfeldman$elm_css$VirtualDom$Styled$property_fn("open", $elm$json$Json$Encode$bool(expanded))
            ])));
        }
        else {
            return $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]));
        }
    }, $author$project$Components$toExpandable = F2($author$project$Components$toExpandable_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_0 = $rtfeldman$elm_css$Css$property_fn("margin", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_0 = $rtfeldman$elm_css$Css$property_fn("padding", "0px");
    var $author$project$Components$wrapWithSpinner2_fn = function (wrapperStyles, spinnerStyles, spinner, element) {
        return spinner ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$batch(wrapperStyles),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
            ]))
        ]), _List_fromArray([
            $author$project$Svg$spinner(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6,
                    $rtfeldman$elm_css$Css$batch(spinnerStyles),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0
                ]))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
            ]), _List_fromArray([element]))
        ])) : element;
    }, $author$project$Components$wrapWithSpinner2 = F4($author$project$Components$wrapWithSpinner2_fn);
    var $author$project$Components$aiEditor = function (cfg) {
        var queryButton = function (cfg_) {
            return $author$project$Components$wrapWithSpinner2_fn(cfg_.m, _List_Nil, cfg_.h5, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.kW,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $rtfeldman$elm_css$Css$batch(cfg_.m)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg_.a_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg.cd || cfg_.cd)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg_.eM)
            ])));
        };
        var aiPromptInput = $author$project$Components$expandingInput({
            iE: false,
            cP: _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0, "AI Prompt  (Powered by OpenAI)"),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$rows, cfg.lt)
            ]),
            iV: _List_fromArray([
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 3.5)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 35))
            ]),
            j3: true,
            bC: $elm$core$Maybe$Just(cfg.kd),
            ek: cfg.nI,
            cv: cfg.nJ,
            m: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_scroll,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
            ])
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            A3($author$project$Components$toExpandable, "AI Prompt", cfg.lu, _List_fromArray([
                aiPromptInput(cfg.iA),
                queryButton({
                    cd: (cfg.iA === "") || (cfg.gY || cfg.gR),
                    a_: cfg.kd,
                    h5: cfg.gY,
                    m: _List_Nil,
                    eM: $elm$core$Maybe$withDefault_fn("Generate", cfg.ls)
                })
            ])),
            $author$project$Components$Editor$view_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1]), cfg.nS, cfg.hG, cfg.gO),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex]))
            ]), _List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, A2($author$project$Components$textButton, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]), "Cancel"), A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ])))), cfg.ek),
                queryButton({
                    cd: ((cfg.gO.gB === "") && (!_Utils_eq($elm$core$Maybe$Just(cfg.gO.gB), cfg.l8))) || (cfg.gR || cfg.gY),
                    a_: cfg.hG,
                    h5: cfg.gR,
                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12]),
                    eM: $elm$core$Maybe$withDefault_fn("Execute", cfg.iU)
                })
            ]))
        ]));
    };
    var $rtfeldman$elm_css$Css$left_a0 = "left", $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$left_a0);
    var $rtfeldman$elm_css$Css$top_a0 = "top", $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$top_a0);
    var $author$project$Overlay$toView_fn = function (view_, toMsg, model) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (overlay) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_40,
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$left_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, overlay.pH)),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$top_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, overlay.pJ)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                    (!overlay.b$) ? $rtfeldman$elm_css$Css$batch(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none])) : $rtfeldman$elm_css$Css$batch(overlay.cH)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, overlay.bR)
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, view_)
            ]));
        }, model.a$);
    }, $author$project$Overlay$toView = F3($author$project$Overlay$toView_fn);
    var $author$project$Overlay$view_fn = function (toMsg, model) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (overlay) {
            return $author$project$Overlay$toView_fn(overlay.it(overlay.ay), toMsg, model);
        }, $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.ay;
        }, A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)), model.a$));
    }, $author$project$Overlay$view = F2($author$project$Overlay$view_fn);
    var $author$project$Components$AiEditor$element = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), _List_fromArray([
            $author$project$Components$aiEditor({
                iA: model.iA,
                ls: model.ls,
                lt: model.lt,
                lu: model.lu,
                iU: model.iU,
                l8: model.l8,
                cd: false,
                gO: model.gO,
                gR: model.gR,
                gY: model.gY,
                nI: $author$project$Components$AiEditor$NoOp,
                kd: $author$project$Components$AiEditor$AiPromptApplied,
                nJ: $author$project$Components$AiEditor$AiPromptTyped,
                ek: $elm$core$Maybe$map_fn($author$project$Components$AiEditor$ParentMsgReceived, model.ek),
                hG: $author$project$Components$AiEditor$AppliedUnconfirmed,
                nS: $author$project$Components$AiEditor$EditorMsgReceived,
                m: model.m
            }),
            $author$project$Overlay$view_fn($elm$core$Basics$identity, model.aE)
        ])));
    };
    var $author$project$Components$AiEditor$view = function (toMsg) {
        return A2($elm$core$Basics$composeR, $author$project$Components$AiEditor$element, $rtfeldman$elm_css$Html$Styled$map(toMsg));
    };
    var $author$project$Components$AiEditorOverlay$editorView = function (model) {
        var wrapper = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 16)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 24)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 28)),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 5))),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 5)))
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $author$project$Theme$theme.of
            ]))
        ]));
        var toolbar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(model.eM),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$closeCircled,
                a_: model.gd($author$project$Components$AiEditorOverlay$Closed),
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]),
                bE: _List_Nil
            })
        ]));
        return A3($author$project$Components$backdrop, "editor", $elm$core$Maybe$Just(model.gd($author$project$Components$AiEditorOverlay$Closed)), _List_fromArray([
            wrapper(_List_fromArray([
                toolbar,
                A2($author$project$Components$AiEditor$view, $elm$core$Basics$identity, model.h7)
            ]))
        ]));
    };
    var $author$project$Components$AiEditorOverlay$initOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$showCentered_fn($author$project$Components$AiEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$AiEditorOverlay$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$AiEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$AiEditorOverlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return $author$project$Util$withModel_fn($author$project$Components$AiEditorOverlay$initOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$AiEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                var editorMsg = msg.a;
                var _v1 = $author$project$Components$AiEditor$update_fn(editorMsg, model.h7);
                var state = _v1.a;
                var cmd = _v1.b;
                return $author$project$Util$withModel_fn($author$project$Components$AiEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { h7: state }), cmd));
            default:
                var overlayMsg = msg.a;
                var _v2 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Components$AiEditorOverlay$update = F2($author$project$Components$AiEditorOverlay$update_fn);
    var $author$project$Pages$Home$update_fn = function (cfg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var subMsg = msg.a;
                var result = $elm$core$Maybe$map_fn($author$project$Components$AiEditorOverlay$update(subMsg), model.bD);
                return _Utils_Tuple2(_Utils_update(model, {
                    bD: $elm$core$Maybe$map_fn($elm$core$Tuple$first, result)
                }), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Platform$Cmd$map(cfg.gd)), result)));
            case 1:
                var maybeTeam = msg.a;
                var aiPromptExpanded = msg.b;
                var overlay = $author$project$Components$InitialQueryEditorOverlay$init_fn($author$project$Pages$Home$QueryEditorMsg, $author$project$Pages$Home$Uploaded, aiPromptExpanded, maybeTeam, shared.k2);
                return _Utils_Tuple2(_Utils_update(model, {
                    bD: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Home$QueryEditorMsg($author$project$Components$AiEditorOverlay$Opened))));
            case 2:
                return _Utils_Tuple2(_Utils_update(model, { mR: true }), $elm$core$Platform$Cmd$none);
            case 3:
                return _Utils_Tuple2(_Utils_update(model, { mR: false }), $elm$core$Platform$Cmd$none);
            case 4:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                var response = msg.c;
                var queryEditor = $author$project$Api$Response$isSuccess(response) ? $elm$core$Maybe$Nothing : model.bD;
                var errorDisplay = $author$project$Types$UploadType$isInitialUpload(uploadType) ? 0 : 2;
                return _Utils_Tuple2(_Utils_update(model, { bD: queryEditor }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A4(cfg.ko, errorDisplay, uploadType, maybeTeam, response)));
            case 5:
                var maybeTeam = msg.a;
                return _Utils_Tuple2(model, cfg.iY(maybeTeam));
            case 6:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A3(cfg.kl, 0, uploadType, maybeTeam)));
            case 7:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                var file = msg.c;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A4(cfg.kk, 0, uploadType, maybeTeam, file)));
            default:
                var _v1 = msg.a;
                var title = _v1.a;
                var message = _v1.b;
                return _Utils_Tuple2(model, A2(cfg.nT, $elm$core$Maybe$Just(title), _List_fromArray([message])));
        }
    }, $author$project$Pages$Home$update = F4($author$project$Pages$Home$update_fn);
    var $author$project$Shared$ClearTokenState = { $: 1 };
    var $author$project$Shared$SetToken = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Login$UserReceived = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Types$User$User_fn = function (name, serverRoles, teams) {
        return { M: name, kQ: serverRoles, pc: teams };
    }, $author$project$Types$User$User = F3($author$project$Types$User$User_fn);
    var $author$project$Types$User$decode = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("teams", $elm$json$Json$Decode$list($author$project$Types$Team$decode)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("serverRoles", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("username", _Json_map1_fn($elm$core$Basics$identity, $elm$json$Json$Decode$string)), $elm$json$Json$Decode$succeed($author$project$Types$User$User))));
    var $author$project$Api$getUser_fn = function (msg, token, username) {
        return $author$project$Api$requestWithMaybeToken_fn($elm$core$Maybe$Just(token), {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$User$decode),
            f: "GET",
            g: "/api/users/" + $elm$url$Url$percentEncode(username)
        });
    }, $author$project$Api$getUser = F3($author$project$Api$getUser_fn);
    var $author$project$Route$isAuthFree = function (route) {
        switch (route.$) {
            case 16:
                return false;
            case 17:
                return false;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            case 21:
                return false;
            case 22:
                return false;
            case 23:
                return false;
            case 24:
                return false;
            case 25:
                return false;
            case 26:
                return false;
            case 0:
                return true;
            case 1:
                return false;
            case 2:
                return true;
            case 3:
                return true;
            case 4:
                return true;
            case 5:
                return true;
            case 6:
                return true;
            case 7:
                return true;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return true;
            case 14:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Route$isPostLoginRoute = function (route) {
        return (!_Utils_eq($author$project$Route$getDatabaseId(route), $elm$core$Maybe$Nothing)) || function () {
            switch (route.$) {
                case 3:
                    return true;
                case 4:
                    return true;
                case 26:
                    return true;
                case 9:
                    return true;
                default:
                    return false;
            }
        }();
    };
    var $author$project$Api$login_fn = function (msg, username, password) {
        return $elm$http$Http$request({
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("username", $elm$json$Json$Encode$string(username)),
                _Utils_Tuple2("password", $elm$json$Json$Encode$string(password))
            ]))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$SessionToken$decode),
            d9: _List_Nil,
            f: "POST",
            eK: $elm$core$Maybe$Nothing,
            eQ: $elm$core$Maybe$Nothing,
            g: "/api/login"
        });
    }, $author$project$Api$login = F3($author$project$Api$login_fn);
    var $author$project$Pages$Login$update_fn = function (toMsg, toSharedCmd, onLogin, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var maybeUser = msg.a;
                var maybeRreviousRoute = msg.b;
                if (maybeRreviousRoute.$ === 1) {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    if (maybeRreviousRoute.a.$ === 6) {
                        var _v2 = maybeRreviousRoute.a;
                        return _Utils_eq(maybeUser, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $elm$core$Tuple$pair_fn(model, toSharedCmd($author$project$Shared$RouteReplace($author$project$Route$Teams($author$project$Pages$Teams$Route$Teams))));
                    }
                    else {
                        var previousRoute = maybeRreviousRoute.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            kx: $author$project$Route$isPostLoginRoute(previousRoute) ? maybeRreviousRoute : model.kx
                        }), $elm$core$Platform$Cmd$none);
                    }
                }
            case 1:
                var formMsg = msg.a;
                var _v3 = $dillonkearns$elm_form$Form$update_fn(formMsg, model.d6);
                var formState = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { d6: formState }), _Platform_map_fn(toMsg, cmd));
            case 2:
                var parsed = msg.a;
                if (!parsed.$) {
                    var username = parsed.a.lb;
                    var password = parsed.a.kr;
                    return _Utils_Tuple2(_Utils_update(model, { bd: true, dh: _List_Nil }), _Platform_map_fn(toMsg, $author$project$Api$login_fn($author$project$Pages$Login$TokenReceived(username), username, password)));
                }
                else {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 3:
                if (!msg.b.$) {
                    var username = msg.a;
                    var token = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { fA: false, bd: false }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Api$getUser_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Login$UserReceived), token, username),
                        toSharedCmd($author$project$Shared$SetToken(token))
                    ])));
                }
                else {
                    var errors = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { bd: false, dh: errors }), $elm$core$Platform$Cmd$none);
                }
            default:
                if (!msg.a.$) {
                    var user = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { fA: true, bd: false }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A2(onLogin, user, model.kx)));
                }
                else {
                    var errors = msg.a.a;
                    var enforceLoginRouteCmd = $author$project$Route$isAuthFree(shared.eu) ? $elm$core$Platform$Cmd$none : toSharedCmd($author$project$Shared$RouteReplace($author$project$Route$Login));
                    return _Utils_Tuple2(_Utils_update(model, { bd: false, dh: errors }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        enforceLoginRouteCmd,
                        toSharedCmd($author$project$Shared$ClearTokenState)
                    ])));
                }
        }
    }, $author$project$Pages$Login$update_fn_unwrapped = function (toMsg, toSharedCmd, onLogin, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var maybeUser = msg.a;
                var maybeRreviousRoute = msg.b;
                if (maybeRreviousRoute.$ === 1) {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    if (maybeRreviousRoute.a.$ === 6) {
                        var _v2 = maybeRreviousRoute.a;
                        return _Utils_eq(maybeUser, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $elm$core$Tuple$pair_fn(model, toSharedCmd($author$project$Shared$RouteReplace($author$project$Route$Teams($author$project$Pages$Teams$Route$Teams))));
                    }
                    else {
                        var previousRoute = maybeRreviousRoute.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            kx: $author$project$Route$isPostLoginRoute(previousRoute) ? maybeRreviousRoute : model.kx
                        }), $elm$core$Platform$Cmd$none);
                    }
                }
            case 1:
                var formMsg = msg.a;
                var _v3 = $dillonkearns$elm_form$Form$update_fn(formMsg, model.d6);
                var formState = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { d6: formState }), _Platform_map_fn(toMsg, cmd));
            case 2:
                var parsed = msg.a;
                if (!parsed.$) {
                    var username = parsed.a.lb;
                    var password = parsed.a.kr;
                    return _Utils_Tuple2(_Utils_update(model, { bd: true, dh: _List_Nil }), _Platform_map_fn(toMsg, $author$project$Api$login_fn($author$project$Pages$Login$TokenReceived(username), username, password)));
                }
                else {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 3:
                if (!msg.b.$) {
                    var username = msg.a;
                    var token = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { fA: false, bd: false }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Api$getUser_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Login$UserReceived), token, username),
                        toSharedCmd($author$project$Shared$SetToken(token))
                    ])));
                }
                else {
                    var errors = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { bd: false, dh: errors }), $elm$core$Platform$Cmd$none);
                }
            default:
                if (!msg.a.$) {
                    var user = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { fA: true, bd: false }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, onLogin(user, model.kx)));
                }
                else {
                    var errors = msg.a.a;
                    var enforceLoginRouteCmd = $author$project$Route$isAuthFree(shared.eu) ? $elm$core$Platform$Cmd$none : toSharedCmd($author$project$Shared$RouteReplace($author$project$Route$Login));
                    return _Utils_Tuple2(_Utils_update(model, { bd: false, dh: errors }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        enforceLoginRouteCmd,
                        toSharedCmd($author$project$Shared$ClearTokenState)
                    ])));
                }
        }
    }, $author$project$Pages$Login$update = F6($author$project$Pages$Login$update_fn);
    var $author$project$Pages$Queries$DeletedTargetView_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $author$project$Pages$Queries$DeletedTargetView = F3($author$project$Pages$Queries$DeletedTargetView_fn);
    var $author$project$Pages$Queries$EditViewResponded_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Pages$Queries$EditViewResponded = F2($author$project$Pages$Queries$EditViewResponded_fn);
    var $author$project$Pages$Queries$GotSchema_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Queries$GotSchema = F2($author$project$Pages$Queries$GotSchema_fn);
    var $author$project$Pages$Queries$CreateViewMsg = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Pages$Queries$ViewCreateFailed = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Pages$Queries$ViewCreated = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Types$SQLResult$SQLResult_fn = function (rows, runtime, affectedTables, errors) {
        return { lr: affectedTables, ml: errors, hT: rows, oJ: runtime };
    }, $author$project$Types$SQLResult$SQLResult = F4($author$project$Types$SQLResult$SQLResult_fn);
    var $author$project$Types$SQLResult$decode = _Json_map4_fn($author$project$Types$SQLResult$SQLResult, _Json_decodeField_fn("rows", $elm$json$Json$Decode$list($elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))), _Json_decodeField_fn("runtimeSeconds", $elm$json$Json$Decode$float), _Json_decodeField_fn("affectedTables", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)), _Json_decodeField_fn("errors", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
    var $author$project$Api$executeQuery_fn = function (msg, maybeToken, dbId, query) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("query", $elm$json$Json$Encode$string(query))
            ]))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$SQLResult$decode),
            f: "POST",
            g: "/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/sql")
        });
    }, $author$project$Api$executeQuery = F4($author$project$Api$executeQuery_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$get_fn = function (index, _v0) {
        var first = _v0.a;
        var rest = _v0.c;
        return (!index) ? $elm$core$Maybe$Just(first) : $elm$core$Array$get_fn(index - 1, rest);
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$get = F2($basti1302$elm_non_empty_array$Array$NonEmpty$get_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected = function (nea) {
        var _v0 = nea;
        var first = _v0.a;
        var selected = _v0.b;
        var elem = $basti1302$elm_non_empty_array$Array$NonEmpty$get_fn(selected, nea);
        if (!elem.$) {
            var e = elem.a;
            return e;
        }
        else {
            return first;
        }
    };
    var $author$project$Pages$Queries$quoteSqlKeyword = function (keyword) {
        return function (n) {
            return "\"" + (n + "\"");
        }($elm$core$String$replace_fn("\"", "\"\"", $elm$core$String$trim(keyword)));
    };
    var $author$project$Pages$Queries$QueryTab$toQuery_a0 = function ($) {
        return $.dC;
    }, $author$project$Pages$Queries$QueryTab$toQuery_a1 = A2($elm$core$Basics$composeR, function ($) {
        return $.gO;
    }, function ($) {
        return $.gB;
    }), $author$project$Pages$Queries$QueryTab$toQuery = A2($elm$core$Basics$composeR, $author$project$Pages$Queries$QueryTab$toQuery_a0, $author$project$Pages$Queries$QueryTab$toQuery_a1);
    var $author$project$Pages$Queries$createViewNameRequester_fn = function (maybeDbId, shared, model) {
        return $author$project$Components$InputRequester$init({
            ln: "Create",
            bC: F2(function (state, inputReqMsg) {
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (dbId) {
                    return $author$project$Api$executeQuery_fn(A2($elm$core$Basics$composeL, $author$project$Pages$Queries$CreateViewMsg, inputReqMsg), shared.k2, dbId, _String_append_fn("CREATE VIEW " + ($author$project$Pages$Queries$quoteSqlKeyword(state) + " AS "), $elm$core$Basics$composeR_fn($author$project$Pages$Queries$QueryTab$toQuery_a0, $author$project$Pages$Queries$QueryTab$toQuery_a1, $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n))));
                }, maybeDbId);
            }),
            nT: A2($elm$core$Basics$composeR, $author$project$Pages$Queries$ViewCreateFailed, $author$project$Util$msgCmd),
            fM: A2($elm$core$Basics$composeR, $author$project$Pages$Queries$ViewCreated, $author$project$Util$msgCmd),
            kt: $elm$core$Maybe$Nothing,
            df: "View Name",
            gd: $author$project$Pages$Queries$CreateViewMsg
        });
    }, $author$project$Pages$Queries$createViewNameRequester = F3($author$project$Pages$Queries$createViewNameRequester_fn);
    var $author$project$Types$TableType$toString = function (tableType) {
        if (!tableType) {
            return "Table";
        }
        else {
            return "View";
        }
    };
    var $author$project$Api$deleteTable_fn = function (msg, maybeToken, table, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("name", $elm$json$Json$Encode$string(table.M)),
                _Utils_Tuple2("tableType", $elm$json$Json$Encode$string($author$project$Types$TableType$toString(table.o8)))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "DELETE",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + $elm$url$Url$percentEncode(table.M)))
        });
    }, $author$project$Api$deleteTable = F4($author$project$Api$deleteTable_fn);
    var $elm_community$list_extra$List$Extra$findIndexHelp_fn = function (index, predicate, list) {
        findIndexHelp: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var x = list.a;
                var xs = list.b;
                if (predicate(x)) {
                    return $elm$core$Maybe$Just(index);
                }
                else {
                    var $temp$index = index + 1, $temp$predicate = predicate, $temp$list = xs;
                    index = $temp$index;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue findIndexHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$findIndexHelp = F3($elm_community$list_extra$List$Extra$findIndexHelp_fn);
    var $elm_community$list_extra$List$Extra$findIndex_a0 = 0, $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp($elm_community$list_extra$List$Extra$findIndex_a0);
    var $author$project$Api$generateQuery_fn = function (msg, maybeToken, dbId, prompt) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("prompt", $elm$json$Json$Encode$string(prompt))
            ]))),
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("completion", $elm$json$Json$Decode$string)),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/prompt")
        });
    }, $author$project$Api$generateQuery = F4($author$project$Api$generateQuery_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$length = function (_v0) {
        var first = _v0.a;
        var rest = _v0.c;
        return $elm$core$Array$length(rest) + 1;
    };
    var $basti1302$elm_non_empty_array$Array$NonEmpty$selectedIndex = function (_v0) {
        var selected = _v0.b;
        return selected;
    };
    var $elm$core$Array$setHelp_fn = function (shift, index, value, tree) {
        var pos = $elm$core$Array$bitMask & (index >>> shift);
        var _v0 = _JsArray_unsafeGet_fn(pos, tree);
        if (!_v0.$) {
            var subTree = _v0.a;
            var newSub = $elm$core$Array$setHelp_fn(shift - $elm$core$Array$shiftStep, index, value, subTree);
            return _JsArray_unsafeSet_fn(pos, $elm$core$Array$SubTree(newSub), tree);
        }
        else {
            var values = _v0.a;
            var newLeaf = _JsArray_unsafeSet_fn($elm$core$Array$bitMask & index, value, values);
            return _JsArray_unsafeSet_fn(pos, $elm$core$Array$Leaf(newLeaf), tree);
        }
    }, $elm$core$Array$setHelp = F4($elm$core$Array$setHelp_fn);
    var $elm$core$Array$set_fn = function (index, value, array) {
        var len = array.a;
        var startShift = array.b;
        var tree = array.c;
        var tail = array.d;
        return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Array$Array_elm_builtin_fn(len, startShift, tree, _JsArray_unsafeSet_fn($elm$core$Array$bitMask & index, value, tail)) : $elm$core$Array$Array_elm_builtin_fn(len, startShift, $elm$core$Array$setHelp_fn(startShift, index, value, tree), tail));
    }, $elm$core$Array$set = F3($elm$core$Array$set_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$set_fn = function (index, element, _v0) {
        var first = _v0.a;
        var selected = _v0.b;
        var rest = _v0.c;
        return (!index) ? $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(element, selected, rest) : $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, selected, $elm$core$Array$set_fn(index - 1, element, rest));
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$set = F3($basti1302$elm_non_empty_array$Array$NonEmpty$set_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn = function (_function, nea) {
        var index = $basti1302$elm_non_empty_array$Array$NonEmpty$selectedIndex(nea);
        var element = $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(nea);
        return $basti1302$elm_non_empty_array$Array$NonEmpty$set_fn(index, _function(element), nea);
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected = F2($basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn);
    var $author$project$Pages$Queries$mapCurrentTab_fn = function (f, model) {
        return _Utils_update(model, {
            n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn(f, model.n)
        });
    }, $author$project$Pages$Queries$mapCurrentTab = F2($author$project$Pages$Queries$mapCurrentTab_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$push_fn = function (element, _v0) {
        var first = _v0.a;
        var selected = _v0.b;
        var rest = _v0.c;
        return $basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, selected, $elm$core$Array$push_fn(element, rest));
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$push = F2($basti1302$elm_non_empty_array$Array$NonEmpty$push_fn);
    var $author$project$Api$queryViewSql_fn = function (msg, maybeToken, dbId, table) {
        var removeCreateViewStatement = function (sql) {
            var _v0 = $elm$core$String$split_fn("SELECT", $elm$core$String$toUpper(sql));
            if (_v0.b) {
                var createStatement = _v0.a;
                return $elm$core$String$dropLeft_fn($elm$core$String$length(createStatement), sql);
            }
            else {
                return sql;
            }
        };
        var query = $elm$core$String$replace_fn("TABLENAME", table.M, "\n            select \"sql\"\n            from sqlite_master\n            where name = \"TABLENAME\"\n            ");
        var decoder = _Json_map1_fn(removeCreateViewStatement, _Json_decodeField_fn("rows", _Json_decodeIndex_fn(0, _Json_decodeField_fn("sql", $elm$json$Json$Decode$string))));
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("query", $elm$json$Json$Encode$string(query))
            ]))),
            e: A2($author$project$Api$expect, msg, decoder),
            f: "POST",
            g: "/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/sql")
        });
    }, $author$project$Api$queryViewSql = F4($author$project$Api$queryViewSql_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraSplitAt_fn = function (index, xs) {
        var len = $elm$core$Array$length(xs);
        var _v0 = _Utils_Tuple2(index > 0, _Utils_cmp(index, len) < 0);
        if (_v0.a) {
            if (_v0.b) {
                return _Utils_Tuple2($elm$core$Array$slice_fn(0, index, xs), $elm$core$Array$slice_fn(index, len, xs));
            }
            else {
                return _Utils_Tuple2(xs, $elm$core$Array$empty);
            }
        }
        else {
            if (_v0.b) {
                return _Utils_Tuple2($elm$core$Array$empty, xs);
            }
            else {
                return _Utils_Tuple2($elm$core$Array$empty, $elm$core$Array$empty);
            }
        }
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraSplitAt = F2($basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraSplitAt_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraRemoveAt_fn = function (index, xs) {
        var _v0 = $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraSplitAt_fn(index, xs);
        var xs0 = _v0.a;
        var xs1 = _v0.b;
        var len1 = $elm$core$Array$length(xs1);
        return (!len1) ? xs0 : $elm$core$Array$append_fn(xs0, $elm$core$Array$slice_fn(1, len1, xs1));
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraRemoveAt = F2($basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraRemoveAt_fn);
    var $elm$core$Array$isEmpty = function (_v0) {
        var len = _v0.a;
        return !len;
    };
    var $basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndexAndReport_fn = function (selected, nea) {
        var _v0 = nea;
        var first = _v0.a;
        var oldSelected = _v0.b;
        var rest = _v0.c;
        return ((selected >= 0) && (_Utils_cmp(selected, $basti1302$elm_non_empty_array$Array$NonEmpty$length(nea)) < 0)) ? _Utils_Tuple2($basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, selected, rest), !_Utils_eq(selected, oldSelected)) : _Utils_Tuple2($basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, oldSelected, rest), false);
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndexAndReport = F2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndexAndReport_fn);
    var $basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex = function (selected) {
        return A2($elm$core$Basics$composeR, $basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndexAndReport(selected), $elm$core$Tuple$first);
    };
    var $basti1302$elm_non_empty_array$Array$NonEmpty$removeAt_fn = function (index, nea) {
        if ((index < 0) || (_Utils_cmp(index, $basti1302$elm_non_empty_array$Array$NonEmpty$length(nea)) > 0)) {
            return $elm$core$Maybe$Just(nea);
        }
        else {
            var _v0 = nea;
            var first = _v0.a;
            var selected = _v0.b;
            var rest = _v0.c;
            var _v1 = _Utils_Tuple2(index, $elm$core$Array$isEmpty(rest));
            if (!_v1.a) {
                if (_v1.b) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    return $elm$core$Maybe$map_fn($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex(selected - 1), $basti1302$elm_non_empty_array$Array$NonEmpty$fromArray(rest));
                }
            }
            else {
                var otherwise = _v1;
                var updatedSelectedIndex = function () {
                    var _v2 = _Utils_compare_fn(index, selected);
                    switch (_v2) {
                        case 1:
                            return $elm$core$Basics$max_fn(selected - 1, 0);
                        case 0:
                            return selected - 1;
                        default:
                            return selected;
                    }
                }();
                var updatedRest = $basti1302$elm_non_empty_array$Array$NonEmpty$arrayExtraRemoveAt_fn(index - 1, rest);
                return $elm$core$Maybe$Just($basti1302$elm_non_empty_array$Array$NonEmpty$NEA_fn(first, updatedSelectedIndex, updatedRest));
            }
        }
    }, $basti1302$elm_non_empty_array$Array$NonEmpty$removeAt = F2($basti1302$elm_non_empty_array$Array$NonEmpty$removeAt_fn);
    var $author$project$Pages$Queries$QueryTab$setAiEditor_fn = function (aiEditor, tab) {
        return _Utils_update(tab, { dC: aiEditor });
    }, $author$project$Pages$Queries$QueryTab$setAiEditor = F2($author$project$Pages$Queries$QueryTab$setAiEditor_fn);
    var $author$project$Pages$Queries$QueryTab$setResultErrors_fn = function (errors, tab) {
        return _Utils_update(tab, {
            oV: $author$project$Api$Response$Failure(errors)
        });
    }, $author$project$Pages$Queries$QueryTab$setResultErrors = F2($author$project$Pages$Queries$QueryTab$setResultErrors_fn);
    var $author$project$Pages$Queries$QueryTab$setStatus_fn = function (status, tab) {
        return _Utils_update(tab, {
            oV: $author$project$Api$Response$Success(status)
        });
    }, $author$project$Pages$Queries$QueryTab$setStatus = F2($author$project$Pages$Queries$QueryTab$setStatus_fn);
    var $author$project$Pages$Queries$setCurrentTabResult_fn = function (sqlResult, status, model) {
        return _Utils_update(model, {
            n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn(function () {
                if ($elm$core$List$isEmpty(sqlResult.ml)) {
                    var queryReturnedRows = A2($elm$core$Basics$composeR, function ($) {
                        return $.hT;
                    }, A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
                    return queryReturnedRows(sqlResult) ? $author$project$Pages$Queries$QueryTab$setStatus("") : $author$project$Pages$Queries$QueryTab$setStatus(status);
                }
                else {
                    return $author$project$Pages$Queries$QueryTab$setResultErrors(sqlResult.ml);
                }
            }(), model.n)
        });
    }, $author$project$Pages$Queries$setCurrentTabResult = F3($author$project$Pages$Queries$setCurrentTabResult_fn);
    var $author$project$Pages$Queries$QueryTab$setResultTableOptions_fn = function (resultTableOptions, tab) {
        return _Utils_update(tab, { kI: resultTableOptions });
    }, $author$project$Pages$Queries$QueryTab$setResultTableOptions = F2($author$project$Pages$Queries$QueryTab$setResultTableOptions_fn);
    var $PaackEng$paack_remotedata$Remote$Recyclable$Ready = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Queries$QueryTab$setSqlResult_fn = function (sqlResult, tab) {
        return _Utils_update(tab, {
            a2: $PaackEng$paack_remotedata$Remote$Recyclable$Ready(sqlResult)
        });
    }, $author$project$Pages$Queries$QueryTab$setSqlResult = F2($author$project$Pages$Queries$QueryTab$setSqlResult_fn);
    var $PaackEng$paack_remotedata$Remote$Errors$Custom = function (a) {
        return { $: 0, a: a };
    };
    var $PaackEng$paack_remotedata$Remote$Recyclable$Failure = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Queries$QueryTab$setSqlResultErrors_fn = function (errors, tab) {
        return _Utils_update(tab, {
            a2: $PaackEng$paack_remotedata$Remote$Recyclable$Failure($PaackEng$paack_remotedata$Remote$Errors$Custom(errors))
        });
    }, $author$project$Pages$Queries$QueryTab$setSqlResultErrors = F2($author$project$Pages$Queries$QueryTab$setSqlResultErrors_fn);
    var $PaackEng$paack_remotedata$Remote$Recyclable$Loading = { $: 1 };
    var $PaackEng$paack_remotedata$Remote$Recyclable$LoadingStage = { $: 0 };
    var $PaackEng$paack_remotedata$Remote$Recyclable$Recycling_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $PaackEng$paack_remotedata$Remote$Recyclable$Recycling = F2($PaackEng$paack_remotedata$Remote$Recyclable$Recycling_fn);
    var $PaackEng$paack_remotedata$Remote$Recyclable$toLoading = function (data) {
        switch (data.$) {
            case 0:
                return $PaackEng$paack_remotedata$Remote$Recyclable$Loading;
            case 1:
                return $PaackEng$paack_remotedata$Remote$Recyclable$Loading;
            case 2:
                return $PaackEng$paack_remotedata$Remote$Recyclable$Loading;
            case 4:
                var object = data.a;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Recycling_fn(object, $PaackEng$paack_remotedata$Remote$Recyclable$LoadingStage);
            default:
                var object = data.a;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Recycling_fn(object, $PaackEng$paack_remotedata$Remote$Recyclable$LoadingStage);
        }
    };
    var $author$project$Pages$Queries$QueryTab$setSqlResultLoading = function (tab) {
        return _Utils_update(tab, {
            a2: $PaackEng$paack_remotedata$Remote$Recyclable$toLoading(tab.a2)
        });
    };
    var $author$project$Pages$Queries$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Pages$Queries$setUpdating = F2($author$project$Pages$Queries$setUpdating_fn);
    var $author$project$Pages$Queries$QueryTab$setViewToOverwrite_fn = function (viewToOverwrite, tab) {
        return _Utils_update(tab, {
            dt: $elm$core$Maybe$Just(viewToOverwrite)
        });
    }, $author$project$Pages$Queries$QueryTab$setViewToOverwrite = F2($author$project$Pages$Queries$QueryTab$setViewToOverwrite_fn);
    var $author$project$Pages$Queries$update_fn = function (onError, onTablesAffected, maybeDbId, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                return _Utils_Tuple2(_Utils_update(model, { cm: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$none);
            case 2:
                var subMsg = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    eG: $author$project$Components$TableSchema$update_fn(subMsg, model.eG)
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var subMsg = msg.a;
                var _v1 = $author$project$Components$AiEditor$update_fn(subMsg, $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n).dC);
                var aiEditorState = _v1.a;
                var aiEditorCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setAiEditor(aiEditorState), model.n)
                }), _Platform_map_fn(toMsg, aiEditorCmd));
            case 4:
                var toMsg_ = msg.a;
                var prompt = msg.b;
                var generateQueryCmd = function () {
                    if (maybeDbId.$ === 1) {
                        return $elm$core$Platform$Cmd$none;
                    }
                    else {
                        var dbId = maybeDbId.a;
                        return $author$project$Api$generateQuery_fn(A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Queries$AiEditorMsgReceived, toMsg)), shared.k2, dbId, prompt);
                    }
                }();
                return _Utils_Tuple2(model, generateQueryCmd);
            case 5:
                var toMsg_ = msg.a;
                var query = msg.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setStatus("")), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResultLoading), _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (dbId) {
                    return $author$project$Api$executeQuery_fn(A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Queries$AiEditorMsgReceived, toMsg)), shared.k2, dbId, query);
                }, maybeDbId))));
            case 6:
                var sqlResult = msg.a;
                return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "\n                    The SQL query was successfully executed!\n\n                    It did not return any results.\n                    "), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResult(sqlResult)), _Utils_Tuple2(model, onTablesAffected(sqlResult.lr))));
            case 7:
                var errors = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResultErrors(errors)), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Nothing, errors))));
            case 8:
                var subMsg = msg.a;
                var _v3 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Queries$createViewNameRequester_fn(maybeDbId, shared, model), model.cm));
                var inputRequester = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd));
            case 9:
                var sqlResult = msg.a;
                var name = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                    return $.h7;
                }, model.cm);
                return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "View \"" + (name + "\" successfully created!")), _Utils_Tuple2(model, onTablesAffected(_List_fromArray([name]))));
            case 10:
                var errors = msg.a;
                var errors_ = function () {
                    var name = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                        return $.h7;
                    }, model.cm);
                    return $elm$core$List$map_fn($elm$core$String$append("Failed to create view \"" + (name + "\": ")), errors);
                }();
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors_)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 11:
                var subMsg = msg.a;
                switch (subMsg.$) {
                    case 0:
                        var dbId = subMsg.a;
                        var table = subMsg.b;
                        return _Utils_Tuple2(model, $author$project$Api$queryViewSql_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Queries$EditView), $author$project$Pages$Queries$GotSchema(table)), shared.k2, dbId, table));
                    case 1:
                        if (subMsg.b.$ === 1) {
                            var errors = subMsg.b.a;
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Nothing, errors)));
                        }
                        else {
                            var table = subMsg.a;
                            var schema = subMsg.b.a;
                            var idxEditorWithSchema = $elm$core$Maybe$map_fn($elm$core$Basics$add(1), $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, A2($elm$core$Basics$composeR, function ($) {
                                return $.dC;
                            }, A2($elm$core$Basics$composeR, function ($) {
                                return $.gO;
                            }, A2($elm$core$Basics$composeR, function ($) {
                                return $.gB;
                            }, $elm$core$Basics$eq(schema)))), $elm$core$List$drop_fn(1, $basti1302$elm_non_empty_array$Array$NonEmpty$toList(model.n))));
                            return _Utils_Tuple2(_Utils_update(model, {
                                n: function () {
                                    if (!idxEditorWithSchema.$) {
                                        var idx = idxEditorWithSchema.a;
                                        return $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setViewToOverwrite(table.M), A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, idx, model.n));
                                    }
                                    else {
                                        return A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, $basti1302$elm_non_empty_array$Array$NonEmpty$length(model.n), $basti1302$elm_non_empty_array$Array$NonEmpty$push_fn($author$project$Pages$Queries$QueryTab$init_fn($elm$core$Maybe$Just(table.M), $author$project$Pages$Queries$initAiEditor($elm$core$Maybe$Just(schema))), model.n));
                                    }
                                }()
                            }), $elm$core$Platform$Cmd$none);
                        }
                    case 2:
                        var targetView = subMsg.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setViewToOverwrite(targetView), model.n)
                        }), $elm$core$Platform$Cmd$none);
                    case 3:
                        var dbId = subMsg.a;
                        var targetView = subMsg.b;
                        return _Utils_Tuple2(_Utils_update(model, { la: true }), $author$project$Api$deleteTable_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Queries$EditView), A2($author$project$Pages$Queries$DeletedTargetView, dbId, targetView)), shared.k2, targetView, dbId));
                    case 4:
                        var dbId = subMsg.a;
                        var targetView = subMsg.b;
                        var response = subMsg.c;
                        if (!response.$) {
                            return _Utils_Tuple2(model, $author$project$Api$executeQuery_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Queries$EditViewResponded(targetView.M), A2($elm$core$Basics$composeR, $author$project$Pages$Queries$EditView, toMsg)), shared.k2, dbId, _String_append_fn("CREATE VIEW " + ($author$project$Pages$Queries$quoteSqlKeyword(targetView.M) + " AS "), $elm$core$Basics$composeR_fn($author$project$Pages$Queries$QueryTab$toQuery_a0, $author$project$Pages$Queries$QueryTab$toQuery_a1, $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n)))));
                        }
                        else {
                            var errors = response.a;
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), _Utils_Tuple2(_Utils_update(model, { la: false }), A2(onError, $elm$core$Maybe$Nothing, errors)));
                        }
                    default:
                        if (!subMsg.b.$) {
                            var name = subMsg.a;
                            var sqlResult = subMsg.b.a;
                            return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "View \"" + (name + "\" successfully overwritten!")), $author$project$Util$withModel_fn($author$project$Pages$Queries$setUpdating(false), _Utils_Tuple2(model, onTablesAffected(_List_fromArray([name])))));
                        }
                        else {
                            var name = subMsg.a;
                            var errors = subMsg.b.a;
                            var errors_ = $elm$core$List$map_fn($elm$core$String$append("Failed to overwrite view \"" + (name + "\": ")), errors);
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors_)), $author$project$Util$withModel_fn($author$project$Pages$Queries$setUpdating(false), _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Nothing, errors))));
                        }
                }
            case 12:
                var idx = msg.a;
                return _Utils_eq(idx, $basti1302$elm_non_empty_array$Array$NonEmpty$selectedIndex(model.n)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, {
                    n: A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, idx, model.n)
                }), $elm$core$Platform$Cmd$none);
            case 13:
                return _Utils_Tuple2(_Utils_update(model, {
                    n: A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, $basti1302$elm_non_empty_array$Array$NonEmpty$length(model.n), $basti1302$elm_non_empty_array$Array$NonEmpty$push_fn($author$project$Pages$Queries$QueryTab$default($author$project$Pages$Queries$initAiEditor($elm$core$Maybe$Nothing)), model.n))
                }), $elm$core$Platform$Cmd$none);
            case 14:
                var idx = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    n: $elm$core$Maybe$withDefault_fn(model.n, $basti1302$elm_non_empty_array$Array$NonEmpty$removeAt_fn(idx, model.n))
                }), $elm$core$Platform$Cmd$none);
            case 15:
                var options = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultTableOptions(options)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            default:
                var search = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { ff: search }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Pages$Queries$update_fn_unwrapped = function (onError, onTablesAffected, maybeDbId, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                return _Utils_Tuple2(_Utils_update(model, { cm: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$none);
            case 2:
                var subMsg = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    eG: $author$project$Components$TableSchema$update_fn(subMsg, model.eG)
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var subMsg = msg.a;
                var _v1 = $author$project$Components$AiEditor$update_fn(subMsg, $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n).dC);
                var aiEditorState = _v1.a;
                var aiEditorCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setAiEditor(aiEditorState), model.n)
                }), _Platform_map_fn(toMsg, aiEditorCmd));
            case 4:
                var toMsg_ = msg.a;
                var prompt = msg.b;
                var generateQueryCmd = function () {
                    if (maybeDbId.$ === 1) {
                        return $elm$core$Platform$Cmd$none;
                    }
                    else {
                        var dbId = maybeDbId.a;
                        return $author$project$Api$generateQuery_fn(A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Queries$AiEditorMsgReceived, toMsg)), shared.k2, dbId, prompt);
                    }
                }();
                return _Utils_Tuple2(model, generateQueryCmd);
            case 5:
                var toMsg_ = msg.a;
                var query = msg.b;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setStatus("")), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResultLoading), _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (dbId) {
                    return $author$project$Api$executeQuery_fn(A2($elm$core$Basics$composeR, toMsg_, A2($elm$core$Basics$composeR, $author$project$Pages$Queries$AiEditorMsgReceived, toMsg)), shared.k2, dbId, query);
                }, maybeDbId))));
            case 6:
                var sqlResult = msg.a;
                return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "\n                    The SQL query was successfully executed!\n\n                    It did not return any results.\n                    "), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResult(sqlResult)), _Utils_Tuple2(model, onTablesAffected(sqlResult.lr))));
            case 7:
                var errors = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setSqlResultErrors(errors)), _Utils_Tuple2(model, onError($elm$core$Maybe$Nothing, errors))));
            case 8:
                var subMsg = msg.a;
                var _v3 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn($author$project$Pages$Queries$createViewNameRequester_fn(maybeDbId, shared, model), model.cm));
                var inputRequester = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    cm: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(toMsg, cmd));
            case 9:
                var sqlResult = msg.a;
                var name = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                    return $.h7;
                }, model.cm);
                return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "View \"" + (name + "\" successfully created!")), _Utils_Tuple2(model, onTablesAffected(_List_fromArray([name]))));
            case 10:
                var errors = msg.a;
                var errors_ = function () {
                    var name = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                        return $.h7;
                    }, model.cm);
                    return $elm$core$List$map_fn($elm$core$String$append("Failed to create view \"" + (name + "\": ")), errors);
                }();
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors_)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 11:
                var subMsg = msg.a;
                switch (subMsg.$) {
                    case 0:
                        var dbId = subMsg.a;
                        var table = subMsg.b;
                        return _Utils_Tuple2(model, $author$project$Api$queryViewSql_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Queries$EditView), $author$project$Pages$Queries$GotSchema(table)), shared.k2, dbId, table));
                    case 1:
                        if (subMsg.b.$ === 1) {
                            var errors = subMsg.b.a;
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), _Utils_Tuple2(model, onError($elm$core$Maybe$Nothing, errors)));
                        }
                        else {
                            var table = subMsg.a;
                            var schema = subMsg.b.a;
                            var idxEditorWithSchema = $elm$core$Maybe$map_fn($elm$core$Basics$add(1), $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, A2($elm$core$Basics$composeR, function ($) {
                                return $.dC;
                            }, A2($elm$core$Basics$composeR, function ($) {
                                return $.gO;
                            }, A2($elm$core$Basics$composeR, function ($) {
                                return $.gB;
                            }, $elm$core$Basics$eq(schema)))), $elm$core$List$drop_fn(1, $basti1302$elm_non_empty_array$Array$NonEmpty$toList(model.n))));
                            return _Utils_Tuple2(_Utils_update(model, {
                                n: function () {
                                    if (!idxEditorWithSchema.$) {
                                        var idx = idxEditorWithSchema.a;
                                        return $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setViewToOverwrite(table.M), A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, idx, model.n));
                                    }
                                    else {
                                        return A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, $basti1302$elm_non_empty_array$Array$NonEmpty$length(model.n), $basti1302$elm_non_empty_array$Array$NonEmpty$push_fn($author$project$Pages$Queries$QueryTab$init_fn($elm$core$Maybe$Just(table.M), $author$project$Pages$Queries$initAiEditor($elm$core$Maybe$Just(schema))), model.n));
                                    }
                                }()
                            }), $elm$core$Platform$Cmd$none);
                        }
                    case 2:
                        var targetView = subMsg.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            n: $basti1302$elm_non_empty_array$Array$NonEmpty$updateSelected_fn($author$project$Pages$Queries$QueryTab$setViewToOverwrite(targetView), model.n)
                        }), $elm$core$Platform$Cmd$none);
                    case 3:
                        var dbId = subMsg.a;
                        var targetView = subMsg.b;
                        return _Utils_Tuple2(_Utils_update(model, { la: true }), $author$project$Api$deleteTable_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Queries$EditView), A2($author$project$Pages$Queries$DeletedTargetView, dbId, targetView)), shared.k2, targetView, dbId));
                    case 4:
                        var dbId = subMsg.a;
                        var targetView = subMsg.b;
                        var response = subMsg.c;
                        if (!response.$) {
                            return _Utils_Tuple2(model, $author$project$Api$executeQuery_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Queries$EditViewResponded(targetView.M), A2($elm$core$Basics$composeR, $author$project$Pages$Queries$EditView, toMsg)), shared.k2, dbId, _String_append_fn("CREATE VIEW " + ($author$project$Pages$Queries$quoteSqlKeyword(targetView.M) + " AS "), $elm$core$Basics$composeR_fn($author$project$Pages$Queries$QueryTab$toQuery_a0, $author$project$Pages$Queries$QueryTab$toQuery_a1, $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n)))));
                        }
                        else {
                            var errors = response.a;
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors)), _Utils_Tuple2(_Utils_update(model, { la: false }), onError($elm$core$Maybe$Nothing, errors)));
                        }
                    default:
                        if (!subMsg.b.$) {
                            var name = subMsg.a;
                            var sqlResult = subMsg.b.a;
                            return $author$project$Util$withModel_fn(A2($author$project$Pages$Queries$setCurrentTabResult, sqlResult, "View \"" + (name + "\" successfully overwritten!")), $author$project$Util$withModel_fn($author$project$Pages$Queries$setUpdating(false), _Utils_Tuple2(model, onTablesAffected(_List_fromArray([name])))));
                        }
                        else {
                            var name = subMsg.a;
                            var errors = subMsg.b.a;
                            var errors_ = $elm$core$List$map_fn($elm$core$String$append("Failed to overwrite view \"" + (name + "\": ")), errors);
                            return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultErrors(errors_)), $author$project$Util$withModel_fn($author$project$Pages$Queries$setUpdating(false), _Utils_Tuple2(model, onError($elm$core$Maybe$Nothing, errors))));
                        }
                }
            case 12:
                var idx = msg.a;
                return _Utils_eq(idx, $basti1302$elm_non_empty_array$Array$NonEmpty$selectedIndex(model.n)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, {
                    n: A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, idx, model.n)
                }), $elm$core$Platform$Cmd$none);
            case 13:
                return _Utils_Tuple2(_Utils_update(model, {
                    n: A2($basti1302$elm_non_empty_array$Array$NonEmpty$setSelectedIndex, $basti1302$elm_non_empty_array$Array$NonEmpty$length(model.n), $basti1302$elm_non_empty_array$Array$NonEmpty$push_fn($author$project$Pages$Queries$QueryTab$default($author$project$Pages$Queries$initAiEditor($elm$core$Maybe$Nothing)), model.n))
                }), $elm$core$Platform$Cmd$none);
            case 14:
                var idx = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    n: $elm$core$Maybe$withDefault_fn(model.n, $basti1302$elm_non_empty_array$Array$NonEmpty$removeAt_fn(idx, model.n))
                }), $elm$core$Platform$Cmd$none);
            case 15:
                var options = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Queries$mapCurrentTab($author$project$Pages$Queries$QueryTab$setResultTableOptions(options)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            default:
                var search = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { ff: search }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Pages$Queries$update = F7($author$project$Pages$Queries$update_fn);
    var $author$project$Pages$Settings$EnvEditorOverlayMsg = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Pages$Settings$Navigated = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Settings$SettingsEditModified = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Pages$Settings$SettingsLoaded = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Settings$SettingsUpdated = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Dialog$SuccessMessage = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Settings$VacuumDatabaseResponded = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Api$getDatabaseSettings_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$DatabaseSettings$decoder),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/settings")
        });
    }, $author$project$Api$getDatabaseSettings = F3($author$project$Api$getDatabaseSettings_fn);
    var $author$project$Types$DatabaseSettings$maybeSetEnvVars_fn = function (maybeSettings, envVars) {
        return $elm$core$Maybe$map_fn(function (settings) {
            return _Utils_update(settings, { gQ: envVars });
        }, maybeSettings);
    }, $author$project$Types$DatabaseSettings$maybeSetEnvVars = F2($author$project$Types$DatabaseSettings$maybeSetEnvVars_fn);
    var $author$project$Pages$Settings$setActiveRoute_fn = function (maybeSubRoute, model) {
        return _Utils_update(model, { dx: maybeSubRoute });
    }, $author$project$Pages$Settings$setActiveRoute = F2($author$project$Pages$Settings$setActiveRoute_fn);
    var $author$project$Route$setSettingsRoute_fn = function (settingsRoute, route) {
        if (route.$ === 25) {
            var dbId = route.a;
            return $elm$core$Maybe$Just($author$project$Route$Settings_fn(dbId, $elm$core$Maybe$Just(settingsRoute)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$setSettingsRoute = F2($author$project$Route$setSettingsRoute_fn);
    var $author$project$Api$vacuumDatabase_fn = function (msg, maybeToken, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/vacuum")
        });
    }, $author$project$Api$vacuumDatabase = F3($author$project$Api$vacuumDatabase_fn);
    var $author$project$Pages$Settings$update_fn = function (onError, setDialog, updateDatabaseSettingsState, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var route = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setSettingsRoute_fn(route, shared.eu)));
            case 1:
                var dbId = msg.a;
                var maybeSubRoute = msg.b;
                var qualifiedRoute = _Utils_eq(maybeSubRoute, $elm$core$Maybe$Just(0)) || (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) || _Utils_eq(maybeSubRoute, $elm$core$Maybe$Just(2)));
                return $author$project$Util$withModel_fn($author$project$Pages$Settings$setActiveRoute(maybeSubRoute), (qualifiedRoute && $krisajenkins$remotedata$RemoteData$isNotAsked(model.kR)) ? _Utils_Tuple2(_Utils_update(model, { kR: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getDatabaseSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Settings$SettingsLoaded), shared.k2, dbId)) : (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $author$project$Util$restoreActiveRoute({
                    dx: model.dx,
                    lo: $elm$core$Basics$always(_List_Nil),
                    ma: $elm$core$Maybe$Just(0),
                    ol: A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$setSettingsRoute, shared.eu), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteTo, toSharedCmd))),
                    ou: A2($elm$core$Basics$composeR, $author$project$Pages$Settings$Navigated, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))
                })) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 2:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        aL: $elm$core$Maybe$Just(settings)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), A2(onError, $elm$core$Maybe$Nothing, errors));
                }
            case 3:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        eT: _List_Nil
                    }), updateDatabaseSettingsState(settings));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { eT: errors }), A2(onError, $elm$core$Maybe$Nothing, errors));
                }
            case 4:
                var settingsEdit = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { aL: settingsEdit }), $elm$core$Platform$Cmd$none);
            case 5:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$setDatabaseSettings, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Settings$SettingsUpdated), shared.k2, dbId), model.aL));
            case 6:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $author$project$Api$vacuumDatabase_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Settings$VacuumDatabaseResponded, toMsg), shared.k2, dbId));
            case 7:
                var response = msg.a;
                if (!response.$) {
                    var successDialog = $author$project$Dialog$SuccessMessage({ no: "Database vacuumed successfully.", eM: "Database Vacuumed" });
                    return _Utils_Tuple2(model, setDialog($elm$core$Maybe$Just(successDialog)));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Nothing, errors));
                }
            case 8:
                var maybeEnvVar = msg.a;
                var overlay = function () {
                    var envVarsWithoutSelected = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$neq(maybeEnvVar)), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                        return $.gQ;
                    }, model.aL));
                    var isUniqueByNameValue = function (envVar) {
                        return $elm_community$maybe_extra$Maybe$Extra$isNothing($elm_community$list_extra$List$Extra$find_fn(function (_v3) {
                            var name = _v3.M;
                            var value = _v3.pB;
                            return _Utils_eq(name, envVar.M) && _Utils_eq(value, envVar.pB);
                        }, envVarsWithoutSelected));
                    };
                    return $author$project$Components$EditorTitledOverlay$init({
                        gB: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.pB;
                        }, maybeEnvVar),
                        fi: "value",
                        fx: "Set Environment Variable",
                        bC: F2(function (state, _v2) {
                            return $elm$core$Platform$Cmd$batch($elm$core$List$append_fn(_List_fromArray([
                                $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Closed))
                            ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $elm$core$List$append(envVarsWithoutSelected), A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetEnvVars(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, $author$project$Util$msgCmd)))), $elm_community$maybe_extra$Maybe$Extra$filter_fn(isUniqueByNameValue, $elm$core$Maybe$Just($author$project$Types$EnvironmentVariable$EnvironmentVariable_fn("", state.eM, state.gB)))))));
                        }),
                        nT: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        fM: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        eM: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.M;
                        }, maybeEnvVar),
                        gc: "key",
                        gd: $author$project$Pages$Settings$EnvEditorOverlayMsg
                    });
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    cZ: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Opened))));
            default:
                var subMsg = msg.a;
                var _v4 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond($elm$core$Platform$Cmd$map(toMsg)), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$EditorTitledOverlay$update(subMsg), model.cZ))));
                var overlay = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, { cZ: overlay }), cmd);
        }
    }, $author$project$Pages$Settings$update_fn_unwrapped = function (onError, setDialog, updateDatabaseSettingsState, toSharedCmd, toMsg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var route = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setSettingsRoute_fn(route, shared.eu)));
            case 1:
                var dbId = msg.a;
                var maybeSubRoute = msg.b;
                var qualifiedRoute = _Utils_eq(maybeSubRoute, $elm$core$Maybe$Just(0)) || (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) || _Utils_eq(maybeSubRoute, $elm$core$Maybe$Just(2)));
                return $author$project$Util$withModel_fn($author$project$Pages$Settings$setActiveRoute(maybeSubRoute), (qualifiedRoute && $krisajenkins$remotedata$RemoteData$isNotAsked(model.kR)) ? _Utils_Tuple2(_Utils_update(model, { kR: $krisajenkins$remotedata$RemoteData$Loading }), $author$project$Api$getDatabaseSettings_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Settings$SettingsLoaded), shared.k2, dbId)) : (_Utils_eq(maybeSubRoute, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $author$project$Util$restoreActiveRoute({
                    dx: model.dx,
                    lo: $elm$core$Basics$always(_List_Nil),
                    ma: $elm$core$Maybe$Just(0),
                    ol: A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Route$setSettingsRoute, shared.eu), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteTo, toSharedCmd))),
                    ou: A2($elm$core$Basics$composeR, $author$project$Pages$Settings$Navigated, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd))
                })) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 2:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        aL: $elm$core$Maybe$Just(settings)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), onError($elm$core$Maybe$Nothing, errors));
                }
            case 3:
                if (!msg.a.$) {
                    var settings = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        kR: $krisajenkins$remotedata$RemoteData$Success(settings),
                        eT: _List_Nil
                    }), updateDatabaseSettingsState(settings));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { eT: errors }), onError($elm$core$Maybe$Nothing, errors));
                }
            case 4:
                var settingsEdit = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { aL: settingsEdit }), $elm$core$Platform$Cmd$none);
            case 5:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$setDatabaseSettings, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Settings$SettingsUpdated), shared.k2, dbId), model.aL));
            case 6:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $author$project$Api$vacuumDatabase_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Settings$VacuumDatabaseResponded, toMsg), shared.k2, dbId));
            case 7:
                var response = msg.a;
                if (!response.$) {
                    var successDialog = $author$project$Dialog$SuccessMessage({ no: "Database vacuumed successfully.", eM: "Database Vacuumed" });
                    return _Utils_Tuple2(model, setDialog($elm$core$Maybe$Just(successDialog)));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(model, onError($elm$core$Maybe$Nothing, errors));
                }
            case 8:
                var maybeEnvVar = msg.a;
                var overlay = function () {
                    var envVarsWithoutSelected = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$neq(maybeEnvVar)), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                        return $.gQ;
                    }, model.aL));
                    var isUniqueByNameValue = function (envVar) {
                        return $elm_community$maybe_extra$Maybe$Extra$isNothing($elm_community$list_extra$List$Extra$find_fn(function (_v3) {
                            var name = _v3.M;
                            var value = _v3.pB;
                            return _Utils_eq(name, envVar.M) && _Utils_eq(value, envVar.pB);
                        }, envVarsWithoutSelected));
                    };
                    return $author$project$Components$EditorTitledOverlay$init({
                        gB: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.pB;
                        }, maybeEnvVar),
                        fi: "value",
                        fx: "Set Environment Variable",
                        bC: F2(function (state, _v2) {
                            return $elm$core$Platform$Cmd$batch($elm$core$List$append_fn(_List_fromArray([
                                $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Closed))
                            ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $elm$core$List$append(envVarsWithoutSelected), A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetEnvVars(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, $author$project$Util$msgCmd)))), $elm_community$maybe_extra$Maybe$Extra$filter_fn(isUniqueByNameValue, $elm$core$Maybe$Just($author$project$Types$EnvironmentVariable$EnvironmentVariable_fn("", state.eM, state.gB)))))));
                        }),
                        nT: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        fM: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
                        eM: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                            return $.M;
                        }, maybeEnvVar),
                        gc: "key",
                        gd: $author$project$Pages$Settings$EnvEditorOverlayMsg
                    });
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    cZ: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Settings$EnvEditorOverlayMsg($author$project$Components$EditorTitledOverlay$Opened))));
            default:
                var subMsg = msg.a;
                var _v4 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond($elm$core$Platform$Cmd$map(toMsg)), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$EditorTitledOverlay$update(subMsg), model.cZ))));
                var overlay = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, { cZ: overlay }), cmd);
        }
    }, $author$project$Pages$Settings$update = F8($author$project$Pages$Settings$update_fn);
    var $author$project$Pages$Signup$SignedUp = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Api$signUp_fn = function (msg, maybeToken, username, email, password) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("username", $elm$json$Json$Encode$string(username)),
                _Utils_Tuple2("email_address", $elm$json$Json$Encode$string(email)),
                _Utils_Tuple2("password", $elm$json$Json$Encode$string(password))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "POST",
            g: "/api/users"
        });
    }, $author$project$Api$signUp = F5($author$project$Api$signUp_fn);
    var $author$project$Pages$Signup$update_fn = function (msg, shared, model) {
        switch (msg.$) {
            case 0:
                var formMsg = msg.a;
                var _v1 = $dillonkearns$elm_form$Form$update_fn(formMsg, model.d6);
                var formState = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, { d6: formState }), cmd);
            case 1:
                var parsed = msg.a;
                if (!parsed.$) {
                    var username = parsed.a.lb;
                    var email = parsed.a.jb;
                    var password = parsed.a.kr;
                    return _Utils_Tuple2(_Utils_update(model, { dh: _List_Nil, cC: true }), $author$project$Api$signUp_fn($author$project$Pages$Signup$SignedUp, shared.k2, username, email, password));
                }
                else {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            default:
                if (!msg.a.$) {
                    return _Utils_Tuple2(_Utils_update(model, { ew: true, cC: false }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { dh: errors, cC: false }), $elm$core$Platform$Cmd$none);
                }
        }
    }, $author$project$Pages$Signup$update = F3($author$project$Pages$Signup$update_fn);
    var $author$project$Pages$Tables$BackupViewport_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Pages$Tables$BackupViewport = F2($author$project$Pages$Tables$BackupViewport_fn);
    var $author$project$Pages$Tables$BackupViewportResulted_fn = function (a, b, c) {
        return { $: 10, a: a, b: b, c: c };
    }, $author$project$Pages$Tables$BackupViewportResulted = F3($author$project$Pages$Tables$BackupViewportResulted_fn);
    var $author$project$Dialog$ConfirmDialog_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $author$project$Dialog$ConfirmDialog = F3($author$project$Dialog$ConfirmDialog_fn);
    var $author$project$Pages$Tables$DataReceived_fn = function (a, b, c) {
        return { $: 8, a: a, b: b, c: c };
    }, $author$project$Pages$Tables$DataReceived = F3($author$project$Pages$Tables$DataReceived_fn);
    var $author$project$Pages$Tables$DescriptionEditorMsg = function (a) {
        return { $: 30, a: a };
    };
    var $author$project$Pages$Tables$ExportTable_fn = function (a, b) {
        return { $: 28, a: a, b: b };
    }, $author$project$Pages$Tables$ExportTable = F2($author$project$Pages$Tables$ExportTable_fn);
    var $author$project$Pages$Tables$GridTabChanged = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Pages$Tables$GridTabDragResponded_fn = function (a, b) {
        return { $: 27, a: a, b: b };
    }, $author$project$Pages$Tables$GridTabDragResponded = F2($author$project$Pages$Tables$GridTabDragResponded_fn);
    var $author$project$Pages$Tables$NoOp = { $: 0 };
    var $author$project$Pages$Tables$ShowErrors = function (a) {
        return { $: 34, a: a };
    };
    var $author$project$Components$ConfirmDialog$TableContext_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Components$ConfirmDialog$TableContext = F2($author$project$Components$ConfirmDialog$TableContext_fn);
    var $author$project$Pages$Tables$TableDeleteRequested = function (a) {
        return { $: 21, a: a };
    };
    var $author$project$Pages$Tables$TableDeleteResponded_fn = function (a, b) {
        return { $: 22, a: a, b: b };
    }, $author$project$Pages$Tables$TableDeleteResponded = F2($author$project$Pages$Tables$TableDeleteResponded_fn);
    var $author$project$Pages$Tables$TableNameEditResponded = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Pages$Tables$TableUpdated = function (a) {
        return { $: 33, a: a };
    };
    var $author$project$Pages$Tables$ViewCodeLineCountResponded_fn = function (a, b) {
        return { $: 23, a: a, b: b };
    }, $author$project$Pages$Tables$ViewCodeLineCountResponded = F2($author$project$Pages$Tables$ViewCodeLineCountResponded_fn);
    var $author$project$Pages$Tables$TableEditApplied = { $: 15 };
    var $author$project$Pages$Tables$TableEditCanceled = { $: 14 };
    var $author$project$Pages$Tables$TableEditUpdated = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Types$TableEdit$setName_fn = function (tableEdit, name) {
        return _Utils_update(tableEdit, { M: name });
    }, $author$project$Types$TableEdit$setName = F2($author$project$Types$TableEdit$setName_fn);
    var $author$project$Pages$Tables$addTableOverlay = function (_v0) {
        var updating = _v0.la;
        var tableEdit = _v0.bm;
        return $author$project$Components$inputRequester({
            ln: "Add",
            bC: $author$project$Pages$Tables$TableEditApplied,
            ek: $author$project$Pages$Tables$TableEditCanceled,
            fN: $author$project$Pages$Tables$TableEditUpdated,
            kt: $elm$core$Maybe$Nothing,
            df: "Table Name",
            hX: $author$project$Types$TableEdit$setName(tableEdit),
            h7: tableEdit.M,
            la: updating
        });
    };
    var $author$project$Route$changeRowId_fn = function (rowId, route) {
        switch (route.$) {
            case 17:
                var dbId = route.a;
                var table = route.b;
                var maybeCurrentRowId = route.c;
                var maybeCol = route.d;
                return _Utils_eq(maybeCurrentRowId, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(route) : $elm$core$Maybe$Just($author$project$Route$Tables_fn(dbId, table, $elm$core$Maybe$Just(rowId), maybeCol));
            case 18:
                var dbId = route.a;
                var table = route.b;
                var maybeCurrentRowId = route.c;
                var maybeCol = route.d;
                return _Utils_eq(maybeCurrentRowId, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(route) : $elm$core$Maybe$Just($author$project$Route$Views_fn(dbId, table, $elm$core$Maybe$Just(rowId), maybeCol));
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$changeRowId = F2($author$project$Route$changeRowId_fn);
    var $author$project$Types$TableType$encoder = function (tableType) {
        if (!tableType) {
            return $elm$json$Json$Encode$string("Table");
        }
        else {
            return $elm$json$Json$Encode$string("View");
        }
    };
    var $author$project$Types$TableEdit$encoder = function (tableEdit) {
        var encode = F2(function (tableType, name) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("tableType", $author$project$Types$TableType$encoder(tableType)),
                _Utils_Tuple2("name", $elm$json$Json$Encode$string(name))
            ]));
        });
        return $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm_community$string_extra$String$Extra$nonEmpty($elm$core$String$trim(tableEdit.M)), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, tableEdit.o8, $elm$core$Maybe$Just(encode)));
    };
    var $author$project$Types$TableEdit$setTableType_fn = function (tableType, tableEdit) {
        return _Utils_update(tableEdit, {
            o8: $elm$core$Maybe$Just(tableType)
        });
    }, $author$project$Types$TableEdit$setTableType = F2($author$project$Types$TableEdit$setTableType_fn);
    var $author$project$Api$createTable_fn = function (msg, maybeToken, tableEdit, dbId) {
        return $elm$core$Maybe$map_fn(function (tableEditEncoded) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: $elm$http$Http$jsonBody(tableEditEncoded),
                e: A2($author$project$Api$expect, msg, $author$project$Types$Table$decoder),
                f: "PUT",
                g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + $elm$url$Url$percentEncode(tableEdit.M)))
            });
        }, $author$project$Types$TableEdit$encoder($author$project$Types$TableEdit$setTableType_fn(0, tableEdit)));
    }, $author$project$Api$createTable = F4($author$project$Api$createTable_fn);
    var $author$project$Types$Table$isView = function (table) {
        return table.o8 === 1;
    };
    var $author$project$Types$Table$filterTables_a0 = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Table$isView), $author$project$Types$Table$filterTables = $elm$core$List$filter($author$project$Types$Table$filterTables_a0);
    var $author$project$Types$Table$filterViews_a0 = $author$project$Types$Table$isView, $author$project$Types$Table$filterViews = $elm$core$List$filter($author$project$Types$Table$filterViews_a0);
    var $author$project$Types$TableEdit$fromTable = function (table) {
        return {
            M: table.M,
            kp: $elm$core$Maybe$Just(table),
            o8: $elm$core$Maybe$Just(table.o8)
        };
    };
    var $author$project$Api$generateTableDescription_fn = function (msg, maybeToken, prompt, table, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("prompt", $elm$json$Json$Encode$string(prompt)),
                _Utils_Tuple2("tableName", $elm$json$Json$Encode$string(table.M))
            ]))),
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("completion", $elm$json$Json$Decode$string)),
            f: "POST",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/prompt/describe-table")
        });
    }, $author$project$Api$generateTableDescription = F5($author$project$Api$generateTableDescription_fn);
    var $author$project$GraphGrid$GetRow = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$GraphGrid$getRowMsg = $author$project$GraphGrid$GetRow;
    var $author$project$Api$getTable_fn = function (msg, maybeToken, name, maybeFilter, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$Table$decoder),
            f: "GET",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + ($elm$url$Url$percentEncode(name) + $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", A2($elm$core$Basics$composeR, function ($) {
                return $.oN;
            }, A2($elm$core$Basics$composeR, $elm$url$Url$percentEncode, $elm$core$String$append("/search/"))), maybeFilter))))
        });
    }, $author$project$Api$getTable = F5($author$project$Api$getTable_fn);
    var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
    var $author$project$Types$Table$hasName_fn = function (tableName, table) {
        return _Utils_eq(table.M, tableName);
    }, $author$project$Types$Table$hasName = F2($author$project$Types$Table$hasName_fn);
    var $author$project$Types$Column$find = function (columnName) {
        return $elm_community$list_extra$List$Extra$find(A2($elm$core$Basics$composeL, $elm$core$Basics$eq(columnName), function ($) {
            return $.jx;
        }));
    };
    var $author$project$Types$Column$getCells_a0 = function ($) {
        return $.y;
    }, $author$project$Types$Column$getCells_a1 = $krisajenkins$remotedata$RemoteData$withDefault(_List_Nil), $author$project$Types$Column$getCells = A2($elm$core$Basics$composeR, $author$project$Types$Column$getCells_a0, $author$project$Types$Column$getCells_a1);
    var $author$project$Types$Column$getIdxRowByIntVal_fn = function (val, column) {
        return $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, A2($elm$core$Basics$composeR, $author$project$Types$Cell$toMaybeString, A2($elm$core$Basics$composeR, $elm$core$Maybe$andThen($elm$core$String$toInt), $elm$core$Basics$eq($elm$core$Maybe$Just(val)))), $elm$core$Basics$composeR_fn($author$project$Types$Column$getCells_a0, $author$project$Types$Column$getCells_a1, column));
    }, $author$project$Types$Column$getIdxRowByIntVal = F2($author$project$Types$Column$getIdxRowByIntVal_fn);
    var $author$project$GraphGrid$findIdxRow_fn = function (model, rowId) {
        return $elm$core$Maybe$andThen_fn($author$project$Types$Column$getIdxRowByIntVal(rowId), A2($author$project$Types$Column$find, model.ab, model.iT));
    }, $author$project$GraphGrid$findIdxRow = F2($author$project$GraphGrid$findIdxRow_fn);
    var $author$project$GraphGrid$hasRow_fn = function (rowId, model) {
        return !_Utils_eq($author$project$GraphGrid$findIdxRow_fn(model, rowId), $elm$core$Maybe$Nothing);
    }, $author$project$GraphGrid$hasRow = F2($author$project$GraphGrid$hasRow_fn);
    var $author$project$Types$TableFilter$empty = { oN: "" };
    var $author$project$Components$Toolbar$init = { dw: $elm$core$Maybe$Nothing, dI: false, ba: $author$project$Types$TableFilter$empty };
    var $elm_community$maybe_extra$Maybe$Extra$andThen2_fn = function (func, ma, mb) {
        if (!ma.$) {
            var a = ma.a;
            if (!mb.$) {
                var b = mb.a;
                return A2(func, a, b);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$andThen2_fn_unwrapped = function (func, ma, mb) {
        if (!ma.$) {
            var a = ma.a;
            if (!mb.$) {
                var b = mb.a;
                return func(a, b);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$andThen2 = F3($elm_community$maybe_extra$Maybe$Extra$andThen2_fn);
    var $author$project$Types$Edition$applyBilling_fn = function (billing, edition) {
        if (!edition.$) {
            return $author$project$Types$Edition$Shared(billing);
        }
        else {
            return $author$project$Types$Edition$Dedicated;
        }
    }, $author$project$Types$Edition$applyBilling = F2($author$project$Types$Edition$applyBilling_fn);
    var $author$project$Types$User$findTeam_fn = function (user, teamName) {
        return $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, $elm$core$Basics$eq(teamName)), user.pc);
    }, $author$project$Types$User$findTeam = F2($author$project$Types$User$findTeam_fn);
    var $author$project$EditGrid$ColEditOverlayMsgReceived = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$EditGrid$OverlayMsgReceived = function (a) {
        return { $: 18, a: a };
    };
    var $author$project$Types$ColumnEdit$Creation = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Types$ColumnEdit$empty = function (type_) {
        return { mN: $elm$core$Maybe$Nothing, jL: false, hf: false, M: "", gh: type_, pA: $elm$core$Maybe$Nothing };
    };
    var $author$project$Types$ColumnEdit$emptyCreation = $author$project$Types$ColumnEdit$empty($author$project$Types$ColumnEdit$Creation($elm$core$Maybe$Nothing));
    var $author$project$EditGrid$init = function (cfg) {
        return {
            eZ: cfg.eZ,
            K: _List_Nil,
            e3: $elm$core$Maybe$Nothing,
            a7: $author$project$Types$ColumnEdit$emptyCreation,
            aC: $author$project$Overlay$init_fn($elm$core$Maybe$Just("editgrid"), $author$project$EditGrid$ColEditOverlayMsgReceived),
            bL: $elm$core$Maybe$Nothing,
            fh: cfg.fh,
            T: _List_Nil,
            gT: cfg.gT,
            fH: cfg.fH,
            fI: cfg.fI,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Just("editgrid"), $author$project$EditGrid$OverlayMsgReceived),
            b3: $elm$core$Maybe$Nothing,
            m: cfg.m,
            v: { ix: $elm$core$Maybe$Nothing, bK: $elm$core$Maybe$Nothing, cc: cfg.cc, bc: cfg.bc, hy: cfg.hy, di: _List_Nil, bj: cfg.bj, f3: cfg.f3 },
            la: false
        };
    };
    var $author$project$FocusView$OverlayMsgReceived = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$FocusView$init = {
        bG: $elm$core$Set$empty,
        cX: false,
        T: _List_Nil,
        ft: $elm$core$Maybe$Nothing,
        a$: $author$project$Overlay$init_fn($elm$core$Maybe$Just("focusview_bg"), $author$project$FocusView$OverlayMsgReceived),
        la: false
    };
    var $author$project$Types$TableType$isReadonly = function (tableType) {
        if (!tableType) {
            return false;
        }
        else {
            return true;
        }
    };
    var $author$project$GraphGrid$init = function (cfg) {
        return {
            ad: cfg.ad,
            iT: cfg.iT,
            s: $author$project$EditGrid$init({
                eZ: cfg.eZ,
                cc: cfg.cc,
                fh: cfg.fh,
                gT: cfg.gT,
                bc: $author$project$Types$TableType$isReadonly(cfg.o8),
                fH: cfg.fH,
                fI: false,
                hy: false,
                bj: cfg.bj,
                f3: cfg.f3,
                m: cfg.m
            }),
            aq: $author$project$FocusView$init,
            bT: false,
            cs: cfg.cs,
            ab: cfg.kK,
            eF: cfg.eF,
            ah: cfg.ah,
            o8: cfg.o8,
            bp: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Types$Flags$mapEdition_fn = function (f, flags) {
        return _Utils_update(flags, {
            ja: f(flags.ja)
        });
    }, $author$project$Types$Flags$mapEdition = F2($author$project$Types$Flags$mapEdition_fn);
    var $author$project$Config$mapFlags_fn = function (f, config) {
        return _Utils_update(config, {
            mx: f(config.mx)
        });
    }, $author$project$Config$mapFlags = F2($author$project$Config$mapFlags_fn);
    var $author$project$Types$Edition$toString = function (edition) {
        if (!edition.$) {
            var billing = edition.a;
            if (!billing.$) {
                return "Free";
            }
            else {
                return "Pro";
            }
        }
        else {
            return "Enterprise";
        }
    };
    var $author$project$Pages$Tables$initGrid_fn = function (maybeDatabase, maybeUser, maybeCollapsedColumns, config, schemaLocked, table, apiUrl) {
        return $author$project$GraphGrid$init({
            eZ: true,
            ad: apiUrl,
            cc: $elm$core$Maybe$withDefault_fn($elm$core$Set$empty, maybeCollapsedColumns),
            iT: table.iT,
            fh: config.mx.fh,
            gT: true,
            cs: table.cs,
            fH: config.mx.fH,
            kK: table.kK,
            bj: schemaLocked,
            f3: true,
            m: _List_Nil,
            eF: function () {
                if (!table.cs) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var maybeDatabaseOwner = $elm$core$Maybe$andThen_fn(function ($) {
                        return $.ob;
                    }, maybeDatabase);
                    var maybeTeamForTable = $elm_community$maybe_extra$Maybe$Extra$andThen2_fn($author$project$Types$User$findTeam, maybeUser, maybeDatabaseOwner);
                    var patchedConfig = function () {
                        var _v0 = $elm$core$Maybe$andThen_fn(function ($) {
                            return $.lF;
                        }, maybeTeamForTable);
                        if (!_v0.$) {
                            var billing = _v0.a;
                            return $author$project$Config$init(A3($elm$core$Basics$apL, $author$project$Config$mapFlags, $author$project$Types$Flags$mapEdition($author$project$Types$Edition$applyBilling(billing)), config).mx);
                        }
                        else {
                            return config;
                        }
                    }();
                    return $elm$core$Maybe$Just("Airsequel " + ($author$project$Types$Edition$toString(patchedConfig.mx.ja) + (" does not support displaying more than " + ($elm$core$String$fromInt(patchedConfig.fE) + (" cells." + (" Please use SQL views to extract relevant entries" + " from the table."))))));
                }
            }(),
            ah: table.M,
            o8: table.o8
        });
    }, $author$project$Pages$Tables$initGrid = F7($author$project$Pages$Tables$initGrid_fn);
    var $author$project$Components$Toolbar$isAwaitingResult = function (model) {
        return model.dI;
    };
    var $author$project$Types$Column$isLoaded_a0 = function ($) {
        return $.y;
    }, $author$project$Types$Column$isLoaded_a1 = $krisajenkins$remotedata$RemoteData$isSuccess, $author$project$Types$Column$isLoaded = A2($elm$core$Basics$composeR, $author$project$Types$Column$isLoaded_a0, $author$project$Types$Column$isLoaded_a1);
    var $author$project$Types$Table$isLoaded = function (table) {
        return $elm$core$List$all_fn($author$project$Types$Column$isLoaded, table.iT);
    };
    var $author$project$Types$TableType$isMutable = function (tableType) {
        if (!tableType) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isTablesRoute = function (route) {
        if (route.$ === 17) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Util$Maybe$joinTuple = function (_v0) {
        var a = _v0.a;
        var b = _v0.b;
        return $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, a, b);
    };
    var $author$project$Types$Table$map = function (name) {
        return $elm_community$list_extra$List$Extra$updateIf(A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, $elm$core$Basics$eq(name)));
    };
    var $elm$core$Maybe$map3_fn = function (func, ma, mb, mc) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                if (mc.$ === 1) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var c = mc.a;
                    return $elm$core$Maybe$Just(A3(func, a, b, c));
                }
            }
        }
    }, $elm$core$Maybe$map3_fn_unwrapped = function (func, ma, mb, mc) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                if (mc.$ === 1) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var c = mc.a;
                    return $elm$core$Maybe$Just(func(a, b, c));
                }
            }
        }
    }, $elm$core$Maybe$map3 = F4($elm$core$Maybe$map3_fn);
    var $elm_community$dict_extra$Dict$Extra$mapKeys_fn = function (keyMapper, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, acc) {
            return $elm$core$Dict$insert_fn(keyMapper(k), v, acc);
        }, $elm$core$Dict$empty, dict);
    }, $elm_community$dict_extra$Dict$Extra$mapKeys = F2($elm_community$dict_extra$Dict$Extra$mapKeys_fn);
    var $elm_community$list_extra$List$Extra$getAt_fn = function (idx, xs) {
        return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head($elm$core$List$drop_fn(idx, xs));
    }, $elm_community$list_extra$List$Extra$getAt = F2($elm_community$list_extra$List$Extra$getAt_fn);
    var $elm_community$list_extra$List$Extra$splitAt_fn = function (n, xs) {
        return _Utils_Tuple2($elm$core$List$take_fn(n, xs), $elm$core$List$drop_fn(n, xs));
    }, $elm_community$list_extra$List$Extra$splitAt = F2($elm_community$list_extra$List$Extra$splitAt_fn);
    var $author$project$Util$List$moveIndexes_fn = function (list, idxTo, idxFrom) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(list, function (original) {
            var _v0 = (_Utils_cmp(idxFrom, idxTo) < 0) ? _Utils_Tuple2(idxTo + 1, idxFrom) : _Utils_Tuple2(idxTo, idxFrom + 1);
            var idxToSplitAt = _v0.a;
            var idxToRemove = _v0.b;
            var _v1 = $elm_community$list_extra$List$Extra$splitAt_fn(idxToSplitAt, list);
            var before = _v1.a;
            var after = _v1.b;
            return $elm_community$list_extra$List$Extra$removeAt_fn(idxToRemove, _Utils_ap(before, _List_Cons(original, after)));
        }, $elm_community$list_extra$List$Extra$getAt_fn(idxFrom, list));
    }, $author$project$Util$List$moveIndexes = F3($author$project$Util$List$moveIndexes_fn);
    var $author$project$Api$moveTable_fn = function (msg, maybeToken, tablesOld, tableIdxFrom, tableIdxTo, dbId) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (tableFrom) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: function () {
                    var offset = (_Utils_cmp(tableIdxTo, tableIdxFrom) > 0) ? 0 : (-1);
                    return $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("after", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, A2($elm$core$Basics$composeR, function ($) {
                            return $.M;
                        }, $elm$json$Json$Encode$string), $elm_community$list_extra$List$Extra$getAt_fn(tableIdxTo + offset, tablesOld)))
                    ])));
                }(),
                e: A2($author$project$Api$expect, msg(tablesOld), $elm$json$Json$Decode$succeed(0)),
                f: "PATCH",
                g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + $elm$url$Url$percentEncode(tableFrom.M)))
            });
        }, $elm_community$list_extra$List$Extra$getAt_fn(tableIdxFrom, tablesOld));
    }, $author$project$Api$moveTable = F6($author$project$Api$moveTable_fn);
    var $author$project$Components$Toolbar$setActiveFilter_fn = function (succeeded, model) {
        return succeeded ? _Utils_update(model, {
            dw: $elm$core$Maybe$Just(model.ba)
        }) : model;
    }, $author$project$Components$Toolbar$setActiveFilter = F2($author$project$Components$Toolbar$setActiveFilter_fn);
    var $author$project$Components$Toolbar$setAwaitingResult_fn = function (awaiting, model) {
        return _Utils_update(model, { dI: awaiting });
    }, $author$project$Components$Toolbar$setAwaitingResult = F2($author$project$Components$Toolbar$setAwaitingResult_fn);
    var $author$project$Components$Toolbar$onFilterFailed_a0 = $author$project$Components$Toolbar$setActiveFilter(false), $author$project$Components$Toolbar$onFilterFailed_a1 = $author$project$Components$Toolbar$setAwaitingResult(false), $author$project$Components$Toolbar$onFilterFailed = A2($elm$core$Basics$composeR, $author$project$Components$Toolbar$onFilterFailed_a0, $author$project$Components$Toolbar$onFilterFailed_a1);
    var $author$project$Components$Toolbar$onFilterSucceeded_a0 = $author$project$Components$Toolbar$setActiveFilter(true), $author$project$Components$Toolbar$onFilterSucceeded_a1 = $author$project$Components$Toolbar$setAwaitingResult(false), $author$project$Components$Toolbar$onFilterSucceeded = A2($elm$core$Basics$composeR, $author$project$Components$Toolbar$onFilterSucceeded_a0, $author$project$Components$Toolbar$onFilterSucceeded_a1);
    var $author$project$Api$queryLinesOfCode_fn = function (msg, maybeToken, table, dbId) {
        var query = $elm$core$String$replace_fn("TABLENAME", table.M, "\n            select LENGTH(\"sql\")\n                - LENGTH(REPLACE(\"sql\", X'0A', ''))\n                + 1 as num_of_lines\n            from sqlite_master\n            where name = 'TABLENAME'\n            ");
        var decoder = _Json_decodeField_fn("rows", _Json_decodeIndex_fn(0, _Json_decodeField_fn("num_of_lines", $elm$json$Json$Decode$int)));
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("query", $elm$json$Json$Encode$string(query))
            ]))),
            e: A2($author$project$Api$expect, msg, decoder),
            f: "POST",
            g: "/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/sql")
        });
    }, $author$project$Api$queryLinesOfCode = F4($author$project$Api$queryLinesOfCode_fn);
    var $author$project$Api$renameTable_fn = function (msg, maybeToken, tableEdit, dbId) {
        return $elm$core$Maybe$map2_fn_unwrapped(function (tableEditEncoded, table) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: $elm$http$Http$jsonBody(tableEditEncoded),
                e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
                f: "PATCH",
                g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + $elm$url$Url$percentEncode(table.M)))
            });
        }, $author$project$Types$TableEdit$encoder(tableEdit), tableEdit.kp);
    }, $author$project$Api$renameTable = F4($author$project$Api$renameTable_fn);
    var $author$project$Pages$Tables$saveGridViewport_fn = function (tableName, viewportResult, model) {
        var viewports = $elm$core$Maybe$withDefault_fn(model.b7, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(model.b7), $elm$core$Maybe$map_fn($elm$core$Dict$insert(tableName), $elm$core$Result$toMaybe(viewportResult))));
        return _Utils_update(model, { b7: viewports });
    }, $author$project$Pages$Tables$saveGridViewport = F3($author$project$Pages$Tables$saveGridViewport_fn);
    var $author$project$Types$Table$setColumns_fn = function (tableName, columns) {
        return A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, $elm$core$Basics$eq(tableName)), function (table) {
            return _Utils_update(table, { iT: columns });
        });
    }, $author$project$Types$Table$setColumns = F2($author$project$Types$Table$setColumns_fn);
    var $author$project$Types$Table$setDescription_fn = function (table, description) {
        return _Utils_update(table, { i6: description });
    }, $author$project$Types$Table$setDescription = F2($author$project$Types$Table$setDescription_fn);
    var $author$project$Types$Column$setFailed = function (column) {
        return _Utils_update(column, {
            y: $krisajenkins$remotedata$RemoteData$Failure("")
        });
    };
    var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
    var $author$project$Pages$Tables$setGridViewport_fn = function (toMsg, tableName) {
        return A2($elm$core$Basics$composeR, function ($) {
            return $.b7;
        }, A2($elm$core$Basics$composeR, $elm$core$Dict$get(tableName), A2($elm$core$Basics$composeR, $elm$core$Maybe$map(function ($) {
            return $.lf;
        }), A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault({ g$: 0, ir: 0, pH: 0, pJ: 0 }), function (_v0) {
            var x = _v0.pH;
            var y = _v0.pJ;
            return $elm$core$Task$attempt_fn($elm$core$Basics$always(toMsg($author$project$Pages$Tables$NoOp)), _Browser_setViewportOf_fn("editgrid-content", x, y));
        }))));
    }, $author$project$Pages$Tables$setGridViewport = F2($author$project$Pages$Tables$setGridViewport_fn);
    var $author$project$Types$Column$setLoading = function (column) {
        return _Utils_update(column, { y: $krisajenkins$remotedata$RemoteData$Loading });
    };
    var $author$project$Types$Table$setName_fn = function (tableName, table) {
        return _Utils_update(table, { M: tableName });
    }, $author$project$Types$Table$setName = F2($author$project$Types$Table$setName_fn);
    var $author$project$Route$setTable_fn = function (maybeTable, route) {
        switch (route.$) {
            case 17:
                var dbId = route.a;
                return $elm$core$Maybe$Just($author$project$Route$Tables_fn(dbId, maybeTable, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
            case 18:
                var dbId = route.a;
                return $elm$core$Maybe$Just($author$project$Route$Views_fn(dbId, maybeTable, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$setTable = F2($author$project$Route$setTable_fn);
    var $author$project$Api$setTableDescription_fn = function (msg, maybeToken, table, description, dbId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("description", $elm$json$Json$Encode$string($elm$core$Maybe$withDefault_fn("", description)))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(description)),
            f: "PATCH",
            g: "/api/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + ("/tables/" + $elm$url$Url$percentEncode(table.M)))
        });
    }, $author$project$Api$setTableDescription = F5($author$project$Api$setTableDescription_fn);
    var $author$project$Route$setTablePos_fn = function (maybeRowId, maybeCol, route) {
        switch (route.$) {
            case 17:
                var dbId = route.a;
                var table = route.b;
                return $elm$core$Maybe$Just($author$project$Route$Tables_fn(dbId, table, maybeRowId, maybeCol));
            case 18:
                var dbId = route.a;
                var table = route.b;
                return $elm$core$Maybe$Just($author$project$Route$Views_fn(dbId, table, maybeRowId, maybeCol));
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Route$setTablePos = F3($author$project$Route$setTablePos_fn);
    var $elm$file$File$Download$string_fn = function (name, mime, content) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _File_download_fn(name, mime, content));
    }, $elm$file$File$Download$string = F3($elm$file$File$Download$string_fn);
    var $author$project$Types$Column$cellCount_a0 = function ($) {
        return $.y;
    }, $author$project$Types$Column$cellCount_a1 = A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe, $elm$core$Maybe$map($elm$core$List$length)), $author$project$Types$Column$cellCount = A2($elm$core$Basics$composeR, $author$project$Types$Column$cellCount_a0, $author$project$Types$Column$cellCount_a1);
    var $author$project$Types$Table$countRows = function (table) {
        return $elm$core$Maybe$withDefault_fn(table.ka, $elm$core$Maybe$andThen_fn($author$project$Types$Column$cellCount, $elm$core$List$head(table.iT)));
    };
    var $elm$core$List$sortBy = _List_sortBy;
    var $elm$core$List$sum = function (numbers) {
        return $elm$core$List$foldl_fn($elm$core$Basics$add, 0, numbers);
    };
    var $BrianHicks$elm_csv$Csv$Encode$encodeItems_fn = function (encoder, rows) {
        if (!encoder.$) {
            var convert = encoder.a;
            var _v1 = $elm$core$List$foldr_fn(F2(function (row, _v2) {
                var converted_ = _v2.a;
                var names = _v2.b;
                var convertedRow = convert(row);
                return _Utils_Tuple2(_List_Cons($elm$core$Dict$fromList(convertedRow), converted_), $elm$core$List$foldl_fn_unwrapped(function (_v3, _v4) {
                    var name = _v3.a;
                    var soFar = _v4.a;
                    var column = _v4.b;
                    return _Utils_Tuple2($elm$core$Dict$update_fn(name, function (value) {
                        if (!value.$) {
                            var columns = value.a;
                            return $elm$core$Maybe$Just(_List_Cons(column, columns));
                        }
                        else {
                            return $elm$core$Maybe$Just(_List_fromArray([column]));
                        }
                    }, soFar), column + 1);
                }, _Utils_Tuple2(names, 0), convertedRow).a);
            }), _Utils_Tuple2(_List_Nil, $elm$core$Dict$empty), rows);
            var converted = _v1.a;
            var namePositions = _v1.b;
            var ordering = $elm$core$List$map_fn($elm$core$Tuple$first, _List_sortBy_fn($elm$core$Tuple$second, $elm$core$Dict$toList($elm$core$Dict$map_fn_unwrapped(function (_v6, positions) {
                return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
            }, namePositions))));
            return _List_Cons(ordering, $elm$core$List$map_fn(function (row) {
                return $elm$core$List$map_fn(function (field) {
                    return $elm$core$Maybe$withDefault_fn("", $elm$core$Dict$get_fn(field, row));
                }, ordering);
            }, converted));
        }
        else {
            var convert = encoder.a;
            return $elm$core$List$map_fn(convert, rows);
        }
    }, $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2($BrianHicks$elm_csv$Csv$Encode$encodeItems_fn);
    var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary_fn = function (fieldSeparator, value) {
        return (_String_contains_fn("\"", value) || (_String_contains_fn(fieldSeparator, value) || (_String_contains_fn("\r\n", value) || _String_contains_fn("\n", value)))) ? ("\"" + ($elm$core$String$replace_fn("\"", "\"\"", value) + "\"")) : value;
    }, $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2($BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary_fn);
    var $BrianHicks$elm_csv$Csv$Encode$encode_fn = function (_v0, items) {
        var encoder = _v0.mj;
        var fieldSeparator = _v0.mu;
        var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
        return $elm$core$String$join_fn("\r\n", $elm$core$List$map_fn(A2($elm$core$Basics$composeL, $elm$core$String$join(fieldSeparatorString), $elm$core$List$map($BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))), $BrianHicks$elm_csv$Csv$Encode$encodeItems_fn(encoder, items)));
    }, $BrianHicks$elm_csv$Csv$Encode$encode = F2($BrianHicks$elm_csv$Csv$Encode$encode_fn);
    var $author$project$Types$Column$getCell = function (idxRow) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Column$getCells, $elm_community$list_extra$List$Extra$getAt(idxRow));
    };
    var $author$project$Types$Column$toKeyStringPairs_fn = function (columns, idxRow) {
        return $elm$core$List$map_fn(function (column) {
            return $elm$core$Tuple$pair_fn(column.jx, $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$andThen_fn($author$project$Types$Cell$toMaybeString, A2($author$project$Types$Column$getCell, idxRow, column))));
        }, columns);
    }, $author$project$Types$Column$toKeyStringPairs = F2($author$project$Types$Column$toKeyStringPairs_fn);
    var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
        return { $: 0, a: a };
    };
    var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
    var $author$project$Types$Table$toCsv = function (table) {
        return $BrianHicks$elm_csv$Csv$Encode$encode_fn({
            mj: $BrianHicks$elm_csv$Csv$Encode$withFieldNames($elm$core$Basics$identity),
            mu: ","
        }, $elm$core$List$map_fn($author$project$Types$Column$toKeyStringPairs(table.iT), $elm$core$List$range_fn(0, $author$project$Types$Table$countRows(table) - 1)));
    };
    var $author$project$Types$Table$toIndex_fn = function (tables, table) {
        return $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, $elm$core$Basics$eq(table), tables);
    }, $author$project$Types$Table$toIndex = F2($author$project$Types$Table$toIndex_fn);
    var $author$project$Types$Table$toHeaderId = function (tables) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Table$toIndex(tables), $elm$core$Maybe$map(A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$String$append("table-header-"))));
    };
    var $elm$json$Json$Encode$float = _Json_wrap;
    var $author$project$Util$Bool$fromString = function (string) {
        var _v0 = $elm$core$String$toLower(string);
        switch (_v0) {
            case "true":
                return $elm$core$Maybe$Just(true);
            case "false":
                return $elm$core$Maybe$Just(false);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$Cell$unpack_fn = function (_default, unwrapper, cell) {
        if (!cell.$) {
            return _default(0);
        }
        else {
            var string = cell.a;
            return unwrapper(string);
        }
    }, $author$project$Types$Cell$unpack = F3($author$project$Types$Cell$unpack_fn);
    var $author$project$Types$Cell$encoder = function (dataType) {
        return A2($author$project$Types$Cell$unpack, $elm$core$Basics$always($elm$core$Maybe$Just($elm$json$Json$Encode$null)), function () {
            switch (dataType.$) {
                case 0:
                    return A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm$core$Maybe$map($elm$json$Json$Encode$int));
                case 1:
                    return A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm$core$Maybe$map($elm$json$Json$Encode$float));
                case 2:
                    return A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, $elm$core$Maybe$Just);
                case 3:
                    return A2($elm$core$Basics$composeR, $author$project$Util$Bool$fromString, $elm$core$Maybe$map($elm$json$Json$Encode$bool));
                default:
                    return A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, $elm$core$Maybe$Just);
            }
        }());
    };
    var $author$project$Types$Column$toJson_fn = function (columns, idxRow) {
        return _Json_encode_fn(2, $elm$json$Json$Encode$object($elm$core$List$filterMap_fn(function (column) {
            return $elm$core$Maybe$map_fn($elm$core$Tuple$pair(column.jx), $elm$core$Maybe$andThen_fn($author$project$Types$Cell$encoder(column.l$), A2($author$project$Types$Column$getCell, idxRow, column)));
        }, columns)));
    }, $author$project$Types$Column$toJson = F2($author$project$Types$Column$toJson_fn);
    var $author$project$Types$Table$toJson = function (table) {
        return _Json_encode_fn(2, $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, $elm$core$List$filterMap_fn(A2($elm$core$Basics$composeR, $author$project$Types$Column$toJson(table.iT), A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString($elm$json$Json$Decode$value), $elm$core$Result$toMaybe)), $elm$core$List$range_fn(0, $author$project$Types$Table$countRows(table) - 1))));
    };
    var $author$project$Route$toTable = function (route) {
        switch (route.$) {
            case 17:
                var table = route.b;
                return table;
            case 18:
                var table = route.b;
                return table;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Route$toTableCol = function (route) {
        switch (route.$) {
            case 17:
                var maybeCol = route.d;
                return maybeCol;
            case 18:
                var maybeCol = route.d;
                return maybeCol;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Route$toTableRow = function (route) {
        switch (route.$) {
            case 17:
                var maybeRowId = route.c;
                return maybeRowId;
            case 18:
                var maybeRowId = route.c;
                return maybeRowId;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$delay_300 = $rtfeldman$elm_css$Css$property_fn("transition-delay", "300ms");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$duration_200 = $rtfeldman$elm_css$Css$property_fn("transition-duration", "200ms");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_in_out = $rtfeldman$elm_css$Css$property_fn("transition-timing-function", "cubic-bezier(0.4, 0, 0.2, 1)");
    var $rtfeldman$elm_css$Html$Styled$Events$onMouseLeave = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mouseleave", $elm$json$Json$Decode$succeed(msg));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "0.75rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1rem")
    ]));
    var $author$project$Overlay$tooltipElement_fn = function (styles, lines) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_line,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_Nil))), lines));
    }, $author$project$Overlay$tooltipElement = F2($author$project$Overlay$tooltipElement_fn);
    var $author$project$Overlay$tooltip_fn = function (posMapper, styles, lines, model) {
        if (_Utils_eq(lines, _List_Nil)) {
            return _Utils_update(model, { a$: $elm$core$Maybe$Nothing });
        }
        else {
            var tooltip_ = $author$project$Overlay$tooltipElement_fn(styles, lines);
            return _Utils_update(model, {
                a$: $elm$core$Maybe$Just({
                    cb: $elm$core$Platform$Cmd$none,
                    bR: "tooltip-overlay",
                    b_: posMapper,
                    b$: false,
                    cH: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_in_out, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$delay_300, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$duration_200]),
                    ay: _List_fromArray([tooltip_]),
                    it: $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "tooltip-overlay-wrapper"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                        $rtfeldman$elm_css$Html$Styled$Events$onMouseLeave(model.gd($author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)))
                    ])),
                    pH: 0,
                    pJ: 0
                })
            });
        }
    }, $author$project$Overlay$tooltip = F4($author$project$Overlay$tooltip_fn);
    var $author$project$Overlay$tooltipBottom_a0 = $elm$core$Maybe$Just(F2(function (tooltip_, trigger) {
        return $author$project$Overlay$Position_fn((tooltip_.pH + (trigger.bq / 2)) - (tooltip_.bq / 2), (tooltip_.pJ + trigger.ck) + 5);
    })), $author$project$Overlay$tooltipBottom = $author$project$Overlay$tooltip($author$project$Overlay$tooltipBottom_a0);
    var $author$project$EditGrid$hasAdditionErrors = function (model) {
        return $elm$core$List$any_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fl;
        }, $elm_community$maybe_extra$Maybe$Extra$isJust), $elm$core$List$concat(model.K));
    };
    var $author$project$EditGrid$hasEditErrors = function (model) {
        return $elm$core$List$any_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fl;
        }, $elm_community$maybe_extra$Maybe$Extra$isJust), model.T);
    };
    var $author$project$EditGrid$hasErrors = function (model) {
        return $author$project$EditGrid$hasEditErrors(model) || $author$project$EditGrid$hasAdditionErrors(model);
    };
    var $author$project$GraphGrid$unsavedChanges = function (model) {
        return model.s.la || ($author$project$EditGrid$hasErrors(model.s) || ((!_Utils_eq(model.s.T, _List_Nil)) || (!_Utils_eq(model.s.K, _List_Nil))));
    };
    var $author$project$Types$TableFilter$isValid_a0 = function ($) {
        return $.oN;
    }, $author$project$Types$TableFilter$isValid_a1 = A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not), $author$project$Types$TableFilter$isValid = A2($elm$core$Basics$composeR, $author$project$Types$TableFilter$isValid_a0, $author$project$Types$TableFilter$isValid_a1);
    var $author$project$Components$Toolbar$update_fn = function (cfg, msg, model) {
        switch (msg.$) {
            case 0:
                var filter = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { ba: filter }), $elm$core$Platform$Cmd$none);
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$Toolbar$setAwaitingResult(true), _Utils_Tuple2(model, $elm$core$Basics$composeR_fn($author$project$Types$TableFilter$isValid_a0, $author$project$Types$TableFilter$isValid_a1, model.ba) ? cfg.nK(model.ba) : $elm$core$Platform$Cmd$none));
            case 2:
                return _Utils_Tuple2(_Utils_update(model, { ba: $author$project$Types$TableFilter$empty }), cfg.nN);
            default:
                return _Utils_Tuple2(model, cfg.nZ);
        }
    }, $author$project$Components$Toolbar$update = F3($author$project$Components$Toolbar$update_fn);
    var $author$project$GraphGrid$ColDeleteIntentConfirmed = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$GraphGrid$ColResetIntentConfirmed = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Components$ConfirmDialog$ColumnContext = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Components$ConfirmDialog$DataContext = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$GraphGrid$EditGridMsgReceived = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$GraphGrid$FileUploaded_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $author$project$GraphGrid$FileUploaded = F2($author$project$GraphGrid$FileUploaded_fn);
    var $author$project$GraphGrid$FocusViewMsgReceived = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$GraphGrid$SetFocusViewRow = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Types$Edit$idxRowFromRowId = function (rowId) {
        return $elm$core$String$toInt($elm$core$String$dropLeft_fn(3, rowId));
    };
    var $author$project$GraphGrid$errorPathToMaybeIdxRow = function (path) {
        if (!path.$) {
            var rowId = path.a;
            return $author$project$Types$Edit$idxRowFromRowId(rowId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$Edit$idxColFromColId = function (colId) {
        return $elm$core$String$toInt($elm$core$String$dropLeft_fn(3, colId));
    };
    var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
    var $elm_community$string_extra$String$Extra$firstResultHelp_fn = function (_default, list) {
        firstResultHelp: while (true) {
            if (!list.b) {
                return _default;
            }
            else {
                if (!list.a.$) {
                    var a = list.a.a;
                    return a;
                }
                else {
                    var _v1 = list.a;
                    var rest = list.b;
                    var $temp$default = _default, $temp$list = rest;
                    _default = $temp$default;
                    list = $temp$list;
                    continue firstResultHelp;
                }
            }
        }
    }, $elm_community$string_extra$String$Extra$firstResultHelp = F2($elm_community$string_extra$String$Extra$firstResultHelp_fn);
    var $elm_community$string_extra$String$Extra$firstResult = function (list) {
        return $elm_community$string_extra$String$Extra$firstResultHelp_fn("", list);
    };
    var $elm_community$string_extra$String$Extra$regexEscape = A2($elm$regex$Regex$replace, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "[-/\\^$*+?.()|[\\]{}]"), function (_v0) {
        var match = _v0.j_;
        return "\\" + match;
    });
    var $elm_community$string_extra$String$Extra$rightOf_fn = function (pattern, string) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.o$;
        }, $elm_community$string_extra$String$Extra$firstResult), _Regex_findAtMost_fn(1, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, $elm_community$string_extra$String$Extra$regexEscape(pattern) + "(.*)$"), string)));
    }, $elm_community$string_extra$String$Extra$rightOf = F2($elm_community$string_extra$String$Extra$rightOf_fn);
    var $author$project$Types$Edit$idxColFromId = function (id) {
        return $author$project$Types$Edit$idxColFromColId($elm_community$string_extra$String$Extra$rightOf_fn("_", id));
    };
    var $elm_community$string_extra$String$Extra$leftOf_fn = function (pattern, string) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.o$;
        }, $elm_community$string_extra$String$Extra$firstResult), _Regex_findAtMost_fn(1, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "^(.*?)" + $elm_community$string_extra$String$Extra$regexEscape(pattern)), string)));
    }, $elm_community$string_extra$String$Extra$leftOf = F2($elm_community$string_extra$String$Extra$leftOf_fn);
    var $author$project$Types$Edit$idxRowFromId = function (id) {
        return $author$project$Types$Edit$idxRowFromRowId($elm_community$string_extra$String$Extra$leftOf_fn("_", id));
    };
    var $author$project$Types$Edit$posFromId = function (id) {
        return $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, $author$project$Types$Edit$idxRowFromId(id), $author$project$Types$Edit$idxColFromId(id));
    };
    var $author$project$GraphGrid$errorPathToMaybePosition = function (path) {
        if (!path.$) {
            var positionId = path.a;
            return $author$project$Types$Edit$posFromId(positionId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm_community$maybe_extra$Maybe$Extra$oneOf_fn = function (fmbs, a) {
        oneOf: while (true) {
            if (!fmbs.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var fmb = fmbs.a;
                var rest = fmbs.b;
                var _v1 = fmb(a);
                if (!_v1.$) {
                    var b = _v1.a;
                    return $elm$core$Maybe$Just(b);
                }
                else {
                    var $temp$fmbs = rest, $temp$a = a;
                    fmbs = $temp$fmbs;
                    a = $temp$a;
                    continue oneOf;
                }
            }
        }
    }, $elm_community$maybe_extra$Maybe$Extra$oneOf = F2($elm_community$maybe_extra$Maybe$Extra$oneOf_fn);
    var $elm_community$string_extra$String$Extra$rightOfBack_fn = function (pattern, string) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Basics$add($elm$core$String$length(pattern)), function (a) {
            return $elm$core$String$dropLeft_fn(a, string);
        }), $elm$core$List$head($elm$core$List$reverse(_String_indexes_fn(pattern, string)))));
    }, $elm_community$string_extra$String$Extra$rightOfBack = F2($elm_community$string_extra$String$Extra$rightOfBack_fn);
    var $author$project$Types$Edit$samePos_fn = function (pos, edit) {
        return _Utils_eq(pos, edit.eo);
    }, $author$project$Types$Edit$samePos = F2($author$project$Types$Edit$samePos_fn);
    var $author$project$Types$Edit$toString = function ($) {
        return $.pB;
    };
    var $author$project$Types$Edit$withError_fn = function (errorMessage, edit) {
        return _Utils_update(edit, {
            fl: $elm$core$Maybe$Just(errorMessage)
        });
    }, $author$project$Types$Edit$withError = F2($author$project$Types$Edit$withError_fn);
    var $author$project$GraphGrid$addErrorsToEdits_fn = function (columns, errors, edits) {
        var editFromErrorValue = function (error) {
            var maybeValue = $elm_community$string_extra$String$Extra$nonEmpty($elm_community$string_extra$String$Extra$leftOf_fn("\\\"", $elm_community$string_extra$String$Extra$rightOf_fn("Value \\\"", error.no)));
            var editsWithSameValue = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toString, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(maybeValue))), edits);
            return $elm$core$Maybe$map_fn($author$project$Types$Edit$withError(error.no), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always($elm$core$List$length(editsWithSameValue) === 1), $elm$core$List$head(editsWithSameValue)));
        };
        var editFromErrorPosition = function (error) {
            var maybePosition = function () {
                var maybeIdxCol = function () {
                    var messageToColumnName = function (message) {
                        return $elm_community$maybe_extra$Maybe$Extra$oneOf_fn(_List_fromArray([
                            A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$rightOfBack(" "), A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$rightOf("."), $elm_community$string_extra$String$Extra$nonEmpty)),
                            A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$rightOfBack(":"), A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$leftOf("IN ("), A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm_community$string_extra$String$Extra$nonEmpty))),
                            A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$rightOfBack(" "), $elm_community$string_extra$String$Extra$nonEmpty)
                        ]), message);
                    };
                    var columnNameToMaybeIdxCol = function (columnName) {
                        return $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, A2($elm$core$Basics$composeR, function ($) {
                            return $.jx;
                        }, $elm$core$Basics$eq(columnName)), columns);
                    };
                    return $elm$core$Maybe$andThen_fn(columnNameToMaybeIdxCol, messageToColumnName(error.no));
                }();
                var maybeErrorPath = $elm$core$List$head($elm$core$Maybe$withDefault_fn(_List_Nil, error.ks));
                return $elm_community$maybe_extra$Maybe$Extra$oneOf_fn(_List_fromArray([
                    $elm$core$Maybe$andThen($author$project$GraphGrid$errorPathToMaybePosition),
                    A2($elm$core$Basics$composeR, $elm$core$Maybe$andThen($author$project$GraphGrid$errorPathToMaybeIdxRow), A2($elm$core$Maybe$map2, $author$project$Util$flip($elm$core$Tuple$pair), maybeIdxCol))
                ]), maybeErrorPath);
            }();
            return $elm$core$Maybe$andThen_fn(function (position) {
                return $elm$core$Maybe$map_fn($author$project$Types$Edit$withError(error.no), $elm_community$list_extra$List$Extra$find_fn($author$project$Types$Edit$samePos(position), edits));
            }, maybePosition);
        };
        var errorEdits = $elm$core$List$filterMap_fn(function (gqlError) {
            return $elm_community$maybe_extra$Maybe$Extra$orElse_fn(editFromErrorValue(gqlError), editFromErrorPosition(gqlError));
        }, errors);
        var getErrorEdit = function (edit) {
            return $elm$core$Maybe$withDefault_fn(edit, $elm_community$list_extra$List$Extra$find_fn($author$project$Types$Edit$samePos(edit.eo), errorEdits));
        };
        return $elm$core$List$map_fn(getErrorEdit, edits);
    }, $author$project$GraphGrid$addErrorsToEdits = F3($author$project$GraphGrid$addErrorsToEdits_fn);
    var $author$project$Types$Column$appendRow_fn = function (row, columns) {
        return $elm$core$List$indexedMap_fn_unwrapped(function (idxColumn, column) {
            var cell = $elm_community$maybe_extra$Maybe$Extra$toList($elm_community$list_extra$List$Extra$getAt_fn(idxColumn, row));
            return _Utils_update(column, {
                y: $krisajenkins$remotedata$RemoteData$succeed($author$project$Util$flip_fn($elm$core$List$append, cell, $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, column.y)))
            });
        }, columns);
    }, $author$project$Types$Column$appendRow = F2($author$project$Types$Column$appendRow_fn);
    var $author$project$Types$Cell$fromString = function (nullable) {
        return nullable ? A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$nonEmpty, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Types$Cell$NullCell, $author$project$Types$Cell$StringCell)) : $author$project$Types$Cell$StringCell;
    };
    var $author$project$Types$DataType$isNullable = function (dataType) {
        switch (dataType.$) {
            case 0:
                if (!dataType.a) {
                    var _v1 = dataType.a;
                    return true;
                }
                else {
                    var _v5 = dataType.a;
                    return false;
                }
            case 1:
                if (!dataType.a) {
                    var _v2 = dataType.a;
                    return true;
                }
                else {
                    var _v6 = dataType.a;
                    return false;
                }
            case 2:
                if (!dataType.a) {
                    var _v3 = dataType.a;
                    return true;
                }
                else {
                    var _v7 = dataType.a;
                    return false;
                }
            case 3:
                if (!dataType.a) {
                    var _v4 = dataType.a;
                    return true;
                }
                else {
                    var _v8 = dataType.a;
                    return false;
                }
            default:
                if (!dataType.a) {
                    var _v9 = dataType.a;
                    return true;
                }
                else {
                    var _v10 = dataType.a;
                    return false;
                }
        }
    };
    var $author$project$Types$Column$isNullable_a0 = function ($) {
        return $.l$;
    }, $author$project$Types$Column$isNullable_a1 = $author$project$Types$DataType$isNullable, $author$project$Types$Column$isNullable = A2($elm$core$Basics$composeR, $author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1);
    var $author$project$Types$Column$isPrimaryKeyAt_fn = function (columns, idxCol) {
        return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function ($) {
            return $.co;
        }, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns)));
    }, $author$project$Types$Column$isPrimaryKeyAt = F2($author$project$Types$Column$isPrimaryKeyAt_fn);
    var $author$project$Types$Edit$idxColFromPos = $elm$core$Tuple$second;
    var $author$project$Types$Edit$toIdxCol_a0 = function ($) {
        return $.eo;
    }, $author$project$Types$Edit$toIdxCol_a1 = $author$project$Types$Edit$idxColFromPos, $author$project$Types$Edit$toIdxCol = A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1);
    var $author$project$Types$Column$isPrimaryKeyEdit = function (columns) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, $author$project$Types$Column$isPrimaryKeyAt(columns));
    };
    var $author$project$Types$DataType$isValidData_fn = function (isPrimaryKey, string, dataType) {
        var orEmptyStringIfNullable = F2(function (nullability, check) {
            if (!nullability) {
                return ((!isPrimaryKey) && $elm$core$String$isEmpty(string)) || check(string);
            }
            else {
                return check(string);
            }
        });
        switch (dataType.$) {
            case 0:
                var nullability = dataType.a;
                return A2(orEmptyStringIfNullable, nullability, A2($elm$core$Basics$composeR, $elm$core$String$toInt, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter(A2($elm$core$Basics$composeR, $elm$core$Basics$abs, $elm$core$Basics$gt(2147483648))), $elm_community$maybe_extra$Maybe$Extra$isJust)));
            case 1:
                var nullability = dataType.a;
                return A2(orEmptyStringIfNullable, nullability, A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm_community$maybe_extra$Maybe$Extra$isJust));
            case 2:
                return true;
            case 3:
                var nullability = dataType.a;
                return A2(orEmptyStringIfNullable, nullability, A2($elm$core$Basics$composeR, $author$project$Util$Bool$fromString, $elm_community$maybe_extra$Maybe$Extra$isJust));
            default:
                var nullability = dataType.a;
                return A2(orEmptyStringIfNullable, nullability, $elm$core$Basics$always(true));
        }
    }, $author$project$Types$DataType$isValidData = F3($author$project$Types$DataType$isValidData_fn);
    var $author$project$Types$Column$applyEdits_fn = function (edits, columns) {
        var updateColumn = F2(function (idxCol, column) {
            var updateCell = F2(function (idxRow, cell) {
                var maybeEdit = $elm_community$list_extra$List$Extra$find_fn($author$project$Types$Edit$samePos(_Utils_Tuple2(idxRow, idxCol)), edits);
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(cell, A2($elm$core$Basics$composeR, $author$project$Types$Edit$toString, $author$project$Types$Cell$fromString($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column))), $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (edit) {
                    return $author$project$Types$DataType$isValidData_fn(A2($author$project$Types$Column$isPrimaryKeyEdit, columns, edit), edit.pB, column.l$);
                }, maybeEdit));
            });
            return _Utils_update(column, {
                y: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$List$indexedMap(updateCell), column.y)
            });
        });
        return $elm$core$List$indexedMap_fn(updateColumn, columns);
    }, $author$project$Types$Column$applyEdits = F2($author$project$Types$Column$applyEdits_fn);
    var $author$project$EditGrid$clearEdits = function (model) {
        return _Utils_update(model, { T: _List_Nil });
    };
    var $author$project$FocusView$clearEdits = function (model) {
        return _Utils_update(model, { T: _List_Nil });
    };
    var $author$project$EditGrid$closeColEditOverlay = function (model) {
        return _Utils_update(model, {
            a7: $author$project$Types$ColumnEdit$emptyCreation,
            aC: $author$project$Overlay$clear(model.aC)
        });
    };
    var $author$project$Types$InputElement$defaultValue = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return "0";
            case 1:
                return "0";
            case 2:
                return "";
            case 3:
                return "false";
            case 4:
                var options = inputElement.a;
                return $elm$core$Maybe$withDefault_fn("", $elm$core$List$head(options));
            case 5:
                return "1970-01-01";
            case 6:
                return "00:00";
            case 7:
                return "1970-01-01T00:00";
            case 8:
                return "0:00";
            case 9:
                return "PT0S";
            case 10:
                return "";
            case 11:
                return "";
            case 12:
                return "";
            case 13:
                return "#000000";
            case 14:
                return "null";
            case 15:
                return "{}";
            case 16:
                return "[]";
            case 17:
                return "";
            case 18:
                return "(0,0)";
            case 19:
                return "AD";
            case 20:
                return "ABW";
            default:
                return "{}";
        }
    };
    var $author$project$Types$Cell$empty = $author$project$Types$Cell$StringCell("");
    var $author$project$Types$InputElement$isEmptiable = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return true;
            case 1:
                return true;
            case 2:
                return true;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return false;
            case 14:
                return false;
            case 15:
                return false;
            case 16:
                return false;
            case 17:
                return false;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Types$SqliteDataType$isString = function (dataType) {
        switch (dataType) {
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return true;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return true;
            case 8:
                return true;
            case 9:
                return true;
            case 10:
                return true;
            case 11:
                return true;
            case 12:
                return true;
            case 13:
                return true;
            case 14:
                return true;
            case 15:
                return true;
            case 16:
                return true;
            case 17:
                return true;
            case 18:
                return true;
            case 19:
                return true;
            case 20:
                return true;
            case 21:
                return true;
            case 22:
                return true;
            case 23:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Types$Column$isString_a0 = function ($) {
        return $.l0;
    }, $author$project$Types$Column$isString_a1 = $author$project$Types$SqliteDataType$isString, $author$project$Types$Column$isString = A2($elm$core$Basics$composeR, $author$project$Types$Column$isString_a0, $author$project$Types$Column$isString_a1);
    var $author$project$Types$Column$isEmptiable = function (column) {
        return $author$project$Types$InputElement$isEmptiable(column.mN) && ($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column) || $elm$core$Basics$composeR_fn($author$project$Types$Column$isString_a0, $author$project$Types$Column$isString_a1, column));
    };
    var $author$project$Types$Cell$null = $author$project$Types$Cell$NullCell;
    var $author$project$Types$Column$defaultCell = function (column) {
        return $elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column) ? $author$project$Types$Cell$null : ($author$project$Types$Column$isEmptiable(column) ? $author$project$Types$Cell$empty : A2($author$project$Types$Cell$fromString, false, $author$project$Types$InputElement$defaultValue(column.mN)));
    };
    var $author$project$GraphGrid$apiUrlGqlToRest_fn = function (apiUrl, tableName, columnName) {
        return $elm$core$String$replace_fn("graphql", "tables/" + ($elm$url$Url$percentEncode(tableName) + ("/columns/" + $elm$url$Url$percentEncode(columnName))), _String_append_fn("/api", apiUrl));
    }, $author$project$GraphGrid$apiUrlGqlToRest = F3($author$project$GraphGrid$apiUrlGqlToRest_fn);
    var $author$project$Types$Column$getByNameAt_fn = function (idxRow, columnName, columns) {
        return $elm$core$Maybe$andThen_fn($author$project$Types$Cell$toMaybeString, $elm$core$Maybe$andThen_fn($author$project$Types$Column$getCell(idxRow), A2($author$project$Types$Column$find, columnName, columns)));
    }, $author$project$Types$Column$getByNameAt = F3($author$project$Types$Column$getByNameAt_fn);
    var $author$project$Types$Column$getNameAt = function (idxCol) {
        return A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$getAt(idxCol), $elm$core$Maybe$map(function ($) {
            return $.jx;
        }));
    };
    var $author$project$Types$Edit$idxRowFromPos = $elm$core$Tuple$first;
    var $author$project$Types$Edit$toIdxRow_a0 = function ($) {
        return $.eo;
    }, $author$project$Types$Edit$toIdxRow_a1 = $author$project$Types$Edit$idxRowFromPos, $author$project$Types$Edit$toIdxRow = A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1);
    var $author$project$GraphGrid$editToFileUrl_fn = function (tableName, columns, rowidColumnName, apiUrl, edit) {
        return $elm$core$Maybe$map2_fn_unwrapped(function (rowid, url) {
            return url + ("/files/" + (rowidColumnName + ("/" + rowid)));
        }, $author$project$Types$Column$getByNameAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit), rowidColumnName, columns), $elm$core$Maybe$map_fn(A2($author$project$GraphGrid$apiUrlGqlToRest, apiUrl, tableName), $author$project$Util$flip_fn($author$project$Types$Column$getNameAt, columns, $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit))));
    }, $author$project$GraphGrid$editToFileUrl = F5($author$project$GraphGrid$editToFileUrl_fn);
    var $author$project$Types$Column$findIndex = function (column) {
        return $elm_community$list_extra$List$Extra$findIndex($elm$core$Basics$eq(column));
    };
    var $author$project$Types$Cell$isNull_a0 = $author$project$Types$Cell$null, $author$project$Types$Cell$isNull = $elm$core$Basics$eq($author$project$Types$Cell$isNull_a0);
    var $author$project$Types$InputElement$isServerSide = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return false;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return false;
            case 14:
                return false;
            case 15:
                return false;
            case 16:
                return false;
            case 17:
                return false;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return true;
        }
    };
    var $author$project$GraphGrid$editsToAffectedPositions_fn = function (rowidName, columns) {
        var conditionallyAffectedColumns = function (edit) {
            var isRowidEdit = A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Types$Column$getNameAt, columns), $elm$core$Basics$eq($elm$core$Maybe$Just(rowidName))));
            var columnIsNullAt = function (idxRow) {
                return A2($elm$core$Basics$composeR, $author$project$Types$Column$getCell(idxRow), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Types$Cell$isNull));
            };
            if (isRowidEdit(edit)) {
                var idxRow = $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit);
                return $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, columnIsNullAt(idxRow)), $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.mN;
                }, $author$project$Types$InputElement$isServerSide), columns));
            }
            else {
                return _List_Nil;
            }
        };
        var alwaysAffectedColumns = $elm$core$List$filter_fn(function ($) {
            return $.cn;
        }, columns);
        var toPositions = function (edit) {
            var idxRow = $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit);
            var affectedColumns = _Utils_ap(alwaysAffectedColumns, conditionallyAffectedColumns(edit));
            return $elm$core$List$map_fn($elm$core$Tuple$pair(idxRow), $elm$core$List$filterMap_fn(A2($author$project$Util$flip, $author$project$Types$Column$findIndex, columns), affectedColumns));
        };
        return $elm$core$List$concatMap(toPositions);
    }, $author$project$GraphGrid$editsToAffectedPositions = F2($author$project$GraphGrid$editsToAffectedPositions_fn);
    var $author$project$GraphGrid$filterEditsToRefetch_fn = function (columns, edits) {
        return $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$getAt, columns), A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter(function (column) {
            return $author$project$Types$InputElement$isServerSide(column.mN) || column.cn;
        }), $elm_community$maybe_extra$Maybe$Extra$isJust))), edits);
    }, $author$project$GraphGrid$filterEditsToRefetch = F2($author$project$GraphGrid$filterEditsToRefetch_fn);
    var $elm_community$list_extra$List$Extra$filterNot_fn = function (pred, list) {
        return $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred), list);
    }, $elm_community$list_extra$List$Extra$filterNot = F2($elm_community$list_extra$List$Extra$filterNot_fn);
    var $author$project$GraphGrid$GetCellsResponded = function (a) {
        return { $: 18, a: a };
    };
    var $elm_community$json_extra$Json$Decode$Extra$combine_a0 = $elm$json$Json$Decode$map2($elm$core$List$cons), $elm_community$json_extra$Json$Decode$Extra$combine_a1 = $elm$json$Json$Decode$succeed(_List_Nil), $elm_community$json_extra$Json$Decode$Extra$combine = A2($elm$core$List$foldr, $elm_community$json_extra$Json$Decode$Extra$combine_a0, $elm_community$json_extra$Json$Decode$Extra$combine_a1);
    var $author$project$DoubleXEncoding$charEncode = function (_char) {
        switch (_char) {
            case " ":
                return "0";
            case "!":
                return "1";
            case "\"":
                return "2";
            case "#":
                return "3";
            case "$":
                return "4";
            case "%":
                return "5";
            case "&":
                return "6";
            case "'":
                return "7";
            case "(":
                return "8";
            case ")":
                return "9";
            case "*":
                return "A";
            case "+":
                return "B";
            case ",":
                return "C";
            case "-":
                return "D";
            case ".":
                return "E";
            case "/":
                return "F";
            case ":":
                return "G";
            case ";":
                return "H";
            case "<":
                return "I";
            case "=":
                return "J";
            case ">":
                return "K";
            case "?":
                return "L";
            case "@":
                return "M";
            case "[":
                return "N";
            case "\\":
                return "O";
            case "]":
                return "P";
            case "^":
                return "Q";
            case "_":
                return "R";
            case "`":
                return "S";
            case "{":
                return "T";
            case "|":
                return "U";
            case "}":
                return "V";
            case "~":
                return "W";
            case "X":
                return "Y";
            default:
                return "\0";
        }
    };
    var $author$project$UInt64$digitsToString = function (_v0) {
        var _v1 = _v0;
        var digits = _v1.b;
        return $elm$core$String$fromList(digits);
    };
    var $author$project$UInt64$UInt64 = $elm$core$Basics$identity;
    var $author$project$UInt64$limit24 = 16777216;
    var $author$project$UInt64$limit48 = 281474976710656;
    var $author$project$UInt64$max24 = 16777215;
    var $author$project$UInt64$maxSafeHighPart = 31;
    var $author$project$UInt64$maxSafe = _Utils_Tuple3($author$project$UInt64$maxSafeHighPart, $author$project$UInt64$max24, $author$project$UInt64$max24);
    var $author$project$UInt64$maxSafeInt = 9007199254740991;
    var $author$project$UInt64$zero = _Utils_Tuple3(0, 0, 0);
    var $author$project$UInt64$fromInt = function (x) {
        if (x <= 0) {
            return $author$project$UInt64$zero;
        }
        else {
            if (_Utils_cmp(x, $author$project$UInt64$maxSafeInt) < 1) {
                var high = $elm$core$Basics$floor(x / $author$project$UInt64$limit48);
                var midLow = x - ($author$project$UInt64$limit48 * high);
                var mid = $elm$core$Basics$floor(midLow / $author$project$UInt64$limit24);
                var low = midLow - ($author$project$UInt64$limit24 * mid);
                return _Utils_Tuple3(high, mid, low);
            }
            else {
                return $author$project$UInt64$maxSafe;
            }
        }
    };
    var $author$project$UInt64$Hex = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$UInt64$Lower = 1;
    var $author$project$UInt64$hexLower = $author$project$UInt64$Hex(1);
    var $author$project$DoubleXEncoding$hexShiftEncode = function (digit) {
        switch (digit) {
            case "0":
                return "a";
            case "1":
                return "b";
            case "2":
                return "c";
            case "3":
                return "d";
            case "4":
                return "e";
            case "5":
                return "f";
            case "6":
                return "g";
            case "7":
                return "h";
            case "8":
                return "i";
            case "9":
                return "j";
            case "a":
                return "k";
            case "b":
                return "l";
            case "c":
                return "m";
            case "d":
                return "n";
            case "e":
                return "o";
            case "f":
                return "p";
            default:
                return "\0";
        }
    };
    var $elm$core$String$padLeft_fn = function (n, _char, string) {
        return _Utils_ap($elm$core$String$repeat_fn(n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)), string);
    }, $elm$core$String$padLeft = F3($elm$core$String$padLeft_fn);
    var $author$project$UInt64$Digits = $elm$core$Basics$identity;
    var $author$project$UInt64$Upper = 0;
    var $author$project$UInt64$isZero = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        return (!low) && ((!mid) && (!high));
    };
    var $author$project$UInt64$riskyIntToLowerCaseDigit = function (x) {
        switch (x) {
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                return "x";
        }
    };
    var $author$project$UInt64$riskyIntToUpperCaseDigit = function (x) {
        switch (x) {
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "A";
            case 11:
                return "B";
            case 12:
                return "C";
            case 13:
                return "D";
            case 14:
                return "E";
            case 15:
                return "F";
            default:
                return "X";
        }
    };
    var $author$project$UInt64$riskyIntToNonDecimalIntDigits_fn = function (bitsPerDigit, x, digitCount, digits) {
        riskyIntToNonDecimalIntDigits: while (true) {
            var bitMask = function (_v0) {
                return (1 << bitsPerDigit) - 1;
            };
            if (!x) {
                return _Utils_Tuple2(digitCount, digits);
            }
            else {
                var $temp$bitsPerDigit = bitsPerDigit, $temp$x = x >>> bitsPerDigit, $temp$digitCount = digitCount + 1, $temp$digits = _List_Cons(bitMask(0) & x, digits);
                bitsPerDigit = $temp$bitsPerDigit;
                x = $temp$x;
                digitCount = $temp$digitCount;
                digits = $temp$digits;
                continue riskyIntToNonDecimalIntDigits;
            }
        }
    }, $author$project$UInt64$riskyIntToNonDecimalIntDigits = F4($author$project$UInt64$riskyIntToNonDecimalIntDigits_fn);
    var $author$project$UInt64$max16 = 65535;
    var $author$project$UInt64$add_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var low = lowA + lowB;
        var mid = (_Utils_cmp(low, $author$project$UInt64$limit24) < 0) ? (midA + midB) : ((midA + midB) + 1);
        var high = (_Utils_cmp(mid, $author$project$UInt64$limit24) < 0) ? (highA + highB) : ((highA + highB) + 1);
        return _Utils_Tuple3($author$project$UInt64$max16 & high, $author$project$UInt64$max24 & mid, $author$project$UInt64$max24 & low);
    }, $author$project$UInt64$add = F2($author$project$UInt64$add_fn);
    var $author$project$UInt64$compare_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var _v4 = _Utils_compare_fn(highA, highB);
        if (_v4 === 1) {
            var _v5 = _Utils_compare_fn(midA, midB);
            if (_v5 === 1) {
                return _Utils_compare_fn(lowA, lowB);
            }
            else {
                var midNotEq = _v5;
                return midNotEq;
            }
        }
        else {
            var highNotEq = _v4;
            return highNotEq;
        }
    }, $author$project$UInt64$compare = F2($author$project$UInt64$compare_fn);
    var $author$project$UInt64$compare72_64_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var _v4 = _Utils_compare_fn(highA, highB);
        if (_v4 === 1) {
            var _v5 = _Utils_compare_fn(midA, midB);
            if (_v5 === 1) {
                return _Utils_compare_fn(lowA, lowB);
            }
            else {
                var midNotEq = _v5;
                return midNotEq;
            }
        }
        else {
            var highNotEq = _v4;
            return highNotEq;
        }
    }, $author$project$UInt64$compare72_64 = F2($author$project$UInt64$compare72_64_fn);
    var $author$project$UInt64$maxValue = _Utils_Tuple3($author$project$UInt64$max16, $author$project$UInt64$max24, $author$project$UInt64$max24);
    var $author$project$UInt64$decrement = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        return (low > 0) ? _Utils_Tuple3(high, mid, low - 1) : ((mid > 0) ? _Utils_Tuple3(high, mid - 1, $author$project$UInt64$max24) : ((high > 0) ? _Utils_Tuple3(high - 1, $author$project$UInt64$max24, $author$project$UInt64$max24) : $author$project$UInt64$maxValue));
    };
    var $author$project$UInt64$divModFloat_fn = function (a, b) {
        var div_ = $elm$core$Basics$floor(a / b);
        return _Utils_Tuple2(div_, a - (b * div_));
    }, $author$project$UInt64$divModFloat = F2($author$project$UInt64$divModFloat_fn);
    var $author$project$UInt64$minCertainInteger = 4503599627370496;
    var $author$project$UInt64$floorAnyPositiveFloat = function (x) {
        return (_Utils_cmp(x, $author$project$UInt64$minCertainInteger) > -1) ? x : $elm$core$Basics$floor(x);
    };
    var $author$project$UInt64$increment = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        return (_Utils_cmp(low, $author$project$UInt64$max24) < 0) ? _Utils_Tuple3(high, mid, low + 1) : ((_Utils_cmp(mid, $author$project$UInt64$max24) < 0) ? _Utils_Tuple3(high, mid + 1, 0) : ((_Utils_cmp(high, $author$project$UInt64$max16) < 0) ? _Utils_Tuple3(high + 1, 0, 0) : $author$project$UInt64$zero));
    };
    var $author$project$UInt64$isSafe72 = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        return _Utils_cmp(high, $author$project$UInt64$maxSafeHighPart) < 1;
    };
    var $author$project$UInt64$mul_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var lowFull = lowA * lowB;
        var lowCarry = $elm$core$Basics$floor(lowFull / $author$project$UInt64$limit24);
        var midFull = (lowCarry + (lowA * midB)) + (midA * lowB);
        var midCarry = $elm$core$Basics$floor(midFull / $author$project$UInt64$limit24);
        var mid = midFull - (midCarry * $author$project$UInt64$limit24);
        var low = lowFull - (lowCarry * $author$project$UInt64$limit24);
        var high = $author$project$UInt64$max16 & (((midCarry + (lowA * highB)) + (midA * midB)) + (highA * lowB));
        return _Utils_Tuple3(high, mid, low);
    }, $author$project$UInt64$mul = F2($author$project$UInt64$mul_fn);
    var $author$project$UInt64$UInt72 = $elm$core$Basics$identity;
    var $author$project$UInt64$mul64_64_72_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var lowFull = lowA * lowB;
        var lowCarry = $elm$core$Basics$floor(lowFull / $author$project$UInt64$limit24);
        var midFull = (lowCarry + (lowA * midB)) + (midA * lowB);
        var midCarry = $elm$core$Basics$floor(midFull / $author$project$UInt64$limit24);
        var mid = midFull - (midCarry * $author$project$UInt64$limit24);
        var low = lowFull - (lowCarry * $author$project$UInt64$limit24);
        var high = $author$project$UInt64$max24 & (((midCarry + (lowA * highB)) + (midA * midB)) + (highA * lowB));
        return _Utils_Tuple3(high, mid, low);
    }, $author$project$UInt64$mul64_64_72 = F2($author$project$UInt64$mul64_64_72_fn);
    var $author$project$UInt64$risky72to64 = function (_v0) {
        var tuple = _v0;
        return tuple;
    };
    var $author$project$UInt64$riskyFloatTo64 = function (x) {
        var highMid = $elm$core$Basics$floor(x / $author$project$UInt64$limit24);
        var low = $elm$core$Basics$floor(x) - (highMid * $author$project$UInt64$limit24);
        var high = $elm$core$Basics$floor(highMid / $author$project$UInt64$limit24);
        var mid = highMid - (high * $author$project$UInt64$limit24);
        return _Utils_Tuple3(high, mid, low);
    };
    var $author$project$UInt64$sub_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var low = lowA - lowB;
        var mid = (low >= 0) ? (midA - midB) : ((midA - midB) - 1);
        var high = (mid >= 0) ? (highA - highB) : ((highA - highB) - 1);
        return _Utils_Tuple3($author$project$UInt64$max16 & high, $author$project$UInt64$max24 & mid, $author$project$UInt64$max24 & low);
    }, $author$project$UInt64$sub = F2($author$project$UInt64$sub_fn);
    var $author$project$UInt64$sub72_64_72_fn = function (_v0, _v2) {
        var _v1 = _v0;
        var highA = _v1.a;
        var midA = _v1.b;
        var lowA = _v1.c;
        var _v3 = _v2;
        var highB = _v3.a;
        var midB = _v3.b;
        var lowB = _v3.c;
        var low = lowA - lowB;
        var mid = (low >= 0) ? (midA - midB) : ((midA - midB) - 1);
        var high = (mid >= 0) ? (highA - highB) : ((highA - highB) - 1);
        return _Utils_Tuple3($author$project$UInt64$max24 & high, $author$project$UInt64$max24 & mid, $author$project$UInt64$max24 & low);
    }, $author$project$UInt64$sub72_64_72 = F2($author$project$UInt64$sub72_64_72_fn);
    var $author$project$UInt64$toFloat = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        return (((high * $author$project$UInt64$limit24) + mid) * $author$project$UInt64$limit24) + low;
    };
    var $author$project$UInt64$toFloat72 = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        return (((high * $author$project$UInt64$limit24) + mid) * $author$project$UInt64$limit24) + low;
    };
    var $author$project$UInt64$divModFast_fn = function (dividend, divisor) {
        if ($author$project$UInt64$isZero(divisor)) {
            return $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$zero, $author$project$UInt64$zero));
        }
        else {
            var approxDivisor = $author$project$UInt64$toFloat(divisor);
            var approxDiv = $author$project$UInt64$riskyFloatTo64($author$project$UInt64$floorAnyPositiveFloat($author$project$UInt64$toFloat(dividend) / approxDivisor));
            var approxDivMultiplied72 = $author$project$UInt64$mul64_64_72_fn(approxDiv, divisor);
            var _v0 = $author$project$UInt64$compare72_64_fn(approxDivMultiplied72, dividend);
            switch (_v0) {
                case 1:
                    return $elm$core$Result$Ok(_Utils_Tuple2(approxDiv, $author$project$UInt64$zero));
                case 0:
                    var delta = $author$project$UInt64$sub_fn(dividend, $author$project$UInt64$risky72to64(approxDivMultiplied72));
                    var _v1 = $author$project$UInt64$compare_fn(delta, divisor);
                    switch (_v1) {
                        case 0:
                            return $elm$core$Result$Ok(_Utils_Tuple2(approxDiv, delta));
                        case 1:
                            return $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$increment(approxDiv), $author$project$UInt64$zero));
                        default:
                            var secondApproxDiv = $author$project$UInt64$add_fn(approxDiv, $author$project$UInt64$riskyFloatTo64($author$project$UInt64$floorAnyPositiveFloat($author$project$UInt64$toFloat(delta) / approxDivisor)));
                            var secondApproxDivMultiplied = $author$project$UInt64$mul_fn(secondApproxDiv, divisor);
                            var _v2 = $author$project$UInt64$compare_fn(secondApproxDivMultiplied, dividend);
                            switch (_v2) {
                                case 1:
                                    return $elm$core$Result$Ok(_Utils_Tuple2(secondApproxDiv, $author$project$UInt64$zero));
                                case 0:
                                    var secondDelta = $author$project$UInt64$sub_fn(dividend, secondApproxDivMultiplied);
                                    var _v3 = $author$project$UInt64$compare_fn(secondDelta, divisor);
                                    if (!_v3) {
                                        return $elm$core$Result$Ok(_Utils_Tuple2(secondApproxDiv, secondDelta));
                                    }
                                    else {
                                        return $elm$core$Result$Err("IMPOSSIBLE: secondDelta >= divisor");
                                    }
                                default:
                                    return $elm$core$Result$Err("IMPOSSIBLE: secondApproxDivMultiplied > dividend");
                            }
                    }
                default:
                    var delta72 = $author$project$UInt64$sub72_64_72_fn(approxDivMultiplied72, dividend);
                    var _v4 = $author$project$UInt64$compare72_64_fn(delta72, divisor);
                    switch (_v4) {
                        case 0:
                            return $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$decrement(approxDiv), $author$project$UInt64$sub_fn(divisor, $author$project$UInt64$risky72to64(delta72))));
                        case 1:
                            return $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$decrement(approxDiv), $author$project$UInt64$zero));
                        default:
                            if ($author$project$UInt64$isSafe72(delta72)) {
                                var _v5 = $author$project$UInt64$divModFloat_fn($author$project$UInt64$toFloat72(delta72), approxDivisor);
                                var deltaDiv = _v5.a;
                                var deltaMod = _v5.b;
                                return (!deltaMod) ? $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$sub_fn(approxDiv, $author$project$UInt64$riskyFloatTo64(deltaDiv)), $author$project$UInt64$zero)) : $elm$core$Result$Ok(_Utils_Tuple2($author$project$UInt64$sub_fn(approxDiv, $author$project$UInt64$riskyFloatTo64(deltaDiv + 1)), $author$project$UInt64$riskyFloatTo64(approxDivisor - deltaMod)));
                            }
                            else {
                                return $elm$core$Result$Err("IMPOSSIBLE: approxDivMultiplied72 > dividend " + "&& not (isSafe72 delta72)");
                            }
                    }
            }
        }
    }, $author$project$UInt64$divModFast = F2($author$project$UInt64$divModFast_fn);
    var $author$project$UInt64$getBit_fn = function (givenBitNumber, _v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        var bitNumber = 63 & givenBitNumber;
        return (bitNumber < 24) ? (1 & (low >>> bitNumber)) : ((bitNumber < 48) ? (1 & (mid >>> (bitNumber - 24))) : (1 & (high >>> (bitNumber - 48))));
    }, $author$project$UInt64$getBit = F2($author$project$UInt64$getBit_fn);
    var $elm$core$Bitwise$complement = _Bitwise_complement;
    var $author$project$UInt64$setBit_fn = function (givenBitNumber, givenBitValue, _v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        var bitValue = 1 & givenBitValue;
        var bitNumber = 63 & givenBitNumber;
        return (bitNumber < 24) ? ((!bitValue) ? _Utils_Tuple3(high, mid, low & (~(1 << bitNumber))) : _Utils_Tuple3(high, mid, low | (1 << bitNumber))) : ((bitNumber < 48) ? ((!bitValue) ? _Utils_Tuple3(high, mid & (~(1 << (bitNumber - 24))), low) : _Utils_Tuple3(high, mid | (1 << (bitNumber - 24)), low)) : ((!bitValue) ? _Utils_Tuple3(high & (~(1 << (bitNumber - 48))), mid, low) : _Utils_Tuple3(high | (1 << (bitNumber - 48)), mid, low)));
    }, $author$project$UInt64$setBit = F3($author$project$UInt64$setBit_fn);
    var $author$project$UInt64$shiftLeftBy_fn = function (givenShift, _v0) {
        var _v1 = _v0;
        var high = _v1.a;
        var mid = _v1.b;
        var low = _v1.c;
        var n = 63 & givenShift;
        return (n < 24) ? _Utils_Tuple3($author$project$UInt64$max16 & ((high << n) | (mid >>> (24 - n))), $author$project$UInt64$max24 & ((mid << n) | (low >>> (24 - n))), $author$project$UInt64$max24 & (low << n)) : ((n < 48) ? _Utils_Tuple3($author$project$UInt64$max16 & ((mid << (n - 24)) | (low >>> (48 - n))), $author$project$UInt64$max24 & (low << (n - 24)), 0) : _Utils_Tuple3($author$project$UInt64$max16 & (low << (n - 48)), 0, 0));
    }, $author$project$UInt64$shiftLeftBy = F2($author$project$UInt64$shiftLeftBy_fn);
    var $author$project$UInt64$divModSlow_fn = function (dividend, divisor) {
        return $author$project$UInt64$isZero(divisor) ? _Utils_Tuple2($author$project$UInt64$zero, $author$project$UInt64$zero) : $elm$core$List$foldl_fn_unwrapped(function (n, _v0) {
            var div_ = _v0.a;
            var mod_ = _v0.b;
            var newMod = $author$project$UInt64$setBit_fn(0, $author$project$UInt64$getBit_fn(n, dividend), $author$project$UInt64$shiftLeftBy_fn(1, mod_));
            return (!(!$author$project$UInt64$compare_fn(newMod, divisor))) ? _Utils_Tuple2($author$project$UInt64$setBit_fn(n, 1, div_), $author$project$UInt64$sub_fn(newMod, divisor)) : _Utils_Tuple2(div_, newMod);
        }, _Utils_Tuple2($author$project$UInt64$zero, $author$project$UInt64$zero), $elm$core$List$reverse($elm$core$List$range_fn(0, 63)));
    }, $author$project$UInt64$divModSlow = F2($author$project$UInt64$divModSlow_fn);
    var $author$project$UInt64$isSafe = function (_v0) {
        var _v1 = _v0;
        var high = _v1.a;
        return _Utils_cmp(high, $author$project$UInt64$maxSafeHighPart) < 1;
    };
    var $author$project$UInt64$divMod_fn = function (dividend, divisor) {
        var _v0 = divisor;
        var divisorHigh = _v0.a;
        var divisorMid = _v0.b;
        var divisorLow = _v0.c;
        if ((divisorMid <= 31) && (!divisorHigh)) {
            if ((!divisorLow) && (!divisorMid)) {
                return _Utils_Tuple2($author$project$UInt64$zero, $author$project$UInt64$zero);
            }
            else {
                var divisorFloat = $author$project$UInt64$toFloat(divisor);
                var _v1 = dividend;
                var _v2 = _v1;
                var dividendHigh = _v2.a;
                var dividendMid = _v2.b;
                var dividendLow = _v2.c;
                var dividendHighMid = (dividendHigh * $author$project$UInt64$limit24) + dividendMid;
                var quotHighMid = $elm$core$Basics$floor(dividendHighMid / divisorFloat);
                var highMidCarry = dividendHighMid - (divisorFloat * quotHighMid);
                var highMidCarryWithLow = (highMidCarry * $author$project$UInt64$limit24) + dividendLow;
                var quotLow = $elm$core$Basics$floor(highMidCarryWithLow / divisorFloat);
                var modMidLow = highMidCarryWithLow - (divisorFloat * quotLow);
                var modMid = $elm$core$Basics$floor(modMidLow / $author$project$UInt64$limit24);
                var modLow = $elm$core$Basics$floor(modMidLow) - (modMid * $author$project$UInt64$limit24);
                var quotHigh = $elm$core$Basics$floor(quotHighMid / $author$project$UInt64$limit24);
                var quotMid = quotHighMid - (quotHigh * $author$project$UInt64$limit24);
                return _Utils_Tuple2(_Utils_Tuple3(quotHigh, quotMid, quotLow), _Utils_Tuple3(0, modMid, modLow));
            }
        }
        else {
            if ($author$project$UInt64$isSafe(dividend)) {
                var divisorFloat = $author$project$UInt64$toFloat(divisor);
                var dividendFloat = $author$project$UInt64$toFloat(dividend);
                var quotInt = $elm$core$Basics$floor(dividendFloat / divisorFloat);
                var modFloat = dividendFloat - (divisorFloat * quotInt);
                var modHigh = $elm$core$Basics$floor(modFloat / $author$project$UInt64$limit48);
                var modMidLow = modFloat - ($author$project$UInt64$limit48 * modHigh);
                var modMid = $elm$core$Basics$floor(modMidLow / $author$project$UInt64$limit24);
                var modLow = modMidLow - ($author$project$UInt64$limit24 * modMid);
                var quotHigh = $elm$core$Basics$floor(quotInt / $author$project$UInt64$limit48);
                var quotMidLow = quotInt - ($author$project$UInt64$limit48 * quotHigh);
                var quotMid = $elm$core$Basics$floor(quotMidLow / $author$project$UInt64$limit24);
                var quotLow = quotMidLow - ($author$project$UInt64$limit24 * quotMid);
                return _Utils_Tuple2(_Utils_Tuple3(quotHigh, quotMid, quotLow), _Utils_Tuple3(modHigh, modMid, $elm$core$Basics$floor(modLow)));
            }
            else {
                var _v3 = $author$project$UInt64$divModFast_fn(dividend, divisor);
                if (!_v3.$) {
                    var divMod_ = _v3.a;
                    return divMod_;
                }
                else {
                    return $author$project$UInt64$divModSlow_fn(dividend, divisor);
                }
            }
        }
    }, $author$project$UInt64$divMod = F2($author$project$UInt64$divMod_fn);
    var $elm$core$List$repeatHelp_fn = function (result, n, value) {
        repeatHelp: while (true) {
            if (n <= 0) {
                return result;
            }
            else {
                var $temp$result = _List_Cons(value, result), $temp$n = n - 1, $temp$value = value;
                result = $temp$result;
                n = $temp$n;
                value = $temp$value;
                continue repeatHelp;
            }
        }
    }, $elm$core$List$repeatHelp = F3($elm$core$List$repeatHelp_fn);
    var $elm$core$List$repeat_fn = function (n, value) {
        return $elm$core$List$repeatHelp_fn(_List_Nil, n, value);
    }, $elm$core$List$repeat = F2($elm$core$List$repeat_fn);
    var $author$project$UInt64$riskyIntToDecimalIntDigits_fn = function (x, digitCount, digits) {
        riskyIntToDecimalIntDigits: while (true) {
            if (!x) {
                return _Utils_Tuple2(digitCount, digits);
            }
            else {
                var $temp$x = (x / 10) | 0, $temp$digitCount = digitCount + 1, $temp$digits = _List_Cons(_Basics_modBy_fn(10, x), digits);
                x = $temp$x;
                digitCount = $temp$digitCount;
                digits = $temp$digits;
                continue riskyIntToDecimalIntDigits;
            }
        }
    }, $author$project$UInt64$riskyIntToDecimalIntDigits = F3($author$project$UInt64$riskyIntToDecimalIntDigits_fn);
    var $author$project$UInt64$toDecimalIntDigits = function (x) {
        var divisorInt = 10000000;
        var divisor = _Utils_Tuple3(0, 0, divisorInt);
        var _v0 = $author$project$UInt64$divMod_fn(x, divisor);
        var highMidDecimal = _v0.a;
        var _v1 = _v0.b;
        var lowDecimal = _v1.c;
        if ($author$project$UInt64$isZero(highMidDecimal)) {
            return $author$project$UInt64$riskyIntToDecimalIntDigits_fn(lowDecimal, 0, _List_Nil);
        }
        else {
            var _v2 = highMidDecimal;
            var _v3 = _v2;
            var highMidDecimal_mid = _v3.b;
            var highMidDecimal_low = _v3.c;
            var highMidDecimalInt = highMidDecimal_low + ($author$project$UInt64$limit24 * highMidDecimal_mid);
            var highDecimal = $elm$core$Basics$floor(highMidDecimalInt / divisorInt);
            var midDecimal = highMidDecimalInt - (divisorInt * highDecimal);
            if (!highDecimal) {
                var _v4 = $author$project$UInt64$riskyIntToDecimalIntDigits_fn(midDecimal, 0, _List_Nil);
                var midCount = _v4.a;
                var midDigits = _v4.b;
                var _v5 = $author$project$UInt64$riskyIntToDecimalIntDigits_fn(lowDecimal, 0, _List_Nil);
                var lowCount = _v5.a;
                var lowDigits = _v5.b;
                return _Utils_Tuple2(midCount + 7, _Utils_ap(midDigits, _Utils_ap($elm$core$List$repeat_fn(7 - lowCount, 0), lowDigits)));
            }
            else {
                var _v6 = $author$project$UInt64$riskyIntToDecimalIntDigits_fn(midDecimal, 0, _List_Nil);
                var midCount = _v6.a;
                var midDigits = _v6.b;
                var _v7 = $author$project$UInt64$riskyIntToDecimalIntDigits_fn(lowDecimal, 0, _List_Nil);
                var lowCount = _v7.a;
                var lowDigits = _v7.b;
                var _v8 = $author$project$UInt64$riskyIntToDecimalIntDigits_fn(highDecimal, 0, _List_Nil);
                var highCount = _v8.a;
                var highDigits = _v8.b;
                return _Utils_Tuple2(highCount + 14, _Utils_ap(highDigits, _Utils_ap($elm$core$List$repeat_fn(7 - midCount, 0), _Utils_ap(midDigits, _Utils_ap($elm$core$List$repeat_fn(7 - lowCount, 0), lowDigits)))));
            }
        }
    };
    var $author$project$UInt64$toIntDigits_fn = function (base, x) {
        var toNonDecimalIntDigits = F3(function (bitsPerDigit, partToDigits, _v3) {
            var _v4 = _v3;
            var high = _v4.a;
            var mid = _v4.b;
            var low = _v4.c;
            if (high > 0) {
                var _v1 = $author$project$UInt64$riskyIntToNonDecimalIntDigits_fn(bitsPerDigit, high, 0, _List_Nil);
                var highCount = _v1.a;
                var highDigits = _v1.b;
                return _Utils_Tuple2(highCount + ((48 / bitsPerDigit) | 0), _Utils_ap(highDigits, _Utils_ap(partToDigits(mid), partToDigits(low))));
            }
            else {
                if (mid > 0) {
                    var _v2 = $author$project$UInt64$riskyIntToNonDecimalIntDigits_fn(bitsPerDigit, mid, 0, _List_Nil);
                    var midCount = _v2.a;
                    var midDigits = _v2.b;
                    return _Utils_Tuple2(midCount + ((24 / bitsPerDigit) | 0), _Utils_ap(midDigits, partToDigits(low)));
                }
                else {
                    return $author$project$UInt64$riskyIntToNonDecimalIntDigits_fn(bitsPerDigit, low, 0, _List_Nil);
                }
            }
        });
        if ($author$project$UInt64$isZero(x)) {
            return _Utils_Tuple2(1, _List_fromArray([0]));
        }
        else {
            switch (base.$) {
                case 0:
                    return $author$project$UInt64$toDecimalIntDigits(x);
                case 1:
                    var partToDigits = function (part) {
                        return _List_fromArray([part >>> 20, 15 & (part >>> 16), 15 & (part >>> 12), 15 & (part >>> 8), 15 & (part >>> 4), 15 & part]);
                    };
                    return A3(toNonDecimalIntDigits, 4, partToDigits, x);
                case 2:
                    var partToDigits = function (part) {
                        return _List_fromArray([part >>> 21, 7 & (part >>> 18), 7 & (part >>> 15), 7 & (part >>> 12), 7 & (part >>> 9), 7 & (part >>> 6), 7 & (part >>> 3), 7 & part]);
                    };
                    return A3(toNonDecimalIntDigits, 3, partToDigits, x);
                default:
                    var partToDigits = function (part) {
                        return _List_fromArray([part >>> 23, 1 & (part >>> 22), 1 & (part >>> 21), 1 & (part >>> 20), 1 & (part >>> 19), 1 & (part >>> 18), 1 & (part >>> 17), 1 & (part >>> 16), 1 & (part >>> 15), 1 & (part >>> 14), 1 & (part >>> 13), 1 & (part >>> 12), 1 & (part >>> 11), 1 & (part >>> 10), 1 & (part >>> 9), 1 & (part >>> 8), 1 & (part >>> 7), 1 & (part >>> 6), 1 & (part >>> 5), 1 & (part >>> 4), 1 & (part >>> 3), 1 & (part >>> 2), 1 & (part >>> 1), 1 & part]);
                    };
                    return A3(toNonDecimalIntDigits, 1, partToDigits, x);
            }
        }
    }, $author$project$UInt64$toIntDigits = F2($author$project$UInt64$toIntDigits_fn);
    var $author$project$UInt64$toString = function (x) {
        var lowDecimalToDigits = function (_v3) {
            var _v4 = _v3;
            var low = _v4.c;
            return $elm$core$String$fromInt(low);
        };
        var highDecimalToDigits = function (_v1) {
            var _v2 = _v1;
            var mid = _v2.b;
            var low = _v2.c;
            return $elm$core$String$fromInt(low + ($author$project$UInt64$limit24 * mid));
        };
        var divisor = _Utils_Tuple3(0, 0, 10000000);
        var _v0 = $author$project$UInt64$divMod_fn(x, divisor);
        var highDecimal = _v0.a;
        var lowDecimal = _v0.b;
        return $author$project$UInt64$isZero(highDecimal) ? lowDecimalToDigits(lowDecimal) : _Utils_ap(highDecimalToDigits(highDecimal), $elm$core$String$padLeft_fn(7, "0", lowDecimalToDigits(lowDecimal)));
    };
    var $author$project$UInt64$toDigits_fn = function (base, x) {
        if ($author$project$UInt64$isZero(x)) {
            return _Utils_Tuple2(1, _List_fromArray(["0"]));
        }
        else {
            switch (base.$) {
                case 0:
                    var digitsStr = $author$project$UInt64$toString(x);
                    return _Utils_Tuple2($elm$core$String$length(digitsStr), $elm$core$String$toList(digitsStr));
                case 1:
                    var upperOrLower = base.a;
                    var _v1 = $author$project$UInt64$toIntDigits_fn(base, x);
                    var _v2 = _v1;
                    var digitCount = _v2.a;
                    var digitsInt = _v2.b;
                    return (!upperOrLower) ? _Utils_Tuple2(digitCount, $elm$core$List$map_fn($author$project$UInt64$riskyIntToUpperCaseDigit, digitsInt)) : _Utils_Tuple2(digitCount, $elm$core$List$map_fn($author$project$UInt64$riskyIntToLowerCaseDigit, digitsInt));
                case 2:
                    var _v3 = $author$project$UInt64$toIntDigits_fn(base, x);
                    var _v4 = _v3;
                    var digitCount = _v4.a;
                    var digitsInt = _v4.b;
                    return _Utils_Tuple2(digitCount, $elm$core$List$map_fn($author$project$UInt64$riskyIntToUpperCaseDigit, digitsInt));
                default:
                    var _v5 = $author$project$UInt64$toIntDigits_fn(base, x);
                    var _v6 = _v5;
                    var digitCount = _v6.a;
                    var digitsInt = _v6.b;
                    return _Utils_Tuple2(digitCount, $elm$core$List$map_fn($author$project$UInt64$riskyIntToUpperCaseDigit, digitsInt));
            }
        }
    }, $author$project$UInt64$toDigits = F2($author$project$UInt64$toDigits_fn);
    var $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn = function (encodeOptions, string) {
        var encodeStandard = function (str) {
            return $elm$core$String$fromList($elm$core$List$concatMap_fn(function (_char) {
                if ($elm$core$Char$isAlphaNum(_char) || (_char === "_")) {
                    return _List_fromArray([_char]);
                }
                else {
                    if ($author$project$DoubleXEncoding$charEncode(_char) !== "\0") {
                        return _List_fromArray([
                            "X",
                            "X",
                            $author$project$DoubleXEncoding$charEncode(_char)
                        ]);
                    }
                    else {
                        var charHex = $author$project$UInt64$digitsToString($author$project$UInt64$toDigits_fn($author$project$UInt64$hexLower, $author$project$UInt64$fromInt($elm$core$Char$toCode(_char))));
                        var charHexEncoded = $elm$core$String$fromList($elm$core$List$map_fn($author$project$DoubleXEncoding$hexShiftEncode, $elm$core$String$toList(charHex)));
                        return ($elm$core$String$length(charHexEncoded) <= 5) ? $elm$core$String$toList("XX" + $elm$core$String$padLeft_fn(5, "a", charHexEncoded)) : (($elm$core$String$length(charHexEncoded) === 6) ? $elm$core$String$toList("XXY" + $elm$core$String$padLeft_fn(6, "a", charHexEncoded)) : $elm$core$String$toList("ERROR: Hex encoding is too long"));
                    }
                }
            }, $elm$core$String$toList(function (txt) {
                return encodeOptions.fj ? $elm$core$String$replace_fn("__", "XXRXXR", txt) : txt;
            }($elm$core$String$replace_fn("XX", "XXXXXX", str)))));
        };
        var encodeDigit = function (digit) {
            return $elm$core$String$fromList(_List_fromArray(["X", "X", "Z", digit]));
        };
        if (encodeOptions.d3) {
            var _v0 = $elm$core$String$toList(string);
            if (!_v0.b) {
                return "";
            }
            else {
                var leadingChar = _v0.a;
                var rest = _v0.b;
                return (!$elm$core$Char$isDigit(leadingChar)) ? encodeStandard(string) : ($elm$core$List$isEmpty(rest) ? encodeDigit(leadingChar) : _Utils_ap(encodeDigit(leadingChar), $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn(_Utils_update(encodeOptions, { d3: false }), $elm$core$String$fromList(rest))));
            }
        }
        else {
            return encodeStandard(string);
        }
    }, $author$project$DoubleXEncoding$doubleXEncodeWithOptions = F2($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn);
    var $author$project$DoubleXEncoding$gqlOptions = { fj: true, d3: true };
    var $author$project$DoubleXEncoding$doubleXEncodeGql_a0 = $author$project$DoubleXEncoding$gqlOptions, $author$project$DoubleXEncoding$doubleXEncodeGql = $author$project$DoubleXEncoding$doubleXEncodeWithOptions($author$project$DoubleXEncoding$doubleXEncodeGql_a0);
    var $ghivert$elm_graphql$GraphQl$Field$Field = $elm$core$Basics$identity;
    var $ghivert$elm_graphql$GraphQl$Field$new = { e_: $elm$core$Maybe$Nothing, dH: _List_Nil, bR: $elm$core$Maybe$Nothing, f2: _List_Nil, gk: _List_Nil };
    var $ghivert$elm_graphql$GraphQl$Field$setId_fn = function (id, _v0) {
        var value = _v0;
        return _Utils_update(value, {
            bR: $elm$core$Maybe$Just(id)
        });
    }, $ghivert$elm_graphql$GraphQl$Field$setId = F2($ghivert$elm_graphql$GraphQl$Field$setId_fn);
    var $ghivert$elm_graphql$GraphQl$field = function (id) {
        return $ghivert$elm_graphql$GraphQl$Field$setId_fn(id, $ghivert$elm_graphql$GraphQl$Field$new);
    };
    var $ghivert$elm_graphql$GraphQl$Argument = $elm$core$Basics$identity;
    var $ghivert$elm_graphql$GraphQl$addArgField = function (_v0) {
        var param = _v0.a;
        var operation = _v0.b;
        return param + (": " + operation);
    };
    var $ghivert$elm_graphql$Helpers$betweenBraces = function (string) {
        return "{" + (string + "}");
    };
    var $ghivert$elm_graphql$GraphQl$argsToString_a0 = $elm$core$List$map($ghivert$elm_graphql$GraphQl$addArgField), $ghivert$elm_graphql$GraphQl$argsToString_a1 = A2($elm$core$Basics$composeR, $elm$core$String$join(", "), $ghivert$elm_graphql$Helpers$betweenBraces), $ghivert$elm_graphql$GraphQl$argsToString = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$argsToString_a0, $ghivert$elm_graphql$GraphQl$argsToString_a1);
    var $ghivert$elm_graphql$GraphQl$input_a0 = $ghivert$elm_graphql$GraphQl$argsToString, $ghivert$elm_graphql$GraphQl$input_a1 = $elm$core$Basics$identity, $ghivert$elm_graphql$GraphQl$input = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1);
    var $ghivert$elm_graphql$GraphQl$int_a0 = $elm$core$String$fromInt, $ghivert$elm_graphql$GraphQl$int_a1 = $elm$core$Basics$identity, $ghivert$elm_graphql$GraphQl$int = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$int_a0, $ghivert$elm_graphql$GraphQl$int_a1);
    var $author$project$GraphGrid$filterInput_fn = function (idxRow, rowidName) {
        var toFilterInput = function (_v0) {
            var key = _v0.a;
            var val = _v0.b;
            return _Utils_Tuple2(key, $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                _Utils_Tuple2("eq", val)
            ])));
        };
        return A2($elm$core$Basics$composeR, A2($author$project$Types$Column$getByNameAt, idxRow, rowidName), A2($elm$core$Basics$composeR, $elm$core$Maybe$andThen($elm$core$String$toInt), A2($elm$core$Basics$composeR, $elm$core$Maybe$map(A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$int, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair(rowidName), toFilterInput))), $elm_community$maybe_extra$Maybe$Extra$toList)));
    }, $author$project$GraphGrid$filterInput = F2($author$project$GraphGrid$filterInput_fn);
    var $author$project$Types$Column$getDataType_fn = function (columns, idx) {
        return $elm$core$Maybe$map_fn(function ($) {
            return $.l$;
        }, $elm_community$list_extra$List$Extra$getAt_fn(idx, columns));
    }, $author$project$Types$Column$getDataType = F2($author$project$Types$Column$getDataType_fn);
    var $author$project$Types$Edit$Edit_fn = function (pos, value, error, isAddition) {
        return { fl: error, jJ: isAddition, eo: pos, pB: value };
    }, $author$project$Types$Edit$Edit = F4($author$project$Types$Edit$Edit_fn);
    var $author$project$Types$Edit$fromString_fn = function (pos, string) {
        return $author$project$Types$Edit$Edit_fn(pos, string, $elm$core$Maybe$Nothing, false);
    }, $author$project$Types$Edit$fromString = F2($author$project$Types$Edit$fromString_fn);
    var $author$project$Types$Edit$toColId_a0 = $author$project$Types$Edit$toIdxCol, $author$project$Types$Edit$toColId_a1 = A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$String$append("col")), $author$project$Types$Edit$toColId = A2($elm$core$Basics$composeR, $author$project$Types$Edit$toColId_a0, $author$project$Types$Edit$toColId_a1);
    var $author$project$Types$Edit$toRowId_a0 = $author$project$Types$Edit$toIdxRow, $author$project$Types$Edit$toRowId_a1 = A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$String$append("row")), $author$project$Types$Edit$toRowId = A2($elm$core$Basics$composeR, $author$project$Types$Edit$toRowId_a0, $author$project$Types$Edit$toRowId_a1);
    var $author$project$Types$Edit$toId = function (edit) {
        return $elm$core$Basics$composeR_fn($author$project$Types$Edit$toRowId_a0, $author$project$Types$Edit$toRowId_a1, edit) + ("_" + $elm$core$Basics$composeR_fn($author$project$Types$Edit$toColId_a0, $author$project$Types$Edit$toColId_a1, edit));
    };
    var $author$project$Types$Edit$idFromPos_a0 = A2($author$project$Util$flip, $author$project$Types$Edit$fromString, ""), $author$project$Types$Edit$idFromPos_a1 = $author$project$Types$Edit$toId, $author$project$Types$Edit$idFromPos = A2($elm$core$Basics$composeR, $author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1);
    var $ghivert$elm_graphql$GraphQl$Operation = $elm$core$Basics$identity;
    var $ghivert$elm_graphql$GraphQl$Field$addSelectorsIn_fn = function (_v0, selectors) {
        var value = _v0;
        return _Utils_update(value, {
            f2: $elm$core$List$append_fn(selectors, value.f2)
        });
    }, $ghivert$elm_graphql$GraphQl$Field$addSelectorsIn = F2($ghivert$elm_graphql$GraphQl$Field$addSelectorsIn_fn);
    var $ghivert$elm_graphql$GraphQl$named = function (id) {
        return A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$Field$addSelectorsIn($ghivert$elm_graphql$GraphQl$Field$new), A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$Field$setId(id), $elm$core$Basics$identity));
    };
    var $ghivert$elm_graphql$GraphQl$OperationQuery = 0;
    var $ghivert$elm_graphql$GraphQl$Request_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $ghivert$elm_graphql$GraphQl$Request = F3($ghivert$elm_graphql$GraphQl$Request_fn);
    var $ghivert$elm_graphql$GraphQl$query = function (query_) {
        return $ghivert$elm_graphql$GraphQl$Request_fn(0, query_, $elm$core$Maybe$Nothing);
    };
    var $elm$core$Result$mapError_fn = function (f, result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            var e = result.a;
            return $elm$core$Result$Err(f(e));
        }
    }, $elm$core$Result$mapError = F2($elm$core$Result$mapError_fn);
    var $elm$http$Http$resolve_fn = function (toResult, response) {
        switch (response.$) {
            case 0:
                var url = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
            case 1:
                return $elm$core$Result$Err($elm$http$Http$Timeout);
            case 2:
                return $elm$core$Result$Err($elm$http$Http$NetworkError);
            case 3:
                var metadata = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.oW));
            default:
                var body = response.b;
                return $elm$core$Result$mapError_fn($elm$http$Http$BadBody, toResult(body));
        }
    }, $elm$http$Http$resolve = F2($elm$http$Http$resolve_fn);
    var $elm$http$Http$expectJson_fn = function (toMsg, decoder) {
        return $elm$http$Http$expectStringResponse_fn(toMsg, $elm$http$Http$resolve(function (string) {
            return $elm$core$Result$mapError_fn($elm$json$Json$Decode$errorToString, _Json_runOnString_fn(decoder, string));
        }));
    }, $elm$http$Http$expectJson = F2($elm$http$Http$expectJson_fn);
    var $ghivert$elm_graphql$Helpers$between_fn = function (_char, string) {
        return _Utils_ap(_char, _Utils_ap(string, _char));
    }, $ghivert$elm_graphql$Helpers$between = F2($ghivert$elm_graphql$Helpers$between_fn);
    var $ghivert$elm_graphql$Helpers$betweenNewline_a0 = "\n", $ghivert$elm_graphql$Helpers$betweenNewline = $ghivert$elm_graphql$Helpers$between($ghivert$elm_graphql$Helpers$betweenNewline_a0);
    var $ghivert$elm_graphql$Helpers$betweenParen = function (string) {
        return "(" + (string + ")");
    };
    var $ghivert$elm_graphql$GraphQl$Field$joinGraphQlArgument = function (_v0) {
        var param = _v0.a;
        var value = _v0.b;
        return param + (": " + value);
    };
    var $ghivert$elm_graphql$GraphQl$Field$addArguments = function (_arguments) {
        return $elm$core$List$isEmpty(_arguments) ? "" : $ghivert$elm_graphql$Helpers$betweenParen($elm$core$String$join_fn(", ", $elm$core$List$map_fn($ghivert$elm_graphql$GraphQl$Field$joinGraphQlArgument, _arguments)));
    };
    var $ghivert$elm_graphql$Helpers$reverseAdd_fn = function (first, second) {
        return _Utils_ap(second, first);
    }, $ghivert$elm_graphql$Helpers$reverseAdd = F2($ghivert$elm_graphql$Helpers$reverseAdd_fn);
    var $ghivert$elm_graphql$GraphQl$Field$addName_a0 = $elm$core$Maybe$map($ghivert$elm_graphql$Helpers$reverseAdd(":")), $ghivert$elm_graphql$GraphQl$Field$addName_a1 = $elm$core$Maybe$withDefault(""), $ghivert$elm_graphql$GraphQl$Field$addName = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$Field$addName_a0, $ghivert$elm_graphql$GraphQl$Field$addName_a1);
    var $ghivert$elm_graphql$GraphQl$Field$encodeName_fn = function (_v0, id) {
        var value = _v0;
        return $ghivert$elm_graphql$Helpers$reverseAdd_fn($ghivert$elm_graphql$GraphQl$Field$addArguments(value.dH), _Utils_ap($elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$Field$addName_a0, $ghivert$elm_graphql$GraphQl$Field$addName_a1, value.e_), id));
    }, $ghivert$elm_graphql$GraphQl$Field$encodeName = F2($ghivert$elm_graphql$GraphQl$Field$encodeName_fn);
    var $ghivert$elm_graphql$GraphQl$Field$addSelectors = function (selectors) {
        return $elm$core$List$isEmpty(selectors) ? "" : $ghivert$elm_graphql$Helpers$betweenBraces($ghivert$elm_graphql$Helpers$between_fn($ghivert$elm_graphql$Helpers$betweenNewline_a0, $elm$core$String$join_fn("\n", $elm$core$List$map_fn($ghivert$elm_graphql$GraphQl$Field$encodeFieldHelp, selectors))));
    };
    var $ghivert$elm_graphql$GraphQl$Field$encodeFieldHelp = function (_v0) {
        var value = _v0;
        return $ghivert$elm_graphql$Helpers$reverseAdd_fn($ghivert$elm_graphql$GraphQl$Field$addSelectors(value.f2), $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($ghivert$elm_graphql$GraphQl$Field$encodeName(value), value.bR)));
    };
    var $ghivert$elm_graphql$GraphQl$Field$swapArgumentsAndVariables = function (_v0) {
        var value = _v0;
        return _Utils_update(value, { dH: value.gk });
    };
    var $ghivert$elm_graphql$GraphQl$Field$unsetAlias = function (_v0) {
        var value = _v0;
        return _Utils_update(value, { e_: $elm$core$Maybe$Nothing });
    };
    var $ghivert$elm_graphql$GraphQl$Field$encodeField = function (value) {
        return $ghivert$elm_graphql$GraphQl$Field$encodeFieldHelp($ghivert$elm_graphql$GraphQl$Field$swapArgumentsAndVariables($ghivert$elm_graphql$GraphQl$Field$unsetAlias(value)));
    };
    var $ghivert$elm_graphql$GraphQl$operationToString = function (requestType) {
        if (requestType === 1) {
            return "mutation ";
        }
        else {
            return "query ";
        }
    };
    var $ghivert$elm_graphql$GraphQl$encodeOperation_fn = function (requestType, _v0) {
        var value = _v0;
        return _Utils_ap($ghivert$elm_graphql$GraphQl$operationToString(requestType), $ghivert$elm_graphql$GraphQl$Field$encodeField(value));
    }, $ghivert$elm_graphql$GraphQl$encodeOperation = F2($ghivert$elm_graphql$GraphQl$encodeOperation_fn);
    var $ghivert$elm_graphql$GraphQl$operationToJson_fn = function (requestType, value, variables) {
        return $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2("query", $elm$json$Json$Encode$string($ghivert$elm_graphql$GraphQl$encodeOperation_fn(requestType, value)))
            ]),
            $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($elm$core$Tuple$pair("variables"), $elm$core$Maybe$map_fn($elm$json$Json$Encode$object, variables))))
        ])));
    }, $ghivert$elm_graphql$GraphQl$operationToJson = F3($ghivert$elm_graphql$GraphQl$operationToJson_fn);
    var $ghivert$elm_graphql$GraphQl$toJson = function (_v0) {
        var requestType = _v0.a;
        var operation = _v0.b;
        var variables = _v0.c;
        return $ghivert$elm_graphql$GraphQl$operationToJson_fn(requestType, operation, variables);
    };
    var $ghivert$elm_graphql$GraphQl$Http$send_fn = function (_v0, msg, decoder, body) {
        var url = _v0.g;
        var headers = _v0.d9;
        return $elm$http$Http$request({
            d: $elm$http$Http$jsonBody($ghivert$elm_graphql$GraphQl$toJson(body)),
            e: $elm$http$Http$expectJson_fn(msg, _Json_decodeField_fn("data", decoder)),
            d9: headers,
            f: "POST",
            eK: $elm$core$Maybe$Nothing,
            eQ: $elm$core$Maybe$Nothing,
            g: url
        });
    }, $ghivert$elm_graphql$GraphQl$Http$send = F4($ghivert$elm_graphql$GraphQl$Http$send_fn);
    var $ghivert$elm_graphql$GraphQl$Field$setAlias_fn = function (alias, _v0) {
        var value = _v0;
        return _Utils_update(value, {
            e_: $elm$core$Maybe$Just(alias)
        });
    }, $ghivert$elm_graphql$GraphQl$Field$setAlias = F2($ghivert$elm_graphql$GraphQl$Field$setAlias_fn);
    var $ghivert$elm_graphql$GraphQl$withAlias_fn = function (alias_, value) {
        return $ghivert$elm_graphql$GraphQl$Field$setAlias_fn(alias_, value);
    }, $ghivert$elm_graphql$GraphQl$withAlias = F2($ghivert$elm_graphql$GraphQl$withAlias_fn);
    var $ghivert$elm_graphql$GraphQl$Field$setArguments_fn = function (_arguments, _v0) {
        var value = _v0;
        return _Utils_update(value, { dH: _arguments });
    }, $ghivert$elm_graphql$GraphQl$Field$setArguments = F2($ghivert$elm_graphql$GraphQl$Field$setArguments_fn);
    var $ghivert$elm_graphql$GraphQl$Field$addInFieldArguments_fn = function (arg, _v0) {
        var value = _v0;
        return $ghivert$elm_graphql$GraphQl$Field$setArguments_fn(_List_Cons(arg, value.dH), value);
    }, $ghivert$elm_graphql$GraphQl$Field$addInFieldArguments = F2($ghivert$elm_graphql$GraphQl$Field$addInFieldArguments_fn);
    var $ghivert$elm_graphql$GraphQl$withArgument_fn = function (name, _v0, value) {
        var content = _v0;
        return $ghivert$elm_graphql$GraphQl$Field$addInFieldArguments_fn(_Utils_Tuple2(name, content), value);
    }, $ghivert$elm_graphql$GraphQl$withArgument = F3($ghivert$elm_graphql$GraphQl$withArgument_fn);
    var $ghivert$elm_graphql$GraphQl$withSelectors_fn = function (selectors, value) {
        return $ghivert$elm_graphql$GraphQl$Field$addSelectorsIn_fn(value, selectors);
    }, $ghivert$elm_graphql$GraphQl$withSelectors = F2($ghivert$elm_graphql$GraphQl$withSelectors_fn);
    var $author$project$GraphGrid$getCells_fn = function (maybeToken, apiUrl, rowidName, tableName, toMsg, columns, positions) {
        if (_Utils_eq(positions, _List_Nil)) {
            return $elm$core$Platform$Cmd$none;
        }
        else {
            var idxColToMaybeColumnName = A2($author$project$Util$flip, $author$project$Types$Column$getNameAt, columns);
            var idxColToSelector = A2($elm$core$Basics$composeR, idxColToMaybeColumnName, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, A2($elm$core$Basics$composeR, $author$project$DoubleXEncoding$doubleXEncodeGql, A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$field, $elm$core$List$singleton))));
            var posToRequest = function (_v1) {
                var idxRow = _v1.a;
                var idxCol = _v1.b;
                return $ghivert$elm_graphql$GraphQl$withSelectors_fn(idxColToSelector(idxCol), $ghivert$elm_graphql$GraphQl$withArgument_fn("filter", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, A3($author$project$GraphGrid$filterInput, idxRow, rowidName, columns)), $ghivert$elm_graphql$GraphQl$withAlias_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1, _Utils_Tuple2(idxRow, idxCol)), $ghivert$elm_graphql$GraphQl$field($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName)))));
            };
            var posToCellUpdateDecoder = function (_v0) {
                var idxRow = _v0.a;
                var idxCol = _v0.b;
                var listHeadDecoder = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$andThen(A2($elm$core$Basics$composeR, $elm$core$List$head, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(""), $elm$json$Json$Decode$succeed))));
                var cellDecoder = $author$project$Types$Cell$decoder($author$project$Types$Column$getDataType_fn(columns, idxCol));
                var fieldDecoder = _Json_decodeField_fn($elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($author$project$DoubleXEncoding$doubleXEncodeGql, idxColToMaybeColumnName(idxCol))), cellDecoder);
                return _Json_map1_fn($elm$core$Tuple$pair(_Utils_Tuple2(idxRow, idxCol)), _Json_decodeField_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1, _Utils_Tuple2(idxRow, idxCol)), listHeadDecoder(fieldDecoder)));
            };
            var cellUpdatesDecoder = $elm$core$List$foldr_fn($elm_community$json_extra$Json$Decode$Extra$combine_a0, $elm_community$json_extra$Json$Decode$Extra$combine_a1, $elm$core$List$map_fn(posToCellUpdateDecoder, positions));
            return $ghivert$elm_graphql$GraphQl$Http$send_fn({
                d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
                g: apiUrl
            }, A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$GetCellsResponded), cellUpdatesDecoder, $ghivert$elm_graphql$GraphQl$query(A2($ghivert$elm_graphql$GraphQl$named, "GetCells", $elm$core$List$map_fn(posToRequest, positions))));
        }
    }, $author$project$GraphGrid$getCells = F7($author$project$GraphGrid$getCells_fn);
    var $author$project$GraphGrid$getGQLErrors_a0 = $krisajenkins$remotedata$RemoteData$toMaybe, $author$project$GraphGrid$getGQLErrors_a1 = A2($elm$core$Basics$composeR, $elm$core$Maybe$andThen($elm_community$result_extra$Result$Extra$error), $elm$core$Maybe$withDefault(_List_Nil)), $author$project$GraphGrid$getGQLErrors = A2($elm$core$Basics$composeR, $author$project$GraphGrid$getGQLErrors_a0, $author$project$GraphGrid$getGQLErrors_a1);
    var $author$project$GraphGrid$getHttpError = function (response) {
        if (response.$ === 2) {
            var httpError = response.a;
            if (httpError.$ === 4) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var otherHttpError = httpError;
                return $elm$core$Maybe$Just(otherHttpError);
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$GraphGrid$GetRowResponded = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$GraphGrid$getRow_fn = function (maybeToken, apiUrl, rowidName, tableName, columns, toMsg, rowId) {
        var fieldsDecoder = $elm$core$List$foldr_fn($elm_community$json_extra$Json$Decode$Extra$combine_a0, $elm_community$json_extra$Json$Decode$Extra$combine_a1, $elm$core$List$map_fn(function (col) {
            return _Json_decodeField_fn($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, col.jx), $author$project$Types$Cell$decoder($elm$core$Maybe$Just(col.l$)));
        }, columns));
        var alias_ = $elm$core$String$replace_fn("-", "_neg_", "rowid" + $elm$core$String$fromInt(rowId));
        var request = $elm$core$List$singleton($ghivert$elm_graphql$GraphQl$withSelectors_fn($elm$core$List$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.jx;
        }, A2($elm$core$Basics$composeR, $author$project$DoubleXEncoding$doubleXEncodeGql, $ghivert$elm_graphql$GraphQl$field)), columns), $ghivert$elm_graphql$GraphQl$withArgument_fn("filter", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
            _Utils_Tuple2(rowidName, $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                _Utils_Tuple2("eq", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$int_a0, $ghivert$elm_graphql$GraphQl$int_a1, rowId))
            ])))
        ])), $ghivert$elm_graphql$GraphQl$withAlias_fn(alias_, $ghivert$elm_graphql$GraphQl$field($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName))))));
        var responseDecoder = _Json_decodeField_fn(alias_, _Json_map1_fn($elm$core$List$concat, $elm$json$Json$Decode$list(fieldsDecoder)));
        return $ghivert$elm_graphql$GraphQl$Http$send_fn({
            d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
            g: apiUrl
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$GetRowResponded), responseDecoder, $ghivert$elm_graphql$GraphQl$query(A2($ghivert$elm_graphql$GraphQl$named, "GetRow", request)));
    }, $author$project$GraphGrid$getRow = F7($author$project$GraphGrid$getRow_fn);
    var $author$project$Types$Edit$hasError = function (edit) {
        return !_Utils_eq(edit.fl, $elm$core$Maybe$Nothing);
    };
    var $author$project$Types$Column$hasStaticValue = function (column) {
        return _Utils_eq(column.mN, $author$project$Types$InputElement$InputFile) && (!$author$project$Types$DataType$isNullable(column.l$));
    };
    var $elm_community$list_extra$List$Extra$updateIfIndex_fn = function (predicate, update, list) {
        return $elm$core$List$indexedMap_fn_unwrapped(function (i, x) {
            return predicate(i) ? update(x) : x;
        }, list);
    }, $elm_community$list_extra$List$Extra$updateIfIndex = F3($elm_community$list_extra$List$Extra$updateIfIndex_fn);
    var $author$project$Util$List$insert_fn = function (idx, val, list) {
        return (idx < 0) ? _List_Cons(val, list) : ((_Utils_cmp(idx, $elm$core$List$length(list) - 1) < 1) ? $elm$core$List$concat($elm_community$list_extra$List$Extra$updateIfIndex_fn($elm$core$Basics$eq(idx), A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([val])), $elm$core$List$map_fn($elm$core$List$singleton, list))) : $elm$core$List$append_fn(list, _List_fromArray([val])));
    }, $author$project$Util$List$insert = F3($author$project$Util$List$insert_fn);
    var $author$project$Types$Column$mapCells_fn = function (mapper, column) {
        return _Utils_update(column, {
            y: $krisajenkins$remotedata$RemoteData$succeed(mapper($krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, column.y)))
        });
    }, $author$project$Types$Column$mapCells = F2($author$project$Types$Column$mapCells_fn);
    var $author$project$Types$Edit$mapString_fn = function (mapper, edit) {
        return _Utils_update(edit, {
            pB: mapper(edit.pB)
        });
    }, $author$project$Types$Edit$mapString = F2($author$project$Types$Edit$mapString_fn);
    var $author$project$GraphGrid$InsertResultReceived_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$GraphGrid$InsertResultReceived = F2($author$project$GraphGrid$InsertResultReceived_fn);
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$Error_fn = function (message, locations, path) {
        return { m8: locations, no: message, ks: path };
    }, $harmboschloo$graphql_to_elm$GraphQL$Errors$Error = F3($harmboschloo$graphql_to_elm$GraphQL$Errors$Error_fn);
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$Location_fn = function (line, column) {
        return { a8: column, m6: line };
    }, $harmboschloo$graphql_to_elm$GraphQL$Errors$Location = F2($harmboschloo$graphql_to_elm$GraphQL$Errors$Location_fn);
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$locationDecoder = _Json_map2_fn($harmboschloo$graphql_to_elm$GraphQL$Errors$Location, _Json_decodeField_fn("line", $elm$json$Json$Decode$int), _Json_decodeField_fn("column", $elm$json$Json$Decode$int));
    var $harmboschloo$graphql_to_elm$GraphQL$Optional$nonNullFieldDecoder_fn = function (name, decoder) {
        return _Json_andThen_fn(function (maybeValue) {
            if (!maybeValue.$) {
                return _Json_map1_fn($elm$core$Maybe$Just, _Json_decodeField_fn(name, decoder));
            }
            else {
                return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
            }
        }, $elm$json$Json$Decode$maybe(_Json_decodeField_fn(name, $elm$json$Json$Decode$value)));
    }, $harmboschloo$graphql_to_elm$GraphQL$Optional$nonNullFieldDecoder = F2($harmboschloo$graphql_to_elm$GraphQL$Optional$nonNullFieldDecoder_fn);
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$FieldName = function (a) {
        return { $: 0, a: a };
    };
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$ListIndex = function (a) {
        return { $: 1, a: a };
    };
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$pathSegmentDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map1_fn($harmboschloo$graphql_to_elm$GraphQL$Errors$ListIndex, $elm$json$Json$Decode$int),
        _Json_map1_fn($harmboschloo$graphql_to_elm$GraphQL$Errors$FieldName, $elm$json$Json$Decode$string)
    ]));
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$errorDecoder = _Json_map3_fn($harmboschloo$graphql_to_elm$GraphQL$Errors$Error, _Json_decodeField_fn("message", $elm$json$Json$Decode$string), $harmboschloo$graphql_to_elm$GraphQL$Optional$nonNullFieldDecoder_fn("locations", $elm$json$Json$Decode$list($harmboschloo$graphql_to_elm$GraphQL$Errors$locationDecoder)), $harmboschloo$graphql_to_elm$GraphQL$Optional$nonNullFieldDecoder_fn("path", $elm$json$Json$Decode$list($harmboschloo$graphql_to_elm$GraphQL$Errors$pathSegmentDecoder)));
    var $harmboschloo$graphql_to_elm$GraphQL$Errors$decoder = $elm$json$Json$Decode$list($harmboschloo$graphql_to_elm$GraphQL$Errors$errorDecoder);
    var $author$project$Types$Column$findIndexByName = function (columnName) {
        return $elm_community$list_extra$List$Extra$findIndex(A2($elm$core$Basics$composeL, $elm$core$Basics$eq(columnName), function ($) {
            return $.jx;
        }));
    };
    var $elm_community$list_extra$List$Extra$indexedFoldr_fn = function (func, acc, list) {
        var step = F2(function (x, _v0) {
            var i = _v0.a;
            var thisAcc = _v0.b;
            return _Utils_Tuple2(i - 1, A3(func, i, x, thisAcc));
        });
        return $elm$core$List$foldr_fn(step, _Utils_Tuple2($elm$core$List$length(list) - 1, acc), list).b;
    }, $elm_community$list_extra$List$Extra$indexedFoldr_fn_unwrapped = function (func, acc, list) {
        var step = F2(function (x, _v0) {
            var i = _v0.a;
            var thisAcc = _v0.b;
            return _Utils_Tuple2(i - 1, func(i, x, thisAcc));
        });
        return $elm$core$List$foldr_fn(step, _Utils_Tuple2($elm$core$List$length(list) - 1, acc), list).b;
    }, $elm_community$list_extra$List$Extra$indexedFoldr = F3($elm_community$list_extra$List$Extra$indexedFoldr_fn);
    var $elm_community$list_extra$List$Extra$findIndices = function (predicate) {
        var consIndexIf = F3(function (index, x, acc) {
            return predicate(x) ? _List_Cons(index, acc) : acc;
        });
        return A2($elm_community$list_extra$List$Extra$indexedFoldr, consIndexIf, _List_Nil);
    };
    var $ghivert$elm_graphql$GraphQl$bool = function (value) {
        if (value) {
            return "true";
        }
        else {
            return "false";
        }
    };
    var $elm_community$maybe_extra$Maybe$Extra$or_fn = function (ma, mb) {
        if (ma.$ === 1) {
            return mb;
        }
        else {
            return ma;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$or = F2($elm_community$maybe_extra$Maybe$Extra$or_fn);
    var $ghivert$elm_graphql$Helpers$betweenQuotes_a0 = "\"", $ghivert$elm_graphql$Helpers$betweenQuotes = $ghivert$elm_graphql$Helpers$between($ghivert$elm_graphql$Helpers$betweenQuotes_a0);
    var $ghivert$elm_graphql$GraphQl$string_a0 = $ghivert$elm_graphql$Helpers$betweenQuotes, $ghivert$elm_graphql$GraphQl$string_a1 = $elm$core$Basics$identity, $ghivert$elm_graphql$GraphQl$string = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$string_a0, $ghivert$elm_graphql$GraphQl$string_a1);
    var $ghivert$elm_graphql$GraphQl$type_ = $elm$core$Basics$identity;
    var $author$project$GraphGrid$encode_fn = function (cell, dataType) {
        var nullIfNullable = $author$project$Types$DataType$isNullable(dataType) ? $elm$core$Maybe$Just($ghivert$elm_graphql$GraphQl$type_("null")) : $elm$core$Maybe$Nothing;
        return $author$project$Types$Cell$unpack_fn($elm$core$Basics$always(nullIfNullable), function () {
            switch (dataType.$) {
                case 0:
                    return A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm$core$Maybe$map($ghivert$elm_graphql$GraphQl$int));
                case 1:
                    return A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$type_, $elm$core$Maybe$Just);
                case 2:
                    return A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$encode(0), A2($elm$core$Basics$composeR, A2($elm$core$String$slice, 1, -1), A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$string, $elm$core$Maybe$Just))));
                case 3:
                    return A2($elm$core$Basics$composeR, $author$project$Util$Bool$fromString, $elm$core$Maybe$map($ghivert$elm_graphql$GraphQl$bool));
                default:
                    var nullability = dataType.a;
                    return $elm$core$Basics$always($elm_community$maybe_extra$Maybe$Extra$or_fn($author$project$GraphGrid$encode_fn(cell, $author$project$Types$DataType$BooleanType(nullability)), $elm_community$maybe_extra$Maybe$Extra$or_fn($author$project$GraphGrid$encode_fn(cell, $author$project$Types$DataType$StringType(nullability)), $elm_community$maybe_extra$Maybe$Extra$or_fn($author$project$GraphGrid$encode_fn(cell, $author$project$Types$DataType$FloatType(nullability)), $author$project$GraphGrid$encode_fn(cell, $author$project$Types$DataType$IntType(nullability))))));
            }
        }(), cell);
    }, $author$project$GraphGrid$encode = F2($author$project$GraphGrid$encode_fn);
    var $author$project$GraphGrid$maybeUpdateArgumentFromEdit_fn = function (columns, edit) {
        var maybeUpdateType = $author$project$Types$Column$getDataType_fn(columns, $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit));
        var maybeCell = function () {
            var maybeIsNullable = $elm$core$Maybe$map_fn($author$project$Types$Column$isNullable, $elm_community$list_extra$List$Extra$getAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit), columns));
            return $elm$core$Maybe$map2_fn($author$project$Types$Cell$fromString, maybeIsNullable, $elm$core$Maybe$Just($author$project$Types$Edit$toString(edit)));
        }();
        return $elm_community$maybe_extra$Maybe$Extra$andThen2_fn($author$project$GraphGrid$encode, maybeCell, maybeUpdateType);
    }, $author$project$GraphGrid$maybeUpdateArgumentFromEdit = F2($author$project$GraphGrid$maybeUpdateArgumentFromEdit_fn);
    var $ghivert$elm_graphql$GraphQl$OperationMutation = 1;
    var $ghivert$elm_graphql$GraphQl$mutation = function (query_) {
        return $ghivert$elm_graphql$GraphQl$Request_fn(1, query_, $elm$core$Maybe$Nothing);
    };
    var $ghivert$elm_graphql$Helpers$betweenBrackets = function (string) {
        return "[" + (string + "]");
    };
    var $ghivert$elm_graphql$GraphQl$nestedInput_a0 = $elm$core$List$map($ghivert$elm_graphql$GraphQl$argsToString), $ghivert$elm_graphql$GraphQl$nestedInput_a1 = A2($elm$core$Basics$composeR, $elm$core$String$join(", "), A2($elm$core$Basics$composeR, $ghivert$elm_graphql$Helpers$betweenBrackets, $elm$core$Basics$identity)), $ghivert$elm_graphql$GraphQl$nestedInput = A2($elm$core$Basics$composeR, $ghivert$elm_graphql$GraphQl$nestedInput_a0, $ghivert$elm_graphql$GraphQl$nestedInput_a1);
    var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
        if (result.$ === 1) {
            var e = result.a;
            return $krisajenkins$remotedata$RemoteData$Failure(e);
        }
        else {
            var x = result.a;
            return $krisajenkins$remotedata$RemoteData$Success(x);
        }
    };
    var $elm$http$Http$riskyRequest = function (r) {
        return $elm$http$Http$command($elm$http$Http$Request({ lw: true, d: r.d, e: r.e, d9: r.d9, f: r.f, eK: r.eK, eQ: r.eQ, g: r.g }));
    };
    var $ohanhi$remotedata_http$RemoteData$Http$performRequest = function (_v0) {
        var risky = _v0.oF;
        return risky ? $elm$http$Http$riskyRequest : $elm$http$Http$request;
    };
    var $ohanhi$remotedata_http$RemoteData$Http$request_fn = function (method, config, url, tagger, decoder, body) {
        return A2($ohanhi$remotedata_http$RemoteData$Http$performRequest, config, {
            d: body,
            e: $elm$http$Http$expectJson_fn(A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, tagger), decoder),
            d9: config.d9,
            f: method,
            eK: config.eK,
            eQ: config.eQ,
            g: url
        });
    }, $ohanhi$remotedata_http$RemoteData$Http$request = F6($ohanhi$remotedata_http$RemoteData$Http$request_fn);
    var $ohanhi$remotedata_http$RemoteData$Http$requestWithJson_fn = function (method, config, url, tagger, decoder, body) {
        return $ohanhi$remotedata_http$RemoteData$Http$request_fn(method, config, url, tagger, decoder, $elm$http$Http$jsonBody(body));
    }, $ohanhi$remotedata_http$RemoteData$Http$requestWithJson = F6($ohanhi$remotedata_http$RemoteData$Http$requestWithJson_fn);
    var $ohanhi$remotedata_http$RemoteData$Http$postWithConfig_a0 = "POST", $ohanhi$remotedata_http$RemoteData$Http$postWithConfig = $ohanhi$remotedata_http$RemoteData$Http$requestWithJson($ohanhi$remotedata_http$RemoteData$Http$postWithConfig_a0);
    var $author$project$GraphGrid$postWithMaybeToken = function (maybeToken) {
        return $ohanhi$remotedata_http$RemoteData$Http$postWithConfig({
            d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
            oF: false,
            eK: $elm$core$Maybe$Nothing,
            eQ: $elm$core$Maybe$Nothing
        });
    };
    var $elm_community$maybe_extra$Maybe$Extra$traverseHelp_fn = function (f, list, acc) {
        traverseHelp: while (true) {
            if (list.b) {
                var head = list.a;
                var tail = list.b;
                var _v1 = f(head);
                if (!_v1.$) {
                    var a = _v1.a;
                    var $temp$f = f, $temp$list = tail, $temp$acc = _List_Cons(a, acc);
                    f = $temp$f;
                    list = $temp$list;
                    acc = $temp$acc;
                    continue traverseHelp;
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                return $elm$core$Maybe$Just($elm$core$List$reverse(acc));
            }
        }
    }, $elm_community$maybe_extra$Maybe$Extra$traverseHelp = F3($elm_community$maybe_extra$Maybe$Extra$traverseHelp_fn);
    var $elm_community$maybe_extra$Maybe$Extra$traverse_fn = function (f, list) {
        return $elm_community$maybe_extra$Maybe$Extra$traverseHelp_fn(f, list, _List_Nil);
    }, $elm_community$maybe_extra$Maybe$Extra$traverse = F2($elm_community$maybe_extra$Maybe$Extra$traverse_fn);
    var $author$project$GraphGrid$onAdd_fn = function (maybeToken, apiUrl, rowidName, tableName, toMsg, columns, rows) {
        var rowToAlias = $elm_community$list_extra$List$Extra$findMap(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toRowId, $elm$core$Maybe$Just));
        var resultDecoder = function () {
            var dataDecoder = function () {
                var rowDecoder = function () {
                    var toEdit = F2(function (alias_, rowId) {
                        return $elm$core$Maybe$map2_fn_unwrapped(function (idxRow, idxCol) {
                            return $author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), rowId);
                        }, $author$project$Types$Edit$idxRowFromRowId(alias_), A2($author$project$Types$Column$findIndexByName, rowidName, columns));
                    });
                    var rowidDecoder = _Json_decodeField_fn("returning", _Json_decodeIndex_fn(0, _Json_decodeField_fn(rowidName, _Json_map1_fn($elm$core$String$fromInt, $elm$json$Json$Decode$int))));
                    return A2($elm$core$Basics$composeR, rowToAlias, $elm$core$Maybe$map(function (alias_) {
                        return _Json_andThen_fn(A2($elm$core$Basics$composeR, toEdit(alias_), A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(""), $elm$json$Json$Decode$succeed)), _Json_decodeField_fn(alias_, rowidDecoder));
                    }));
                }();
                return $elm$core$List$foldr_fn($elm_community$json_extra$Json$Decode$Extra$combine_a0, $elm_community$json_extra$Json$Decode$Extra$combine_a1, $elm$core$List$filterMap_fn(rowDecoder, rows));
            }();
            return $elm$json$Json$Decode$oneOf(_List_fromArray([
                _Json_map1_fn($elm$core$Result$Err, _Json_decodeField_fn("errors", $harmboschloo$graphql_to_elm$GraphQL$Errors$decoder)),
                _Json_map1_fn($elm$core$Result$Ok, _Json_decodeField_fn("data", dataDecoder))
            ]));
        }();
        var maybeColumnName = function (colIdx) {
            return $elm$core$Maybe$map_fn($author$project$DoubleXEncoding$doubleXEncodeGql, $elm$core$Maybe$map_fn(function ($) {
                return $.jx;
            }, $elm_community$list_extra$List$Extra$getAt_fn(colIdx, columns)));
        };
        var request = function () {
            var generatedCols = A2($elm_community$list_extra$List$Extra$findIndices, function ($) {
                return $.cn;
            }, columns);
            var toParams = function (row) {
                return $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, rowToAlias(row), $elm_community$maybe_extra$Maybe$Extra$traverse_fn(function (edit) {
                    return $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, maybeColumnName($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit)), $author$project$GraphGrid$maybeUpdateArgumentFromEdit_fn(columns, edit));
                }, $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$notMember, generatedCols)), row)));
            };
            return $elm$core$List$map_fn(function (_v0) {
                var alias_ = _v0.a;
                var _arguments = _v0.b;
                return $ghivert$elm_graphql$GraphQl$withSelectors_fn(_List_fromArray([
                    $ghivert$elm_graphql$GraphQl$withSelectors_fn(_List_fromArray([
                        $ghivert$elm_graphql$GraphQl$field(rowidName)
                    ]), $ghivert$elm_graphql$GraphQl$field("returning"))
                ]), $ghivert$elm_graphql$GraphQl$withArgument_fn("objects", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$nestedInput_a0, $ghivert$elm_graphql$GraphQl$nestedInput_a1, _List_fromArray([_arguments])), $ghivert$elm_graphql$GraphQl$withAlias_fn(alias_, $ghivert$elm_graphql$GraphQl$field("insert_" + $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName)))));
            }, $elm$core$List$filterMap_fn(toParams, rows));
        }();
        return A5($author$project$GraphGrid$postWithMaybeToken, maybeToken, apiUrl, A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$InsertResultReceived(rows)), resultDecoder, $ghivert$elm_graphql$GraphQl$toJson($ghivert$elm_graphql$GraphQl$mutation(A2($ghivert$elm_graphql$GraphQl$named, "Insert", request))));
    }, $author$project$GraphGrid$onAdd = F7($author$project$GraphGrid$onAdd_fn);
    var $author$project$GraphGrid$DeleteResultReceived_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $author$project$GraphGrid$DeleteResultReceived = F3($author$project$GraphGrid$DeleteResultReceived_fn);
    var $author$project$GraphGrid$onDelete_fn = function (maybeToken, apiUrl, rowidName, tableName, toMsg, columns, idxRows) {
        var resultDecoder = _Json_decodeField_fn("errors", $harmboschloo$graphql_to_elm$GraphQL$Errors$decoder);
        var idxRowToRequest = function (idxRow) {
            return $ghivert$elm_graphql$GraphQl$withSelectors_fn(_List_fromArray([
                $ghivert$elm_graphql$GraphQl$field("affected_rows")
            ]), $ghivert$elm_graphql$GraphQl$withArgument_fn("filter", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, A3($author$project$GraphGrid$filterInput, idxRow, rowidName, columns)), $ghivert$elm_graphql$GraphQl$withAlias_fn("row" + $elm$core$String$fromInt(idxRow), $ghivert$elm_graphql$GraphQl$field("delete_" + $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName)))));
        };
        return A5($author$project$GraphGrid$postWithMaybeToken, maybeToken, apiUrl, A2($elm$core$Basics$composeL, toMsg, A2($author$project$GraphGrid$DeleteResultReceived, columns, idxRows)), resultDecoder, $ghivert$elm_graphql$GraphQl$toJson($ghivert$elm_graphql$GraphQl$mutation(A2($ghivert$elm_graphql$GraphQl$named, "DeleteRows", $elm$core$List$map_fn(idxRowToRequest, idxRows)))));
    }, $author$project$GraphGrid$onDelete = F7($author$project$GraphGrid$onDelete_fn);
    var $author$project$GraphGrid$ColDeleteResponded_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $author$project$GraphGrid$ColDeleteResponded = F2($author$project$GraphGrid$ColDeleteResponded_fn);
    var $author$project$GraphGrid$onDeleteCol_fn = function (maybeToken, apiUrl, tableName, toMsg, column) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, A2($elm$core$Basics$composeR, $author$project$GraphGrid$ColDeleteResponded(column), toMsg), $elm$json$Json$Decode$succeed(0)),
            f: "DELETE",
            g: $author$project$GraphGrid$apiUrlGqlToRest_fn(apiUrl, tableName, column.jx)
        });
    }, $author$project$GraphGrid$onDeleteCol = F5($author$project$GraphGrid$onDeleteCol_fn);
    var $author$project$GraphGrid$UpdateResultReceived_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $author$project$GraphGrid$UpdateResultReceived = F3($author$project$GraphGrid$UpdateResultReceived_fn);
    var $author$project$GraphGrid$cellUpdateToEdit = function (_v0) {
        var pos = _v0.a;
        var cell = _v0.b;
        return $elm$core$Maybe$map_fn($author$project$Types$Edit$fromString(pos), $author$project$Types$Cell$toMaybeString(cell));
    };
    var $author$project$GraphGrid$maybeUpdateArgumentFromCell_fn = function (columns, idxCol, cell) {
        var maybeUpdateType = $author$project$Types$Column$getDataType_fn(columns, idxCol);
        return $elm$core$Maybe$andThen_fn($author$project$GraphGrid$encode(cell), maybeUpdateType);
    }, $author$project$GraphGrid$maybeUpdateArgumentFromCell = F3($author$project$GraphGrid$maybeUpdateArgumentFromCell_fn);
    var $author$project$GraphGrid$onEdit_fn = function (maybeToken, apiUrl, rowidName, tableName, toMsg, maybeOnChangeRowId, columns, edits, cells) {
        if (_Utils_eq(edits, _List_Nil) && _Utils_eq(cells, _List_Nil)) {
            return $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$GraphGrid$UpdateResultReceived_fn(columns, edits, $krisajenkins$remotedata$RemoteData$Success($elm$core$Result$Ok(0)))));
        }
        else {
            var toRequest = F4(function (idxRow, id, updateField, updateArgument) {
                return $ghivert$elm_graphql$GraphQl$withSelectors_fn(_List_fromArray([
                    $ghivert$elm_graphql$GraphQl$field("affected_rows")
                ]), $ghivert$elm_graphql$GraphQl$withArgument_fn("filter", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, A3($author$project$GraphGrid$filterInput, idxRow, rowidName, columns)), $ghivert$elm_graphql$GraphQl$withArgument_fn("set", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                    _Utils_Tuple2($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, updateField), updateArgument)
                ])), $ghivert$elm_graphql$GraphQl$withAlias_fn(id, $ghivert$elm_graphql$GraphQl$field("update_" + $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName))))));
            });
            var routeUpdateCmd = function () {
                if (maybeOnChangeRowId.$ === 1) {
                    return $elm$core$Platform$Cmd$none;
                }
                else {
                    var onChangeRowId = maybeOnChangeRowId.a;
                    var idxRowid = A2($author$project$Types$Column$findIndexByName, rowidName, columns);
                    var maybeRowidEdit = $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(idxRowid))), edits);
                    var maybeNewRowId = $elm$core$Maybe$andThen_fn($elm$core$String$toInt, $elm$core$Maybe$map_fn($author$project$Types$Edit$toString, maybeRowidEdit));
                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, onChangeRowId, maybeNewRowId);
                }
            }();
            var resultDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
                _Json_map1_fn($elm$core$Result$Err, _Json_decodeField_fn("errors", $harmboschloo$graphql_to_elm$GraphQL$Errors$decoder)),
                $elm$json$Json$Decode$succeed($elm$core$Result$Ok(0))
            ]));
            var getColumn = function (idx) {
                return $elm_community$list_extra$List$Extra$getAt_fn(idx, columns);
            };
            var editToRequest = function (edit) {
                var idxRow = $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit);
                var idxCol = $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit);
                var maybeUpdateField = $elm$core$Maybe$map_fn(function ($) {
                    return $.jx;
                }, getColumn(idxCol));
                var id = $author$project$Types$Edit$toId(edit);
                return $elm$core$Maybe$map2_fn(A2(toRequest, idxRow, id), maybeUpdateField, $author$project$GraphGrid$maybeUpdateArgumentFromEdit_fn(columns, edit));
            };
            var cellsAsEdits = $elm$core$List$filterMap_fn($author$project$GraphGrid$cellUpdateToEdit, cells);
            var cellToRequest = function (_v0) {
                var _v1 = _v0.a;
                var idxRow = _v1.a;
                var idxCol = _v1.b;
                var cell = _v0.b;
                var maybeUpdateField = $elm$core$Maybe$map_fn(function ($) {
                    return $.jx;
                }, getColumn(idxCol));
                var id = $author$project$Types$Edit$toId($author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), ""));
                return $elm$core$Maybe$map2_fn(A2(toRequest, idxRow, id), maybeUpdateField, $author$project$GraphGrid$maybeUpdateArgumentFromCell_fn(columns, idxCol, cell));
            };
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                routeUpdateCmd,
                A5($author$project$GraphGrid$postWithMaybeToken, maybeToken, apiUrl, A2($elm$core$Basics$composeL, toMsg, A2($author$project$GraphGrid$UpdateResultReceived, columns, _Utils_ap(edits, cellsAsEdits))), resultDecoder, $ghivert$elm_graphql$GraphQl$toJson($ghivert$elm_graphql$GraphQl$mutation(A2($ghivert$elm_graphql$GraphQl$named, "UpdateTable", $elm$core$List$append_fn($elm$core$List$filterMap_fn(editToRequest, edits), $elm$core$List$filterMap_fn(cellToRequest, cells))))))
            ]));
        }
    }, $author$project$GraphGrid$onEdit = F9($author$project$GraphGrid$onEdit_fn);
    var $author$project$GraphGrid$ColEditResponded = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Types$InputElement$encoder_a0 = $author$project$Types$InputElement$toJsonString, $author$project$Types$InputElement$encoder_a1 = $elm$json$Json$Encode$string, $author$project$Types$InputElement$encoder = A2($elm$core$Basics$composeR, $author$project$Types$InputElement$encoder_a0, $author$project$Types$InputElement$encoder_a1);
    var $elm_community$maybe_extra$Maybe$Extra$combineHelp_fn = function (list, acc) {
        combineHelp: while (true) {
            if (list.b) {
                var head = list.a;
                var tail = list.b;
                if (!head.$) {
                    var a = head.a;
                    var $temp$list = tail, $temp$acc = _List_Cons(a, acc);
                    list = $temp$list;
                    acc = $temp$acc;
                    continue combineHelp;
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                return $elm$core$Maybe$Just($elm$core$List$reverse(acc));
            }
        }
    }, $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2($elm_community$maybe_extra$Maybe$Extra$combineHelp_fn);
    var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
        return $elm_community$maybe_extra$Maybe$Extra$combineHelp_fn(list, _List_Nil);
    };
    var $author$project$Types$Validations$encoder_fn = function (validations, dataType) {
        var values = validations;
        return $elm$core$Maybe$map_fn($elm$json$Json$Encode$object, $elm_community$maybe_extra$Maybe$Extra$combine(_List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2("type", $elm$json$Json$Encode$string("OneOf"))),
            $elm$core$Maybe$Just($elm$core$Tuple$pair_fn("values", $elm$json$Json$Encode$list_fn(A2($elm$core$Basics$composeR, $author$project$Types$Cell$encoder(dataType), $elm$core$Maybe$withDefault($elm$json$Json$Encode$null)), values)))
        ])));
    }, $author$project$Types$Validations$encoder = F2($author$project$Types$Validations$encoder_fn);
    var $author$project$Types$Validations$fromOptions_fn = function (nullable, optionStrings) {
        var optionCells = function (_v0) {
            return $elm$core$List$map_fn($author$project$Types$Cell$fromString(nullable), $elm$core$List$filterMap_fn($elm_community$string_extra$String$Extra$nonEmpty, $elm$core$List$map_fn($elm$core$String$trim, optionStrings)));
        };
        return ($elm$core$List$length(optionStrings) > 0) ? $elm$core$Maybe$Just(optionCells(0)) : $elm$core$Maybe$Nothing;
    }, $author$project$Types$Validations$fromOptions = F2($author$project$Types$Validations$fromOptions_fn);
    var $author$project$Types$InputElement$hasOptions = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return false;
            case 3:
                return false;
            case 4:
                return true;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return false;
            case 14:
                return false;
            case 15:
                return false;
            case 16:
                return false;
            case 17:
                return false;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Types$DataType$boolToNullability = function (isNullable_) {
        return isNullable_ ? 0 : 1;
    };
    var $author$project$Types$InputElement$toDataType_fn = function (isNullable, inputElement) {
        var nullability = $author$project$Types$DataType$boolToNullability(isNullable);
        switch (inputElement.$) {
            case 0:
                return $elm$core$Maybe$Just($author$project$Types$DataType$IntType(nullability));
            case 1:
                return $elm$core$Maybe$Just($author$project$Types$DataType$FloatType(nullability));
            case 2:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 3:
                return $elm$core$Maybe$Just($author$project$Types$DataType$BooleanType(nullability));
            case 4:
                return $elm$core$Maybe$Just($author$project$Types$DataType$CustomType_fn(nullability, ""));
            case 5:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 6:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 7:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 8:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 9:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 10:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 11:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 12:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 13:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 14:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 15:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 16:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 17:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 18:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 19:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            case 20:
                return $elm$core$Maybe$Just($author$project$Types$DataType$StringType(nullability));
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Types$InputElement$toDataType = F2($author$project$Types$InputElement$toDataType_fn);
    var $author$project$Types$InputElement$toOptions = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return _List_Nil;
            case 1:
                return _List_Nil;
            case 2:
                return _List_Nil;
            case 3:
                return _List_Nil;
            case 4:
                var options = inputElement.a;
                return options;
            case 5:
                return _List_Nil;
            case 6:
                return _List_Nil;
            case 7:
                return _List_Nil;
            case 8:
                return _List_Nil;
            case 9:
                return _List_Nil;
            case 10:
                return _List_Nil;
            case 11:
                return _List_Nil;
            case 12:
                return _List_Nil;
            case 13:
                return _List_Nil;
            case 14:
                return _List_Nil;
            case 15:
                return _List_Nil;
            case 16:
                return _List_Nil;
            case 17:
                return _List_Nil;
            case 18:
                return _List_Nil;
            case 19:
                return _List_Nil;
            case 20:
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Types$ColumnEdit$encoder_fn = function (columns, columnEdit) {
        var maybeRightOf = function () {
            var _v0 = columnEdit.gh;
            if (!_v0.$) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!_v0.a.$) {
                    var origin = _v0.a.a.en;
                    var offset = _v0.a.a.fK;
                    return $elm$core$Maybe$Just($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $elm$core$Maybe$map_fn(function ($) {
                        return $.jx;
                    }, $elm$core$Maybe$andThen_fn(A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$getAt, columns), $elm$core$Maybe$map_fn($elm$core$Basics$add(offset), $author$project$Util$flip_fn($author$project$Types$Column$findIndex, columns, origin))))));
                }
                else {
                    var _v1 = _v0.a;
                    return $elm$core$Maybe$Nothing;
                }
            }
        }();
        var encode = function (inputElement) {
            return $elm$json$Json$Encode$object($elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                $elm$core$Maybe$Just(_Utils_Tuple2("name", $elm$json$Json$Encode$string(columnEdit.M))),
                $elm$core$Maybe$Just(_Utils_Tuple2("inputElement", $elm$core$Basics$composeR_fn($author$project$Types$InputElement$encoder_a0, $author$project$Types$InputElement$encoder_a1, inputElement))),
                $elm$core$Maybe$Just(_Utils_Tuple2("isNonNull", $elm$json$Json$Encode$bool(columnEdit.jL))),
                $elm$core$Maybe$Just(_Utils_Tuple2("isUnique", $elm$json$Json$Encode$bool(columnEdit.hf))),
                $author$project$Types$InputElement$hasOptions(inputElement) ? $elm$core$Maybe$map_fn($elm$core$Tuple$pair("validations"), $elm_community$maybe_extra$Maybe$Extra$join($elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $author$project$Types$InputElement$toDataType_fn(columnEdit.jL, inputElement), $elm$core$Maybe$map_fn($author$project$Types$Validations$encoder, $author$project$Types$Validations$fromOptions_fn(columnEdit.jL, $author$project$Types$InputElement$toOptions(inputElement)))))) : $elm$core$Maybe$Nothing,
                $elm$core$Maybe$map_fn($elm$core$Tuple$pair("rightOf"), maybeRightOf)
            ])));
        };
        return $elm$core$Maybe$map_fn(encode, columnEdit.mN);
    }, $author$project$Types$ColumnEdit$encoder = F2($author$project$Types$ColumnEdit$encoder_fn);
    var $author$project$Types$ColumnEdit$toOriginal = function (columnEdit) {
        var _v0 = columnEdit.gh;
        if (!_v0.$) {
            var column = _v0.a;
            return $elm$core$Maybe$Just(column);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$GraphGrid$onEditCol_fn = function (maybeToken, apiUrl, tableName, columns, toMsg, columnEdit) {
        var _v0 = function () {
            var _v1 = $author$project$Types$ColumnEdit$toOriginal(columnEdit);
            if (_v1.$ === 1) {
                return _Utils_Tuple2("PUT", columnEdit.M);
            }
            else {
                var original = _v1.a;
                return _Utils_Tuple2("PATCH", original.jx);
            }
        }();
        var method = _v0.a;
        var columnName = _v0.b;
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (columnEditEncoded) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: $elm$http$Http$jsonBody(columnEditEncoded),
                e: A2($author$project$Api$expect, A2($elm$core$Basics$composeR, $author$project$GraphGrid$ColEditResponded, toMsg), $author$project$Types$Column$decoder),
                f: method,
                g: $author$project$GraphGrid$apiUrlGqlToRest_fn(apiUrl, tableName, columnName)
            });
        }, $author$project$Types$ColumnEdit$encoder_fn(columns, columnEdit));
    }, $author$project$GraphGrid$onEditCol = F6($author$project$GraphGrid$onEditCol_fn);
    var $author$project$GraphGrid$FileUploadSelected_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$GraphGrid$FileUploadSelected = F2($author$project$GraphGrid$FileUploadSelected_fn);
    var $author$project$GraphGrid$onFileUpload_fn = function (toMsg, edit) {
        return $elm$file$File$Select$file_fn(_List_Nil, A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$FileUploadSelected(edit)));
    }, $author$project$GraphGrid$onFileUpload = F2($author$project$GraphGrid$onFileUpload_fn);
    var $author$project$GraphGrid$ColMoveResponded_fn = function (a, b) {
        return { $: 13, a: a, b: b };
    }, $author$project$GraphGrid$ColMoveResponded = F2($author$project$GraphGrid$ColMoveResponded_fn);
    var $author$project$GraphGrid$onMoveCol_fn = function (maybeToken, apiUrl, tableName, toMsg, columnsOld, colIdxFrom, colIdxTo) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (colFromName) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: function () {
                    var offset = (_Utils_cmp(colIdxTo, colIdxFrom) > 0) ? 0 : (-1);
                    return $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("after", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, A2($author$project$Types$Column$getNameAt, colIdxTo + offset, columnsOld)))
                    ])));
                }(),
                e: A2($author$project$Api$expect, A2($elm$core$Basics$composeR, $author$project$GraphGrid$ColMoveResponded(columnsOld), toMsg), $elm$json$Json$Decode$succeed(0)),
                f: "PATCH",
                g: $author$project$GraphGrid$apiUrlGqlToRest_fn(apiUrl, tableName, colFromName)
            });
        }, A2($author$project$Types$Column$getNameAt, colIdxFrom, columnsOld));
    }, $author$project$GraphGrid$onMoveCol = F7($author$project$GraphGrid$onMoveCol_fn);
    var $author$project$GraphGrid$ColRenameResponded_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$GraphGrid$ColRenameResponded = F2($author$project$GraphGrid$ColRenameResponded_fn);
    var $author$project$Types$Column$encoder = function (column) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(column.jx)),
            _Utils_Tuple2("inputElement", $elm$core$Basics$composeR_fn($author$project$Types$InputElement$encoder_a0, $author$project$Types$InputElement$encoder_a1, column.mN)),
            _Utils_Tuple2("isNonNull", $elm$json$Json$Encode$bool($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column))),
            _Utils_Tuple2("isPrimaryKey", $elm$json$Json$Encode$bool(column.co))
        ]));
    };
    var $author$project$Types$Column$setName_fn = function (name, column) {
        return _Utils_update(column, { jx: name });
    }, $author$project$Types$Column$setName = F2($author$project$Types$Column$setName_fn);
    var $author$project$GraphGrid$onRenameCol_fn = function (maybeToken, apiUrl, tableName, toMsg, columnsOld, edit) {
        var maybeColumnOld = $elm_community$list_extra$List$Extra$getAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit), columnsOld);
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (columnOld) {
            return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
                d: $elm$http$Http$jsonBody($author$project$Types$Column$encoder($author$project$Types$Column$setName_fn($author$project$Types$Edit$toString(edit), columnOld))),
                e: A2($author$project$Api$expect, A2($elm$core$Basics$composeR, $author$project$GraphGrid$ColRenameResponded(columnsOld), toMsg), $elm$json$Json$Decode$succeed(0)),
                f: "PATCH",
                g: $author$project$GraphGrid$apiUrlGqlToRest_fn(apiUrl, tableName, columnOld.jx)
            });
        }, maybeColumnOld);
    }, $author$project$GraphGrid$onRenameCol = F6($author$project$GraphGrid$onRenameCol_fn);
    var $elm_community$list_extra$List$Extra$removeIfIndex = function (predicate) {
        return A2($elm_community$list_extra$List$Extra$indexedFoldr, F3(function (index, item, acc) {
            return predicate(index) ? acc : _List_Cons(item, acc);
        }), _List_Nil);
    };
    var $author$project$Types$Column$removeCells_fn = function (idxRowList, column) {
        return _Utils_update(column, {
            y: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$removeIfIndex(A2($author$project$Util$flip, $elm$core$List$member, idxRowList)), column.y)
        });
    }, $author$project$Types$Column$removeCells = F2($author$project$Types$Column$removeCells_fn);
    var $elm$core$Set$map_fn = function (func, set) {
        return $elm$core$Set$fromList($elm$core$Set$foldl_fn_unwrapped(function (x, xs) {
            return _List_Cons(func(x), xs);
        }, _List_Nil, set));
    }, $elm$core$Set$map = F2($elm$core$Set$map_fn);
    var $author$project$EditGrid$removeCollapsedCol_fn = function (idxCol, model) {
        var subModel = model.v;
        return _Utils_update(model, {
            v: _Utils_update(subModel, {
                cc: $elm$core$Set$map_fn(function (idx) {
                    return (_Utils_cmp(idx, idxCol) > 0) ? (idx - 1) : idx;
                }, $elm$core$Set$remove_fn(idxCol, subModel.cc))
            })
        });
    }, $author$project$EditGrid$removeCollapsedCol = F2($author$project$EditGrid$removeCollapsedCol_fn);
    var $author$project$Types$Column$reset = function (column) {
        return _Utils_update(column, {
            y: $krisajenkins$remotedata$RemoteData$map_fn($elm$core$List$map($elm$core$Basics$always($author$project$Types$Column$defaultCell(column))), column.y)
        });
    };
    var $elm_community$list_extra$List$Extra$updateAt_fn = function (index, fn, list) {
        if (index < 0) {
            return list;
        }
        else {
            var tail = $elm$core$List$drop_fn(index, list);
            if (tail.b) {
                var x = tail.a;
                var xs = tail.b;
                return _Utils_ap($elm$core$List$take_fn(index, list), _List_Cons(fn(x), xs));
            }
            else {
                return list;
            }
        }
    }, $elm_community$list_extra$List$Extra$updateAt = F3($elm_community$list_extra$List$Extra$updateAt_fn);
    var $author$project$Types$Column$resetAt = function (idxCol) {
        return A2($elm_community$list_extra$List$Extra$updateAt, idxCol, $author$project$Types$Column$reset);
    };
    var $author$project$GraphGrid$resetColumn_fn = function (maybeToken, apiUrl, rowidName, tableName, columns, column, idxCol, toMsg) {
        var toRequest = function (argument) {
            return $ghivert$elm_graphql$GraphQl$withSelectors_fn(_List_fromArray([
                $ghivert$elm_graphql$GraphQl$field("affected_rows")
            ]), $ghivert$elm_graphql$GraphQl$withArgument_fn("filter", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                _Utils_Tuple2(rowidName, $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                    _Utils_Tuple2("neq", $ghivert$elm_graphql$GraphQl$type_("null"))
                ])))
            ])), $ghivert$elm_graphql$GraphQl$withArgument_fn("set", $elm$core$Basics$composeR_fn($ghivert$elm_graphql$GraphQl$input_a0, $ghivert$elm_graphql$GraphQl$input_a1, _List_fromArray([
                _Utils_Tuple2($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, column.jx), argument)
            ])), $ghivert$elm_graphql$GraphQl$withAlias_fn($author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, column.jx), $ghivert$elm_graphql$GraphQl$field("update_" + $author$project$DoubleXEncoding$doubleXEncodeWithOptions_fn($author$project$DoubleXEncoding$doubleXEncodeGql_a0, tableName))))));
        };
        var resultDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($elm$core$Result$Err, _Json_decodeField_fn("errors", $harmboschloo$graphql_to_elm$GraphQL$Errors$decoder)),
            $elm$json$Json$Decode$succeed($elm$core$Result$Ok(0))
        ]));
        var allCellsAsEdits = $elm$core$List$indexedMap_fn(function (idxRow) {
            return $author$project$Types$Edit$fromString(_Utils_Tuple2(idxRow, idxCol));
        }, $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$Cell$toMaybeString, $elm$core$Maybe$withDefault("")), $elm$core$Basics$composeR_fn($author$project$Types$Column$getCells_a0, $author$project$Types$Column$getCells_a1, column)));
        return A5($author$project$GraphGrid$postWithMaybeToken, maybeToken, apiUrl, A2($elm$core$Basics$composeL, toMsg, A2($author$project$GraphGrid$UpdateResultReceived, columns, allCellsAsEdits)), resultDecoder, $ghivert$elm_graphql$GraphQl$toJson($ghivert$elm_graphql$GraphQl$mutation(A2($ghivert$elm_graphql$GraphQl$named, "ResetColumn", $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn(toRequest, $author$project$GraphGrid$maybeUpdateArgumentFromCell_fn(columns, idxCol, $author$project$Types$Column$defaultCell(column))))))));
    }, $author$project$GraphGrid$resetColumn = F8($author$project$GraphGrid$resetColumn_fn);
    var $author$project$EditGrid$setAdditions_fn = function (rows, model) {
        return _Utils_update(model, {
            K: $elm$core$List$filter_fn($elm$core$Basics$neq(_List_Nil), rows)
        });
    }, $author$project$EditGrid$setAdditions = F2($author$project$EditGrid$setAdditions_fn);
    var $author$project$Types$Column$setCell_fn = function (idxRow, cell, column) {
        return _Utils_update(column, {
            y: $krisajenkins$remotedata$RemoteData$map_fn(A2($elm_community$list_extra$List$Extra$updateAt, idxRow, $elm$core$Basics$always(cell)), column.y)
        });
    }, $author$project$Types$Column$setCell = F3($author$project$Types$Column$setCell_fn);
    var $author$project$EditGrid$setErrors_fn = function (edits, model) {
        return _Utils_update(model, {
            T: $elm$core$List$append_fn(edits, $elm_community$list_extra$List$Extra$filterNot_fn($author$project$Types$Edit$hasError, model.T))
        });
    }, $author$project$EditGrid$setErrors = F2($author$project$EditGrid$setErrors_fn);
    var $author$project$FocusView$setErrors_fn = function (edits, model) {
        return _Utils_update(model, {
            T: $elm$core$List$append_fn(edits, $elm_community$list_extra$List$Extra$filterNot_fn($author$project$Types$Edit$hasError, model.T))
        });
    }, $author$project$FocusView$setErrors = F2($author$project$FocusView$setErrors_fn);
    var $author$project$FocusView$setIdxRow_fn = function (idxRow, model) {
        return _Utils_update(model, {
            ft: $elm$core$Maybe$Just(idxRow)
        });
    }, $author$project$FocusView$setIdxRow = F2($author$project$FocusView$setIdxRow_fn);
    var $author$project$EditGrid$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$EditGrid$setUpdating = F2($author$project$EditGrid$setUpdating_fn);
    var $author$project$FocusView$setUpdating_fn = function (state, model) {
        return _Utils_update(model, { la: state });
    }, $author$project$FocusView$setUpdating = F2($author$project$FocusView$setUpdating_fn);
    var $author$project$Types$ColumnEdit$toIdxInsert_fn = function (columns, columnEdit) {
        var _v0 = columnEdit.gh;
        if (!_v0.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            if (!_v0.a.$) {
                var origin = _v0.a.a.en;
                var offset = _v0.a.a.fK;
                return $elm$core$Maybe$map_fn($elm$core$Basics$add(offset), $author$project$Util$flip_fn($author$project$Types$Column$findIndex, columns, origin));
            }
            else {
                var _v1 = _v0.a;
                return $elm$core$Maybe$Nothing;
            }
        }
    }, $author$project$Types$ColumnEdit$toIdxInsert = F2($author$project$Types$ColumnEdit$toIdxInsert_fn);
    var $author$project$EditGrid$CellEditApplied = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$EditGrid$CellEditUpdated = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$EditGrid$OpenCellAsLink_fn = function (a, b) {
        return { $: 34, a: a, b: b };
    }, $author$project$EditGrid$OpenCellAsLink = F2($author$project$EditGrid$OpenCellAsLink_fn);
    var $author$project$Types$Column$addRow_fn = function (row, columns) {
        return $elm$core$List$indexedMap_fn_unwrapped(function (idxColumn, column) {
            var rowList = $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toString, $author$project$Types$Cell$fromString($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column))), $elm_community$list_extra$List$Extra$getAt_fn(idxColumn, row)));
            return _Utils_update(column, {
                y: $krisajenkins$remotedata$RemoteData$succeed($author$project$Util$flip_fn($elm$core$List$append, rowList, $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, column.y)))
            });
        }, columns);
    }, $author$project$Types$Column$addRow = F2($author$project$Types$Column$addRow_fn);
    var $author$project$EditGrid$SubModel$addRowsSelected_fn = function (rows, sub) {
        return _Utils_update(sub, {
            di: $elm_community$list_extra$List$Extra$unique(_Utils_ap(rows, sub.di))
        });
    }, $author$project$EditGrid$SubModel$addRowsSelected = F2($author$project$EditGrid$SubModel$addRowsSelected_fn);
    var $author$project$EditGrid$CallNumber = function (a) {
        return { $: 32, a: a };
    };
    var $author$project$EditGrid$CellExported_fn = function (a, b, c) {
        return { $: 16, a: a, b: b, c: c };
    }, $author$project$EditGrid$CellExported = F3($author$project$EditGrid$CellExported_fn);
    var $author$project$EditGrid$FocusModeStarted_fn = function (a, b) {
        return { $: 15, a: a, b: b };
    }, $author$project$EditGrid$FocusModeStarted = F2($author$project$EditGrid$FocusModeStarted_fn);
    var $author$project$EditGrid$NoOp = { $: 8 };
    var $author$project$EditGrid$SendEmail = function (a) {
        return { $: 33, a: a };
    };
    var $author$project$EditGrid$SetCell_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$EditGrid$SetCell = F2($author$project$EditGrid$SetCell_fn);
    var $author$project$Types$Cell$hasNonEmptyString = function (cell) {
        if (!cell.$) {
            return false;
        }
        else {
            var string = cell.a;
            return !$elm$core$String$isEmpty(string);
        }
    };
    var $author$project$EditGrid$cellMenuOptions_fn = function (pos, tableType, cell, column) {
        var idxRow = pos.a;
        return $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column) && ((!_Utils_eq($author$project$Types$Cell$isNull_a0, cell)) && ((!column.co) && ($author$project$Types$TableType$isMutable(tableType) && (!column.cn))))), $elm$core$Maybe$Just(_Utils_Tuple3("Set Null", $author$project$EditGrid$SetCell_fn(pos, $author$project$Types$Cell$null), true))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always($elm$core$Basics$composeR_fn($author$project$Types$Column$isString_a0, $author$project$Types$Column$isString_a1, column) && ((!column.co) && (($author$project$Types$Cell$hasNonEmptyString(cell) || _Utils_eq($author$project$Types$Cell$isNull_a0, cell)) && ($author$project$Types$TableType$isMutable(tableType) && ($author$project$Types$Column$isEmptiable(column) && (!column.cn)))))), $elm$core$Maybe$Just(_Utils_Tuple3("Set Empty", $author$project$EditGrid$SetCell_fn(pos, $author$project$Types$Cell$empty), true))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always((!$elm$core$Basics$composeR_fn($author$project$Types$Column$isString_a0, $author$project$Types$Column$isString_a1, column)) && ((!$elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column)) && ((!_Utils_eq(cell, $author$project$Types$Column$defaultCell(column))) && ((!column.co) && ($author$project$Types$TableType$isMutable(tableType) && (!column.cn)))))), $elm$core$Maybe$Just(_Utils_Tuple3("Set Default", $author$project$EditGrid$SetCell_fn(pos, $author$project$Types$Column$defaultCell(column)), true))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always($elm$core$Basics$composeR_fn($author$project$Types$Column$isString_a0, $author$project$Types$Column$isString_a1, column) && $author$project$Types$Cell$hasNonEmptyString(cell)), $elm$core$Maybe$Just(_Utils_Tuple3("Export", $author$project$EditGrid$CellExported_fn(cell, column.jx, idxRow), false))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(_Utils_eq(column.mN, $author$project$Types$InputElement$InputPhone) && $author$project$Types$Cell$hasNonEmptyString(cell)), $elm$core$Maybe$Just(_Utils_Tuple3("Call Number", $author$project$EditGrid$CallNumber(cell), false))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(_Utils_eq(column.mN, $author$project$Types$InputElement$InputEmail) && $author$project$Types$Cell$hasNonEmptyString(cell)), $elm$core$Maybe$Just(_Utils_Tuple3("Send Email", $author$project$EditGrid$SendEmail(cell), false))),
            $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(_Utils_eq(column.mN, $author$project$Types$InputElement$InputUrl) && $author$project$Types$Cell$hasNonEmptyString(cell)), $elm$core$Maybe$map_fn(function (title) {
                return _Utils_Tuple3(title, $author$project$EditGrid$NoOp, false);
            }, $elm$core$Maybe$map_fn($elm$url$Url$toString, $elm$core$Maybe$andThen_fn($elm$url$Url$fromString, $author$project$Types$Cell$toMaybeString(cell))))),
            $elm$core$Maybe$Just(_Utils_Tuple3("Focus", $author$project$EditGrid$FocusModeStarted_fn(idxRow, $elm$core$Maybe$Just($author$project$Types$Edit$idxColFromPos(pos))), false))
        ]));
    }, $author$project$EditGrid$cellMenuOptions = F4($author$project$EditGrid$cellMenuOptions_fn);
    var $author$project$EditGrid$SubModel$clearColDrag = function (sub) {
        return _Utils_update(sub, { bK: $elm$core$Maybe$Nothing });
    };
    var $author$project$EditGrid$SubModel$setRowsSelected_fn = function (rows, sub) {
        return _Utils_update(sub, { di: rows });
    }, $author$project$EditGrid$SubModel$setRowsSelected = F2($author$project$EditGrid$SubModel$setRowsSelected_fn);
    var $author$project$EditGrid$SubModel$clearRowsSelected_a0 = _List_Nil, $author$project$EditGrid$SubModel$clearRowsSelected = $author$project$EditGrid$SubModel$setRowsSelected($author$project$EditGrid$SubModel$clearRowsSelected_a0);
    var $author$project$EditGrid$ColEditApplied = { $: 28 };
    var $author$project$EditGrid$ColEditCanceled = { $: 27 };
    var $author$project$EditGrid$ColEditUpdated = function (a) {
        return { $: 26, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$checked_a0 = "checked", $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0);
    var $author$project$Config$dbObjectRegex = ".*(?!\\.)\\S+";
    var $elm_community$string_extra$String$Extra$changeCase_fn = function (mutator, word) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (_v0) {
            var head = _v0.a;
            var tail = _v0.b;
            return _String_cons_fn(mutator(head), tail);
        }, $elm$core$String$uncons(word)));
    }, $elm_community$string_extra$String$Extra$changeCase = F2($elm_community$string_extra$String$Extra$changeCase_fn);
    var $elm$core$Char$toUpper = _Char_toUpper;
    var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
        return $elm_community$string_extra$String$Extra$changeCase_fn($elm$core$Char$toUpper, word);
    };
    var $elm_community$string_extra$String$Extra$humanize = function (string) {
        return $elm_community$string_extra$String$Extra$toSentenceCase($elm$core$String$toLower($elm$core$String$trim(_Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "_id$|[-_\\s]+"), $elm$core$Basics$always(" "), _Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "[A-Z]+"), A2($elm$core$Basics$composeR, function ($) {
            return $.j_;
        }, $elm$core$String$append("-")), string)))));
    };
    var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
        var uppercaseMatch = A2($elm$regex$Regex$replace, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "\\w+"), A2($elm$core$Basics$composeR, function ($) {
            return $.j_;
        }, $elm_community$string_extra$String$Extra$toSentenceCase));
        return _Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "^([a-z])|\\s+([a-z])"), A2($elm$core$Basics$composeR, function ($) {
            return $.j_;
        }, uppercaseMatch), ws);
    };
    var $author$project$Types$InputElement$toString_a0 = $author$project$Types$InputElement$toJsonString, $author$project$Types$InputElement$toString_a1 = A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "Input", ""), A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$humanize, A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$toTitleCase, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "Iso", "ISO"), A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "Alpha", "Alpha "), A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "Json", "JSON"), A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "Url", "URL"), A2($elm$core$String$replace, "Location", "Location (lat, lng)")))))))), $author$project$Types$InputElement$toString = A2($elm$core$Basics$composeR, $author$project$Types$InputElement$toString_a0, $author$project$Types$InputElement$toString_a1);
    var $author$project$Types$InputElement$fromString = function (name) {
        return $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $author$project$Types$InputElement$toString, $elm$core$Basics$eq(name)), $author$project$Types$InputElement$list);
    };
    var $rtfeldman$elm_css$Html$Styled$Events$targetChecked = $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "checked"]), $elm$json$Json$Decode$bool);
    var $rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("change", _Json_map1_fn(tagger, $rtfeldman$elm_css$Html$Styled$Events$targetChecked));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_end = $rtfeldman$elm_css$Css$property_fn("align-self", "flex-end");
    var $author$project$Types$ColumnEdit$setInputElement_fn = function (columnEdit, inputElement) {
        return _Utils_update(columnEdit, {
            mN: $elm$core$Maybe$Just(inputElement)
        });
    }, $author$project$Types$ColumnEdit$setInputElement = F2($author$project$Types$ColumnEdit$setInputElement_fn);
    var $author$project$Types$ColumnEdit$setIsNonNull_fn = function (columnEdit, isNonNull) {
        return _Utils_update(columnEdit, { jL: isNonNull });
    }, $author$project$Types$ColumnEdit$setIsNonNull = F2($author$project$Types$ColumnEdit$setIsNonNull_fn);
    var $author$project$Types$ColumnEdit$setIsUnique_fn = function (columnEdit, isUnique) {
        return _Utils_update(columnEdit, { hf: isUnique });
    }, $author$project$Types$ColumnEdit$setIsUnique = F2($author$project$Types$ColumnEdit$setIsUnique_fn);
    var $author$project$Types$ColumnEdit$setName_fn = function (columnEdit, name) {
        return _Utils_update(columnEdit, { M: name });
    }, $author$project$Types$ColumnEdit$setName = F2($author$project$Types$ColumnEdit$setName_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$space_x_3 = $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
        $rtfeldman$elm_css$Css$Global$selector_fn(":not([hidden]) ~ :not([hidden])", _List_fromArray([
            $rtfeldman$elm_css$Css$property_fn("--tw-space-x-reverse", "0"),
            $rtfeldman$elm_css$Css$property_fn("margin-right", "calc(0.75rem * var(--tw-space-x-reverse))"),
            $rtfeldman$elm_css$Css$property_fn("margin-left", "calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))")
        ]))
    ]));
    var $author$project$EditGrid$colEditOverlay_fn = function (numRows, _v0) {
        var updating = _v0.la;
        var colEdit = _v0.a7;
        var submitButtonTitle = $elm$core$Maybe$withDefault_fn("Add", $elm$core$Maybe$map_fn($elm$core$Basics$always("Update"), $author$project$Types$ColumnEdit$toOriginal(colEdit)));
        var inputStyles = $rtfeldman$elm_css$Css$batch(_List_fromArray([
            $author$project$Theme$theme.fu,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
        ]));
        var input_ = F4(function (title, value_, setter, styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, $author$project$Overlay$focusId),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0, title),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0, $author$project$Config$dbObjectRegex),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    inputStyles,
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, $author$project$EditGrid$ColEditUpdated, setter))
            ]), _List_Nil);
        });
        var select_ = function (styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$select_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    inputStyles,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, $author$project$EditGrid$ColEditUpdated, A2($elm$core$Basics$composeL, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, colEdit, $author$project$Types$ColumnEdit$setInputElement(colEdit)), $author$project$Types$InputElement$fromString)))
            ]), $elm$core$List$append_fn(_List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, _Utils_eq(colEdit.mN, $elm$core$Maybe$Nothing)),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, true)
                ]), _List_Nil)
            ]), $elm$core$List$map_fn(function (value) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$eq($elm$core$Basics$composeR_fn($author$project$Types$InputElement$toString_a0, $author$project$Types$InputElement$toString_a1, value)), $elm$core$Maybe$map_fn($author$project$Types$InputElement$toString, colEdit.mN))))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$Basics$composeR_fn($author$project$Types$InputElement$toString_a0, $author$project$Types$InputElement$toString_a1, value))
                ]));
            }, $author$project$Types$InputElement$list)));
        };
        var checkbox_ = F4(function (title, state, setter, disabled_) {
            var id_ = $elm$core$String$toLower(title) + "-checkbox";
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$space_x_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_end]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, id_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, state),
                    $rtfeldman$elm_css$Html$Styled$Events$onCheck(setter)
                ]), _List_Nil)
            ]));
        });
        var button_ = F2(function (title, attributes) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$focus(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ])), attributes), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]));
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onSubmit($author$project$EditGrid$ColEditApplied)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_prose,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, updating)
            ]), _List_fromArray([
                A4(input_, "Column name", colEdit.M, $author$project$Types$ColumnEdit$setName(colEdit), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1])),
                select_(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1])),
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (inputElementWithOptions) {
                    return A4(input_, "option1, option2..", $elm$core$String$join_fn(",", $author$project$Types$InputElement$toOptions(inputElementWithOptions)), A2($elm$core$Basics$composeR, $elm$core$String$split(","), A2($elm$core$Basics$composeR, $author$project$Types$InputElement$setOptions(inputElementWithOptions), $author$project$Types$ColumnEdit$setInputElement(colEdit))), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1]));
                }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($author$project$Types$InputElement$hasOptions, colEdit.mN)),
                A4(checkbox_, "Not Null", colEdit.jL, A2($elm$core$Basics$composeR, $author$project$Types$ColumnEdit$setIsNonNull(colEdit), $author$project$EditGrid$ColEditUpdated), colEdit.hf && (numRows > 1)),
                A4(checkbox_, "Unique", colEdit.hf, A2($elm$core$Basics$composeR, $author$project$Types$ColumnEdit$setIsUnique(colEdit), $author$project$EditGrid$ColEditUpdated), colEdit.jL && (numRows > 1)),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ]), _List_fromArray([
                    A2(button_, "Cancel", _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
                        $rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$EditGrid$ColEditCanceled)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto]))
                    ]), _List_fromArray([
                        A2(button_, submitButtonTitle, _List_Nil),
                        $author$project$Util$showElement_fn(updating, $author$project$Svg$spinner(_List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4]))
                        ])))
                    ]))
                ]))
            ]))
        ]));
    }, $author$project$EditGrid$colEditOverlay = F2($author$project$EditGrid$colEditOverlay_fn);
    var $author$project$EditGrid$columnCount = function () {
        var addIndexCellOffset = $elm$core$Basics$add(1);
        return A2($elm$core$Basics$composeR, $elm$core$List$length, addIndexCellOffset);
    }();
    var $author$project$EditGrid$ColCollapseToggled = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$EditGrid$ColDeleted = function (a) {
        return { $: 29, a: a };
    };
    var $author$project$EditGrid$ColEditStarted = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$EditGrid$ColNameEditStarted = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$EditGrid$ColReset_fn = function (a, b) {
        return { $: 30, a: a, b: b };
    }, $author$project$EditGrid$ColReset = F2($author$project$EditGrid$ColReset_fn);
    var $author$project$Types$ColumnEdit$creationLeftOf = function (origin) {
        return $author$project$Types$ColumnEdit$empty($author$project$Types$ColumnEdit$Creation($elm$core$Maybe$Just({ fK: -1, en: origin })));
    };
    var $author$project$Types$ColumnEdit$creationRightOf = function (origin) {
        return $author$project$Types$ColumnEdit$empty($author$project$Types$ColumnEdit$Creation($elm$core$Maybe$Just({ fK: 0, en: origin })));
    };
    var $author$project$Types$Column$findCellIndexes = function (predicate) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Column$getCells, A2($elm$core$Basics$composeR, $elm$core$List$indexedMap(F2(function (idx, cell) {
            return predicate(cell) ? $elm$core$Maybe$Just(idx) : $elm$core$Maybe$Nothing;
        })), $elm_community$maybe_extra$Maybe$Extra$values));
    };
    var $author$project$Types$Column$findNonDefaultCellIndexes = function (column) {
        var _default = $author$project$Types$Column$defaultCell(column);
        return A2($author$project$Types$Column$findCellIndexes, $elm$core$Basics$neq(_default), column);
    };
    var $author$project$Types$ColumnEdit$Modification = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Types$ColumnEdit$fromColumn = function (column) {
        return {
            mN: $elm$core$Maybe$Just(column.mN),
            jL: !$author$project$Types$DataType$isNullable(column.l$),
            hf: column.hf,
            M: column.jx,
            gh: $author$project$Types$ColumnEdit$Modification(column),
            pA: column.pA
        };
    };
    var $author$project$EditGrid$columnMenuOptions_fn = function (model, tableType, column, idxCol, colIsCollapsed) {
        var isReadonly = $author$project$Types$TableType$isReadonly(tableType);
        var allCellsDefault = function (_v0) {
            return _Utils_eq($author$project$Types$Column$findNonDefaultCellIndexes(column), _List_Nil);
        };
        return $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            (model.v.bj || isReadonly) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Rename", $author$project$EditGrid$ColNameEditStarted($author$project$Types$Edit$fromString_fn(_Utils_Tuple2(-1, idxCol), column.jx)), false)),
            ((!model.fh) || (model.v.bj || isReadonly)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Edit", $author$project$EditGrid$ColEditStarted($author$project$Types$ColumnEdit$fromColumn(column)), false)),
            (model.v.bj || isReadonly) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Insert left", $author$project$EditGrid$ColEditStarted($author$project$Types$ColumnEdit$creationLeftOf(column)), false)),
            (model.v.bj || isReadonly) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Insert right", $author$project$EditGrid$ColEditStarted($author$project$Types$ColumnEdit$creationRightOf(column)), false)),
            function () {
                if (model.v.bj || (isReadonly || (column.co || (allCellsDefault(0) || column.cn)))) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var action = _Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$null) ? "Null" : (_Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$empty) ? "Empty" : "Default");
                    return $elm$core$Maybe$Just(_Utils_Tuple3(action + " all cells", $author$project$EditGrid$ColReset_fn(column, idxCol), false));
                }
            }(),
            (model.v.bj || isReadonly) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Delete", $author$project$EditGrid$ColDeleted(idxCol), false)),
            colIsCollapsed ? $elm$core$Maybe$Just(_Utils_Tuple3("Expand", $author$project$EditGrid$ColCollapseToggled(idxCol), false)) : $elm$core$Maybe$Just(_Utils_Tuple3("Collapse", $author$project$EditGrid$ColCollapseToggled(idxCol), false))
        ]));
    }, $author$project$EditGrid$columnMenuOptions = F5($author$project$EditGrid$columnMenuOptions_fn);
    var $author$project$Types$Column$getInputElement_fn = function (columns, idx) {
        return $elm$core$Maybe$map_fn(function ($) {
            return $.mN;
        }, $elm_community$list_extra$List$Extra$getAt_fn(idx, columns));
    }, $author$project$Types$Column$getInputElement = F2($author$project$Types$Column$getInputElement_fn);
    var $author$project$Types$Column$getFirstPrimaryKey_a0 = function ($) {
        return $.co;
    }, $author$project$Types$Column$getFirstPrimaryKey = $elm_community$list_extra$List$Extra$find($author$project$Types$Column$getFirstPrimaryKey_a0);
    var $author$project$Types$Column$getRowId = function (idxRow) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Column$getFirstPrimaryKey, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter(A2($elm$core$Basics$composeR, function ($) {
            return $.jx;
        }, $elm$core$Basics$eq("rowid"))), A2($elm$core$Basics$composeR, $elm$core$Maybe$andThen($author$project$Types$Column$getCell(idxRow)), $elm$core$Maybe$andThen($author$project$Types$Cell$toMaybeString))));
    };
    var $author$project$EditGrid$SubModel$hasCollapsedCol_fn = function (sub, col) {
        return $elm$core$Set$member_fn(col, sub.cc);
    }, $author$project$EditGrid$SubModel$hasCollapsedCol = F2($author$project$EditGrid$SubModel$hasCollapsedCol_fn);
    var $author$project$Types$Column$isNullableAt_fn = function (columns, idxCol) {
        return _Utils_eq($elm$core$Maybe$Just(true), $elm$core$Maybe$map_fn($author$project$Types$DataType$isNullable, $elm$core$Maybe$map_fn(function ($) {
            return $.l$;
        }, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns))));
    }, $author$project$Types$Column$isNullableAt = F2($author$project$Types$Column$isNullableAt_fn);
    var $author$project$Types$Edit$isEmpty_a0 = $author$project$Types$Edit$toString, $author$project$Types$Edit$isEmpty_a1 = $elm$core$String$isEmpty, $author$project$Types$Edit$isEmpty = A2($elm$core$Basics$composeR, $author$project$Types$Edit$isEmpty_a0, $author$project$Types$Edit$isEmpty_a1);
    var $robinheghan$elm_phone_numbers$PhoneNumber$FixedLine = 0;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Mobile = 1;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Uan = 8;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAC = {
        e8: "247",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[01589]\\d|[46])\\d{4}")),
        bR: "AC",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "62889",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[2-467]\\d{3}"))
            },
            {
                mo: "40123",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4\\d{4}"))
            },
            {
                mo: "542011",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0[1-9]|[1589]\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$NoInternationalDialling = 15;
    var $robinheghan$elm_phone_numbers$PhoneNumber$PremiumRate = 3;
    var $robinheghan$elm_phone_numbers$PhoneNumber$TollFree = 2;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAD = {
        e8: "376",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1|6\\d)\\d{7}|[135-9]\\d{5}")),
        bR: "AD",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{4}"))
            },
            {
                mo: "712345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[78]\\d{5}"))
            },
            {
                mo: "312345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("690\\d{6}|[356]\\d{5}"))
            },
            {
                mo: "18001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180[02]\\d{4}"))
            },
            {
                mo: "912345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[19]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$SharedCost = 4;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAE = {
        e8: "971",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}")),
        bR: "AE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-4679][2-8]\\d{6}"))
            },
            {
                mo: "501234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[024-68]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("400\\d{6}|800\\d{2,9}"))
            },
            {
                mo: "900234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[02]\\d{5}"))
            },
            {
                mo: "700012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700[05]\\d{5}"))
            },
            {
                mo: "600212345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("600[25]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAF = {
        e8: "93",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7]\\d{8}")),
        bR: "AF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "234567890",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"))
            },
            {
                mo: "701234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7\\d{8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Pager = 7;
    var $robinheghan$elm_phone_numbers$PhoneNumber$PersonalNumber = 5;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Voip = 6;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAG = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:268|[58]\\d\\d|900)\\d{7}")),
        bR: "AG",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2684601234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"))
            },
            {
                mo: "2684641234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"))
            },
            {
                mo: "2684061234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("26840[69]\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "2684801234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("26848[01]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAI = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:264|[58]\\d\\d|900)\\d{7}")),
        bR: "AI",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2644612345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("264(?:292|4(?:6[12]|9[78]))\\d{4}"))
            },
            {
                mo: "2642351234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"))
            },
            {
                mo: "2647241234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("264724\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAL = {
        e8: "355",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}")),
        bR: "AL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}"))
            },
            {
                mo: "672123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:[78][2-9]|9\\d)\\d{6}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}"))
            },
            {
                mo: "900123",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[1-9]\\d\\d"))
            },
            {
                mo: "808123",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808[1-9]\\d\\d"))
            },
            {
                mo: "70021234",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700[2-9]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAM = {
        e8: "374",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-489]\\d|55|60|77)\\d{6}")),
        bR: "AM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "10123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"))
            },
            {
                mo: "77123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[016]\\d{5}"))
            },
            {
                mo: "80112345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[1-4]\\d{5}"))
            },
            {
                mo: "60271234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|90)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAO = {
        e8: "244",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[29]\\d{8}")),
        bR: "AO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "222123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"))
            },
            {
                mo: "923123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[1-49]\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAR = {
        e8: "54",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("11\\d{8}|(?:[2368]|9\\d)\\d{9}")),
        bR: "AR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("810\\d{7}"))
            },
            {
                mo: "1123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"))
            },
            {
                mo: "91123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "6001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("60[04579]\\d{7}"))
            },
            {
                mo: "8101234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("810\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAS = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|684|900)\\d{7}")),
        bR: "AS",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "6846221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6846(?:22|33|44|55|77|88|9[19])\\d{4}"))
            },
            {
                mo: "6847331234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAT = {
        e8: "43",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}")),
        bR: "AT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1234567890",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"))
            },
            {
                mo: "664123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6,10}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:0[01]|3[019])\\d{6,10}"))
            },
            {
                mo: "810123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:10|2[018])\\d{6,10}|828\\d{5}"))
            },
            {
                mo: "780123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAU = {
        e8: "61",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}")),
        bR: "AU",
        jI: $elm$core$Maybe$Just("001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}"))
            },
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}"))
            },
            {
                mo: "412345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}"))
            },
            {
                mo: "1631234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("163\\d{2,6}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180(?:0\\d{3}|2)\\d{3}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("190[0-26]\\d{6}"))
            },
            {
                mo: "1300123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}"))
            },
            {
                mo: "147101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAW = {
        e8: "297",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[25-79]\\d\\d|800)\\d{4}")),
        bR: "AW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "5212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:2\\d|8[1-9])\\d{4}"))
            },
            {
                mo: "5601234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}"))
            },
            {
                mo: "9001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{4}"))
            },
            {
                mo: "5011234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:28\\d|501)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAX = {
        e8: "358",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}")),
        bR: "AX",
        jI: $elm$core$Maybe$Just("00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "181234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18[1-8]\\d{3,6}"))
            },
            {
                mo: "412345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[0-8]|50)\\d{4,8}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4,6}"))
            },
            {
                mo: "600123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[67]00\\d{5,6}"))
            },
            {
                mo: "10112345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAZ = {
        e8: "994",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("365\\d{6}|(?:[124579]\\d|60|88)\\d{7}")),
        bR: "AZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "123123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}"))
            },
            {
                mo: "401234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}"))
            },
            {
                mo: "881234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88\\d{7}"))
            },
            {
                mo: "900200123",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900200\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBA = {
        e8: "387",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{8}|(?:[35689]\\d|49|70)\\d{6}")),
        bR: "BA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "30212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}"))
            },
            {
                mo: "61123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6040[0-4]\\d{4}|6(?:03|[1-356]|44|7\\d)\\d{6}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[08]\\d{6}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[0246]\\d{6}"))
            },
            {
                mo: "82123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[12]\\d{6}"))
            },
            {
                mo: "70341234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70(?:3[0146]|[56]0)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBB = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:246|[58]\\d\\d|900)\\d{7}")),
        bR: "BB",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2464123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"))
            },
            {
                mo: "2462501234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:246976|900[2-9]\\d\\d)\\d{4}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "2463101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("24631\\d{5}"))
            },
            {
                mo: "2464301234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBD = {
        e8: "880",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}")),
        bR: "BD",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "27111234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2[45]\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"))
            },
            {
                mo: "1812345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[03]\\d{7}"))
            },
            {
                mo: "9604123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBE = {
        e8: "32",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4\\d{8}|[1-9]\\d{7}")),
        bR: "BE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}"))
            },
            {
                mo: "470123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4[5-9]\\d{7}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[1-9]\\d{4}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}"))
            },
            {
                mo: "78791234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7879\\d{4}"))
            },
            {
                mo: "78102345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBF = {
        e8: "226",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[025-7]\\d{7}")),
        bR: "BF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20491234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"))
            },
            {
                mo: "70123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0[127]|5[1-8]|[67]\\d)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBG = {
        e8: "359",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}")),
        bR: "BG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "2123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}"))
            },
            {
                mo: "48123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{6}"))
            },
            {
                mo: "70012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBH = {
        e8: "973",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[136-9]\\d{7}")),
        bR: "BH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "17001234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}"))
            },
            {
                mo: "36001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:87|9[014578])\\d{6}"))
            },
            {
                mo: "84123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("84\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBI = {
        e8: "257",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[267]\\d|31)\\d{6}")),
        bR: "BI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22\\d{6}"))
            },
            {
                mo: "79561234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:29|31|6[1289]|7[125-9])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBJ = {
        e8: "229",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2689]\\d|51)\\d{6}")),
        bR: "BJ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20211234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:02|1[037]|2[45]|3[68])\\d{5}"))
            },
            {
                mo: "90011234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:51|6\\d|9[013-9])\\d{6}"))
            },
            {
                mo: "85751234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("857[58]\\d{4}"))
            },
            {
                mo: "81123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBL = {
        e8: "590",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:590|69\\d|976)\\d{6}")),
        bR: "BL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "590271234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("590(?:2[7-9]|5[12]|87)\\d{4}"))
            },
            {
                mo: "690001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"))
            },
            {
                mo: "976012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("976[01]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBM = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:441|[58]\\d\\d|900)\\d{7}")),
        bR: "BM",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "4414123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"))
            },
            {
                mo: "4413701234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("441(?:[2378]\\d|5[0-39])\\d{5}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBN = {
        e8: "673",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-578]\\d{6}")),
        bR: "BN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"))
            },
            {
                mo: "7123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:22[89]|[78]\\d\\d)\\d{4}"))
            },
            {
                mo: "5345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[34]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBO = {
        e8: "591",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-467]\\d\\d|8001)\\d{5}")),
        bR: "BO",
        jI: $elm$core$Maybe$Just("00(?:1\\d)?"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8001[07]\\d{4}"))
            },
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}"))
            },
            {
                mo: "71234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[67]\\d{7}"))
            },
            {
                mo: "800171234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8001[07]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBQ = {
        e8: "599",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[34]1|7\\d)\\d{5}")),
        bR: "BQ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "7151234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"))
            },
            {
                mo: "3181234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR = {
        e8: "55",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}")),
        bR: "BR",
        jI: $elm$core$Maybe$Just("00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4020\\d{4}|[34]00\\d{5}"))
            },
            {
                mo: "1123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}"))
            },
            {
                mo: "11961234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6,7}"))
            },
            {
                mo: "300123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("300\\d{6}|[59]00\\d{6,7}"))
            },
            {
                mo: "40041234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBS = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:242|[58]\\d\\d|900)\\d{7}")),
        bR: "BS",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2423456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"))
            },
            {
                mo: "2423591234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "2422250123",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("242225\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBT = {
        e8: "975",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[17]\\d{7}|[2-8]\\d{6}")),
        bR: "BT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}"))
            },
            {
                mo: "17123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[67]|77)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBW = {
        e8: "267",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{5}|(?:[2-6]|7\\d)\\d{6}")),
        bR: "BW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2401234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}"))
            },
            {
                mo: "71123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77200\\d{3}|7(?:[1-6]\\d|7[013-9])\\d{5}"))
            },
            {
                mo: "9012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{5}"))
            },
            {
                mo: "79101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBY = {
        e8: "375",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}")),
        bR: "BY",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"))
            },
            {
                mo: "152450911",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}"))
            },
            {
                mo: "294911911",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}"))
            },
            {
                mo: "8011234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"))
            },
            {
                mo: "9021234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:810|902)\\d{7}"))
            },
            {
                mo: "249123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("249\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBZ = {
        e8: "501",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0800\\d|[2-8])\\d{6}")),
        bR: "BZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:236|732)\\d{4}|[2-578][02]\\d{5}"))
            },
            {
                mo: "6221234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[0-35-7]\\d{5}"))
            },
            {
                mo: "08001234123",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-8]\\d|90)\\d{8}")),
        bR: "CA",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "5062345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"))
            },
            {
                mo: "5062345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"))
            },
            {
                mo: "6002012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("600[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCC = {
        e8: "61",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}")),
        bR: "CC",
        jI: $elm$core$Maybe$Just("001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "891621234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}"))
            },
            {
                mo: "412345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180(?:0\\d{3}|2)\\d{3}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("190[0-26]\\d{6}"))
            },
            {
                mo: "1300123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}"))
            },
            {
                mo: "147101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCD = {
        e8: "243",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[189]\\d{8}|[1-68]\\d{6}")),
        bR: "CD",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("12\\d{7}|[1-6]\\d{6}"))
            },
            {
                mo: "991234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88\\d{5}|(?:8[0-2459]|9[017-9])\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCF = {
        e8: "236",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[27]\\d{3}|8776)\\d{4}")),
        bR: "CF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21612345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[12]\\d{6}"))
            },
            {
                mo: "70012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[0257]\\d{6}"))
            },
            {
                mo: "87761234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8776\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCG = {
        e8: "242",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("222\\d{6}|(?:0\\d|80)\\d{7}")),
        bR: "CG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "222123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("222[1-589]\\d{5}"))
            },
            {
                mo: "061234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0[14-6]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:0\\d\\d|11[0-4])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Voicemail = 10;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCH = {
        e8: "41",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{11}|[2-9]\\d{8}")),
        bR: "CH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"))
            },
            {
                mo: "781234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[35-9]\\d{7}"))
            },
            {
                mo: "740123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("74[0248]\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[016]\\d{6}"))
            },
            {
                mo: "840123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("84[0248]\\d{6}"))
            },
            {
                mo: "878123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("878\\d{6}"))
            },
            {
                mo: "581234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[18]\\d{7}"))
            },
            {
                mo: "860123456789",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("860\\d{9}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCI = {
        e8: "225",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[02-9]\\d{7}")),
        bR: "CI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}"))
            },
            {
                mo: "01234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[0-3]80|97[0-3]\\d)\\d{4}|(?:0[1-9]|[457]\\d|6[014-9]|8[4-9]|95)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCK = {
        e8: "682",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-578]\\d{4}")),
        bR: "CK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d|3[13-7]|4[1-5])\\d{3}"))
            },
            {
                mo: "71234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[578]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCL = {
        e8: "56",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}")),
        bR: "CL",
        jI: $elm$core$Maybe$Just("(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("600\\d{7,8}"))
            },
            {
                mo: "221234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:0\\d|1[0-35-9]|2[1-9]|3[0-2]|40)))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}"))
            },
            {
                mo: "221234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:0\\d|1[0-35-9]|2[1-9]|3[0-2]|40)))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:123|8)00\\d{6}"))
            },
            {
                mo: "6001234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("600\\d{7,8}"))
            },
            {
                mo: "441234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("44\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCM = {
        e8: "237",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[26]\\d\\d|88)\\d{6}")),
        bR: "CM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "222123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:22|33)\\d{6}"))
            },
            {
                mo: "671234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:24[23]|6[5-9]\\d)\\d{6}"))
            },
            {
                mo: "88012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCN = {
        e8: "86",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}")),
        bR: "CN",
        jI: $elm$core$Maybe$Just("00|1(?:[12]\\d|79)\\d\\d00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}"))
            },
            {
                mo: "1012345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))"))
            },
            {
                mo: "13123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:10|21)8|8)00\\d{7}"))
            },
            {
                mo: "16812345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("16[08]\\d{5}"))
            },
            {
                mo: "4001234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCO = {
        e8: "57",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d|3)\\d{9}|[124-8]\\d{7}")),
        bR: "CO",
        jI: $elm$core$Maybe$Just("00(?:4(?:[14]4|56)|[579])"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[124-8][2-9]\\d{6}"))
            },
            {
                mo: "3211234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|33(?:00|3[0-24-9])\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}"))
            },
            {
                mo: "18001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{7}"))
            },
            {
                mo: "19001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("19(?:0[01]|4[78])\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR = {
        e8: "506",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}")),
        bR: "CR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}"))
            },
            {
                mo: "83123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[059]\\d{7}"))
            },
            {
                mo: "40001234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:210[0-6]|4\\d{3}|5100)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCU = {
        e8: "53",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}")),
        bR: "CU",
        jI: $elm$core$Maybe$Just("119"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "71234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"))
            },
            {
                mo: "51234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "8071234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("807\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCV = {
        e8: "238",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-59]\\d\\d|800)\\d{4}")),
        bR: "CV",
        jI: $elm$core$Maybe$Just("0"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2211234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"))
            },
            {
                mo: "9911234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[34][36]|5[1-389]|9\\d)\\d{5}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCW = {
        e8: "599",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}")),
        bR: "CW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "94351234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"))
            },
            {
                mo: "95181234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"))
            },
            {
                mo: "95581234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("955\\d{5}"))
            },
            {
                mo: "6001234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("60[0-2]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCX = {
        e8: "61",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}")),
        bR: "CX",
        jI: $elm$core$Maybe$Just("001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "891641234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}"))
            },
            {
                mo: "412345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180(?:0\\d{3}|2)\\d{3}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("190[0-26]\\d{6}"))
            },
            {
                mo: "1300123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}"))
            },
            {
                mo: "147101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCY = {
        e8: "357",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[279]\\d|[58]0)\\d{6}")),
        bR: "CY",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[2-6]\\d{6}"))
            },
            {
                mo: "96123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[4-79]\\d{6}"))
            },
            {
                mo: "80001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[09]\\d{5}"))
            },
            {
                mo: "80112345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[1-9]\\d{5}"))
            },
            {
                mo: "70012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{5}"))
            },
            {
                mo: "77123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:50|77)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCZ = {
        e8: "420",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}")),
        bR: "CZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"))
            },
            {
                mo: "601123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:0[05689]|76)\\d{6}"))
            },
            {
                mo: "811234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[134]\\d{7}"))
            },
            {
                mo: "700123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[01]\\d{6}"))
            },
            {
                mo: "910123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[17]0\\d{6}"))
            },
            {
                mo: "972123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:5\\d|7[2-4])\\d{6}"))
            },
            {
                mo: "93123456789",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:3\\d{9}|6\\d{7,10})"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDE = {
        e8: "49",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}")),
        bR: "DE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "30123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:32|49[4-6]\\d)\\d{9}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}"))
            },
            {
                mo: "15123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}"))
            },
            {
                mo: "16412345",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("16(?:4\\d{1,10}|[89]\\d{1,11})"))
            },
            {
                mo: "8001234567890",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7,12}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:137[7-9]|900(?:[135]|9\\d))\\d{6}"))
            },
            {
                mo: "18012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}"))
            },
            {
                mo: "70012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{8}"))
            },
            {
                mo: "18500123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18(?:1\\d{5,11}|[2-9]\\d{8})"))
            },
            {
                mo: "177991234567",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDJ = {
        e8: "253",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d|77)\\d{6}")),
        bR: "DJ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21360003",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:1[2-5]|7[45])\\d{5}"))
            },
            {
                mo: "77831001",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDK = {
        e8: "45",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-9]\\d{7}")),
        bR: "DK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "32123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"))
            },
            {
                mo: "32123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDM = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|767|900)\\d{7}")),
        bR: "DM",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "7674201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"))
            },
            {
                mo: "7672251234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7]|70[1-6])\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDO = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|900)\\d{7}")),
        bR: "DO",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "8092345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"))
            },
            {
                mo: "8092345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[024]9[2-9]\\d{6}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDZ = {
        e8: "213",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-4]|[5-79]\\d|80)\\d{7}")),
        bR: "DZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}"))
            },
            {
                mo: "551234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5(?:4[0-29]|5\\d|6[01])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "808123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[3-689]1\\d{5}"))
            },
            {
                mo: "801123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[12]1\\d{5}"))
            },
            {
                mo: "983123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("98[23]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEC = {
        e8: "593",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}")),
        bR: "EC",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7][2-7]\\d{6}"))
            },
            {
                mo: "991234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}"))
            },
            {
                mo: "18001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{7}|1[78]00\\d{6}"))
            },
            {
                mo: "28901234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7]890\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEE = {
        e8: "372",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}")),
        bR: "EE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[2-9]\\d{3}"))
            },
            {
                mo: "3212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}"))
            },
            {
                mo: "51234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9]|8[2-4])\\d|7(?:[679]\\d|8[13-9]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"))
            },
            {
                mo: "9001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:40\\d\\d|900)\\d{4}"))
            },
            {
                mo: "70012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[0-2]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEG = {
        e8: "20",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}")),
        bR: "EG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "234567890",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}"))
            },
            {
                mo: "1001234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[0-25]\\d{8}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEH = {
        e8: "212",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[5-8]\\d{8}")),
        bR: "EH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "528812345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("528[89]\\d{5}"))
            },
            {
                mo: "650123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            },
            {
                mo: "891234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("89\\d{7}"))
            },
            {
                mo: "592401234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("592(?:4[0-2]|93)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryER = {
        e8: "291",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[178]\\d{6}")),
        bR: "ER",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "8370362",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"))
            },
            {
                mo: "7123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:17[1-3]|7\\d\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryES = {
        e8: "34",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[5-9]\\d{8}")),
        bR: "ES",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "810123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"))
            },
            {
                mo: "612345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[89]00\\d{6}"))
            },
            {
                mo: "803123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[367]\\d{6}"))
            },
            {
                mo: "901123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[12]\\d{6}"))
            },
            {
                mo: "701234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{7}"))
            },
            {
                mo: "511234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("51\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET = {
        e8: "251",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:11|[2-59]\\d)\\d{7}")),
        bR: "ET",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "111112345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"))
            },
            {
                mo: "911234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFI = {
        e8: "358",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}")),
        bR: "FI",
        jI: $elm$core$Maybe$Just("00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"))
            },
            {
                mo: "131234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}"))
            },
            {
                mo: "412345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[0-8]|50)\\d{4,8}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4,6}"))
            },
            {
                mo: "600123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[67]00\\d{5,6}"))
            },
            {
                mo: "10112345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFJ = {
        e8: "679",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("45\\d{5}|(?:0800\\d|[235-9])\\d{6}")),
        bR: "FJ",
        jI: $elm$core$Maybe$Just("0(?:0|52)"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "3212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}"))
            },
            {
                mo: "7012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[279]\\d|45|5[01568]|8[034679])\\d{5}"))
            },
            {
                mo: "08001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFK = {
        e8: "500",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7]\\d{4}")),
        bR: "FK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "31234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-47]\\d{4}"))
            },
            {
                mo: "51234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[56]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFM = {
        e8: "691",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[39]\\d\\d|820)\\d{4}")),
        bR: "FM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "3201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"))
            },
            {
                mo: "3501234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFO = {
        e8: "298",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-8]\\d|90)\\d{4}")),
        bR: "FO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:20|[34]\\d|8[19])\\d{4}"))
            },
            {
                mo: "211234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[27][1-9]|5\\d)\\d{4}"))
            },
            {
                mo: "802123",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[257-9]\\d{3}"))
            },
            {
                mo: "901123",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"))
            },
            {
                mo: "601234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6[0-36]|88)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFR = {
        e8: "33",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-9]\\d{8}")),
        bR: "FR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-35]\\d|4[1-9])\\d{7}"))
            },
            {
                mo: "612345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{6}|(?:6\\d|7[3-9])\\d{7}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[0-5]\\d{6}"))
            },
            {
                mo: "891123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"))
            },
            {
                mo: "884012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:1[01]|2[0156]|84)\\d{6}"))
            },
            {
                mo: "912345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{8}"))
            },
            {
                mo: "806123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[6-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGA = {
        e8: "241",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}")),
        bR: "GA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "01441234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[01]1\\d{6}"))
            },
            {
                mo: "06031234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB = {
        e8: "44",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}")),
        bR: "GB",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}"))
            },
            {
                mo: "7400123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}"))
            },
            {
                mo: "7640123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[08]\\d{7}|800\\d{6}|8001111"))
            },
            {
                mo: "9012345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d"))
            },
            {
                mo: "7012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{8}"))
            },
            {
                mo: "5612345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56\\d{8}"))
            },
            {
                mo: "5512345678",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[0347]|55)\\d{8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGD = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:473|[58]\\d\\d|900)\\d{7}")),
        bR: "GD",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "4732691234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"))
            },
            {
                mo: "4734031234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGE = {
        e8: "995",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[3-57]\\d\\d|800)\\d{6}")),
        bR: "GE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[67]\\d{6}"))
            },
            {
                mo: "322123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"))
            },
            {
                mo: "555123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:0(?:0(?:0\\d|50)\\d|555[5-9])|(?:111\\d|8(?:58[89]|888))\\d|(?:2222|3333)[0-4]|52(?:00\\d|22[0-4])|75(?:00\\d|7(?:7[7-9]|8[01])))\\d{3}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "706123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[67]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGF = {
        e8: "594",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[56]94|976)\\d{6}")),
        bR: "GF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "594101234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}"))
            },
            {
                mo: "694201234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("694(?:[0-249]\\d|3[0-48])\\d{4}"))
            },
            {
                mo: "976012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("976\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGG = {
        e8: "44",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?")),
        bR: "GG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1481256789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1481[25-9]\\d{5}"))
            },
            {
                mo: "7781123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:(?:781|839)\\d|911[17])\\d{5}"))
            },
            {
                mo: "7640123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[08]\\d{7}|800\\d{6}|8001111"))
            },
            {
                mo: "9012345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d"))
            },
            {
                mo: "7012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{8}"))
            },
            {
                mo: "5612345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56\\d{8}"))
            },
            {
                mo: "5512345678",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[0347]|55)\\d{8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGH = {
        e8: "233",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[235]\\d{3}|800)\\d{5}")),
        bR: "GH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "302345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}"))
            },
            {
                mo: "231234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[0346-8]\\d|5(?:[0457]\\d|6[01]|9[1-6]))\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGI = {
        e8: "350",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[256]\\d{7}")),
        bR: "GI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}"))
            },
            {
                mo: "57123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5[146-8]\\d|6(?:06|29))\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGL = {
        e8: "299",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:19|[2-689]\\d)\\d{4}")),
        bR: "GL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "321000",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}"))
            },
            {
                mo: "221234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[245]\\d{5}"))
            },
            {
                mo: "801234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{4}"))
            },
            {
                mo: "381234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[89]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGM = {
        e8: "220",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-9]\\d{6}")),
        bR: "GM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "5661234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"))
            },
            {
                mo: "3012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[23679]\\d|5[0-389])\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGN = {
        e8: "224",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("722\\d{6}|(?:3|6\\d)\\d{7}")),
        bR: "GN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "30241234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}"))
            },
            {
                mo: "601123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[02356]\\d{7}"))
            },
            {
                mo: "722123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("722\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGP = {
        e8: "590",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:590|69\\d|976)\\d{6}")),
        bR: "GP",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "590201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"))
            },
            {
                mo: "690001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"))
            },
            {
                mo: "976012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("976[01]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGQ = {
        e8: "240",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("222\\d{6}|(?:3\\d|55|[89]0)\\d{7}")),
        bR: "GQ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "333091234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"))
            },
            {
                mo: "222123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:222|55[015])\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d[1-9]\\d{5}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d[1-9]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGR = {
        e8: "30",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5005000\\d{3}|(?:[2689]\\d|70)\\d{8}")),
        bR: "GR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}"))
            },
            {
                mo: "6912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("68[57-9]\\d{7}|(?:69|94)\\d{8}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "9091234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[19]\\d{7}"))
            },
            {
                mo: "8011234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:0[16]|12|[27]5|50)\\d{7}"))
            },
            {
                mo: "7012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{8}"))
            },
            {
                mo: "5005000123",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5005000\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGT = {
        e8: "502",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d{3}|[2-7])\\d{7}")),
        bR: "GT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[267][2-9]\\d{6}"))
            },
            {
                mo: "51234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[3-5]\\d{7}"))
            },
            {
                mo: "18001112222",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18[01]\\d{8}"))
            },
            {
                mo: "19001112222",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("19\\d{9}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGU = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|671|900)\\d{7}")),
        bR: "GU",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "6713001234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"))
            },
            {
                mo: "6713001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGW = {
        e8: "245",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[49]\\d{8}|4\\d{6}")),
        bR: "GW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "443201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("443\\d{6}"))
            },
            {
                mo: "955012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:5\\d|6[569]|77)\\d{6}"))
            },
            {
                mo: "4012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("40\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGY = {
        e8: "592",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}")),
        bR: "GY",
        jI: $elm$core$Maybe$Just("001"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}"))
            },
            {
                mo: "6091234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{6}"))
            },
            {
                mo: "2891234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:289|862)\\d{4}"))
            },
            {
                mo: "9008123",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9008\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHK = {
        e8: "852",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}")),
        bR: "HK",
        jI: $elm$core$Maybe$Just("00(?:30|5[09]|[126-9]?)"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:384[0-5]|58(?:0[1-8]|1[2-9]))\\d{4}|(?:2(?:[13-9]\\d|2[013-9])|3(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69]|89))\\d{5}"))
            },
            {
                mo: "51234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:46(?:[01][0-6]|4[0-57-9])|5730|626[01]|707[1-5]|848[015-9]|929[03-9])\\d{4}|(?:462|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}"))
            },
            {
                mo: "71123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "90012345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900(?:[0-24-9]\\d{7}|3\\d{1,4})"))
            },
            {
                mo: "81123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}"))
            },
            {
                mo: "30161234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHN = {
        e8: "504",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{10}|[237-9]\\d{7}")),
        bR: "HN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8002\\d{7}"))
            },
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:2(?:0[0139]|1[1-36]|[23]\\d|4[04-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}"))
            },
            {
                mo: "91234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[37-9]\\d{7}"))
            },
            {
                mo: "80021234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8002\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHR = {
        e8: "385",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}")),
        bR: "HR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}"))
            },
            {
                mo: "921234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[01]\\d{4,6}"))
            },
            {
                mo: "611234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[01459]\\d{6}|6[01]\\d{4,5}"))
            },
            {
                mo: "74123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[45]\\d{6}"))
            },
            {
                mo: "62123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("62\\d{6,7}|72\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHT = {
        e8: "509",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-489]\\d{7}")),
        bR: "HT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22453300",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:2\\d|5[1-5]|81|9[149])\\d{5}"))
            },
            {
                mo: "34101234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[34]\\d{7}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{7}"))
            },
            {
                mo: "98901234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHU = {
        e8: "36",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[235-7]\\d{8}|[1-9]\\d{7}")),
        bR: "HU",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("06"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[48]0\\d|6802)\\d{5}"))
            },
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}"))
            },
            {
                mo: "201234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[257]0|3[01])\\d{7}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[48]0\\d|6802)\\d{5}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[01]\\d{6}"))
            },
            {
                mo: "211234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("21\\d{7}"))
            },
            {
                mo: "381234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("38\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryID = {
        e8: "62",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}")),
        bR: "ID",
        jI: $elm$core$Maybe$Just("00[189]"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:007803\\d|8071)\\d{6}"))
            },
            {
                mo: "218350123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}"))
            },
            {
                mo: "812345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[1-35-9]\\d{7,10}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("007803\\d{7}|(?:177\\d|800)\\d{5,7}"))
            },
            {
                mo: "8091234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("809\\d{7}"))
            },
            {
                mo: "8041234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("804\\d{7}"))
            },
            {
                mo: "8071123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1500|8071\\d{3})\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIE = {
        e8: "353",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}")),
        bR: "IE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18[59]0\\d{6}"))
            },
            {
                mo: "2212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"))
            },
            {
                mo: "850123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:22|[35-9]\\d)\\d{6}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{6}"))
            },
            {
                mo: "1520123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("15(?:1[2-8]|[2-8]0|9[089])\\d{6}"))
            },
            {
                mo: "1850123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18[59]0\\d{6}"))
            },
            {
                mo: "700123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{6}"))
            },
            {
                mo: "761234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("76\\d{7}"))
            },
            {
                mo: "818123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("818\\d{6}"))
            },
            {
                mo: "8551234567",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIL = {
        e8: "972",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}")),
        bR: "IL",
        jI: $elm$core$Maybe$Just("0(?:0|1[2-9])"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1700\\d{6}"))
            },
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}"))
            },
            {
                mo: "502345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-8]|3[23]|44|5[05689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:255|80[019]\\d{3})\\d{3}"))
            },
            {
                mo: "1919123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}"))
            },
            {
                mo: "1700123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1700\\d{6}"))
            },
            {
                mo: "771234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("78(?:33|55|77|81)\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}"))
            },
            {
                mo: "1599123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1599\\d{6}"))
            },
            {
                mo: "15112340000",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("151\\d{8,9}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIM = {
        e8: "44",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1624\\d{6}|(?:[3578]\\d|90)\\d{8}")),
        bR: "IM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1624756789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1624[5-8]\\d{5}"))
            },
            {
                mo: "7924123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"))
            },
            {
                mo: "8081624567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808162\\d{4}"))
            },
            {
                mo: "9016247890",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"))
            },
            {
                mo: "7012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{8}"))
            },
            {
                mo: "5612345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56\\d{8}"))
            },
            {
                mo: "5512345678",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIN = {
        e8: "91",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}")),
        bR: "IN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"))
            },
            {
                mo: "7410410123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}"))
            },
            {
                mo: "8123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"))
            },
            {
                mo: "1861123456789",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("186[12]\\d{9}"))
            },
            {
                mo: "18603451234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1860\\d{7}"))
            },
            {
                mo: "1409305260",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("140\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIO = {
        e8: "246",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3\\d{6}")),
        bR: "IO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "3709100",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("37\\d{5}"))
            },
            {
                mo: "3801234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("38\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIQ = {
        e8: "964",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}")),
        bR: "IQ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}"))
            },
            {
                mo: "7912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[3-9]\\d{8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIR = {
        e8: "98",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}")),
        bR: "IR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))"))
            },
            {
                mo: "2123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}"))
            },
            {
                mo: "9123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:(?:0(?:[1-35]\\d|4[4-6])|(?:[13]\\d|2[0-2])\\d)\\d|9(?:(?:[0-2]\\d|3[01]|4[45])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|1\\d|21|77|9[6-9])))\\d{5}"))
            },
            {
                mo: "9932123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("993[2-9]\\d{6}"))
            },
            {
                mo: "9601",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIS = {
        e8: "354",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:38\\d|[4-9])\\d{6}")),
        bR: "IS",
        jI: $elm$core$Maybe$Just("00|1(?:0(?:01|[12]0)|100)"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "4101234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}"))
            },
            {
                mo: "6111234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[08]\\d{4}"))
            },
            {
                mo: "9001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}"))
            },
            {
                mo: "4921234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("49[0-24-79]\\d{4}"))
            },
            {
                mo: "8091234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("809\\d{4}"))
            },
            {
                mo: "6891234",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:689|8(?:7[18]|80)|95[48])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIT = {
        e8: "39",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}")),
        bR: "IT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("848\\d{6}"))
            },
            {
                mo: "0212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"))
            },
            {
                mo: "3123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[1-9]\\d{8}|3[2-9]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:0\\d{3}|3)\\d{3}"))
            },
            {
                mo: "899123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}"))
            },
            {
                mo: "848123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("84(?:[08]\\d{3}|[17])\\d{3}"))
            },
            {
                mo: "1781234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:78\\d|99)\\d{6}"))
            },
            {
                mo: "5512345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("55\\d{8}"))
            },
            {
                mo: "33101234501",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[2-8]\\d{9,10}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJE = {
        e8: "44",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1534\\d{6}|(?:[3578]\\d|90)\\d{8}")),
        bR: "JE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1534456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1534[0-24-8]\\d{5}"))
            },
            {
                mo: "7797712345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"))
            },
            {
                mo: "7640123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"))
            },
            {
                mo: "8007354567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:07(?:35|81)|8901)\\d{4}"))
            },
            {
                mo: "9018105678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"))
            },
            {
                mo: "7015115678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("701511\\d{4}"))
            },
            {
                mo: "5612345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56\\d{8}"))
            },
            {
                mo: "5512345678",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJM = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|658|900)\\d{7}")),
        bR: "JM",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "8765230123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:5(?:02|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"))
            },
            {
                mo: "8762101234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:658295|876(?:2(?:[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[13-9]|1[579]|[2-57-9]\\d|6[0-24-9])|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJO = {
        e8: "962",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}")),
        bR: "JO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "62001234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-467]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}"))
            },
            {
                mo: "790123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:[78][0-25-9]|9\\d)\\d{6}"))
            },
            {
                mo: "746612345",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("74(?:66|77)\\d{5}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{7}"))
            },
            {
                mo: "85012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("85\\d{6}"))
            },
            {
                mo: "700123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{7}"))
            },
            {
                mo: "88101234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:10|8\\d)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJP = {
        e8: "81",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}")),
        bR: "JP",
        jI: $elm$core$Maybe$Just("010"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66)\\d{6,13}"))
            },
            {
                mo: "312345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}"))
            },
            {
                mo: "9012345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[7-9]0[1-9]\\d{7}"))
            },
            {
                mo: "2012345678",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20\\d{8}"))
            },
            {
                mo: "120123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00(?:(?:37|66)\\d{6,13}|(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d)|(?:120|800\\d)\\d{6}"))
            },
            {
                mo: "990123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("990\\d{6}"))
            },
            {
                mo: "601234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("60\\d{7}"))
            },
            {
                mo: "5012345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("50[1-9]\\d{7}"))
            },
            {
                mo: "570123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("570\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKE = {
        e8: "254",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}")),
        bR: "KE",
        jI: $elm$core$Maybe$Just("000"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "202012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}"))
            },
            {
                mo: "712123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:0[0-2]|1[0-5])|7\\d\\d)\\d{6}"))
            },
            {
                mo: "800223456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[24-8]\\d{5,6}"))
            },
            {
                mo: "900223456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[02-9]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKG = {
        e8: "996",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{9}|(?:[235-8]\\d|99)\\d{7}")),
        bR: "KG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "312123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}"))
            },
            {
                mo: "700123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:312(?:58\\d|973)|8801\\d\\d)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|99[05-9])\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6,7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKH = {
        e8: "855",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{9}|[1-9]\\d{7,8}")),
        bR: "KH",
        jI: $elm$core$Maybe$Just("00[14-9]"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "23756789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})"))
            },
            {
                mo: "91234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800(?:1\\d|2[019])\\d{4}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1900(?:1\\d|2[09])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKI = {
        e8: "686",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}")),
        bR: "KI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "31234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"))
            },
            {
                mo: "72001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}"))
            },
            {
                mo: "30010000",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("30(?:0[01]\\d\\d|12(?:11|20))\\d\\d"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKM = {
        e8: "269",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[3478]\\d{6}")),
        bR: "KM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "7712345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[4-7]\\d{5}"))
            },
            {
                mo: "3212345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[34]\\d{6}"))
            },
            {
                mo: "8001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKN = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|900)\\d{7}")),
        bR: "KN",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "8692361234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"))
            },
            {
                mo: "8697652917",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKP = {
        e8: "850",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("85\\d{6}|(?:19\\d|[2-7])\\d{7}")),
        bR: "KP",
        jI: $elm$core$Maybe$Just("00|99"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}"))
            },
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"))
            },
            {
                mo: "1921234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("19[1-3]\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKR = {
        e8: "82",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}")),
        bR: "KR",
        jI: $elm$core$Maybe$Just("00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})"))
            },
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}"))
            },
            {
                mo: "1020000000",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}"))
            },
            {
                mo: "1523456789",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("15\\d{7,8}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}"))
            },
            {
                mo: "602345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("60[2-9]\\d{6}"))
            },
            {
                mo: "5012345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("50\\d{8,9}"))
            },
            {
                mo: "7012345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{8}"))
            },
            {
                mo: "15441234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKW = {
        e8: "965",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:18|[2569]\\d\\d)\\d{5}")),
        bR: "KW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}"))
            },
            {
                mo: "50012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5(?:2(?:22|5[25])|88[58])|6(?:222|444|70[013-9]|888|93[039])|9(?:11[01]|333|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}"))
            },
            {
                mo: "1801234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("18\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKY = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:345|[58]\\d\\d|900)\\d{7}")),
        bR: "KY",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "3452221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}"))
            },
            {
                mo: "3453231234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"))
            },
            {
                mo: "3458491234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("345849\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:345976|900[2-9]\\d\\d)\\d{4}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKZ = {
        e8: "7",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("33622\\d{5}|(?:7\\d|80)\\d{8}")),
        bR: "KZ",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("751\\d{7}"))
            },
            {
                mo: "7123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}"))
            },
            {
                mo: "7710009998",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:0[0-25-8]|47|6[02-4]|7[15-8]|85)\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "8091234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("809\\d{7}"))
            },
            {
                mo: "8081234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808\\d{7}"))
            },
            {
                mo: "7511234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("751\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLA = {
        e8: "856",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}")),
        bR: "LA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "21212862",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[13]|[35-7][14]|41|8[1468])\\d{6}"))
            },
            {
                mo: "2023123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}"))
            },
            {
                mo: "301234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("30[013-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLB = {
        e8: "961",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[7-9]\\d{7}|[13-9]\\d{6}")),
        bR: "LB",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:[14-69]\\d|8[02-9])\\d|7(?:[2-57]\\d|62|8[0-7]|9[04-9]))\\d{4}"))
            },
            {
                mo: "71123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[01]\\d{6}"))
            },
            {
                mo: "80123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLC = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|758|900)\\d{7}")),
        bR: "LC",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "7584305678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"))
            },
            {
                mo: "7582845678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLI = {
        e8: "423",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}")),
        bR: "LI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "2345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}"))
            },
            {
                mo: "660234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6(?:4(?:79|[89]\\d)|5[0-4]\\d|6(?:0\\d|10|2[0-26-9]|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"))
            },
            {
                mo: "8002222",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:02[28]|9\\d\\d)\\d\\d"))
            },
            {
                mo: "9002222",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d"))
            },
            {
                mo: "8702812",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("870(?:28|87)\\d\\d"))
            },
            {
                mo: "697861234",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("697(?:42|56|[78]\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLK = {
        e8: "94",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-9]\\d{8}")),
        bR: "LK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "112345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"))
            },
            {
                mo: "712345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[0-25-8]\\d{7}"))
            },
            {
                mo: "197312345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1973\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLR = {
        e8: "231",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}")),
        bR: "LR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d{3}|33333)\\d{4}"))
            },
            {
                mo: "770123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}"))
            },
            {
                mo: "332021234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("332(?:02|[34]\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLS = {
        e8: "266",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[256]\\d\\d|800)\\d{5}")),
        bR: "LS",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d{7}"))
            },
            {
                mo: "50123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[56]\\d{7}"))
            },
            {
                mo: "80021234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[256]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLT = {
        e8: "370",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[3469]\\d|52|[78]0)\\d{6}")),
        bR: "LT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "31234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[1478]|4[124-6]|52)\\d{6}"))
            },
            {
                mo: "61234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{7}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[02]\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:0[0239]|10)\\d{5}"))
            },
            {
                mo: "80812345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808\\d{5}"))
            },
            {
                mo: "70012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[05]\\d{5}"))
            },
            {
                mo: "80123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[89]01\\d{5}"))
            },
            {
                mo: "70712345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[67]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLU = {
        e8: "352",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}")),
        bR: "LU",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "27123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"))
            },
            {
                mo: "628123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:[269][18]|5[158]|7[189]|81)\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[015]\\d{5}"))
            },
            {
                mo: "80112345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("801\\d{5}"))
            },
            {
                mo: "20201234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20(?:1\\d{5}|[2-689]\\d{1,7})"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLV = {
        e8: "371",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[268]\\d|90)\\d{6}")),
        bR: "LV",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "63123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{7}"))
            },
            {
                mo: "21234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d{7}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{6}"))
            },
            {
                mo: "81123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLY = {
        e8: "218",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-9]\\d{8}")),
        bR: "LY",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[1-6]\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMA = {
        e8: "212",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[5-8]\\d{8}")),
        bR: "MA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "520123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"))
            },
            {
                mo: "650123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            },
            {
                mo: "891234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("89\\d{7}"))
            },
            {
                mo: "592401234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("592(?:4[0-2]|93)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMC = {
        e8: "377",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("870\\d{5}|(?:[349]|6\\d)\\d{7}")),
        bR: "MC",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("870\\d{5}"))
            },
            {
                mo: "99123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:870|9[2-47-9]\\d)\\d{5}"))
            },
            {
                mo: "612345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"))
            },
            {
                mo: "90123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMD = {
        e8: "373",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[235-7]\\d|[89]0)\\d{6}")),
        bR: "MD",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"))
            },
            {
                mo: "62112345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("562\\d{5}|(?:6\\d|7[16-9])\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[056]\\d{5}"))
            },
            {
                mo: "80812345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808\\d{5}"))
            },
            {
                mo: "30123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[08]\\d{6}"))
            },
            {
                mo: "80312345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("803\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryME = {
        e8: "382",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}")),
        bR: "ME",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "30234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}"))
            },
            {
                mo: "67622901",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}"))
            },
            {
                mo: "80080002",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:[0-2578]|9\\d)\\d{5}"))
            },
            {
                mo: "94515151",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:4[1568]|5[178])\\d{5}"))
            },
            {
                mo: "78108780",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("78[1-49]\\d{5}"))
            },
            {
                mo: "77273012",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77[1-9]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMF = {
        e8: "590",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:590|69\\d|976)\\d{6}")),
        bR: "MF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "590271234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"))
            },
            {
                mo: "690001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"))
            },
            {
                mo: "976012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("976[01]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMG = {
        e8: "261",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[23]\\d{8}")),
        bR: "MG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "202123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"))
            },
            {
                mo: "321234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[2-49]\\d{7}"))
            },
            {
                mo: "221234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMH = {
        e8: "692",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("329\\d{4}|(?:[256]\\d|45)\\d{5}")),
        bR: "MH",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2471234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:247|528|625)\\d{4}"))
            },
            {
                mo: "2351234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:23|54)5|329|45[56])\\d{4}"))
            },
            {
                mo: "6351234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("635\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMK = {
        e8: "389",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-578]\\d{7}")),
        bR: "MK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"))
            },
            {
                mo: "72345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "50012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[02-9]\\d{6}"))
            },
            {
                mo: "80123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:0[1-9]|[1-9]\\d)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryML = {
        e8: "223",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[24-9]\\d{7}")),
        bR: "ML",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            },
            {
                mo: "20212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"))
            },
            {
                mo: "65012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMM = {
        e8: "95",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}")),
        bR: "MM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}"))
            },
            {
                mo: "92123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}"))
            },
            {
                mo: "8008001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80080(?:[01][1-9]|2\\d)\\d{3}"))
            },
            {
                mo: "13331234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1333\\d{4}|[12]468\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMN = {
        e8: "976",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[12]\\d{7,9}|[57-9]\\d{7}")),
        bR: "MN",
        jI: $elm$core$Maybe$Just("001"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "53123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"))
            },
            {
                mo: "88123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}"))
            },
            {
                mo: "75123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMO = {
        e8: "853",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:28|[68]\\d)\\d{6}")),
        bR: "MO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "28212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}"))
            },
            {
                mo: "66123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:[02][5-9]|[146-8]\\d|[35][0-4]))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMP = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[58]\\d{9}|(?:67|90)0\\d{7}")),
        bR: "MP",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "6702345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"))
            },
            {
                mo: "6702345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMQ = {
        e8: "596",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("69\\d{7}|(?:59|97)6\\d{6}")),
        bR: "MQ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "596301234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("596(?:0[0-7]|10|2[7-9]|3[05-9]|4[0-46-8]|[5-7]\\d|8[09]|9[4-8])\\d{4}"))
            },
            {
                mo: "696201234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}"))
            },
            {
                mo: "976612345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("976(?:6[1-9]|7[0-367])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMR = {
        e8: "222",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-4]\\d\\d|800)\\d{5}")),
        bR: "MR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "35123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:25[08]|35\\d|45[1-7])\\d{5}"))
            },
            {
                mo: "22123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-4][0-46-9]\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMS = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|664|900)\\d{7}")),
        bR: "MS",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "6644912345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6644(?:1[0-3]|91)\\d{4}"))
            },
            {
                mo: "6644923456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMT = {
        e8: "356",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}")),
        bR: "MT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21001234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}"))
            },
            {
                mo: "96961234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"))
            },
            {
                mo: "71171234",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7117\\d{4}"))
            },
            {
                mo: "80071234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[3467]\\d{4}"))
            },
            {
                mo: "50037123",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"))
            },
            {
                mo: "35501234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3550\\d{4}"))
            },
            {
                mo: "50112345",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("501\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMU = {
        e8: "230",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-468]|5\\d)\\d{6}")),
        bR: "MU",
        jI: $elm$core$Maybe$Just("0(?:0|[24-7]0|3[03])"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "54480123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}"))
            },
            {
                mo: "52512345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[589]|4[3-589]|7\\d|8[0-689]|9[0-8])\\d{5}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[0-2]\\d{4}"))
            },
            {
                mo: "3012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("30\\d{5}"))
            },
            {
                mo: "3201234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3(?:20|9\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMV = {
        e8: "960",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}")),
        bR: "MV",
        jI: $elm$core$Maybe$Just("0(?:0|19)"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "6701234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}"))
            },
            {
                mo: "7712345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{7}"))
            },
            {
                mo: "4001234",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4[05]0\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMW = {
        e8: "265",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}")),
        bR: "MW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[2-9]|21\\d\\d)\\d{5}"))
            },
            {
                mo: "991234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("111\\d{6}|(?:31|77|88|99)\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMX = {
        e8: "52",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}")),
        bR: "MX",
        jI: $elm$core$Maybe$Just("0[09]"),
        nx: $elm$core$Maybe$Just("01"),
        kb: _List_fromArray([
            {
                mo: "2001234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}"))
            },
            {
                mo: "12221234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|88)\\d{7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{7}"))
            },
            {
                mo: "3001234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("300\\d{7}"))
            },
            {
                mo: "5001234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("500\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMY = {
        e8: "60",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{8,9}|(?:3\\d|[4-9])\\d{7}")),
        bR: "MY",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "323856789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}"))
            },
            {
                mo: "123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[01]\\d|2[2-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}"))
            },
            {
                mo: "1300123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[378]00\\d{6}"))
            },
            {
                mo: "1600123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1600\\d{6}"))
            },
            {
                mo: "1546012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMZ = {
        e8: "258",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2|8\\d)\\d{7}")),
        bR: "MZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}"))
            },
            {
                mo: "821234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[2-79]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNA = {
        e8: "264",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[68]\\d{7,8}")),
        bR: "NA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "61221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"))
            },
            {
                mo: "811234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:60|8[1245])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            },
            {
                mo: "870123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8701\\d{5}"))
            },
            {
                mo: "88612345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:3\\d\\d|86)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNC = {
        e8: "687",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-57-9]\\d{5}")),
        bR: "NC",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"))
            },
            {
                mo: "751234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"))
            },
            {
                mo: "366711",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("36\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNE = {
        e8: "227",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[027-9]\\d{7}")),
        bR: "NE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20201234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"))
            },
            {
                mo: "93123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:23|7[04]|[89]\\d)\\d{6}"))
            },
            {
                mo: "08123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("08\\d{6}"))
            },
            {
                mo: "09123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("09\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNF = {
        e8: "672",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[13]\\d{5}")),
        bR: "NF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "106609",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"))
            },
            {
                mo: "381234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:14|3[58])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNG = {
        e8: "234",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}")),
        bR: "NG",
        jI: $elm$core$Maybe$Just("009"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "18040123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}"))
            },
            {
                mo: "8021234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|90[1-9])\\d{7}"))
            },
            {
                mo: "80017591759",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7,11}"))
            },
            {
                mo: "7001234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("700\\d{7,11}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNI = {
        e8: "505",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1800|[25-8]\\d{3})\\d{4}")),
        bR: "NI",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2\\d{7}"))
            },
            {
                mo: "81234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"))
            },
            {
                mo: "18001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNL = {
        e8: "31",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}")),
        bR: "NL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d"))
            },
            {
                mo: "101234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}"))
            },
            {
                mo: "612345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[1-58]\\d{7}"))
            },
            {
                mo: "662345678",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("66\\d{7}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4,7}"))
            },
            {
                mo: "9061234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[069]\\d{4,7}"))
            },
            {
                mo: "851234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:85|91)\\d{7}"))
            },
            {
                mo: "14020",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNO = {
        e8: "47",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0|[2-9]\\d{3})\\d{4}")),
        bR: "NO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}"))
            },
            {
                mo: "40612345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[015-8]|5[89]|9\\d)\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[01]\\d{5}"))
            },
            {
                mo: "82012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("82[09]\\d{5}"))
            },
            {
                mo: "81021234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("810(?:0[0-6]|[2-8]\\d)\\d{3}"))
            },
            {
                mo: "88012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("880\\d{5}"))
            },
            {
                mo: "85012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("85[0-5]\\d{5}"))
            },
            {
                mo: "02000",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"))
            },
            {
                mo: "81212345",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81[23]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNP = {
        e8: "977",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{9}|[1-9]\\d{7}")),
        bR: "NP",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "14567890",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}"))
            },
            {
                mo: "9841234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNR = {
        e8: "674",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:444|(?:55|8\\d)\\d|666)\\d{4}")),
        bR: "NR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "4441234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("444\\d{4}"))
            },
            {
                mo: "5551234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:55[3-9]|666|8\\d\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNU = {
        e8: "683",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[47]|888\\d)\\d{3}")),
        bR: "NU",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "7012",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[47]\\d{3}"))
            },
            {
                mo: "8884012",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("888[4-9]\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ = {
        e8: "64",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}")),
        bR: "NZ",
        jI: $elm$core$Maybe$Just("0(?:0|161)"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "32345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}"))
            },
            {
                mo: "211234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[0-27-9]\\d{7,8}|21\\d{6}"))
            },
            {
                mo: "26123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[28]6\\d{6,7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("508\\d{6,7}|80\\d{6,8}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:11\\d{5}|50(?:0[08]|30|66|77))\\d{3}|90\\d{6,8}"))
            },
            {
                mo: "701234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{7}"))
            },
            {
                mo: "83012378",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("83\\d{3,8}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryOM = {
        e8: "968",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}")),
        bR: "OM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "23123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[2-6]\\d{6}"))
            },
            {
                mo: "92123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1505|90[1-9]\\d)\\d{4}|(?:7[1289]|9[1-9])\\d{6}"))
            },
            {
                mo: "80071234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("500\\d{4}|8007\\d{4,5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPA = {
        e8: "507",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-57-9]|6\\d)\\d{6}")),
        bR: "PA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2001234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}"))
            },
            {
                mo: "61234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-6])\\d|8(?:1[01]|7[23]))\\d{4}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}"))
            },
            {
                mo: "8601234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPE = {
        e8: "51",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[14-8]|9\\d)\\d{7}")),
        bR: "PE",
        jI: $elm$core$Maybe$Just("19(?:1[124]|77|90)00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "11234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{8}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "80512345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("805\\d{5}"))
            },
            {
                mo: "80112345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("801\\d{5}"))
            },
            {
                mo: "80212345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[24]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPF = {
        e8: "689",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[48]\\d{7}|4\\d{5}")),
        bR: "PF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("44\\d{4}"))
            },
            {
                mo: "40412345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:0[4-689]|9[4-68])\\d{5}"))
            },
            {
                mo: "87123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[7-9]\\d{6}"))
            },
            {
                mo: "49901234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("499\\d{5}"))
            },
            {
                mo: "440123",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("44\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPG = {
        e8: "675",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}")),
        bR: "PG",
        jI: $elm$core$Maybe$Just("00|140[1-3]"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "3123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:64[1-9]|7730|85[02-46-9])\\d{4}|(?:3[0-2]|4[257]|5[34]|77[0-24]|9[78])\\d{5}"))
            },
            {
                mo: "70123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77(?:3[1-9]|[5-9]\\d)\\d{4}|(?:7[0-689]|81)\\d{6}"))
            },
            {
                mo: "2700123",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("27[01]\\d{4}"))
            },
            {
                mo: "1801234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("180\\d{4}"))
            },
            {
                mo: "2751234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0[0-47]|7[568])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPH = {
        e8: "63",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}")),
        bR: "PH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|2\\d{5}(?:\\d{2})?|8[2-8]\\d{7}"))
            },
            {
                mo: "9051234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:81[37]|9(?:0[5-9]|1[0-24-9]|2[0-35-9]|[35]\\d|4[235-9]|6[0-35-8]|7[1-9]|8[189]|9[4-9]))\\d{7}"))
            },
            {
                mo: "180012345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{7,9}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPK = {
        e8: "92",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}")),
        bR: "PK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "2123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}"))
            },
            {
                mo: "3012345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{5}"))
            },
            {
                mo: "122044444",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("122\\d{6}"))
            },
            {
                mo: "21111825888",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPL = {
        e8: "48",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?")),
        bR: "PL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))"))
            },
            {
                mo: "512345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}"))
            },
            {
                mo: "641234567",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("64\\d{4,7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6,7}"))
            },
            {
                mo: "701234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70[01346-8]\\d{6}"))
            },
            {
                mo: "801234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("801\\d{6}"))
            },
            {
                mo: "391234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("39\\d{7}"))
            },
            {
                mo: "804123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("804\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPM = {
        e8: "508",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[45]\\d{5}")),
        bR: "PM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "430123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[1-3]|50)\\d{4}"))
            },
            {
                mo: "551234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[02-4]|5[05])\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPR = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[589]\\d\\d|787)\\d{7}")),
        bR: "PR",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "7872345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:787|939)[2-9]\\d{6}"))
            },
            {
                mo: "7872345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:787|939)[2-9]\\d{6}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPS = {
        e8: "970",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2489]2\\d{6}|(?:1\\d|5)\\d{8}")),
        bR: "PS",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}"))
            },
            {
                mo: "599123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[69]\\d{7}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{6}"))
            },
            {
                mo: "1700123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1700\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT = {
        e8: "351",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[26-9]\\d|30)\\d{7}")),
        bR: "PT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[356]9230\\d{3}|(?:6[036]93|9(?:[1-36]\\d\\d|480))\\d{5}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[02]\\d{6}"))
            },
            {
                mo: "760123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"))
            },
            {
                mo: "808123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:8\\d|9[1579])\\d{5}"))
            },
            {
                mo: "884123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("884[0-4689]\\d{5}"))
            },
            {
                mo: "301234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("30\\d{7}"))
            },
            {
                mo: "707123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70(?:7\\d|8[17])\\d{5}"))
            },
            {
                mo: "600110000",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("600\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPW = {
        e8: "680",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[24-8]\\d\\d|345|900)\\d{4}")),
        bR: "PW",
        jI: $elm$core$Maybe$Just("01[12]"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2771234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"))
            },
            {
                mo: "6201234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:45[0-5]|6[2-4689]0|(?:77|88)\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPY = {
        e8: "595",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}")),
        bR: "PY",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "212345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}"))
            },
            {
                mo: "961456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}"))
            },
            {
                mo: "870012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8700[0-4]\\d{4}"))
            },
            {
                mo: "201234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-9]0\\d{4,7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryQA = {
        e8: "974",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}")),
        bR: "QA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "44123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:23|4[04])\\d{6}"))
            },
            {
                mo: "33123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:28|[35-7]\\d)\\d{6}"))
            },
            {
                mo: "2123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[12]\\d|61)\\d{4}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRE = {
        e8: "262",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9769\\d{5}|(?:26|[68]\\d)\\d{7}")),
        bR: "RE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "262161234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("26(?:2\\d\\d|30[01])\\d{4}"))
            },
            {
                mo: "692123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[05]|6[0-36]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            },
            {
                mo: "891123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("89[1-37-9]\\d{6}"))
            },
            {
                mo: "810123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:1[019]|2[0156]|84|90)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRO = {
        e8: "40",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}")),
        bR: "RO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "211234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"))
            },
            {
                mo: "712034567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[01]20\\d{5}|7(?:0[013-9]|1[01]|[2-7]\\d|8[03-8]|9[09])\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[0136]\\d{6}"))
            },
            {
                mo: "801123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("801\\d{6}"))
            },
            {
                mo: "372123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:37\\d|80[578])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRS = {
        e8: "381",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}")),
        bR: "RS",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "10234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}"))
            },
            {
                mo: "601234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:[0-689]|7\\d)\\d{6,7}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{3,9}"))
            },
            {
                mo: "90012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:78\\d|90[0169])\\d{3,7}"))
            },
            {
                mo: "700123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[06]\\d{4,10}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRU = {
        e8: "7",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[347-9]\\d{9}")),
        bR: "RU",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "3011234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}"))
            },
            {
                mo: "9123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9\\d{9}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[04]\\d{7}"))
            },
            {
                mo: "8091234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[39]\\d{7}"))
            },
            {
                mo: "8081234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("808\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRW = {
        e8: "250",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:06|[27]\\d\\d|[89]00)\\d{6}")),
        bR: "RW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "250123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:06|2[23568]\\d)\\d{6}"))
            },
            {
                mo: "720123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[238]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySA = {
        e8: "966",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("92\\d{7}|(?:[15]|8\\d)\\d{8}")),
        bR: "SA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "112345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}"))
            },
            {
                mo: "512345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5(?:[013-689]\\d|7[0-36-8])\\d{6}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "925012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("925\\d{6}"))
            },
            {
                mo: "920012345",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("920\\d{6}"))
            },
            {
                mo: "8110123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("811\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySB = {
        e8: "677",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-6]|[7-9]\\d\\d)\\d{4}")),
        bR: "SB",
        jI: $elm$core$Maybe$Just("0[01]"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "40123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}"))
            },
            {
                mo: "7421234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"))
            },
            {
                mo: "18123",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[38]\\d{3}"))
            },
            {
                mo: "51123",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[12]\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySC = {
        e8: "248",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8000\\d{3}|(?:[249]\\d|64)\\d{5}")),
        bR: "SC",
        jI: $elm$core$Maybe$Just("010|0[0-2]"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "4217123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4[2-46]\\d{5}"))
            },
            {
                mo: "2510123",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[5-8]\\d{5}"))
            },
            {
                mo: "8000000",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8000\\d{3}"))
            },
            {
                mo: "6412345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("971\\d{4}|(?:64|95)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySD = {
        e8: "249",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[19]\\d{8}")),
        bR: "SD",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "153123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:5\\d|8[35-7])\\d{6}"))
            },
            {
                mo: "911231234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[0-2]|9[0-3569])\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySE = {
        e8: "46",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}")),
        bR: "SE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "8123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}"))
            },
            {
                mo: "701234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[02369]\\d{7}"))
            },
            {
                mo: "740123456",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("74[02-9]\\d{6}"))
            },
            {
                mo: "20123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20\\d{4,7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}"))
            },
            {
                mo: "771234567",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77[0-7]\\d{6}"))
            },
            {
                mo: "751234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("75[1-8]\\d{6}"))
            },
            {
                mo: "102345678",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("10[1-8]\\d{6}"))
            },
            {
                mo: "254123456789",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:25[245]|67[3-68])\\d{9}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySG = {
        e8: "65",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}")),
        bR: "SG",
        jI: $elm$core$Maybe$Just("0[0-3]\\d"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "61234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}"))
            },
            {
                mo: "81234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:0(?:1[0-7]|3[01])|[1-8]\\d\\d|9(?:[0-24]\\d|3[0-489]|5[0-2]))|9[0-8]\\d\\d)\\d{4}"))
            },
            {
                mo: "18001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:18|8)00\\d{7}"))
            },
            {
                mo: "19001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1900\\d{7}"))
            },
            {
                mo: "31234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[12]\\d|666)\\d{5}"))
            },
            {
                mo: "70001234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7000\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySH = {
        e8: "290",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[256]\\d|8)\\d{3}")),
        bR: "SH",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22158",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[0-57-9]\\d|6[4-9])\\d\\d"))
            },
            {
                mo: "51234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[56]\\d{4}"))
            },
            {
                mo: "26212",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("262\\d\\d"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySI = {
        e8: "386",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}")),
        bR: "SI",
        jI: $elm$core$Maybe$Just("00|10(?:22|66|88|99)"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[1-357][2-8]|4[24-8])\\d{6}"))
            },
            {
                mo: "31234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}"))
            },
            {
                mo: "80123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{4,6}"))
            },
            {
                mo: "90123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("89[1-3]\\d{2,5}|90\\d{4,6}"))
            },
            {
                mo: "59012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySJ = {
        e8: "47",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0\\d{4}|(?:[4589]\\d|79)\\d{6}")),
        bR: "SJ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "79123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("79\\d{6}"))
            },
            {
                mo: "41234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:4[015-8]|5[89]|9\\d)\\d{6}"))
            },
            {
                mo: "80012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[01]\\d{5}"))
            },
            {
                mo: "82012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("82[09]\\d{5}"))
            },
            {
                mo: "81021234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("810(?:0[0-6]|[2-8]\\d)\\d{3}"))
            },
            {
                mo: "88012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("880\\d{5}"))
            },
            {
                mo: "85012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("85[0-5]\\d{5}"))
            },
            {
                mo: "02000",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"))
            },
            {
                mo: "81212345",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81[23]\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySK = {
        e8: "421",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}")),
        bR: "SK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}"))
            },
            {
                mo: "221234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"))
            },
            {
                mo: "912123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}"))
            },
            {
                mo: "9090123",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9090\\d{3}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:00|[78]\\d)\\d{6}"))
            },
            {
                mo: "850123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[5-9]\\d{7}"))
            },
            {
                mo: "690123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:02|5[0-4]|9[0-6])\\d{6}"))
            },
            {
                mo: "961234567",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("96\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySL = {
        e8: "232",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2378]\\d|66|99)\\d{6}")),
        bR: "SL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "22221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22[2-4][2-9]\\d{4}"))
            },
            {
                mo: "25123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:25|3[013-5]|66|7[4-9]|8[08]|99)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySM = {
        e8: "378",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0549|[5-7]\\d)\\d{6}")),
        bR: "SM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "0549886377",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0549(?:8[0157-9]|9\\d)\\d{4}"))
            },
            {
                mo: "66661212",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[16]\\d{6}"))
            },
            {
                mo: "71123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[178]\\d{6}"))
            },
            {
                mo: "58001110",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("5[158]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySN = {
        e8: "221",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[378]\\d{4}|93330)\\d{4}")),
        bR: "SN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "301012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"))
            },
            {
                mo: "701234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:[06-8]\\d|21|90)\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "884123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88[4689]\\d{6}"))
            },
            {
                mo: "810123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81[02468]\\d{6}"))
            },
            {
                mo: "933301234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("93330\\d{4}|3(?:392|9[01]\\d)\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySO = {
        e8: "252",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}")),
        bR: "SO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "4012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}"))
            },
            {
                mo: "71123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("28\\d{5}|(?:6[1-9]|79)\\d{6,7}|(?:15|24|(?:3[59]|4[89]|8[08])\\d|60|7[1-8]|9(?:0\\d|[2-9]))\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySR = {
        e8: "597",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-5]|68|[78]\\d)\\d{5}")),
        bR: "SR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "211234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"))
            },
            {
                mo: "7412345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7[124-7]|8[124-9])\\d{5}"))
            },
            {
                mo: "561234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySS = {
        e8: "211",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[19]\\d{8}")),
        bR: "SS",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "181234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1[89]\\d{7}"))
            },
            {
                mo: "977123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:12|9[12579])\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryST = {
        e8: "239",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:22|9\\d)\\d{5}")),
        bR: "ST",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2221234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22\\d{5}"))
            },
            {
                mo: "9812345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySV = {
        e8: "503",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?")),
        bR: "SV",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}"))
            },
            {
                mo: "70123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{4}(?:\\d{4})?"))
            },
            {
                mo: "9001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{4}(?:\\d{4})?"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySX = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}")),
        bR: "SX",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "7215425678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7215(?:4[2-8]|8[239]|9[056])\\d{4}"))
            },
            {
                mo: "7215205678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"))
            },
            {
                mo: "8002123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySY = {
        e8: "963",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-39]\\d{8}|[1-5]\\d{7}")),
        bR: "SY",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "112345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"))
            },
            {
                mo: "944567890",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9(?:22|[3-589]\\d|6[02-9])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySZ = {
        e8: "268",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{4}|(?:[237]\\d|900)\\d{6}")),
        bR: "SZ",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{4}"))
            },
            {
                mo: "22171234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[23][2-5]\\d{6}"))
            },
            {
                mo: "76123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[6-9]\\d{6}"))
            },
            {
                mo: "08001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{4}"))
            },
            {
                mo: "900012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{6}"))
            },
            {
                mo: "70012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTA = {
        e8: "290",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{3}")),
        bR: "TA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "8999",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTC = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|649|900)\\d{7}")),
        bR: "TC",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "6497121234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("649(?:266|712|9(?:4\\d|50))\\d{4}"))
            },
            {
                mo: "6492311234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "6497101234",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("649(?:71[01]|966)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTD = {
        e8: "235",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:22|[69]\\d|77)\\d{6}")),
        bR: "TD",
        jI: $elm$core$Maybe$Just("00|16"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22501234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("22(?:[37-9]0|5[0-5]|6[89])\\d{4}"))
            },
            {
                mo: "63012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6[023568]|77|9\\d)\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTG = {
        e8: "228",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[279]\\d{7}")),
        bR: "TG",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22212345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"))
            },
            {
                mo: "90112345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7[09]|9[0-36-9])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTH = {
        e8: "66",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}")),
        bR: "TH",
        jI: $elm$core$Maybe$Just("00[1-9]"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "21234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}"))
            },
            {
                mo: "812345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:14|6[1-6]|[89]\\d)\\d{7}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{6}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1900\\d{6}"))
            },
            {
                mo: "601234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[08]\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTJ = {
        e8: "992",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:00|11|[3-57-9]\\d)\\d{7}")),
        bR: "TJ",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "372123456",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"))
            },
            {
                mo: "917123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("41[18]\\d{6}|(?:[04]0|11|5[05]|7[07]|88|9\\d)\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTK = {
        e8: "690",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-47]\\d{3,6}")),
        bR: "TK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "3101",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[2-4]|[34]\\d)\\d{2,5}"))
            },
            {
                mo: "7290",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[2-4]\\d{2,5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTL = {
        e8: "670",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}")),
        bR: "TL",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "2112345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[1-5]|3[1-9]|4[1-4])\\d{5}"))
            },
            {
                mo: "77212345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[2-8]\\d{6}"))
            },
            {
                mo: "8012345",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{5}"))
            },
            {
                mo: "9012345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{5}"))
            },
            {
                mo: "7012345",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("70\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTM = {
        e8: "993",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-6]\\d{7}")),
        bR: "TM",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "12345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"))
            },
            {
                mo: "66123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTN = {
        e8: "216",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-57-9]\\d{7}")),
        bR: "TN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "30010123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"))
            },
            {
                mo: "20123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"))
            },
            {
                mo: "80101234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8010\\d{4}"))
            },
            {
                mo: "88123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("88\\d{6}"))
            },
            {
                mo: "81101234",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8[12]10\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTO = {
        e8: "676",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}")),
        bR: "TO",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}"))
            },
            {
                mo: "7715123",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6(?:3[02]|8[5-9])\\d{4}|(?:6[09]|7\\d|8[46-9])\\d{5}"))
            },
            {
                mo: "0800222",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0800\\d{3}"))
            },
            {
                mo: "5501234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("55[04]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTR = {
        e8: "90",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}")),
        bR: "TR",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("444\\d{4}"))
            },
            {
                mo: "2123456789",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}"))
            },
            {
                mo: "5012345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}"))
            },
            {
                mo: "5123456789",
                hE: 7,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("512\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}(?:\\d{2,3})?"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8[89]8|900)\\d{7}"))
            },
            {
                mo: "5922121234",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("592(?:21[12]|461)\\d{4}"))
            },
            {
                mo: "8500123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("850\\d{7}"))
            },
            {
                mo: "4441444",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("444\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTT = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|900)\\d{7}")),
        bR: "TT",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "8682211234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"))
            },
            {
                mo: "8682911234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("868(?:2(?:6[3-9]|[7-9]\\d)|(?:3\\d|4[6-9])\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "8686191234",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("868619\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTV = {
        e8: "688",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2|7\\d\\d|90)\\d{4}")),
        bR: "TV",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "20123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[02-9]\\d{3}"))
            },
            {
                mo: "901234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7[01]\\d|90)\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTW = {
        e8: "886",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}")),
        bR: "TW",
        jI: $elm$core$Maybe$Just("0(?:0[25-79]|19)"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "221234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:40001[0-2]|9[0-8]\\d{4})\\d{3}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[0-79]\\d{6}|800\\d{5}"))
            },
            {
                mo: "203123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20(?:[013-9]\\d\\d|2)\\d{4}"))
            },
            {
                mo: "990123456",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("99\\d{7}"))
            },
            {
                mo: "7012345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}"))
            },
            {
                mo: "500123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("50[0-46-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTZ = {
        e8: "255",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[26-8]\\d|41|90)\\d{7}")),
        bR: "TZ",
        jI: $elm$core$Maybe$Just("00[056]"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:8(?:[04]0|6[01])|90\\d)\\d{6}"))
            },
            {
                mo: "222345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2[2-8]\\d{7}"))
            },
            {
                mo: "621234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("77[2-9]\\d{6}|(?:6[2-9]|7[13-689])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[08]\\d{6}"))
            },
            {
                mo: "900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90\\d{7}"))
            },
            {
                mo: "840123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:40|6[01])\\d{6}"))
            },
            {
                mo: "412345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("41\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUA = {
        e8: "380",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[89]\\d{9}|[3-9]\\d{8}")),
        bR: "UA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "311234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}"))
            },
            {
                mo: "501234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[1-8]\\d{5,6}"))
            },
            {
                mo: "900212345",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[239]\\d{5,6}"))
            },
            {
                mo: "891234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("89[1-579]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUG = {
        e8: "256",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}|(?:[29]0|[347]\\d)\\d{7}")),
        bR: "UG",
        jI: $elm$core$Maybe$Just("00[057]"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "312345678",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"))
            },
            {
                mo: "712345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7260\\d{5}|7(?:[0157-9]\\d|20|36|4[0-4])\\d{6}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800[1-3]\\d{5}"))
            },
            {
                mo: "901123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[1-3]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[2-9]\\d{9}")),
        bR: "US",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2015550123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"))
            },
            {
                mo: "2015550123",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUY = {
        e8: "598",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[249]\\d\\d|80)\\d{5}|9\\d{6}")),
        bR: "UY",
        jI: $elm$core$Maybe$Just("0(?:0|1[3-9]\\d)"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "21231234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2\\d|4[2-7])\\d{6}"))
            },
            {
                mo: "94231234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("9[1-9]\\d{6}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80[05]\\d{4}"))
            },
            {
                mo: "9001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[0-8]\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUZ = {
        e8: "998",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("55501\\d{4}|(?:[679]\\d|88)\\d{7}")),
        bR: "UZ",
        jI: $elm$core$Maybe$Just("810"),
        nx: $elm$core$Maybe$Just("8"),
        kb: _List_fromArray([
            {
                mo: "669050123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:55501|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))|(?:88|9[0-57-9])\\d{3})\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVA = {
        e8: "39",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}")),
        bR: "VA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "0669812345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("06698\\d{1,6}"))
            },
            {
                mo: "3123456789",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[1-9]\\d{8}|3[2-9]\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:0\\d{3}|3)\\d{3}"))
            },
            {
                mo: "899123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}"))
            },
            {
                mo: "848123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("84(?:[08]\\d{3}|[17])\\d{3}"))
            },
            {
                mo: "1781234567",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1(?:78\\d|99)\\d{6}"))
            },
            {
                mo: "5512345678",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("55\\d{8}"))
            },
            {
                mo: "33101234501",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("3[2-8]\\d{9,10}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVC = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[58]\\d\\d|784|900)\\d{7}")),
        bR: "VC",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "7842661234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"))
            },
            {
                mo: "7844301234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVE = {
        e8: "58",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}")),
        bR: "VE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "2121234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"))
            },
            {
                mo: "4121234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4(?:1[24-8]|2[46])\\d{7}"))
            },
            {
                mo: "8001234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{7}"))
            },
            {
                mo: "9001234567",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[01]\\d{7}"))
            },
            {
                mo: "5010123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("501\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVG = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:284|[58]\\d\\d|900)\\d{7}")),
        bR: "VG",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "2842291234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"))
            },
            {
                mo: "2843001234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVI = {
        e8: "1",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[58]\\d{9}|(?:34|90)0\\d{7}")),
        bR: "VI",
        jI: $elm$core$Maybe$Just("011"),
        nx: $elm$core$Maybe$Just("1"),
        kb: _List_fromArray([
            {
                mo: "3406421234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"))
            },
            {
                mo: "3406421234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"))
            },
            {
                mo: "8002345678",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"))
            },
            {
                mo: "9002345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900[2-9]\\d{6}"))
            },
            {
                mo: "5002345678",
                hE: 5,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVN = {
        e8: "84",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}")),
        bR: "VN",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "",
                hE: 15,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[17]99\\d{4}|69\\d{5,6}"))
            },
            {
                mo: "2101234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}"))
            },
            {
                mo: "912345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}"))
            },
            {
                mo: "1800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1800\\d{4,6}|12(?:03|28)\\d{4}"))
            },
            {
                mo: "1900123456",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("1900\\d{4,6}"))
            },
            {
                mo: "672012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("672\\d{6}"))
            },
            {
                mo: "1992000",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[17]99|80\\d)\\d{4}|69\\d{5,6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVU = {
        e8: "678",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}")),
        bR: "VU",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}"))
            },
            {
                mo: "5912345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:5\\d|7[013-7])\\d{5}"))
            },
            {
                mo: "9010123",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("90[1-9]\\d{4}"))
            },
            {
                mo: "30123",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:3[03]|900\\d)\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWF = {
        e8: "681",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[45]0|68|72|8\\d)\\d{4}")),
        bR: "WF",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "501234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:50|68|72)\\d{4}"))
            },
            {
                mo: "501234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:50|68|72|8[23])\\d{4}"))
            },
            {
                mo: "401234",
                hE: 10,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[48]0\\d{4}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWS = {
        e8: "685",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}")),
        bR: "WS",
        jI: $elm$core$Maybe$Just("0"),
        nx: $elm$core$Maybe$Nothing,
        kb: _List_fromArray([
            {
                mo: "22123",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}"))
            },
            {
                mo: "7212345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7[235-7]|8(?:[3-7]|9\\d{3}))\\d{5}"))
            },
            {
                mo: "800123",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{3}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryXK = {
        e8: "383",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}")),
        bR: "XK",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "28012345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2[89]|39)0\\d{6}|[23][89]\\d{6}"))
            },
            {
                mo: "43201234",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("4[3-9]\\d{6}"))
            },
            {
                mo: "80001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{5}"))
            },
            {
                mo: "90001234",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("900\\d{5}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYE = {
        e8: "967",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1|7\\d)\\d{7}|[1-7]\\d{6}")),
        bR: "YE",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}"))
            },
            {
                mo: "712345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7[0137]\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYT = {
        e8: "262",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}|(?:26|63)9\\d{6}")),
        bR: "YT",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "269601234",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("269(?:0[67]|5[0-2]|6\\d|[78]0)\\d{4}"))
            },
            {
                mo: "639012345",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA = {
        e8: "27",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[1-79]\\d{8}|8\\d{4,9}")),
        bR: "ZA",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "101234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}"))
            },
            {
                mo: "711234567",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}"))
            },
            {
                mo: "801234567",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80\\d{7}"))
            },
            {
                mo: "862345678",
                hE: 3,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:86[2-9]|9[0-2]\\d)\\d{6}"))
            },
            {
                mo: "860123456",
                hE: 4,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("860\\d{6}"))
            },
            {
                mo: "871234567",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}"))
            },
            {
                mo: "861123456",
                hE: 8,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("861\\d{6,7}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZM = {
        e8: "260",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}")),
        bR: "ZM",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "211234567",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("21[1-8]\\d{6}"))
            },
            {
                mo: "955123456",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:7[679]|9[5-8])\\d{7}"))
            },
            {
                mo: "800123456",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("800\\d{6}"))
            },
            {
                mo: "630012345",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("630\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZW = {
        e8: "263",
        js: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}")),
        bR: "ZW",
        jI: $elm$core$Maybe$Just("00"),
        nx: $elm$core$Maybe$Just("0"),
        kb: _List_fromArray([
            {
                mo: "1312345",
                hE: 0,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"))
            },
            {
                mo: "712345678",
                hE: 1,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("7(?:[17]\\d|[38][1-9])\\d{6}"))
            },
            {
                mo: "8001234",
                hE: 2,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("80(?:[01]\\d|20|8[0-8])\\d{3}"))
            },
            {
                mo: "8686123456",
                hE: 6,
                kt: $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("86(?:1[12]|22|30|44|55|77|8[368])\\d{6}"))
            }
        ])
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$all = _List_fromArray([$robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryER, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryES, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryID, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryME, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryML, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryOM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryQA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryST, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryXK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZW]);
    var $robinheghan$elm_phone_numbers$PhoneNumber$CarrierSpecific = 13;
    var $robinheghan$elm_phone_numbers$PhoneNumber$Emergency = 9;
    var $robinheghan$elm_phone_numbers$PhoneNumber$ShortCode = 11;
    var $robinheghan$elm_phone_numbers$PhoneNumber$SmsServices = 14;
    var $robinheghan$elm_phone_numbers$PhoneNumber$StandardRate = 12;
    var $robinheghan$elm_phone_numbers$PhoneNumber$anyType = _List_fromArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var $elm$core$String$endsWith = _String_endsWith;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AD = 0;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AE = 1;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AF = 2;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AG = 3;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AI = 4;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AL = 5;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AM = 6;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AO = 7;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AQ = 8;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AR = 9;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AS = 10;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AT = 11;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AU = 12;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AW = 13;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AX = 14;
    var $rl_king$elm_iso3166_country_codes$Iso3166$AZ = 15;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BA = 16;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BB = 17;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BD = 18;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BE = 19;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BF = 20;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BG = 21;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BH = 22;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BI = 23;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BJ = 24;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BL = 25;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BM = 26;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BN = 27;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BO = 28;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BQ = 29;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BR = 30;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BS = 31;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BT = 32;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BV = 33;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BW = 34;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BY = 35;
    var $rl_king$elm_iso3166_country_codes$Iso3166$BZ = 36;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CA = 37;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CC = 38;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CD = 39;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CF = 40;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CG = 41;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CH = 42;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CI = 43;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CK = 44;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CL = 45;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CM = 46;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CN = 47;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CO = 48;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CR = 49;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CU = 50;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CV = 51;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CW = 52;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CX = 53;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CY = 54;
    var $rl_king$elm_iso3166_country_codes$Iso3166$CZ = 55;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DE = 56;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DJ = 57;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DK = 58;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DM = 59;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DO = 60;
    var $rl_king$elm_iso3166_country_codes$Iso3166$DZ = 61;
    var $rl_king$elm_iso3166_country_codes$Iso3166$EC = 62;
    var $rl_king$elm_iso3166_country_codes$Iso3166$EE = 63;
    var $rl_king$elm_iso3166_country_codes$Iso3166$EG = 64;
    var $rl_king$elm_iso3166_country_codes$Iso3166$EH = 65;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ER = 66;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ES = 67;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ET = 68;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FI = 69;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FJ = 70;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FK = 71;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FM = 72;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FO = 73;
    var $rl_king$elm_iso3166_country_codes$Iso3166$FR = 74;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GA = 75;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GB = 76;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GD = 77;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GE = 78;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GF = 79;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GG = 80;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GH = 81;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GI = 82;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GL = 83;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GM = 84;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GN = 85;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GP = 86;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GQ = 87;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GR = 88;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GS = 89;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GT_ = 90;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GU = 91;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GW = 92;
    var $rl_king$elm_iso3166_country_codes$Iso3166$GY = 93;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HK = 94;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HM = 95;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HN = 96;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HR = 97;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HT = 98;
    var $rl_king$elm_iso3166_country_codes$Iso3166$HU = 99;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ID = 100;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IE = 101;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IL = 102;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IM = 103;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IN = 104;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IO = 105;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IQ = 106;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IR = 107;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IS = 108;
    var $rl_king$elm_iso3166_country_codes$Iso3166$IT = 109;
    var $rl_king$elm_iso3166_country_codes$Iso3166$JE = 110;
    var $rl_king$elm_iso3166_country_codes$Iso3166$JM = 111;
    var $rl_king$elm_iso3166_country_codes$Iso3166$JO = 112;
    var $rl_king$elm_iso3166_country_codes$Iso3166$JP = 113;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KE = 114;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KG = 115;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KH = 116;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KI = 117;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KM = 118;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KN = 119;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KP = 120;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KR = 121;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KW = 122;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KY = 123;
    var $rl_king$elm_iso3166_country_codes$Iso3166$KZ = 124;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LA = 125;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LB = 126;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LC = 127;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LI = 128;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LK = 129;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LR = 130;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LS = 131;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LT_ = 132;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LU = 133;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LV = 134;
    var $rl_king$elm_iso3166_country_codes$Iso3166$LY = 135;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MA = 136;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MC = 137;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MD = 138;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ME = 139;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MF = 140;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MG = 141;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MH = 142;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MK = 143;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ML = 144;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MM = 145;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MN = 146;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MO = 147;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MP = 148;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MQ = 149;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MR = 150;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MS = 151;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MT = 152;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MU = 153;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MV = 154;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MW = 155;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MX = 156;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MY = 157;
    var $rl_king$elm_iso3166_country_codes$Iso3166$MZ = 158;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NA = 159;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NC = 160;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NE = 161;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NF = 162;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NG = 163;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NI = 164;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NL = 165;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NO = 166;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NP = 167;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NR = 168;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NU = 169;
    var $rl_king$elm_iso3166_country_codes$Iso3166$NZ = 170;
    var $rl_king$elm_iso3166_country_codes$Iso3166$OM = 171;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PA = 172;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PE = 173;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PF = 174;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PG = 175;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PH = 176;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PK = 177;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PL = 178;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PM = 179;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PN = 180;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PR = 181;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PS = 182;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PT = 183;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PW = 184;
    var $rl_king$elm_iso3166_country_codes$Iso3166$PY = 185;
    var $rl_king$elm_iso3166_country_codes$Iso3166$QA = 186;
    var $rl_king$elm_iso3166_country_codes$Iso3166$RE = 187;
    var $rl_king$elm_iso3166_country_codes$Iso3166$RO = 188;
    var $rl_king$elm_iso3166_country_codes$Iso3166$RS = 189;
    var $rl_king$elm_iso3166_country_codes$Iso3166$RU = 190;
    var $rl_king$elm_iso3166_country_codes$Iso3166$RW = 191;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SA = 192;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SB = 193;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SC = 194;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SD = 195;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SE = 196;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SG = 197;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SH = 198;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SI = 199;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SJ = 200;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SK = 201;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SL = 202;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SM = 203;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SN = 204;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SO = 205;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SR = 206;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SS = 207;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ST = 208;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SV = 209;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SX = 210;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SY = 211;
    var $rl_king$elm_iso3166_country_codes$Iso3166$SZ = 212;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TC = 213;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TD = 214;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TF = 215;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TG = 216;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TH = 217;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TJ = 218;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TK = 219;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TL = 220;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TM = 221;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TN = 222;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TO = 223;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TR = 224;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TT = 225;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TV = 226;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TW = 227;
    var $rl_king$elm_iso3166_country_codes$Iso3166$TZ = 228;
    var $rl_king$elm_iso3166_country_codes$Iso3166$UA = 229;
    var $rl_king$elm_iso3166_country_codes$Iso3166$UG = 230;
    var $rl_king$elm_iso3166_country_codes$Iso3166$UM = 231;
    var $rl_king$elm_iso3166_country_codes$Iso3166$US = 232;
    var $rl_king$elm_iso3166_country_codes$Iso3166$UY = 233;
    var $rl_king$elm_iso3166_country_codes$Iso3166$UZ = 234;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VA = 235;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VC = 236;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VE = 237;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VG = 238;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VI = 239;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VN = 240;
    var $rl_king$elm_iso3166_country_codes$Iso3166$VU = 241;
    var $rl_king$elm_iso3166_country_codes$Iso3166$WF = 242;
    var $rl_king$elm_iso3166_country_codes$Iso3166$WS = 243;
    var $rl_king$elm_iso3166_country_codes$Iso3166$YE = 244;
    var $rl_king$elm_iso3166_country_codes$Iso3166$YT = 245;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ZA = 246;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ZM = 247;
    var $rl_king$elm_iso3166_country_codes$Iso3166$ZW = 248;
    var $rl_king$elm_iso3166_country_codes$Iso3166$fromAlpha3 = function (s) {
        switch (s) {
            case "and":
                return $elm$core$Maybe$Just(0);
            case "are":
                return $elm$core$Maybe$Just(1);
            case "afg":
                return $elm$core$Maybe$Just(2);
            case "atg":
                return $elm$core$Maybe$Just(3);
            case "aia":
                return $elm$core$Maybe$Just(4);
            case "alb":
                return $elm$core$Maybe$Just(5);
            case "arm":
                return $elm$core$Maybe$Just(6);
            case "ago":
                return $elm$core$Maybe$Just(7);
            case "ata":
                return $elm$core$Maybe$Just(8);
            case "arg":
                return $elm$core$Maybe$Just(9);
            case "asm":
                return $elm$core$Maybe$Just(10);
            case "aut":
                return $elm$core$Maybe$Just(11);
            case "aus":
                return $elm$core$Maybe$Just(12);
            case "abw":
                return $elm$core$Maybe$Just(13);
            case "ala":
                return $elm$core$Maybe$Just(14);
            case "aze":
                return $elm$core$Maybe$Just(15);
            case "bih":
                return $elm$core$Maybe$Just(16);
            case "brb":
                return $elm$core$Maybe$Just(17);
            case "bgd":
                return $elm$core$Maybe$Just(18);
            case "bel":
                return $elm$core$Maybe$Just(19);
            case "bfa":
                return $elm$core$Maybe$Just(20);
            case "bgr":
                return $elm$core$Maybe$Just(21);
            case "bhr":
                return $elm$core$Maybe$Just(22);
            case "bdi":
                return $elm$core$Maybe$Just(23);
            case "ben":
                return $elm$core$Maybe$Just(24);
            case "blm":
                return $elm$core$Maybe$Just(25);
            case "bmu":
                return $elm$core$Maybe$Just(26);
            case "brn":
                return $elm$core$Maybe$Just(27);
            case "bol":
                return $elm$core$Maybe$Just(28);
            case "bes":
                return $elm$core$Maybe$Just(29);
            case "bra":
                return $elm$core$Maybe$Just(30);
            case "bhs":
                return $elm$core$Maybe$Just(31);
            case "btn":
                return $elm$core$Maybe$Just(32);
            case "bvt":
                return $elm$core$Maybe$Just(33);
            case "bwa":
                return $elm$core$Maybe$Just(34);
            case "blr":
                return $elm$core$Maybe$Just(35);
            case "blz":
                return $elm$core$Maybe$Just(36);
            case "can":
                return $elm$core$Maybe$Just(37);
            case "cck":
                return $elm$core$Maybe$Just(38);
            case "cod":
                return $elm$core$Maybe$Just(39);
            case "caf":
                return $elm$core$Maybe$Just(40);
            case "cog":
                return $elm$core$Maybe$Just(41);
            case "che":
                return $elm$core$Maybe$Just(42);
            case "civ":
                return $elm$core$Maybe$Just(43);
            case "cok":
                return $elm$core$Maybe$Just(44);
            case "chl":
                return $elm$core$Maybe$Just(45);
            case "cmr":
                return $elm$core$Maybe$Just(46);
            case "chn":
                return $elm$core$Maybe$Just(47);
            case "col":
                return $elm$core$Maybe$Just(48);
            case "cri":
                return $elm$core$Maybe$Just(49);
            case "cub":
                return $elm$core$Maybe$Just(50);
            case "cpv":
                return $elm$core$Maybe$Just(51);
            case "cuw":
                return $elm$core$Maybe$Just(52);
            case "cxr":
                return $elm$core$Maybe$Just(53);
            case "cyp":
                return $elm$core$Maybe$Just(54);
            case "cze":
                return $elm$core$Maybe$Just(55);
            case "deu":
                return $elm$core$Maybe$Just(56);
            case "dji":
                return $elm$core$Maybe$Just(57);
            case "dnk":
                return $elm$core$Maybe$Just(58);
            case "dma":
                return $elm$core$Maybe$Just(59);
            case "dom":
                return $elm$core$Maybe$Just(60);
            case "dza":
                return $elm$core$Maybe$Just(61);
            case "ecu":
                return $elm$core$Maybe$Just(62);
            case "est":
                return $elm$core$Maybe$Just(63);
            case "egy":
                return $elm$core$Maybe$Just(64);
            case "esh":
                return $elm$core$Maybe$Just(65);
            case "eri":
                return $elm$core$Maybe$Just(66);
            case "esp":
                return $elm$core$Maybe$Just(67);
            case "eth":
                return $elm$core$Maybe$Just(68);
            case "fin":
                return $elm$core$Maybe$Just(69);
            case "fji":
                return $elm$core$Maybe$Just(70);
            case "flk":
                return $elm$core$Maybe$Just(71);
            case "fsm":
                return $elm$core$Maybe$Just(72);
            case "fro":
                return $elm$core$Maybe$Just(73);
            case "fra":
                return $elm$core$Maybe$Just(74);
            case "gab":
                return $elm$core$Maybe$Just(75);
            case "gbr":
                return $elm$core$Maybe$Just(76);
            case "grd":
                return $elm$core$Maybe$Just(77);
            case "geo":
                return $elm$core$Maybe$Just(78);
            case "guf":
                return $elm$core$Maybe$Just(79);
            case "ggy":
                return $elm$core$Maybe$Just(80);
            case "gha":
                return $elm$core$Maybe$Just(81);
            case "gib":
                return $elm$core$Maybe$Just(82);
            case "grl":
                return $elm$core$Maybe$Just(83);
            case "gmb":
                return $elm$core$Maybe$Just(84);
            case "gin":
                return $elm$core$Maybe$Just(85);
            case "glp":
                return $elm$core$Maybe$Just(86);
            case "gnq":
                return $elm$core$Maybe$Just(87);
            case "grc":
                return $elm$core$Maybe$Just(88);
            case "sgs":
                return $elm$core$Maybe$Just(89);
            case "gtm":
                return $elm$core$Maybe$Just(90);
            case "gum":
                return $elm$core$Maybe$Just(91);
            case "gnb":
                return $elm$core$Maybe$Just(92);
            case "guy":
                return $elm$core$Maybe$Just(93);
            case "hkg":
                return $elm$core$Maybe$Just(94);
            case "hmd":
                return $elm$core$Maybe$Just(95);
            case "hnd":
                return $elm$core$Maybe$Just(96);
            case "hrv":
                return $elm$core$Maybe$Just(97);
            case "hti":
                return $elm$core$Maybe$Just(98);
            case "hun":
                return $elm$core$Maybe$Just(99);
            case "idn":
                return $elm$core$Maybe$Just(100);
            case "irl":
                return $elm$core$Maybe$Just(101);
            case "isr":
                return $elm$core$Maybe$Just(102);
            case "imn":
                return $elm$core$Maybe$Just(103);
            case "ind":
                return $elm$core$Maybe$Just(104);
            case "iot":
                return $elm$core$Maybe$Just(105);
            case "irq":
                return $elm$core$Maybe$Just(106);
            case "irn":
                return $elm$core$Maybe$Just(107);
            case "isl":
                return $elm$core$Maybe$Just(108);
            case "ita":
                return $elm$core$Maybe$Just(109);
            case "jey":
                return $elm$core$Maybe$Just(110);
            case "jam":
                return $elm$core$Maybe$Just(111);
            case "jor":
                return $elm$core$Maybe$Just(112);
            case "jpn":
                return $elm$core$Maybe$Just(113);
            case "ken":
                return $elm$core$Maybe$Just(114);
            case "kgz":
                return $elm$core$Maybe$Just(115);
            case "khm":
                return $elm$core$Maybe$Just(116);
            case "kir":
                return $elm$core$Maybe$Just(117);
            case "com":
                return $elm$core$Maybe$Just(118);
            case "kna":
                return $elm$core$Maybe$Just(119);
            case "prk":
                return $elm$core$Maybe$Just(120);
            case "kor":
                return $elm$core$Maybe$Just(121);
            case "kwt":
                return $elm$core$Maybe$Just(122);
            case "cym":
                return $elm$core$Maybe$Just(123);
            case "kaz":
                return $elm$core$Maybe$Just(124);
            case "lao":
                return $elm$core$Maybe$Just(125);
            case "lbn":
                return $elm$core$Maybe$Just(126);
            case "lca":
                return $elm$core$Maybe$Just(127);
            case "lie":
                return $elm$core$Maybe$Just(128);
            case "lka":
                return $elm$core$Maybe$Just(129);
            case "lbr":
                return $elm$core$Maybe$Just(130);
            case "lso":
                return $elm$core$Maybe$Just(131);
            case "ltu":
                return $elm$core$Maybe$Just(132);
            case "lux":
                return $elm$core$Maybe$Just(133);
            case "lva":
                return $elm$core$Maybe$Just(134);
            case "lby":
                return $elm$core$Maybe$Just(135);
            case "mar":
                return $elm$core$Maybe$Just(136);
            case "mco":
                return $elm$core$Maybe$Just(137);
            case "mda":
                return $elm$core$Maybe$Just(138);
            case "mne":
                return $elm$core$Maybe$Just(139);
            case "maf":
                return $elm$core$Maybe$Just(140);
            case "mdg":
                return $elm$core$Maybe$Just(141);
            case "mhl":
                return $elm$core$Maybe$Just(142);
            case "mkd":
                return $elm$core$Maybe$Just(143);
            case "mli":
                return $elm$core$Maybe$Just(144);
            case "mmr":
                return $elm$core$Maybe$Just(145);
            case "mng":
                return $elm$core$Maybe$Just(146);
            case "mac":
                return $elm$core$Maybe$Just(147);
            case "mnp":
                return $elm$core$Maybe$Just(148);
            case "mtq":
                return $elm$core$Maybe$Just(149);
            case "mrt":
                return $elm$core$Maybe$Just(150);
            case "msr":
                return $elm$core$Maybe$Just(151);
            case "mlt":
                return $elm$core$Maybe$Just(152);
            case "mus":
                return $elm$core$Maybe$Just(153);
            case "mdv":
                return $elm$core$Maybe$Just(154);
            case "mwi":
                return $elm$core$Maybe$Just(155);
            case "mex":
                return $elm$core$Maybe$Just(156);
            case "mys":
                return $elm$core$Maybe$Just(157);
            case "moz":
                return $elm$core$Maybe$Just(158);
            case "nam":
                return $elm$core$Maybe$Just(159);
            case "ncl":
                return $elm$core$Maybe$Just(160);
            case "ner":
                return $elm$core$Maybe$Just(161);
            case "nfk":
                return $elm$core$Maybe$Just(162);
            case "nga":
                return $elm$core$Maybe$Just(163);
            case "nic":
                return $elm$core$Maybe$Just(164);
            case "nld":
                return $elm$core$Maybe$Just(165);
            case "nor":
                return $elm$core$Maybe$Just(166);
            case "npl":
                return $elm$core$Maybe$Just(167);
            case "nru":
                return $elm$core$Maybe$Just(168);
            case "niu":
                return $elm$core$Maybe$Just(169);
            case "nzl":
                return $elm$core$Maybe$Just(170);
            case "omn":
                return $elm$core$Maybe$Just(171);
            case "pan":
                return $elm$core$Maybe$Just(172);
            case "per":
                return $elm$core$Maybe$Just(173);
            case "pyf":
                return $elm$core$Maybe$Just(174);
            case "png":
                return $elm$core$Maybe$Just(175);
            case "phl":
                return $elm$core$Maybe$Just(176);
            case "pak":
                return $elm$core$Maybe$Just(177);
            case "pol":
                return $elm$core$Maybe$Just(178);
            case "spm":
                return $elm$core$Maybe$Just(179);
            case "pcn":
                return $elm$core$Maybe$Just(180);
            case "pri":
                return $elm$core$Maybe$Just(181);
            case "pse":
                return $elm$core$Maybe$Just(182);
            case "prt":
                return $elm$core$Maybe$Just(183);
            case "plw":
                return $elm$core$Maybe$Just(184);
            case "pry":
                return $elm$core$Maybe$Just(185);
            case "qat":
                return $elm$core$Maybe$Just(186);
            case "reu":
                return $elm$core$Maybe$Just(187);
            case "rou":
                return $elm$core$Maybe$Just(188);
            case "srb":
                return $elm$core$Maybe$Just(189);
            case "rus":
                return $elm$core$Maybe$Just(190);
            case "rwa":
                return $elm$core$Maybe$Just(191);
            case "sau":
                return $elm$core$Maybe$Just(192);
            case "slb":
                return $elm$core$Maybe$Just(193);
            case "syc":
                return $elm$core$Maybe$Just(194);
            case "sdn":
                return $elm$core$Maybe$Just(195);
            case "swe":
                return $elm$core$Maybe$Just(196);
            case "sgp":
                return $elm$core$Maybe$Just(197);
            case "shn":
                return $elm$core$Maybe$Just(198);
            case "svn":
                return $elm$core$Maybe$Just(199);
            case "sjm":
                return $elm$core$Maybe$Just(200);
            case "svk":
                return $elm$core$Maybe$Just(201);
            case "sle":
                return $elm$core$Maybe$Just(202);
            case "smr":
                return $elm$core$Maybe$Just(203);
            case "sen":
                return $elm$core$Maybe$Just(204);
            case "som":
                return $elm$core$Maybe$Just(205);
            case "sur":
                return $elm$core$Maybe$Just(206);
            case "ssd":
                return $elm$core$Maybe$Just(207);
            case "stp":
                return $elm$core$Maybe$Just(208);
            case "slv":
                return $elm$core$Maybe$Just(209);
            case "sxm":
                return $elm$core$Maybe$Just(210);
            case "syr":
                return $elm$core$Maybe$Just(211);
            case "swz":
                return $elm$core$Maybe$Just(212);
            case "tca":
                return $elm$core$Maybe$Just(213);
            case "tcd":
                return $elm$core$Maybe$Just(214);
            case "atf":
                return $elm$core$Maybe$Just(215);
            case "tgo":
                return $elm$core$Maybe$Just(216);
            case "tha":
                return $elm$core$Maybe$Just(217);
            case "tjk":
                return $elm$core$Maybe$Just(218);
            case "tkl":
                return $elm$core$Maybe$Just(219);
            case "tls":
                return $elm$core$Maybe$Just(220);
            case "tkm":
                return $elm$core$Maybe$Just(221);
            case "tun":
                return $elm$core$Maybe$Just(222);
            case "ton":
                return $elm$core$Maybe$Just(223);
            case "tur":
                return $elm$core$Maybe$Just(224);
            case "tto":
                return $elm$core$Maybe$Just(225);
            case "tuv":
                return $elm$core$Maybe$Just(226);
            case "twn":
                return $elm$core$Maybe$Just(227);
            case "tza":
                return $elm$core$Maybe$Just(228);
            case "ukr":
                return $elm$core$Maybe$Just(229);
            case "uga":
                return $elm$core$Maybe$Just(230);
            case "umi":
                return $elm$core$Maybe$Just(231);
            case "usa":
                return $elm$core$Maybe$Just(232);
            case "ury":
                return $elm$core$Maybe$Just(233);
            case "uzb":
                return $elm$core$Maybe$Just(234);
            case "vat":
                return $elm$core$Maybe$Just(235);
            case "vct":
                return $elm$core$Maybe$Just(236);
            case "ven":
                return $elm$core$Maybe$Just(237);
            case "vgb":
                return $elm$core$Maybe$Just(238);
            case "vir":
                return $elm$core$Maybe$Just(239);
            case "vnm":
                return $elm$core$Maybe$Just(240);
            case "vut":
                return $elm$core$Maybe$Just(241);
            case "wlf":
                return $elm$core$Maybe$Just(242);
            case "wsm":
                return $elm$core$Maybe$Just(243);
            case "yem":
                return $elm$core$Maybe$Just(244);
            case "myt":
                return $elm$core$Maybe$Just(245);
            case "zaf":
                return $elm$core$Maybe$Just(246);
            case "zmb":
                return $elm$core$Maybe$Just(247);
            case "zwe":
                return $elm$core$Maybe$Just(248);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $supermario$elm_countries$Countries$Country_fn = function (name, code, flag) {
        return { lS: code, fn: flag, M: name };
    }, $supermario$elm_countries$Countries$Country = F3($supermario$elm_countries$Countries$Country_fn);
    var $supermario$elm_countries$Countries$all = $elm$core$List$map_fn(function (_v0) {
        var name = _v0.a;
        var code = _v0.b;
        var flag = _v0.c;
        return $supermario$elm_countries$Countries$Country_fn(name, code, flag);
    }, _List_fromArray([
        _Utils_Tuple3("Andorra", "AD", "\uD83C\uDDE6\uD83C\uDDE9"),
        _Utils_Tuple3("United Arab Emirates", "AE", "\uD83C\uDDE6\uD83C\uDDEA"),
        _Utils_Tuple3("Afghanistan", "AF", "\uD83C\uDDE6\uD83C\uDDEB"),
        _Utils_Tuple3("Antigua and Barbuda", "AG", "\uD83C\uDDE6\uD83C\uDDEC"),
        _Utils_Tuple3("Anguilla", "AI", "\uD83C\uDDE6\uD83C\uDDEE"),
        _Utils_Tuple3("Albania", "AL", "\uD83C\uDDE6\uD83C\uDDF1"),
        _Utils_Tuple3("Armenia", "AM", "\uD83C\uDDE6\uD83C\uDDF2"),
        _Utils_Tuple3("Angola", "AO", "\uD83C\uDDE6\uD83C\uDDF4"),
        _Utils_Tuple3("Antarctica", "AQ", "\uD83C\uDDE6\uD83C\uDDF6"),
        _Utils_Tuple3("Argentina", "AR", "\uD83C\uDDE6\uD83C\uDDF7"),
        _Utils_Tuple3("American Samoa", "AS", "\uD83C\uDDE6\uD83C\uDDF8"),
        _Utils_Tuple3("Austria", "AT", "\uD83C\uDDE6\uD83C\uDDF9"),
        _Utils_Tuple3("Australia", "AU", "\uD83C\uDDE6\uD83C\uDDFA"),
        _Utils_Tuple3("Aruba", "AW", "\uD83C\uDDE6\uD83C\uDDFC"),
        _Utils_Tuple3("\u00C5land Islands", "AX", "\uD83C\uDDE6\uD83C\uDDFD"),
        _Utils_Tuple3("Azerbaijan", "AZ", "\uD83C\uDDE6\uD83C\uDDFF"),
        _Utils_Tuple3("Bosnia and Herzegovina", "BA", "\uD83C\uDDE7\uD83C\uDDE6"),
        _Utils_Tuple3("Barbados", "BB", "\uD83C\uDDE7\uD83C\uDDE7"),
        _Utils_Tuple3("Bangladesh", "BD", "\uD83C\uDDE7\uD83C\uDDE9"),
        _Utils_Tuple3("Belgium", "BE", "\uD83C\uDDE7\uD83C\uDDEA"),
        _Utils_Tuple3("Burkina Faso", "BF", "\uD83C\uDDE7\uD83C\uDDEB"),
        _Utils_Tuple3("Bulgaria", "BG", "\uD83C\uDDE7\uD83C\uDDEC"),
        _Utils_Tuple3("Bahrain", "BH", "\uD83C\uDDE7\uD83C\uDDED"),
        _Utils_Tuple3("Burundi", "BI", "\uD83C\uDDE7\uD83C\uDDEE"),
        _Utils_Tuple3("Benin", "BJ", "\uD83C\uDDE7\uD83C\uDDEF"),
        _Utils_Tuple3("Saint Barth\u00E9lemy", "BL", "\uD83C\uDDE7\uD83C\uDDF1"),
        _Utils_Tuple3("Bermuda", "BM", "\uD83C\uDDE7\uD83C\uDDF2"),
        _Utils_Tuple3("Brunei Darussalam", "BN", "\uD83C\uDDE7\uD83C\uDDF3"),
        _Utils_Tuple3("Bolivia (Plurinational State of)", "BO", "\uD83C\uDDE7\uD83C\uDDF4"),
        _Utils_Tuple3("Bonaire, Sint Eustatius and Saba", "BQ", "\uD83C\uDDE7\uD83C\uDDF6"),
        _Utils_Tuple3("Brazil", "BR", "\uD83C\uDDE7\uD83C\uDDF7"),
        _Utils_Tuple3("Bahamas", "BS", "\uD83C\uDDE7\uD83C\uDDF8"),
        _Utils_Tuple3("Bhutan", "BT", "\uD83C\uDDE7\uD83C\uDDF9"),
        _Utils_Tuple3("Bouvet Island", "BV", "\uD83C\uDDE7\uD83C\uDDFB"),
        _Utils_Tuple3("Botswana", "BW", "\uD83C\uDDE7\uD83C\uDDFC"),
        _Utils_Tuple3("Belarus", "BY", "\uD83C\uDDE7\uD83C\uDDFE"),
        _Utils_Tuple3("Belize", "BZ", "\uD83C\uDDE7\uD83C\uDDFF"),
        _Utils_Tuple3("Canada", "CA", "\uD83C\uDDE8\uD83C\uDDE6"),
        _Utils_Tuple3("Cocos (Keeling) Islands", "CC", "\uD83C\uDDE8\uD83C\uDDE8"),
        _Utils_Tuple3("Congo, Democratic Republic of the", "CD", "\uD83C\uDDE8\uD83C\uDDE9"),
        _Utils_Tuple3("Central African Republic", "CF", "\uD83C\uDDE8\uD83C\uDDEB"),
        _Utils_Tuple3("Congo", "CG", "\uD83C\uDDE8\uD83C\uDDEC"),
        _Utils_Tuple3("Switzerland", "CH", "\uD83C\uDDE8\uD83C\uDDED"),
        _Utils_Tuple3("C\u00F4te d'Ivoire", "CI", "\uD83C\uDDE8\uD83C\uDDEE"),
        _Utils_Tuple3("Cook Islands", "CK", "\uD83C\uDDE8\uD83C\uDDF0"),
        _Utils_Tuple3("Chile", "CL", "\uD83C\uDDE8\uD83C\uDDF1"),
        _Utils_Tuple3("Cameroon", "CM", "\uD83C\uDDE8\uD83C\uDDF2"),
        _Utils_Tuple3("China", "CN", "\uD83C\uDDE8\uD83C\uDDF3"),
        _Utils_Tuple3("Colombia", "CO", "\uD83C\uDDE8\uD83C\uDDF4"),
        _Utils_Tuple3("Costa Rica", "CR", "\uD83C\uDDE8\uD83C\uDDF7"),
        _Utils_Tuple3("Cuba", "CU", "\uD83C\uDDE8\uD83C\uDDFA"),
        _Utils_Tuple3("Cabo Verde", "CV", "\uD83C\uDDE8\uD83C\uDDFB"),
        _Utils_Tuple3("Cura\u00E7ao", "CW", "\uD83C\uDDE8\uD83C\uDDFC"),
        _Utils_Tuple3("Christmas Island", "CX", "\uD83C\uDDE8\uD83C\uDDFD"),
        _Utils_Tuple3("Cyprus", "CY", "\uD83C\uDDE8\uD83C\uDDFE"),
        _Utils_Tuple3("Czechia", "CZ", "\uD83C\uDDE8\uD83C\uDDFF"),
        _Utils_Tuple3("Germany", "DE", "\uD83C\uDDE9\uD83C\uDDEA"),
        _Utils_Tuple3("Djibouti", "DJ", "\uD83C\uDDE9\uD83C\uDDEF"),
        _Utils_Tuple3("Denmark", "DK", "\uD83C\uDDE9\uD83C\uDDF0"),
        _Utils_Tuple3("Dominica", "DM", "\uD83C\uDDE9\uD83C\uDDF2"),
        _Utils_Tuple3("Dominican Republic", "DO", "\uD83C\uDDE9\uD83C\uDDF4"),
        _Utils_Tuple3("Algeria", "DZ", "\uD83C\uDDE9\uD83C\uDDFF"),
        _Utils_Tuple3("Ecuador", "EC", "\uD83C\uDDEA\uD83C\uDDE8"),
        _Utils_Tuple3("Estonia", "EE", "\uD83C\uDDEA\uD83C\uDDEA"),
        _Utils_Tuple3("Egypt", "EG", "\uD83C\uDDEA\uD83C\uDDEC"),
        _Utils_Tuple3("Western Sahara", "EH", "\uD83C\uDDEA\uD83C\uDDED"),
        _Utils_Tuple3("Eritrea", "ER", "\uD83C\uDDEA\uD83C\uDDF7"),
        _Utils_Tuple3("Spain", "ES", "\uD83C\uDDEA\uD83C\uDDF8"),
        _Utils_Tuple3("Ethiopia", "ET", "\uD83C\uDDEA\uD83C\uDDF9"),
        _Utils_Tuple3("Finland", "FI", "\uD83C\uDDEB\uD83C\uDDEE"),
        _Utils_Tuple3("Fiji", "FJ", "\uD83C\uDDEB\uD83C\uDDEF"),
        _Utils_Tuple3("Falkland Islands (Malvinas)", "FK", "\uD83C\uDDEB\uD83C\uDDF0"),
        _Utils_Tuple3("Micronesia (Federated States of)", "FM", "\uD83C\uDDEB\uD83C\uDDF2"),
        _Utils_Tuple3("Faroe Islands", "FO", "\uD83C\uDDEB\uD83C\uDDF4"),
        _Utils_Tuple3("France", "FR", "\uD83C\uDDEB\uD83C\uDDF7"),
        _Utils_Tuple3("Gabon", "GA", "\uD83C\uDDEC\uD83C\uDDE6"),
        _Utils_Tuple3("United Kingdom of Great Britain and Northern Ireland", "GB", "\uD83C\uDDEC\uD83C\uDDE7"),
        _Utils_Tuple3("Grenada", "GD", "\uD83C\uDDEC\uD83C\uDDE9"),
        _Utils_Tuple3("Georgia", "GE", "\uD83C\uDDEC\uD83C\uDDEA"),
        _Utils_Tuple3("French Guiana", "GF", "\uD83C\uDDEC\uD83C\uDDEB"),
        _Utils_Tuple3("Guernsey", "GG", "\uD83C\uDDEC\uD83C\uDDEC"),
        _Utils_Tuple3("Ghana", "GH", "\uD83C\uDDEC\uD83C\uDDED"),
        _Utils_Tuple3("Gibraltar", "GI", "\uD83C\uDDEC\uD83C\uDDEE"),
        _Utils_Tuple3("Greenland", "GL", "\uD83C\uDDEC\uD83C\uDDF1"),
        _Utils_Tuple3("Gambia", "GM", "\uD83C\uDDEC\uD83C\uDDF2"),
        _Utils_Tuple3("Guinea", "GN", "\uD83C\uDDEC\uD83C\uDDF3"),
        _Utils_Tuple3("Guadeloupe", "GP", "\uD83C\uDDEC\uD83C\uDDF5"),
        _Utils_Tuple3("Equatorial Guinea", "GQ", "\uD83C\uDDEC\uD83C\uDDF6"),
        _Utils_Tuple3("Greece", "GR", "\uD83C\uDDEC\uD83C\uDDF7"),
        _Utils_Tuple3("South Georgia and the South Sandwich Islands", "GS", "\uD83C\uDDEC\uD83C\uDDF8"),
        _Utils_Tuple3("Guatemala", "GT", "\uD83C\uDDEC\uD83C\uDDF9"),
        _Utils_Tuple3("Guam", "GU", "\uD83C\uDDEC\uD83C\uDDFA"),
        _Utils_Tuple3("Guinea-Bissau", "GW", "\uD83C\uDDEC\uD83C\uDDFC"),
        _Utils_Tuple3("Guyana", "GY", "\uD83C\uDDEC\uD83C\uDDFE"),
        _Utils_Tuple3("Hong Kong", "HK", "\uD83C\uDDED\uD83C\uDDF0"),
        _Utils_Tuple3("Heard Island and McDonald Islands", "HM", "\uD83C\uDDED\uD83C\uDDF2"),
        _Utils_Tuple3("Honduras", "HN", "\uD83C\uDDED\uD83C\uDDF3"),
        _Utils_Tuple3("Croatia", "HR", "\uD83C\uDDED\uD83C\uDDF7"),
        _Utils_Tuple3("Haiti", "HT", "\uD83C\uDDED\uD83C\uDDF9"),
        _Utils_Tuple3("Hungary", "HU", "\uD83C\uDDED\uD83C\uDDFA"),
        _Utils_Tuple3("Indonesia", "ID", "\uD83C\uDDEE\uD83C\uDDE9"),
        _Utils_Tuple3("Ireland", "IE", "\uD83C\uDDEE\uD83C\uDDEA"),
        _Utils_Tuple3("Israel", "IL", "\uD83C\uDDEE\uD83C\uDDF1"),
        _Utils_Tuple3("Isle of Man", "IM", "\uD83C\uDDEE\uD83C\uDDF2"),
        _Utils_Tuple3("India", "IN", "\uD83C\uDDEE\uD83C\uDDF3"),
        _Utils_Tuple3("British Indian Ocean Territory", "IO", "\uD83C\uDDEE\uD83C\uDDF4"),
        _Utils_Tuple3("Iraq", "IQ", "\uD83C\uDDEE\uD83C\uDDF6"),
        _Utils_Tuple3("Iran (Islamic Republic of)", "IR", "\uD83C\uDDEE\uD83C\uDDF7"),
        _Utils_Tuple3("Iceland", "IS", "\uD83C\uDDEE\uD83C\uDDF8"),
        _Utils_Tuple3("Italy", "IT", "\uD83C\uDDEE\uD83C\uDDF9"),
        _Utils_Tuple3("Jersey", "JE", "\uD83C\uDDEF\uD83C\uDDEA"),
        _Utils_Tuple3("Jamaica", "JM", "\uD83C\uDDEF\uD83C\uDDF2"),
        _Utils_Tuple3("Jordan", "JO", "\uD83C\uDDEF\uD83C\uDDF4"),
        _Utils_Tuple3("Japan", "JP", "\uD83C\uDDEF\uD83C\uDDF5"),
        _Utils_Tuple3("Kenya", "KE", "\uD83C\uDDF0\uD83C\uDDEA"),
        _Utils_Tuple3("Kyrgyzstan", "KG", "\uD83C\uDDF0\uD83C\uDDEC"),
        _Utils_Tuple3("Cambodia", "KH", "\uD83C\uDDF0\uD83C\uDDED"),
        _Utils_Tuple3("Kiribati", "KI", "\uD83C\uDDF0\uD83C\uDDEE"),
        _Utils_Tuple3("Comoros", "KM", "\uD83C\uDDF0\uD83C\uDDF2"),
        _Utils_Tuple3("Saint Kitts and Nevis", "KN", "\uD83C\uDDF0\uD83C\uDDF3"),
        _Utils_Tuple3("Korea (Democratic People's Republic of)", "KP", "\uD83C\uDDF0\uD83C\uDDF5"),
        _Utils_Tuple3("Korea, Republic of", "KR", "\uD83C\uDDF0\uD83C\uDDF7"),
        _Utils_Tuple3("Kuwait", "KW", "\uD83C\uDDF0\uD83C\uDDFC"),
        _Utils_Tuple3("Cayman Islands", "KY", "\uD83C\uDDF0\uD83C\uDDFE"),
        _Utils_Tuple3("Kazakhstan", "KZ", "\uD83C\uDDF0\uD83C\uDDFF"),
        _Utils_Tuple3("Lao People's Democratic Republic", "LA", "\uD83C\uDDF1\uD83C\uDDE6"),
        _Utils_Tuple3("Lebanon", "LB", "\uD83C\uDDF1\uD83C\uDDE7"),
        _Utils_Tuple3("Saint Lucia", "LC", "\uD83C\uDDF1\uD83C\uDDE8"),
        _Utils_Tuple3("Liechtenstein", "LI", "\uD83C\uDDF1\uD83C\uDDEE"),
        _Utils_Tuple3("Sri Lanka", "LK", "\uD83C\uDDF1\uD83C\uDDF0"),
        _Utils_Tuple3("Liberia", "LR", "\uD83C\uDDF1\uD83C\uDDF7"),
        _Utils_Tuple3("Lesotho", "LS", "\uD83C\uDDF1\uD83C\uDDF8"),
        _Utils_Tuple3("Lithuania", "LT", "\uD83C\uDDF1\uD83C\uDDF9"),
        _Utils_Tuple3("Luxembourg", "LU", "\uD83C\uDDF1\uD83C\uDDFA"),
        _Utils_Tuple3("Latvia", "LV", "\uD83C\uDDF1\uD83C\uDDFB"),
        _Utils_Tuple3("Libya", "LY", "\uD83C\uDDF1\uD83C\uDDFE"),
        _Utils_Tuple3("Morocco", "MA", "\uD83C\uDDF2\uD83C\uDDE6"),
        _Utils_Tuple3("Monaco", "MC", "\uD83C\uDDF2\uD83C\uDDE8"),
        _Utils_Tuple3("Moldova, Republic of", "MD", "\uD83C\uDDF2\uD83C\uDDE9"),
        _Utils_Tuple3("Montenegro", "ME", "\uD83C\uDDF2\uD83C\uDDEA"),
        _Utils_Tuple3("Saint Martin (French part)", "MF", "\uD83C\uDDF2\uD83C\uDDEB"),
        _Utils_Tuple3("Madagascar", "MG", "\uD83C\uDDF2\uD83C\uDDEC"),
        _Utils_Tuple3("Marshall Islands", "MH", "\uD83C\uDDF2\uD83C\uDDED"),
        _Utils_Tuple3("North Macedonia", "MK", "\uD83C\uDDF2\uD83C\uDDF0"),
        _Utils_Tuple3("Mali", "ML", "\uD83C\uDDF2\uD83C\uDDF1"),
        _Utils_Tuple3("Myanmar", "MM", "\uD83C\uDDF2\uD83C\uDDF2"),
        _Utils_Tuple3("Mongolia", "MN", "\uD83C\uDDF2\uD83C\uDDF3"),
        _Utils_Tuple3("Macao", "MO", "\uD83C\uDDF2\uD83C\uDDF4"),
        _Utils_Tuple3("Northern Mariana Islands", "MP", "\uD83C\uDDF2\uD83C\uDDF5"),
        _Utils_Tuple3("Martinique", "MQ", "\uD83C\uDDF2\uD83C\uDDF6"),
        _Utils_Tuple3("Mauritania", "MR", "\uD83C\uDDF2\uD83C\uDDF7"),
        _Utils_Tuple3("Montserrat", "MS", "\uD83C\uDDF2\uD83C\uDDF8"),
        _Utils_Tuple3("Malta", "MT", "\uD83C\uDDF2\uD83C\uDDF9"),
        _Utils_Tuple3("Mauritius", "MU", "\uD83C\uDDF2\uD83C\uDDFA"),
        _Utils_Tuple3("Maldives", "MV", "\uD83C\uDDF2\uD83C\uDDFB"),
        _Utils_Tuple3("Malawi", "MW", "\uD83C\uDDF2\uD83C\uDDFC"),
        _Utils_Tuple3("Mexico", "MX", "\uD83C\uDDF2\uD83C\uDDFD"),
        _Utils_Tuple3("Malaysia", "MY", "\uD83C\uDDF2\uD83C\uDDFE"),
        _Utils_Tuple3("Mozambique", "MZ", "\uD83C\uDDF2\uD83C\uDDFF"),
        _Utils_Tuple3("Namibia", "NA", "\uD83C\uDDF3\uD83C\uDDE6"),
        _Utils_Tuple3("New Caledonia", "NC", "\uD83C\uDDF3\uD83C\uDDE8"),
        _Utils_Tuple3("Niger", "NE", "\uD83C\uDDF3\uD83C\uDDEA"),
        _Utils_Tuple3("Norfolk Island", "NF", "\uD83C\uDDF3\uD83C\uDDEB"),
        _Utils_Tuple3("Nigeria", "NG", "\uD83C\uDDF3\uD83C\uDDEC"),
        _Utils_Tuple3("Nicaragua", "NI", "\uD83C\uDDF3\uD83C\uDDEE"),
        _Utils_Tuple3("Netherlands", "NL", "\uD83C\uDDF3\uD83C\uDDF1"),
        _Utils_Tuple3("Norway", "NO", "\uD83C\uDDF3\uD83C\uDDF4"),
        _Utils_Tuple3("Nepal", "NP", "\uD83C\uDDF3\uD83C\uDDF5"),
        _Utils_Tuple3("Nauru", "NR", "\uD83C\uDDF3\uD83C\uDDF7"),
        _Utils_Tuple3("Niue", "NU", "\uD83C\uDDF3\uD83C\uDDFA"),
        _Utils_Tuple3("New Zealand", "NZ", "\uD83C\uDDF3\uD83C\uDDFF"),
        _Utils_Tuple3("Oman", "OM", "\uD83C\uDDF4\uD83C\uDDF2"),
        _Utils_Tuple3("Panama", "PA", "\uD83C\uDDF5\uD83C\uDDE6"),
        _Utils_Tuple3("Peru", "PE", "\uD83C\uDDF5\uD83C\uDDEA"),
        _Utils_Tuple3("French Polynesia", "PF", "\uD83C\uDDF5\uD83C\uDDEB"),
        _Utils_Tuple3("Papua New Guinea", "PG", "\uD83C\uDDF5\uD83C\uDDEC"),
        _Utils_Tuple3("Philippines", "PH", "\uD83C\uDDF5\uD83C\uDDED"),
        _Utils_Tuple3("Pakistan", "PK", "\uD83C\uDDF5\uD83C\uDDF0"),
        _Utils_Tuple3("Poland", "PL", "\uD83C\uDDF5\uD83C\uDDF1"),
        _Utils_Tuple3("Saint Pierre and Miquelon", "PM", "\uD83C\uDDF5\uD83C\uDDF2"),
        _Utils_Tuple3("Pitcairn", "PN", "\uD83C\uDDF5\uD83C\uDDF3"),
        _Utils_Tuple3("Puerto Rico", "PR", "\uD83C\uDDF5\uD83C\uDDF7"),
        _Utils_Tuple3("Palestine, State of", "PS", "\uD83C\uDDF5\uD83C\uDDF8"),
        _Utils_Tuple3("Portugal", "PT", "\uD83C\uDDF5\uD83C\uDDF9"),
        _Utils_Tuple3("Palau", "PW", "\uD83C\uDDF5\uD83C\uDDFC"),
        _Utils_Tuple3("Paraguay", "PY", "\uD83C\uDDF5\uD83C\uDDFE"),
        _Utils_Tuple3("Qatar", "QA", "\uD83C\uDDF6\uD83C\uDDE6"),
        _Utils_Tuple3("R\u00E9union", "RE", "\uD83C\uDDF7\uD83C\uDDEA"),
        _Utils_Tuple3("Romania", "RO", "\uD83C\uDDF7\uD83C\uDDF4"),
        _Utils_Tuple3("Serbia", "RS", "\uD83C\uDDF7\uD83C\uDDF8"),
        _Utils_Tuple3("Russian Federation", "RU", "\uD83C\uDDF7\uD83C\uDDFA"),
        _Utils_Tuple3("Rwanda", "RW", "\uD83C\uDDF7\uD83C\uDDFC"),
        _Utils_Tuple3("Saudi Arabia", "SA", "\uD83C\uDDF8\uD83C\uDDE6"),
        _Utils_Tuple3("Solomon Islands", "SB", "\uD83C\uDDF8\uD83C\uDDE7"),
        _Utils_Tuple3("Seychelles", "SC", "\uD83C\uDDF8\uD83C\uDDE8"),
        _Utils_Tuple3("Sudan", "SD", "\uD83C\uDDF8\uD83C\uDDE9"),
        _Utils_Tuple3("Sweden", "SE", "\uD83C\uDDF8\uD83C\uDDEA"),
        _Utils_Tuple3("Singapore", "SG", "\uD83C\uDDF8\uD83C\uDDEC"),
        _Utils_Tuple3("Saint Helena, Ascension and Tristan da Cunha", "SH", "\uD83C\uDDF8\uD83C\uDDED"),
        _Utils_Tuple3("Slovenia", "SI", "\uD83C\uDDF8\uD83C\uDDEE"),
        _Utils_Tuple3("Svalbard and Jan Mayen", "SJ", "\uD83C\uDDF8\uD83C\uDDEF"),
        _Utils_Tuple3("Slovakia", "SK", "\uD83C\uDDF8\uD83C\uDDF0"),
        _Utils_Tuple3("Sierra Leone", "SL", "\uD83C\uDDF8\uD83C\uDDF1"),
        _Utils_Tuple3("San Marino", "SM", "\uD83C\uDDF8\uD83C\uDDF2"),
        _Utils_Tuple3("Senegal", "SN", "\uD83C\uDDF8\uD83C\uDDF3"),
        _Utils_Tuple3("Somalia", "SO", "\uD83C\uDDF8\uD83C\uDDF4"),
        _Utils_Tuple3("Suriname", "SR", "\uD83C\uDDF8\uD83C\uDDF7"),
        _Utils_Tuple3("South Sudan", "SS", "\uD83C\uDDF8\uD83C\uDDF8"),
        _Utils_Tuple3("Sao Tome and Principe", "ST", "\uD83C\uDDF8\uD83C\uDDF9"),
        _Utils_Tuple3("El Salvador", "SV", "\uD83C\uDDF8\uD83C\uDDFB"),
        _Utils_Tuple3("Sint Maarten (Dutch part)", "SX", "\uD83C\uDDF8\uD83C\uDDFD"),
        _Utils_Tuple3("Syrian Arab Republic", "SY", "\uD83C\uDDF8\uD83C\uDDFE"),
        _Utils_Tuple3("Eswatini", "SZ", "\uD83C\uDDF8\uD83C\uDDFF"),
        _Utils_Tuple3("Turks and Caicos Islands", "TC", "\uD83C\uDDF9\uD83C\uDDE8"),
        _Utils_Tuple3("Chad", "TD", "\uD83C\uDDF9\uD83C\uDDE9"),
        _Utils_Tuple3("French Southern Territories", "TF", "\uD83C\uDDF9\uD83C\uDDEB"),
        _Utils_Tuple3("Togo", "TG", "\uD83C\uDDF9\uD83C\uDDEC"),
        _Utils_Tuple3("Thailand", "TH", "\uD83C\uDDF9\uD83C\uDDED"),
        _Utils_Tuple3("Tajikistan", "TJ", "\uD83C\uDDF9\uD83C\uDDEF"),
        _Utils_Tuple3("Tokelau", "TK", "\uD83C\uDDF9\uD83C\uDDF0"),
        _Utils_Tuple3("Timor-Leste", "TL", "\uD83C\uDDF9\uD83C\uDDF1"),
        _Utils_Tuple3("Turkmenistan", "TM", "\uD83C\uDDF9\uD83C\uDDF2"),
        _Utils_Tuple3("Tunisia", "TN", "\uD83C\uDDF9\uD83C\uDDF3"),
        _Utils_Tuple3("Tonga", "TO", "\uD83C\uDDF9\uD83C\uDDF4"),
        _Utils_Tuple3("Turkey", "TR", "\uD83C\uDDF9\uD83C\uDDF7"),
        _Utils_Tuple3("Trinidad and Tobago", "TT", "\uD83C\uDDF9\uD83C\uDDF9"),
        _Utils_Tuple3("Tuvalu", "TV", "\uD83C\uDDF9\uD83C\uDDFB"),
        _Utils_Tuple3("Taiwan, Province of China", "TW", "\uD83C\uDDF9\uD83C\uDDFC"),
        _Utils_Tuple3("Tanzania, United Republic of", "TZ", "\uD83C\uDDF9\uD83C\uDDFF"),
        _Utils_Tuple3("Ukraine", "UA", "\uD83C\uDDFA\uD83C\uDDE6"),
        _Utils_Tuple3("Uganda", "UG", "\uD83C\uDDFA\uD83C\uDDEC"),
        _Utils_Tuple3("United States Minor Outlying Islands", "UM", "\uD83C\uDDFA\uD83C\uDDF2"),
        _Utils_Tuple3("United States of America", "US", "\uD83C\uDDFA\uD83C\uDDF8"),
        _Utils_Tuple3("Uruguay", "UY", "\uD83C\uDDFA\uD83C\uDDFE"),
        _Utils_Tuple3("Uzbekistan", "UZ", "\uD83C\uDDFA\uD83C\uDDFF"),
        _Utils_Tuple3("Holy See", "VA", "\uD83C\uDDFB\uD83C\uDDE6"),
        _Utils_Tuple3("Saint Vincent and the Grenadines", "VC", "\uD83C\uDDFB\uD83C\uDDE8"),
        _Utils_Tuple3("Venezuela (Bolivarian Republic of)", "VE", "\uD83C\uDDFB\uD83C\uDDEA"),
        _Utils_Tuple3("Virgin Islands (British)", "VG", "\uD83C\uDDFB\uD83C\uDDEC"),
        _Utils_Tuple3("Virgin Islands (U.S.)", "VI", "\uD83C\uDDFB\uD83C\uDDEE"),
        _Utils_Tuple3("Viet Nam", "VN", "\uD83C\uDDFB\uD83C\uDDF3"),
        _Utils_Tuple3("Vanuatu", "VU", "\uD83C\uDDFB\uD83C\uDDFA"),
        _Utils_Tuple3("Wallis and Futuna", "WF", "\uD83C\uDDFC\uD83C\uDDEB"),
        _Utils_Tuple3("Samoa", "WS", "\uD83C\uDDFC\uD83C\uDDF8"),
        _Utils_Tuple3("Yemen", "YE", "\uD83C\uDDFE\uD83C\uDDEA"),
        _Utils_Tuple3("Mayotte", "YT", "\uD83C\uDDFE\uD83C\uDDF9"),
        _Utils_Tuple3("South Africa", "ZA", "\uD83C\uDDFF\uD83C\uDDE6"),
        _Utils_Tuple3("Zambia", "ZM", "\uD83C\uDDFF\uD83C\uDDF2"),
        _Utils_Tuple3("Zimbabwe", "ZW", "\uD83C\uDDFF\uD83C\uDDFC")
    ]));
    var $supermario$elm_countries$Countries$fromCodeCustom_fn = function (countries, code) {
        return ($elm$core$String$length(code) !== 2) ? $elm$core$Maybe$Nothing : $elm$core$List$head($elm$core$List$filter_fn(function (country) {
            return _Utils_eq(country.lS, code);
        }, countries));
    }, $supermario$elm_countries$Countries$fromCodeCustom = F2($supermario$elm_countries$Countries$fromCodeCustom_fn);
    var $supermario$elm_countries$Countries$fromCode = function (code) {
        return $supermario$elm_countries$Countries$fromCodeCustom_fn($supermario$elm_countries$Countries$all, code);
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$addElementsToDuration = function () {
        var addElementToDuration = F2(function (element, intermediateDuration) {
            switch (element.$) {
                case 0:
                    var y = element.a;
                    return _Utils_update(intermediateDuration, { gm: y });
                case 1:
                    var m = element.a;
                    return _Utils_update(intermediateDuration, { fG: m });
                case 2:
                    var d = element.a;
                    return _Utils_update(intermediateDuration, { d_: d });
                case 3:
                    var h = element.a;
                    return _Utils_update(intermediateDuration, { bQ: h });
                case 4:
                    var m = element.a;
                    return _Utils_update(intermediateDuration, { bW: m });
                default:
                    var s = element.a;
                    return _Utils_update(intermediateDuration, { dj: s });
            }
        });
        return $elm$core$List$foldr(addElementToDuration);
    }();
    var $gigobyte$iso8601_duration$Iso8601$Duration$Days = function (a) {
        return { $: 2, a: a };
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$Months = function (a) {
        return { $: 1, a: a };
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$Years = function (a) {
        return { $: 0, a: a };
    };
    var $elm$parser$Parser$ExpectingFloat = { $: 5 };
    var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
    var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
    var $elm$parser$Parser$Advanced$bumpOffset_fn = function (newOffset, s) {
        return { iR: s.iR + (newOffset - s.fK), bx: s.bx, w: s.w, fK: newOffset, kJ: s.kJ, h6: s.h6 };
    }, $elm$parser$Parser$Advanced$bumpOffset = F2($elm$parser$Parser$Advanced$bumpOffset_fn);
    var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
    var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
    var $elm$parser$Parser$Advanced$consumeExp_fn = function (offset, src) {
        if (_Parser_isAsciiCode_fn(101, offset, src) || _Parser_isAsciiCode_fn(69, offset, src)) {
            var eOffset = offset + 1;
            var expOffset = (_Parser_isAsciiCode_fn(43, eOffset, src) || _Parser_isAsciiCode_fn(45, eOffset, src)) ? (eOffset + 1) : eOffset;
            var newOffset = _Parser_chompBase10_fn(expOffset, src);
            return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
        }
        else {
            return offset;
        }
    }, $elm$parser$Parser$Advanced$consumeExp = F2($elm$parser$Parser$Advanced$consumeExp_fn);
    var $elm$parser$Parser$Advanced$consumeDotAndExp_fn = function (offset, src) {
        return _Parser_isAsciiCode_fn(46, offset, src) ? $elm$parser$Parser$Advanced$consumeExp_fn(_Parser_chompBase10_fn(offset + 1, src), src) : $elm$parser$Parser$Advanced$consumeExp_fn(offset, src);
    }, $elm$parser$Parser$Advanced$consumeDotAndExp = F2($elm$parser$Parser$Advanced$consumeDotAndExp_fn);
    var $elm$parser$Parser$Advanced$finalizeInt_fn = function (invalid, handler, startOffset, _v0, s) {
        var endOffset = _v0.a;
        var n = _v0.b;
        if (handler.$ === 1) {
            var x = handler.a;
            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        }
        else {
            var toValue = handler.a;
            return _Utils_eq(startOffset, endOffset) ? $elm$parser$Parser$Advanced$Bad_fn(_Utils_cmp(s.fK, startOffset) < 0, $elm$parser$Parser$Advanced$fromState_fn(s, invalid)) : $elm$parser$Parser$Advanced$Good_fn(true, toValue(n), $elm$parser$Parser$Advanced$bumpOffset_fn(endOffset, s));
        }
    }, $elm$parser$Parser$Advanced$finalizeInt = F5($elm$parser$Parser$Advanced$finalizeInt_fn);
    var $elm$parser$Parser$Advanced$fromInfo_fn = function (row, col, x, context) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(row, col, x, context));
    }, $elm$parser$Parser$Advanced$fromInfo = F4($elm$parser$Parser$Advanced$fromInfo_fn);
    var $elm$parser$Parser$Advanced$finalizeFloat_fn = function (invalid, expecting, intSettings, floatSettings, intPair, s) {
        var intOffset = intPair.a;
        var floatOffset = $elm$parser$Parser$Advanced$consumeDotAndExp_fn(intOffset, s.h6);
        if (floatOffset < 0) {
            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromInfo_fn(s.kJ, s.iR - (floatOffset + s.fK), invalid, s.bx));
        }
        else {
            if (_Utils_eq(s.fK, floatOffset)) {
                return $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting));
            }
            else {
                if (_Utils_eq(intOffset, floatOffset)) {
                    return $elm$parser$Parser$Advanced$finalizeInt_fn(invalid, intSettings, s.fK, intPair, s);
                }
                else {
                    if (floatSettings.$ === 1) {
                        var x = floatSettings.a;
                        return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, invalid));
                    }
                    else {
                        var toValue = floatSettings.a;
                        var _v1 = $elm$core$String$toFloat(_String_slice_fn(s.fK, floatOffset, s.h6));
                        if (_v1.$ === 1) {
                            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, invalid));
                        }
                        else {
                            var n = _v1.a;
                            return $elm$parser$Parser$Advanced$Good_fn(true, toValue(n), $elm$parser$Parser$Advanced$bumpOffset_fn(floatOffset, s));
                        }
                    }
                }
            }
        }
    }, $elm$parser$Parser$Advanced$finalizeFloat = F6($elm$parser$Parser$Advanced$finalizeFloat_fn);
    var $elm$parser$Parser$Advanced$number = function (c) {
        return function (s) {
            if (_Parser_isAsciiCode_fn(48, s.fK, s.h6)) {
                var zeroOffset = s.fK + 1;
                var baseOffset = zeroOffset + 1;
                return _Parser_isAsciiCode_fn(120, zeroOffset, s.h6) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.c5, c.jy, baseOffset, _Parser_consumeBase16_fn(baseOffset, s.h6), s) : (_Parser_isAsciiCode_fn(111, zeroOffset, s.h6) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.c5, c.kc, baseOffset, _Parser_consumeBase_fn(8, baseOffset, s.h6), s) : (_Parser_isAsciiCode_fn(98, zeroOffset, s.h6) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.c5, c.iK, baseOffset, _Parser_consumeBase_fn(2, baseOffset, s.h6), s) : $elm$parser$Parser$Advanced$finalizeFloat_fn(c.c5, c.ji, c.jG, c.jo, _Utils_Tuple2(zeroOffset, 0), s)));
            }
            else {
                return $elm$parser$Parser$Advanced$finalizeFloat_fn(c.c5, c.ji, c.jG, c.jo, _Parser_consumeBase_fn(10, s.fK, s.h6), s);
            }
        };
    };
    var $elm$parser$Parser$Advanced$float_fn = function (expecting, invalid) {
        return $elm$parser$Parser$Advanced$number({
            iK: $elm$core$Result$Err(invalid),
            ji: expecting,
            jo: $elm$core$Result$Ok($elm$core$Basics$identity),
            jy: $elm$core$Result$Err(invalid),
            jG: $elm$core$Result$Ok($elm$core$Basics$toFloat),
            c5: invalid,
            kc: $elm$core$Result$Err(invalid)
        });
    }, $elm$parser$Parser$Advanced$float = F2($elm$parser$Parser$Advanced$float_fn);
    var $elm$parser$Parser$float = $elm$parser$Parser$Advanced$float_fn($elm$parser$Parser$ExpectingFloat, $elm$parser$Parser$ExpectingFloat);
    var $gigobyte$iso8601_duration$Iso8601$Duration$dateElementParser = function (elements) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(F2(function (a, b) {
                return $elm$parser$Parser$Loop(_List_Cons(b(a), elements));
            })), $elm$parser$Parser$float), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Years), $elm$parser$Parser$symbol("Y")),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Months), $elm$parser$Parser$symbol("M")),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Days), $elm$parser$Parser$symbol("D"))
            ]))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(elements))
        ]));
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$dateElementsParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol("P")), $elm$parser$Parser$loop_fn(_List_Nil, $gigobyte$iso8601_duration$Iso8601$Duration$dateElementParser));
    var $gigobyte$iso8601_duration$Iso8601$Duration$initialDuration = { d_: 0, bQ: 0, bW: 0, fG: 0, dj: 0, gm: 0 };
    var $gigobyte$iso8601_duration$Iso8601$Duration$isValidElementSequence_fn = function (a, b) {
        var _v0 = _Utils_Tuple2(a, b);
        _v0$6: while (true) {
            switch (_v0.a.$) {
                case 1:
                    if (!_v0.b.$) {
                        return true;
                    }
                    else {
                        break _v0$6;
                    }
                case 2:
                    switch (_v0.b.$) {
                        case 1:
                            return true;
                        case 0:
                            return true;
                        default:
                            break _v0$6;
                    }
                case 4:
                    if (_v0.b.$ === 3) {
                        return true;
                    }
                    else {
                        break _v0$6;
                    }
                case 5:
                    switch (_v0.b.$) {
                        case 4:
                            return true;
                        case 3:
                            return true;
                        default:
                            break _v0$6;
                    }
                default:
                    break _v0$6;
            }
        }
        return false;
    }, $gigobyte$iso8601_duration$Iso8601$Duration$isValidElementSequence = F2($gigobyte$iso8601_duration$Iso8601$Duration$isValidElementSequence_fn);
    var $gigobyte$iso8601_duration$Iso8601$Duration$isOutOfOrder = function (elements) {
        isOutOfOrder: while (true) {
            if (elements.b && elements.b.b) {
                var x = elements.a;
                var _v1 = elements.b;
                var y = _v1.a;
                var xs = _v1.b;
                if (!$gigobyte$iso8601_duration$Iso8601$Duration$isValidElementSequence_fn(x, y)) {
                    return true;
                }
                else {
                    var $temp$elements = _List_Cons(y, xs);
                    elements = $temp$elements;
                    continue isOutOfOrder;
                }
            }
            else {
                return false;
            }
        }
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$parseElements_fn = function (elementParser, date) {
        return $elm$core$Maybe$andThen_fn(function (elements) {
            return $gigobyte$iso8601_duration$Iso8601$Duration$isOutOfOrder(elements) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(elements);
        }, $elm$core$Result$toMaybe($elm$parser$Parser$run_fn(elementParser, date)));
    }, $gigobyte$iso8601_duration$Iso8601$Duration$parseElements = F2($gigobyte$iso8601_duration$Iso8601$Duration$parseElements_fn);
    var $gigobyte$iso8601_duration$Iso8601$Duration$Hours = function (a) {
        return { $: 3, a: a };
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$Minutes = function (a) {
        return { $: 4, a: a };
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$Seconds = function (a) {
        return { $: 5, a: a };
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$timeElementParser = function (elements) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(F2(function (a, b) {
                return $elm$parser$Parser$Loop(_List_Cons(b(a), elements));
            })), $elm$parser$Parser$float), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Hours), $elm$parser$Parser$symbol("H")),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Minutes), $elm$parser$Parser$symbol("M")),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($gigobyte$iso8601_duration$Iso8601$Duration$Seconds), $elm$parser$Parser$symbol("S"))
            ]))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(elements))
        ]));
    };
    var $gigobyte$iso8601_duration$Iso8601$Duration$timeElementsParser = $elm$parser$Parser$loop_fn(_List_Nil, $gigobyte$iso8601_duration$Iso8601$Duration$timeElementParser);
    var $gigobyte$iso8601_duration$Iso8601$Duration$weekParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol("P")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$float, $elm$parser$Parser$symbol("W")), $elm$parser$Parser$end));
    var $gigobyte$iso8601_duration$Iso8601$Duration$fromString = function (duration) {
        if (!_String_startsWith_fn("P", duration)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            if (_String_contains_fn("W", duration)) {
                return $elm$core$Result$toMaybe($elm$core$Result$map_fn(function (weeks) {
                    return _Utils_update($gigobyte$iso8601_duration$Iso8601$Duration$initialDuration, { d_: weeks * 7 });
                }, $elm$parser$Parser$run_fn($gigobyte$iso8601_duration$Iso8601$Duration$weekParser, duration)));
            }
            else {
                var _v0 = $elm$core$String$split_fn("T", $elm$core$String$replace_fn(",", ".", duration));
                _v0$4: while (true) {
                    if (_v0.b) {
                        if (_v0.b.b) {
                            if (!_v0.b.b.b) {
                                if (_v0.b.a === "") {
                                    var date = _v0.a;
                                    var _v1 = _v0.b;
                                    return $elm$core$Maybe$Nothing;
                                }
                                else {
                                    var date = _v0.a;
                                    var _v2 = _v0.b;
                                    var time = _v2.a;
                                    var _v3 = _Utils_Tuple2($gigobyte$iso8601_duration$Iso8601$Duration$parseElements_fn($gigobyte$iso8601_duration$Iso8601$Duration$dateElementsParser, date), $gigobyte$iso8601_duration$Iso8601$Duration$parseElements_fn($gigobyte$iso8601_duration$Iso8601$Duration$timeElementsParser, time));
                                    if ((((!_v3.a.$) && (!_v3.a.a.b)) && (!_v3.b.$)) && (!_v3.b.a.b)) {
                                        return $elm$core$Maybe$Nothing;
                                    }
                                    else {
                                        var dateElements = _v3.a;
                                        var timeElements = _v3.b;
                                        return function (intermediateDuration) {
                                            return $elm$core$Maybe$map2_fn($gigobyte$iso8601_duration$Iso8601$Duration$addElementsToDuration, intermediateDuration, timeElements);
                                        }($elm$core$Maybe$map_fn($gigobyte$iso8601_duration$Iso8601$Duration$addElementsToDuration($gigobyte$iso8601_duration$Iso8601$Duration$initialDuration), dateElements));
                                    }
                                }
                            }
                            else {
                                break _v0$4;
                            }
                        }
                        else {
                            if (_v0.a === "P") {
                                return $elm$core$Maybe$Nothing;
                            }
                            else {
                                var date = _v0.a;
                                var _v4 = $gigobyte$iso8601_duration$Iso8601$Duration$parseElements_fn($gigobyte$iso8601_duration$Iso8601$Duration$dateElementsParser, date);
                                if ((!_v4.$) && (!_v4.a.b)) {
                                    return $elm$core$Maybe$Nothing;
                                }
                                else {
                                    var dateElements = _v4;
                                    return $elm$core$Maybe$map_fn($gigobyte$iso8601_duration$Iso8601$Duration$addElementsToDuration($gigobyte$iso8601_duration$Iso8601$Duration$initialDuration), dateElements);
                                }
                            }
                        }
                    }
                    else {
                        break _v0$4;
                    }
                }
                return $elm$core$Maybe$Nothing;
            }
        }
    };
    var $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2 = function (c) {
        switch (c) {
            case 0:
                return "ad";
            case 1:
                return "ae";
            case 2:
                return "af";
            case 3:
                return "ag";
            case 4:
                return "ai";
            case 5:
                return "al";
            case 6:
                return "am";
            case 7:
                return "ao";
            case 8:
                return "aq";
            case 9:
                return "ar";
            case 10:
                return "as";
            case 11:
                return "at";
            case 12:
                return "au";
            case 13:
                return "aw";
            case 14:
                return "ax";
            case 15:
                return "az";
            case 16:
                return "ba";
            case 17:
                return "bb";
            case 18:
                return "bd";
            case 19:
                return "be";
            case 20:
                return "bf";
            case 21:
                return "bg";
            case 22:
                return "bh";
            case 23:
                return "bi";
            case 24:
                return "bj";
            case 25:
                return "bl";
            case 26:
                return "bm";
            case 27:
                return "bn";
            case 28:
                return "bo";
            case 29:
                return "bq";
            case 30:
                return "br";
            case 31:
                return "bs";
            case 32:
                return "bt";
            case 33:
                return "bv";
            case 34:
                return "bw";
            case 35:
                return "by";
            case 36:
                return "bz";
            case 37:
                return "ca";
            case 38:
                return "cc";
            case 39:
                return "cd";
            case 40:
                return "cf";
            case 41:
                return "cg";
            case 42:
                return "ch";
            case 43:
                return "ci";
            case 44:
                return "ck";
            case 45:
                return "cl";
            case 46:
                return "cm";
            case 47:
                return "cn";
            case 48:
                return "co";
            case 49:
                return "cr";
            case 50:
                return "cu";
            case 51:
                return "cv";
            case 52:
                return "cw";
            case 53:
                return "cx";
            case 54:
                return "cy";
            case 55:
                return "cz";
            case 56:
                return "de";
            case 57:
                return "dj";
            case 58:
                return "dk";
            case 59:
                return "dm";
            case 60:
                return "do";
            case 61:
                return "dz";
            case 62:
                return "ec";
            case 63:
                return "ee";
            case 64:
                return "eg";
            case 65:
                return "eh";
            case 66:
                return "er";
            case 67:
                return "es";
            case 68:
                return "et";
            case 69:
                return "fi";
            case 70:
                return "fj";
            case 71:
                return "fk";
            case 72:
                return "fm";
            case 73:
                return "fo";
            case 74:
                return "fr";
            case 75:
                return "ga";
            case 76:
                return "gb";
            case 77:
                return "gd";
            case 78:
                return "ge";
            case 79:
                return "gf";
            case 80:
                return "gg";
            case 81:
                return "gh";
            case 82:
                return "gi";
            case 83:
                return "gl";
            case 84:
                return "gm";
            case 85:
                return "gn";
            case 86:
                return "gp";
            case 87:
                return "gq";
            case 88:
                return "gr";
            case 89:
                return "gs";
            case 90:
                return "gt";
            case 91:
                return "gu";
            case 92:
                return "gw";
            case 93:
                return "gy";
            case 94:
                return "hk";
            case 95:
                return "hm";
            case 96:
                return "hn";
            case 97:
                return "hr";
            case 98:
                return "ht";
            case 99:
                return "hu";
            case 100:
                return "id";
            case 101:
                return "ie";
            case 102:
                return "il";
            case 103:
                return "im";
            case 104:
                return "in";
            case 105:
                return "io";
            case 106:
                return "iq";
            case 107:
                return "ir";
            case 108:
                return "is";
            case 109:
                return "it";
            case 110:
                return "je";
            case 111:
                return "jm";
            case 112:
                return "jo";
            case 113:
                return "jp";
            case 114:
                return "ke";
            case 115:
                return "kg";
            case 116:
                return "kh";
            case 117:
                return "ki";
            case 118:
                return "km";
            case 119:
                return "kn";
            case 120:
                return "kp";
            case 121:
                return "kr";
            case 122:
                return "kw";
            case 123:
                return "ky";
            case 124:
                return "kz";
            case 125:
                return "la";
            case 126:
                return "lb";
            case 127:
                return "lc";
            case 128:
                return "li";
            case 129:
                return "lk";
            case 130:
                return "lr";
            case 131:
                return "ls";
            case 132:
                return "lt";
            case 133:
                return "lu";
            case 134:
                return "lv";
            case 135:
                return "ly";
            case 136:
                return "ma";
            case 137:
                return "mc";
            case 138:
                return "md";
            case 139:
                return "me";
            case 140:
                return "mf";
            case 141:
                return "mg";
            case 142:
                return "mh";
            case 143:
                return "mk";
            case 144:
                return "ml";
            case 145:
                return "mm";
            case 146:
                return "mn";
            case 147:
                return "mo";
            case 148:
                return "mp";
            case 149:
                return "mq";
            case 150:
                return "mr";
            case 151:
                return "ms";
            case 152:
                return "mt";
            case 153:
                return "mu";
            case 154:
                return "mv";
            case 155:
                return "mw";
            case 156:
                return "mx";
            case 157:
                return "my";
            case 158:
                return "mz";
            case 159:
                return "na";
            case 160:
                return "nc";
            case 161:
                return "ne";
            case 162:
                return "nf";
            case 163:
                return "ng";
            case 164:
                return "ni";
            case 165:
                return "nl";
            case 166:
                return "no";
            case 167:
                return "np";
            case 168:
                return "nr";
            case 169:
                return "nu";
            case 170:
                return "nz";
            case 171:
                return "om";
            case 172:
                return "pa";
            case 173:
                return "pe";
            case 174:
                return "pf";
            case 175:
                return "pg";
            case 176:
                return "ph";
            case 177:
                return "pk";
            case 178:
                return "pl";
            case 179:
                return "pm";
            case 180:
                return "pn";
            case 181:
                return "pr";
            case 182:
                return "ps";
            case 183:
                return "pt";
            case 184:
                return "pw";
            case 185:
                return "py";
            case 186:
                return "qa";
            case 187:
                return "re";
            case 188:
                return "ro";
            case 189:
                return "rs";
            case 190:
                return "ru";
            case 191:
                return "rw";
            case 192:
                return "sa";
            case 193:
                return "sb";
            case 194:
                return "sc";
            case 195:
                return "sd";
            case 196:
                return "se";
            case 197:
                return "sg";
            case 198:
                return "sh";
            case 199:
                return "si";
            case 200:
                return "sj";
            case 201:
                return "sk";
            case 202:
                return "sl";
            case 203:
                return "sm";
            case 204:
                return "sn";
            case 205:
                return "so";
            case 206:
                return "sr";
            case 207:
                return "ss";
            case 208:
                return "st";
            case 209:
                return "sv";
            case 210:
                return "sx";
            case 211:
                return "sy";
            case 212:
                return "sz";
            case 213:
                return "tc";
            case 214:
                return "td";
            case 215:
                return "tf";
            case 216:
                return "tg";
            case 217:
                return "th";
            case 218:
                return "tj";
            case 219:
                return "tk";
            case 220:
                return "tl";
            case 221:
                return "tm";
            case 222:
                return "tn";
            case 223:
                return "to";
            case 224:
                return "tr";
            case 225:
                return "tt";
            case 226:
                return "tv";
            case 227:
                return "tw";
            case 228:
                return "tz";
            case 229:
                return "ua";
            case 230:
                return "ug";
            case 231:
                return "um";
            case 232:
                return "us";
            case 233:
                return "uy";
            case 234:
                return "uz";
            case 235:
                return "va";
            case 236:
                return "vc";
            case 237:
                return "ve";
            case 238:
                return "vg";
            case 239:
                return "vi";
            case 240:
                return "vn";
            case 241:
                return "vu";
            case 242:
                return "wf";
            case 243:
                return "ws";
            case 244:
                return "ye";
            case 245:
                return "yt";
            case 246:
                return "za";
            case 247:
                return "zm";
            default:
                return "zw";
        }
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber_fn = function (country, number) {
        var _v0 = country.jI;
        if (_v0.$ === 1) {
            return $elm$core$Maybe$Just(number);
        }
        else {
            var prefix = _v0.a;
            var prefixLength = $elm$core$String$length(prefix);
            var countryCodeLength = $elm$core$String$length(country.e8);
            return _String_startsWith_fn("+", number) ? (_Utils_eq(country.e8, $elm$core$String$left_fn(countryCodeLength, $elm$core$String$dropLeft_fn(1, number))) ? $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(countryCodeLength + 1, number)) : $elm$core$Maybe$Nothing) : (_String_startsWith_fn(prefix, number) ? (_Utils_eq(country.e8, $elm$core$String$left_fn(countryCodeLength, $elm$core$String$dropLeft_fn(prefixLength, number))) ? $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(prefixLength + countryCodeLength, number)) : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Just(number));
        }
    }, $robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber = F2($robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber_fn);
    var $elm$regex$Regex$find_a0 = _Regex_infinity, $elm$regex$Regex$find = _Regex_findAtMost($elm$regex$Regex$find_a0);
    var $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch_fn = function (regex, str) {
        var _v0 = _Regex_findAtMost_fn($elm$regex$Regex$find_a0, regex, str);
        if (_v0.b && (!_v0.b.b)) {
            var match = _v0.a;
            return _Utils_eq(match.j_, str);
        }
        else {
            return false;
        }
    }, $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch = F2($robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch_fn);
    var $robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry_fn = function (number, defaultCountry, relevantTypes, country) {
        var maybeLocalNumber = $robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber_fn(country, number);
        var matchesSpec = F2(function (localNumber, desc) {
            return $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch_fn(desc.kt, localNumber);
        });
        var isDefaultCountry = _Utils_eq(defaultCountry.bR, country.bR);
        if (maybeLocalNumber.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var localNumber = maybeLocalNumber.a;
            if (_Utils_eq(localNumber, number) && (!isDefaultCountry)) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var matchingTypes = $elm$core$List$map_fn(function ($) {
                    return $.hE;
                }, $elm$core$List$filter_fn(matchesSpec(localNumber), $elm$core$List$filter_fn(function (nt) {
                    return $elm$core$List$member_fn(nt.hE, relevantTypes);
                }, country.kb)));
                if (!matchingTypes.b) {
                    return $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch_fn(country.js, localNumber) ? $elm$core$Maybe$Just(_Utils_Tuple2(country, _List_Nil)) : $elm$core$Maybe$Nothing;
                }
                else {
                    return $elm$core$Maybe$Just(_Utils_Tuple2(country, matchingTypes));
                }
            }
        }
    }, $robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry = F4($robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry_fn);
    var $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber = function (str) {
        return _String_filter_fn(function (c) {
            return c !== " ";
        }, str);
    };
    var $robinheghan$elm_phone_numbers$PhoneNumber$matches_fn = function (config, number) {
        var sanitizedNumber = $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber(number);
        return $elm$core$List$filterMap_fn(A3($robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry, sanitizedNumber, config.l9, config.pu), _List_Cons(config.l9, config.oa));
    }, $robinheghan$elm_phone_numbers$PhoneNumber$matches = F2($robinheghan$elm_phone_numbers$PhoneNumber$matches_fn);
    var $robinheghan$elm_phone_numbers$PhoneNumber$valid_fn = function (config, number) {
        var _v0 = $robinheghan$elm_phone_numbers$PhoneNumber$matches_fn(config, number);
        if (!_v0.b) {
            return false;
        }
        else {
            return true;
        }
    }, $robinheghan$elm_phone_numbers$PhoneNumber$valid = F2($robinheghan$elm_phone_numbers$PhoneNumber$valid_fn);
    var $author$project$Types$InputElement$isValidInput = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm_community$maybe_extra$Maybe$Extra$isJust);
            case 1:
                return A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm_community$maybe_extra$Maybe$Extra$isJust);
            case 2:
                return $elm$core$Basics$always(true);
            case 3:
                return A2($elm$core$Basics$composeR, $author$project$Util$Bool$fromString, $elm_community$maybe_extra$Maybe$Extra$isJust);
            case 4:
                var options = inputElement.a;
                return A2($author$project$Util$flip, $elm$core$List$member, options);
            case 5:
                var timeCheck = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$isJust));
                return function (value) {
                    return timeCheck(value) && _Regex_contains_fn($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^[0-9]{4}-[0-9]{2}-[0-9]{2}$")), value);
                };
            case 6:
                return $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^(?:[01]\\d|2[0-3]):[0-5]\\d(:[0-5]\\d(\\.\\d\\d\\d)?)?$")));
            case 7:
                var timeCheck = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$isJust));
                return function (value) {
                    return timeCheck(value) && _Regex_contains_fn($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^[0-9]{4}-[0-9]{2}-[0-9]{2}T(?:[01]\\d|2[0-3]):[0-5]\\d(:[0-5]\\d(\\.\\d\\d\\dZ?)?)?$")), value);
                };
            case 8:
                return $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^(\\d)+:[0-5]\\d(:[0-5]\\d(\\.\\d\\d\\d)?)?$")));
            case 9:
                return A2($elm$core$Basics$composeR, $gigobyte$iso8601_duration$Iso8601$Duration$fromString, $elm_community$maybe_extra$Maybe$Extra$isJust);
            case 10:
                var urlCheck = A2($elm$core$Basics$composeR, $elm$url$Url$fromString, $elm_community$maybe_extra$Maybe$Extra$isJust);
                return function (value) {
                    return urlCheck(value) && _Regex_contains_fn($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})$")), value);
                };
            case 11:
                var emailCheck = $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([\\w-\\.]+(\\+\\w+)?)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$")));
                return function (value) {
                    return emailCheck(value) && ($elm$core$String$length(value) <= 254);
                };
            case 12:
                var phoneCheck = $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\+")));
                return function (value) {
                    return phoneCheck(value) && $robinheghan$elm_phone_numbers$PhoneNumber$valid_fn({ l9: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS, oa: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$all, pu: $robinheghan$elm_phone_numbers$PhoneNumber$anyType }, value);
                };
            case 13:
                var colorCheck = $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$")));
                return function (value) {
                    return colorCheck(value) && ($elm$core$String$length(value) === 7);
                };
            case 14:
                return A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString($elm$json$Json$Decode$succeed(0)), A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$isJust));
            case 15:
                return function (value) {
                    return _String_startsWith_fn("{", value) && (_String_endsWith_fn("}", value) && $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Result$toMaybe(_Json_runOnString_fn($elm$json$Json$Decode$succeed(0), value))));
                };
            case 16:
                return function (value) {
                    return _String_startsWith_fn("[", value) && (_String_endsWith_fn("]", value) && $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Result$toMaybe(_Json_runOnString_fn($elm$json$Json$Decode$list($elm$json$Json$Decode$succeed(0)), value))));
                };
            case 17:
                return $elm$core$Basics$always(true);
            case 18:
                return $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\([-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)\\)$")));
            case 19:
                return A2($elm$core$Basics$composeR, $supermario$elm_countries$Countries$fromCode, $elm_community$maybe_extra$Maybe$Extra$isJust);
            case 20:
                return function (value) {
                    return (!_Utils_eq(value, $elm$core$String$toUpper(value))) ? false : $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Maybe$andThen_fn($supermario$elm_countries$Countries$fromCode, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2, $elm$core$String$toUpper), $rl_king$elm_iso3166_country_codes$Iso3166$fromAlpha3($elm$core$String$toLower(value)))));
                };
            default:
                return $elm$core$Basics$always(true);
        }
    };
    var $author$project$Types$Column$isValidEdit_fn = function (column, edit) {
        return (edit.jJ && ($elm$core$Basics$composeR_fn($author$project$Types$Edit$isEmpty_a0, $author$project$Types$Edit$isEmpty_a1, edit) && column.jN)) || ($author$project$Types$DataType$isValidData_fn(column.co, edit.pB, column.l$) && ($elm$core$Basics$composeR_fn($author$project$Types$Edit$isEmpty_a0, $author$project$Types$Edit$isEmpty_a1, edit) || A2($author$project$Types$InputElement$isValidInput, column.mN, edit.pB)));
    }, $author$project$Types$Column$isValidEdit = F2($author$project$Types$Column$isValidEdit_fn);
    var $author$project$Types$Column$isValidEditAt_fn = function (columns, edit) {
        return $elm$core$Maybe$withDefault_fn(true, $elm$core$Maybe$map_fn(function (col) {
            return $author$project$Types$Column$isValidEdit_fn(col, edit);
        }, $author$project$Util$flip_fn($elm_community$list_extra$List$Extra$getAt, columns, $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit))));
    }, $author$project$Types$Column$isValidEditAt = F2($author$project$Types$Column$isValidEditAt_fn);
    var $author$project$Types$Column$moveRow_fn = function (columns, idxRowTo, idxRowFrom) {
        return $elm$core$List$map_fn($author$project$Types$Column$mapCells(function (cells) {
            return $author$project$Util$List$moveIndexes_fn(cells, idxRowTo, idxRowFrom);
        }), columns);
    }, $author$project$Types$Column$moveRow = F3($author$project$Types$Column$moveRow_fn);
    var $elm$core$List$partition_fn = function (f, xs) {
        var truesHead = _List_Cons(undefined, _List_Nil);
        var falsesHead = _List_Cons(undefined, _List_Nil);
        var truesEnd = truesHead;
        var falsesEnd = falsesHead;
        for (; xs.b; xs = xs.b) {
            var next = _List_Cons(xs.
                a, _List_Nil);
            if (f(xs.a)) {
                truesEnd.b = next;
                truesEnd = next;
            }
            else {
                falsesEnd.b = next;
                falsesEnd = next;
            }
        }
        return _Utils_Tuple2(truesHead
            .b, falsesHead.b);
    }, $elm$core$List$partition = F2($elm$core$List$partition_fn);
    var $author$project$Types$Column$editValueChanged_fn = function (columns, edit) {
        var maybeCurrentValue = $elm$core$Maybe$andThen_fn($author$project$Types$Cell$toMaybeString, $elm$core$Maybe$andThen_fn($author$project$Types$Column$getCell($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit)), $author$project$Util$flip_fn($elm_community$list_extra$List$Extra$getAt, columns, $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit))));
        return !_Utils_eq(maybeCurrentValue, $elm$core$Maybe$Just(edit.pB));
    }, $author$project$Types$Column$editValueChanged = F2($author$project$Types$Column$editValueChanged_fn);
    var $author$project$Types$Column$filterChangedEdits = function (columns) {
        return $elm$core$List$filter($author$project$Types$Column$editValueChanged(columns));
    };
    var $author$project$Types$Column$validateEdits_fn = function (columns, edits) {
        return $elm$core$List$partition_fn($author$project$Types$Column$isValidEditAt(columns), edits);
    }, $author$project$Types$Column$validateEdits = F2($author$project$Types$Column$validateEdits_fn);
    var $author$project$EditGrid$partitionValidEdits = function (columns) {
        return A2($elm$core$Basics$composeR, $author$project$Types$Column$validateEdits(columns), $elm$core$Tuple$mapFirst($author$project$Types$Column$filterChangedEdits(columns)));
    };
    var $author$project$EditGrid$SubModel$removeCollapsedCol_fn = function (col, sub) {
        return _Utils_update(sub, {
            cc: $elm$core$Set$remove_fn(col, sub.cc)
        });
    }, $author$project$EditGrid$SubModel$removeCollapsedCol = F2($author$project$EditGrid$SubModel$removeCollapsedCol_fn);
    var $author$project$EditGrid$SubModel$removeRowsSelected_fn = function (rows, sub) {
        return _Utils_update(sub, {
            di: $elm$core$List$filter_fn(A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$notMember, rows), sub.di)
        });
    }, $author$project$EditGrid$SubModel$removeRowsSelected = F2($author$project$EditGrid$SubModel$removeRowsSelected_fn);
    var $author$project$EditGrid$additionsOffset = function (model) {
        return $elm$core$List$length(model.K);
    };
    var $author$project$EditGrid$rowCount_fn = function (columns, model) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(0, A2($elm$core$Basics$composeR, $author$project$Types$Column$getCells, A2($elm$core$Basics$composeR, $elm$core$List$length, $elm$core$Basics$add($author$project$EditGrid$additionsOffset(model)))), $elm$core$List$head(columns));
    }, $author$project$EditGrid$rowCount = F2($author$project$EditGrid$rowCount_fn);
    var $author$project$Types$Edit$sameCol_fn = function (pos, edit) {
        return _Utils_eq($author$project$Types$Edit$idxColFromPos(pos), $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit));
    }, $author$project$Types$Edit$sameCol = F2($author$project$Types$Edit$sameCol_fn);
    var $author$project$Types$Edit$sameRow_fn = function (pos, edit) {
        return _Utils_eq($author$project$Types$Edit$idxRowFromPos(pos), $elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit));
    }, $author$project$Types$Edit$sameRow = F2($author$project$Types$Edit$sameRow_fn);
    var $author$project$EditGrid$SubModel$setActiveRow_fn = function (row, sub) {
        return _Utils_update(sub, {
            ix: $elm$core$Maybe$Just(row)
        });
    }, $author$project$EditGrid$SubModel$setActiveRow = F2($author$project$EditGrid$SubModel$setActiveRow_fn);
    var $author$project$Types$Edit$setAsAddition = function (edit) {
        return _Utils_update(edit, { jJ: true });
    };
    var $author$project$EditGrid$SubModel$setColDrag_fn = function (col, sub) {
        return _Utils_update(sub, {
            bK: $elm$core$Maybe$Just(col)
        });
    }, $author$project$EditGrid$SubModel$setColDrag = F2($author$project$EditGrid$SubModel$setColDrag_fn);
    var $author$project$EditGrid$SubModel$setCollapsedCols_fn = function (cols, sub) {
        return _Utils_update(sub, { cc: cols });
    }, $author$project$EditGrid$SubModel$setCollapsedCols = F2($author$project$EditGrid$SubModel$setCollapsedCols_fn);
    var $author$project$Types$InputElement$GridContext = 0;
    var $author$project$Types$InputElement$idFromContext = function (context) {
        if (!context) {
            return $author$project$Types$Edit$toId;
        }
        else {
            return A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, $elm$core$String$fromInt);
        }
    };
    var $author$project$EditGrid$setFocus = function (toMsg) {
        return A2($elm$core$Basics$composeR, $author$project$Types$InputElement$idFromContext(0), A2($elm$core$Basics$composeR, $elm$browser$Browser$Dom$focus, $elm$core$Task$attempt(function (_v0) {
            return toMsg($author$project$EditGrid$NoOp);
        })));
    };
    var $author$project$EditGrid$SubModel$addRowSelected_fn = function (row, sub) {
        return _Utils_update(sub, {
            di: _List_Cons(row, sub.di)
        });
    }, $author$project$EditGrid$SubModel$addRowSelected = F2($author$project$EditGrid$SubModel$addRowSelected_fn);
    var $author$project$EditGrid$SubModel$removeRowSelected_fn = function (row, sub) {
        return _Utils_update(sub, {
            di: $elm$core$List$filter_fn($elm$core$Basics$neq(row), sub.di)
        });
    }, $author$project$EditGrid$SubModel$removeRowSelected = F2($author$project$EditGrid$SubModel$removeRowSelected_fn);
    var $author$project$EditGrid$SubModel$setRowSelected_fn = function (row, selected, sub) {
        return selected ? $author$project$EditGrid$SubModel$addRowSelected_fn(row, sub) : $author$project$EditGrid$SubModel$removeRowSelected_fn(row, sub);
    }, $author$project$EditGrid$SubModel$setRowSelected = F3($author$project$EditGrid$SubModel$setRowSelected_fn);
    var $author$project$Types$Edit$setStringClearError_fn = function (edit, string) {
        return _Utils_update(edit, { fl: $elm$core$Maybe$Nothing, pB: string });
    }, $author$project$Types$Edit$setStringClearError = F2($author$project$Types$Edit$setStringClearError_fn);
    var $author$project$Types$Column$toHeaderIdFromIdx_a0 = $elm$core$String$fromInt, $author$project$Types$Column$toHeaderIdFromIdx_a1 = $elm$core$String$append("col-header-"), $author$project$Types$Column$toHeaderIdFromIdx = A2($elm$core$Basics$composeR, $author$project$Types$Column$toHeaderIdFromIdx_a0, $author$project$Types$Column$toHeaderIdFromIdx_a1);
    var $author$project$Types$ColumnEdit$toIdx_fn = function (columns, columnEdit) {
        var _v0 = columnEdit.gh;
        if (!_v0.$) {
            var column = _v0.a;
            return A2($author$project$Types$Column$findIndex, column, columns);
        }
        else {
            var maybe = _v0.a;
            return $elm$core$Maybe$andThen_fn(A2($author$project$Util$flip, $author$project$Types$Column$findIndex, columns), $elm$core$Maybe$map_fn(function ($) {
                return $.en;
            }, maybe));
        }
    }, $author$project$Types$ColumnEdit$toIdx = F2($author$project$Types$ColumnEdit$toIdx_fn);
    var $stoeffel$set_extra$Set$Extra$toggle_fn = function (elem, set) {
        return $elm$core$Set$member_fn(elem, set) ? $elm$core$Set$remove_fn(elem, set) : $elm$core$Set$insert_fn(elem, set);
    }, $stoeffel$set_extra$Set$Extra$toggle = F2($stoeffel$set_extra$Set$Extra$toggle_fn);
    var $author$project$EditGrid$SubModel$toggleCollapsedCol_fn = function (col, sub) {
        return _Utils_update(sub, {
            cc: $stoeffel$set_extra$Set$Extra$toggle_fn(col, sub.cc)
        });
    }, $author$project$EditGrid$SubModel$toggleCollapsedCol = F2($author$project$EditGrid$SubModel$toggleCollapsedCol_fn);
    var $author$project$Overlay$withPosition_fn = function (position, model) {
        return _Utils_update(model, {
            a$: $elm$core$Maybe$map_fn(function (overlay_) {
                return _Utils_update(overlay_, { pH: position.pH, pJ: position.pJ });
            }, model.a$)
        });
    }, $author$project$Overlay$withPosition = F2($author$project$Overlay$withPosition_fn);
    var $author$project$Overlay$positionMapperBelowRight_fn = function (element, trigger) {
        return $author$project$Overlay$Position_fn(element.pH + trigger.bq, (element.pJ + trigger.ck) + 5);
    }, $author$project$Overlay$positionMapperBelowRight = F2($author$project$Overlay$positionMapperBelowRight_fn);
    var $author$project$Overlay$withPositionMapper_fn = function (positionMapper, model) {
        return _Utils_update(model, {
            a$: $elm$core$Maybe$map_fn(function (overlay_) {
                return _Utils_update(overlay_, {
                    b_: $elm$core$Maybe$Just(positionMapper)
                });
            }, model.a$)
        });
    }, $author$project$Overlay$withPositionMapper = F2($author$project$Overlay$withPositionMapper_fn);
    var $author$project$Overlay$withPositionBelowRight_a0 = $author$project$Overlay$positionMapperBelowRight, $author$project$Overlay$withPositionBelowRight = $author$project$Overlay$withPositionMapper($author$project$Overlay$withPositionBelowRight_a0);
    var $author$project$EditGrid$withSubModel_fn = function (f, _v0) {
        var model = _v0.a;
        var columns = _v0.b;
        var cmd = _v0.c;
        return _Utils_Tuple3(_Utils_update(model, {
            v: f(model.v)
        }), columns, cmd);
    }, $author$project$EditGrid$withSubModel = F2($author$project$EditGrid$withSubModel_fn);
    var $author$project$EditGrid$update = function (routeToRow) {
        return function (columns) {
            return function (maybeOnEdit) {
                return function (maybeOnAdd) {
                    return function (maybeOnDelete) {
                        return function (maybeOnUploadFile) {
                            return function (maybeOnRenameCol) {
                                return function (maybeOnEditCol) {
                                    return function (maybeOnMoveCol) {
                                        return function (maybeOnDeleteCol) {
                                            return function (maybeOnResetCol) {
                                                return function (toMsg) {
                                                    return function (msg) {
                                                        return function (model) {
                                                            switch (msg.$) {
                                                                case 0:
                                                                    var edit = msg.a;
                                                                    var multiSelect = msg.b;
                                                                    return $author$project$EditGrid$hasErrors(model) ? _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(_Utils_update(model, {
                                                                        T: multiSelect ? _List_Cons(edit, model.T) : _List_fromArray([edit])
                                                                    }), columns, A2($author$project$EditGrid$setFocus, toMsg, edit));
                                                                case 3:
                                                                    return _Utils_Tuple3(_Utils_update(model, { K: _List_Nil, T: _List_Nil }), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                        return A3(onEdit, columns, _List_Nil, _List_Nil);
                                                                    }, maybeOnEdit));
                                                                case 1:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        K: $elm_community$list_extra$List$Extra$updateIf_fn($elm$core$List$all($author$project$Types$Edit$sameRow(edit.eo)), A2($elm_community$list_extra$List$Extra$updateIf, $author$project$Types$Edit$sameCol(edit.eo), $elm$core$Basics$always(edit)), model.K),
                                                                        T: $elm$core$List$map_fn(A2($author$project$Util$flip, $author$project$Types$Edit$setStringClearError, edit.pB), model.T)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 2:
                                                                    var maybeEdit = msg.a;
                                                                    if (!maybeEdit.$) {
                                                                        var edit = maybeEdit.a;
                                                                        return _Utils_eq(model.K, _List_Nil) ? _Utils_Tuple3(_Utils_update(model, {
                                                                            T: _List_Cons(edit, model.T)
                                                                        }), columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$CellEditApplied($elm$core$Maybe$Nothing)))) : _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$CellEditUpdated(edit))));
                                                                    }
                                                                    else {
                                                                        if (_Utils_eq(model.K, _List_Nil)) {
                                                                            var _v2 = A2($author$project$EditGrid$partitionValidEdits, columns, model.T);
                                                                            var validEdits = _v2.a;
                                                                            var invalidEdits = _v2.b;
                                                                            return _Utils_Tuple3(_Utils_update(model, {
                                                                                T: invalidEdits,
                                                                                la: !_Utils_eq(validEdits, _List_Nil)
                                                                            }), $author$project$Types$Column$applyEdits_fn(validEdits, columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                                return A3(onEdit, columns, validEdits, _List_Nil);
                                                                            }, maybeOnEdit));
                                                                        }
                                                                        else {
                                                                            var _v3 = $elm$core$List$partition_fn($elm$core$List$all($author$project$Types$Column$isValidEditAt(columns)), model.K);
                                                                            var validRows = _v3.a;
                                                                            var invalidRows = _v3.b;
                                                                            var _v4 = _Utils_eq(invalidRows, _List_Nil) ? _Utils_Tuple2(validRows, _List_Nil) : _Utils_Tuple2(_List_Nil, model.K);
                                                                            var newRows = _v4.a;
                                                                            var additions = _v4.b;
                                                                            return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearRowsSelected, _Utils_Tuple3(_Utils_update(model, { K: additions, la: true }), $elm$core$List$foldl_fn($author$project$Types$Column$addRow, columns, newRows), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onAdd) {
                                                                                return A2(onAdd, columns, newRows);
                                                                            }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(!_Utils_eq(newRows, _List_Nil)), maybeOnAdd))));
                                                                        }
                                                                    }
                                                                case 9:
                                                                    var rows = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setRowsSelected(rows), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 10:
                                                                    var idxRow = msg.a;
                                                                    var selected = msg.b;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setActiveRow(idxRow), $author$project$EditGrid$withSubModel_fn(A2($author$project$EditGrid$SubModel$setRowSelected, idxRow, selected), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none)));
                                                                case 11:
                                                                    var fromRow = msg.a;
                                                                    var toRow = msg.b;
                                                                    var selected = msg.c;
                                                                    var range = (_Utils_cmp(toRow, fromRow) > 0) ? $elm$core$List$range_fn(fromRow, toRow) : $elm$core$List$range_fn(toRow, fromRow);
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setActiveRow(toRow), $author$project$EditGrid$withSubModel_fn(selected ? $author$project$EditGrid$SubModel$addRowsSelected(range) : $author$project$EditGrid$SubModel$removeRowsSelected(range), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none)));
                                                                case 12:
                                                                    var maybeRowList = msg.a;
                                                                    var rowList = $elm$core$Maybe$withDefault_fn(model.v.di, maybeRowList);
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearRowsSelected, _Utils_Tuple3(model, $elm$core$List$map_fn($author$project$Types$Column$removeCells(rowList), columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onDelete) {
                                                                        return A2(onDelete, columns, rowList);
                                                                    }, maybeOnDelete)));
                                                                case 13:
                                                                    var addition = function () {
                                                                        var idxRow = $author$project$EditGrid$rowCount_fn(columns, model);
                                                                        return $elm$core$List$map_fn($author$project$Types$Edit$setAsAddition, $elm$core$List$map_fn(function (idxCol) {
                                                                            return $author$project$Types$Column$isNullableAt_fn(columns, idxCol) ? $author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), "") : $author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Types$InputElement$defaultValue, $author$project$Types$Column$getInputElement_fn(columns, idxCol)));
                                                                        }, $elm$core$List$range_fn(0, $author$project$EditGrid$columnCount(columns) - 2)));
                                                                    }();
                                                                    var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, $author$project$EditGrid$setFocus(toMsg), $elm$core$List$head(addition));
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        K: _Utils_ap(model.K, _List_fromArray([addition])),
                                                                        T: _List_Nil
                                                                    }), columns, cmd);
                                                                case 20:
                                                                    var edit = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$removeCollapsedCol($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit)), _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Just(edit)
                                                                    }), columns, A2($author$project$EditGrid$setFocus, toMsg, edit)));
                                                                case 21:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Just(edit)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 22:
                                                                    var _v5 = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(columns, $elm$core$Platform$Cmd$none), function (edit) {
                                                                        return _Utils_Tuple2($elm_community$list_extra$List$Extra$updateAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit), $author$project$Types$Column$setName(edit.pB), columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onRenameColumn) {
                                                                            return A2(onRenameColumn, columns, edit);
                                                                        }, maybeOnRenameCol));
                                                                    }, $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v6) {
                                                                        var value = _v6.pB;
                                                                        return (value !== "") && $elm$core$List$all_fn(A2($elm$core$Basics$composeR, function ($) {
                                                                            return $.jx;
                                                                        }, $elm$core$Basics$neq(value)), columns);
                                                                    }, model.bL));
                                                                    var columnsNew = _v5.a;
                                                                    var cmd = _v5.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Nothing,
                                                                        la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                                    }), columnsNew, cmd);
                                                                case 23:
                                                                    return _Utils_Tuple3(_Utils_update(model, { bL: $elm$core$Maybe$Nothing }), columns, $elm$core$Platform$Cmd$none);
                                                                case 25:
                                                                    var colEdit = msg.a;
                                                                    var overlay = $author$project$Overlay$showBelow_fn($author$project$EditGrid$colEditOverlay_fn($author$project$EditGrid$rowCount_fn(columns, model), _Utils_update(model, { a7: colEdit })), model.aC);
                                                                    return _Utils_Tuple3(_Utils_update(model, { a7: colEdit }), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (elementId) {
                                                                        return $author$project$Overlay$setOrigin_fn(toMsg, elementId, overlay);
                                                                    }, $elm$core$Maybe$map_fn($author$project$Types$Column$toHeaderIdFromIdx, $author$project$Types$ColumnEdit$toIdx_fn(columns, colEdit))));
                                                                case 26:
                                                                    var columnEdit = msg.a;
                                                                    var updateColEditOverlay = function (m) {
                                                                        return _Utils_update(m, {
                                                                            aC: $author$project$Overlay$updateView_fn($author$project$EditGrid$colEditOverlay_fn($author$project$EditGrid$rowCount_fn(columns, m), m), model.aC)
                                                                        });
                                                                    };
                                                                    return _Utils_Tuple3(updateColEditOverlay(_Utils_update(model, { a7: columnEdit })), columns, $elm$core$Platform$Cmd$none);
                                                                case 27:
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        a7: $author$project$Types$ColumnEdit$emptyCreation,
                                                                        aC: $author$project$Overlay$clear(model.aC)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 28:
                                                                    var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEditCol) {
                                                                        return onEditCol(model.a7);
                                                                    }, maybeOnEditCol);
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                                    }), columns, cmd);
                                                                case 24:
                                                                    var idxCol = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$toggleCollapsedCol(idxCol), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 30:
                                                                    var column = msg.a;
                                                                    var idxCol = msg.b;
                                                                    if (_Utils_eq(maybeOnResetCol, $elm$core$Maybe$Nothing)) {
                                                                        var cellUpdates = $elm$core$List$map_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, $author$project$Types$Cell$null), $elm$core$List$map_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, idxCol), A2($author$project$Types$Column$findCellIndexes, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Cell$isNull), column)));
                                                                        return _Utils_Tuple3(model, A2($author$project$Types$Column$resetAt, idxCol, columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                            return A3(onEdit, columns, _List_Nil, cellUpdates);
                                                                        }, maybeOnEdit));
                                                                    }
                                                                    else {
                                                                        return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onResetCol) {
                                                                            return onResetCol(column);
                                                                        }, maybeOnResetCol));
                                                                    }
                                                                case 29:
                                                                    var idxCol = msg.a;
                                                                    var cmd = $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns), maybeOnDeleteCol));
                                                                    return (!_Utils_eq(cmd, $elm$core$Platform$Cmd$none)) ? _Utils_Tuple3(model, columns, cmd) : _Utils_Tuple3($author$project$EditGrid$removeCollapsedCol_fn(idxCol, model), $elm_community$list_extra$List$Extra$removeAt_fn(idxCol, columns), $elm$core$Platform$Cmd$none);
                                                                case 8:
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none);
                                                                case 14:
                                                                    var maybePos = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, { e3: maybePos }), columns, $elm$core$Platform$Cmd$none);
                                                                case 15:
                                                                    var idxRow = msg.a;
                                                                    var maybeIdxCol = msg.b;
                                                                    var idxRowLast = $author$project$EditGrid$rowCount_fn(columns, model) - 1;
                                                                    var idxRowAdjusted = (_Utils_cmp(idxRow, idxRowLast) > 0) ? 0 : ((idxRow < 0) ? idxRowLast : idxRow);
                                                                    return _Utils_Tuple3(model, columns, A3(routeToRow, columns, $elm$core$Maybe$Just(idxRowAdjusted), maybeIdxCol));
                                                                case 4:
                                                                    var _v7 = msg.a;
                                                                    var idxRow = _v7.a;
                                                                    var idxCol = _v7.b;
                                                                    var cell = msg.b;
                                                                    var hasStaticValue = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($author$project$Types$Column$hasStaticValue, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns)));
                                                                    return _Utils_Tuple3(model, (hasStaticValue ? $elm$core$Basics$identity : A2($elm_community$list_extra$List$Extra$updateAt, idxCol, A2($author$project$Types$Column$setCell, idxRow, cell)))(columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                        return A3(onEdit, columns, _List_Nil, _List_fromArray([
                                                                            _Utils_Tuple2(_Utils_Tuple2(idxRow, idxCol), cell)
                                                                        ]));
                                                                    }, maybeOnEdit));
                                                                case 5:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3($author$project$EditGrid$setUpdating_fn(!_Utils_eq(maybeOnUploadFile, $elm$core$Maybe$Nothing), model), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onUploadFile) {
                                                                        return onUploadFile(edit);
                                                                    }, maybeOnUploadFile));
                                                                case 6:
                                                                    var originId = msg.a;
                                                                    var pos = msg.b;
                                                                    var tableType = msg.c;
                                                                    var cell = msg.d;
                                                                    var column = msg.e;
                                                                    var maybeMousePos = msg.f;
                                                                    var withPosition = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Overlay$withPositionBelowRight, function (_v8) {
                                                                        var mouseX = _v8.a;
                                                                        var mouseY = _v8.b;
                                                                        return $author$project$Overlay$withPosition({ pH: mouseX, pJ: mouseY });
                                                                    }, maybeMousePos);
                                                                    var menu = withPosition($author$project$Overlay$popupMenu_fn(model.a$, $author$project$EditGrid$cellMenuOptions_fn(pos, tableType, cell, column)));
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: menu }), columns, $author$project$Overlay$setOrigin_fn(toMsg, originId, menu));
                                                                case 7:
                                                                    var originId = msg.a;
                                                                    var tableType = msg.b;
                                                                    var column = msg.c;
                                                                    var idxCol = msg.d;
                                                                    var colCollapsed = msg.e;
                                                                    var menu = $author$project$Overlay$withPositionMapper_fn($author$project$Overlay$withPositionBelowRight_a0, $author$project$Overlay$popupMenu_fn(model.a$, $author$project$EditGrid$columnMenuOptions_fn(model, tableType, column, idxCol, colCollapsed)));
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: menu }), columns, $author$project$Overlay$setOrigin_fn(toMsg, originId, menu));
                                                                case 16:
                                                                    var cell = msg.a;
                                                                    var columnName = msg.b;
                                                                    var idxRow = msg.c;
                                                                    return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (cellString) {
                                                                        var fileName = function () {
                                                                            var maybeFromRowId = $elm$core$Maybe$map_fn($elm$core$String$append("rowid_"), A2($author$project$Types$Column$getRowId, idxRow, columns));
                                                                            var fromIdxRow = "row_" + $elm$core$String$fromInt(idxRow + 1);
                                                                            var rowInfo = $elm$core$Maybe$withDefault_fn(fromIdxRow, maybeFromRowId);
                                                                            return rowInfo + ("_" + (columnName + ".txt"));
                                                                        }();
                                                                        return $elm$file$File$Download$string_fn(fileName, "text/*", cellString);
                                                                    }, $author$project$Types$Cell$toMaybeString(cell)));
                                                                case 17:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_Tuple3(model, columns, function () {
                                                                        var fileName = function () {
                                                                            var maybeFromRowId = $elm$core$Maybe$map_fn($elm$core$String$append("rowid_"), A2($author$project$Types$Column$getRowId, idxRow, columns));
                                                                            var fromIdxRow = "row_" + $elm$core$String$fromInt(idxRow + 1);
                                                                            var rowInfo = $elm$core$Maybe$withDefault_fn(fromIdxRow, maybeFromRowId);
                                                                            return rowInfo + ".json";
                                                                        }();
                                                                        return $elm$file$File$Download$string_fn(fileName, "application/json", $author$project$Types$Column$toJson_fn(columns, idxRow));
                                                                    }());
                                                                case 18:
                                                                    var subMsg = msg.a;
                                                                    var _v9 = $author$project$Overlay$update_fn(subMsg, model.a$);
                                                                    var overlay = _v9.a;
                                                                    var cmd = _v9.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: overlay }), columns, _Platform_map_fn(toMsg, cmd));
                                                                case 19:
                                                                    var subMsg = msg.a;
                                                                    var _v10 = $author$project$Overlay$update_fn(subMsg, model.aC);
                                                                    var overlay = _v10.a;
                                                                    var cmd = _v10.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, { aC: overlay }), columns, _Platform_map_fn(toMsg, cmd));
                                                                case 31:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(model, columns, A2($author$project$EditGrid$setFocus, toMsg, edit));
                                                                case 32:
                                                                    var cell = msg.a;
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$OpenCellAsLink_fn($elm$core$Maybe$Just("tel:"), cell))));
                                                                case 33:
                                                                    var cell = msg.a;
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$OpenCellAsLink_fn($elm$core$Maybe$Just("mailto:"), cell))));
                                                                case 34:
                                                                    var maybePrefix = msg.a;
                                                                    var cell = msg.b;
                                                                    return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$String$append($elm$core$Maybe$withDefault_fn("", maybePrefix)), $elm$browser$Browser$Navigation$load), $elm$core$Maybe$map_fn($elm$url$Url$percentEncode, $elm$core$Maybe$andThen_fn($elm_community$string_extra$String$Extra$nonEmpty, $author$project$Types$Cell$toMaybeString(cell)))));
                                                                case 35:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        b3: $elm$core$Maybe$Just(idxRow)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 36:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_eq(model.b3, $elm$core$Maybe$Just(idxRow)) ? _Utils_Tuple3(_Utils_update(model, { b3: $elm$core$Maybe$Nothing }), columns, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(_Utils_update(model, { b3: $elm$core$Maybe$Nothing }), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(columns, A2($author$project$Types$Column$moveRow, columns, idxRow), model.b3), $elm$core$Platform$Cmd$none);
                                                                case 37:
                                                                    var idxCol = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setColDrag(idxCol), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 38:
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                default:
                                                                    var idxColTo = msg.a;
                                                                    if (_Utils_eq(model.v.bK, $elm$core$Maybe$Just(idxColTo))) {
                                                                        return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                    }
                                                                    else {
                                                                        var collapsedCols = function () {
                                                                            var asBoolList = $elm$core$List$map_fn($author$project$EditGrid$SubModel$hasCollapsedCol(model.v), $elm$core$List$range_fn(0, $elm$core$List$length(columns) - 1));
                                                                            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(model.v.cc, A2($elm$core$Basics$composeR, A2($author$project$Util$List$moveIndexes, asBoolList, idxColTo), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$findIndices($elm$core$Basics$identity), $elm$core$Set$fromList)), model.v.bK);
                                                                        }();
                                                                        return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setCollapsedCols(collapsedCols), $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(columns, A2($author$project$Util$List$moveIndexes, columns, idxColTo), model.v.bK), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn_unwrapped(function (onMoveCol, idxColFrom) {
                                                                            return A3(onMoveCol, columns, idxColFrom, idxColTo);
                                                                        }, maybeOnMoveCol, model.v.bK)))));
                                                                    }
                                                            }
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, $author$project$EditGrid$update_unwrapped = function (routeToRow) {
        return function (columns) {
            return function (maybeOnEdit) {
                return function (maybeOnAdd) {
                    return function (maybeOnDelete) {
                        return function (maybeOnUploadFile) {
                            return function (maybeOnRenameCol) {
                                return function (maybeOnEditCol) {
                                    return function (maybeOnMoveCol) {
                                        return function (maybeOnDeleteCol) {
                                            return function (maybeOnResetCol) {
                                                return function (toMsg) {
                                                    return function (msg) {
                                                        return function (model) {
                                                            switch (msg.$) {
                                                                case 0:
                                                                    var edit = msg.a;
                                                                    var multiSelect = msg.b;
                                                                    return $author$project$EditGrid$hasErrors(model) ? _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(_Utils_update(model, {
                                                                        T: multiSelect ? _List_Cons(edit, model.T) : _List_fromArray([edit])
                                                                    }), columns, A2($author$project$EditGrid$setFocus, toMsg, edit));
                                                                case 3:
                                                                    return _Utils_Tuple3(_Utils_update(model, { K: _List_Nil, T: _List_Nil }), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                        return A3(onEdit, columns, _List_Nil, _List_Nil);
                                                                    }, maybeOnEdit));
                                                                case 1:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        K: $elm_community$list_extra$List$Extra$updateIf_fn($elm$core$List$all($author$project$Types$Edit$sameRow(edit.eo)), A2($elm_community$list_extra$List$Extra$updateIf, $author$project$Types$Edit$sameCol(edit.eo), $elm$core$Basics$always(edit)), model.K),
                                                                        T: $elm$core$List$map_fn(A2($author$project$Util$flip, $author$project$Types$Edit$setStringClearError, edit.pB), model.T)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 2:
                                                                    var maybeEdit = msg.a;
                                                                    if (!maybeEdit.$) {
                                                                        var edit = maybeEdit.a;
                                                                        return _Utils_eq(model.K, _List_Nil) ? _Utils_Tuple3(_Utils_update(model, {
                                                                            T: _List_Cons(edit, model.T)
                                                                        }), columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$CellEditApplied($elm$core$Maybe$Nothing)))) : _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$CellEditUpdated(edit))));
                                                                    }
                                                                    else {
                                                                        if (_Utils_eq(model.K, _List_Nil)) {
                                                                            var _v2 = A2($author$project$EditGrid$partitionValidEdits, columns, model.T);
                                                                            var validEdits = _v2.a;
                                                                            var invalidEdits = _v2.b;
                                                                            return _Utils_Tuple3(_Utils_update(model, {
                                                                                T: invalidEdits,
                                                                                la: !_Utils_eq(validEdits, _List_Nil)
                                                                            }), $author$project$Types$Column$applyEdits_fn(validEdits, columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                                return A3(onEdit, columns, validEdits, _List_Nil);
                                                                            }, maybeOnEdit));
                                                                        }
                                                                        else {
                                                                            var _v3 = $elm$core$List$partition_fn($elm$core$List$all($author$project$Types$Column$isValidEditAt(columns)), model.K);
                                                                            var validRows = _v3.a;
                                                                            var invalidRows = _v3.b;
                                                                            var _v4 = _Utils_eq(invalidRows, _List_Nil) ? _Utils_Tuple2(validRows, _List_Nil) : _Utils_Tuple2(_List_Nil, model.K);
                                                                            var newRows = _v4.a;
                                                                            var additions = _v4.b;
                                                                            return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearRowsSelected, _Utils_Tuple3(_Utils_update(model, { K: additions, la: true }), $elm$core$List$foldl_fn($author$project$Types$Column$addRow, columns, newRows), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onAdd) {
                                                                                return A2(onAdd, columns, newRows);
                                                                            }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(!_Utils_eq(newRows, _List_Nil)), maybeOnAdd))));
                                                                        }
                                                                    }
                                                                case 9:
                                                                    var rows = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setRowsSelected(rows), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 10:
                                                                    var idxRow = msg.a;
                                                                    var selected = msg.b;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setActiveRow(idxRow), $author$project$EditGrid$withSubModel_fn(A2($author$project$EditGrid$SubModel$setRowSelected, idxRow, selected), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none)));
                                                                case 11:
                                                                    var fromRow = msg.a;
                                                                    var toRow = msg.b;
                                                                    var selected = msg.c;
                                                                    var range = (_Utils_cmp(toRow, fromRow) > 0) ? $elm$core$List$range_fn(fromRow, toRow) : $elm$core$List$range_fn(toRow, fromRow);
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setActiveRow(toRow), $author$project$EditGrid$withSubModel_fn(selected ? $author$project$EditGrid$SubModel$addRowsSelected(range) : $author$project$EditGrid$SubModel$removeRowsSelected(range), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none)));
                                                                case 12:
                                                                    var maybeRowList = msg.a;
                                                                    var rowList = $elm$core$Maybe$withDefault_fn(model.v.di, maybeRowList);
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearRowsSelected, _Utils_Tuple3(model, $elm$core$List$map_fn($author$project$Types$Column$removeCells(rowList), columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onDelete) {
                                                                        return A2(onDelete, columns, rowList);
                                                                    }, maybeOnDelete)));
                                                                case 13:
                                                                    var addition = function () {
                                                                        var idxRow = $author$project$EditGrid$rowCount_fn(columns, model);
                                                                        return $elm$core$List$map_fn($author$project$Types$Edit$setAsAddition, $elm$core$List$map_fn(function (idxCol) {
                                                                            return $author$project$Types$Column$isNullableAt_fn(columns, idxCol) ? $author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), "") : $author$project$Types$Edit$fromString_fn(_Utils_Tuple2(idxRow, idxCol), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Types$InputElement$defaultValue, $author$project$Types$Column$getInputElement_fn(columns, idxCol)));
                                                                        }, $elm$core$List$range_fn(0, $author$project$EditGrid$columnCount(columns) - 2)));
                                                                    }();
                                                                    var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, $author$project$EditGrid$setFocus(toMsg), $elm$core$List$head(addition));
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        K: _Utils_ap(model.K, _List_fromArray([addition])),
                                                                        T: _List_Nil
                                                                    }), columns, cmd);
                                                                case 20:
                                                                    var edit = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$removeCollapsedCol($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit)), _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Just(edit)
                                                                    }), columns, A2($author$project$EditGrid$setFocus, toMsg, edit)));
                                                                case 21:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Just(edit)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 22:
                                                                    var _v5 = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(columns, $elm$core$Platform$Cmd$none), function (edit) {
                                                                        return _Utils_Tuple2($elm_community$list_extra$List$Extra$updateAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxCol_a0, $author$project$Types$Edit$toIdxCol_a1, edit), $author$project$Types$Column$setName(edit.pB), columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onRenameColumn) {
                                                                            return A2(onRenameColumn, columns, edit);
                                                                        }, maybeOnRenameCol));
                                                                    }, $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v6) {
                                                                        var value = _v6.pB;
                                                                        return (value !== "") && $elm$core$List$all_fn(A2($elm$core$Basics$composeR, function ($) {
                                                                            return $.jx;
                                                                        }, $elm$core$Basics$neq(value)), columns);
                                                                    }, model.bL));
                                                                    var columnsNew = _v5.a;
                                                                    var cmd = _v5.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        bL: $elm$core$Maybe$Nothing,
                                                                        la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                                    }), columnsNew, cmd);
                                                                case 23:
                                                                    return _Utils_Tuple3(_Utils_update(model, { bL: $elm$core$Maybe$Nothing }), columns, $elm$core$Platform$Cmd$none);
                                                                case 25:
                                                                    var colEdit = msg.a;
                                                                    var overlay = $author$project$Overlay$showBelow_fn($author$project$EditGrid$colEditOverlay_fn($author$project$EditGrid$rowCount_fn(columns, model), _Utils_update(model, { a7: colEdit })), model.aC);
                                                                    return _Utils_Tuple3(_Utils_update(model, { a7: colEdit }), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (elementId) {
                                                                        return $author$project$Overlay$setOrigin_fn(toMsg, elementId, overlay);
                                                                    }, $elm$core$Maybe$map_fn($author$project$Types$Column$toHeaderIdFromIdx, $author$project$Types$ColumnEdit$toIdx_fn(columns, colEdit))));
                                                                case 26:
                                                                    var columnEdit = msg.a;
                                                                    var updateColEditOverlay = function (m) {
                                                                        return _Utils_update(m, {
                                                                            aC: $author$project$Overlay$updateView_fn($author$project$EditGrid$colEditOverlay_fn($author$project$EditGrid$rowCount_fn(columns, m), m), model.aC)
                                                                        });
                                                                    };
                                                                    return _Utils_Tuple3(updateColEditOverlay(_Utils_update(model, { a7: columnEdit })), columns, $elm$core$Platform$Cmd$none);
                                                                case 27:
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        a7: $author$project$Types$ColumnEdit$emptyCreation,
                                                                        aC: $author$project$Overlay$clear(model.aC)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 28:
                                                                    var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEditCol) {
                                                                        return onEditCol(model.a7);
                                                                    }, maybeOnEditCol);
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                                    }), columns, cmd);
                                                                case 24:
                                                                    var idxCol = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$toggleCollapsedCol(idxCol), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 30:
                                                                    var column = msg.a;
                                                                    var idxCol = msg.b;
                                                                    if (_Utils_eq(maybeOnResetCol, $elm$core$Maybe$Nothing)) {
                                                                        var cellUpdates = $elm$core$List$map_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, $author$project$Types$Cell$null), $elm$core$List$map_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, idxCol), A2($author$project$Types$Column$findCellIndexes, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Cell$isNull), column)));
                                                                        return _Utils_Tuple3(model, A2($author$project$Types$Column$resetAt, idxCol, columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                            return A3(onEdit, columns, _List_Nil, cellUpdates);
                                                                        }, maybeOnEdit));
                                                                    }
                                                                    else {
                                                                        return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onResetCol) {
                                                                            return onResetCol(column);
                                                                        }, maybeOnResetCol));
                                                                    }
                                                                case 29:
                                                                    var idxCol = msg.a;
                                                                    var cmd = $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns), maybeOnDeleteCol));
                                                                    return (!_Utils_eq(cmd, $elm$core$Platform$Cmd$none)) ? _Utils_Tuple3(model, columns, cmd) : _Utils_Tuple3($author$project$EditGrid$removeCollapsedCol_fn(idxCol, model), $elm_community$list_extra$List$Extra$removeAt_fn(idxCol, columns), $elm$core$Platform$Cmd$none);
                                                                case 8:
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none);
                                                                case 14:
                                                                    var maybePos = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, { e3: maybePos }), columns, $elm$core$Platform$Cmd$none);
                                                                case 15:
                                                                    var idxRow = msg.a;
                                                                    var maybeIdxCol = msg.b;
                                                                    var idxRowLast = $author$project$EditGrid$rowCount_fn(columns, model) - 1;
                                                                    var idxRowAdjusted = (_Utils_cmp(idxRow, idxRowLast) > 0) ? 0 : ((idxRow < 0) ? idxRowLast : idxRow);
                                                                    return _Utils_Tuple3(model, columns, routeToRow(columns, $elm$core$Maybe$Just(idxRowAdjusted), maybeIdxCol));
                                                                case 4:
                                                                    var _v7 = msg.a;
                                                                    var idxRow = _v7.a;
                                                                    var idxCol = _v7.b;
                                                                    var cell = msg.b;
                                                                    var hasStaticValue = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($author$project$Types$Column$hasStaticValue, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns)));
                                                                    return _Utils_Tuple3(model, (hasStaticValue ? $elm$core$Basics$identity : A2($elm_community$list_extra$List$Extra$updateAt, idxCol, A2($author$project$Types$Column$setCell, idxRow, cell)))(columns), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                                                        return A3(onEdit, columns, _List_Nil, _List_fromArray([
                                                                            _Utils_Tuple2(_Utils_Tuple2(idxRow, idxCol), cell)
                                                                        ]));
                                                                    }, maybeOnEdit));
                                                                case 5:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3($author$project$EditGrid$setUpdating_fn(!_Utils_eq(maybeOnUploadFile, $elm$core$Maybe$Nothing), model), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onUploadFile) {
                                                                        return onUploadFile(edit);
                                                                    }, maybeOnUploadFile));
                                                                case 6:
                                                                    var originId = msg.a;
                                                                    var pos = msg.b;
                                                                    var tableType = msg.c;
                                                                    var cell = msg.d;
                                                                    var column = msg.e;
                                                                    var maybeMousePos = msg.f;
                                                                    var withPosition = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Overlay$withPositionBelowRight, function (_v8) {
                                                                        var mouseX = _v8.a;
                                                                        var mouseY = _v8.b;
                                                                        return $author$project$Overlay$withPosition({ pH: mouseX, pJ: mouseY });
                                                                    }, maybeMousePos);
                                                                    var menu = withPosition($author$project$Overlay$popupMenu_fn(model.a$, $author$project$EditGrid$cellMenuOptions_fn(pos, tableType, cell, column)));
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: menu }), columns, $author$project$Overlay$setOrigin_fn(toMsg, originId, menu));
                                                                case 7:
                                                                    var originId = msg.a;
                                                                    var tableType = msg.b;
                                                                    var column = msg.c;
                                                                    var idxCol = msg.d;
                                                                    var colCollapsed = msg.e;
                                                                    var menu = $author$project$Overlay$withPositionMapper_fn($author$project$Overlay$withPositionBelowRight_a0, $author$project$Overlay$popupMenu_fn(model.a$, $author$project$EditGrid$columnMenuOptions_fn(model, tableType, column, idxCol, colCollapsed)));
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: menu }), columns, $author$project$Overlay$setOrigin_fn(toMsg, originId, menu));
                                                                case 16:
                                                                    var cell = msg.a;
                                                                    var columnName = msg.b;
                                                                    var idxRow = msg.c;
                                                                    return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (cellString) {
                                                                        var fileName = function () {
                                                                            var maybeFromRowId = $elm$core$Maybe$map_fn($elm$core$String$append("rowid_"), A2($author$project$Types$Column$getRowId, idxRow, columns));
                                                                            var fromIdxRow = "row_" + $elm$core$String$fromInt(idxRow + 1);
                                                                            var rowInfo = $elm$core$Maybe$withDefault_fn(fromIdxRow, maybeFromRowId);
                                                                            return rowInfo + ("_" + (columnName + ".txt"));
                                                                        }();
                                                                        return $elm$file$File$Download$string_fn(fileName, "text/*", cellString);
                                                                    }, $author$project$Types$Cell$toMaybeString(cell)));
                                                                case 17:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_Tuple3(model, columns, function () {
                                                                        var fileName = function () {
                                                                            var maybeFromRowId = $elm$core$Maybe$map_fn($elm$core$String$append("rowid_"), A2($author$project$Types$Column$getRowId, idxRow, columns));
                                                                            var fromIdxRow = "row_" + $elm$core$String$fromInt(idxRow + 1);
                                                                            var rowInfo = $elm$core$Maybe$withDefault_fn(fromIdxRow, maybeFromRowId);
                                                                            return rowInfo + ".json";
                                                                        }();
                                                                        return $elm$file$File$Download$string_fn(fileName, "application/json", $author$project$Types$Column$toJson_fn(columns, idxRow));
                                                                    }());
                                                                case 18:
                                                                    var subMsg = msg.a;
                                                                    var _v9 = $author$project$Overlay$update_fn(subMsg, model.a$);
                                                                    var overlay = _v9.a;
                                                                    var cmd = _v9.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, { a$: overlay }), columns, _Platform_map_fn(toMsg, cmd));
                                                                case 19:
                                                                    var subMsg = msg.a;
                                                                    var _v10 = $author$project$Overlay$update_fn(subMsg, model.aC);
                                                                    var overlay = _v10.a;
                                                                    var cmd = _v10.b;
                                                                    return _Utils_Tuple3(_Utils_update(model, { aC: overlay }), columns, _Platform_map_fn(toMsg, cmd));
                                                                case 31:
                                                                    var edit = msg.a;
                                                                    return _Utils_Tuple3(model, columns, A2($author$project$EditGrid$setFocus, toMsg, edit));
                                                                case 32:
                                                                    var cell = msg.a;
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$OpenCellAsLink_fn($elm$core$Maybe$Just("tel:"), cell))));
                                                                case 33:
                                                                    var cell = msg.a;
                                                                    return _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$EditGrid$OpenCellAsLink_fn($elm$core$Maybe$Just("mailto:"), cell))));
                                                                case 34:
                                                                    var maybePrefix = msg.a;
                                                                    var cell = msg.b;
                                                                    return _Utils_Tuple3(model, columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$String$append($elm$core$Maybe$withDefault_fn("", maybePrefix)), $elm$browser$Browser$Navigation$load), $elm$core$Maybe$map_fn($elm$url$Url$percentEncode, $elm$core$Maybe$andThen_fn($elm_community$string_extra$String$Extra$nonEmpty, $author$project$Types$Cell$toMaybeString(cell)))));
                                                                case 35:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        b3: $elm$core$Maybe$Just(idxRow)
                                                                    }), columns, $elm$core$Platform$Cmd$none);
                                                                case 36:
                                                                    var idxRow = msg.a;
                                                                    return _Utils_eq(model.b3, $elm$core$Maybe$Just(idxRow)) ? _Utils_Tuple3(_Utils_update(model, { b3: $elm$core$Maybe$Nothing }), columns, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(_Utils_update(model, { b3: $elm$core$Maybe$Nothing }), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(columns, A2($author$project$Types$Column$moveRow, columns, idxRow), model.b3), $elm$core$Platform$Cmd$none);
                                                                case 37:
                                                                    var idxCol = msg.a;
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setColDrag(idxCol), _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                case 38:
                                                                    return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                default:
                                                                    var idxColTo = msg.a;
                                                                    if (_Utils_eq(model.v.bK, $elm$core$Maybe$Just(idxColTo))) {
                                                                        return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none));
                                                                    }
                                                                    else {
                                                                        var collapsedCols = function () {
                                                                            var asBoolList = $elm$core$List$map_fn($author$project$EditGrid$SubModel$hasCollapsedCol(model.v), $elm$core$List$range_fn(0, $elm$core$List$length(columns) - 1));
                                                                            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(model.v.cc, A2($elm$core$Basics$composeR, A2($author$project$Util$List$moveIndexes, asBoolList, idxColTo), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$findIndices($elm$core$Basics$identity), $elm$core$Set$fromList)), model.v.bK);
                                                                        }();
                                                                        return $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$setCollapsedCols(collapsedCols), $author$project$EditGrid$withSubModel_fn($author$project$EditGrid$SubModel$clearColDrag, _Utils_Tuple3(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(columns, A2($author$project$Util$List$moveIndexes, columns, idxColTo), model.v.bK), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map2_fn_unwrapped(function (onMoveCol, idxColFrom) {
                                                                            return A3(onMoveCol, columns, idxColFrom, idxColTo);
                                                                        }, maybeOnMoveCol, model.v.bK)))));
                                                                    }
                                                            }
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$FocusView$DeleteButtonToggled = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$FocusView$FieldEditApplied = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$FocusView$hasErrors = function (model) {
        return $elm$core$List$any_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fl;
        }, $elm_community$maybe_extra$Maybe$Extra$isJust), model.T);
    };
    var $author$project$Types$InputElement$FocusContext = 1;
    var $author$project$FocusView$NoOp = { $: 0 };
    var $author$project$FocusView$setFocus = function (toMsg) {
        return A2($elm$core$Basics$composeR, $author$project$Types$InputElement$idFromContext(1), A2($elm$core$Basics$composeR, $elm$browser$Browser$Dom$focus, $elm$core$Task$attempt(function (_v0) {
            return toMsg($author$project$FocusView$NoOp);
        })));
    };
    var $author$project$FocusView$update_fn = function (columns, onClose, maybeOnEdit, maybeOnUploadFile, toMsg, toGridMsg, msg, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none);
            case 1:
                var msgs = msg.a;
                return _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$batch($elm$core$List$map_fn(A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd), msgs)));
            case 2:
                return _Utils_Tuple3(_Utils_update(model, { ft: $elm$core$Maybe$Nothing }), columns, onClose);
            case 4:
                var edit = msg.a;
                return _Utils_Tuple3(model, columns, A2($author$project$FocusView$setFocus, toMsg, edit));
            case 3:
                var edit = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    T: _List_fromArray([edit])
                }), columns, $elm$core$Platform$Cmd$none);
            case 5:
                var maybeEdit = msg.a;
                if (!maybeEdit.$) {
                    var edit = maybeEdit.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        T: _List_Cons(edit, model.T)
                    }), columns, model.cX ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$FocusView$FieldEditApplied($elm$core$Maybe$Nothing))));
                }
                else {
                    if ($author$project$FocusView$hasErrors(model) || (model.la || _Utils_eq(model.T, _List_Nil))) {
                        return _Utils_Tuple3(model, columns, $elm$core$Platform$Cmd$none);
                    }
                    else {
                        if (!model.cX) {
                            return _Utils_Tuple3(_Utils_update(model, { cX: true }), columns, $author$project$Util$msgCmdDelayed_fn(20, toMsg($author$project$FocusView$FieldEditApplied($elm$core$Maybe$Nothing))));
                        }
                        else {
                            var _v2 = A2($author$project$EditGrid$partitionValidEdits, columns, model.T);
                            var validEdits = _v2.a;
                            var invalidEdits = _v2.b;
                            var columnsNew = $author$project$Types$Column$applyEdits_fn(validEdits, columns);
                            return _Utils_Tuple3(_Utils_update(model, {
                                cX: false,
                                T: invalidEdits,
                                la: !_Utils_eq(validEdits, _List_Nil)
                            }), columnsNew, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                                return A3(onEdit, columns, validEdits, _List_Nil);
                            }, maybeOnEdit));
                        }
                    }
                }
            case 6:
                return _Utils_Tuple3(_Utils_update(model, { T: _List_Nil }), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onEdit) {
                    return A3(onEdit, columns, _List_Nil, _List_Nil);
                }, maybeOnEdit));
            case 11:
                var edit = msg.a;
                return _Utils_Tuple3($author$project$FocusView$setUpdating_fn(!_Utils_eq(maybeOnUploadFile, $elm$core$Maybe$Nothing), model), columns, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (onUploadFile) {
                    return onUploadFile(edit);
                }, maybeOnUploadFile));
            case 7:
                var subMsg = msg.a;
                var _v3 = $author$project$Overlay$update_fn(subMsg, model.a$);
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, { a$: overlay }), columns, _Platform_map_fn(toMsg, cmd));
            case 8:
                var subMsg = msg.a;
                return _Utils_Tuple3(model, columns, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toGridMsg(subMsg)));
            case 9:
                var idxRow = msg.a;
                var _v4 = $elm$core$Set$member_fn(idxRow, model.bG) ? _Utils_Tuple2($elm$core$Set$remove_fn(idxRow, model.bG), $elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Set$insert_fn(idxRow, model.bG), $author$project$Util$msgCmdDelayed_fn(2000, toMsg($author$project$FocusView$DeleteButtonToggled(idxRow))));
                var activeDeleteButtons = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, { bG: activeDeleteButtons }), columns, cmd);
            default:
                var edit = msg.a;
                return _Utils_Tuple3(model, columns, A2($author$project$FocusView$setFocus, toMsg, edit));
        }
    }, $author$project$FocusView$update = F8($author$project$FocusView$update_fn);
    var $author$project$GraphGrid$update_fn = function (onError, routeToRowId, changeRowId, refetchTable, setDialog, toMsg, msg, shared, model) {
        var routeToRow = F3(function (columns, maybeIdxRow, maybeIdxCol) {
            var isTableWithRowId = !_Utils_eq(A2($author$project$Types$Column$find, model.ab, columns), $elm$core$Maybe$Nothing);
            if (isTableWithRowId) {
                var maybeRowId = $elm$core$Maybe$andThen_fn(function (idxRow) {
                    return $elm$core$Maybe$andThen_fn($elm$core$String$toInt, $author$project$Types$Column$getByNameAt_fn(idxRow, model.ab, columns));
                }, maybeIdxRow);
                return A2(routeToRowId, maybeRowId, maybeIdxCol);
            }
            else {
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$GraphGrid$SetFocusViewRow, A2($elm$core$Basics$composeR, toMsg, $author$project$Util$msgCmd)), maybeIdxRow);
            }
        });
        var onSQLiteErrors = onError($elm$core$Maybe$Just("SQLite Error"));
        var onHttpError = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Util$httpErrorToString, A2($elm$core$Basics$composeR, $elm$core$List$singleton, onError($elm$core$Maybe$Just("Http Error")))));
        var onGQLErrors = A2($elm$core$Basics$composeR, $elm$core$List$map(function ($) {
            return $.no;
        }), onError($elm$core$Maybe$Just("GraphQL Error")));
        switch (msg.$) {
            case 0:
                var subMsg = msg.a;
                var showResetDialog = function (column) {
                    var action = _Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$null) ? "null" : (_Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$empty) ? "empty" : "default");
                    return setDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn(action, toMsg($author$project$GraphGrid$ColResetIntentConfirmed(column)), $author$project$Components$ConfirmDialog$DataContext(column))));
                };
                var showDeleteDialog = function (column) {
                    return setDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", toMsg($author$project$GraphGrid$ColDeleteIntentConfirmed(column)), $author$project$Components$ConfirmDialog$ColumnContext(column))));
                };
                var _v1 = $author$project$EditGrid$update(routeToRow)(model.iT)($elm$core$Maybe$Just(A6($author$project$GraphGrid$onEdit, shared.k2, model.ad, model.ab, model.ah, toMsg, $elm$core$Maybe$Nothing)))($elm$core$Maybe$Just(A5($author$project$GraphGrid$onAdd, shared.k2, model.ad, model.ab, model.ah, toMsg)))($elm$core$Maybe$Just(A5($author$project$GraphGrid$onDelete, shared.k2, model.ad, model.ab, model.ah, toMsg)))($elm$core$Maybe$Just($author$project$GraphGrid$onFileUpload(toMsg)))($elm$core$Maybe$Just(A4($author$project$GraphGrid$onRenameCol, shared.k2, model.ad, model.ah, toMsg)))($elm$core$Maybe$Just(A5($author$project$GraphGrid$onEditCol, shared.k2, model.ad, model.ah, model.iT, toMsg)))($elm$core$Maybe$Just(A4($author$project$GraphGrid$onMoveCol, shared.k2, model.ad, model.ah, toMsg)))($elm$core$Maybe$Just(showDeleteDialog))($elm$core$Maybe$Just(showResetDialog))(A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$EditGridMsgReceived))(subMsg)(model.s);
                var editGrid = _v1.a;
                var columns = _v1.b;
                var cmd = _v1.c;
                return _Utils_Tuple2(_Utils_update(model, { iT: columns, s: editGrid }), cmd);
            case 1:
                var subMsg = msg.a;
                var _v2 = $author$project$FocusView$update_fn(model.iT, A3(routeToRow, model.iT, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), $elm$core$Maybe$Just(A6($author$project$GraphGrid$onEdit, shared.k2, model.ad, model.ab, model.ah, toMsg, $elm$core$Maybe$Just(changeRowId))), $elm$core$Maybe$Just($author$project$GraphGrid$onFileUpload(toMsg)), A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$FocusViewMsgReceived), A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$EditGridMsgReceived), subMsg, model.aq);
                var focusView = _v2.a;
                var columns = _v2.b;
                var cmd = _v2.c;
                return _Utils_Tuple2(_Utils_update(model, { iT: columns, aq: focusView }), cmd);
            case 2:
                var columnsOld = msg.a;
                var edits = msg.b;
                var response = msg.c;
                var maybeHttpError = $author$project$GraphGrid$getHttpError(response);
                var _v3 = function () {
                    if (!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) {
                        return _Utils_Tuple2(_List_Nil, _List_Nil);
                    }
                    else {
                        var gqlErrors = $elm$core$Basics$composeR_fn($author$project$GraphGrid$getGQLErrors_a0, $author$project$GraphGrid$getGQLErrors_a1, response);
                        var errorEditsIdentified = $elm$core$List$filter_fn($author$project$Types$Edit$hasError, $author$project$GraphGrid$addErrorsToEdits_fn(model.iT, gqlErrors, edits));
                        return (_Utils_eq(errorEditsIdentified, _List_Nil) && (!_Utils_eq(gqlErrors, _List_Nil))) ? _Utils_Tuple2(_List_Nil, gqlErrors) : _Utils_Tuple2(errorEditsIdentified, _List_Nil);
                    }
                }();
                var errorEdits = _v3.a;
                var gqlErrorsUnhandled = _v3.b;
                var routeRestoreCmd = function () {
                    if (!model.aq.la) {
                        return $elm$core$Platform$Cmd$none;
                    }
                    else {
                        if (_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing) && _Utils_eq(errorEdits, _List_Nil)) {
                            return $elm$core$Platform$Cmd$none;
                        }
                        else {
                            var rowIdEdit = $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $author$project$Types$Column$getNameAt, model.iT), $elm$core$Basics$eq($elm$core$Maybe$Just(model.ab)))), edits);
                            var maybeRowId = $elm$core$Maybe$andThen_fn($elm$core$String$toInt, $elm$core$Maybe$andThen_fn(function (edit) {
                                return $author$project$Types$Column$getByNameAt_fn($elm$core$Basics$composeR_fn($author$project$Types$Edit$toIdxRow_a0, $author$project$Types$Edit$toIdxRow_a1, edit), model.ab, columnsOld);
                            }, rowIdEdit));
                            return _Utils_eq(maybeRowId, $elm$core$Maybe$Nothing) ? $elm$core$Platform$Cmd$none : A2(routeToRowId, maybeRowId, $elm$core$Maybe$Nothing);
                        }
                    }
                }();
                var updatedEdits = $elm_community$list_extra$List$Extra$filterNot_fn(function (edit) {
                    return $elm$core$List$any_fn($author$project$Types$Edit$samePos(edit.eo), errorEdits);
                }, edits);
                var refetchAffectedCellsCmd = ((!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) || (!_Utils_eq(errorEdits, _List_Nil))) ? $elm$core$Platform$Cmd$none : $author$project$GraphGrid$getCells_fn(shared.k2, model.ad, model.ab, model.ah, toMsg, model.iT, A3($author$project$GraphGrid$editsToAffectedPositions, model.ab, model.iT, updatedEdits));
                return _Utils_Tuple2(_Utils_update(model, {
                    iT: ((!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) || (!_Utils_eq(gqlErrorsUnhandled, _List_Nil))) ? columnsOld : (_Utils_eq(errorEdits, _List_Nil) ? model.iT : $author$project$Types$Column$applyEdits_fn(updatedEdits, columnsOld)),
                    s: $author$project$EditGrid$setUpdating_fn(false, $author$project$EditGrid$setErrors_fn(errorEdits, model.s)),
                    aq: $author$project$FocusView$setUpdating_fn(false, $author$project$FocusView$setErrors_fn(errorEdits, model.aq))
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    onHttpError(maybeHttpError),
                    onGQLErrors(gqlErrorsUnhandled),
                    setDialog($elm$core$Maybe$Nothing),
                    refetchAffectedCellsCmd,
                    routeRestoreCmd
                ])));
            case 3:
                var rows = msg.a;
                var response = msg.b;
                var maybeHttpError = $author$project$GraphGrid$getHttpError(response);
                var _v4 = function () {
                    if (!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) {
                        return _Utils_Tuple2(rows, _List_Nil);
                    }
                    else {
                        var gqlErrors = $elm$core$Basics$composeR_fn($author$project$GraphGrid$getGQLErrors_a0, $author$project$GraphGrid$getGQLErrors_a1, response);
                        var errorRowsIdentified = $elm$core$List$filter_fn($elm$core$List$any($author$project$Types$Edit$hasError), $elm$core$List$map_fn(A2($author$project$GraphGrid$addErrorsToEdits, model.iT, gqlErrors), rows));
                        return (_Utils_eq(errorRowsIdentified, _List_Nil) && (!_Utils_eq(gqlErrors, _List_Nil))) ? _Utils_Tuple2(rows, gqlErrors) : _Utils_Tuple2(errorRowsIdentified, _List_Nil);
                    }
                }();
                var errorRows = _v4.a;
                var gqlErrorsUnhandled = _v4.b;
                var columns = function () {
                    var returningEdits = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$andThen_fn($elm$core$Result$toMaybe, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, response)));
                    var errorRowNumbers = $elm_community$list_extra$List$Extra$unique($elm$core$List$filterMap_fn(A2($elm$core$Basics$composeR, $elm$core$List$head, $elm$core$Maybe$map($author$project$Types$Edit$toIdxRow)), errorRows));
                    return $author$project$Types$Column$applyEdits_fn(returningEdits, $elm$core$List$map_fn($author$project$Types$Column$removeCells(errorRowNumbers), model.iT));
                }();
                var refetchCellsCmd = ((!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) || (!_Utils_eq(errorRows, _List_Nil))) ? $elm$core$Platform$Cmd$none : $author$project$GraphGrid$getCells_fn(shared.k2, model.ad, model.ab, model.ah, toMsg, columns, $elm$core$List$map_fn(function ($) {
                    return $.eo;
                }, $author$project$GraphGrid$filterEditsToRefetch_fn(columns, $elm$core$List$concat(rows))));
                return _Utils_Tuple2(_Utils_update(model, {
                    iT: columns,
                    s: $author$project$EditGrid$setUpdating_fn(false, $author$project$EditGrid$setAdditions_fn(errorRows, model.s))
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    onHttpError(maybeHttpError),
                    onGQLErrors(gqlErrorsUnhandled),
                    refetchCellsCmd
                ])));
            case 4:
                var columnsOld = msg.a;
                var idxRows = msg.b;
                var errors = msg.c;
                var maybeHttpError = $author$project$GraphGrid$getHttpError(errors);
                var gqlErrors = $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, errors);
                var refetchTableCmd = function () {
                    var noErrors = _Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing) && _Utils_eq(gqlErrors, _List_Nil);
                    return (noErrors && model.cs) ? refetchTable : $elm$core$Platform$Cmd$none;
                }();
                var successRows = function () {
                    var errorRowNumbers = function () {
                        if (!_Utils_eq(maybeHttpError, $elm$core$Maybe$Nothing)) {
                            return idxRows;
                        }
                        else {
                            var toErrorRowNumbers = $elm$core$List$filterMap(A2($elm$core$Basics$composeR, function ($) {
                                return $.ks;
                            }, A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault(_List_Nil), A2($elm$core$Basics$composeR, $elm$core$List$head, $elm$core$Maybe$andThen($author$project$GraphGrid$errorPathToMaybeIdxRow)))));
                            return toErrorRowNumbers(gqlErrors);
                        }
                    }();
                    return $elm_community$list_extra$List$Extra$filterNot_fn(A2($author$project$Util$flip, $elm$core$List$member, errorRowNumbers), idxRows);
                }();
                var columns = $elm$core$List$map_fn($author$project$Types$Column$removeCells(successRows), columnsOld);
                return _Utils_Tuple2(_Utils_update(model, {
                    iT: columns,
                    s: $author$project$EditGrid$setUpdating_fn(false, model.s),
                    bT: !_Utils_eq(refetchTableCmd, $elm$core$Platform$Cmd$none)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    onHttpError(maybeHttpError),
                    onGQLErrors(gqlErrors),
                    refetchTableCmd
                ])));
            case 5:
                var edit = msg.a;
                var file = msg.b;
                var maybeFileUrl = $author$project$GraphGrid$editToFileUrl_fn(model.ah, model.iT, model.ab, model.ad, edit);
                if (maybeFileUrl.$ === 1) {
                    return _Utils_Tuple2(model, A2(onError, $elm$core$Maybe$Just("Upload Error"), _List_fromArray(["File url not found"])));
                }
                else {
                    var fileUrl = maybeFileUrl.a;
                    var tracker = $author$project$Types$Edit$toId(edit);
                    return _Utils_Tuple2(_Utils_update(model, {
                        bp: $elm$core$Maybe$Just({ bR: tracker, fT: $elm$core$Maybe$Nothing })
                    }), $elm$http$Http$request({
                        d: $elm$http$Http$multipartBody(_List_fromArray([
                            _Http_pair_fn("file", file)
                        ])),
                        e: A2($author$project$Api$expect, A2($elm$core$Basics$composeR, $author$project$GraphGrid$FileUploaded(edit), toMsg), $elm$json$Json$Decode$succeed(fileUrl)),
                        d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, shared.k2),
                        f: "PUT",
                        eK: $elm$core$Maybe$Nothing,
                        eQ: $elm$core$Maybe$Just(tracker),
                        g: fileUrl
                    }));
                }
            case 6:
                var progress = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bp: $elm$core$Maybe$map_fn(function (upload) {
                        return _Utils_update(upload, {
                            fT: $elm$core$Maybe$Just(progress)
                        });
                    }, model.bp)
                }), $elm$core$Platform$Cmd$none);
            case 7:
                var edit = msg.a;
                var response = msg.b;
                var focusView = $author$project$FocusView$clearEdits($author$project$FocusView$setUpdating_fn(false, model.aq));
                var editGrid = $author$project$EditGrid$clearEdits($author$project$EditGrid$setUpdating_fn(false, model.s));
                if (!response.$) {
                    var fileUrl = response.a;
                    var editUpdated = $author$project$Types$Edit$mapString_fn($elm$core$Basics$always(_Json_encode_fn(2, $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("url", $elm$json$Json$Encode$string(fileUrl))
                    ])))), edit);
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: $author$project$Types$Column$applyEdits_fn(_List_fromArray([editUpdated]), model.iT),
                        s: editGrid,
                        aq: focusView,
                        bp: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, { s: editGrid, aq: focusView, bp: $elm$core$Maybe$Nothing }), A2(onError, $elm$core$Maybe$Just("Upload Error"), errors));
                }
            case 8:
                var columnsOld = msg.a;
                var response = msg.b;
                var editGrid = $author$project$EditGrid$setUpdating_fn(false, model.s);
                if (!response.$) {
                    return _Utils_Tuple2(_Utils_update(model, { s: editGrid }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, { iT: columnsOld, s: editGrid }), onSQLiteErrors(errors));
                }
            case 9:
                var response = msg.a;
                var editGrid = $author$project$EditGrid$setUpdating_fn(false, model.s);
                if (!response.$) {
                    var column = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: function () {
                            var columnAdjustedToCellLimit = function () {
                                if (!model.cs) {
                                    return column;
                                }
                                else {
                                    var maybeCellCountFirstCol = $elm$core$Maybe$andThen_fn($author$project$Types$Column$cellCount, $elm$core$List$head(model.iT));
                                    return $author$project$Util$flip_fn($author$project$Types$Column$mapCells, column, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Basics$identity, $elm$core$List$take, maybeCellCountFirstCol));
                                }
                            }();
                            var _v9 = $author$project$Types$ColumnEdit$toOriginal(editGrid.a7);
                            if (_v9.$ === 1) {
                                var idxInsert = $elm$core$Maybe$withDefault_fn($elm$core$List$length(model.iT) - 1, $author$project$Types$ColumnEdit$toIdxInsert_fn(model.iT, editGrid.a7));
                                return $author$project$Util$List$insert_fn(idxInsert, columnAdjustedToCellLimit, model.iT);
                            }
                            else {
                                var original = _v9.a;
                                return $elm_community$list_extra$List$Extra$updateIf_fn($elm$core$Basics$eq(original), $elm$core$Basics$always(columnAdjustedToCellLimit), model.iT);
                            }
                        }(),
                        s: $author$project$EditGrid$closeColEditOverlay(editGrid)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, { s: editGrid }), onSQLiteErrors(errors));
                }
            case 12:
                var column = msg.a;
                var _v10 = $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, $elm$core$Basics$eq(column), model.iT);
                if (_v10.$ === 1) {
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    var idxCol = _v10.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: ($author$project$Types$Column$hasStaticValue(column) ? $elm$core$Basics$identity : $author$project$Types$Column$resetAt(idxCol))(model.iT)
                    }), $author$project$GraphGrid$resetColumn_fn(shared.k2, model.ad, model.ab, model.ah, model.iT, column, idxCol, toMsg));
                }
            case 10:
                var column = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    s: $author$project$EditGrid$setUpdating_fn(true, model.s)
                }), $author$project$GraphGrid$onDeleteCol_fn(shared.k2, model.ad, model.ah, toMsg, column));
            case 11:
                var column = msg.a;
                var response = msg.b;
                var editGrid = $author$project$EditGrid$setUpdating_fn(false, model.s);
                if (!response.$) {
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: $elm_community$list_extra$List$Extra$remove_fn(column, model.iT),
                        s: $elm$core$Maybe$withDefault_fn(editGrid, $elm$core$Maybe$map_fn(A2($author$project$Util$flip, $author$project$EditGrid$removeCollapsedCol, editGrid), $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, $elm$core$Basics$eq(column), model.iT)))
                    }), setDialog($elm$core$Maybe$Nothing));
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, { s: editGrid }), onSQLiteErrors(errors));
                }
            case 13:
                var columnsOld = msg.a;
                var response = msg.b;
                var editGrid = $author$project$EditGrid$setUpdating_fn(false, model.s);
                if (!response.$) {
                    return _Utils_Tuple2(_Utils_update(model, { s: editGrid }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, { iT: columnsOld, s: editGrid }), onSQLiteErrors(errors));
                }
            case 16:
                var rowId = msg.a;
                return _Utils_eq(A2($author$project$Types$Column$find, model.ab, model.iT), $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, { bT: true }), $author$project$GraphGrid$getRow_fn(shared.k2, model.ad, model.ab, model.ah, model.iT, toMsg, rowId));
            case 17:
                var result = msg.a;
                if (!result.$) {
                    var row = result.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: $author$project$Types$Column$appendRow_fn(row, model.iT),
                        bT: false
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = result.a;
                    return _Utils_Tuple2(_Utils_update(model, { bT: false }), onHttpError($elm$core$Maybe$Just(errors)));
                }
            case 18:
                var result = msg.a;
                if (!result.$) {
                    var cellUpdates = result.a;
                    var applyCellUpdate = F2(function (_v15, columns) {
                        var _v16 = _v15.a;
                        var idxRow = _v16.a;
                        var idxCol = _v16.b;
                        var cell = _v15.b;
                        return $elm_community$list_extra$List$Extra$updateAt_fn(idxCol, A2($author$project$Types$Column$setCell, idxRow, cell), columns);
                    });
                    return _Utils_Tuple2(_Utils_update(model, {
                        iT: $elm$core$List$foldl_fn(applyCellUpdate, model.iT, cellUpdates)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = result.a;
                    return _Utils_Tuple2(model, onHttpError($elm$core$Maybe$Just(errors)));
                }
            case 14:
                return _Utils_Tuple2(model, A2(routeToRowId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
            default:
                var idxRow = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    aq: $author$project$FocusView$setIdxRow_fn(idxRow, model.aq)
                }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$GraphGrid$update = F9($author$project$GraphGrid$update_fn);
    var $author$project$Pages$Tables$update = function (onError) {
        return function (onEditView) {
            return function (setDialog) {
                return function (maybeDatabase) {
                    return function (tables) {
                        return function (toSharedCmd) {
                            return function (toMsg) {
                                return function (msg) {
                                    return function (maybeUser) {
                                        return function (shared) {
                                            return function (model) {
                                                var setActiveTableView = F2(function (model_, name) {
                                                    return $author$project$Route$isTablesRoute(shared.eu) ? _Utils_update(model_, { dy: name }) : _Utils_update(model_, { dz: name });
                                                });
                                                var routeToTab = function (tab) {
                                                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setTable_fn($elm$core$Maybe$Just(tab), shared.eu));
                                                };
                                                var routeToRowId = F2(function (maybeRowId, maybeCol) {
                                                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$setTablePos_fn(maybeRowId, maybeCol, shared.eu));
                                                });
                                                var maybeDbId = $elm$core$Maybe$map_fn(function ($) {
                                                    return $.bR;
                                                }, maybeDatabase);
                                                var requestTable = F3(function (successMsg, maybeFilter, tableName) {
                                                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A4($author$project$Api$getTable, A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Tables$DataReceived, successMsg, tableName)), shared.k2, tableName, maybeFilter), maybeDbId);
                                                });
                                                var changeRowId = function (rowId) {
                                                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd), $author$project$Route$changeRowId_fn(rowId, shared.eu));
                                                };
                                                var activeTableView = $author$project$Route$isTablesRoute(shared.eu) ? model.dy : model.dz;
                                                switch (msg.$) {
                                                    case 0:
                                                        return _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none);
                                                    case 1:
                                                        var subMsg = msg.a;
                                                        var _v1 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn(A8($author$project$GraphGrid$update, onError, routeToRowId, changeRowId, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Tables$DataRequested(activeTableView))), setDialog, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Tables$GraphGridMsgReceived), subMsg, shared), model.aH)));
                                                        var gridState = _v1.a;
                                                        var cmd = _v1.b;
                                                        return _Utils_Tuple3(_Utils_update(model, { aH: gridState }), A3($author$project$Types$Table$setColumns, activeTableView, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                                                            return $.iT;
                                                        }, gridState), tables), cmd);
                                                    case 2:
                                                        var subMsg = msg.a;
                                                        var _v2 = $elm$core$Maybe$map_fn(A2($author$project$Components$Toolbar$update, {
                                                            nK: function (tableFilter) {
                                                                return A3(requestTable, $author$project$Pages$Tables$DataLoaded, $elm$core$Maybe$Just(tableFilter), activeTableView);
                                                            },
                                                            nN: A3(requestTable, $author$project$Pages$Tables$DataLoaded, $elm$core$Maybe$Nothing, activeTableView),
                                                            nZ: A3(requestTable, $author$project$Pages$Tables$DataLoaded, $elm$core$Maybe$Nothing, activeTableView)
                                                        }, subMsg), $elm$core$Dict$get_fn(activeTableView, model.Z));
                                                        if (!_v2.$) {
                                                            var _v3 = _v2.a;
                                                            var toolbar = _v3.a;
                                                            var cmd = _v3.b;
                                                            return _Utils_Tuple3(_Utils_update(model, {
                                                                Z: $elm$core$Dict$insert_fn(activeTableView, toolbar, model.Z)
                                                            }), tables, cmd);
                                                        }
                                                        else {
                                                            return _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none);
                                                        }
                                                    case 3:
                                                        var subMsg = msg.a;
                                                        var _v4 = $author$project$Overlay$update_fn(subMsg, model.aA);
                                                        var addTableOverlay_ = _v4.a;
                                                        var cmd = _v4.b;
                                                        return _Utils_Tuple3(_Utils_update(model, { aA: addTableOverlay_ }), tables, _Platform_map_fn(toMsg, cmd));
                                                    case 4:
                                                        var subMsg = msg.a;
                                                        var _v5 = $author$project$Overlay$update_fn(subMsg, model.a$);
                                                        var tableMenu = _v5.a;
                                                        var cmd = _v5.b;
                                                        return _Utils_Tuple3(_Utils_update(model, { a$: tableMenu }), tables, _Platform_map_fn(toMsg, cmd));
                                                    case 5:
                                                        var route = msg.a;
                                                        var maybeStateTableView = $elm$core$Maybe$map_fn(function ($) {
                                                            return $.ah;
                                                        }, model.aH);
                                                        var maybeRouteTableView = $author$project$Route$toTable(route);
                                                        var maybeNewTableView = $elm_community$maybe_extra$Maybe$Extra$orElse_fn(function () {
                                                            var filter = $author$project$Route$isTablesRoute(shared.eu) ? $author$project$Types$Table$filterTables : $author$project$Types$Table$filterViews;
                                                            return $elm$core$Maybe$map_fn(function ($) {
                                                                return $.M;
                                                            }, $elm$core$List$head(filter(tables)));
                                                        }(), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($elm_community$string_extra$String$Extra$nonEmpty(activeTableView), maybeRouteTableView));
                                                        var gridLoadedForTableView = _Utils_eq(maybeStateTableView, maybeNewTableView);
                                                        var loadTableViewCmd = gridLoadedForTableView ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Tables$DataLoaded));
                                                        var focusColCmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($elm$core$Basics$composeR, $elm$browser$Browser$Dom$focus, $elm$core$Task$attempt(function (_v6) {
                                                            return toMsg($author$project$Pages$Tables$NoOp);
                                                        }))), $author$project$Route$toTableCol(route));
                                                        var alreadyOnRoute = _Utils_eq(maybeNewTableView, maybeRouteTableView);
                                                        var routeToTabCmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, routeToTab, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(!alreadyOnRoute), maybeNewTableView));
                                                        return _Utils_Tuple3($elm_community$maybe_extra$Maybe$Extra$unwrap_fn(model, setActiveTableView(model), maybeNewTableView), tables, $elm$core$List$foldr_fn($author$project$Util$cmdOrList_a0, $author$project$Util$cmdOrList_a1, _List_fromArray([routeToTabCmd, loadTableViewCmd, focusColCmd])));
                                                    case 6:
                                                        var gridState = function () {
                                                            var maybeDbSettings = $elm$core$Maybe$map_fn(function ($) {
                                                                return $.kR;
                                                            }, maybeDatabase);
                                                            var apiUrl = $elm$core$Maybe$map_fn(function (dbId) {
                                                                return "/dbs/" + ($elm$url$Url$percentEncode($author$project$Types$Database$unwrapId(dbId)) + "/graphql");
                                                            }, maybeDbId);
                                                            return $elm$core$Maybe$map2_fn(A5($author$project$Pages$Tables$initGrid, maybeDatabase, maybeUser, $elm$core$Dict$get_fn(activeTableView, model.cc), shared.aQ, _Utils_eq($elm$core$Maybe$map_fn(function ($) {
                                                                return $.bj;
                                                            }, maybeDbSettings), $elm$core$Maybe$Just(true))), A2($author$project$Types$Table$find, activeTableView, tables), apiUrl);
                                                        }();
                                                        var fetchRowCmd = function () {
                                                            var _v7 = $author$project$Route$toTableRow(shared.eu);
                                                            if (!_v7.$) {
                                                                var rowId = _v7.a;
                                                                var rowIdIsLoaded = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($author$project$GraphGrid$hasRow(rowId), gridState)));
                                                                return rowIdIsLoaded ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Tables$GraphGridMsgReceived($author$project$GraphGrid$getRowMsg(rowId))));
                                                            }
                                                            else {
                                                                return $elm$core$Platform$Cmd$none;
                                                            }
                                                        }();
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            aH: gridState,
                                                            Z: $elm$core$Dict$update_fn(activeTableView, $elm_community$maybe_extra$Maybe$Extra$orElse($elm$core$Maybe$Just($author$project$Components$Toolbar$init)), model.Z)
                                                        }), tables, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                            fetchRowCmd,
                                                            A3($author$project$Pages$Tables$setGridViewport, toMsg, activeTableView, model)
                                                        ])));
                                                    case 7:
                                                        var tableName = msg.a;
                                                        var newTables = $elm_community$list_extra$List$Extra$updateIf_fn($author$project$Types$Table$hasName(tableName), $author$project$Types$Table$mapColumns($author$project$Types$Column$setLoading), tables);
                                                        var fetchTableViewCmd = A3(requestTable, $author$project$Pages$Tables$DataLoaded, $elm$core$Maybe$Nothing, tableName);
                                                        return _Utils_Tuple3(model, newTables, fetchTableViewCmd);
                                                    case 8:
                                                        var successMsg = msg.a;
                                                        var tableName = msg.b;
                                                        var response = msg.c;
                                                        if (!response.$) {
                                                            var table = response.a;
                                                            var isNewTable = _Utils_eq(A2($author$project$Types$Table$find, tableName, tables), $elm$core$Maybe$Nothing);
                                                            var newTables = (isNewTable ? A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([table])) : A2($author$project$Types$Table$map, tableName, $elm$core$Basics$always(table)))(tables);
                                                            var routeToNewTableCmd = isNewTable ? routeToTab(tableName) : $elm$core$Platform$Cmd$none;
                                                            return _Utils_Tuple3(_Utils_update(model, {
                                                                aA: $author$project$Overlay$clear(model.aA),
                                                                dc: _List_Nil,
                                                                bm: $author$project$Types$TableEdit$empty,
                                                                Z: $elm$core$Dict$update_fn(activeTableView, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$orElse($elm$core$Maybe$Just($author$project$Components$Toolbar$init)), A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter($author$project$Components$Toolbar$isAwaitingResult), $elm$core$Maybe$map($author$project$Components$Toolbar$onFilterSucceeded))), model.Z),
                                                                la: false
                                                            }), newTables, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                                routeToNewTableCmd,
                                                                $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg(successMsg))
                                                            ])));
                                                        }
                                                        else {
                                                            var errors = response.a;
                                                            return _Utils_Tuple3(_Utils_update(model, {
                                                                dc: errors,
                                                                Z: $elm$core$Dict$update_fn(activeTableView, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$orElse($elm$core$Maybe$Just($author$project$Components$Toolbar$init)), A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter($author$project$Components$Toolbar$isAwaitingResult), $elm$core$Maybe$map($author$project$Components$Toolbar$onFilterFailed))), model.Z),
                                                                la: false
                                                            }), $elm_community$list_extra$List$Extra$updateIf_fn($author$project$Types$Table$hasName(tableName), $author$project$Types$Table$mapColumns($author$project$Types$Column$setFailed), tables), A2(onError, $elm$core$Maybe$Just("Error creating table"), errors));
                                                        }
                                                    case 9:
                                                        var tableName = msg.a;
                                                        var successCmd = msg.b;
                                                        return _Utils_Tuple3(model, tables, $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Tables$BackupViewportResulted, tableName, successCmd)), $elm$browser$Browser$Dom$getViewportOf("editgrid-content")));
                                                    case 10:
                                                        var tableName = msg.a;
                                                        var successCmd = msg.b;
                                                        var viewportResult = msg.c;
                                                        return _Utils_Tuple3($author$project$Pages$Tables$saveGridViewport_fn(tableName, viewportResult, model), tables, _Platform_map_fn(toMsg, successCmd));
                                                    case 11:
                                                        var title = msg.a;
                                                        return (!_Utils_eq($elm$core$Maybe$map_fn($author$project$GraphGrid$unsavedChanges, model.aH), $elm$core$Maybe$Just(true))) ? _Utils_Tuple3(model, tables, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Tables$BackupViewport_fn(activeTableView, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Tables$GridTabChanged(title)))))) : _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none);
                                                    case 12:
                                                        var title = msg.a;
                                                        return _Utils_Tuple3($author$project$Util$flip_fn(setActiveTableView, title, _Utils_update(model, {
                                                            cc: $elm$core$Dict$insert_fn(activeTableView, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Set$empty, A2($elm$core$Basics$composeR, function ($) {
                                                                return $.s;
                                                            }, A2($elm$core$Basics$composeR, function ($) {
                                                                return $.v;
                                                            }, function ($) {
                                                                return $.cc;
                                                            })), model.aH), model.cc)
                                                        })), A3($author$project$Types$Table$setColumns, activeTableView, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                                                            return $.iT;
                                                        }, model.aH), tables), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                            routeToTab(title),
                                                            A3($author$project$Pages$Tables$setGridViewport, toMsg, title, model)
                                                        ])));
                                                    case 13:
                                                        var tableEdit = msg.a;
                                                        var updateTableEditOverlay = function (m) {
                                                            return _Utils_update(m, {
                                                                aA: $author$project$Overlay$updateView_fn($author$project$Pages$Tables$addTableOverlay(m), model.aA)
                                                            });
                                                        };
                                                        return _Utils_Tuple3(updateTableEditOverlay(_Utils_update(model, { bm: tableEdit })), tables, $elm$core$Platform$Cmd$none);
                                                    case 14:
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            aA: $author$project$Overlay$clear(model.aA),
                                                            bm: $author$project$Types$TableEdit$empty
                                                        }), tables, $elm$core$Platform$Cmd$none);
                                                    case 15:
                                                        var cmd = $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$andThen_fn(A3($author$project$Api$createTable, A2($author$project$Pages$Tables$DataReceived, $author$project$Pages$Tables$DataLoaded, model.bm.M), shared.k2, model.bm), maybeDbId));
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                        }), tables, _Platform_map_fn(toMsg, cmd));
                                                    case 16:
                                                        var table = msg.a;
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            an: $elm$core$Maybe$Just($author$project$Types$TableEdit$fromTable(table))
                                                        }), tables, $elm$core$Task$attempt_fn(function (_v9) {
                                                            return toMsg($author$project$Pages$Tables$NoOp);
                                                        }, _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, "table-name-input")));
                                                    case 17:
                                                        var tableEdit = msg.a;
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            an: $elm$core$Maybe$Just(tableEdit)
                                                        }), tables, $elm$core$Platform$Cmd$none);
                                                    case 18:
                                                        return model.la ? _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(_Utils_update(model, { an: $elm$core$Maybe$Nothing }), tables, $elm$core$Platform$Cmd$none);
                                                    case 19:
                                                        var _v10 = $author$project$Util$Maybe$joinTuple($elm$core$Tuple$pair_fn(model.an, $elm$core$Maybe$andThen_fn(function ($) {
                                                            return $.kp;
                                                        }, model.an)));
                                                        if (_v10.$ === 1) {
                                                            return _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none);
                                                        }
                                                        else {
                                                            var _v11 = _v10.a;
                                                            var tableNameEdit = _v11.a;
                                                            var table = _v11.b;
                                                            var tableNameTrimmed = $elm$core$String$trim(tableNameEdit.M);
                                                            if (_Utils_eq(tableNameTrimmed, table.M)) {
                                                                return _Utils_Tuple3(_Utils_update(model, { an: $elm$core$Maybe$Nothing }), tables, $elm$core$Platform$Cmd$none);
                                                            }
                                                            else {
                                                                if (!_Utils_eq(A2($author$project$Types$Table$find, tableNameTrimmed, tables), $elm$core$Maybe$Nothing)) {
                                                                    return _Utils_Tuple3(model, tables, A2(onError, $elm$core$Maybe$Just("Error"), _List_fromArray(["Table name already exists"])));
                                                                }
                                                                else {
                                                                    var toolbars = $elm_community$dict_extra$Dict$Extra$mapKeys_fn(function (key) {
                                                                        return _Utils_eq(key, table.M) ? tableNameTrimmed : key;
                                                                    }, model.Z);
                                                                    return _Utils_Tuple3(_Utils_update(model, {
                                                                        an: $elm$core$Maybe$map_fn(A2($author$project$Util$flip, $author$project$Types$TableEdit$setName, tableNameTrimmed), model.an),
                                                                        Z: toolbars,
                                                                        la: true
                                                                    }), $elm_community$list_extra$List$Extra$updateIf_fn($elm$core$Basics$eq(table), $author$project$Types$Table$setName(tableNameTrimmed), tables), _Platform_map_fn(toMsg, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                                        $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$andThen_fn(A3($author$project$Api$renameTable, $author$project$Pages$Tables$TableNameEditResponded, shared.k2, tableNameEdit), maybeDbId)),
                                                                        $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Tables$GridTabChanged(tableNameTrimmed))
                                                                    ]))));
                                                                }
                                                            }
                                                        }
                                                    case 20:
                                                        if (!msg.a.$) {
                                                            return _Utils_Tuple3(_Utils_update(model, { an: $elm$core$Maybe$Nothing, la: false }), tables, $elm$core$Platform$Cmd$none);
                                                        }
                                                        else {
                                                            var errors = msg.a.a;
                                                            var _v12 = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple3(tables, model.Z, $elm$core$Platform$Cmd$none), function (_v13) {
                                                                var tableNameEdit = _v13.a;
                                                                var table = _v13.b;
                                                                return _Utils_Tuple3($elm_community$list_extra$List$Extra$updateIf_fn(A2($elm$core$Basics$composeR, function ($) {
                                                                    return $.M;
                                                                }, $elm$core$Basics$eq(tableNameEdit.M)), $elm$core$Basics$always(table), tables), $elm_community$dict_extra$Dict$Extra$mapKeys_fn(function (key) {
                                                                    return _Utils_eq(key, tableNameEdit.M) ? table.M : key;
                                                                }, model.Z), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                                    A2(onError, $elm$core$Maybe$Just("Error"), errors),
                                                                    _Platform_map_fn(toMsg, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Tables$GridTabChanged(table.M)))
                                                                ])));
                                                            }, $author$project$Util$Maybe$joinTuple($elm$core$Tuple$pair_fn(model.an, $elm$core$Maybe$andThen_fn(function ($) {
                                                                return $.kp;
                                                            }, model.an))));
                                                            var tablesNew = _v12.a;
                                                            var toolbars = _v12.b;
                                                            var cmd = _v12.c;
                                                            return _Utils_Tuple3(_Utils_update(model, { an: $elm$core$Maybe$Nothing, Z: toolbars, la: false }), tablesNew, cmd);
                                                        }
                                                    case 24:
                                                        var table = msg.a;
                                                        var cmd = $author$project$Types$TableType$isMutable(table.o8) ? setDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", toMsg($author$project$Pages$Tables$TableDeleteRequested(table)), $author$project$Components$ConfirmDialog$TableContext_fn(table, $elm$core$Maybe$Nothing)))) : $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$queryLinesOfCode, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Tables$ViewCodeLineCountResponded(table)), shared.k2, table), maybeDbId);
                                                        return _Utils_Tuple3(model, tables, cmd);
                                                    case 23:
                                                        var table = msg.a;
                                                        var response = msg.b;
                                                        if (!response.$) {
                                                            var lineCount = response.a;
                                                            return _Utils_Tuple3(model, tables, setDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", toMsg($author$project$Pages$Tables$TableDeleteRequested(table)), $author$project$Components$ConfirmDialog$TableContext_fn(table, $elm$core$Maybe$Just(lineCount))))));
                                                        }
                                                        else {
                                                            var errors = response.a;
                                                            return _Utils_Tuple3(model, tables, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                                                        }
                                                    case 21:
                                                        var table = msg.a;
                                                        var cmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A3($author$project$Api$deleteTable, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Tables$TableDeleteResponded(table)), shared.k2, table), maybeDbId);
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            la: !_Utils_eq(cmd, $elm$core$Platform$Cmd$none)
                                                        }), tables, cmd);
                                                    case 22:
                                                        if (msg.b.$ === 1) {
                                                            var errors = msg.b.a;
                                                            return _Utils_Tuple3(_Utils_update(model, { la: false }), tables, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                                                        }
                                                        else {
                                                            var table = msg.a;
                                                            return _Utils_Tuple3($author$project$Util$flip_fn(setActiveTableView, "", _Utils_update(model, {
                                                                Z: $elm$core$Dict$remove_fn(table.M, model.Z),
                                                                la: false,
                                                                b7: $elm$core$Dict$remove_fn(table.M, model.b7)
                                                            })), $elm_community$list_extra$List$Extra$remove_fn(table, tables), setDialog($elm$core$Maybe$Nothing));
                                                        }
                                                    case 25:
                                                        var fromTable = msg.a;
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            bz: $elm$core$Maybe$Just(fromTable)
                                                        }), tables, $elm$core$Platform$Cmd$none);
                                                    case 26:
                                                        var toTable = msg.a;
                                                        if (_Utils_eq(model.bz, $elm$core$Maybe$Just(toTable))) {
                                                            return _Utils_Tuple3(_Utils_update(model, { bz: $elm$core$Maybe$Nothing }), tables, $elm$core$Platform$Cmd$none);
                                                        }
                                                        else {
                                                            var maybeIdxTo = $author$project$Types$Table$toIndex_fn(tables, toTable);
                                                            var maybeIdxFrom = $elm$core$Maybe$andThen_fn($author$project$Types$Table$toIndex(tables), model.bz);
                                                            return _Utils_Tuple3(_Utils_update(model, { bz: $elm$core$Maybe$Nothing }), $elm$core$Maybe$withDefault_fn(tables, $elm$core$Maybe$map2_fn($author$project$Util$List$moveIndexes(tables), maybeIdxTo, maybeIdxFrom)), _Platform_map_fn(toMsg, $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map3_fn(A3($author$project$Api$moveTable, $author$project$Pages$Tables$GridTabDragResponded, shared.k2, tables), maybeIdxFrom, maybeIdxTo, maybeDbId))));
                                                        }
                                                    case 27:
                                                        var tablesOld = msg.a;
                                                        var response = msg.b;
                                                        if (!response.$) {
                                                            return _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$none);
                                                        }
                                                        else {
                                                            var errors = response.a;
                                                            return _Utils_Tuple3(model, tablesOld, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                                                        }
                                                    case 28:
                                                        var format = msg.a;
                                                        var table = msg.b;
                                                        var maybeLoadedTable = $elm_community$maybe_extra$Maybe$Extra$filter_fn($author$project$Types$Table$isLoaded, A2($author$project$Types$Table$find, table.M, tables));
                                                        if (maybeLoadedTable.$ === 1) {
                                                            return _Utils_Tuple3(model, $elm_community$list_extra$List$Extra$updateIf_fn($author$project$Types$Table$hasName(table.M), $author$project$Types$Table$mapColumns($author$project$Types$Column$setLoading), tables), A3(requestTable, $author$project$Pages$Tables$ExportTable_fn(format, table), $elm$core$Maybe$Nothing, table.M));
                                                        }
                                                        else {
                                                            var loadedTable = maybeLoadedTable.a;
                                                            var initGridCmd = function () {
                                                                var tableWasNotLoaded = !$author$project$Types$Table$isLoaded(table);
                                                                var tabChangedToTable = _Utils_eq(activeTableView, loadedTable.M);
                                                                return (tableWasNotLoaded && tabChangedToTable) ? _Platform_map_fn(toMsg, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Pages$Tables$DataLoaded)) : $elm$core$Platform$Cmd$none;
                                                            }();
                                                            var _v17 = function () {
                                                                if (!format) {
                                                                    return _Utils_Tuple3(".json", "application/json", $author$project$Types$Table$toJson);
                                                                }
                                                                else {
                                                                    return _Utils_Tuple3(".csv", "text/csv", $author$project$Types$Table$toCsv);
                                                                }
                                                            }();
                                                            var fileExtension = _v17.a;
                                                            var mime = _v17.b;
                                                            var formatter = _v17.c;
                                                            return _Utils_Tuple3(model, tables, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                                $elm$file$File$Download$string_fn(_Utils_ap(table.M, fileExtension), mime, formatter(loadedTable)),
                                                                initGridCmd
                                                            ])));
                                                        }
                                                    case 29:
                                                        var table = msg.a;
                                                        return _Utils_Tuple3(model, tables, onEditView(table));
                                                    case 30:
                                                        var subMsg = msg.a;
                                                        var result = $elm$core$Maybe$map_fn($author$project$Components$AiEditorOverlay$update(subMsg), model.ce);
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            ce: $elm$core$Maybe$map_fn($elm$core$Tuple$first, result)
                                                        }), tables, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$map(toMsg), $elm$core$Maybe$map_fn($elm$core$Tuple$second, result)));
                                                    case 31:
                                                        var table = msg.a;
                                                        var overlay = $author$project$Components$AiEditorOverlay$init({
                                                            iA: "Create a plain text description of the table \"" + (table.M + "\""),
                                                            ls: $elm$core$Maybe$Just("Generate Table Description"),
                                                            lt: $elm$core$Maybe$Just(3),
                                                            lu: $elm$core$Maybe$Just(false),
                                                            iU: $elm$core$Maybe$Just("Save"),
                                                            gB: $elm$core$Maybe$withDefault_fn("", table.i6),
                                                            lU: $elm$core$Maybe$Nothing,
                                                            l8: $elm$core$Maybe$Just(""),
                                                            mg: $elm$core$Maybe$Just(7),
                                                            mh: $elm$core$Maybe$Nothing,
                                                            bC: F2(function (msg_, description) {
                                                                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A4($author$project$Api$setTableDescription, A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, $author$project$Pages$Tables$DescriptionEditorMsg)), shared.k2, table, $elm_community$string_extra$String$Extra$nonEmpty(description)), maybeDbId);
                                                            }),
                                                            nT: A2($elm$core$Basics$composeR, $author$project$Pages$Tables$ShowErrors, $author$project$Util$msgCmd),
                                                            el: F2(function (msg_, prompt) {
                                                                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A4($author$project$Api$generateTableDescription, A2($elm$core$Basics$composeR, msg_, A2($elm$core$Basics$composeR, $author$project$Components$AiEditorOverlay$EditorMsg, $author$project$Pages$Tables$DescriptionEditorMsg)), shared.k2, prompt, table), maybeDbId);
                                                            }),
                                                            fM: A2($elm$core$Basics$composeR, $author$project$Types$Table$setDescription(table), A2($elm$core$Basics$composeR, $author$project$Pages$Tables$TableUpdated, $author$project$Util$msgCmd)),
                                                            eM: "Table Description Editor",
                                                            gd: $author$project$Pages$Tables$DescriptionEditorMsg
                                                        });
                                                        return _Utils_Tuple3(_Utils_update(model, {
                                                            ce: $elm$core$Maybe$Just(overlay)
                                                        }), tables, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, toMsg($author$project$Pages$Tables$DescriptionEditorMsg($author$project$Components$AiEditorOverlay$Opened))));
                                                    case 32:
                                                        var table = msg.a;
                                                        var overlay = $elm$core$Maybe$withDefault_fn(model.a$, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(model.a$), $elm$core$Maybe$map_fn($author$project$Overlay$tooltipBottom(_List_fromArray([
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                                                        ])), $elm$core$Maybe$map_fn($elm$core$List$singleton, table.i6))));
                                                        return _Utils_Tuple3(_Utils_update(model, { a$: overlay }), tables, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (elementId) {
                                                            return $author$project$Overlay$setOrigin_fn(toMsg, elementId, overlay);
                                                        }, A2($author$project$Types$Table$toHeaderId, tables, table)));
                                                    case 33:
                                                        var table = msg.a;
                                                        return _Utils_Tuple3(_Utils_update(model, { ce: $elm$core$Maybe$Nothing }), A3($author$project$Types$Table$map, table.M, $elm$core$Basics$always(table), tables), $elm$core$Platform$Cmd$none);
                                                    default:
                                                        var errors = msg.a;
                                                        return _Utils_Tuple3(model, tables, A2(onError, $elm$core$Maybe$Just("Error"), errors));
                                                }
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Types$UploadType$CSV = 1;
    var $author$project$Pages$Teams$CreateEmptyDB = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Teams$CreateFromAIprompt = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Pages$Teams$CreateFromEditor_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Teams$CreateFromEditor = F2($author$project$Pages$Teams$CreateFromEditor_fn);
    var $author$project$Pages$Teams$CreateFromQuery = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Teams$OnUploaded_fn = function (a, b, c) {
        return { $: 11, a: a, b: b, c: c };
    }, $author$project$Pages$Teams$OnUploaded = F3($author$project$Pages$Teams$OnUploaded_fn);
    var $author$project$Pages$Teams$QueryEditorMsg = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Pages$Teams$Settings$Routed = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Teams$Tokens$Routed_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Pages$Teams$Tokens$Routed = F2($author$project$Pages$Teams$Tokens$Routed_fn);
    var $author$project$Types$UploadType$SQLite = 0;
    var $author$project$Pages$Teams$SettingsPageMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Teams$ShowErrors = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$Pages$Teams$TeamCreated = function (a) {
        return { $: 18, a: a };
    };
    var $author$project$Pages$Teams$TeamNameRequesterMsg = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Pages$Teams$TokensPageMsg = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Teams$UploadFile_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $author$project$Pages$Teams$UploadFile = F2($author$project$Pages$Teams$UploadFile_fn);
    var $author$project$Api$createTeam_fn = function (msg, maybeToken, teamName) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_Nil)),
            e: A2($author$project$Api$expect, msg, $author$project$Types$Team$decode),
            f: "PATCH",
            g: "/api/teams/" + $elm$url$Url$percentEncode(teamName)
        });
    }, $author$project$Api$createTeam = F3($author$project$Api$createTeam_fn);
    var $author$project$Types$Edition$isShared = function (edition) {
        if (!edition.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$Edition$notShared_a0 = $author$project$Types$Edition$isShared, $author$project$Types$Edition$notShared_a1 = $elm$core$Basics$not, $author$project$Types$Edition$notShared = A2($elm$core$Basics$composeR, $author$project$Types$Edition$notShared_a0, $author$project$Types$Edition$notShared_a1);
    var $author$project$Config$teamNameRegex = "^[a-zA-Z0-9_\\-]{4,32}$";
    var $author$project$Pages$Teams$Route$toTeamName = function (route) {
        switch (route.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var teamName = route.a;
                return $elm$core$Maybe$Just(teamName);
            case 2:
                var teamName = route.a;
                return $elm$core$Maybe$Just(teamName);
            case 3:
                var teamName = route.a;
                return $elm$core$Maybe$Just(teamName);
            default:
                var teamName = route.a;
                return $elm$core$Maybe$Just(teamName);
        }
    };
    var $author$project$Components$ConfirmDialog$ApiTokenContext = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Dialog$ConfirmDialogSimple = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Pages$Teams$Settings$DeleteToken = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Teams$Settings$DeletedToken = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Components$ApiTokenEditorOverlay$Opened = { $: 0 };
    var $author$project$Components$TeamMemberEditorOverlay$Opened = { $: 0 };
    var $author$project$Components$ConfirmDialog$TeamContext = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamDeleted = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamDeletionConfirmed = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Types$Team$TeamMember$TeamMember_fn = function (username, roles) {
        return { oG: roles, lb: username };
    }, $author$project$Types$Team$TeamMember$TeamMember = F2($author$project$Types$Team$TeamMember$TeamMember_fn);
    var $author$project$Pages$Teams$Settings$TeamMemberEditorOverlayMsg = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamMemberReceived = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamMemberRemovalConfirmed_fn = function (a, b) {
        return { $: 18, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamMemberRemovalConfirmed = F2($author$project$Pages$Teams$Settings$TeamMemberRemovalConfirmed_fn);
    var $author$project$Pages$Teams$Settings$TeamMemberRemoved_fn = function (a, b) {
        return { $: 19, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamMemberRemoved = F2($author$project$Pages$Teams$Settings$TeamMemberRemoved_fn);
    var $author$project$Pages$Teams$Settings$TeamMembersReceived = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamNameRequesterMsg_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamNameRequesterMsg = F2($author$project$Pages$Teams$Settings$TeamNameRequesterMsg_fn);
    var $author$project$Pages$Teams$Settings$TeamRenamed_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamRenamed = F2($author$project$Pages$Teams$Settings$TeamRenamed_fn);
    var $author$project$Pages$Teams$Settings$TokenEditorOverlayMsg = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Teams$Settings$TokenReceived = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Teams$Settings$TokensReceived = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Api$editTeamMember_fn = function (msg, maybeToken, team, teamMember) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("roles", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, teamMember.oG))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(teamMember)),
            f: "PATCH",
            g: "/api/teams/" + ($elm$url$Url$percentEncode(team.M) + ("/members/" + teamMember.lb))
        });
    }, $author$project$Api$editTeamMember = F4($author$project$Api$editTeamMember_fn);
    var $author$project$Api$addTeamMember = $author$project$Api$editTeamMember;
    var $author$project$Types$ApiToken$ApiToken_fn = function (name, id, description, createdUtc, expirationUtc, body, permissions) {
        return { d: body, lW: createdUtc, i6: description, mq: expirationUtc, bR: id, M: name, od: permissions };
    }, $author$project$Types$ApiToken$ApiToken = F7($author$project$Types$ApiToken$ApiToken_fn);
    var $author$project$Types$DatabasePermission$DatabasePermission_fn = function (dbId, dbName, name) {
        return { i2: dbId, l4: dbName, M: name };
    }, $author$project$Types$DatabasePermission$DatabasePermission = F3($author$project$Types$DatabasePermission$DatabasePermission_fn);
    var $author$project$Types$DatabasePermission$Read = 0;
    var $author$project$Types$DatabasePermission$Write = 1;
    var $author$project$Types$DatabasePermission$databasePermissionNameFromString = function (name) {
        switch (name) {
            case "read":
                return $elm$core$Maybe$Just(0);
            case "write":
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Types$DatabasePermission$decode = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_andThen_fn(A2($elm$core$Basics$composeR, $author$project$Types$DatabasePermission$databasePermissionNameFromString, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail("Invalid database permission name"), $elm$json$Json$Decode$succeed)), _Json_decodeField_fn("name", $elm$json$Json$Decode$string)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("db_name", $elm$json$Json$Decode$string), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("db_id", _Json_map1_fn($author$project$Types$Database$wrapId, $elm$json$Json$Decode$string)), $elm$json$Json$Decode$succeed($author$project$Types$DatabasePermission$DatabasePermission))));
    var $author$project$Types$ApiToken$decode = _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("permissions", $elm$json$Json$Decode$list($author$project$Types$DatabasePermission$decode)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("body", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("expiration_utc", $elm$json$Json$Decode$nullable($author$project$Types$Utc$decode)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("created_utc", $author$project$Types$Utc$decode), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("description", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("id", _Json_map1_fn($author$project$Types$ApiToken$idFromInt, $elm$json$Json$Decode$int)), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Types$ApiToken$ApiToken))))))));
    var $author$project$Types$DatabasePermission$databasePermissionNameToString = function (name) {
        if (!name) {
            return "read";
        }
        else {
            return "write";
        }
    };
    var $author$project$Types$DatabasePermission$encode = function (permission) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("db_id", $elm$json$Json$Encode$string($author$project$Types$Database$unwrapId(permission.i2))),
            _Utils_Tuple2("name", $elm$json$Json$Encode$string($author$project$Types$DatabasePermission$databasePermissionNameToString(permission.M)))
        ]));
    };
    var $author$project$Types$Utc$encode_a0 = $author$project$Types$Utc$toString, $author$project$Types$Utc$encode_a1 = $elm$json$Json$Encode$string, $author$project$Types$Utc$encode = A2($elm$core$Basics$composeR, $author$project$Types$Utc$encode_a0, $author$project$Types$Utc$encode_a1);
    var $author$project$Types$ApiToken$encodeToList = function (apiToken) {
        return _List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(apiToken.M)),
            _Utils_Tuple2("description", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, apiToken.i6)),
            _Utils_Tuple2("created_utc", $elm$core$Basics$composeR_fn($author$project$Types$Utc$encode_a0, $author$project$Types$Utc$encode_a1, apiToken.lW)),
            _Utils_Tuple2("expiration_utc", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, $author$project$Types$Utc$encode, apiToken.mq)),
            _Utils_Tuple2("body", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, apiToken.d)),
            _Utils_Tuple2("permissions", $elm$json$Json$Encode$list_fn($author$project$Types$DatabasePermission$encode, apiToken.od))
        ]);
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
        switch (month) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn = function (digits, time) {
        return $elm$core$String$padLeft_fn(digits, "0", $elm$core$String$fromInt(time));
    }, $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn);
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
        return $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(4, $elm$time$Time$toYear_fn($elm$time$Time$utc, time)) + ("-" + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(2, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth($elm$time$Time$toMonth_fn($elm$time$Time$utc, time))) + ("-" + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(2, $elm$time$Time$toDay_fn($elm$time$Time$utc, time)) + ("T" + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(2, $elm$time$Time$toHour_fn($elm$time$Time$utc, time)) + (":" + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(2, $elm$time$Time$toMinute_fn($elm$time$Time$utc, time)) + (":" + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(2, $elm$time$Time$toSecond_fn($elm$time$Time$utc, time)) + ("." + ($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString_fn(3, $elm$time$Time$toMillis_fn($elm$time$Time$utc, time)) + "Z"))))))))))));
    };
    var $author$project$Types$Utc$fromPosix_a0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $author$project$Types$Utc$fromPosix_a1 = $elm$core$Basics$identity, $author$project$Types$Utc$fromPosix = A2($elm$core$Basics$composeR, $author$project$Types$Utc$fromPosix_a0, $author$project$Types$Utc$fromPosix_a1);
    var $author$project$Types$ApiTokenEdit$toApiToken = function (apiTokenEdit) {
        var toDatabasePermissions = function () {
            var split = function (permission) {
                return $elm$core$List$map_fn(A2($author$project$Types$DatabasePermission$DatabasePermission, permission.i2, permission.l4), $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    permission.on ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing,
                    permission.pG ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing
                ])));
            };
            return $elm$core$List$concatMap(split);
        }();
        var _v0 = apiTokenEdit.kp;
        if (!_v0.$) {
            var apiToken = _v0.a;
            return _Utils_update(apiToken, {
                i6: apiTokenEdit.i6,
                mq: apiTokenEdit.mq,
                M: apiTokenEdit.M,
                od: toDatabasePermissions(apiTokenEdit.od)
            });
        }
        else {
            return {
                d: $elm$core$Maybe$Nothing,
                lW: $elm$core$Basics$composeR_fn($author$project$Types$Utc$fromPosix_a0, $author$project$Types$Utc$fromPosix_a1, $elm$time$Time$millisToPosix(0)),
                i6: apiTokenEdit.i6,
                mq: apiTokenEdit.mq,
                bR: $author$project$Types$ApiToken$idFromInt(-1),
                M: apiTokenEdit.M,
                od: toDatabasePermissions(apiTokenEdit.od)
            };
        }
    };
    var $author$project$Api$createApiToken_fn = function (msg, maybeToken, teamName, apiTokenEdit) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object($elm$core$List$append_fn(_List_fromArray([
                _Utils_Tuple2("team_name", $elm$json$Json$Encode$string(teamName))
            ]), $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$neq("body")), $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$neq("created_utc")), $author$project$Types$ApiToken$encodeToList($author$project$Types$ApiTokenEdit$toApiToken(apiTokenEdit))))))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$ApiToken$decode),
            f: "POST",
            g: "/api/tokens"
        });
    }, $author$project$Api$createApiToken = F4($author$project$Api$createApiToken_fn);
    var $author$project$Api$deleteApiToken_fn = function (msg, maybeToken, apiToken) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(apiToken)),
            f: "DELETE",
            g: _String_append_fn("/api/tokens/", $elm$url$Url$percentEncode($elm$core$String$fromInt($author$project$Types$ApiToken$idToInt(apiToken.bR))))
        });
    }, $author$project$Api$deleteApiToken = F3($author$project$Api$deleteApiToken_fn);
    var $author$project$Api$deleteTeam_fn = function (msg, maybeToken, team) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(team)),
            f: "DELETE",
            g: "/api/teams/" + $elm$url$Url$percentEncode(team.M)
        });
    }, $author$project$Api$deleteTeam = F3($author$project$Api$deleteTeam_fn);
    var $author$project$Api$editApiToken_fn = function (msg, maybeToken, teamName, apiTokenEdit) {
        var apiToken = $author$project$Types$ApiTokenEdit$toApiToken(apiTokenEdit);
        var modifiedFields = function () {
            var _v0 = apiTokenEdit.kp;
            if (!_v0.$) {
                var original = _v0.a;
                var originalFields = $author$project$Types$ApiToken$encodeToList(original);
                return $elm$core$List$filter_fn(A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$notMember, originalFields), $author$project$Types$ApiToken$encodeToList(apiToken));
            }
            else {
                return $author$project$Types$ApiToken$encodeToList(apiToken);
            }
        }();
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object($elm$core$List$append_fn(_List_fromArray([
                _Utils_Tuple2("team_name", $elm$json$Json$Encode$string(teamName))
            ]), modifiedFields))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$ApiToken$decode),
            f: "PATCH",
            g: _String_append_fn("/api/tokens/", $elm$url$Url$percentEncode($elm$core$String$fromInt($author$project$Types$ApiToken$idToInt(apiToken.bR))))
        });
    }, $author$project$Api$editApiToken = F4($author$project$Api$editApiToken_fn);
    var $author$project$Types$ApiTokenEdit$fromApiToken = function (apiToken) {
        var mergePermissions = function (permissions) {
            var mergeBySameDatabaseId = F2(function (permission, acc) {
                var maybeExistingPermissionMatchIdx = $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, A2($elm$core$Basics$composeR, function ($) {
                    return $.i2;
                }, $elm$core$Basics$eq(permission.i2)), acc);
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Cons(permission, acc), function (idx) {
                    return $elm_community$list_extra$List$Extra$updateAt_fn(idx, function (p) {
                        return _Utils_update(p, { on: p.on || permission.on, pG: p.pG || permission.pG });
                    }, acc);
                }, maybeExistingPermissionMatchIdx);
            });
            return $elm$core$List$foldr_fn(mergeBySameDatabaseId, _List_Nil, permissions);
        };
        return {
            i6: apiToken.i6,
            mq: apiToken.mq,
            M: apiToken.M,
            kp: $elm$core$Maybe$Just(apiToken),
            od: mergePermissions($elm$core$List$map_fn(function (permission) {
                return { i2: permission.i2, l4: permission.l4, on: !permission.M, pG: permission.M === 1 };
            }, apiToken.od))
        };
    };
    var $author$project$Types$ApiTokenEdit$fromTeam = function (team) {
        return {
            i6: $elm$core$Maybe$Nothing,
            mq: $elm$core$Maybe$Nothing,
            M: "",
            kp: $elm$core$Maybe$Nothing,
            od: $elm$core$List$map_fn(function (database) {
                return { i2: database.bR, l4: database.M, on: false, pG: false };
            }, $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, team.l1))
        };
    };
    var $author$project$Api$getApiTokens_fn = function (msg, maybeToken, team) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("tokens", $elm$json$Json$Decode$list($author$project$Types$ApiToken$decode))),
            f: "GET",
            g: "/api/teams/" + ($elm$url$Url$percentEncode(team.M) + "/tokens")
        });
    }, $author$project$Api$getApiTokens = F3($author$project$Api$getApiTokens_fn);
    var $author$project$Types$Team$TeamMember$decode = A3($elm$core$Basics$apR, _Json_decodeField_fn("roles", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)), $elm_community$json_extra$Json$Decode$Extra$andMap, A3($elm$core$Basics$apR, _Json_decodeField_fn("username", $elm$json$Json$Decode$string), $elm_community$json_extra$Json$Decode$Extra$andMap, $elm$json$Json$Decode$succeed($author$project$Types$Team$TeamMember$TeamMember)));
    var $author$project$Api$getTeamMembers_fn = function (msg, maybeToken, team) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, _Json_decodeField_fn("members", $elm$json$Json$Decode$list($author$project$Types$Team$TeamMember$decode))),
            f: "GET",
            g: "/api/teams/" + ($elm$url$Url$percentEncode(team.M) + "/members")
        });
    }, $author$project$Api$getTeamMembers = F3($author$project$Api$getTeamMembers_fn);
    var $author$project$Components$ApiTokenEditorOverlay$OverlayMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$ApiTokenEditorOverlay$init = function (cfg) {
        return {
            dS: false,
            gO: $author$project$Components$Editor$init_fn($elm$core$Maybe$Just(3), $elm$core$Maybe$Nothing, $elm$core$Maybe$withDefault_fn("", cfg.k2.i6)),
            hd: cfg.k2,
            bC: cfg.bC,
            nT: cfg.nT,
            fM: cfg.fM,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$ApiTokenEditorOverlay$OverlayMsg, cfg.gd)),
            gd: cfg.gd,
            k2: cfg.k2,
            la: false
        };
    };
    var $author$project$Components$TeamMemberEditorOverlay$DialogOverlayMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$TeamMemberEditorOverlay$OverlayMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Components$TeamMemberEditorOverlay$init = function (cfg) {
        return {
            aE: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, $author$project$Components$TeamMemberEditorOverlay$DialogOverlayMsg),
            hc: cfg.k$,
            fu: cfg.k$,
            ed: cfg.ed,
            bC: cfg.bC,
            nT: cfg.nT,
            fM: cfg.fM,
            a$: $author$project$Overlay$init_fn($elm$core$Maybe$Nothing, A2($elm$core$Basics$composeR, $author$project$Components$TeamMemberEditorOverlay$OverlayMsg, cfg.gd)),
            gd: cfg.gd,
            la: false
        };
    };
    var $author$project$Api$removeTeamMember_fn = function (msg, maybeToken, team, teamMember) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(teamMember)),
            f: "DELETE",
            g: "/api/teams/" + ($elm$url$Url$percentEncode(team.M) + ("/members/" + teamMember.lb))
        });
    }, $author$project$Api$removeTeamMember = F4($author$project$Api$removeTeamMember_fn);
    var $author$project$Api$renameTeam_fn = function (msg, maybeToken, team, newName) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("name", $elm$json$Json$Encode$string(newName))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(_Utils_update(team, { M: newName }))),
            f: "PATCH",
            g: "/api/teams/" + $elm$url$Url$percentEncode(team.M)
        });
    }, $author$project$Api$renameTeam = F4($author$project$Api$renameTeam_fn);
    var $author$project$Api$Response$toRemoteData = function (response) {
        if (!response.$) {
            var value = response.a;
            return $krisajenkins$remotedata$RemoteData$Success(value);
        }
        else {
            var errors = response.a;
            return $krisajenkins$remotedata$RemoteData$Failure(errors);
        }
    };
    var $author$project$Dialog$SuccessDialog = function (a) {
        return { $: 1, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$break_words = $rtfeldman$elm_css$Css$property_fn("overflow-wrap", "break-word");
    var $rtfeldman$elm_css$Html$Styled$section_a0 = "section", $rtfeldman$elm_css$Html$Styled$section = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$section_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold = $rtfeldman$elm_css$Css$property_fn("font-weight", "600");
    var $author$project$Components$toDetails_fn = function (maybeId, title, description) {
        var wrapAsLabel = function () {
            if (!maybeId.$) {
                var id_ = maybeId.a;
                return A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$label(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, id_)
                ])));
            }
            else {
                return $elm$core$Basics$identity;
            }
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]))
            ]), _List_fromArray([
                wrapAsLabel($rtfeldman$elm_css$Html$Styled$text(title))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs,
                    $author$project$Util$styleIf_fn(description === "", $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(description)
            ]))
        ]));
    }, $author$project$Components$toDetails = F3($author$project$Components$toDetails_fn);
    var $author$project$Components$contentDetailed_fn = function (title, description, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]), _List_fromArray([
            $author$project$Components$toDetails_fn($elm$core$Maybe$Nothing, title, description),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), content)
        ]));
    }, $author$project$Components$contentDetailed = F3($author$project$Components$contentDetailed_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_400 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "74", "222", "128", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_50 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "240", "253", "244", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_700 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "21", "128", "61", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $rtfeldman$elm_css$Css$makeImportant = function (_v0) {
        var str = _v0;
        return _String_endsWith_fn(" !important", $elm$core$String$toLower(str)) ? str : (str + " !important");
    };
    var $rtfeldman$elm_css$Css$Preprocess$mapAllProperties_fn = function (update, styles) {
        if (!styles.b) {
            return styles;
        }
        else {
            if (!styles.b.b) {
                var only = styles.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn(update, only)
                ]);
            }
            else {
                var first = styles.a;
                var rest = styles.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Preprocess$mapAllProperties_fn(update, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Preprocess$mapAllProperties = F2($rtfeldman$elm_css$Css$Preprocess$mapAllProperties_fn);
    var $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn = function (update, style) {
        switch (style.$) {
            case 0:
                var property = style.a;
                return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(update(property));
            case 1:
                var selector = style.a;
                var styles = style.b;
                return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector_fn(selector, $rtfeldman$elm_css$Css$Preprocess$mapAllProperties_fn(update, styles));
            case 2:
                return style;
            case 3:
                return style;
            case 4:
                return style;
            case 5:
                return style;
            default:
                var otherStyles = style.a;
                return $rtfeldman$elm_css$Css$Preprocess$ApplyStyles($elm$core$List$map_fn($rtfeldman$elm_css$Css$Preprocess$mapProperties(update), otherStyles));
        }
    }, $rtfeldman$elm_css$Css$Preprocess$mapProperties = F2($rtfeldman$elm_css$Css$Preprocess$mapProperties_fn);
    var $rtfeldman$elm_css$Css$important_a0 = $rtfeldman$elm_css$Css$makeImportant, $rtfeldman$elm_css$Css$important = $rtfeldman$elm_css$Css$Preprocess$mapProperties($rtfeldman$elm_css$Css$important_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_around = $rtfeldman$elm_css$Css$property_fn("justify-content", "space-around");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_2xl = $rtfeldman$elm_css$Css$property_fn("max-width", "42rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4 = $rtfeldman$elm_css$Css$property_fn("margin-top", "-1rem");
    var $rtfeldman$elm_css$Css$unset = _Utils_update($rtfeldman$elm_css$Css$initial, { pB: "unset" });
    var $author$project$Types$Utc$toDateString_a0 = $author$project$Types$Utc$toString, $author$project$Types$Utc$toDateString_a1 = $elm_community$string_extra$String$Extra$leftOf("T"), $author$project$Types$Utc$toDateString = A2($elm$core$Basics$composeR, $author$project$Types$Utc$toDateString_a0, $author$project$Types$Utc$toDateString_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_help = $rtfeldman$elm_css$Css$property_fn("cursor", "help");
    var $rtfeldman$elm_css$Html$Styled$Attributes$title_a0 = "title", $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$title_a0);
    var $author$project$Components$wrapWithTitleTooltip = function (tooltip) {
        return A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$span(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$title_a0, tooltip),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_help]))
        ])));
    };
    var $author$project$Components$utcWithTooltip_fn = function (styles, utcString) {
        var formatUtc = A2($elm$core$Basics$composeR, $author$project$Types$Utc$toDateString, A2($author$project$Util$flip, $elm$core$String$append, " UTC"));
        return A2($author$project$Components$wrapWithTitleTooltip, $author$project$Types$Utc$toString(utcString), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(formatUtc(utcString))
        ])));
    }, $author$project$Components$utcWithTooltip = F2($author$project$Components$utcWithTooltip_fn);
    var $author$project$Pages$Teams$Settings$tokenCreateSuccessDialog_fn = function (token, body) {
        var content = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4]))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Copy the token below and store it in a safe place." + " It will not be shown again."),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_700),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_50),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$break_words
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(body)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_around]))
            ]), _List_fromArray([
                $author$project$Components$contentDetailed_fn("Name", token.M, _List_Nil),
                $author$project$Components$contentDetailed_fn("Expiration", "", $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs
                    ]))
                ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text("Never"), $author$project$Components$utcWithTooltip(_List_Nil), token.mq)))))
            ]))
        ]));
        return $author$project$Dialog$SuccessDialog({
            bv: false,
            gB: content,
            m: _List_fromArray([
                $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn($rtfeldman$elm_css$Css$important_a0, $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$unset)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_2xl,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100))
            ]),
            eM: "Token Created"
        });
    }, $author$project$Pages$Teams$Settings$tokenCreateSuccessDialog = F2($author$project$Pages$Teams$Settings$tokenCreateSuccessDialog_fn);
    var $author$project$Components$ApiTokenEditorOverlay$Responded = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$ApiTokenEditorOverlay$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$ApiTokenEditorOverlay$Applied = { $: 3 };
    var $author$project$Components$ApiTokenEditorOverlay$BackdropClicked = { $: 2 };
    var $author$project$Components$ApiTokenEditorOverlay$CloseCancelDialog = { $: 8 };
    var $author$project$Components$ApiTokenEditorOverlay$Closed = { $: 1 };
    var $author$project$Components$ApiTokenEditorOverlay$EditorMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Components$ApiTokenEditorOverlay$TokenUpdated = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Types$Utc$fromDateString_a0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $author$project$Types$Utc$fromDateString_a1 = A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime), $elm$core$Maybe$map($elm$core$Basics$identity))), $author$project$Types$Utc$fromDateString = A2($elm$core$Basics$composeR, $author$project$Types$Utc$fromDateString_a0, $author$project$Types$Utc$fromDateString_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_5 = $rtfeldman$elm_css$Css$property_fn("gap", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_24 = $rtfeldman$elm_css$Css$property_fn("height", "6rem");
    var $author$project$Util$hideElement_fn = function (condition, element) {
        return (!condition) ? element : $rtfeldman$elm_css$Html$Styled$text("");
    }, $author$project$Util$hideElement = F2($author$project$Util$hideElement_fn);
    var $author$project$Components$ApiTokenEditorOverlay$isInvalidEdit = function (model) {
        return $elm$core$String$isEmpty(model.k2.M) || $elm$core$List$isEmpty($author$project$Types$ApiTokenEdit$toApiToken(model.k2).od);
    };
    var $rtfeldman$elm_css$Css$checked = $rtfeldman$elm_css$Css$pseudoClass("checked");
    var $rtfeldman$elm_css$Css$Structure$IdSelector = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Css$Global$id_fn = function (str, styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn(styles, $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_fromArray([
            $rtfeldman$elm_css$Css$Structure$IdSelector(str)
        ])));
    }, $rtfeldman$elm_css$Css$Global$id = F2($rtfeldman$elm_css$Css$Global$id_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-left", "auto"),
        $rtfeldman$elm_css$Css$property_fn("margin-right", "auto")
    ]));
    var $author$project$Toggable$modalToggle = function (cfg) {
        var wrapperId = cfg.bR + "-wrapper";
        var toggleId = cfg.bR + "-toggle";
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
        ]), _List_fromArray([
            $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(toggleId), cfg.nj)),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, _Utils_eq(cfg.nj, $elm$core$Maybe$Nothing)),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, toggleId),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                    $rtfeldman$elm_css$Css$checked(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$adjacentSiblings_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$id_fn(wrapperId, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                        ]))
                    ]))
                ]))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, wrapperId),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$fixed, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1]))
                        ]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                        cfg.lR ? $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, toggleId) : $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen]))
                    ]), _List_Nil),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto]))
                    ]), _List_fromArray([
                        cfg.nt(toggleId)
                    ]))
                ]))
            ]))
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto = $rtfeldman$elm_css$Css$property_fn("margin", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0.125rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0.125rem")
    ]));
    var $author$project$Types$ApiTokenEdit$setReadPermission_fn = function (apiTokenEdit, databaseId, value) {
        return _Utils_update(apiTokenEdit, {
            od: $elm_community$list_extra$List$Extra$updateIf_fn(function (permission) {
                return _Utils_eq(permission.i2, databaseId);
            }, function (permission) {
                return _Utils_update(permission, { on: value });
            }, apiTokenEdit.od)
        });
    }, $author$project$Types$ApiTokenEdit$setReadPermission = F3($author$project$Types$ApiTokenEdit$setReadPermission_fn);
    var $author$project$Types$ApiTokenEdit$setWritePermission_fn = function (apiTokenEdit, databaseId, value) {
        return _Utils_update(apiTokenEdit, {
            od: $elm_community$list_extra$List$Extra$updateIf_fn(function (permission) {
                return _Utils_eq(permission.i2, databaseId);
            }, function (permission) {
                return _Utils_update(permission, { pG: value });
            }, apiTokenEdit.od)
        });
    }, $author$project$Types$ApiTokenEdit$setWritePermission = F3($author$project$Types$ApiTokenEdit$setWritePermission_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_auto = $rtfeldman$elm_css$Css$property_fn("table-layout", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_cell = $rtfeldman$elm_css$Css$property_fn("display", "table-cell");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_header_group = $rtfeldman$elm_css$Css$property_fn("display", "table-header-group");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row = $rtfeldman$elm_css$Css$property_fn("display", "table-row");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row_group = $rtfeldman$elm_css$Css$property_fn("display", "table-row-group");
    var $author$project$Components$permissionsInput = function (cfg) {
        var toRow = function (permission) {
            var toCheckbox = F2(function (getter, setter) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                        $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onCheck, $elm$core$Maybe$map_fn(function (onUpdate) {
                            return A2($elm$core$Basics$composeR, A2(setter, cfg.k2, permission.i2), onUpdate);
                        }, cfg.hp)),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, getter(permission)),
                        $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$tabindex, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(_Utils_eq(cfg.hp, $elm$core$Maybe$Nothing)), $elm$core$Maybe$Just(-1))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto,
                            $author$project$Util$styleIf_fn(_Utils_eq(cfg.hp, $elm$core$Maybe$Nothing), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none)
                        ]))
                    ]), _List_Nil)
                ]));
            });
            var databaseLink = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$Database(permission.i2))),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$target, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(cfg.pb), $elm$core$Maybe$Just("_blank"))),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(permission.l4)
            ]));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row,
                    $author$project$Theme$theme.bN.kJ,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_cell, $author$project$Theme$theme.bN.e2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1]))
                    ]))
                ]))
            ]), _List_fromArray([
                databaseLink,
                A2(toCheckbox, function ($) {
                    return $.on;
                }, $author$project$Types$ApiTokenEdit$setReadPermission),
                A2(toCheckbox, function ($) {
                    return $.pG;
                }, $author$project$Types$ApiTokenEdit$setWritePermission)
            ]));
        };
        var rows = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row_group]))
        ]), $elm$core$List$map_fn(toRow, cfg.k2.od));
        var headers = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_header_group,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_cell, $author$project$Theme$theme.bN.e2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0_dot_5]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Database")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Read")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Write")
                ]))
            ]))
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_auto, $author$project$Theme$theme.bN.kZ, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto]))
        ]), _List_fromArray([headers, rows]))));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_5 = $rtfeldman$elm_css$Css$property_fn("padding-top", "1.25rem");
    var $author$project$Types$ApiTokenEdit$setExpiration_fn = function (apiTokenEdit, maybeExpiration) {
        return _Utils_update(apiTokenEdit, { mq: maybeExpiration });
    }, $author$project$Types$ApiTokenEdit$setExpiration = F2($author$project$Types$ApiTokenEdit$setExpiration_fn);
    var $author$project$Types$ApiTokenEdit$setName_fn = function (apiTokenEdit, name) {
        return _Utils_update(apiTokenEdit, { M: name });
    }, $author$project$Types$ApiTokenEdit$setName = F2($author$project$Types$ApiTokenEdit$setName_fn);
    var $author$project$Components$ApiTokenEditorOverlay$unchanged = function (model) {
        return _Utils_eq(model.k2, model.hd);
    };
    var $author$project$Components$ApiTokenEditorOverlay$editorView = function (model) {
        var toolbar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("API Token Editor")
            ])),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$closeCircled,
                a_: $author$project$Components$ApiTokenEditorOverlay$Closed,
                m: _List_Nil,
                bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
            })
        ]));
        var toDialog = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 28))
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $author$project$Theme$theme.of
            ]))
        ]));
        var toContent = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_5]))
        ]));
        var isEdit = !_Utils_eq(model.k2.kp, $elm$core$Maybe$Nothing);
        var submitButtonTitle = isEdit ? "Update Token" : "Create Token";
        var confirmButton = function (cfg_) {
            return $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6]), cfg_.h5, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.kW,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $rtfeldman$elm_css$Css$batch(cfg_.m)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg_.a_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg_.cd)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg_.eM)
            ])));
        };
        var cancelDialog = $author$project$Toggable$modalToggle({
            lR: false,
            bR: "token-editor-cancel-dialog",
            nj: $elm$core$Maybe$Nothing,
            nt: function (_v0) {
                return $author$project$Components$confirmDialogSimple({ lL: $elm$core$Maybe$Nothing, iU: $elm$core$Maybe$Nothing, no: "All changes will be lost.", ek: $author$project$Components$ApiTokenEditorOverlay$CloseCancelDialog, hG: $author$project$Components$ApiTokenEditorOverlay$Closed });
            }
        });
        var borderStyles = _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
        ]);
        var expirationInput = $author$project$Components$wrapWithLabel_fn({ jS: "Expiration", jT: "", jU: _List_Nil, m: _List_Nil }, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "date"),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Types$Utc$toDateString, model.k2.mq)),
            $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeR, $author$project$Types$Utc$fromDateString, A2($elm$core$Basics$composeR, $author$project$Types$ApiTokenEdit$setExpiration(model.k2), $author$project$Components$ApiTokenEditorOverlay$TokenUpdated))),
            $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $rtfeldman$elm_css$Css$batch(borderStyles)
            ]))
        ]), _List_Nil));
        var nameInput = $author$project$Components$wrapWithLabel_fn({ jS: "Token Name", jT: "", jU: _List_Nil, m: _List_Nil }, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.k2.M),
            $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApiTokenEditorOverlay$TokenUpdated, $author$project$Types$ApiTokenEdit$setName(model.k2))),
            $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $rtfeldman$elm_css$Css$batch(borderStyles)
            ]))
        ]), _List_Nil));
        var permissionsInput = $author$project$Components$wrapWithLabel_fn({
            jS: "Permissions",
            jT: "",
            jU: _List_Nil,
            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0])
        }, $author$project$Components$permissionsInput({
            hp: $elm$core$Maybe$Just($author$project$Components$ApiTokenEditorOverlay$TokenUpdated),
            m: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $rtfeldman$elm_css$Css$batch(borderStyles)
            ]),
            pb: true,
            k2: model.k2
        }));
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, A3($author$project$Components$backdrop, "token-editor", $elm$core$Maybe$Just($author$project$Components$ApiTokenEditorOverlay$BackdropClicked), _List_fromArray([
            toDialog(_List_fromArray([
                toolbar,
                toContent(_List_fromArray([
                    nameInput,
                    $author$project$Components$wrapWithLabel_fn({
                        jS: "Description",
                        jT: "",
                        jU: _List_Nil,
                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_24])
                    }, $author$project$Components$Editor$view_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full]), $author$project$Components$ApiTokenEditorOverlay$EditorMsg, $author$project$Components$ApiTokenEditorOverlay$Applied, model.gO)),
                    expirationInput,
                    $author$project$Util$hideElement_fn(isEdit || _Utils_eq(model.k2.od, _List_Nil), permissionsInput),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                    ]), _List_fromArray([
                        $author$project$Components$textButton_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]), "Cancel", $author$project$Components$ApiTokenEditorOverlay$Closed),
                        confirmButton({
                            cd: $author$project$Components$ApiTokenEditorOverlay$isInvalidEdit(model) || ($author$project$Components$ApiTokenEditorOverlay$unchanged(model) || model.la),
                            a_: $author$project$Components$ApiTokenEditorOverlay$Applied,
                            h5: model.la,
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12]),
                            eM: submitButtonTitle
                        })
                    ]))
                ])),
                $author$project$Util$showElement_fn(model.dS, cancelDialog)
            ]))
        ])));
    };
    var $author$project$Components$ApiTokenEditorOverlay$initOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$showCentered_fn($author$project$Components$ApiTokenEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Types$ApiTokenEdit$setDescription_fn = function (apiTokenEdit, description) {
        return _Utils_update(apiTokenEdit, {
            i6: $elm$core$Maybe$Just(description)
        });
    }, $author$project$Types$ApiTokenEdit$setDescription = F2($author$project$Types$ApiTokenEdit$setDescription_fn);
    var $author$project$Components$ApiTokenEditorOverlay$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Components$ApiTokenEditorOverlay$setUpdating = F2($author$project$Components$ApiTokenEditorOverlay$setUpdating_fn);
    var $author$project$Components$ApiTokenEditorOverlay$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$ApiTokenEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$ApiTokenEditorOverlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$initOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                return $author$project$Components$ApiTokenEditorOverlay$unchanged(model) ? $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { dS: true }), $elm$core$Platform$Cmd$none));
            case 3:
                return $author$project$Components$ApiTokenEditorOverlay$unchanged(model) ? $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : ($author$project$Components$ApiTokenEditorOverlay$isInvalidEdit(model) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $author$project$Util$withCmd_fn(A2(model.bC, model.k2, $author$project$Components$ApiTokenEditorOverlay$Responded), $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
            case 4:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$closeOverlay, $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
            case 7:
                var tokenEdit = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { k2: tokenEdit }), $elm$core$Platform$Cmd$none));
            case 8:
                return $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { dS: false }), $elm$core$Platform$Cmd$none));
            case 5:
                var editorMsg = msg.a;
                var editor = $author$project$Components$Editor$update_fn(editorMsg, model.gO);
                return $author$project$Util$withModel_fn($author$project$Components$ApiTokenEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, {
                    gO: editor,
                    k2: $author$project$Types$ApiTokenEdit$setDescription_fn(model.k2, editor.gB)
                }), $elm$core$Platform$Cmd$none));
            default:
                var overlayMsg = msg.a;
                var _v2 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
        }
    }, $author$project$Components$ApiTokenEditorOverlay$update = F2($author$project$Components$ApiTokenEditorOverlay$update_fn);
    var $author$project$Components$TeamMemberEditorOverlay$CloseDialog = { $: 8 };
    var $author$project$Components$TeamMemberEditorOverlay$Closed = { $: 1 };
    var $author$project$Components$TeamMemberEditorOverlay$Responded = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$TeamMemberEditorOverlay$closeOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$clear(model.a$)
        });
    };
    var $author$project$Components$TeamMemberEditorOverlay$Applied = { $: 3 };
    var $author$project$Components$TeamMemberEditorOverlay$BackdropClicked = { $: 2 };
    var $author$project$Components$TeamMemberEditorOverlay$InputUpdated = function (a) {
        return { $: 7, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$capitalize = $rtfeldman$elm_css$Css$property_fn("text-transform", "capitalize");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_span_2 = $rtfeldman$elm_css$Css$property_fn("grid-column", "span 2 / span 2");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_6 = $rtfeldman$elm_css$Css$property_fn("gap", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_12 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "3rem"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "3rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2 = $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "repeat(2, minmax(0, 1fr))");
    var $author$project$Components$TeamMemberEditorOverlay$isInvalidEdit = function (model) {
        return $elm$core$String$isEmpty(model.fu.lb);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start = $rtfeldman$elm_css$Css$property_fn("justify-content", "flex-start");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_3 = $rtfeldman$elm_css$Css$property_fn("padding-left", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_6 = $rtfeldman$elm_css$Css$property_fn("padding-top", "1.5rem");
    var $author$project$Components$TeamMemberEditorOverlay$setTeamMemberUsername_fn = function (teamMember, username) {
        return _Utils_update(teamMember, { lb: username });
    }, $author$project$Components$TeamMemberEditorOverlay$setTeamMemberUsername = F2($author$project$Components$TeamMemberEditorOverlay$setTeamMemberUsername_fn);
    var $author$project$Components$TeamMemberEditorOverlay$toggleTeamMemberRole_fn = function (teamMember, role) {
        var active = $elm$core$List$member_fn(role, teamMember.oG);
        var roles = (active ? $elm_community$list_extra$List$Extra$remove(role) : $elm$core$List$cons(role))(teamMember.oG);
        return _Utils_update(teamMember, { oG: roles });
    }, $author$project$Components$TeamMemberEditorOverlay$toggleTeamMemberRole = F2($author$project$Components$TeamMemberEditorOverlay$toggleTeamMemberRole_fn);
    var $author$project$Components$TeamMemberEditorOverlay$unchanged = function (model) {
        return _Utils_eq(model.fu, model.hc);
    };
    var $author$project$Components$TeamMemberEditorOverlay$editorView = function (model) {
        var toolbar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Team Member Editor")
            ])),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$closeCircled,
                a_: $author$project$Components$TeamMemberEditorOverlay$Closed,
                m: _List_Nil,
                bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
            })
        ]));
        var toDialog = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1))),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 28))
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $author$project$Theme$theme.of
            ]))
        ]));
        var toContent = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_6]))
        ]));
        var submitButtonTitle = model.ed ? "Update Member" : "Add Member";
        var confirmButton = function (cfg_) {
            return $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6]), cfg_.h5, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.kW,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $rtfeldman$elm_css$Css$batch(cfg_.m)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg_.a_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg_.cd)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg_.eM)
            ])));
        };
        var borderStyles = $rtfeldman$elm_css$Css$batch(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
        ]));
        var nameInput = $author$project$Components$wrapWithLabel_fn({ jS: "Member Name", jT: "", jU: _List_Nil, m: _List_Nil }, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.fu.lb),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, model.ed),
            $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeR, $author$project$Components$TeamMemberEditorOverlay$setTeamMemberUsername(model.fu), $author$project$Components$TeamMemberEditorOverlay$InputUpdated)),
            $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, borderStyles]))
        ]), _List_Nil));
        var rolesCheckboxes = function () {
            var toCheckbox = function (name) {
                var isChecked = $elm$core$List$member_fn(name, model.fu.oG);
                var checkboxId = $elm$core$String$toLower(name) + "-role-checkbox";
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $rtfeldman$elm_css$Css$onlyChild(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_span_2]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, checkboxId),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, isChecked),
                        $rtfeldman$elm_css$Html$Styled$Events$onCheck(function (_v0) {
                            return $author$project$Components$TeamMemberEditorOverlay$InputUpdated($author$project$Components$TeamMemberEditorOverlay$toggleTeamMemberRole_fn(model.fu, name));
                        })
                    ]), _List_Nil),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, checkboxId),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$capitalize]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(name)
                    ]))
                ]));
            };
            return $author$project$Components$wrapWithLabel_fn({ jS: "Roles", jT: "", jU: _List_Nil, m: _List_Nil }, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_12, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, borderStyles]))
            ]), _List_fromArray([
                toCheckbox("admin")
            ])));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(model.gd, A3($author$project$Components$backdrop, "member-editor", $elm$core$Maybe$Just($author$project$Components$TeamMemberEditorOverlay$BackdropClicked), _List_fromArray([
            $author$project$Overlay$view_fn($elm$core$Basics$identity, model.aE),
            toDialog(_List_fromArray([
                toolbar,
                toContent(_List_fromArray([
                    nameInput,
                    rolesCheckboxes,
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                    ]), _List_fromArray([
                        $author$project$Components$textButton_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]), "Cancel", $author$project$Components$TeamMemberEditorOverlay$Closed),
                        confirmButton({
                            cd: $author$project$Components$TeamMemberEditorOverlay$isInvalidEdit(model) || ($author$project$Components$TeamMemberEditorOverlay$unchanged(model) || model.la),
                            a_: $author$project$Components$TeamMemberEditorOverlay$Applied,
                            h5: model.la,
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12]),
                            eM: submitButtonTitle
                        })
                    ]))
                ]))
            ]))
        ])));
    };
    var $author$project$Components$TeamMemberEditorOverlay$initOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$showCentered_fn($author$project$Components$TeamMemberEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$TeamMemberEditorOverlay$setUpdating_fn = function (updating, model) {
        return _Utils_update(model, { la: updating });
    }, $author$project$Components$TeamMemberEditorOverlay$setUpdating = F2($author$project$Components$TeamMemberEditorOverlay$setUpdating_fn);
    var $author$project$Components$TeamMemberEditorOverlay$updateOverlay = function (model) {
        return _Utils_update(model, {
            a$: $author$project$Overlay$updateView_fn($author$project$Components$TeamMemberEditorOverlay$editorView(model), model.a$)
        });
    };
    var $author$project$Components$TeamMemberEditorOverlay$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$initOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 1:
                return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                if ($author$project$Components$TeamMemberEditorOverlay$unchanged(model)) {
                    return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
                }
                else {
                    var dialog = $author$project$Components$confirmDialogSimple({ lL: $elm$core$Maybe$Nothing, iU: $elm$core$Maybe$Nothing, no: "All changes will be lost.", ek: $author$project$Components$TeamMemberEditorOverlay$CloseDialog, hG: $author$project$Components$TeamMemberEditorOverlay$Closed });
                    return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, {
                        aE: $author$project$Overlay$showCentered_fn(dialog, model.aE)
                    }), $elm$core$Platform$Cmd$none));
                }
            case 3:
                return $author$project$Components$TeamMemberEditorOverlay$unchanged(model) ? $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$closeOverlay, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : ($author$project$Components$TeamMemberEditorOverlay$isInvalidEdit(model) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $author$project$Util$withCmd_fn(A2(model.bC, model.fu, $author$project$Components$TeamMemberEditorOverlay$Responded), $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$setUpdating(true), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
            case 4:
                var response = msg.a;
                if (!response.$) {
                    var object = response.a;
                    return $author$project$Util$withCmd_fn(model.fM(object), $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$closeOverlay, $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
                else {
                    var errors = response.a;
                    return $author$project$Util$withCmd_fn(model.nT(errors), $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$updateOverlay, $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$setUpdating(false), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
                }
            case 7:
                var input = msg.a;
                return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, { fu: input }), $elm$core$Platform$Cmd$none));
            case 8:
                return $author$project$Util$withModel_fn($author$project$Components$TeamMemberEditorOverlay$updateOverlay, _Utils_Tuple2(_Utils_update(model, {
                    aE: $author$project$Overlay$clear(model.aE)
                }), $elm$core$Platform$Cmd$none));
            case 5:
                var overlayMsg = msg.a;
                var _v2 = $author$project$Overlay$update_fn(overlayMsg, model.a$);
                var overlay = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
            default:
                var subMsg = msg.a;
                var _v3 = $author$project$Overlay$update_fn(subMsg, model.aE);
                var overlay = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { aE: overlay }), _Platform_map_fn(model.gd, cmd));
        }
    }, $author$project$Components$TeamMemberEditorOverlay$update = F2($author$project$Components$TeamMemberEditorOverlay$update_fn);
    var $author$project$Pages$Teams$Settings$upsertTeamMember_fn = function (member, members) {
        var isEdit = $elm$core$List$any_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.lb;
        }, $elm$core$Basics$eq(member.lb)), members);
        return isEdit ? $elm_community$list_extra$List$Extra$updateIf_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.lb;
        }, $elm$core$Basics$eq(member.lb)), $elm$core$Basics$always(member), members) : _List_Cons(member, members);
    }, $author$project$Pages$Teams$Settings$upsertTeamMember = F2($author$project$Pages$Teams$Settings$upsertTeamMember_fn);
    var $author$project$Pages$Teams$Settings$update_fn = function (cfg, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var maybeTeam = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, function (team) {
                    return $elm$core$Platform$Cmd$batch($elm$core$List$map_fn($elm$core$Platform$Cmd$map(cfg.gd), _List_fromArray([
                        $author$project$Api$getApiTokens_fn($author$project$Pages$Teams$Settings$TokensReceived, shared.k2, team),
                        $author$project$Api$getTeamMembers_fn($author$project$Pages$Teams$Settings$TeamMembersReceived, shared.k2, team)
                    ])));
                }, maybeTeam));
            case 1:
                var team = msg.a;
                var maybeToken = msg.b;
                var request = _Utils_eq(maybeToken, $elm$core$Maybe$Nothing) ? $author$project$Api$createApiToken : $author$project$Api$editApiToken;
                var tokenEditor = $author$project$Components$ApiTokenEditorOverlay$init({
                    bC: F2(function (state, toResponseMsg) {
                        return A4(request, A2($elm$core$Basics$composeR, toResponseMsg, $author$project$Pages$Teams$Settings$TokenEditorOverlayMsg), shared.k2, team.M, state);
                    }),
                    nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TokenReceived, $author$project$Util$msgCmd)),
                    fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TokenReceived, $author$project$Util$msgCmd)),
                    gd: $author$project$Pages$Teams$Settings$TokenEditorOverlayMsg,
                    k2: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Types$ApiTokenEdit$fromTeam(team), $author$project$Types$ApiTokenEdit$fromApiToken, maybeToken)
                });
                return _Utils_Tuple2(_Utils_update(model, {
                    cF: $elm$core$Maybe$Just(tokenEditor)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$Settings$TokenEditorOverlayMsg($author$project$Components$ApiTokenEditorOverlay$Opened))));
            case 2:
                var subMsg = msg.a;
                var _v1 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$ApiTokenEditorOverlay$update(subMsg), model.cF)));
                var tokenEditor = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, { cF: tokenEditor }), _Platform_map_fn(cfg.gd, cmd));
            case 3:
                var team = msg.a;
                var subMsg = msg.b;
                var teamNameRequester = function (_v3) {
                    return $author$project$Components$InputRequester$init({
                        ln: "Rename",
                        bC: F2(function (state, inputReqMsg) {
                            return $author$project$Api$renameTeam_fn(A2($elm$core$Basics$composeR, inputReqMsg, $author$project$Pages$Teams$Settings$TeamNameRequesterMsg(team)), shared.k2, team, state);
                        }),
                        nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamRenamed(team), $author$project$Util$msgCmd)),
                        fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamRenamed(team), $author$project$Util$msgCmd)),
                        kt: $elm$core$Maybe$Just($author$project$Config$teamNameRegex),
                        df: "Team Name",
                        gd: $author$project$Pages$Teams$Settings$TeamNameRequesterMsg(team)
                    });
                };
                var _v2 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn(teamNameRequester(0), model.dn));
                var inputRequester = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    dn: $elm$core$Maybe$Just(inputRequester),
                    bo: model.bo || inputRequester.la
                }), _Platform_map_fn(cfg.gd, cmd));
            case 4:
                if (!msg.a.$) {
                    var tokens = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        ps: $krisajenkins$remotedata$RemoteData$Success(tokens)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        ps: $krisajenkins$remotedata$RemoteData$Failure(errors)
                    }), $elm$core$Platform$Cmd$none);
                }
            case 5:
                if (!msg.a.$) {
                    var token = msg.a.a;
                    var edit = _Utils_eq(token.d, $elm$core$Maybe$Nothing);
                    var _v4 = edit ? _Utils_Tuple2(A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
                        return $.bR;
                    }, $elm$core$Basics$eq(token.bR)), $elm$core$Basics$always(token)), $elm$core$Maybe$Nothing) : _Utils_Tuple2(A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([token])), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$tokenCreateSuccessDialog(token), A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, cfg.oR)), token.d));
                    var mapTokens = _v4.a;
                    var maybeShowCreatedTokenCmd = _v4.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        cF: $elm$core$Maybe$Nothing,
                        ps: $krisajenkins$remotedata$RemoteData$map_fn(mapTokens, model.ps)
                    }), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, maybeShowCreatedTokenCmd));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(model, A2(cfg.nT, $elm$core$Maybe$Just("Failed upserting token"), errors));
                }
            case 6:
                var token = msg.a;
                return _Utils_Tuple2(model, cfg.oR($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", cfg.gd($author$project$Pages$Teams$Settings$DeleteToken(token)), $author$project$Components$ConfirmDialog$ApiTokenContext(token)))));
            case 7:
                var token = msg.a;
                return _Utils_Tuple2(model, $author$project$Api$deleteApiToken_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$DeletedToken, cfg.gd), shared.k2, token));
            case 8:
                if (!msg.a.$) {
                    var token = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        ps: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$remove(token), model.ps)
                    }), cfg.oR($elm$core$Maybe$Nothing));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2(cfg.nT, $elm$core$Maybe$Just("Failed deleting token"), errors),
                        cfg.oR($elm$core$Maybe$Nothing)
                    ])));
                }
            case 9:
                var team = msg.a;
                return _Utils_Tuple2(model, cfg.oR($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", cfg.gd($author$project$Pages$Teams$Settings$TeamDeletionConfirmed(team)), $author$project$Components$ConfirmDialog$TeamContext(team)))));
            case 10:
                var team = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { bo: true }), $author$project$Api$deleteTeam_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamDeleted, cfg.gd), shared.k2, team));
            case 11:
                if (!msg.a.$) {
                    var team = msg.a.a;
                    return _Utils_Tuple2($author$project$Pages$Teams$Settings$init, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cfg.n3(team),
                        cfg.ge($author$project$Shared$RouteReplace($author$project$Route$Teams($author$project$Pages$Teams$Route$Teams))),
                        cfg.oR($elm$core$Maybe$Nothing)
                    ])));
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { bo: false }), A2(cfg.nT, $elm$core$Maybe$Just("Failed deleting team"), errors));
                }
            case 12:
                if (!msg.b.$) {
                    var oldTeam = msg.a;
                    var renamedTeam = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { bo: false }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cfg.ge($author$project$Shared$RouteReplace($author$project$Route$Teams($author$project$Pages$Teams$Route$Settings(renamedTeam.M)))),
                        A2(cfg.n4, oldTeam, renamedTeam)
                    ])));
                }
                else {
                    var errors = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { bo: false }), A2(cfg.nT, $elm$core$Maybe$Just("Failed renaming team"), errors));
                }
            case 13:
                var team = msg.a;
                var maybeTeamMember = msg.b;
                var request = _Utils_eq(maybeTeamMember, $elm$core$Maybe$Nothing) ? $author$project$Api$addTeamMember : $author$project$Api$editTeamMember;
                var teamMemberEditor = $author$project$Components$TeamMemberEditorOverlay$init({
                    ed: !_Utils_eq(maybeTeamMember, $elm$core$Maybe$Nothing),
                    bC: F2(function (teamMember, toResponseMsg) {
                        return A4(request, A2($elm$core$Basics$composeR, toResponseMsg, $author$project$Pages$Teams$Settings$TeamMemberEditorOverlayMsg), shared.k2, team, teamMember);
                    }),
                    nT: A2($elm$core$Basics$composeR, $author$project$Api$Response$Failure, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamMemberReceived, $author$project$Util$msgCmd)),
                    fM: A2($elm$core$Basics$composeR, $author$project$Api$Response$Success, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamMemberReceived, $author$project$Util$msgCmd)),
                    k$: $elm$core$Maybe$withDefault_fn($author$project$Types$Team$TeamMember$TeamMember_fn("", _List_Nil), maybeTeamMember),
                    gd: $author$project$Pages$Teams$Settings$TeamMemberEditorOverlayMsg
                });
                return _Utils_Tuple2(_Utils_update(model, {
                    b4: $elm$core$Maybe$Just(teamMemberEditor)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$Settings$TeamMemberEditorOverlayMsg($author$project$Components$TeamMemberEditorOverlay$Opened))));
            case 16:
                var response = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bn: $author$project$Api$Response$toRemoteData(response)
                }), $elm$core$Platform$Cmd$none);
            case 15:
                if (!msg.a.$) {
                    var teamMember = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        b4: $elm$core$Maybe$Nothing,
                        bn: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Pages$Teams$Settings$upsertTeamMember(teamMember), model.bn)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = msg.a.a;
                    return _Utils_Tuple2(_Utils_update(model, { b4: $elm$core$Maybe$Nothing }), A2(cfg.nT, $elm$core$Maybe$Just("Failed upserting member"), errors));
                }
            case 14:
                var subMsg = msg.a;
                var _v5 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($elm$core$Tuple$mapFirst($elm$core$Maybe$Just), $elm$core$Maybe$map_fn($author$project$Components$TeamMemberEditorOverlay$update(subMsg), model.b4)));
                var teamMemberEditor = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple2(_Utils_update(model, { b4: teamMemberEditor }), _Platform_map_fn(cfg.gd, cmd));
            case 17:
                var team = msg.a;
                var teamMember = msg.b;
                return _Utils_Tuple2(model, cfg.oR($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialogSimple({
                    lL: $elm$core$Maybe$Nothing,
                    iU: $elm$core$Maybe$Nothing,
                    no: "Removing this team member will revoke their access" + " to all databases in this team.",
                    hG: cfg.gd($author$project$Pages$Teams$Settings$TeamMemberRemovalConfirmed_fn(team, teamMember))
                }))));
            case 18:
                var team = msg.a;
                var teamMember = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    bn: $krisajenkins$remotedata$RemoteData$map_fn($elm_community$list_extra$List$Extra$remove(teamMember), model.bn)
                }), $author$project$Api$removeTeamMember_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$TeamMemberRemoved(model.bn), cfg.gd), shared.k2, team, teamMember));
            default:
                if (!msg.b.$) {
                    return _Utils_Tuple2(model, cfg.oR($elm$core$Maybe$Nothing));
                }
                else {
                    var teamMembersBackup = msg.a;
                    var errors = msg.b.a;
                    return _Utils_Tuple2(_Utils_update(model, { bn: teamMembersBackup }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2(cfg.nT, $elm$core$Maybe$Just("Failed removing member"), errors),
                        cfg.oR($elm$core$Maybe$Nothing)
                    ])));
                }
        }
    }, $author$project$Pages$Teams$Settings$update = F4($author$project$Pages$Teams$Settings$update_fn);
    var $author$project$Pages$Teams$Tokens$TokenReceived = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Api$getApiToken_fn = function (msg, maybeToken, apiTokenId) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$emptyBody,
            e: A2($author$project$Api$expect, msg, $author$project$Types$ApiToken$decode),
            f: "GET",
            g: _String_append_fn("/api/tokens/", $elm$core$String$fromInt($author$project$Types$ApiToken$idToInt(apiTokenId)))
        });
    }, $author$project$Api$getApiToken = F3($author$project$Api$getApiToken_fn);
    var $author$project$Pages$Teams$Tokens$update_fn = function (cfg, msg, shared, model) {
        if (!msg.$) {
            var tokenId = msg.a;
            var maybeToken = msg.b;
            var token = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$Success, maybeToken);
            var getTokenCmd = _Utils_eq(maybeToken, $elm$core$Maybe$Nothing) ? $author$project$Api$getApiToken_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Tokens$TokenReceived, cfg.gd), shared.k2, tokenId) : $elm$core$Platform$Cmd$none;
            return _Utils_Tuple2(_Utils_update(model, { k2: token }), getTokenCmd);
        }
        else {
            var response = msg.a;
            return _Utils_Tuple2(_Utils_update(model, {
                k2: $author$project$Api$Response$toRemoteData(response)
            }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Pages$Teams$Tokens$update = F4($author$project$Pages$Teams$Tokens$update_fn);
    var $author$project$Overlay$withPositionBelow_a0 = $author$project$Overlay$positionMapperBelow, $author$project$Overlay$withPositionBelow = $author$project$Overlay$withPositionMapper($author$project$Overlay$withPositionBelow_a0);
    var $author$project$Pages$Teams$update_fn = function (cfg, user, msg, shared, model) {
        switch (msg.$) {
            case 0:
                var subRoute = msg.a;
                var maybeTeamName = $author$project$Pages$Teams$Route$toTeamName(subRoute);
                var maybeTeam = $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.M;
                }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(maybeTeamName))), user.pc);
                var hydrateTeamsCmd = function () {
                    var teamsToHydrate = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(user.pc, $elm$core$List$singleton, maybeTeam);
                    return $elm$core$Platform$Cmd$batch($elm$core$List$map_fn(cfg.m7, $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $krisajenkins$remotedata$RemoteData$isLoading), function ($) {
                        return $.l1;
                    }), $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $krisajenkins$remotedata$RemoteData$isSuccess), function ($) {
                        return $.l1;
                    }), teamsToHydrate))));
                }();
                switch (subRoute.$) {
                    case 0:
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 1:
                        return _Utils_Tuple2(model, hydrateTeamsCmd);
                    case 2:
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            hydrateTeamsCmd,
                            $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$SettingsPageMsg($author$project$Pages$Teams$Settings$Routed(maybeTeam))))
                        ])));
                    case 3:
                        return _Utils_Tuple2(model, hydrateTeamsCmd);
                    default:
                        var tokenId = subRoute.b;
                        var maybeTokenFromSettingsState = $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
                            return $.bR;
                        }, $elm$core$Basics$eq(tokenId)), $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, model.hY.ps));
                        return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$TokensPageMsg($author$project$Pages$Teams$Tokens$Routed_fn(tokenId, maybeTokenFromSettingsState)))));
                }
            case 1:
                var subMsg = msg.a;
                var _v2 = $author$project$Pages$Teams$Settings$update_fn({
                    nT: cfg.nT,
                    n3: cfg.n3,
                    n4: F2(function (old, _new) {
                        return $elm$core$Platform$Cmd$batch(_List_fromArray([
                            cfg.n2(_new),
                            cfg.n3(old)
                        ]));
                    }),
                    oR: cfg.oR,
                    gd: A2($elm$core$Basics$composeR, $author$project$Pages$Teams$SettingsPageMsg, cfg.gd),
                    ge: cfg.ge
                }, subMsg, shared, model.hY);
                var settingsModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, { hY: settingsModel }), cmd);
            case 20:
                var subMsg = msg.a;
                var _v3 = $author$project$Components$Billing$update_fn(subMsg, model.dO);
                var billingModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, { dO: billingModel }), cmd);
            case 2:
                var subMsg = msg.a;
                var _v4 = $author$project$Pages$Teams$Tokens$update_fn({
                    nT: cfg.nT,
                    gd: A2($elm$core$Basics$composeR, $author$project$Pages$Teams$TokensPageMsg, cfg.gd)
                }, subMsg, shared, model.eP);
                var tokensModel = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, { eP: tokensModel }), cmd);
            case 19:
                var route = msg.a;
                return _Utils_Tuple2(model, cfg.ge($author$project$Shared$RouteTo($author$project$Route$Teams(route))));
            case 3:
                var team = msg.a;
                return _Utils_Tuple2(model, cfg.iY(team));
            case 4:
                var team = msg.a;
                var aiPromptExpanded = msg.b;
                var overlay = $author$project$Components$InitialQueryEditorOverlay$init_fn($author$project$Pages$Teams$QueryEditorMsg, $author$project$Pages$Teams$OnUploaded, aiPromptExpanded, $elm$core$Maybe$Just(team), shared.k2);
                return _Utils_Tuple2(_Utils_update(model, {
                    bD: $elm$core$Maybe$Just(overlay)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$QueryEditorMsg($author$project$Components$AiEditorOverlay$Opened))));
            case 5:
                var team = msg.a;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$CreateFromEditor_fn(team, $elm$core$Maybe$Just(false)))));
            case 6:
                var team = msg.a;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, cfg.gd($author$project$Pages$Teams$CreateFromEditor_fn(team, $elm$core$Maybe$Nothing))));
            case 12:
                var fileType = msg.a;
                var team = msg.b;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A3(cfg.kl, 2, $author$project$Types$UploadType$Initial(fileType), $elm$core$Maybe$Just(team))));
            case 7:
                var team = msg.a;
                var databasesMenu = function () {
                    var unrestricted = $elm$core$Basics$composeR_fn($author$project$Types$Edition$notShared_a0, $author$project$Types$Edition$notShared_a1, shared.aQ.mx.ja) || $author$project$Types$Team$isPro(team);
                    var dbFromAiPrompt = shared.aQ.mx.i1;
                    return $author$project$Overlay$withPositionMapper_fn($author$project$Overlay$withPositionBelow_a0, $author$project$Overlay$popupMenu_fn(model.a$, $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                        $elm$core$Maybe$Just(_Utils_Tuple3("Create Empty", $author$project$Pages$Teams$CreateEmptyDB(team), false)),
                        $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v5) {
                            return dbFromAiPrompt;
                        }, $elm$core$Maybe$Just(_Utils_Tuple3("Create from SQL Query", $author$project$Pages$Teams$CreateFromQuery(team), false))),
                        $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v6) {
                            return dbFromAiPrompt;
                        }, $elm$core$Maybe$Just(_Utils_Tuple3("Create from AI Prompt", $author$project$Pages$Teams$CreateFromAIprompt(team), false))),
                        $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v7) {
                            return unrestricted;
                        }, $elm$core$Maybe$Just(_Utils_Tuple3("Upload SQLite File", $author$project$Pages$Teams$UploadFile_fn(0, team), false))),
                        $elm$core$Maybe$Just(_Utils_Tuple3("Upload CSV File", $author$project$Pages$Teams$UploadFile_fn(1, team), false))
                    ]))));
                }();
                return _Utils_Tuple2(_Utils_update(model, { a$: databasesMenu }), _Platform_map_fn(cfg.gd, $author$project$Overlay$setOrigin_fn($elm$core$Basics$identity, "create-database-button", databasesMenu)));
            case 8:
                var subMsg = msg.a;
                var _v8 = $author$project$Overlay$update_fn(subMsg, model.a$);
                var menu = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: menu }), _Platform_map_fn(cfg.gd, cmd));
            case 9:
                var subMsg = msg.a;
                var result = $elm$core$Maybe$map_fn($author$project$Components$AiEditorOverlay$update(subMsg), model.bD);
                return _Utils_Tuple2(_Utils_update(model, {
                    bD: $elm$core$Maybe$map_fn($elm$core$Tuple$first, result)
                }), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Platform$Cmd$map(cfg.gd)), result)));
            case 10:
                var subMsg = msg.a;
                var teamNameRequester = function (_v10) {
                    return $author$project$Components$InputRequester$init({
                        ln: "Create",
                        bC: F2(function (state, inputReqMsg) {
                            return $author$project$Api$createTeam_fn(A2($elm$core$Basics$composeR, inputReqMsg, $author$project$Pages$Teams$TeamNameRequesterMsg), shared.k2, state);
                        }),
                        nT: A2($elm$core$Basics$composeR, $elm$core$String$join("\n\n"), A2($elm$core$Basics$composeR, $elm$core$Tuple$pair("Error"), A2($elm$core$Basics$composeR, $author$project$Pages$Teams$ShowErrors, $author$project$Util$msgCmd))),
                        fM: A2($elm$core$Basics$composeR, $author$project$Pages$Teams$TeamCreated, $author$project$Util$msgCmd),
                        kt: $elm$core$Maybe$Just($author$project$Config$teamNameRegex),
                        df: "Team Name",
                        gd: $author$project$Pages$Teams$TeamNameRequesterMsg
                    });
                };
                var _v9 = $author$project$Components$InputRequester$update_fn(subMsg, $elm$core$Maybe$withDefault_fn(teamNameRequester(0), model.dn));
                var inputRequester = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    dn: $elm$core$Maybe$Just(inputRequester)
                }), _Platform_map_fn(cfg.gd, cmd));
            case 18:
                var team = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { dn: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cfg.ge($author$project$Shared$RouteTo($author$project$Route$Teams($author$project$Pages$Teams$Route$Overview(team.M)))),
                    cfg.n2(team)
                ])));
            case 11:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                var response = msg.c;
                var queryEditor = $author$project$Api$Response$isSuccess(response) ? $elm$core$Maybe$Nothing : model.bD;
                return _Utils_Tuple2(_Utils_update(model, { bD: queryEditor }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A4(cfg.ko, 2, uploadType, maybeTeam, response)));
            case 13:
                return _Utils_Tuple2(_Utils_update(model, { mR: true }), $elm$core$Platform$Cmd$none);
            case 14:
                return _Utils_Tuple2(_Utils_update(model, { mR: false }), $elm$core$Platform$Cmd$none);
            case 15:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A3(cfg.kl, 0, uploadType, maybeTeam)));
            case 16:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                var file = msg.c;
                return _Utils_Tuple2(_Utils_update(model, { mR: false }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, A4(cfg.kk, 0, uploadType, maybeTeam, file)));
            default:
                var _v11 = msg.a;
                var title = _v11.a;
                var error = _v11.b;
                return _Utils_Tuple2(model, A2(cfg.nT, $elm$core$Maybe$Just(title), _List_fromArray([error])));
        }
    }, $author$project$Pages$Teams$update = F5($author$project$Pages$Teams$update_fn);
    var $author$project$Pages$Trial$Responded = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Config$cloudRegions = _List_fromArray([
        { fx: "Amsterdam, Netherlands", t: "ams" },
        { fx: "Stockholm, Sweden", t: "arn" },
        { fx: "Bogot\u00E1, Colombia", t: "bog" },
        { fx: "Boston, Massachusetts (US)", t: "bos" },
        { fx: "Paris, France", t: "cdg" },
        { fx: "Denver, Colorado (US)", t: "den" },
        { fx: "Dallas, Texas (US)", t: "dfw" },
        { fx: "Secaucus, NJ (US)", t: "ewr" },
        { fx: "Guadalajara, Mexico", t: "gdl" },
        { fx: "Rio de Janeiro, Brazil", t: "gig" },
        { fx: "Sao Paulo, Brazil", t: "gru" },
        { fx: "Hong Kong, Hong Kong", t: "hkg" },
        { fx: "Ashburn, Virginia (US)", t: "iad" },
        { fx: "Johannesburg, South Africa", t: "jnb" },
        { fx: "Los Angeles, California (US)", t: "lax" },
        { fx: "London, United Kingdom", t: "lhr" },
        { fx: "Madrid, Spain", t: "mad" },
        { fx: "Miami, Florida (US)", t: "mia" },
        { fx: "Tokyo, Japan", t: "nrt" },
        { fx: "Chicago, Illinois (US)", t: "ord" },
        { fx: "Bucharest, Romania", t: "otp" },
        { fx: "Quer\u00E9taro, Mexico", t: "qro" },
        { fx: "Santiago, Chile", t: "scl" },
        { fx: "Seattle, Washington (US)", t: "sea" },
        { fx: "Singapore, Singapore", t: "sin" },
        { fx: "San Jose, California (US)", t: "sjc" },
        { fx: "Sydney, Australia", t: "syd" },
        { fx: "Warsaw, Poland", t: "waw" },
        { fx: "Montreal, Canada", t: "yul" },
        { fx: "Toronto, Canada", t: "yyz" }
    ]);
    var $author$project$Pages$Trial$removeErrors = function (model) {
        return _Utils_update(model, { b2: $krisajenkins$remotedata$RemoteData$NotAsked });
    };
    var $author$project$Api$startTrial_fn = function (msg, maybeToken, subdomain, email, purpose, region) {
        return $author$project$Api$requestWithMaybeToken_fn(maybeToken, {
            d: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("subdomain", $elm$json$Json$Encode$string(subdomain)),
                _Utils_Tuple2("region", $elm$json$Json$Encode$string(region)),
                _Utils_Tuple2("email", $elm$json$Json$Encode$string(email)),
                _Utils_Tuple2("purpose", $elm$json$Json$Encode$string(purpose))
            ]))),
            e: A2($author$project$Api$expect, msg, $elm$json$Json$Decode$succeed(0)),
            f: "POST",
            g: "/api/trial"
        });
    }, $author$project$Api$startTrial = F6($author$project$Api$startTrial_fn);
    var $author$project$Pages$Trial$update_fn = function (msg, shared, model) {
        switch (msg.$) {
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                var subdomain = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Trial$removeErrors, _Utils_Tuple2(_Utils_update(model, { eE: subdomain }), $elm$core$Platform$Cmd$none));
            case 2:
                var region = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Trial$removeErrors, _Utils_Tuple2(_Utils_update(model, { es: region }), $elm$core$Platform$Cmd$none));
            case 3:
                var email = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Trial$removeErrors, _Utils_Tuple2(_Utils_update(model, { jb: email }), $elm$core$Platform$Cmd$none));
            case 4:
                var purpose = msg.a;
                return $author$project$Util$withModel_fn($author$project$Pages$Trial$removeErrors, _Utils_Tuple2(_Utils_update(model, { eq: purpose }), $elm$core$Platform$Cmd$none));
            case 5:
                return _Utils_Tuple2(_Utils_update(model, { b2: $krisajenkins$remotedata$RemoteData$Loading }), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A5($author$project$Api$startTrial, $author$project$Pages$Trial$Responded, shared.k2, model.eE, model.jb, model.eq), $elm$core$Maybe$map_fn(function ($) {
                    return $.t;
                }, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.fx;
                }, $elm$core$Basics$eq(model.es)), $author$project$Config$cloudRegions))));
            default:
                var response = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    b2: $author$project$Api$Response$toRemoteData(response)
                }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Pages$Trial$update = F3($author$project$Pages$Trial$update_fn);
    var $author$project$Pages$Users$routeToUserCmd = function (toSharedCmd) {
        return A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Route$Users, A2($elm$core$Basics$composeR, $author$project$Shared$RouteReplace, toSharedCmd))));
    };
    var $author$project$Pages$Users$update_fn = function (cfg, user, msg, model) {
        var maybeUsername = msg;
        return _Utils_eq(maybeUsername, $elm$core$Maybe$Nothing) ? $author$project$Util$withCmd_fn(A2($author$project$Pages$Users$routeToUserCmd, cfg.ge, user), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    }, $author$project$Pages$Users$update = F4($author$project$Pages$Users$update_fn);
    var $elm$browser$Browser$Navigation$back_fn = function (key, n) {
        return _Browser_go_fn(key, -n);
    }, $elm$browser$Browser$Navigation$back = F2($elm$browser$Browser$Navigation$back_fn);
    var $author$project$Ports$removeFromLocalStorage = _Platform_outgoingPort("removeFromLocalStorage", $elm$json$Json$Encode$string);
    var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
    var $author$project$Shared$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                var token = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    k2: $elm$core$Maybe$Just(token)
                }), $author$project$Ports$saveToLocalStorage({
                    jQ: "sessionToken",
                    pB: $elm$json$Json$Encode$string($author$project$Types$SessionToken$toString(token))
                }));
            case 1:
                return _Utils_Tuple2(_Utils_update(model, { k2: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, { k2: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$removeFromLocalStorage("username"),
                    $author$project$Ports$removeFromLocalStorage("sessionToken")
                ])));
            case 3:
                return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$back_fn(model.jQ, 1));
            case 4:
                var route = msg.a;
                return _Utils_eq(model.kx, $elm$core$Maybe$Just(route)) ? _Utils_Tuple2(model, $elm$browser$Browser$Navigation$back_fn(model.jQ, 1)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $elm$browser$Browser$Navigation$back_fn(model.jQ, 1),
                    _Browser_pushUrl_fn(model.jQ, $author$project$Route$toUrlPath(model.eu)),
                    _Browser_replaceUrl_fn(model.jQ, $author$project$Route$toUrlPath(route))
                ])));
            case 5:
                var route = msg.a;
                return _Utils_Tuple2(model, _Browser_pushUrl_fn(model.jQ, $author$project$Route$toUrlPath(route)));
            case 6:
                var route = msg.a;
                return _Utils_Tuple2(model, _Browser_replaceUrl_fn(model.jQ, $author$project$Route$toUrlPath(route)));
            default:
                return _Utils_Tuple2(model, _Browser_replaceUrl_fn(model.jQ, $author$project$Route$toUrlPath(model.eu)));
        }
    }, $author$project$Shared$update = F2($author$project$Shared$update_fn);
    var $elm$http$Http$stringPart = _Http_pair;
    var $author$project$Api$uploadDatabase_fn = function (msg, maybeToken, maybeTeam, file, maybeId) {
        return $elm$http$Http$request({
            d: $elm$http$Http$multipartBody($elm$core$List$append_fn(_List_fromArray([
                _Http_pair_fn("database", file)
            ]), $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn($elm$http$Http$stringPart("team"), $elm$core$Maybe$map_fn(function ($) {
                return $.M;
            }, maybeTeam))))),
            e: A2($author$project$Api$expect, msg, $author$project$Types$Database$decodeId),
            d9: $elm$core$Basics$composeR_fn($author$project$Api$headersFromMaybeToken_a0, $author$project$Api$headersFromMaybeToken_a1, maybeToken),
            f: "POST",
            eK: $elm$core$Maybe$Nothing,
            eQ: maybeId,
            g: "/dbs"
        });
    }, $author$project$Api$uploadDatabase = F5($author$project$Api$uploadDatabase_fn);
    var $author$project$Util$withMaybeMsg_fn = function (maybeMsg, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(model, cmd), A2($elm$core$Basics$composeR, $author$project$Util$msgCmd, A2($author$project$Util$flip, $author$project$Util$withCmd, _Utils_Tuple2(model, cmd))), maybeMsg);
    }, $author$project$Util$withMaybeMsg = F2($author$project$Util$withMaybeMsg_fn);
    var $author$project$Main$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                var urlRequest = msg.a;
                if (!urlRequest.$) {
                    var url = urlRequest.a;
                    return ($author$project$Route$isPlaygroundUrl(url) || ($author$project$Route$isDuplicateUrl(url) || $author$project$Route$isAppUrl(url))) ? _Utils_Tuple2(model, $elm$browser$Browser$Navigation$load($elm$url$Url$toString(url))) : _Utils_Tuple2(model, _Browser_pushUrl_fn(model.b.jQ, $elm$url$Url$toString(url)));
                }
                else {
                    var href = urlRequest.a;
                    return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$load(href));
                }
            case 1:
                var url = msg.a;
                return ($author$project$Route$isRegenerateDbIdRoute(model.b.eu) || $author$project$Route$isRegenerateReadonlyIdRoute(model.b.eu)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : $author$project$Util$withModel_fn($author$project$Main$handlePageChange, $author$project$Util$updateAndThen_fn($author$project$Main$handleUrlChange(url), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
            case 2:
                return _Utils_Tuple2($author$project$Model$reset(model), $elm$core$Platform$Cmd$none);
            case 3:
                var time = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { pf: time }), $elm$core$Platform$Cmd$none);
            case 4:
                var text = msg.a;
                return $author$project$Util$withModel_fn($author$project$Model$mapOverlay($author$project$Overlay$addTextNotification(text)), _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 5:
                var uploadType = msg.a;
                var maybeTeam = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    a3: $elm$core$Maybe$Just($author$project$Types$Upload$setProgress_fn(100, $author$project$Types$Upload$init_fn($elm$core$Maybe$Nothing, uploadType)))
                }), $author$project$Api$createDatabase_fn(A3($author$project$Msg$Uploaded, 0, uploadType, maybeTeam), model.b.k2, maybeTeam, $author$project$Types$UploadType$toQuery(uploadType), "New Database"));
            case 6:
                var errorDisplay = msg.a;
                var uploadType = msg.b;
                var maybeTeam = msg.c;
                var mimes = $author$project$Types$UploadType$toMimes(uploadType);
                return _Utils_Tuple2(model, $elm$file$File$Select$file_fn(mimes, A3($author$project$Msg$GotFile, errorDisplay, uploadType, maybeTeam)));
            case 35:
                var maybeDialog = msg.a;
                return _Utils_Tuple2(_Utils_update(model, { mc: maybeDialog }), $elm$core$Platform$Cmd$none);
            case 7:
                var errorDisplay = msg.a;
                var uploadType = msg.b;
                var maybeTeam = msg.c;
                var file = msg.d;
                var maybeUploadId = $elm$core$Maybe$Just("database-upload");
                var maxDbSize = _Utils_eq($elm$core$Maybe$map_fn($author$project$Types$Team$isPro, maybeTeam), $elm$core$Maybe$Just(true)) ? $author$project$Config$pro.fD : model.b.aQ.fD;
                var _v2 = (_Utils_cmp($elm$file$File$size(file), maxDbSize * 1000000) > 0) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just("Upload can't be larger than " + ($elm$core$String$fromInt(maxDbSize) + " MB"))) : _Utils_Tuple2($elm$core$Maybe$Just($author$project$Types$Upload$init_fn(maybeUploadId, uploadType)), $elm$core$Maybe$Nothing);
                var maybeUpload = _v2.a;
                var maybeUploadError = _v2.b;
                var uploadCmd = function () {
                    var _v3 = $elm$core$Maybe$map_fn(function ($) {
                        return $.gh;
                    }, maybeUpload);
                    _v3$2: while (true) {
                        if (!_v3.$) {
                            switch (_v3.a.$) {
                                case 2:
                                    var fileType = _v3.a.a;
                                    return $author$project$Api$uploadDatabase_fn(A3($author$project$Msg$Uploaded, errorDisplay, $author$project$Types$UploadType$Initial(fileType), maybeTeam), model.b.k2, maybeTeam, file, maybeUploadId);
                                case 3:
                                    var fileType = _v3.a.a;
                                    return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A4($author$project$Api$replaceDatabase, A3($author$project$Msg$Uploaded, errorDisplay, $author$project$Types$UploadType$Replacement(fileType), maybeTeam), model.b.k2, file, maybeUploadId), $author$project$Route$getDatabaseId(model.b.eu));
                                default:
                                    break _v3$2;
                            }
                        }
                        else {
                            break _v3$2;
                        }
                    }
                    return $elm$core$Platform$Cmd$none;
                }();
                var displayUploadErrorCmd = $elm$core$Maybe$map_fn($author$project$Msg$errorDisplayCmd_fn(errorDisplay, "Upload Error"), $elm$core$Maybe$map_fn($elm$core$List$singleton, maybeUploadError));
                return _Utils_Tuple2(_Utils_update(model, {
                    bF: $elm_community$maybe_extra$Maybe$Extra$toList(maybeUploadError),
                    a3: maybeUpload
                }), $elm$core$Maybe$withDefault_fn(uploadCmd, displayUploadErrorCmd));
            case 8:
                var progress = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    a3: $elm$core$Maybe$map2_fn($author$project$Types$Upload$setProgress, $author$project$Util$httpProgressToPercent(progress), model.a3)
                }), $elm$core$Platform$Cmd$none);
            case 9:
                if (msg.d.$ === 1) {
                    var errorDisplay = msg.a;
                    var errors = msg.d.a;
                    var uploadErrors = (!errorDisplay) ? errors : _List_Nil;
                    var displayUploadErrorCmd = A3($author$project$Msg$errorDisplayCmd, errorDisplay, "Error", errors);
                    return _Utils_Tuple2(_Utils_update(model, { bF: uploadErrors, a3: $elm$core$Maybe$Nothing }), $author$project$Util$cmdOr_fn($author$project$Main$onError_fn($elm$core$Maybe$Nothing, errors), displayUploadErrorCmd));
                }
                else {
                    var uploadType = msg.b;
                    var maybeTeam = msg.c;
                    var id = msg.d.a;
                    var routeToDatabaseCmd = $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteTo($author$project$Route$Database(id)));
                    var refetchTeamCmd = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, $author$project$Msg$TeamHydratedRequested, $author$project$Util$msgCmd), maybeTeam);
                    var addBookmarkNotificationCmd = (_Utils_eq($author$project$Types$Database$unwrapId(id), $author$project$Config$exampleDbId) || ($author$project$Types$UploadType$isReplacement(uploadType) || (!_Utils_eq(maybeTeam, $elm$core$Maybe$Nothing)))) ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$AddTextNotification("\n                        Please bookmark this page to be\n                        able to access it in the future\n                        "));
                    return $author$project$Util$withCmd_fn(addBookmarkNotificationCmd, $author$project$Util$withCmd_fn(refetchTeamCmd, $author$project$Util$withCmd_fn(routeToDatabaseCmd, $author$project$Util$withModel_fn($author$project$Model$setUploaded, $author$project$Util$withModel_fn($author$project$Model$reset, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))))));
                }
            case 44:
                var team = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    p: $elm$core$Maybe$map_fn($author$project$Types$User$addTeam(team), model.p)
                }), $elm$core$Platform$Cmd$none);
            case 45:
                var teamName = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    p: $elm$core$Maybe$map_fn($author$project$Types$User$removeTeam(teamName), model.p)
                }), $elm$core$Platform$Cmd$none);
            case 46:
                var team = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    p: $elm$core$Maybe$map_fn(A2($author$project$Types$User$mapTeam, team.M, $author$project$Types$Team$setDatabasesLoading), model.p)
                }), $author$project$Api$getTeam_fn($author$project$Msg$TeamHydratedReceived(team), model.b.k2, team.M));
            case 47:
                var team = msg.a;
                var response = msg.b;
                if (!response.$) {
                    var teamHydrated = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        p: $elm$core$Maybe$map_fn(A2($author$project$Types$User$mapTeam, team.M, $elm$core$Basics$always(teamHydrated)), model.p)
                    }), $elm$core$Platform$Cmd$none);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        p: $elm$core$Maybe$map_fn(A2($author$project$Types$User$mapTeam, team.M, $author$project$Types$Team$setDatabasesFailure(errors)), model.p)
                    }), $author$project$Main$onError_fn($elm$core$Maybe$Nothing, errors));
                }
            case 48:
                var db = msg.a;
                return _Utils_Tuple2(model, $author$project$Api$deleteDatabase_fn($author$project$Msg$DatabaseDeletionResponded, model.b.k2, db.bR));
            case 49:
                var response = msg.a;
                if (!response.$) {
                    var dbId = response.a;
                    var findTeamWithDeletedDb = function (teams) {
                        return $elm$core$Maybe$map_fn($author$project$Types$Team$mapDatabases($elm$core$List$filter(A2($elm$core$Basics$composeR, function ($) {
                            return $.bR;
                        }, $elm$core$Basics$neq(dbId)))), $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
                            return $.l1;
                        }, A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$withDefault(_List_Nil), $elm$core$List$any(A2($elm$core$Basics$composeR, function ($) {
                            return $.bR;
                        }, $elm$core$Basics$eq(dbId))))), teams));
                    };
                    var userWithUpdatedTeam = $elm$core$Maybe$map_fn(function (user) {
                        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(user, function (team) {
                            return $author$project$Types$User$mapTeam_fn(team.M, $elm$core$Basics$always(team), user);
                        }, findTeamWithDeletedDb(user.pc));
                    }, model.p);
                    var _v6 = $author$project$Types$Database$hasId_fn(dbId, model.j) ? _Utils_Tuple2($krisajenkins$remotedata$RemoteData$NotAsked, $elm$core$Basics$composeR_fn($author$project$Types$Database$toOwner_a0, $author$project$Types$Database$toOwner_a1, model.j)) : _Utils_Tuple2(model.j, $elm$core$Maybe$Nothing);
                    var database = _v6.a;
                    var maybeOwner = _v6.b;
                    var routeCmd = _Utils_eq(model.p, $elm$core$Maybe$Nothing) ? $elm$browser$Browser$Navigation$load("/") : $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteTo($author$project$Route$Teams($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Pages$Teams$Route$Teams, $author$project$Pages$Teams$Route$Overview, maybeOwner))));
                    return _Utils_Tuple2(_Utils_update(model, { j: database, mc: $elm$core$Maybe$Nothing, p: userWithUpdatedTeam }), routeCmd);
                }
                else {
                    var errors = response.a;
                    return _Utils_Tuple2(model, $author$project$Main$onError_fn($elm$core$Maybe$Just("Failed to delete database"), errors));
                }
            case 10:
                var database = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    p: $elm$core$Maybe$map_fn($author$project$Types$User$mapTeams($author$project$Types$Team$mapDatabases(A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
                        return $.bR;
                    }, $elm$core$Basics$eq(database.bR)), function (teamDatabase) {
                        return _Utils_update(teamDatabase, { M: database.mw });
                    }))), model.p)
                }), $elm$core$Platform$Cmd$none);
            case 11:
                var visibility = msg.a;
                var database = msg.b;
                return _Utils_Tuple2(model, $author$project$Api$setDatabaseSettings_fn($author$project$Msg$DatabaseSettingsReceived, model.b.k2, database.bR, $author$project$Types$DatabaseSettings$setVisibility_fn(visibility, database.kR)));
            case 12:
                var response = msg.a;
                return $author$project$Util$withModel_fn($author$project$Model$closeDialog, function () {
                    if (!response.$) {
                        var databaseSettings = response.a;
                        return _Utils_Tuple2(model, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$DatabaseSettingsStateUpdated(databaseSettings)));
                    }
                    else {
                        var errors = response.a;
                        return _Utils_Tuple2(model, $author$project$Main$onError_fn($elm$core$Maybe$Nothing, errors));
                    }
                }());
            case 13:
                var databaseSettings = msg.a;
                var maybeDbId = $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, model.j);
                return _Utils_Tuple2(_Utils_update(model, {
                    j: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Types$Database$setSettings(databaseSettings), model.j),
                    p: $elm$core$Maybe$map_fn($author$project$Types$User$mapTeams($author$project$Types$Team$mapDatabases(A2($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, function ($) {
                        return $.bR;
                    }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(maybeDbId))), $author$project$Types$Team$TeamDatabase$applyDatabaseSettings(databaseSettings)))), model.p)
                }), $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$TablesPageMsgReceived($author$project$Pages$Tables$DataLoaded)));
            case 14:
                var callBack = msg.a;
                var dbId = msg.b;
                var owner = msg.c;
                return _Utils_Tuple2(model, $author$project$Api$setOwner_fn(A2($author$project$Msg$DatabaseOwnerReceived, callBack, dbId), model.b.k2, owner, dbId));
            case 15:
                var callBack = msg.a;
                var dbId = msg.b;
                var response = msg.c;
                var maybeDatabaseRefetchMsg = function () {
                    var databaseNeedsRefetchWithOwner = $krisajenkins$remotedata$RemoteData$isFailure(model.j);
                    return databaseNeedsRefetchWithOwner ? $elm$core$Maybe$Just($author$project$Msg$DatabaseRequested_fn($elm$core$Maybe$Nothing, dbId)) : $elm$core$Maybe$Nothing;
                }();
                return $author$project$Util$withMaybeMsg_fn(maybeDatabaseRefetchMsg, $author$project$Util$withCmd_fn($elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, callBack), function () {
                    if (!response.$) {
                        var owner = response.a;
                        var user = function () {
                            var updateNewOwner = A2($author$project$Types$User$mapTeam, owner, A2($elm$core$Basics$composeR, $author$project$Types$Team$setDatabasesNotAsked, $author$project$Types$Team$increaseDatabaseCount));
                            var maybePreviousOwner = $elm$core$Basics$composeR_fn($author$project$Types$Database$toOwner_a0, $author$project$Types$Database$toOwner_a1, model.j);
                            var updatePreviousOwner = function () {
                                if (maybePreviousOwner.$ === 1) {
                                    return $elm$core$Basics$identity;
                                }
                                else {
                                    var previousOwner = maybePreviousOwner.a;
                                    return A2($author$project$Types$User$mapTeam, previousOwner, $author$project$Types$Team$removeDatabase(dbId));
                                }
                            }();
                            return $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, updatePreviousOwner, updateNewOwner), model.p);
                        }();
                        var database = A2($author$project$Types$Database$setOwner, owner, model.j);
                        return _Utils_Tuple2(_Utils_update(model, { j: database, p: user }), $elm$core$Platform$Cmd$none);
                    }
                    else {
                        var errors = response.a;
                        return _Utils_Tuple2(model, $author$project$Main$onError_fn($elm$core$Maybe$Just("Error"), errors));
                    }
                }()));
            case 16:
                var maybeSuccessMsg = msg.a;
                var id = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    j: _Utils_eq(model.j, $krisajenkins$remotedata$RemoteData$NotAsked) ? $krisajenkins$remotedata$RemoteData$Loading : model.j
                }), $author$project$Api$getDatabaseSchema_fn(A2($author$project$Msg$GotDbData, maybeSuccessMsg, model.j), model.b.k2, id));
            case 17:
                var maybeSuccessMsg = msg.a;
                var databaseOld = msg.b;
                var response = msg.c;
                if (!response.$) {
                    var databaseNew = response.a;
                    var merger = $krisajenkins$remotedata$RemoteData$unwrap_fn($elm$core$Basics$identity, $author$project$Types$Database$merge, databaseOld);
                    var database = $krisajenkins$remotedata$RemoteData$succeed(merger(databaseNew));
                    var modelNew = _Utils_update(model, { j: database });
                    return _Utils_Tuple2(modelNew, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, $author$project$Util$msgCmd, maybeSuccessMsg));
                }
                else {
                    var errors = response.a;
                    var assignDatabaseBannerDialog = function () {
                        var databaseIsExpired = $elm$core$List$any_fn($elm$core$String$contains("expired"), errors);
                        return databaseIsExpired ? $elm$core$Maybe$map_fn($author$project$Main$databaseAssignmentDialog(model), $author$project$Route$getDatabaseId(model.b.eu)) : $elm$core$Maybe$Nothing;
                    }();
                    return _Utils_Tuple2(_Utils_update(model, {
                        j: $krisajenkins$remotedata$RemoteData$Failure($elm$core$String$join_fn("\n", errors))
                    }), $elm$core$Maybe$withDefault_fn($author$project$Main$onError_fn($elm$core$Maybe$Nothing, errors), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Msg$SetDialog, $author$project$Util$msgCmd)), assignDatabaseBannerDialog)));
                }
            case 18:
                var affectedTables = msg.a;
                return _Utils_Tuple2(model, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Platform$Cmd$none, A2($elm$core$Basics$composeR, function ($) {
                    return $.bR;
                }, A2($elm$core$Basics$composeR, $author$project$Msg$DatabaseRequested($elm$core$Maybe$Just($author$project$Msg$RemoveTableCells(affectedTables))), $author$project$Util$msgCmd)), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.j)));
            case 19:
                var tables = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    j: A2($author$project$Types$Database$removeTableCells, tables, model.j)
                }), $elm$core$Platform$Cmd$none);
            case 37:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$load($author$project$Route$toUrlPathWithToken_fn($author$project$Route$RegenerateDbId(dbId), model.b.k2)));
            case 38:
                var dbId = msg.a;
                return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$load($author$project$Route$toUrlPathWithToken_fn($author$project$Route$RegenerateReadonlyId(dbId), model.b.k2)));
            case 20:
                var subMsg = msg.a;
                var _v11 = $author$project$Pages$Home$update_fn({
                    iY: A2($elm$core$Basics$composeR, $author$project$Msg$CreateDB($author$project$Types$UploadType$CreateEmpty), $author$project$Util$msgCmd),
                    nT: $author$project$Main$onError,
                    kk: $author$project$Msg$GotFile,
                    kl: $author$project$Msg$Pick,
                    ko: $author$project$Msg$Uploaded,
                    gd: $author$project$Msg$HomePageMsgReceived,
                    ge: $author$project$Msg$sharedCmd
                }, subMsg, model.b, model.g1);
                var pageModel = _v11.a;
                var pageCmd = _v11.b;
                return _Utils_Tuple2(_Utils_update(model, { g1: pageModel }), pageCmd);
            case 22:
                var subMsg = msg.a;
                var _v12 = $author$project$Pages$Database$update_fn($author$project$Main$onError, A2($elm$core$Basics$composeR, $author$project$Msg$DatabaseRenamed, $author$project$Util$msgCmd), $author$project$Msg$DatabaseOwnerSubmitted, $author$project$Msg$DatabasePageMsgReceived, subMsg, model.j, model.b, model.gF);
                var pageModel = _v12.a;
                var database = _v12.b;
                var pageCmd = _v12.c;
                return _Utils_Tuple2(_Utils_update(model, { j: database, gF: pageModel }), pageCmd);
            case 21:
                var subMsg = msg.a;
                var onEditView = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Basics$always($elm$core$Platform$Cmd$none), F2(function (dbId, table) {
                    return $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$QueriesPageMsgReceived($author$project$Pages$Queries$editViewMsg_fn(dbId, table))),
                        $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteTo($author$project$Route$Queries_fn(dbId, $elm$core$Maybe$Nothing)))
                    ]));
                }), $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, model.j));
                var _v13 = $author$project$Pages$Tables$update($author$project$Main$onError)(onEditView)(A2($elm$core$Basics$composeL, $author$project$Util$msgCmd, $author$project$Msg$SetDialog))($elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.j))($krisajenkins$remotedata$RemoteData$unwrap_fn(_List_Nil, function ($) {
                    return $.eH;
                }, model.j))($author$project$Msg$sharedCmd)($author$project$Msg$TablesPageMsgReceived)(subMsg)(model.p)(model.b)(model.eI);
                var pageModel = _v13.a;
                var tables = _v13.b;
                var pageCmd = _v13.c;
                return _Utils_Tuple2(_Utils_update(model, {
                    j: $krisajenkins$remotedata$RemoteData$map_fn($author$project$Types$Database$setTables(tables), model.j),
                    eI: pageModel
                }), pageCmd);
            case 23:
                var subMsg = msg.a;
                var _v14 = $author$project$Pages$Queries$update_fn($author$project$Main$onError, A2($elm$core$Basics$composeR, $author$project$Msg$TablesAffected, $author$project$Util$msgCmd), $author$project$Route$getDatabaseId(model.b.eu), $author$project$Msg$QueriesPageMsgReceived, subMsg, model.b, model.hQ);
                var pageModel = _v14.a;
                var pageCmd = _v14.b;
                return _Utils_Tuple2(_Utils_update(model, { hQ: pageModel }), pageCmd);
            case 24:
                var subMsg = msg.a;
                var _v15 = $author$project$Pages$Apps$update_fn($author$project$Main$onError, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$SetDialog($elm$core$Maybe$Nothing)), $author$project$Msg$sharedCmd, $author$project$Msg$AppsPageMsgReceived, subMsg, model.b, model.gp);
                var pageModel = _v15.a;
                var pageCmd = _v15.b;
                return _Utils_Tuple2(_Utils_update(model, { gp: pageModel }), pageCmd);
            case 25:
                var subMsg = msg.a;
                var _v16 = $author$project$Pages$Functions$update_fn($author$project$Main$onError, $elm$core$Basics$composeL_fn($author$project$Util$msgCmd_a0, $author$project$Util$msgCmd_a1, $author$project$Msg$SetDialog($elm$core$Maybe$Nothing)), $author$project$Route$getDatabaseId(model.b.eu), $author$project$Msg$sharedCmd, $author$project$Msg$FunctionsPageMsgReceived, subMsg, model.b, model.gW);
                var pageModel = _v16.a;
                var pageCmd = _v16.b;
                return _Utils_Tuple2(_Utils_update(model, { gW: pageModel }), pageCmd);
            case 36:
                var subMsg = msg.a;
                var _v17 = $author$project$Overlay$update_fn(subMsg, model.a$);
                var overlay = _v17.a;
                var cmd = _v17.b;
                return _Utils_Tuple2(_Utils_update(model, { a$: overlay }), cmd);
            case 26:
                var subMsg = msg.a;
                var requireTableCmd = $author$project$Main$requireTable(model);
                var _v18 = $author$project$Pages$Dashboards$update_fn({
                    ng: $elm$core$Basics$composeR_fn($author$project$Types$Database$toDatabaseId_a0, $author$project$Types$Database$toDatabaseId_a1, model.j),
                    nT: $author$project$Main$onError,
                    ov: requireTableCmd,
                    eu: $author$project$Route$getDashboardsRoute(model.b.eu),
                    eH: $krisajenkins$remotedata$RemoteData$unwrap_fn(_List_Nil, function ($) {
                        return $.eH;
                    }, model.j),
                    gd: $author$project$Msg$DashboardsPageMsgReceived,
                    ge: $author$project$Msg$sharedCmd
                }, subMsg, model.b, model.gD);
                var pageModel = _v18.a;
                var pageCmd = _v18.b;
                return _Utils_Tuple2(_Utils_update(model, { gD: pageModel }), pageCmd);
            case 27:
                var subMsg = msg.a;
                var _v19 = $author$project$Pages$Settings$update_fn($author$project$Main$onError, A2($elm$core$Basics$composeL, $author$project$Util$msgCmd, $author$project$Msg$SetDialog), A2($elm$core$Basics$composeL, $author$project$Util$msgCmd, $author$project$Msg$DatabaseSettingsStateUpdated), $author$project$Msg$sharedCmd, $author$project$Msg$SettingsPageMsgReceived, subMsg, model.b, model.hY);
                var pageModel = _v19.a;
                var pageCmd = _v19.b;
                return _Utils_Tuple2(_Utils_update(model, { hY: pageModel }), pageCmd);
            case 28:
                var subMsg = msg.a;
                var _v20 = $author$project$Pages$Admin$update_fn($author$project$Main$onError, $author$project$Msg$sharedCmd, $author$project$Msg$AdminPageMsgReceived, subMsg, model.b, model.gn);
                var pageModel = _v20.a;
                var pageCmd = _v20.b;
                return _Utils_Tuple2(_Utils_update(model, { gn: pageModel }), pageCmd);
            case 29:
                var subMsg = msg.a;
                var _v21 = $author$project$Pages$Trial$update_fn(subMsg, model.b, model.im);
                var pageModel = _v21.a;
                var pageCmd = _v21.b;
                return _Utils_Tuple2(_Utils_update(model, { im: pageModel }), _Platform_map_fn($author$project$Msg$TrialPageMsgReceived, pageCmd));
            case 30:
                var subMsg = msg.a;
                var _v22 = $author$project$Pages$Signup$update_fn(subMsg, model.b, model.h_);
                var pageModel = _v22.a;
                var pageCmd = _v22.b;
                return _Utils_Tuple2(_Utils_update(model, { h_: pageModel }), _Platform_map_fn($author$project$Msg$SignupPageMsgReceived, pageCmd));
            case 31:
                var subMsg = msg.a;
                var _v23 = $author$project$Pages$Login$update_fn($author$project$Msg$LoginPageMsgReceived, $author$project$Msg$sharedCmd, $author$project$Msg$UserLoggedIn, subMsg, model.b, model.hn);
                var pageModel = _v23.a;
                var cmd = _v23.b;
                return _Utils_Tuple2(_Utils_update(model, { hn: pageModel }), cmd);
            case 32:
                var subMsg = msg.a;
                var _v24 = $author$project$Pages$ForgotPassword$update_fn($author$project$Msg$ForgotPasswordPageMsgReceived, subMsg, model.gU);
                var pageModel = _v24.a;
                var cmd = _v24.b;
                return _Utils_Tuple2(_Utils_update(model, { gU: pageModel }), cmd);
            case 33:
                var subMsg = msg.a;
                var _v25 = function () {
                    var _v26 = model.p;
                    if (_v26.$ === 1) {
                        return _Utils_Tuple2(model.gj, $elm$core$Platform$Cmd$none);
                    }
                    else {
                        var user = _v26.a;
                        return $author$project$Pages$Users$update_fn({ gd: $author$project$Msg$UsersPageMsgReceived, ge: $author$project$Msg$sharedCmd }, user, subMsg, model.gj);
                    }
                }();
                var pageModel = _v25.a;
                var pageCmd = _v25.b;
                return _Utils_Tuple2(_Utils_update(model, { gj: pageModel }), pageCmd);
            case 34:
                var subMsg = msg.a;
                var _v27 = function () {
                    var _v28 = model.p;
                    if (_v28.$ === 1) {
                        return _Utils_Tuple2(model.f9, $elm$core$Platform$Cmd$none);
                    }
                    else {
                        var user = _v28.a;
                        return $author$project$Pages$Teams$update_fn({
                            iY: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Msg$CreateDB($author$project$Types$UploadType$CreateEmpty), $author$project$Util$msgCmd)),
                            m7: A2($elm$core$Basics$composeR, $author$project$Msg$TeamHydratedRequested, $author$project$Util$msgCmd),
                            nT: $author$project$Main$onError,
                            kk: $author$project$Msg$GotFile,
                            kl: $author$project$Msg$Pick,
                            n2: A2($elm$core$Basics$composeR, $author$project$Msg$TeamCreated, $author$project$Util$msgCmd),
                            n3: A2($elm$core$Basics$composeR, $author$project$Msg$TeamDeleted, $author$project$Util$msgCmd),
                            ko: $author$project$Msg$Uploaded,
                            oR: A2($elm$core$Basics$composeR, $author$project$Msg$SetDialog, $author$project$Util$msgCmd),
                            gd: $author$project$Msg$TeamsPageMsgReceived,
                            ge: $author$project$Msg$sharedCmd
                        }, user, subMsg, model.b, model.f9);
                    }
                }();
                var pageModel = _v27.a;
                var pageCmd = _v27.b;
                return _Utils_Tuple2(_Utils_update(model, { f9: pageModel }), pageCmd);
            case 39:
                var user = msg.a;
                var maybeNextRoute = msg.b;
                var teamsRoute = $author$project$Route$Teams($author$project$Pages$Teams$Route$Teams);
                var maybeCurrentNonLoginRoute = $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$neq($author$project$Route$Login), $elm$core$Maybe$Just(model.b.eu));
                return _Utils_Tuple2(_Utils_update(model, {
                    p: $elm$core$Maybe$Just(user)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteReplace($elm$core$Maybe$withDefault_fn(teamsRoute, $elm_community$maybe_extra$Maybe$Extra$orElse_fn(maybeCurrentNonLoginRoute, maybeNextRoute)))),
                    $author$project$Ports$saveToLocalStorage({
                        jQ: "username",
                        pB: $elm$json$Json$Encode$string($author$project$Types$User$nameToString(user.M))
                    })
                ])));
            case 40:
                return _Utils_Tuple2(_Utils_update(model, { p: $elm$core$Maybe$Nothing }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$RouteTo($author$project$Route$Home)),
                    $elm$core$Basics$composeR_fn($author$project$Msg$sharedCmd_a0, $author$project$Msg$sharedCmd_a1, $author$project$Shared$ClearUserData),
                    $author$project$Api$logout_fn($elm$core$Basics$always($author$project$Msg$Reset), model.b.k2)
                ])));
            case 41:
                var userMenu = $author$project$Overlay$withPositionMapper_fn($author$project$Overlay$withPositionBelowRight_a0, $author$project$Overlay$popupMenu_fn(model.eU, $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    $elm$core$Maybe$Just(_Utils_Tuple3("Logout", $author$project$Msg$UserLoggedOut, false)),
                    model.b.aQ.mx.ip ? $elm$core$Maybe$Just(_Utils_Tuple3("Profile", $author$project$Msg$SharedMsg($author$project$Shared$RouteTo($author$project$Route$Users($elm$core$Maybe$Nothing))), false)) : $elm$core$Maybe$Nothing,
                    $elm$core$Maybe$Just(_Utils_Tuple3("Teams", $author$project$Msg$SharedMsg($author$project$Shared$RouteTo($author$project$Route$Teams($author$project$Pages$Teams$Route$Teams))), false))
                ]))));
                return _Utils_Tuple2(_Utils_update(model, { eU: userMenu }), $author$project$Overlay$setOrigin_fn($elm$core$Basics$identity, "user-status", userMenu));
            case 42:
                var subMsg = msg.a;
                var _v29 = $author$project$Overlay$update_fn(subMsg, model.eU);
                var userMenu = _v29.a;
                var cmd = _v29.b;
                return _Utils_Tuple2(_Utils_update(model, { eU: userMenu }), cmd);
            default:
                var subMsg = msg.a;
                var _v30 = $author$project$Shared$update_fn(subMsg, model.b);
                var pageModel = _v30.a;
                var pageCmd = _v30.b;
                return _Utils_Tuple2(_Utils_update(model, { b: pageModel }), _Platform_map_fn($author$project$Msg$SharedMsg, pageCmd));
        }
    }, $author$project$Main$update = F2($author$project$Main$update_fn);
    var $author$project$Msg$UserMenuOpened = { $: 41 };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_50 = $rtfeldman$elm_css$Css$property_fn("z-index", "50");
    var $author$project$Components$fullScreen_fn = function (styles, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_50,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), content);
    }, $author$project$Components$fullScreen = F2($author$project$Components$fullScreen_fn);
    var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
        return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(A3($elm$virtual_dom$VirtualDom$node, "span", _List_fromArray([
            $elm$virtual_dom$VirtualDom$attribute_fn("style", "display: none;"),
            $elm$virtual_dom$VirtualDom$attribute_fn("class", "elm-css-style-wrapper")
        ]), $elm$core$List$singleton(A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, $elm$core$List$singleton($elm$virtual_dom$VirtualDom$text($rtfeldman$elm_css$Css$Preprocess$Resolve$compile($rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets))))))));
    };
    var $rtfeldman$elm_css$Css$Global$body_a0 = "body", $rtfeldman$elm_css$Css$Global$body = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$body_a0);
    var $rtfeldman$elm_css$Css$prop3_fn = function (key, argA, argB, argC) {
        return $rtfeldman$elm_css$Css$property_fn(key, argA.pB + (" " + (argB.pB + (" " + argC.pB))));
    }, $rtfeldman$elm_css$Css$prop3 = F4($rtfeldman$elm_css$Css$prop3_fn);
    var $rtfeldman$elm_css$Css$border3_a0 = "border", $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3($rtfeldman$elm_css$Css$border3_a0);
    var $rtfeldman$elm_css$Css$borderRadius_a0 = "border-radius", $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$borderRadius_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_0 = $rtfeldman$elm_css$Css$property_fn("border-width", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$box_border = $rtfeldman$elm_css$Css$property_fn("box-sizing", "border-box");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_6 = $rtfeldman$elm_css$Css$property_fn("line-height", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "1rem");
    var $rtfeldman$elm_css$Css$prop2_fn = function (key, argA, argB) {
        return $rtfeldman$elm_css$Css$property_fn(key, argA.pB + (" " + argB.pB));
    }, $rtfeldman$elm_css$Css$prop2 = F3($rtfeldman$elm_css$Css$prop2_fn);
    var $rtfeldman$elm_css$Css$padding2_a0 = "padding", $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2($rtfeldman$elm_css$Css$padding2_a0);
    var $rtfeldman$elm_css$Css$solid = { aP: 0, cD: 0, pB: "solid" };
    var $author$project$Styles$tailwindVars = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-border-spacing-x", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-border-spacing-y", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-x", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-y", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-rotate", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-skew-x", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-skew-y", "0"),
        $rtfeldman$elm_css$Css$property_fn("--tw-scale-x", "1"),
        $rtfeldman$elm_css$Css$property_fn("--tw-scale-y", "1"),
        $rtfeldman$elm_css$Css$property_fn("--tw-pan-x", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-pan-y", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-pinch-zoom", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-scroll-snap-strictness", "proximity"),
        $rtfeldman$elm_css$Css$property_fn("--tw-ordinal", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-slashed-zero", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-numeric-figure", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-numeric-spacing", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-numeric-fraction", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-inset", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-offset-width", "0px"),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-offset-color", "#fff"),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-color", "rgb(59 130 246 / 0.5)"),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-offset-shadow", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("--tw-ring-shadow", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow-colored", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("--tw-blur", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-brightness", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-contrast", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-grayscale", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-hue-rotate", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-invert", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-saturate", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-sepia", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-drop-shadow", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-blur", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-brightness", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-contrast", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-grayscale", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-hue-rotate", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-invert", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-opacity", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-saturate", " "),
        $rtfeldman$elm_css$Css$property_fn("--tw-backdrop-sepia", " ")
    ]));
    var $author$project$Styles$global = _List_fromArray([
        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$author$project$Styles$tailwindVars, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$box_border, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_0])),
        $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$body_a0, _List_fromArray([
            $elm$core$Basics$composeL_fn($rtfeldman$elm_css$Css$fontFamilies_a0, $rtfeldman$elm_css$Css$fontFamilies_a1, _List_fromArray(["Helvetica Neue", "Arial", "sans-serif"])),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 15)),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_6
        ])),
        $rtfeldman$elm_css$Css$Global$selector_fn(".docs-description p", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4])),
        $rtfeldman$elm_css$Css$Global$selector_fn(".docs-description code", _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 0.8)),
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 90)),
            $rtfeldman$elm_css$Css$prop3_fn($rtfeldman$elm_css$Css$border3_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 1), $rtfeldman$elm_css$Css$solid, $rtfeldman$elm_css$Css$hsl_fn(0, 0, 80)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 4)),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$padding2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 0.1), $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 0.4))
        ]))
    ]);
    var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp_fn = function (fn, arg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy_fn = function (fn, arg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy2_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy = F2($rtfeldman$elm_css$VirtualDom$Styled$lazy_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy = $rtfeldman$elm_css$VirtualDom$Styled$lazy;
    var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2_fn = function (fn, arg1, arg2) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A2(fn, arg1, arg2));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2_fn_unwrapped = function (fn, arg1, arg2) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy2_fn = function (fn, arg1, arg2) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy3_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3($rtfeldman$elm_css$VirtualDom$Styled$lazy2_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = $rtfeldman$elm_css$VirtualDom$Styled$lazy2;
    var $rtfeldman$elm_css$Css$animationDelay = function (arg) {
        return $rtfeldman$elm_css$Css$prop1_fn("animation-delay", arg);
    };
    var $rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
        var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
        var classAttribute = $elm$virtual_dom$VirtualDom$attribute_fn("", "");
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(classAttribute, true, cssTemplate);
    };
    var $rtfeldman$elm_css$Svg$Styled$Attributes$css = $rtfeldman$elm_css$Svg$Styled$Internal$css;
    var $author$project$Svg$spinnerDelayed = function (attributes) {
        return $author$project$Svg$spinner(_List_Cons($rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0,
            $rtfeldman$elm_css$Css$property_fn("animation-fill-mode", "forwards"),
            $rtfeldman$elm_css$Css$animationDelay($rtfeldman$elm_css$Css$sec(1)),
            $rtfeldman$elm_css$Css$animationDuration($rtfeldman$elm_css$Css$sec(3)),
            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                _Utils_Tuple2(100, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("opacity", "1")
                ]))
            ])))
        ])), attributes));
    };
    var $author$project$Components$pageSpinner = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center]))
    ]), _List_fromArray([
        $author$project$Svg$spinnerDelayed(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100]))
        ]))
    ]));
    var $author$project$Svg$bug = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8z\n                m-6 8h-4v-2h4v2z\n                m0-4h-4v-2h4v2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$help = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M11 18h2v-2h-2v2z\n                m1-16C6.48 2 2 6.48 2 12\n                    s4.48 10 10 10 10-4.48 10-10\n                    S17.52 2 12 2z\n                m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\n                m0-14c-2.21 0-4 1.79-4 4h2\n                    c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2\n                    c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$iconLinkPill_fn = function (titleTxt, svg, url) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$href(url),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$title_a0, titleTxt),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank"),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $author$project$Theme$theme.hO(true),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
            ]))
        ]), _List_fromArray([
            svg(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]))
            ]))
        ]));
    }, $author$project$Components$iconLinkPill = F3($author$project$Components$iconLinkPill_fn);
    var $author$project$Route$isTabbed = function (route) {
        switch (route.$) {
            case 10:
                return true;
            case 16:
                return true;
            case 17:
                return true;
            case 18:
                return true;
            case 19:
                return true;
            case 20:
                return true;
            case 21:
                return true;
            case 23:
                return true;
            case 24:
                return true;
            case 25:
                return true;
            case 26:
                return true;
            default:
                return false;
        }
    };
    var $author$project$Util$stylesIf_fn = function (condition, styles) {
        return condition ? $rtfeldman$elm_css$Css$batch(styles) : $rtfeldman$elm_css$Css$batch(_List_Nil);
    }, $author$project$Util$stylesIf = F2($author$project$Util$stylesIf_fn);
    var $author$project$Components$loginSignupButtons = function (currentRoute) {
        var toLink = F2(function (title, route) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(route)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.hO(false),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $author$project$Util$stylesIf_fn(_Utils_eq(route, currentRoute), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]));
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), _List_fromArray([
            A2(toLink, "Login", $author$project$Route$Login),
            A2(toLink, "Signup", $author$project$Route$Signup)
        ]));
    };
    var $author$project$Route$toTeamName = function (route) {
        if (route.$ === 9) {
            var subRoute = route.a;
            return $author$project$Pages$Teams$Route$toTeamName(subRoute);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "1.125rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1.75rem")
    ]));
    var $author$project$Components$iconTextButton = function (cfg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
            A2($author$project$Util$stopPropagationOn, "click", cfg.a_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg,
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(cfg.ii),
            cfg.bA(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(cfg.bE)
            ])),
            $rtfeldman$elm_css$Html$Styled$text(cfg.ih)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("margin-left", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-left", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-right", "0.25rem")
    ]));
    var $author$project$Svg$triangleDown = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 12 12"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M1 4l5 5 5-5z")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_px = $rtfeldman$elm_css$Css$property_fn("width", "1px");
    var $author$project$Components$userStatus_fn = function (onOpenUserMenu, route, maybeTeamName, user) {
        var teamLink = function () {
            if (!maybeTeamName.$) {
                var teamName = maybeTeamName.a;
                return {
                    fx: teamName,
                    eu: $author$project$Route$Teams($author$project$Pages$Teams$Route$Overview(teamName))
                };
            }
            else {
                return {
                    fx: "My Teams",
                    eu: $author$project$Route$Teams($author$project$Pages$Teams$Route$Teams)
                };
            }
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "user-status"),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $author$project$Theme$theme.hO(false),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(teamLink.eu)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline])),
                    $author$project$Util$styleIf_fn(_Utils_eq(route, teamLink.eu), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(teamLink.fx)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_px,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
                ]))
            ]), _List_Nil),
            $author$project$Components$iconTextButton({
                bA: $author$project$Svg$triangleDown,
                a_: onOpenUserMenu,
                m: _List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
                ]),
                bE: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_0_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_0_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ]))
                ]),
                ih: "",
                ii: $author$project$Types$User$nameToString(user.M)
            })
        ]));
    }, $author$project$Components$userStatus = F4($author$project$Components$userStatus_fn);
    var $author$project$Components$sessionStatus_fn = function (onOpenUserMenu, route, maybeUser, remoteDatabase) {
        var maybeTeamName = function () {
            var maybeTeamNameFromRoute = $author$project$Route$toTeamName(route);
            var maybeTeamNameFromDatabase = function () {
                var equalsDatabaseForRoute = A2($elm$core$Basics$composeR, function ($) {
                    return $.bR;
                }, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq($author$project$Route$getDatabaseId(route))));
                return $elm$core$Maybe$andThen_fn(function ($) {
                    return $.ob;
                }, $elm_community$maybe_extra$Maybe$Extra$filter_fn(equalsDatabaseForRoute, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, remoteDatabase)));
            }();
            return $elm_community$maybe_extra$Maybe$Extra$orElse_fn(maybeTeamNameFromDatabase, maybeTeamNameFromRoute);
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                $author$project$Util$styleIf_fn(_Utils_eq(route, $author$project$Route$NotFound), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents,
                    $author$project$Util$styleIf_fn(!$author$project$Route$isTabbed(route), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                ]))
            ]), _List_fromArray([
                $author$project$Components$iconLinkPill_fn("Documentation", $author$project$Svg$help, "https://docs.airsequel.com"),
                $author$project$Components$iconLinkPill_fn("Issue Tracker", $author$project$Svg$bug, "https://github.com/Airsequel/Airsequel-Issues/issues")
            ])),
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Components$loginSignupButtons(route), A3($author$project$Components$userStatus, onOpenUserMenu, route, maybeTeamName), maybeUser)
        ]));
    }, $author$project$Components$sessionStatus = F4($author$project$Components$sessionStatus_fn);
    var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
    var $author$project$Dialog$addBackDrop = function (maybeOnClick) {
        return A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Components$backdrop_fn("dialog", maybeOnClick));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$brightness_90 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-brightness", "brightness(.9)"),
        $rtfeldman$elm_css$Css$property_fn("filter", "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row = $rtfeldman$elm_css$Css$property_fn("flex-direction", "row");
    var $rtfeldman$elm_css$Html$Styled$h2_a0 = "h2", $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$h2_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_4over5 = $rtfeldman$elm_css$Css$property_fn("height", "80%");
    var $author$project$Components$hairBar = function (styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_px,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$current),
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_Nil);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_1 = $rtfeldman$elm_css$Css$property_fn("margin", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_1 = $rtfeldman$elm_css$Css$property_fn("margin-right", "-0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overscroll_y_none = $rtfeldman$elm_css$Css$property_fn("overscroll-behavior-y", "none");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("padding-right", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("padding-top", "0.125rem");
    var $author$project$Dialog$customizedDialog_fn = function (cfg, closeDialog) {
        var titleBar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_7,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color(cfg.cj)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden,
                    $rtfeldman$elm_css$Css$batch(cfg.eO)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg.eM)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), cfg.eN),
                $author$project$Components$hairBar(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_4over5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color(cfg.cj),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$brightness_90,
                    $author$project$Util$styleIf_fn(_Utils_eq(cfg.eN, _List_Nil), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                ])),
                $author$project$Components$iconButton({
                    bA: $author$project$Svg$closeCircled,
                    a_: closeDialog,
                    m: _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_0_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_0_dot_5,
                        $rtfeldman$elm_css$Css$hover($elm$core$List$map_fn($rtfeldman$elm_css$Css$important, cfg.cT)),
                        $rtfeldman$elm_css$Css$batch(cfg.cT)
                    ]),
                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6])
                })
            ]))
        ]));
        return function () {
            var _v0 = cfg.bv;
            if (_v0.$ === 1) {
                return $elm$core$Basics$identity;
            }
            else {
                if (!_v0.a) {
                    return $author$project$Dialog$addBackDrop($elm$core$Maybe$Nothing);
                }
                else {
                    return $author$project$Dialog$addBackDrop($elm$core$Maybe$Just(closeDialog));
                }
            }
        }()($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([
                $author$project$Theme$theme.mc,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overscroll_y_none,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color(cfg.cj),
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            titleBar,
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_scroll]))
            ]), _List_fromArray([cfg.gB]))
        ])));
    }, $author$project$Dialog$customizedDialog = F2($author$project$Dialog$customizedDialog_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_100 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "220", "252", "231", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_800 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "22", "101", "52", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Dialog$customizedSuccessDialog_fn = function (cfg, closeDialog) {
        return $author$project$Dialog$customizedDialog_fn({
            cT: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_800)
            ]),
            bv: cfg.bv,
            gB: cfg.gB,
            cj: $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_400,
            m: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_800),
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]),
            eM: cfg.eM,
            eN: _List_Nil,
            eO: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_50)
            ])
        }, closeDialog);
    }, $author$project$Dialog$customizedSuccessDialog = F2($author$project$Dialog$customizedSuccessDialog_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_400 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "248", "113", "113", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_900 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "127", "29", "29", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Components$ConfirmDialog$contextToCreatedUtc = function (context) {
        switch (context.$) {
            case 0:
                var db = context.b;
                return $elm$core$Maybe$Just(db.lW);
            case 1:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Nothing;
            case 4:
                var db = context.b;
                return $elm$core$Maybe$Just(db.lW);
            case 5:
                var db = context.b;
                return $elm$core$Maybe$Just(db.lW);
            case 6:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                var apiToken = context.a;
                return $elm$core$Maybe$Just(apiToken.lW);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$ConfirmDialog$contextToFirstParagraphEnding = function (context) {
        switch (context.$) {
            case 4:
                return $rtfeldman$elm_css$Html$Styled$text("with the following content:");
            case 5:
                return $rtfeldman$elm_css$Html$Styled$text("with the following content:");
            case 3:
                var column = context.a;
                var intro = (_Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$null) || _Utils_eq($author$project$Types$Column$defaultCell(column), $author$project$Types$Cell$empty)) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("to"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text($author$project$Types$InputElement$defaultValue(column.mN))
                    ]))
                ]));
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex]))
                ]), _List_fromArray([
                    intro,
                    $rtfeldman$elm_css$Html$Styled$text("and delete the data of:")
                ]));
            default:
                return $rtfeldman$elm_css$Html$Styled$text("and all of its content including:");
        }
    };
    var $author$project$Components$ConfirmDialog$contextToName = function (context) {
        switch (context.$) {
            case 0:
                var database = context.b;
                return database.mw;
            case 1:
                var table = context.a;
                return table.M;
            case 2:
                var column = context.a;
                return column.jx;
            case 3:
                var column = context.a;
                return column.jx;
            case 4:
                var database = context.b;
                return database.mw;
            case 5:
                var database = context.b;
                return database.mw;
            case 6:
                var _function = context.a;
                return _function.M;
            case 7:
                var app = context.a;
                return app.M;
            case 8:
                var apiToken = context.a;
                return apiToken.M;
            default:
                var team = context.a;
                return team.M;
        }
    };
    var $author$project$Components$ConfirmDialog$contextToTarget = function (context) {
        switch (context.$) {
            case 0:
                return "database";
            case 1:
                var table = context.a;
                return $elm$core$String$toLower($author$project$Types$TableType$toString(table.o8));
            case 2:
                return "column";
            case 3:
                return "column";
            case 4:
                return "database";
            case 5:
                return "database";
            case 6:
                return "function";
            case 7:
                return "app";
            case 8:
                return "api token";
            default:
                return "team";
        }
    };
    var $author$project$Components$ConfirmDialog$contextToTargetDescription = function (context) {
        switch (context.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Just("cells in ");
            case 4:
                var database = context.b;
                return $elm$core$Maybe$Just("Database ID " + ($author$project$Types$Database$unwrapId(database.bR) + " of the "));
            case 5:
                var database = context.b;
                return $elm$core$Maybe$Just("Read-Only ID " + (database.oo + " of the "));
            case 6:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$ConfirmDialog$contextToTargetDetail = function (context) {
        switch (context.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Just(" Data");
            case 4:
                return $elm$core$Maybe$Just(" ID");
            case 5:
                return $elm$core$Maybe$Just(" Read-Only ID");
            case 6:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$ConfirmDialog$contextToTime = function (context) {
        switch (context.$) {
            case 0:
                var time = context.a;
                return $elm$core$Maybe$Just(time);
            case 1:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Nothing;
            case 4:
                var time = context.a;
                return $elm$core$Maybe$Just(time);
            case 5:
                var time = context.a;
                return $elm$core$Maybe$Just(time);
            case 6:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$dialogButton_fn = function (title, styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
        ])), styles), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(title)
        ]));
    }, $author$project$Components$dialogButton = F2($author$project$Components$dialogButton_fn);
    var $author$project$Components$ConfirmDialog$escapeRegex = function (str) {
        return $elm$core$String$replace_fn("$", "\\$", $elm$core$String$replace_fn("|", "\\|", $elm$core$String$replace_fn("+", "\\+", $elm$core$String$replace_fn("^", "\\^", $elm$core$String$replace_fn("*", "\\*", $elm$core$String$replace_fn("}", "\\}", $elm$core$String$replace_fn("{", "\\{", $elm$core$String$replace_fn("]", "\\]", $elm$core$String$replace_fn("[", "\\[", $elm$core$String$replace_fn(")", "\\)", $elm$core$String$replace_fn("(", "\\(", $elm$core$String$replace_fn(".", "\\.", $elm$core$String$replace_fn("?", "\\?", $elm$core$String$replace_fn("\\", "\\\\", str))))))))))))));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold = $rtfeldman$elm_css$Css$property_fn("font-weight", "700");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_3 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_x_0 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("left", "0px"),
        $rtfeldman$elm_css$Css$property_fn("right", "0px")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center = $rtfeldman$elm_css$Css$property_fn("text-align", "center");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_max = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("width", "-webkit-max-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "-moz-max-content"),
        $rtfeldman$elm_css$Css$property_fn("width", "max-content")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_3over5 = $rtfeldman$elm_css$Css$property_fn("height", "60%");
    var $author$project$Components$wrapWithSpinner3_fn = function (wrapperStyles, spinner, element) {
        return spinner ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                $rtfeldman$elm_css$Css$batch(wrapperStyles)
            ]))
        ]), _List_fromArray([
            $author$project$Svg$spinner(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_3over5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute]))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ]), _List_fromArray([element]))
        ])) : element;
    }, $author$project$Components$wrapWithSpinner3 = F3($author$project$Components$wrapWithSpinner3_fn);
    var $author$project$Components$progressButton_fn = function (title, maybeOnClick, maybePercent, disabled_, styles) {
        var progressing = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$neq(100), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$neq(0), maybePercent)));
        var buttonText = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(title, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($author$project$Util$flip, $elm$core$String$append, "%")), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(!disabled_), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(progressing), maybePercent)));
        return $author$project$Components$wrapWithSpinner3_fn(_List_Nil, _Utils_eq(maybePercent, $elm$core$Maybe$Just(100)) && (!disabled_), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onClick, maybeOnClick),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_ || (!_Utils_eq(maybePercent, $elm$core$Maybe$Nothing))),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_max,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_x_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(buttonText)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]))
        ])));
    }, $author$project$Components$progressButton = F5($author$project$Components$progressButton_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "1.5rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "1.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0.75rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0.75rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "1.25rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1.75rem")
    ]));
    var $author$project$Components$wrapWithCloseButton_fn = function (styles, msg, element) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
        ]), _List_fromArray([
            $author$project$Svg$closeCircled(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_30,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ])),
            element
        ]));
    }, $author$project$Components$wrapWithCloseButton = F3($author$project$Components$wrapWithCloseButton_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_5 = $rtfeldman$elm_css$Css$property_fn("bottom", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$delay_500 = $rtfeldman$elm_css$Css$property_fn("transition-delay", "500ms");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_in = $rtfeldman$elm_css$Css$property_fn("transition-timing-function", "cubic-bezier(0.4, 0, 1, 1)");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_1over2 = $rtfeldman$elm_css$Css$property_fn("left", "50%");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_1over2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-x", "-50%"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1 = $rtfeldman$elm_css$Css$property_fn("padding", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.625rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.625rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow", "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow-colored", "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)"),
        $rtfeldman$elm_css$Css$property_fn("box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transform = $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))");
    var $author$project$Components$wrapWithTooltip_fn = function (styles, txt, element) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_help,
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$id_fn("tooltip-content", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transition_opacity, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ease_in, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$delay_500, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100]))
                    ]))
                ]))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "tooltip-content"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_1over2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_50,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$black),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transform,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_1over2,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(txt)
            ])),
            element
        ]));
    }, $author$project$Components$wrapWithTooltip = F3($author$project$Components$wrapWithTooltip_fn);
    var $author$project$Components$ConfirmDialog$view = function (cfg) {
        var totalRowCount = function (db) {
            return $elm$core$List$sum($elm$core$List$map_fn($author$project$Types$Table$countRows, db.eH));
        };
        var totalColumnsCount = function (db) {
            return $elm$core$List$length($elm$core$List$concatMap_fn(function ($) {
                return $.iT;
            }, db.eH));
        };
        var targetDescription = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", A2($elm$core$String$padRight, 1, " "), $author$project$Components$ConfirmDialog$contextToTargetDescription(cfg.bx));
        var target = $author$project$Components$ConfirmDialog$contextToTarget(cfg.bx);
        var statsBox = F2(function (quantity, kind) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_lg,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromInt(quantity))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(_Utils_ap(kind, (quantity !== 1) ? "s" : ""))
                ]))
            ]));
        });
        var statsBoxes = function () {
            var _v0 = cfg.bx;
            switch (_v0.$) {
                case 0:
                    var db = _v0.b;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(db.eH), "Table"),
                        A2(statsBox, totalColumnsCount(db), "Column"),
                        A2(statsBox, totalRowCount(db), "Row")
                    ]);
                case 1:
                    var table = _v0.a;
                    var maybeLoc = _v0.b;
                    return $author$project$Types$TableType$isMutable(table.o8) ? _List_fromArray([
                        A2(statsBox, $elm$core$List$length(table.iT), "Column"),
                        A2(statsBox, $author$project$Types$Table$countRows(table), "Row")
                    ]) : $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function (loc) {
                        return _List_fromArray([
                            A2(statsBox, loc, "Lines of SQL Code")
                        ]);
                    }, maybeLoc);
                case 2:
                    var column = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length($author$project$Types$Column$findNonDefaultCellIndexes(column)), "Cell")
                    ]);
                case 3:
                    var column = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length($author$project$Types$Column$findNonDefaultCellIndexes(column)), "Cell")
                    ]);
                case 4:
                    var db = _v0.b;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(db.eH), "Table"),
                        A2(statsBox, totalColumnsCount(db), "Column"),
                        A2(statsBox, totalRowCount(db), "Row")
                    ]);
                case 5:
                    var db = _v0.b;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(db.eH), "Table"),
                        A2(statsBox, totalColumnsCount(db), "Column"),
                        A2(statsBox, totalRowCount(db), "Row")
                    ]);
                case 6:
                    var _function = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(_function.le), "Version")
                    ]);
                case 7:
                    var app = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(app.le), "Version")
                    ]);
                case 8:
                    var apiToken = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $elm$core$List$length(apiToken.od), "Permission")
                    ]);
                default:
                    var team = _v0.a;
                    return _List_fromArray([
                        A2(statsBox, $krisajenkins$remotedata$RemoteData$unwrap_fn(0, $elm$core$List$length, team.l1), "Database")
                    ]);
            }
        }();
        var maybeTargetDetail = $author$project$Components$ConfirmDialog$contextToTargetDetail(cfg.bx);
        var maybeCreatedUtc = $author$project$Components$ConfirmDialog$contextToCreatedUtc(cfg.bx);
        var maybeAgeInDays = function () {
            var millisToDays = function (millis) {
                return (((millis / 1000) / 60) / 60) / 24;
            };
            var maybeAgeInMillis = $elm$core$Maybe$map2_fn($elm$core$Basics$sub, $elm$core$Maybe$map_fn($elm$time$Time$posixToMillis, $author$project$Components$ConfirmDialog$contextToTime(cfg.bx)), $elm$core$Maybe$map_fn($elm$time$Time$posixToMillis, $elm$core$Maybe$andThen_fn($author$project$Types$Utc$toPosix, maybeCreatedUtc)));
            return $elm$core$Maybe$andThen_fn($elm$core$String$toFloat, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Basics$toFloat, A2($elm$core$Basics$composeR, millisToDays, $myrho$elm_round$Round$round(1))), maybeAgeInMillis));
        }();
        return $author$project$Components$wrapWithCloseButton_fn(_List_Nil, cfg.ke, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.mc]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($elm_community$string_extra$String$Extra$toTitleCase(cfg.ln) + (" " + ($elm_community$string_extra$String$Extra$toTitleCase(target) + $elm$core$Maybe$withDefault_fn("", maybeTargetDetail))))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("This will " + (cfg.ln + (" the " + targetDescription))),
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, $elm$core$Basics$floor, A2($elm$core$Basics$composeR, A2($elm_community$string_extra$String$Extra$pluralize, "day old ", "days old "), A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$span(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700)
                    ]))
                ])), A2($author$project$Components$wrapWithTooltip, _List_Nil, $elm$core$String$replace_fn("-", "\u2011", $elm$core$String$join_fn(" ", $elm_community$list_extra$List$Extra$updateAt_fn(1, $elm_community$string_extra$String$Extra$leftOf("."), $elm$core$String$split_fn(" ", $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Types$Utc$toString, maybeCreatedUtc))))))))))), maybeAgeInDays),
                $rtfeldman$elm_css$Html$Styled$text(target)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($author$project$Components$ConfirmDialog$contextToName(cfg.bx))
            ])),
            $author$project$Components$ConfirmDialog$contextToFirstParagraphEnding(cfg.bx),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_around]))
            ]), statsBoxes),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $rtfeldman$elm_css$Css$invalid(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$selector_fn("div > button:last-of-type", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
                        ]))
                    ]))
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onSubmit(cfg.hG)
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Enter " + (target + " name to confirm:")),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0, $author$project$Components$ConfirmDialog$escapeRegex($author$project$Components$ConfirmDialog$contextToName(cfg.bx))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                        ]))
                    ]), _List_Nil)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                ]), _List_fromArray([
                    $author$project$Components$dialogButton_fn("Cancel", _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
                        $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.ke)
                    ])),
                    $author$project$Components$progressButton_fn($elm_community$string_extra$String$Extra$toTitleCase(cfg.ln), $elm$core$Maybe$Nothing, cfg.py, false, _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded
                    ]))
                ]))
            ]))
        ])));
    };
    var $author$project$Dialog$view_fn = function (uploadPercent, closeDialog, dialog) {
        switch (dialog.$) {
            case 0:
                var _v1 = dialog.a;
                var title = _v1.a;
                var message = _v1.b;
                return $author$project$Dialog$customizedDialog_fn({
                    cT: _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_900)
                    ]),
                    bv: $elm$core$Maybe$Just(true),
                    gB: $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Svg$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4])),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(message)
                    ])),
                    cj: $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_400,
                    m: _List_Nil,
                    eM: title,
                    eN: _List_Nil,
                    eO: _List_Nil
                }, closeDialog);
            case 1:
                var cfg = dialog.a;
                return $author$project$Dialog$customizedSuccessDialog_fn({
                    bv: $elm$core$Maybe$Just(cfg.bv),
                    gB: cfg.gB,
                    m: cfg.m,
                    eM: cfg.eM
                }, closeDialog);
            case 2:
                var cfg = dialog.a;
                return $author$project$Dialog$customizedSuccessDialog_fn({
                    bv: $elm$core$Maybe$Just(true),
                    gB: $rtfeldman$elm_css$Html$Styled$text(cfg.no),
                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_line, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$break_words]),
                    eM: cfg.eM
                }, closeDialog);
            case 3:
                var action = dialog.a;
                var onConfirm = dialog.b;
                var context = dialog.c;
                return A2($author$project$Dialog$addBackDrop, $elm$core$Maybe$Just(closeDialog), $author$project$Components$ConfirmDialog$view({ ln: action, bx: context, ke: closeDialog, hG: onConfirm, py: uploadPercent }));
            case 4:
                var cfg = dialog.a;
                return A2($author$project$Dialog$addBackDrop, $elm$core$Maybe$Just(closeDialog), $author$project$Components$confirmDialogSimple({ lL: cfg.lL, iU: cfg.iU, no: cfg.no, ek: closeDialog, hG: cfg.hG }));
            case 5:
                var content = dialog.a;
                return content(closeDialog);
            default:
                var cfg = dialog.a;
                return $author$project$Dialog$customizedDialog_fn({
                    cT: cfg.cT,
                    bv: $elm$core$Maybe$Just(cfg.bv),
                    gB: cfg.gB,
                    cj: cfg.cj,
                    m: cfg.m,
                    eM: cfg.eM,
                    eN: _List_Nil,
                    eO: cfg.eO
                }, closeDialog);
        }
    }, $author$project$Dialog$view = F3($author$project$Dialog$view_fn);
    var $author$project$Model$featureApps = function (model) {
        return $elm$core$Basics$composeR_fn($author$project$Types$Edition$notShared_a0, $author$project$Types$Edition$notShared_a1, model.b.aQ.mx.ja) || model.b.aQ.mx.lz;
    };
    var $author$project$Model$featureFunctions = function (model) {
        return $elm$core$Basics$composeR_fn($author$project$Types$Edition$notShared_a0, $author$project$Types$Edition$notShared_a1, model.b.aQ.mx.ja) || model.b.aQ.mx.mB;
    };
    var $rtfeldman$elm_css$Html$Styled$h1_a0 = "h1", $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$h1_a0);
    var $author$project$Types$User$isAdmin_a0 = function ($) {
        return $.kQ;
    }, $author$project$Types$User$isAdmin_a1 = $elm$core$List$member("admin"), $author$project$Types$User$isAdmin = A2($elm$core$Basics$composeR, $author$project$Types$User$isAdmin_a0, $author$project$Types$User$isAdmin_a1);
    var $author$project$Pages$Admin$Route$isBillingRoute = function (route) {
        if (route.$ === 3) {
            return true;
        }
        else {
            return false;
        }
    };
    var $rtfeldman$elm_css$Html$Styled$main__a0 = "main", $rtfeldman$elm_css$Html$Styled$main_ = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$main__a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "1.5rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "2rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_3xl = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "1.875rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "2.25rem")
    ]));
    var $rtfeldman$elm_css$Html$Styled$h3_a0 = "h3", $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$h3_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_36 = $rtfeldman$elm_css$Css$property_fn("margin-top", "9rem");
    var $author$project$Pages$Admin$home = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_36,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
        ]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Airsequel Admin")
        ])),
        $rtfeldman$elm_css$Html$Styled$text("choose a tab to get started")
    ]));
    var $author$project$Pages$Admin$BillingPageMsgReceived = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$TabView$RouteTo = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Admin$Route$isDatabasesRoute = function (route) {
        if (route.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Pages$Admin$Route$isSettingsRoute = function (route) {
        if (route.$ === 2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md = $rtfeldman$elm_css$Css$Media$withMediaQuery(_List_fromArray(["(min-width: 768px)"]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_6 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "1.5rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "1.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "2rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "2rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_t = $rtfeldman$elm_css$Css$property_fn("border-top-width", "1px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap = $rtfeldman$elm_css$Css$property_fn("flex-wrap", "wrap");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_0 = $rtfeldman$elm_css$Css$property_fn("min-width", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_4 = $rtfeldman$elm_css$Css$property_fn("margin-left", "1rem");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$stroke_a0 = "stroke", $rtfeldman$elm_css$Svg$Styled$Attributes$stroke = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$stroke_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth_a0 = "stroke-width", $rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth_a0);
    var $author$project$Svg$plus = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth_a0, "3.5"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$stroke_a0, "currentColor"), attributes))), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3 = $rtfeldman$elm_css$Css$property_fn("width", "0.75rem");
    var $author$project$TabView$addAddButton_fn = function (maybeOnAdd, disabled_, headers) {
        if (!maybeOnAdd.$) {
            var onAdd = maybeOnAdd.a;
            return _Utils_ap(headers, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_)
                ]), _List_fromArray([
                    $author$project$Components$iconButton({
                        bA: $author$project$Svg$plus,
                        a_: onAdd,
                        m: _List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_4,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3,
                            $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                        ]),
                        bE: _List_Nil
                    })
                ]))
            ]));
        }
        else {
            return headers;
        }
    }, $author$project$TabView$addAddButton = F3($author$project$TabView$addAddButton_fn);
    var $author$project$Svg$closeNoCircle = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M0 0h24v24H0z"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "none")
            ]), _List_Nil),
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z")
            ]), _List_Nil)
        ]));
    };
    var $rtfeldman$elm_css$Html$Styled$nav_a0 = "nav", $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$nav_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0 = $rtfeldman$elm_css$Css$property_fn("right", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_md = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.375rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5 = $rtfeldman$elm_css$Css$property_fn("width", "0.875rem");
    var $author$project$TabView$toHeaders_fn = function (onAdd, headerStyles, tabStyles, tabStylesActive, styles, model, tabs) {
        var getBorder = function (isActive) {
            return isActive ? _Utils_ap(_List_fromArray([
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.dd),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.dd)
                ]))
            ]), tabStylesActive) : _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
            ]);
        };
        var toHeader = function (tab) {
            var maybeCloseButton = $elm$core$Maybe$map_fn(function (onClose) {
                return $author$project$Components$iconButton({
                    bA: $author$project$Svg$closeNoCircle,
                    a_: onClose,
                    m: _List_Nil,
                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0])
                });
            }, $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v2) {
                return !tab.cd(model);
            }, tab.ke));
            var _v0 = function () {
                var _v1 = tab.a_(model);
                if (!_v1.$) {
                    var route = _v1.a;
                    return _Utils_Tuple3($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), tab.cd(model) ? $elm$core$Basics$identity : A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$a(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(route)),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                            $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit)
                        ]))
                    ]))), tab.cd(model) ? $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0) : $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1));
                }
                else {
                    var msg = _v1.a;
                    return _Utils_Tuple3($rtfeldman$elm_css$Html$Styled$Events$onClick(msg), $elm$core$Basics$identity, $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0));
                }
            }();
            var onClickAttr = _v0.a;
            var linkWrapper = _v0.b;
            var buttonTabIndex = _v0.c;
            return linkWrapper($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                onClickAttr,
                buttonTabIndex,
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, tab.cd(model)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none])),
                    $rtfeldman$elm_css$Css$batch(tabStyles),
                    $rtfeldman$elm_css$Css$batch(getBorder(tab.fw(model))),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$svg_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100]))
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(tab.eM),
                $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), maybeCloseButton)
            ])));
        };
        var allTabsDisabled = $elm$core$List$all_fn(function (tab) {
            return tab.cd(model);
        }, tabs);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$nav_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(styles, headerStyles))
        ]), $author$project$TabView$addAddButton_fn(onAdd, allTabsDisabled, $elm$core$List$map_fn(toHeader, $elm$core$List$filter_fn(function (tab) {
            return !tab.fr(model);
        }, tabs))));
    }, $author$project$TabView$toHeaders = F7($author$project$TabView$toHeaders_fn);
    var $author$project$TabView$tabView_fn = function (cfg, model, tabs) {
        var content = $elm$core$Maybe$map_fn(function (tab) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_t,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8)),
                    $rtfeldman$elm_css$Css$batch(cfg.gC),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                    $author$project$Util$styleIf_fn(tab.fq, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0)
                ]))
            ]), _List_fromArray([
                tab.gl(model)
            ]));
        }, $elm_community$list_extra$List$Extra$find_fn(function (tab) {
            return tab.fw(model);
        }, tabs));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
        ]), $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            $elm$core$Maybe$Just($author$project$TabView$toHeaders_fn(cfg.nH, cfg.mG, cfg.o5, cfg.o6, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]), model, tabs)),
            content
        ])));
    }, $author$project$TabView$tabView = F3($author$project$TabView$tabView_fn);
    var $author$project$Pages$Admin$Route$toSettingsRoute = function (route) {
        if (route.$ === 2) {
            var settingsRoute = route.a;
            return settingsRoute;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Billing$CurrencyChanged = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Components$Billing$MonthlyPriceDataReceived = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Components$Billing$SubtotalChanged = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Components$Billing$TotalChanged = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Components$Billing$VatChanged = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Components$Billing$freqToString = function (pricingFrequency) {
        switch (pricingFrequency) {
            case 0:
                return "Year";
            case 1:
                return "Half-Year";
            default:
                return "Month";
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8 = $rtfeldman$elm_css$Css$property_fn("gap", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_lg = $rtfeldman$elm_css$Css$property_fn("max-width", "32rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_fit = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("min-width", "-webkit-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("min-width", "-moz-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("min-width", "fit-content")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0.5rem");
    var $author$project$Components$Billing$PriceData_fn = function (country, priceGross, priceNet, priceTax, priceTaxIncluded) {
        return { iX: country, b0: priceGross, a0: priceNet, b1: priceTax, ky: priceTaxIncluded };
    }, $author$project$Components$Billing$PriceData = F5($author$project$Components$Billing$PriceData_fn);
    var $author$project$Components$Billing$priceDataDecoder = _Json_map5_fn($author$project$Components$Billing$PriceData, _Json_decodeField_fn("country", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)), _Json_decodeField_fn("price", $elm$json$Json$Decode$maybe(_Json_decodeField_fn("gross", $elm$json$Json$Decode$string))), _Json_decodeField_fn("price", $elm$json$Json$Decode$maybe(_Json_decodeField_fn("net", $elm$json$Json$Decode$string))), _Json_decodeField_fn("price", $elm$json$Json$Decode$maybe(_Json_decodeField_fn("tax", $elm$json$Json$Decode$string))), _Json_decodeField_fn("price", $elm$json$Json$Decode$maybe(_Json_decodeField_fn("tax_included", $elm$json$Json$Decode$bool))));
    var $author$project$Components$Billing$toEditionAttribute = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("edition", $author$project$Types$Edition$isShared(model.ja) ? "pro" : "enterpriseCloud");
    };
    var $author$project$Types$Billing$toEmail = function (billing) {
        if (billing.$ === 1) {
            var emailAddress = billing.a.jc;
            return $elm$core$Maybe$Just(emailAddress);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Billing$HalfYearly = 1;
    var $author$project$Components$Billing$Monthly = 2;
    var $author$project$Components$Billing$PricingFrequencyChanged = function (a) {
        return { $: 5, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow = $rtfeldman$elm_css$Css$property_fn("flex-grow", "1");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_800 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "31", "41", "55", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_px = $rtfeldman$elm_css$Css$property_fn("height", "1px");
    var $author$project$Components$hairLine = function (styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_px,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$current),
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_Nil);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$inherit = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Keyword("inherit");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_outside = $rtfeldman$elm_css$Css$property_fn("list-style-position", "outside");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_16 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "4rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_6 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_8 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "1rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_l_md = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("border-bottom-left-radius", "0.375rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_r_md = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("border-bottom-right-radius", "0.375rem")
    ]));
    var $rtfeldman$elm_css$Html$Styled$strong_a0 = "strong", $rtfeldman$elm_css$Html$Styled$strong = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$strong_a0);
    var $author$project$Components$Billing$toEditionName = function (model) {
        return $author$project$Types$Edition$isShared(model.ja) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just("Enterprise Cloud");
    };
    var $rtfeldman$elm_css$Html$Styled$br_a0 = "br", $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$br_a0);
    var $rtfeldman$elm_css$Html$Styled$td_a0 = "td", $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$td_a0);
    var $author$project$PricingData$cell_fn = function (styles, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$td_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1
            ]), styles))
        ]), content);
    }, $author$project$PricingData$cell = F2($author$project$PricingData$cell_fn);
    var $author$project$PricingData$cellBold = function (contentStr) {
        return $author$project$PricingData$cell_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(contentStr)
        ]));
    };
    var $author$project$PricingData$cellLink_fn = function (route, contentStr) {
        return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(route))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(contentStr)
            ]))
        ]));
    }, $author$project$PricingData$cellLink = F2($author$project$PricingData$cellLink_fn);
    var $author$project$PricingData$cellStr = function (contentStr) {
        return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(contentStr)
        ]));
    };
    var $rtfeldman$elm_css$Html$Styled$small_a0 = "small", $rtfeldman$elm_css$Html$Styled$small = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$small_a0);
    var $author$project$PricingData$finePrint = function (txt) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(txt)
        ]));
    };
    var $rtfeldman$elm_css$Html$Styled$hr_a0 = "hr", $rtfeldman$elm_css$Html$Styled$hr = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$hr_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end = $rtfeldman$elm_css$Css$property_fn("justify-content", "flex-end");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "0.5rem")
    ]));
    var $author$project$PricingData$tableRows = _List_fromArray([
        {
            jd: _Utils_Tuple2("Unlimited", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("Unlimited", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("Fair-use policy", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Number of Databases", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("Fair-use policy", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("Unlimited", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("Unlimited", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("Fair-use policy", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Number of Users", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("Fair-use policy", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("GraphQL API", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u274C", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Cloud Functions", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Upload of CSV Files", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u274C", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Upload of SQLite Files", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Execute SQL queries", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("30 s (increasable on request)", function (_v0) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("30 s"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("10 s", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("SQL timeout", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("20 s", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("SQLite Views", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("\u2705", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\u274C", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Recursive SQLite Triggers", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\u274C", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("Dedicated Server", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("Self-hosted", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("Shared Server", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Deployment", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("Shared Server", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("<your-name>.airsequel.net", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("<your-custom-domain>", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("airsequel.com", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("URL", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("airsequel.com", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("1000", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("10", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Max Tables / Database", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("100", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("2000 (increasable on request)", function (_v1) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("2000"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("100", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Max Columns / Table", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("500", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("10\u202F000\u202F000 (increasable on request)", function (_v2) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("10\u202F000\u202F000"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("2000", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Max Rows / Table", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("100\u202F000", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$enterprise.fD) + " MB", function (txt) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(txt),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$free.fD) + " MB", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Maximum Database Size", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$pro.fD) + " MB", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$enterprise.fC) + " MB", function (txt) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(txt),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("Configurable", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$free.fC) + " MB", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Maximum Cell Size", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2($elm$core$String$fromInt($author$project$Config$pro.fC) + " MB", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("Daily (increasable on request)", function (_v3) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Daily"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $author$project$PricingData$finePrint("(increasable on request)")
                ]));
            }),
            je: _Utils_Tuple2("-", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("Daily", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Automatic Backups", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("Daily", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("All fly.io regions", function (_v4) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDDE9\uD83C\uDDEA DE, Nuremberg"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDDE9\uD83C\uDDEA DE, Falkenstein"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDDEB\uD83C\uDDEE FI, Helsinki"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDDFA\uD83C\uDDF8 US, Virginia, Ashburn"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDDFA\uD83C\uDDF8 US, Oregon, Hillsboro"),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDF0D All "),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href("https://fly.io/docs/reference/regions/"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank")
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("fly.io regions")
                    ])),
                    $rtfeldman$elm_css$Html$Styled$text(" on request")
                ]));
            }),
            je: _Utils_Tuple2("\uD83C\uDF0D Anywhere", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("\uD83C\uDDE9\uD83C\uDDEA DE, Nuremberg", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Available Locations", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("\uD83C\uDDE9\uD83C\uDDEA DE, Nuremberg", $author$project$PricingData$cellStr)
        },
        {
            jd: _Utils_Tuple2("Email, Phone", $author$project$PricingData$cellStr),
            je: _Utils_Tuple2("Email, Phone, On-site", $author$project$PricingData$cellStr),
            jr: _Utils_Tuple2("Self-serve Docs", $author$project$PricingData$cellStr),
            fx: _Utils_Tuple2("Support", $author$project$PricingData$cellBold),
            kz: _Utils_Tuple2("Email", $author$project$PricingData$cellStr)
        },
        function () {
            var mailSubject = "Request Trial Instance";
            var mailBody = "Dear Airsequel Team,\n                        I am interested in experimenting with\n                        a trial instance of the Enterprise Cloud.\n                        Best Regards!\n                        ";
            var contactSalesCell = function (txt) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href("mailto:sales@feram.io?subject=" + ($elm$url$Url$percentEncode(mailSubject) + ("&body=" + $elm$url$Url$percentEncode(mailBody)))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(txt)
                    ]))
                ]));
            };
            return {
                jd: _Utils_Tuple2("Start 30 day trial", $author$project$PricingData$cellLink($author$project$Route$Trial)),
                je: _Utils_Tuple2("Request trial instance", contactSalesCell),
                jr: _Utils_Tuple2("-", $author$project$PricingData$cellStr),
                fx: _Utils_Tuple2("Trial", $author$project$PricingData$cellBold),
                kz: _Utils_Tuple2("-", $author$project$PricingData$cellStr)
            };
        }(),
        function () {
            var signupButton = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href("/signup"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_3,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.na)
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Sign Up")
            ]));
            var mailSubject = "Request Offer";
            var mailBody = function (tier) {
                return "Dear Airsequel Team,\n            we are interested in a commercial deployment\n            of the Airsequel " + (tier + ".\n            Company: [PLEASE SPECIFY]\n            Industry: [PLEASE SPECIFY]\n            Number of users: [PLEASE SPECIFY]\n            Usage scenario: [PLEASE SPECIFY]\n            Best Regards!\n            ");
            };
            var requestOffer = F2(function (tier, txt) {
                return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href("mailto:sales@feram.io?subject=" + ($elm$url$Url$percentEncode(mailSubject) + ("&body=" + $elm$url$Url$percentEncode(mailBody(tier))))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(txt)
                    ]))
                ]));
            });
            return {
                jd: _Utils_Tuple2("Request offer", requestOffer("Enterprise Cloud")),
                je: _Utils_Tuple2("Request offer", requestOffer("Enterprise Server")),
                jr: _Utils_Tuple2("Free", function (str) {
                    return $author$project$PricingData$cell_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text(str)
                            ])),
                            signupButton
                        ]))
                    ]));
                }),
                fx: _Utils_Tuple2("Price", $author$project$PricingData$cellBold),
                kz: _Utils_Tuple2("", function (_v5) {
                    return $author$project$PricingData$cell_fn(_List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$strong_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("4.1 $")
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                        $author$project$PricingData$finePrint(" / month / team"),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                        $author$project$PricingData$finePrint("when paid anually"),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$hr_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_px,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2
                            ]))
                        ]), _List_Nil),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$strong_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("4.5 $")
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                        $author$project$PricingData$finePrint(" / month / team"),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                        $author$project$PricingData$finePrint("when paid monthly"),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$hr_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_px,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2
                            ]))
                        ]), _List_Nil),
                        signupButton
                    ]));
                })
            };
        }()
    ]);
    var $author$project$PricingData$enterpriseCloudTableRows = $elm$core$List$map_fn(function (row) {
        return _Utils_Tuple2(row.fx.a, row.jd.a);
    }, $author$project$PricingData$tableRows);
    var $author$project$PricingData$proTableRows = $elm$core$List$map_fn(function (row) {
        return _Utils_Tuple2(row.fx.a, row.kz.a);
    }, $author$project$PricingData$tableRows);
    var $author$project$Components$Billing$toPricingRows = function (model) {
        return $author$project$Types$Edition$isShared(model.ja) ? $author$project$PricingData$proTableRows : $author$project$PricingData$enterpriseCloudTableRows;
    };
    var $author$project$Components$Billing$viewInformationPanel_fn = function (toMsg, model, styles) {
        var highlightButtonFor = function (freq) {
            return _Utils_eq(freq, model.al) ? _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_800),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold
            ]) : _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
            ]);
        };
        var freqToNetFmt = function (frequency) {
            return function () {
                switch (frequency) {
                    case 0:
                        return $elm$core$Maybe$withDefault_fn("-", model.aV.a0);
                    case 1:
                        return $elm$core$Maybe$withDefault_fn("-", model.aU.a0);
                    default:
                        return $elm$core$Maybe$withDefault_fn("-", model.aJ.a0);
                }
            }() + (" " + $elm$core$Maybe$withDefault_fn("", model.cV));
        };
        var freqToGrossFmt = function (frequency) {
            return function () {
                switch (frequency) {
                    case 0:
                        return $elm$core$Maybe$withDefault_fn("-", model.aV.b0);
                    case 1:
                        return $elm$core$Maybe$withDefault_fn("-", model.aU.b0);
                    default:
                        return $elm$core$Maybe$withDefault_fn("-", model.aJ.b0);
                }
            }() + (" " + $elm$core$Maybe$withDefault_fn("", model.cV));
        };
        var calcDiscountForFreq = function (frequency) {
            var priceToFloat = function (price) {
                return $elm$core$Maybe$map_fn(function (n) {
                    return n / 100;
                }, $elm$core$String$toFloat(_String_filter_fn(function (c) {
                    return (c >= "0") && (c <= "9");
                }, price)));
            };
            var fmtDiscount = function (discount) {
                return function (n) {
                    return "~ " + (n + " %");
                }($elm$core$String$fromInt($elm$core$Basics$floor(discount)));
            };
            var calcDiscount = F2(function (numMonths, comparisonPriceStringMb) {
                var priceMonthlyFloatMb = $elm$core$Maybe$andThen_fn(priceToFloat, model.aJ.a0);
                var comparisonPriceMb = $elm$core$Maybe$andThen_fn($elm$core$String$toFloat, comparisonPriceStringMb);
                var _v2 = _Utils_Tuple2(priceMonthlyFloatMb, comparisonPriceMb);
                if ((!_v2.a.$) && (!_v2.b.$)) {
                    var priceMonthlyFloat = _v2.a.a;
                    var comparisonPrice = _v2.b.a;
                    var discount = (1 - (comparisonPrice / (numMonths * priceMonthlyFloat))) * 100;
                    return (discount > 0) ? discount : 0;
                }
                else {
                    return 0;
                }
            });
            switch (frequency) {
                case 0:
                    return fmtDiscount(A2(calcDiscount, 12, model.aV.a0));
                case 1:
                    return fmtDiscount(A2(calcDiscount, 6, model.aU.a0));
                default:
                    return "0 %";
            }
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
        ]), _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (edition) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_6]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Airsequel " + (edition + " Subscription"))
                ]));
            }, $author$project$Components$Billing$toEditionName(model)),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_outside, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]))
            ]), $elm$core$List$map_fn(function (row) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(row.a + ": ")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$strong_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(row.b)
                    ]))
                ]));
            }, $elm$core$List$filter_fn(function (row) {
                return !$elm$core$List$member_fn(row.a, _List_fromArray(["Price", "Trial", "Available Locations"]));
            }, $author$project$Components$Billing$toPricingRows(model)))),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Payment Frequency")
                ])),
                function () {
                    var buttonStyles = function (add) {
                        return _Utils_ap(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$inherit)
                        ]), add);
                    };
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_16, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(buttonStyles(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_l_md])), highlightButtonFor(0))),
                            $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$Components$Billing$PricingFrequencyChanged(0)))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Yearly")
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(buttonStyles(_List_Nil), highlightButtonFor(1))),
                            $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$Components$Billing$PricingFrequencyChanged(1)))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Half-Yearly")
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(buttonStyles(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_r_md])), highlightButtonFor(2))),
                            $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$Components$Billing$PricingFrequencyChanged(2)))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Monthly")
                        ]))
                    ]));
                }()
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _Utils_ap((model.al !== 2) ? _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Discount on monthly pricing")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(calcDiscountForFreq(model.al))
                    ]))
                ])),
                $author$project$Components$hairLine(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4
                ]))
            ]) : _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Subtotal")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(freqToNetFmt(model.al) + (" / " + $author$project$Components$Billing$freqToString(model.al)))
                    ]))
                ])),
                $author$project$Components$hairLine(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("VAT")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(function () {
                            var _v0 = model.al;
                            switch (_v0) {
                                case 0:
                                    return $elm$core$Maybe$withDefault_fn("-", model.aV.b1);
                                case 1:
                                    return $elm$core$Maybe$withDefault_fn("-", model.aU.b1);
                                default:
                                    return $elm$core$Maybe$withDefault_fn("-", model.aJ.b1);
                            }
                        }() + (" " + ($elm$core$Maybe$withDefault_fn("", model.cV) + (" / " + $author$project$Components$Billing$freqToString(model.al)))))
                    ]))
                ])),
                $author$project$Components$hairLine(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Total")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(freqToGrossFmt(model.al) + (" / " + $author$project$Components$Billing$freqToString(model.al)))
                    ]))
                ]))
            ])))
        ]));
    }, $author$project$Components$Billing$viewInformationPanel = F3($author$project$Components$Billing$viewInformationPanel_fn);
    var $author$project$Components$Billing$view_fn = function (toMsg, styles, maybeBilling, model) {
        var onMonthlyPriceDataReceived = $rtfeldman$elm_css$Html$Styled$Events$on_fn("monthlyPriceDataReceived", _Json_map1_fn(toMsg, _Json_map1_fn($author$project$Components$Billing$MonthlyPriceDataReceived, _Json_decodeField_fn("data", $author$project$Components$Billing$priceDataDecoder))));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_4xl,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $author$project$Components$Billing$viewInformationPanel_fn(toMsg, model, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_fit])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "checkout-container"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_lg, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto]))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn("checkout-elem", _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("pricing-frequency", $author$project$Components$Billing$freqToString(model.al)),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$attribute("email"), $elm$core$Maybe$andThen_fn($author$project$Types$Billing$toEmail, maybeBilling)),
                $author$project$Components$Billing$toEditionAttribute(model),
                onMonthlyPriceDataReceived,
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("subtotalChanged", _Json_map1_fn(toMsg, _Json_map1_fn($author$project$Components$Billing$SubtotalChanged, _Json_decodeField_fn("data", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$float))))),
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("vatChanged", _Json_map1_fn(toMsg, _Json_map1_fn($author$project$Components$Billing$VatChanged, _Json_decodeField_fn("data", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$float))))),
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("totalChanged", _Json_map1_fn(toMsg, _Json_map1_fn($author$project$Components$Billing$TotalChanged, _Json_decodeField_fn("data", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$float))))),
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("currencyChanged", _Json_map1_fn(toMsg, _Json_map1_fn($author$project$Components$Billing$CurrencyChanged, _Json_decodeField_fn("data", $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)))))
            ]), _List_Nil)
        ]));
    }, $author$project$Components$Billing$view = F4($author$project$Components$Billing$view_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2 = $rtfeldman$elm_css$Css$property_fn("row-gap", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_12 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "3rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_auto = $rtfeldman$elm_css$Css$property_fn("overflow-x", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_900 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "30", "58", "138", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $elm_community$string_extra$String$Extra$leftOfBack_fn = function (pattern, string) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (a) {
            return $elm$core$String$left_fn(a, string);
        }, $elm$core$List$head($elm$core$List$reverse(_String_indexes_fn(pattern, string)))));
    }, $elm_community$string_extra$String$Extra$leftOfBack = F2($elm_community$string_extra$String$Extra$leftOfBack_fn);
    var $author$project$Types$Utc$toDateTimeString_a0 = $author$project$Types$Utc$toString, $author$project$Types$Utc$toDateTimeString_a1 = A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "T", " "), $elm_community$string_extra$String$Extra$leftOfBack(":")), $author$project$Types$Utc$toDateTimeString = A2($elm$core$Basics$composeR, $author$project$Types$Utc$toDateTimeString_a0, $author$project$Types$Utc$toDateTimeString_a1);
    var $author$project$Components$dateTimeWithTooltip_fn = function (styles, utcString) {
        var formatDateTime = A2($elm$core$Basics$composeR, $author$project$Types$Utc$toDateTimeString, A2($author$project$Util$flip, $elm$core$String$append, " Z"));
        return A2($author$project$Components$wrapWithTitleTooltip, $author$project$Types$Utc$toString(utcString), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(formatDateTime(utcString))
        ])));
    }, $author$project$Components$dateTimeWithTooltip = F2($author$project$Components$dateTimeWithTooltip_fn);
    var $basti1302$elm_human_readable_filesize$Filesize$Base10 = 0;
    var $basti1302$elm_human_readable_filesize$Filesize$defaultSettings = { gH: 2, fb: ".", eS: 0 };
    var $basti1302$elm_human_readable_filesize$Filesize$base10UnitList = _List_fromArray([
        { aj: "B", af: 1 },
        { aj: "kB", af: 1000 },
        { aj: "MB", af: 1000000 },
        { aj: "GB", af: 1000000000 },
        { aj: "TB", af: 1000000000000 },
        { aj: "PB", af: 1000000000000000 },
        { aj: "EB", af: 1000000000000000000 }
    ]);
    var $basti1302$elm_human_readable_filesize$Filesize$base2UnitList = _List_fromArray([
        { aj: "B", af: 1 },
        { aj: "KiB", af: 1024 },
        { aj: "MiB", af: 1048576 },
        { aj: "GiB", af: 1073741824 },
        { aj: "TiB", af: 1099511627776 },
        { aj: "PiB", af: 1125899906842624 }
    ]);
    var $basti1302$elm_human_readable_filesize$Filesize$getUnitDefinitionList = function (units) {
        if (!units) {
            return $basti1302$elm_human_readable_filesize$Filesize$base10UnitList;
        }
        else {
            return $basti1302$elm_human_readable_filesize$Filesize$base2UnitList;
        }
    };
    var $basti1302$elm_human_readable_filesize$Filesize$decimalSeparatorRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("\\."));
    var $myrho$elm_round$Round$floor_a0 = F2(function (signed, str) {
        var _v0 = $elm$core$String$uncons(str);
        if (_v0.$ === 1) {
            return false;
        }
        else {
            if ("0" === _v0.a.a) {
                var _v1 = _v0.a;
                var rest = _v1.b;
                return signed && $elm$core$List$any_fn($elm$core$Basics$neq("0"), $elm$core$String$toList(rest));
            }
            else {
                return signed;
            }
        }
    }), $myrho$elm_round$Round$floor = $myrho$elm_round$Round$roundFun($myrho$elm_round$Round$floor_a0);
    var $basti1302$elm_human_readable_filesize$Filesize$removeTrailingZeroesRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^(\\d+\\.[^0]*)(0+)$"));
    var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
    var $basti1302$elm_human_readable_filesize$Filesize$roundToDecimalPlaces_fn = function (settings, num) {
        var rounded = $myrho$elm_round$Round$roundFun_fn($myrho$elm_round$Round$floor_a0, settings.gH, num);
        var withoutTrailingZeroes = _Regex_replaceAtMost_fn(1, $basti1302$elm_human_readable_filesize$Filesize$removeTrailingZeroesRegex, function (_v1) {
            var submatches = _v1.o$;
            return $elm$core$String$join_fn("", $elm$core$List$map_fn($elm$core$Maybe$withDefault(""), $elm$core$List$take_fn(1, submatches)));
        }, rounded);
        var withoutTrailingDot = _String_endsWith_fn(".", withoutTrailingZeroes) ? $elm$core$String$dropRight_fn(1, withoutTrailingZeroes) : withoutTrailingZeroes;
        return (settings.fb === ".") ? withoutTrailingDot : _Regex_replaceAtMost_fn(1, $basti1302$elm_human_readable_filesize$Filesize$decimalSeparatorRegex, function (_v0) {
            return settings.fb;
        }, withoutTrailingDot);
    }, $basti1302$elm_human_readable_filesize$Filesize$roundToDecimalPlaces = F2($basti1302$elm_human_readable_filesize$Filesize$roundToDecimalPlaces_fn);
    var $basti1302$elm_human_readable_filesize$Filesize$unknownUnit = { aj: "?", af: 1 };
    var $basti1302$elm_human_readable_filesize$Filesize$formatWithSplit_fn = function (settings, num) {
        if (!num) {
            return _Utils_Tuple2("0", "B");
        }
        else {
            var unitDefinitionList = $basti1302$elm_human_readable_filesize$Filesize$getUnitDefinitionList(settings.eS);
            var _v0 = (num < 0) ? _Utils_Tuple2(-num, "-") : _Utils_Tuple2(num, "");
            var num2 = _v0.a;
            var negativePrefix = _v0.b;
            var unitDefinition = $elm$core$Maybe$withDefault_fn($basti1302$elm_human_readable_filesize$Filesize$unknownUnit, $elm$core$List$head($elm$core$List$reverse($elm$core$List$filter_fn(function (unitDef) {
                return _Utils_cmp(num2, unitDef.af) > -1;
            }, unitDefinitionList))));
            var formattedNumber = $basti1302$elm_human_readable_filesize$Filesize$roundToDecimalPlaces_fn(settings, num2 / unitDefinition.af);
            return _Utils_Tuple2(_Utils_ap(negativePrefix, formattedNumber), unitDefinition.aj);
        }
    }, $basti1302$elm_human_readable_filesize$Filesize$formatWithSplit = F2($basti1302$elm_human_readable_filesize$Filesize$formatWithSplit_fn);
    var $basti1302$elm_human_readable_filesize$Filesize$format = function (num) {
        var _v0 = $basti1302$elm_human_readable_filesize$Filesize$formatWithSplit_fn($basti1302$elm_human_readable_filesize$Filesize$defaultSettings, num);
        var size = _v0.a;
        var unit = _v0.b;
        return size + (" " + unit);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll = $rtfeldman$elm_css$Css$property_fn("overflow-x", "scroll");
    var $author$project$Components$simpleTable_fn = function (cfg, items) {
        var toRow = function (item) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row,
                    $author$project$Theme$theme.bN.kJ,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_cell, $author$project$Theme$theme.bN.e2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2]))
                    ]))
                ]))
            ]), cfg.mY(item));
        };
        var rows = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row_group]))
        ]), $elm$core$List$map_fn(toRow, items));
        var headers = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_header_group,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_row,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_cell, $author$project$Theme$theme.bN.e2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2]))
                    ]))
                ]))
            ]), $elm$core$List$map_fn(function (header) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(header)
                ]));
            }, cfg.d9))
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$table_auto, $author$project$Theme$theme.bN.kZ, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll]))
        ]), _List_fromArray([headers, rows]));
    }, $author$project$Components$simpleTable = F2($author$project$Components$simpleTable_fn);
    var $author$project$Pages$Admin$Databases$viewDatabases = function () {
        var toRightAligned = A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right]))
        ])));
        var toLink = F2(function (label, route) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath(route)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_900),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(label)
            ]));
        });
        return A2($elm$core$Basics$composeR, $elm$core$List$sortBy(A2($elm$core$Basics$composeR, function ($) {
            return $.lW;
        }, $author$project$Types$Utc$toString)), A2($elm$core$Basics$composeR, $elm$core$List$reverse, $author$project$Components$simpleTable({
            d9: _List_fromArray(["ID", "Name", "Created", "Modified", "Tables", "Size", "Owner"]),
            mY: function (database) {
                return _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text($author$project$Types$Database$unwrapId(database.bR))
                    ])),
                    A2(toLink, database.mw, $author$project$Route$Database(database.bR)),
                    $author$project$Components$dateTimeWithTooltip_fn(_List_Nil, database.lW),
                    $author$project$Components$dateTimeWithTooltip_fn(_List_Nil, database.m0),
                    toRightAligned($rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromInt($elm$core$List$length(database.eH)))),
                    toRightAligned($rtfeldman$elm_css$Html$Styled$text($basti1302$elm_human_readable_filesize$Filesize$format(database.oS))),
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Unassigned")
                    ])), function (owner) {
                        return A2(toLink, owner, $author$project$Route$Teams($author$project$Pages$Teams$Route$Overview(owner)));
                    }, database.ob)
                ]);
            }
        })));
    }();
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "2rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "2rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_10 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "2.5rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "2.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "1rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "1.25rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "1.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_wrap = $rtfeldman$elm_css$Css$property_fn("white-space", "pre-wrap");
    var $author$project$Components$wrapWithErrorDiv = function (body) {
        return _Utils_eq(body, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_10, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_5])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_wrap,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$break_words
            ]))
        ]), body);
    };
    var $author$project$Components$wrapErrorsStyled_fn = function (styles, errors) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Components$wrapWithErrorDiv)), errors));
    }, $author$project$Components$wrapErrorsStyled = F2($author$project$Components$wrapErrorsStyled_fn);
    var $author$project$Components$wrapErrors = function (errors) {
        return _Utils_eq(errors, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text("") : $author$project$Components$wrapErrorsStyled_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8]), errors);
    };
    var $author$project$Pages$Admin$Databases$view = function (model) {
        var _v0 = model.l1;
        switch (_v0.$) {
            case 0:
                return $author$project$Components$pageSpinner;
            case 1:
                return $author$project$Components$pageSpinner;
            case 2:
                var errors = _v0.a;
                return $author$project$Components$wrapErrors(errors);
            default:
                var _v1 = _v0.a;
                var databases = _v1.a;
                var numberOfDatabases = _v1.b;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_12,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_auto,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Databases "),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium
                            ]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text($author$project$Util$flip_fn($elm$core$String$append, ")", _String_append_fn("(", $elm$core$String$join_fn(" / ", $elm$core$List$map_fn($elm$core$String$fromInt, $elm_community$list_extra$List$Extra$unique(_List_fromArray([
                                $elm$core$List$length(databases),
                                numberOfDatabases
                            ])))))))
                        ]))
                    ])),
                    $author$project$Pages$Admin$Databases$viewDatabases(databases)
                ]));
        }
    };
    var $author$project$Pages$Admin$Settings$SettingsEditApplied = { $: 5 };
    var $author$project$Pages$Admin$Settings$EnvVarEditorOpened = function (a) {
        return { $: 6, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("max-width", "-webkit-min-content"),
        $rtfeldman$elm_css$Css$property_fn("max-width", "-moz-min-content"),
        $rtfeldman$elm_css$Css$property_fn("max-width", "min-content")
    ]));
    var $author$project$Components$addEntryButton = function (onClick) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button"),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(onClick),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min,
                $author$project$Theme$theme.kX,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
                ])),
                $rtfeldman$elm_css$Css$active(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
                ]))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Add")
        ]));
    };
    var $author$project$Svg$edit = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87\n                M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("row-gap", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_4 = $rtfeldman$elm_css$Css$property_fn("row-gap", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6 = $rtfeldman$elm_css$Css$property_fn("height", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_full = $rtfeldman$elm_css$Css$property_fn("max-width", "100%");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_hidden = $rtfeldman$elm_css$Css$property_fn("overflow-y", "hidden");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2 = $rtfeldman$elm_css$Css$property_fn("padding-left", "0.5rem");
    var $author$project$Svg$trash = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z\n                M19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$editableRows = function (cfg) {
        var stringToCell = F2(function (maybeHref, styles) {
            var toOptionalLink = function (element) {
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(element, function (url) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href(url),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$inherit),
                            $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                        ]))
                    ]), _List_fromArray([element]));
                }, maybeHref);
            };
            return A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 4)),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 12)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ])), toOptionalLink)));
        });
        var firstRow = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, cfg.hh, $elm$core$List$head(cfg.aZ));
        var numericColumns = $elm$core$List$filter_fn(function (idx) {
            return $elm$core$List$all_fn(function (item) {
                return $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Maybe$andThen_fn($elm$core$String$toInt, $elm_community$list_extra$List$Extra$getAt_fn(idx, cfg.hh(item))));
            }, cfg.aZ);
        }, A2($elm_community$list_extra$List$Extra$findIndices, A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm_community$maybe_extra$Maybe$Extra$isJust), firstRow));
        var itemToRow = function (item) {
            var maybeHref = function (idxCol) {
                return $elm_community$maybe_extra$Maybe$Extra$join($elm_community$list_extra$List$Extra$getAt_fn(idxCol, cfg.mW(item)));
            };
            var editButton = $elm$core$Maybe$map_fn(function (onEdit) {
                return $author$project$Components$iconButton({
                    bA: $author$project$Svg$edit,
                    a_: onEdit(item),
                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2]),
                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
                });
            }, cfg.ki);
            var deleteButton = $elm$core$Maybe$map_fn(function (onDelete) {
                return $author$project$Components$iconButton({
                    bA: $author$project$Svg$trash,
                    a_: onDelete(item),
                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2]),
                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
                });
            }, cfg.kg);
            var addRowButtons = function (columns) {
                return $elm$core$List$append_fn(columns, $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([editButton, deleteButton])));
            };
            return addRowButtons($elm$core$List$indexedMap_fn(function (idxCol) {
                return A2(stringToCell, maybeHref(idxCol), _List_fromArray([
                    $author$project$Util$styleIf_fn($elm$core$List$member_fn(idxCol, numericColumns), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right)
                ]));
            }, cfg.hh(item)));
        };
        var columnsNeededForButtons = $elm$core$List$length($elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([cfg.ki, cfg.kg])));
        var columnsNeeded = $elm$core$List$length(firstRow) + columnsNeededForButtons;
        var addHeaders = function () {
            var toHeader = function (_v1) {
                return A2(stringToCell, $elm$core$Maybe$Nothing, _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_hidden,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none
                ]));
            };
            var buttonColumnHeaders = function (_v0) {
                return $elm$core$List$repeat_fn(columnsNeededForButtons, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50)
                    ]))
                ]), _List_Nil));
            };
            return _Utils_eq(cfg.aZ, _List_Nil) ? $elm$core$Basics$identity : $elm$core$List$append($author$project$Util$flip_fn($elm$core$List$append, buttonColumnHeaders(0), $elm$core$List$map_fn(toHeader(0), cfg.d9)));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_4]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_0_dot_5,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "repeat(" + ($elm$core$String$fromInt(columnsNeeded) + ", min-content)")),
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$button_a0, _List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                        ]))
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]))
            ]), addHeaders($elm$core$List$concatMap_fn(itemToRow, cfg.aZ))),
            $author$project$Components$addEntryButton(cfg.nH)
        ]));
    };
    var $author$project$Pages$Admin$Settings$environment_fn = function (toMsg, model) {
        return _List_fromArray([
            $author$project$Components$contentDetailed_fn("Environment Variables", "Manage environment variables for your server.", _List_fromArray([
                $author$project$Components$editableRows({
                    d9: _List_fromArray(["created utc", "key", "value"]),
                    mW: $elm$core$Basics$always(_List_Nil),
                    hh: function (_v0) {
                        var createdAt = _v0.iZ;
                        var name = _v0.M;
                        var value = _v0.pB;
                        return _List_fromArray([createdAt, name, value]);
                    },
                    aZ: _List_sortBy_fn(function ($) {
                        return $.iZ;
                    }, model.aL.gQ),
                    nH: toMsg($author$project$Pages$Admin$Settings$EnvVarEditorOpened($elm$core$Maybe$Nothing)),
                    kg: $elm$core$Maybe$Just(function (envVar) {
                        return toMsg($author$project$Pages$Admin$Settings$SettingsEditModified($author$project$Types$ServerSettings$setEnvVars_fn(model.aL, $elm$core$List$filter_fn($elm$core$Basics$neq(envVar), model.aL.gQ))));
                    }),
                    ki: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$EnvVarEditorOpened, toMsg)))
                })
            ]))
        ]);
    }, $author$project$Pages$Admin$Settings$environment = F2($author$project$Pages$Admin$Settings$environment_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_gradient_to_t = $rtfeldman$elm_css$Css$property_fn("background-image", "linear-gradient(to top, var(--tw-gradient-stops))");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_0 = $rtfeldman$elm_css$Css$property_fn("bottom", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse = $rtfeldman$elm_css$Css$property_fn("visibility", "collapse");
    var $matheus23$elm_tailwind_modules_base$Tailwind$Color$withOpacity_fn = function (opacity, color) {
        if (color.$ === 1) {
            var k = color.a;
            return $matheus23$elm_tailwind_modules_base$Tailwind$Color$Keyword(k);
        }
        else {
            var mode = color.a;
            var r = color.b;
            var g = color.c;
            var b = color.d;
            return $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn(mode, r, g, b, opacity);
        }
    }, $matheus23$elm_tailwind_modules_base$Tailwind$Color$withOpacity = F2($matheus23$elm_tailwind_modules_base$Tailwind$Color$withOpacity_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$from_color = function (color) {
        return $rtfeldman$elm_css$Css$batch(_List_fromArray([
            $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("--tw-gradient-from", function (c) {
                return c;
            }, $elm$core$Maybe$Nothing, color),
            $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("--tw-gradient-to", function (c) {
                return c;
            }, $elm$core$Maybe$Nothing, $matheus23$elm_tailwind_modules_base$Tailwind$Color$withOpacity_fn($matheus23$elm_tailwind_modules_base$Tailwind$Color$Opacity("0"), color)),
            $rtfeldman$elm_css$Css$property_fn("--tw-gradient-stops", "var(--tw-gradient-from), var(--tw-gradient-to)")
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_12 = $rtfeldman$elm_css$Css$property_fn("height", "3rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_8 = $rtfeldman$elm_css$Css$property_fn("padding-bottom", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_8 = $rtfeldman$elm_css$Css$property_fn("padding-right", "2rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$sticky = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("position", "-webkit-sticky"),
        $rtfeldman$elm_css$Css$property_fn("position", "sticky")
    ]));
    var $author$project$Components$formSubmitFooter_fn = function (maybeOnCancel, disabled_, errors) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$sticky, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_0]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_12,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_gradient_to_t,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$from_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                ]))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50)
                ]))
            ]), _List_fromArray([
                $author$project$Components$wrapErrors(errors)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50)
                ]))
            ]), _List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($author$project$Components$textButton, _List_fromArray([
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse]))
                ]), "Discard Changes"), maybeOnCancel),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $author$project$Theme$theme.kW,
                        $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Save")
                ]))
            ]))
        ]));
    }, $author$project$Components$formSubmitFooter = F3($author$project$Components$formSubmitFooter_fn);
    var $author$project$Types$ServerSettings$allowedHostsRegex = "(?:^|\\s)((https?:\\/\\/)?(?:localhost|[\\w-]+(?:\\.[\\w-]+)+)(:\\d+)?(\\/\\S*)?)";
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-left", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-right", "0.5rem")
    ]));
    var $elm_community$list_extra$List$Extra$setAt_fn = function (index, value) {
        return A2($elm_community$list_extra$List$Extra$updateAt, index, $elm$core$Basics$always(value));
    }, $elm_community$list_extra$List$Extra$setAt = F2($elm_community$list_extra$List$Extra$setAt_fn);
    var $author$project$Components$listInput = function (cfg) {
        var toEntry = F2(function (idx, item) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, item),
                    $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeL, cfg.fN, A2($author$project$Util$flip, $elm_community$list_extra$List$Extra$setAt(idx), cfg.aZ))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                    $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), $rtfeldman$elm_css$Html$Styled$Attributes$pattern, cfg.kt),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none
                    ]))
                ]), _List_Nil),
                $author$project$Components$iconButton({
                    bA: $author$project$Svg$trash,
                    a_: cfg.fN($elm_community$list_extra$List$Extra$removeAt_fn(idx, cfg.aZ)),
                    m: _List_Nil,
                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
                })
            ]));
        });
        var toEntries = $rtfeldman$elm_css$Html$Styled$fieldset(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 24)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4
            ]))
        ]));
        return toEntries($author$project$Util$flip_fn($elm$core$List$append, _List_fromArray([
            $author$project$Components$addEntryButton(cfg.fN($author$project$Util$flip_fn($elm$core$List$append, _List_fromArray([""]), cfg.aZ)))
        ]), $elm$core$List$indexedMap_fn(toEntry, cfg.aZ)));
    };
    var $author$project$Pages$Admin$Settings$functions_fn = function (toMsg, model) {
        return _List_fromArray([
            $author$project$Components$contentDetailed_fn("Allowed Hosts", "Specify allowed hosts for your functions.", _List_fromArray([
                $author$project$Components$listInput({
                    aZ: model.aL.iD,
                    fN: A2($elm$core$Basics$composeR, $author$project$Types$ServerSettings$setAllowedHosts(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$SettingsEditModified, toMsg)),
                    kt: $elm$core$Maybe$Just($author$project$Types$ServerSettings$allowedHostsRegex)
                })
            ]))
        ]);
    }, $author$project$Pages$Admin$Settings$functions = F2($author$project$Pages$Admin$Settings$functions_fn);
    var $author$project$Pages$Admin$Settings$unsavedChanges = function (model) {
        return !_Utils_eq($elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.kR), $elm$core$Maybe$Just($author$project$Types$ServerSettings$sanitize(model.aL)));
    };
    var $author$project$Pages$Admin$Settings$content_fn = function (toMsg, maybeRoute, shared, model) {
        var separator = $author$project$Components$hairLine(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$form_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onSubmit(toMsg($author$project$Pages$Admin$Settings$SettingsEditApplied)),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
        ]), _Utils_ap($elm$core$List$intersperse_fn(separator, function () {
            if (maybeRoute.$ === 1) {
                return $author$project$Pages$Admin$Settings$functions_fn(toMsg, model);
            }
            else {
                if (!maybeRoute.a) {
                    var _v1 = maybeRoute.a;
                    return $author$project$Pages$Admin$Settings$functions_fn(toMsg, model);
                }
                else {
                    var _v2 = maybeRoute.a;
                    return shared.aQ.mx.kP ? $author$project$Pages$Admin$Settings$environment_fn(toMsg, model) : _List_Nil;
                }
            }
        }()), _List_fromArray([
            $author$project$Components$formSubmitFooter_fn($elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Settings$SettingsEditModified, toMsg), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.kR)), !$author$project$Pages$Admin$Settings$unsavedChanges(model), model.eT)
        ])));
    }, $author$project$Pages$Admin$Settings$content = F4($author$project$Pages$Admin$Settings$content_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_5xl = $rtfeldman$elm_css$Css$property_fn("max-width", "64rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_2 = $rtfeldman$elm_css$Css$property_fn("margin-left", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_1 = $rtfeldman$elm_css$Css$property_fn("margin-right", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-left", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-right", "1rem")
    ]));
    var $rtfeldman$elm_css$Css$ellipsis = { k0: 0, pB: "ellipsis" };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_1_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "0.375rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "0px"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "0px")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_br_md = $rtfeldman$elm_css$Css$property_fn("border-bottom-right-radius", "0.375rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr_md = $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.375rem");
    var $rtfeldman$elm_css$Css$textOverflow_a0 = "text-overflow", $rtfeldman$elm_css$Css$textOverflow = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$textOverflow_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("width", "0.125rem");
    var $author$project$Components$pageMenu_fn = function (cfg, menuEntries) {
        var toNavigationLink = F2(function (title, route) {
            var isSelected = _Utils_eq(cfg.dW, $elm$core$Maybe$Just(route)) || (_Utils_eq(cfg.dW, $elm$core$Maybe$Nothing) && _Utils_eq(route, cfg.dM));
            var indicator = function () {
                var color = isSelected ? $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.dd) : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent);
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_0_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, color]))
                ]), _List_Nil);
            }();
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8]))
            ]), _List_fromArray([
                indicator,
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.gd(cfg.fL(route))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr_md,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_br_md,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                        ])),
                        $author$project$Util$styleIf_fn(isSelected, $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd)),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 14)),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$textOverflow_a0, $rtfeldman$elm_css$Css$ellipsis)
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]))
            ]));
        });
        var toSection = function (sectionEntrys) {
            return $elm$core$List$map_fn(function (_v2) {
                var title = _v2.a;
                var route = _v2.b;
                return A2(toNavigationLink, title, route);
            }, sectionEntrys);
        };
        var separator = $author$project$Components$hairLine(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_1_dot_5
        ]));
        var mobileNavigation = $author$project$Components$stringSelect({
            cP: _List_Nil,
            bR: $elm$core$Maybe$Just("page-menu-select"),
            cv: $elm$core$Maybe$Just(function (selected) {
                return cfg.gd(cfg.fL($elm$core$Maybe$withDefault_fn(cfg.dM, $elm_community$list_extra$List$Extra$findMap_fn(function (_v0) {
                    var title = _v0.a;
                    var route = _v0.b;
                    return _Utils_eq(title, selected) ? $elm$core$Maybe$Just(route) : $elm$core$Maybe$Nothing;
                }, $elm$core$List$concat(menuEntries)))));
            }),
            cx: $elm$core$List$map_fn($elm$core$Tuple$first, $elm$core$List$concat(menuEntries)),
            df: "",
            ev: function () {
                var routeWithDefault = $elm$core$Maybe$withDefault_fn(cfg.dM, cfg.dW);
                return $elm$core$Maybe$withDefault_fn("", $elm_community$list_extra$List$Extra$findMap_fn(function (_v1) {
                    var title = _v1.a;
                    var route = _v1.b;
                    return _Utils_eq(route, routeWithDefault) ? $elm$core$Maybe$Just(title) : $elm$core$Maybe$Nothing;
                }, $elm$core$List$concat(menuEntries)));
            }(),
            m: _List_fromArray([$author$project$Theme$theme.fu, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_full])
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg.cd)
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$nav_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                        $rtfeldman$elm_css$Css$batch(cfg.m),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                    ]))
                ]), $elm$core$List$concat($elm$core$List$intersperse_fn(_List_fromArray([separator]), $elm_community$list_extra$List$Extra$remove_fn(_List_Nil, $author$project$Util$flip_fn($elm$core$List$append, _List_fromArray([cfg.gw]), $elm$core$List$map_fn(toSection, menuEntries)))))),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$nav_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4
                    ]))
                ]), _List_fromArray([
                    mobileNavigation,
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                    ]), cfg.gw)
                ]))
            ]))
        ]));
    }, $author$project$Components$pageMenu = F2($author$project$Components$pageMenu_fn);
    var $author$project$Components$menuPage_fn = function (_v0, cfg) {
        var styles = _v0.m;
        var menuStyles = _v0.ht;
        var contentStyles = _v0.gC;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row])),
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $author$project$Components$pageMenu_fn({ dM: cfg.dM, gw: cfg.nl, dW: cfg.dW, cd: cfg.nm, fL: cfg.fL, m: menuStyles, gd: cfg.gd }, cfg.nn),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_0,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_4])),
                    $rtfeldman$elm_css$Css$batch(contentStyles)
                ]))
            ]), _List_fromArray([cfg.gB]))
        ]));
    }, $author$project$Components$menuPage = F2($author$project$Components$menuPage_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_12 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-top", "3rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-bottom", "3rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2over3 = $rtfeldman$elm_css$Css$property_fn("width", "66.666667%");
    var $author$project$Components$menuPageSmall_a0 = {
        gC: _List_Nil,
        ht: _List_Nil,
        m: _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_12,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2over3,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 40)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_5xl
            ])),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto
        ])
    }, $author$project$Components$menuPageSmall = $author$project$Components$menuPage($author$project$Components$menuPageSmall_a0);
    var $author$project$Components$EditorTitledOverlay$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $author$project$Pages$Admin$Settings$view_fn = function (toMsg, maybeRoute, shared, model) {
        var _v0 = model.kR;
        switch (_v0.$) {
            case 3:
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), _List_fromArray([
                    $author$project$Components$menuPage_fn($author$project$Components$menuPageSmall_a0, {
                        dM: 0,
                        gB: $author$project$Pages$Admin$Settings$content_fn(toMsg, maybeRoute, shared, model),
                        dW: maybeRoute,
                        nl: _List_Nil,
                        nm: $author$project$Pages$Admin$Settings$unsavedChanges(model),
                        nn: _List_fromArray([
                            $elm_community$list_extra$List$Extra$filterNot_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, $elm$core$Basics$eq("Environment"), $elm$core$Basics$and(!shared.aQ.mx.kP))), _List_fromArray([
                                _Utils_Tuple2("Functions", 0),
                                _Utils_Tuple2("Environment", 1)
                            ]))
                        ]),
                        fL: $author$project$Pages$Admin$Settings$Navigated,
                        gd: toMsg
                    }),
                    A2($author$project$Components$EditorTitledOverlay$view, toMsg, model.a$)
                ]));
            case 2:
                var errors = _v0.a;
                return $author$project$Components$wrapErrors(errors);
            default:
                return $author$project$Components$pageSpinner;
        }
    }, $author$project$Pages$Admin$Settings$view = F4($author$project$Pages$Admin$Settings$view_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_top = $rtfeldman$elm_css$Css$property_fn("vertical-align", "top");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_1 = $rtfeldman$elm_css$Css$property_fn("gap", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_items_center = $rtfeldman$elm_css$Css$property_fn("place-items", "center");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "0.375rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "0.375rem")
    ]));
    var $author$project$Components$badge_fn = function (title, maybeIcon, styles) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), maybeIcon),
            $rtfeldman$elm_css$Html$Styled$text(title)
        ]));
    }, $author$project$Components$badge = F3($author$project$Components$badge_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_500 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "34", "197", "94", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_500 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "234", "179", "8", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Components$environmentBadge = function (title) {
        var styles = function () {
            switch (title) {
                case "Testing":
                    return _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500)
                    ]);
                case "Staging":
                    return _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_500)
                    ]);
                case "Production":
                    return _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500)
                    ]);
                case "Template":
                    return _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_500)
                    ]);
                default:
                    return _List_Nil;
            }
        }();
        return $author$project$Components$badge_fn(title, $elm$core$Maybe$Nothing, styles);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_px = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "1px"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "1px")
    ]));
    var $rtfeldman$elm_css$Html$Styled$header_a0 = "header", $rtfeldman$elm_css$Html$Styled$header = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$header_a0);
    var $author$project$Types$Database$isPublic = function (remoteDatabase) {
        var maybeVisibility = $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.kR;
        }, function ($) {
            return $.pE;
        }), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, remoteDatabase));
        var hasNoDatabaseOwner = function () {
            var maybeDatabaseOwner = $elm$core$Maybe$andThen_fn(function ($) {
                return $.ob;
            }, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, remoteDatabase));
            return _Utils_eq(maybeDatabaseOwner, $elm$core$Maybe$Nothing);
        }();
        return hasNoDatabaseOwner || _Utils_eq(maybeVisibility, $elm$core$Maybe$Just(1));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_stretch = $rtfeldman$elm_css$Css$property_fn("align-items", "stretch");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4 = $rtfeldman$elm_css$Css$property_fn("margin-right", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_8 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "2rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "2rem")
    ]));
    var $author$project$Types$Database$toEnvironment_a0 = $krisajenkins$remotedata$RemoteData$toMaybe, $author$project$Types$Database$toEnvironment_a1 = $elm$core$Maybe$map(A2($elm$core$Basics$composeR, function ($) {
        return $.kR;
    }, function ($) {
        return $.mk;
    })), $author$project$Types$Database$toEnvironment = A2($elm$core$Basics$composeR, $author$project$Types$Database$toEnvironment_a0, $author$project$Types$Database$toEnvironment_a1);
    var $author$project$Svg$globe = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z\n                M4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12z\n                m13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$lock = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z\n                M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$DatabaseSettings$Visibility$toIcon_fn = function (attrs, visibility) {
        return function () {
            if (!visibility) {
                return $author$project$Svg$lock;
            }
            else {
                return $author$project$Svg$globe;
            }
        }()(attrs);
    }, $author$project$Types$DatabaseSettings$Visibility$toIcon = F2($author$project$Types$DatabaseSettings$Visibility$toIcon_fn);
    var $author$project$Components$mainHeader_fn = function (config, remoteDatabase) {
        var toEdition = function (editionName) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_normal,
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.2))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(editionName)
            ]));
        };
        var maybeEnvironment = $elm$core$Basics$composeR_fn($author$project$Types$Database$toEnvironment_a0, $author$project$Types$Database$toEnvironment_a1, remoteDatabase);
        var maybeDatabaseName = $elm$core$Maybe$map_fn(function ($) {
            return $.mw;
        }, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, remoteDatabase));
        var accessBadge = function () {
            var visibility = $author$project$Types$Database$isPublic(remoteDatabase) ? 1 : 0;
            return $author$project$Util$showElement_fn($krisajenkins$remotedata$RemoteData$isSuccess(remoteDatabase), $author$project$Components$badge_fn($elm_community$string_extra$String$Extra$toTitleCase($author$project$Types$DatabaseSettings$Visibility$toString(visibility)), $elm$core$Maybe$Just($author$project$Types$DatabaseSettings$Visibility$toIcon_fn(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4]))
            ]), visibility)), _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
            ])));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$header_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_stretch,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_4,
                    $author$project$Util$styleIf_fn($elm_community$maybe_extra$Maybe$Extra$isJust(maybeDatabaseName), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_px)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_3,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_top,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1_dot_5
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$Home)),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                            $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDF00Airsequel"),
                        function () {
                            var _v0 = config.mx.ja;
                            if (!_v0.$) {
                                if (!_v0.a.$) {
                                    var _v1 = _v0.a;
                                    return $rtfeldman$elm_css$Html$Styled$text("");
                                }
                                else {
                                    return toEdition("Pro");
                                }
                            }
                            else {
                                return toEdition("Enterprise");
                            }
                        }()
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_3,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn("", maybeDatabaseName))
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
                    ]), _List_fromArray([
                        accessBadge,
                        $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), $author$project$Components$environmentBadge, maybeEnvironment)
                    ]))
                ]))
            ]))
        ]));
    }, $author$project$Components$mainHeader = F2($author$project$Components$mainHeader_fn);
    var $author$project$Components$wrapTabsWithMain_fn = function (config, remoteDatabase, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$main__a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$lazy2_fn($author$project$Components$mainHeader, config, remoteDatabase),
            content
        ]));
    }, $author$project$Components$wrapTabsWithMain = F3($author$project$Components$wrapTabsWithMain_fn);
    var $author$project$Pages$Admin$viewTabs_fn = function (toMsg, route, shared, model) {
        return $author$project$Components$wrapTabsWithMain_fn(shared.aQ, $krisajenkins$remotedata$RemoteData$NotAsked, $author$project$TabView$tabView_fn({ gC: _List_Nil, mG: _List_Nil, nH: $elm$core$Maybe$Nothing, o5: _List_Nil, o6: _List_Nil }, model, _List_fromArray([
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always(false),
                fw: $elm$core$Basics$always($author$project$Pages$Admin$Route$isDatabasesRoute(route)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Admin($author$project$Pages$Admin$Route$Databases))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Databases",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.dZ;
                }, $author$project$Pages$Admin$Databases$view)
            },
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always(false),
                fw: $elm$core$Basics$always($author$project$Pages$Admin$Route$isSettingsRoute(route)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Admin($author$project$Pages$Admin$Route$Settings($elm$core$Maybe$Nothing)))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Settings",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.hY;
                }, A3($author$project$Pages$Admin$Settings$view, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$SettingsPageMsgReceived), $author$project$Pages$Admin$Route$toSettingsRoute(route), shared))
            },
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always($author$project$Types$Edition$isShared(shared.aQ.mx.ja)),
                fw: $elm$core$Basics$always($author$project$Pages$Admin$Route$isBillingRoute(route)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Admin($author$project$Pages$Admin$Route$Billing))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Billing",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.dP;
                }, $rtfeldman$elm_css$Html$Styled$Lazy$lazy(A3($author$project$Components$Billing$view, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Admin$BillingPageMsgReceived), _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto
                ]), $elm$core$Maybe$Nothing)))
            }
        ])));
    }, $author$project$Pages$Admin$viewTabs = F4($author$project$Pages$Admin$viewTabs_fn);
    var $author$project$Pages$Admin$view_fn = function (toMsg, route, shared, model) {
        switch (route.$) {
            case 0:
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $author$project$Pages$Admin$viewTabs_fn(toMsg, route, shared, model),
                    $author$project$Pages$Admin$home
                ]));
            case 1:
                return $author$project$Pages$Admin$viewTabs_fn(toMsg, route, shared, model);
            case 2:
                return $author$project$Pages$Admin$viewTabs_fn(toMsg, route, shared, model);
            default:
                return $author$project$Pages$Admin$viewTabs_fn(toMsg, route, shared, model);
        }
    }, $author$project$Pages$Admin$view = F4($author$project$Pages$Admin$view_fn);
    var $author$project$Pages$Affiliate$contactUsSection = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_lg,
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_600)
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline
            ])),
            $rtfeldman$elm_css$Html$Styled$Attributes$href("mailto:info@feram.io")
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Contact Us")
        ]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xs = $rtfeldman$elm_css$Css$property_fn("max-width", "20rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "2.5rem");
    var $author$project$Pages$Affiliate$exampleApps = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("\n                Here is list of services / apps that have been built, or\n                could potentially be built with Airsequel:\n                ")
        ])),
        function () {
            var tileStyle = $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xs,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
            ]));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Business Management")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Customer, inventory, and order management\n                    with dashboards and custom web-apps.\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("For Organizations")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    User databases, project management,\n                    campaign administration, \u2026\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Data Analysis")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Data cleaning, querying,\n                    and visualization\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Data Tracking")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Tracking inventory levels, schedules, customers,\n                    sales, or any other kind of data\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Workflows")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Execution of complex workflows\n                    with multiple steps and users\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("For Startups")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    MVPs, prototypes, and proof of concepts\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("For Educational Institutions")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Student performance monitoring, class schedules,\n                    management of other administrative data, \u2026\n                    ")
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("For Freelancers & Consultants")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                    Management of client data,\n                    time tracking, finance tracking, \u2026\n                    ")
                    ]))
                ]))
            ]));
        }()
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_8 = $rtfeldman$elm_css$Css$property_fn("padding", "2rem");
    var $author$project$Pages$Affiliate$heroBox = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_8,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10
        ]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_medium]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Join our affiliate program and earn a"),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(" 30% ")
            ])),
            $rtfeldman$elm_css$Html$Styled$text("commission for every contract you help us close.")
        ]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_8 = $rtfeldman$elm_css$Css$property_fn("margin-left", "2rem");
    var $rtfeldman$elm_css$Html$Styled$ol_a0 = "ol", $rtfeldman$elm_css$Html$Styled$ol = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$ol_a0);
    var $author$project$Pages$Affiliate$howItWorks = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("How it works")
        ])),
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ol_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_8]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("\n                    You introduce us to a potential client.\n                    We will get in touch with them and discuss their needs.\n                    ")
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("\n                    If they decide to work with us,\n                    we will send you a contract.\n                    ")
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("\n                    You sign the contract and send it back to us.\n                    ")
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("\n                    We will pay you\n                    "),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("30%")
                ])),
                $rtfeldman$elm_css$Html$Styled$text("\n                    of the contract value\n                    for the first year.\n                    ")
            ]))
        ]))
    ]));
    var $author$project$Components$aHrefText_fn = function (hrefStr, textStr) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$href("https://" + hrefStr),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(textStr)
        ]));
    }, $author$project$Components$aHrefText = F2($author$project$Components$aHrefText_fn);
    var $author$project$Components$bar = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$text(" | ")
    ]));
    var $rtfeldman$elm_css$Css$backgroundImage_a0 = "background-image", $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$backgroundImage_a0);
    var $rtfeldman$elm_css$Css$collectStops_a0 = function (_v0) {
        var c = _v0.a;
        var len = _v0.b;
        return _String_append_fn(c.pB, $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeL, $elm$core$String$cons(" "), function ($) {
            return $.pB;
        }), len)));
    }, $rtfeldman$elm_css$Css$collectStops = $elm$core$List$map($rtfeldman$elm_css$Css$collectStops_a0);
    var $rtfeldman$elm_css$Css$linearGradient2_fn = function (direction, firstStop, secondStop, otherStops) {
        return {
            cQ: 0,
            l: 0,
            pB: $rtfeldman$elm_css$Css$cssFunction_fn("linear-gradient", _List_Cons(direction.pB, $elm$core$List$map_fn($rtfeldman$elm_css$Css$collectStops_a0, _Utils_ap(_List_fromArray([firstStop, secondStop]), otherStops))))
        };
    }, $rtfeldman$elm_css$Css$linearGradient2 = F4($rtfeldman$elm_css$Css$linearGradient2_fn);
    var $rtfeldman$elm_css$Css$stop = function (c) {
        return _Utils_Tuple2(c, $elm$core$Maybe$Nothing);
    };
    var $rtfeldman$elm_css$Css$toRight = { br: 0, pB: "to right" };
    var $author$project$Util$buildTextGradient_fn = function (color1, color2) {
        return $rtfeldman$elm_css$Css$batch(_List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$backgroundImage_a0, $rtfeldman$elm_css$Css$linearGradient2_fn($rtfeldman$elm_css$Css$toRight, $rtfeldman$elm_css$Css$stop(color1), $rtfeldman$elm_css$Css$stop(color2), _List_Nil)),
            $rtfeldman$elm_css$Css$property_fn("background-clip", "text"),
            $rtfeldman$elm_css$Css$property_fn("-webkit-background-clip", "text"),
            $rtfeldman$elm_css$Css$property_fn("-webkit-text-fill-color", "transparent")
        ]));
    }, $author$project$Util$buildTextGradient = F2($author$project$Util$buildTextGradient_fn);
    var $rtfeldman$elm_css$Html$Styled$footer_a0 = "footer", $rtfeldman$elm_css$Html$Styled$footer = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$footer_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_3 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "0.75rem"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "0.75rem")
    ]));
    var $author$project$Route$isTeamsRoute = function (route) {
        if (route.$ === 9) {
            return true;
        }
        else {
            return false;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_16 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "4rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "4rem")
    ]));
    var $author$project$Components$line = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$hr_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_16,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_px,
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8))
        ]))
    ]), _List_Nil);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2 = $rtfeldman$elm_css$Css$property_fn("margin-right", "0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_10 = $rtfeldman$elm_css$Css$property_fn("margin-top", "2.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6 = $rtfeldman$elm_css$Css$property_fn("margin-top", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_16 = $rtfeldman$elm_css$Css$property_fn("padding-bottom", "4rem");
    var $author$project$Components$socialMediaLinks = _List_fromArray([
        $author$project$Components$aHrefText_fn("discord.gg/RCstvcdXxY", "Discord"),
        $author$project$Components$aHrefText_fn("matrix.to/#/%23airsequel:matrix.feram.io", "Matrix"),
        $author$project$Components$aHrefText_fn("reddit.com/r/Airsequel", "Reddit"),
        $author$project$Components$aHrefText_fn("github.com/Airsequel", "GitHub"),
        $author$project$Components$aHrefText_fn("twitter.com/Airsequel", "\uD835\uDD4F")
    ]);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_4xl = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "2.25rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "2.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1.5rem")
    ]));
    var $author$project$Components$wrapWithMain_fn = function (route, content) {
        var airsequelLinks = function (styles) {
            var toLinkTarget = F4(function (maybeTarget, title, url, customStyles) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$href(url),
                    $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$target, maybeTarget),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(styles, customStyles))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]));
            });
            var toLinkBlank = F2(function (title, url) {
                return A4(toLinkTarget, $elm$core$Maybe$Just("_blank"), title, url, _List_Nil);
            });
            var toLink = F2(function (title, url) {
                return A4(toLinkTarget, $elm$core$Maybe$Nothing, title, url, _List_Nil);
            });
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                A2(toLink, "Blog", "https://blog.airsequel.com"),
                A2(toLink, "Docs", "https://docs.airsequel.com"),
                A2(toLink, "Changelog", "https://docs.airsequel.com/changelog"),
                A4(toLinkTarget, $elm$core$Maybe$Nothing, "Pricing", "/pricing", _List_fromArray([
                    $author$project$Util$stylesIf_fn(_Utils_eq(route, $author$project$Route$Pricing), _List_fromArray([
                        $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$current)
                    ]))
                ])),
                A2(toLinkBlank, "Newsletter", "https://buttondown.email/Airsequel")
            ]));
        };
        var headerLinks = function (styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_3,
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.2)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8])),
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                airsequelLinks(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$current)
                    ]))
                ]))
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$main__a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_4xl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$header_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_12]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_4xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$href("/"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $author$project$Util$buildTextGradient_fn($author$project$Theme$theme.ho, $author$project$Theme$theme.dd),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2
                            ]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDF00Airsequel")
                        ]))
                    ])),
                    $author$project$Util$hideElement_fn($author$project$Route$isTeamsRoute(route), headerLinks(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_10])))
                ]))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1]))
            ]), content),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$footer_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_16,
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.6))
                ]))
            ]), _List_Cons($author$project$Components$line, _List_Cons($author$project$Util$showElement_fn($author$project$Route$isTeamsRoute(route), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                airsequelLinks(_List_fromArray([
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_2
                ])),
                $author$project$Components$bar
            ]))), _Utils_ap($author$project$Components$socialMediaLinks, _List_fromArray([
                $author$project$Components$bar,
                $author$project$Components$aHrefText_fn("status.airsequel.com/", "Status"),
                $author$project$Components$bar,
                $author$project$Components$aHrefText_fn("feram.io/imprint", "Imprint"),
                $author$project$Components$aHrefText_fn("feram.notion.site/Airsequel-Terms-of-Service" + "-5c256a8b44ff4b3ca77ee091dac16559", "Terms of Service"),
                $author$project$Components$aHrefText_fn("feram.notion.site/Airsequel-Privacy-Policy" + "-9d512ad4f9d94e5e8356482777c2e6f6", "Privacy Policy")
            ])))))
        ]));
    }, $author$project$Components$wrapWithMain = F2($author$project$Components$wrapWithMain_fn);
    var $author$project$Pages$Affiliate$view = function (model) {
        return $author$project$Components$wrapWithMain_fn(model.b.eu, _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_2xl]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Become our Affiliate Partner")
                    ])),
                    $author$project$Pages$Affiliate$heroBox,
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                        We are a software development company\n                        and we operate and maintain "),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$href("https://www.airsequel.com"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500)
                            ]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("airsequel.com")
                        ])),
                        $rtfeldman$elm_css$Html$Styled$text(". We are currently looking for\n                        new clients who want to use our services\n                        and build custom web applications, dashboards, tools,\n                        processes, and platforms on top of Airsequel.\n                        ")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("\n                        If necessary, we also include other\n                        technologies and third party services\n                        to implement the desired functionality.\n                        ")
                    ])),
                    $author$project$Pages$Affiliate$exampleApps,
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("\n                        Do you know someone\n                        who might be interested in our services?\n                        Friends or family? Business partners?\n                        We would love to get in touch with them!\n                        ")
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("\n                            If your introduction leads to a contract,\n                            you will receive a "),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("30%")
                            ])),
                            $rtfeldman$elm_css$Html$Styled$text(" commission\n                            on the value of the contract\n                            for the first year.\n                            ")
                        ]))
                    ])),
                    $author$project$Pages$Affiliate$howItWorks,
                    $author$project$Pages$Affiliate$contactUsSection
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$ForgotPassword$FormMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$ForgotPassword$FormSubmitted = function (a) {
        return { $: 2, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "191", "219", "254", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $dillonkearns$elm_form$Internal$Input$Email = { $: 9 };
    var $dillonkearns$elm_form$Form$Field$email = function (_v0) {
        var field = _v0.a;
        return $dillonkearns$elm_form$Internal$Field$Field_fn(field, $dillonkearns$elm_form$Internal$Input$Email);
    };
    var $author$project$Pages$ForgotPassword$ForgotPasswordForm = function (email) {
        return { jb: email };
    };
    var $author$project$Util$isValidEmailAddress_a0 = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([\\w-\\.]+(\\+\\w+)?)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$")), $author$project$Util$isValidEmailAddress = $elm$regex$Regex$contains($author$project$Util$isValidEmailAddress_a0);
    var $author$project$Pages$ForgotPassword$validateForm = function (email) {
        return $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, $dillonkearns$elm_form$Form$Validation$fromResult($dillonkearns$elm_form$Form$Validation$map_fn(A2($elm$core$Basics$composeR, $elm$core$Result$Ok, A2($elm_community$result_extra$Result$Extra$filter, "Invalid email address", $author$project$Util$isValidEmailAddress)), email)), $dillonkearns$elm_form$Form$Validation$succeed($author$project$Pages$ForgotPassword$ForgotPasswordForm));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "1rem"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "1rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_6 = $rtfeldman$elm_css$Css$property_fn("top", "1.5rem");
    var $author$project$Pages$ForgotPassword$viewErrors_fn = function (_v0, field) {
        var submitAttempted = _v0.o1;
        var errors = _v0.ml;
        var placeholder = function () {
            var zeroWidthString = $elm$core$String$fromChar("\u200B");
            return $rtfeldman$elm_css$Html$Styled$text(zeroWidthString);
        }();
        if (submitAttempted || $dillonkearns$elm_form$Form$Validation$statusAtLeast_fn(3, field)) {
            var _v1 = $dillonkearns$elm_form$Form$errorsForField_fn(field, errors);
            if (!_v1.b) {
                return placeholder;
            }
            else {
                var errorsForField = _v1;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto]))
                ]), $elm$core$List$map_fn(function (error) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(error)
                    ]));
                }, errorsForField));
            }
        }
        else {
            return placeholder;
        }
    }, $author$project$Pages$ForgotPassword$viewErrors = F2($author$project$Pages$ForgotPassword$viewErrors_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_200 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "187", "247", "208", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_300 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "134", "239", "172", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Components$wrapSuccess_fn = function (styles, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_700),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_wrap,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(content)
        ]));
    }, $author$project$Components$wrapSuccess = F2($author$project$Components$wrapSuccess_fn);
    var $author$project$Pages$ForgotPassword$viewForm_fn = function (model, email, formState) {
        var wrapErrors = F2(function (styles, errors) {
            return _Utils_eq(errors, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), $elm$core$List$map_fn($author$project$Components$wrapSuccess(_List_fromArray([
                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
            ])), errors));
        });
        var toField = F2(function (title, field) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
                ]), _List_fromArray([
                    $dillonkearns$elm_form$Form$FieldView$inputStyled_fn(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200)
                        ]))
                    ]), field),
                    $author$project$Pages$ForgotPassword$viewErrors_fn(formState, field)
                ]))
            ]));
        });
        return _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "min-content 1fr"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2
                ]))
            ]), _List_fromArray([
                A2(toField, "Email", email)
            ])),
            function () {
                var _v0 = model.bs;
                if (_v0.$ === 3) {
                    return $author$project$Components$wrapSuccess_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]), "Password reset link sent! Check your mailbox.");
                }
                else {
                    return $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_6]), formState.o2, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, model.fA || $krisajenkins$remotedata$RemoteData$isLoading(model.bs)),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                            $author$project$Theme$theme.kX,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                            $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default]))
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Reset Password")
                    ])));
                }
            }(),
            A2(wrapErrors, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]), function () {
                var _v1 = model.bs;
                if (_v1.$ === 2) {
                    var errors = _v1.a;
                    return errors;
                }
                else {
                    return _List_Nil;
                }
            }())
        ]);
    }, $author$project$Pages$ForgotPassword$viewForm = F3($author$project$Pages$ForgotPassword$viewForm_fn);
    var $author$project$Pages$ForgotPassword$form = function (model) {
        return $dillonkearns$elm_form$Form$field_fn("email", $dillonkearns$elm_form$Form$Field$required_fn("Enter your email address", $dillonkearns$elm_form$Form$Field$email($dillonkearns$elm_form$Form$Field$text)), $dillonkearns$elm_form$Form$form(function (email) {
            return {
                lT: $author$project$Pages$ForgotPassword$validateForm(email),
                gl: A2($author$project$Pages$ForgotPassword$viewForm, model, email)
            };
        }));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_md = $rtfeldman$elm_css$Css$property_fn("max-width", "28rem");
    var $author$project$Pages$ForgotPassword$view = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_md]))
            ]))
        ]), _List_fromArray([
            $dillonkearns$elm_form$Form$renderStyledHtml_fn({
                h7: model.d6,
                o2: $krisajenkins$remotedata$RemoteData$isLoading(model.bs),
                gd: $author$project$Pages$ForgotPassword$FormMsg
            }, $dillonkearns$elm_form$Form$withOnSubmit_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.oc;
            }, $author$project$Pages$ForgotPassword$FormSubmitted), $dillonkearns$elm_form$Form$options("log-in")), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_50)
                ]))
            ]), $author$project$Pages$ForgotPassword$form(model))
        ]));
    };
    var $author$project$Pages$Home$CreateEmptyDB = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Home$DragEntered = { $: 2 };
    var $author$project$Pages$Home$DragLeft = { $: 3 };
    var $author$project$Pages$Home$FileSelected_fn = function (a, b, c) {
        return { $: 7, a: a, b: b, c: c };
    }, $author$project$Pages$Home$FileSelected = F3($author$project$Pages$Home$FileSelected_fn);
    var $author$project$Pages$Home$FileSelectorOpened_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $author$project$Pages$Home$FileSelectorOpened = F2($author$project$Pages$Home$FileSelectorOpened_fn);
    var $author$project$Pages$Home$OpenQueryEditor_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Home$OpenQueryEditor = F2($author$project$Pages$Home$OpenQueryEditor_fn);
    var $author$project$Pages$Home$ShowErrors = function (a) {
        return { $: 8, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$alt_a0 = "alt", $rtfeldman$elm_css$Html$Styled$Attributes$alt = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0);
    var $author$project$Types$UploadType$isCreateFromQuery = function (uploadType) {
        if (uploadType.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_5 = $rtfeldman$elm_css$Css$property_fn("line-height", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "1.25rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "1.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_9 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("padding-left", "2.25rem"),
        $rtfeldman$elm_css$Css$property_fn("padding-right", "2.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl = $rtfeldman$elm_css$Css$property_fn("border-radius", "0.75rem");
    var $author$project$Components$uploadButton_fn = function (title, maybeOnclick, maybePercent, disabled_, styles) {
        return $author$project$Components$progressButton_fn(title, maybeOnclick, maybePercent, disabled_, _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3,
            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_9, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4])),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold,
            $rtfeldman$elm_css$Css$batch(styles)
        ]));
    }, $author$project$Components$uploadButton = F5($author$project$Components$uploadButton_fn);
    var $author$project$Components$createDbButton_fn = function (title, onClick, maybeUpload, styles) {
        return $author$project$Components$uploadButton_fn(title, onClick, $elm$core$Maybe$andThen_fn(function ($) {
            return $.fT;
        }, maybeUpload), $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.gh;
        }, A2($elm$core$Basics$composeR, $author$project$Types$UploadType$isCreateFromQuery, $elm$core$Basics$not)), maybeUpload)), _List_Cons($rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho), styles));
    }, $author$project$Components$createDbButton = F4($author$project$Components$createDbButton_fn);
    var $author$project$Types$UploadType$isCreateEmpty = function (uploadType) {
        if (!uploadType.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Components$createEmptyDbButton_fn = function (onClick, maybeUpload, maybeTeam, styles) {
        return $author$project$Components$uploadButton_fn("Create Empty DB", $elm$core$Maybe$Just(A2(onClick, $author$project$Types$UploadType$CreateEmpty, maybeTeam)), $elm$core$Maybe$andThen_fn(function ($) {
            return $.fT;
        }, maybeUpload), $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.gh;
        }, A2($elm$core$Basics$composeR, $author$project$Types$UploadType$isCreateEmpty, $elm$core$Basics$not)), maybeUpload)), _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base,
            $rtfeldman$elm_css$Css$batch(styles)
        ]));
    }, $author$project$Components$createEmptyDbButton_fn_unwrapped = function (onClick, maybeUpload, maybeTeam, styles) {
        return $author$project$Components$uploadButton_fn("Create Empty DB", $elm$core$Maybe$Just(onClick($author$project$Types$UploadType$CreateEmpty, maybeTeam)), $elm$core$Maybe$andThen_fn(function ($) {
            return $.fT;
        }, maybeUpload), $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.gh;
        }, A2($elm$core$Basics$composeR, $author$project$Types$UploadType$isCreateEmpty, $elm$core$Basics$not)), maybeUpload)), _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base,
            $rtfeldman$elm_css$Css$batch(styles)
        ]));
    }, $author$project$Components$createEmptyDbButton = F4($author$project$Components$createEmptyDbButton_fn);
    var $rtfeldman$elm_css$Css$dashed = { aP: 0, cD: 0, pB: "dashed" };
    var $elm$file$File$decoder = _File_decoder;
    var $author$project$Types$UploadType$fileTypeFromMime = function (mime) {
        switch (mime) {
            case "application/vnd.sqlite3":
                return $elm$core$Maybe$Just(0);
            case "application/x-sqlite3":
                return $elm$core$Maybe$Just(0);
            case "":
                return $elm$core$Maybe$Just(0);
            case "text/csv":
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow_0 = $rtfeldman$elm_css$Css$property_fn("flex-grow", "0");
    var $author$project$Types$UploadType$isInitialUploadCsv = function (uploadType) {
        if ((uploadType.$ === 2) && (uploadType.a === 1)) {
            var _v1 = uploadType.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$UploadType$isInitialUploadSqlite = function (uploadType) {
        if ((uploadType.$ === 2) && (!uploadType.a)) {
            var _v1 = uploadType.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xl = $rtfeldman$elm_css$Css$property_fn("max-width", "36rem");
    var $elm$file$File$mime = _File_mime;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_9 = $rtfeldman$elm_css$Css$property_fn("margin-top", "2.25rem");
    var $elm$json$Json$Decode$oneOrMoreHelp_fn = function (toValue, xs) {
        if (!xs.b) {
            return $elm$json$Json$Decode$fail("a ARRAY with at least ONE element");
        }
        else {
            var y = xs.a;
            var ys = xs.b;
            return $elm$json$Json$Decode$succeed(A2(toValue, y, ys));
        }
    }, $elm$json$Json$Decode$oneOrMoreHelp_fn_unwrapped = function (toValue, xs) {
        if (!xs.b) {
            return $elm$json$Json$Decode$fail("a ARRAY with at least ONE element");
        }
        else {
            var y = xs.a;
            var ys = xs.b;
            return $elm$json$Json$Decode$succeed(toValue(y, ys));
        }
    }, $elm$json$Json$Decode$oneOrMoreHelp = F2($elm$json$Json$Decode$oneOrMoreHelp_fn);
    var $elm$json$Json$Decode$oneOrMore_fn = function (toValue, decoder) {
        return _Json_andThen_fn($elm$json$Json$Decode$oneOrMoreHelp(toValue), $elm$json$Json$Decode$list(decoder));
    }, $elm$json$Json$Decode$oneOrMore = F2($elm$json$Json$Decode$oneOrMore_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4 = $rtfeldman$elm_css$Css$property_fn("padding-top", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_2xl = $rtfeldman$elm_css$Css$property_fn("border-radius", "1rem");
    var $author$project$Components$databaseInitPanel = function (cfg) {
        var dropArea = function () {
            var unrestricted = $elm$core$Basics$composeR_fn($author$project$Types$Edition$notShared_a0, $author$project$Types$Edition$notShared_a1, cfg.ja) || $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, $author$project$Types$Team$isPro, cfg.eh);
            var dropDecoder = $elm$json$Json$Decode$at_fn(_List_fromArray(["dataTransfer", "files"]), $elm$json$Json$Decode$oneOrMore_fn(F2(function (file, _v0) {
                return $elm$core$Maybe$withDefault_fn(cfg.nT(_Utils_Tuple2("Error", "Unsupported file type")), $elm$core$Maybe$map_fn(function (fileType) {
                    return A3(cfg.n1, $author$project$Types$UploadType$Initial(fileType), cfg.eh, file);
                }, $author$project$Types$UploadType$fileTypeFromMime($elm$file$File$mime(file))));
            }), $elm$file$File$decoder));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop3_fn($rtfeldman$elm_css$Css$border3_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 3), $rtfeldman$elm_css$Css$dashed, cfg.mR ? $author$project$Theme$theme.dd : $rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_2xl,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xl,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_9,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "drop-area"),
                A2($author$project$Util$preventDefaultOn, "dragenter", cfg.kh),
                A2($author$project$Util$preventDefaultOn, "dragover", cfg.kh),
                A2($author$project$Util$preventDefaultOn, "dragleave", cfg.nR),
                $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("drop", _Json_map1_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, true), dropDecoder))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
                ]), _List_fromArray([
                    $author$project$Util$showElement_fn(unrestricted, $author$project$Components$uploadButton_fn("Upload SQLite Database", $elm$core$Maybe$Just($author$project$Util$flip_fn(cfg.km, cfg.eh, $author$project$Types$UploadType$Initial(0))), $elm$core$Maybe$andThen_fn(function ($) {
                        return $.fT;
                    }, cfg.ct), $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                        return $.gh;
                    }, A2($elm$core$Basics$composeR, $author$project$Types$UploadType$isInitialUploadSqlite, $elm$core$Basics$not)), cfg.ct)), _List_fromArray([
                        $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho)
                    ]))),
                    $author$project$Components$uploadButton_fn("Upload CSV File", $elm$core$Maybe$Just($author$project$Util$flip_fn(cfg.km, cfg.eh, $author$project$Types$UploadType$Initial(1))), $elm$core$Maybe$andThen_fn(function ($) {
                        return $.fT;
                    }, cfg.ct), $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                        return $.gh;
                    }, A2($elm$core$Basics$composeR, $author$project$Types$UploadType$isInitialUploadCsv, $elm$core$Basics$not)), cfg.ct)), _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $author$project$Components$wrapErrors(cfg.ml),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("\u2026 or drag & drop it here")
                ]))
            ]));
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            $author$project$Util$showElement_fn(cfg.i1, $author$project$Components$createDbButton_fn("New SQLite DB From AI Prompt", cfg.j$($elm$core$Maybe$Nothing), cfg.ct, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))),
            $author$project$Util$showElement_fn(cfg.i1, $author$project$Components$createDbButton_fn("New DB From SQL Query", cfg.j$($elm$core$Maybe$Just(false)), cfg.ct, _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6
            ]))),
            $author$project$Components$createEmptyDbButton_fn(cfg.nO, cfg.ct, cfg.eh, _List_Nil),
            dropArea
        ]));
    };
    var $author$project$Pages$Home$exampleDatabaseButton = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$DuplicateReadonly($author$project$Types$Database$wrapId($author$project$Config$exampleDbId))))
    ]), _List_fromArray([
        $author$project$Components$uploadButton_fn("Open Demo Database", $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, false, _List_fromArray([
            $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho)
        ]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_nowrap = $rtfeldman$elm_css$Css$property_fn("flex-wrap", "nowrap");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row_reverse = $rtfeldman$elm_css$Css$property_fn("flex-direction", "row-reverse");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_16 = $rtfeldman$elm_css$Css$property_fn("gap", "4rem");
    var $rtfeldman$elm_css$Html$Styled$img_a0 = "img", $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$img_a0);
    var $author$project$Svg$ai = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7z\n                m12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14z\n                M22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5z\n                m-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96\n                    c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0\n                    L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35z\n                m-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle = $rtfeldman$elm_css$Css$property_fn("vertical-align", "middle");
    var $author$project$Svg$barChart = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M4 9h4v11H4zm12 4h4v7h-4zm-6-9h4v16h-4z")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$function = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2\n                    c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2\n                    c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7\n                    c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7z\n                m17 3c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3\n                    c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34\n                    c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3\n                    c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_600 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "22", "163", "74", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_normal = $rtfeldman$elm_css$Css$property_fn("line-height", "1.5");
    var $rtfeldman$elm_css$Css$letterSpacing_a0 = "letter-spacing", $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$letterSpacing_a0);
    var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
        return $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn("src", url);
    };
    var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap_a0 = "stroke-linecap", $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap_a0);
    var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin_a0 = "stroke-linejoin", $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin_a0);
    var $author$project$Svg$tableCells = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "1 1 22 22"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth_a0, "1.5"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$stroke_a0, "currentColor"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "none"), attributes)))), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap_a0, "round"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin_a0, "round"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M3.375 19.5h17.25\n                m-17.25 0a1.125 1.125 0 01-1.125-1.125\n                M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125\n                m-9.75 0V5.625\n                m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125\n                m18.375 2.625V5.625\n                m0 12.75c0 .621-.504 1.125-1.125 1.125\n                m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125\n                m0 3.75h-7.5A1.125 1.125 0 0112 18.375\n                m9.75-12.75c0-.621-.504-1.125-1.125-1.125\n                    H3.375c-.621 0-1.125.504-1.125 1.125\n                m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125\n                M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125\n                m0 0h17.25\n                m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125\n                M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5\n                    c0 .621.504 1.125 1.125 1.125\n                m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125\n                m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5\n                    c0 .621-.504 1.125-1.125 1.125\n                m-17.25 0h7.5\n                m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5\n                    c0 .621.504 1.125 1.125 1.125\n                M12 10.875v-1.5\n                m0 1.5c0 .621-.504 1.125-1.125 1.125\n                M12 10.875c0 .621.504 1.125 1.125 1.125\n                m-2.25 0c.621 0 1.125.504 1.125 1.125\n                M13.125 12h7.5\n                m-7.5 0c-.621 0-1.125.504-1.125 1.125\n                M20.625 12c.621 0 1.125.504 1.125 1.125v1.5\n                    c0 .621-.504 1.125-1.125 1.125\n                m-17.25 0h7.5\n                M12 14.625v-1.5\n                m0 1.5c0 .621-.504 1.125-1.125 1.125\n                M12 14.625c0 .621.504 1.125 1.125 1.125\n                m-2.25 0c.621 0 1.125.504 1.125 1.125\n                m0 1.5v-1.5\n                m0 0c0-.621.504-1.125 1.125-1.125\n                m0 0h7.5\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_5xl = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("font-size", "3rem"),
        $rtfeldman$elm_css$Css$property_fn("line-height", "1")
    ]));
    var $author$project$Pages$Home$introSection = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center]))
    ]), _List_fromArray([
        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$letterSpacing_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, -0.04))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_4xl,
                    $author$project$Util$buildTextGradient_fn($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0), $rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.3)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_5xl]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Launch Your Data")
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_normal,
                    $author$project$Util$buildTextGradient_fn($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.3), $rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.4)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_3xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$leading_normal]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$src("images/graphql.svg"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "GraphQL Icon")
                ]), _List_Nil),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Automatic GraphQL API")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$src("images/sqlite.svg"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "SQLite Icon")
                ]), _List_Nil),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("SQLite Workbench")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $author$project$Svg$tableCells(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_600),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Spreadsheet UI")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $author$project$Svg$function(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Cloud Functions")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $author$project$Svg$barChart(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Dashboards")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                $author$project$Svg$ai(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_middle
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("AI Enhanced")
                ]))
            ]))
        ]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$lg = $rtfeldman$elm_css$Css$Media$withMediaQuery(_List_fromArray(["(min-width: 1024px)"]));
    var $rtfeldman$elm_css$Css$marginLeft_a0 = "margin-left", $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$marginLeft_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_3xl = $rtfeldman$elm_css$Css$property_fn("max-width", "48rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_20 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_28 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "7rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_32 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "8rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_12 = $rtfeldman$elm_css$Css$property_fn("margin-top", "3rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_7 = $rtfeldman$elm_css$Css$property_fn("padding-top", "1.75rem");
    var $author$project$Components$AiEditorOverlay$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_64 = $rtfeldman$elm_css$Css$property_fn("width", "16rem");
    var $author$project$Pages$Home$view_fn = function (maybeUpload, uploadErrors, maybeUser, shared, model) {
        var welcomeMessage = function (_v2) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                    $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Welcome to Airsequel Enterprise")
                ])),
                $author$project$Util$showElement_fn(_Utils_eq(maybeUser, $elm$core$Maybe$Nothing), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Please log in to manage your databases")
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$Login))
                    ]), _List_fromArray([
                        $author$project$Components$uploadButton_fn("Go To Login Page", $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, false, _List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_12,
                            $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho)
                        ]))
                    ]))
                ])))
            ]));
        };
        var databaseInitPanel = function (_v1) {
            return $author$project$Components$databaseInitPanel({
                i1: shared.aQ.mx.i1,
                ja: shared.aQ.mx.ja,
                ml: uploadErrors,
                mR: model.mR,
                j$: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Pages$Home$OpenQueryEditor($elm$core$Maybe$Nothing)),
                eh: $elm$core$Maybe$Nothing,
                ct: maybeUpload,
                nO: function (_v0) {
                    return $author$project$Pages$Home$CreateEmptyDB;
                },
                kh: $author$project$Pages$Home$DragEntered,
                nR: $author$project$Pages$Home$DragLeft,
                nT: $author$project$Pages$Home$ShowErrors,
                km: $author$project$Pages$Home$FileSelectorOpened,
                n1: $author$project$Pages$Home$FileSelected,
                m: _List_Nil
            });
        };
        return _Utils_eq(shared.aQ.mx.ja, $author$project$Types$Edition$Dedicated) ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$main__a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_3xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_7, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_16, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_sm, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]))
        ]), _List_fromArray([
            A2($author$project$Components$AiEditorOverlay$view, $elm$core$Basics$identity, model.bD),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_3xl,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_4xl])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_16
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $author$project$Util$buildTextGradient_fn($author$project$Theme$theme.ho, $author$project$Theme$theme.dd),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("\uD83C\uDF00Airsequel")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_normal,
                        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.2))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Enterprise")
                ]))
            ])),
            welcomeMessage(0),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$footer_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700),
                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8))
                ]))
            ]), $author$project$Components$socialMediaLinks)
        ])) : $author$project$Components$wrapWithMain_fn(shared.eu, _List_fromArray([
            A2($author$project$Components$AiEditorOverlay$view, $elm$core$Basics$identity, model.bD),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_16,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $rtfeldman$elm_css$Css$onlyChild(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto]))
                    ]))
                ]), _List_fromArray([$author$project$Pages$Home$introSection, $author$project$Pages$Home$exampleDatabaseButton])),
                $author$project$Util$showElement_fn(_Utils_eq(maybeUser, $elm$core$Maybe$Nothing), databaseInitPanel(0))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_20]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$lg(_List_fromArray([
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 130)),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$marginLeft_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, -15))
                        ]))
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/2023-08-21t203319_multi_device.webp")
                ]), _List_Nil)
            ])),
            function () {
                var sectionCss = function (extend) {
                    return $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_28,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_16,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_nowrap]))
                    ]), extend));
                };
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_Nil)
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Instant GraphQL API")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Automatically provides\n                            a full fledged GraphQL API\n                            for each of your tables.\n                            No coding necessary!\n                            ")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Access the API with thousands of\n                            tools and libraries, which already\n                            have full GraphQL support.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Diagram of SQL to GraphQL conversion"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/sql_to_graphql.png"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row_reverse]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("AI Powered SQL Query Generation")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Utilize AI to effortlessly generate SQL queries.\n                            Simplify data retrieval and elevate your analytics\n                            with minimal manual input.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Screenshot of SQL editor"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/ai_powered_query_generation.png"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_Nil)
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Visualize Your Data")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Create beautiful charts and dashboards\n                            with our intuitive chart editor\n                            and dashboard builder.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Screenshot of chart editor"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/chart_editor.png"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row_reverse]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("SQLite - The Ultimate Database")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            SQLite is the most deployed database\n                            for good reason:\n                            It's fast, stable, self-contained, highly reliable,\n                            fully-featured, supported until at least 2050,\n                            and the only database recommended\n                            by the US Library of Congress\n                            for long-term archival.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Online transactions"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/online_transactions.svg"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_Nil)
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Cloud Functions")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Run your own TypeScript and Python code\n                            with our built-in cloud functions.\n\n                            Use them to automate tasks,\n                            create custom APIs,\n                            or implement complex business logic.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Online transactions"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/function_workflow.svg"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row_reverse]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Get Started Quickly")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Upload your CSV file or SQLite database\n                            and have a GraphQL API available in mere seconds.\n                            Build applications faster than ever before!\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Person launching a rocket"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/rocket_launch.svg"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        sectionCss(_List_Nil)
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Flexible Deployment")
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            Either use our hosted cloud offering\n                            or deploy Airsequel on your own hardware.\n                            Packaged as a single binary, you can deploy\n                            Airsequel anywhere or even\n                            embed it in your own applications.\n                            ")
                            ]))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$img_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$alt_a0, "Deployment options"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$src("/images/deployment_options.svg"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 24))
                            ]))
                        ]), _List_Nil)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_32, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_16]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("What can you do with Airsequel?")
                        ])),
                        function () {
                            var tileStyle = $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xs,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_64
                            ]));
                            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Business Management")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Simplify customer, inventory,\n                                and order management\n                                with custom tables, dashboards,\n                                and web-apps.\n                                ")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Data Analysis")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Streamline data cleaning, querying,\n                                and visualization\n                                for efficient and organized\n                                data analysis processes.\n                                ")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Non-profit Organizations")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Manage donor databases, project progress,\n                                and fundraising campaigns\n                                with tailored data management\n                                and visualization solutions.\n                                ")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Educational Institutions")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Monitor student performance, class schedules,\n                                and other administrative data\n                                with user-friendly dashboards\n                                and analysis tools.\n                                ")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Data Tracking")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Track inventory levels, schedules, customers,\n                                sales, or any other kind of data\n                                with intuitive dashboards\n                                and efficient data management tools.\n                                ")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([tileStyle]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Freelancers & Consultants")
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                Organize client data, project milestones,\n                                and financial information\n                                with personalized dashboards\n                                and easy-to-use data manipulation tools.\n                                ")
                                    ]))
                                ]))
                            ]));
                        }(),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$href("https://docs.airsequel.com/tutorials"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.ho),
                                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                                    $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.na)
                                ])),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 1.2))
                            ]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("View Tutorials")
                        ]))
                    ]))
                ]));
            }()
        ]));
    }, $author$project$Pages$Home$view = F5($author$project$Pages$Home$view_fn);
    var $author$project$Pages$Login$FormMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Login$FormSubmitted = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_form$Internal$Input$Password = { $: 8 };
    var $dillonkearns$elm_form$Form$Field$password = function (_v0) {
        var field = _v0.a;
        return $dillonkearns$elm_form$Internal$Field$Field_fn(field, $dillonkearns$elm_form$Internal$Input$Password);
    };
    var $author$project$Pages$Login$LoginForm_fn = function (username, password) {
        return { kr: password, lb: username };
    }, $author$project$Pages$Login$LoginForm = F2($author$project$Pages$Login$LoginForm_fn);
    var $author$project$Pages$Login$validateForm_fn = function (username, password) {
        return $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, password, $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, username, $dillonkearns$elm_form$Form$Validation$succeed($author$project$Pages$Login$LoginForm)));
    }, $author$project$Pages$Login$validateForm = F2($author$project$Pages$Login$validateForm_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_fit = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("height", "-webkit-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("height", "-moz-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("height", "fit-content")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_8 = $rtfeldman$elm_css$Css$property_fn("margin-top", "-2rem");
    var $author$project$Pages$Login$viewErrors_fn = function (_v0, field) {
        var submitAttempted = _v0.o1;
        var errors = _v0.ml;
        var placeholder = function () {
            var zeroWidthString = $elm$core$String$fromChar("\u200B");
            return $rtfeldman$elm_css$Html$Styled$text(zeroWidthString);
        }();
        if (submitAttempted || $dillonkearns$elm_form$Form$Validation$statusAtLeast_fn(3, field)) {
            var _v1 = $dillonkearns$elm_form$Form$errorsForField_fn(field, errors);
            if (!_v1.b) {
                return placeholder;
            }
            else {
                var errorsForField = _v1;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto]))
                ]), $elm$core$List$map_fn(function (error) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(error)
                    ]));
                }, errorsForField));
            }
        }
        else {
            return placeholder;
        }
    }, $author$project$Pages$Login$viewErrors = F2($author$project$Pages$Login$viewErrors_fn);
    var $author$project$Pages$Login$viewForm_fn = function (model, username, password, formState) {
        var wrapErrors = F2(function (styles, errors) {
            return _Utils_eq(errors, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), $elm$core$List$map_fn($author$project$Components$wrapSuccess(_List_fromArray([
                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
            ])), errors));
        });
        var toField = F2(function (title, field) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
                ]), _List_fromArray([
                    $dillonkearns$elm_form$Form$FieldView$inputStyled_fn(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200)
                        ]))
                    ]), field),
                    $author$project$Pages$Login$viewErrors_fn(formState, field)
                ]))
            ]));
        });
        var forgotPasswordLink = function () {
            var linkDisabled = model.fA || (model.bd || formState.o2);
            var toLink = $rtfeldman$elm_css$Html$Styled$a(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_fit,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $author$project$Util$styleIf_fn(linkDisabled, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$ForgotPassword)),
                linkDisabled ? $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1) : $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0)
            ]));
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_Nil),
                toLink(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Forgot Password?")
                ]))
            ]));
        }();
        return _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "min-content 1fr"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2
                ]))
            ]), _List_fromArray([
                A2(toField, "Username", username),
                A2(toField, "Password", password),
                forgotPasswordLink
            ])),
            $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_6]), formState.o2, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, model.fA || model.bd),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $author$project$Theme$theme.kX,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Log In")
            ]))),
            A2(wrapErrors, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]), model.dh)
        ]);
    }, $author$project$Pages$Login$viewForm = F4($author$project$Pages$Login$viewForm_fn);
    var $author$project$Pages$Login$form = function (model) {
        return $dillonkearns$elm_form$Form$field_fn("password", $dillonkearns$elm_form$Form$Field$required_fn("Enter password", $dillonkearns$elm_form$Form$Field$password($dillonkearns$elm_form$Form$Field$text)), $dillonkearns$elm_form$Form$field_fn("username", $dillonkearns$elm_form$Form$Field$required_fn("Enter username", $dillonkearns$elm_form$Form$Field$text), $dillonkearns$elm_form$Form$form(F2(function (username, password) {
            return {
                lT: $author$project$Pages$Login$validateForm_fn(username, password),
                gl: A3($author$project$Pages$Login$viewForm, model, username, password)
            };
        }))));
    };
    var $author$project$Pages$Login$view = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_md]))
            ]))
        ]), _List_fromArray([
            $dillonkearns$elm_form$Form$renderStyledHtml_fn({ h7: model.d6, o2: model.bd, gd: $author$project$Pages$Login$FormMsg }, $dillonkearns$elm_form$Form$withOnSubmit_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.oc;
            }, $author$project$Pages$Login$FormSubmitted), $dillonkearns$elm_form$Form$options("log-in")), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_50)
                ]))
            ]), $author$project$Pages$Login$form(model))
        ]));
    };
    var $rtfeldman$elm_css$Css$borderBox = { gu: 0, e1: 0, pB: "border-box" };
    var $rtfeldman$elm_css$Css$boxSizing_a0 = "box-sizing", $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$boxSizing_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_1 = $rtfeldman$elm_css$Css$property_fn("height", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_16 = $rtfeldman$elm_css$Css$property_fn("margin-top", "4rem");
    var $rtfeldman$elm_css$Html$Styled$table_a0 = "table", $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$table_a0);
    var $rtfeldman$elm_css$Html$Styled$tbody_a0 = "tbody", $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$tbody_a0);
    var $rtfeldman$elm_css$Html$Styled$thead_a0 = "thead", $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$thead_a0);
    var $rtfeldman$elm_css$Html$Styled$tr_a0 = "tr", $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$tr_a0);
    var $author$project$Pages$Pricing$viewRow = function (row) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
            A2($elm$core$Tuple$second, row.fx, row.fx.a),
            A2($elm$core$Tuple$second, row.jr, row.jr.a),
            A2($elm$core$Tuple$second, row.kz, row.kz.a),
            A2($elm$core$Tuple$second, row.jd, row.jd.a),
            A2($elm$core$Tuple$second, row.je, row.je.a)
        ]));
    };
    var $author$project$Pages$Pricing$view = function (model) {
        return $author$project$Components$wrapWithMain_fn(model.b.eu, _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$table_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_collapse, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_12, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_1]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$thead_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                        $author$project$PricingData$cell_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_0]), _List_Nil),
                        $author$project$PricingData$cell_fn(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Free")
                        ])),
                        $author$project$PricingData$cell_fn(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Pro")
                        ])),
                        $author$project$PricingData$cell_fn(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Enterprise Cloud")
                        ])),
                        $author$project$PricingData$cell_fn(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Enterprise Server")
                        ]))
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tbody_a0, _List_Nil, $elm$core$List$map_fn($author$project$Pages$Pricing$viewRow, $author$project$PricingData$tableRows))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_16,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_lg,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$boxSizing_a0, $rtfeldman$elm_css$Css$borderBox)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Airsequel Embedded")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("\n                Airsequel can be deployed as a single binary and is\n                therefore suitable for embedding into your own application.\n                ")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_6]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("\n                We would be happy to help you work out the details of\n                an integration and provide support for necessary customizations.\n                Simply contact us and we can discuss your specific needs\n                and how Airsequel Embedded can help you achieve your goals.\n                ")
                ])),
                function () {
                    var mailSubject = "Airsequel Embedded";
                    var mailBody = "Dear Airsequel Team,\n\n                    we are interested in a commercial deployment\n                    of Airsequel Embedded.\n\n                    Company: [PLEASE SPECIFY]\n                    Industry: [PLEASE SPECIFY]\n                    Usage scenario: [PLEASE SPECIFY]\n\n                    Following time slots are available\n                    for a brainstorming session: [PLEASE SPECIFY]\n\n                    Best Regards!\n                    ";
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href("mailto:sales@feram.io?subject=" + ($elm$url$Url$percentEncode(mailSubject) + ("&body=" + $elm$url$Url$percentEncode(mailBody)))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.oY]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Request Brainstorming Session")
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$Pages$Signup$FormMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Signup$FormSubmitted = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Pages$Signup$SignUpForm_fn = function (username, email, password) {
        return { jb: email, kr: password, lb: username };
    }, $author$project$Pages$Signup$SignUpForm = F3($author$project$Pages$Signup$SignUpForm_fn);
    var $dillonkearns$elm_form$Form$Validation$withErrorIf_fn = function (includeError, _v0, error, _v1) {
        var key = _v0.b;
        var viewField = _v1.a;
        var name = _v1.b;
        var _v2 = _v1.c;
        var maybeParsedA = _v2.a;
        var errorsA = _v2.b;
        return $dillonkearns$elm_form$Pages$Internal$Form$Validation_fn(viewField, name, _Utils_Tuple2(maybeParsedA, includeError ? $dillonkearns$elm_form$Form$Validation$insertIfNonempty_fn($elm$core$Maybe$withDefault_fn("", key), _List_fromArray([error]), errorsA) : errorsA));
    }, $dillonkearns$elm_form$Form$Validation$withErrorIf = F4($dillonkearns$elm_form$Form$Validation$withErrorIf_fn);
    var $author$project$Pages$Signup$validateForm_fn = function (username, email, password, passwordConfirmation) {
        return $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, $dillonkearns$elm_form$Form$Validation$andThen_fn($elm$core$Basics$identity, $dillonkearns$elm_form$Form$Validation$map2_fn(F2(function (passwordValue, passwordConfirmationValue) {
            return $dillonkearns$elm_form$Form$Validation$withErrorIf_fn(!_Utils_eq(passwordConfirmationValue, passwordValue), passwordConfirmation, "Must match password", $dillonkearns$elm_form$Form$Validation$withErrorIf_fn($elm$core$String$length(passwordValue) > 50, password, "Password must have at most 50 characters", $dillonkearns$elm_form$Form$Validation$withErrorIf_fn($elm$core$String$length(passwordValue) < 10, password, "Password must have at least 10 characters", $dillonkearns$elm_form$Form$Validation$succeed(passwordValue))));
        }), password, passwordConfirmation)), $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, $dillonkearns$elm_form$Form$Validation$fromResult($dillonkearns$elm_form$Form$Validation$map_fn(A2($elm$core$Basics$composeR, $elm$core$Result$Ok, A2($elm_community$result_extra$Result$Extra$filter, "Invalid email address", $author$project$Util$isValidEmailAddress)), email)), $dillonkearns$elm_form$Form$Validation$map2_fn($dillonkearns$elm_form$Form$Validation$andMap_a0, $dillonkearns$elm_form$Form$Validation$fromResult($dillonkearns$elm_form$Form$Validation$map_fn(A2($elm$core$Basics$composeR, $elm$core$Result$Ok, A2($elm$core$Basics$composeR, A2($elm_community$result_extra$Result$Extra$filter, "Must have at least 3 characters", A2($elm$core$Basics$composeR, $elm$core$String$length, $elm$core$Basics$le(3))), A2($elm$core$Basics$composeR, A2($elm_community$result_extra$Result$Extra$filter, "Must have at most 32 characters", A2($elm$core$Basics$composeR, $elm$core$String$length, $elm$core$Basics$ge(32))), A2($elm$core$Basics$composeR, A2($elm_community$result_extra$Result$Extra$filter, "Must start with a letter", A2($elm$core$Basics$composeR, $elm$core$String$left(1), $elm$core$String$all($elm$core$Char$isAlpha))), A2($elm_community$result_extra$Result$Extra$filter, "Must only contain a-z, A-Z, 0-9, -, _", $elm$core$String$all(function (c) {
            return $elm$core$Char$isAlphaNum(c) || ((c === "-") || (c === "_"));
        })))))), username)), $dillonkearns$elm_form$Form$Validation$succeed($author$project$Pages$Signup$SignUpForm))));
    }, $author$project$Pages$Signup$validateForm = F4($author$project$Pages$Signup$validateForm_fn);
    var $author$project$Pages$Signup$viewErrors_fn = function (_v0, field) {
        var submitAttempted = _v0.o1;
        var errors = _v0.ml;
        var placeholder = function () {
            var zeroWidthString = $elm$core$String$fromChar("\u200B");
            return $rtfeldman$elm_css$Html$Styled$text(zeroWidthString);
        }();
        if (submitAttempted || $dillonkearns$elm_form$Form$Validation$statusAtLeast_fn(3, field)) {
            var _v1 = $dillonkearns$elm_form$Form$errorsForField_fn(field, errors);
            if (!_v1.b) {
                return placeholder;
            }
            else {
                var errorsForField = _v1;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto]))
                ]), $elm$core$List$map_fn(function (error) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(error)
                    ]));
                }, errorsForField));
            }
        }
        else {
            return placeholder;
        }
    }, $author$project$Pages$Signup$viewErrors = F2($author$project$Pages$Signup$viewErrors_fn);
    var $author$project$Pages$Signup$viewForm_fn = function (model, username, email, password, passwordConfirmation, formState) {
        var wrapErrors = F2(function (styles, errors) {
            return _Utils_eq(errors, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), $elm$core$List$map_fn($author$project$Components$wrapSuccess(_List_fromArray([
                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
            ])), errors));
        });
        var toField = F2(function (title, field) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
                ]), _List_fromArray([
                    $dillonkearns$elm_form$Form$FieldView$inputStyled_fn(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200)
                        ]))
                    ]), field),
                    $author$project$Pages$Signup$viewErrors_fn(formState, field)
                ]))
            ]));
        });
        return _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "min-content 1fr"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2
                ]))
            ]), _List_fromArray([
                A2(toField, "Username", username),
                A2(toField, "Email", email),
                A2(toField, "Password", password),
                A2(toField, "Password", passwordConfirmation)
            ])),
            $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_6]), formState.o2, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "submit"),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, model.ew || model.cC),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $author$project$Theme$theme.kX,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Sign Up")
            ]))),
            A2(wrapErrors, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]), model.dh),
            $author$project$Util$showElement_fn(model.ew, $author$project$Components$wrapSuccess_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]), "You signed up successfully! " + ("Please check your emails and use the confirmation link " + "before logging in.")))
        ]);
    }, $author$project$Pages$Signup$viewForm = F6($author$project$Pages$Signup$viewForm_fn);
    var $author$project$Pages$Signup$form = function (model) {
        return $dillonkearns$elm_form$Form$field_fn("password-confirmation", $dillonkearns$elm_form$Form$Field$required_fn("Confirm your password", $dillonkearns$elm_form$Form$Field$password($dillonkearns$elm_form$Form$Field$text)), $dillonkearns$elm_form$Form$field_fn("password", $dillonkearns$elm_form$Form$Field$required_fn("Enter a password", $dillonkearns$elm_form$Form$Field$password($dillonkearns$elm_form$Form$Field$text)), $dillonkearns$elm_form$Form$field_fn("email", $dillonkearns$elm_form$Form$Field$required_fn("Enter your email address", $dillonkearns$elm_form$Form$Field$email($dillonkearns$elm_form$Form$Field$text)), $dillonkearns$elm_form$Form$field_fn("username", $dillonkearns$elm_form$Form$Field$required_fn("Enter a username", $dillonkearns$elm_form$Form$Field$text), $dillonkearns$elm_form$Form$form(F4(function (username, email, password, passwordConfirmation) {
            return {
                lT: $author$project$Pages$Signup$validateForm_fn(username, email, password, passwordConfirmation),
                gl: A5($author$project$Pages$Signup$viewForm, model, username, email, password, passwordConfirmation)
            };
        }))))));
    };
    var $author$project$Pages$Signup$view = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_md]))
            ]))
        ]), _List_fromArray([
            $dillonkearns$elm_form$Form$renderStyledHtml_fn({ h7: model.d6, o2: model.cC, gd: $author$project$Pages$Signup$FormMsg }, $dillonkearns$elm_form$Form$withOnSubmit_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.oc;
            }, $author$project$Pages$Signup$FormSubmitted), $dillonkearns$elm_form$Form$options("sign-up")), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_50)
                ]))
            ]), $author$project$Pages$Signup$form(model))
        ]));
    };
    var $author$project$Pages$Teams$Navigated = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$Pages$Teams$toMenuPage_fn = function (subRoute, teamName, shared, content) {
        return $author$project$Components$menuPage_fn($author$project$Components$menuPageSmall_a0, {
            dM: $author$project$Pages$Teams$Route$Teams,
            gB: content,
            dW: $elm$core$Maybe$Just(subRoute),
            nl: _List_Nil,
            nm: false,
            nn: _List_fromArray([
                _List_fromArray([
                    _Utils_Tuple2("View Teams", $author$project$Pages$Teams$Route$Teams)
                ]),
                $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    $elm$core$Maybe$Just(_Utils_Tuple2("Overview", $author$project$Pages$Teams$Route$Overview(teamName))),
                    $elm$core$Maybe$Just(_Utils_Tuple2("Settings", $author$project$Pages$Teams$Route$Settings(teamName))),
                    $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (_v0) {
                        return !_Utils_eq(shared.aQ.mx.ja, $author$project$Types$Edition$Dedicated);
                    }, $elm$core$Maybe$Just(_Utils_Tuple2("Billing", $author$project$Pages$Teams$Route$Billing(teamName))))
                ]))
            ]),
            fL: $author$project$Pages$Teams$Navigated,
            gd: $elm$core$Basics$identity
        });
    }, $author$project$Pages$Teams$toMenuPage = F4($author$project$Pages$Teams$toMenuPage_fn);
    var $author$project$Pages$Teams$Settings$ShowTokenDeleteDialog = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Components$InputRequester$Started = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamDeletionIntended = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Pages$Teams$Settings$TeamMemberEditorOpened_fn = function (a, b) {
        return { $: 13, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamMemberEditorOpened = F2($author$project$Pages$Teams$Settings$TeamMemberEditorOpened_fn);
    var $author$project$Pages$Teams$Settings$TeamMemberRemovalIntended_fn = function (a, b) {
        return { $: 17, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TeamMemberRemovalIntended = F2($author$project$Pages$Teams$Settings$TeamMemberRemovalIntended_fn);
    var $author$project$Pages$Teams$Settings$TokenEditorOpened_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Pages$Teams$Settings$TokenEditorOpened = F2($author$project$Pages$Teams$Settings$TokenEditorOpened_fn);
    var $author$project$Util$titleToId = function (kind) {
        return A2($elm$core$Basics$composeR, $elm$core$String$toLower, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, " ", "-"), A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$String$append, "-"), A2($author$project$Util$flip, $elm$core$String$append, kind))));
    };
    var $author$project$Components$buttonDetailed_fn = function (title, description, buttonTitle, updating, msg) {
        var buttonId = A2($author$project$Util$titleToId, "button", title);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]), _List_fromArray([
            $author$project$Components$toDetails_fn($elm$core$Maybe$Nothing, title, description),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.o_, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, buttonId),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, updating),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(buttonTitle)
            ]))
        ]));
    }, $author$project$Components$buttonDetailed = F5($author$project$Components$buttonDetailed_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_6 = $rtfeldman$elm_css$Css$property_fn("margin-top", "-1.5rem");
    var $elm_community$list_extra$List$Extra$uniqueBy_fn = function (f, list) {
        return $elm_community$list_extra$List$Extra$uniqueHelp_fn(f, _List_Nil, list, _List_Nil);
    }, $elm_community$list_extra$List$Extra$uniqueBy = F2($elm_community$list_extra$List$Extra$uniqueBy_fn);
    var $author$project$Components$ApiTokenEditorOverlay$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $author$project$Components$InputRequester$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $author$project$Components$TeamMemberEditorOverlay$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $author$project$Pages$Teams$Settings$view_fn = function (model, team) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_16]))
        ]), _List_fromArray([
            A2($author$project$Components$ApiTokenEditorOverlay$view, $elm$core$Basics$identity, model.cF),
            A2($author$project$Components$TeamMemberEditorOverlay$view, $elm$core$Basics$identity, model.b4),
            A2($author$project$Components$InputRequester$view, $elm$core$Basics$identity, model.dn),
            $author$project$Components$contentDetailed_fn("API Tokens", "Create and manage API tokens to be used by external applications.", _List_fromArray([
                function () {
                    var _v0 = team.l1;
                    switch (_v0.$) {
                        case 2:
                            var errors = _v0.a;
                            return $author$project$Components$wrapErrors(_List_Cons("Error loading databases", errors));
                        case 3:
                            if (!_v0.a.b) {
                                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4,
                                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs
                                    ]))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$text("Create a database first to create a token.")
                                ]));
                            }
                            else {
                                return $author$project$Components$editableRows({
                                    d9: _List_fromArray(["Name", "Expiration", "Databases"]),
                                    mW: function (token) {
                                        return _List_fromArray([
                                            $elm$core$Maybe$Just($author$project$Route$toUrlPath($author$project$Route$Teams($author$project$Pages$Teams$Route$Tokens_fn(team.M, token.bR)))),
                                            $elm$core$Maybe$Nothing,
                                            $elm$core$Maybe$Nothing
                                        ]);
                                    },
                                    hh: function (token) {
                                        return _List_fromArray([
                                            token.M,
                                            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("Never", A2($elm$core$Basics$composeR, $author$project$Types$Utc$toDateTimeString, A2($author$project$Util$flip, $elm$core$String$append, " Z")), token.mq),
                                            $elm$core$String$fromInt($elm$core$List$length($elm_community$list_extra$List$Extra$uniqueBy_fn(function ($) {
                                                return $.i2;
                                            }, token.od)))
                                        ]);
                                    },
                                    aZ: $elm$core$List$reverse($krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, model.ps)),
                                    nH: $author$project$Pages$Teams$Settings$TokenEditorOpened_fn(team, $elm$core$Maybe$Nothing),
                                    kg: $elm$core$Maybe$Just($author$project$Pages$Teams$Settings$ShowTokenDeleteDialog),
                                    ki: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Teams$Settings$TokenEditorOpened(team)))
                                });
                            }
                        default:
                            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_6]))
                            ]), _List_fromArray([$author$project$Components$pageSpinner]));
                    }
                }()
            ])),
            $author$project$Components$contentDetailed_fn("Team Members", "Add and manage team members.", _List_fromArray([
                function () {
                    var _v1 = model.bn;
                    switch (_v1.$) {
                        case 2:
                            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4,
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500),
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs
                                ]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("Error loading team members")
                            ]));
                        case 3:
                            var teamMembers = _v1.a;
                            return $author$project$Components$editableRows({
                                d9: _List_fromArray(["Username", "Roles"]),
                                mW: $elm$core$Basics$always(_List_Nil),
                                hh: function (member) {
                                    return _List_fromArray([
                                        member.lb,
                                        $elm$core$String$join_fn(", ", $elm$core$List$map_fn($elm_community$string_extra$String$Extra$toTitleCase, member.oG))
                                    ]);
                                },
                                aZ: teamMembers,
                                nH: $author$project$Pages$Teams$Settings$TeamMemberEditorOpened_fn(team, $elm$core$Maybe$Nothing),
                                kg: $elm$core$Maybe$Just($author$project$Pages$Teams$Settings$TeamMemberRemovalIntended(team)),
                                ki: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Teams$Settings$TeamMemberEditorOpened(team)))
                            });
                        default:
                            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_6]))
                            ]), _List_fromArray([$author$project$Components$pageSpinner]));
                    }
                }()
            ])),
            $author$project$Components$buttonDetailed_fn("Rename Team", "\n            Renaming your team will not affect your databases or data in them.\n            ", "Rename", model.bo, $author$project$Pages$Teams$Settings$TeamNameRequesterMsg_fn(team, $author$project$Components$InputRequester$Started("rename-team-button"))),
            $author$project$Components$buttonDetailed_fn("Delete Team", "\n            Deleting your team will delete all databases and all data in them.\n            Currently it's not yet possible to assign the databases to another\n            team. Please download your databases to retain your data.\n            ", "Delete", model.bo, $author$project$Pages$Teams$Settings$TeamDeletionIntended(team))
        ]));
    }, $author$project$Pages$Teams$Settings$view = F2($author$project$Pages$Teams$Settings$view_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_center = $rtfeldman$elm_css$Css$property_fn("place-self", "center");
    var $author$project$Pages$Teams$Tokens$viewToken = function (token) {
        var utcWithTooltip = $author$project$Components$dateTimeWithTooltip(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_lg, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8]))
            ]), _List_fromArray([
                $author$project$Components$contentDetailed_fn("Name", token.M, _List_Nil),
                function (description) {
                    return $author$project$Components$contentDetailed_fn("Description", description, _List_Nil);
                }($elm$core$Maybe$withDefault_fn("None", token.i6)),
                $author$project$Components$contentDetailed_fn("Created", "", $elm$core$List$singleton(utcWithTooltip(token.lW))),
                $author$project$Components$contentDetailed_fn("Expiration", "", $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mt_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs
                    ]))
                ]), $elm$core$List$singleton($elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text("Never"), $author$project$Components$dateTimeWithTooltip(_List_Nil), token.mq))))),
                $author$project$Components$contentDetailed_fn("Permissions", "", _List_fromArray([
                    $author$project$Components$permissionsInput({
                        hp: $elm$core$Maybe$Nothing,
                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_center]),
                        pb: false,
                        k2: $author$project$Types$ApiTokenEdit$fromApiToken(token)
                    })
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Teams$Tokens$view = function (model) {
        var _v0 = model.k2;
        switch (_v0.$) {
            case 0:
                return $author$project$Components$pageSpinner;
            case 1:
                return $author$project$Components$pageSpinner;
            case 2:
                var errors = _v0.a;
                return $author$project$Components$wrapErrors(errors);
            default:
                var token = _v0.a;
                return $author$project$Pages$Teams$Tokens$viewToken(token);
        }
    };
    var $author$project$Pages$Teams$BillingPageMsg = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Pages$Teams$viewBilling_fn = function (shared, model, team) {
        if (!shared.aQ.mx.oh) {
            return _List_Nil;
        }
        else {
            var toLink = F3(function (attrs, title, url) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                ])), _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$href(url), attrs)), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]));
            });
            var viewSubscribed = function (_v1) {
                return _List_fromArray([
                    $author$project$Components$contentDetailed_fn("Airsequel Pro", "This team is subscribed to Airsequel Pro.", _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("To cancel the subscription, please contact our "),
                            A3(toLink, _List_Nil, "support", "mailto:support@airsequel.com"),
                            $rtfeldman$elm_css$Html$Styled$text(".")
                        ]))
                    ]))
                ]);
            };
            var viewUnsubscribed = function (_v0) {
                return _List_fromArray([
                    $author$project$Components$contentDetailed_fn("Upgrade to Airsequel Pro", "Go Pro to benefit from increased limits and features.", _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Please check out the "),
                            A3(toLink, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank")
                            ]), "pricing page", $author$project$Route$toUrlPath($author$project$Route$Pricing)),
                            $rtfeldman$elm_css$Html$Styled$text(" for a full comparison of all available editions.")
                        ])),
                        $author$project$Components$Billing$view_fn($author$project$Pages$Teams$BillingPageMsg, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start]), team.lF, model.dO)
                    ]))
                ]);
            };
            return $author$project$Types$Team$isPro(team) ? viewSubscribed(0) : viewUnsubscribed(0);
        }
    }, $author$project$Pages$Teams$viewBilling = F3($author$project$Pages$Teams$viewBilling_fn);
    var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement("after");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_fit = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("max-width", "-webkit-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("max-width", "-moz-fit-content"),
        $rtfeldman$elm_css$Css$property_fn("max-width", "fit-content")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_12 = $rtfeldman$elm_css$Css$property_fn("padding-bottom", "3rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_6 = $rtfeldman$elm_css$Css$property_fn("padding-bottom", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1 = $rtfeldman$elm_css$Css$property_fn("top", "0.25rem");
    var $author$project$Pages$Teams$DatabasesMenuOpened = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Pages$Teams$DragEntered = { $: 13 };
    var $author$project$Pages$Teams$DragLeft = { $: 14 };
    var $author$project$Pages$Teams$FileSelected_fn = function (a, b, c) {
        return { $: 16, a: a, b: b, c: c };
    }, $author$project$Pages$Teams$FileSelected = F3($author$project$Pages$Teams$FileSelected_fn);
    var $author$project$Pages$Teams$FileSelectorOpened_fn = function (a, b) {
        return { $: 15, a: a, b: b };
    }, $author$project$Pages$Teams$FileSelectorOpened = F2($author$project$Pages$Teams$FileSelectorOpened_fn);
    var $rtfeldman$elm_css$Css$firstChild = $rtfeldman$elm_css$Css$pseudoClass("first-child");
    var $author$project$Pages$Teams$databaseTable_a0 = $elm$core$List$sortBy(A2($elm$core$Basics$composeR, function ($) {
        return $.hM;
    }, $author$project$Types$Utc$toString)), $author$project$Pages$Teams$databaseTable_a1 = A2($elm$core$Basics$composeR, $elm$core$List$reverse, $author$project$Components$simpleTable({
        d9: _List_fromArray(["Database", "Owner Since"]),
        mY: function (database) {
            return _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$Database(database.bR))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$blue_900),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline,
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                                $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                                    $rtfeldman$elm_css$Css$firstChild(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(database.M)
                    ])),
                    $author$project$Types$DatabaseSettings$Visibility$toIcon_fn(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                        ]))
                    ]), database.pE),
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), $author$project$Components$environmentBadge, database.mk)
                ])),
                $author$project$Components$utcWithTooltip_fn(_List_Nil, database.hM)
            ]);
        }
    })), $author$project$Pages$Teams$databaseTable = A2($elm$core$Basics$composeR, $author$project$Pages$Teams$databaseTable_a0, $author$project$Pages$Teams$databaseTable_a1);
    var $author$project$Components$emptyStateView_fn = function (itemKind, addItemButton) {
        var itemKindLower = $elm$core$String$toLower(itemKind);
        return _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("No " + (itemKindLower + "s yet"))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Create a new " + (itemKindLower + " to get started"))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]))
            ]), _List_fromArray([addItemButton]))
        ]);
    }, $author$project$Components$emptyStateView = F2($author$project$Components$emptyStateView_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_auto = $rtfeldman$elm_css$Css$property_fn("margin-top", "auto");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_start = $rtfeldman$elm_css$Css$property_fn("place-self", "start");
    var $author$project$Pages$Teams$viewTeamDatabases_fn = function (maybeUpload, uploadErrors, team, databases, shared, model) {
        return _Utils_eq(databases, _List_Nil) ? $author$project$Components$emptyStateView_fn("Database", $author$project$Components$databaseInitPanel({
            i1: shared.aQ.mx.i1,
            ja: shared.aQ.mx.ja,
            ml: uploadErrors,
            mR: model.mR,
            j$: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Pages$Teams$CreateFromEditor(team)),
            eh: $elm$core$Maybe$Just(team),
            ct: maybeUpload,
            nO: F2(function (_v0, _v1) {
                return $author$project$Pages$Teams$CreateEmptyDB(team);
            }),
            kh: $author$project$Pages$Teams$DragEntered,
            nR: $author$project$Pages$Teams$DragLeft,
            nT: $author$project$Pages$Teams$ShowErrors,
            km: $author$project$Pages$Teams$FileSelectorOpened,
            n1: $author$project$Pages$Teams$FileSelected,
            m: _List_Nil
        })) : _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_start, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_normal, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_auto]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Databases")
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "create-database-button")
                ]), _List_fromArray([
                    $author$project$Components$progressButton_fn("+ Create Database", $elm$core$Maybe$Just($author$project$Pages$Teams$DatabasesMenuOpened(team)), $elm$core$Maybe$andThen_fn(function ($) {
                        return $.fT;
                    }, maybeUpload), false, _List_fromArray([$author$project$Theme$theme.kX]))
                ]))
            ])),
            $elm$core$Basics$composeR_fn($author$project$Pages$Teams$databaseTable_a0, $author$project$Pages$Teams$databaseTable_a1, databases)
        ]);
    }, $author$project$Pages$Teams$viewTeamDatabases = F6($author$project$Pages$Teams$viewTeamDatabases_fn);
    var $author$project$Pages$Teams$viewTeam_fn = function (maybeUpload, uploadErrors, shared, model, team) {
        var _v0 = team.l1;
        switch (_v0.$) {
            case 3:
                var databases = _v0.a;
                var proBadgePseudo = $rtfeldman$elm_css$Css$after(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_2,
                    $author$project$Theme$theme.nk,
                    $rtfeldman$elm_css$Css$property_fn("content", "'Pro'")
                ]));
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_6,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_12])),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $author$project$Util$styleIf_fn($author$project$Types$Team$isPro(team), proBadgePseudo)
                            ]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text(team.M)
                        ]))
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
                    ]), $author$project$Pages$Teams$viewTeamDatabases_fn(maybeUpload, uploadErrors, team, databases, shared, model))
                ]));
            case 2:
                var errors = _v0.a;
                return $author$project$Components$wrapErrors(errors);
            default:
                return $author$project$Components$pageSpinner;
        }
    }, $author$project$Pages$Teams$viewTeam = F5($author$project$Pages$Teams$viewTeam_fn);
    var $author$project$Components$initButton_fn = function (action, id_, object, onClick) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_center,
                $author$project$Theme$theme.kX,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
            ])),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(onClick(id_))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text($elm_community$string_extra$String$Extra$toTitleCase("+ " + (action + (" " + object))))
        ]));
    }, $author$project$Components$initButton = F4($author$project$Components$initButton_fn);
    var $author$project$Components$createButton_a0 = "create", $author$project$Components$createButton = $author$project$Components$initButton($author$project$Components$createButton_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_3 = $rtfeldman$elm_css$Css$property_fn("gap", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grow = $rtfeldman$elm_css$Css$property_fn("flex-grow", "1");
    var $author$project$Components$nbsp = $elm$core$String$fromChar($elm$core$Char$fromCode(160));
    var $author$project$Components$overview = function (cfg) {
        var toListItem = function (item) {
            var toOptionalLinkToSubitems = function (element) {
                var maybeHrefFromItem = $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(item), $elm$core$Maybe$andThen_fn(function ($) {
                    return $.mK;
                }, cfg.f4));
                if (maybeHrefFromItem.$ === 1) {
                    return element;
                }
                else {
                    var hrefFromItem = maybeHrefFromItem.a;
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href(hrefFromItem),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline]))
                    ]), _List_fromArray([element]));
                }
            };
            var editBtn = F2(function (styles, onClick_) {
                return $author$project$Components$iconButton({ bA: $author$project$Svg$edit, a_: onClick_, m: _List_Nil, bE: styles });
            });
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 3.5)),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_3,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(A2($author$project$Util$flip, $elm$core$String$append, $author$project$Components$nbsp + "Z"), $elm$core$Maybe$map_fn($author$project$Types$Utc$toDateTimeString, $elm$core$Maybe$map_fn($author$project$Types$Utc$fromPosix, cfg.mU(item)))))),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href(cfg.mV(item)),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(cfg.mZ(item))
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grow]))
                ]), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function (badgeTitle) {
                    return _List_fromArray([
                        $author$project$Components$badge_fn(badgeTitle, $elm$core$Maybe$Nothing, _List_fromArray([$author$project$Theme$theme.nk]))
                    ]);
                }, cfg.mX(item))),
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (subitem) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_8,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ]))
                    ]), _List_fromArray([
                        toOptionalLinkToSubitems($rtfeldman$elm_css$Html$Styled$text($elm_community$string_extra$String$Extra$pluralize_fn(subitem.hj, subitem.hj + "s", $elm$core$List$length(subitem.jZ(item)))))
                    ]));
                }, cfg.f4),
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), editBtn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4])), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(item), cfg.nh))
            ]));
        };
        var itemCount = $elm$core$List$length(cfg.aZ);
        var title = function (_v0) {
            var namedSubitemCount = function () {
                var maybeSubitemKind = $elm$core$Maybe$map_fn(function ($) {
                    return $.hj;
                }, cfg.f4);
                var maybeSubitemCount = $elm$core$Maybe$map_fn($elm$core$List$length, $elm$core$Maybe$map_fn($elm$core$List$concat, $elm_community$maybe_extra$Maybe$Extra$traverse_fn(function (item) {
                    return $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(item), $elm$core$Maybe$map_fn(function ($) {
                        return $.jZ;
                    }, cfg.f4));
                }, cfg.aZ)));
                return $elm$core$Maybe$map2_fn_unwrapped(function (subitemCount, subitemKind) {
                    return $elm_community$string_extra$String$Extra$pluralize_fn(subitemKind, subitemKind + "s", subitemCount);
                }, maybeSubitemCount, maybeSubitemKind);
            }();
            return _Utils_ap($elm_community$string_extra$String$Extra$pluralize_fn(cfg.hg, cfg.hg + "s", itemCount), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $elm$core$String$append(" - "), namedSubitemCount));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), (!itemCount) ? $author$project$Components$emptyStateView_fn(cfg.hg, cfg.iy) : _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title(0))
            ])),
            $author$project$Util$showElement_fn(cfg.lx, cfg.iy),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2]))
            ]), $elm$core$List$map_fn(toListItem, cfg.aZ))
        ]));
    };
    var $author$project$Types$Billing$toString = function (billing) {
        if (!billing.$) {
            return "Free";
        }
        else {
            return "Pro";
        }
    };
    var $author$project$Pages$Teams$viewTeams_fn = function (model, teams) {
        return $author$project$Components$overview({
            iy: $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                $author$project$Components$initButton_fn($author$project$Components$createButton_a0, "create-team-button", "Team", A2($elm$core$Basics$composeL, $author$project$Pages$Teams$TeamNameRequesterMsg, $author$project$Components$InputRequester$Started)),
                A2($author$project$Components$InputRequester$view, $elm$core$Basics$identity, model.dn)
            ])),
            lx: true,
            hg: "Team",
            mU: $elm$core$Basics$always($elm$core$Maybe$Nothing),
            mV: A2($elm$core$Basics$composeR, function ($) {
                return $.M;
            }, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Route$Overview, A2($elm$core$Basics$composeR, $author$project$Route$Teams, $author$project$Route$toUrlPath))),
            mX: A2($elm$core$Basics$composeR, function ($) {
                return $.lF;
            }, $elm$core$Maybe$map($author$project$Types$Billing$toString)),
            mZ: function ($) {
                return $.M;
            },
            aZ: teams,
            nh: $elm$core$Maybe$Nothing,
            m: _List_Nil,
            f4: $elm$core$Maybe$Just({
                mK: $elm$core$Maybe$Nothing,
                hj: "Database",
                jZ: function (team) {
                    return $elm$core$Maybe$withDefault_fn($elm$core$List$repeat_fn(team.nG, {
                        mk: $elm$core$Maybe$Nothing,
                        bR: $author$project$Types$Database$wrapId(""),
                        M: "",
                        hM: $elm$core$Basics$composeR_fn($author$project$Types$Utc$fromPosix_a0, $author$project$Types$Utc$fromPosix_a1, $elm$time$Time$millisToPosix(0)),
                        pE: 0
                    }), $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, team.l1));
                }
            })
        });
    }, $author$project$Pages$Teams$viewTeams = F2($author$project$Pages$Teams$viewTeams_fn);
    var $author$project$Pages$Teams$view_fn = function (maybeUpload, uploadErrors, user, subRoute, shared, model) {
        var withTeamFromTeamName = F2(function (teamName, view_) {
            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_fromArray([
                $author$project$Components$wrapErrors(_List_fromArray(["Team not found"]))
            ]), view_, $author$project$Types$User$findTeam_fn(user, teamName));
        });
        switch (subRoute.$) {
            case 0:
                return $author$project$Pages$Teams$viewTeams_fn(model, user.pc);
            case 1:
                var teamName = subRoute.a;
                return $author$project$Pages$Teams$toMenuPage_fn(subRoute, teamName, shared, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
                ]), A2(withTeamFromTeamName, teamName, A2($elm$core$Basics$composeR, A4($author$project$Pages$Teams$viewTeam, maybeUpload, uploadErrors, shared, model), A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$core$List$append(_List_fromArray([
                    $author$project$Overlay$view_fn($elm$core$Basics$identity, model.a$),
                    A2($author$project$Components$AiEditorOverlay$view, $elm$core$Basics$identity, model.bD)
                ])))))));
            case 2:
                var teamName = subRoute.a;
                return $author$project$Pages$Teams$toMenuPage_fn(subRoute, teamName, shared, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), A2(withTeamFromTeamName, teamName, A2($elm$core$Basics$composeR, $author$project$Pages$Teams$Settings$view(model.hY), A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$map($author$project$Pages$Teams$SettingsPageMsg), $elm$core$List$singleton)))));
            case 3:
                var teamName = subRoute.a;
                return $author$project$Pages$Teams$toMenuPage_fn(subRoute, teamName, shared, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), A2(withTeamFromTeamName, teamName, A2($author$project$Pages$Teams$viewBilling, shared, model))));
            default:
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Pages$Teams$TokensPageMsg, $author$project$Pages$Teams$Tokens$view(model.eP))));
        }
    }, $author$project$Pages$Teams$view = F6($author$project$Pages$Teams$view_fn);
    var $author$project$Pages$Trial$EmailTyped = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Pages$Trial$NoOp = { $: 0 };
    var $author$project$Pages$Trial$PurposeTyped = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Pages$Trial$RegionSelected = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Pages$Trial$SubdomainTyped = function (a) {
        return { $: 1, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_4 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "-1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_end = $rtfeldman$elm_css$Css$property_fn("place-self", "end");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2 = $rtfeldman$elm_css$Css$property_fn("padding-right", "0.5rem");
    var $author$project$Pages$Trial$Submitted = { $: 5 };
    var $rtfeldman$elm_css$Css$Global$input_a0 = "input", $rtfeldman$elm_css$Css$Global$input = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$input_a0);
    var $rtfeldman$elm_css$Css$Global$select_a0 = "select", $rtfeldman$elm_css$Css$Global$select = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$select_a0);
    var $rtfeldman$elm_css$Css$Global$textarea_a0 = "textarea", $rtfeldman$elm_css$Css$Global$textarea = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$textarea_a0);
    var $author$project$Pages$Trial$toForm = function () {
        var inputStyles = _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
        ]);
        return $rtfeldman$elm_css$Html$Styled$form(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onSubmit($author$project$Pages$Trial$Submitted),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_12, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_lg])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$input_a0, inputStyles),
                    $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$select_a0, inputStyles),
                    $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$textarea_a0, inputStyles)
                ]))
            ]))
        ]));
    }();
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("gap", "0.125rem");
    var $author$project$Pages$Trial$toSection_fn = function (id_, title, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_0_dot_5]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, id_),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_semibold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ])),
            content
        ]));
    }, $author$project$Pages$Trial$toSection = F3($author$project$Pages$Trial$toSection_fn);
    var $author$project$Pages$Trial$view = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center]))
        ]), _List_fromArray([
            $author$project$Pages$Trial$toForm(_List_fromArray([
                $author$project$Pages$Trial$toSection_fn("subdomain", "Subdomain", $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "subdomain"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.eE),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                        $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                        $rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Trial$SubdomainTyped),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right]))
                    ]), _List_Nil),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_0_dot_5]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(".airsequel.net")
                    ]))
                ]))),
                $author$project$Pages$Trial$toSection_fn("region", "Location", $author$project$Components$stringSelect({
                    cP: _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true)
                    ]),
                    bR: $elm$core$Maybe$Just("region"),
                    cv: $elm$core$Maybe$Just($author$project$Pages$Trial$RegionSelected),
                    cx: $elm$core$List$map_fn(function ($) {
                        return $.fx;
                    }, $author$project$Config$cloudRegions),
                    df: "",
                    ev: model.es,
                    m: _List_Nil
                })),
                $author$project$Pages$Trial$toSection_fn("email", "Email Address", $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "email"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "email"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, model.jb),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true),
                    $rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Trial$EmailTyped)
                ]), _List_Nil)),
                $author$project$Pages$Trial$toSection_fn("purpose", "Purpose", $author$project$Components$expandingInput_fn({
                    iE: false,
                    cP: _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "purpose"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$rows(7),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true)
                    ]),
                    iV: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]),
                    j3: true,
                    bC: $elm$core$Maybe$Nothing,
                    ek: $author$project$Pages$Trial$NoOp,
                    cv: $author$project$Pages$Trial$PurposeTyped,
                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2])
                }, model.eq)),
                $author$project$Components$wrapWithSpinner3_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_end]), $krisajenkins$remotedata$RemoteData$isLoading(model.b2), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, $krisajenkins$remotedata$RemoteData$isSuccess(model.b2)),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $author$project$Theme$theme.kW,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_self_end,
                        $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Start Trial")
                ]))),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    function () {
                        var _v0 = model.b2;
                        switch (_v0.$) {
                            case 0:
                                return $rtfeldman$elm_css$Html$Styled$text("");
                            case 1:
                                return $rtfeldman$elm_css$Html$Styled$text("");
                            case 3:
                                return $author$project$Components$wrapSuccess_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_4]), "Trial started! Check your mailbox.");
                            default:
                                var errors = _v0.a;
                                return $author$project$Components$wrapErrorsStyled_fn(_List_Nil, errors);
                        }
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Users$viewUser = function (user) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($author$project$Types$User$nameToString(user.M))
            ]))
        ]));
    };
    var $author$project$Pages$Users$view_fn = function (maybeUsername, maybeUser, _v0) {
        var _v1 = _Utils_Tuple2(maybeUsername, maybeUser);
        if (_v1.a.$ === 1) {
            var _v2 = _v1.a;
            return $author$project$Components$pageSpinner;
        }
        else {
            if (_v1.b.$ === 1) {
                var _v3 = _v1.b;
                return $author$project$Components$pageSpinner;
            }
            else {
                var username = _v1.a.a;
                var user = _v1.b.a;
                return (!_Utils_eq(username, user.M)) ? $author$project$Components$wrapErrors(_List_fromArray(["User not found"])) : $author$project$Pages$Users$viewUser(user);
            }
        }
    }, $author$project$Pages$Users$view = F3($author$project$Pages$Users$view_fn);
    var $author$project$Components$ConfirmDialog$AppContext = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Components$ConfirmDialog$DatabaseContext_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Components$ConfirmDialog$DatabaseContext = F2($author$project$Components$ConfirmDialog$DatabaseContext_fn);
    var $author$project$Msg$DatabaseDeletionRequested = function (a) {
        return { $: 48, a: a };
    };
    var $author$project$Components$ConfirmDialog$DatabaseIDContext_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Components$ConfirmDialog$DatabaseIDContext = F2($author$project$Components$ConfirmDialog$DatabaseIDContext_fn);
    var $author$project$Components$ConfirmDialog$DatabaseReadonlyIDContext_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Components$ConfirmDialog$DatabaseReadonlyIDContext = F2($author$project$Components$ConfirmDialog$DatabaseReadonlyIDContext_fn);
    var $author$project$Msg$DatabaseVisibilityModified_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $author$project$Msg$DatabaseVisibilityModified = F2($author$project$Msg$DatabaseVisibilityModified_fn);
    var $author$project$Pages$Apps$DeleteApp = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Pages$Functions$DeleteFunction = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$Components$ConfirmDialog$FunctionContext = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Types$ErrorDisplay$Notificaction = 1;
    var $author$project$Msg$RegenerateDatabaseID = function (a) {
        return { $: 37, a: a };
    };
    var $author$project$Msg$RegenerateReadonlyID = function (a) {
        return { $: 38, a: a };
    };
    var $author$project$Route$getQueriesRouteTab = function (route) {
        if (route.$ === 19) {
            var maybeTab = route.b;
            return maybeTab;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Route$getSettingsRoute = function (route) {
        if (route.$ === 25) {
            var settingsRoute = route.b;
            return settingsRoute;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Main$graphiqlPlayground_fn = function (sessionToken, dbId) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn("airsequel-graphql-playground", _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("session-token", sessionToken),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("db-id", dbId)
        ]), _List_Nil);
    }, $author$project$Main$graphiqlPlayground = F2($author$project$Main$graphiqlPlayground_fn);
    var $rtfeldman$elm_css$Css$height_a0 = "height", $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$height_a0);
    var $author$project$Route$isAppsRoute = function (route) {
        if (route.$ === 21) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isDatabaseRoute = function (route) {
        if (route.$ === 16) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isFunctionsRoute = function (route) {
        if (route.$ === 23) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isGraphiQLRoute = function (route) {
        if (route.$ === 20) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isQueriesRoute = function (route) {
        if (route.$ === 19) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isSettingsRoute = function (route) {
        if (route.$ === 25) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Route$isViewsRoute = function (route) {
        if (route.$ === 18) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5_fn = function (fn, arg1, arg2, arg3, arg4, arg5) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A5(fn, arg1, arg2, arg3, arg4, arg5));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5_fn_unwrapped = function (fn, arg1, arg2, arg3, arg4, arg5) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2, arg3, arg4, arg5));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5 = F6($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy5_fn = function (fn, arg1, arg2, arg3, arg4, arg5) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy6_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5, fn, arg1, arg2, arg3, arg4, arg5));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy5 = F6($rtfeldman$elm_css$VirtualDom$Styled$lazy5_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy5 = $rtfeldman$elm_css$VirtualDom$Styled$lazy5;
    var $author$project$Pages$Apps$UploadIntended_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$Pages$Apps$UploadIntended = F2($author$project$Pages$Apps$UploadIntended_fn);
    var $author$project$Components$addButton_a0 = "add", $author$project$Components$addButton = $author$project$Components$initButton($author$project$Components$addButton_a0);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_r = $rtfeldman$elm_css$Css$property_fn("border-right-width", "1px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_8 = $rtfeldman$elm_css$Css$property_fn("padding-top", "2rem");
    var $author$project$Components$menuPageFull_a0 = {
        gC: _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4]))
        ]),
        ht: _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_8])),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_1,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_r,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
        ]),
        m: _List_Nil
    }, $author$project$Components$menuPageFull = $author$project$Components$menuPage($author$project$Components$menuPageFull_a0);
    var $author$project$Pages$Apps$view_fn = function (toMsg, onDelete, route, dbId, _v0, model) {
        var _v1 = model.lz;
        switch (_v1.$) {
            case 2:
                return $author$project$Components$wrapErrors(model.ml);
            case 1:
                return $author$project$Components$pageSpinner;
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text("");
            default:
                var apps = _v1.a;
                var toButton = F4(function (title, msg, condition, styles) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $author$project$Theme$theme.kW,
                            $rtfeldman$elm_css$Css$batch(styles)
                        ])),
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "app-" + ($elm$core$String$toLower(title) + "-button")),
                        $rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, _Utils_eq(model.dG, $elm$core$Maybe$Nothing) || (model.la || (!condition)))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(title)
                    ]));
                });
                var addAppButton = function (id) {
                    return $author$project$Components$initButton_fn($author$project$Components$addButton_a0, id, "App", A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Apps$AddAppMsg(dbId)), $author$project$Components$InputRequester$Started));
                };
                var content = function () {
                    var _v2 = $author$project$Pages$Apps$getAppByName(model);
                    if (_v2.$ === 1) {
                        return $author$project$Components$overview({
                            iy: addAppButton("app-add-button"),
                            lx: false,
                            hg: "App",
                            mU: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                            mV: function (item) {
                                return "apps/" + item.M;
                            },
                            mX: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                            mZ: function ($) {
                                return $.M;
                            },
                            aZ: $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, model.lz),
                            nh: $elm$core$Maybe$Nothing,
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]),
                            f4: $elm$core$Maybe$Just({
                                mK: $elm$core$Maybe$Nothing,
                                hj: "Version",
                                jZ: function ($) {
                                    return $.le;
                                }
                            })
                        });
                    }
                    else {
                        var app = _v2.a;
                        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
                            ]), _List_fromArray([
                                A4(toButton, "Delete", onDelete(app), true, _List_fromArray([$author$project$Theme$theme.oZ])),
                                A4(toButton, "Rename", toMsg($author$project$Pages$Apps$RenameAppMsg_fn(app, dbId, $author$project$Components$InputRequester$Started(app.M))), true, _List_Nil),
                                A4(toButton, "Upload New Version", toMsg($author$project$Pages$Apps$UploadIntended_fn(dbId, app)), !$elm$core$List$isEmpty(app.le), _List_Nil)
                            ]))
                        ]));
                    }
                }();
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), _List_fromArray([
                    A2($author$project$Components$InputRequester$view, toMsg, model.cm),
                    $author$project$Components$menuPage_fn($author$project$Components$menuPageFull_a0, {
                        dM: $author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Nothing),
                        gB: content,
                        dW: $elm$core$Maybe$Just(route),
                        nl: _List_fromArray([
                            addAppButton("app-add-button-menu")
                        ]),
                        nm: false,
                        nn: $elm$core$List$append_fn(_List_fromArray([
                            _List_fromArray([
                                _Utils_Tuple2("Overview", $author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Nothing))
                            ])
                        ]), $elm$core$List$singleton($elm$core$List$map_fn(function (app) {
                            return _Utils_Tuple2(app.M, $author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Just(app.M)));
                        }, apps))),
                        fL: $author$project$Pages$Apps$NavigateReplace,
                        gd: toMsg
                    })
                ]));
        }
    }, $author$project$Pages$Apps$view = F6($author$project$Pages$Apps$view_fn);
    var $author$project$Pages$Dashboards$CreateChart_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Pages$Dashboards$CreateChart = F2($author$project$Pages$Dashboards$CreateChart_fn);
    var $author$project$Pages$Dashboards$DeleteChart_fn = function (a, b, c, d) {
        return { $: 14, a: a, b: b, c: c, d: d };
    }, $author$project$Pages$Dashboards$DeleteChart = F4($author$project$Pages$Dashboards$DeleteChart_fn);
    var $author$project$Pages$Dashboards$DeleteDashboard_fn = function (a, b, c) {
        return { $: 7, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$DeleteDashboard = F3($author$project$Pages$Dashboards$DeleteDashboard_fn);
    var $author$project$Pages$Dashboards$EditChart_fn = function (a, b, c) {
        return { $: 10, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$EditChart = F3($author$project$Pages$Dashboards$EditChart_fn);
    var $author$project$Pages$Dashboards$EditDashboard_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Dashboards$EditDashboard = F2($author$project$Pages$Dashboards$EditDashboard_fn);
    var $author$project$Pages$Dashboards$NavigateBack = { $: 2 };
    var $author$project$Pages$Dashboards$SaveChart_fn = function (a, b, c, d) {
        return { $: 13, a: a, b: b, c: c, d: d };
    }, $author$project$Pages$Dashboards$SaveChart = F4($author$project$Pages$Dashboards$SaveChart_fn);
    var $author$project$Pages$Dashboards$SaveDashboard_fn = function (a, b, c) {
        return { $: 6, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$SaveDashboard = F3($author$project$Pages$Dashboards$SaveDashboard_fn);
    var $author$project$Pages$Dashboards$SaveNewChart_fn = function (a, b, c) {
        return { $: 12, a: a, b: b, c: c };
    }, $author$project$Pages$Dashboards$SaveNewChart = F3($author$project$Pages$Dashboards$SaveNewChart_fn);
    var $author$project$Pages$Dashboards$UpdateChart_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $author$project$Pages$Dashboards$UpdateChart = F2($author$project$Pages$Dashboards$UpdateChart_fn);
    var $author$project$Pages$Dashboards$UpdateDashboard = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Dashboards$htmlNone = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_Nil);
    var $elm$core$Dict$values = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, valueList) {
            return _List_Cons(value, valueList);
        }, _List_Nil, dict);
    };
    var $author$project$Pages$Dashboards$btn_fn = function (styles, onClick_, text_) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $author$project$Theme$theme.kX,
                $rtfeldman$elm_css$Css$batch(styles)
            ])),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(onClick_)
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(text_)
        ]));
    }, $author$project$Pages$Dashboards$btn = F3($author$project$Pages$Dashboards$btn_fn);
    var $author$project$Pages$Dashboards$editBtn_fn = function (styles, onClick_) {
        return $author$project$Components$iconButton({ bA: $author$project$Svg$edit, a_: onClick_, m: styles, bE: _List_Nil });
    }, $author$project$Pages$Dashboards$editBtn = F2($author$project$Pages$Dashboards$editBtn_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_10 = $rtfeldman$elm_css$Css$property_fn("gap", "2.5rem");
    var $author$project$Types$Dashboard$getChartsOfDashboard = function (_v0) {
        var charts = _v0.aa;
        return $elm$core$Dict$filter(F2(function (key, _v1) {
            return $elm$core$Set$member_fn(key, charts);
        }));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1_dot_5 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0.375rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_center = $rtfeldman$elm_css$Css$property_fn("align-self", "center");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_9 = $rtfeldman$elm_css$Css$property_fn("padding", "2.25rem");
    var $rtfeldman$elm_css$Css$Internal$property_fn = function (key, value) {
        return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (":" + value));
    }, $rtfeldman$elm_css$Css$Internal$property = F2($rtfeldman$elm_css$Css$Internal$property_fn);
    var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn = function (functionName, desiredKey, style) {
        getOverloadedProperty: while (true) {
            switch (style.$) {
                case 0:
                    var str = style.a;
                    var key = $elm$core$Maybe$withDefault_fn("", $elm$core$List$head($elm$core$String$split_fn(":", str)));
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, key);
                case 1:
                    var selector = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-selector"));
                case 2:
                    var combinator = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-combinator"));
                case 3:
                    var pseudoElement = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-pseudo-element setter"));
                case 4:
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-media-query"));
                case 5:
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-keyframes"));
                default:
                    if (!style.a.b) {
                        return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-empty-Style"));
                    }
                    else {
                        if (!style.a.b.b) {
                            var _v1 = style.a;
                            var only = _v1.a;
                            var $temp$functionName = functionName, $temp$desiredKey = desiredKey, $temp$style = only;
                            functionName = $temp$functionName;
                            desiredKey = $temp$desiredKey;
                            style = $temp$style;
                            continue getOverloadedProperty;
                        }
                        else {
                            var _v2 = style.a;
                            var first = _v2.a;
                            var rest = _v2.b;
                            var $temp$functionName = functionName, $temp$desiredKey = desiredKey, $temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
                            functionName = $temp$functionName;
                            desiredKey = $temp$desiredKey;
                            style = $temp$style;
                            continue getOverloadedProperty;
                        }
                    }
            }
        }
    }, $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3($rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn);
    var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = $rtfeldman$elm_css$Css$Internal$lengthConverter_fn(0, "", 0);
    var $rtfeldman$elm_css$Css$alignItems = function (fn) {
        return $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn("alignItems", "align-items", fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_items_start = $rtfeldman$elm_css$Css$property_fn("justify-items", "start");
    var $rtfeldman$elm_css$Css$start_a0 = "start", $rtfeldman$elm_css$Css$start = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$start_a0);
    var $author$project$Pages$Dashboards$columnEl = function (attrs) {
        return $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_items_start,
                $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$start)
            ]), attrs))
        ]));
    };
    var $rtfeldman$elm_css$Css$padding_a0 = "padding", $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$padding_a0);
    var $rtfeldman$elm_css$Css$stretch_a0 = "stretch", $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$stretch_a0);
    var $author$project$Pages$Dashboards$section = function (attrs) {
        return $author$project$Pages$Dashboards$columnEl(_Utils_ap(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$padding_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 8)),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_0_dot_5,
            $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch)
        ]), attrs));
    };
    var $author$project$Pages$Dashboards$chartContainer_a0 = $elm$core$List$singleton, $author$project$Pages$Dashboards$chartContainer_a1 = $author$project$Pages$Dashboards$section(_List_fromArray([
        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 600)),
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_9,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_16,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_hidden,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
    ])), $author$project$Pages$Dashboards$chartContainer = A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$chartContainer_a0, $author$project$Pages$Dashboards$chartContainer_a1);
    var $elm_community$list_extra$List$Extra$rowsLength = function (listOfLists) {
        if (!listOfLists.b) {
            return 0;
        }
        else {
            var x = listOfLists.a;
            return $elm$core$List$length(x);
        }
    };
    var $elm_community$list_extra$List$Extra$transpose = function (listOfLists) {
        return $elm$core$List$foldr_fn($elm$core$List$map2($elm$core$List$cons), $elm$core$List$repeat_fn($elm_community$list_extra$List$Extra$rowsLength(listOfLists), _List_Nil), listOfLists);
    };
    var $author$project$Pages$Dashboards$getChartData_fn = function (ts, c) {
        var columns = A2($author$project$Types$Table$getColumns, c.kZ, ts);
        var cols = $elm$core$List$map_fn($author$project$Types$Column$getCells, $elm$core$List$filterMap_fn(A2($author$project$Util$flip, $author$project$Types$Column$find, columns), $author$project$Types$ChartType$toHeaders(c.bu)));
        var rows = $elm_community$list_extra$List$Extra$transpose(cols);
        return rows;
    }, $author$project$Pages$Dashboards$getChartData = F2($author$project$Pages$Dashboards$getChartData_fn);
    var $author$project$Pages$Dashboards$BarChartHovered_fn = function (a, b) {
        return { $: 24, a: a, b: b };
    }, $author$project$Pages$Dashboards$BarChartHovered = F2($author$project$Pages$Dashboards$BarChartHovered_fn);
    var $terezka$elm_charts$Internal$Svg$Start = 1;
    var $terezka$elm_charts$Chart$Attributes$alignLeft = function (config) {
        return _Utils_update(config, {
            R: $elm$core$Maybe$Just(1)
        });
    };
    var $terezka$elm_charts$Internal$Item$getDataIndex = function (_v0) {
        var item = _v0;
        return item.aQ.gg.i_;
    };
    var $terezka$elm_charts$Internal$Item$getDatum = function (_v0) {
        var item = _v0;
        return item.aQ.pC.l2;
    };
    var $terezka$elm_charts$Internal$Item$getPropertyIndex = function (_v0) {
        var item = _v0;
        return item.aQ.gg.ok;
    };
    var $terezka$elm_charts$Internal$Item$getStackIndex = function (_v0) {
        var item = _v0;
        return item.aQ.gg.oU;
    };
    var $terezka$elm_charts$Internal$Property$Property = function (a) {
        return { $: 0, a: a };
    };
    var $terezka$elm_charts$Internal$Property$Stacked = function (a) {
        return { $: 1, a: a };
    };
    var $terezka$elm_charts$Internal$Property$variation_fn = function (attrs, prop) {
        if (!prop.$) {
            var c = prop.a;
            return $terezka$elm_charts$Internal$Property$Property(_Utils_update(c, {
                ms: F5(function (p, s, i, m, d) {
                    return _Utils_ap(A5(c.ms, p, s, i, m, d), A5(attrs, p, s, i, m, d));
                })
            }));
        }
        else {
            var cs = prop.a;
            return $terezka$elm_charts$Internal$Property$Stacked($elm$core$List$map_fn(function (c) {
                return _Utils_update(c, {
                    ms: F5(function (p, s, i, m, d) {
                        return _Utils_ap(A5(c.ms, p, s, i, m, d), A5(attrs, p, s, i, m, d));
                    })
                });
            }, cs));
        }
    }, $terezka$elm_charts$Internal$Property$variation_fn_unwrapped = function (attrs, prop) {
        if (!prop.$) {
            var c = prop.a;
            return $terezka$elm_charts$Internal$Property$Property(_Utils_update(c, {
                ms: F5(function (p, s, i, m, d) {
                    return _Utils_ap(A5(c.ms, p, s, i, m, d), attrs(p, s, i, m, d));
                })
            }));
        }
        else {
            var cs = prop.a;
            return $terezka$elm_charts$Internal$Property$Stacked($elm$core$List$map_fn(function (c) {
                return _Utils_update(c, {
                    ms: F5(function (p, s, i, m, d) {
                        return _Utils_ap(A5(c.ms, p, s, i, m, d), attrs(p, s, i, m, d));
                    })
                });
            }, cs));
        }
    }, $terezka$elm_charts$Internal$Property$variation = F2($terezka$elm_charts$Internal$Property$variation_fn);
    var $terezka$elm_charts$Chart$amongst_fn = function (inQuestion, func) {
        return $terezka$elm_charts$Internal$Property$variation(F5(function (p, s, i, meta, d) {
            var check = function (product) {
                return (_Utils_eq($terezka$elm_charts$Internal$Item$getPropertyIndex(product), p) && (_Utils_eq($terezka$elm_charts$Internal$Item$getStackIndex(product), s) && (_Utils_eq($terezka$elm_charts$Internal$Item$getDataIndex(product), i) && _Utils_eq($terezka$elm_charts$Internal$Item$getDatum(product), d)))) ? func(d) : _List_Nil;
            };
            return $elm$core$List$concatMap_fn(check, inQuestion);
        }));
    }, $terezka$elm_charts$Chart$amongst = F2($terezka$elm_charts$Chart$amongst_fn);
    var $terezka$elm_charts$Internal$Many$Remodel_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $terezka$elm_charts$Internal$Many$Remodel = F2($terezka$elm_charts$Internal$Many$Remodel_fn);
    var $terezka$elm_charts$Internal$Item$getPosition_fn = function (plane, _v0) {
        var item = _v0;
        return A2(item.pn, plane, item.aQ);
    }, $terezka$elm_charts$Internal$Item$getPosition = F2($terezka$elm_charts$Internal$Item$getPosition_fn);
    var $terezka$elm_charts$Internal$Many$any = $terezka$elm_charts$Internal$Many$Remodel_fn($terezka$elm_charts$Internal$Item$getPosition, $elm$core$Basics$identity);
    var $terezka$elm_charts$Chart$Item$any = $terezka$elm_charts$Internal$Many$any;
    var $terezka$elm_charts$Internal$Property$property_fn = function (value, inter, attrs) {
        return $terezka$elm_charts$Internal$Property$Property({
            E: attrs,
            ms: F5(function (_v0, _v1, _v2, _v3, _v4) {
                return _List_Nil;
            }),
            d7: A2($elm$core$Basics$composeR, value, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$String$fromFloat), $elm$core$Maybe$withDefault("N/A"))),
            mQ: inter,
            j1: $elm$core$Maybe$Nothing,
            pB: value,
            eV: value
        });
    }, $terezka$elm_charts$Internal$Property$property = F3($terezka$elm_charts$Internal$Property$property_fn);
    var $terezka$elm_charts$Chart$barMaybe = function (y) {
        return A2($terezka$elm_charts$Internal$Property$property, y, _List_Nil);
    };
    var $terezka$elm_charts$Chart$BarsElement_fn = function (a, b, c, d, e) {
        return { $: 2, a: a, b: b, c: c, d: d, e: e };
    }, $terezka$elm_charts$Chart$BarsElement = F5($terezka$elm_charts$Chart$BarsElement_fn);
    var $terezka$elm_charts$Chart$Indexed = function (a) {
        return { $: 0, a: a };
    };
    var $terezka$elm_charts$Internal$Many$apply_fn = function (_v0, items) {
        var func = _v0.b;
        return func(items);
    }, $terezka$elm_charts$Internal$Many$apply = F2($terezka$elm_charts$Internal$Many$apply_fn);
    var $terezka$elm_charts$Chart$Item$apply = $terezka$elm_charts$Internal$Many$apply;
    var $terezka$elm_charts$Internal$Helpers$apply_fn = function (funcs, _default) {
        var apply_ = F2(function (f, a) {
            return f(a);
        });
        return $elm$core$List$foldl_fn(apply_, _default, funcs);
    }, $terezka$elm_charts$Internal$Helpers$apply = F2($terezka$elm_charts$Internal$Helpers$apply_fn);
    var $terezka$elm_charts$Internal$Item$Rendered = $elm$core$Basics$identity;
    var $terezka$elm_charts$Internal$Many$editLimits_fn = function (edit, _v0) {
        var group_ = _v0;
        return _Utils_update(group_, {
            pk: function (c) {
                return function (_v1) {
                    var x = _v1.a;
                    var xs = _v1.b;
                    return A2(edit, x, group_.pk(c));
                }(c.aZ);
            }
        });
    }, $terezka$elm_charts$Internal$Many$editLimits_fn_unwrapped = function (edit, _v0) {
        var group_ = _v0;
        return _Utils_update(group_, {
            pk: function (c) {
                return function (_v1) {
                    var x = _v1.a;
                    var xs = _v1.b;
                    return edit(x, group_.pk(c));
                }(c.aZ);
            }
        });
    }, $terezka$elm_charts$Internal$Many$editLimits = F2($terezka$elm_charts$Internal$Many$editLimits_fn);
    var $terezka$elm_charts$Internal$Item$getX1 = function (_v0) {
        var item = _v0;
        return item.aQ.pC.dv;
    };
    var $terezka$elm_charts$Internal$Item$getX2 = function (_v0) {
        var item = _v0;
        return item.aQ.pC.eW;
    };
    var $terezka$elm_charts$Internal$Helpers$gatherWith_fn = function (testFn, list) {
        var helper = F2(function (scattered, gathered) {
            if (!scattered.b) {
                return $elm$core$List$reverse(gathered);
            }
            else {
                var toGather = scattered.a;
                var population = scattered.b;
                var _v1 = $elm$core$List$partition_fn(testFn(toGather), population);
                var gathering = _v1.a;
                var remaining = _v1.b;
                return A2(helper, remaining, _List_Cons(_Utils_Tuple2(toGather, gathering), gathered));
            }
        });
        return A2(helper, list, _List_Nil);
    }, $terezka$elm_charts$Internal$Helpers$gatherWith = F2($terezka$elm_charts$Internal$Helpers$gatherWith_fn);
    var $elm$svg$Svg$Attributes$class_a0 = "class", $elm$svg$Svg$Attributes$class = _VirtualDom_attribute($elm$svg$Svg$Attributes$class_a0);
    var $terezka$elm_charts$Internal$Coordinates$Position_fn = function (x1, x2, y1, y2) {
        return { dv: x1, eW: x2, pK: y1, iu: y2 };
    }, $terezka$elm_charts$Internal$Coordinates$Position = F4($terezka$elm_charts$Internal$Coordinates$Position_fn);
    var $elm$core$Basics$min_fn = function (x, y) {
        return (_Utils_cmp(x, y) < 0) ? x : y;
    }, $elm$core$Basics$min = F2($elm$core$Basics$min_fn);
    var $terezka$elm_charts$Internal$Coordinates$foldPosition_fn = function (func, data) {
        var fold = F2(function (datum, posM) {
            if (!posM.$) {
                var pos = posM.a;
                return $elm$core$Maybe$Just({
                    dv: $elm$core$Basics$min_fn(func(datum).dv, pos.dv),
                    eW: $elm$core$Basics$max_fn(func(datum).eW, pos.eW),
                    pK: $elm$core$Basics$min_fn(func(datum).pK, pos.pK),
                    iu: $elm$core$Basics$max_fn(func(datum).iu, pos.iu)
                });
            }
            else {
                return $elm$core$Maybe$Just(func(datum));
            }
        });
        return $elm$core$Maybe$withDefault_fn($terezka$elm_charts$Internal$Coordinates$Position_fn(0, 0, 0, 0), $elm$core$List$foldl_fn(fold, $elm$core$Maybe$Nothing, data));
    }, $terezka$elm_charts$Internal$Coordinates$foldPosition = F2($terezka$elm_charts$Internal$Coordinates$foldPosition_fn);
    var $elm$svg$Svg$trustedNode_a0 = "http://www.w3.org/2000/svg", $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS($elm$svg$Svg$trustedNode_a0);
    var $elm$svg$Svg$g = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "g"), $elm$svg$Svg$g_fn = $elm$svg$Svg$g.a2;
    var $terezka$elm_charts$Internal$Item$getLimits = function (_v0) {
        var item = _v0;
        return item.pk(item.aQ);
    };
    var $elm$html$Html$table = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "table"), $elm$html$Html$table_fn = $elm$html$Html$table.a2;
    var $terezka$elm_charts$Internal$Item$toHtml = function (_v0) {
        var item = _v0;
        return item.pj(item.aQ);
    };
    var $terezka$elm_charts$Internal$Item$toSvg_fn = function (plane, _v0) {
        var item = _v0;
        return A3(item.po, plane, item.aQ, A2(item.pn, plane, item.aQ));
    }, $terezka$elm_charts$Internal$Item$toSvg = F2($terezka$elm_charts$Internal$Item$toSvg_fn);
    var $terezka$elm_charts$Internal$Many$toGroup_fn = function (first, rest) {
        var concatTuple = function (_v1) {
            var x = _v1.a;
            var xs = _v1.b;
            return _List_Cons(x, xs);
        };
        return {
            aQ: {
                aZ: _Utils_Tuple2(first, rest)
            },
            pj: function (c) {
                return _List_fromArray([
                    $elm$html$Html$table_fn(_List_Nil, $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Item$toHtml, concatTuple(c.aZ)))
                ]);
            },
            pk: function (c) {
                return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getLimits, concatTuple(c.aZ));
            },
            pn: F2(function (p, c) {
                return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getPosition(p), concatTuple(c.aZ));
            }),
            po: F3(function (p, c, _v0) {
                return $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__group")
                ]), $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$toSvg(p), concatTuple(c.aZ)));
            })
        };
    }, $terezka$elm_charts$Internal$Many$toGroup = F2($terezka$elm_charts$Internal$Many$toGroup_fn);
    var $terezka$elm_charts$Internal$Many$groupingHelp_fn = function (_v0, items) {
        var shared = _v0.b;
        var equality = _v0.fk;
        var edits = _v0.T;
        var toShared = function (_v2) {
            var item = _v2;
            return shared(item.aQ);
        };
        var toNewGroup = function (_v1) {
            var i = _v1.a;
            var is = _v1.b;
            return edits($terezka$elm_charts$Internal$Many$toGroup_fn(i, is));
        };
        var toEquality = F2(function (aO, bO) {
            return A2(equality, toShared(aO), toShared(bO));
        });
        return $elm$core$List$map_fn(toNewGroup, $terezka$elm_charts$Internal$Helpers$gatherWith_fn(toEquality, items));
    }, $terezka$elm_charts$Internal$Many$groupingHelp = F2($terezka$elm_charts$Internal$Many$groupingHelp_fn);
    var $terezka$elm_charts$Internal$Many$bins = $terezka$elm_charts$Internal$Many$Remodel_fn($terezka$elm_charts$Internal$Item$getPosition, $terezka$elm_charts$Internal$Many$groupingHelp({
        T: $terezka$elm_charts$Internal$Many$editLimits(F2(function (item, pos) {
            return _Utils_update(pos, {
                dv: $terezka$elm_charts$Internal$Item$getX1(item),
                eW: $terezka$elm_charts$Internal$Item$getX2(item)
            });
        })),
        fk: F2(function (a, b) {
            return _Utils_eq(a.dv, b.dv) && (_Utils_eq(a.eW, b.eW) && (_Utils_eq(a.mi, b.mi) && _Utils_eq(a.gE, b.gE)));
        }),
        b: function (config) {
            return { gE: config.gg.i_, mi: config.gg.mi, dv: config.pC.dv, eW: config.pC.eW };
        }
    }));
    var $terezka$elm_charts$Chart$Item$bins = $terezka$elm_charts$Internal$Many$bins;
    var $terezka$elm_charts$Internal$Produce$defaultBars = { L: false, mF: true, cr: 0.1, oH: 0, oI: 0, oT: 0.05, dv: $elm$core$Maybe$Nothing, eW: $elm$core$Maybe$Nothing };
    var $terezka$elm_charts$Internal$Item$generalize_fn = function (toAny, _v0) {
        var item = _v0;
        return {
            aQ: {
                oj: toAny(item.aQ.oj),
                pi: $elm$core$Basics$identity,
                gg: item.aQ.gg,
                pC: item.aQ.pC
            },
            pj: function (c) {
                return $terezka$elm_charts$Internal$Item$toHtml(item);
            },
            pk: function (_v1) {
                return item.pk(item.aQ);
            },
            pn: F2(function (plane, _v2) {
                return A2(item.pn, plane, item.aQ);
            }),
            po: F3(function (plane, _v3, _v4) {
                return $terezka$elm_charts$Internal$Item$toSvg_fn(plane, item);
            })
        };
    }, $terezka$elm_charts$Internal$Item$generalize = F2($terezka$elm_charts$Internal$Item$generalize_fn);
    var $terezka$elm_charts$Internal$Many$getMembers = function (_v0) {
        var group_ = _v0;
        return function (_v1) {
            var x = _v1.a;
            var xs = _v1.b;
            return _List_Cons(x, xs);
        }(group_.aQ.aZ);
    };
    var $terezka$elm_charts$Internal$Many$getGenerals = function (group_) {
        var generalize = function (_v0) {
            var item = _v0;
            return $terezka$elm_charts$Internal$Item$generalize_fn(item.aQ.pi, item);
        };
        return $elm$core$List$map_fn(generalize, $terezka$elm_charts$Internal$Many$getMembers(group_));
    };
    var $terezka$elm_charts$Chart$Item$getLimits = $terezka$elm_charts$Internal$Item$getLimits;
    var $terezka$elm_charts$Internal$Item$map_fn = function (func, _v0) {
        var item = _v0;
        return {
            aQ: {
                oj: item.aQ.oj,
                pi: item.aQ.pi,
                gg: item.aQ.gg,
                pC: {
                    l2: func(item.aQ.pC.l2),
                    mS: item.aQ.pC.mS,
                    dv: item.aQ.pC.dv,
                    eW: item.aQ.pC.eW,
                    pJ: item.aQ.pC.pJ
                }
            },
            pj: function (_v1) {
                return $terezka$elm_charts$Internal$Item$toHtml(item);
            },
            pk: function (_v2) {
                return item.pk(item.aQ);
            },
            pn: F2(function (plane, _v3) {
                return A2(item.pn, plane, item.aQ);
            }),
            po: F3(function (plane, _v4, _v5) {
                return $terezka$elm_charts$Internal$Item$toSvg_fn(plane, item);
            })
        };
    }, $terezka$elm_charts$Internal$Item$map = F2($terezka$elm_charts$Internal$Item$map_fn);
    var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
    var $terezka$elm_charts$Internal$Legend$BarLegend_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $terezka$elm_charts$Internal$Legend$BarLegend = F2($terezka$elm_charts$Internal$Legend$BarLegend_fn);
    var $terezka$elm_charts$Chart$Attributes$border_fn = function (v, config) {
        return _Utils_update(config, { au: v });
    }, $terezka$elm_charts$Chart$Attributes$border = F2($terezka$elm_charts$Chart$Attributes$border_fn);
    var $terezka$elm_charts$Chart$Attributes$color_fn = function (v, config) {
        return (v === "") ? config : _Utils_update(config, { bw: v });
    }, $terezka$elm_charts$Chart$Attributes$color = F2($terezka$elm_charts$Chart$Attributes$color_fn);
    var $terezka$elm_charts$Internal$Helpers$pink = "#ea60df";
    var $terezka$elm_charts$Internal$Svg$defaultBar = { E: _List_Nil, au: "white", aB: 0, bw: $terezka$elm_charts$Internal$Helpers$pink, gL: $elm$core$Maybe$Nothing, c4: 0, mH: "", mI: 10, bg: 1, oH: 0, oI: 0 };
    var $terezka$elm_charts$Chart$Attributes$roundBottom_fn = function (v, config) {
        return _Utils_update(config, { oH: v });
    }, $terezka$elm_charts$Chart$Attributes$roundBottom = F2($terezka$elm_charts$Chart$Attributes$roundBottom_fn);
    var $terezka$elm_charts$Chart$Attributes$roundTop_fn = function (v, config) {
        return _Utils_update(config, { oI: v });
    }, $terezka$elm_charts$Chart$Attributes$roundTop = F2($terezka$elm_charts$Chart$Attributes$roundTop_fn);
    var $terezka$elm_charts$Internal$Property$toConfigs = function (prop) {
        if (!prop.$) {
            var config = prop.a;
            return _List_fromArray([config]);
        }
        else {
            var configs = prop.a;
            return configs;
        }
    };
    var $terezka$elm_charts$Internal$Helpers$blue = "#12A5ED";
    var $terezka$elm_charts$Internal$Helpers$brown = "#871c1c";
    var $terezka$elm_charts$Internal$Helpers$green = "#71c614";
    var $terezka$elm_charts$Internal$Helpers$moss = "#92b42c";
    var $terezka$elm_charts$Internal$Helpers$orange = "#FF8400";
    var $terezka$elm_charts$Internal$Helpers$purple = "#7b4dff";
    var $terezka$elm_charts$Internal$Helpers$red = "#F5325B";
    var $elm$core$Dict$sizeHelp_fn = function (n, dict) {
        sizeHelp: while (true) {
            if (dict.$ === -2) {
                return n;
            }
            else {
                var left = dict.d;
                var right = dict.e;
                var $temp$n = $elm$core$Dict$sizeHelp_fn(n + 1, right), $temp$dict = left;
                n = $temp$n;
                dict = $temp$dict;
                continue sizeHelp;
            }
        }
    }, $elm$core$Dict$sizeHelp = F2($elm$core$Dict$sizeHelp_fn);
    var $elm$core$Dict$size = function (dict) {
        return $elm$core$Dict$sizeHelp_fn(0, dict);
    };
    var $terezka$elm_charts$Internal$Helpers$toDefault_fn = function (_default, items, index) {
        var dict = $elm$core$Dict$fromList($elm$core$List$indexedMap_fn($elm$core$Tuple$pair, items));
        var numOfItems = $elm$core$Dict$size(dict);
        var itemIndex = index % numOfItems;
        return $elm$core$Maybe$withDefault_fn(_default, $elm$core$Dict$get_fn(itemIndex, dict));
    }, $terezka$elm_charts$Internal$Helpers$toDefault = F3($terezka$elm_charts$Internal$Helpers$toDefault_fn);
    var $terezka$elm_charts$Internal$Helpers$turquoise = "#22d2ba";
    var $terezka$elm_charts$Internal$Helpers$yellow = "#FFCA00";
    var $terezka$elm_charts$Internal$Helpers$toDefaultColor_a0 = $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1 = _List_fromArray([$terezka$elm_charts$Internal$Helpers$purple, $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$blue, $terezka$elm_charts$Internal$Helpers$green, $terezka$elm_charts$Internal$Helpers$red, $terezka$elm_charts$Internal$Helpers$yellow, $terezka$elm_charts$Internal$Helpers$turquoise, $terezka$elm_charts$Internal$Helpers$orange, $terezka$elm_charts$Internal$Helpers$moss, $terezka$elm_charts$Internal$Helpers$brown]), $terezka$elm_charts$Internal$Helpers$toDefaultColor = A2($terezka$elm_charts$Internal$Helpers$toDefault, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a0, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1);
    var $terezka$elm_charts$Internal$Legend$toBarLegends_fn = function (elIndex, barsAttrs, properties) {
        var toBarConfig = function (attrs) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(attrs, $terezka$elm_charts$Internal$Svg$defaultBar);
        };
        var barsConfig = $terezka$elm_charts$Internal$Helpers$apply_fn(barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
        var toBarLegend = F2(function (colorIndex, prop) {
            var rounding = $elm$core$Basics$max_fn(barsConfig.oI, barsConfig.oH);
            var defaultName = "Property #" + $elm$core$String$fromInt(colorIndex + 1);
            var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefault_fn($terezka$elm_charts$Internal$Helpers$toDefaultColor_a0, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1, colorIndex);
            var defaultAttrs = _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$roundTop(rounding),
                $terezka$elm_charts$Chart$Attributes$roundBottom(rounding),
                $terezka$elm_charts$Chart$Attributes$color(defaultColor),
                $terezka$elm_charts$Chart$Attributes$border(defaultColor)
            ]);
            var attrsOrg = _Utils_ap(defaultAttrs, prop.E);
            var productOrg = toBarConfig(attrsOrg);
            var attrs = _Utils_eq(productOrg.au, defaultColor) ? _Utils_ap(attrsOrg, _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$border(productOrg.bw)
            ])) : attrsOrg;
            return $terezka$elm_charts$Internal$Legend$BarLegend_fn($elm$core$Maybe$withDefault_fn(defaultName, prop.j1), attrs);
        });
        return $elm$core$List$indexedMap_fn(function (propIndex) {
            return toBarLegend(elIndex + propIndex);
        }, $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Property$toConfigs, properties));
    }, $terezka$elm_charts$Internal$Legend$toBarLegends = F3($terezka$elm_charts$Internal$Legend$toBarLegends_fn);
    var $terezka$elm_charts$Internal$Item$Bar = function (a) {
        return { $: 1, a: a };
    };
    var $terezka$elm_charts$Internal$Commands$Arc_fn = function (a, b, c, d, e, f, g) {
        return { $: 6, a: a, b: b, c: c, d: d, e: e, f: f, g: g };
    }, $terezka$elm_charts$Internal$Commands$Arc = F7($terezka$elm_charts$Internal$Commands$Arc_fn);
    var $terezka$elm_charts$Internal$Commands$Line_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $terezka$elm_charts$Internal$Commands$Line = F2($terezka$elm_charts$Internal$Commands$Line_fn);
    var $terezka$elm_charts$Internal$Commands$Move_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $terezka$elm_charts$Internal$Commands$Move = F2($terezka$elm_charts$Internal$Commands$Move_fn);
    var $elm$svg$Svg$Attributes$d_a0 = "d", $elm$svg$Svg$Attributes$d = _VirtualDom_attribute($elm$svg$Svg$Attributes$d_a0);
    var $terezka$elm_charts$Internal$Commands$joinCommands = function (commands) {
        return $elm$core$String$join_fn(" ", commands);
    };
    var $terezka$elm_charts$Internal$Commands$stringBoolInt = function (bool) {
        return bool ? "1" : "0";
    };
    var $terezka$elm_charts$Internal$Commands$stringPoint = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $elm$core$String$fromFloat(x) + (" " + $elm$core$String$fromFloat(y));
    };
    var $terezka$elm_charts$Internal$Commands$stringPoints = function (points) {
        return $elm$core$String$join_fn(",", $elm$core$List$map_fn($terezka$elm_charts$Internal$Commands$stringPoint, points));
    };
    var $terezka$elm_charts$Internal$Commands$stringCommand = function (command) {
        switch (command.$) {
            case 0:
                var x = command.a;
                var y = command.b;
                return "M" + $terezka$elm_charts$Internal$Commands$stringPoint(_Utils_Tuple2(x, y));
            case 1:
                var x = command.a;
                var y = command.b;
                return "L" + $terezka$elm_charts$Internal$Commands$stringPoint(_Utils_Tuple2(x, y));
            case 2:
                var cx1 = command.a;
                var cy1 = command.b;
                var cx2 = command.c;
                var cy2 = command.d;
                var x = command.e;
                var y = command.f;
                return "C" + $terezka$elm_charts$Internal$Commands$stringPoints(_List_fromArray([
                    _Utils_Tuple2(cx1, cy1),
                    _Utils_Tuple2(cx2, cy2),
                    _Utils_Tuple2(x, y)
                ]));
            case 3:
                var cx1 = command.a;
                var cy1 = command.b;
                var x = command.c;
                var y = command.d;
                return "Q" + $terezka$elm_charts$Internal$Commands$stringPoints(_List_fromArray([
                    _Utils_Tuple2(cx1, cy1),
                    _Utils_Tuple2(x, y)
                ]));
            case 4:
                var cx1 = command.a;
                var cy1 = command.b;
                var x = command.c;
                var y = command.d;
                return "Q" + $terezka$elm_charts$Internal$Commands$stringPoints(_List_fromArray([
                    _Utils_Tuple2(cx1, cy1),
                    _Utils_Tuple2(x, y)
                ]));
            case 5:
                var x = command.a;
                var y = command.b;
                return "T" + $terezka$elm_charts$Internal$Commands$stringPoint(_Utils_Tuple2(x, y));
            case 6:
                var rx = command.a;
                var ry = command.b;
                var xAxisRotation = command.c;
                var largeArcFlag = command.d;
                var sweepFlag = command.e;
                var x = command.f;
                var y = command.g;
                return "A " + $terezka$elm_charts$Internal$Commands$joinCommands(_List_fromArray([
                    $terezka$elm_charts$Internal$Commands$stringPoint(_Utils_Tuple2(rx, ry)),
                    $elm$core$String$fromInt(xAxisRotation),
                    $terezka$elm_charts$Internal$Commands$stringBoolInt(largeArcFlag),
                    $terezka$elm_charts$Internal$Commands$stringBoolInt(sweepFlag),
                    $terezka$elm_charts$Internal$Commands$stringPoint(_Utils_Tuple2(x, y))
                ]));
            default:
                return "Z";
        }
    };
    var $terezka$elm_charts$Internal$Commands$Close = { $: 7 };
    var $terezka$elm_charts$Internal$Commands$CubicBeziers_fn = function (a, b, c, d, e, f) {
        return { $: 2, a: a, b: b, c: c, d: d, e: e, f: f };
    }, $terezka$elm_charts$Internal$Commands$CubicBeziers = F6($terezka$elm_charts$Internal$Commands$CubicBeziers_fn);
    var $terezka$elm_charts$Internal$Commands$CubicBeziersShort_fn = function (a, b, c, d) {
        return { $: 3, a: a, b: b, c: c, d: d };
    }, $terezka$elm_charts$Internal$Commands$CubicBeziersShort = F4($terezka$elm_charts$Internal$Commands$CubicBeziersShort_fn);
    var $terezka$elm_charts$Internal$Commands$QuadraticBeziers_fn = function (a, b, c, d) {
        return { $: 4, a: a, b: b, c: c, d: d };
    }, $terezka$elm_charts$Internal$Commands$QuadraticBeziers = F4($terezka$elm_charts$Internal$Commands$QuadraticBeziers_fn);
    var $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort = F2($terezka$elm_charts$Internal$Commands$QuadraticBeziersShort_fn);
    var $terezka$elm_charts$Internal$Coordinates$innerLength = function (axis) {
        return $elm$core$Basics$max_fn(1, (axis.hl - axis.nc) - axis.nb);
    };
    var $terezka$elm_charts$Internal$Coordinates$innerWidth = function (plane) {
        return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.pH);
    };
    var $terezka$elm_charts$Internal$Coordinates$range = function (axis) {
        var diff = axis.ne - axis.np;
        return (diff > 0) ? diff : 1;
    };
    var $terezka$elm_charts$Internal$Coordinates$scaleSVGX_fn = function (plane, value) {
        return (value * $terezka$elm_charts$Internal$Coordinates$innerWidth(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.pH);
    }, $terezka$elm_charts$Internal$Coordinates$scaleSVGX = F2($terezka$elm_charts$Internal$Coordinates$scaleSVGX_fn);
    var $terezka$elm_charts$Internal$Coordinates$toSVGX_fn = function (plane, value) {
        return $terezka$elm_charts$Internal$Coordinates$scaleSVGX_fn(plane, value - plane.pH.np) + plane.pH.nc;
    }, $terezka$elm_charts$Internal$Coordinates$toSVGX = F2($terezka$elm_charts$Internal$Coordinates$toSVGX_fn);
    var $terezka$elm_charts$Internal$Coordinates$innerHeight = function (plane) {
        return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.pJ);
    };
    var $terezka$elm_charts$Internal$Coordinates$scaleSVGY_fn = function (plane, value) {
        return (value * $terezka$elm_charts$Internal$Coordinates$innerHeight(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.pJ);
    }, $terezka$elm_charts$Internal$Coordinates$scaleSVGY = F2($terezka$elm_charts$Internal$Coordinates$scaleSVGY_fn);
    var $terezka$elm_charts$Internal$Coordinates$toSVGY_fn = function (plane, value) {
        return $terezka$elm_charts$Internal$Coordinates$scaleSVGY_fn(plane, plane.pJ.ne - value) + plane.pJ.nc;
    }, $terezka$elm_charts$Internal$Coordinates$toSVGY = F2($terezka$elm_charts$Internal$Coordinates$toSVGY_fn);
    var $terezka$elm_charts$Internal$Commands$translate_fn = function (plane, command) {
        switch (command.$) {
            case 0:
                var x = command.a;
                var y = command.b;
                return $terezka$elm_charts$Internal$Commands$Move_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 1:
                var x = command.a;
                var y = command.b;
                return $terezka$elm_charts$Internal$Commands$Line_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 2:
                var cx1 = command.a;
                var cy1 = command.b;
                var cx2 = command.c;
                var cy2 = command.d;
                var x = command.e;
                var y = command.f;
                return $terezka$elm_charts$Internal$Commands$CubicBeziers_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, cx1), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, cy1), $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, cx2), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, cy2), $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 3:
                var cx1 = command.a;
                var cy1 = command.b;
                var x = command.c;
                var y = command.d;
                return $terezka$elm_charts$Internal$Commands$CubicBeziersShort_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, cx1), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, cy1), $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 4:
                var cx1 = command.a;
                var cy1 = command.b;
                var x = command.c;
                var y = command.d;
                return $terezka$elm_charts$Internal$Commands$QuadraticBeziers_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, cx1), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, cy1), $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 5:
                var x = command.a;
                var y = command.b;
                return $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort_fn($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            case 6:
                var rx = command.a;
                var ry = command.b;
                var xAxisRotation = command.c;
                var largeArcFlag = command.d;
                var sweepFlag = command.e;
                var x = command.f;
                var y = command.g;
                return $terezka$elm_charts$Internal$Commands$Arc_fn(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x), $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y));
            default:
                return $terezka$elm_charts$Internal$Commands$Close;
        }
    }, $terezka$elm_charts$Internal$Commands$translate = F2($terezka$elm_charts$Internal$Commands$translate_fn);
    var $terezka$elm_charts$Internal$Commands$description_fn = function (plane, commands) {
        return $terezka$elm_charts$Internal$Commands$joinCommands($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $terezka$elm_charts$Internal$Commands$translate(plane), $terezka$elm_charts$Internal$Commands$stringCommand), commands));
    }, $terezka$elm_charts$Internal$Commands$description = F2($terezka$elm_charts$Internal$Commands$description_fn);
    var $elm$svg$Svg$Attributes$fill_a0 = "fill", $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute($elm$svg$Svg$Attributes$fill_a0);
    var $elm$svg$Svg$Attributes$fillOpacity_a0 = "fill-opacity", $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute($elm$svg$Svg$Attributes$fillOpacity_a0);
    var $elm$svg$Svg$path = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "path"), $elm$svg$Svg$path_fn = $elm$svg$Svg$path.a2;
    var $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn = function (plane, value) {
        return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.pH)) / $terezka$elm_charts$Internal$Coordinates$innerWidth(plane);
    }, $terezka$elm_charts$Internal$Coordinates$scaleCartesianX = F2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn);
    var $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn = function (plane, value) {
        return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.pJ)) / $terezka$elm_charts$Internal$Coordinates$innerHeight(plane);
    }, $terezka$elm_charts$Internal$Coordinates$scaleCartesianY = F2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn);
    var $elm$svg$Svg$Attributes$stroke_a0 = "stroke", $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute($elm$svg$Svg$Attributes$stroke_a0);
    var $elm$svg$Svg$Attributes$strokeOpacity_a0 = "stroke-opacity", $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute($elm$svg$Svg$Attributes$strokeOpacity_a0);
    var $elm$svg$Svg$Attributes$strokeWidth_a0 = "stroke-width", $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute($elm$svg$Svg$Attributes$strokeWidth_a0);
    var $terezka$elm_charts$Internal$Svg$apply_fn = function (funcs, _default) {
        var apply_ = F2(function (f, a) {
            return f(a);
        });
        return $elm$core$List$foldl_fn(apply_, _default, funcs);
    }, $terezka$elm_charts$Internal$Svg$apply = F2($terezka$elm_charts$Internal$Svg$apply_fn);
    var $elm$svg$Svg$circle = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "circle"), $elm$svg$Svg$circle_fn = $elm$svg$Svg$circle.a2;
    var $elm$svg$Svg$Attributes$cx_a0 = "cx", $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute($elm$svg$Svg$Attributes$cx_a0);
    var $elm$svg$Svg$Attributes$cy_a0 = "cy", $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute($elm$svg$Svg$Attributes$cy_a0);
    var $elm$svg$Svg$defs = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "defs"), $elm$svg$Svg$defs_fn = $elm$svg$Svg$defs.a2;
    var $elm$svg$Svg$Attributes$height_a0 = "height", $elm$svg$Svg$Attributes$height = _VirtualDom_attribute($elm$svg$Svg$Attributes$height_a0);
    var $elm$svg$Svg$Attributes$id_a0 = "id", $elm$svg$Svg$Attributes$id = _VirtualDom_attribute($elm$svg$Svg$Attributes$id_a0);
    var $elm$svg$Svg$line = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "line"), $elm$svg$Svg$line_fn = $elm$svg$Svg$line.a2;
    var $elm$svg$Svg$linearGradient = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "linearGradient"), $elm$svg$Svg$linearGradient_fn = $elm$svg$Svg$linearGradient.a2;
    var $elm$svg$Svg$Attributes$offset_a0 = "offset", $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute($elm$svg$Svg$Attributes$offset_a0);
    var $elm$svg$Svg$pattern = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "pattern"), $elm$svg$Svg$pattern_fn = $elm$svg$Svg$pattern.a2;
    var $elm$svg$Svg$Attributes$patternTransform_a0 = "patternTransform", $elm$svg$Svg$Attributes$patternTransform = _VirtualDom_attribute($elm$svg$Svg$Attributes$patternTransform_a0);
    var $elm$svg$Svg$Attributes$patternUnits_a0 = "patternUnits", $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute($elm$svg$Svg$Attributes$patternUnits_a0);
    var $elm$svg$Svg$Attributes$r_a0 = "r", $elm$svg$Svg$Attributes$r = _VirtualDom_attribute($elm$svg$Svg$Attributes$r_a0);
    var $elm$svg$Svg$stop = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "stop"), $elm$svg$Svg$stop_fn = $elm$svg$Svg$stop.a2;
    var $elm$svg$Svg$Attributes$stopColor_a0 = "stop-color", $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute($elm$svg$Svg$Attributes$stopColor_a0);
    var $elm$svg$Svg$Attributes$width_a0 = "width", $elm$svg$Svg$Attributes$width = _VirtualDom_attribute($elm$svg$Svg$Attributes$width_a0);
    var $elm$svg$Svg$Attributes$x1_a0 = "x1", $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute($elm$svg$Svg$Attributes$x1_a0);
    var $elm$svg$Svg$Attributes$x2_a0 = "x2", $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute($elm$svg$Svg$Attributes$x2_a0);
    var $elm$svg$Svg$Attributes$y_a0 = "y", $elm$svg$Svg$Attributes$y = _VirtualDom_attribute($elm$svg$Svg$Attributes$y_a0);
    var $elm$svg$Svg$Attributes$y1_a0 = "y1", $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute($elm$svg$Svg$Attributes$y1_a0);
    var $elm$svg$Svg$Attributes$y2_a0 = "y2", $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute($elm$svg$Svg$Attributes$y2_a0);
    var $terezka$elm_charts$Internal$Svg$toPattern_fn = function (defaultColor, design) {
        var toPatternId = function (props) {
            return $elm$core$String$replace_fn("(", "-", $elm$core$String$replace_fn(")", "-", $elm$core$String$replace_fn(".", "-", $elm$core$String$replace_fn(",", "-", $elm$core$String$replace_fn(" ", "-", $elm$core$String$join_fn("-", _Utils_ap(_List_fromArray([
                "elm-charts__pattern",
                function () {
                    switch (design.$) {
                        case 0:
                            return "striped";
                        case 1:
                            return "dotted";
                        default:
                            return "gradient";
                    }
                }()
            ]), props)))))));
        };
        var toPatternDefs = F4(function (id, spacing, rotate, inside) {
            return $elm$svg$Svg$defs_fn(_List_Nil, _List_fromArray([
                $elm$svg$Svg$pattern_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$id_a0, id),
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$patternUnits_a0, "userSpaceOnUse"),
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat(spacing)),
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat(spacing)),
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$patternTransform_a0, "rotate(" + ($elm$core$String$fromFloat(rotate) + ")"))
                ]), _List_fromArray([inside]))
            ]));
        });
        var _v0 = function () {
            switch (design.$) {
                case 0:
                    var edits = design.a;
                    var config = $terezka$elm_charts$Internal$Svg$apply_fn(edits, { bw: defaultColor, Y: 45, oT: 4, ir: 3 });
                    var theId = toPatternId(_List_fromArray([
                        config.bw,
                        $elm$core$String$fromFloat(config.ir),
                        $elm$core$String$fromFloat(config.oT),
                        $elm$core$String$fromFloat(config.Y)
                    ]));
                    return _Utils_Tuple2(A4(toPatternDefs, theId, config.oT, config.Y, $elm$svg$Svg$line_fn(_List_fromArray([
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x1_a0, "0"),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y_a0, "0"),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x2_a0, "0"),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y2_a0, $elm$core$String$fromFloat(config.oT)),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, config.bw),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.ir))
                    ]), _List_Nil)), theId);
                case 1:
                    var edits = design.a;
                    var config = $terezka$elm_charts$Internal$Svg$apply_fn(edits, { bw: defaultColor, Y: 45, oT: 4, ir: 3 });
                    var theId = toPatternId(_List_fromArray([
                        config.bw,
                        $elm$core$String$fromFloat(config.ir),
                        $elm$core$String$fromFloat(config.oT),
                        $elm$core$String$fromFloat(config.Y)
                    ]));
                    return _Utils_Tuple2(A4(toPatternDefs, theId, config.oT, config.Y, $elm$svg$Svg$circle_fn(_List_fromArray([
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, config.bw),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$cx_a0, $elm$core$String$fromFloat(config.ir / 3)),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$cy_a0, $elm$core$String$fromFloat(config.ir / 3)),
                        _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$r_a0, $elm$core$String$fromFloat(config.ir / 3))
                    ]), _List_Nil)), theId);
                default:
                    var edits = design.a;
                    var colors = _Utils_eq(edits, _List_Nil) ? _List_fromArray([defaultColor, "white"]) : edits;
                    var theId = toPatternId(colors);
                    var totalColors = $elm$core$List$length(colors);
                    var toPercentage = function (i) {
                        return (i * 100) / (totalColors - 1);
                    };
                    var toStop = F2(function (i, c) {
                        return $elm$svg$Svg$stop_fn(_List_fromArray([
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$offset_a0, $elm$core$String$fromFloat(toPercentage(i)) + "%"),
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stopColor_a0, c)
                        ]), _List_Nil);
                    });
                    return _Utils_Tuple2($elm$svg$Svg$defs_fn(_List_Nil, _List_fromArray([
                        $elm$svg$Svg$linearGradient_fn(_List_fromArray([
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$id_a0, theId),
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x1_a0, "0"),
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x2_a0, "0"),
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y1_a0, "0"),
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y2_a0, "1")
                        ]), $elm$core$List$indexedMap_fn(toStop, colors))
                    ])), theId);
            }
        }();
        var patternDefs = _v0.a;
        var patternId = _v0.b;
        return _Utils_Tuple2(patternDefs, "url(#" + (patternId + ")"));
    }, $terezka$elm_charts$Internal$Svg$toPattern = F2($terezka$elm_charts$Internal$Svg$toPattern_fn);
    var $terezka$elm_charts$Internal$Svg$withAttrs_fn = function (attrs, toEl, defaultAttrs) {
        return toEl(_Utils_ap(defaultAttrs, $elm$core$List$map_fn($elm$html$Html$Attributes$map($elm$core$Basics$never), attrs)));
    }, $terezka$elm_charts$Internal$Svg$withAttrs = F3($terezka$elm_charts$Internal$Svg$withAttrs_fn);
    var $elm$svg$Svg$Attributes$clipPath_a0 = "clip-path", $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute($elm$svg$Svg$Attributes$clipPath_a0);
    var $terezka$elm_charts$Internal$Coordinates$toId = function (plane) {
        var numToStr = A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, A2($elm$core$String$replace, ".", "-"));
        return $elm$core$String$join_fn("_", _List_fromArray([
            "elm-charts__id",
            numToStr(plane.pH.hl),
            numToStr(plane.pH.np),
            numToStr(plane.pH.ne),
            numToStr(plane.pH.nc),
            numToStr(plane.pH.nb),
            numToStr(plane.pJ.hl),
            numToStr(plane.pJ.np),
            numToStr(plane.pJ.ne),
            numToStr(plane.pJ.nc),
            numToStr(plane.pJ.nb)
        ]));
    };
    var $terezka$elm_charts$Internal$Svg$withinChartArea = function (plane) {
        return _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$clipPath_a0, "url(#" + ($terezka$elm_charts$Internal$Coordinates$toId(plane) + ")"));
    };
    var $terezka$elm_charts$Internal$Svg$bar_fn = function (plane, config, point) {
        var viewBar = F6(function (fill, fillOpacity, border, borderWidth, strokeOpacity, cmds) {
            return A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$path, _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__bar"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, fill),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fillOpacity_a0, $elm$core$String$fromFloat(fillOpacity)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, border),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(borderWidth)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeOpacity_a0, $elm$core$String$fromFloat(strokeOpacity)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Commands$description_fn(plane, cmds)),
                $terezka$elm_charts$Internal$Svg$withinChartArea(plane)
            ]), _List_Nil);
        });
        var highlightColor = (config.mH === "") ? config.bw : config.mH;
        var borderWidthCarY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, config.aB / 2);
        var highlightWidthCarY = borderWidthCarY + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, config.mI / 2);
        var borderWidthCarX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, config.aB / 2);
        var highlightWidthCarX = borderWidthCarX + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, config.mI / 2);
        var pos = {
            dv: $elm$core$Basics$min_fn(point.dv, point.eW) + borderWidthCarX,
            eW: $elm$core$Basics$max_fn(point.dv, point.eW) - borderWidthCarX,
            pK: $elm$core$Basics$min_fn(point.pK, point.iu) + borderWidthCarY,
            iu: $elm$core$Basics$max_fn(point.pK, point.iu) - borderWidthCarY
        };
        var height = $elm$core$Basics$abs(pos.iu - pos.pK);
        var highlightPos = { dv: pos.dv - highlightWidthCarX, eW: pos.eW + highlightWidthCarX, pK: pos.pK - highlightWidthCarY, iu: pos.iu + highlightWidthCarY };
        var width = $elm$core$Basics$abs(pos.eW - pos.dv);
        var roundingBottom = ($terezka$elm_charts$Internal$Coordinates$scaleSVGX_fn(plane, width) * 0.5) * $elm$core$Basics$clamp_fn(0, 1, config.oH);
        var radiusBottomX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, roundingBottom);
        var radiusBottomY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, roundingBottom);
        var roundingTop = ($terezka$elm_charts$Internal$Coordinates$scaleSVGX_fn(plane, width) * 0.5) * $elm$core$Basics$clamp_fn(0, 1, config.oI);
        var radiusTopX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, roundingTop);
        var radiusTopY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, roundingTop);
        var _v0 = ((((height - (radiusTopY * 0.8)) - (radiusBottomY * 0.8)) <= 0) || (((width - (radiusTopX * 0.8)) - (radiusBottomX * 0.8)) <= 0)) ? _Utils_Tuple2(0, 0) : _Utils_Tuple2(config.oI, config.oH);
        var roundTop = _v0.a;
        var roundBottom = _v0.b;
        var _v1 = function () {
            if (_Utils_eq(pos.pK, pos.iu)) {
                return _Utils_Tuple2(_List_Nil, _List_Nil);
            }
            else {
                var _v2 = _Utils_Tuple2(roundTop > 0, roundBottom > 0);
                if (!_v2.a) {
                    if (!_v2.b) {
                        return _Utils_Tuple2(_List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(pos.dv, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK)
                        ]), _List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(highlightPos.dv, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK)
                        ]));
                    }
                    else {
                        return _Utils_Tuple2(_List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(pos.dv + radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, pos.dv, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, pos.eW - radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv + radiusBottomX, pos.pK)
                        ]), _List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(highlightPos.dv + radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, highlightPos.dv, highlightPos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, highlightPos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, highlightPos.eW - radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv + radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW - radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, false, pos.eW, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK)
                        ]));
                    }
                }
                else {
                    if (!_v2.b) {
                        return _Utils_Tuple2(_List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(pos.dv, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, pos.dv + radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW - radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, pos.eW, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK)
                        ]), _List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(highlightPos.dv, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv, highlightPos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, highlightPos.dv + radiusTopX, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW - radiusTopX, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, highlightPos.eW, highlightPos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, false, pos.eW - radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv + radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, false, pos.dv, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK)
                        ]));
                    }
                    else {
                        return _Utils_Tuple2(_List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(pos.dv + radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, pos.dv, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, pos.dv + radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW - radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, pos.eW, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, pos.eW - radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv + radiusBottomX, pos.pK)
                        ]), _List_fromArray([
                            $terezka$elm_charts$Internal$Commands$Move_fn(highlightPos.dv + radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, highlightPos.dv, highlightPos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv, highlightPos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, highlightPos.dv + radiusTopX, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW - radiusTopX, highlightPos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, true, highlightPos.eW, highlightPos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.eW, highlightPos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, true, highlightPos.eW - radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(highlightPos.dv + radiusBottomX, highlightPos.pK),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW - radiusBottomX, pos.pK),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingBottom, roundingBottom, -45, false, false, pos.eW, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, false, pos.eW - radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv + radiusTopX, pos.iu),
                            $terezka$elm_charts$Internal$Commands$Arc_fn(roundingTop, roundingTop, -45, false, false, pos.dv, pos.iu - radiusTopY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.dv, pos.pK + radiusBottomY),
                            $terezka$elm_charts$Internal$Commands$Line_fn(pos.eW, pos.pK)
                        ]));
                    }
                }
            }
        }();
        var commands = _v1.a;
        var highlightCommands = _v1.b;
        var viewAuraBar = function (fill) {
            return (!config.c4) ? A6(viewBar, fill, config.bg, config.au, config.aB, 1, commands) : $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__bar-with-highlight")
            ]), _List_fromArray([
                A6(viewBar, highlightColor, config.c4, "transparent", 0, 0, highlightCommands),
                A6(viewBar, fill, config.bg, config.au, config.aB, 1, commands)
            ]));
        };
        var _v3 = config.gL;
        if (_v3.$ === 1) {
            return viewAuraBar(config.bw);
        }
        else {
            var design = _v3.a;
            var _v4 = $terezka$elm_charts$Internal$Svg$toPattern_fn(config.bw, design);
            var patternDefs = _v4.a;
            var fill = _v4.b;
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__bar-with-pattern")
            ]), _List_fromArray([
                patternDefs,
                viewAuraBar(fill)
            ]));
        }
    }, $terezka$elm_charts$Internal$Svg$bar = F3($terezka$elm_charts$Internal$Svg$bar_fn);
    var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
    var $terezka$elm_charts$Internal$Produce$toDefaultName_fn = function (index, name) {
        return $elm$core$Maybe$withDefault_fn("Property #" + $elm$core$String$fromInt(index + 1), name);
    }, $terezka$elm_charts$Internal$Produce$toDefaultName = F2($terezka$elm_charts$Internal$Produce$toDefaultName_fn);
    var $elm$html$Html$td = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "td"), $elm$html$Html$td_fn = $elm$html$Html$td.a2;
    var $elm$html$Html$tr = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "tr"), $elm$html$Html$tr_fn = $elm$html$Html$tr.a2;
    var $terezka$elm_charts$Internal$Produce$tooltipRow_fn = function (color, title, text) {
        return $elm$html$Html$tr_fn(_List_Nil, _List_fromArray([
            $elm$html$Html$td_fn(_List_fromArray([
                _VirtualDom_style_fn("color", color),
                _VirtualDom_style_fn("padding", "0"),
                _VirtualDom_style_fn("padding-right", "3px")
            ]), _List_fromArray([
                $elm$html$Html$text(title + ":")
            ])),
            $elm$html$Html$td_fn(_List_fromArray([
                _VirtualDom_style_fn("text-align", "right"),
                _VirtualDom_style_fn("padding", "0")
            ]), _List_fromArray([
                $elm$html$Html$text(text)
            ]))
        ]));
    }, $terezka$elm_charts$Internal$Produce$tooltipRow = F3($terezka$elm_charts$Internal$Produce$tooltipRow_fn);
    var $terezka$elm_charts$Internal$Helpers$withSurround_fn = function (all, func) {
        var fold = F4(function (index, prev, acc, list) {
            fold: while (true) {
                if (list.b) {
                    if (list.b.b) {
                        var a = list.a;
                        var _v1 = list.b;
                        var b = _v1.a;
                        var rest = _v1.b;
                        var $temp$index = index + 1, $temp$prev = $elm$core$Maybe$Just(a), $temp$acc = _Utils_ap(acc, _List_fromArray([
                            A4(func, index, prev, a, $elm$core$Maybe$Just(b))
                        ])), $temp$list = _List_Cons(b, rest);
                        index = $temp$index;
                        prev = $temp$prev;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue fold;
                    }
                    else {
                        var a = list.a;
                        return _Utils_ap(acc, _List_fromArray([
                            A4(func, index, prev, a, $elm$core$Maybe$Nothing)
                        ]));
                    }
                }
                else {
                    return acc;
                }
            }
        });
        return A4(fold, 0, $elm$core$Maybe$Nothing, _List_Nil, all);
    }, $terezka$elm_charts$Internal$Helpers$withSurround_fn_unwrapped = function (all, func) {
        var fold = F4(function (index, prev, acc, list) {
            fold: while (true) {
                if (list.b) {
                    if (list.b.b) {
                        var a = list.a;
                        var _v1 = list.b;
                        var b = _v1.a;
                        var rest = _v1.b;
                        var $temp$index = index + 1, $temp$prev = $elm$core$Maybe$Just(a), $temp$acc = _Utils_ap(acc, _List_fromArray([
                            func(index, prev, a, $elm$core$Maybe$Just(b))
                        ])), $temp$list = _List_Cons(b, rest);
                        index = $temp$index;
                        prev = $temp$prev;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue fold;
                    }
                    else {
                        var a = list.a;
                        return _Utils_ap(acc, _List_fromArray([
                            func(index, prev, a, $elm$core$Maybe$Nothing)
                        ]));
                    }
                }
                else {
                    return acc;
                }
            }
        });
        return A4(fold, 0, $elm$core$Maybe$Nothing, _List_Nil, all);
    }, $terezka$elm_charts$Internal$Helpers$withSurround = F2($terezka$elm_charts$Internal$Helpers$withSurround_fn);
    var $terezka$elm_charts$Internal$Produce$toBarSeries_fn = function (elIndex, barsAttrs, properties, data) {
        var toBarConfig = function (attrs) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(attrs, $terezka$elm_charts$Internal$Svg$defaultBar);
        };
        var barsConfig = $terezka$elm_charts$Internal$Helpers$apply_fn(barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
        var toBarItem = F7(function (sections, barIndex, sectionIndex, section, colorIndex, dataIndex, bin) {
            var visual = section.eV(bin.l2);
            var value = section.pB(bin.l2);
            var start = bin.x;
            var numOfSections = $elm$core$List$length(sections);
            var numOfBars = barsConfig.mF ? $elm$core$List$length(properties) : 1;
            var minY = (numOfSections > 1) ? $elm$core$Basics$max(0) : $elm$core$Basics$identity;
            var y1 = minY($elm$core$Maybe$withDefault_fn(0, visual) - $elm$core$Maybe$withDefault_fn(0, value));
            var y2 = minY($elm$core$Maybe$withDefault_fn(0, visual));
            var isSingle = numOfSections === 1;
            var isLast = sectionIndex === numOfSections - 1;
            var roundTop = (isSingle || isLast) ? barsConfig.oI : 0;
            var isFirst = !sectionIndex;
            var roundBottom = (isSingle || isFirst) ? barsConfig.oH : 0;
            var end = bin.u;
            var length = end - start;
            var margin = length * barsConfig.cr;
            var spacing = length * barsConfig.oT;
            var width = ((length - (margin * 2)) - ((numOfBars - 1) * spacing)) / numOfBars;
            var offset = barsConfig.mF ? ((barIndex * width) + (barIndex * spacing)) : 0;
            var x1 = (start + margin) + offset;
            var x2 = ((start + margin) + offset) + width;
            var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefault_fn($terezka$elm_charts$Internal$Helpers$toDefaultColor_a0, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1, colorIndex);
            var defaultAttrs = _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$roundTop(roundTop),
                $terezka$elm_charts$Chart$Attributes$roundBottom(roundBottom),
                $terezka$elm_charts$Chart$Attributes$color(defaultColor),
                $terezka$elm_charts$Chart$Attributes$border(defaultColor)
            ]);
            var attrs = _Utils_ap(defaultAttrs, _Utils_ap(section.E, A5(section.ms, barIndex, sectionIndex, dataIndex, section.j1, bin.l2)));
            var productOrg = toBarConfig(attrs);
            var product = function (p) {
                return _Utils_eq(p.au, defaultColor) ? _Utils_update(p, { au: p.bw }) : p;
            }(function (p) {
                var _v21 = p.gL;
                if (((!_v21.$) && (_v21.a.$ === 2)) && _v21.a.a.b) {
                    var _v22 = _v21.a.a;
                    var color = _v22.a;
                    return _Utils_eq(p.bw, defaultColor) ? _Utils_update(p, { bw: color }) : p;
                }
                else {
                    return p;
                }
            }(productOrg));
            return {
                aQ: {
                    oj: product,
                    pi: $terezka$elm_charts$Internal$Item$Bar,
                    gg: {
                        au: product.au,
                        aB: product.aB,
                        bw: product.bw,
                        i_: dataIndex,
                        mi: elIndex,
                        jp: section.d7(bin.l2),
                        i: colorIndex,
                        M: section.j1,
                        ok: barIndex,
                        oU: sectionIndex
                    },
                    pC: {
                        l2: bin.l2,
                        mS: function () {
                            if (!value.$) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }(),
                        dv: start,
                        eW: end,
                        pJ: $elm$core$Maybe$withDefault_fn(0, value)
                    }
                },
                pj: function (c) {
                    return _List_fromArray([
                        $terezka$elm_charts$Internal$Produce$tooltipRow_fn(c.gg.bw, $terezka$elm_charts$Internal$Produce$toDefaultName_fn(colorIndex, c.gg.M), section.d7(bin.l2))
                    ]);
                },
                pk: function (config) {
                    return {
                        dv: x1,
                        eW: x2,
                        pK: $elm$core$Basics$min_fn(y1, y2),
                        iu: $elm$core$Basics$max_fn(y1, y2)
                    };
                },
                pn: F2(function (_v20, config) {
                    return { dv: x1, eW: x2, pK: y1, iu: y2 };
                }),
                po: F3(function (plane, config, position) {
                    return $terezka$elm_charts$Internal$Svg$bar_fn(plane, product, position);
                })
            };
        });
        var toSeriesItem = F6(function (bins, sections, barIndex, sectionIndex, section, colorIndex) {
            var _v13 = $elm$core$List$indexedMap_fn(A5(toBarItem, sections, barIndex, sectionIndex, section, colorIndex), bins);
            if (!_v13.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var first = _v13.a;
                var rest = _v13.b;
                return $elm$core$Maybe$Just({
                    aQ: {
                        aZ: _Utils_Tuple2(first, rest)
                    },
                    pj: function (c) {
                        return _List_fromArray([
                            $elm$html$Html$table_fn(_List_fromArray([
                                _VirtualDom_style_fn("margin", "0")
                            ]), $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Item$toHtml, function (_v14) {
                                var x = _v14.a;
                                var xs = _v14.b;
                                return _List_Cons(x, xs);
                            }(c.aZ)))
                        ]);
                    },
                    pk: function (c) {
                        return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getLimits, function (_v15) {
                            var x = _v15.a;
                            var xs = _v15.b;
                            return _List_Cons(x, xs);
                        }(c.aZ));
                    },
                    pn: F2(function (plane, c) {
                        return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getPosition(plane), function (_v16) {
                            var x = _v16.a;
                            var xs = _v16.b;
                            return _List_Cons(x, xs);
                        }(c.aZ));
                    }),
                    po: F3(function (plane, c, _v17) {
                        return $elm$svg$Svg$g_fn(_List_fromArray([
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__bar-series")
                        ]), $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$toSvg(plane), function (_v18) {
                            var x = _v18.a;
                            var xs = _v18.b;
                            return _List_Cons(x, xs);
                        }(c.aZ)));
                    })
                });
            }
        });
        var toBin = F4(function (index, prevM, curr, nextM) {
            var _v0 = _Utils_Tuple2(barsConfig.dv, barsConfig.eW);
            if (_v0.a.$ === 1) {
                if (_v0.b.$ === 1) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    return { l2: curr, u: (index + 1) + 0.5, x: (index + 1) - 0.5 };
                }
                else {
                    var _v8 = _v0.a;
                    var toEnd = _v0.b.a;
                    var _v9 = _Utils_Tuple2(prevM, nextM);
                    if (!_v9.a.$) {
                        var prev = _v9.a.a;
                        return {
                            l2: curr,
                            u: toEnd(curr),
                            x: toEnd(prev)
                        };
                    }
                    else {
                        if (!_v9.b.$) {
                            var _v10 = _v9.a;
                            var next = _v9.b.a;
                            return {
                                l2: curr,
                                u: toEnd(curr),
                                x: toEnd(curr) - (toEnd(next) - toEnd(curr))
                            };
                        }
                        else {
                            var _v11 = _v9.a;
                            var _v12 = _v9.b;
                            return {
                                l2: curr,
                                u: toEnd(curr),
                                x: toEnd(curr) - 1
                            };
                        }
                    }
                }
            }
            else {
                if (_v0.b.$ === 1) {
                    var toStart = _v0.a.a;
                    var _v3 = _v0.b;
                    var _v4 = _Utils_Tuple2(prevM, nextM);
                    if (!_v4.b.$) {
                        var next = _v4.b.a;
                        return {
                            l2: curr,
                            u: toStart(next),
                            x: toStart(curr)
                        };
                    }
                    else {
                        if (!_v4.a.$) {
                            var prev = _v4.a.a;
                            var _v5 = _v4.b;
                            return {
                                l2: curr,
                                u: toStart(curr) + (toStart(curr) - toStart(prev)),
                                x: toStart(curr)
                            };
                        }
                        else {
                            var _v6 = _v4.a;
                            var _v7 = _v4.b;
                            return {
                                l2: curr,
                                u: toStart(curr) + 1,
                                x: toStart(curr)
                            };
                        }
                    }
                }
                else {
                    var toStart = _v0.a.a;
                    var toEnd = _v0.b.a;
                    return {
                        l2: curr,
                        u: toEnd(curr),
                        x: toStart(curr)
                    };
                }
            }
        });
        return function (bins) {
            return $elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$List$indexedMap_fn_unwrapped(function (propIndex, f) {
                return f(elIndex + propIndex);
            }, $elm$core$List$concat($elm$core$List$indexedMap_fn_unwrapped(function (barIndex, stacks) {
                return $elm$core$List$indexedMap_fn(A3(toSeriesItem, bins, stacks, barIndex), $elm$core$List$reverse(stacks));
            }, $elm$core$List$map_fn($terezka$elm_charts$Internal$Property$toConfigs, properties)))));
        }($terezka$elm_charts$Internal$Helpers$withSurround_fn(data, toBin));
    }, $terezka$elm_charts$Internal$Produce$toBarSeries = F4($terezka$elm_charts$Internal$Produce$toBarSeries_fn);
    var $terezka$elm_charts$Chart$barsMap_fn = function (mapData, edits, properties, data) {
        return $terezka$elm_charts$Chart$Indexed(function (index) {
            var legends_ = $terezka$elm_charts$Internal$Legend$toBarLegends_fn(index, edits, properties);
            var items = $terezka$elm_charts$Internal$Produce$toBarSeries_fn(index, edits, properties, data);
            var generalized = $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$map(mapData), $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Many$getGenerals, items));
            var bins = $terezka$elm_charts$Internal$Many$apply_fn($terezka$elm_charts$Chart$Item$bins, generalized);
            var toLimits = $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$getLimits, bins);
            var barsConfig = $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Produce$defaultBars);
            var toTicks = F2(function (plane, acc) {
                return _Utils_update(acc, {
                    aO: _Utils_ap(acc.aO, barsConfig.L ? $elm$core$List$concatMap_fn(A2($elm$core$Basics$composeR, $terezka$elm_charts$Chart$Item$getLimits, function (pos) {
                        return _List_fromArray([pos.dv, pos.eW]);
                    }), bins) : _List_Nil)
                });
            });
            return _Utils_Tuple2($terezka$elm_charts$Chart$BarsElement_fn(toLimits, generalized, legends_, toTicks, function (plane) {
                return _VirtualDom_map_fn($elm$core$Basics$never, $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__bar-series")
                ]), $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$toSvg(plane), items)));
            }), index + $elm$core$List$length($elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Property$toConfigs, properties)));
        });
    }, $terezka$elm_charts$Chart$barsMap = F4($terezka$elm_charts$Chart$barsMap_fn);
    var $terezka$elm_charts$Internal$Svg$Event_fn = function (name, handler) {
        return { jw: handler, M: name };
    }, $terezka$elm_charts$Internal$Svg$Event = F2($terezka$elm_charts$Internal$Svg$Event_fn);
    var $elm$svg$Svg$clipPath = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "clipPath"), $elm$svg$Svg$clipPath_fn = $elm$svg$Svg$clipPath.a2;
    var $debois$elm_dom$DOM$offsetHeight = _Json_decodeField_fn("offsetHeight", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$offsetWidth = _Json_decodeField_fn("offsetWidth", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$offsetLeft = _Json_decodeField_fn("offsetLeft", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$offsetParent_fn = function (x, decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_decodeField_fn("offsetParent", $elm$json$Json$Decode$null(x)),
            _Json_decodeField_fn("offsetParent", decoder)
        ]));
    }, $debois$elm_dom$DOM$offsetParent = F2($debois$elm_dom$DOM$offsetParent_fn);
    var $debois$elm_dom$DOM$offsetTop = _Json_decodeField_fn("offsetTop", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$scrollLeft = _Json_decodeField_fn("scrollLeft", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$scrollTop = _Json_decodeField_fn("scrollTop", $elm$json$Json$Decode$float);
    var $debois$elm_dom$DOM$position_fn = function (x, y) {
        return _Json_andThen_fn(function (_v0) {
            var x_ = _v0.a;
            var y_ = _v0.b;
            return $debois$elm_dom$DOM$offsetParent_fn(_Utils_Tuple2(x_, y_), $debois$elm_dom$DOM$position_fn(x_, y_));
        }, _Json_map4_fn(F4(function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
            return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
        }), $debois$elm_dom$DOM$scrollLeft, $debois$elm_dom$DOM$scrollTop, $debois$elm_dom$DOM$offsetLeft, $debois$elm_dom$DOM$offsetTop));
    }, $debois$elm_dom$DOM$position = F2($debois$elm_dom$DOM$position_fn);
    var $debois$elm_dom$DOM$boundingClientRect = _Json_map3_fn(F3(function (_v0, width, height) {
        var x = _v0.a;
        var y = _v0.b;
        return { g$: height, jW: x, k3: y, ir: width };
    }), $debois$elm_dom$DOM$position_fn(0, 0), $debois$elm_dom$DOM$offsetWidth, $debois$elm_dom$DOM$offsetHeight);
    var $debois$elm_dom$DOM$parentElement = function (decoder) {
        return _Json_decodeField_fn("parentElement", decoder);
    };
    function $terezka$elm_charts$Internal$Svg$cyclic$decodePosition() {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $debois$elm_dom$DOM$boundingClientRect,
            $elm$json$Json$Decode$lazy(function (_v0) {
                return $debois$elm_dom$DOM$parentElement($terezka$elm_charts$Internal$Svg$cyclic$decodePosition());
            })
        ]));
    }
    var $terezka$elm_charts$Internal$Svg$decodePosition = $terezka$elm_charts$Internal$Svg$cyclic$decodePosition();
    $terezka$elm_charts$Internal$Svg$cyclic$decodePosition = function () {
        return $terezka$elm_charts$Internal$Svg$decodePosition;
    };
    var $terezka$elm_charts$Internal$Coordinates$toCartesianX_fn = function (plane, value) {
        return $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, value - plane.pH.nc) + plane.pH.np;
    }, $terezka$elm_charts$Internal$Coordinates$toCartesianX = F2($terezka$elm_charts$Internal$Coordinates$toCartesianX_fn);
    var $terezka$elm_charts$Internal$Coordinates$toCartesianY_fn = function (plane, value) {
        return ($terezka$elm_charts$Internal$Coordinates$range(plane.pJ) - $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, value - plane.pJ.nc)) + plane.pJ.np;
    }, $terezka$elm_charts$Internal$Coordinates$toCartesianY = F2($terezka$elm_charts$Internal$Coordinates$toCartesianY_fn);
    var $terezka$elm_charts$Internal$Svg$fromSvg_fn = function (plane, point) {
        return {
            pH: $terezka$elm_charts$Internal$Coordinates$toCartesianX_fn(plane, point.pH),
            pJ: $terezka$elm_charts$Internal$Coordinates$toCartesianY_fn(plane, point.pJ)
        };
    }, $terezka$elm_charts$Internal$Svg$fromSvg = F2($terezka$elm_charts$Internal$Svg$fromSvg_fn);
    var $debois$elm_dom$DOM$target = function (decoder) {
        return _Json_decodeField_fn("target", decoder);
    };
    var $terezka$elm_charts$Internal$Svg$decoder_fn = function (plane, toMsg) {
        var handle = F3(function (mouseX, mouseY, box) {
            var yPrev = plane.pJ;
            var xPrev = plane.pH;
            var widthPercent = box.ir / plane.pH.hl;
            var heightPercent = box.g$ / plane.pJ.hl;
            var newPlane = _Utils_update(plane, {
                pH: _Utils_update(xPrev, { hl: box.ir, nb: plane.pH.nb * widthPercent, nc: plane.pH.nc * widthPercent }),
                pJ: _Utils_update(yPrev, { hl: box.g$, nb: plane.pJ.nb * heightPercent, nc: plane.pJ.nc * heightPercent })
            });
            var searched = $terezka$elm_charts$Internal$Svg$fromSvg_fn(newPlane, { pH: mouseX - box.jW, pJ: mouseY - box.k3 });
            return A2(toMsg, newPlane, searched);
        });
        return _Json_map3_fn(handle, _Json_decodeField_fn("pageX", $elm$json$Json$Decode$float), _Json_decodeField_fn("pageY", $elm$json$Json$Decode$float), $debois$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
    }, $terezka$elm_charts$Internal$Svg$decoder_fn_unwrapped = function (plane, toMsg) {
        var handle = F3(function (mouseX, mouseY, box) {
            var yPrev = plane.pJ;
            var xPrev = plane.pH;
            var widthPercent = box.ir / plane.pH.hl;
            var heightPercent = box.g$ / plane.pJ.hl;
            var newPlane = _Utils_update(plane, {
                pH: _Utils_update(xPrev, { hl: box.ir, nb: plane.pH.nb * widthPercent, nc: plane.pH.nc * widthPercent }),
                pJ: _Utils_update(yPrev, { hl: box.g$, nb: plane.pJ.nb * heightPercent, nc: plane.pJ.nc * heightPercent })
            });
            var searched = $terezka$elm_charts$Internal$Svg$fromSvg_fn(newPlane, { pH: mouseX - box.jW, pJ: mouseY - box.k3 });
            return toMsg(newPlane, searched);
        });
        return _Json_map3_fn(handle, _Json_decodeField_fn("pageX", $elm$json$Json$Decode$float), _Json_decodeField_fn("pageY", $elm$json$Json$Decode$float), $debois$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
    }, $terezka$elm_charts$Internal$Svg$decoder = F2($terezka$elm_charts$Internal$Svg$decoder_fn);
    var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
    var $elm$svg$Svg$rect = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "rect"), $elm$svg$Svg$rect_fn = $elm$svg$Svg$rect.a2;
    var $elm$svg$Svg$svg = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "svg"), $elm$svg$Svg$svg_fn = $elm$svg$Svg$svg.a2;
    var $elm$svg$Svg$Attributes$viewBox_a0 = "viewBox", $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute($elm$svg$Svg$Attributes$viewBox_a0);
    var $elm$svg$Svg$Attributes$x_a0 = "x", $elm$svg$Svg$Attributes$x = _VirtualDom_attribute($elm$svg$Svg$Attributes$x_a0);
    var $terezka$elm_charts$Internal$Svg$container_fn = function (plane, config, below, chartEls, above) {
        var toEvent = function (event) {
            return $elm$html$Html$Events$on_fn(event.M, $terezka$elm_charts$Internal$Svg$decoder_fn(plane, event.jw));
        };
        var svgAttrsSize = config.fX ? _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "0 0 " + ($elm$core$String$fromFloat(plane.pH.hl) + (" " + $elm$core$String$fromFloat(plane.pJ.hl)))),
            _VirtualDom_style_fn("display", "block")
        ]) : _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat(plane.pH.hl)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat(plane.pJ.hl)),
            _VirtualDom_style_fn("display", "block")
        ]);
        var htmlAttrsSize = config.fX ? _List_fromArray([
            _VirtualDom_style_fn("width", "100%"),
            _VirtualDom_style_fn("height", "100%")
        ]) : _List_fromArray([
            _VirtualDom_style_fn("width", $elm$core$String$fromFloat(plane.pH.hl) + "px"),
            _VirtualDom_style_fn("height", $elm$core$String$fromFloat(plane.pJ.hl) + "px")
        ]);
        var htmlAttrsDef = _List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "elm-charts__container-inner")
        ]);
        var htmlAttrs = _Utils_ap(config.fs, _Utils_ap(htmlAttrsDef, htmlAttrsSize));
        var chartPosition = _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x_a0, $elm$core$String$fromFloat(plane.pH.nc)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y_a0, $elm$core$String$fromFloat(plane.pJ.nc)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$innerWidth(plane))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$innerHeight(plane))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "transparent")
        ]);
        var clipPathDefs = $elm$svg$Svg$defs_fn(_List_Nil, _List_fromArray([
            $elm$svg$Svg$clipPath_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$id_a0, $terezka$elm_charts$Internal$Coordinates$toId(plane))
            ]), _List_fromArray([
                $elm$svg$Svg$rect_fn(chartPosition, _List_Nil)
            ]))
        ]));
        var catcher = $elm$svg$Svg$rect_fn(_Utils_ap(chartPosition, $elm$core$List$map_fn(toEvent, config.mn)), _List_Nil);
        var chart = $elm$svg$Svg$svg_fn(_Utils_ap(svgAttrsSize, config.E), _Utils_ap(_List_fromArray([clipPathDefs]), _Utils_ap(chartEls, _List_fromArray([catcher]))));
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "elm-charts__container"),
            _VirtualDom_style_fn("position", "relative")
        ]), _List_fromArray([
            $elm$html$Html$div_fn(htmlAttrs, _Utils_ap(below, _Utils_ap(_List_fromArray([chart]), above)))
        ]));
    }, $terezka$elm_charts$Internal$Svg$container = F5($terezka$elm_charts$Internal$Svg$container_fn);
    var $terezka$elm_charts$Chart$Attributes$lowest_fn = function (v, edit, b) {
        return _Utils_update(b, {
            np: A3(edit, v, b.np, b.l_)
        });
    }, $terezka$elm_charts$Chart$Attributes$lowest_fn_unwrapped = function (v, edit, b) {
        return _Utils_update(b, {
            np: edit(v, b.np, b.l_)
        });
    }, $terezka$elm_charts$Chart$Attributes$lowest = F3($terezka$elm_charts$Chart$Attributes$lowest_fn);
    var $terezka$elm_charts$Chart$Attributes$orLower_fn = function (least, real, _v0) {
        return (_Utils_cmp(real, least) > 0) ? least : real;
    }, $terezka$elm_charts$Chart$Attributes$orLower = F3($terezka$elm_charts$Chart$Attributes$orLower_fn);
    var $terezka$elm_charts$Chart$definePlane_fn = function (config, elements) {
        var width = $elm$core$Basics$max_fn(1, (config.ir - config.bh.jW) - config.bh.et);
        var toLimit = F5(function (length, marginMin, marginMax, min, max) {
            return { lZ: max, l_: min, hl: length, nb: marginMax, nc: marginMin, ne: max, np: min };
        });
        var height = $elm$core$Basics$max_fn(1, (config.g$ - config.bh.dR) - config.bh.k3);
        var fixSingles = function (bs) {
            return _Utils_eq(bs.np, bs.ne) ? _Utils_update(bs, { ne: bs.np + 10 }) : bs;
        };
        var collectLimits = F2(function (el, acc) {
            switch (el.$) {
                case 0:
                    return acc;
                case 1:
                    var lims = el.a;
                    return _Utils_ap(acc, lims);
                case 2:
                    var lims = el.a;
                    return _Utils_ap(acc, lims);
                case 3:
                    return acc;
                case 4:
                    return acc;
                case 5:
                    return acc;
                case 6:
                    return acc;
                case 7:
                    return acc;
                case 8:
                    return acc;
                case 9:
                    return acc;
                case 10:
                    return acc;
                case 11:
                    var subs = el.a;
                    return $elm$core$List$foldl_fn(collectLimits, acc, subs);
                case 12:
                    return acc;
                default:
                    return acc;
            }
        });
        var limits_ = function (pos) {
            return function (_v3) {
                var x = _v3.pH;
                var y = _v3.pJ;
                return {
                    pH: fixSingles(x),
                    pJ: fixSingles(y)
                };
            }({
                pH: A5(toLimit, width, config.cr.jW, config.cr.et, pos.dv, pos.eW),
                pJ: A5(toLimit, height, config.cr.k3, config.cr.dR, pos.pK, pos.iu)
            });
        }($terezka$elm_charts$Internal$Coordinates$foldPosition_fn($elm$core$Basics$identity, $elm$core$List$foldl_fn(collectLimits, _List_Nil, elements)));
        var calcRange = function () {
            var _v2 = config.hR;
            if (!_v2.b) {
                return limits_.pH;
            }
            else {
                var some = _v2;
                return $elm$core$List$foldl_fn_unwrapped(function (f, b) {
                    return f(b);
                }, limits_.pH, some);
            }
        }();
        var calcDomain = function () {
            var _v1 = config.gM;
            if (!_v1.b) {
                return $terezka$elm_charts$Chart$Attributes$lowest_fn(0, $terezka$elm_charts$Chart$Attributes$orLower, limits_.pJ);
            }
            else {
                var some = _v1;
                return $elm$core$List$foldl_fn_unwrapped(function (f, b) {
                    return f(b);
                }, limits_.pJ, some);
            }
        }();
        var unpadded = { pH: calcRange, pJ: calcDomain };
        var scalePadX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX(unpadded);
        var xMax = calcRange.ne + scalePadX(config.bh.et);
        var xMin = calcRange.np - scalePadX(config.bh.jW);
        var scalePadY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY(unpadded);
        var yMax = calcDomain.ne + scalePadY(config.bh.k3);
        var yMin = calcDomain.np - scalePadY(config.bh.dR);
        return {
            pH: _Utils_update(calcRange, {
                hl: config.ir,
                ne: $elm$core$Basics$max_fn(xMin, xMax),
                np: $elm$core$Basics$min_fn(xMin, xMax)
            }),
            pJ: _Utils_update(calcDomain, {
                hl: config.g$,
                ne: $elm$core$Basics$max_fn(yMin, yMax),
                np: $elm$core$Basics$min_fn(yMin, yMax)
            })
        };
    }, $terezka$elm_charts$Chart$definePlane = F2($terezka$elm_charts$Chart$definePlane_fn);
    var $terezka$elm_charts$Chart$getItems_fn = function (plane, elements) {
        var toItems = F2(function (el, acc) {
            switch (el.$) {
                case 0:
                    return acc;
                case 1:
                    var items = el.b;
                    return _Utils_ap(acc, items);
                case 2:
                    var items = el.b;
                    return _Utils_ap(acc, items);
                case 3:
                    var item = el.a;
                    return _Utils_ap(acc, _List_fromArray([item]));
                case 4:
                    var func = el.a;
                    return acc;
                case 5:
                    return acc;
                case 6:
                    return acc;
                case 7:
                    return acc;
                case 8:
                    return acc;
                case 9:
                    return acc;
                case 10:
                    return acc;
                case 11:
                    var subs = el.a;
                    return $elm$core$List$foldl_fn(toItems, acc, subs);
                case 12:
                    return acc;
                default:
                    return acc;
            }
        });
        return $elm$core$List$foldl_fn(toItems, _List_Nil, elements);
    }, $terezka$elm_charts$Chart$getItems = F2($terezka$elm_charts$Chart$getItems_fn);
    var $terezka$elm_charts$Chart$getLegends = function (elements) {
        var toLegends = F2(function (el, acc) {
            switch (el.$) {
                case 0:
                    return acc;
                case 1:
                    var legends_ = el.c;
                    return _Utils_ap(acc, legends_);
                case 2:
                    var legends_ = el.c;
                    return _Utils_ap(acc, legends_);
                case 3:
                    return acc;
                case 4:
                    return acc;
                case 5:
                    return acc;
                case 6:
                    return acc;
                case 7:
                    return acc;
                case 8:
                    return acc;
                case 9:
                    return acc;
                case 10:
                    return acc;
                case 11:
                    var subs = el.a;
                    return $elm$core$List$foldl_fn(toLegends, acc, subs);
                case 12:
                    return acc;
                default:
                    return acc;
            }
        });
        return $elm$core$List$foldl_fn(toLegends, _List_Nil, elements);
    };
    var $terezka$elm_charts$Chart$TickValues_fn = function (xAxis, yAxis, xs, ys) {
        return { eX: xAxis, aO: xs, eY: yAxis, a4: ys };
    }, $terezka$elm_charts$Chart$TickValues = F4($terezka$elm_charts$Chart$TickValues_fn);
    var $terezka$elm_charts$Chart$getTickValues_fn = function (plane, items, elements) {
        var toValues = F2(function (el, acc) {
            switch (el.$) {
                case 0:
                    return acc;
                case 1:
                    return acc;
                case 2:
                    var func = el.d;
                    return A2(func, plane, acc);
                case 3:
                    var func = el.b;
                    return acc;
                case 4:
                    var func = el.a;
                    return A2(func, plane, acc);
                case 5:
                    var func = el.a;
                    return A2(func, plane, acc);
                case 6:
                    var toC = el.a;
                    var func = el.b;
                    return A3(func, plane, toC(plane), acc);
                case 7:
                    var toC = el.a;
                    var func = el.b;
                    return A3(func, plane, toC(plane), acc);
                case 8:
                    var toC = el.a;
                    var func = el.b;
                    return A3(func, plane, toC(plane), acc);
                case 10:
                    var func = el.a;
                    return $elm$core$List$foldl_fn(toValues, acc, A2(func, plane, items));
                case 9:
                    return acc;
                case 11:
                    var subs = el.a;
                    return $elm$core$List$foldl_fn(toValues, acc, subs);
                case 12:
                    return acc;
                default:
                    return acc;
            }
        });
        return $elm$core$List$foldl_fn(toValues, $terezka$elm_charts$Chart$TickValues_fn(_List_Nil, _List_Nil, _List_Nil, _List_Nil), elements);
    }, $terezka$elm_charts$Chart$getTickValues = F3($terezka$elm_charts$Chart$getTickValues_fn);
    var $terezka$elm_charts$Chart$GridElement = function (a) {
        return { $: 9, a: a };
    };
    var $terezka$elm_charts$Internal$Svg$Circle = 0;
    var $terezka$elm_charts$Chart$Attributes$circle = function (config) {
        return _Utils_update(config, {
            dk: $elm$core$Maybe$Just(0)
        });
    };
    var $terezka$elm_charts$Internal$Helpers$darkGray = "rgb(200 200 200)";
    var $terezka$elm_charts$Chart$Attributes$dashed_fn = function (value, config) {
        return _Utils_update(config, { e9: value });
    }, $terezka$elm_charts$Chart$Attributes$dashed = F2($terezka$elm_charts$Chart$Attributes$dashed_fn);
    var $terezka$elm_charts$Internal$Svg$defaultDot = { au: "", aB: 0, bw: $terezka$elm_charts$Internal$Helpers$pink, V: false, c4: 0, mH: "", mI: 5, bg: 1, dk: $elm$core$Maybe$Nothing, oS: 6 };
    var $terezka$elm_charts$Internal$Svg$isWithinPlane_fn = function (plane, x, y) {
        return _Utils_eq($elm$core$Basics$clamp_fn(plane.pH.np, plane.pH.ne, x), x) && _Utils_eq($elm$core$Basics$clamp_fn(plane.pJ.np, plane.pJ.ne, y), y);
    }, $terezka$elm_charts$Internal$Svg$isWithinPlane = F3($terezka$elm_charts$Internal$Svg$isWithinPlane_fn);
    var $elm$core$Basics$sqrt = _Basics_sqrt;
    var $terezka$elm_charts$Internal$Svg$plusPath_fn = function (area_, off, x_, y_) {
        var side = $elm$core$Basics$sqrt(area_ / 4) + off;
        var r6 = side / 2;
        var r3 = side;
        return $elm$core$String$join_fn(" ", _List_fromArray([
            "M" + ($elm$core$String$fromFloat(x_ - r6) + (" " + $elm$core$String$fromFloat(((y_ - r3) - r6) + off))),
            "v" + $elm$core$String$fromFloat(r3 - off),
            "h" + $elm$core$String$fromFloat((-r3) + off),
            "v" + $elm$core$String$fromFloat(r3),
            "h" + $elm$core$String$fromFloat(r3 - off),
            "v" + $elm$core$String$fromFloat(r3 - off),
            "h" + $elm$core$String$fromFloat(r3),
            "v" + $elm$core$String$fromFloat((-r3) + off),
            "h" + $elm$core$String$fromFloat(r3 - off),
            "v" + $elm$core$String$fromFloat(-r3),
            "h" + $elm$core$String$fromFloat((-r3) + off),
            "v" + $elm$core$String$fromFloat((-r3) + off),
            "h" + $elm$core$String$fromFloat(-r3),
            "v" + $elm$core$String$fromFloat(r3 - off)
        ]));
    }, $terezka$elm_charts$Internal$Svg$plusPath = F4($terezka$elm_charts$Internal$Svg$plusPath_fn);
    var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
    var $elm$svg$Svg$Attributes$transform_a0 = "transform", $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute($elm$svg$Svg$Attributes$transform_a0);
    var $elm$core$Basics$tan = _Basics_tan;
    var $terezka$elm_charts$Internal$Svg$trianglePath_fn = function (area_, off, x_, y_) {
        var side = $elm$core$Basics$sqrt((area_ * 4) / $elm$core$Basics$sqrt(3)) + (off * $elm$core$Basics$sqrt(3));
        var height = ($elm$core$Basics$sqrt(3) * side) / 2;
        var fromMiddle = height - (($elm$core$Basics$tan($elm$core$Basics$degrees(30)) * side) / 2);
        return $elm$core$String$join_fn(" ", _List_fromArray([
            "M" + ($elm$core$String$fromFloat(x_) + (" " + $elm$core$String$fromFloat(y_ - fromMiddle))),
            "l" + ($elm$core$String$fromFloat((-side) / 2) + (" " + $elm$core$String$fromFloat(height))),
            "h" + $elm$core$String$fromFloat(side),
            "z"
        ]));
    }, $terezka$elm_charts$Internal$Svg$trianglePath = F4($terezka$elm_charts$Internal$Svg$trianglePath_fn);
    var $terezka$elm_charts$Internal$Svg$dot_fn = function (plane, toX, toY, config, datum_) {
        var yOrg = toY(datum_);
        var y_ = $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, yOrg);
        var xOrg = toX(datum_);
        var x_ = $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, xOrg);
        var styleAttrs = _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, (config.au === "") ? config.bw : config.au),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.aB)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fillOpacity_a0, $elm$core$String$fromFloat(config.bg)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, config.bw),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__dot"),
            config.V ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "")
        ]);
        var showDot = $terezka$elm_charts$Internal$Svg$isWithinPlane_fn(plane, xOrg, yOrg) || config.V;
        var highlightColor = (config.mH === "") ? config.bw : config.mH;
        var highlightAttrs = _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, highlightColor),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.mI)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeOpacity_a0, $elm$core$String$fromFloat(config.c4)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "transparent"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__dot-highlight")
        ]);
        var view = F3(function (toEl, highlightOff, toAttrs) {
            return (config.c4 > 0) ? $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__dot-container")
            ]), _List_fromArray([
                A2(toEl, _Utils_ap(toAttrs(highlightOff), highlightAttrs), _List_Nil),
                A2(toEl, _Utils_ap(toAttrs(0), styleAttrs), _List_Nil)
            ])) : A2(toEl, _Utils_ap(toAttrs(0), styleAttrs), _List_Nil);
        });
        var area_ = (2 * $elm$core$Basics$pi) * config.oS;
        if (!showDot) {
            return $elm$svg$Svg$text("");
        }
        else {
            var _v0 = config.dk;
            if (_v0.$ === 1) {
                return $elm$svg$Svg$text("");
            }
            else {
                switch (_v0.a) {
                    case 0:
                        var _v1 = _v0.a;
                        return A3(view, $elm$svg$Svg$circle, config.mI / 2, function (off) {
                            var radius = $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$cx_a0, $elm$core$String$fromFloat(x_)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$cy_a0, $elm$core$String$fromFloat(y_)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$r_a0, $elm$core$String$fromFloat(radius + off))
                            ]);
                        });
                    case 1:
                        var _v2 = _v0.a;
                        return A3(view, $elm$svg$Svg$path, config.mI, function (off) {
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Svg$trianglePath_fn(area_, off, x_, y_))
                            ]);
                        });
                    case 2:
                        var _v3 = _v0.a;
                        return A3(view, $elm$svg$Svg$rect, config.mI, function (off) {
                            var side = $elm$core$Basics$sqrt(area_);
                            var sideOff = side + off;
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x_a0, $elm$core$String$fromFloat(x_ - (sideOff / 2))),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y_a0, $elm$core$String$fromFloat(y_ - (sideOff / 2))),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat(sideOff)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat(sideOff))
                            ]);
                        });
                    case 3:
                        var _v4 = _v0.a;
                        return A3(view, $elm$svg$Svg$rect, config.mI, function (off) {
                            var side = $elm$core$Basics$sqrt(area_);
                            var sideOff = side + off;
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x_a0, $elm$core$String$fromFloat(x_ - (sideOff / 2))),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y_a0, $elm$core$String$fromFloat(y_ - (sideOff / 2))),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat(sideOff)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat(sideOff)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$transform_a0, "rotate(45 " + ($elm$core$String$fromFloat(x_) + (" " + ($elm$core$String$fromFloat(y_) + ")"))))
                            ]);
                        });
                    case 4:
                        var _v5 = _v0.a;
                        return A3(view, $elm$svg$Svg$path, config.mI, function (off) {
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Svg$plusPath_fn(area_, off, x_, y_)),
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$transform_a0, "rotate(45 " + ($elm$core$String$fromFloat(x_) + (" " + ($elm$core$String$fromFloat(y_) + ")"))))
                            ]);
                        });
                    default:
                        var _v6 = _v0.a;
                        return A3(view, $elm$svg$Svg$path, config.mI, function (off) {
                            return _List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Svg$plusPath_fn(area_, off, x_, y_))
                            ]);
                        });
                }
            }
        }
    }, $terezka$elm_charts$Internal$Svg$dot = F5($terezka$elm_charts$Internal$Svg$dot_fn);
    var $terezka$elm_charts$Chart$Svg$dot_fn = function (plane, toX, toY, edits) {
        return A4($terezka$elm_charts$Internal$Svg$dot, plane, toX, toY, $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Svg$defaultDot));
    }, $terezka$elm_charts$Chart$Svg$dot = F4($terezka$elm_charts$Chart$Svg$dot_fn);
    var $terezka$elm_charts$Internal$Helpers$gray = "#EFF2FA";
    var $terezka$elm_charts$Internal$Svg$defaultLine = { E: _List_Nil, lH: false, bw: "rgb(210, 210, 210)", e9: _List_Nil, J: false, V: false, bg: 1, pd: -90, pe: 0, ir: 1, dv: $elm$core$Maybe$Nothing, eW: $elm$core$Maybe$Nothing, pI: $elm$core$Maybe$Nothing, N: 0, pK: $elm$core$Maybe$Nothing, iu: $elm$core$Maybe$Nothing, pL: $elm$core$Maybe$Nothing, O: 0 };
    var $elm$core$Basics$cos = _Basics_cos;
    var $terezka$elm_charts$Internal$Svg$lengthInCartesianX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX;
    var $terezka$elm_charts$Internal$Svg$lengthInCartesianY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY;
    var $elm$core$Basics$sin = _Basics_sin;
    var $elm$svg$Svg$Attributes$strokeDasharray_a0 = "stroke-dasharray", $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute($elm$svg$Svg$Attributes$strokeDasharray_a0);
    var $terezka$elm_charts$Internal$Svg$line_fn = function (plane, config) {
        var angle = $elm$core$Basics$degrees(config.pd);
        var _v0 = function () {
            var _v3 = _Utils_Tuple3(_Utils_Tuple2(config.dv, config.eW), _Utils_Tuple2(config.pK, config.iu), _Utils_Tuple2(config.pI, config.pL));
            if (!_v3.a.a.$) {
                if (!_v3.a.b.$) {
                    if (_v3.b.a.$ === 1) {
                        if (_v3.b.b.$ === 1) {
                            var _v4 = _v3.a;
                            var a = _v4.a.a;
                            var b = _v4.b.a;
                            var _v5 = _v3.b;
                            var _v6 = _v5.a;
                            var _v7 = _v5.b;
                            return _Utils_Tuple2(_Utils_Tuple2(a, b), _Utils_Tuple2(plane.pJ.np, plane.pJ.np));
                        }
                        else {
                            var _v38 = _v3.a;
                            var a = _v38.a.a;
                            var b = _v38.b.a;
                            var _v39 = _v3.b;
                            var _v40 = _v39.a;
                            var c = _v39.b.a;
                            return _Utils_Tuple2(_Utils_Tuple2(a, b), _Utils_Tuple2(c, c));
                        }
                    }
                    else {
                        if (_v3.b.b.$ === 1) {
                            var _v41 = _v3.a;
                            var a = _v41.a.a;
                            var b = _v41.b.a;
                            var _v42 = _v3.b;
                            var c = _v42.a.a;
                            var _v43 = _v42.b;
                            return _Utils_Tuple2(_Utils_Tuple2(a, b), _Utils_Tuple2(c, c));
                        }
                        else {
                            return _Utils_Tuple2(_Utils_Tuple2($elm$core$Maybe$withDefault_fn(plane.pH.np, config.dv), $elm$core$Maybe$withDefault_fn(plane.pH.ne, config.eW)), _Utils_Tuple2($elm$core$Maybe$withDefault_fn(plane.pJ.np, config.pK), $elm$core$Maybe$withDefault_fn(plane.pJ.ne, config.iu)));
                        }
                    }
                }
                else {
                    if (_v3.b.a.$ === 1) {
                        if (_v3.b.b.$ === 1) {
                            var _v8 = _v3.a;
                            var a = _v8.a.a;
                            var _v9 = _v8.b;
                            var _v10 = _v3.b;
                            var _v11 = _v10.a;
                            var _v12 = _v10.b;
                            return _Utils_Tuple2(_Utils_Tuple2(a, a), _Utils_Tuple2(plane.pJ.np, plane.pJ.ne));
                        }
                        else {
                            if (!_v3.c.a.$) {
                                if (!_v3.c.b.$) {
                                    var _v51 = _v3.a;
                                    var a = _v51.a.a;
                                    var _v52 = _v51.b;
                                    var _v53 = _v3.b;
                                    var _v54 = _v53.a;
                                    var b = _v53.b.a;
                                    var _v55 = _v3.c;
                                    var xOff = _v55.a.a;
                                    var yOff = _v55.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                                else {
                                    var _v56 = _v3.a;
                                    var a = _v56.a.a;
                                    var _v57 = _v56.b;
                                    var _v58 = _v3.b;
                                    var _v59 = _v58.a;
                                    var b = _v58.b.a;
                                    var _v60 = _v3.c;
                                    var xOff = _v60.a.a;
                                    var _v61 = _v60.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b));
                                }
                            }
                            else {
                                if (_v3.c.b.$ === 1) {
                                    var _v44 = _v3.a;
                                    var a = _v44.a.a;
                                    var _v45 = _v44.b;
                                    var _v46 = _v3.b;
                                    var _v47 = _v46.a;
                                    var b = _v46.b.a;
                                    var _v48 = _v3.c;
                                    var _v49 = _v48.a;
                                    var _v50 = _v48.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, plane.pH.ne), _Utils_Tuple2(b, b));
                                }
                                else {
                                    var _v62 = _v3.a;
                                    var a = _v62.a.a;
                                    var _v63 = _v62.b;
                                    var _v64 = _v3.b;
                                    var _v65 = _v64.a;
                                    var b = _v64.b.a;
                                    var _v66 = _v3.c;
                                    var _v67 = _v66.a;
                                    var yOff = _v66.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                            }
                        }
                    }
                    else {
                        if (!_v3.b.b.$) {
                            var _v35 = _v3.a;
                            var c = _v35.a.a;
                            var _v36 = _v35.b;
                            var _v37 = _v3.b;
                            var a = _v37.a.a;
                            var b = _v37.b.a;
                            return _Utils_Tuple2(_Utils_Tuple2(c, c), _Utils_Tuple2(a, b));
                        }
                        else {
                            if (!_v3.c.a.$) {
                                if (!_v3.c.b.$) {
                                    var _v75 = _v3.a;
                                    var a = _v75.a.a;
                                    var _v76 = _v75.b;
                                    var _v77 = _v3.b;
                                    var b = _v77.a.a;
                                    var _v78 = _v77.b;
                                    var _v79 = _v3.c;
                                    var xOff = _v79.a.a;
                                    var yOff = _v79.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                                else {
                                    var _v80 = _v3.a;
                                    var a = _v80.a.a;
                                    var _v81 = _v80.b;
                                    var _v82 = _v3.b;
                                    var b = _v82.a.a;
                                    var _v83 = _v82.b;
                                    var _v84 = _v3.c;
                                    var xOff = _v84.a.a;
                                    var _v85 = _v84.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b));
                                }
                            }
                            else {
                                if (_v3.c.b.$ === 1) {
                                    var _v68 = _v3.a;
                                    var a = _v68.a.a;
                                    var _v69 = _v68.b;
                                    var _v70 = _v3.b;
                                    var b = _v70.a.a;
                                    var _v71 = _v70.b;
                                    var _v72 = _v3.c;
                                    var _v73 = _v72.a;
                                    var _v74 = _v72.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, plane.pH.ne), _Utils_Tuple2(b, b));
                                }
                                else {
                                    var _v86 = _v3.a;
                                    var a = _v86.a.a;
                                    var _v87 = _v86.b;
                                    var _v88 = _v3.b;
                                    var b = _v88.a.a;
                                    var _v89 = _v88.b;
                                    var _v90 = _v3.c;
                                    var _v91 = _v90.a;
                                    var yOff = _v90.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                            }
                        }
                    }
                }
            }
            else {
                if (!_v3.a.b.$) {
                    if (_v3.b.a.$ === 1) {
                        if (_v3.b.b.$ === 1) {
                            var _v13 = _v3.a;
                            var _v14 = _v13.a;
                            var b = _v13.b.a;
                            var _v15 = _v3.b;
                            var _v16 = _v15.a;
                            var _v17 = _v15.b;
                            return _Utils_Tuple2(_Utils_Tuple2(b, b), _Utils_Tuple2(plane.pJ.np, plane.pJ.ne));
                        }
                        else {
                            if (!_v3.c.a.$) {
                                if (!_v3.c.b.$) {
                                    var _v99 = _v3.a;
                                    var _v100 = _v99.a;
                                    var a = _v99.b.a;
                                    var _v101 = _v3.b;
                                    var _v102 = _v101.a;
                                    var b = _v101.b.a;
                                    var _v103 = _v3.c;
                                    var xOff = _v103.a.a;
                                    var yOff = _v103.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                                else {
                                    var _v104 = _v3.a;
                                    var _v105 = _v104.a;
                                    var a = _v104.b.a;
                                    var _v106 = _v3.b;
                                    var _v107 = _v106.a;
                                    var b = _v106.b.a;
                                    var _v108 = _v3.c;
                                    var xOff = _v108.a.a;
                                    var _v109 = _v108.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b));
                                }
                            }
                            else {
                                if (_v3.c.b.$ === 1) {
                                    var _v92 = _v3.a;
                                    var _v93 = _v92.a;
                                    var a = _v92.b.a;
                                    var _v94 = _v3.b;
                                    var _v95 = _v94.a;
                                    var b = _v94.b.a;
                                    var _v96 = _v3.c;
                                    var _v97 = _v96.a;
                                    var _v98 = _v96.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, plane.pH.ne), _Utils_Tuple2(b, b));
                                }
                                else {
                                    var _v110 = _v3.a;
                                    var _v111 = _v110.a;
                                    var a = _v110.b.a;
                                    var _v112 = _v3.b;
                                    var _v113 = _v112.a;
                                    var b = _v112.b.a;
                                    var _v114 = _v3.c;
                                    var _v115 = _v114.a;
                                    var yOff = _v114.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                            }
                        }
                    }
                    else {
                        if (!_v3.b.b.$) {
                            var _v32 = _v3.a;
                            var _v33 = _v32.a;
                            var c = _v32.b.a;
                            var _v34 = _v3.b;
                            var a = _v34.a.a;
                            var b = _v34.b.a;
                            return _Utils_Tuple2(_Utils_Tuple2(c, c), _Utils_Tuple2(a, b));
                        }
                        else {
                            if (!_v3.c.a.$) {
                                if (!_v3.c.b.$) {
                                    var _v123 = _v3.a;
                                    var _v124 = _v123.a;
                                    var a = _v123.b.a;
                                    var _v125 = _v3.b;
                                    var b = _v125.a.a;
                                    var _v126 = _v125.b;
                                    var _v127 = _v3.c;
                                    var xOff = _v127.a.a;
                                    var yOff = _v127.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                                else {
                                    var _v128 = _v3.a;
                                    var _v129 = _v128.a;
                                    var a = _v128.b.a;
                                    var _v130 = _v3.b;
                                    var b = _v130.a.a;
                                    var _v131 = _v130.b;
                                    var _v132 = _v3.c;
                                    var xOff = _v132.a.a;
                                    var _v133 = _v132.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, xOff)), _Utils_Tuple2(b, b));
                                }
                            }
                            else {
                                if (_v3.c.b.$ === 1) {
                                    var _v116 = _v3.a;
                                    var _v117 = _v116.a;
                                    var a = _v116.b.a;
                                    var _v118 = _v3.b;
                                    var b = _v118.a.a;
                                    var _v119 = _v118.b;
                                    var _v120 = _v3.c;
                                    var _v121 = _v120.a;
                                    var _v122 = _v120.b;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, plane.pH.ne), _Utils_Tuple2(b, b));
                                }
                                else {
                                    var _v134 = _v3.a;
                                    var _v135 = _v134.a;
                                    var a = _v134.b.a;
                                    var _v136 = _v3.b;
                                    var b = _v136.a.a;
                                    var _v137 = _v136.b;
                                    var _v138 = _v3.c;
                                    var _v139 = _v138.a;
                                    var yOff = _v138.b.a;
                                    return _Utils_Tuple2(_Utils_Tuple2(a, a), _Utils_Tuple2(b, b + $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, yOff)));
                                }
                            }
                        }
                    }
                }
                else {
                    if (!_v3.b.a.$) {
                        if (!_v3.b.b.$) {
                            var _v18 = _v3.a;
                            var _v19 = _v18.a;
                            var _v20 = _v18.b;
                            var _v21 = _v3.b;
                            var a = _v21.a.a;
                            var b = _v21.b.a;
                            return _Utils_Tuple2(_Utils_Tuple2(plane.pH.np, plane.pH.np), _Utils_Tuple2(a, b));
                        }
                        else {
                            var _v22 = _v3.a;
                            var _v23 = _v22.a;
                            var _v24 = _v22.b;
                            var _v25 = _v3.b;
                            var a = _v25.a.a;
                            var _v26 = _v25.b;
                            return _Utils_Tuple2(_Utils_Tuple2(plane.pH.np, plane.pH.ne), _Utils_Tuple2(a, a));
                        }
                    }
                    else {
                        if (!_v3.b.b.$) {
                            var _v27 = _v3.a;
                            var _v28 = _v27.a;
                            var _v29 = _v27.b;
                            var _v30 = _v3.b;
                            var _v31 = _v30.a;
                            var b = _v30.b.a;
                            return _Utils_Tuple2(_Utils_Tuple2(plane.pH.np, plane.pH.ne), _Utils_Tuple2(b, b));
                        }
                        else {
                            var _v140 = _v3.a;
                            var _v141 = _v140.a;
                            var _v142 = _v140.b;
                            var _v143 = _v3.b;
                            var _v144 = _v143.a;
                            var _v145 = _v143.b;
                            return _Utils_Tuple2(_Utils_Tuple2(plane.pH.np, plane.pH.ne), _Utils_Tuple2(plane.pJ.np, plane.pJ.ne));
                        }
                    }
                }
            }
        }();
        var _v1 = _v0.a;
        var x1 = _v1.a;
        var x2 = _v1.b;
        var _v2 = _v0.b;
        var y1 = _v2.a;
        var y2 = _v2.b;
        var x1_ = x1 + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, config.N);
        var x2_ = x2 + $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, config.N);
        var y1_ = y1 - $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, config.O);
        var y2_ = y2 - $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, config.O);
        var _v146 = (config.pe > 0) ? _Utils_Tuple2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, $elm$core$Basics$cos(angle) * config.pe), $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, $elm$core$Basics$sin(angle) * config.pe)) : _Utils_Tuple2(0, 0);
        var tickOffsetX = _v146.a;
        var tickOffsetY = _v146.b;
        var cmds = config.J ? _Utils_ap((config.pe > 0) ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Move_fn(x2_ + tickOffsetX, y2_ + tickOffsetY),
            $terezka$elm_charts$Internal$Commands$Line_fn(x2_, y2_)
        ]) : _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Move_fn(x2_, y2_)
        ]), _Utils_ap(config.lH ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x2_, y1_),
            $terezka$elm_charts$Internal$Commands$Line_fn(x1_, y1_)
        ]) : _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x1_, y1_)
        ]), (config.pe > 0) ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x1_ + tickOffsetX, y1_ + tickOffsetY)
        ]) : _List_Nil)) : _Utils_ap((config.pe > 0) ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Move_fn(x1_ + tickOffsetX, y1_ + tickOffsetY),
            $terezka$elm_charts$Internal$Commands$Line_fn(x1_, y1_)
        ]) : _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Move_fn(x1_, y1_)
        ]), _Utils_ap(config.lH ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x1_, y2_),
            $terezka$elm_charts$Internal$Commands$Line_fn(x2_, y2_)
        ]) : _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x2_, y2_)
        ]), (config.pe > 0) ? _List_fromArray([
            $terezka$elm_charts$Internal$Commands$Line_fn(x2_ + tickOffsetX, y2_ + tickOffsetY)
        ]) : _List_Nil));
        return A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$path, _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__line"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "transparent"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, config.bw),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.ir)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeOpacity_a0, $elm$core$String$fromFloat(config.bg)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeDasharray_a0, $elm$core$String$join_fn(" ", $elm$core$List$map_fn($elm$core$String$fromFloat, config.e9))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Commands$description_fn(plane, cmds)),
            config.V ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "")
        ]), _List_Nil);
    }, $terezka$elm_charts$Internal$Svg$line = F2($terezka$elm_charts$Internal$Svg$line_fn);
    var $terezka$elm_charts$Chart$Svg$line_fn = function (plane, edits) {
        return $terezka$elm_charts$Internal$Svg$line_fn(plane, $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Svg$defaultLine));
    }, $terezka$elm_charts$Chart$Svg$line = F2($terezka$elm_charts$Chart$Svg$line_fn);
    var $terezka$elm_charts$Chart$Attributes$size_fn = function (v, config) {
        return _Utils_update(config, { oS: v });
    }, $terezka$elm_charts$Chart$Attributes$size = F2($terezka$elm_charts$Chart$Attributes$size_fn);
    var $terezka$elm_charts$Chart$Attributes$width_fn = function (v, config) {
        return _Utils_update(config, { ir: v });
    }, $terezka$elm_charts$Chart$Attributes$width = F2($terezka$elm_charts$Chart$Attributes$width_fn);
    var $terezka$elm_charts$Chart$Attributes$x1_fn = function (v, config) {
        return _Utils_update(config, {
            dv: $elm$core$Maybe$Just(v)
        });
    }, $terezka$elm_charts$Chart$Attributes$x1 = F2($terezka$elm_charts$Chart$Attributes$x1_fn);
    var $terezka$elm_charts$Chart$Attributes$y1_fn = function (v, config) {
        return _Utils_update(config, {
            pK: $elm$core$Maybe$Just(v)
        });
    }, $terezka$elm_charts$Chart$Attributes$y1 = F2($terezka$elm_charts$Chart$Attributes$y1_fn);
    var $terezka$elm_charts$Chart$grid = function (edits) {
        var config = $terezka$elm_charts$Internal$Helpers$apply_fn(edits, { bw: "", e9: _List_Nil, d1: false, ir: 0 });
        var width = (!config.ir) ? (config.d1 ? 0.5 : 1) : config.ir;
        var color = $elm$core$String$isEmpty(config.bw) ? (config.d1 ? $terezka$elm_charts$Internal$Helpers$darkGray : $terezka$elm_charts$Internal$Helpers$gray) : config.bw;
        var toDot = F4(function (vs, p, x, y) {
            return ($elm$core$List$member_fn(x, vs.eX) || $elm$core$List$member_fn(y, vs.eY)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A5($terezka$elm_charts$Chart$Svg$dot, p, function ($) {
                return $.pH;
            }, function ($) {
                return $.pJ;
            }, _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color(color),
                $terezka$elm_charts$Chart$Attributes$size(width),
                $terezka$elm_charts$Chart$Attributes$circle
            ]), { pH: x, pJ: y }));
        });
        var toXGrid = F3(function (vs, p, v) {
            return $elm$core$List$member_fn(v, vs.eX) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($terezka$elm_charts$Chart$Svg$line_fn(p, _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color(color),
                $terezka$elm_charts$Chart$Attributes$width(width),
                $terezka$elm_charts$Chart$Attributes$x1(v),
                $terezka$elm_charts$Chart$Attributes$dashed(config.e9)
            ])));
        });
        var toYGrid = F3(function (vs, p, v) {
            return $elm$core$List$member_fn(v, vs.eY) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($terezka$elm_charts$Chart$Svg$line_fn(p, _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color(color),
                $terezka$elm_charts$Chart$Attributes$width(width),
                $terezka$elm_charts$Chart$Attributes$y1(v),
                $terezka$elm_charts$Chart$Attributes$dashed(config.e9)
            ])));
        });
        return $terezka$elm_charts$Chart$GridElement(F2(function (p, vs) {
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__grid")
            ]), config.d1 ? $elm$core$List$concatMap_fn(function (x) {
                return $elm$core$List$filterMap_fn(A3(toDot, vs, p, x), vs.a4);
            }, vs.aO) : _List_fromArray([
                $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__x-grid")
                ]), $elm$core$List$filterMap_fn(A2(toXGrid, vs, p), vs.aO)),
                $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__y-grid")
                ]), $elm$core$List$filterMap_fn(A2(toYGrid, vs, p), vs.a4))
            ]));
        }));
    };
    var $elm$svg$Svg$Attributes$style_a0 = "style", $elm$svg$Svg$Attributes$style = _VirtualDom_attribute($elm$svg$Svg$Attributes$style_a0);
    var $terezka$elm_charts$Chart$viewElements_fn = function (config, plane, tickValues, allItems, allLegends, elements) {
        var viewOne = F2(function (el, _v0) {
            var before = _v0.a;
            var chart_ = _v0.b;
            var after = _v0.c;
            switch (el.$) {
                case 0:
                    return _Utils_Tuple3(before, chart_, after);
                case 1:
                    var view = el.d;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                case 2:
                    var view = el.e;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                case 3:
                    var view = el.b;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                case 4:
                    var view = el.b;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                case 5:
                    var view = el.b;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                case 6:
                    var toC = el.a;
                    var view = el.c;
                    return _Utils_Tuple3(before, _List_Cons(A2(view, plane, toC(plane)), chart_), after);
                case 7:
                    var toC = el.a;
                    var view = el.c;
                    return _Utils_Tuple3(before, _List_Cons(A2(view, plane, toC(plane)), chart_), after);
                case 8:
                    var toC = el.a;
                    var view = el.c;
                    return _Utils_Tuple3(before, _List_Cons(A2(view, plane, toC(plane)), chart_), after);
                case 9:
                    var view = el.a;
                    return _Utils_Tuple3(before, _List_Cons(A2(view, plane, tickValues), chart_), after);
                case 10:
                    var func = el.a;
                    return $elm$core$List$foldr_fn(viewOne, _Utils_Tuple3(before, chart_, after), A2(func, plane, allItems));
                case 11:
                    var els = el.a;
                    return $elm$core$List$foldr_fn(viewOne, _Utils_Tuple3(before, chart_, after), els);
                case 12:
                    var view = el.a;
                    return _Utils_Tuple3(before, _List_Cons(view(plane), chart_), after);
                default:
                    var view = el.a;
                    return _Utils_Tuple3(($elm$core$List$length(chart_) > 0) ? _List_Cons(A2(view, plane, allLegends), before) : before, chart_, ($elm$core$List$length(chart_) > 0) ? after : _List_Cons(A2(view, plane, allLegends), after));
            }
        });
        return $elm$core$List$foldr_fn(viewOne, _Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil), elements);
    }, $terezka$elm_charts$Chart$viewElements = F6($terezka$elm_charts$Chart$viewElements_fn);
    var $terezka$elm_charts$Chart$chart_fn = function (edits, unindexedElements) {
        var indexedElements = function () {
            var toIndexedEl = F2(function (el, _v4) {
                var acc = _v4.a;
                var index = _v4.b;
                switch (el.$) {
                    case 0:
                        var toElAndIndex = el.a;
                        var _v6 = toElAndIndex(index);
                        var newEl = _v6.a;
                        var newIndex = _v6.b;
                        return _Utils_Tuple2(_Utils_ap(acc, _List_fromArray([newEl])), newIndex);
                    case 11:
                        var els = el.a;
                        return $elm$core$List$foldl_fn(toIndexedEl, _Utils_Tuple2(acc, index), els);
                    default:
                        return _Utils_Tuple2(_Utils_ap(acc, _List_fromArray([el])), index);
                }
            });
            return $elm$core$List$foldl_fn(toIndexedEl, _Utils_Tuple2(_List_Nil, 0), unindexedElements).a;
        }();
        var elements = function () {
            var isGrid = function (el) {
                if (el.$ === 9) {
                    return true;
                }
                else {
                    return false;
                }
            };
            return $elm$core$List$any_fn(isGrid, indexedElements) ? indexedElements : _List_Cons($terezka$elm_charts$Chart$grid(_List_Nil), indexedElements);
        }();
        var legends_ = $terezka$elm_charts$Chart$getLegends(elements);
        var config = $terezka$elm_charts$Internal$Helpers$apply_fn(edits, {
            E: _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$style_a0, "overflow: visible;")
            ]),
            gM: _List_Nil,
            mn: _List_Nil,
            g$: 300,
            fs: _List_Nil,
            cr: { dR: 0, jW: 0, et: 0, k3: 0 },
            bh: { dR: 0, jW: 0, et: 0, k3: 0 },
            hR: _List_Nil,
            fX: true,
            ir: 300
        });
        var plane = $terezka$elm_charts$Chart$definePlane_fn(config, elements);
        var items = $terezka$elm_charts$Chart$getItems_fn(plane, elements);
        var toEvent = function (_v2) {
            var event_ = _v2;
            var _v1 = event_.l7;
            var decoder = _v1;
            return $terezka$elm_charts$Internal$Svg$Event_fn(event_.M, decoder(items));
        };
        var tickValues = $terezka$elm_charts$Chart$getTickValues_fn(plane, items, elements);
        var _v0 = $terezka$elm_charts$Chart$viewElements_fn(config, plane, tickValues, items, legends_, elements);
        var beforeEls = _v0.a;
        var chartEls = _v0.b;
        var afterEls = _v0.c;
        return $terezka$elm_charts$Internal$Svg$container_fn(plane, {
            E: config.E,
            mn: $elm$core$List$map_fn(toEvent, config.mn),
            fs: config.fs,
            fX: config.fX
        }, beforeEls, chartEls, afterEls);
    }, $terezka$elm_charts$Chart$chart = F2($terezka$elm_charts$Chart$chart_fn);
    var $terezka$elm_charts$Chart$SubElements = function (a) {
        return { $: 10, a: a };
    };
    var $terezka$elm_charts$Chart$each_fn = function (items, func) {
        return $terezka$elm_charts$Chart$SubElements(F2(function (p, _v0) {
            return $elm$core$List$concatMap_fn(func(p), items);
        }));
    }, $terezka$elm_charts$Chart$each = F2($terezka$elm_charts$Chart$each_fn);
    var $terezka$elm_charts$Chart$eachCustom_fn = function (grouping, func) {
        return $terezka$elm_charts$Chart$SubElements(F2(function (p, items) {
            var processed = $terezka$elm_charts$Internal$Many$apply_fn(grouping, items);
            return $elm$core$List$concatMap_fn(func(p), processed);
        }));
    }, $terezka$elm_charts$Chart$eachCustom = F2($terezka$elm_charts$Chart$eachCustom_fn);
    var $terezka$elm_charts$Internal$Property$format_fn = function (value, prop) {
        if (!prop.$) {
            var con = prop.a;
            return $terezka$elm_charts$Internal$Property$Property(_Utils_update(con, {
                d7: A2($elm$core$Basics$composeR, con.pB, value)
            }));
        }
        else {
            var cons = prop.a;
            return $terezka$elm_charts$Internal$Property$Stacked($elm$core$List$map_fn(function (con) {
                return _Utils_update(con, {
                    d7: A2($elm$core$Basics$composeR, con.pB, value)
                });
            }, cons));
        }
    }, $terezka$elm_charts$Internal$Property$format = F2($terezka$elm_charts$Internal$Property$format_fn);
    var $terezka$elm_charts$Chart$formatMaybe = $terezka$elm_charts$Internal$Property$format;
    var $terezka$elm_charts$Chart$Item$getMembers = $terezka$elm_charts$Internal$Many$getMembers;
    var $terezka$elm_charts$Internal$Events$Decoder = $elm$core$Basics$identity;
    var $terezka$elm_charts$Internal$Svg$closestPoint_fn = function (pos, searched) {
        return {
            pH: $elm$core$Basics$clamp_fn(pos.dv, pos.eW, searched.pH),
            pJ: $elm$core$Basics$clamp_fn(pos.pK, pos.iu, searched.pJ)
        };
    }, $terezka$elm_charts$Internal$Svg$closestPoint = F2($terezka$elm_charts$Internal$Svg$closestPoint_fn);
    var $terezka$elm_charts$Internal$Svg$distanceX_fn = function (plane, searched, point) {
        return $elm$core$Basics$abs($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, point.pH) - $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, searched.pH));
    }, $terezka$elm_charts$Internal$Svg$distanceX = F3($terezka$elm_charts$Internal$Svg$distanceX_fn);
    var $terezka$elm_charts$Internal$Svg$keepOne = function (toPosition) {
        var toArea = function (a) {
            return function (pos) {
                return (pos.dv - pos.eW) * (pos.pK - pos.iu);
            }(toPosition(a));
        };
        var func = F2(function (one, acc) {
            var _v0 = $elm$core$List$head(acc);
            if (_v0.$ === 1) {
                return _List_fromArray([one]);
            }
            else {
                var other = _v0.a;
                return _Utils_eq(toPosition(other), toPosition(one)) ? _List_Cons(other, acc) : ((_Utils_cmp(toArea(other), toArea(one)) > 0) ? _List_fromArray([one]) : acc);
            }
        });
        return A2($elm$core$List$foldr, func, _List_Nil);
    };
    var $terezka$elm_charts$Internal$Svg$getNearestXHelp_fn = function (toPosition, items, plane, searched) {
        var toPoint = function (i) {
            return $terezka$elm_charts$Internal$Svg$closestPoint_fn(toPosition(i), searched);
        };
        var distanceX_ = A2($terezka$elm_charts$Internal$Svg$distanceX, plane, searched);
        var getClosest = F2(function (item, allClosest) {
            var _v0 = $elm$core$List$head(allClosest);
            if (!_v0.$) {
                var closest = _v0.a;
                return _Utils_eq(toPoint(closest).pH, toPoint(item).pH) ? _List_Cons(item, allClosest) : ((_Utils_cmp(distanceX_(toPoint(closest)), distanceX_(toPoint(item))) > 0) ? _List_fromArray([item]) : allClosest);
            }
            else {
                return _List_fromArray([item]);
            }
        });
        return A2($terezka$elm_charts$Internal$Svg$keepOne, toPosition, $elm$core$List$foldl_fn(getClosest, _List_Nil, items));
    }, $terezka$elm_charts$Internal$Svg$getNearestXHelp = F4($terezka$elm_charts$Internal$Svg$getNearestXHelp_fn);
    var $terezka$elm_charts$Internal$Svg$getNearestX_fn = function (toPosition, items, plane, searched) {
        return $terezka$elm_charts$Internal$Svg$getNearestXHelp_fn(toPosition, items, plane, searched);
    }, $terezka$elm_charts$Internal$Svg$getNearestX = F4($terezka$elm_charts$Internal$Svg$getNearestX_fn);
    var $terezka$elm_charts$Internal$Events$getNearestX = function (grouping) {
        var toPos = grouping.a;
        return F2(function (items, plane) {
            var groups = $terezka$elm_charts$Internal$Many$apply_fn(grouping, items);
            return A3($terezka$elm_charts$Internal$Svg$getNearestX, toPos(plane), groups, plane);
        });
    };
    var $terezka$elm_charts$Chart$Events$getNearestX = $terezka$elm_charts$Internal$Events$getNearestX;
    var $terezka$elm_charts$Internal$Coordinates$top = function (pos) {
        return { pH: pos.dv + ((pos.eW - pos.dv) / 2), pJ: pos.iu };
    };
    var $terezka$elm_charts$Chart$Item$getTop = function (p) {
        return A2($elm$core$Basics$composeR, $terezka$elm_charts$Internal$Item$getPosition(p), $terezka$elm_charts$Internal$Coordinates$top);
    };
    var $author$project$Pages$Dashboards$getXHeader_a0 = $elm$core$List$head, $author$project$Pages$Dashboards$getXHeader_a1 = $elm$core$Maybe$andThen($author$project$Types$Cell$toMaybeString), $author$project$Pages$Dashboards$getXHeader = A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$getXHeader_a0, $author$project$Pages$Dashboards$getXHeader_a1);
    var $terezka$elm_charts$Chart$Attributes$height_fn = function (v, config) {
        return _Utils_update(config, { g$: v });
    }, $terezka$elm_charts$Chart$Attributes$height = F2($terezka$elm_charts$Chart$Attributes$height_fn);
    var $terezka$elm_charts$Internal$Item$isReal = function (_v0) {
        var item = _v0;
        return item.aQ.pC.mS;
    };
    var $terezka$elm_charts$Chart$Item$isReal = $terezka$elm_charts$Internal$Item$isReal;
    var $terezka$elm_charts$Chart$SvgElement = function (a) {
        return { $: 12, a: a };
    };
    var $terezka$elm_charts$Internal$Svg$defaultLabel = { R: $elm$core$Maybe$Nothing, E: _List_Nil, au: "white", aB: 0, bw: "#808BAB", U: $elm$core$Maybe$Nothing, aG: $elm$core$Maybe$Nothing, V: false, Y: 0, _: false, N: 0, O: 0 };
    var $elm$svg$Svg$foreignObject = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "foreignObject"), $elm$svg$Svg$foreignObject_fn = $elm$svg$Svg$foreignObject.a2;
    var $terezka$elm_charts$Internal$Svg$position_fn = function (plane, rotation, x_, y_, xOff_, yOff_) {
        return _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$transform_a0, "translate(" + ($elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x_) + xOff_) + ("," + ($elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y_) + yOff_) + (") rotate(" + ($elm$core$String$fromFloat(rotation) + ")"))))));
    }, $terezka$elm_charts$Internal$Svg$position = F6($terezka$elm_charts$Internal$Svg$position_fn);
    var $elm$svg$Svg$text_ = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "text"), $elm$svg$Svg$text__fn = $elm$svg$Svg$text_.a2;
    var $elm$svg$Svg$tspan = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "tspan"), $elm$svg$Svg$tspan_fn = $elm$svg$Svg$tspan.a2;
    var $terezka$elm_charts$Internal$Svg$label_fn = function (plane, config, inner, point) {
        var _v0 = config.U;
        if (_v0.$ === 1) {
            var withOverflowWrap = function (el) {
                return config.V ? $elm$svg$Svg$g_fn(_List_fromArray([
                    $terezka$elm_charts$Internal$Svg$withinChartArea(plane)
                ]), _List_fromArray([el])) : el;
            };
            var uppercaseStyle = config._ ? "text-transform: uppercase;" : "";
            var fontStyle = function () {
                var _v5 = config.aG;
                if (!_v5.$) {
                    var size_ = _v5.a;
                    return "font-size: " + ($elm$core$String$fromInt(size_) + "px;");
                }
                else {
                    return "";
                }
            }();
            var anchorStyle = function () {
                var _v1 = config.R;
                if (_v1.$ === 1) {
                    return "text-anchor: middle;";
                }
                else {
                    switch (_v1.a) {
                        case 0:
                            var _v2 = _v1.a;
                            return "text-anchor: end;";
                        case 1:
                            var _v3 = _v1.a;
                            return "text-anchor: start;";
                        default:
                            var _v4 = _v1.a;
                            return "text-anchor: middle;";
                    }
                }
            }();
            return withOverflowWrap(A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$text_, _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__label"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, config.au),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.aB)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, config.bw),
                $terezka$elm_charts$Internal$Svg$position_fn(plane, -config.Y, point.pH, point.pJ, config.N, config.O),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$style_a0, $elm$core$String$join_fn(" ", _List_fromArray(["pointer-events: none;", fontStyle, anchorStyle, uppercaseStyle])))
            ]), _List_fromArray([
                $elm$svg$Svg$tspan_fn(_List_Nil, inner)
            ])));
        }
        else {
            var ellipsis = _v0.a;
            var xOffWithAnchor = function () {
                var _v11 = config.R;
                if (_v11.$ === 1) {
                    return config.N - (ellipsis.ir / 2);
                }
                else {
                    switch (_v11.a) {
                        case 0:
                            var _v12 = _v11.a;
                            return config.N - ellipsis.ir;
                        case 1:
                            var _v13 = _v11.a;
                            return config.N;
                        default:
                            var _v14 = _v11.a;
                            return config.N - (ellipsis.ir / 2);
                    }
                }
            }();
            var withOverflowWrap = function (el) {
                return config.V ? $elm$svg$Svg$g_fn(_List_fromArray([
                    $terezka$elm_charts$Internal$Svg$withinChartArea(plane)
                ]), _List_fromArray([el])) : el;
            };
            var uppercaseStyle = config._ ? _VirtualDom_style_fn("text-transform", "uppercase") : _VirtualDom_style_fn("", "");
            var fontStyle = function () {
                var _v10 = config.aG;
                if (!_v10.$) {
                    var size_ = _v10.a;
                    return _VirtualDom_style_fn("font-size", $elm$core$String$fromInt(size_) + "px");
                }
                else {
                    return _VirtualDom_style_fn("", "");
                }
            }();
            var anchorStyle = function () {
                var _v6 = config.R;
                if (_v6.$ === 1) {
                    return _VirtualDom_style_fn("text-align", "center");
                }
                else {
                    switch (_v6.a) {
                        case 0:
                            var _v7 = _v6.a;
                            return _VirtualDom_style_fn("text-align", "right");
                        case 1:
                            var _v8 = _v6.a;
                            return _VirtualDom_style_fn("text-align", "left");
                        default:
                            var _v9 = _v6.a;
                            return _VirtualDom_style_fn("text-align", "center");
                    }
                }
            }();
            return withOverflowWrap(A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$foreignObject, _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__label"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__html-label"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, $elm$core$String$fromFloat(ellipsis.ir)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, $elm$core$String$fromFloat(ellipsis.g$)),
                $terezka$elm_charts$Internal$Svg$position_fn(plane, -config.Y, point.pH, point.pJ, xOffWithAnchor, config.O - 10)
            ]), _List_fromArray([
                $elm$html$Html$div_fn(_List_fromArray([
                    $elm$virtual_dom$VirtualDom$attribute_fn("xmlns", "http://www.w3.org/1999/xhtml"),
                    _VirtualDom_style_fn("white-space", "nowrap"),
                    _VirtualDom_style_fn("overflow", "hidden"),
                    _VirtualDom_style_fn("text-overflow", "ellipsis"),
                    _VirtualDom_style_fn("height", "100%"),
                    _VirtualDom_style_fn("pointer-events", "none"),
                    _VirtualDom_style_fn("color", config.bw),
                    fontStyle,
                    uppercaseStyle,
                    anchorStyle
                ]), inner)
            ])));
        }
    }, $terezka$elm_charts$Internal$Svg$label = F4($terezka$elm_charts$Internal$Svg$label_fn);
    var $terezka$elm_charts$Chart$Svg$label_fn = function (plane, edits) {
        return A2($terezka$elm_charts$Internal$Svg$label, plane, $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Svg$defaultLabel));
    }, $terezka$elm_charts$Chart$Svg$label = F2($terezka$elm_charts$Chart$Svg$label_fn);
    var $terezka$elm_charts$Chart$label_fn = function (attrs, inner, point) {
        return $terezka$elm_charts$Chart$SvgElement(function (p) {
            return A4($terezka$elm_charts$Chart$Svg$label, p, attrs, inner, point);
        });
    }, $terezka$elm_charts$Chart$label = F3($terezka$elm_charts$Chart$label_fn);
    var $terezka$elm_charts$Chart$Attributes$moveRight_fn = function (v, config) {
        return _Utils_update(config, { N: config.N + v });
    }, $terezka$elm_charts$Chart$Attributes$moveRight = F2($terezka$elm_charts$Chart$Attributes$moveRight_fn);
    var $terezka$elm_charts$Chart$Attributes$moveUp_fn = function (v, config) {
        return _Utils_update(config, { O: config.O - v });
    }, $terezka$elm_charts$Chart$Attributes$moveUp = F2($terezka$elm_charts$Chart$Attributes$moveUp_fn);
    var $terezka$elm_charts$Internal$Property$meta_fn = function (value, prop) {
        if (!prop.$) {
            var con = prop.a;
            return $terezka$elm_charts$Internal$Property$Property(_Utils_update(con, {
                j1: $elm$core$Maybe$Just(value)
            }));
        }
        else {
            var cons = prop.a;
            return $terezka$elm_charts$Internal$Property$Stacked($elm$core$List$map_fn(function (con) {
                return _Utils_update(con, {
                    j1: $elm$core$Maybe$Just(value)
                });
            }, cons));
        }
    }, $terezka$elm_charts$Internal$Property$meta = F2($terezka$elm_charts$Internal$Property$meta_fn);
    var $terezka$elm_charts$Chart$named = function (name) {
        return $terezka$elm_charts$Internal$Property$meta(name);
    };
    var $terezka$elm_charts$Internal$Events$getCoords_fn = function (_v0, plane, searched) {
        return searched;
    }, $terezka$elm_charts$Internal$Events$getCoords = F3($terezka$elm_charts$Internal$Events$getCoords_fn);
    var $terezka$elm_charts$Chart$Events$getCoords = $terezka$elm_charts$Internal$Events$getCoords;
    var $terezka$elm_charts$Internal$Events$map_fn = function (f, _v0) {
        var a = _v0;
        return F3(function (ps, s, p) {
            return f(A3(a, ps, s, p));
        });
    }, $terezka$elm_charts$Internal$Events$map = F2($terezka$elm_charts$Internal$Events$map_fn);
    var $terezka$elm_charts$Chart$Events$map = $terezka$elm_charts$Internal$Events$map;
    var $terezka$elm_charts$Internal$Events$Event = $elm$core$Basics$identity;
    var $terezka$elm_charts$Internal$Events$on_fn = function (name, decoder, config) {
        return _Utils_update(config, {
            mn: _List_Cons({ l7: decoder, M: name }, config.mn)
        });
    }, $terezka$elm_charts$Internal$Events$on = F3($terezka$elm_charts$Internal$Events$on_fn);
    var $terezka$elm_charts$Chart$Events$on = $terezka$elm_charts$Internal$Events$on;
    var $terezka$elm_charts$Chart$Events$onMouseLeave = function (onMsg) {
        return A2($terezka$elm_charts$Chart$Events$on, "mouseleave", $terezka$elm_charts$Internal$Events$map_fn($elm$core$Basics$always(onMsg), $terezka$elm_charts$Chart$Events$getCoords));
    };
    var $terezka$elm_charts$Chart$Events$onMouseMove_fn = function (onMsg, decoder) {
        return A2($terezka$elm_charts$Chart$Events$on, "mousemove", $terezka$elm_charts$Internal$Events$map_fn(onMsg, decoder));
    }, $terezka$elm_charts$Chart$Events$onMouseMove = F2($terezka$elm_charts$Chart$Events$onMouseMove_fn);
    var $terezka$elm_charts$Chart$Attributes$opacity_fn = function (v, config) {
        return _Utils_update(config, { bg: v });
    }, $terezka$elm_charts$Chart$Attributes$opacity = F2($terezka$elm_charts$Chart$Attributes$opacity_fn);
    var $author$project$Pages$Dashboards$getColumnDimension = function (rows) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$List$length, $elm$core$List$head(rows)));
    };
    var $author$project$Pages$Dashboards$remainingColumnsIdxs = function (cd) {
        return $elm$core$List$range_fn(1, $author$project$Pages$Dashboards$getColumnDimension(cd) - 1);
    };
    var $author$project$Pages$Dashboards$removeXHeader_a0 = 1, $author$project$Pages$Dashboards$removeXHeader = $elm$core$List$drop($author$project$Pages$Dashboards$removeXHeader_a0);
    var $terezka$elm_charts$Chart$Attributes$rotate_fn = function (v, config) {
        return _Utils_update(config, { Y: config.Y + v });
    }, $terezka$elm_charts$Chart$Attributes$rotate = F2($terezka$elm_charts$Chart$Attributes$rotate_fn);
    var $rtfeldman$elm_css$Svg$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
    var $rtfeldman$elm_css$Svg$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
    var $terezka$elm_charts$Chart$HtmlElement = function (a) {
        return { $: 13, a: a };
    };
    var $terezka$elm_charts$Chart$html = function (func) {
        return $terezka$elm_charts$Chart$HtmlElement(F2(function (p, _v0) {
            return func(p);
        }));
    };
    var $terezka$elm_charts$Internal$Svg$defaultTooltip = { cO: true, dJ: "white", au: "#D8D8D8", md: $elm$core$Maybe$Nothing, my: $elm$core$Maybe$Nothing, g$: 0, fK: 8, ir: 0 };
    var $terezka$elm_charts$Internal$Svg$Bottom = 3;
    var $terezka$elm_charts$Internal$Svg$Left = 1;
    var $terezka$elm_charts$Internal$Svg$Right = 2;
    var $terezka$elm_charts$Internal$Svg$Top = 0;
    var $terezka$elm_charts$Internal$Coordinates$bottom = function (pos) {
        return { pH: pos.dv + ((pos.eW - pos.dv) / 2), pJ: pos.pK };
    };
    var $terezka$elm_charts$Internal$Coordinates$left = function (pos) {
        return { pH: pos.dv, pJ: pos.pK + ((pos.iu - pos.pK) / 2) };
    };
    var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
    var $terezka$elm_charts$Internal$Svg$positionHtml_fn = function (plane, x, y, xOff, yOff, attrs, content) {
        var yPercentage = (($terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, y) - yOff) * 100) / plane.pJ.hl;
        var xPercentage = (($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, x) + xOff) * 100) / plane.pH.hl;
        var posititonStyles = _List_fromArray([
            _VirtualDom_style_fn("left", $elm$core$String$fromFloat(xPercentage) + "%"),
            _VirtualDom_style_fn("top", $elm$core$String$fromFloat(yPercentage) + "%"),
            _VirtualDom_style_fn("margin-right", "-400px"),
            _VirtualDom_style_fn("position", "absolute")
        ]);
        return $elm$html$Html$div_fn(_Utils_ap(posititonStyles, attrs), content);
    }, $terezka$elm_charts$Internal$Svg$positionHtml = F7($terezka$elm_charts$Internal$Svg$positionHtml_fn);
    var $terezka$elm_charts$Internal$Coordinates$right = function (pos) {
        return { pH: pos.eW, pJ: pos.pK + ((pos.iu - pos.pK) / 2) };
    };
    var $terezka$elm_charts$Internal$Svg$tooltipPointerStyle_fn = function (direction, className, background, borderColor) {
        var config = function () {
            switch (direction) {
                case 0:
                    return { b8: "right", a6: "top", bt: "left" };
                case 3:
                    return { b8: "right", a6: "bottom", bt: "left" };
                case 1:
                    return { b8: "bottom", a6: "left", bt: "top" };
                case 2:
                    return { b8: "bottom", a6: "right", bt: "top" };
                case 4:
                    return { b8: "bottom", a6: "left", bt: "top" };
                default:
                    return { b8: "right", a6: "top", bt: "left" };
            }
        }();
        return "\n  ." + (className + (":before, ." + (className + (":after {\n    content: \"\";\n    position: absolute;\n    border-" + (config.bt + (": 5px solid transparent;\n    border-" + (config.b8 + (": 5px solid transparent;\n    " + (config.a6 + (": 100%;\n    " + (config.bt + (": 50%;\n    margin-" + (config.bt + (": -5px;\n  }\n\n  ." + (className + (":after {\n    border-" + (config.a6 + (": 5px solid " + (background + (";\n    margin-" + (config.a6 + (": -1px;\n    z-index: 1;\n    height: 0px;\n  }\n\n  ." + (className + (":before {\n    border-" + (config.a6 + (": 5px solid " + (borderColor + ";\n    height: 0px;\n  }\n  ")))))))))))))))))))))))))));
    }, $terezka$elm_charts$Internal$Svg$tooltipPointerStyle = F4($terezka$elm_charts$Internal$Svg$tooltipPointerStyle_fn);
    var $terezka$elm_charts$Internal$Svg$tooltip_fn = function (plane, pos, config, htmlAttrs, content) {
        var distanceTop = $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, pos.iu);
        var distanceRight = plane.pH.hl - $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, pos.dv);
        var distanceLeft = $terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, pos.eW);
        var distanceBottom = plane.pJ.hl - $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, pos.pK);
        var direction = function () {
            var _v5 = config.md;
            if (!_v5.$) {
                switch (_v5.a) {
                    case 4:
                        var _v6 = _v5.a;
                        return (config.ir > 0) ? ((_Utils_cmp(distanceLeft, config.ir + config.fK) > 0) ? 1 : 2) : ((_Utils_cmp(distanceLeft, distanceRight) > 0) ? 1 : 2);
                    case 5:
                        var _v7 = _v5.a;
                        return (config.g$ > 0) ? ((_Utils_cmp(distanceTop, config.g$ + config.fK) > 0) ? 0 : 3) : ((_Utils_cmp(distanceTop, distanceBottom) > 0) ? 0 : 3);
                    default:
                        var dir = _v5.a;
                        return dir;
                }
            }
            else {
                var isLargest = function (a) {
                    return $elm$core$List$all(function (b) {
                        return _Utils_cmp(a, b) > -1;
                    });
                };
                return A2(isLargest, distanceTop, _List_fromArray([distanceBottom, distanceLeft, distanceRight])) ? 0 : (A2(isLargest, distanceBottom, _List_fromArray([distanceTop, distanceLeft, distanceRight])) ? 3 : (A2(isLargest, distanceLeft, _List_fromArray([distanceTop, distanceBottom, distanceRight])) ? 1 : 2));
            }
        }();
        var focalPoint = function () {
            var _v2 = config.my;
            if (!_v2.$) {
                var focal = _v2.a;
                switch (direction) {
                    case 0:
                        return $terezka$elm_charts$Internal$Coordinates$top(focal(pos));
                    case 3:
                        return $terezka$elm_charts$Internal$Coordinates$bottom(focal(pos));
                    case 1:
                        return $terezka$elm_charts$Internal$Coordinates$left(focal(pos));
                    case 2:
                        return $terezka$elm_charts$Internal$Coordinates$right(focal(pos));
                    case 4:
                        return $terezka$elm_charts$Internal$Coordinates$left(focal(pos));
                    default:
                        return $terezka$elm_charts$Internal$Coordinates$right(focal(pos));
                }
            }
            else {
                switch (direction) {
                    case 0:
                        return $terezka$elm_charts$Internal$Coordinates$top(pos);
                    case 3:
                        return $terezka$elm_charts$Internal$Coordinates$bottom(pos);
                    case 1:
                        return $terezka$elm_charts$Internal$Coordinates$left(pos);
                    case 2:
                        return $terezka$elm_charts$Internal$Coordinates$right(pos);
                    case 4:
                        return $terezka$elm_charts$Internal$Coordinates$left(pos);
                    default:
                        return $terezka$elm_charts$Internal$Coordinates$right(pos);
                }
            }
        }();
        var arrowWidth = config.cO ? 4 : 0;
        var _v0 = function () {
            switch (direction) {
                case 0:
                    return { ca: "elm-charts__tooltip-top", cG: "translate(-50%, -100%)", N: 0, O: config.fK + arrowWidth };
                case 3:
                    return { ca: "elm-charts__tooltip-bottom", cG: "translate(-50%, 0%)", N: 0, O: (-config.fK) - arrowWidth };
                case 1:
                    return { ca: "elm-charts__tooltip-left", cG: "translate(-100%, -50%)", N: (-config.fK) - arrowWidth, O: 0 };
                case 2:
                    return { ca: "elm-charts__tooltip-right", cG: "translate(0, -50%)", N: config.fK + arrowWidth, O: 0 };
                case 4:
                    return { ca: "elm-charts__tooltip-leftOrRight", cG: "translate(0, -50%)", N: (-config.fK) - arrowWidth, O: 0 };
                default:
                    return { ca: "elm-charts__tooltip-topOrBottom", cG: "translate(-50%, -100%)", N: 0, O: config.fK + arrowWidth };
            }
        }();
        var xOff = _v0.N;
        var yOff = _v0.O;
        var transformation = _v0.cG;
        var className = _v0.ca;
        var children = config.cO ? _List_Cons(A3($elm$html$Html$node, "style", _List_Nil, _List_fromArray([
            $elm$html$Html$text($terezka$elm_charts$Internal$Svg$tooltipPointerStyle_fn(direction, className, config.dJ, config.au))
        ])), content) : content;
        var attributes = _Utils_ap(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, className),
            _VirtualDom_style_fn("transform", transformation),
            _VirtualDom_style_fn("padding", "5px 8px"),
            _VirtualDom_style_fn("background", config.dJ),
            _VirtualDom_style_fn("border", "1px solid " + config.au),
            _VirtualDom_style_fn("border-radius", "3px"),
            _VirtualDom_style_fn("pointer-events", "none")
        ]), htmlAttrs);
        return _VirtualDom_map_fn($elm$core$Basics$never, $terezka$elm_charts$Internal$Svg$positionHtml_fn(plane, focalPoint.pH, focalPoint.pJ, xOff, yOff, attributes, children));
    }, $terezka$elm_charts$Internal$Svg$tooltip = F5($terezka$elm_charts$Internal$Svg$tooltip_fn);
    var $terezka$elm_charts$Chart$Svg$tooltip_fn = function (plane, pos, edits) {
        return A3($terezka$elm_charts$Internal$Svg$tooltip, plane, pos, $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Svg$defaultTooltip));
    }, $terezka$elm_charts$Chart$Svg$tooltip = F3($terezka$elm_charts$Chart$Svg$tooltip_fn);
    var $terezka$elm_charts$Chart$tooltip_fn = function (i, edits, attrs_, content) {
        return $terezka$elm_charts$Chart$html(function (p) {
            var pos = $terezka$elm_charts$Internal$Item$getLimits(i);
            var content_ = _Utils_eq(content, _List_Nil) ? $terezka$elm_charts$Internal$Item$toHtml(i) : content;
            return $terezka$elm_charts$Internal$Svg$isWithinPlane_fn(p, pos.dv, pos.iu) ? A5($terezka$elm_charts$Chart$Svg$tooltip, p, $terezka$elm_charts$Internal$Item$getPosition_fn(p, i), edits, attrs_, content_) : $elm$html$Html$text("");
        });
    }, $terezka$elm_charts$Chart$tooltip = F4($terezka$elm_charts$Chart$tooltip_fn);
    var $terezka$elm_charts$Chart$Attributes$withGrid = function (config) {
        return _Utils_update(config, { L: true });
    };
    var $terezka$elm_charts$Chart$Attributes$ellipsis_fn = function (w, h, config) {
        return _Utils_update(config, {
            U: $elm$core$Maybe$Just({ g$: h, ir: w })
        });
    }, $terezka$elm_charts$Chart$Attributes$ellipsis = F3($terezka$elm_charts$Chart$Attributes$ellipsis_fn);
    var $terezka$elm_charts$Chart$ListOfElements = function (a) {
        return { $: 11, a: a };
    };
    var $terezka$elm_charts$Chart$list = $terezka$elm_charts$Chart$ListOfElements;
    var $terezka$elm_charts$Chart$Attributes$moveLeft_fn = function (v, config) {
        return _Utils_update(config, { N: config.N - v });
    }, $terezka$elm_charts$Chart$Attributes$moveLeft = F2($terezka$elm_charts$Chart$Attributes$moveLeft_fn);
    var $terezka$elm_charts$Chart$Attributes$x_fn = function (v, config) {
        return _Utils_update(config, { pH: v });
    }, $terezka$elm_charts$Chart$Attributes$x = F2($terezka$elm_charts$Chart$Attributes$x_fn);
    var $terezka$elm_charts$Chart$LabelElement_fn = function (a, b, c) {
        return { $: 8, a: a, b: b, c: c };
    }, $terezka$elm_charts$Chart$LabelElement = F3($terezka$elm_charts$Chart$LabelElement_fn);
    var $terezka$elm_charts$Chart$Attributes$middle = function (b) {
        return b.np + ((b.ne - b.np) / 2);
    };
    var $terezka$elm_charts$Chart$Attributes$zero = function (b) {
        return $elm$core$Basics$clamp_fn(b.np, b.ne, 0);
    };
    var $terezka$elm_charts$Chart$xLabel_fn = function (edits, inner) {
        var toTickValues = F3(function (p, config, ts) {
            return (!config.L) ? ts : _Utils_update(ts, {
                aO: _Utils_ap(ts.aO, _List_fromArray([config.pH]))
            });
        });
        var toConfig = function (p) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(edits, {
                R: $elm$core$Maybe$Nothing,
                E: _List_Nil,
                au: "white",
                aB: 0.1,
                bw: "#808BAB",
                U: $elm$core$Maybe$Nothing,
                J: false,
                aG: $elm$core$Maybe$Nothing,
                L: false,
                V: false,
                Y: 0,
                _: false,
                pH: $terezka$elm_charts$Chart$Attributes$middle(p.pH),
                N: 0,
                pJ: $terezka$elm_charts$Chart$Attributes$zero(p.pJ),
                O: 20
            });
        };
        return $terezka$elm_charts$Chart$LabelElement_fn(toConfig, toTickValues, F2(function (p, config) {
            var string = _Utils_eq(inner, _List_Nil) ? _List_fromArray([
                $elm$svg$Svg$text($elm$core$String$fromFloat(config.pH))
            ]) : inner;
            return $terezka$elm_charts$Internal$Svg$label_fn(p, {
                R: config.R,
                E: config.E,
                au: config.au,
                aB: config.aB,
                bw: config.bw,
                U: config.U,
                aG: config.aG,
                V: config.V,
                Y: config.Y,
                _: config._,
                N: config.N,
                O: config.J ? ((-config.O) + 10) : config.O
            }, string, { pH: config.pH, pJ: config.pJ });
        }));
    }, $terezka$elm_charts$Chart$xLabel = F2($terezka$elm_charts$Chart$xLabel_fn);
    var $author$project$Pages$Dashboards$xLabelsRotated = function (degree) {
        var degMod = _Basics_modBy_fn(360, -degree);
        return A2($elm$core$Basics$composeR, $elm$core$List$indexedMap(F2(function (i, label) {
            return $terezka$elm_charts$Chart$xLabel_fn(_Utils_ap(_List_fromArray([
                $terezka$elm_charts$Chart$Attributes$x(i + 1),
                $terezka$elm_charts$Chart$Attributes$rotate(degMod),
                ((degMod > 0) && (degMod <= 60)) ? $terezka$elm_charts$Chart$Attributes$moveUp(30) : (((degMod > 60) && (degMod <= 135)) ? $terezka$elm_charts$Chart$Attributes$moveUp(25) : $terezka$elm_charts$Chart$Attributes$moveUp(5)),
                ((degMod < 135) && (degMod > 30)) ? $terezka$elm_charts$Chart$Attributes$moveLeft(11) : (((degMod < 315) && (degMod > 225)) ? $terezka$elm_charts$Chart$Attributes$moveRight(10) : $terezka$elm_charts$Chart$Attributes$moveLeft(0)),
                A2($terezka$elm_charts$Chart$Attributes$ellipsis, 170, 20)
            ]), _Utils_ap((!degMod) ? _List_Nil : _List_fromArray([$terezka$elm_charts$Chart$Attributes$alignLeft]), (degree < 0) ? _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color("#dbd7d2")
            ]) : _List_Nil)), _List_fromArray([
                $rtfeldman$elm_css$Svg$Styled$toUnstyled($rtfeldman$elm_css$Svg$Styled$text(label))
            ]));
        })), $terezka$elm_charts$Chart$list);
    };
    var $terezka$elm_charts$Internal$Svg$End = 0;
    var $terezka$elm_charts$Internal$Svg$Floats = { $: 0 };
    var $terezka$elm_charts$Chart$LabelsElement_fn = function (a, b, c) {
        return { $: 7, a: a, b: b, c: c };
    }, $terezka$elm_charts$Chart$LabelsElement = F3($terezka$elm_charts$Chart$LabelsElement_fn);
    var $terezka$elm_charts$Internal$Svg$Generator = $elm$core$Basics$identity;
    var $terezka$intervals$Intervals$Around = function (a) {
        return { $: 1, a: a };
    };
    var $terezka$intervals$Intervals$around = $terezka$intervals$Intervals$Around;
    var $terezka$intervals$Intervals$ceilingTo_fn = function (prec, number) {
        return prec * $elm$core$Basics$ceiling(number / prec);
    }, $terezka$intervals$Intervals$ceilingTo = F2($terezka$intervals$Intervals$ceilingTo_fn);
    var $terezka$intervals$Intervals$getBeginning_fn = function (min, interval) {
        var multiple = min / interval;
        return _Utils_eq(multiple, $elm$core$Basics$round(multiple)) ? min : $terezka$intervals$Intervals$ceilingTo_fn(interval, min);
    }, $terezka$intervals$Intervals$getBeginning = F2($terezka$intervals$Intervals$getBeginning_fn);
    var $terezka$intervals$Intervals$correctFloat = function (prec) {
        return A2($elm$core$Basics$composeR, $myrho$elm_round$Round$round(prec), A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm$core$Maybe$withDefault(0)));
    };
    var $terezka$intervals$Intervals$getMultiples_fn = function (magnitude, allowDecimals, hasTickAmount) {
        var defaults = hasTickAmount ? _List_fromArray([1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) : _List_fromArray([1, 2, 2.5, 5, 10]);
        return allowDecimals ? defaults : ((magnitude === 1) ? $elm$core$List$filter_fn(function (n) {
            return _Utils_eq($elm$core$Basics$round(n), n);
        }, defaults) : ((magnitude <= 0.1) ? _List_fromArray([1 / magnitude]) : defaults));
    }, $terezka$intervals$Intervals$getMultiples = F3($terezka$intervals$Intervals$getMultiples_fn);
    var $terezka$intervals$Intervals$getPrecision = function (number) {
        var _v0 = $elm$core$String$split_fn("e", $elm$core$String$fromFloat(number));
        if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
            var before = _v0.a;
            var _v1 = _v0.b;
            var after = _v1.a;
            return $elm$core$Basics$abs($elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(after)));
        }
        else {
            var _v2 = $elm$core$String$split_fn(".", $elm$core$String$fromFloat(number));
            if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
                var before = _v2.a;
                var _v3 = _v2.b;
                var after = _v3.a;
                return $elm$core$String$length(after);
            }
            else {
                return 0;
            }
        }
    };
    var $elm$core$Basics$e = _Basics_e;
    var $elm$core$Basics$pow = _Basics_pow;
    var $terezka$intervals$Intervals$toMagnitude = function (num) {
        return _Basics_pow_fn(10, $elm$core$Basics$floor($elm$core$Basics$logBase_fn($elm$core$Basics$e, num) / $elm$core$Basics$logBase_fn($elm$core$Basics$e, 10)));
    };
    var $terezka$intervals$Intervals$getInterval_fn = function (intervalRaw, allowDecimals, hasTickAmount) {
        var magnitude = $terezka$intervals$Intervals$toMagnitude(intervalRaw);
        var multiples = $terezka$intervals$Intervals$getMultiples_fn(magnitude, allowDecimals, hasTickAmount);
        var normalized = intervalRaw / magnitude;
        var findMultipleExact = function (multiples_) {
            findMultipleExact: while (true) {
                if (multiples_.b) {
                    var m1 = multiples_.a;
                    var rest = multiples_.b;
                    if (_Utils_cmp(m1 * magnitude, intervalRaw) > -1) {
                        return m1;
                    }
                    else {
                        var $temp$multiples_ = rest;
                        multiples_ = $temp$multiples_;
                        continue findMultipleExact;
                    }
                }
                else {
                    return 1;
                }
            }
        };
        var findMultiple = function (multiples_) {
            findMultiple: while (true) {
                if (multiples_.b) {
                    if (multiples_.b.b) {
                        var m1 = multiples_.a;
                        var _v2 = multiples_.b;
                        var m2 = _v2.a;
                        var rest = _v2.b;
                        if (_Utils_cmp(normalized, (m1 + m2) / 2) < 1) {
                            return m1;
                        }
                        else {
                            var $temp$multiples_ = _List_Cons(m2, rest);
                            multiples_ = $temp$multiples_;
                            continue findMultiple;
                        }
                    }
                    else {
                        var m1 = multiples_.a;
                        var rest = multiples_.b;
                        if (_Utils_cmp(normalized, m1) < 1) {
                            return m1;
                        }
                        else {
                            var $temp$multiples_ = rest;
                            multiples_ = $temp$multiples_;
                            continue findMultiple;
                        }
                    }
                }
                else {
                    return 1;
                }
            }
        };
        var multiple = hasTickAmount ? findMultipleExact(multiples) : findMultiple(multiples);
        var precision = $terezka$intervals$Intervals$getPrecision(magnitude) + $terezka$intervals$Intervals$getPrecision(multiple);
        return A2($terezka$intervals$Intervals$correctFloat, precision, multiple * magnitude);
    }, $terezka$intervals$Intervals$getInterval = F3($terezka$intervals$Intervals$getInterval_fn);
    var $terezka$intervals$Intervals$positions_fn = function (range, beginning, interval, m, acc) {
        positions: while (true) {
            var nextPosition = A2($terezka$intervals$Intervals$correctFloat, $terezka$intervals$Intervals$getPrecision(interval), beginning + (m * interval));
            if (_Utils_cmp(nextPosition, range.ne) > 0) {
                return acc;
            }
            else {
                var $temp$range = range, $temp$beginning = beginning, $temp$interval = interval, $temp$m = m + 1, $temp$acc = _Utils_ap(acc, _List_fromArray([nextPosition]));
                range = $temp$range;
                beginning = $temp$beginning;
                interval = $temp$interval;
                m = $temp$m;
                acc = $temp$acc;
                continue positions;
            }
        }
    }, $terezka$intervals$Intervals$positions = F5($terezka$intervals$Intervals$positions_fn);
    var $terezka$intervals$Intervals$values_fn = function (allowDecimals, exact, amountRough, range) {
        var intervalRough = (range.ne - range.np) / amountRough;
        var interval = $terezka$intervals$Intervals$getInterval_fn(intervalRough, allowDecimals, exact);
        var intervalSafe = (!interval) ? 1 : interval;
        var beginning = $terezka$intervals$Intervals$getBeginning_fn(range.np, intervalSafe);
        var amountRoughSafe = (!amountRough) ? 1 : amountRough;
        return $terezka$intervals$Intervals$positions_fn(range, beginning, intervalSafe, 0, _List_Nil);
    }, $terezka$intervals$Intervals$values = F4($terezka$intervals$Intervals$values_fn);
    var $terezka$intervals$Intervals$floats = function (amount) {
        if (!amount.$) {
            var number = amount.a;
            return A3($terezka$intervals$Intervals$values, true, true, number);
        }
        else {
            var number = amount.a;
            return A3($terezka$intervals$Intervals$values, true, false, number);
        }
    };
    var $terezka$elm_charts$Internal$Svg$floats_fn = function (i, b) {
        return A2($terezka$intervals$Intervals$floats, $terezka$intervals$Intervals$around(i), { ne: b.ne, np: b.np });
    }, $terezka$elm_charts$Internal$Svg$floats = F2($terezka$elm_charts$Internal$Svg$floats_fn);
    var $terezka$elm_charts$Chart$Svg$floats = $terezka$elm_charts$Internal$Svg$floats;
    var $ryannhg$date_format$DateFormat$Language$Language_fn = function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
        return { ph: toAmPm, pl: toMonthAbbreviation, pm: toMonthName, dr: toOrdinalSuffix, pp: toWeekdayAbbreviation, pq: toWeekdayName };
    }, $ryannhg$date_format$DateFormat$Language$Language = F6($ryannhg$date_format$DateFormat$Language$Language_fn);
    var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
        return (hour > 11) ? "pm" : "am";
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
        switch (month) {
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
        var _v0 = _Basics_modBy_fn(100, num);
        switch (_v0) {
            case 11:
                return "th";
            case 12:
                return "th";
            case 13:
                return "th";
            default:
                var _v1 = _Basics_modBy_fn(10, num);
                switch (_v1) {
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
        }
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
        switch (weekday) {
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    };
    var $ryannhg$date_format$DateFormat$Language$english = $ryannhg$date_format$DateFormat$Language$Language_fn($ryannhg$date_format$DateFormat$Language$toEnglishMonthName, A2($elm$core$Basics$composeR, $ryannhg$date_format$DateFormat$Language$toEnglishMonthName, $elm$core$String$left(3)), $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName, A2($elm$core$Basics$composeR, $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName, $elm$core$String$left(3)), $ryannhg$date_format$DateFormat$Language$toEnglishAmPm, $ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
    var $ryannhg$date_format$DateFormat$amPm_fn = function (language, zone, posix) {
        return language.ph($elm$time$Time$toHour_fn(zone, posix));
    }, $ryannhg$date_format$DateFormat$amPm = F3($ryannhg$date_format$DateFormat$amPm_fn);
    var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
    var $ryannhg$date_format$DateFormat$days = _List_fromArray([6, 0, 1, 2, 3, 4, 5]);
    var $elm$time$Time$toWeekday_fn = function (zone, time) {
        var _v0 = _Basics_modBy_fn(7, $elm$time$Time$flooredDiv_fn($elm$time$Time$toAdjustedMinutes_fn(zone, time), 60 * 24));
        switch (_v0) {
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }, $elm$time$Time$toWeekday = F2($elm$time$Time$toWeekday_fn);
    var $ryannhg$date_format$DateFormat$dayOfWeek_fn = function (zone, posix) {
        return function (_v1) {
            var i = _v1.a;
            return i;
        }($elm$core$Maybe$withDefault_fn(_Utils_Tuple2(0, 6), $elm$core$List$head($elm$core$List$filter_fn(function (_v0) {
            var day = _v0.b;
            return _Utils_eq(day, $elm$time$Time$toWeekday_fn(zone, posix));
        }, $elm$core$List$indexedMap_fn_unwrapped(function (i, day) {
            return _Utils_Tuple2(i, day);
        }, $ryannhg$date_format$DateFormat$days)))));
    }, $ryannhg$date_format$DateFormat$dayOfWeek = F2($ryannhg$date_format$DateFormat$dayOfWeek_fn);
    var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
        return (!(!_Basics_modBy_fn(4, year_))) ? false : ((!(!_Basics_modBy_fn(100, year_))) ? true : ((!(!_Basics_modBy_fn(400, year_))) ? false : true));
    };
    var $ryannhg$date_format$DateFormat$daysInMonth_fn = function (year_, month) {
        switch (month) {
            case 0:
                return 31;
            case 1:
                return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $ryannhg$date_format$DateFormat$daysInMonth = F2($ryannhg$date_format$DateFormat$daysInMonth_fn);
    var $ryannhg$date_format$DateFormat$months = _List_fromArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
    var $ryannhg$date_format$DateFormat$monthPair_fn = function (zone, posix) {
        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(0, 0), $elm$core$List$head($elm$core$List$filter_fn(function (_v0) {
            var i = _v0.a;
            var m = _v0.b;
            return _Utils_eq(m, $elm$time$Time$toMonth_fn(zone, posix));
        }, $elm$core$List$indexedMap_fn_unwrapped(function (a, b) {
            return _Utils_Tuple2(a, b);
        }, $ryannhg$date_format$DateFormat$months))));
    }, $ryannhg$date_format$DateFormat$monthPair = F2($ryannhg$date_format$DateFormat$monthPair_fn);
    var $ryannhg$date_format$DateFormat$monthNumber__fn = function (zone, posix) {
        return 1 + function (_v0) {
            var i = _v0.a;
            var m = _v0.b;
            return i;
        }($ryannhg$date_format$DateFormat$monthPair_fn(zone, posix));
    }, $ryannhg$date_format$DateFormat$monthNumber_ = F2($ryannhg$date_format$DateFormat$monthNumber__fn);
    var $ryannhg$date_format$DateFormat$dayOfYear_fn = function (zone, posix) {
        var monthsBeforeThisOne = $elm$core$List$take_fn($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix) - 1, $ryannhg$date_format$DateFormat$months);
        var daysBeforeThisMonth = $elm$core$List$sum($elm$core$List$map_fn($ryannhg$date_format$DateFormat$daysInMonth($elm$time$Time$toYear_fn(zone, posix)), monthsBeforeThisOne));
        return daysBeforeThisMonth + $elm$time$Time$toDay_fn(zone, posix);
    }, $ryannhg$date_format$DateFormat$dayOfYear = F2($ryannhg$date_format$DateFormat$dayOfYear_fn);
    var $ryannhg$date_format$DateFormat$quarter_fn = function (zone, posix) {
        return ($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix) / 4) | 0;
    }, $ryannhg$date_format$DateFormat$quarter = F2($ryannhg$date_format$DateFormat$quarter_fn);
    var $ryannhg$date_format$DateFormat$toFixedLength_fn = function (totalChars, num) {
        var numStr = $elm$core$String$fromInt(num);
        var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
        var zeros = $elm$core$String$join_fn("", $elm$core$List$map_fn(function (_v0) {
            return "0";
        }, $elm$core$List$range_fn(1, numZerosNeeded)));
        return _Utils_ap(zeros, numStr);
    }, $ryannhg$date_format$DateFormat$toFixedLength = F2($ryannhg$date_format$DateFormat$toFixedLength_fn);
    var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
        return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
    };
    var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
    var $ryannhg$date_format$DateFormat$firstDayOfYear_fn = function (zone, time) {
        return $elm$time$Time$millisToPosix($ryannhg$date_format$DateFormat$millisecondsPerYear * $elm$time$Time$toYear_fn(zone, time));
    }, $ryannhg$date_format$DateFormat$firstDayOfYear = F2($ryannhg$date_format$DateFormat$firstDayOfYear_fn);
    var $ryannhg$date_format$DateFormat$weekOfYear_fn = function (zone, posix) {
        var firstDay = $ryannhg$date_format$DateFormat$firstDayOfYear_fn(zone, posix);
        var firstDayOffset = $ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, firstDay);
        var daysSoFar = $ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix);
        return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
    }, $ryannhg$date_format$DateFormat$weekOfYear = F2($ryannhg$date_format$DateFormat$weekOfYear_fn);
    var $ryannhg$date_format$DateFormat$year_fn = function (zone, time) {
        return $elm$core$String$fromInt($elm$time$Time$toYear_fn(zone, time));
    }, $ryannhg$date_format$DateFormat$year = F2($ryannhg$date_format$DateFormat$year_fn);
    var $ryannhg$date_format$DateFormat$piece_fn = function (language, zone, posix, token) {
        switch (token.$) {
            case 0:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 1:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 2:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 3:
                return language.pl($elm$time$Time$toMonth_fn(zone, posix));
            case 4:
                return language.pm($elm$time$Time$toMonth_fn(zone, posix));
            case 17:
                return $elm$core$String$fromInt(1 + $ryannhg$date_format$DateFormat$quarter_fn(zone, posix));
            case 18:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }(1 + $ryannhg$date_format$DateFormat$quarter_fn(zone, posix));
            case 5:
                return $elm$core$String$fromInt($elm$time$Time$toDay_fn(zone, posix));
            case 6:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }($elm$time$Time$toDay_fn(zone, posix));
            case 7:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toDay_fn(zone, posix));
            case 8:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 9:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }($ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 10:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(3, $ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 11:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, posix));
            case 12:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }($ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, posix));
            case 13:
                return language.pp($elm$time$Time$toWeekday_fn(zone, posix));
            case 14:
                return language.pq($elm$time$Time$toWeekday_fn(zone, posix));
            case 19:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 20:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.dr(num));
                }($ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 21:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 15:
                return $elm$core$String$right_fn(2, $ryannhg$date_format$DateFormat$year_fn(zone, posix));
            case 16:
                return $ryannhg$date_format$DateFormat$year_fn(zone, posix);
            case 22:
                return $elm$core$String$toUpper($ryannhg$date_format$DateFormat$amPm_fn(language, zone, posix));
            case 23:
                return $elm$core$String$toLower($ryannhg$date_format$DateFormat$amPm_fn(language, zone, posix));
            case 24:
                return $elm$core$String$fromInt($elm$time$Time$toHour_fn(zone, posix));
            case 25:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toHour_fn(zone, posix));
            case 26:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$toNonMilitary($elm$time$Time$toHour_fn(zone, posix)));
            case 27:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$toNonMilitary($elm$time$Time$toHour_fn(zone, posix)));
            case 28:
                return $elm$core$String$fromInt(1 + $elm$time$Time$toHour_fn(zone, posix));
            case 29:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, 1 + $elm$time$Time$toHour_fn(zone, posix));
            case 30:
                return $elm$core$String$fromInt($elm$time$Time$toMinute_fn(zone, posix));
            case 31:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toMinute_fn(zone, posix));
            case 32:
                return $elm$core$String$fromInt($elm$time$Time$toSecond_fn(zone, posix));
            case 33:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toSecond_fn(zone, posix));
            case 34:
                return $elm$core$String$fromInt($elm$time$Time$toMillis_fn(zone, posix));
            case 35:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(3, $elm$time$Time$toMillis_fn(zone, posix));
            default:
                var string = token.a;
                return string;
        }
    }, $ryannhg$date_format$DateFormat$piece = F4($ryannhg$date_format$DateFormat$piece_fn);
    var $ryannhg$date_format$DateFormat$formatWithLanguage_fn = function (language, tokens, zone, time) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A3($ryannhg$date_format$DateFormat$piece, language, zone, time), tokens));
    }, $ryannhg$date_format$DateFormat$formatWithLanguage = F4($ryannhg$date_format$DateFormat$formatWithLanguage_fn);
    var $ryannhg$date_format$DateFormat$format_a0 = $ryannhg$date_format$DateFormat$Language$english, $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$format_a0);
    var $ryannhg$date_format$DateFormat$HourMilitaryFixed = { $: 25 };
    var $ryannhg$date_format$DateFormat$hourMilitaryFixed = $ryannhg$date_format$DateFormat$HourMilitaryFixed;
    var $ryannhg$date_format$DateFormat$MinuteFixed = { $: 31 };
    var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
    var $ryannhg$date_format$DateFormat$Text = function (a) {
        return { $: 36, a: a };
    };
    var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
    var $terezka$elm_charts$Internal$Svg$formatClock = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$hourMilitaryFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed
    ]));
    var $ryannhg$date_format$DateFormat$MillisecondFixed = { $: 35 };
    var $ryannhg$date_format$DateFormat$millisecondFixed = $ryannhg$date_format$DateFormat$MillisecondFixed;
    var $ryannhg$date_format$DateFormat$SecondFixed = { $: 33 };
    var $ryannhg$date_format$DateFormat$secondFixed = $ryannhg$date_format$DateFormat$SecondFixed;
    var $terezka$elm_charts$Internal$Svg$formatClockMillis = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$hourMilitaryFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$secondFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$millisecondFixed
    ]));
    var $terezka$elm_charts$Internal$Svg$formatClockSecond = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$hourMilitaryFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$secondFixed
    ]));
    var $ryannhg$date_format$DateFormat$DayOfMonthNumber = { $: 5 };
    var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
    var $ryannhg$date_format$DateFormat$MonthNumber = { $: 0 };
    var $ryannhg$date_format$DateFormat$monthNumber = $ryannhg$date_format$DateFormat$MonthNumber;
    var $terezka$elm_charts$Internal$Svg$formatDate = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$monthNumber,
        $ryannhg$date_format$DateFormat$text("/"),
        $ryannhg$date_format$DateFormat$dayOfMonthNumber
    ]));
    var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = { $: 3 };
    var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
    var $terezka$elm_charts$Internal$Svg$formatMonth = $ryannhg$date_format$DateFormat$format(_List_fromArray([$ryannhg$date_format$DateFormat$monthNameAbbreviated]));
    var $ryannhg$date_format$DateFormat$DayOfWeekNameFull = { $: 14 };
    var $ryannhg$date_format$DateFormat$dayOfWeekNameFull = $ryannhg$date_format$DateFormat$DayOfWeekNameFull;
    var $terezka$elm_charts$Internal$Svg$formatWeekday = $ryannhg$date_format$DateFormat$format(_List_fromArray([$ryannhg$date_format$DateFormat$dayOfWeekNameFull]));
    var $ryannhg$date_format$DateFormat$YearNumber = { $: 16 };
    var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
    var $terezka$elm_charts$Internal$Svg$formatYear = $ryannhg$date_format$DateFormat$format(_List_fromArray([$ryannhg$date_format$DateFormat$yearNumber]));
    var $terezka$elm_charts$Internal$Svg$formatTime_fn = function (zone, time) {
        var _v0 = $elm$core$Maybe$withDefault_fn(time.pv, time.lP);
        switch (_v0) {
            case 0:
                return A2($terezka$elm_charts$Internal$Svg$formatClockMillis, zone, time.pg);
            case 1:
                return A2($terezka$elm_charts$Internal$Svg$formatClockSecond, zone, time.pg);
            case 2:
                return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.pg);
            case 3:
                return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.pg);
            case 4:
                return (time.nv === 7) ? A2($terezka$elm_charts$Internal$Svg$formatWeekday, zone, time.pg) : A2($terezka$elm_charts$Internal$Svg$formatDate, zone, time.pg);
            case 5:
                return A2($terezka$elm_charts$Internal$Svg$formatMonth, zone, time.pg);
            default:
                return A2($terezka$elm_charts$Internal$Svg$formatYear, zone, time.pg);
        }
    }, $terezka$elm_charts$Internal$Svg$formatTime = F2($terezka$elm_charts$Internal$Svg$formatTime_fn);
    var $terezka$elm_charts$Chart$Svg$formatTime = $terezka$elm_charts$Internal$Svg$formatTime;
    var $terezka$elm_charts$Internal$Svg$generate_fn = function (amount, _v0, limits) {
        var func = _v0;
        return A2(func, amount, limits);
    }, $terezka$elm_charts$Internal$Svg$generate = F3($terezka$elm_charts$Internal$Svg$generate_fn);
    var $terezka$elm_charts$Chart$Svg$generate = $terezka$elm_charts$Internal$Svg$generate;
    var $terezka$intervals$Intervals$ints_fn = function (amount, range) {
        return $elm$core$List$map_fn($elm$core$Basics$round, function () {
            if (!amount.$) {
                var number = amount.a;
                return $terezka$intervals$Intervals$values_fn(false, true, number, range);
            }
            else {
                var number = amount.a;
                return $terezka$intervals$Intervals$values_fn(false, false, number, range);
            }
        }());
    }, $terezka$intervals$Intervals$ints = F2($terezka$intervals$Intervals$ints_fn);
    var $terezka$elm_charts$Internal$Svg$ints_fn = function (i, b) {
        return $terezka$intervals$Intervals$ints_fn($terezka$intervals$Intervals$around(i), { ne: b.ne, np: b.np });
    }, $terezka$elm_charts$Internal$Svg$ints = F2($terezka$elm_charts$Internal$Svg$ints_fn);
    var $terezka$elm_charts$Chart$Svg$ints = $terezka$elm_charts$Internal$Svg$ints;
    var $terezka$intervals$Intervals$Day = 4;
    var $terezka$intervals$Intervals$Hour = 3;
    var $terezka$intervals$Intervals$Millisecond = 0;
    var $terezka$intervals$Intervals$Minute = 2;
    var $terezka$intervals$Intervals$Month = 5;
    var $terezka$intervals$Intervals$Second = 1;
    var $terezka$intervals$Intervals$Year = 6;
    var $justinmimbs$date$Date$Days = 3;
    var $justinmimbs$date$Date$Months = 1;
    var $justinmimbs$date$Date$add_fn = function (unit, n, _v0) {
        var rd = _v0;
        switch (unit) {
            case 0:
                return $justinmimbs$date$Date$add_fn(1, 12 * n, rd);
            case 1:
                var date = $justinmimbs$date$Date$toCalendarDate(rd);
                var wholeMonths = ((12 * (date.lk - 1)) + ($justinmimbs$date$Date$monthToNumber(date.j2) - 1)) + n;
                var m = $justinmimbs$date$Date$numberToMonth(_Basics_modBy_fn(12, wholeMonths) + 1);
                var y = $justinmimbs$date$Date$floorDiv_fn(wholeMonths, 12) + 1;
                return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + $elm$core$Basics$min_fn(date.i$, $justinmimbs$date$Date$daysInMonth_fn(y, m));
            case 2:
                return rd + (7 * n);
            default:
                return rd + n;
        }
    }, $justinmimbs$date$Date$add = F3($justinmimbs$date$Date$add_fn);
    var $justinmimbs$time_extra$Time$Extra$add_fn = function (interval, n, zone, posix) {
        add: while (true) {
            switch (interval) {
                case 15:
                    return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(posix) + n);
                case 14:
                    var $temp$interval = 15, $temp$n = n * 1000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 13:
                    var $temp$interval = 15, $temp$n = n * 60000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 12:
                    var $temp$interval = 15, $temp$n = n * 3600000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 11:
                    return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$add_fn(3, n, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix));
                case 2:
                    return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$add_fn(1, n, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix));
                case 0:
                    var $temp$interval = 2, $temp$n = n * 12, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 1:
                    var $temp$interval = 2, $temp$n = n * 3, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 3:
                    var $temp$interval = 11, $temp$n = n * 7, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                default:
                    var weekday = interval;
                    var $temp$interval = 11, $temp$n = n * 7, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
            }
        }
    }, $justinmimbs$time_extra$Time$Extra$add = F4($justinmimbs$time_extra$Time$Extra$add_fn);
    var $justinmimbs$time_extra$Time$Extra$ceiling_fn = function (interval, zone, posix) {
        var floored = $justinmimbs$time_extra$Time$Extra$floor_fn(interval, zone, posix);
        return _Utils_eq(floored, posix) ? posix : $justinmimbs$time_extra$Time$Extra$add_fn(interval, 1, zone, floored);
    }, $justinmimbs$time_extra$Time$Extra$ceiling = F3($justinmimbs$time_extra$Time$Extra$ceiling_fn);
    var $terezka$intervals$Intervals$Time$ceilingDay_fn = function (zone, mult, stamp) {
        return (mult === 7) ? $justinmimbs$time_extra$Time$Extra$ceiling_fn(3, zone, stamp) : $justinmimbs$time_extra$Time$Extra$ceiling_fn(11, zone, stamp);
    }, $terezka$intervals$Intervals$Time$ceilingDay = F3($terezka$intervals$Intervals$Time$ceilingDay_fn);
    var $justinmimbs$time_extra$Time$Extra$Hour = 12;
    var $justinmimbs$time_extra$Time$Extra$partsToPosix_fn = function (zone, _v0) {
        var year = _v0.lk;
        var month = _v0.j2;
        var day = _v0.i$;
        var hour = _v0.g2;
        var minute = _v0.hw;
        var second = _v0.hW;
        var millisecond = _v0.hv;
        return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromCalendarDate_fn(year, month, day), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$core$Basics$clamp_fn(0, 23, hour), $elm$core$Basics$clamp_fn(0, 59, minute), $elm$core$Basics$clamp_fn(0, 59, second), $elm$core$Basics$clamp_fn(0, 999, millisecond)));
    }, $justinmimbs$time_extra$Time$Extra$partsToPosix = F2($justinmimbs$time_extra$Time$Extra$partsToPosix_fn);
    var $justinmimbs$time_extra$Time$Extra$posixToParts_fn = function (zone, posix) {
        return {
            i$: $elm$time$Time$toDay_fn(zone, posix),
            g2: $elm$time$Time$toHour_fn(zone, posix),
            hv: $elm$time$Time$toMillis_fn(zone, posix),
            hw: $elm$time$Time$toMinute_fn(zone, posix),
            j2: $elm$time$Time$toMonth_fn(zone, posix),
            hW: $elm$time$Time$toSecond_fn(zone, posix),
            lk: $elm$time$Time$toYear_fn(zone, posix)
        };
    }, $justinmimbs$time_extra$Time$Extra$posixToParts = F2($justinmimbs$time_extra$Time$Extra$posixToParts_fn);
    var $terezka$intervals$Intervals$Time$ceilingHour_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(12, zone, stamp));
        var rem = parts.g2 % mult;
        var _new = $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, parts);
        return (!rem) ? _new : $justinmimbs$time_extra$Time$Extra$add_fn(12, mult - rem, zone, _new);
    }, $terezka$intervals$Intervals$Time$ceilingHour = F3($terezka$intervals$Intervals$Time$ceilingHour_fn);
    var $justinmimbs$time_extra$Time$Extra$Minute = 13;
    var $terezka$intervals$Intervals$Time$ceilingMinute_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(13, zone, stamp));
        var rem = parts.hw % mult;
        var _new = $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, parts);
        return (!rem) ? _new : $justinmimbs$time_extra$Time$Extra$add_fn(13, mult - rem, zone, _new);
    }, $terezka$intervals$Intervals$Time$ceilingMinute = F3($terezka$intervals$Intervals$Time$ceilingMinute_fn);
    var $terezka$intervals$Intervals$Time$intAsMonth = function (_int) {
        switch (_int) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            case 12:
                return 11;
            default:
                return 11;
        }
    };
    var $terezka$intervals$Intervals$Time$monthAsInt = function (month) {
        switch (month) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $terezka$intervals$Intervals$Time$ceilingMonth_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(2, zone, stamp));
        var monthInt = $terezka$intervals$Intervals$Time$monthAsInt(parts.j2);
        var rem = (monthInt - 1) % mult;
        var newMonth = (!rem) ? monthInt : ((monthInt - rem) + mult);
        return $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, (newMonth > 12) ? _Utils_update(parts, {
            j2: $terezka$intervals$Intervals$Time$intAsMonth(newMonth - 12),
            lk: parts.lk + 1
        }) : _Utils_update(parts, {
            j2: $terezka$intervals$Intervals$Time$intAsMonth(newMonth)
        }));
    }, $terezka$intervals$Intervals$Time$ceilingMonth = F3($terezka$intervals$Intervals$Time$ceilingMonth_fn);
    var $terezka$intervals$Intervals$Time$ceilingMs_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, stamp);
        var rem = parts.hv % mult;
        return (!rem) ? $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, parts) : $justinmimbs$time_extra$Time$Extra$add_fn(15, mult - rem, zone, stamp);
    }, $terezka$intervals$Intervals$Time$ceilingMs = F3($terezka$intervals$Intervals$Time$ceilingMs_fn);
    var $justinmimbs$time_extra$Time$Extra$Second = 14;
    var $terezka$intervals$Intervals$Time$ceilingSecond_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(14, zone, stamp));
        var rem = parts.hW % mult;
        var _new = $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, parts);
        return (!rem) ? _new : $justinmimbs$time_extra$Time$Extra$add_fn(14, mult - rem, zone, _new);
    }, $terezka$intervals$Intervals$Time$ceilingSecond = F3($terezka$intervals$Intervals$Time$ceilingSecond_fn);
    var $justinmimbs$time_extra$Time$Extra$Year = 0;
    var $terezka$intervals$Intervals$Time$ceilingYear_fn = function (zone, mult, stamp) {
        var parts = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(0, zone, stamp));
        var rem = parts.lk % mult;
        var newYear = (!rem) ? parts.lk : ((parts.lk - rem) + mult);
        return $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, _Utils_update(parts, { lk: newYear }));
    }, $terezka$intervals$Intervals$Time$ceilingYear = F3($terezka$intervals$Intervals$Time$ceilingYear_fn);
    var $terezka$intervals$Intervals$Time$ceilingUnit_fn = function (zone, unit, mult) {
        switch (unit) {
            case 0:
                return A2($terezka$intervals$Intervals$Time$ceilingMs, zone, mult);
            case 1:
                return A2($terezka$intervals$Intervals$Time$ceilingSecond, zone, mult);
            case 2:
                return A2($terezka$intervals$Intervals$Time$ceilingMinute, zone, mult);
            case 3:
                return A2($terezka$intervals$Intervals$Time$ceilingHour, zone, mult);
            case 4:
                return A2($terezka$intervals$Intervals$Time$ceilingDay, zone, mult);
            case 5:
                return A2($terezka$intervals$Intervals$Time$ceilingMonth, zone, mult);
            default:
                return A2($terezka$intervals$Intervals$Time$ceilingYear, zone, mult);
        }
    }, $terezka$intervals$Intervals$Time$ceilingUnit = F3($terezka$intervals$Intervals$Time$ceilingUnit_fn);
    var $terezka$intervals$Intervals$Time$Day = 4;
    var $terezka$intervals$Intervals$Time$Hour = 3;
    var $terezka$intervals$Intervals$Time$Millisecond = 0;
    var $terezka$intervals$Intervals$Time$Minute = 2;
    var $terezka$intervals$Intervals$Time$Month = 5;
    var $terezka$intervals$Intervals$Time$Second = 1;
    var $terezka$intervals$Intervals$Time$Year = 6;
    var $terezka$intervals$Intervals$Time$getChange_fn = function (zone, a, b) {
        var bP = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, b);
        var aP = $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, a);
        return (!_Utils_eq(aP.lk, bP.lk)) ? 6 : ((!_Utils_eq(aP.j2, bP.j2)) ? 5 : ((!_Utils_eq(aP.i$, bP.i$)) ? 4 : ((!_Utils_eq(aP.g2, bP.g2)) ? 3 : ((!_Utils_eq(aP.hw, bP.hw)) ? 2 : ((!_Utils_eq(aP.hW, bP.hW)) ? 1 : 0)))));
    }, $terezka$intervals$Intervals$Time$getChange = F3($terezka$intervals$Intervals$Time$getChange_fn);
    var $danhandrea$elm_time_extra$Util$isLeapYear = function (year) {
        return (!_Basics_modBy_fn(400, year)) || ((!(!_Basics_modBy_fn(100, year))) && (!_Basics_modBy_fn(4, year)));
    };
    var $danhandrea$elm_time_extra$Month$days_fn = function (year, month) {
        switch (month) {
            case 0:
                return 31;
            case 1:
                return $danhandrea$elm_time_extra$Util$isLeapYear(year) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $danhandrea$elm_time_extra$Month$days = F2($danhandrea$elm_time_extra$Month$days_fn);
    var $danhandrea$elm_time_extra$TimeExtra$daysInMonth = $danhandrea$elm_time_extra$Month$days;
    var $terezka$intervals$Intervals$Time$toMs = $elm$time$Time$posixToMillis;
    var $terezka$intervals$Intervals$Time$getDiff_fn = function (zone, a, b) {
        var _v0 = (_Utils_cmp($terezka$intervals$Intervals$Time$toMs(a), $terezka$intervals$Intervals$Time$toMs(b)) < 0) ? _Utils_Tuple2($justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, a), $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, b)) : _Utils_Tuple2($justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, b), $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, a));
        var aP = _v0.a;
        var bP = _v0.b;
        var dMsX = bP.hv - aP.hv;
        var dMs = (dMsX < 0) ? (1000 + dMsX) : dMsX;
        var dSecondX = (bP.hW - aP.hW) + ((dMsX < 0) ? (-1) : 0);
        var dMinuteX = (bP.hw - aP.hw) + ((dSecondX < 0) ? (-1) : 0);
        var dHourX = (bP.g2 - aP.g2) + ((dMinuteX < 0) ? (-1) : 0);
        var dDayX = (bP.i$ - aP.i$) + ((dHourX < 0) ? (-1) : 0);
        var dDay = (dDayX < 0) ? ($danhandrea$elm_time_extra$Month$days_fn(bP.lk, bP.j2) + dDayX) : dDayX;
        var dMonthX = ($terezka$intervals$Intervals$Time$monthAsInt(bP.j2) - $terezka$intervals$Intervals$Time$monthAsInt(aP.j2)) + ((dDayX < 0) ? (-1) : 0);
        var dMonth = (dMonthX < 0) ? (12 + dMonthX) : dMonthX;
        var dHour = (dHourX < 0) ? (24 + dHourX) : dHourX;
        var dMinute = (dMinuteX < 0) ? (60 + dMinuteX) : dMinuteX;
        var dSecond = (dSecondX < 0) ? (60 + dSecondX) : dSecondX;
        var dYearX = (bP.lk - aP.lk) + ((dMonthX < 0) ? (-1) : 0);
        var dYear = (dYearX < 0) ? ($terezka$intervals$Intervals$Time$monthAsInt(bP.j2) + dYearX) : dYearX;
        return { i$: dDay, g2: dHour, hv: dMs, hw: dMinute, j2: dMonth, hW: dSecond, lk: dYear };
    }, $terezka$intervals$Intervals$Time$getDiff = F3($terezka$intervals$Intervals$Time$getDiff_fn);
    var $terezka$intervals$Intervals$Time$oneSecond = 1000;
    var $terezka$intervals$Intervals$Time$oneMinute = $terezka$intervals$Intervals$Time$oneSecond * 60;
    var $terezka$intervals$Intervals$Time$oneHour = $terezka$intervals$Intervals$Time$oneMinute * 60;
    var $terezka$intervals$Intervals$Time$oneDay = $terezka$intervals$Intervals$Time$oneHour * 24;
    var $terezka$intervals$Intervals$Time$oneMs = 1;
    var $terezka$intervals$Intervals$Time$getNumOfTicks_fn = function (zone, unit, mult, a, b) {
        var div = F2(function (n1, n2) {
            return $elm$core$Basics$floor(n1 / n2);
        });
        var timeDiff = function (ms) {
            var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
            return (_Utils_cmp($terezka$intervals$Intervals$Time$toMs(ceiled), $terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(div, A2(div, $terezka$intervals$Intervals$Time$toMs(b) - $terezka$intervals$Intervals$Time$toMs(ceiled), ms), mult);
        };
        var diff = function (property) {
            var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
            return (_Utils_cmp($terezka$intervals$Intervals$Time$toMs(ceiled), $terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(div, property($terezka$intervals$Intervals$Time$getDiff_fn(zone, ceiled, b)), mult);
        };
        switch (unit) {
            case 0:
                return timeDiff($terezka$intervals$Intervals$Time$oneMs) + 1;
            case 1:
                return timeDiff($terezka$intervals$Intervals$Time$oneSecond) + 1;
            case 2:
                return timeDiff($terezka$intervals$Intervals$Time$oneMinute) + 1;
            case 3:
                return timeDiff($terezka$intervals$Intervals$Time$oneHour) + 1;
            case 4:
                return timeDiff($terezka$intervals$Intervals$Time$oneDay) + 1;
            case 5:
                return diff(function (d) {
                    return d.j2 + (d.lk * 12);
                }) + 1;
            default:
                return diff(function ($) {
                    return $.lk;
                }) + 1;
        }
    }, $terezka$intervals$Intervals$Time$getNumOfTicks = F5($terezka$intervals$Intervals$Time$getNumOfTicks_fn);
    var $terezka$intervals$Intervals$Time$largerUnit = function (unit) {
        switch (unit) {
            case 0:
                return $elm$core$Maybe$Just(1);
            case 1:
                return $elm$core$Maybe$Just(2);
            case 2:
                return $elm$core$Maybe$Just(3);
            case 3:
                return $elm$core$Maybe$Just(4);
            case 4:
                return $elm$core$Maybe$Just(5);
            case 5:
                return $elm$core$Maybe$Just(6);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $terezka$intervals$Intervals$Time$niceMultiples = function (unit) {
        switch (unit) {
            case 0:
                return _List_fromArray([1, 2, 5, 10, 20, 25, 50, 100, 200, 500]);
            case 1:
                return _List_fromArray([1, 2, 5, 10, 15, 30]);
            case 2:
                return _List_fromArray([1, 2, 5, 10, 15, 30]);
            case 3:
                return _List_fromArray([1, 2, 3, 4, 6, 8, 12]);
            case 4:
                return _List_fromArray([1, 2, 3, 7, 14]);
            case 5:
                return _List_fromArray([1, 2, 3, 4, 6]);
            default:
                return _List_fromArray([1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 10000, 1000000, 10000000]);
        }
    };
    var $terezka$intervals$Intervals$Time$toBestUnit_fn = function (zone, amount, min, max) {
        var toNice = function (unit) {
            toNice: while (true) {
                var niceNums = $terezka$intervals$Intervals$Time$niceMultiples(unit);
                var maybeNiceNum = $elm$core$List$filter_fn(function (n) {
                    return _Utils_cmp($terezka$intervals$Intervals$Time$getNumOfTicks_fn(zone, unit, n, min, max), amount) < 1;
                }, niceNums);
                var div = F2(function (n1, n2) {
                    return $elm$core$Basics$ceiling(n1 / n2);
                });
                var _v0 = $elm$core$List$head(maybeNiceNum);
                if (!_v0.$) {
                    var niceNum = _v0.a;
                    return _Utils_Tuple2(unit, niceNum);
                }
                else {
                    var _v1 = $terezka$intervals$Intervals$Time$largerUnit(unit);
                    if (!_v1.$) {
                        var larger = _v1.a;
                        var $temp$unit = larger;
                        unit = $temp$unit;
                        continue toNice;
                    }
                    else {
                        return _Utils_Tuple2(6, 100000000);
                    }
                }
            }
        };
        return toNice(0);
    }, $terezka$intervals$Intervals$Time$toBestUnit = F4($terezka$intervals$Intervals$Time$toBestUnit_fn);
    var $terezka$intervals$Intervals$Time$toExtraUnit = function (unit) {
        switch (unit) {
            case 0:
                return 15;
            case 1:
                return 14;
            case 2:
                return 13;
            case 3:
                return 12;
            case 4:
                return 11;
            case 5:
                return 2;
            default:
                return 0;
        }
    };
    var $terezka$intervals$Intervals$Time$unitToInt = function (unit) {
        switch (unit) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 4;
            case 5:
                return 5;
            default:
                return 6;
        }
    };
    var $terezka$intervals$Intervals$Time$values_fn = function (zone, maxMmount, min, max) {
        var _v0 = $terezka$intervals$Intervals$Time$toBestUnit_fn(zone, maxMmount, min, max);
        var unit = _v0.a;
        var mult = _v0.b;
        var amount = $terezka$intervals$Intervals$Time$getNumOfTicks_fn(zone, unit, mult, min, max);
        var initial = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, min);
        var tUnit = $terezka$intervals$Intervals$Time$toExtraUnit(unit);
        var toTick = F3(function (x, timestamp, change) {
            return {
                lP: (_Utils_cmp($terezka$intervals$Intervals$Time$unitToInt(change), $terezka$intervals$Intervals$Time$unitToInt(unit)) > 0) ? $elm$core$Maybe$Just(change) : $elm$core$Maybe$Nothing,
                he: !x,
                nv: mult,
                pg: timestamp,
                pv: unit,
                iv: zone
            };
        });
        var toTicks = F2(function (xs, acc) {
            toTicks: while (true) {
                if (xs.b) {
                    var x = xs.a;
                    var rest = xs.b;
                    var prev = $justinmimbs$time_extra$Time$Extra$add_fn(tUnit, (x - 1) * mult, zone, initial);
                    var curr = $justinmimbs$time_extra$Time$Extra$add_fn(tUnit, x * mult, zone, initial);
                    var change = $terezka$intervals$Intervals$Time$getChange_fn(zone, prev, curr);
                    var $temp$xs = rest, $temp$acc = _List_Cons(A3(toTick, x, curr, change), acc);
                    xs = $temp$xs;
                    acc = $temp$acc;
                    continue toTicks;
                }
                else {
                    return acc;
                }
            }
        });
        return $elm$core$List$reverse(A2(toTicks, $elm$core$List$range_fn(0, amount - 1), _List_Nil));
    }, $terezka$intervals$Intervals$Time$values = F4($terezka$intervals$Intervals$Time$values_fn);
    var $terezka$intervals$Intervals$times_fn = function (zone, amount, range) {
        var toUnit = function (unit) {
            switch (unit) {
                case 0:
                    return 0;
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 3:
                    return 3;
                case 4:
                    return 4;
                case 5:
                    return 5;
                default:
                    return 6;
            }
        };
        var translateUnit = function (time) {
            return {
                lP: $elm$core$Maybe$map_fn(toUnit, time.lP),
                he: time.he,
                nv: time.nv,
                pg: time.pg,
                pv: toUnit(time.pv),
                iv: time.iv
            };
        };
        var fromMs = function (ts) {
            return $elm$time$Time$millisToPosix($elm$core$Basics$round(ts));
        };
        return $elm$core$List$map_fn(translateUnit, $terezka$intervals$Intervals$Time$values_fn(zone, amount, fromMs(range.np), fromMs(range.ne)));
    }, $terezka$intervals$Intervals$times = F3($terezka$intervals$Intervals$times_fn);
    var $terezka$elm_charts$Internal$Svg$times = function (zone) {
        return F2(function (i, b) {
            return $terezka$intervals$Intervals$times_fn(zone, i, { ne: b.ne, np: b.np });
        });
    };
    var $terezka$elm_charts$Chart$Svg$times = $terezka$elm_charts$Internal$Svg$times;
    var $terezka$elm_charts$Chart$generateValues_fn = function (amount, tick, maybeFormat, axis) {
        var toTickValues = F2(function (toValue, toString) {
            return $elm$core$List$map(function (i) {
                return {
                    fx: function () {
                        if (!maybeFormat.$) {
                            var formatter = maybeFormat.a;
                            return formatter(toValue(i));
                        }
                        else {
                            return toString(i);
                        }
                    }(),
                    pB: toValue(i)
                };
            });
        });
        switch (tick.$) {
            case 0:
                return A3(toTickValues, $elm$core$Basics$identity, $elm$core$String$fromFloat, $terezka$elm_charts$Internal$Svg$generate_fn(amount, $terezka$elm_charts$Chart$Svg$floats, axis));
            case 1:
                return A3(toTickValues, $elm$core$Basics$toFloat, $elm$core$String$fromInt, $terezka$elm_charts$Internal$Svg$generate_fn(amount, $terezka$elm_charts$Chart$Svg$ints, axis));
            default:
                var zone = tick.a;
                return A3(toTickValues, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$toFloat, $elm$time$Time$posixToMillis), function ($) {
                    return $.pg;
                }), $terezka$elm_charts$Chart$Svg$formatTime(zone), $terezka$elm_charts$Internal$Svg$generate_fn(amount, $terezka$elm_charts$Chart$Svg$times(zone), axis));
        }
    }, $terezka$elm_charts$Chart$generateValues = F4($terezka$elm_charts$Chart$generateValues_fn);
    var $terezka$elm_charts$Chart$yLabels = function (edits) {
        var toTicks = F2(function (p, config) {
            return $terezka$elm_charts$Chart$generateValues_fn(config.a5, config.bb, config.d7, $elm$core$List$foldl_fn_unwrapped(function (f, y) {
                return f(y);
            }, p.pJ, config.as));
        });
        var toTickValues = F3(function (p, config, ts) {
            return (!config.L) ? ts : _Utils_update(ts, {
                a4: _Utils_ap(ts.a4, $elm$core$List$map_fn(function ($) {
                    return $.pB;
                }, A2(toTicks, p, config)))
            });
        });
        var toConfig = function (p) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(edits, { a5: 5, R: $elm$core$Maybe$Nothing, E: _List_Nil, bw: "#808BAB", U: $elm$core$Maybe$Nothing, J: false, aG: $elm$core$Maybe$Nothing, d7: $elm$core$Maybe$Nothing, bb: $terezka$elm_charts$Internal$Svg$Floats, L: false, V: false, as: _List_Nil, X: $terezka$elm_charts$Chart$Attributes$zero, Y: 0, _: false, N: -10, O: 3 });
        };
        return $terezka$elm_charts$Chart$LabelsElement_fn(toConfig, toTickValues, F2(function (p, config) {
            var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
            var toLabel = function (item) {
                return $terezka$elm_charts$Internal$Svg$label_fn(p, _Utils_update(_default, {
                    R: function () {
                        var _v0 = config.R;
                        if (_v0.$ === 1) {
                            return $elm$core$Maybe$Just(config.J ? 1 : 0);
                        }
                        else {
                            var anchor = _v0.a;
                            return $elm$core$Maybe$Just(anchor);
                        }
                    }(),
                    E: config.E,
                    bw: config.bw,
                    U: config.U,
                    aG: config.aG,
                    V: config.V,
                    Y: config.Y,
                    _: config._,
                    N: config.J ? (-config.N) : config.N,
                    O: config.O
                }), _List_fromArray([
                    $elm$svg$Svg$text(item.fx)
                ]), {
                    pH: config.X(p.pH),
                    pJ: item.pB
                });
            };
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__y-labels")
            ]), $elm$core$List$map_fn(toLabel, A2(toTicks, p, config)));
        }));
    };
    var $author$project$Pages$Dashboards$viewBarChart_fn = function (toMsg, model, chart, chartDataRaw) {
        var hovers = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn(chart.bR, model.dL));
        var renderBarAt = function (colIdx) {
            return $terezka$elm_charts$Internal$Property$format_fn(A2($elm_community$maybe_extra$Maybe$Extra$unwrap, "null", $elm$core$String$fromFloat), A3($elm$core$Basics$apR, $elm$core$Maybe$withDefault_fn("", $elm_community$list_extra$List$Extra$getAt_fn(colIdx, $author$project$Types$ChartType$toHeaders(chart.bu))), $terezka$elm_charts$Chart$named, A3($terezka$elm_charts$Chart$amongst, $elm$core$List$concatMap_fn($terezka$elm_charts$Chart$Item$getMembers, hovers), $elm$core$Basics$always(_List_fromArray([
                $terezka$elm_charts$Chart$Attributes$opacity(0.7)
            ])), A2($terezka$elm_charts$Chart$barMaybe, A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$getAt(colIdx), $elm$core$Maybe$andThen(A2($author$project$Types$Cell$unpack, $elm$core$Basics$always($elm$core$Maybe$Just(0)), $elm$core$String$toFloat))), _List_Nil))));
        };
        var chartData = chart.ea ? $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$removeXHeader, $elm$core$List$all(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Cell$isNull))), chartDataRaw) : chartDataRaw;
        var customXLabels = $elm$core$List$filterMap_fn($author$project$Pages$Dashboards$getXHeader, chartData);
        return $rtfeldman$elm_css$Html$Styled$fromUnstyled($terezka$elm_charts$Chart$chart_fn(_List_fromArray([
            $terezka$elm_charts$Chart$Attributes$width(600),
            $terezka$elm_charts$Chart$Attributes$height(260),
            $terezka$elm_charts$Chart$Events$onMouseMove_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$BarChartHovered(chart.bR)), $terezka$elm_charts$Chart$Events$getNearestX($terezka$elm_charts$Chart$Item$bins)),
            $terezka$elm_charts$Chart$Events$onMouseLeave(toMsg($author$project$Pages$Dashboards$BarChartHovered_fn(chart.bR, _List_Nil)))
        ]), _List_fromArray([
            A2($author$project$Pages$Dashboards$xLabelsRotated, chart.ef, customXLabels),
            $terezka$elm_charts$Chart$yLabels(_List_fromArray([$terezka$elm_charts$Chart$Attributes$withGrid])),
            $terezka$elm_charts$Chart$barsMap_fn($elm$core$Basics$identity, _List_Nil, $elm$core$List$map_fn(renderBarAt, $author$project$Pages$Dashboards$remainingColumnsIdxs(chartData)), chartData),
            $terezka$elm_charts$Chart$each_fn(hovers, F2(function (_v0, item) {
                return _List_fromArray([
                    $terezka$elm_charts$Chart$tooltip_fn(item, _List_Nil, _List_Nil, _List_Nil)
                ]);
            })),
            $terezka$elm_charts$Chart$eachCustom_fn($terezka$elm_charts$Chart$Item$any, F2(function (plane, bar) {
                return (chart.ea || $terezka$elm_charts$Chart$Item$isReal(bar)) ? _List_Nil : _List_fromArray([
                    $terezka$elm_charts$Chart$label_fn(_List_fromArray([
                        $terezka$elm_charts$Chart$Attributes$moveUp(5),
                        $terezka$elm_charts$Chart$Attributes$moveRight(5),
                        $terezka$elm_charts$Chart$Attributes$rotate(90),
                        $terezka$elm_charts$Chart$Attributes$alignLeft
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Svg$Styled$toUnstyled($rtfeldman$elm_css$Svg$Styled$text("null"))
                    ]), A2($terezka$elm_charts$Chart$Item$getTop, plane, bar))
                ]);
            }))
        ])));
    }, $author$project$Pages$Dashboards$viewBarChart = F4($author$project$Pages$Dashboards$viewBarChart_fn);
    var $author$project$Pages$Dashboards$expectAllFloats_a0 = $elm_community$maybe_extra$Maybe$Extra$traverse(A2($elm$core$Basics$composeR, $author$project$Types$Cell$toMaybeString, $elm$core$Maybe$andThen($elm$core$String$toFloat))), $author$project$Pages$Dashboards$expectAllFloats = $elm$core$List$filterMap($author$project$Pages$Dashboards$expectAllFloats_a0);
    var $author$project$Pages$Dashboards$tail_a0 = $author$project$Pages$Dashboards$removeXHeader, $author$project$Pages$Dashboards$tail = $elm$core$List$map($author$project$Pages$Dashboards$tail_a0);
    var $author$project$Pages$Dashboards$LineChartHovered_fn = function (a, b) {
        return { $: 25, a: a, b: b };
    }, $author$project$Pages$Dashboards$LineChartHovered = F2($author$project$Pages$Dashboards$LineChartHovered_fn);
    var $terezka$elm_charts$Chart$Attributes$exactly_fn = function (exact, _v0, _v1) {
        return exact;
    }, $terezka$elm_charts$Chart$Attributes$exactly = F3($terezka$elm_charts$Chart$Attributes$exactly_fn);
    var $terezka$elm_charts$Internal$Svg$Linear = 0;
    var $terezka$elm_charts$Chart$Attributes$linear = function (config) {
        return _Utils_update(config, {
            f: $elm$core$Maybe$Just(0)
        });
    };
    var $terezka$elm_charts$Chart$interpolated_fn = function (y, inter) {
        return A2($terezka$elm_charts$Internal$Property$property, A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just), _Utils_ap(_List_fromArray([$terezka$elm_charts$Chart$Attributes$linear]), inter));
    }, $terezka$elm_charts$Chart$interpolated = F2($terezka$elm_charts$Chart$interpolated_fn);
    var $terezka$elm_charts$Chart$SeriesElement_fn = function (a, b, c, d) {
        return { $: 1, a: a, b: b, c: c, d: d };
    }, $terezka$elm_charts$Chart$SeriesElement = F4($terezka$elm_charts$Chart$SeriesElement_fn);
    var $terezka$elm_charts$Internal$Legend$LineLegend_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $terezka$elm_charts$Internal$Legend$LineLegend = F3($terezka$elm_charts$Internal$Legend$LineLegend_fn);
    var $terezka$elm_charts$Internal$Svg$defaultInterpolation = { E: _List_Nil, bw: $terezka$elm_charts$Internal$Helpers$pink, e9: _List_Nil, gL: $elm$core$Maybe$Nothing, f: $elm$core$Maybe$Nothing, bg: 0, ir: 1 };
    var $terezka$elm_charts$Internal$Legend$toDotLegends_fn = function (elIndex, properties) {
        var toInterConfig = function (attrs) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
        };
        var toDotLegend = F3(function (props, prop, colorIndex) {
            var defaultOpacity = ($elm$core$List$length(props) > 1) ? 0.4 : 0;
            var interAttr = _Utils_ap(_List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color($terezka$elm_charts$Internal$Helpers$toDefault_fn($terezka$elm_charts$Internal$Helpers$toDefaultColor_a0, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1, colorIndex)),
                $terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
            ]), prop.mQ);
            var interConfig = toInterConfig(interAttr);
            var defaultName = "Property #" + $elm$core$String$fromInt(colorIndex + 1);
            var defaultAttrs = _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color(interConfig.bw),
                $terezka$elm_charts$Chart$Attributes$border(interConfig.bw),
                _Utils_eq(interConfig.f, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $elm$core$Basics$identity
            ]);
            var dotAttrs = _Utils_ap(defaultAttrs, prop.E);
            return $terezka$elm_charts$Internal$Legend$LineLegend_fn($elm$core$Maybe$withDefault_fn(defaultName, prop.j1), interAttr, dotAttrs);
        });
        return $elm$core$List$indexedMap_fn_unwrapped(function (propIndex, f) {
            return f(elIndex + propIndex);
        }, $elm$core$List$concatMap_fn(function (ps) {
            return $elm$core$List$map_fn(toDotLegend(ps), ps);
        }, $elm$core$List$map_fn($terezka$elm_charts$Internal$Property$toConfigs, properties)));
    }, $terezka$elm_charts$Internal$Legend$toDotLegends = F2($terezka$elm_charts$Internal$Legend$toDotLegends_fn);
    var $terezka$elm_charts$Internal$Item$Dot = function (a) {
        return { $: 0, a: a };
    };
    var $elm$svg$Svg$Attributes$fillRule_a0 = "fill-rule", $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute($elm$svg$Svg$Attributes$fillRule_a0);
    var $terezka$elm_charts$Internal$Interpolation$linear_a0 = $elm$core$List$map(function (_v0) {
        var x = _v0.pH;
        var y = _v0.pJ;
        return $terezka$elm_charts$Internal$Commands$Line_fn(x, y);
    }), $terezka$elm_charts$Internal$Interpolation$linear = $elm$core$List$map($terezka$elm_charts$Internal$Interpolation$linear_a0);
    var $terezka$elm_charts$Internal$Interpolation$First = { $: 0 };
    var $terezka$elm_charts$Internal$Interpolation$Previous = function (a) {
        return { $: 1, a: a };
    };
    var $terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn = function (point0, point1, tangent0, tangent1) {
        var dx = (point1.pH - point0.pH) / 3;
        return $terezka$elm_charts$Internal$Commands$CubicBeziers_fn(point0.pH + dx, point0.pJ + (dx * tangent0), point1.pH - dx, point1.pJ - (dx * tangent1), point1.pH, point1.pJ);
    }, $terezka$elm_charts$Internal$Interpolation$monotoneCurve = F4($terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn);
    var $terezka$elm_charts$Internal$Interpolation$slope2_fn = function (point0, point1, t) {
        var h = point1.pH - point0.pH;
        return (!(!h)) ? ((((3 * (point1.pJ - point0.pJ)) / h) - t) / 2) : t;
    }, $terezka$elm_charts$Internal$Interpolation$slope2 = F3($terezka$elm_charts$Internal$Interpolation$slope2_fn);
    var $terezka$elm_charts$Internal$Interpolation$sign = function (x) {
        return (x < 0) ? (-1) : 1;
    };
    var $terezka$elm_charts$Internal$Interpolation$toH_fn = function (h0, h1) {
        return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
    }, $terezka$elm_charts$Internal$Interpolation$toH = F2($terezka$elm_charts$Internal$Interpolation$toH_fn);
    var $terezka$elm_charts$Internal$Interpolation$slope3_fn = function (point0, point1, point2) {
        var h1 = point2.pH - point1.pH;
        var h0 = point1.pH - point0.pH;
        var s0h = $terezka$elm_charts$Internal$Interpolation$toH_fn(h0, h1);
        var s0 = (point1.pJ - point0.pJ) / s0h;
        var s1h = $terezka$elm_charts$Internal$Interpolation$toH_fn(h1, h0);
        var s1 = (point2.pJ - point1.pJ) / s1h;
        var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
        var slope = ($terezka$elm_charts$Internal$Interpolation$sign(s0) + $terezka$elm_charts$Internal$Interpolation$sign(s1)) * $elm$core$Basics$min_fn($elm$core$Basics$min_fn($elm$core$Basics$abs(s0), $elm$core$Basics$abs(s1)), 0.5 * $elm$core$Basics$abs(p));
        return $elm$core$Basics$isNaN(slope) ? 0 : slope;
    }, $terezka$elm_charts$Internal$Interpolation$slope3 = F3($terezka$elm_charts$Internal$Interpolation$slope3_fn);
    var $terezka$elm_charts$Internal$Interpolation$monotonePart_fn = function (points, _v0) {
        var tangent = _v0.a;
        var commands = _v0.b;
        var _v1 = _Utils_Tuple2(tangent, points);
        _v1$4: while (true) {
            if (!_v1.a.$) {
                if (_v1.b.b && _v1.b.b.b) {
                    if (_v1.b.b.b.b) {
                        var _v2 = _v1.a;
                        var _v3 = _v1.b;
                        var p0 = _v3.a;
                        var _v4 = _v3.b;
                        var p1 = _v4.a;
                        var _v5 = _v4.b;
                        var p2 = _v5.a;
                        var rest = _v5.b;
                        var t1 = $terezka$elm_charts$Internal$Interpolation$slope3_fn(p0, p1, p2);
                        var t0 = $terezka$elm_charts$Internal$Interpolation$slope2_fn(p0, p1, t1);
                        return $terezka$elm_charts$Internal$Interpolation$monotonePart_fn(_List_Cons(p1, _List_Cons(p2, rest)), _Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$Previous(t1), _Utils_ap(commands, _List_fromArray([
                            $terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn(p0, p1, t0, t1)
                        ]))));
                    }
                    else {
                        var _v9 = _v1.a;
                        var _v10 = _v1.b;
                        var p0 = _v10.a;
                        var _v11 = _v10.b;
                        var p1 = _v11.a;
                        var t1 = $terezka$elm_charts$Internal$Interpolation$slope3_fn(p0, p1, p1);
                        return _Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$Previous(t1), _Utils_ap(commands, _List_fromArray([
                            $terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn(p0, p1, t1, t1),
                            $terezka$elm_charts$Internal$Commands$Line_fn(p1.pH, p1.pJ)
                        ])));
                    }
                }
                else {
                    break _v1$4;
                }
            }
            else {
                if (_v1.b.b && _v1.b.b.b) {
                    if (_v1.b.b.b.b) {
                        var t0 = _v1.a.a;
                        var _v6 = _v1.b;
                        var p0 = _v6.a;
                        var _v7 = _v6.b;
                        var p1 = _v7.a;
                        var _v8 = _v7.b;
                        var p2 = _v8.a;
                        var rest = _v8.b;
                        var t1 = $terezka$elm_charts$Internal$Interpolation$slope3_fn(p0, p1, p2);
                        return $terezka$elm_charts$Internal$Interpolation$monotonePart_fn(_List_Cons(p1, _List_Cons(p2, rest)), _Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$Previous(t1), _Utils_ap(commands, _List_fromArray([
                            $terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn(p0, p1, t0, t1)
                        ]))));
                    }
                    else {
                        var t0 = _v1.a.a;
                        var _v12 = _v1.b;
                        var p0 = _v12.a;
                        var _v13 = _v12.b;
                        var p1 = _v13.a;
                        var t1 = $terezka$elm_charts$Internal$Interpolation$slope3_fn(p0, p1, p1);
                        return _Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$Previous(t1), _Utils_ap(commands, _List_fromArray([
                            $terezka$elm_charts$Internal$Interpolation$monotoneCurve_fn(p0, p1, t0, t1),
                            $terezka$elm_charts$Internal$Commands$Line_fn(p1.pH, p1.pJ)
                        ])));
                    }
                }
                else {
                    break _v1$4;
                }
            }
        }
        return _Utils_Tuple2(tangent, commands);
    }, $terezka$elm_charts$Internal$Interpolation$monotonePart = F2($terezka$elm_charts$Internal$Interpolation$monotonePart_fn);
    var $terezka$elm_charts$Internal$Interpolation$monotoneSection_fn = function (points, _v0) {
        var tangent = _v0.a;
        var acc = _v0.b;
        var _v1 = function () {
            if (points.b) {
                var p0 = points.a;
                var rest = points.b;
                return $terezka$elm_charts$Internal$Interpolation$monotonePart_fn(_List_Cons(p0, rest), _Utils_Tuple2(tangent, _List_fromArray([
                    $terezka$elm_charts$Internal$Commands$Line_fn(p0.pH, p0.pJ)
                ])));
            }
            else {
                return _Utils_Tuple2(tangent, _List_Nil);
            }
        }();
        var t0 = _v1.a;
        var commands = _v1.b;
        return _Utils_Tuple2(t0, _List_Cons(commands, acc));
    }, $terezka$elm_charts$Internal$Interpolation$monotoneSection = F2($terezka$elm_charts$Internal$Interpolation$monotoneSection_fn);
    var $terezka$elm_charts$Internal$Interpolation$monotone = function (sections) {
        return $elm$core$List$foldr_fn($terezka$elm_charts$Internal$Interpolation$monotoneSection, _Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$First, _List_Nil), sections).b;
    };
    var $terezka$elm_charts$Internal$Interpolation$Point_fn = function (x, y) {
        return { pH: x, pJ: y };
    }, $terezka$elm_charts$Internal$Interpolation$Point = F2($terezka$elm_charts$Internal$Interpolation$Point_fn);
    var $terezka$elm_charts$Internal$Interpolation$after_fn = function (a, b) {
        return _List_fromArray([
            a,
            $terezka$elm_charts$Internal$Interpolation$Point_fn(b.pH, a.pJ),
            b
        ]);
    }, $terezka$elm_charts$Internal$Interpolation$after = F2($terezka$elm_charts$Internal$Interpolation$after_fn);
    var $terezka$elm_charts$Internal$Interpolation$stepped = function (sections) {
        var expand = F2(function (result, section) {
            expand: while (true) {
                if (section.b) {
                    if (section.b.b) {
                        var a = section.a;
                        var _v1 = section.b;
                        var b = _v1.a;
                        var rest = _v1.b;
                        var $temp$result = _Utils_ap(result, $terezka$elm_charts$Internal$Interpolation$after_fn(a, b)), $temp$section = _List_Cons(b, rest);
                        result = $temp$result;
                        section = $temp$section;
                        continue expand;
                    }
                    else {
                        var last = section.a;
                        return result;
                    }
                }
                else {
                    return result;
                }
            }
        });
        return $elm$core$List$map_fn(A2($elm$core$Basics$composeR, expand(_List_Nil), $elm$core$List$map(function (_v2) {
            var x = _v2.pH;
            var y = _v2.pJ;
            return $terezka$elm_charts$Internal$Commands$Line_fn(x, y);
        })), sections);
    };
    var $terezka$elm_charts$Internal$Svg$last = function (list) {
        return $elm$core$List$head($elm$core$List$drop_fn($elm$core$List$length(list) - 1, list));
    };
    var $terezka$elm_charts$Internal$Svg$withBorder_fn = function (stuff, func) {
        if (stuff.b) {
            var first = stuff.a;
            var rest = stuff.b;
            return $elm$core$Maybe$Just(A2(func, first, $elm$core$Maybe$withDefault_fn(first, $terezka$elm_charts$Internal$Svg$last(rest))));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $terezka$elm_charts$Internal$Svg$withBorder_fn_unwrapped = function (stuff, func) {
        if (stuff.b) {
            var first = stuff.a;
            var rest = stuff.b;
            return $elm$core$Maybe$Just(func(first, $elm$core$Maybe$withDefault_fn(first, $terezka$elm_charts$Internal$Svg$last(rest))));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $terezka$elm_charts$Internal$Svg$withBorder = F2($terezka$elm_charts$Internal$Svg$withBorder_fn);
    var $terezka$elm_charts$Internal$Svg$toCommands_fn = function (method, toX, toY, data) {
        var toSets = F2(function (ps, cmds) {
            return $terezka$elm_charts$Internal$Svg$withBorder_fn_unwrapped(ps, function (first, last_) {
                return _Utils_Tuple3(first, cmds, last_);
            });
        });
        var fold = F2(function (datum_, acc) {
            var _v1 = toY(datum_);
            if (!_v1.$) {
                var y_ = _v1.a;
                if (acc.b) {
                    var latest = acc.a;
                    var rest = acc.b;
                    return _List_Cons(_Utils_ap(latest, _List_fromArray([
                        {
                            pH: toX(datum_),
                            pJ: y_
                        }
                    ])), rest);
                }
                else {
                    return _List_Cons(_List_fromArray([
                        {
                            pH: toX(datum_),
                            pJ: y_
                        }
                    ]), acc);
                }
            }
            else {
                return _List_Cons(_List_Nil, acc);
            }
        });
        var points = $elm$core$List$reverse($elm$core$List$foldl_fn(fold, _List_Nil, data));
        var commands = function () {
            switch (method) {
                case 0:
                    return $elm$core$List$map_fn($terezka$elm_charts$Internal$Interpolation$linear_a0, points);
                case 1:
                    return $terezka$elm_charts$Internal$Interpolation$monotone(points);
                default:
                    return $terezka$elm_charts$Internal$Interpolation$stepped(points);
            }
        }();
        return $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_map2_fn(toSets, points, commands));
    }, $terezka$elm_charts$Internal$Svg$toCommands = F4($terezka$elm_charts$Internal$Svg$toCommands_fn);
    var $terezka$elm_charts$Internal$Svg$area_fn = function (plane, toX, toY2M, toY, config, data) {
        var _v0 = function () {
            var _v1 = config.gL;
            if (_v1.$ === 1) {
                return _Utils_Tuple2($elm$svg$Svg$text(""), config.bw);
            }
            else {
                var design = _v1.a;
                return $terezka$elm_charts$Internal$Svg$toPattern_fn(config.bw, design);
            }
        }();
        var patternDefs = _v0.a;
        var fill = _v0.b;
        var view = function (cmds) {
            return A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$path, _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__area-section"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, fill),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fillOpacity_a0, $elm$core$String$fromFloat(config.bg)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, "0"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fillRule_a0, "evenodd"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Commands$description_fn(plane, cmds)),
                $terezka$elm_charts$Internal$Svg$withinChartArea(plane)
            ]), _List_Nil);
        };
        var withUnder = F2(function (_v5, _v6) {
            var firstBottom = _v5.a;
            var cmdsBottom = _v5.b;
            var endBottom = _v5.c;
            var firstTop = _v6.a;
            var cmdsTop = _v6.b;
            var endTop = _v6.c;
            return view(_Utils_ap(_List_fromArray([
                $terezka$elm_charts$Internal$Commands$Move_fn(firstBottom.pH, firstBottom.pJ),
                $terezka$elm_charts$Internal$Commands$Line_fn(firstTop.pH, firstTop.pJ)
            ]), _Utils_ap(cmdsTop, _Utils_ap(_List_fromArray([
                $terezka$elm_charts$Internal$Commands$Move_fn(firstBottom.pH, firstBottom.pJ)
            ]), _Utils_ap(cmdsBottom, _List_fromArray([
                $terezka$elm_charts$Internal$Commands$Line_fn(endTop.pH, endTop.pJ)
            ]))))));
        });
        var withoutUnder = function (_v4) {
            var first = _v4.a;
            var cmds = _v4.b;
            var end = _v4.c;
            return view(_Utils_ap(_List_fromArray([
                $terezka$elm_charts$Internal$Commands$Move_fn(first.pH, 0),
                $terezka$elm_charts$Internal$Commands$Line_fn(first.pH, first.pJ)
            ]), _Utils_ap(cmds, _List_fromArray([
                $terezka$elm_charts$Internal$Commands$Line_fn(end.pH, 0)
            ]))));
        };
        if (config.bg <= 0) {
            return $elm$svg$Svg$text("");
        }
        else {
            var _v2 = config.f;
            if (_v2.$ === 1) {
                return $elm$svg$Svg$text("");
            }
            else {
                var method = _v2.a;
                return $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__area-sections")
                ]), function () {
                    if (toY2M.$ === 1) {
                        return _List_Cons(patternDefs, $elm$core$List$map_fn(withoutUnder, $terezka$elm_charts$Internal$Svg$toCommands_fn(method, toX, toY, data)));
                    }
                    else {
                        var toY2 = toY2M.a;
                        return _List_Cons(patternDefs, _List_map2_fn(withUnder, $terezka$elm_charts$Internal$Svg$toCommands_fn(method, toX, toY2, data), $terezka$elm_charts$Internal$Svg$toCommands_fn(method, toX, toY, data)));
                    }
                }());
            }
        }
    }, $terezka$elm_charts$Internal$Svg$area = F6($terezka$elm_charts$Internal$Svg$area_fn);
    var $terezka$elm_charts$Internal$Svg$interpolation_fn = function (plane, toX, toY, config, data) {
        var view = function (_v1) {
            var first = _v1.a;
            var cmds = _v1.b;
            return A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$path, _List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__interpolation-section"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "transparent"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, config.bw),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeDasharray_a0, $elm$core$String$join_fn(" ", $elm$core$List$map_fn($elm$core$String$fromFloat, config.e9))),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.ir)),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, $terezka$elm_charts$Internal$Commands$description_fn(plane, _List_Cons($terezka$elm_charts$Internal$Commands$Move_fn(first.pH, first.pJ), cmds))),
                $terezka$elm_charts$Internal$Svg$withinChartArea(plane)
            ]), _List_Nil);
        };
        var _v0 = config.f;
        if (_v0.$ === 1) {
            return $elm$svg$Svg$text("");
        }
        else {
            var method = _v0.a;
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__interpolation-sections")
            ]), $elm$core$List$map_fn(view, $terezka$elm_charts$Internal$Svg$toCommands_fn(method, toX, toY, data)));
        }
    }, $terezka$elm_charts$Internal$Svg$interpolation = F5($terezka$elm_charts$Internal$Svg$interpolation_fn);
    var $terezka$elm_charts$Internal$Svg$toRadius_fn = function (size_, shape) {
        var area_ = (2 * $elm$core$Basics$pi) * size_;
        switch (shape) {
            case 0:
                return $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
            case 1:
                var side = $elm$core$Basics$sqrt((area_ * 4) / $elm$core$Basics$sqrt(3));
                return $elm$core$Basics$sqrt(3) * side;
            case 2:
                return $elm$core$Basics$sqrt(area_) / 2;
            case 3:
                return $elm$core$Basics$sqrt(area_) / 2;
            case 4:
                return $elm$core$Basics$sqrt(area_ / 4);
            default:
                return $elm$core$Basics$sqrt(area_ / 4);
        }
    }, $terezka$elm_charts$Internal$Svg$toRadius = F2($terezka$elm_charts$Internal$Svg$toRadius_fn);
    var $terezka$elm_charts$Internal$Produce$toDotSeries_fn = function (elIndex, toX, properties, data) {
        var toInterConfig = function (attrs) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
        };
        var toDotConfig = function (attrs) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(attrs, $terezka$elm_charts$Internal$Svg$defaultDot);
        };
        var toDotItem = F7(function (lineIndex, stackIndex, colorIndex, prop, interConfig, dataIndex, datum_) {
            var y_ = $elm$core$Maybe$withDefault_fn(0, prop.eV(datum_));
            var x_ = toX(datum_);
            var defaultAttrs = _List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color(interConfig.bw),
                $terezka$elm_charts$Chart$Attributes$border(interConfig.bw),
                _Utils_eq(interConfig.f, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $elm$core$Basics$identity
            ]);
            var dotAttrs = _Utils_ap(defaultAttrs, _Utils_ap(prop.E, A5(prop.ms, lineIndex, stackIndex, dataIndex, prop.j1, datum_)));
            var config = toDotConfig(dotAttrs);
            return {
                aQ: {
                    oj: config,
                    pi: $terezka$elm_charts$Internal$Item$Dot,
                    gg: {
                        au: config.au,
                        aB: config.aB,
                        bw: function () {
                            var _v6 = config.bw;
                            if (_v6 === "white") {
                                return interConfig.bw;
                            }
                            else {
                                return config.bw;
                            }
                        }(),
                        i_: dataIndex,
                        mi: elIndex,
                        jp: prop.d7(datum_),
                        i: colorIndex,
                        M: prop.j1,
                        ok: lineIndex,
                        oU: stackIndex
                    },
                    pC: {
                        l2: datum_,
                        mS: function () {
                            var _v7 = prop.pB(datum_);
                            if (!_v7.$) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }(),
                        dv: x_,
                        eW: x_,
                        pJ: y_
                    }
                },
                pj: function (c) {
                    return _List_fromArray([
                        $terezka$elm_charts$Internal$Produce$tooltipRow_fn(c.gg.bw, $terezka$elm_charts$Internal$Produce$toDefaultName_fn(colorIndex, c.gg.M), prop.d7(datum_))
                    ]);
                },
                pk: function (_v8) {
                    return { dv: x_, eW: x_, pK: y_, iu: y_ };
                },
                pn: F2(function (plane, _v9) {
                    var radius = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($terezka$elm_charts$Internal$Svg$toRadius(config.oS), config.dk));
                    var radiusX_ = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX_fn(plane, radius);
                    var radiusY_ = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY_fn(plane, radius);
                    return { dv: x_ - radiusX_, eW: x_ + radiusX_, pK: y_ - radiusY_, iu: y_ + radiusY_ };
                }),
                po: F3(function (plane, _v10, _v11) {
                    var _v12 = prop.pB(datum_);
                    if (_v12.$ === 1) {
                        return $elm$svg$Svg$text("");
                    }
                    else {
                        return $terezka$elm_charts$Internal$Svg$dot_fn(plane, function ($) {
                            return $.pH;
                        }, function ($) {
                            return $.pJ;
                        }, config, { pH: x_, pJ: y_ });
                    }
                })
            };
        });
        var toSeriesItem = F5(function (lineIndex, stacks, stackIndex, prop, colorIndex) {
            var defaultOpacity = ($elm$core$List$length(stacks) > 1) ? 0.4 : 0;
            var interAttr = _Utils_ap(_List_fromArray([
                $terezka$elm_charts$Chart$Attributes$color($terezka$elm_charts$Internal$Helpers$toDefault_fn($terezka$elm_charts$Internal$Helpers$toDefaultColor_a0, $terezka$elm_charts$Internal$Helpers$toDefaultColor_a1, colorIndex)),
                $terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
            ]), prop.mQ);
            var interConfig = toInterConfig(interAttr);
            var dotItems = $elm$core$List$indexedMap_fn(A5(toDotItem, lineIndex, stackIndex, colorIndex, prop, interConfig), data);
            if (!dotItems.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var first = dotItems.a;
                var rest = dotItems.b;
                return $elm$core$Maybe$Just({
                    aQ: {
                        aZ: _Utils_Tuple2(first, rest)
                    },
                    pj: function (c) {
                        return _List_fromArray([
                            $elm$html$Html$table_fn(_List_fromArray([
                                _VirtualDom_style_fn("margin", "0")
                            ]), $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Item$toHtml, function (_v1) {
                                var x = _v1.a;
                                var xs = _v1.b;
                                return _List_Cons(x, xs);
                            }(c.aZ)))
                        ]);
                    },
                    pk: function (c) {
                        return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getLimits, function (_v2) {
                            var x = _v2.a;
                            var xs = _v2.b;
                            return _List_Cons(x, xs);
                        }(c.aZ));
                    },
                    pn: F2(function (plane, c) {
                        return $terezka$elm_charts$Internal$Coordinates$foldPosition_fn($terezka$elm_charts$Internal$Item$getPosition(plane), function (_v3) {
                            var x = _v3.a;
                            var xs = _v3.b;
                            return _List_Cons(x, xs);
                        }(c.aZ));
                    }),
                    po: F3(function (plane, _v4, _v5) {
                        var toBottom = function (datum_) {
                            return $elm$core$Maybe$map2_fn_unwrapped(function (real, visual) {
                                return visual - real;
                            }, prop.pB(datum_), prop.eV(datum_));
                        };
                        return $elm$svg$Svg$g_fn(_List_fromArray([
                            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__series")
                        ]), _List_fromArray([
                            $terezka$elm_charts$Internal$Svg$area_fn(plane, toX, $elm$core$Maybe$Just(toBottom), prop.eV, interConfig, data),
                            $terezka$elm_charts$Internal$Svg$interpolation_fn(plane, toX, prop.eV, interConfig, data),
                            $elm$svg$Svg$g_fn(_List_fromArray([
                                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__dots")
                            ]), $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$toSvg(plane), dotItems))
                        ]));
                    })
                });
            }
        });
        return $elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$List$indexedMap_fn_unwrapped(function (propIndex, f) {
            return f(elIndex + propIndex);
        }, $elm$core$List$concat($elm$core$List$indexedMap_fn_unwrapped(function (lineIndex, stacks) {
            return $elm$core$List$indexedMap_fn(A2(toSeriesItem, lineIndex, stacks), stacks);
        }, $elm$core$List$map_fn($terezka$elm_charts$Internal$Property$toConfigs, properties)))));
    }, $terezka$elm_charts$Internal$Produce$toDotSeries = F4($terezka$elm_charts$Internal$Produce$toDotSeries_fn);
    var $terezka$elm_charts$Chart$seriesMap_fn = function (mapData, toX, properties, data) {
        return $terezka$elm_charts$Chart$Indexed(function (index) {
            var legends_ = $terezka$elm_charts$Internal$Legend$toDotLegends_fn(index, properties);
            var items = $terezka$elm_charts$Internal$Produce$toDotSeries_fn(index, toX, properties, data);
            var toLimits = $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$getLimits, items);
            var generalized = $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$map(mapData), $elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Many$getGenerals, items));
            return _Utils_Tuple2($terezka$elm_charts$Chart$SeriesElement_fn(toLimits, generalized, legends_, function (p) {
                return _VirtualDom_map_fn($elm$core$Basics$never, $elm$svg$Svg$g_fn(_List_fromArray([
                    _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__dot-series")
                ]), $elm$core$List$map_fn($terezka$elm_charts$Internal$Item$toSvg(p), items)));
            }), index + $elm$core$List$length($elm$core$List$concatMap_fn($terezka$elm_charts$Internal$Property$toConfigs, properties)));
        });
    }, $terezka$elm_charts$Chart$seriesMap = F4($terezka$elm_charts$Chart$seriesMap_fn);
    var $terezka$elm_charts$Chart$series_fn = function (toX, properties, data) {
        return $terezka$elm_charts$Chart$seriesMap_fn($elm$core$Basics$identity, toX, properties, data);
    }, $terezka$elm_charts$Chart$series = F3($terezka$elm_charts$Chart$series_fn);
    var $author$project$Pages$Dashboards$getLineSeries_fn = function (chart, chartData) {
        return A2($terezka$elm_charts$Chart$series, A2($elm$core$Basics$composeR, $elm$core$List$head, $elm$core$Maybe$withDefault(0)), $elm$core$List$map_fn(function (colIdx) {
            return A3($elm$core$Basics$apR, $elm$core$Maybe$withDefault_fn("", $elm_community$list_extra$List$Extra$getAt_fn(colIdx, $author$project$Types$ChartType$toHeaders(chart.bu))), $terezka$elm_charts$Chart$named, A3($terezka$elm_charts$Chart$interpolated, A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$getAt(colIdx), $elm$core$Maybe$withDefault(0)), _List_Nil, _List_Nil));
        }, $author$project$Pages$Dashboards$remainingColumnsIdxs(chartData)));
    }, $author$project$Pages$Dashboards$getLineSeries = F2($author$project$Pages$Dashboards$getLineSeries_fn);
    var $terezka$elm_charts$Internal$Svg$distanceY_fn = function (plane, searched, point) {
        return $elm$core$Basics$abs($terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, point.pJ) - $terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, searched.pJ));
    }, $terezka$elm_charts$Internal$Svg$distanceY = F3($terezka$elm_charts$Internal$Svg$distanceY_fn);
    var $terezka$elm_charts$Internal$Svg$distanceSquared_fn = function (plane, searched, point) {
        return _Basics_pow_fn($terezka$elm_charts$Internal$Svg$distanceX_fn(plane, searched, point), 2) + _Basics_pow_fn($terezka$elm_charts$Internal$Svg$distanceY_fn(plane, searched, point), 2);
    }, $terezka$elm_charts$Internal$Svg$distanceSquared = F3($terezka$elm_charts$Internal$Svg$distanceSquared_fn);
    var $terezka$elm_charts$Internal$Svg$getNearestHelp_fn = function (toPosition, items, plane, searched) {
        var toPoint = function (i) {
            return $terezka$elm_charts$Internal$Svg$closestPoint_fn(toPosition(i), searched);
        };
        var distanceSquared_ = A2($terezka$elm_charts$Internal$Svg$distanceSquared, plane, searched);
        var getClosest = F2(function (item, allClosest) {
            var _v0 = $elm$core$List$head(allClosest);
            if (!_v0.$) {
                var closest = _v0.a;
                return _Utils_eq(toPoint(closest), toPoint(item)) ? _List_Cons(item, allClosest) : ((_Utils_cmp(distanceSquared_(toPoint(closest)), distanceSquared_(toPoint(item))) > 0) ? _List_fromArray([item]) : allClosest);
            }
            else {
                return _List_fromArray([item]);
            }
        });
        return A2($terezka$elm_charts$Internal$Svg$keepOne, toPosition, $elm$core$List$foldl_fn(getClosest, _List_Nil, items));
    }, $terezka$elm_charts$Internal$Svg$getNearestHelp = F4($terezka$elm_charts$Internal$Svg$getNearestHelp_fn);
    var $terezka$elm_charts$Internal$Svg$getNearest_fn = function (toPosition, items, plane, searched) {
        return $terezka$elm_charts$Internal$Svg$getNearestHelp_fn(toPosition, items, plane, searched);
    }, $terezka$elm_charts$Internal$Svg$getNearest = F4($terezka$elm_charts$Internal$Svg$getNearest_fn);
    var $terezka$elm_charts$Internal$Events$getNearest = function (grouping) {
        var toPos = grouping.a;
        return F2(function (items, plane) {
            var groups = $terezka$elm_charts$Internal$Many$apply_fn(grouping, items);
            return A3($terezka$elm_charts$Internal$Svg$getNearest, toPos(plane), groups, plane);
        });
    };
    var $terezka$elm_charts$Chart$Events$getNearest = $terezka$elm_charts$Internal$Events$getNearest;
    var $terezka$elm_charts$Chart$Attributes$highest_fn = function (v, edit, b) {
        return _Utils_update(b, {
            ne: A3(edit, v, b.ne, b.lZ)
        });
    }, $terezka$elm_charts$Chart$Attributes$highest_fn_unwrapped = function (v, edit, b) {
        return _Utils_update(b, {
            ne: edit(v, b.ne, b.lZ)
        });
    }, $terezka$elm_charts$Chart$Attributes$highest = F3($terezka$elm_charts$Chart$Attributes$highest_fn);
    var $terezka$elm_charts$Chart$Attributes$range_fn = function (v, config) {
        return _Utils_update(config, { hR: v });
    }, $terezka$elm_charts$Chart$Attributes$range = F2($terezka$elm_charts$Chart$Attributes$range_fn);
    var $terezka$elm_charts$Chart$xLabels = function (edits) {
        var toTicks = F2(function (p, config) {
            return $terezka$elm_charts$Chart$generateValues_fn(config.a5, config.bb, config.d7, $elm$core$List$foldl_fn_unwrapped(function (f, x) {
                return f(x);
            }, p.pH, config.as));
        });
        var toTickValues = F3(function (p, config, ts) {
            return (!config.L) ? ts : _Utils_update(ts, {
                aO: _Utils_ap(ts.aO, $elm$core$List$map_fn(function ($) {
                    return $.pB;
                }, A2(toTicks, p, config)))
            });
        });
        var toConfig = function (p) {
            return $terezka$elm_charts$Internal$Helpers$apply_fn(edits, { a5: 5, R: $elm$core$Maybe$Nothing, E: _List_Nil, bw: "#808BAB", U: $elm$core$Maybe$Nothing, J: false, aG: $elm$core$Maybe$Nothing, d7: $elm$core$Maybe$Nothing, bb: $terezka$elm_charts$Internal$Svg$Floats, L: false, V: false, as: _List_Nil, X: $terezka$elm_charts$Chart$Attributes$zero, Y: 0, _: false, N: 0, O: 18 });
        };
        return $terezka$elm_charts$Chart$LabelsElement_fn(toConfig, toTickValues, F2(function (p, config) {
            var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
            var toLabel = function (item) {
                return $terezka$elm_charts$Internal$Svg$label_fn(p, _Utils_update(_default, {
                    R: config.R,
                    E: config.E,
                    bw: config.bw,
                    U: config.U,
                    aG: config.aG,
                    V: config.V,
                    Y: config.Y,
                    _: config._,
                    N: config.N,
                    O: config.J ? ((-config.O) + 10) : config.O
                }), _List_fromArray([
                    $elm$svg$Svg$text(item.fx)
                ]), {
                    pH: item.pB,
                    pJ: config.X(p.pJ)
                });
            };
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__x-labels")
            ]), $elm$core$List$map_fn(toLabel, A2(toTicks, p, config)));
        }));
    };
    var $terezka$elm_charts$Chart$TicksElement_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $terezka$elm_charts$Chart$TicksElement = F2($terezka$elm_charts$Chart$TicksElement_fn);
    var $terezka$elm_charts$Chart$Attributes$length_fn = function (v, config) {
        return _Utils_update(config, { hl: v });
    }, $terezka$elm_charts$Chart$Attributes$length = F2($terezka$elm_charts$Chart$Attributes$length_fn);
    var $terezka$elm_charts$Internal$Svg$defaultTick = { E: _List_Nil, bw: "rgb(210, 210, 210)", hl: 5, ir: 1 };
    var $terezka$elm_charts$Internal$Svg$tick_fn = function (plane, config, isX, point) {
        return A4($terezka$elm_charts$Internal$Svg$withAttrs, config.E, $elm$svg$Svg$line, _List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__tick"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$stroke_a0, config.bw),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$strokeWidth_a0, $elm$core$String$fromFloat(config.ir)),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x1_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, point.pH))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$x2_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGX_fn(plane, point.pH) + (isX ? 0 : (-config.hl)))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y1_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, point.pJ))),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$y2_a0, $elm$core$String$fromFloat($terezka$elm_charts$Internal$Coordinates$toSVGY_fn(plane, point.pJ) + (isX ? config.hl : 0)))
        ]), _List_Nil);
    }, $terezka$elm_charts$Internal$Svg$tick = F4($terezka$elm_charts$Internal$Svg$tick_fn);
    var $terezka$elm_charts$Internal$Svg$xTick_fn = function (plane, config, point) {
        return $terezka$elm_charts$Internal$Svg$tick_fn(plane, config, true, point);
    }, $terezka$elm_charts$Internal$Svg$xTick = F3($terezka$elm_charts$Internal$Svg$xTick_fn);
    var $terezka$elm_charts$Chart$Svg$xTick_fn = function (plane, edits) {
        return A2($terezka$elm_charts$Internal$Svg$xTick, plane, $terezka$elm_charts$Internal$Helpers$apply_fn(edits, $terezka$elm_charts$Internal$Svg$defaultTick));
    }, $terezka$elm_charts$Chart$Svg$xTick = F2($terezka$elm_charts$Chart$Svg$xTick_fn);
    var $terezka$elm_charts$Chart$xTicks = function (edits) {
        var config = $terezka$elm_charts$Internal$Helpers$apply_fn(edits, { a5: 5, bw: "", J: false, bb: $terezka$elm_charts$Internal$Svg$Floats, L: true, g$: 5, as: _List_Nil, X: $terezka$elm_charts$Chart$Attributes$zero, ir: 1 });
        var toTicks = function (p) {
            return $elm$core$List$map_fn(function ($) {
                return $.pB;
            }, $terezka$elm_charts$Chart$generateValues_fn(config.a5, config.bb, $elm$core$Maybe$Nothing, $elm$core$List$foldl_fn_unwrapped(function (f, x) {
                return f(x);
            }, p.pH, config.as)));
        };
        var addTickValues = F2(function (p, ts) {
            return (!config.L) ? ts : _Utils_update(ts, {
                aO: _Utils_ap(ts.aO, toTicks(p))
            });
        });
        return $terezka$elm_charts$Chart$TicksElement_fn(addTickValues, function (p) {
            var toTick = function (x) {
                return A3($terezka$elm_charts$Chart$Svg$xTick, p, _List_fromArray([
                    $terezka$elm_charts$Chart$Attributes$color(config.bw),
                    $terezka$elm_charts$Chart$Attributes$length(config.J ? (-config.g$) : config.g$),
                    $terezka$elm_charts$Chart$Attributes$width(config.ir)
                ]), {
                    pH: x,
                    pJ: config.X(p.pJ)
                });
            };
            return $elm$svg$Svg$g_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$class_a0, "elm-charts__x-ticks")
            ]), $elm$core$List$map_fn(toTick, toTicks(p)));
        });
    };
    var $author$project$Pages$Dashboards$viewXYPlotLineChart_fn = function (toMsg, model, chart, chartData, rows, maybeCustomXLabels) {
        var _v0 = function () {
            if (!maybeCustomXLabels.$) {
                var customXLabels = maybeCustomXLabels.a;
                return _Utils_Tuple2(_List_fromArray([
                    A2($author$project$Pages$Dashboards$xLabelsRotated, chart.ef, customXLabels),
                    $terezka$elm_charts$Chart$xTicks(_List_fromArray([$terezka$elm_charts$Chart$Attributes$withGrid]))
                ]), _List_fromArray([
                    A2($terezka$elm_charts$Chart$Attributes$lowest, 0.5, $terezka$elm_charts$Chart$Attributes$exactly),
                    A2($terezka$elm_charts$Chart$Attributes$highest, $elm$core$List$length(rows) + 0.5, $terezka$elm_charts$Chart$Attributes$exactly)
                ]));
            }
            else {
                return _Utils_Tuple2(_List_fromArray([
                    $terezka$elm_charts$Chart$xLabels(_List_fromArray([$terezka$elm_charts$Chart$Attributes$withGrid]))
                ]), _List_Nil);
            }
        }();
        var conditionalElements = _v0.a;
        var range = _v0.b;
        return $rtfeldman$elm_css$Html$Styled$fromUnstyled($terezka$elm_charts$Chart$chart_fn(_List_fromArray([
            $terezka$elm_charts$Chart$Attributes$width(600),
            $terezka$elm_charts$Chart$Attributes$height(260),
            $terezka$elm_charts$Chart$Events$onMouseMove_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$LineChartHovered(chart.bR)), $terezka$elm_charts$Chart$Events$getNearest($terezka$elm_charts$Chart$Item$any)),
            $terezka$elm_charts$Chart$Events$onMouseLeave(toMsg($author$project$Pages$Dashboards$LineChartHovered_fn(chart.bR, _List_Nil))),
            $terezka$elm_charts$Chart$Attributes$range(range)
        ]), _List_fromArray([
            $terezka$elm_charts$Chart$list(conditionalElements),
            $terezka$elm_charts$Chart$yLabels(_List_fromArray([$terezka$elm_charts$Chart$Attributes$withGrid])),
            A3($author$project$Pages$Dashboards$getLineSeries, chart, chartData, rows),
            $terezka$elm_charts$Chart$each_fn($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn(chart.bR, model.eg)), F2(function (_v2, item) {
                return _List_fromArray([
                    $terezka$elm_charts$Chart$tooltip_fn(item, _List_Nil, _List_Nil, _List_Nil)
                ]);
            }))
        ])));
    }, $author$project$Pages$Dashboards$viewXYPlotLineChart = F6($author$project$Pages$Dashboards$viewXYPlotLineChart_fn);
    var $author$project$Pages$Dashboards$viewCustomLinechart_fn = function (toMsg, model, chart, chartData) {
        var rows = $elm$core$List$indexedMap_fn(function (i) {
            return $elm$core$List$append(_List_fromArray([i + 1]));
        }, $elm$core$List$filterMap_fn($author$project$Pages$Dashboards$expectAllFloats_a0, $elm$core$List$map_fn($author$project$Pages$Dashboards$tail_a0, chartData)));
        var customXLabels = $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$getXHeader, $elm$core$Maybe$withDefault("unknown")), $elm$core$List$filter_fn($elm$core$List$all(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Cell$isNull)), chartData));
        return $author$project$Pages$Dashboards$viewXYPlotLineChart_fn(toMsg, model, chart, chartData, rows, $elm$core$Maybe$Just(customXLabels));
    }, $author$project$Pages$Dashboards$viewCustomLinechart = F4($author$project$Pages$Dashboards$viewCustomLinechart_fn);
    var $author$project$Pages$Dashboards$viewLineChart_fn = function (toMsg, model, chart, chartData) {
        var rowsForXYPlotting = $elm$core$List$filterMap_fn($author$project$Pages$Dashboards$expectAllFloats_a0, chartData);
        return (!$elm$core$List$isEmpty(rowsForXYPlotting)) ? $author$project$Pages$Dashboards$viewXYPlotLineChart_fn(toMsg, model, chart, chartData, rowsForXYPlotting, $elm$core$Maybe$Nothing) : $author$project$Pages$Dashboards$viewCustomLinechart_fn(toMsg, model, chart, chartData);
    }, $author$project$Pages$Dashboards$viewLineChart = F4($author$project$Pages$Dashboards$viewLineChart_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_6 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "-1.5rem");
    var $author$project$Pages$Dashboards$viewSingleton = function (data) {
        return function (t) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_5xl
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(t)
            ]));
        }($elm$core$Maybe$withDefault_fn("No data found", $elm$core$Maybe$andThen_fn($author$project$Types$Cell$toMaybeString, $elm$core$Maybe$andThen_fn($elm$core$List$head, $elm$core$List$head(data)))));
    };
    var $author$project$Pages$Dashboards$getChartTypeView_fn = function (ct, toMsg) {
        switch (ct.$) {
            case 0:
                return $author$project$Pages$Dashboards$viewBarChart(toMsg);
            case 1:
                return $author$project$Pages$Dashboards$viewLineChart(toMsg);
            default:
                return $elm$core$Basics$always($elm$core$Basics$always($author$project$Pages$Dashboards$viewSingleton));
        }
    }, $author$project$Pages$Dashboards$getChartTypeView = F2($author$project$Pages$Dashboards$getChartTypeView_fn);
    var $author$project$Pages$Dashboards$viewChart_fn = function (c, ct, ts, toMsg, model) {
        return $elm$core$Basics$composeR_fn($author$project$Pages$Dashboards$chartContainer_a0, $author$project$Pages$Dashboards$chartContainer_a1, A5($author$project$Pages$Dashboards$getChartTypeView, ct, toMsg, model, c, $author$project$Pages$Dashboards$getChartData_fn(ts, c)));
    }, $author$project$Pages$Dashboards$viewChart = F5($author$project$Pages$Dashboards$viewChart_fn);
    var $author$project$Pages$Dashboards$viewCharts_fn = function (_v0, toCharts, model) {
        var tables = _v0.eH;
        var editChart = _v0.fg;
        var toMsg = _v0.gd;
        return $elm$core$List$map_fn(function (_v1) {
            var cid = _v1.a;
            var c = _v1.b;
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_1]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h3_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_center]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(c.eM)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_center]))
                    ]), _List_fromArray([
                        $author$project$Pages$Dashboards$editBtn_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1_dot_5]), editChart(cid))
                    ]))
                ])),
                $author$project$Pages$Dashboards$viewChart_fn(c, c.bu, tables, toMsg, model)
            ]));
        }, $elm$core$Dict$toList(toCharts(model)));
    }, $author$project$Pages$Dashboards$viewCharts = F3($author$project$Pages$Dashboards$viewCharts_fn);
    var $author$project$Pages$Dashboards$viewDashboard_fn = function (_v0, model, tables, dashboard) {
        var editDashboard = _v0.i9;
        var editChart = _v0.fg;
        var newChart = _v0.j5;
        var toMsg = _v0.gd;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(dashboard.eM),
                $author$project$Pages$Dashboards$editBtn_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2]), editDashboard)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_10, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
            ]), $author$project$Pages$Dashboards$viewCharts_fn({ fg: editChart, eH: tables, gd: toMsg }, A2($elm$core$Basics$composeL, $author$project$Types$Dashboard$getChartsOfDashboard(dashboard), $author$project$Pages$Dashboards$getCharts), model)),
            $author$project$Pages$Dashboards$btn_fn(_List_Nil, newChart, "Add chart")
        ]));
    }, $author$project$Pages$Dashboards$viewDashboard = F4($author$project$Pages$Dashboards$viewDashboard_fn);
    var $author$project$Pages$Dashboards$cancelSaveDeleteButtons = function (opts) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
            ]), _List_fromArray([
                $author$project$Components$textButton_fn(_List_Nil, "Cancel", opts.bJ),
                $author$project$Pages$Dashboards$btn_fn(_List_Nil, opts.hU, "Save")
            ])),
            $author$project$Components$hairLine(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_2
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (msg) {
                    return $author$project$Pages$Dashboards$btn_fn(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_100)
                    ]), msg, "Delete");
                }, opts.gJ)
            ]))
        ]));
    };
    var $author$project$Pages$Dashboards$rowEl = function (attrs) {
        return $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_items_start,
                $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$start)
            ]), attrs))
        ]));
    };
    var $author$project$Types$Validated$mapValue_fn = function (mapper, v) {
        return _Utils_update(v, {
            pB: mapper(v.pB)
        });
    }, $author$project$Types$Validated$mapValue = F2($author$project$Types$Validated$mapValue_fn);
    var $author$project$Pages$Dashboards$Forms$addChartFormHeader = function (form) {
        return _Utils_update(form, {
            d9: $author$project$Types$Validated$mapValue_fn(A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([""])), form.d9)
        });
    };
    var $rtfeldman$elm_css$Css$borderWidth_a0 = "border-width", $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$borderWidth_a0);
    var $rtfeldman$elm_css$Css$cursor_a0 = "cursor", $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$cursor_a0);
    var $rtfeldman$elm_css$Css$pointer = { k: 0, pB: "pointer" };
    var $author$project$Pages$Dashboards$btnDelete = function (onClick_) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6,
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$cursor_a0, $rtfeldman$elm_css$Css$pointer)
            ])),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(onClick_)
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("\u00D7")
        ]));
    };
    var $author$project$Types$ChartType$chartTypes = _List_fromArray([
        _Utils_Tuple2($author$project$Types$ChartType$BarChart_fn("", $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement("")), "Bar chart"),
        _Utils_Tuple2($author$project$Types$ChartType$LineChart_fn("", $basti1302$elm_non_empty_array$Array$NonEmpty$fromElement("")), "Line chart"),
        _Utils_Tuple2($author$project$Types$ChartType$Singleton(""), "Single value")
    ]);
    var $author$project$Pages$Dashboards$el_fn = function (attrs, elem) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(attrs)
        ]), _List_fromArray([elem]));
    }, $author$project$Pages$Dashboards$el = F2($author$project$Pages$Dashboards$el_fn);
    var $rtfeldman$elm_css$Css$smaller = { aG: 0, pB: "smaller" };
    var $rtfeldman$elm_css$Css$sub_a0 = "sub", $rtfeldman$elm_css$Css$sub = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$sub_a0);
    var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
        return $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn("verticalAlign", "vertical-align", fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
    };
    var $author$project$Pages$Dashboards$dataHeaderLabel_fn = function (idx, headersLength) {
        return $author$project$Pages$Dashboards$el_fn(_List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 20)),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center
        ]), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text((!idx) ? "x" : "y"),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$sub),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$smaller)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text((!idx) ? "" : ((headersLength <= 2) ? "" : $elm$core$String$fromInt(idx)))
            ]))
        ])));
    }, $author$project$Pages$Dashboards$dataHeaderLabel = F2($author$project$Pages$Dashboards$dataHeaderLabel_fn);
    var $author$project$Types$ChartType$equals_fn = function (chartType1, chartType2) {
        var _v0 = _Utils_Tuple2(chartType1, chartType2);
        _v0$3: while (true) {
            switch (_v0.a.$) {
                case 0:
                    if (!_v0.b.$) {
                        var _v1 = _v0.a;
                        var _v2 = _v0.b;
                        return true;
                    }
                    else {
                        break _v0$3;
                    }
                case 1:
                    if (_v0.b.$ === 1) {
                        var _v3 = _v0.a;
                        var _v4 = _v0.b;
                        return true;
                    }
                    else {
                        break _v0$3;
                    }
                default:
                    if (_v0.b.$ === 2) {
                        return true;
                    }
                    else {
                        break _v0$3;
                    }
            }
        }
        return false;
    }, $author$project$Types$ChartType$equals = F2($author$project$Types$ChartType$equals_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_1 = $rtfeldman$elm_css$Css$property_fn("padding-left", "0.25rem");
    var $rtfeldman$elm_css$Css$small = { aG: 0, pB: "small" };
    var $author$project$Pages$Dashboards$inputLabeled_fn = function (styles, input, elem) {
        return A2($author$project$Pages$Dashboards$section, _Utils_ap(styles, _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
        ])), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$small),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_1
                ]))
            ]), _List_fromArray([input])),
            elem
        ]));
    }, $author$project$Pages$Dashboards$inputLabeled = F3($author$project$Pages$Dashboards$inputLabeled_fn);
    var $author$project$Types$ChartType$isLineChart = function (chartType) {
        if (chartType.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Types$ChartType$isSingleton = function (chartType) {
        if (chartType.$ === 2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_8 = $rtfeldman$elm_css$Css$property_fn("margin-right", "2rem");
    var $rtfeldman$elm_css$Html$Styled$Events$onMouseDown = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mousedown", $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Pages$Dashboards$Forms$removeChartFormHeader_fn = function (idx, form) {
        return _Utils_update(form, {
            d9: $author$project$Types$Validated$mapValue_fn($elm_community$list_extra$List$Extra$removeAt(idx), form.d9)
        });
    }, $author$project$Pages$Dashboards$Forms$removeChartFormHeader = F2($author$project$Pages$Dashboards$Forms$removeChartFormHeader_fn);
    var $author$project$Pages$Dashboards$Forms$setChartFormHeader_fn = function (form, idx, header) {
        return _Utils_update(form, {
            d9: $author$project$Types$Validated$mapValue_fn($elm_community$list_extra$List$Extra$setAt_fn(idx, header), form.d9)
        });
    }, $author$project$Pages$Dashboards$Forms$setChartFormHeader = F3($author$project$Pages$Dashboards$Forms$setChartFormHeader_fn);
    var $author$project$Pages$Dashboards$Forms$setChartFormTable_fn = function (form, table) {
        var valueChanged = !_Utils_eq(table, $author$project$Types$Validated$getValue(form.kZ));
        return _Utils_update(form, {
            d9: valueChanged ? $author$project$Types$Validated$setValue($elm$core$List$map_fn($elm$core$Basics$always(""), $author$project$Types$ChartType$toHeaders($author$project$Types$Validated$getValue(form.bu)))) : form.d9,
            kZ: $author$project$Types$Validated$setValue(table)
        });
    }, $author$project$Pages$Dashboards$Forms$setChartFormTable = F2($author$project$Pages$Dashboards$Forms$setChartFormTable_fn);
    var $author$project$Pages$Dashboards$Forms$setChartFormType_fn = function (chartType, form) {
        return _Utils_update(form, {
            bu: $author$project$Types$Validated$setValue(chartType),
            d9: $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(form.d9, A2($elm$core$Basics$composeR, $author$project$Types$ChartType$toHeaders, $author$project$Types$Validated$setValue), $author$project$Types$ChartType$withHeaders_fn($author$project$Types$Validated$getValue(form.d9), chartType))
        });
    }, $author$project$Pages$Dashboards$Forms$setChartFormType = F2($author$project$Pages$Dashboards$Forms$setChartFormType_fn);
    var $author$project$Pages$Dashboards$inputInt_fn = function (onInput_, value_) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "number"),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
            $rtfeldman$elm_css$Html$Styled$Events$onInput(onInput_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right
            ]))
        ]), _List_Nil);
    }, $author$project$Pages$Dashboards$inputInt = F2($author$project$Pages$Dashboards$inputInt_fn);
    var $author$project$Types$Validated$withValidated_fn = function (attrs, fn, v) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col])), attrs), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex]))
            ]), _List_fromArray([
                fn(v.pB)
            ])),
            $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_Nil), $elm$core$Maybe$map_fn(function (e) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Svg$Styled$text(e)
                ]));
            }, v.fl))
        ]));
    }, $author$project$Types$Validated$withValidated = F3($author$project$Types$Validated$withValidated_fn);
    var $author$project$Pages$Dashboards$validatedIntInput_a0 = $author$project$Types$Validated$withValidated(_List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
    ])), $author$project$Pages$Dashboards$validatedIntInput_a1 = $author$project$Pages$Dashboards$inputInt, $author$project$Pages$Dashboards$validatedIntInput = A2($elm$core$Basics$composeL, $author$project$Pages$Dashboards$validatedIntInput_a0, $author$project$Pages$Dashboards$validatedIntInput_a1);
    var $author$project$Pages$Dashboards$inputString_fn = function (onInput_, value_) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
            $rtfeldman$elm_css$Html$Styled$Events$onInput(onInput_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow
            ]))
        ]), _List_Nil);
    }, $author$project$Pages$Dashboards$inputString = F2($author$project$Pages$Dashboards$inputString_fn);
    var $author$project$Pages$Dashboards$validatedStringInput_a0 = $author$project$Types$Validated$withValidated(_List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
    ])), $author$project$Pages$Dashboards$validatedStringInput_a1 = $author$project$Pages$Dashboards$inputString, $author$project$Pages$Dashboards$validatedStringInput = A2($elm$core$Basics$composeL, $author$project$Pages$Dashboards$validatedStringInput_a0, $author$project$Pages$Dashboards$validatedStringInput_a1);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_7 = $rtfeldman$elm_css$Css$property_fn("width", "1.75rem");
    var $author$project$Types$Validated$withValidation_fn = function (value, element) {
        return $author$project$Types$Validated$withValidated_fn(_List_Nil, $elm$core$Basics$always(element), value);
    }, $author$project$Types$Validated$withValidation = F2($author$project$Types$Validated$withValidation_fn);
    var $author$project$Pages$Dashboards$viewEditChartInputs_fn = function (_v0, cf) {
        var updateChart = _v0.io;
        var tables = _v0.eH;
        return A2($author$project$Pages$Dashboards$columnEl, _List_fromArray([
            $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2
        ]), _List_fromArray([
            $author$project$Pages$Dashboards$inputLabeled_fn(_List_Nil, $rtfeldman$elm_css$Html$Styled$text("Title"), A2($author$project$Pages$Dashboards$validatedStringInput, function (title) {
                return updateChart(_Utils_update(cf, {
                    eM: $author$project$Types$Validated$setValue(title)
                }));
            }, cf.eM)),
            $author$project$Pages$Dashboards$inputLabeled_fn(_List_Nil, $rtfeldman$elm_css$Html$Styled$text("Type"), A2($author$project$Pages$Dashboards$rowEl, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]), $elm$core$List$map_fn(function (_v1) {
                var chartType = _v1.a;
                var name = _v1.b;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Events$onMouseDown(updateChart($author$project$Pages$Dashboards$Forms$setChartFormType_fn(chartType, cf))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$cursor_a0, $rtfeldman$elm_css$Css$pointer),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 2)),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Types$ChartType$equals_fn(chartType, cf.bu.pB) ? _List_fromArray([
                        $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0))
                    ]) : _List_fromArray([
                        $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.9))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(name)
                ]));
            }, $author$project$Types$ChartType$chartTypes))),
            $author$project$Pages$Dashboards$inputLabeled_fn(_List_Nil, $rtfeldman$elm_css$Html$Styled$text("Table"), $author$project$Components$stringSelect({
                cP: _List_Nil,
                bR: $elm$core$Maybe$Nothing,
                cv: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $author$project$Pages$Dashboards$Forms$setChartFormTable(cf), updateChart)),
                cx: $elm$core$List$map_fn(function ($) {
                    return $.M;
                }, tables),
                df: "Select a table",
                ev: cf.kZ.pB,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                ])
            })),
            $author$project$Pages$Dashboards$inputLabeled_fn(_List_Nil, $rtfeldman$elm_css$Html$Styled$text("Data headers"), function () {
                var placeholder = "Select a column";
                var options = $elm$core$List$map_fn(function ($) {
                    return $.jx;
                }, A2($author$project$Types$Table$getColumns, cf.kZ.pB, tables));
                var isSingleton = $author$project$Types$ChartType$isSingleton(cf.bu.pB);
                var isLineChart = function (_v2) {
                    return $author$project$Types$ChartType$isLineChart(cf.bu.pB);
                };
                var headers = $author$project$Types$Validated$getValue(cf.d9);
                var headersLength = $elm$core$List$length(headers);
                var selectColumnHeaderIdx = function (idx) {
                    return A2($author$project$Pages$Dashboards$rowEl, _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $author$project$Util$styleIf_fn(isSingleton && (!(!idx)), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse)
                    ]), _List_fromArray([
                        $author$project$Pages$Dashboards$dataHeaderLabel_fn(idx, headersLength),
                        $author$project$Components$stringSelect({
                            cP: _List_Nil,
                            bR: $elm$core$Maybe$Nothing,
                            cv: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, A2($author$project$Pages$Dashboards$Forms$setChartFormHeader, cf, idx), updateChart)),
                            cx: options,
                            df: placeholder,
                            ev: $elm$core$Maybe$withDefault_fn("", $elm_community$list_extra$List$Extra$getAt_fn(idx, cf.d9.pB)),
                            m: _List_fromArray([
                                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 12)),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                            ])
                        }),
                        (idx > 1) ? $author$project$Pages$Dashboards$btnDelete(updateChart($author$project$Pages$Dashboards$Forms$removeChartFormHeader_fn(idx, cf))) : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6]))
                        ]), _List_Nil)
                    ]));
                };
                return $author$project$Types$Validated$withValidation_fn(cf.d9, A2($author$project$Pages$Dashboards$rowEl, _List_Nil, _List_fromArray([
                    selectColumnHeaderIdx(0),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cf.kZ.pB === "")
                    ]), _List_fromArray([
                        A2($author$project$Pages$Dashboards$columnEl, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]), _List_Cons(selectColumnHeaderIdx(1), _Utils_ap($elm$core$List$map_fn(selectColumnHeaderIdx, $elm$core$List$range_fn(2, headersLength - 1)), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents,
                                    $author$project$Util$styleIf_fn(isSingleton, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Pages$Dashboards$rowEl, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]), _List_fromArray([
                                    $author$project$Pages$Dashboards$el_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_7, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center]), $rtfeldman$elm_css$Html$Styled$text("+")),
                                    $author$project$Pages$Dashboards$btn_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_8]), updateChart($author$project$Pages$Dashboards$Forms$addChartFormHeader(cf)), "Add another series")
                                ])),
                                $author$project$Util$hideElement_fn(isLineChart(0), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_end, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$text("hide null values"),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                                        $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, cf.ea),
                                        $rtfeldman$elm_css$Html$Styled$Events$onCheck($elm$core$Basics$always(updateChart(_Utils_update(cf, { ea: !cf.ea }))))
                                    ]), _List_Nil)
                                ])))
                            ]))
                        ]))))
                    ]))
                ])));
            }()),
            $author$project$Util$hideElement_fn($author$project$Types$ChartType$isSingleton(cf.bu.pB), $author$project$Pages$Dashboards$inputLabeled_fn(_List_Nil, $rtfeldman$elm_css$Html$Styled$text("Label rotation"), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
            ]), _List_fromArray([
                A2($author$project$Pages$Dashboards$validatedIntInput, function (labelRotation) {
                    return updateChart(_Utils_update(cf, {
                        ef: $author$project$Types$Validated$setValue(labelRotation)
                    }));
                }, cf.ef),
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, A2($elm_community$string_extra$String$Extra$pluralize, "Degree", "Degrees"), A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$rightOf(" "), A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5]))
                ])))))), $elm$core$String$toInt($author$project$Types$Validated$getValue(cf.ef)))
            ]))))
        ]));
    }, $author$project$Pages$Dashboards$viewEditChartInputs = F2($author$project$Pages$Dashboards$viewEditChartInputs_fn);
    var $author$project$Pages$Dashboards$viewEditChartPreview_fn = function (opts, model) {
        return A2($author$project$Pages$Dashboards$section, _List_Nil, _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$small)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Preview")
            ])),
            $author$project$Pages$Dashboards$viewChart_fn($author$project$Pages$Dashboards$Forms$fromChartForm(model.ao), $author$project$Types$Validated$getValue(model.ao.bu), opts.eH, opts.gd, model)
        ]));
    }, $author$project$Pages$Dashboards$viewEditChartPreview = F2($author$project$Pages$Dashboards$viewEditChartPreview_fn);
    var $author$project$Pages$Dashboards$viewEditChart_fn = function (opts, model) {
        var isEdit = !_Utils_eq(opts.fd, $elm$core$Maybe$Nothing);
        var action = isEdit ? "Edit" : "Add new";
        return A2($author$project$Pages$Dashboards$columnEl, _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
            $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(action + " chart")
            ])),
            A2($author$project$Pages$Dashboards$rowEl, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ]), _List_fromArray([
                    $author$project$Pages$Dashboards$viewEditChartInputs_fn(opts, model.ao),
                    $author$project$Pages$Dashboards$cancelSaveDeleteButtons({
                        bJ: opts.bJ,
                        gJ: $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(model.ao), opts.fd),
                        hU: opts.hV(model.ao)
                    })
                ])),
                $author$project$Pages$Dashboards$viewEditChartPreview_fn(opts, model)
            ]))
        ]));
    }, $author$project$Pages$Dashboards$viewEditChart = F2($author$project$Pages$Dashboards$viewEditChart_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_56 = $rtfeldman$elm_css$Css$property_fn("width", "14rem");
    var $author$project$Pages$Dashboards$viewEditDashboard_fn = function (_v0, d) {
        var updateDashboard = _v0.k9;
        var cancel = _v0.bJ;
        var saveDashboard = _v0.kM;
        var deleteDashboard = _v0.i5;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4]))
        ]), _List_fromArray([
            $author$project$Pages$Dashboards$inputLabeled_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_56]), $rtfeldman$elm_css$Html$Styled$text("Title"), A2($author$project$Pages$Dashboards$validatedStringInput, function (title) {
                return updateDashboard(_Utils_update(d, {
                    eM: $author$project$Types$Validated$setValue(title)
                }));
            }, d.eM)),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_56]))
            ]), _List_fromArray([
                $author$project$Pages$Dashboards$cancelSaveDeleteButtons({
                    bJ: cancel,
                    gJ: $elm$core$Maybe$Just(deleteDashboard(d)),
                    hU: saveDashboard(d)
                })
            ]))
        ]));
    }, $author$project$Pages$Dashboards$viewEditDashboard = F2($author$project$Pages$Dashboards$viewEditDashboard_fn);
    var $author$project$Pages$Dashboards$view_fn = function (_v0, route, model) {
        var toMsg = _v0.gd;
        var tables = _v0.eH;
        var dbId = _v0.i2;
        var content = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_grow]))
        ]), _List_fromArray([
            function () {
                var navBack = toMsg($author$project$Pages$Dashboards$NavigateBack);
                var mapDashboard = F2(function (fn, i) {
                    return $elm$core$Maybe$withDefault_fn($author$project$Pages$Dashboards$htmlNone, $elm$core$Maybe$map_fn(fn, $elm$core$Dict$get_fn(i, $author$project$Pages$Dashboards$getDashboards(model))));
                });
                switch (route.$) {
                    case 1:
                        var did = route.a;
                        return A2(mapDashboard, A3($author$project$Pages$Dashboards$viewDashboard, {
                            fg: A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$EditChart, dbId, did)),
                            i9: toMsg($author$project$Pages$Dashboards$EditDashboard_fn(dbId, did)),
                            j5: toMsg($author$project$Pages$Dashboards$CreateChart_fn(dbId, did)),
                            gd: toMsg
                        }, model, tables), did);
                    case 2:
                        var did = route.a;
                        return $author$project$Pages$Dashboards$viewEditDashboard_fn({
                            bJ: navBack,
                            i5: A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$DeleteDashboard, dbId, did)),
                            kM: A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$SaveDashboard, dbId, did)),
                            k9: A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$UpdateDashboard)
                        }, model.by);
                    case 3:
                        var did = route.a;
                        return $author$project$Pages$Dashboards$viewEditChart_fn({
                            bJ: navBack,
                            fd: $elm$core$Maybe$Nothing,
                            hV: A2($elm$core$Basics$composeL, toMsg, A2($author$project$Pages$Dashboards$SaveNewChart, dbId, did)),
                            eH: tables,
                            gd: toMsg,
                            io: A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$UpdateChart(dbId))
                        }, model);
                    case 4:
                        var did = route.a;
                        var cid = route.b;
                        return $author$project$Pages$Dashboards$viewEditChart_fn({
                            bJ: navBack,
                            fd: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, toMsg, A3($author$project$Pages$Dashboards$DeleteChart, dbId, did, cid))),
                            hV: A2($elm$core$Basics$composeL, toMsg, A3($author$project$Pages$Dashboards$SaveChart, dbId, did, cid)),
                            eH: tables,
                            gd: toMsg,
                            io: A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$UpdateChart(dbId))
                        }, model);
                    default:
                        return $author$project$Components$overview({
                            iy: $author$project$Components$initButton_fn($author$project$Components$addButton_a0, "dashboard-add-button", "Dashboard", A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$AddNewDashboardMsg), $author$project$Components$InputRequester$Started)),
                            lx: false,
                            hg: "Dashboard",
                            mU: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                            mV: function (item) {
                                return "./" + item.bR;
                            },
                            mX: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                            mZ: function ($) {
                                return $.eM;
                            },
                            aZ: $elm$core$Dict$values($author$project$Pages$Dashboards$getDashboards(model)),
                            nh: $elm$core$Maybe$Just(function (item) {
                                return toMsg($author$project$Pages$Dashboards$EditDashboard_fn(dbId, item.bR));
                            }),
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]),
                            f4: $elm$core$Maybe$Just({
                                mK: $elm$core$Maybe$Nothing,
                                hj: "Chart",
                                jZ: A2($elm$core$Basics$composeR, function ($) {
                                    return $.aa;
                                }, $elm$core$Set$toList)
                            })
                        });
                }
            }()
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), _List_fromArray([
            A2($author$project$Components$InputRequester$view, toMsg, model.cm),
            $author$project$Components$menuPage_fn($author$project$Components$menuPageFull_a0, {
                dM: $author$project$Pages$Dashboards$Route$Overview,
                gB: content,
                dW: $elm$core$Maybe$Just(route),
                nl: _List_fromArray([
                    $author$project$Components$initButton_fn($author$project$Components$addButton_a0, "dashboard-add-button-menu", "Dashboard", A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Dashboards$AddNewDashboardMsg), $author$project$Components$InputRequester$Started))
                ]),
                nm: $author$project$Pages$Dashboards$Route$isEditingRoute(route),
                nn: $elm$core$List$append_fn(_List_fromArray([
                    _List_fromArray([
                        _Utils_Tuple2("Overview", $author$project$Pages$Dashboards$Route$Overview)
                    ])
                ]), $elm$core$List$singleton($elm$core$Dict$values($elm$core$Dict$map_fn_unwrapped(function (did, d) {
                    return _Utils_Tuple2(d.eM, $author$project$Pages$Dashboards$Route$ViewDashboard(did));
                }, $author$project$Pages$Dashboards$getDashboards(model))))),
                fL: $author$project$Pages$Dashboards$NavigateReplace(dbId),
                gd: toMsg
            })
        ]));
    }, $author$project$Pages$Dashboards$view = F3($author$project$Pages$Dashboards$view_fn);
    var $author$project$Pages$Database$DatabaseNameEditStarted = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Pages$Database$OwnerSubmitted_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Pages$Database$OwnerSubmitted = F2($author$project$Pages$Database$OwnerSubmitted_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$box_content = $rtfeldman$elm_css$Css$property_fn("box-sizing", "content-box");
    var $author$project$Components$codeView_fn = function (styles, content) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$pre_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_8,
                $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.96)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_scroll,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(content)
            ]))
        ]));
    }, $author$project$Components$codeView = F2($author$project$Components$codeView_fn);
    var $author$project$Pages$Database$TableSchemaMsgReceived = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Html$Styled$th_a0 = "th", $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$th_a0);
    var $author$project$Components$TableSchema$DetailToggled = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Components$TableSchema$DetailsClosed = { $: 1 };
    var $author$project$Components$TableSchema$DetailsOpened = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Types$TableType$isView = function (tableType) {
        if (!tableType) {
            return false;
        }
        else {
            return true;
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1 = $rtfeldman$elm_css$Css$property_fn("margin-left", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_6 = $rtfeldman$elm_css$Css$property_fn("margin-left", "1.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_3 = $rtfeldman$elm_css$Css$property_fn("margin-right", "0.75rem");
    var $author$project$Types$DataType$nullabilityToNotNullString = function (nullability) {
        if (!nullability) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Just("Not Null");
        }
    };
    var $elm$core$Set$size = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$size(dict);
    };
    var $author$project$Svg$eye = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6\n                m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4z\n                m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9\n                m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$table = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\n                m0 2v3H5V5h15z\n                m-5 14h-5v-9h5v9z\n                M5 10h3v9H5v-9z\n                m12 9v-9h3v9h-3z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$TableType$toIcon_fn = function (svgStyle, tableType) {
        if (!tableType) {
            return $author$project$Svg$table(_List_fromArray([svgStyle]));
        }
        else {
            return $author$project$Svg$eye(_List_fromArray([svgStyle]));
        }
    }, $author$project$Types$TableType$toIcon = F2($author$project$Types$TableType$toIcon_fn);
    var $author$project$Types$DataType$toNullability = function (dataType) {
        switch (dataType.$) {
            case 0:
                var nullability = dataType.a;
                return nullability;
            case 1:
                var nullability = dataType.a;
                return nullability;
            case 2:
                var nullability = dataType.a;
                return nullability;
            case 3:
                var nullability = dataType.a;
                return nullability;
            default:
                var nullability = dataType.a;
                return nullability;
        }
    };
    var $author$project$Types$SqliteDataType$toString = function (dataType) {
        switch (dataType) {
            case 0:
                return "INTEGER";
            case 1:
                return "REAL";
            case 2:
                return "TEXT";
            case 3:
                return "BLOB";
            case 4:
                return "BLOB_FILE";
            case 5:
                return "BOOLEAN";
            case 6:
                return "REAL_MONEY";
            case 7:
                return "TEXT_EMAIL";
            case 8:
                return "TEXT_URL";
            case 9:
                return "TEXT_BASE64";
            case 10:
                return "TEXT_DATE";
            case 11:
                return "TEXT_TIME";
            case 12:
                return "TEXT_DATETIME";
            case 13:
                return "TEXT_DURATION";
            case 14:
                return "TEXT_DURATION_ISO";
            case 15:
                return "TEXT_PHONE";
            case 16:
                return "TEXT_COLOR";
            case 17:
                return "TEXT_JSON";
            case 18:
                return "TEXT_JSON_OBJECT";
            case 19:
                return "TEXT_JSON_ARRAY";
            case 20:
                return "TEXT_CODE";
            case 21:
                return "TEXT_LOCATION";
            case 22:
                return "TEXT_COUNTRY_ALPHA2";
            case 23:
                return "TEXT_COUNTRY_ALPHA3";
            default:
                return "ANY";
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$translate_y_0_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-y", "0.125rem"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$translate_y_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-y", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $author$project$Svg$unfoldLess = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83z\n                m0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$unfoldMore = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59z\n                m9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$TableSchema$view_fn = function (styles, buttonStyles, maybeOnEditView, toMsg, model, db) {
        var toButton = F3(function (onClick, show, icon) {
            return show ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                ])),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg(onClick))
            ]), _List_fromArray([
                icon(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer]))
                ]))
            ])) : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]))
            ]), _List_Nil);
        });
        var renderCol = function (col) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_3]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(col.jx)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.6))
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text($author$project$Types$SqliteDataType$toString(col.l0)),
                        $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, $elm$core$String$append(", "), $rtfeldman$elm_css$Html$Styled$text), $author$project$Types$DataType$nullabilityToNotNullString($author$project$Types$DataType$toNullability(col.l$)))
                    ]))
                ]))
            ]));
        };
        var renderTable = function (table) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$details_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap])),
                $rtfeldman$elm_css$VirtualDom$Styled$property_fn("open", $elm$json$Json$Encode$bool($elm$core$Set$member_fn(table.M, model.aR))),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$Components$TableSchema$DetailToggled(table.M)))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$summary_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer]))
                ]), _List_fromArray([
                    $author$project$Types$TableType$toIcon_fn($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$translate_y_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ])), table.o8),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(table.M)
                    ])),
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (onEditView) {
                        return $author$project$Components$iconButton({
                            bA: $author$project$Svg$edit,
                            a_: onEditView(table),
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transform, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$translate_y_0_dot_5]),
                            bE: _List_Nil
                        });
                    }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always($author$project$Types$TableType$isView(table.o8)), maybeOnEditView))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_6]))
                ]), $elm$core$List$map_fn(renderCol, table.iT))
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end,
                    $rtfeldman$elm_css$Css$batch(buttonStyles)
                ]))
            ]), _List_fromArray([
                A3(toButton, $author$project$Components$TableSchema$DetailsOpened($elm$core$List$map_fn(function ($) {
                    return $.M;
                }, db.eH)), _Utils_cmp($elm$core$Set$size(model.aR), $elm$core$List$length(db.eH)) < 0, $author$project$Svg$unfoldLess),
                A3(toButton, $author$project$Components$TableSchema$DetailsClosed, $elm$core$Set$size(model.aR) > 0, $author$project$Svg$unfoldMore)
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, $elm$core$List$map_fn(renderTable, db.eH))
        ]));
    }, $author$project$Components$TableSchema$view = F6($author$project$Components$TableSchema$view_fn);
    var $author$project$Pages$Database$databaseInfoTable_fn = function (db, cfg) {
        var readonlyIdWarning = "Warning:\n" + (("Grants full read access " + "to all data in the database.\n") + "Share carefully.");
        var idWarning = "Warning:\n" + ("This grants full access to the database.\n" + ("Only share with admins.\n" + ("It's also included in the URL.\n" + "You can generate a new one in the settings.")));
        var cellCss = _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
            $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8))
        ]);
        var cellHead = function (content) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$th_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(cellCss)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(content)
            ]));
        };
        var cell = function (content) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$td_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(cellCss)
            ]), content);
        };
        var cellStr = function (content) {
            return cell(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(content)
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$table_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_collapse, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_sm]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$thead_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellHead("Attribute"),
                    cellHead("Value")
                ]))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tbody_a0, _List_Nil, _List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (owner) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                        cellStr("Owner"),
                        cellStr(owner)
                    ]));
                }, db.ob),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("ID"),
                    cell(_List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text($author$project$Types$Database$unwrapId(db.bR))
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_help, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold])),
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$title_a0, idWarning)
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text(" \u24D8")
                        ]))
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Read Only ID"),
                    cell(_List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inline_block, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_2]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text(db.oo)
                        ])),
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_help, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold])),
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$title_a0, readonlyIdWarning)
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text(" \u24D8")
                        ]))
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Original File Format"),
                    cellStr(db.mv)
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Size"),
                    cellStr($basti1302$elm_human_readable_filesize$Filesize$format(db.oS))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Created"),
                    cell(_List_fromArray([
                        $author$project$Components$dateTimeWithTooltip_fn(_List_Nil, db.lW)
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Last Modified"),
                    cell(_List_fromArray([
                        $author$project$Components$dateTimeWithTooltip_fn(_List_Nil, db.m0)
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("User Version"),
                    cellStr($elm$core$String$fromInt(db.pz))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Schema Version"),
                    cellStr($elm$core$String$fromInt(db.oK))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$td_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $rtfeldman$elm_css$Css$batch(_List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$align_top, cellCss))
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Tables / Views")
                    ])),
                    cell(_List_fromArray([
                        $author$project$Components$TableSchema$view_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none]), _List_Nil, $elm$core$Maybe$Nothing, A2($elm$core$Basics$composeL, cfg.gd, $author$project$Pages$Database$TableSchemaMsgReceived), cfg.nu.eG, db)
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_Nil, _List_fromArray([
                    cellStr("Location"),
                    function () {
                        var longLat = $elm$core$String$fromFloat(db.hm.m9) + ("," + $elm$core$String$fromFloat(db.hm.m1));
                        return cell(_List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$href("http://www.google.com/maps/place/" + (longLat + ("/@" + (longLat + ",4z")))),
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                    $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
                                ])),
                                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank")
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text(db.hm.M)
                            ]))
                        ]));
                    }()
                ]))
            ]))
        ]));
    }, $author$project$Pages$Database$databaseInfoTable = F2($author$project$Pages$Database$databaseInfoTable_fn);
    var $author$project$Pages$Database$DatabaseNameEditApplied = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Database$DatabaseNameEditSet = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Util$collapseElement_fn = function (condition, element) {
        return (!condition) ? element : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$property_fn("visibility", "collapse"),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents
            ]))
        ]), _List_fromArray([element]));
    }, $author$project$Util$collapseElement = F2($author$project$Util$collapseElement_fn);
    var $author$project$Pages$Database$editableDatabaseName_fn = function (styles, toMsg, model, database) {
        var isEditing = !_Utils_eq(model.a9, $elm$core$Maybe$Nothing);
        var input_ = function (inputStyles) {
            return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), $author$project$Components$expandingInput({
                iE: true,
                cP: _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "database-name-input"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true)
                ]),
                iV: _List_Nil,
                j3: false,
                bC: $elm$core$Maybe$Just(toMsg($author$project$Pages$Database$DatabaseNameEditApplied(database))),
                ek: toMsg($author$project$Pages$Database$DatabaseNameEditSet($elm$core$Maybe$Nothing)),
                cv: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Pages$Database$DatabaseNameEditSet, toMsg)),
                m: _Utils_ap(inputStyles, styles)
            }), model.a9);
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Database \"")
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1,
                            $rtfeldman$elm_css$Css$batch(styles)
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $author$project$Util$collapseElement_fn(!isEditing, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex]))
                ]), _List_fromArray([
                    input_(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold
                    ])),
                    $rtfeldman$elm_css$Html$Styled$text("\"")
                ]))),
                $author$project$Util$collapseElement_fn(isEditing, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($author$project$Util$flip_fn($elm$core$String$append, "\"", database.mw))
                ])))
            ]))
        ]));
    }, $author$project$Pages$Database$editableDatabaseName = F4($author$project$Pages$Database$editableDatabaseName_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$italic = $rtfeldman$elm_css$Css$property_fn("font-style", "italic");
    var $elm$core$String$any = _String_any;
    var $elm$core$String$lines = _String_lines;
    var $elm$core$List$minimum = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just($elm$core$List$foldl_fn($elm$core$Basics$min, x, xs));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm_community$string_extra$String$Extra$unindent = function (multilineSting) {
        var lines = $elm$core$String$lines(multilineSting);
        var isNotWhitespace = function (_char) {
            return (_char !== " ") && (_char !== "\t");
        };
        var countLeadingWhitespace = F2(function (count, line) {
            countLeadingWhitespace: while (true) {
                var _v0 = $elm$core$String$uncons(line);
                if (_v0.$ === 1) {
                    return count;
                }
                else {
                    var _v1 = _v0.a;
                    var _char = _v1.a;
                    var rest = _v1.b;
                    switch (_char) {
                        case " ":
                            var $temp$count = count + 1, $temp$line = rest;
                            count = $temp$count;
                            line = $temp$line;
                            continue countLeadingWhitespace;
                        case "\t":
                            var $temp$count = count + 1, $temp$line = rest;
                            count = $temp$count;
                            line = $temp$line;
                            continue countLeadingWhitespace;
                        default:
                            return count;
                    }
                }
            }
        });
        var minLead = $elm$core$Maybe$withDefault_fn(0, $elm$core$List$minimum($elm$core$List$map_fn(countLeadingWhitespace(0), $elm$core$List$filter_fn($elm$core$String$any(isNotWhitespace), lines))));
        return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($elm$core$String$dropLeft(minLead), lines));
    };
    var $author$project$Util$replaceUrlPath_fn = function (url, newPath) {
        return _Utils_update(url, { ks: newPath });
    }, $author$project$Util$replaceUrlPath = F2($author$project$Util$replaceUrlPath_fn);
    var $author$project$Util$urlWithPathToString = function (url) {
        return A2($elm$core$Basics$composeR, $author$project$Util$replaceUrlPath(url), $elm$url$Url$toString);
    };
    var $author$project$Components$Description$EditorOpened = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Css$Global$collectSelectors = function (declarations) {
        collectSelectors: while (true) {
            if (!declarations.b) {
                return _List_Nil;
            }
            else {
                if (!declarations.a.$) {
                    var _v5 = declarations.a.a;
                    var firstSelector = _v5.a;
                    var otherSelectors = _v5.b;
                    var styles = _v5.c;
                    var rest = declarations.b;
                    return _Utils_ap(_List_Cons($rtfeldman$elm_css$Css$Global$unwrapSelector_fn(firstSelector, styles), otherSelectors), $rtfeldman$elm_css$Css$Global$collectSelectors(rest));
                }
                else {
                    var rest = declarations.b;
                    var $temp$declarations = rest;
                    declarations = $temp$declarations;
                    continue collectSelectors;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Global$unwrapSelector_fn = function (_v0, styles) {
        var sequence = _v0.a;
        var combinators = _v0.b;
        var mPseudo = _v0.c;
        var unwrapSequenceSelector = F2(function (style, s) {
            if (style.$ === 1) {
                var nestedSelector = style.a;
                var evenMoreNestedStyles = style.b;
                return $elm$core$List$foldr_fn(unwrapSequenceSelector, $rtfeldman$elm_css$Css$Structure$appendRepeatable_fn(nestedSelector, s), evenMoreNestedStyles);
            }
            else {
                return s;
            }
        });
        var unwrapCombinatorSelector = F2(function (style, cs) {
            if (style.$ === 2) {
                var combinator = style.a;
                var snippets = style.b;
                return $elm$core$List$append_fn(cs, $elm$core$List$map_fn(function (_v3) {
                    var s = _v3.a;
                    return _Utils_Tuple2(combinator, s);
                }, $elm$core$List$concatMap_fn(A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, $rtfeldman$elm_css$Css$Global$collectSelectors), snippets)));
            }
            else {
                return cs;
            }
        });
        return $rtfeldman$elm_css$Css$Structure$Selector_fn($elm$core$List$foldr_fn(unwrapSequenceSelector, sequence, styles), $elm$core$List$foldr_fn(unwrapCombinatorSelector, combinators, styles), mPseudo);
    }, $rtfeldman$elm_css$Css$Global$unwrapSelector = F2($rtfeldman$elm_css$Css$Global$unwrapSelector_fn);
    var $rtfeldman$elm_css$Css$Global$each_fn = function (snippetCreators, styles) {
        var selectorsToSnippet = function (selectors) {
            if (!selectors.b) {
                return _List_Nil;
            }
            else {
                var first = selectors.a;
                var rest = selectors.b;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn(first, rest, styles))
                ]);
            }
        };
        return selectorsToSnippet($rtfeldman$elm_css$Css$Global$collectSelectors($elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, $elm$core$List$map_fn($elm$core$Basics$apR(_List_Nil), snippetCreators))));
    }, $rtfeldman$elm_css$Css$Global$each = F2($rtfeldman$elm_css$Css$Global$each_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_2 = $rtfeldman$elm_css$Css$property_fn("margin", "0.5rem");
    var $elm$core$Result$andThen_fn = function (callback, result) {
        if (!result.$) {
            var value = result.a;
            return callback(value);
        }
        else {
            var msg = result.a;
            return $elm$core$Result$Err(msg);
        }
    }, $elm$core$Result$andThen = F2($elm$core$Result$andThen_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
        switch (problem.$) {
            case 0:
                var string = problem.a;
                return "Expecting " + string;
            case 1:
                return "Expecting int";
            case 2:
                return "Expecting hex";
            case 3:
                return "Expecting octal";
            case 4:
                return "Expecting binary";
            case 5:
                return "Expecting float";
            case 6:
                return "Expecting number";
            case 7:
                return "Expecting variable";
            case 8:
                var string = problem.a;
                return "Expecting symbol " + string;
            case 9:
                var string = problem.a;
                return "Expecting keyword " + string;
            case 10:
                return "Expecting keyword end";
            case 11:
                return "Unexpected char";
            case 12:
                var problemDescription = problem.a;
                return problemDescription;
            default:
                return "Bad repeat";
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
        return "Problem at row " + ($elm$core$String$fromInt(deadEnd.kJ) + ("\n" + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.oi)));
    };
    var $elm$html$Html$a = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "a"), $elm$html$Html$a_fn = $elm$html$Html$a.a2;
    var $elm$html$Html$Attributes$align_a0 = "align", $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$align_a0);
    var $elm$html$Html$Attributes$alt_a0 = "alt", $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$alt_a0);
    var $elm$html$Html$blockquote = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "blockquote"), $elm$html$Html$blockquote_fn = $elm$html$Html$blockquote.a2;
    var $elm$html$Html$br = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "br"), $elm$html$Html$br_fn = $elm$html$Html$br.a2;
    var $elm$html$Html$del = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "del"), $elm$html$Html$del_fn = $elm$html$Html$del.a2;
    var $elm$html$Html$Attributes$disabled_a0 = "disabled", $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$disabled_a0);
    var $elm$html$Html$em = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "em"), $elm$html$Html$em_fn = $elm$html$Html$em.a2;
    var $elm$html$Html$h1 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h1"), $elm$html$Html$h1_fn = $elm$html$Html$h1.a2;
    var $elm$html$Html$h2 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h2"), $elm$html$Html$h2_fn = $elm$html$Html$h2.a2;
    var $elm$html$Html$h3 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h3"), $elm$html$Html$h3_fn = $elm$html$Html$h3.a2;
    var $elm$html$Html$h4 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h4"), $elm$html$Html$h4_fn = $elm$html$Html$h4.a2;
    var $elm$html$Html$h5 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h5"), $elm$html$Html$h5_fn = $elm$html$Html$h5.a2;
    var $elm$html$Html$h6 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h6"), $elm$html$Html$h6_fn = $elm$html$Html$h6.a2;
    var $elm$html$Html$hr = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "hr"), $elm$html$Html$hr_fn = $elm$html$Html$hr.a2;
    var $elm$html$Html$Attributes$href = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("href", _VirtualDom_noJavaScriptUri(url));
    };
    var $elm$html$Html$img = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "img"), $elm$html$Html$img_fn = $elm$html$Html$img.a2;
    var $elm$html$Html$input = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "input"), $elm$html$Html$input_fn = $elm$html$Html$input.a2;
    var $elm$html$Html$li = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "li"), $elm$html$Html$li_fn = $elm$html$Html$li.a2;
    var $elm$html$Html$ol = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "ol"), $elm$html$Html$ol_fn = $elm$html$Html$ol.a2;
    var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$Html$resultOr_fn = function (ra, rb) {
        if (ra.$ === 1) {
            var singleError = ra.a;
            if (!rb.$) {
                var okValue = rb.a;
                return $elm$core$Result$Ok(okValue);
            }
            else {
                var errorsSoFar = rb.a;
                return $elm$core$Result$Err(_List_Cons(singleError, errorsSoFar));
            }
        }
        else {
            var okValue = ra.a;
            return $elm$core$Result$Ok(okValue);
        }
    }, $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2($dillonkearns$elm_markdown$Markdown$Html$resultOr_fn);
    var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
        return $elm$core$String$join_fn(" ", $elm$core$List$map_fn(function (_v0) {
            var name = _v0.M;
            var value = _v0.pB;
            return name + ("=\"" + (value + "\""));
        }, attributes));
    };
    var $dillonkearns$elm_markdown$Markdown$Html$tagToString_fn = function (tagName, attributes) {
        return $elm$core$List$isEmpty(attributes) ? ("<" + (tagName + ">")) : ("<" + (tagName + (" " + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + ">"))));
    }, $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn);
    var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
        var unwrappedDecoders = $elm$core$List$map_fn(function (_v4) {
            var rawDecoder = _v4;
            return rawDecoder;
        }, decoders);
        return function (rawDecoder) {
            return F3(function (tagName, attributes, innerBlocks) {
                return $elm$core$Result$mapError_fn(function (errors) {
                    if (!errors.b) {
                        return "Ran into a oneOf with no possibilities!";
                    }
                    else {
                        if (!errors.b.b) {
                            var singleError = errors.a;
                            return "Problem with the given value:\n\n" + ($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn(tagName, attributes) + ("\n\n" + (singleError + "\n")));
                        }
                        else {
                            return "oneOf failed parsing this value:\n    " + ($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn(tagName, attributes) + ("\n\nParsing failed in the following 2 ways:\n\n\n" + ($elm$core$String$join_fn("\n\n", $elm$core$List$indexedMap_fn_unwrapped(function (index, error) {
                                return "(" + ($elm$core$String$fromInt(index + 1) + (") " + error));
                            }, errors)) + "\n")));
                        }
                    }
                }, A3(rawDecoder, tagName, attributes, innerBlocks));
            });
        }($elm$core$List$foldl_fn_unwrapped(function (decoder, soFar) {
            return F3(function (tagName, attributes, children) {
                return $dillonkearns$elm_markdown$Markdown$Html$resultOr_fn(A3(decoder, tagName, attributes, children), A3(soFar, tagName, attributes, children));
            });
        }, F3(function (_v0, _v1, _v2) {
            return $elm$core$Result$Err(_List_Nil);
        }), unwrappedDecoders));
    };
    var $elm$html$Html$p = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "p"), $elm$html$Html$p_fn = $elm$html$Html$p.a2;
    var $elm$html$Html$Attributes$src = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("src", _VirtualDom_noJavaScriptOrHtmlUri(url));
    };
    var $elm$html$Html$Attributes$start = function (n) {
        return $elm$html$Html$Attributes$stringProperty_fn("start", $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$strong = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "strong"), $elm$html$Html$strong_fn = $elm$html$Html$strong.a2;
    var $elm$html$Html$tbody = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "tbody"), $elm$html$Html$tbody_fn = $elm$html$Html$tbody.a2;
    var $elm$html$Html$th = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "th"), $elm$html$Html$th_fn = $elm$html$Html$th.a2;
    var $elm$html$Html$thead = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "thead"), $elm$html$Html$thead_fn = $elm$html$Html$thead.a2;
    var $elm$html$Html$Attributes$title_a0 = "title", $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$title_a0);
    var $elm$html$Html$ul = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "ul"), $elm$html$Html$ul_fn = $elm$html$Html$ul.a2;
    var $elm$core$String$words = _String_words;
    var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
        gv: $elm$html$Html$blockquote(_List_Nil),
        gy: function (_v0) {
            var body = _v0.d;
            var language = _v0.m$;
            var classes = function () {
                var _v1 = $elm$core$Maybe$map_fn($elm$core$String$words, language);
                if ((!_v1.$) && _v1.a.b) {
                    var _v2 = _v1.a;
                    var actualLanguage = _v2.a;
                    return _List_fromArray([
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "language-" + actualLanguage)
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }();
            return $elm$html$Html$pre_fn(_List_Nil, _List_fromArray([
                $elm$html$Html$code_fn(classes, _List_fromArray([
                    $elm$html$Html$text(body)
                ]))
            ]));
        },
        gz: function (content) {
            return $elm$html$Html$code_fn(_List_Nil, _List_fromArray([
                $elm$html$Html$text(content)
            ]));
        },
        gP: function (children) {
            return $elm$html$Html$em_fn(_List_Nil, children);
        },
        gZ: $elm$html$Html$br_fn(_List_Nil, _List_Nil),
        g_: function (_v3) {
            var level = _v3.jX;
            var children = _v3.gx;
            switch (level) {
                case 0:
                    return $elm$html$Html$h1_fn(_List_Nil, children);
                case 1:
                    return $elm$html$Html$h2_fn(_List_Nil, children);
                case 2:
                    return $elm$html$Html$h3_fn(_List_Nil, children);
                case 3:
                    return $elm$html$Html$h4_fn(_List_Nil, children);
                case 4:
                    return $elm$html$Html$h5_fn(_List_Nil, children);
                default:
                    return $elm$html$Html$h6_fn(_List_Nil, children);
            }
        },
        g3: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
        g4: function (imageInfo) {
            var _v5 = imageInfo.eM;
            if (!_v5.$) {
                var title = _v5.a;
                return $elm$html$Html$img_fn(_List_fromArray([
                    $elm$html$Html$Attributes$src(imageInfo.h6),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$alt_a0, imageInfo.go),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, title)
                ]), _List_Nil);
            }
            else {
                return $elm$html$Html$img_fn(_List_fromArray([
                    $elm$html$Html$Attributes$src(imageInfo.h6),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$alt_a0, imageInfo.go)
                ]), _List_Nil);
            }
        },
        jY: F2(function (link, content) {
            var _v6 = link.eM;
            if (!_v6.$) {
                var title = _v6.a;
                return $elm$html$Html$a_fn(_List_fromArray([
                    $elm$html$Html$Attributes$href(link.mb),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, title)
                ]), content);
            }
            else {
                return $elm$html$Html$a_fn(_List_fromArray([
                    $elm$html$Html$Attributes$href(link.mb)
                ]), content);
            }
        }),
        hK: F2(function (startingIndex, items) {
            return $elm$html$Html$ol_fn(function () {
                if (startingIndex === 1) {
                    return _List_fromArray([
                        $elm$html$Html$Attributes$start(startingIndex)
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }(), $elm$core$List$map_fn(function (itemBlocks) {
                return $elm$html$Html$li_fn(_List_Nil, itemBlocks);
            }, items));
        }),
        hN: $elm$html$Html$p(_List_Nil),
        ia: function (children) {
            return $elm$html$Html$del_fn(_List_Nil, children);
        },
        ib: function (children) {
            return $elm$html$Html$strong_fn(_List_Nil, children);
        },
        kZ: $elm$html$Html$table(_List_Nil),
        ic: $elm$html$Html$tbody(_List_Nil),
        id: function (maybeAlignment) {
            var attrs = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($elm$html$Html$Attributes$align, $elm$core$Maybe$map_fn(function (alignment) {
                switch (alignment) {
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, maybeAlignment))));
            return $elm$html$Html$td(attrs);
        },
        ie: $elm$html$Html$thead(_List_Nil),
        $8: function (maybeAlignment) {
            var attrs = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($elm$html$Html$Attributes$align, $elm$core$Maybe$map_fn(function (alignment) {
                switch (alignment) {
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, maybeAlignment))));
            return $elm$html$Html$th(attrs);
        },
        f8: $elm$html$Html$tr(_List_Nil),
        C: $elm$html$Html$text,
        ik: $elm$html$Html$hr_fn(_List_Nil, _List_Nil),
        $9: function (items) {
            return $elm$html$Html$ul_fn(_List_Nil, $elm$core$List$map_fn(function (item) {
                var task = item.a;
                var children = item.b;
                var checkbox = function () {
                    switch (task) {
                        case 0:
                            return $elm$html$Html$text("");
                        case 1:
                            return $elm$html$Html$input_fn(_List_fromArray([
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true),
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, false),
                                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "checkbox")
                            ]), _List_Nil);
                        default:
                            return $elm$html$Html$input_fn(_List_fromArray([
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true),
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, true),
                                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "checkbox")
                            ]), _List_Nil);
                    }
                }();
                return $elm$html$Html$li_fn(_List_Nil, _List_Cons(checkbox, children));
            }, items));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = { $: 10 };
    var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
        return { $: 11, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = { $: 0 };
    var $elm$parser$Parser$Expecting = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = { $: 8 };
    var $dillonkearns$elm_markdown$Markdown$Block$Heading_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$Heading = F2($dillonkearns$elm_markdown$Markdown$Block$Heading_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Image_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$Image = F3($dillonkearns$elm_markdown$Markdown$Block$Image_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Link_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$Link = F3($dillonkearns$elm_markdown$Markdown$Block$Link_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2($dillonkearns$elm_markdown$Markdown$Block$ListItem_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3($dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn = function (a, b, c, d, e, f) {
        return { $: 4, a: a, b: b, c: c, d: d, e: e, f: f };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
        return { $: 12, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Table_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$Table = F2($dillonkearns$elm_markdown$Markdown$Block$Table_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
        return { $: 8, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Table$Table_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Table$Table = F2($dillonkearns$elm_markdown$Markdown$Table$Table_fn);
    var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = { $: 8 };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = { $: 7 };
    var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2($dillonkearns$elm_markdown$Markdown$Block$UnorderedList_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn = function (a, b, c, d) {
        return { $: 3, a: a, b: b, c: c, d: d };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$Parser$addReference_fn = function (state, linkRef) {
        return {
            a: _List_Cons(linkRef, state.a),
            c: state.c
        };
    }, $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2($dillonkearns$elm_markdown$Markdown$Parser$addReference_fn);
    var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
        switch (_char) {
            case " ":
                return true;
            case "\t":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = $elm$parser$Parser$Advanced$Token_fn("\r", $elm$parser$Parser$Expecting("a carriage return"));
    var $dillonkearns$elm_markdown$Parser$Token$newline = $elm$parser$Parser$Advanced$Token_fn("\n", $elm$parser$Parser$Expecting("a newline"));
    var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
            $elm$parser$Parser$Advanced$succeed(0)
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $dillonkearns$elm_markdown$Whitespace$lineEnd));
    var $dillonkearns$elm_markdown$Parser$Token$space = $elm$parser$Parser$Advanced$Token_fn(" ", $elm$parser$Parser$Expecting("a space"));
    var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray([
        $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(">"))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(" >"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(" >", $elm$parser$Parser$Expecting("  >"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("  >", $elm$parser$Parser$Expecting("   >")))
        ])))
    ]);
    var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
        switch (_char) {
            case "\n":
                return true;
            case "\r":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
    var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("the end of the input"));
    var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
    var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote), $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
        return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph = function (block) {
        endWithOpenBlockOrParagraph: while (true) {
            switch (block.$) {
                case 1:
                    var str = block.a;
                    return !_String_endsWith_fn(str, "\n");
                case 12:
                    var blocks = block.a;
                    if (blocks.b) {
                        var last = blocks.a;
                        var $temp$block = last;
                        block = $temp$block;
                        continue endWithOpenBlockOrParagraph;
                    }
                    else {
                        return false;
                    }
                case 4:
                    var blockslist = block.e;
                    if (blockslist.b) {
                        var blocks = blockslist.a;
                        if (blocks.b) {
                            var last = blocks.a;
                            var $temp$block = last;
                            block = $temp$block;
                            continue endWithOpenBlockOrParagraph;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                case 0:
                    return true;
                default:
                    return false;
            }
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$Element_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$HtmlParser$Element = F3($dillonkearns$elm_markdown$HtmlParser$Element_fn);
    var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting("at least 1 tag name character");
    var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
        switch (c) {
            case " ":
                return false;
            case "\r":
                return false;
            case "\n":
                return false;
            case "\t":
                return false;
            case "/":
                return false;
            case "<":
                return false;
            case ">":
                return false;
            case "\"":
                return false;
            case "'":
                return false;
            case "=":
                return false;
            default:
                return true;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$tagName = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (name, _v0) {
        return $elm$core$String$toLower(name);
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
    var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
    var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$ExpectingSymbol(str)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("amp", "&"),
        _Utils_Tuple2("lt", "<"),
        _Utils_Tuple2("gt", ">"),
        _Utils_Tuple2("apos", "'"),
        _Utils_Tuple2("quot", "\"")
    ]));
    var $elm$core$Result$fromMaybe_fn = function (err, maybe) {
        if (!maybe.$) {
            var v = maybe.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            return $elm$core$Result$Err(err);
        }
    }, $elm$core$Result$fromMaybe = F2($elm$core$Result$fromMaybe_fn);
    var $rtfeldman$elm_hex$Hex$fromStringHelp_fn = function (position, chars, accumulated) {
        fromStringHelp: while (true) {
            if (!chars.b) {
                return $elm$core$Result$Ok(accumulated);
            }
            else {
                var _char = chars.a;
                var rest = chars.b;
                switch (_char) {
                    case "0":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated;
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "1":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + _Basics_pow_fn(16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "2":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (2 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "3":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (3 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "4":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (4 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "5":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (5 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "6":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (6 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "7":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (7 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "8":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (8 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "9":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (9 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "a":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (10 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "b":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (11 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "c":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (12 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "d":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (13 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "e":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (14 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "f":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (15 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    default:
                        var nonHex = _char;
                        return $elm$core$Result$Err($elm$core$String$fromChar(nonHex) + " is not a valid hexadecimal character.");
                }
            }
        }
    }, $rtfeldman$elm_hex$Hex$fromStringHelp = F3($rtfeldman$elm_hex$Hex$fromStringHelp_fn);
    var $rtfeldman$elm_hex$Hex$fromString = function (str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Result$Err("Empty strings are not valid hexadecimal strings.");
        }
        else {
            var result = function () {
                if (_String_startsWith_fn("-", str)) {
                    var list = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail($elm$core$String$toList(str)));
                    return $elm$core$Result$map_fn($elm$core$Basics$negate, $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$List$length(list) - 1, list, 0));
                }
                else {
                    return $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$String$length(str) - 1, $elm$core$String$toList(str), 0);
                }
            }();
            var formatError = function (err) {
                return $elm$core$String$join_fn(" ", _List_fromArray(["\"" + (str + "\""), "is not a valid hexadecimal string because", err]));
            };
            return $elm$core$Result$mapError_fn(formatError, result);
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
        return _String_startsWith_fn("#x", s) ? $elm$core$Result$mapError_fn($elm$parser$Parser$Problem, $elm$core$Result$map_fn($elm$core$Char$fromCode, $rtfeldman$elm_hex$Hex$fromString($elm$core$String$dropLeft_fn(2, s)))) : (_String_startsWith_fn("#", s) ? $elm$core$Result$fromMaybe_fn($elm$parser$Parser$Problem("Invalid escaped character: " + s), $elm$core$Maybe$map_fn($elm$core$Char$fromCode, $elm$core$String$toInt($elm$core$String$dropLeft_fn(1, s)))) : $elm$core$Result$fromMaybe_fn($elm$parser$Parser$Problem("No entity named \"&" + (s + ";\" found.")), $elm$core$Dict$get_fn(s, $dillonkearns$elm_markdown$HtmlParser$entities)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
        var process = function (entityStr) {
            var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
            if (!_v0.$) {
                var c = _v0.a;
                return $elm$parser$Parser$Advanced$succeed(c);
            }
            else {
                var e = _v0.a;
                return $elm$parser$Parser$Advanced$problem(e);
            }
        };
        var isEntityChar = function (c) {
            return (!_Utils_eq(c, end_)) && (c !== ";");
        };
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("&")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn(process, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn(isEntityChar, $elm$parser$Parser$Expecting("an entity character")), $elm$parser$Parser$Advanced$chompWhile(isEntityChar)))), $dillonkearns$elm_markdown$HtmlParser$symbol(";")));
    };
    var $dillonkearns$elm_markdown$HtmlParser$textStringStep_fn = function (closingChar, predicate, accum) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (soFar) {
            return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (escaped) {
                    return $elm$parser$Parser$Advanced$Loop(_Utils_ap(accum, _Utils_ap(soFar, $elm$core$String$fromChar(escaped))));
                }, $dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
                $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(_Utils_ap(accum, soFar)))
            ]));
        }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile(predicate)));
    }, $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3($dillonkearns$elm_markdown$HtmlParser$textStringStep_fn);
    var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
        var predicate = function (c) {
            return (!_Utils_eq(c, closingChar)) && (c !== "&");
        };
        return $elm$parser$Parser$Advanced$loop_fn("", A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
    };
    var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("\"")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$textString("\""), $dillonkearns$elm_markdown$HtmlParser$symbol("\""))),
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("'")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$textString("'"), $dillonkearns$elm_markdown$HtmlParser$symbol("'")))
    ]));
    var $dillonkearns$elm_markdown$HtmlParser$keepOldest_fn = function (_new, mValue) {
        if (!mValue.$) {
            var v = mValue.a;
            return $elm$core$Maybe$Just(v);
        }
        else {
            return $elm$core$Maybe$Just(_new);
        }
    }, $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2($dillonkearns$elm_markdown$HtmlParser$keepOldest_fn);
    var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
        switch (c) {
            case " ":
                return true;
            case "\r":
                return true;
            case "\n":
                return true;
            case "\t":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
    var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
        var process = F2(function (name, value) {
            return $elm$parser$Parser$Advanced$Loop($elm$core$Dict$update_fn($elm$core$String$toLower(name), $dillonkearns$elm_markdown$HtmlParser$keepOldest(value), attrs));
        });
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(process), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $dillonkearns$elm_markdown$HtmlParser$symbol("=")), $dillonkearns$elm_markdown$HtmlParser$whiteSpace)), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(attrs))
        ]));
    };
    var $dillonkearns$elm_markdown$HtmlParser$attributes = $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Dict$foldl, F3(function (key, value, accum) {
        return _List_Cons({ M: key, pB: value }, accum);
    }), _List_Nil), $elm$parser$Parser$Advanced$loop_fn($elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
    var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
        return function (s) {
            var _v0 = _Parser_findSubString_fn(str, s.fK, s.kJ, s.iR, s.h6);
            var newOffset = _v0.a;
            var newRow = _v0.b;
            var newCol = _v0.c;
            var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.h6) : newOffset;
            return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.fK, adjustedOffset) < 0, 0, { iR: newCol, bx: s.bx, w: s.w, fK: adjustedOffset, kJ: newRow, h6: s.h6 });
        };
    };
    var $dillonkearns$elm_markdown$HtmlParser$cdata = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("<![CDATA[")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("]]>")), $dillonkearns$elm_markdown$HtmlParser$symbol("]]>")));
    var $dillonkearns$elm_markdown$HtmlParser$childrenStep_fn = function (options, accum) {
        return $elm$parser$Parser$Advanced$map_fn(function (f) {
            return f(accum);
        }, $elm$parser$Parser$Advanced$oneOf(options));
    }, $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2($dillonkearns$elm_markdown$HtmlParser$childrenStep_fn);
    var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(str));
    };
    var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
        var closingTagName = $elm$parser$Parser$Advanced$andThen_fn(function (endTagName) {
            return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail("tag name mismatch: " + (startTagName + (" and " + endTagName)));
        }, $dillonkearns$elm_markdown$HtmlParser$tagName);
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$symbol("</"), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), closingTagName), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $dillonkearns$elm_markdown$HtmlParser$symbol(">"));
    };
    var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
        return $elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$Expecting(str));
    };
    var $dillonkearns$elm_markdown$HtmlParser$comment = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment), $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$HtmlParser$toToken("<!--"))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("-->")), $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$HtmlParser$toToken("-->"))));
    var $dillonkearns$elm_markdown$HtmlParser$Declaration_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $dillonkearns$elm_markdown$HtmlParser$Declaration = F2($dillonkearns$elm_markdown$HtmlParser$Declaration_fn);
    var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting("at least 1 uppercase character");
    var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter), $elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
    var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$isWhitespace, $elm$parser$Parser$Expecting("at least one whitespace")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
    var $dillonkearns$elm_markdown$HtmlParser$docType = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration), $dillonkearns$elm_markdown$HtmlParser$symbol("<!")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr(">")), $dillonkearns$elm_markdown$HtmlParser$symbol(">")));
    var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction), $dillonkearns$elm_markdown$HtmlParser$symbol("<?")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("?>")), $dillonkearns$elm_markdown$HtmlParser$symbol("?>")));
    var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
        switch (c) {
            case "<":
                return false;
            case "&":
                return false;
            default:
                return true;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray([
        $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            return $elm$parser$Parser$Advanced$Loop(0);
        }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar, $elm$parser$Parser$Expecting("is not & or <")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
        $elm$parser$Parser$Advanced$map_fn(function (_v1) {
            return $elm$parser$Parser$Advanced$Loop(0);
        }, $dillonkearns$elm_markdown$HtmlParser$escapedChar("<")),
        $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(0))
    ]);
    var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
        return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
    };
    var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$loop_fn(0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
    var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
        return $elm$parser$Parser$Advanced$loop_fn(_List_Nil, $dillonkearns$elm_markdown$HtmlParser$childrenStep($dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
        return _List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(F2(function (_v1, accum) {
                return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(accum));
            }), $dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
            $elm$parser$Parser$Advanced$andThen_fn(function (text) {
                return $elm$core$String$isEmpty(text) ? $elm$parser$Parser$Advanced$map_fn(F2(function (_v2, accum) {
                    return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(accum));
                }), $dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(function (accum) {
                    return $elm$parser$Parser$Advanced$Loop(_List_Cons($dillonkearns$elm_markdown$HtmlParser$Text(text), accum));
                });
            }, $dillonkearns$elm_markdown$HtmlParser$textNodeString),
            $elm$parser$Parser$Advanced$map_fn(F2(function (_new, accum) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(_new, accum));
            }), $dillonkearns$elm_markdown$HtmlParser$cyclic$html())
        ]);
    };
    var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Element(startTagName)), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return _List_Nil;
            }, $dillonkearns$elm_markdown$HtmlParser$symbol("/>")),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol(">")), $dillonkearns$elm_markdown$HtmlParser$children(startTagName))
        ])));
    };
    function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
            $dillonkearns$elm_markdown$HtmlParser$processingInstruction,
            $dillonkearns$elm_markdown$HtmlParser$comment,
            $dillonkearns$elm_markdown$HtmlParser$docType,
            $dillonkearns$elm_markdown$HtmlParser$cyclic$element()
        ]));
    }
    function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("<")), $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
    }
    var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
    $dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
        return $dillonkearns$elm_markdown$HtmlParser$html;
    };
    var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
    $dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
        return $dillonkearns$elm_markdown$HtmlParser$element;
    };
    var $dillonkearns$elm_markdown$Parser$Token$tab = $elm$parser$Parser$Advanced$Token_fn("\t", $elm$parser$Parser$Expecting("a tab"));
    var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("   ", $elm$parser$Parser$ExpectingSymbol("Indentation"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(" \t", $elm$parser$Parser$ExpectingSymbol("Indentation"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("  \t", $elm$parser$Parser$ExpectingSymbol("Indentation")))
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock), $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
        return !_Basics_modBy_fn(2, _int);
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
    var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
    var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
        return isTight ? 1 : 0;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn = function (joinWith, string1, string2) {
        var _v0 = _Utils_Tuple2(string1, string2);
        if (_v0.a === "") {
            return string2;
        }
        else {
            if (_v0.b === "") {
                return string1;
            }
            else {
                return _Utils_ap(string1, _Utils_ap(joinWith, string2));
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn = function (string1, string2) {
        return string1 + ("\n" + string2);
    }, $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (rawLine, _v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
    }, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
    var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem_fn = function (order, intended, marker, body) {
        return { d: body, mP: intended, nd: marker, n9: order };
    }, $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem_fn);
    var $elm$parser$Parser$Advanced$getCol = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.iR, s);
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(function (bodyStartPos) {
        return _Utils_Tuple2(bodyStartPos, "");
    }), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn(condition, $elm$parser$Parser$Problem("Expected one or more character")), $elm$parser$Parser$Advanced$chompWhile(condition));
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (bodyStartPos, item) {
        return _Utils_Tuple2(bodyStartPos, item);
    })), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $elm$parser$Parser$Advanced$getCol), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
    var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
    var $dillonkearns$elm_markdown$Parser$Token$closingParen = $elm$parser$Parser$Advanced$Token_fn(")", $elm$parser$Parser$Expecting("a `)`"));
    var $dillonkearns$elm_markdown$Parser$Token$dot = $elm$parser$Parser$Advanced$Token_fn(".", $elm$parser$Parser$Expecting("a `.`"));
    var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
    ]));
    var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
    var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = $elm$parser$Parser$Advanced$andThen_fn(function (parsed) {
        return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Starting numbers must be nine digits or less."));
    }, $dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
    var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
    var $dillonkearns$elm_markdown$Parser$Extra$upTo_fn = function (n, parser) {
        var _v0 = $elm$core$List$repeat_fn(n, parser);
        if (!_v0.b) {
            return $elm$parser$Parser$Advanced$succeed(0);
        }
        else {
            var firstParser = _v0.a;
            var remainingParsers = _v0.b;
            return $elm$core$List$foldl_fn_unwrapped(function (p, parsers) {
                return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$ignorer_fn(p, parsers),
                    $elm$parser$Parser$Advanced$succeed(0)
                ]));
            }, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                firstParser,
                $elm$parser$Parser$Advanced$succeed(0)
            ])), remainingParsers);
        }
    }, $dillonkearns$elm_markdown$Parser$Extra$upTo = F2($dillonkearns$elm_markdown$Parser$Extra$upTo_fn);
    var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
        if (parsed === 1) {
            return $elm$parser$Parser$Advanced$succeed(parsed);
        }
        else {
            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
        return previousWasBody ? $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Parser$Extra$upTo_fn(3, $dillonkearns$elm_markdown$Whitespace$space)), $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Parser$Extra$upTo_fn(3, $dillonkearns$elm_markdown$Whitespace$space)), $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
        var parseSubsequentItem = F5(function (start, order, marker, mid, _v0) {
            var end = _v0.a;
            var body = _v0.b;
            return ((end - mid) <= 4) ? $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem_fn(order, end - start, marker, body) : $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem_fn(order, (mid - start) + 1, marker, _Utils_ap($elm$core$String$repeat_fn((end - mid) - 1, " "), body));
        });
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(parseSubsequentItem), $elm$parser$Parser$Advanced$getCol), $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))), $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)), $elm$parser$Parser$Advanced$getCol), previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(_List_fromArray([$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
        return $elm$parser$Parser$Advanced$map_fn(function (item) {
            return $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(true, item.mP, item.nd, item.n9, _List_Nil, item.d);
        }, $dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = { $: 1 };
    var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$Image_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Image = F3($dillonkearns$elm_markdown$Markdown$Inline$Image_fn);
    var $dillonkearns$elm_markdown$Markdown$Inline$Link_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Link = F3($dillonkearns$elm_markdown$Markdown$Inline$Link_fn);
    var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
        var match = _v0;
        var _v1 = match.gh;
        switch (_v1.$) {
            case 0:
                return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.C);
            case 1:
                return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
            case 2:
                return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.C);
            case 3:
                var _v2 = _v1.a;
                var text = _v2.a;
                var url = _v2.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Link_fn(url, $elm$core$Maybe$Nothing, _List_fromArray([
                    $dillonkearns$elm_markdown$Markdown$Inline$Text(text)
                ]));
            case 4:
                var _v3 = _v1.a;
                var url = _v3.a;
                var maybeTitle = _v3.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Link_fn(url, maybeTitle, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.ae));
            case 5:
                var _v4 = _v1.a;
                var url = _v4.a;
                var maybeTitle = _v4.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Image_fn(url, maybeTitle, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.ae));
            case 6:
                var model = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
            case 7:
                var length = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn(length, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.ae));
            default:
                return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough($dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.ae));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
        return $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn = function (parentMatch, childMatch) {
        return { u: childMatch.u - parentMatch.ai, ae: childMatch.ae, x: childMatch.x - parentMatch.ai, C: childMatch.C, aN: childMatch.aN - parentMatch.ai, ai: childMatch.ai - parentMatch.ai, gh: childMatch.gh };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn = function (parentMatch, childMatch) {
        return {
            u: parentMatch.u,
            ae: _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn(parentMatch, childMatch), parentMatch.ae),
            x: parentMatch.x,
            C: parentMatch.C,
            aN: parentMatch.aN,
            ai: parentMatch.ai,
            gh: parentMatch.gh
        };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
        var match = _v4;
        return {
            u: match.u,
            ae: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.ae),
            x: match.x,
            C: match.C,
            aN: match.aN,
            ai: match.ai,
            gh: match.gh
        };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
        var _v2 = _List_sortBy_fn(function (_v3) {
            var match = _v3;
            return match.x;
        }, matches);
        if (!_v2.b) {
            return _List_Nil;
        }
        else {
            var first = _v2.a;
            var rest = _v2.b;
            return $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn(rest, first, _List_Nil);
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn = function (remaining, _v0, matchesTail) {
        organizeMatchesHelp: while (true) {
            var prevMatch = _v0;
            if (!remaining.b) {
                return _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch), matchesTail);
            }
            else {
                var match = remaining.a;
                var rest = remaining.b;
                if (_Utils_cmp(prevMatch.u, match.x) < 1) {
                    var $temp$remaining = rest, $temp$_v0 = match, $temp$matchesTail = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch), matchesTail);
                    remaining = $temp$remaining;
                    _v0 = $temp$_v0;
                    matchesTail = $temp$matchesTail;
                    continue organizeMatchesHelp;
                }
                else {
                    if ((_Utils_cmp(prevMatch.x, match.x) < 0) && (_Utils_cmp(prevMatch.u, match.u) > 0)) {
                        var $temp$remaining = rest, $temp$_v0 = $dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn(prevMatch, match), $temp$matchesTail = matchesTail;
                        remaining = $temp$remaining;
                        _v0 = $temp$_v0;
                        matchesTail = $temp$matchesTail;
                        continue organizeMatchesHelp;
                    }
                    else {
                        var $temp$remaining = rest, $temp$_v0 = prevMatch, $temp$matchesTail = matchesTail;
                        remaining = $temp$remaining;
                        _v0 = $temp$_v0;
                        matchesTail = $temp$matchesTail;
                        continue organizeMatchesHelp;
                    }
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = { $: 0 };
    var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
        return _String_contains_fn("&", string);
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&#([0-9]{1,8});"));
    var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
        var remain_ = _Basics_modBy_fn(16, _int);
        var remain = _Basics_modBy_fn(131070, _int);
        return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
        return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
        return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar($elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar($elm$core$Char$fromCode(65533));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
        var _v0 = match.o$;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            var _v1 = $elm$core$String$toInt(first);
            if (!_v1.$) {
                var v = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
            }
            else {
                return match.j_;
            }
        }
        else {
            return match.j_;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
    var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&([0-9a-zA-Z]+);"));
    var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("quot", 34),
        _Utils_Tuple2("amp", 38),
        _Utils_Tuple2("apos", 39),
        _Utils_Tuple2("lt", 60),
        _Utils_Tuple2("gt", 62),
        _Utils_Tuple2("nbsp", 160),
        _Utils_Tuple2("iexcl", 161),
        _Utils_Tuple2("cent", 162),
        _Utils_Tuple2("pound", 163),
        _Utils_Tuple2("curren", 164),
        _Utils_Tuple2("yen", 165),
        _Utils_Tuple2("brvbar", 166),
        _Utils_Tuple2("sect", 167),
        _Utils_Tuple2("uml", 168),
        _Utils_Tuple2("copy", 169),
        _Utils_Tuple2("ordf", 170),
        _Utils_Tuple2("laquo", 171),
        _Utils_Tuple2("not", 172),
        _Utils_Tuple2("shy", 173),
        _Utils_Tuple2("reg", 174),
        _Utils_Tuple2("macr", 175),
        _Utils_Tuple2("deg", 176),
        _Utils_Tuple2("plusmn", 177),
        _Utils_Tuple2("sup2", 178),
        _Utils_Tuple2("sup3", 179),
        _Utils_Tuple2("acute", 180),
        _Utils_Tuple2("micro", 181),
        _Utils_Tuple2("para", 182),
        _Utils_Tuple2("middot", 183),
        _Utils_Tuple2("cedil", 184),
        _Utils_Tuple2("sup1", 185),
        _Utils_Tuple2("ordm", 186),
        _Utils_Tuple2("raquo", 187),
        _Utils_Tuple2("frac14", 188),
        _Utils_Tuple2("frac12", 189),
        _Utils_Tuple2("frac34", 190),
        _Utils_Tuple2("iquest", 191),
        _Utils_Tuple2("Agrave", 192),
        _Utils_Tuple2("Aacute", 193),
        _Utils_Tuple2("Acirc", 194),
        _Utils_Tuple2("Atilde", 195),
        _Utils_Tuple2("Auml", 196),
        _Utils_Tuple2("Aring", 197),
        _Utils_Tuple2("AElig", 198),
        _Utils_Tuple2("Ccedil", 199),
        _Utils_Tuple2("Egrave", 200),
        _Utils_Tuple2("Eacute", 201),
        _Utils_Tuple2("Ecirc", 202),
        _Utils_Tuple2("Euml", 203),
        _Utils_Tuple2("Igrave", 204),
        _Utils_Tuple2("Iacute", 205),
        _Utils_Tuple2("Icirc", 206),
        _Utils_Tuple2("Iuml", 207),
        _Utils_Tuple2("ETH", 208),
        _Utils_Tuple2("Ntilde", 209),
        _Utils_Tuple2("Ograve", 210),
        _Utils_Tuple2("Oacute", 211),
        _Utils_Tuple2("Ocirc", 212),
        _Utils_Tuple2("Otilde", 213),
        _Utils_Tuple2("Ouml", 214),
        _Utils_Tuple2("times", 215),
        _Utils_Tuple2("Oslash", 216),
        _Utils_Tuple2("Ugrave", 217),
        _Utils_Tuple2("Uacute", 218),
        _Utils_Tuple2("Ucirc", 219),
        _Utils_Tuple2("Uuml", 220),
        _Utils_Tuple2("Yacute", 221),
        _Utils_Tuple2("THORN", 222),
        _Utils_Tuple2("szlig", 223),
        _Utils_Tuple2("agrave", 224),
        _Utils_Tuple2("aacute", 225),
        _Utils_Tuple2("acirc", 226),
        _Utils_Tuple2("atilde", 227),
        _Utils_Tuple2("auml", 228),
        _Utils_Tuple2("aring", 229),
        _Utils_Tuple2("aelig", 230),
        _Utils_Tuple2("ccedil", 231),
        _Utils_Tuple2("egrave", 232),
        _Utils_Tuple2("eacute", 233),
        _Utils_Tuple2("ecirc", 234),
        _Utils_Tuple2("euml", 235),
        _Utils_Tuple2("igrave", 236),
        _Utils_Tuple2("iacute", 237),
        _Utils_Tuple2("icirc", 238),
        _Utils_Tuple2("iuml", 239),
        _Utils_Tuple2("eth", 240),
        _Utils_Tuple2("ntilde", 241),
        _Utils_Tuple2("ograve", 242),
        _Utils_Tuple2("oacute", 243),
        _Utils_Tuple2("ocirc", 244),
        _Utils_Tuple2("otilde", 245),
        _Utils_Tuple2("ouml", 246),
        _Utils_Tuple2("divide", 247),
        _Utils_Tuple2("oslash", 248),
        _Utils_Tuple2("ugrave", 249),
        _Utils_Tuple2("uacute", 250),
        _Utils_Tuple2("ucirc", 251),
        _Utils_Tuple2("uuml", 252),
        _Utils_Tuple2("yacute", 253),
        _Utils_Tuple2("thorn", 254),
        _Utils_Tuple2("yuml", 255),
        _Utils_Tuple2("OElig", 338),
        _Utils_Tuple2("oelig", 339),
        _Utils_Tuple2("Scaron", 352),
        _Utils_Tuple2("scaron", 353),
        _Utils_Tuple2("Yuml", 376),
        _Utils_Tuple2("fnof", 402),
        _Utils_Tuple2("circ", 710),
        _Utils_Tuple2("tilde", 732),
        _Utils_Tuple2("Alpha", 913),
        _Utils_Tuple2("Beta", 914),
        _Utils_Tuple2("Gamma", 915),
        _Utils_Tuple2("Delta", 916),
        _Utils_Tuple2("Epsilon", 917),
        _Utils_Tuple2("Zeta", 918),
        _Utils_Tuple2("Eta", 919),
        _Utils_Tuple2("Theta", 920),
        _Utils_Tuple2("Iota", 921),
        _Utils_Tuple2("Kappa", 922),
        _Utils_Tuple2("Lambda", 923),
        _Utils_Tuple2("Mu", 924),
        _Utils_Tuple2("Nu", 925),
        _Utils_Tuple2("Xi", 926),
        _Utils_Tuple2("Omicron", 927),
        _Utils_Tuple2("Pi", 928),
        _Utils_Tuple2("Rho", 929),
        _Utils_Tuple2("Sigma", 931),
        _Utils_Tuple2("Tau", 932),
        _Utils_Tuple2("Upsilon", 933),
        _Utils_Tuple2("Phi", 934),
        _Utils_Tuple2("Chi", 935),
        _Utils_Tuple2("Psi", 936),
        _Utils_Tuple2("Omega", 937),
        _Utils_Tuple2("alpha", 945),
        _Utils_Tuple2("beta", 946),
        _Utils_Tuple2("gamma", 947),
        _Utils_Tuple2("delta", 948),
        _Utils_Tuple2("epsilon", 949),
        _Utils_Tuple2("zeta", 950),
        _Utils_Tuple2("eta", 951),
        _Utils_Tuple2("theta", 952),
        _Utils_Tuple2("iota", 953),
        _Utils_Tuple2("kappa", 954),
        _Utils_Tuple2("lambda", 955),
        _Utils_Tuple2("mu", 956),
        _Utils_Tuple2("nu", 957),
        _Utils_Tuple2("xi", 958),
        _Utils_Tuple2("omicron", 959),
        _Utils_Tuple2("pi", 960),
        _Utils_Tuple2("rho", 961),
        _Utils_Tuple2("sigmaf", 962),
        _Utils_Tuple2("sigma", 963),
        _Utils_Tuple2("tau", 964),
        _Utils_Tuple2("upsilon", 965),
        _Utils_Tuple2("phi", 966),
        _Utils_Tuple2("chi", 967),
        _Utils_Tuple2("psi", 968),
        _Utils_Tuple2("omega", 969),
        _Utils_Tuple2("thetasym", 977),
        _Utils_Tuple2("upsih", 978),
        _Utils_Tuple2("piv", 982),
        _Utils_Tuple2("ensp", 8194),
        _Utils_Tuple2("emsp", 8195),
        _Utils_Tuple2("thinsp", 8201),
        _Utils_Tuple2("zwnj", 8204),
        _Utils_Tuple2("zwj", 8205),
        _Utils_Tuple2("lrm", 8206),
        _Utils_Tuple2("rlm", 8207),
        _Utils_Tuple2("ndash", 8211),
        _Utils_Tuple2("mdash", 8212),
        _Utils_Tuple2("lsquo", 8216),
        _Utils_Tuple2("rsquo", 8217),
        _Utils_Tuple2("sbquo", 8218),
        _Utils_Tuple2("ldquo", 8220),
        _Utils_Tuple2("rdquo", 8221),
        _Utils_Tuple2("bdquo", 8222),
        _Utils_Tuple2("dagger", 8224),
        _Utils_Tuple2("Dagger", 8225),
        _Utils_Tuple2("bull", 8226),
        _Utils_Tuple2("hellip", 8230),
        _Utils_Tuple2("permil", 8240),
        _Utils_Tuple2("prime", 8242),
        _Utils_Tuple2("Prime", 8243),
        _Utils_Tuple2("lsaquo", 8249),
        _Utils_Tuple2("rsaquo", 8250),
        _Utils_Tuple2("oline", 8254),
        _Utils_Tuple2("frasl", 8260),
        _Utils_Tuple2("euro", 8364),
        _Utils_Tuple2("image", 8465),
        _Utils_Tuple2("weierp", 8472),
        _Utils_Tuple2("real", 8476),
        _Utils_Tuple2("trade", 8482),
        _Utils_Tuple2("alefsym", 8501),
        _Utils_Tuple2("larr", 8592),
        _Utils_Tuple2("uarr", 8593),
        _Utils_Tuple2("rarr", 8594),
        _Utils_Tuple2("darr", 8595),
        _Utils_Tuple2("harr", 8596),
        _Utils_Tuple2("crarr", 8629),
        _Utils_Tuple2("lArr", 8656),
        _Utils_Tuple2("uArr", 8657),
        _Utils_Tuple2("rArr", 8658),
        _Utils_Tuple2("dArr", 8659),
        _Utils_Tuple2("hArr", 8660),
        _Utils_Tuple2("forall", 8704),
        _Utils_Tuple2("part", 8706),
        _Utils_Tuple2("exist", 8707),
        _Utils_Tuple2("empty", 8709),
        _Utils_Tuple2("nabla", 8711),
        _Utils_Tuple2("isin", 8712),
        _Utils_Tuple2("notin", 8713),
        _Utils_Tuple2("ni", 8715),
        _Utils_Tuple2("prod", 8719),
        _Utils_Tuple2("sum", 8721),
        _Utils_Tuple2("minus", 8722),
        _Utils_Tuple2("lowast", 8727),
        _Utils_Tuple2("radic", 8730),
        _Utils_Tuple2("prop", 8733),
        _Utils_Tuple2("infin", 8734),
        _Utils_Tuple2("ang", 8736),
        _Utils_Tuple2("and", 8743),
        _Utils_Tuple2("or", 8744),
        _Utils_Tuple2("cap", 8745),
        _Utils_Tuple2("cup", 8746),
        _Utils_Tuple2("int", 8747),
        _Utils_Tuple2("there4", 8756),
        _Utils_Tuple2("sim", 8764),
        _Utils_Tuple2("cong", 8773),
        _Utils_Tuple2("asymp", 8776),
        _Utils_Tuple2("ne", 8800),
        _Utils_Tuple2("equiv", 8801),
        _Utils_Tuple2("le", 8804),
        _Utils_Tuple2("ge", 8805),
        _Utils_Tuple2("sub", 8834),
        _Utils_Tuple2("sup", 8835),
        _Utils_Tuple2("nsub", 8836),
        _Utils_Tuple2("sube", 8838),
        _Utils_Tuple2("supe", 8839),
        _Utils_Tuple2("oplus", 8853),
        _Utils_Tuple2("otimes", 8855),
        _Utils_Tuple2("perp", 8869),
        _Utils_Tuple2("sdot", 8901),
        _Utils_Tuple2("lceil", 8968),
        _Utils_Tuple2("rceil", 8969),
        _Utils_Tuple2("lfloor", 8970),
        _Utils_Tuple2("rfloor", 8971),
        _Utils_Tuple2("lang", 9001),
        _Utils_Tuple2("rang", 9002),
        _Utils_Tuple2("loz", 9674),
        _Utils_Tuple2("spades", 9824),
        _Utils_Tuple2("clubs", 9827),
        _Utils_Tuple2("hearts", 9829),
        _Utils_Tuple2("diams", 9830)
    ]));
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
        var _v0 = match.o$;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            var _v1 = $elm$core$Dict$get_fn(first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
            if (!_v1.$) {
                var code = _v1.a;
                return $elm$core$String$fromChar($elm$core$Char$fromCode(code));
            }
            else {
                return match.j_;
            }
        }
        else {
            return match.j_;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
    var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])"));
    var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex, function (regexMatch) {
        var _v0 = regexMatch.o$;
        if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
            var backslashes = _v0.a.a;
            var _v1 = _v0.b;
            var escapedStr = _v1.a.a;
            return _Utils_ap($elm$core$String$repeat_fn(($elm$core$String$length(backslashes) / 2) | 0, "\\"), escapedStr);
        }
        else {
            return regexMatch.j_;
        }
    });
    var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&#[Xx]([0-9a-fA-F]{1,8});"));
    var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
        var folder = F2(function (hexDigit, _int) {
            return ((_int * 16) + _Basics_modBy_fn(39, $elm$core$Char$toCode(hexDigit))) - 9;
        });
        return _String_foldl_fn(folder, 0, $elm$core$String$toLower(string));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
        var _v0 = match.o$;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode($dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
        }
        else {
            return match.j_;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
    var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
        var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
        return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals($dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals($dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
        return {
            u: 0,
            ae: _List_Nil,
            x: 0,
            C: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
            aN: 0,
            ai: 0,
            gh: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
        };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn = function (rawText, _v2, parsedMatches) {
        var matchModel = _v2;
        var updtMatch = {
            u: matchModel.u,
            ae: $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn(matchModel.C, _List_Nil, matchModel.ae),
            x: matchModel.x,
            C: matchModel.C,
            aN: matchModel.aN,
            ai: matchModel.ai,
            gh: matchModel.gh
        };
        if (!parsedMatches.b) {
            var finalStr = $elm$core$String$dropLeft_fn(matchModel.u, rawText);
            return $elm$core$String$isEmpty(finalStr) ? _List_fromArray([updtMatch]) : _List_fromArray([
                updtMatch,
                $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
            ]);
        }
        else {
            var matchHead = parsedMatches.a;
            var _v4 = matchHead.gh;
            if (!_v4.$) {
                return _List_Cons(updtMatch, parsedMatches);
            }
            else {
                return _Utils_eq(matchModel.u, matchHead.x) ? _List_Cons(updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.u, matchHead.x) < 0) ? _List_Cons(updtMatch, _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(_String_slice_fn(matchModel.u, matchHead.x, rawText)), parsedMatches)) : parsedMatches);
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn = function (rawText, parsedMatches, matches) {
        parseTextMatches: while (true) {
            if (!matches.b) {
                if (!parsedMatches.b) {
                    return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray([
                        $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
                    ]);
                }
                else {
                    var matchModel = parsedMatches.a;
                    return (matchModel.x > 0) ? _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch($elm$core$String$left_fn(matchModel.x, rawText)), parsedMatches) : parsedMatches;
                }
            }
            else {
                var match = matches.a;
                var matchesTail = matches.b;
                var $temp$rawText = rawText, $temp$parsedMatches = $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn(rawText, match, parsedMatches), $temp$matches = matchesTail;
                rawText = $temp$rawText;
                parsedMatches = $temp$parsedMatches;
                matches = $temp$matches;
                continue parseTextMatches;
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn = function (tokensL, tokensR, countL) {
        cleanAngleBracketTokens: while (true) {
            if (!tokensR.b) {
                return _List_Nil;
            }
            else {
                var hd1 = tokensR.a;
                var rest1 = tokensR.b;
                if (!tokensL.b) {
                    if (countL > 1) {
                        var $temp$tokensL = tokensL, $temp$tokensR = rest1, $temp$countL = countL - 1;
                        tokensL = $temp$tokensL;
                        tokensR = $temp$tokensR;
                        countL = $temp$countL;
                        continue cleanAngleBracketTokens;
                    }
                    else {
                        if (countL === 1) {
                            return _List_Cons(hd1, $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn(tokensL, rest1, countL - 1));
                        }
                        else {
                            var $temp$tokensL = tokensL, $temp$tokensR = rest1, $temp$countL = 0;
                            tokensL = $temp$tokensL;
                            tokensR = $temp$tokensR;
                            countL = $temp$countL;
                            continue cleanAngleBracketTokens;
                        }
                    }
                }
                else {
                    var hd = tokensL.a;
                    var rest = tokensL.b;
                    if (_Utils_cmp(hd.i, hd1.i) < 0) {
                        if (!countL) {
                            return _List_Cons(hd, $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn(rest, tokensR, countL + 1));
                        }
                        else {
                            var $temp$tokensL = rest, $temp$tokensR = tokensR, $temp$countL = countL + 1;
                            tokensL = $temp$tokensL;
                            tokensR = $temp$tokensR;
                            countL = $temp$countL;
                            continue cleanAngleBracketTokens;
                        }
                    }
                    else {
                        if (countL > 1) {
                            var $temp$tokensL = tokensL, $temp$tokensR = rest1, $temp$countL = countL - 1;
                            tokensL = $temp$tokensL;
                            tokensR = $temp$tokensR;
                            countL = $temp$countL;
                            continue cleanAngleBracketTokens;
                        }
                        else {
                            if (countL === 1) {
                                return _List_Cons(hd1, $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn(tokensL, rest1, countL - 1));
                            }
                            else {
                                var $temp$tokensL = tokensL, $temp$tokensR = rest1, $temp$countL = 0;
                                tokensL = $temp$tokensL;
                                tokensR = $temp$tokensR;
                                countL = $temp$countL;
                                continue cleanAngleBracketTokens;
                            }
                        }
                    }
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens = F3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\<)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = { $: 4 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ i: regMatch.i + backslashesLength, hl: 1, o: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen }) : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\>)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $elm$core$Maybe$Just({
                i: regMatch.i + backslashesLength,
                hl: 1,
                o: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
            });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)([^*])?(\\*+)([^*])?"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
        switch (c) {
            case "!":
                return true;
            case "\"":
                return true;
            case "#":
                return true;
            case "%":
                return true;
            case "&":
                return true;
            case "'":
                return true;
            case "(":
                return true;
            case ")":
                return true;
            case "*":
                return true;
            case ",":
                return true;
            case "-":
                return true;
            case ".":
                return true;
            case "/":
                return true;
            case ":":
                return true;
            case ";":
                return true;
            case "?":
                return true;
            case "@":
                return true;
            case "[":
                return true;
            case "]":
                return true;
            case "_":
                return true;
            case "{":
                return true;
            case "}":
                return true;
            case "~":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0 = F2(function (c, accum) {
        return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1 = false, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2($elm$core$String$foldl, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
        switch (c) {
            case " ":
                return true;
            case "\f":
                return true;
            case "\n":
                return true;
            case "\r":
                return true;
            case "\t":
                return true;
            case "\v":
                return true;
            case "\u00A0":
                return true;
            case "\u2028":
                return true;
            case "\u2029":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0 = F2(function (c, accum) {
        return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1 = false, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2($elm$core$String$foldl, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
        if (!mstring.$) {
            var string = mstring.a;
            return ($elm$core$String$isEmpty(string) || _String_foldl_fn($dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1, string)) ? 0 : (_String_foldl_fn($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1, string) ? 1 : 2);
        }
        else {
            return 0;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken_fn = function (_char, rawText, regMatch) {
        var _v0 = regMatch.o$;
        if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var maybeLeftFringe = _v1.a;
            var _v2 = _v1.b;
            var delimiter = _v2.a.a;
            var _v3 = _v2.b;
            var maybeRightFringe = _v3.a;
            var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
            var leftFringeLength = function () {
                if (!maybeLeftFringe.$) {
                    var left = maybeLeftFringe.a;
                    return $elm$core$String$length(left);
                }
                else {
                    return 0;
                }
            }();
            var mLeftFringe = ((!(!regMatch.i)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(_String_slice_fn(regMatch.i - 1, regMatch.i, rawText)) : maybeLeftFringe;
            var backslashesLength = function () {
                if (!maybeBackslashes.$) {
                    var backslashes = maybeBackslashes.a;
                    return $elm$core$String$length(backslashes);
                }
                else {
                    return 0;
                }
            }();
            var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
                if ((!mLeftFringe.$) && (mLeftFringe.a === "\\")) {
                    return true;
                }
                else {
                    return false;
                }
            }();
            var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
            var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
            if ((delimiterLength <= 0) || ((_char === "_") && ((lFringeRank === 2) && (rFringeRank === 2)))) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var index = ((regMatch.i + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
                return $elm$core$Maybe$Just({
                    i: index,
                    hl: delimiterLength,
                    o: $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn(_char, { fy: lFringeRank, fY: rFringeRank })
                });
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
        return $elm$core$List$filterMap_fn(A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, "*", str), _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\`+)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backtick = _v1.a.a;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $elm$core$Maybe$Just({
                i: regMatch.i + backslashesLength,
                hl: $elm$core$String$length(backtick),
                o: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
            });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(\\\\+)|( {2,}))\\n"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = { $: 8 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
        var _v0 = regMatch.o$;
        _v0$2: while (true) {
            if (_v0.b) {
                if (!_v0.a.$) {
                    var backslashes = _v0.a.a;
                    var backslashesLength = $elm$core$String$length(backslashes);
                    return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just({ i: (regMatch.i + backslashesLength) - 1, hl: 2, o: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken }) : $elm$core$Maybe$Nothing;
                }
                else {
                    if (_v0.b.b && (!_v0.b.a.$)) {
                        var _v1 = _v0.b;
                        return $elm$core$Maybe$Just({
                            i: regMatch.i,
                            hl: $elm$core$String$length(regMatch.j_),
                            o: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
                        });
                    }
                    else {
                        break _v0$2;
                    }
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
        var _v0 = regMatch.o$;
        _v0$2: while (true) {
            if (_v0.b) {
                if (!_v0.a.$) {
                    var backslashes = _v0.a.a;
                    var backslashesLength = $elm$core$String$length(backslashes);
                    return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ i: regMatch.i + backslashesLength, hl: 1, o: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken }) : $elm$core$Maybe$Just({ i: (regMatch.i + backslashesLength) - 1, hl: 2, o: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken });
                }
                else {
                    if (_v0.b.b) {
                        var _v1 = _v0.b;
                        return $elm$core$Maybe$Just({
                            i: regMatch.i,
                            hl: $elm$core$String$length(regMatch.j_),
                            o: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
                        });
                    }
                    else {
                        break _v0$2;
                    }
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(\\\\+)|( *))\\n"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\])"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = { $: 3 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ i: regMatch.i + backslashesLength, hl: 1, o: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose }) : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\!)?(\\[)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = { $: 2 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var maybeImageOpen = _v1.a;
            var _v2 = _v1.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
            var index = isEscaped ? ((regMatch.i + backslashesLength) + 1) : (regMatch.i + backslashesLength);
            if (isEscaped) {
                if (!maybeImageOpen.$) {
                    return $elm$core$Maybe$Just({
                        i: index,
                        hl: 1,
                        o: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
                    });
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                if (!maybeImageOpen.$) {
                    return $elm$core$Maybe$Just({ i: index, hl: 2, o: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken });
                }
                else {
                    return $elm$core$Maybe$Just({
                        i: index,
                        hl: 1,
                        o: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
                    });
                }
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
        return { $: 9, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
        var _v0 = regMatch.o$;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var tilde = _v1.a.a;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2($elm$core$String$length(tilde), $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2($elm$core$String$length(tilde), $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
            var length = _v2.a;
            var meaning = _v2.b;
            return $elm$core$Maybe$Just({ i: regMatch.i + backslashesLength, hl: length, o: meaning });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(~{2,})([^~])?"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)([^_])?(\\_+)([^_])?"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
        return $elm$core$List$filterMap_fn(A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, "_", str), _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn = function (left, right) {
        if (left.b) {
            var lfirst = left.a;
            var lrest = left.b;
            if (right.b) {
                var rfirst = right.a;
                var rrest = right.b;
                return (_Utils_cmp(lfirst.i, rfirst.i) < 0) ? _List_Cons(lfirst, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn(lrest, right)) : _List_Cons(rfirst, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn(left, rrest));
            }
            else {
                return left;
            }
        }
        else {
            return right;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens_fn(_List_sortBy_fn(function ($) {
            return $.i;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText)), _List_sortBy_fn(function ($) {
            return $.i;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText)), 0), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText))))))));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = { $: 2 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = { $: 8 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0 = $elm$url$Url$percentEncode, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1 = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex, function (match) {
        return $elm$core$Maybe$withDefault_fn(match.j_, $elm$url$Url$percentDecode(match.j_));
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
        var match = _v0;
        return _Regex_contains_fn($dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.C) ? $elm$core$Result$Ok(_Utils_update(match, {
            gh: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(_Utils_Tuple2(match.C, $elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, match.C)))
        })) : $elm$core$Result$Err(match);
    };
    var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = "[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*";
    var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\[\\s*(" + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ")\\s*\\]")));
    var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
        return original;
    };
    var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0 = $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1 = $elm$core$String$toLower, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn = function (rawUrl, maybeTitle) {
        return _Utils_Tuple2($elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)), $elm$core$Maybe$map_fn($dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn = function (matchModel, references, maybeRegexMatch) {
        var refLabel = function (str) {
            return $elm$core$String$isEmpty(str) ? matchModel.C : str;
        }($elm$core$Maybe$withDefault_fn(matchModel.C, $elm$core$Maybe$withDefault_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.o$;
        }, $elm$core$List$head), maybeRegexMatch))));
        var _v0 = $elm$core$Dict$get_fn($elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1, refLabel), references);
        if (_v0.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v1 = _v0.a;
            var rawUrl = _v1.a;
            var maybeTitle = _v1.b;
            var type_ = function () {
                var _v3 = matchModel.gh;
                if (_v3.$ === 5) {
                    return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle));
                }
                else {
                    return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle));
                }
            }();
            var regexMatchLength = function () {
                if (!maybeRegexMatch.$) {
                    var match = maybeRegexMatch.a.j_;
                    return $elm$core$String$length(match);
                }
                else {
                    return 0;
                }
            }();
            return $elm$core$Maybe$Just(_Utils_update(matchModel, { u: matchModel.u + regexMatchLength, gh: type_ }));
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3($dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn = function (remainText, _v0, references) {
        var tempMatch = _v0;
        var matches = _Regex_findAtMost_fn(1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
        return $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn(tempMatch, references, $elm$core$List$head(matches));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn);
    var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = "\\f\\v\\r\\n";
    var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = " \\t\\f\\v\\r\\n";
    var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = "(?:<([^<>" + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + ("]*)>|([^" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ("\\(\\)\\\\]*(?:\\\\.[^" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + "\\(\\)\\\\]*)*))")))));
    var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = "(?:[" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ("]+" + ("(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|" + ("\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|" + "\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?"))));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\(\\s*" + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + "\\s*\\)"))));
    var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
        var process = F2(function (a, maybeFound) {
            if (!maybeFound.$) {
                var found = maybeFound.a;
                return $elm$core$Maybe$Just(found);
            }
            else {
                return a;
            }
        });
        return $elm$core$List$foldl_fn(process, $elm$core$Maybe$Nothing, maybes);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn = function (matchModel, regexMatch) {
        var _v0 = regexMatch.o$;
        if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
            var maybeRawUrlAngleBrackets = _v0.a;
            var _v1 = _v0.b;
            var maybeRawUrlWithoutBrackets = _v1.a;
            var _v2 = _v1.b;
            var maybeTitleSingleQuotes = _v2.a;
            var _v3 = _v2.b;
            var maybeTitleDoubleQuotes = _v3.a;
            var _v4 = _v3.b;
            var maybeTitleParenthesis = _v4.a;
            var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(_List_fromArray([maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
            var toMatch = function (rawUrl) {
                return _Utils_update(matchModel, {
                    u: matchModel.u + $elm$core$String$length(regexMatch.j_),
                    gh: function () {
                        var _v5 = matchModel.gh;
                        if (_v5.$ === 5) {
                            return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
                        }
                        else {
                            return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
                        }
                    }()($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle))
                });
            };
            var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(_List_fromArray([maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
            return $elm$core$Maybe$Just(toMatch($elm$core$Maybe$withDefault_fn("", maybeRawUrl)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn = function (remainText, _v0, refs) {
        var tempMatch = _v0;
        var _v1 = _Regex_findAtMost_fn(1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
        if (_v1.b) {
            var first = _v1.a;
            var _v2 = $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn(tempMatch, first);
            if (!_v2.$) {
                var match = _v2.a;
                return $elm$core$Maybe$Just(match);
            }
            else {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn(remainText, tempMatch, refs);
            }
        }
        else {
            return $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn(remainText, tempMatch, refs);
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn = function (_v0, remainMatches) {
        var match = _v0;
        var overlappingMatches = $elm$core$List$filter(function (_v1) {
            var testMatch = _v1;
            return (_Utils_cmp(match.u, testMatch.x) > 0) && (_Utils_cmp(match.u, testMatch.u) < 0);
        });
        return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(_List_Cons(match, remainMatches)) : $elm$core$Maybe$Nothing;
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
        var match = _v0;
        return _Regex_contains_fn($dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.C) ? $elm$core$Result$Ok(_Utils_update(match, {
            gh: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(_Utils_Tuple2(match.C, "mailto:" + $elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, match.C)))
        })) : $elm$core$Result$Err(match);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn = function (innerTokens, isToken, tokens) {
        findTokenHelp: while (true) {
            if (!tokens.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var nextToken = tokens.a;
                var remainingTokens = tokens.b;
                if (isToken(nextToken)) {
                    return $elm$core$Maybe$Just(_Utils_Tuple3(nextToken, $elm$core$List$reverse(innerTokens), remainingTokens));
                }
                else {
                    var $temp$innerTokens = _List_Cons(nextToken, innerTokens), $temp$isToken = isToken, $temp$tokens = remainingTokens;
                    innerTokens = $temp$innerTokens;
                    isToken = $temp$isToken;
                    tokens = $temp$tokens;
                    continue findTokenHelp;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn = function (isToken, tokens) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn(_List_Nil, isToken, tokens);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 0;
    var $elm$parser$Parser$Advanced$getOffset = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.fK, s);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn = function (rawText, _v0) {
        var match = _v0;
        var consumedCharacters = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F3(function (startOffset, htmlTag, endOffset) {
            return { jA: htmlTag, hl: endOffset - startOffset };
        })), $elm$parser$Parser$Advanced$getOffset), $dillonkearns$elm_markdown$HtmlParser$html), $elm$parser$Parser$Advanced$getOffset);
        var parsed = $elm$parser$Parser$Advanced$run_fn(consumedCharacters, $elm$core$String$dropLeft_fn(match.x, rawText));
        if (!parsed.$) {
            var htmlTag = parsed.a.jA;
            var length = parsed.a.hl;
            var htmlToken = $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn(0, htmlTag);
            return $elm$core$Maybe$Just({ i: match.x, hl: length, o: htmlToken });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn);
    var $dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn = function (_function, result) {
        if (!result.$) {
            return result;
        }
        else {
            var err = result.a;
            return _function(err);
        }
    }, $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2($dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair_fn = function (closeToken, openToken) {
        var _v0 = openToken.o;
        if (!_v0.$) {
            if (!_v0.a) {
                var _v1 = _v0.a;
                return openToken.hl - 1 === closeToken.hl;
            }
            else {
                var _v2 = _v0.a;
                return _Utils_eq(openToken.hl, closeToken.hl);
            }
        }
        else {
            return false;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
        var _v0 = token.o;
        switch (_v0.$) {
            case 1:
                return true;
            case 2:
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken_fn = function (closeToken, openToken) {
        var _v0 = openToken.o;
        if (_v0.$ === 7) {
            var openChar = _v0.a;
            var open = _v0.b;
            var _v1 = closeToken.o;
            if (_v1.$ === 7) {
                var closeChar = _v1.a;
                var close = _v1.b;
                return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.fy, open.fY) || _Utils_eq(close.fy, close.fY)) ? ((!(!_Basics_modBy_fn(3, closeToken.hl + openToken.hl))) || ((!_Basics_modBy_fn(3, closeToken.hl)) && (!_Basics_modBy_fn(3, openToken.hl)))) : true) : false;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair_fn = function (closeToken, openToken) {
        var _v0 = function () {
            var _v1 = openToken.o;
            if (_v1.$ === 9) {
                if (!_v1.a) {
                    var _v2 = _v1.a;
                    return _Utils_Tuple2(true, openToken.hl - 1);
                }
                else {
                    var _v3 = _v1.a;
                    return _Utils_Tuple2(true, openToken.hl);
                }
            }
            else {
                return _Utils_Tuple2(false, 0);
            }
        }();
        var openTokenIsStrikethrough = _v0.a;
        var openTokenLength = _v0.b;
        var _v4 = function () {
            var _v5 = closeToken.o;
            if (_v5.$ === 9) {
                if (!_v5.a) {
                    var _v6 = _v5.a;
                    return _Utils_Tuple2(true, closeToken.hl - 1);
                }
                else {
                    var _v7 = _v5.a;
                    return _Utils_Tuple2(true, closeToken.hl);
                }
            }
            else {
                return _Utils_Tuple2(false, 0);
            }
        }();
        var closeTokenIsStrikethrough = _v4.a;
        var closeTokenLength = _v4.b;
        return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = { $: 1 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn = function (token, type_) {
        return { u: token.i + token.hl, ae: _List_Nil, x: token.i, C: "", aN: 0, ai: 0, gh: type_ };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn = function (remaining, matches) {
        lineBreakTTM: while (true) {
            if (!remaining.b) {
                return matches;
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v1 = token.o;
                if (_v1.$ === 8) {
                    var $temp$remaining = tokensTail, $temp$matches = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn(token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType), matches);
                    remaining = $temp$remaining;
                    matches = $temp$matches;
                    continue lineBreakTTM;
                }
                else {
                    var $temp$remaining = tokensTail, $temp$matches = matches;
                    remaining = $temp$remaining;
                    matches = $temp$matches;
                    continue lineBreakTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F2($dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn = function (_v0, tokensTail) {
        var match = _v0;
        return $elm$core$List$filter_fn(function (token) {
            return _Utils_cmp(token.i, match.u) > -1;
        }, tokensTail);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn = function (closeToken, escaped, matches, references, rawText, _v44) {
        var openToken = _v44.a;
        var remainTokens = _v44.c;
        var result = $dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn($dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch, $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
            return s;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, openToken, closeToken, _List_Nil)));
        if (result.$ === 1) {
            var tempMatch = result.a;
            if (escaped === 1) {
                var _v47 = $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn(rawText, tempMatch);
                if (!_v47.$) {
                    var newToken = _v47.a;
                    return $elm$core$Maybe$Just(_Utils_Tuple2(_List_Cons(newToken, remainTokens), matches));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
        else {
            var newMatch = result.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2(remainTokens, _List_Cons(newMatch, matches)));
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn = function (remaining, tokens, matches, references, rawText) {
        codeAutolinkTypeHtmlTagTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v36 = token.o;
                switch (_v36.$) {
                    case 0:
                        var _v37 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token), tokens);
                        if (!_v37.$) {
                            var code = _v37.a;
                            var _v38 = $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn(token, matches, references, rawText, code);
                            var newTokens = _v38.a;
                            var newMatches = _v38.b;
                            var $temp$remaining = tokensTail, $temp$tokens = newTokens, $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                    case 5:
                        var isEscaped = _v36.a;
                        var isAngleBracketOpen = function (_v43) {
                            var meaning = _v43.o;
                            if (meaning.$ === 4) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        var _v39 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn(isAngleBracketOpen, tokens);
                        if (!_v39.$) {
                            var found = _v39.a;
                            var _v40 = $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn(token, isEscaped, matches, references, rawText, found);
                            if (!_v40.$) {
                                var _v41 = _v40.a;
                                var newTokens = _v41.a;
                                var newMatches = _v41.b;
                                var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), newTokens), $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue codeAutolinkTypeHtmlTagTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue codeAutolinkTypeHtmlTagTTM;
                            }
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                    default:
                        var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue codeAutolinkTypeHtmlTagTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn = function (closeToken, matches, references, rawText, _v32) {
        var openToken = _v32.a;
        var remainTokens = _v32.c;
        var updatedOpenToken = function () {
            var _v33 = openToken.o;
            if ((!_v33.$) && (!_v33.a)) {
                var _v34 = _v33.a;
                return _Utils_update(openToken, { i: openToken.i + 1, hl: openToken.hl - 1 });
            }
            else {
                return openToken;
            }
        }();
        var match = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
        return _Utils_Tuple2(remainTokens, _List_Cons(match, matches));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn = function (remaining, tokens, matches, references, rawText) {
        emphasisTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v27 = token.o;
                if (_v27.$ === 7) {
                    var _char = _v27.a;
                    var leftFringeRank = _v27.b.fy;
                    var rightFringeRank = _v27.b.fY;
                    if (_Utils_eq(leftFringeRank, rightFringeRank)) {
                        if ((!(!rightFringeRank)) && ((_char !== "_") || (rightFringeRank === 1))) {
                            var _v28 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token), tokens);
                            if (!_v28.$) {
                                var found = _v28.a;
                                var _v29 = $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn(references, rawText, token, tokensTail, found);
                                var newRemaining = _v29.a;
                                var match = _v29.b;
                                var newTokens = _v29.c;
                                var $temp$remaining = newRemaining, $temp$tokens = newTokens, $temp$matches = _List_Cons(match, matches), $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue emphasisTTM;
                        }
                    }
                    else {
                        if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
                            var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue emphasisTTM;
                        }
                        else {
                            var _v30 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token), tokens);
                            if (!_v30.$) {
                                var found = _v30.a;
                                var _v31 = $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn(references, rawText, token, tokensTail, found);
                                var newRemaining = _v31.a;
                                var match = _v31.b;
                                var newTokens = _v31.c;
                                var $temp$remaining = newRemaining, $temp$tokens = newTokens, $temp$matches = _List_Cons(match, matches), $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                        }
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue emphasisTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn = function (references, rawText, closeToken, tokensTail, _v25) {
        var openToken = _v25.a;
        var innerTokens = _v25.b;
        var remainTokens = _v25.c;
        var remainLength = openToken.hl - closeToken.hl;
        var updt = (!remainLength) ? { e6: closeToken, em: openToken, fU: remainTokens, gf: tokensTail } : ((remainLength > 0) ? {
            e6: closeToken,
            em: _Utils_update(openToken, { i: openToken.i + remainLength, hl: closeToken.hl }),
            fU: _List_Cons(_Utils_update(openToken, { hl: remainLength }), remainTokens),
            gf: tokensTail
        } : {
            e6: _Utils_update(closeToken, { hl: openToken.hl }),
            em: openToken,
            fU: remainTokens,
            gf: _List_Cons(_Utils_update(closeToken, { i: closeToken.i + openToken.hl, hl: -remainLength }), tokensTail)
        });
        var match = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
            return s;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.em.hl), updt.em, updt.e6, $elm$core$List$reverse(innerTokens));
        return _Utils_Tuple3(updt.gf, match, updt.fU);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn = function (remaining, tokens, matches, references, rawText) {
        htmlElementTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v23 = token.o;
                if (_v23.$ === 6) {
                    var isOpen = _v23.a;
                    var htmlModel = _v23.b;
                    var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn(token, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)), matches), $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue htmlElementTTM;
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue htmlElementTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn = function (remaining, tokens, matches, references, rawText) {
        linkImageTypeTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v18 = token.o;
                if (_v18.$ === 3) {
                    var _v19 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
                    if (!_v19.$) {
                        var found = _v19.a;
                        var _v20 = $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn(token, tokensTail, matches, references, rawText, found);
                        if (!_v20.$) {
                            var _v21 = _v20.a;
                            var x = _v21.a;
                            var newMatches = _v21.b;
                            var newTokens = _v21.c;
                            var $temp$remaining = x, $temp$tokens = newTokens, $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue linkImageTypeTTM;
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue linkImageTypeTTM;
                        }
                    }
                    else {
                        var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue linkImageTypeTTM;
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue linkImageTypeTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn = function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
        var openToken = _v8.a;
        var innerTokens = _v8.b;
        var remainTokens = _v8.c;
        var removeOpenToken = _Utils_Tuple3(tokensTail, oldMatches, _Utils_ap(innerTokens, remainTokens));
        var remainText = $elm$core$String$dropLeft_fn(closeToken.i + 1, rawText);
        var inactivateLinkOpenToken = function (token) {
            var _v16 = token.o;
            if (_v16.$ === 1) {
                return _Utils_update(token, {
                    o: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
                });
            }
            else {
                return token;
            }
        };
        var findTempMatch = function (isLinkType) {
            return $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
                return s;
            }, isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(_Utils_Tuple2("", $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(_Utils_Tuple2("", $elm$core$Maybe$Nothing)), openToken, closeToken, $elm$core$List$reverse(innerTokens));
        };
        var _v9 = openToken.o;
        switch (_v9.$) {
            case 2:
                var tempMatch = findTempMatch(false);
                var _v10 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn(remainText, tempMatch, references);
                if (_v10.$ === 1) {
                    return $elm$core$Maybe$Just(removeOpenToken);
                }
                else {
                    var match = _v10.a;
                    var _v11 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn(match, oldMatches);
                    if (!_v11.$) {
                        var matches = _v11.a;
                        return $elm$core$Maybe$Just(_Utils_Tuple3($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn(match, tokensTail), matches, remainTokens));
                    }
                    else {
                        return $elm$core$Maybe$Just(removeOpenToken);
                    }
                }
            case 1:
                if (!_v9.a) {
                    var _v12 = _v9.a;
                    var tempMatch = findTempMatch(true);
                    var _v13 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn(remainText, tempMatch, references);
                    if (_v13.$ === 1) {
                        return $elm$core$Maybe$Just(removeOpenToken);
                    }
                    else {
                        var match = _v13.a;
                        var _v14 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn(match, oldMatches);
                        if (!_v14.$) {
                            var matches = _v14.a;
                            return $elm$core$Maybe$Just(_Utils_Tuple3($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn(match, tokensTail), matches, $elm$core$List$map_fn(inactivateLinkOpenToken, remainTokens)));
                        }
                        else {
                            return $elm$core$Maybe$Just(removeOpenToken);
                        }
                    }
                }
                else {
                    var _v15 = _v9.a;
                    return $elm$core$Maybe$Just(removeOpenToken);
                }
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM_fn = function (remaining, tokens, matches, references, rawText) {
        strikethroughTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn($elm$core$List$reverse(tokens), matches);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v5 = token.o;
                if (_v5.$ === 9) {
                    var _v6 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token), tokens);
                    if (!_v6.$) {
                        var content = _v6.a;
                        var _v7 = $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch_fn(token, matches, references, rawText, content);
                        var newTokens = _v7.a;
                        var newMatches = _v7.b;
                        var $temp$remaining = tokensTail, $temp$tokens = newTokens, $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue strikethroughTTM;
                    }
                    else {
                        var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue strikethroughTTM;
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue strikethroughTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch_fn = function (closeToken, matches, references, rawText, _v1) {
        var openToken = _v1.a;
        var remainTokens = _v1.c;
        var updatedOpenToken = function () {
            var _v2 = openToken.o;
            if ((_v2.$ === 9) && (!_v2.a)) {
                var _v3 = _v2.a;
                return _Utils_update(openToken, { i: openToken.i + 1, hl: openToken.hl - 1 });
            }
            else {
                return openToken;
            }
        }();
        var match = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
        return _Utils_Tuple2(remainTokens, _List_Cons(match, matches));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn = function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
        var textStart = openToken.i + openToken.hl;
        var textEnd = closeToken.i;
        var text = processText(_String_slice_fn(textStart, textEnd, rawText));
        var start = openToken.i;
        var end = closeToken.i + closeToken.hl;
        var match = { u: end, ae: _List_Nil, x: start, C: text, aN: textEnd, ai: textStart, gh: type_ };
        var matches = $elm$core$List$map_fn(function (_v0) {
            var matchModel = _v0;
            return $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn(match, matchModel);
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn(innerTokens, _List_Nil, references, rawText));
        return { u: end, ae: matches, x: start, C: text, aN: textEnd, ai: textStart, gh: type_ };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn = function (tokens, matches, references, rawText) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn(tokens, _List_Nil, matches, references, rawText);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn = function (refs, rawText_) {
        var rawText = $elm$core$String$trim(rawText_);
        var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
        return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn(rawText, _List_Nil, $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn(tokens, _List_Nil, refs, rawText))));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2($dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(" ", $elm$parser$Parser$Expecting(" "))),
        $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(">"))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($elm$core$Char$isAlpha, $elm$parser$Parser$Expecting("Alpha")), $elm$parser$Parser$Advanced$chompWhile(function (c) {
            return $elm$core$Char$isAlphaNum(c) || (c === "-");
        })), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(":", $elm$parser$Parser$Expecting(":"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("@", $elm$parser$Parser$Expecting("@"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("\\", $elm$parser$Parser$Expecting("\\"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("+", $elm$parser$Parser$Expecting("+"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(".", $elm$parser$Parser$Expecting(".")))
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (rawLine, _v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("<", $elm$parser$Parser$Expecting("<"))), $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag), $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
    var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$Expecting(str)));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
        var curr = _v0.a;
        var acc = _v0.b;
        var _return = $elm$core$Maybe$withDefault_fn($elm$parser$Parser$Advanced$Done(acc), $elm$core$Maybe$map_fn(function (cell) {
            return $elm$parser$Parser$Advanced$Done(_List_Cons(cell, acc));
        }, curr));
        var finishCell = $elm$core$Maybe$withDefault_fn($elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Nothing, acc)), $elm$core$Maybe$map_fn(function (cell) {
            return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Cons(cell, acc)));
        }, curr));
        var addToCurrent = function (c) {
            return _Utils_ap($elm$core$Maybe$withDefault_fn("", curr), c);
        };
        var continueCell = function (c) {
            return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Just(addToCurrent(c)), acc));
        };
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                return _return;
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("|\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return _return;
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v3) {
                return _return;
            }, $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end"))),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("|"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\\\|")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("\\"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\\\")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("|"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\|")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(finishCell)), $dillonkearns$elm_markdown$Parser$Token$parseString("|")),
            $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (_char, _v4) {
                return continueCell(_char);
            }, $elm$parser$Parser$Advanced$chompIf_fn($elm$core$Basics$always(true), $elm$parser$Parser$Problem("No character found")))
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = $elm$parser$Parser$Advanced$map_fn(A2($elm$core$List$foldl, F2(function (cell, acc) {
        return _List_Cons($elm$core$String$trim(cell), acc);
    }), _List_Nil), $elm$parser$Parser$Advanced$loop_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil), $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
    var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Parser$Token$parseString("|"),
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn = function (_v0, headersRow) {
        var columnAlignments = _v0.b;
        var headersWithAlignment = function (headers) {
            return _List_map2_fn_unwrapped(function (headerCell, alignment) {
                return { e$: alignment, fx: headerCell };
            }, headers, columnAlignments);
        };
        var combineHeaderAndDelimiter = function (headers) {
            return _Utils_eq($elm$core$List$length(headers), $elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(headersWithAlignment(headers)) : $elm$core$Result$Err("Tables must have the same number of header columns (" + ($elm$core$String$fromInt($elm$core$List$length(headers)) + (") as delimiter columns (" + ($elm$core$String$fromInt($elm$core$List$length(columnAlignments)) + ")"))));
        };
        var _v1 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
        if (!_v1.$) {
            var headers = _v1.a;
            return combineHeaderAndDelimiter(headers);
        }
        else {
            return $elm$core$Result$Err("Unable to parse previous line as a table header");
        }
    }, $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2($dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock_fn = function (language, body) {
        return { d: body, m$: language };
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
        var toInfoString = F2(function (str, _v2) {
            var _v1 = $elm$core$String$trim(str);
            if (_v1 === "") {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var trimmed = _v1;
                return $elm$core$Maybe$Just(trimmed);
            }
        });
        var _v0 = fenceCharacter.hj;
        if (!_v0) {
            return $elm$parser$Parser$Advanced$mapChompedString_fn(toInfoString, $elm$parser$Parser$Advanced$chompWhile(function (c) {
                return (c !== "`") && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
            }));
        }
        else {
            return $elm$parser$Parser$Advanced$mapChompedString_fn(toInfoString, $elm$parser$Parser$Advanced$chompWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
    var $dillonkearns$elm_markdown$Parser$Token$backtick = $elm$parser$Parser$Advanced$Token_fn("`", $elm$parser$Parser$Expecting("a '`'"));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = { e4: "`", hj: 0, k2: $dillonkearns$elm_markdown$Parser$Token$backtick };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
        switch (_int) {
            case 1:
                return $elm$parser$Parser$Advanced$succeed(0);
            case 2:
                return $elm$parser$Parser$Advanced$succeed(1);
            case 3:
                return $elm$parser$Parser$Advanced$succeed(2);
            case 4:
                return $elm$parser$Parser$Advanced$succeed(3);
            default:
                return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("Fenced code blocks should be indented no more than 3 spaces"));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn = function (minLength, fenceCharacter) {
        var builtTokens = $elm$core$List$foldl_fn_unwrapped(function (t, p) {
            return $elm$parser$Parser$Advanced$ignorer_fn(p, t);
        }, $elm$parser$Parser$Advanced$succeed(0), $elm$core$List$repeat_fn(minLength, $elm$parser$Parser$Advanced$token(fenceCharacter.k2)));
        return $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
            return _Utils_Tuple2(fenceCharacter, $elm$core$String$length(str));
        }, $elm$parser$Parser$Advanced$ignorer_fn(builtTokens, $elm$parser$Parser$Advanced$chompWhile($elm$core$Basics$eq(fenceCharacter.e4))));
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
    var $dillonkearns$elm_markdown$Parser$Token$tilde = $elm$parser$Parser$Advanced$Token_fn("~", $elm$parser$Parser$Expecting("a `~`"));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = { e4: "~", hj: 1, k2: $dillonkearns$elm_markdown$Parser$Token$tilde };
    var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Whitespace$space, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))),
        $elm$parser$Parser$Advanced$succeed(0)
    ]));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (indent, _v0) {
        var character = _v0.a;
        var length = _v0.b;
        return { e5: character, hb: indent, hl: length };
    })), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
        $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
    ])));
    var $dillonkearns$elm_markdown$Whitespace$isSpace_a0 = " ", $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq($dillonkearns$elm_markdown$Whitespace$isSpace_a0);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn = function (minLength, fenceCharacter) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(minLength, fenceCharacter)), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Parser$Extra$upTo_fn(indented, $dillonkearns$elm_markdown$Whitespace$space)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    };
    var $elm$parser$Parser$Advanced$getSource = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.h6, s);
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
        var fence = _v0.a;
        var body = _v0.b;
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(body)), $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
            $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (lineEnd, _v1) {
                return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2(fence, _Utils_ap(body, lineEnd)));
            }, $dillonkearns$elm_markdown$Whitespace$lineEnd),
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(body)), $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn(fence.hl, fence.e5))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F3(function (start, end, source) {
                return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2(fence, _Utils_ap(body, _String_slice_fn(start, end, source))));
            })), $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.hb)), $elm$parser$Parser$Advanced$getOffset), $elm$parser$Parser$Advanced$getSource)
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
        return $elm$parser$Parser$Advanced$loop_fn(_Utils_Tuple2(fence, ""), $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = $elm$parser$Parser$Advanced$andThen_fn(function (fence) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.e5), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)), $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
    var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
        dropTrailingHashes: while (true) {
            if (_String_endsWith_fn("#", headingString)) {
                var $temp$headingString = $elm$core$String$dropRight_fn(1, headingString);
                headingString = $temp$headingString;
                continue dropTrailingHashes;
            }
            else {
                return headingString;
            }
        }
    };
    var $elm$core$String$trimRight = _String_trimRight;
    var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
        var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
        return (_String_endsWith_fn(" ", droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
    };
    var $dillonkearns$elm_markdown$Parser$Token$hash = $elm$parser$Parser$Advanced$Token_fn("#", $elm$parser$Parser$Expecting("a `#`"));
    var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
        if ("#" === c) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(function (c) {
        return (c === " ") || ((c === "\n") || (c === "\r"));
    });
    var $dillonkearns$elm_markdown$Markdown$Heading$parser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading), $elm$parser$Parser$Advanced$andThen_fn(function (startingSpaces) {
        var startSpace = $elm$core$String$length(startingSpaces);
        return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("heading with < 4 spaces in front")) : $elm$parser$Parser$Advanced$succeed(startSpace);
    }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)), $elm$parser$Parser$Advanced$andThen_fn(function (additionalHashes) {
        var level = $elm$core$String$length(additionalHashes) + 1;
        return (level >= 7) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("heading with < 7 #'s")) : $elm$parser$Parser$Advanced$succeed(level);
    }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(""), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
            $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
        ]))), $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (headingText, _v0) {
            return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence($elm$core$String$trim(headingText));
        }, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
    ])));
    var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
    var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        return function (s) {
            var _v1 = _Parser_findSubString_fn(str, s.fK, s.kJ, s.iR, s.h6);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromInfo_fn(newRow, newCol, expecting, s.bx)) : $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.fK, newOffset) < 0, 0, { iR: newCol, bx: s.bx, w: s.w, fK: newOffset, kJ: newRow, h6: s.h6 });
        };
    };
    var $dillonkearns$elm_markdown$Parser$Token$greaterThan = $elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting("a `>`"));
    var $elm$parser$Parser$Advanced$Located_fn = function (row, col, context) {
        return { iR: col, bx: context, kJ: row };
    }, $elm$parser$Parser$Advanced$Located = F3($elm$parser$Parser$Advanced$Located_fn);
    var $elm$parser$Parser$Advanced$changeContext_fn = function (newContext, s) {
        return { iR: s.iR, bx: newContext, w: s.w, fK: s.fK, kJ: s.kJ, h6: s.h6 };
    }, $elm$parser$Parser$Advanced$changeContext = F2($elm$parser$Parser$Advanced$changeContext_fn);
    var $elm$parser$Parser$Advanced$inContext_fn = function (context, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse($elm$parser$Parser$Advanced$changeContext_fn(_List_Cons($elm$parser$Parser$Advanced$Located_fn(s0.kJ, s0.iR, context), s0.bx), s0));
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, a, $elm$parser$Parser$Advanced$changeContext_fn(s0.bx, s1));
            }
            else {
                var step = _v1;
                return step;
            }
        };
    }, $elm$parser$Parser$Advanced$inContext = F2($elm$parser$Parser$Advanced$inContext_fn);
    var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
        switch (_char) {
            case " ":
                return true;
            case "\n":
                return true;
            case "\t":
                return true;
            case "\v":
                return true;
            case "\f":
                return true;
            case "\r":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Parser$Token$lessThan = $elm$parser$Parser$Advanced$Token_fn("<", $elm$parser$Parser$Expecting("a `<`"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = $elm$parser$Parser$Advanced$inContext_fn("link destination", $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
        $elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
    ])));
    var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = $elm$parser$Parser$Advanced$Token_fn("]", $elm$parser$Parser$Expecting("a `]`"));
    var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = $elm$parser$Parser$Advanced$Token_fn("[", $elm$parser$Parser$Expecting("a `[`"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("]:", $elm$parser$Parser$Expecting("]:")))));
    var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = $elm$parser$Parser$Advanced$Token_fn("\"", $elm$parser$Parser$Expecting("a double quote"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
        return _String_contains_fn("\n\n", str) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("no blank line")) : $elm$parser$Parser$Advanced$succeed(str);
    };
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompWhile(function (c) {
        return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
    }), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$Whitespace$isWhitespace, $elm$parser$Parser$Expecting("Required whitespace")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
    var $dillonkearns$elm_markdown$Parser$Token$singleQuote = $elm$parser$Parser$Advanced$Token_fn("'", $elm$parser$Parser$Expecting("a single quote"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
        var inSingleQuotes = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
        var inDoubleQuotes = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
        return $elm$parser$Parser$Advanced$inContext_fn("title", $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$requiredWhitespace), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                inDoubleQuotes,
                inSingleQuotes,
                $elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
            ])))),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
        ])));
    }();
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = $elm$parser$Parser$Advanced$inContext_fn("link reference definition", $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F3(function (label, destination, title) {
        return _Utils_Tuple2(label, { mb: destination, eM: title });
    })), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser, $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Whitespace$lineEnd,
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
    var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
    var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
    var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
        var token = $dillonkearns$elm_markdown$Parser$Token$parseString($elm$core$String$fromChar(tchar));
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), token), $dillonkearns$elm_markdown$ThematicBreak$whitespace), token), $dillonkearns$elm_markdown$ThematicBreak$whitespace), token), $elm$parser$Parser$Advanced$chompWhile(function (c) {
            return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
        })), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    };
    var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$ThematicBreak$withChar("-"),
        $dillonkearns$elm_markdown$ThematicBreak$withChar("*"),
        $dillonkearns$elm_markdown$ThematicBreak$withChar("_")
    ]));
    var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$space), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
        $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
    ]));
    var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn = function (a, b) {
        return { $: 13, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn);
    var $dillonkearns$elm_markdown$Parser$Token$equals = $elm$parser$Parser$Advanced$Token_fn("=", $elm$parser$Parser$Expecting("a `=`"));
    var $dillonkearns$elm_markdown$Parser$Token$minus = $elm$parser$Parser$Advanced$Token_fn("-", $elm$parser$Parser$Expecting("a `-`"));
    var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
        var setextLevel = F3(function (level, levelToken, levelChar) {
            return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(level), $elm$parser$Parser$Advanced$token(levelToken)), $elm$parser$Parser$Advanced$chompWhile($elm$core$Basics$eq(levelChar)));
        });
        return $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (raw, level) {
            return $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn(level, raw);
        }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, "="),
            A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, "-")
        ])), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
    }();
    var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
        return { $: 9, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
    var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$chompIf_fn(condition, $elm$parser$Parser$Problem("Character not found")),
            $elm$parser$Parser$Advanced$succeed(0)
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
        return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Parser$Token$parseString("|"),
            $elm$parser$Parser$Advanced$succeed(0)
        ])) : $dillonkearns$elm_markdown$Parser$Token$parseString("|");
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("|\n"))),
            $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end"))),
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(revDelimiterColumns)), $dillonkearns$elm_markdown$Parser$Token$parseString("|")), $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end")))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(function (column) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(column, revDelimiterColumns));
            }), $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)), $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $dillonkearns$elm_markdown$Parser$Extra$maybeChomp(function (c) {
                return c === ":";
            })), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(function (c) {
                return c === "-";
            })), $dillonkearns$elm_markdown$Parser$Extra$maybeChomp(function (c) {
                return c === ":";
            }))), $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
    var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
        var _v0 = _Utils_Tuple2(_String_startsWith_fn(":", cell), _String_endsWith_fn(":", cell));
        if (_v0.a) {
            if (_v0.b) {
                return $elm$core$Maybe$Just(2);
            }
            else {
                return $elm$core$Maybe$Just(0);
            }
        }
        else {
            if (_v0.b) {
                return $elm$core$Maybe$Just(1);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = $elm$parser$Parser$Advanced$andThen_fn(function (delimiterRow) {
        var trimmed = delimiterRow.a.k7;
        var headers = delimiterRow.b;
        return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("Must have at least one column in delimiter row.")) : ((($elm$core$List$length(headers) === 1) && (!(_String_startsWith_fn("|", trimmed) && _String_endsWith_fn("|", trimmed)))) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.")) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
    }, $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (delimiterText, revDelimiterColumns) {
        return $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn({
            kF: delimiterText,
            k7: $elm$core$String$trim(delimiterText)
        }, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment, $elm$core$List$reverse(revDelimiterColumns)));
    }, $elm$parser$Parser$Advanced$loop_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
    var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
    var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn = function (expectedLength, row) {
        var rowLength = $elm$core$List$length(row);
        var _v0 = _Utils_compare_fn(expectedLength, rowLength);
        switch (_v0) {
            case 0:
                return $elm$core$List$take_fn(expectedLength, row);
            case 1:
                return row;
            default:
                return _Utils_ap(row, $elm$core$List$repeat_fn(expectedLength - rowLength, ""));
        }
    }, $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn);
    var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (row) {
            return ($elm$core$List$isEmpty(row) || $elm$core$List$all_fn($elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("A line must have at least one column")) : $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn(expectedRowLength, row));
        }, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
        var headers = _v0.a;
        var body = _v0.b;
        return $elm$parser$Parser$Advanced$map_fn(function (row) {
            return $dillonkearns$elm_markdown$Markdown$RawBlock$Table($dillonkearns$elm_markdown$Markdown$Table$Table_fn(headers, _Utils_ap(body, _List_fromArray([row]))));
        }, $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser($elm$core$List$length(headers)));
    };
    var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
    var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
    var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
    var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
    var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
    var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
        switch (level) {
            case 1:
                return $elm$core$Result$Ok(0);
            case 2:
                return $elm$core$Result$Ok(1);
            case 3:
                return $elm$core$Result$Ok(2);
            case 4:
                return $elm$core$Result$Ok(3);
            case 5:
                return $elm$core$Result$Ok(4);
            case 6:
                return $elm$core$Result$Ok(5);
            default:
                return $elm$core$Result$Err($elm$parser$Parser$Expecting("A heading with 1 to 6 #'s, but found " + $elm$core$String$fromInt(level)));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = { $: 2 };
    var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem_fn);
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem_fn = function (markerStartPos, listMarker, markerEndPos, _v0) {
        var bodyStartPos = _v0.a;
        var item = _v0.b;
        var spaceNum = bodyStartPos - markerEndPos;
        if (spaceNum <= 4) {
            return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
        }
        else {
            var intendedCodeItem = function () {
                switch (item.$) {
                    case 0:
                        var completion = item.a;
                        var string = item.b;
                        return $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem_fn(completion, _Utils_ap($elm$core$String$repeat_fn(spaceNum - 1, " "), string));
                    case 1:
                        var string = item.a;
                        return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(_Utils_ap($elm$core$String$repeat_fn(spaceNum - 1, " "), string));
                    default:
                        return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
                }
            }();
            return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
        }
    }, $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem_fn);
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(function (bodyStartPos) {
        return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
    }), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
    var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
    var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[x] ", $elm$parser$Parser$ExpectingSymbol("[x] ")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[X] ", $elm$parser$Parser$ExpectingSymbol("[X] ")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[ ] ", $elm$parser$Parser$ExpectingSymbol("[ ] "))))
    ]));
    var $dillonkearns$elm_markdown$Markdown$ListItem$parser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser, $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
        $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
    ])), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (bodyStartPos, item) {
        return _Utils_Tuple2(bodyStartPos, item);
    })), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $elm$parser$Parser$Advanced$getCol), $dillonkearns$elm_markdown$Markdown$ListItem$parser);
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $dillonkearns$elm_markdown$Parser$Extra$upTo_fn(3, $dillonkearns$elm_markdown$Whitespace$space)), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("-", $elm$parser$Parser$ExpectingSymbol("-")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("+", $elm$parser$Parser$ExpectingSymbol("+")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(2), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("*", $elm$parser$Parser$ExpectingSymbol("*"))))
    ]));
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem), $elm$parser$Parser$Advanced$getCol), $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)), $elm$parser$Parser$Advanced$getCol), previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(_List_fromArray([$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
        var parseListItem = F2(function (listmarker, unparsedListItem) {
            switch (unparsedListItem.$) {
                case 0:
                    var completion = unparsedListItem.a;
                    var body = unparsedListItem.b;
                    return {
                        d: body,
                        nd: listmarker,
                        Q: $elm$core$Maybe$Just(function () {
                            if (completion === 1) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }())
                    };
                case 1:
                    var body = unparsedListItem.a;
                    return { d: body, nd: listmarker, Q: $elm$core$Maybe$Nothing };
                default:
                    return { d: "", nd: listmarker, Q: $elm$core$Maybe$Nothing };
            }
        });
        return $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            var listmarker = _v0.a;
            var intended = _v0.b;
            var unparsedListItem = _v0.c;
            return $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(true, intended, _List_Nil, A2(parseListItem, listmarker, unparsedListItem));
        }, $dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn = function (node, blocks) {
        switch (node.$) {
            case 0:
                var tag = node.a;
                var attributes = node.b;
                var children = node.c;
                var _v106 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
                if (!_v106.$) {
                    var childrenAsBlocks = _v106.a;
                    var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, childrenAsBlocks));
                    return $elm$core$Result$Ok(_List_Cons(block, blocks));
                }
                else {
                    var err = _v106.a;
                    return $elm$core$Result$Err(err);
                }
            case 1:
                var innerText = node.a;
                var _v107 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
                if (!_v107.$) {
                    var value = _v107.a;
                    return $elm$core$Result$Ok(_Utils_ap($elm$core$List$reverse(value), blocks));
                }
                else {
                    var error = _v107.a;
                    return $elm$core$Result$Err($elm$parser$Parser$Expecting($elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
                }
            case 2:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)), blocks));
            case 3:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$Cdata(string)), blocks));
            case 4:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)), blocks));
            default:
                var declarationType = node.a;
                var content = node.b;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content)), blocks));
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
        var _v91 = state.c;
        _v91$5: while (true) {
            if (_v91.b) {
                switch (_v91.a.$) {
                    case 11:
                        var body2 = _v91.a.a;
                        var rest = _v91.b;
                        var _v92 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                        if (!_v92.$) {
                            var value = _v92.a;
                            return $elm$parser$Parser$Advanced$succeed({
                                a: _Utils_ap(state.a, value.a),
                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.c), rest)
                            });
                        }
                        else {
                            var error = _v92.a;
                            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
                        }
                    case 3:
                        var _v93 = _v91.a;
                        var tight = _v93.a;
                        var intended = _v93.b;
                        var closeListItems = _v93.c;
                        var openListItem = _v93.d;
                        var rest = _v91.b;
                        var _v94 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem.d);
                        if (!_v94.$) {
                            var value = _v94.a;
                            var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                            return $elm$parser$Parser$Advanced$succeed({
                                a: _Utils_ap(state.a, value.a),
                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight2, intended, _List_Cons({ d: value.c, Q: openListItem.Q }, closeListItems), openListItem), rest)
                            });
                        }
                        else {
                            var e = _v94.a;
                            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                        }
                    case 4:
                        var _v99 = _v91.a;
                        var tight = _v99.a;
                        var intended = _v99.b;
                        var marker = _v99.c;
                        var order = _v99.d;
                        var closeListItems = _v99.e;
                        var openListItem = _v99.f;
                        var rest = _v91.b;
                        var _v100 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem);
                        if (!_v100.$) {
                            var value = _v100.a;
                            var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                            return $elm$parser$Parser$Advanced$succeed({
                                a: _Utils_ap(state.a, value.a),
                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight2, intended, marker, order, _List_Cons(value.c, closeListItems), openListItem), rest)
                            });
                        }
                        else {
                            var e = _v100.a;
                            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                        }
                    case 10:
                        if (_v91.b.b) {
                            switch (_v91.b.a.$) {
                                case 3:
                                    var _v95 = _v91.a;
                                    var _v96 = _v91.b;
                                    var _v97 = _v96.a;
                                    var tight = _v97.a;
                                    var intended = _v97.b;
                                    var closeListItems = _v97.c;
                                    var openListItem = _v97.d;
                                    var rest = _v96.b;
                                    var _v98 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem.d);
                                    if (!_v98.$) {
                                        var value = _v98.a;
                                        var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight2, intended, _List_Cons({ d: value.c, Q: openListItem.Q }, closeListItems), openListItem), rest)
                                        });
                                    }
                                    else {
                                        var e = _v98.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                case 4:
                                    var _v101 = _v91.a;
                                    var _v102 = _v91.b;
                                    var _v103 = _v102.a;
                                    var tight = _v103.a;
                                    var intended = _v103.b;
                                    var marker = _v103.c;
                                    var order = _v103.d;
                                    var closeListItems = _v103.e;
                                    var openListItem = _v103.f;
                                    var rest = _v102.b;
                                    var _v104 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem);
                                    if (!_v104.$) {
                                        var value = _v104.a;
                                        var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight2, intended, marker, order, _List_Cons(value.c, closeListItems), openListItem), rest)
                                        });
                                    }
                                    else {
                                        var e = _v104.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                default:
                                    break _v91$5;
                            }
                        }
                        else {
                            break _v91$5;
                        }
                    default:
                        break _v91$5;
                }
            }
            else {
                break _v91$5;
            }
        }
        return $elm$parser$Parser$Advanced$succeed(state);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn = function (state, newRawBlock) {
        var _v41 = _Utils_Tuple2(newRawBlock, state.c);
        _v41$13: while (true) {
            if (_v41.b.b) {
                switch (_v41.b.a.$) {
                    case 5:
                        if (_v41.a.$ === 5) {
                            var block1 = _v41.a.a;
                            var _v42 = _v41.b;
                            var block2 = _v42.a.a;
                            var rest = _v42.b;
                            return $elm$parser$Parser$Advanced$succeed({
                                a: state.a,
                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock({
                                    d: $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(block2.d, block1.d),
                                    m$: $elm$core$Maybe$Nothing
                                }), rest)
                            });
                        }
                        else {
                            break _v41$13;
                        }
                    case 6:
                        switch (_v41.a.$) {
                            case 6:
                                var block1 = _v41.a.a;
                                var _v43 = _v41.b;
                                var block2 = _v43.a.a;
                                var rest = _v43.b;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(block2, block1)), rest)
                                });
                            case 10:
                                var _v44 = _v41.a;
                                var _v45 = _v41.b;
                                var block = _v45.a.a;
                                var rest = _v45.b;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(block, "\n")), rest)
                                });
                            default:
                                break _v41$13;
                        }
                    case 11:
                        var _v46 = _v41.b;
                        var body2 = _v46.a.a;
                        var rest = _v46.b;
                        switch (newRawBlock.$) {
                            case 11:
                                var body1 = newRawBlock.a;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(body2, body1)), rest)
                                });
                            case 1:
                                var body1 = newRawBlock.a;
                                var _v48 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                if (!_v48.$) {
                                    var value = _v48.a;
                                    var _v49 = value.c;
                                    if (_v49.b) {
                                        var last = _v49.a;
                                        if ($dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph(last) && (!_String_endsWith_fn("\n", body2))) {
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: state.a,
                                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(body2, body1)), rest)
                                            });
                                        }
                                        else {
                                            var _v50 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                            if (!_v50.$) {
                                                var value1 = _v50.a;
                                                return $elm$parser$Parser$Advanced$succeed({
                                                    a: _Utils_ap(state.a, value.a),
                                                    c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.c), rest))
                                                });
                                            }
                                            else {
                                                var e1 = _v50.a;
                                                return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
                                            }
                                        }
                                    }
                                    else {
                                        var _v51 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                        if (!_v51.$) {
                                            var value1 = _v51.a;
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.c), rest))
                                            });
                                        }
                                        else {
                                            var e1 = _v51.a;
                                            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
                                        }
                                    }
                                }
                                else {
                                    var e = _v48.a;
                                    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                }
                            case 6:
                                var body1 = newRawBlock.a;
                                var _v52 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                if (!_v52.$) {
                                    var value = _v52.a;
                                    var _v53 = value.c;
                                    if (_v53.b && (_v53.a.$ === 1)) {
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: state.a,
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn(" ", body2, body1)), rest)
                                        });
                                    }
                                    else {
                                        var _v54 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                        if (!_v54.$) {
                                            var value1 = _v54.a;
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.c), rest))
                                            });
                                        }
                                        else {
                                            var e1 = _v54.a;
                                            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
                                        }
                                    }
                                }
                                else {
                                    var e = _v52.a;
                                    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                }
                            default:
                                var _v55 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), body2);
                                if (!_v55.$) {
                                    var value = _v55.a;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: _Utils_ap(state.a, value.a),
                                        c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.c), rest))
                                    });
                                }
                                else {
                                    var e = _v55.a;
                                    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                }
                        }
                    case 3:
                        var _v56 = _v41.b;
                        var _v57 = _v56.a;
                        var tight = _v57.a;
                        var intended1 = _v57.b;
                        var closeListItems2 = _v57.c;
                        var openListItem2 = _v57.d;
                        var rest = _v56.b;
                        switch (newRawBlock.$) {
                            case 3:
                                var intended2 = newRawBlock.b;
                                var openListItem1 = newRawBlock.d;
                                if (_Utils_eq(openListItem2.nd, openListItem1.nd)) {
                                    var _v59 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2.d);
                                    if (!_v59.$) {
                                        var value = _v59.a;
                                        return $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(false, intended2, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem1), rest)
                                        }) : $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended2, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem1), rest)
                                        });
                                    }
                                    else {
                                        var e = _v59.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                }
                                else {
                                    var _v60 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2.d);
                                    if (!_v60.$) {
                                        var value = _v60.a;
                                        var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight2, intended1, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem1), rest))
                                        });
                                    }
                                    else {
                                        var e = _v60.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                }
                            case 1:
                                var body1 = newRawBlock.a;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended1, closeListItems2, _Utils_update(openListItem2, {
                                        d: $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", openListItem2.d, body1)
                                    })), rest)
                                });
                            default:
                                var _v61 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2.d);
                                if (!_v61.$) {
                                    var value = _v61.a;
                                    var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: _Utils_ap(state.a, value.a),
                                        c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight2, intended1, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem2), rest))
                                    });
                                }
                                else {
                                    var e = _v61.a;
                                    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                }
                        }
                    case 4:
                        var _v62 = _v41.b;
                        var _v63 = _v62.a;
                        var tight = _v63.a;
                        var intended1 = _v63.b;
                        var marker = _v63.c;
                        var order = _v63.d;
                        var closeListItems2 = _v63.e;
                        var openListItem2 = _v63.f;
                        var rest = _v62.b;
                        switch (newRawBlock.$) {
                            case 4:
                                var intended2 = newRawBlock.b;
                                var marker2 = newRawBlock.c;
                                var openListItem1 = newRawBlock.f;
                                if (_Utils_eq(marker, marker2)) {
                                    var _v65 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2);
                                    if (!_v65.$) {
                                        var value = _v65.a;
                                        var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight2, intended2, marker, order, _List_Cons(value.c, closeListItems2), openListItem1), rest)
                                        });
                                    }
                                    else {
                                        var e = _v65.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                }
                                else {
                                    var _v66 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2);
                                    if (!_v66.$) {
                                        var value = _v66.a;
                                        var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                        return $elm$parser$Parser$Advanced$succeed({
                                            a: _Utils_ap(state.a, value.a),
                                            c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight2, intended1, marker, order, _List_Cons(value.c, closeListItems2), openListItem2), rest))
                                        });
                                    }
                                    else {
                                        var e = _v66.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                }
                            case 1:
                                var body1 = newRawBlock.a;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended1, marker, order, closeListItems2, openListItem2 + ("\n" + body1)), rest)
                                });
                            default:
                                var _v67 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2);
                                if (!_v67.$) {
                                    var value = _v67.a;
                                    var tight2 = $elm$core$List$member_fn($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.c) ? false : tight;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: _Utils_ap(state.a, value.a),
                                        c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight2, intended1, marker, order, _List_Cons(value.c, closeListItems2), openListItem2), rest))
                                    });
                                }
                                else {
                                    var e = _v67.a;
                                    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                }
                        }
                    case 1:
                        switch (_v41.a.$) {
                            case 1:
                                var body1 = _v41.a.a;
                                var _v68 = _v41.b;
                                var body2 = _v68.a.a;
                                var rest = _v68.b;
                                return $elm$parser$Parser$Advanced$succeed({
                                    a: state.a,
                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", body2, body1)), rest)
                                });
                            case 13:
                                if (!_v41.a.a) {
                                    var _v69 = _v41.a;
                                    var _v70 = _v69.a;
                                    var _v71 = _v41.b;
                                    var unparsedInlines = _v71.a.a;
                                    var rest = _v71.b;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: state.a,
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn(1, unparsedInlines), rest)
                                    });
                                }
                                else {
                                    var _v72 = _v41.a;
                                    var _v73 = _v72.a;
                                    var _v74 = _v41.b;
                                    var unparsedInlines = _v74.a.a;
                                    var rest = _v74.b;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: state.a,
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn(2, unparsedInlines), rest)
                                    });
                                }
                            case 9:
                                var _v75 = _v41.a.a;
                                var text = _v75.a;
                                var alignments = _v75.b;
                                var _v76 = _v41.b;
                                var rawHeaders = _v76.a.a;
                                var rest = _v76.b;
                                var _v77 = $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn(text, alignments), rawHeaders);
                                if (!_v77.$) {
                                    var headers = _v77.a;
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: state.a,
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Table($dillonkearns$elm_markdown$Markdown$Table$Table_fn(headers, _List_Nil)), rest)
                                    });
                                }
                                else {
                                    return $elm$parser$Parser$Advanced$succeed({
                                        a: state.a,
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", rawHeaders, text.kF)), rest)
                                    });
                                }
                            default:
                                break _v41$13;
                        }
                    case 8:
                        if (_v41.a.$ === 8) {
                            var updatedTable = _v41.a.a;
                            var _v78 = _v41.b;
                            var rest = _v78.b;
                            return $elm$parser$Parser$Advanced$succeed({
                                a: state.a,
                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable), rest)
                            });
                        }
                        else {
                            break _v41$13;
                        }
                    case 10:
                        if (_v41.b.b.b) {
                            switch (_v41.b.b.a.$) {
                                case 4:
                                    var _v79 = _v41.b;
                                    var _v80 = _v79.a;
                                    var _v81 = _v79.b;
                                    var _v82 = _v81.a;
                                    var tight = _v82.a;
                                    var intended1 = _v82.b;
                                    var marker = _v82.c;
                                    var order = _v82.d;
                                    var closeListItems2 = _v82.e;
                                    var openListItem2 = _v82.f;
                                    var rest = _v81.b;
                                    var _v83 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2);
                                    if (!_v83.$) {
                                        var value = _v83.a;
                                        if (newRawBlock.$ === 4) {
                                            var intended2 = newRawBlock.b;
                                            var openListItem = newRawBlock.f;
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(false, intended2, marker, order, _List_Cons(value.c, closeListItems2), openListItem), rest)
                                            });
                                        }
                                        else {
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended1, marker, order, _List_Cons(value.c, closeListItems2), openListItem2), rest)))
                                            });
                                        }
                                    }
                                    else {
                                        var e = _v83.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                case 3:
                                    var _v85 = _v41.b;
                                    var _v86 = _v85.a;
                                    var _v87 = _v85.b;
                                    var _v88 = _v87.a;
                                    var tight = _v88.a;
                                    var intended1 = _v88.b;
                                    var closeListItems2 = _v88.c;
                                    var openListItem2 = _v88.d;
                                    var rest = _v87.b;
                                    var _v89 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), openListItem2.d);
                                    if (!_v89.$) {
                                        var value = _v89.a;
                                        if (newRawBlock.$ === 3) {
                                            var openListItem = newRawBlock.d;
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(false, intended1, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem), rest)
                                            });
                                        }
                                        else {
                                            return $elm$parser$Parser$Advanced$succeed({
                                                a: _Utils_ap(state.a, value.a),
                                                c: _List_Cons(newRawBlock, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended1, _List_Cons({ d: value.c, Q: openListItem2.Q }, closeListItems2), openListItem2), rest)))
                                            });
                                        }
                                    }
                                    else {
                                        var e = _v89.a;
                                        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
                                    }
                                default:
                                    break _v41$13;
                            }
                        }
                        else {
                            break _v41$13;
                        }
                    default:
                        break _v41$13;
                }
            }
            else {
                break _v41$13;
            }
        }
        return $elm$parser$Parser$Advanced$succeed({
            a: state.a,
            c: _List_Cons(newRawBlock, state.c)
        });
    }, $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn = function (referencesDict, _v36) {
        var unparsedInlines = _v36;
        var mappedReferencesDict = $elm$core$Dict$fromList($elm$core$List$map_fn($elm$core$Tuple$mapSecond(function (_v37) {
            var destination = _v37.mb;
            var title = _v37.eM;
            return _Utils_Tuple2(destination, title);
        }), referencesDict));
        return $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, $dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn(mappedReferencesDict, unparsedInlines));
    }, $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
        switch (inline.$) {
            case 0:
                var string = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
            case 1:
                return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
            case 2:
                var string = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
            case 3:
                var string = inline.a;
                var maybeString = inline.b;
                var inlines = inline.c;
                return $dillonkearns$elm_markdown$Markdown$Block$Link_fn(string, maybeString, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
            case 4:
                var string = inline.a;
                var maybeString = inline.b;
                var inlines = inline.c;
                return $dillonkearns$elm_markdown$Markdown$Block$Image_fn(string, maybeString, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
            case 5:
                var node = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline($dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
            case 6:
                var level = inline.a;
                var inlines = inline.b;
                switch (level) {
                    case 1:
                        return $dillonkearns$elm_markdown$Markdown$Block$Emphasis($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
                    case 2:
                        return $dillonkearns$elm_markdown$Markdown$Block$Strong($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
                    default:
                        return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(_List_fromArray([
                            $dillonkearns$elm_markdown$Markdown$Parser$mapInline($dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn(level - 2, inlines))
                        ])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(_List_fromArray([
                            $dillonkearns$elm_markdown$Markdown$Parser$mapInline($dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn(level - 1, inlines))
                        ]));
                }
            default:
                var inlines = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
        switch (node.$) {
            case 1:
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment("TODO this never happens, but use types to drop this case.");
            case 0:
                var tag = node.a;
                var attributes = node.b;
                var children = node.c;
                var parseChild = function (child) {
                    if (child.$ === 1) {
                        var text = child.a;
                        return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
                    }
                    else {
                        return _List_fromArray([
                            $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
                        ]);
                    }
                };
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, $elm$core$List$concatMap_fn(parseChild, children));
            case 2:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
            case 3:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
            case 4:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
            default:
                var declarationType = node.a;
                var content = node.b;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content);
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
        return $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn(children, _List_Nil);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn = function (remaining, soFar) {
        nodesToBlocksHelp: while (true) {
            if (remaining.b) {
                var node = remaining.a;
                var rest = remaining.b;
                var _v31 = $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn(node, soFar);
                if (!_v31.$) {
                    var newSoFar = _v31.a;
                    var $temp$remaining = rest, $temp$soFar = newSoFar;
                    remaining = $temp$remaining;
                    soFar = $temp$soFar;
                    continue nodesToBlocksHelp;
                }
                else {
                    var e = _v31.a;
                    return $elm$core$Result$Err(e);
                }
            }
            else {
                return $elm$core$Result$Ok($elm$core$List$reverse(soFar));
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
        var _v27 = $elm$parser$Parser$Advanced$run_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), $dillonkearns$elm_markdown$Helpers$endOfFile), input);
        if (_v27.$ === 1) {
            var e = _v27.a;
            return $elm$core$Result$Err(e);
        }
        else {
            var v = _v27.a;
            var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
            if (_v28.$ === 1) {
                var e = _v28.a;
                return $elm$parser$Parser$Advanced$run_fn($elm$parser$Parser$Advanced$problem(e), "");
            }
            else {
                var blocks = _v28.a;
                var isNotEmptyParagraph = function (block) {
                    if ((block.$ === 5) && (!block.a.b)) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };
                return $elm$core$Result$Ok($elm$core$List$filter_fn(isNotEmptyParagraph, blocks));
            }
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
        return $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn(state, state.c, _List_Nil);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn = function (state, rawBlocks, parsedBlocks) {
        parseAllInlinesHelp: while (true) {
            if (rawBlocks.b) {
                var rawBlock = rawBlocks.a;
                var rest = rawBlocks.b;
                var _v26 = $dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn(state.a, rawBlock);
                switch (_v26.$) {
                    case 1:
                        var newParsedBlock = _v26.a;
                        var $temp$state = state, $temp$rawBlocks = rest, $temp$parsedBlocks = _List_Cons(newParsedBlock, parsedBlocks);
                        state = $temp$state;
                        rawBlocks = $temp$rawBlocks;
                        parsedBlocks = $temp$parsedBlocks;
                        continue parseAllInlinesHelp;
                    case 0:
                        var $temp$state = state, $temp$rawBlocks = rest, $temp$parsedBlocks = parsedBlocks;
                        state = $temp$state;
                        rawBlocks = $temp$rawBlocks;
                        parsedBlocks = $temp$parsedBlocks;
                        continue parseAllInlinesHelp;
                    default:
                        var e = _v26.a;
                        return $elm$core$Result$Err(e);
                }
            }
            else {
                return $elm$core$Result$Ok(parsedBlocks);
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn = function (linkReferences, header) {
        return $elm$core$List$map_fn(function (_v24) {
            var label = _v24.fx;
            var alignment = _v24.e$;
            return $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn(linkReferences, function (parsedHeaderLabel) {
                return { e$: alignment, fx: parsedHeaderLabel };
            }, label);
        }, header);
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn = function (linkReferences, rawBlock) {
        switch (rawBlock.$) {
            case 0:
                var level = rawBlock.a;
                var unparsedInlines = rawBlock.b;
                var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
                if (!_v17.$) {
                    var parsedLevel = _v17.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Heading_fn(parsedLevel, $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines)));
                }
                else {
                    var e = _v17.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
                }
            case 1:
                var unparsedInlines = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines)));
            case 2:
                var html = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
            case 3:
                var tight = rawBlock.a;
                var unparsedItems = rawBlock.c;
                var parseItem = F2(function (rawBlockTask, rawBlocks) {
                    var blocksTask = function () {
                        if (!rawBlockTask.$) {
                            if (!rawBlockTask.a) {
                                return 1;
                            }
                            else {
                                return 2;
                            }
                        }
                        else {
                            return 0;
                        }
                    }();
                    var blocks = function () {
                        var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines({ a: linkReferences, c: rawBlocks });
                        if (!_v18.$) {
                            var parsedBlocks = _v18.a;
                            return parsedBlocks;
                        }
                        else {
                            return _List_Nil;
                        }
                    }();
                    return $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn(blocksTask, blocks);
                });
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$UnorderedList_fn($dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight), $elm$core$List$reverse($elm$core$List$map_fn(function (item) {
                    return A2(parseItem, item.Q, item.d);
                }, unparsedItems))));
            case 4:
                var tight = rawBlock.a;
                var startingIndex = rawBlock.d;
                var unparsedItems = rawBlock.e;
                var parseItem = function (rawBlocks) {
                    var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines({ a: linkReferences, c: rawBlocks });
                    if (!_v20.$) {
                        var parsedBlocks = _v20.a;
                        return parsedBlocks;
                    }
                    else {
                        return _List_Nil;
                    }
                };
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn($dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight), startingIndex, $elm$core$List$reverse($elm$core$List$map_fn(parseItem, unparsedItems))));
            case 5:
                var codeBlock = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
            case 7:
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
            case 10:
                return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
            case 11:
                return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
            case 12:
                var rawBlocks = rawBlock.a;
                var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines({ a: linkReferences, c: rawBlocks });
                if (!_v21.$) {
                    var parsedBlocks = _v21.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
                }
                else {
                    var e = _v21.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
                }
            case 6:
                var codeBlockBody = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$CodeBlock({ d: codeBlockBody, m$: $elm$core$Maybe$Nothing }));
            case 8:
                var _v22 = rawBlock.a;
                var header = _v22.a;
                var rows = _v22.b;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Table_fn($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn(linkReferences, header), $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn(linkReferences, rows)));
            case 9:
                var _v23 = rawBlock.a;
                var text = _v23.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, text.kF)));
            default:
                var raw = rawBlock.b;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, raw)));
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn = function (linkReferences, wrap, unparsedInlines) {
        return wrap($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines));
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn = function (linkReferences, rows) {
        return $elm$core$List$map_fn(function (row) {
            return $elm$core$List$map_fn(function (column) {
                return $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn(linkReferences, $elm$core$Basics$identity, column);
            }, row);
        }, rows);
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return $elm$parser$Parser$Advanced$Done(revStmts);
            }, $dillonkearns$elm_markdown$Helpers$endOfFile),
            $elm$parser$Parser$Advanced$map_fn(function (reference) {
                return $elm$parser$Parser$Advanced$Loop($dillonkearns$elm_markdown$Markdown$Parser$addReference_fn(revStmts, reference));
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
            function () {
                var _v3 = revStmts.c;
                _v3$6: while (true) {
                    if (_v3.b) {
                        switch (_v3.a.$) {
                            case 1:
                                return $elm$parser$Parser$Advanced$map_fn(function (block) {
                                    return $elm$parser$Parser$Advanced$Loop(block);
                                }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
                            case 8:
                                var table = _v3.a.a;
                                return $elm$parser$Parser$Advanced$map_fn(function (block) {
                                    return $elm$parser$Parser$Advanced$Loop(block);
                                }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
                                    $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
                                ]))));
                            case 3:
                                var _v4 = _v3.a;
                                var tight = _v4.a;
                                var intended = _v4.b;
                                var closeListItems = _v4.c;
                                var openListItem = _v4.d;
                                var rest = _v3.b;
                                var completeOrMergeUnorderedListBlockBlankLine = F2(function (state, newString) {
                                    return _Utils_update(state, {
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended, closeListItems, _Utils_update(openListItem, {
                                            d: $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("", openListItem.d, newString)
                                        })), rest))
                                    });
                                });
                                var completeOrMergeUnorderedListBlock = F2(function (state, newString) {
                                    return _Utils_update(state, {
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended, closeListItems, _Utils_update(openListItem, {
                                            d: $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", openListItem.d, newString)
                                        })), rest)
                                    });
                                });
                                return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$map_fn(function (_v5) {
                                        return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, "\n");
                                    }, $dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$map_fn(completeOrMergeUnorderedListBlock(revStmts), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn($elm$core$String$repeat_fn(intended, " "), $elm$parser$Parser$ExpectingSymbol("Indentation")))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
                                ]));
                            case 4:
                                var _v10 = _v3.a;
                                var tight = _v10.a;
                                var intended = _v10.b;
                                var marker = _v10.c;
                                var order = _v10.d;
                                var closeListItems = _v10.e;
                                var openListItem = _v10.f;
                                var rest = _v3.b;
                                var completeOrMergeUnorderedListBlockBlankLine = F2(function (state, newString) {
                                    return _Utils_update(state, {
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended, marker, order, closeListItems, openListItem + ("\n" + newString)), rest))
                                    });
                                });
                                var completeOrMergeUnorderedListBlock = F2(function (state, newString) {
                                    return _Utils_update(state, {
                                        c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended, marker, order, closeListItems, openListItem + ("\n" + newString)), rest)
                                    });
                                });
                                return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$map_fn(function (_v11) {
                                        return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, "\n");
                                    }, $dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$map_fn(completeOrMergeUnorderedListBlock(revStmts), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn($elm$core$String$repeat_fn(intended, " "), $elm$parser$Parser$ExpectingSymbol("Indentation")))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
                                    $elm$parser$Parser$Advanced$map_fn(function (block) {
                                        return $elm$parser$Parser$Advanced$Loop(block);
                                    }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
                                ]));
                            case 10:
                                if (_v3.b.b) {
                                    switch (_v3.b.a.$) {
                                        case 3:
                                            var _v6 = _v3.a;
                                            var _v7 = _v3.b;
                                            var _v8 = _v7.a;
                                            var tight = _v8.a;
                                            var intended = _v8.b;
                                            var closeListItems = _v8.c;
                                            var openListItem = _v8.d;
                                            var rest = _v7.b;
                                            var completeOrMergeUnorderedListBlockBlankLine = F2(function (state, newString) {
                                                return _Utils_update(state, {
                                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended, closeListItems, _Utils_update(openListItem, {
                                                        d: $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("", openListItem.d, newString)
                                                    })), rest))
                                                });
                                            });
                                            var completeOrMergeUnorderedListBlock = F2(function (state, newString) {
                                                return _Utils_update(state, {
                                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock_fn(tight, intended, closeListItems, _Utils_update(openListItem, {
                                                        d: $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", openListItem.d, newString)
                                                    })), rest)
                                                });
                                            });
                                            return ($elm$core$String$trim(openListItem.d) === "") ? $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                return $elm$parser$Parser$Advanced$Loop(block);
                                            }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$map_fn(function (_v9) {
                                                    return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, "\n");
                                                }, $dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$map_fn(completeOrMergeUnorderedListBlock(revStmts), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn($elm$core$String$repeat_fn(intended, " "), $elm$parser$Parser$ExpectingSymbol("Indentation")))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
                                            ]));
                                        case 4:
                                            var _v12 = _v3.a;
                                            var _v13 = _v3.b;
                                            var _v14 = _v13.a;
                                            var tight = _v14.a;
                                            var intended = _v14.b;
                                            var marker = _v14.c;
                                            var order = _v14.d;
                                            var closeListItems = _v14.e;
                                            var openListItem = _v14.f;
                                            var rest = _v13.b;
                                            var completeOrMergeUnorderedListBlockBlankLine = F2(function (state, newString) {
                                                return _Utils_update(state, {
                                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended, marker, order, closeListItems, openListItem + ("\n" + newString)), rest))
                                                });
                                            });
                                            var completeOrMergeUnorderedListBlock = F2(function (state, newString) {
                                                return _Utils_update(state, {
                                                    c: _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(tight, intended, marker, order, closeListItems, openListItem + ("\n" + newString)), rest)
                                                });
                                            });
                                            return ($elm$core$String$trim(openListItem) === "") ? $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                return $elm$parser$Parser$Advanced$Loop(block);
                                            }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$map_fn(function (_v15) {
                                                    return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, "\n");
                                                }, $dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$map_fn(completeOrMergeUnorderedListBlock(revStmts), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn($elm$core$String$repeat_fn(intended, " "), $elm$parser$Parser$ExpectingSymbol("Indentation")))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
                                                $elm$parser$Parser$Advanced$map_fn(function (block) {
                                                    return $elm$parser$Parser$Advanced$Loop(block);
                                                }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
                                            ]));
                                        default:
                                            break _v3$6;
                                    }
                                }
                                else {
                                    break _v3$6;
                                }
                            default:
                                break _v3$6;
                        }
                    }
                    else {
                        break _v3$6;
                    }
                }
                return $elm$parser$Parser$Advanced$map_fn(function (block) {
                    return $elm$parser$Parser$Advanced$Loop(block);
                }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
            }(),
            $elm$parser$Parser$Advanced$map_fn(function (block) {
                return $elm$parser$Parser$Advanced$Loop(block);
            }, $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts), $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
        return $elm$core$Result$withDefault_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
        switch (xmlNode.$) {
            case 1:
                var innerText = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
            case 0:
                var tag = xmlNode.a;
                var attributes = xmlNode.b;
                var children = xmlNode.c;
                var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
                if (!_v1.$) {
                    var parsedChildren = _v1.a;
                    return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, parsedChildren)));
                }
                else {
                    var err = _v1.a;
                    return $elm$parser$Parser$Advanced$problem(err);
                }
            case 2:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
            case 3:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
            case 4:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
            default:
                var declarationType = xmlNode.a;
                var content = xmlNode.b;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content)));
        }
    };
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
        return $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$completeBlocks, $elm$parser$Parser$Advanced$loop_fn({ a: _List_Nil, c: _List_Nil }, $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$blankLine,
            $dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
            $elm$parser$Parser$Advanced$map_fn(function (_v40) {
                return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
            $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
            $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
        ]));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$blankLine,
            $dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
            $elm$parser$Parser$Advanced$map_fn(function (_v39) {
                return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
            $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
            $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
        ]));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$blankLine,
            $dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
            $elm$parser$Parser$Advanced$map_fn(function (_v38) {
                return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
            $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
            $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
        ]));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
        return $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
    }
    var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
    };
    var $elm$core$Result$map2_fn = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(A2(func, a, b));
            }
        }
    }, $elm$core$Result$map2_fn_unwrapped = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(func(a, b));
            }
        }
    }, $elm$core$Result$map2 = F3($elm$core$Result$map2_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0 = $elm$core$Result$map2($elm$core$List$cons), $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1 = $elm$core$Result$Ok(_List_Nil), $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2($elm$core$List$foldr, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1);
    var $dillonkearns$elm_markdown$Markdown$Block$foldl_fn = function (_function, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var block = list.a;
                var remainingBlocks = list.b;
                switch (block.$) {
                    case 0:
                        var html = block.a;
                        if (!html.$) {
                            var children = html.c;
                            var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap(children, remainingBlocks);
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                        else {
                            var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                    case 1:
                        var blocks = block.b;
                        var childBlocks = $elm$core$List$concatMap_fn(function (_v3) {
                            var children = _v3.b;
                            return children;
                        }, blocks);
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap(childBlocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 2:
                        var blocks = block.c;
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap($elm$core$List$concat(blocks), remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 3:
                        var blocks = block.a;
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap(blocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 4:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 5:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 6:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 7:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    default:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped = function (_function, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var block = list.a;
                var remainingBlocks = list.b;
                switch (block.$) {
                    case 0:
                        var html = block.a;
                        if (!html.$) {
                            var children = html.c;
                            var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap(children, remainingBlocks);
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                        else {
                            var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                    case 1:
                        var blocks = block.b;
                        var childBlocks = $elm$core$List$concatMap_fn(function (_v3) {
                            var children = _v3.b;
                            return children;
                        }, blocks);
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap(childBlocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 2:
                        var blocks = block.c;
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap($elm$core$List$concat(blocks), remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 3:
                        var blocks = block.a;
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap(blocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 4:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 5:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 6:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 7:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    default:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$foldl = F3($dillonkearns$elm_markdown$Markdown$Block$foldl_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
        switch (block.$) {
            case 5:
                var inlines = block.a;
                return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
            case 0:
                var html = block.a;
                if (!html.$) {
                    var blocks = html.c;
                    return $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped(function (nestedBlock, soFar) {
                        return _Utils_ap(soFar, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
                    }, "", blocks);
                }
                else {
                    return "";
                }
            case 1:
                var items = block.b;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn(function (_v4) {
                    var blocks = _v4.b;
                    return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
                }, items));
            case 2:
                var items = block.c;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn(function (blocks) {
                    return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
                }, items));
            case 3:
                var blocks = block.a;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
            case 4:
                var inlines = block.b;
                return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
            case 6:
                var header = block.a;
                var rows = block.b;
                return $elm$core$String$join_fn("\n", $elm$core$List$concat(_List_fromArray([
                    $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineText, $elm$core$List$map_fn(function ($) {
                        return $.fx;
                    }, header)),
                    $elm$core$List$concat($elm$core$List$map_fn($elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText), rows))
                ])));
            case 7:
                var body = block.a.d;
                return body;
            default:
                return "";
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
        return $elm$core$List$foldl_fn($dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, "", inlines);
    };
    var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp_fn = function (inline, text) {
        switch (inline.$) {
            case 7:
                var str = inline.a;
                return _Utils_ap(text, str);
            case 8:
                return text + " ";
            case 6:
                var str = inline.a;
                return _Utils_ap(text, str);
            case 1:
                var inlines = inline.c;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            case 2:
                var inlines = inline.c;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            case 0:
                var html = inline.a;
                if (!html.$) {
                    var blocks = html.c;
                    return $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped(function (block, soFar) {
                        return _Utils_ap(soFar, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
                    }, text, blocks);
                }
                else {
                    return text;
                }
            case 4:
                var inlines = inline.a;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            case 3:
                var inlines = inline.a;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            default:
                var inlines = inline.a;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2($dillonkearns$elm_markdown$Markdown$Block$extractTextHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn = function (tagName, attributes, children, _v0, renderedChildren) {
        var htmlRenderer = _v0;
        return $elm$core$Result$andThen_fn(function (okChildren) {
            return $elm$core$Result$map_fn(function (myRenderer) {
                return myRenderer(okChildren);
            }, A3(htmlRenderer, tagName, attributes, children));
        }, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, renderedChildren));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5($dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing_fn = function (renderer, topLevelInline, soFar) {
        var _v12 = $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn(renderer, topLevelInline);
        if (!_v12.$) {
            var inline = _v12.a;
            return _List_Cons(inline, soFar);
        }
        else {
            return soFar;
        }
    }, $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3($dillonkearns$elm_markdown$Markdown$Renderer$foldThing_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn = function (renderer, blocks) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer), blocks);
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
        return function (block) {
            switch (block.$) {
                case 4:
                    var level = block.a;
                    var content = block.b;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(function (children) {
                        return renderer.g_({
                            gx: children,
                            jX: level,
                            om: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
                        });
                    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content)));
                case 5:
                    var content = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.hN, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content)));
                case 0:
                    var html = block.a;
                    if (!html.$) {
                        var tag = html.a;
                        var attributes = html.b;
                        var children = html.c;
                        return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn(renderer, tag, attributes, children));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                case 1:
                    var tight = block.a;
                    var items = block.b;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(function (listItems) {
                        return renderer.$9($elm$core$List$map_fn(function (_v7) {
                            var task = _v7.a;
                            var children = _v7.b;
                            return $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn(task, $elm$core$List$concat(children));
                        }, listItems));
                    }, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(function (_v4) {
                        var task = _v4.a;
                        var children = _v4.b;
                        return $elm$core$Result$map_fn($dillonkearns$elm_markdown$Markdown$Block$ListItem(task), $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, function (blocks) {
                            return $elm$core$List$filterMap_fn(function (listItemBlock) {
                                var _v5 = _Utils_Tuple2(tight, listItemBlock);
                                if ((_v5.a === 1) && (_v5.b.$ === 5)) {
                                    var _v6 = _v5.a;
                                    var content = _v5.b.a;
                                    return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content));
                                }
                                else {
                                    return $elm$core$Maybe$map_fn($elm$core$Result$map($elm$core$List$singleton), A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
                                }
                            }, blocks);
                        }(children)));
                    }, items))));
                case 2:
                    var tight = block.a;
                    var startingIndex = block.b;
                    var items = block.c;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(function (listItems) {
                        return A2(renderer.hK, startingIndex, $elm$core$List$map_fn(function (children) {
                            return $elm$core$List$concat(children);
                        }, listItems));
                    }, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(function (itemsblocks) {
                        return $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, function (blocks) {
                            return $elm$core$List$filterMap_fn(function (listItemBlock) {
                                var _v8 = _Utils_Tuple2(tight, listItemBlock);
                                if ((_v8.a === 1) && (_v8.b.$ === 5)) {
                                    var _v9 = _v8.a;
                                    var content = _v8.b.a;
                                    return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content));
                                }
                                else {
                                    return $elm$core$Maybe$map_fn($elm$core$Result$map($elm$core$List$singleton), A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
                                }
                            }, blocks);
                        }(itemsblocks));
                    }, items))));
                case 7:
                    var codeBlock = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.gy(codeBlock)));
                case 8:
                    return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.ik));
                case 3:
                    var nestedBlocks = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.gv, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, nestedBlocks))));
                default:
                    var header = block.a;
                    var rows = block.b;
                    var renderedHeaderCells = $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(function (_v11) {
                        var label = _v11.fx;
                        var alignment = _v11.e$;
                        return $elm$core$Result$map_fn($elm$core$Tuple$pair(alignment), $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, label));
                    }, header));
                    var renderedHeader = $elm$core$Result$map_fn(function (listListView) {
                        return renderer.ie($elm$core$List$singleton(renderer.f8($elm$core$List$map_fn(function (_v10) {
                            var maybeAlignment = _v10.a;
                            var item = _v10.b;
                            return A2(renderer.$8, maybeAlignment, item);
                        }, listListView))));
                    }, renderedHeaderCells);
                    var renderedBody = function (r) {
                        return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray([
                            renderer.ic(r)
                        ]);
                    };
                    var alignmentForColumn = function (columnIndex) {
                        return $elm$core$Maybe$andThen_fn(function ($) {
                            return $.e$;
                        }, $elm$core$List$head($elm$core$List$drop_fn(columnIndex, header)));
                    };
                    var renderRow = function (cells) {
                        return $elm$core$Result$map_fn(renderer.f8, $elm$core$Result$map_fn($elm$core$List$indexedMap(F2(function (index, cell) {
                            return A2(renderer.id, alignmentForColumn(index), cell);
                        })), $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer), cells))));
                    };
                    var renderedRows = $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(renderRow, rows));
                    return $elm$core$Maybe$Just($elm$core$Result$map2_fn_unwrapped(function (h, r) {
                        return renderer.kZ(_List_Cons(h, renderedBody(r)));
                    }, renderedHeader, renderedRows));
            }
        };
    };
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn = function (renderer, tag, attributes, children) {
        return $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn(tag, attributes, children, renderer.g3, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, children));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn = function (renderer, inline) {
        switch (inline.$) {
            case 4:
                var innerInlines = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.ib, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, innerInlines)));
            case 3:
                var innerInlines = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.gP, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, innerInlines)));
            case 5:
                var innerInlines = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.ia, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, innerInlines)));
            case 2:
                var src = inline.a;
                var title = inline.b;
                var children = inline.c;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.g4({
                    go: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
                    h6: src,
                    eM: title
                })));
            case 7:
                var string = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.C(string)));
            case 6:
                var string = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.gz(string)));
            case 1:
                var destination = inline.a;
                var title = inline.b;
                var inlines = inline.c;
                return $elm$core$Maybe$Just($elm$core$Result$andThen_fn(function (children) {
                    return $elm$core$Result$Ok(A2(renderer.jY, { mb: destination, eM: title }, children));
                }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, inlines)));
            case 8:
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.gZ));
            default:
                var html = inline.a;
                if (!html.$) {
                    var tag = html.a;
                    var attributes = html.b;
                    var children = html.c;
                    return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn(renderer, tag, attributes, children));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
        }
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn = function (renderer, styledStrings) {
        return $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer), _List_Nil, styledStrings));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$render_fn = function (renderer, ast) {
        return $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, ast));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$render = F2($dillonkearns$elm_markdown$Markdown$Renderer$render_fn);
    var $author$project$Components$markdownView = function (styles) {
        var linkTargetBlank = function (linkData) {
            return A2($elm$core$Basics$composeR, $elm$core$List$map($rtfeldman$elm_css$Html$Styled$fromUnstyled), A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$a(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href(linkData.mb),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank"),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$title, linkData.eM)
            ])), $rtfeldman$elm_css$Html$Styled$toUnstyled));
        };
        var renderer = function () {
            var defaultHtmlRenderer = $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer;
            return _Utils_update(defaultHtmlRenderer, { jY: linkTargetBlank });
        }();
        var deadEndsToString = function (deadEnds) {
            return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
        };
        return A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Parser$parse, A2($elm$core$Basics$composeR, $elm$core$Result$mapError(deadEndsToString), A2($elm$core$Basics$composeR, $elm$core$Result$andThen($dillonkearns$elm_markdown$Markdown$Renderer$render(renderer)), function (result) {
            if (!result.$) {
                var html = result.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
                ]), $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$fromUnstyled, html));
            }
            else {
                var err = result.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(styles, _List_fromArray([
                        $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                        $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh),
                        $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg)
                    ])))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(err)
                    ]))
                ]));
            }
        })));
    };
    var $rtfeldman$elm_css$Css$Global$ol_a0 = "ol", $rtfeldman$elm_css$Css$Global$ol = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$ol_a0);
    var $rtfeldman$elm_css$Css$Global$p_a0 = "p", $rtfeldman$elm_css$Css$Global$p = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$p_a0);
    var $rtfeldman$elm_css$Css$Global$pre_a0 = "pre", $rtfeldman$elm_css$Css$Global$pre = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$pre_a0);
    var $rtfeldman$elm_css$Css$Global$table_a0 = "table", $rtfeldman$elm_css$Css$Global$table = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$table_a0);
    var $rtfeldman$elm_css$Css$Global$td_a0 = "td", $rtfeldman$elm_css$Css$Global$td = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$td_a0);
    var $rtfeldman$elm_css$Css$Global$th_a0 = "th", $rtfeldman$elm_css$Css$Global$th = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$th_a0);
    var $rtfeldman$elm_css$Css$Global$ul_a0 = "ul", $rtfeldman$elm_css$Css$Global$ul = $rtfeldman$elm_css$Css$Global$typeSelector($rtfeldman$elm_css$Css$Global$ul_a0);
    var $author$project$Components$Description$viewDescription_fn = function (styles, description) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
        ]), _List_fromArray([
            A2($author$project$Components$markdownView, _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $rtfeldman$elm_css$Css$borderColor($rtfeldman$elm_css$Css$hsl_fn(0, 0, 0.8)),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $rtfeldman$elm_css$Css$batch(styles),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$ul, $rtfeldman$elm_css$Css$Global$ol]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_4])),
                    $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$p, $rtfeldman$elm_css$Css$Global$ul, $rtfeldman$elm_css$Css$Global$ol, $rtfeldman$elm_css$Css$Global$table, $rtfeldman$elm_css$Css$Global$pre]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4])),
                    $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$table]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_collapse]))
                ])),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$td, $rtfeldman$elm_css$Css$Global$th]), _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_700),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0_dot_5
                    ])),
                    $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$th]), _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                    ]))
                ]))
            ]), description),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$edit,
                a_: $author$project$Components$Description$EditorOpened(description),
                m: _List_Nil,
                bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_2])
            })
        ]));
    }, $author$project$Components$Description$viewDescription = F2($author$project$Components$Description$viewDescription_fn);
    var $author$project$Components$Description$view_fn = function (styles, toMsg, description, model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
            $author$project$Util$showElement_fn(_Utils_eq(model.gO, $elm$core$Maybe$Nothing), $author$project$Util$showElement_fn(_Utils_eq(description, $elm$core$Maybe$Nothing), $author$project$Components$textButton_fn(_List_Nil, "Add Description", toMsg($author$project$Components$Description$EditorOpened($elm$core$Maybe$withDefault_fn("", description)))))),
            $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), $author$project$Components$Description$viewDescription(styles), $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(_Utils_eq(model.gO, $elm$core$Maybe$Nothing)), description))),
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), $author$project$Components$AiEditor$view(toMsg), model.gO)
        ]));
    }, $author$project$Components$Description$view = F4($author$project$Components$Description$view_fn);
    var $author$project$Pages$Database$view = function (cfg) {
        var _v0 = cfg.j;
        switch (_v0.$) {
            case 2:
                var err = _v0.a;
                return $author$project$Components$wrapWithErrorDiv(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(err)
                ]));
            case 1:
                return $author$project$Components$pageSpinner;
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text("");
            default:
                var db = _v0.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_3xl, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$box_content]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_10]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pb_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
                            ]), _List_fromArray([
                                $author$project$Pages$Database$editableDatabaseName_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl]), cfg.gd, cfg.nu, db),
                                $author$project$Components$iconButton({
                                    bA: $author$project$Svg$edit,
                                    a_: cfg.gd($author$project$Pages$Database$DatabaseNameEditStarted(db.mw)),
                                    m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2]),
                                    bE: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5])
                                })
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn("download", db.mw),
                                    $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPathWithToken_fn($author$project$Route$Download(db.bR), cfg.b.k2)),
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline
                                    ]))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.kX]))
                                    ]), _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Download")
                                    ]))
                                ])),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPathWithToken_fn($author$project$Route$Duplicate(db.bR), cfg.b.k2)),
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$no_underline
                                    ])),
                                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank")
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.kX]))
                                    ]), _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("Duplicate")
                                    ]))
                                ]))
                            ]))
                        ])),
                        $author$project$Components$wrapErrorsStyled_fn(_List_Nil, cfg.bF),
                        A3($elm$core$Basics$apL, $author$project$Util$showElement, _Utils_eq(db.ob, $elm$core$Maybe$Nothing), $author$project$Components$assignExpiredDatabaseBanner({
                            nf: $elm$core$Maybe$Just(db),
                            hr: cfg.hr,
                            hJ: A2($elm$core$Basics$composeL, cfg.gd, $author$project$Pages$Database$OwnerSubmitted(db.bR)),
                            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]),
                            pf: cfg.pf
                        })),
                        $author$project$Util$showElement_fn(cfg.b.aQ.mx.l3, $author$project$Components$Description$view_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]), A2($elm$core$Basics$composeR, $author$project$Pages$Database$DescriptionMsgReceived, cfg.gd), db.i6, cfg.nu.i6)),
                        $author$project$Pages$Database$databaseInfoTable_fn(db, cfg)
                    ])),
                    function () {
                        var graphqlUrl = A2($author$project$Util$urlWithPathToString, cfg.b.g, "/dbs/" + ($author$project$Types$Database$unwrapId(db.bR) + "/graphql"));
                        var graphqlReadonlyUrl = A2($author$project$Util$urlWithPathToString, cfg.b.g, "/readonly/" + (db.oo + "/graphql"));
                        var curlRequest = $elm$core$String$trim(_Utils_ap($elm_community$string_extra$String$Extra$unindent("\n                        curl -X POST -H \"Content-Type: application/json\" \\\n                        --data '{\"query\": \"query{ __schema{ types{ name } } }\"}' \\\n                        "), graphqlUrl));
                        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl]))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$text("GraphQL API")
                                ]))
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                    You can now access the database\n                                    via its GraphQL endpoint.\n                                    Try it out in the\n                                    "),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$GraphiQL(db.bR)))
                                        ]), _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$text("the GraphiQL playground")
                                        ])),
                                        $rtfeldman$elm_css$Html$Styled$text("."),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                                        $rtfeldman$elm_css$Html$Styled$text("\n                                    It uses SQLite 3.41.0 to read the database.\n                                    "),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_scroll, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]))
                                        ]), _List_fromArray([
                                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$strong_a0, _List_fromArray([
                                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg]))
                                            ]), _List_fromArray([
                                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                                                    $rtfeldman$elm_css$Html$Styled$text(graphqlUrl)
                                                ]))
                                            ]))
                                        ])),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4,
                                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                                            ]))
                                        ]), _List_fromArray([
                                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$small_a0, _List_fromArray([
                                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$italic]))
                                            ]), _List_fromArray([
                                                $rtfeldman$elm_css$Html$Styled$text("\n                                        Warning:\n                                        Only use this endpoint\n                                        in secure environments\n                                        as it grants read & write access\n                                        to the database.\n                                        ")
                                            ]))
                                        ])),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil)
                                    ])),
                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_8]))
                                    ]), _List_fromArray([
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_Nil, _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$text("Read-only endpoint for public access:")
                                        ])),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$br_a0, _List_Nil, _List_Nil),
                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_scroll, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4]))
                                        ]), _List_fromArray([
                                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$strong_a0, _List_fromArray([
                                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg]))
                                            ]), _List_fromArray([
                                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                                                    $rtfeldman$elm_css$Html$Styled$text(graphqlReadonlyUrl)
                                                ]))
                                            ]))
                                        ]))
                                    ]))
                                ]))
                            ])),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                            In order to read and write data to the database,\n                            send GraphQL requests to the /graphql endpoint.\n                            E.g. to retrieve all available GraphQL types run:\n                            ")
                            ])),
                            $author$project$Components$codeView_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]), curlRequest),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_8]))
                            ]), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("\n                                For more documentation\n                                and an easy way to try out the API,\n                                please check out\n                                "),
                                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$GraphiQL(db.bR)))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$text("the GraphiQL playground")
                                ])),
                                $rtfeldman$elm_css$Html$Styled$text("!")
                            ]))
                        ]));
                    }()
                ]));
        }
    };
    var $author$project$Components$FormOverlay$Opened = function (a) {
        return { $: 0, a: a };
    };
    var $kyasu1$elm_ulid$Ulid$Ulid = $elm$core$Basics$identity;
    var $kyasu1$elm_ulid$Ulid$Internal$ulidRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, _Regex_fromStringWith_fn({ lM: true, j3: false }, "[0-9A-FGHJKMNP-TV-Z]"));
    var $kyasu1$elm_ulid$Ulid$Internal$isValid = function (s) {
        if (($elm$core$String$length(s) === 26) && _Regex_contains_fn($kyasu1$elm_ulid$Ulid$Internal$ulidRegex, s)) {
            var _v0 = $elm$core$Maybe$map_fn($elm$core$Char$toCode, $elm$core$List$head($elm$core$String$toList(s)));
            if (!_v0.$) {
                var code = _v0.a;
                return (code < 56) ? true : false;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    var $kyasu1$elm_ulid$Ulid$fromString = function (s) {
        return $kyasu1$elm_ulid$Ulid$Internal$isValid(s) ? $elm$core$Maybe$Just(s) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Util$Bool$ifElse_fn = function (ifTrue, ifFalse, predicate) {
        return predicate ? ifTrue : ifFalse;
    }, $author$project$Util$Bool$ifElse = F3($author$project$Util$Bool$ifElse_fn);
    var $author$project$Pages$Functions$isCurrentVersionOf_fn = function (functions, versionId) {
        return _Utils_eq($elm$core$Maybe$Just(versionId), $elm$core$Maybe$map_fn(function ($) {
            return $.bR;
        }, $elm$core$List$head(functions)));
    }, $author$project$Pages$Functions$isCurrentVersionOf = F2($author$project$Pages$Functions$isCurrentVersionOf_fn);
    var $kyasu1$elm_ulid$Ulid$Internal$hexToBits = function (c) {
        switch (c) {
            case "0":
                return _List_fromArray([0, 0, 0, 0]);
            case "1":
                return _List_fromArray([0, 0, 0, 1]);
            case "2":
                return _List_fromArray([0, 0, 1, 0]);
            case "3":
                return _List_fromArray([0, 0, 1, 1]);
            case "4":
                return _List_fromArray([0, 1, 0, 0]);
            case "5":
                return _List_fromArray([0, 1, 0, 1]);
            case "6":
                return _List_fromArray([0, 1, 1, 0]);
            case "7":
                return _List_fromArray([0, 1, 1, 1]);
            case "8":
                return _List_fromArray([1, 0, 0, 0]);
            case "9":
                return _List_fromArray([1, 0, 0, 1]);
            case "A":
                return _List_fromArray([1, 0, 1, 0]);
            case "B":
                return _List_fromArray([1, 0, 1, 1]);
            case "C":
                return _List_fromArray([1, 1, 0, 0]);
            case "D":
                return _List_fromArray([1, 1, 0, 1]);
            case "E":
                return _List_fromArray([1, 1, 1, 0]);
            case "F":
                return _List_fromArray([1, 1, 1, 1]);
            default:
                return _List_Nil;
        }
    };
    var $kyasu1$elm_ulid$Ulid$Internal$base32ToBits = function (c) {
        if ($elm$core$Char$isDigit(c) || (($elm$core$Char$toCode(c) >= 65) && ($elm$core$Char$toCode(c) <= 70))) {
            return _List_Cons(0, $kyasu1$elm_ulid$Ulid$Internal$hexToBits(c));
        }
        else {
            switch (c) {
                case "G":
                    return _List_fromArray([1, 0, 0, 0, 0]);
                case "H":
                    return _List_fromArray([1, 0, 0, 0, 1]);
                case "J":
                    return _List_fromArray([1, 0, 0, 1, 0]);
                case "K":
                    return _List_fromArray([1, 0, 0, 1, 1]);
                case "M":
                    return _List_fromArray([1, 0, 1, 0, 0]);
                case "N":
                    return _List_fromArray([1, 0, 1, 0, 1]);
                case "P":
                    return _List_fromArray([1, 0, 1, 1, 0]);
                case "Q":
                    return _List_fromArray([1, 0, 1, 1, 1]);
                case "R":
                    return _List_fromArray([1, 1, 0, 0, 0]);
                case "S":
                    return _List_fromArray([1, 1, 0, 0, 1]);
                case "T":
                    return _List_fromArray([1, 1, 0, 1, 0]);
                case "V":
                    return _List_fromArray([1, 1, 0, 1, 1]);
                case "W":
                    return _List_fromArray([1, 1, 1, 0, 0]);
                case "X":
                    return _List_fromArray([1, 1, 1, 0, 1]);
                case "Y":
                    return _List_fromArray([1, 1, 1, 1, 0]);
                case "Z":
                    return _List_fromArray([1, 1, 1, 1, 1]);
                default:
                    return _List_Nil;
            }
        }
    };
    var $kyasu1$elm_ulid$Ulid$Internal$bitsToInt_fn = function (baseN, bits) {
        if (!bits.b) {
            return 0;
        }
        else {
            var x = bits.a;
            var xs = bits.b;
            return (x * _Basics_pow_fn(2, baseN - 1)) + $kyasu1$elm_ulid$Ulid$Internal$bitsToInt_fn(baseN - 1, xs);
        }
    }, $kyasu1$elm_ulid$Ulid$Internal$bitsToInt = F2($kyasu1$elm_ulid$Ulid$Internal$bitsToInt_fn);
    var $kyasu1$elm_ulid$Ulid$Internal$decodeTime = function (s) {
        var bits = $elm$core$List$concat($elm$core$List$map_fn($kyasu1$elm_ulid$Ulid$Internal$base32ToBits, $elm$core$List$take_fn(10, $elm$core$String$toList(s))));
        var len = $elm$core$List$length(bits);
        return $elm$time$Time$millisToPosix($kyasu1$elm_ulid$Ulid$Internal$bitsToInt_fn(len, bits));
    };
    var $kyasu1$elm_ulid$Ulid$toTimestamp = function (_v0) {
        var ulid = _v0;
        return $kyasu1$elm_ulid$Ulid$Internal$decodeTime(ulid);
    };
    var $author$project$Pages$Functions$RepublishFunctionVersion_fn = function (a, b, c) {
        return { $: 16, a: a, b: b, c: c };
    }, $author$project$Pages$Functions$RepublishFunctionVersion = F3($author$project$Pages$Functions$RepublishFunctionVersion_fn);
    var $author$project$Toggable$toggleButton_fn = function (cfg, toggleId) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
            ])),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, !cfg.cf),
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onClick, cfg.ni),
            $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
            cfg.o0 ? $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "submit") : $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "button")
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                ])),
                cfg.cf ? $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, toggleId) : $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "")
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$batch(cfg.m)
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(cfg.eM)
                ]))
            ]))
        ]));
    }, $author$project$Toggable$toggleButton = F2($author$project$Toggable$toggleButton_fn);
    var $author$project$Toggable$confirmDialog_fn = function (cfg, toggleId) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(cfg.no),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between]))
            ]), _List_fromArray([
                $author$project$Toggable$toggleButton_fn({
                    cf: true,
                    ni: $elm$core$Maybe$Nothing,
                    m: cfg.lJ,
                    o0: false,
                    eM: $elm$core$Maybe$withDefault_fn("Cancel", cfg.lL)
                }, toggleId),
                $author$project$Toggable$toggleButton_fn({
                    cf: true,
                    ni: $elm$core$Maybe$Just(cfg.hG),
                    m: cfg.lJ,
                    o0: false,
                    eM: $elm$core$Maybe$withDefault_fn("Proceed", cfg.iU)
                }, toggleId)
            ]))
        ]));
    }, $author$project$Toggable$confirmDialog = F2($author$project$Toggable$confirmDialog_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_5 = $rtfeldman$elm_css$Css$property_fn("height", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_none = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0px"),
        $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0px")
    ]));
    var $author$project$Components$Editor$viewReadonly_fn = function (styles, model) {
        return $author$project$Components$Editor$viewBase_fn(_List_fromArray([
            $rtfeldman$elm_css$Css$batch(styles),
            $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$textarea_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden]))
            ]))
        ]), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model);
    }, $author$project$Components$Editor$viewReadonly = F2($author$project$Components$Editor$viewReadonly_fn);
    var $author$project$Pages$Functions$versionOverlay_fn = function (dbId, _function, versionId) {
        var republishButton = $author$project$Toggable$modalToggle({
            lR: true,
            bR: "republish-modal",
            nj: $elm$core$Maybe$Just($author$project$Toggable$toggleButton({
                cf: true,
                ni: $elm$core$Maybe$Nothing,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_base,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$brightness_90])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
                ]),
                o0: false,
                eM: "Republish"
            })),
            nt: $author$project$Toggable$confirmDialog({
                lJ: _List_fromArray([$author$project$Theme$theme.oY]),
                lL: $elm$core$Maybe$Just("Cancel"),
                iU: $elm$core$Maybe$Just("Republish"),
                no: "Do you really want to republish this version?",
                hG: $author$project$Pages$Functions$RepublishFunctionVersion_fn(dbId, _function, versionId),
                m: _List_fromArray([$author$project$Theme$theme.mc])
            })
        });
        var overlayContent = function () {
            var toError = function (errorMsg) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(errorMsg)
                ]));
            };
            var maybeRemoteData = $elm$core$Maybe$map_fn(function ($) {
                return $.i_;
            }, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.bR;
            }, $elm$core$Basics$eq(versionId)), _function.le));
            if (maybeRemoteData.$ === 1) {
                return toError("Function version not found");
            }
            else {
                var remoteData = maybeRemoteData.a;
                switch (remoteData.$) {
                    case 2:
                        return toError("Function version failed to load");
                    case 1:
                        return $author$project$Components$pageSpinner;
                    case 0:
                        return $author$project$Components$pageSpinner;
                    default:
                        var version = remoteData.a;
                        return $author$project$Components$Editor$viewReadonly_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_none]), $author$project$Components$Editor$init_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Types$Function$Runtime$toParser(version.oJ)), version.gB));
                }
            }
        }();
        return $author$project$Dialog$customizedDialog_fn({
            cT: _List_Nil,
            bv: $elm$core$Maybe$Nothing,
            gB: overlayContent,
            cj: $matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300,
            m: _List_fromArray([
                $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn($rtfeldman$elm_css$Css$important_a0, $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$unset)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 20)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 1))),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vh_a0, $rtfeldman$elm_css$Css$vh_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 2))),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 2)))
                ]))
            ]),
            eM: "",
            eN: _List_fromArray([
                $author$project$Util$hideElement_fn($author$project$Pages$Functions$isCurrentVersionOf_fn(_function.le, versionId), republishButton)
            ]),
            eO: _List_Nil
        }, $author$project$Pages$Functions$NavigateReplace($author$project$Pages$Functions$Route$Versions_fn(_function.bR, $elm$core$Maybe$Nothing)));
    }, $author$project$Pages$Functions$versionOverlay = F3($author$project$Pages$Functions$versionOverlay_fn);
    var $author$project$Pages$Functions$DataEditorMsg_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Functions$DataEditorMsg = F2($author$project$Pages$Functions$DataEditorMsg_fn);
    var $author$project$Pages$Functions$EditorMsg_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Pages$Functions$EditorMsg = F2($author$project$Pages$Functions$EditorMsg_fn);
    var $author$project$Pages$Functions$ExecuteFunction = function (a) {
        return { $: 21, a: a };
    };
    var $author$project$Pages$Functions$GqlResponseMsg_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Pages$Functions$GqlResponseMsg = F2($author$project$Pages$Functions$GqlResponseMsg_fn);
    var $author$project$Pages$Functions$RevertChangesIntended = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Pages$Functions$SaveFunction_fn = function (a, b) {
        return { $: 14, a: a, b: b };
    }, $author$project$Pages$Functions$SaveFunction = F2($author$project$Pages$Functions$SaveFunction_fn);
    var $author$project$Pages$Functions$UpdateTab = function (a) {
        return { $: 28, a: a };
    };
    var $author$project$Pages$Functions$FunctionTab$contentChanged_fn = function (tab, _function) {
        return !_Utils_eq($elm$core$Maybe$Just($elm$core$Basics$composeR_fn($author$project$Pages$Functions$FunctionTab$toContent_a0, $author$project$Pages$Functions$FunctionTab$toContent_a1, tab)), _function.gB);
    }, $author$project$Pages$Functions$FunctionTab$contentChanged = F2($author$project$Pages$Functions$FunctionTab$contentChanged_fn);
    var $author$project$Pages$Functions$FunctionTab$dataChanged = function (tab) {
        return $author$project$Components$Editor$contentChanged(tab.lY);
    };
    var $author$project$Types$Function$Runtime$fromString = function (string) {
        return _String_startsWith_fn("TypeScript", string) ? $elm$core$Maybe$Just(0) : (_String_startsWith_fn("Python", string) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing);
    };
    var $author$project$Pages$Functions$FunctionTab$hasNoResponse = function (tab) {
        return _Utils_eq(tab.mE.aw, $elm$core$Maybe$Nothing);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_5 = $rtfeldman$elm_css$Css$property_fn("margin-top", "1.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_600 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "220", "38", "38", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Pages$Functions$FunctionTab$runtimeChanged_fn = function (tab, _function) {
        return !_Utils_eq(tab.oJ, _function.oJ);
    }, $author$project$Pages$Functions$FunctionTab$runtimeChanged = F2($author$project$Pages$Functions$FunctionTab$runtimeChanged_fn);
    var $author$project$Pages$Functions$FunctionTab$setMaybeRuntime_fn = function (tab, maybeRuntime) {
        if (maybeRuntime.$ === 1) {
            return tab;
        }
        else {
            var runtime = maybeRuntime.a;
            return _Utils_update(tab, {
                gO: $author$project$Components$Editor$setParser_fn($author$project$Types$Function$Runtime$toParser(runtime), tab.gO),
                oJ: runtime
            });
        }
    }, $author$project$Pages$Functions$FunctionTab$setMaybeRuntime = F2($author$project$Pages$Functions$FunctionTab$setMaybeRuntime_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$readonly_a0 = "readOnly", $rtfeldman$elm_css$Html$Styled$Attributes$readonly = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$readonly_a0);
    var $author$project$Components$urlBox = function (cfg) {
        var wrapper = function () {
            var _v0 = cfg.fx;
            if (!_v0.$) {
                var label_ = _v0.a;
                return $author$project$Components$wrapWithLabel({ jS: label_, jT: "", jU: _List_Nil, m: cfg.lj });
            }
            else {
                return A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$span(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(cfg.lj)
                ])));
            }
        }();
        var fittingInput = F2(function (value_, styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1,
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
                            $rtfeldman$elm_css$Css$property_fn("scroll-padding", "0 0 2em 2em"),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre,
                            $rtfeldman$elm_css$Css$batch(styles)
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(_Utils_ap(value_, $author$project$Util$zeroWidthString))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "url"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, value_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$readonly_a0, true),
                    $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$resize_none,
                        $rtfeldman$elm_css$Css$property_fn("overflow", "-moz-hidden-unscrollable")
                    ]))
                ]), _List_Nil)
            ]));
        });
        return wrapper(A2(fittingInput, cfg.g, _List_fromArray([
            $author$project$Theme$theme.fu,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
            $rtfeldman$elm_css$Css$batch(cfg.m)
        ])));
    };
    var $author$project$Components$GqlResponse$RawResponse = 1;
    var $author$project$Components$GqlResponse$SetFormat = function (a) {
        return { $: 0, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_72 = $rtfeldman$elm_css$Css$property_fn("height", "18rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_96 = $rtfeldman$elm_css$Css$property_fn("height", "24rem");
    var $author$project$Components$GqlResponse$heightStyle = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_72,
        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_96]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$content_center = $rtfeldman$elm_css$Css$property_fn("align-content", "center");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_color = function (color) {
        return $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
            $rtfeldman$elm_css$Css$Global$selector_fn(":not([hidden]) ~ :not([hidden])", _List_fromArray([
                $matheus23$elm_tailwind_modules_base$Tailwind$Color$propertyWithColor_fn("border-color", function (c) {
                    return c;
                }, $elm$core$Maybe$Just("--tw-divide-opacity"), color)
            ]))
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_solid = $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
        $rtfeldman$elm_css$Css$Global$selector_fn(":not([hidden]) ~ :not([hidden])", _List_fromArray([
            $rtfeldman$elm_css$Css$property_fn("border-style", "solid")
        ]))
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_x = $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
        $rtfeldman$elm_css$Css$Global$selector_fn(":not([hidden]) ~ :not([hidden])", _List_fromArray([
            $rtfeldman$elm_css$Css$property_fn("--tw-divide-x-reverse", "0"),
            $rtfeldman$elm_css$Css$property_fn("border-right-width", "calc(1px * var(--tw-divide-x-reverse))"),
            $rtfeldman$elm_css$Css$property_fn("border-left-width", "calc(1px * calc(1 - var(--tw-divide-x-reverse)))")
        ]))
    ]));
    var $author$project$Components$radioOptionsBar = function (cfg) {
        var toOption = function (_v0) {
            var title = _v0.eM;
            var getter = _v0.mD;
            var setter = _v0.hX;
            var id_ = A2($author$project$Util$titleToId, "radio", title);
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$content_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "radio"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$name_a0, cfg.M),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, getter(cfg.h7)),
                    $rtfeldman$elm_css$Html$Styled$Events$onCheck(A2($elm$core$Basics$composeR, setter(cfg.h7), cfg.hX)),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer]))
                ]), _List_Nil),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$label_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$for_a0, id_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(title)
                ]))
            ]));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_xl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_x,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$divide_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), $elm$core$List$map_fn(toOption, cfg.cx));
    };
    var $author$project$TabView$SendMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Components$GqlResponse$SetMetaDataFocus = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Components$GqlResponse$decodeData = _Json_decodeField_fn("data", $elm$json$Json$Decode$value);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_rows_1 = $rtfeldman$elm_css$Css$property_fn("grid-template-rows", "repeat(1, minmax(0, 1fr))");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_rows_2 = $rtfeldman$elm_css$Css$property_fn("grid-template-rows", "repeat(2, minmax(0, 1fr))");
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$syntaxToStyle = function (syntax) {
        switch (syntax) {
            case 0:
                return _Utils_Tuple2(3, "json-s");
            case 1:
                return _Utils_Tuple2(2, "json-e");
            case 2:
                return _Utils_Tuple2(2, "json-n");
            case 3:
                return _Utils_Tuple2(4, "json-b");
            case 4:
                return _Utils_Tuple2(4, "json-null");
            case 5:
                return _Utils_Tuple2(5, "json-k");
            case 6:
                return _Utils_Tuple2(0, "json-o");
            default:
                return _Utils_Tuple2(0, "json-a");
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Array = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Boolean = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Null = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Object = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$ObjectKey = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$String = 0;
    var $elm$parser$Parser$ExpectingKeyword = function (a) {
        return { $: 9, a: a };
    };
    var $elm$parser$Parser$Advanced$keyword = function (_v0) {
        var kwd = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(kwd);
        return function (s) {
            var _v1 = _Parser_isSubString_fn(kwd, s.fK, s.kJ, s.iR, s.h6);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return (newOffset === -1 || (0 <= _Parser_isSubChar_fn(function (c) {
                return $elm$core$Char$isAlphaNum(c) || (c === "_");
            }, newOffset, s.h6))) ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : $elm$parser$Parser$Advanced$Good_fn(progress, 0, { iR: newCol, bx: s.bx, w: s.w, fK: newOffset, kJ: newRow, h6: s.h6 });
        };
    };
    var $elm$parser$Parser$keyword = function (kwd) {
        return $elm$parser$Parser$Advanced$keyword($elm$parser$Parser$Advanced$Token_fn(kwd, $elm$parser$Parser$ExpectingKeyword(kwd)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Number = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$float));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumberExponentialNotation = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol("-"))), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$numberExponentialNotation = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumberExponentialNotation, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$number = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$numberExponentialNotation));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, "\n");
    }, $elm$parser$Parser$symbol("\n"));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Escapable = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapableSet = $elm$core$Set$fromList(_List_fromArray(["\"", "\\", "/", "b", "f", "n", "r", "t", "u"]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$isEscapableChar = function (c) {
        return $elm$core$Set$member_fn(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapableSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapable = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol("\\"))), $elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$isEscapableChar));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringEscapable = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapable));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$doubleQuoteDelimiter = function (syntax_) {
        return {
            i4: function (b) {
                return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(syntax_), b);
            },
            u: "\"",
            jF: _List_fromArray([
                $elm$parser$Parser$Advanced$map_fn($elm$core$List$singleton, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak),
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringEscapable
            ]),
            jK: false,
            jM: function (c) {
                return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
            },
            x: "\""
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral_fn = function (syntax_, revTokens) {
        return $elm$parser$Parser$Advanced$map_fn(function (n) {
            return _Utils_ap(n, revTokens);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$doubleQuoteDelimiter(syntax_)));
    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral_fn);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$space = $elm$parser$Parser$Advanced$map_fn(function (b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace = $elm$parser$Parser$oneOf(_List_fromArray([$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$space, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$arrayLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $elm$parser$Parser$Advanced$map_fn(function (_v4) {
                return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), ",");
            }, $elm$parser$Parser$symbol(","))),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Done(_List_Cons(n, revTokens));
            }, $elm$parser$Parser$Advanced$map_fn(function (_v5) {
                return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), "]");
            }, $elm$parser$Parser$symbol("]"))),
            $elm$parser$Parser$Advanced$map_fn(function (ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value()),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$objectLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral_fn(5, revTokens)),
            $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$Loop, $elm$parser$Parser$Advanced$andThen_fn(function (_v0) {
                var revTokens_ = _List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), ":"), revTokens);
                return $elm$parser$Parser$Advanced$map_fn(function (ns) {
                    return _Utils_ap(ns, revTokens_);
                }, $elm$parser$Parser$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$andThen_fn(function (ws) {
                        return $elm$parser$Parser$oneOf(_List_fromArray([
                            $elm$parser$Parser$Advanced$map_fn(function (v) {
                                return _Utils_ap(v, _List_fromArray([ws]));
                            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value()),
                            $elm$parser$Parser$succeed(_List_fromArray([ws]))
                        ]));
                    }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
                    $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value(),
                    $elm$parser$Parser$succeed(_List_Nil)
                ])));
            }, $elm$parser$Parser$symbol(":"))),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), ",");
            }, $elm$parser$Parser$symbol(","))),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Done(_List_Cons(n, revTokens));
            }, $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), "}");
            }, $elm$parser$Parser$symbol("}"))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value() {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral_fn(0, _List_Nil),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return _List_fromArray([n]);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$number),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object(),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array(),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return _List_fromArray([
                    _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), s)
                ]);
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$keyword("null"))),
            $elm$parser$Parser$Advanced$map_fn(function (s) {
                return _List_fromArray([
                    _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), s)
                ]);
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$keyword("true"),
                $elm$parser$Parser$keyword("false")
            ]))))
        ]));
    }
    function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array() {
        return $elm$parser$Parser$Advanced$andThen_fn(function (_v6) {
            return $elm$parser$Parser$loop_fn(_List_fromArray([
                _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), "[")
            ]), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$arrayLoop);
        }, $elm$parser$Parser$symbol("["));
    }
    function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object() {
        return $elm$parser$Parser$Advanced$andThen_fn(function (_v3) {
            return $elm$parser$Parser$loop_fn(_List_fromArray([
                _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), "{")
            ]), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$objectLoop);
        }, $elm$parser$Parser$symbol("{"));
    }
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$value = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value();
    $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value = function () {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$value;
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$array = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array();
    $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array = function () {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$array;
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object();
    $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object = function () {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object;
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$mainLoop = function (revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_List_Cons(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
            $elm$parser$Parser$Advanced$map_fn(function (n) {
                return $elm$parser$Parser$Loop(_Utils_ap(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object),
            $elm$parser$Parser$Advanced$map_fn(function (b) {
                return $elm$parser$Parser$Loop(_List_Cons(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b), revTokens));
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Basics$always(true)))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toRevTokens = $elm$parser$Parser$loop_fn(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines_a0 = $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toRevTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines_a1 = $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$syntaxToStyle)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines_a1);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json_a0 = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json_a1 = $elm$core$Result$map($elm$core$Basics$identity), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json_a0, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json_a1);
    var $author$project$Components$GqlResponse$viewResponse_fn = function (decoder, response) {
        var parsedResponse = $author$project$Components$GqlResponse$parseResponse_fn(decoder, response);
        var disabled_ = _Utils_eq(parsedResponse, $elm$core$Maybe$Nothing);
        return $author$project$Components$Editor$viewReadonly_fn(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
            $author$project$Util$styleIf_fn(disabled_, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50)
        ]), $author$project$Components$Editor$init_fn($elm$core$Maybe$Just(5), $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $elm$json$Json$Encode$encode(2), parsedResponse)));
    }, $author$project$Components$GqlResponse$viewResponse = F2($author$project$Components$GqlResponse$viewResponse_fn);
    var $author$project$Components$GqlResponse$viewResponseErrors = function (response) {
        return $author$project$Components$wrapErrorsStyled_fn(_List_Nil, $elm$core$Maybe$withDefault_fn(_List_Nil, $author$project$Components$GqlResponse$parseResponse_fn($author$project$Components$GqlResponse$decodeErrors, response)));
    };
    var $author$project$Components$GqlResponse$viewResponseLogs = function (response) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]), $elm$core$List$map_fn(function (log) {
            var formatUtc = A2($elm$core$Basics$composeR, A2($elm$core$String$replace, "T", " "), A2($elm$core$String$replace, "Z", " Z"));
            var _v0 = (log.h9 === "stderr") ? _Utils_Tuple2(_List_fromArray([
                $rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$theme.jf),
                $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.jg),
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Css$color($author$project$Theme$theme.jh)
            ])) : _Utils_Tuple2(_List_Nil, _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_700)
            ]));
            var styles = _v0.a;
            var labelStyles = _v0.b;
            return $author$project$Components$wrapWithLabel_fn({
                jS: log.h9,
                jT: formatUtc(log.lc),
                jU: _List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50), labelStyles),
                m: _List_Nil
            }, $author$project$Components$wrapSuccess_fn(_List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_left, styles), log.no));
        }, $elm$core$Maybe$withDefault_fn(_List_Nil, $author$project$Components$GqlResponse$parseResponse_fn($author$project$Components$GqlResponse$decodeLogs, response))));
    };
    var $author$project$Components$GqlResponse$viewParsed = function (model) {
        var toTabs = function () {
            var tabContentStyles = _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_hidden, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full]);
            return A2($author$project$TabView$tabView, {
                gC: tabContentStyles,
                mG: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_nowrap]),
                nH: $elm$core$Maybe$Nothing,
                o5: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]),
                o6: _List_Nil
            }, model);
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_rows_2,
                $rtfeldman$elm_css$Css$property_fn("grid-template-rows", "auto auto"),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$author$project$Components$GqlResponse$heightStyle]))
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$md(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_rows_1,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "1fr 45%")
                ])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$lg(_List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "1fr 1fr")
                ]))
            ]))
        ]), _List_fromArray([
            toTabs(_List_fromArray([
                {
                    cd: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, A2($elm$core$Basics$composeR, $author$project$Components$GqlResponse$parseResponse($author$project$Components$GqlResponse$decodeData), $elm_community$maybe_extra$Maybe$Extra$isNothing)),
                    fq: true,
                    fr: $elm$core$Basics$always(false),
                    fw: $elm$core$Basics$always(true),
                    a_: function (_v0) {
                        return $author$project$TabView$SendMsg($author$project$Components$GqlResponse$SetFormat(0));
                    },
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Data",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$viewResponse($author$project$Components$GqlResponse$decodeData))
                }
            ])),
            toTabs(_List_fromArray([
                {
                    cd: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$errorsEmpty),
                    fq: true,
                    fr: $elm$core$Basics$always(false),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.bV;
                    }, $elm$core$Basics$eq($elm$core$Maybe$Just(0))),
                    a_: function (_v1) {
                        return $author$project$TabView$SendMsg($author$project$Components$GqlResponse$SetMetaDataFocus(0));
                    },
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Errors",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$viewResponseErrors)
                },
                {
                    cd: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$logsEmpty),
                    fq: true,
                    fr: $elm$core$Basics$always(false),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.bV;
                    }, $elm$core$Basics$eq($elm$core$Maybe$Just(1))),
                    a_: function (_v2) {
                        return $author$project$TabView$SendMsg($author$project$Components$GqlResponse$SetMetaDataFocus(1));
                    },
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Logs",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$viewResponseLogs)
                },
                {
                    cd: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$extensionsEmpty),
                    fq: true,
                    fr: $elm$core$Basics$always(false),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.bV;
                    }, $elm$core$Basics$eq($elm$core$Maybe$Just(2))),
                    a_: function (_v3) {
                        return $author$project$TabView$SendMsg($author$project$Components$GqlResponse$SetMetaDataFocus(2));
                    },
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Extensions",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.aw;
                    }, $author$project$Components$GqlResponse$viewResponse($author$project$Components$GqlResponse$decodeExtensions))
                }
            ]))
        ]));
    };
    var $author$project$Components$GqlResponse$view_fn = function (toMsg, model) {
        var formatOptionInput = $author$project$Components$radioOptionsBar({
            M: "gql-response-format-option",
            cx: _List_fromArray([
                {
                    mD: $elm$core$Basics$eq(0),
                    hX: F2(function (_v1, _v2) {
                        return 0;
                    }),
                    eM: "Parsed"
                },
                {
                    mD: $elm$core$Basics$eq(1),
                    hX: F2(function (_v3, _v4) {
                        return 1;
                    }),
                    eM: "Raw"
                }
            ]),
            hX: A2($elm$core$Basics$composeR, $author$project$Components$GqlResponse$SetFormat, toMsg),
            h7: model.d7,
            m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto])
        });
        var disabled_ = _Utils_eq(model.aw, $elm$core$Maybe$Nothing);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $author$project$Util$stylesIf_fn(disabled_, _List_fromArray([
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$each_fn(_List_fromArray([$rtfeldman$elm_css$Css$Global$button, $rtfeldman$elm_css$Css$Global$label, $rtfeldman$elm_css$Css$Global$input]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                    ]))
                ]))
            ]))
        ]), _List_fromArray([
            formatOptionInput,
            function () {
                var _v0 = model.d7;
                if (!_v0) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $author$project$Components$GqlResponse$viewParsed(model));
                }
                else {
                    return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Components$GqlResponse$heightStyle]))
                    ]), _List_fromArray([
                        $author$project$Components$GqlResponse$viewResponse_fn($elm$json$Json$Decode$value, model.aw)
                    ])));
                }
            }()
        ]));
    }, $author$project$Components$GqlResponse$view = F2($author$project$Components$GqlResponse$view_fn);
    var $author$project$Components$wrapWithMaybeTitleTooltip_fn = function (maybeTooltip, element) {
        return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(element, A2($author$project$Util$flip, $author$project$Components$wrapWithTitleTooltip, element), maybeTooltip);
    }, $author$project$Components$wrapWithMaybeTitleTooltip = F2($author$project$Components$wrapWithMaybeTitleTooltip_fn);
    var $author$project$Pages$Functions$viewTab_fn = function (toMsg, onDelete, dbId, shared, model, _function, tab) {
        var toButtonGroup = F2(function (styles, buttons) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_y_2,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), buttons);
        });
        var toButton = function (cfg) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.kW,
                    $rtfeldman$elm_css$Css$batch(cfg.m)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "function-" + ($elm$core$String$toLower(cfg.eM) + "-button")),
                $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.a_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, _Utils_eq($author$project$Pages$Functions$getSelectedFunction(model), $elm$core$Maybe$Nothing) || (model.la || (!cfg.cf)))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(cfg.eM)
            ]));
        };
        var runtimeChanged = $author$project$Pages$Functions$FunctionTab$runtimeChanged_fn(tab, _function);
        var executionStatus = F2(function (message, styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(message)
            ]));
        });
        var contentChanged = $author$project$Pages$Functions$FunctionTab$contentChanged_fn(tab, _function);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_w_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_end])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center
                ]))
            ]), _List_fromArray([
                $author$project$Components$stringSelect({
                    cP: _List_Nil,
                    bR: $elm$core$Maybe$Just("function-runtime-select"),
                    cv: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $author$project$Types$Function$Runtime$fromString, A2($elm$core$Basics$composeR, $author$project$Pages$Functions$FunctionTab$setMaybeRuntime(tab), A2($elm$core$Basics$composeR, $author$project$Pages$Functions$UpdateTab, toMsg)))),
                    cx: $elm$core$List$map_fn($author$project$Types$Function$Runtime$toString, $author$project$Types$Function$Runtime$list),
                    df: "",
                    ev: $author$project$Types$Function$Runtime$toString(tab.oJ),
                    m: _List_fromArray([$author$project$Theme$theme.fu, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2])
                }),
                $author$project$Components$urlBox({
                    fx: $elm$core$Maybe$Just("GraphQL Endpoint (POST)"),
                    m: _List_Nil,
                    g: A2($author$project$Util$urlWithPathToString, shared.g, "/fns/" + $elm$url$Url$percentEncode(_function.bR)),
                    lj: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_fit])
                }),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grow, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href($elm$core$Maybe$withDefault_fn("#", $elm$core$Maybe$map_fn(function (url) {
                            return url + "/versions";
                        }, $elm$core$Maybe$andThen_fn($author$project$Pages$Functions$Route$toFunctionId, $author$project$Route$toFunctionsRoute(shared.eu)))))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("Versions")
                    ]))
                ]))
            ])),
            $author$project$Components$Description$view_fn(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
            ]), A2($elm$core$Basics$composeR, $author$project$Pages$Functions$DescriptionMsg(_function), toMsg), _function.i6, tab.i6),
            $author$project$Components$Editor$view_fn(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
            ]), A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$EditorMsg(_function)), toMsg($author$project$Pages$Functions$SaveFunction_fn(_function, dbId)), tab.gO),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
            ]), _List_fromArray([
                A2(toButtonGroup, _List_Nil, _List_fromArray([
                    toButton({
                        cf: true,
                        a_: onDelete(_function),
                        m: _List_fromArray([$author$project$Theme$theme.oZ]),
                        eM: "Delete"
                    }),
                    toButton({
                        cf: true,
                        a_: toMsg($author$project$Pages$Functions$RenameFunctionMsg($author$project$Components$InputRequester$Started("function-rename-button"))),
                        m: _List_Nil,
                        eM: "Rename"
                    })
                ])),
                A2(toButtonGroup, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end]), _List_fromArray([
                    toButton({
                        cf: contentChanged || runtimeChanged,
                        a_: contentChanged ? toMsg($author$project$Pages$Functions$RevertChangesIntended(_function)) : toMsg($author$project$Pages$Functions$RevertChanges(_function)),
                        m: _List_Nil,
                        eM: "Cancel"
                    }),
                    toButton({
                        cf: contentChanged || runtimeChanged,
                        a_: toMsg($author$project$Pages$Functions$SaveFunction_fn(_function, dbId)),
                        m: _List_Nil,
                        eM: "Save"
                    })
                ]))
            ])),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$fieldset_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, contentChanged)
            ]), _List_fromArray([
                $author$project$Components$wrapWithLabel_fn({
                    jS: "context.data (JSON)",
                    jT: "",
                    jU: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6]),
                    m: _List_Nil
                }, $author$project$Components$Editor$view_fn(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                ]), A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$DataEditorMsg(_function)), toMsg($author$project$Pages$Functions$ExecuteFunction(_function)), tab.lY)),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_end]))
                ]), _List_fromArray([
                    _Utils_eq(tab.fa, $elm$core$Maybe$Nothing) ? A2(executionStatus, "Function executed successfully.", _List_fromArray([
                        $author$project$Util$styleIf_fn(contentChanged || ($author$project$Pages$Functions$FunctionTab$dataChanged(tab) || $author$project$Pages$Functions$FunctionTab$hasNoResponse(tab)), $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                    ])) : $author$project$Components$wrapWithMaybeTitleTooltip_fn(tab.fa, A2(executionStatus, "Invalid Input", _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_600)
                    ]))),
                    $author$project$Components$wrapWithSpinner3_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto]), tab.gR, toButton({
                        cf: (!tab.gR) && _Utils_eq(tab.fa, $elm$core$Maybe$Nothing),
                        a_: toMsg($author$project$Pages$Functions$ExecuteFunction(_function)),
                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto]),
                        eM: "Execute"
                    }))
                ]))
            ])),
            $author$project$Components$GqlResponse$view_fn(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$GqlResponseMsg(_function)), tab.mE)
        ]));
    }, $author$project$Pages$Functions$viewTab = F7($author$project$Pages$Functions$viewTab_fn);
    var $author$project$Pages$Functions$content_fn = function (toMsg, onDelete, dbId, shared, model) {
        var _v0 = $author$project$Pages$Functions$getSelectedFunction(model);
        if (_v0.$ === 1) {
            return $author$project$Components$overview({
                iy: $author$project$Components$initButton_fn($author$project$Components$addButton_a0, "function-add-button", "Function", A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$AddFunctionMsg), $author$project$Components$FormOverlay$Opened)),
                lx: false,
                hg: "Function",
                mU: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                mV: function (_function) {
                    return $author$project$Route$toUrlPath($author$project$Route$Functions_fn(dbId, $author$project$Pages$Functions$Route$Function(_function.bR)));
                },
                mX: $elm$core$Basics$always($elm$core$Maybe$Nothing),
                mZ: function ($) {
                    return $.M;
                },
                aZ: $krisajenkins$remotedata$RemoteData$withDefault_fn(_List_Nil, model.mB),
                nh: $elm$core$Maybe$Nothing,
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]),
                f4: $elm$core$Maybe$Just({
                    mK: $elm$core$Maybe$Just(function (_function) {
                        return $author$project$Route$toUrlPath($author$project$Route$Functions_fn(dbId, $author$project$Pages$Functions$Route$Versions_fn(_function.bR, $elm$core$Maybe$Nothing)));
                    }),
                    hj: "Version",
                    jZ: function ($) {
                        return $.le;
                    }
                })
            });
        }
        else {
            var _function = _v0.a;
            var _v1 = $elm$core$Dict$get_fn(_function.bR, model.P);
            if (_v1.$ === 1) {
                return $author$project$Components$pageSpinner;
            }
            else {
                var tab = _v1.a;
                var subRoute = $author$project$Route$toFunctionsRoute(shared.eu);
                _v2$2: while (true) {
                    if (!subRoute.$) {
                        switch (subRoute.a.$) {
                            case 1:
                                return $author$project$Pages$Functions$viewTab_fn(toMsg, onDelete, dbId, shared, model, _function, tab);
                            case 2:
                                var _v3 = subRoute.a;
                                var functionId = _v3.a;
                                var maybeVersionId = _v3.b;
                                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                                ]), _List_fromArray([
                                    $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (versionId) {
                                        return $author$project$Toggable$modalToggle({
                                            lR: false,
                                            bR: "version-overlay",
                                            nj: $elm$core$Maybe$Nothing,
                                            nt: function (_v4) {
                                                return $author$project$Pages$Functions$versionOverlay_fn(dbId, _function, versionId);
                                            }
                                        });
                                    }, maybeVersionId)),
                                    $author$project$Components$overview({
                                        iy: $rtfeldman$elm_css$Html$Styled$text(""),
                                        lx: false,
                                        hg: "Version",
                                        mU: A2($elm$core$Basics$composeR, $elm$core$String$toUpper, A2($elm$core$Basics$composeR, $kyasu1$elm_ulid$Ulid$fromString, $elm$core$Maybe$map($kyasu1$elm_ulid$Ulid$toTimestamp))),
                                        mV: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Pages$Functions$Route$Versions(functionId), A2($elm$core$Basics$composeR, $author$project$Route$Functions(dbId), $author$project$Route$toUrlPath))),
                                        mX: A2($elm$core$Basics$composeR, $author$project$Pages$Functions$isCurrentVersionOf(_function.le), A2($author$project$Util$Bool$ifElse, $elm$core$Maybe$Just("Current"), $elm$core$Maybe$Nothing)),
                                        mZ: $elm$core$Basics$identity,
                                        aZ: $elm$core$List$map_fn(function ($) {
                                            return $.bR;
                                        }, _function.le),
                                        nh: $elm$core$Maybe$Nothing,
                                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4]),
                                        f4: $elm$core$Maybe$Nothing
                                    })
                                ]));
                            default:
                                break _v2$2;
                        }
                    }
                    else {
                        break _v2$2;
                    }
                }
                return $rtfeldman$elm_css$Html$Styled$text("");
            }
        }
    }, $author$project$Pages$Functions$content = F5($author$project$Pages$Functions$content_fn);
    var $author$project$Components$FormOverlay$view = function (toMsg) {
        return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, function ($) {
            return $.a$;
        }, $author$project$Overlay$view(toMsg)));
    };
    var $author$project$Pages$Functions$view_fn = function (toMsg, onDelete, dbId, shared, model) {
        var _v0 = model.mB;
        switch (_v0.$) {
            case 2:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 1:
                return $author$project$Components$pageSpinner;
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text("");
            default:
                var functions = _v0.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), _List_fromArray([
                    $author$project$Overlay$view_fn(toMsg, model.aE),
                    A2($author$project$Components$InputRequester$view, toMsg, model.cm),
                    A2($author$project$Components$FormOverlay$view, toMsg, model.dV),
                    $author$project$Components$menuPage_fn($author$project$Components$menuPageFull_a0, {
                        dM: $elm$core$Maybe$Nothing,
                        gB: $author$project$Pages$Functions$content_fn(toMsg, onDelete, dbId, shared, model),
                        dW: $elm$core$Maybe$map_fn($author$project$Pages$Functions$Route$toFunctionId, $author$project$Route$toFunctionsRoute(shared.eu)),
                        nl: _List_fromArray([
                            $author$project$Components$initButton_fn($author$project$Components$addButton_a0, "function-add-button-menu", "Function", A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Functions$AddFunctionMsg), $author$project$Components$FormOverlay$Opened))
                        ]),
                        nm: false,
                        nn: $elm$core$List$append_fn(_List_fromArray([
                            _List_fromArray([
                                _Utils_Tuple2("Overview", $elm$core$Maybe$Nothing)
                            ])
                        ]), $elm$core$List$singleton($elm$core$List$map_fn(function (_v1) {
                            var name = _v1.M;
                            var id = _v1.bR;
                            return _Utils_Tuple2(name, $elm$core$Maybe$Just(id));
                        }, functions))),
                        fL: A2($elm$core$Basics$composeR, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Pages$Functions$Route$Overview, $author$project$Pages$Functions$Route$Function), $author$project$Pages$Functions$NavigateReplace),
                        gd: toMsg
                    })
                ]));
        }
    }, $author$project$Pages$Functions$view = F5($author$project$Pages$Functions$view_fn);
    var $author$project$Pages$Queries$QueryTabAdded = { $: 13 };
    var $author$project$Pages$Queries$ResultTableOptionUpdated = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Pages$Queries$QueryTab$WrapPreWrap = 1;
    var $author$project$Pages$Queries$QueryTab$WrapWord = 2;
    var $author$project$Util$Recyclable$unwrap_fn = function (_default, f, recyclable) {
        switch (recyclable.$) {
            case 0:
                return _default;
            case 1:
                return _default;
            case 2:
                return _default;
            case 3:
                var object = recyclable.a;
                return f(object);
            default:
                var object = recyclable.a;
                return f(object);
        }
    }, $author$project$Util$Recyclable$unwrap = F3($author$project$Util$Recyclable$unwrap_fn);
    var $author$project$Pages$Queries$dataTable_fn = function (styles, resultTableOptions) {
        var viewHeader = function (sqlResult) {
            var _v2 = $elm$core$List$head(sqlResult.hT);
            if (!_v2.$) {
                var cells = _v2.a;
                return $elm$core$List$map_fn(function (_v3) {
                    var key = _v3.a;
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$th_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.bN.e2]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(key)
                    ]));
                }, cells);
            }
            else {
                return _List_Nil;
            }
        };
        var prettyDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$italic, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("null")
            ]))),
            _Json_map1_fn(function (val) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromInt(val))
                ]));
            }, $elm$json$Json$Decode$int),
            _Json_map1_fn(function (val) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromFloat(val))
                ]));
            }, $elm$json$Json$Decode$float),
            function () {
                var wrappingStyles = function () {
                    var _v1 = resultTableOptions.cN;
                    switch (_v1) {
                        case 0:
                            return $rtfeldman$elm_css$Css$batch(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_xs, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll]));
                        case 1:
                            return $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_wrap;
                        default:
                            return $rtfeldman$elm_css$Css$batch(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$break_words]));
                    }
                }();
                return _Json_map1_fn(function (val) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([wrappingStyles]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(val)
                    ]));
                }, $elm$json$Json$Decode$string);
            }(),
            _Json_andThen_fn(function (val) {
                return A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, function (x) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500)
                        ]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(x)
                    ]));
                })(val ? "ERROR: true is not allowed" : "ERROR: false is not allowed");
            }, $elm$json$Json$Decode$bool)
        ]));
        var viewValue = function (value) {
            return $elm$core$Result$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), _Json_run_fn(prettyDecoder, value));
        };
        var viewRow = function (cells) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tr_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.bN.kJ]))
            ]), $elm$core$List$map_fn(function (_v0) {
                var value = _v0.b;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$td_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.bN.e2]))
                ]), _List_fromArray([
                    viewValue(value)
                ]));
            }, cells));
        };
        return A2($author$project$Util$Recyclable$unwrap, $rtfeldman$elm_css$Html$Styled$text(""), function (sqlResult) {
            var rows = sqlResult.hT;
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$table_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Theme$theme.bN.kZ,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$thead_a0, _List_Nil, viewHeader(sqlResult)),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$tbody_a0, _List_Nil, $elm$core$List$map_fn(viewRow, rows))
            ]));
        });
    }, $author$project$Pages$Queries$dataTable = F2($author$project$Pages$Queries$dataTable_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_2 = $rtfeldman$elm_css$Css$property_fn("margin-bottom", "-0.5rem");
    var $PaackEng$paack_remotedata$Remote$Recyclable$isNeverAsked = function (data) {
        if (!data.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Pages$Queries$QueryTab$neverQueried = function (tab) {
        return $PaackEng$paack_remotedata$Remote$Recyclable$isNeverAsked(tab.a2);
    };
    var $PaackEng$paack_remotedata$Remote$Recyclable$map_fn = function (applier, data) {
        switch (data.$) {
            case 0:
                return $PaackEng$paack_remotedata$Remote$Recyclable$NeverAsked;
            case 1:
                return $PaackEng$paack_remotedata$Remote$Recyclable$Loading;
            case 2:
                var error = data.a;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Failure(error);
            case 4:
                var object = data.a;
                var subState = data.b;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Recycling_fn(applier(object), subState);
            default:
                var object = data.a;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Ready(applier(object));
        }
    }, $PaackEng$paack_remotedata$Remote$Recyclable$map = F2($PaackEng$paack_remotedata$Remote$Recyclable$map_fn);
    var $author$project$Util$Recyclable$toReady = function (recyclable) {
        switch (recyclable.$) {
            case 0:
                return recyclable;
            case 1:
                return recyclable;
            case 2:
                return recyclable;
            case 3:
                return recyclable;
            default:
                var object = recyclable.a;
                return $PaackEng$paack_remotedata$Remote$Recyclable$Ready(object);
        }
    };
    var $PaackEng$paack_remotedata$Remote$Recyclable$withDefault_fn = function (_default, data) {
        if (data.$ === 3) {
            var object = data.a;
            return object;
        }
        else {
            return _default;
        }
    }, $PaackEng$paack_remotedata$Remote$Recyclable$withDefault = F2($PaackEng$paack_remotedata$Remote$Recyclable$withDefault_fn);
    var $author$project$Pages$Queries$QueryTab$queryReturnedRows_a0 = function ($) {
        return $.a2;
    }, $author$project$Pages$Queries$QueryTab$queryReturnedRows_a1 = A2($elm$core$Basics$composeR, $PaackEng$paack_remotedata$Remote$Recyclable$map(A2($elm$core$Basics$composeR, function ($) {
        return $.hT;
    }, A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not))), A2($elm$core$Basics$composeR, $author$project$Util$Recyclable$toReady, $PaackEng$paack_remotedata$Remote$Recyclable$withDefault(false))), $author$project$Pages$Queries$QueryTab$queryReturnedRows = A2($elm$core$Basics$composeR, $author$project$Pages$Queries$QueryTab$queryReturnedRows_a0, $author$project$Pages$Queries$QueryTab$queryReturnedRows_a1);
    var $PaackEng$paack_remotedata$Remote$Recyclable$isLoading = function (data) {
        _v0$2: while (true) {
            switch (data.$) {
                case 1:
                    return true;
                case 4:
                    if (!data.b.$) {
                        var _v1 = data.b;
                        return true;
                    }
                    else {
                        break _v0$2;
                    }
                default:
                    break _v0$2;
            }
        }
        return false;
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_0 = $rtfeldman$elm_css$Css$property_fn("margin-top", "0px");
    var $author$project$Components$AiEditor$contentChanged = function (model) {
        return $author$project$Components$Editor$contentChanged(model.gO);
    };
    var $author$project$Pages$Queries$QueryTab$queryChanged = function (tab) {
        return $author$project$Components$AiEditor$contentChanged(tab.dC);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_start = $rtfeldman$elm_css$Css$property_fn("align-self", "flex-start");
    var $author$project$Pages$Queries$queryToViewButton = function (disabled_) {
        var id_ = "create-view-button";
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.kW, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_start])),
            $rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Queries$CreateViewMsg($author$project$Components$InputRequester$Started(id_)))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("Create View From Query")
        ]));
    };
    var $author$project$Pages$Queries$ConfirmedTargetView_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Pages$Queries$ConfirmedTargetView = F2($author$project$Pages$Queries$ConfirmedTargetView_fn);
    var $author$project$Pages$Queries$SetTargetView = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Types$Database$findTable_fn = function (tableName, database) {
        return $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.M;
        }, $elm$core$Basics$eq(tableName)), database.eH);
    }, $author$project$Types$Database$findTable = F2($author$project$Types$Database$findTable_fn);
    var $author$project$Types$Database$filterTables_fn = function (predicate, database) {
        return _Utils_update(database, {
            eH: $elm$core$List$filter_fn(predicate, database.eH)
        });
    }, $author$project$Types$Database$filterTables = F2($author$project$Types$Database$filterTables_fn);
    var $author$project$Types$Database$keepViews = function (database) {
        return $krisajenkins$remotedata$RemoteData$map_fn($author$project$Types$Database$filterTables($author$project$Types$Table$isView), database);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-x", "-1rem"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_br_none = $rtfeldman$elm_css$Css$property_fn("border-bottom-right-radius", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr_none = $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0px");
    var $author$project$Pages$Queries$queryToViewOverwriteButton = function (cfg) {
        var options = $krisajenkins$remotedata$RemoteData$unwrap_fn(_List_Nil, A2($elm$core$Basics$composeR, function ($) {
            return $.eH;
        }, $elm$core$List$map(function ($) {
            return $.M;
        })), $author$project$Types$Database$keepViews(cfg.j));
        if (_Utils_eq(options, _List_Nil)) {
            return $rtfeldman$elm_css$Html$Styled$text("");
        }
        else {
            var noViewSelected = _Utils_eq(cfg.dt, $elm$core$Maybe$Nothing);
            return $author$project$Components$wrapWithSpinner2_fn(_List_Nil, _List_Nil, cfg.la, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1,
                            $rtfeldman$elm_css$Css$hover(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_200)
                            ]))
                        ]))
                    ])),
                    $author$project$Util$stylesIf_fn(cfg.cd, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                ]))
            ]), _List_fromArray([
                $author$project$Components$stringSelect({
                    cP: _List_Nil,
                    bR: $elm$core$Maybe$Nothing,
                    cv: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$Pages$Queries$EditView, $author$project$Pages$Queries$SetTargetView)),
                    cx: options,
                    df: "Select View To Overwrite",
                    ev: $elm$core$Maybe$withDefault_fn("", cfg.dt),
                    m: _List_fromArray([$author$project$Theme$theme.oZ, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none])
                }),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), A2($elm$core$Basics$composeR, $author$project$Pages$Queries$ConfirmedTargetView(cfg.i2), A2($elm$core$Basics$composeR, $author$project$Pages$Queries$EditView, $rtfeldman$elm_css$Html$Styled$Events$onClick)), $elm_community$maybe_extra$Maybe$Extra$join($elm$core$Maybe$map2_fn($author$project$Types$Database$findTable, cfg.dt, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, cfg.j)))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $author$project$Theme$theme.oZ,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr_none,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_br_none,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transform,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $author$project$Util$styleIf_fn(noViewSelected, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(_String_append_fn("Overwrite View ", $elm$core$Maybe$withDefault_fn("", cfg.dt)))
                ]))
            ])));
        }
    };
    var $myrho$elm_round$Round$funNum_fn = function (fun, s, fl) {
        return $elm$core$Maybe$withDefault_fn(0 / 0, $elm$core$String$toFloat(A2(fun, s, fl)));
    }, $myrho$elm_round$Round$funNum_fn_unwrapped = function (fun, s, fl) {
        return $elm$core$Maybe$withDefault_fn(0 / 0, $elm$core$String$toFloat(fun(s, fl)));
    }, $myrho$elm_round$Round$funNum = F3($myrho$elm_round$Round$funNum_fn);
    var $myrho$elm_round$Round$roundNum_a0 = $myrho$elm_round$Round$round, $myrho$elm_round$Round$roundNum = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$roundNum_a0);
    var $author$project$Pages$Queries$runtimeStats_fn = function (styles, sqlResult) {
        var toView = function (runtime) {
            var viewDuration = function (durInSec) {
                return $rtfeldman$elm_css$Html$Styled$text((durInSec < 10) ? ($elm$core$String$fromFloat($myrho$elm_round$Round$funNum_fn($myrho$elm_round$Round$roundNum_a0, 4, durInSec * 1000)) + ($author$project$Components$nbsp + "ms")) : ($elm$core$String$fromFloat($myrho$elm_round$Round$funNum_fn($myrho$elm_round$Round$roundNum_a0, 4, durInSec)) + ($author$project$Components$nbsp + "s")));
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text("Elapsed: "),
                viewDuration(runtime)
            ]));
        };
        switch (sqlResult.$) {
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 1:
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
                ]), _List_fromArray([$author$project$Components$pageSpinner]));
            case 2:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 4:
                var runtime = sqlResult.a.oJ;
                return toView(runtime);
            default:
                var runtime = sqlResult.a.oJ;
                return toView(runtime);
        }
    }, $author$project$Pages$Queries$runtimeStats = F2($author$project$Pages$Queries$runtimeStats_fn);
    var $author$project$Pages$Queries$QueryTab$toSqlResult = function ($) {
        return $.a2;
    };
    var $author$project$Pages$Queries$runtimeStatsAndActionButtons_fn = function (resultTableVisible, database, dbId, model) {
        var resultIsLoading = $PaackEng$paack_remotedata$Remote$Recyclable$isLoading($author$project$Pages$Queries$QueryTab$toSqlResult($basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n)));
        var queryChanged = $author$project$Pages$Queries$QueryTab$queryChanged($basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full
            ]))
        ]), _List_fromArray([
            $author$project$Pages$Queries$runtimeStats_fn(_List_Nil, $author$project$Pages$Queries$QueryTab$toSqlResult($basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n))),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$place_items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_0])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                    $author$project$Util$styleIf_fn((!resultTableVisible) || queryChanged, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse)
                ]))
            ]), _List_fromArray([
                $author$project$Util$showElement_fn(resultTableVisible, $author$project$Pages$Queries$queryToViewOverwriteButton({
                    j: database,
                    i2: dbId,
                    cd: resultIsLoading,
                    la: model.la,
                    dt: $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n).dt
                })),
                $author$project$Util$showElement_fn(resultTableVisible, $author$project$Pages$Queries$queryToViewButton(model.la || resultIsLoading))
            ]))
        ]));
    }, $author$project$Pages$Queries$runtimeStatsAndActionButtons = F4($author$project$Pages$Queries$runtimeStatsAndActionButtons_fn);
    var $author$project$Pages$Queries$SetDocsSearch = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$Pages$Queries$TableSchemaMsgReceived = function (a) {
        return { $: 2, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_t_0 = $rtfeldman$elm_css$Css$property_fn("border-top-width", "0px");
    var $author$project$Pages$Queries$toTabView_fn = function (headerStyles, tabStyles, onAdd) {
        return $author$project$TabView$tabView({
            gC: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_t_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4]),
            mG: headerStyles,
            nH: onAdd,
            o5: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $rtfeldman$elm_css$Css$batch(tabStyles)
            ]),
            o6: _List_Nil
        });
    }, $author$project$Pages$Queries$toTabView = F3($author$project$Pages$Queries$toTabView_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_1 = $rtfeldman$elm_css$Css$property_fn("left", "0.25rem");
    var $author$project$Svg$magnifier = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$stroke_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z\n                m-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_8 = $rtfeldman$elm_css$Css$property_fn("padding-left", "2rem");
    var $author$project$Components$searchInput = function (cfg) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]), _List_fromArray([
            $author$project$Components$iconButton({
                bA: $author$project$Svg$magnifier,
                a_: cfg.bC,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
                    ]))
                ]),
                bE: _List_Nil
            }),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_8,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_7,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50])),
                    $rtfeldman$elm_css$Css$batch(cfg.mO)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$placeholder_a0, "Search"),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, cfg.pB),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(cfg.cv),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg.cd),
                $author$project$Util$onKeyDown({
                    kf: $elm$core$Maybe$Just(cfg.bC),
                    kj: $elm$core$Maybe$Just(cfg.bC),
                    hH: cfg.hH,
                    kn: $elm$core$Maybe$Nothing
                })
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$SQLiteDocs$aggregateFunctions = _List_fromArray([
        _Utils_Tuple3("avg(X)", "", "\n        The `avg()` function returns the average value of all `non-`NULL` X`\n        within a group.\n        String and BLOB values that do not look like numbers are interpreted as\n        0.\n        The result of `avg()` is always a floating point value whenever there\n        is at least one non-`NULL` input even if all inputs are integers.\n        The result of `avg()` is ``NULL`` if and only if there are no `non-`NULL``\n        inputs.\n        "),
        _Utils_Tuple3("count(X)", "", "\n        The `count(X)` function returns a count of the number of times that `X`\n        is not ``NULL`` in a group.\n        The `count(*)` function (with no arguments) returns the total number of\n        rows in the group.\n        "),
        _Utils_Tuple3("count(*)", "", "\n        The `count(X)` function returns a count of the number of times that `X`\n        is not ``NULL`` in a group.\n        The `count(*)` function (with no arguments) returns the total number of\n        rows in the group.\n        "),
        _Utils_Tuple3("group_concat(X)", "", "\n        The `group_concat()` function returns a string which is the\n        concatenation of all non-`NULL` values of X.\n        If parameter Y is present then it is used as the separator between\n        instances of X.\n        A comma (\",\") is used as the separator if Y is omitted.\n        The order of the concatenated elements is arbitrary.\n        "),
        _Utils_Tuple3("group_concat(X, Y)", "", "\n        The `group_concat()` function returns a string which is the\n        concatenation of all non-`NULL` values of X.\n        If parameter Y is present then it is used as the separator between\n        instances of X.\n        A comma (\",\") is used as the separator if Y is omitted.\n        The order of the concatenated elements is arbitrary.\n        "),
        _Utils_Tuple3("max(X)", "", "\n        The `max()` aggregate function returns the maximum value of all values in\n        the group.\n        The maximum value is the value that would be returned last in an ORDER\n        BY on the same column.\n        Aggregate `max()` returns `NULL` if and only if there are no non-`NULL`\n        values in the group.\n        "),
        _Utils_Tuple3("min(X)", "", "\n        The `min()` aggregate function returns the minimum non-`NULL` value of all\n        values in the group.\n        The minimum value is the first non-`NULL` value that would appear in an\n        ORDER BY of the column.\n        Aggregate `min()` returns `NULL` if and only if there are no non-`NULL`\n        values in the group.\n        "),
        _Utils_Tuple3("sum(X)", "", "\n        The `sum()` and `total()` aggregate functions return the sum of all\n        non-`NULL` values in the group.\n        If there are no non-`NULL` input rows then `sum()` returns `NULL` but total()\n        returns 0.0.\n        `NULL` is not normally a helpful result for the sum of no rows but the\n        SQL standard requires it\n        and most other SQL database engines implement sum()\n        that way so SQLite does it in the same way in order to be compatible.\n        The non-standard `total()` function is provided as a convenient way to\n        work around this design problem in the SQL language.\n        The result of `total()` is always a floating point value.\n        The result of `sum()` is an integer value if all non-`NULL` inputs are\n        integers.\n        If any input to `sum()` is neither an integer nor a `NULL`, then sum()\n        returns a floating point value\n        which is an approximation of the mathematical sum.\n        `Sum()` will throw an \"integer overflow\" exception if all inputs are\n        integers or `NULL` and an integer overflow occurs at any point during the\n        computation.\n        `Total()` never throws an integer overflow.\n        "),
        _Utils_Tuple3("total(X)", "", "\n        The `sum()` and `total()` aggregate functions return the sum of all\n        non-`NULL` values in the group.\n        If there are no non-`NULL` input rows then `sum()` returns `NULL` but total()\n        returns 0.0.\n        `NULL` is not normally a helpful result for the sum of no rows but the\n        SQL standard requires it\n        and most other SQL database engines implement sum()\n        that way so SQLite does it in the same way in order to be compatible.\n        The non-standard `total()` function is provided as a convenient way to\n        work around this design problem in the SQL language.\n        The result of `total()` is always a floating point value.\n        The result of `sum()` is an integer value if all non-`NULL` inputs are\n        integers.\n        If any input to `sum()` is neither an integer nor a `NULL`, then sum()\n        returns a floating point value\n        which is an approximation of the mathematical sum.\n        `Sum()` will throw an \"integer overflow\" exception if all inputs are\n        integers or `NULL` and an integer overflow occurs at any point during the\n        computation.\n        `Total()` never throws an integer overflow.\n        "),
        _Utils_Tuple3("json_group_array(X)", "", "\n        The `json_group_array(X)` function is an\n        [aggregate SQL function](https://www.sqlite.org/lang_aggfunc.html) that\n        returns a JSON array comprised of all `X` values in the aggregation.\n        "),
        _Utils_Tuple3("json_group_object(NAME, VALUE)", "", "\n        The `json_group_object(NAME,VALUE)` function returns a JSON object\n        comprised of all `NAME`/`VALUE` pairs in the aggregation.\n        ")
    ]);
    var $author$project$Components$SQLiteDocs$dateAndTimeFunctions = function () {
        var description = "\n            `time-value` must be a string formatted according to the\n            ISO8601 standard or the keyword `now`.\n            The time value can be followed by zero or more modifiers\n            that alter date and/or time.\n            Each modifier is a transformation\n            that is applied to the time value to its left.\n            Modifiers are applied from left to right; order is important.\n            ";
        return _List_fromArray([
            _Utils_Tuple3("date(time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#date", description),
            _Utils_Tuple3("time(time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#time", description),
            _Utils_Tuple3("datetime(time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#datetime", description),
            _Utils_Tuple3("julianday(time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#julianday", description),
            _Utils_Tuple3("unixepoch(time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#unixepoch", description),
            _Utils_Tuple3("strftime(format, time-value, modifier, \u2026)", "https://www.sqlite.org/lang_datefunc.html#strftime", description)
        ]);
    }();
    var $author$project$Components$SQLiteDocs$pragmaFunctions = _List_fromArray([
        _Utils_Tuple3("pragma_analysis_limit()", "https://www.sqlite.org/pragma.html#pragma_analysis_limit", "\n        Query or change a limit on the approximate ANALYZE setting.\n        This is the approximate number of rows examined in each index by the\n        ANALYZE command.\n        If the argument N is omitted, then the analysis limit is unchanged.\n        If the limit is zero, then the analysis limit is disabled and the\n        ANALYZE command will examine all rows of each index.\n        If N is greater than zero, then the analysis limit is set to N and\n        subsequent ANALYZE commands will stop analyzing each index after it\n        has examined approximately N rows.\n        If N is a negative number or something other than an integer value,\n        then the pragma behaves as if the N argument was omitted.\n        In all cases, the value returned is the new analysis limit used for\n        subsequent ANALYZE commands.\n\n        This pragma can be used to help the ANALYZE command run faster on\n        large databases.\n        The results of analysis are not as good when only part of each index\n        is examined, but the results are usually good enough.\n        Setting N to 100 or 1000 allows the ANALYZE command to run very\n        quickly, even on multi-gigabyte database files.\n        This pragma is particularly useful in combination with PRAGMA\n        optimize.\n        "),
        _Utils_Tuple3("pragma_application_id()", "https://www.sqlite.org/pragma.html#pragma_application_id", "\n        The application_id PRAGMA is used to query or set the 32-bit signed\n        big-endian \"Application ID\" integer located at offset 68 into the\n        database header. Applications that use SQLite as their application\n        file-format should set the Application ID integer to a unique integer\n        so that utilities such as file(1) can determine the specific file\n        type rather than just reporting \"SQLite3 Database\". A list of\n        assigned application IDs can be seen by consulting the magic.txt file\n        in the SQLite source repository.\n        "),
        _Utils_Tuple3("pragma_auto_vacuum()", "https://www.sqlite.org/pragma.html#pragma_auto_vacuum", "\n        Query or set the auto-vacuum status in the database.\n\n        The default setting for auto-vacuum is 0 or \"none\", unless the\n        `SQLITE_DEFAULT_AUTOVACUUM` compile-time option is used. The \"none\"\n        setting means that auto-vacuum is disabled. When auto-vacuum is\n        disabled and data is deleted data from a database, the database file\n        remains the same size. Unused database file pages are added to a\n        \"freelist\" and reused for subsequent inserts. So no database file\n        space is lost. However, the database file does not shrink. In this\n        mode the VACUUM command can be used to rebuild the entire database\n        file and thus reclaim unused disk space.\n\n        When the auto-vacuum mode is 1 or \"full\", the freelist pages are\n        moved to the end of the database file and the database file is\n        truncated to remove the freelist pages at every transaction commit.\n        Note, however, that auto-vacuum only truncates the freelist pages\n        from the file. Auto-vacuum does not defragment the database nor\n        repack individual database pages the way that the `VACUUM` command\n        does. In fact, because it moves pages around within the file,\n        auto-vacuum can actually make fragmentation worse.\n\n        Auto-vacuuming is only possible if the database stores some\n        additional information that allows each database page to be traced\n        backwards to its referrer. Therefore, auto-vacuuming must be turned\n        on before any tables are created. It is not possible to enable or\n        disable auto-vacuum after a table has been created.\n\n        When the value of auto-vacuum is 2 or \"incremental\" then the\n        additional information needed to do auto-vacuuming is stored in the\n        database file but auto-vacuuming does not occur automatically at each\n        commit as it does with auto_vacuum=full. In incremental mode, the\n        separate incremental_vacuum pragma must be invoked to cause the\n        auto-vacuum to occur.\n\n        The database connection can be changed between full and incremental\n        autovacuum mode at any time. However, changing from \"none\" to \"full\"\n        or \"incremental\" can only occur when the database is new (no tables\n        have yet been created) or by running the VACUUM command. To change\n        auto-vacuum modes, first use the auto_vacuum pragma to set the new\n        desired mode, then invoke the `VACUUM` command to reorganize the entire\n        database file. To change from \"full\" or \"incremental\" back to \"none\"\n        always requires running VACUUM even on an empty database.\n\n        When the auto_vacuum pragma is invoked with no arguments, it returns\n        the current auto_vacuum mode.\n        "),
        _Utils_Tuple3("pragma_automatic_index()", "https://www.sqlite.org/pragma.html#pragma_automatic_index", "\n        Query, set, or clear the automatic indexing capability.\n        "),
        _Utils_Tuple3("pragma_busy_timeout()", "https://www.sqlite.org/pragma.html#pragma_busy_timeout", "\n        Query or change the setting of the busy timeout. This pragma is an\n        alternative to the `sqlite3_busy_timeout()` C-language interface which\n        is made available as a pragma for use with language bindings that do\n        not provide direct access to `sqlite3_busy_timeout()`.\n\n        Each database connection can only have a single busy handler. This\n        PRAGMA sets the busy handler for the process, possibly overwriting\n        any previously set busy handler.\n        "),
        _Utils_Tuple3("pragma_cache_size()", "https://www.sqlite.org/pragma.html#pragma_cache_size", "\n        Query or change the suggested maximum number of database disk pages\n        that SQLite will hold in memory at once per open database file.\n        Whether or not this suggestion is honored is at the discretion of the\n        Application Defined Page Cache. The default page cache that is built\n        into SQLite honors the request, however alternative\n        application-defined page cache implementations may choose to\n        interpret the suggested cache size in different ways or to ignore it\n        all together. The default suggested cache size is -2000, which means\n        the cache size is limited to 2048000 bytes of memory. The default\n        suggested cache size can be altered using the\n        SQLITE_DEFAULT_CACHE_SIZE compile-time options. The TEMP database has\n        a default suggested cache size of 0 pages.\n\n        If the argument N is positive then the suggested cache size is set to\n        N. If the argument N is negative, then the number of cache pages is\n        adjusted to be a number of pages that would use approximately\n        abs(N*1024) bytes of memory based on the current page size. SQLite\n        remembers the number of pages in the page cache, not the amount of\n        memory used. So if you set the cache size using a negative number and\n        subsequently change the page size (using the PRAGMA page_size\n        command) then the maximum amount of cache memory will go up or down\n        in proportion to the change in page size.\n\n        Backwards compatibility note: The behavior of cache_size with a\n        negative N was different prior to version 3.7.10 (2012-01-16). In\n        earlier versions, the number of pages in the cache was set to the\n        absolute value of N.\n\n        When you change the cache size using the cache_size pragma, the\n        change only endures for the current session. The cache size reverts\n        to the default value when the database is closed and reopened.\n\n        The default page cache implemention does not allocate the full amount\n        of cache memory all at once. Cache memory is allocated in smaller\n        chunks on an as-needed basis. The page_cache setting is a (suggested)\n        upper bound on the amount of memory that the cache can use, not the\n        amount of memory it will use all of the time. This is the behavior of\n        the default page cache implementation, but an application defined\n        page cache is free to behave differently if it wants.\n        "),
        _Utils_Tuple3("pragma_cache_spill()", "https://www.sqlite.org/pragma.html#pragma_cache_spill", "\n        The cache_spill pragma enables or disables the ability of the pager\n        to spill dirty cache pages to the database file in the middle of a\n        transaction. Cache_spill is enabled by default and most applications\n        should leave it that way as cache spilling is usually advantageous.\n        However, a cache spill has the side-effect of acquiring an EXCLUSIVE\n        lock on the database file. Hence, some applications that have large\n        long-running transactions may want to disable cache spilling in order\n        to prevent the application from acquiring an exclusive lock on the\n        database until the moment that the transaction COMMITs.\n\n        The \"PRAGMA cache_spill=N\" form of this pragma sets a minimum cache\n        size threshold required for spilling to occur. The number of pages in\n        cache must exceed both the cache_spill threshold and the maximum\n        cache size set by the PRAGMA cache_size statement in order for\n        spilling to occur.\n\n        The \"PRAGMA cache_spill=boolean\" form of this pragma applies across\n        all databases attached to the database connection. But the \"PRAGMA\n        cache_spill=N\" form of this statement only applies to the \"main\"\n        schema or whatever other schema is specified as part of the statement.\n        "),
        _Utils_Tuple3("pragma_cell_size_check()", "https://www.sqlite.org/pragma.html#pragma_cell_size_check", "\n        The cell_size_check pragma enables or disables additional sanity\n        checking on database b-tree pages as they are initially read from\n        disk. With cell size checking enabled, database corruption is\n        detected earlier and is less likely to \"spread\". However, there is a\n        small performance hit for doing the extra checks and so cell size\n        checking is turned off by default.\n        "),
        _Utils_Tuple3("pragma_checkpoint_fullfsync()", "https://www.sqlite.org/pragma.html#pragma_checkpoint_fullfsync", "\n        Query or change the fullfsync flag for checkpoint operations. If this\n        flag is set, then the F_FULLFSYNC syncing method is used during\n        checkpoint operations on systems that support F_FULLFSYNC. The\n        default value of the checkpoint_fullfsync flag is off. Only Mac OS-X\n        supports F_FULLFSYNC.\n\n        If the fullfsync flag is set, then the F_FULLFSYNC syncing method is\n        used for all sync operations and the checkpoint_fullfsync setting is\n        irrelevant.\n        "),
        _Utils_Tuple3("pragma_collation_list()", "https://www.sqlite.org/pragma.html#pragma_collation_list", "\n        Return a list of the collating sequences\n        defined for the current database connection.\n        "),
        _Utils_Tuple3("pragma_compile_options()", "https://www.sqlite.org/pragma.html#pragma_compile_options", "\n        This pragma returns the names of compile-time options used when\n        building SQLite, one option per row. The \"SQLITE_\" prefix is omitted\n        from the returned option names. See also the\n        sqlite3_compileoption_get() C/C++ interface and the\n        sqlite_compileoption_get() SQL functions.\n        "),
        _Utils_Tuple3("pragma_data_version()", "https://www.sqlite.org/pragma.html#pragma_data_version", "\n        The \"PRAGMA data_version\" command provides an indication that the\n        database file has been modified. Interactive programs that hold\n        database content in memory or that display database content on-screen\n        can use the PRAGMA data_version command to determine if they need to\n        flush and reload their memory or update the screen display.\n\n        The integer values returned by two invocations of \"PRAGMA\n        data_version\" from the same connection will be different if changes\n        were committed to the database by any other connection in the\n        interim. The \"PRAGMA data_version\" value is unchanged for commits\n        made on the same database connection. The behavior of \"PRAGMA\n        data_version\" is the same for all database connections, including\n        database connections in separate processes and shared cache database\n        connections.\n\n        The \"PRAGMA data_version\" value is a local property of each database\n        connection and so values returned by two concurrent invocations of\n        \"PRAGMA data_version\" on separate database connections are often\n        different even though the underlying database is identical. It is\n        only meaningful to compare the \"PRAGMA data_version\" values returned\n        by the same database connection at two different points in time.\n        "),
        _Utils_Tuple3("pragma_database_list()", "https://www.sqlite.org/pragma.html#pragma_database_list", "\n        This pragma works like a query to return one row for each database\n        attached to the current database connection. The second column is\n        \"main\" for the main database file, \"temp\" for the database file used\n        to store TEMP objects, or the name of the ATTACHed database for other\n        database files. The third column is the name of the database file\n        itself, or an empty string if the database is not associated with a\n        file.\n        "),
        _Utils_Tuple3("pragma_defer_foreign_keys()", "https://www.sqlite.org/pragma.html#pragma_defer_foreign_keys", "\n        When the defer_foreign_keys PRAGMA is on, enforcement of all foreign\n        key constraints is delayed until the outermost transaction is\n        committed. The defer_foreign_keys pragma defaults to OFF so that\n        foreign key constraints are only deferred if they are created as\n        \"DEFERRABLE INITIALLY DEFERRED\". The defer_foreign_keys pragma is\n        automatically switched off at each COMMIT or ROLLBACK. Hence, the\n        defer_foreign_keys pragma must be separately enabled for each\n        transaction. This pragma is only meaningful if foreign key\n        constraints are enabled, of course.\n\n        The sqlite3_db_status(db,SQLITE_DBSTATUS_DEFERRED_FKS,...) C-language\n        interface can be used during a transaction to determine if there are\n        deferred and unresolved foreign key constraints.\n        "),
        _Utils_Tuple3("pragma_encoding()", "https://www.sqlite.org/pragma.html#pragma_encoding", "\n        In first form, if the main database has already been created, then\n        this pragma returns the text encoding used by the main database, one\n        of 'UTF-8', 'UTF-16le' (little-endian UTF-16 encoding) or 'UTF-16be'\n        (big-endian UTF-16 encoding). If the main database has not already\n        been created, then the value returned is the text encoding that will\n        be used to create the main database, if it is created by this session.\n\n        The second through fifth forms of this pragma set the encoding that\n        the main database will be created with if it is created by this\n        session. The string 'UTF-16' is interpreted as \"UTF-16 encoding using\n        native machine byte-ordering\". It is not possible to change the text\n        encoding of a database after it has been created and any attempt to\n        do so will be silently ignored.\n\n        If no encoding is first set with this pragma, then the encoding with\n        which the main database will be created defaults to one determined by\n        the API used to open the connection.\n\n        Once an encoding has been set for a database, it cannot be changed.\n\n        Databases created by the ATTACH command always use the same encoding\n        as the main database. An attempt to ATTACH a database with a\n        different text encoding from the \"main\" database will fail.\n        "),
        _Utils_Tuple3("pragma_foreign_key_check()", "https://www.sqlite.org/pragma.html#pragma_foreign_key_check", "\n        The foreign_key_check pragma checks the database, or the table called\n        \"table-name\", for foreign key constraints that are violated. The\n        foreign_key_check pragma returns one row output for each foreign key\n        violation. There are four columns in each result row. The first\n        column is the name of the table that contains the REFERENCES clause.\n        The second column is the rowid of the row that contains the invalid\n        REFERENCES clause, or NULL if the child table is a WITHOUT ROWID\n        table. The third column is the name of the table that is referred to.\n        The fourth column is the index of the specific foreign key constraint\n        that failed. The fourth column in the output of the foreign_key_check\n        pragma is the same integer as the first column in the output of the\n        foreign_key_list pragma. When a \"table-name\" is specified, the only\n        foreign key constraints checked are those created by REFERENCES\n        clauses in the CREATE TABLE statement for table-name.\n        "),
        _Utils_Tuple3("pragma_foreign_keys()", "https://www.sqlite.org/pragma.html#pragma_foreign_keys", "\n        Query, set, or clear the enforcement of foreign key constraints.\n\n        This pragma is a no-op within a transaction; foreign key constraint\n        enforcement may only be enabled or disabled when there is no pending\n        BEGIN or SAVEPOINT.\n\n        Changing the foreign_keys setting affects the execution of all\n        statements prepared using the database connection, including those\n        prepared before the setting was changed. Any existing statements\n        prepared using the legacy sqlite3_prepare() interface may fail with\n        an SQLITE_SCHEMA error after the foreign_keys setting is changed.\n\n        As of SQLite version 3.6.19, the default setting for foreign key\n        enforcement is OFF. However, that might change in a future release of\n        SQLite. The default setting for foreign key enforcement can be\n        specified at compile-time using the SQLITE_DEFAULT_FOREIGN_KEYS\n        preprocessor macro. To minimize future problems, applications should\n        set the foreign key enforcement flag as required by the application\n        and not depend on the default setting.\n        "),
        _Utils_Tuple3("pragma_freelist_count()", "https://www.sqlite.org/pragma.html#pragma_freelist_count", "\n        Return the number of unused pages in the database file.\n        "),
        _Utils_Tuple3("pragma_full_column_names()", "https://www.sqlite.org/pragma.html#pragma_full_column_names", "\n        Query or change the full_column_names flag. This flag together with\n        the short_column_names flag determine the way SQLite assigns names to\n        result columns of SELECT statements. Result columns are named by\n        applying the following rules in order:\n\n        If there is an AS clause on the result, then the name of the column\n        is the right-hand side of the AS clause.\n\n        If the result is a general expression, not a just the name of a\n        source table column, then the name of the result is a copy of the\n        expression text.\n\n        If the short_column_names pragma is ON, then the name of the result\n        is the name of the source table column without the source table name\n        prefix: COLUMN.\n\n        If both pragmas short_column_names and full_column_names are OFF then\n        case (2) applies.\n\n        The name of the result column is a combination of the source table\n        and source column name: TABLE.COLUMN\n        "),
        _Utils_Tuple3("pragma_fullfsync()", "https://www.sqlite.org/pragma.html#pragma_fullfsync", "\n        Query or change the fullfsync flag.\n        This flag determines whether or not the F_FULLFSYNC syncing method\n        is used on systems that support it.\n        The default value of the fullfsync flag is off.\n        Only Mac OS X supports F_FULLFSYNC.\n\n        See also checkpoint_fullfsync.\n        "),
        _Utils_Tuple3("pragma_function_list()", "https://www.sqlite.org/pragma.html#pragma_function_list", "\n        This pragma returns a list of SQL functions known to the database\n        connection. Each row of the result describes a single calling\n        signature for a single SQL function. Some SQL functions will have\n        multiple rows in the result set if they can (for example) be invoked\n        with a varying number of arguments or can accept text in various\n        encodings.\n        "),
        _Utils_Tuple3("pragma_ignore_check_constraints()", "https://www.sqlite.org/pragma.html#pragma_ignore_check_constraints", "\n        This pragma enables or disables the enforcement of CHECK constraints.\n        The default setting is off,\n        meaning that CHECK constraints are enforced by default.\n        "),
        _Utils_Tuple3("pragma_index_info(index-name)", "https://www.sqlite.org/pragma.html#pragma_index_info", "\n        This pragma returns one row for each key column in the named index. A\n        key column is a column that is actually named in the CREATE INDEX\n        index statement or UNIQUE constraint or PRIMARY KEY constraint that\n        created the index. Index entries also usually contain auxiliary\n        columns that point back to the table row being indexed. The auxiliary\n        index-columns are not shown by the index_info pragma, but they are\n        listed by the index_xinfo pragma.\n\n        Output columns from the index_info pragma are as follows:\n\n        The rank of the column within the index. (0 means left-most.)\n        The rank of the column within the table being indexed. A value of -1\n        means rowid and a value of -2 means that an expression is being used.\n        The name of the column being indexed. This columns is NULL if the\n        column is the rowid or an expression.\n        If there is no index named index-name but there is a WITHOUT ROWID\n        table with that name, then (as of SQLite version 3.30.0 on\n        2019-10-04) this pragma returns the PRIMARY KEY columns of the\n        WITHOUT ROWID table as they are used in the records of the underlying\n        b-tree, which is to say with duplicate columns removed.\n        "),
        _Utils_Tuple3("pragma_index_list(table-name)", "https://www.sqlite.org/pragma.html#pragma_index_list", "\n        This pragma returns one row for each index associated with the given\n        table.\n\n        Output columns from the index_list pragma are as follows:\n\n        A sequence number assigned to each index for internal tracking\n        purposes.\n        The name of the index.\n        \"1\" if the index is UNIQUE and \"0\" if not.\n        \"c\" if the index was created by a CREATE INDEX statement, \"u\" if the\n        index was created by a UNIQUE constraint, or \"pk\" if the index was\n        created by a PRIMARY KEY constraint.\n        \"1\" if the index is a partial index and \"0\" if not.\n        "),
        _Utils_Tuple3("pragma_index_xinfo(index-name)", "https://www.sqlite.org/pragma.html#pragma_index_xinfo", "\n        This pragma returns information about every column in an index.\n        Unlike this index_info pragma, this pragma returns information about\n        every column in the index, not just the key columns. (A key column is\n        a column that is actually named in the CREATE INDEX index statement\n        or UNIQUE constraint or PRIMARY KEY constraint that created the\n        index. Auxiliary columns are additional columns needed to locate the\n        table entry that corresponds to each index entry.)\n\n        Output columns from the index_xinfo pragma are as follows:\n\n        The rank of the column within the index. (0 means left-most. Key\n        columns come before auxiliary columns.)\n        The rank of the column within the table being indexed, or -1 if the\n        index-column is the rowid of the table being indexed and -2 if the\n        index is on an expression.\n        The name of the column being indexed, or NULL if the index-column is\n        the rowid of the table being indexed or an expression.\n        1 if the index-column is sorted in reverse (DESC) order by the index\n        and 0 otherwise.\n        The name for the collating sequence used to compare values in the\n        index-column.\n        1 if the index-column is a key column and 0 if the index-column is an\n        auxiliary column.\n        If there is no index named index-name but there is a WITHOUT ROWID\n        table with that name, then (as of SQLite version 3.30.0 on\n        2019-10-04) this pragma returns the columns of the WITHOUT ROWID\n        table as they are used in the records of the underlying b-tree, which\n        is to say with de-duplicated PRIMARY KEY columns first followed by\n        data columns.\n        "),
        _Utils_Tuple3("pragma_integrity_check()", "https://www.sqlite.org/pragma.html#pragma_integrity_check", "\n        This pragma does a low-level formatting and consistency check of the\n        database. The integrity_check pragma look for:\n\n        Table or index entries that are out of sequence\n        Misformatted records\n        Missing pages\n        Missing or surplus index entries\n        UNIQUE, CHECK, and NOT NULL constraint errors\n        Integrity of the freelist\n        Sections of the database that are used more than once, or not at all\n        If the integrity_check pragma finds problems, strings are returned\n        (as multiple rows with a single column per row) which describe the\n        problems. Pragma integrity_check will return at most N errors before\n        the analysis quits, with N defaulting to 100. If pragma\n        integrity_check finds no errors, a single row with the value 'ok' is\n        returned.\n\n        The usual case is that the entire database file is checked. However,\n        if the argument is TABLENAME, then checking is only performed for the\n        the table named and its associated indexes. This is called a \"partial\n        integrity check\". Because only a subset of the database is checked,\n        errors such as unused sections of the file or duplication use of the\n        same section of the file by two or more tables cannot be detected.\n        The freelist is only verified on a partial integrity check if\n        TABLENAME is sqlite_schema or one of its aliases. Support for partial\n        integrity checks was added with version 3.33.0 (2020-08-14).\n\n        PRAGMA integrity_check does not find FOREIGN KEY errors. Use the\n        PRAGMA foreign_key_check command to find errors in FOREIGN KEY\n        constraints.\n\n        See also the PRAGMA quick_check command which does most of the\n        checking of PRAGMA integrity_check but runs much faster.\n        "),
        _Utils_Tuple3("pragma_journal_mode()", "https://www.sqlite.org/pragma.html#pragma_journal_mode", "\n        This pragma queries or sets the journal mode for databases associated\n        with the current database connection.\n\n        The first form of this pragma queries the current journaling mode for\n        database. When database is omitted, the \"main\" database is queried.\n\n        The second form changes the journaling mode for \"database\" or for all\n        attached databases if \"database\" is omitted. The new journal mode is\n        returned. If the journal mode could not be changed, the original\n        journal mode is returned.\n\n        The DELETE journaling mode is the normal behavior. In the DELETE\n        mode, the rollback journal is deleted at the conclusion of each\n        transaction. Indeed, the delete operation is the action that causes\n        the transaction to commit. (See the document titled Atomic Commit In\n        SQLite for additional detail.)\n\n        The TRUNCATE journaling mode commits transactions by truncating the\n        rollback journal to zero-length instead of deleting it. On many\n        systems, truncating a file is much faster than deleting the file\n        since the containing directory does not need to be changed.\n\n        The PERSIST journaling mode prevents the rollback journal from being\n        deleted at the end of each transaction. Instead, the header of the\n        journal is overwritten with zeros. This will prevent other database\n        connections from rolling the journal back. The PERSIST journaling\n        mode is useful as an optimization on platforms where deleting or\n        truncating a file is much more expensive than overwriting the first\n        block of a file with zeros. See also: PRAGMA journal_size_limit and\n        SQLITE_DEFAULT_JOURNAL_SIZE_LIMIT.\n\n        The MEMORY journaling mode stores the rollback journal in volatile\n        RAM. This saves disk I/O but at the expense of database safety and\n        integrity. If the application using SQLite crashes in the middle of a\n        transaction when the MEMORY journaling mode is set, then the database\n        file will very likely go corrupt.\n\n        The WAL journaling mode uses a write-ahead log instead of a rollback\n        journal to implement transactions. The WAL journaling mode is\n        persistent; after being set it stays in effect across multiple\n        database connections and after closing and reopening the database. A\n        database in WAL journaling mode can only be accessed by SQLite\n        version 3.7.0 (2010-07-21) or later.\n\n        The OFF journaling mode disables the rollback journal completely. No\n        rollback journal is ever created and hence there is never a rollback\n        journal to delete. The OFF journaling mode disables the atomic commit\n        and rollback capabilities of SQLite. The ROLLBACK command no longer\n        works; it behaves in an undefined way. Applications must avoid using\n        the ROLLBACK command when the journal mode is OFF. If the application\n        crashes in the middle of a transaction when the OFF journaling mode\n        is set, then the database file will very likely go corrupt. Without a\n        journal, there is no way for a statement to unwind partially\n        completed operations following a constraint error. This might also\n        leave the database in a corrupted state. For example, if a duplicate\n        entry causes a CREATE UNIQUE INDEX statement to fail half-way\n        through, it will leave behind a partially created, and hence corrupt,\n        index. Because OFF journaling mode allows the database file to be\n        corrupted using ordinary SQL, it is disabled when\n        SQLITE_DBCONFIG_DEFENSIVE is enabled.\n\n        Note that the journal_mode for an in-memory database is either MEMORY\n        or OFF and can not be changed to a different value. An attempt to\n        change the journal_mode of an in-memory database to any setting other\n        than MEMORY or OFF is ignored. Note also that the journal_mode cannot\n        be changed while a transaction is active.\n        "),
        _Utils_Tuple3("pragma_journal_size_limit()", "https://www.sqlite.org/pragma.html#pragma_journal_size_limit", "\n        If a database connection is operating in exclusive locking mode or in\n        persistent journal mode (PRAGMA journal_mode=persist) then after\n        committing a transaction the rollback journal file may remain in the\n        file-system. This increases performance for subsequent transactions\n        since overwriting an existing file is faster than append to a file,\n        but it also consumes file-system space. After a large transaction\n        (e.g. a VACUUM), the rollback journal file may consume a very large\n        amount of space.\n\n        Similarly, in WAL mode, the write-ahead log file is not truncated\n        following a checkpoint. Instead, SQLite reuses the existing file for\n        subsequent WAL entries since overwriting is faster than appending.\n\n        The journal_size_limit pragma may be used to limit the size of\n        rollback-journal and WAL files left in the file-system after\n        transactions or checkpoints. Each time a transaction is committed or\n        a WAL file resets, SQLite compares the size of the rollback journal\n        file or WAL file left in the file-system to the size limit set by\n        this pragma and if the journal or WAL file is larger it is truncated\n        to the limit.\n\n        The second form of the pragma listed above is used to set a new limit\n        in bytes for the specified database. A negative number implies no\n        limit. To always truncate rollback journals and WAL files to their\n        minimum size, set the journal_size_limit to zero. Both the first and\n        second forms of the pragma listed above return a single result row\n        containing a single integer column - the value of the journal size\n        limit in bytes. The default journal size limit is -1 (no limit). The\n        SQLITE_DEFAULT_JOURNAL_SIZE_LIMIT preprocessor macro can be used to\n        change the default journal size limit at compile-time.\n\n        This pragma only operates on the single database specified prior to\n        the pragma name (or on the \"main\" database if no database is\n        specified.) There is no way to change the journal size limit on all\n        attached databases using a single PRAGMA statement. The size limit\n        must be set separately for each attached database.\n        "),
        _Utils_Tuple3("pragma_legacy_alter_table()", "https://www.sqlite.org/pragma.html#pragma_legacy_alter_table", "\n        This pragma sets or queries the value of the legacy_alter_table flag.\n        When this flag is on, the ALTER TABLE RENAME command (for changing\n        the name of a table) works as it did in SQLite 3.24.0 (2018-06-04)\n        and earlier. More specifically, when this flag is on the ALTER TABLE\n        RENAME command only rewrites the initial occurrence of the table name\n        in its CREATE TABLE statement and in any associated CREATE INDEX and\n        CREATE TRIGGER statements. Other references to the table are\n        unmodified, including:\n\n        References to the table within the bodies of triggers and views.\n        References to the table within CHECK constraints in the original\n        CREATE TABLE statement.\n        References to the table within the WHERE clauses of partial indexes.\n        The default setting for this pragma is OFF, which means that all\n        references to the table anywhere in the schema are converted to the\n        new name.\n        This pragma is provided as a work-around for older programs that\n        contain code that expect the incomplete behavior of ALTER TABLE\n        RENAME found in older versions of SQLite. New applications should\n        leave this flag turned off.\n\n        For compatibility with older virtual table implementations, this flag\n        is turned on temporarily while the sqlite3_module.xRename method is\n        being run. The value of this flag is restored after the\n        sqlite3_module.xRename method finishes.\n\n        The legacy alter table behavior can also be toggled on and off using\n        the SQLITE_DBCONFIG_LEGACY_ALTER_TABLE option to the\n        sqlite3_db_config() interface.\n\n        The legacy alter table behavior is a per-connection setting. Turning\n        this features on or off affects all attached database files within\n        the database connection. The setting does not persist. Changing this\n        setting in one connection does not affect any other connections.\n        "),
        _Utils_Tuple3("pragma_locking_mode()", "https://www.sqlite.org/pragma.html#pragma_locking_mode", "\n        This pragma sets or queries the database connection locking-mode. The\n        locking-mode is either NORMAL or EXCLUSIVE.\n\n        In NORMAL locking-mode (the default unless overridden at compile-time\n        using SQLITE_DEFAULT_LOCKING_MODE), a database connection unlocks the\n        database file at the conclusion of each read or write transaction.\n        When the locking-mode is set to EXCLUSIVE, the database connection\n        never releases file-locks. The first time the database is read in\n        EXCLUSIVE mode, a shared lock is obtained and held. The first time\n        the database is written, an exclusive lock is obtained and held.\n\n        Database locks obtained by a connection in EXCLUSIVE mode may be\n        released either by closing the database connection, or by setting the\n        locking-mode back to NORMAL using this pragma and then accessing the\n        database file (for read or write). Simply setting the locking-mode to\n        NORMAL is not enough - locks are not released until the next time the\n        database file is accessed.\n\n        There are three reasons to set the locking-mode to EXCLUSIVE.\n\n        The application wants to prevent other processes from accessing the\n        database file.\n        The number of system calls for filesystem operations is reduced,\n        possibly resulting in a small performance increase.\n        WAL databases can be accessed in EXCLUSIVE mode without the use of\n        shared memory. (Additional information)\n        When the locking_mode pragma specifies a particular database, for\n        example:\n\n        PRAGMA main.locking_mode=EXCLUSIVE;\n        then the locking mode applies only to the named database. If no\n        database name qualifier precedes the \"locking_mode\" keyword then the\n        locking mode is applied to all databases, including any new databases\n        added by subsequent ATTACH commands.\n\n        The \"temp\" database (in which TEMP tables and indices are stored) and\n        in-memory databases always uses exclusive locking mode. The locking\n        mode of temp and in-memory databases cannot be changed. All other\n        databases use the normal locking mode by default and are affected by\n        this pragma.\n\n        If the locking mode is EXCLUSIVE when first entering WAL journal\n        mode, then the locking mode cannot be changed to NORMAL until after\n        exiting WAL journal mode. If the locking mode is NORMAL when first\n        entering WAL journal mode, then the locking mode can be changed\n        between NORMAL and EXCLUSIVE and back again at any time and without\n        needing to exit WAL journal mode.\n        "),
        _Utils_Tuple3("pragma_max_page_count()", "https://www.sqlite.org/pragma.html#pragma_max_page_count", "\n        Query or set the maximum number of pages in the database file. Both\n        forms of the pragma return the maximum page count. The second form\n        attempts to modify the maximum page count. The maximum page count\n        cannot be reduced below the current database size.\n        "),
        _Utils_Tuple3("pragma_module_list()", "https://www.sqlite.org/pragma.html#pragma_module_list", "\n        This pragma returns a list of virtual table modules\n        registered with the database connection.\n        "),
        _Utils_Tuple3("pragma_optimize()", "https://www.sqlite.org/pragma.html#pragma_optimize", "\n        Attempt to optimize the database. All schemas are optimized in the\n        first two forms, and only the specified schema is optimized in the\n        latter two.\n\n        To achieve the best long-term query performance without the need to\n        do a detailed engineering analysis of the application schema and SQL,\n        it is recommended that applications run \"PRAGMA optimize\" (with no\n        arguments) just before closing each database connection. Long-running\n        applications might also benefit from setting a timer to run \"PRAGMA\n        optimize\" every few hours.\n\n        This pragma is usually a no-op or nearly so and is very fast. However\n        if SQLite feels that performing database optimizations (such as\n        running ANALYZE or creating new indexes) will improve the performance\n        of future queries, then some database I/O may be done. Applications\n        that want to limit the amount of work performed can set a timer that\n        will invoke sqlite3_interrupt() if the pragma goes on for too long.\n        Or, since SQLite 3.32.0, the application can use PRAGMA\n        analysis_limit=N for some small value of N (a few hundred or a few\n        thousand) to limit the depth of analyze.\n\n        The details of optimizations performed by this pragma are expected to\n        change and improve over time. Applications should anticipate that\n        this pragma will perform new optimizations in future releases.\n\n        The optional MASK argument is a bitmask of optimizations to perform:\n\n        Debugging mode. Do not actually perform any optimizations but instead\n        return one line of text for each optimization that would have been\n        done. Off by default.\n\n        Run ANALYZE on tables that might benefit. On by default. See below\n        for additional information.\n\n        (Not yet implemented) Record usage and performance information from\n        the current session in the database file so that it will be available\n        to \"optimize\" pragmas run by future database connections.\n\n        (Not yet implemented) Create indexes that might have been helpful to\n        recent queries.\n\n        The default MASK is and always shall be 0xfffe. The 0xfffe mask means\n        perform all of the optimizations listed above except Debug Mode. If\n        new optimizations are added in the future that should be off by\n        default, those new optimizations will be given a mask of 0x10000 or\n        larger.\n\n        To see all optimizations that would have been done without actually\n        doing them, run \"PRAGMA optimize(-1)\". To use only the ANALYZE\n        optimization, run \"PRAGMA optimize(0x02)\".\n\n        Determination Of When To Run Analyze\n\n        In the current implementation, a table is analyzed if and only if all\n        of the following are true:\n\n        MASK bit 0x02 is set.\n\n        The query planner used sqlite_stat1-style statistics for one or more\n        indexes of the table at some point during the lifetime of the current\n        connection.\n\n        One or more indexes of the table are currently unanalyzed or the\n        number of rows in the table has increased by 25 times or more since\n        the last time ANALYZE was run.\n\n        The rules for when tables are analyzed are likely to change in future\n        releases.\n        "),
        _Utils_Tuple3("pragma_page_count()", "https://www.sqlite.org/pragma.html#pragma_page_count", "\n        Return the total number of pages in the database file.\n        "),
        _Utils_Tuple3("pragma_page_size()", "https://www.sqlite.org/pragma.html#pragma_page_size", "\n        Query or set the page size of the database. The page size must be a\n        power of two between 512 and 65536 inclusive.\n\n        When a new database is created, SQLite assigns a page size to the\n        database based on platform and filesystem. For many years, the\n        default page size was almost always 1024 bytes, but beginning with\n        SQLite version 3.12.0 (2016-03-29), the default page size increased\n        to 4096. The default page size is recommended for most applications.\n\n        Specifying a new page size does not change the page size immediately.\n        Instead, the new page size is remembered and is used to set the page\n        size when the database is first created, if it does not already exist\n        when the page_size pragma is issued, or at the next VACUUM command\n        that is run on the same database connection while not in WAL mode.\n\n        The SQLITE_DEFAULT_PAGE_SIZE compile-time option can be used to\n        change the default page size assigned to new databases.\n        "),
        _Utils_Tuple3("pragma_pragma_list()", "https://www.sqlite.org/pragma.html#pragma_pragma_list", "\n        This pragma returns a list of `PRAGMA` commands\n        known to the database connection.\n        "),
        _Utils_Tuple3("pragma_query_only()", "https://www.sqlite.org/pragma.html#pragma_query_only", "\n        The query_only pragma prevents data changes on database files when\n        enabled. When this pragma is enabled, any attempt to CREATE, DELETE,\n        DROP, INSERT, or UPDATE will result in an SQLITE_READONLY error.\n        However, the database is not truly read-only. You can still run a\n        checkpoint or a COMMIT and the return value of the\n        sqlite3_db_readonly() routine is not affected.\n        "),
        _Utils_Tuple3("pragma_quick_check()", "https://www.sqlite.org/pragma.html#pragma_quick_check", "\n        The pragma is like integrity_check except that it does not verify\n        UNIQUE constraints and does not verify that index content matches\n        table content. By skipping UNIQUE and index consistency checks,\n        quick_check is able to run faster. PRAGMA quick_check runs in O(N)\n        time whereas PRAGMA integrity_check requires O(NlogN) time where N is\n        the total number of rows in the database. Otherwise the two pragmas\n        are the same.\n        "),
        _Utils_Tuple3("pragma_read_uncommitted()", "https://www.sqlite.org/pragma.html#pragma_read_uncommitted", "\n        Query, set, or clear READ UNCOMMITTED isolation. The default\n        isolation level for SQLite is SERIALIZABLE. Any process or thread can\n        select READ UNCOMMITTED isolation, but SERIALIZABLE will still be\n        used except between connections that share a common page and schema\n        cache. Cache sharing is enabled using the\n        sqlite3_enable_shared_cache() API. Cache sharing is disabled by\n        default.\n\n        See SQLite Shared-Cache Mode for additional information.\n        "),
        _Utils_Tuple3("pragma_recursive_triggers()", "https://www.sqlite.org/pragma.html#pragma_recursive_triggers", "\n        Query, set, or clear the recursive trigger capability.\n\n        Changing the recursive_triggers setting affects the execution of all\n        statements prepared using the database connection, including those\n        prepared before the setting was changed. Any existing statements\n        prepared using the legacy sqlite3_prepare() interface may fail with\n        an SQLITE_SCHEMA error after the recursive_triggers setting is\n        changed.\n\n        Prior to SQLite version 3.6.18 (2009-09-11), recursive triggers were\n        not supported. The behavior of SQLite was always as if this pragma\n        was set to OFF. Support for recursive triggers was added in version\n        3.6.18 but was initially turned OFF by default, for compatibility.\n        Recursive triggers may be turned on by default in future versions of\n        SQLite.\n\n        The depth of recursion for triggers has a hard upper limit set by the\n        SQLITE_MAX_TRIGGER_DEPTH compile-time option and a run-time limit set\n        by sqlite3_limit(db,SQLITE_LIMIT_TRIGGER_DEPTH,...).\n        "),
        _Utils_Tuple3("pragma_reverse_unordered_selects()", "https://www.sqlite.org/pragma.html#pragma_reverse_unordered_selects", "\n        When enabled, this PRAGMA causes many SELECT statements without an\n        ORDER BY clause to emit their results in the reverse order from what\n        they normally would. This can help debug applications that are making\n        invalid assumptions about the result order. The\n        reverse_unordered_selects pragma works for most SELECT statements,\n        however the query planner may sometimes choose an algorithm that is\n        not easily reversed, in which case the output will appear in the same\n        order regardless of the reverse_unordered_selects setting.\n\n        SQLite makes no guarantees about the order of results if a SELECT\n        omits the ORDER BY clause. Even so, the order of results does not\n        change from one run to the next, and so many applications mistakenly\n        come to depend on the arbitrary output order whatever that order\n        happens to be. However, sometimes new versions of SQLite will contain\n        optimizer enhancements that will cause the output order of queries\n        without ORDER BY clauses to shift. When that happens, applications\n        that depend on a certain output order might malfunction. By running\n        the application multiple times with this pragma both disabled and\n        enabled, cases where the application makes faulty assumptions about\n        output order can be identified and fixed early, reducing problems\n        that might be caused by linking against a different version of SQLite.\n        "),
        _Utils_Tuple3("pragma_schema_version()", "https://www.sqlite.org/pragma.html#pragma_schema_version", "\n        The schema_version pragma will get or set the value of the\n        schema-version integer at offset 40 in the database header.\n\n        SQLite automatically increments the schema-version whenever the\n        schema changes. As each SQL statement runs, the schema version is\n        checked to ensure that the schema has not changed since the SQL\n        statement was prepared. Subverting this mechanism by using \"PRAGMA\n        schema_version=N\" to change the value of the schema_version may cause\n        SQL statement to run using an obsolete schema, which can lead to\n        incorrect answers and/or database corruption. It is always safe to\n        read the schema_version, but changing the schema_version can cause\n        problems. For this reason, attempts to change the value of\n        schema_version are a silent no-op when defensive mode is enabled for\n        a database connection.\n\n        Warning: Misuse of this pragma can result in database corruption.\n\n        For the purposes of this pragma, the VACUUM command is considered a\n        schema change, since VACUUM will usually alter the \"rootpage\" values\n        for entries in the sqlite_schema table.\n\n        See also the application_id pragma and user_version pragma.\n        "),
        _Utils_Tuple3("pragma_secure_delete()", "https://www.sqlite.org/pragma.html#pragma_secure_delete", "\n        Query or change the secure-delete setting. When secure_delete is on,\n        SQLite overwrites deleted content with zeros. The default setting for\n        secure_delete is determined by the SQLITE_SECURE_DELETE compile-time\n        option and is normally off. The off setting for secure_delete\n        improves performance by reducing the number of CPU cycles and the\n        amount of disk I/O. Applications that wish to avoid leaving forensic\n        traces after content is deleted or updated should enable the\n        secure_delete pragma prior to performing the delete or update, or\n        else run VACUUM after the delete or update.\n\n        The \"fast\" setting for secure_delete (added circa 2017-08-01) is an\n        intermediate setting in between \"on\" and \"off\". When secure_delete is\n        set to \"fast\", SQLite will overwrite deleted content with zeros only\n        if doing so does not increase the amount of I/O. In other words, the\n        \"fast\" setting uses more CPU cycles but does not use more I/O. This\n        has the effect of purging all old content from b-tree pages, but\n        leaving forensic traces on freelist pages.\n\n        When there are attached databases and no database is specified in the\n        pragma, all databases have their secure-delete setting altered. The\n        secure-delete setting for newly attached databases is the setting of\n        the main database at the time the ATTACH command is evaluated.\n\n        When multiple database connections share the same cache, changing the\n        secure-delete flag on one database connection changes it for them all.\n        "),
        _Utils_Tuple3("pragma_soft_heap_limit()", "https://www.sqlite.org/pragma.html#pragma_soft_heap_limit", "\n        This pragma invokes the sqlite3_soft_heap_limit64() interface with\n        the argument N, if N is specified and is a non-negative integer. The\n        soft_heap_limit pragma always returns the same integer that would be\n        returned by the sqlite3_soft_heap_limit64(-1) C-language function.\n\n        See also the hard_heap_limit pragma.\n        "),
        _Utils_Tuple3("pragma_synchronous()", "https://www.sqlite.org/pragma.html#pragma_synchronous", "\n        Query or change the setting of the \"synchronous\" flag. The first\n        (query) form will return the synchronous setting as an integer. The\n        second form changes the synchronous setting. The meanings of the\n        various synchronous settings are as follows:\n\n        EXTRA (3)\n        EXTRA synchronous is like FULL with the addition that the directory\n        containing a rollback journal is synced after that journal is\n        unlinked to commit a transaction in DELETE mode. EXTRA provides\n        additional durability if the commit is followed closely by a power\n        loss.\n        FULL (2)\n        When synchronous is FULL (2), the SQLite database engine will use the\n        xSync method of the VFS to ensure that all content is safely written\n        to the disk surface prior to continuing. This ensures that an\n        operating system crash or power failure will not corrupt the\n        database. FULL synchronous is very safe, but it is also slower. FULL\n        is the most commonly used synchronous setting when not in WAL mode.\n        NORMAL (1)\n        When synchronous is NORMAL (1), the SQLite database engine will still\n        sync at the most critical moments, but less often than in FULL mode.\n        There is a very small (though non-zero) chance that a power failure\n        at just the wrong time could corrupt the database in\n        journal_mode=DELETE on an older filesystem. WAL mode is safe from\n        corruption with synchronous=NORMAL, and probably DELETE mode is safe\n        too on modern filesystems. WAL mode is always consistent with\n        synchronous=NORMAL, but WAL mode does lose durability. A transaction\n        committed in WAL mode with synchronous=NORMAL might roll back\n        following a power loss or system crash. Transactions are durable\n        across application crashes regardless of the synchronous setting or\n        journal mode. The synchronous=NORMAL setting is a good choice for\n        most applications running in WAL mode.\n        OFF (0)\n        With synchronous OFF (0), SQLite continues without syncing as soon as\n        it has handed data off to the operating system. If the application\n        running SQLite crashes, the data will be safe, but the database might\n        become corrupted if the operating system crashes or the computer\n        loses power before that data has been written to the disk surface. On\n        the other hand, commits can be orders of magnitude faster with\n        synchronous OFF.\n        In WAL mode when synchronous is NORMAL (1), the WAL file is\n        synchronized before each checkpoint and the database file is\n        synchronized after each completed checkpoint and the WAL file header\n        is synchronized when a WAL file begins to be reused after a\n        checkpoint, but no sync operations occur during most transactions.\n        With synchronous=FULL in WAL mode, an additional sync operation of\n        the WAL file happens after each transaction commit. The extra WAL\n        sync following each transaction helps ensure that transactions are\n        durable across a power loss. Transactions are consistent with or\n        without the extra syncs provided by synchronous=FULL. If durability\n        is not a concern, then synchronous=NORMAL is normally all one needs\n        in WAL mode.\n\n        The TEMP schema always has synchronous=OFF since the content of of\n        TEMP is ephemeral and is not expected to survive a power outage.\n        Attempts to change the synchronous setting for TEMP are silently\n        ignored.\n\n        See also the fullfsync and checkpoint_fullfsync pragmas.\n        "),
        _Utils_Tuple3("pragma_table_info()", "https://www.sqlite.org/pragma.html#pragma_table_info", "\n        This pragma returns one row for each normal column in the named\n        table. Columns in the result set include: \"name\" (its name); \"type\"\n        (data type if given, else ''); \"notnull\" (whether or not the column\n        can be NULL); \"dflt_value\" (the default value for the column); and\n        \"pk\" (either zero for columns that are not part of the primary key,\n        or the 1-based index of the column within the primary key).\n\n        The \"cid\" column should not be taken to mean more than \"rank within\n        the current result set\".\n\n        The table named in the table_info pragma can also be a view.\n\n        This pragma does not show information about generated columns or\n        hidden columns. Use PRAGMA table_xinfo to get a more complete list of\n        columns that includes generated and hidden columns.\n        "),
        _Utils_Tuple3("pragma_table_list()", "https://www.sqlite.org/pragma.html#pragma_table_list", "\n        This pragma returns information about the tables and views in the\n        schema, one table per row of output. The table_list pragma first\n        appeared in SQLite version 3.37.0 (2021-11-27). As of its initial\n        release the columns returned by the table_list pragma include those\n        listed below. Future versions of SQLite will probably add additional\n        columns of output.\n\n        schema: the schema in which the table or view appears (for example\n        \"main\" or \"temp\").\n        name: the name of the table or view.\n        type: the type of object - one of \"table\", \"view\", \"shadow\" (for\n        shadow tables), or \"virtual\" for virtual tables.\n        ncol: the number of columns in the table, including generated columns\n        and hidden columns.\n        wr: 1 if the table is a WITHOUT ROWID table or 0 if is not.\n        strict: 1 if the table is a STRICT table or 0 if it is not.\n        Additional columns will likely be added in future releases.\n        The default behavior is to show all tables in all schemas. If the\n        schema. name appears before the pragma, then only tables in that one\n        schema are shown. If a table-name argument is supplied, then only\n        information about that one table is returned.\n        "),
        _Utils_Tuple3("pragma_table_xinfo()", "https://www.sqlite.org/pragma.html#pragma_table_xinfo", "\n        This pragma returns one row for each column in the named table,\n        including generated columns and hidden columns. The output has the\n        same columns as for PRAGMA table_info plus a column, \"hidden\", whose\n        value signifies a normal column (0), a dynamic or stored generated\n        column (2 or 3), or a hidden column in a virtual table (1). The rows\n        for which this field is non-zero are those omitted for PRAGMA\n        table_info.\n        "),
        _Utils_Tuple3("pragma_temp_store()", "https://www.sqlite.org/pragma.html#pragma_temp_store", "\n        Query or change the setting of the \"temp_store\" parameter. When\n        temp_store is DEFAULT (0), the compile-time C preprocessor macro\n        SQLITE_TEMP_STORE is used to determine where temporary tables and\n        indices are stored. When temp_store is MEMORY (2) temporary tables\n        and indices are kept as if they were in pure in-memory databases.\n        When temp_store is FILE (1) temporary tables and indices are stored\n        in a file. The temp_store_directory pragma can be used to specify the\n        directory containing temporary files when FILE is specified. When the\n        temp_store setting is changed, all existing temporary tables,\n        indices, triggers, and views are immediately deleted.\n\n        It is possible for the library compile-time C preprocessor symbol\n        SQLITE_TEMP_STORE to override this pragma setting. The following\n        table summarizes the interaction of the SQLITE_TEMP_STORE\n        preprocessor macro and the temp_store pragma:\n\n        SQLITE_TEMP_STORE | PRAGMA temp_store | Storage used for TEMP tables and indices\n        ---|---|---\n        0 | any | file\n        1 | 0 | file\n        1 | 1 | file\n        1 | 2 | memory\n        2 | 0 | memory\n        2 | 1 | file\n        2 | 2 | memory\n        3 | any | memory\n        "),
        _Utils_Tuple3("pragma_threads()", "https://www.sqlite.org/pragma.html#pragma_threads", "\n        Query or change the value of the\n        sqlite3_limit(db,SQLITE_LIMIT_WORKER_THREADS,...) limit for the\n        current database connection. This limit sets an upper bound on the\n        number of auxiliary threads that a prepared statement is allowed to\n        launch to assist with a query. The default limit is 0 unless it is\n        changed using the SQLITE_DEFAULT_WORKER_THREADS compile-time option.\n        When the limit is zero, that means no auxiliary threads will be\n        launched.\n\n        This pragma is a thin wrapper around the\n        sqlite3_limit(db,SQLITE_LIMIT_WORKER_THREADS,...) interface.\n        "),
        _Utils_Tuple3("pragma_trusted_schema()", "https://www.sqlite.org/pragma.html#pragma_trusted_schema", "\n        The trusted_schema setting is a per-connection boolean that\n        determines whether or not SQL functions and virtual tables that have\n        not been security audited are allowed to be run by views, triggers,\n        or in expressions of the schema such as CHECK constraints, DEFAULT\n        clauses, generated columns, expression indexes, and/or partial\n        indexes. This setting can also be controlled using the\n        sqlite3_db_config(db,SQLITE_DBCONFIG_TRUSTED_SCHEMA,...) C-language\n        interface.\n\n        In order to maintain backwards compatibility, this setting is ON by\n        default. There are advantages to turning it off, and most\n        applications will be unaffected if it is turned off. For that reason,\n        all applications are encouraged to switch this setting off on every\n        database connection as soon as that connection is opened.\n\n        The -DSQLITE_TRUSTED_SCHEMA=0 compile-time option will cause this\n        setting to default to OFF.\n        "),
        _Utils_Tuple3("pragma_user_version()", "https://www.sqlite.org/pragma.html#pragma_user_version", "\n        The user_version pragma will get or set the value of the user-version\n        integer at offset 60 in the database header. The user-version is an\n        integer that is available to applications to use however they want.\n        SQLite makes no use of the user-version itself.\n\n        See also the application_id pragma and schema_version pragma.\n        "),
        _Utils_Tuple3("pragma_writable_schema()", "https://www.sqlite.org/pragma.html#pragma_writable_schema", "\n        When this pragma is on, and the SQLITE_DBCONFIG_DEFENSIVE flag is\n        off, then the sqlite_schema table can be changed using ordinary\n        UPDATE, INSERT, and DELETE statements. If the argument is \"RESET\"\n        then schema writing is disabled (as with \"PRAGMA\n        writable_schema=OFF\") and, in addition, the schema is reloaded.\n        Warning: misuse of this pragma can easily result in a corrupt\n        database file.\n        ")
    ]);
    var $author$project$Components$SQLiteDocs$scalarFunctions = _List_fromArray([
        _Utils_Tuple3("abs(X)", "https://www.sqlite.org/lang_corefunc.html#abs", "\n        The `abs(X)` function returns the absolute value of the numeric\n        argument `X`.\n        `abs(X)` returns `NULL` if `X` is `NULL`.\n        `abs(X)` returns 0.0 if X is a string or blob\n        that cannot be converted to a numeric value.\n        If X is the\n        integer -9223372036854775808 then abs(X) throws an integer overflow\n        error since there is no equivalent positive 64-bit two complement value.\n        "),
        _Utils_Tuple3("changes()", "https://www.sqlite.org/lang_corefunc.html#changes", "\n        The `changes()` function returns the number of database rows that were\n        changed or inserted or deleted by the most recently completed\n        `INSERT`, `DELETE`, or `UPDATE` statement,\n        exclusive of statements in lower-level triggers.\n        The `changes()` SQL function is a wrapper around the\n        [sqlite3_changes64()](c3ref/changes.html)\n        C/C++ function and hence follows the same rules for counting changes.\n        "),
        _Utils_Tuple3("char(X1, X2, \u2026, XN)", "https://www.sqlite.org/lang_corefunc.html#char", "\n        The char(X1, X2, \u2026, XN) function returns a string composed of characters\n        having the\n        unicode code point values of integers X1 through XN, respectively.\n        "),
        _Utils_Tuple3("coalesce(X, Y, \u2026)", "https://www.sqlite.org/lang_corefunc.html#coalesce", "\n        The `coalesce()` function returns a copy of its first non-`NULL` argument,\n        or\n        `NULL` if all arguments are `NULL`.\n        `Coalesce()` must have at least\n        2 arguments.\n        "),
        _Utils_Tuple3("format(FORMAT, \u2026)", "https://www.sqlite.org/lang_corefunc.html#format", "\n        The `format(FORMAT, \u2026)` SQL function works like the\n        [sqlite3_mprintf()](https://www.sqlite.org/c3ref/mprintf.html)\n        C-language function and the `printf()` function\n        from the standard C library.\n        The first argument is a format string that specifies how to construct\n        the output string using values taken from subsequent arguments.\n        If the FORMAT argument is missing or `NULL` then the result is `NULL`.\n        The %n format is silently ignored and does not consume an argument.\n        The %p format is an alias for %X.\n        The %z format is interchangeable with %s.\n        If there are too few arguments in the argument list,\n        missing arguments are assumed to have a `NULL` value,\n        which is translated into `0` or `0.0` for numeric formats\n        or an empty string for `%s`.\n        See the [built-in `printf()`](https://www.sqlite.org/printf.html)\n        documentation for additional information.\n        "),
        _Utils_Tuple3("glob(X, Y)", "https://www.sqlite.org/lang_corefunc.html#glob", "\n        The `glob(X, Y)` function is equivalent to the\n        expression `Y GLOB X`.\n        Note that the X and Y arguments are reversed in the `glob()` function\n        relative to the infix\n        [`GLOB`](https://www.sqlite.org/lang_expr.html#glob)\n        operator.\n        Y is the string and X is the pattern.\n        So, for example, the following expressions are equivalent:\n        ```sql\n        name GLOB '*helium*'\n        glob('*helium*',name)\n        ```\n        If the\n        [`sqlite3_create_function()`](\n            https://www.sqlite.org/c3ref/create_function.html)\n        interface is used to override the `glob(X, Y)` function\n        with an alternative implementation then the\n        [`GLOB`](https://www.sqlite.org/lang_expr.html#glob)\n        operator will invoke the alternative implementation.\n        "),
        _Utils_Tuple3("hex(X)", "https://www.sqlite.org/lang_corefunc.html#hex", "\n        The `hex()` function interprets its argument as a BLOB and returns\n        a string which is the upper-case hexadecimal rendering of the content of\n        that blob.\n\n        If the argument X in \"hex(X)\" is an\n        integer or floating point number, then \"interprets its argument as a\n        BLOB\" means\n        that the binary number is first converted into a UTF8 text\n        representation, then\n        that text is interpreted as a BLOB.\n        Hence, \"hex(12345678)\" renders\n        as \"3132333435363738\" not the binary representation of the integer value\n        \"0000000000BC614E\".\n        "),
        _Utils_Tuple3("ifnull(X, Y)", "https://www.sqlite.org/lang_corefunc.html#ifnull", "\n        The `ifnull()` function returns a copy of its first non-`NULL` argument,\n        or `NULL` if both arguments are `NULL`.\n        `Ifnull()` must have exactly 2 arguments.\n        The `ifnull()` function is equivalent to\n        [`coalesce()`](https://www.sqlite.org/lang_corefunc.html#coalesce)\n        with two arguments.\n        "),
        _Utils_Tuple3("iif(X, Y,Z)", "https://www.sqlite.org/lang_corefunc.html#iif", "\n        The iif(X, Y,Z) function returns the value Y if X is true, and Z\n        otherwise.\n        The iif(X, Y,Z) function is logically equivalent to and generates the\n        same\n\n        [`bytecode`](https://www.sqlite.org/opcode.html)\n        as the\n        [`CASE expression`](https://www.sqlite.org/lang_expr.html#case)\n        \"CASE WHEN X THEN Y ELSE Z END\".\n        "),
        _Utils_Tuple3("instr(X, Y)", "https://www.sqlite.org/lang_corefunc.html#instr", "\n        The `instr(X, Y)` function finds the first occurrence of string Y within\n        string X and returns the number of prior characters plus 1, or 0 if\n        Y is nowhere found within X.\n        Or, if X and Y are both BLOBs, then `instr(X, Y)` returns one\n        more than the number bytes prior to the first occurrence of Y, or 0 if\n        Y does not occur anywhere within X.\n        If both arguments X and Y to `instr(X, Y)` are non-`NULL` and are not BLOBs\n        then both are interpreted as strings.\n        If either X or Y are `NULL` in `instr(X, Y)` then the result is `NULL`.\n        "),
        _Utils_Tuple3("last_insert_rowid()", "https://www.sqlite.org/lang_corefunc.html#last_insert_rowid", "\n        The `last_insert_rowid()` function returns the\n        [`ROWID`](https://www.sqlite.org/lang_createtable.html#rowid)\n        of the last row insert from the database connection which invoked the\n        function.\n        The `last_insert_rowid()` SQL function is a wrapper around the\n\n        [`sqlite3_last_insert_rowid()`](https://www.sqlite.org/c3ref/last_insert_rowid.html)\n        C/C++ interface function.\n        "),
        _Utils_Tuple3("length(X)", "https://www.sqlite.org/lang_corefunc.html#length", "\n        For a string value X, the length(X) function returns the number of\n        characters (not bytes) in X prior to the first NUL character.\n        Since SQLite strings do not normally contain NUL characters, the\n        length(X)\n        function will usually return the total number of characters in the\n        string X.\n        For a blob value X, length(X) returns the number of bytes in the blob.\n        If X is `NULL` then length(X) is `NULL`.\n        If X is numeric then length(X) returns the length of a string\n        representation of X.\n\n\n        Note that for strings, the length(X) function returns the character\n        length of the string, not the byte length.\n        The character length is the number\n        of characters in the string.\n        The character length is always different from\n        the byte length for UTF-16 strings, and can be different from the byte\n        length\n        for UTF-8 strings if the string contains multi-byte characters.\n\n\n        For BLOB values, length(X) always returns the byte-length of the BLOB.\n\n\n        For string values, length(X) must read the entire string into memory in\n        order\n        to compute the character length.\n        But for BLOB values, that is not necessary as\n        SQLite knows how many bytes are in the BLOB.\n        Hence, for multi-megabyte values,\n        the length(X) function is usually much faster for BLOBs than for\n        strings, since\n        it does not need to load the value into memory.\n        "),
        _Utils_Tuple3("like(X, Y)", "https://www.sqlite.org/lang_corefunc.html#like", "\n        The `like()` function is used to implement the\n        \"Y LIKE X [ESCAPE Z]\" expression.\n        If the optional ESCAPE clause is present, then the\n        `like()` function is invoked with three arguments.\n        Otherwise, it is\n        invoked with two arguments only.\n        Note that the X and Y parameters are\n        reversed in the `like()` function relative to the infix\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator.\n        X is the pattern and Y is the string to match against that pattern.\n        Hence, the following expressions are equivalent:\n\n        ```     name LIKE '%neon%'\n        like('%neon%',name)\n        ```\n        The\n        [`sqlite3_create_function()`](https://www.sqlite.org/c3ref/create_function.html)\n        interface can be used to override the\n        `like()` function and thereby change the operation of the\n\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator.\n        When overriding the `like()` function, it may be important\n        to override both the two and three argument versions of the like()\n        function.\n        Otherwise, different code may be called to implement the\n\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator depending on whether or not an ESCAPE clause was\n        specified.\n        "),
        _Utils_Tuple3("like(X, Y,Z)", "https://www.sqlite.org/lang_corefunc.html#like", "\n        The `like()` function is used to implement the\n        \"Y LIKE X [ESCAPE Z]\" expression.\n        If the optional ESCAPE clause is present, then the\n        `like()` function is invoked with three arguments.\n        Otherwise, it is\n        invoked with two arguments only.\n        Note that the X and Y parameters are\n        reversed in the `like()` function relative to the infix\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator.\n        X is the pattern and Y is the string to match against that pattern.\n        Hence, the following expressions are equivalent:\n\n        ```     name LIKE '%neon%'\n        like('%neon%',name)\n        ```\n        The\n        [`sqlite3_create_function()`](\n            https://www.sqlite.org/c3ref/create_function.html)\n        interface can be used to override the\n        `like()` function and thereby change the operation of the\n\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator.\n        When overriding the `like()` function, it may be important\n        to override both the two and three argument versions of the like()\n        function.\n        Otherwise, different code may be called to implement the\n\n        [`LIKE`](https://www.sqlite.org/lang_expr.html#like)\n        operator depending on whether or not an ESCAPE clause was\n        specified.\n        "),
        _Utils_Tuple3("likelihood(X, Y)", "https://www.sqlite.org/lang_corefunc.html#likelihood", "\n        The `likelihood(X, Y)` function returns argument X unchanged.\n        The value Y in `likelihood(X, Y)` must be a floating point constant\n        between 0.0 and 1.0, inclusive.\n        The likelihood(X) function is a no-op that the code generator\n        optimizes away so that it consumes no CPU cycles during run-time\n        (that is, during calls to\n            [`sqlite3_step()`](https://www.sqlite.org/c3ref/step.html)).\n        The purpose of the `likelihood(X, Y)` function is to provide a hint\n        to the query planner that the argument X is a boolean that is\n        true with a probability of approximately Y.\n        The\n        [`unlikely(X)`](https://www.sqlite.org/lang_corefunc.html#unlikely)\n        function is short-hand for likelihood(X,0.0625).\n        The\n        [`likely(X)`](https://www.sqlite.org/lang_corefunc.html#likely)\n        function is short-hand for likelihood(X,0.9375).\n        "),
        _Utils_Tuple3("likely(X)", "https://www.sqlite.org/lang_corefunc.html#likely", "\n        The likely(X) function returns the argument X unchanged.\n        The likely(X) function is a no-op that the code generator\n        optimizes away so that it consumes no CPU cycles at run-time\n        (that is, during calls to\n            [`sqlite3_step()`](https://www.sqlite.org/c3ref/step.html)).\n        The purpose of the likely(X) function is to provide a hint\n        to the query planner that the argument X is a boolean value\n        that is usually true.\n        The likely(X) function is equivalent\n        to\n        [`likelihood](X,0.9375)`](https://www.sqlite.org/lang_corefunc.html#likelihood).\n        See also:\n        [`unlikely(X)`](https://www.sqlite.org/lang_corefunc.html#unlikely).\n        "),
        _Utils_Tuple3("lower(X)", "https://www.sqlite.org/lang_corefunc.html#lower", "\n        The lower(X) function returns a copy of string X with all ASCII\n        characters\n        converted to lower case.\n        The default built-in `lower()` function works\n        for ASCII characters only.\n        To do case conversions on non-ASCII\n        characters, load the ICU extension.\n        "),
        _Utils_Tuple3("ltrim(X)", "https://www.sqlite.org/lang_corefunc.html#ltrim", "\n        The ltrim(X) function returns a string formed by removing any and all\n        spaces from the left side of X.\n        "),
        _Utils_Tuple3("ltrim(X, Y)", "https://www.sqlite.org/lang_corefunc.html#ltrim", "\n        The `ltrim(X, Y)` function returns a string formed by removing any and all\n        characters that appear in Y from the left side of X.\n        "),
        _Utils_Tuple3("max(X, Y, \u2026)", "https://www.sqlite.org/lang_corefunc.html#max", "\n        The multi-argument `max()` function returns the argument with the\n        maximum value, or return `NULL` if any argument is `NULL`.\n        The multi-argument `max()` function searches its arguments from left to\n        right\n        for an argument that defines a collating function and uses that\n        collating\n        function for all string comparisons.\n        If none of the arguments to max()\n        define a collating function, then the BINARY collating function is used.\n        Note that `max()` is a simple function when\n        it has 2 or more arguments but operates as an\n\n        [`aggregate function`](https://www.sqlite.org/lang_aggfunc.html#max_agg)\n        if given only a single argument.\n        "),
        _Utils_Tuple3("min(X, Y, \u2026)", "https://www.sqlite.org/lang_corefunc.html#min", "\n        The multi-argument `min()` function returns the argument with the\n        minimum value.\n        The multi-argument `min()` function searches its arguments from left to\n        right\n        for an argument that defines a collating function and uses that\n        collating\n        function for all string comparisons.\n        If none of the arguments to min()\n        define a collating function, then the BINARY collating function is used.\n        Note that `min()` is a simple function when\n        it has 2 or more arguments but operates as an\n\n        [`aggregate function`](https://www.sqlite.org/lang_aggfunc.html#min_agg)\n        if given\n        only a single argument.\n        "),
        _Utils_Tuple3("nullif(X, Y)", "https://www.sqlite.org/lang_corefunc.html#nullif", "\n        The `nullif(X, Y)` function returns its first argument if the arguments are\n        different and `NULL` if the arguments are the same.\n        The `nullif(X, Y)` function\n        searches its arguments from left to right for an argument that defines a\n        collating function and uses that collating function for all string\n        comparisons.\n        If neither argument to `nullif()` defines a collating function\n        then the BINARY collating function is used.\n        "),
        _Utils_Tuple3("printf(FORMAT, \u2026)", "https://www.sqlite.org/lang_corefunc.html#printf", "\n        The `printf()` SQL function is an alias for the\n        [`format()` SQL function](\n            https://www.sqlite.org/lang_corefunc.html#format).\n        The `format()` SQL function was original named printf().\n        But the name was later\n        changed to `format()` for compatibility with other database engines.\n        The original\n        `printf()` name is retained as an alias so as not to break any legacy\n        code.\n        "),
        _Utils_Tuple3("quote(X)", "https://www.sqlite.org/lang_corefunc.html#quote", "\n        The quote(X) function returns the text of an SQL literal which\n        is the value of its argument suitable for inclusion into an SQL\n        statement.\n        Strings are surrounded by single-quotes with escapes on interior quotes\n        as needed.\n        BLOBs are encoded as hexadecimal literals.\n        Strings with embedded NUL characters cannot be represented as string\n        literals in SQL and hence the returned string literal is truncated prior\n        to the first NUL.\n        "),
        _Utils_Tuple3("random()", "https://www.sqlite.org/lang_corefunc.html#random", "\n        The `random()` function returns a pseudo-random integer\n        between -9223372036854775808 and +9223372036854775807.\n        "),
        _Utils_Tuple3("randomblob(N)", "https://www.sqlite.org/lang_corefunc.html#randomblob", "\n        The randomblob(N) function return an N-byte blob containing\n        pseudo-random bytes.\n        If N is less than 1 then a 1-byte random blob is returned.\n\n        Hint:  applications can generate globally unique identifiers\n        using this function together with\n        [`hex()`](https://www.sqlite.org/lang_corefunc.html#hex)\n        and/or\n\n        [`lower()`](https://www.sqlite.org/lang_corefunc.html#lower)\n        like this:\n\n        hex(randomblob(16)), ,\n        lower(hex(randomblob(16)))\n        "),
        _Utils_Tuple3("replace(X, Y,Z)", "https://www.sqlite.org/lang_corefunc.html#replace", "\n        The replace(X, Y,Z) function returns a string formed by substituting\n        string Z for every occurrence of string Y in string X.\n        The\n        [`BINARY`](https://www.sqlite.org/datatype3.html#collation)\n        collating sequence is used for comparisons.\n        If Y is an empty\n        string then return X unchanged.\n        If Z is not initially\n        a string, it is cast to a UTF-8 string prior to processing.\n        "),
        _Utils_Tuple3("round(X)", "https://www.sqlite.org/lang_corefunc.html#round", "\n        The `round(X, Y)` function returns a floating-point\n        value X rounded to Y digits to the right of the decimal point.\n        If the Y argument is omitted or negative, it is taken to be 0.\n        "),
        _Utils_Tuple3("round(X, Y)", "https://www.sqlite.org/lang_corefunc.html#round", "\n        The `round(X, Y)` function returns a floating-point\n        value X rounded to Y digits to the right of the decimal point.\n        If the Y argument is omitted or negative, it is taken to be 0.\n        "),
        _Utils_Tuple3("rtrim(X)", "https://www.sqlite.org/lang_corefunc.html#rtrim", "\n        The rtrim(X) function returns a string formed by removing any and all\n        spaces from the right side of X.\n        "),
        _Utils_Tuple3("rtrim(X, Y)", "https://www.sqlite.org/lang_corefunc.html#rtrim", "\n        The `rtrim(X, Y)` function returns a string formed by removing any and all\n        characters that appear in Y from the right side of X.\n        "),
        _Utils_Tuple3("sign(X)", "https://www.sqlite.org/lang_corefunc.html#sign", "\n        The sign(X) function returns -1, 0, or +1 if the argument X is a numeric\n        value that is negative, zero, or positive, respectively.\n        If the argument\n        to sign(X) is `NULL` or is a string or blob that cannot be losslessly\n        converted\n        into a number, then sign(X) returns `NULL`.\n        "),
        _Utils_Tuple3("soundex(X)", "https://www.sqlite.org/lang_corefunc.html#soundex", "\n        The soundex(X) function returns a string that is the soundex encoding\n        of the string X.\n        The string \"?000\" is returned if the argument is `NULL` or contains\n        no ASCII alphabetic characters.\n        This function is omitted from SQLite by default.\n        It is only available if the\n        [`SQLITE_SOUNDEX`](https://www.sqlite.org/compile.html#soundex)\n        compile-time option\n        is used when SQLite is built.\n        "),
        _Utils_Tuple3("sqlite_compileoption_get(N)", "https://www.sqlite.org/lang_corefunc.html#sqlite_compileoption_get", "\n        The `sqlite_compileoption_get()` SQL function is a wrapper around the\n\n        [`sqlite3_compileoption_get()`](\n            https://www.sqlite.org/c3ref/compileoption_get.html)\n        C/C++ function.\n        This routine returns the N-th compile-time option used to build SQLite\n        or `NULL` if N is out of range.\n        See also the\n        [`compile_options pragma`](\n            https://www.sqlite.org/pragma.html#pragma_compile_options).\n        "),
        _Utils_Tuple3("sqlite_compileoption_used(X)", "https://www.sqlite.org/lang_corefunc.html#sqlite_compileoption_used", "\n        The `sqlite_compileoption_used()` SQL function is a wrapper around the\n\n        [`sqlite3_compileoption_used()`](\n            https://www.sqlite.org/c3ref/compileoption_get.html)\n        C/C++ function.\n        When the argument X to sqlite_compileoption_used(X) is a string which\n        is the name of a compile-time option, this routine returns true (1) or\n        false (0) depending on whether or not that option was used during the\n        build.\n        "),
        _Utils_Tuple3("sqlite_offset(X)", "https://www.sqlite.org/lang_corefunc.html#sqlite_offset", "\n        The sqlite_offset(X) function returns the byte offset in the database\n        file for the beginning of the record from which value would be read.\n        If X is not a column in an ordinary table, then sqlite_offset(X) returns\n        `NULL`.\n        The value returned by sqlite_offset(X) might reference either the\n        original table or an index, depending on the query.\n        If the value X would\n        normally be extracted from an index, the sqlite_offset(X) returns the\n        offset to the corresponding index record.\n        If the value X would be\n        extracted from the original table, then sqlite_offset(X) returns the\n        offset to the table record.\n\n        The sqlite_offset(X) SQL function is only available if SQLite is\n        built using the\n        [`-DSQLITE_ENABLE_OFFSET_SQL_FUNC`](\n            https://www.sqlite.org/compile.html#enable_offset_sql_func)\n        compile-time option.\n        "),
        _Utils_Tuple3("sqlite_source_id()", "https://www.sqlite.org/lang_corefunc.html#sqlite_source_id", "\n        The `sqlite_source_id()` function returns a string that identifies the\n        specific version of the source code that was used to build the SQLite\n        library.\n        The string returned by `sqlite_source_id()` is\n        the date and time that the source code was checked in followed by\n        the SHA3-256 hash for that check-in.\n        This function is\n        an SQL wrapper around the\n        [`sqlite3_sourceid()`](https://www.sqlite.org/c3ref/libversion.html)\n        C interface.\n        "),
        _Utils_Tuple3("sqlite_version()", "https://www.sqlite.org/lang_corefunc.html#sqlite_version", "\n        The `sqlite_version()` function returns the version string for the SQLite\n        library that is running.\n        This function is an SQL\n        wrapper around the\n        [`sqlite3_libversion()`](https://www.sqlite.org/c3ref/libversion.html)\n        C-interface.\n        "),
        _Utils_Tuple3("substr(X, Y)", "https://www.sqlite.org/lang_corefunc.html#substr", "\n        The substr(X, Y,Z) function returns a substring of input string X that\n        begins\n        with the Y-th character and which is Z characters long.\n        If Z is omitted then `substr(X, Y)` returns all characters through the end\n        of the string X beginning with the Y-th.\n        The left-most character of X is number 1.\n        If Y is negative\n        then the first character of the substring is found by counting from the\n        right rather than the left.\n        If Z is negative then\n        the abs(Z) characters preceding the Y-th character are returned.\n        If X is a string then characters indices refer to actual UTF-8\n        characters.\n        If X is a BLOB then the indices refer to bytes.\n        "),
        _Utils_Tuple3("substr(X, Y,Z)", "https://www.sqlite.org/lang_corefunc.html#substr", "\n        The substr(X, Y,Z) function returns a substring of input string X that\n        begins\n        with the Y-th character and which is Z characters long.\n        If Z is omitted then `substr(X, Y)` returns all characters through the end\n        of the string X beginning with the Y-th.\n        The left-most character of X is number 1.\n        If Y is negative\n        then the first character of the substring is found by counting from the\n        right rather than the left.\n        If Z is negative then\n        the abs(Z) characters preceding the Y-th character are returned.\n        If X is a string then characters indices refer to actual UTF-8\n        characters.\n        If X is a BLOB then the indices refer to bytes.\n        "),
        _Utils_Tuple3("substring()", "https://www.sqlite.org/lang_corefunc.html#substr", "\n        \"substring()\" is an alias for \"substr()\"\n        "),
        _Utils_Tuple3("total_changes()", "https://www.sqlite.org/lang_corefunc.html#total_changes", "\n        The `total_changes()` function returns the number of row changes\n        caused by INSERT, UPDATE or DELETE\n        statements since the current database connection was opened.\n        This function is a wrapper around the\n        [`sqlite3_total_changes64()`](https://www.sqlite.org/c3ref/total_changes.html)\n        C/C++ interface.\n        "),
        _Utils_Tuple3("trim(X)", "https://www.sqlite.org/lang_corefunc.html#trim", "\n        The trim(X) function returns a string formed by removing any and all\n        spaces from both ends of X.\n        "),
        _Utils_Tuple3("trim(X, Y)", "https://www.sqlite.org/lang_corefunc.html#trim", "\n        The `trim(X, Y)` function returns a string formed by removing any and all\n        characters that appear in Y from both ends of X.\n        "),
        _Utils_Tuple3("typeof(X)", "https://www.sqlite.org/lang_corefunc.html#typeof", "\n        The typeof(X) function returns a string that indicates the\n        [`datatype`](https://www.sqlite.org/datatype3.html)\n        of\n        the expression X: \"null\", \"integer\", \"real\", \"text\", or \"blob\".\n        "),
        _Utils_Tuple3("unicode(X)", "https://www.sqlite.org/lang_corefunc.html#unicode", "\n        The unicode(X) function returns the numeric unicode code point\n        corresponding to\n        the first character of the string X.\n        If the argument to unicode(X) is not a string\n        then the result is undefined.\n        "),
        _Utils_Tuple3("unlikely(X)", "https://www.sqlite.org/lang_corefunc.html#unlikely", "\n        The unlikely(X) function returns the argument X unchanged.\n        The unlikely(X) function is a no-op that the code generator\n        optimizes away so that it consumes no CPU cycles at\n        run-time (that is, during calls to\n        [`sqlite3_step()`](https://www.sqlite.org/c3ref/step.html)).\n        The purpose of the unlikely(X) function is to provide a hint\n        to the query planner that the argument X is a boolean value\n        that is usually not true.\n        The unlikely(X) function is equivalent to\n        [`likelihood](X, 0.0625)`](\n            https://www.sqlite.org/lang_corefunc.html#likelihood).\n        "),
        _Utils_Tuple3("upper(X)", "https://www.sqlite.org/lang_corefunc.html#upper", "\n        The upper(X) function returns a copy of input string X in which all\n        lower-case ASCII characters are converted to their upper-case\n        equivalent.\n        "),
        _Utils_Tuple3("zeroblob(N)", "https://www.sqlite.org/lang_corefunc.html#zeroblob", "\n        The zeroblob(N) function returns a BLOB consisting of N bytes of 0x00.\n        SQLite manages these zeroblobs very efficiently.\n        Zeroblobs can be used to\n        reserve space for a BLOB that is later written using\n\n        [`incremental BLOB I/O](https://www.sqlite.org/c3ref/blob_open.html)`.\n        This SQL function is implemented using the\n        [`sqlite3_result_zeroblob()`](\n            https://www.sqlite.org/c3ref/result_blob.html)\n        routine from the C/C++ interface.\n        "),
        _Utils_Tuple3("json(json)", "https://www.sqlite.org/json1.html#jmini", "\n        The json(X) function verifies that its argument X is a valid JSON\n        string and returns a minified version of that JSON string (with all\n        unnecessary\n        whitespace removed).\n        If X is not a well-formed JSON string, then this routine throws an\n        error.\n\n        In other words, this function converts raw text that looks like JSON\n        into actual JSON so that it may be passed into the value argument of\n        some other\n        json function and will be interpreted as JSON rather than a string.\n        This function is not appropriate for testing whether or not a\n        particular string is well-formed JSON - use the `json_valid()` routine\n        below for\n        that task.\n\n        If the argument X to json(X) contains JSON objects with duplicate\n        labels, then it is undefined whether or not the duplicates are\n        preserved.\n        The current implementation preserves duplicates.\n        However, future enhancements to this routine may choose to silently\n        remove duplicates.\n        "),
        _Utils_Tuple3("json_array(value1, value2, \u2026)", "https://www.sqlite.org/json1.html#jarray", "\n        The `json_array()` SQL function accepts zero or more arguments and\n        returns a well-formed JSON array that is composed from those arguments.\n        If any argument to `json_array()` is a BLOB then an error is thrown.\n\n        An argument with SQL type TEXT is normally converted into a quoted JSON\n        string.\n        However, if the argument is the output from another json1 function,\n        then it is stored as JSON.\n        This allows calls to `json_array()` and `json_object()` to be nested.\n        The `json()` function can also be used to force strings to be recognized\n        as JSON.\n        "),
        _Utils_Tuple3("json_array_length(json)", "https://www.sqlite.org/json1.html#jarraylen", "\n        The json_array_length(X) function returns the number of elements in the\n        JSON array X, or 0 if X is some kind of JSON value other than an array.\n        The json_array_length(X,P) locates the array at path P within X and\n        returns the length of that array, or 0 if path P locates an element or\n        X other\n        than a JSON array, and `NULL` if path P does not locate any element of X.\n        Errors are thrown if either X is not well-formed JSON or if P is not a\n        well-formed path.\n        "),
        _Utils_Tuple3("json_array_length(json, path)", "https://www.sqlite.org/json1.html#jarraylen", "\n        The json_array_length(X) function returns the number of elements in the\n        JSON array X, or 0 if X is some kind of JSON value other than an array.\n        The json_array_length(X,P) locates the array at path P within X and\n        returns the length of that array, or 0 if path P locates an element or\n        X other\n        than a JSON array, and `NULL` if path P does not locate any element of X.\n        Errors are thrown if either X is not well-formed JSON or if P is not a\n        well-formed path.\n        "),
        _Utils_Tuple3("json_extract(json, path, \u2026)", "https://www.sqlite.org/json1.html#jex", "\n        The json_extract(X,P1,P2, \u2026) extracts and returns one or more values\n        from the well-formed JSON at X.\n        If only a single path P1 is provided, then the SQL datatype of the\n        result is `NULL` for a JSON null, INTEGER or REAL for a JSON numeric\n        value, an\n        INTEGER zero for a JSON false value, an INTEGER one for a JSON true\n        value, the\n        dequoted text for a JSON string value, and a text representation for\n        JSON\n        object and array values.\n        If there are multiple path arguments (P1, P2, and so forth) then this\n        routine returns SQLite text which is a well-formed JSON array holding\n        the\n        various values.\n        "),
        _Utils_Tuple3("json -> path", "https://www.sqlite.org/json1.html#jptr", "\n        the -> and ->> operators are available for extracting subcomponents of\n        JSON.\n        The SQLite implementation of the -> and ->> operators strive to be\n        compatible with both MySQL and PostgreSQL.\n        The -> and ->> operators take a JSON string as their left operand and a\n        PATH expression or object field label or array index as their right\n        operand.\n        The -> operator returns a JSON representation of the selected\n        subcomponent or `NULL` if that subcomponent does not exist.\n        The ->> operator returns an SQL TEXT, INTEGER, REAL, or `NULL` value that\n        represents the selected subcomponent, or `NULL` if the subcomponent does\n        not\n        exist.\n\n        Both the -> and ->> operators select the same subcomponent of the JSON\n        to their left.\n        The difference is that -> always returns a JSON representation of that\n        subcomponent and the ->> operator always returns an SQL representation\n        of that\n        subcomponent.\n        Thus, these operators are subtly different from a two-argument\n        `json_extract()` function call.\n        A call to `json_extract()` with two arguments will return a JSON\n        representation of the subcomponent if and only if the subcomponent is a\n        JSON\n        array or object, and will return an SQL representation of the\n        subcomponent if\n        the subcomponent is a JSON null, string, or numeric value.\n\n        The right-hand operand to the -> and ->> operators can be a well-formed\n        JSON path expression.\n        This is the form used by MySQL.\n        For compatibility with PostgreSQL, the -> and ->> operators also accept\n        a text label or integer as their right-hand operand.\n        If the right operand is a text label X, then it is interpreted as the\n        JSON path '$.X'.\n        If the right operand is an integer value N, then it is interpreted as\n        the JSON path '$[N]'.\n        "),
        _Utils_Tuple3("json ->> path", "https://www.sqlite.org/json1.html#jptr", "\n        the -> and ->> operators are available for extracting subcomponents of\n        JSON.\n        The SQLite implementation of the -> and ->> operators strive to be\n        compatible with both MySQL and PostgreSQL.\n        The -> and ->> operators take a JSON string as their left operand and a\n        PATH expression or object field label or array index as their right\n        operand.\n        The -> operator returns a JSON representation of the selected\n        subcomponent or `NULL` if that subcomponent does not exist.\n        The ->> operator returns an SQL TEXT, INTEGER, REAL, or `NULL` value that\n        represents the selected subcomponent, or `NULL` if the subcomponent does\n        not\n        exist.\n\n        Both the -> and ->> operators select the same subcomponent of the JSON\n        to their left.\n        The difference is that -> always returns a JSON representation of that\n        subcomponent and the ->> operator always returns an SQL representation\n        of that\n        subcomponent.\n        Thus, these operators are subtly different from a two-argument\n        `json_extract()` function call.\n        A call to `json_extract()` with two arguments will return a JSON\n        representation of the subcomponent if and only if the subcomponent is a\n        JSON\n        array or object, and will return an SQL representation of the\n        subcomponent if\n        the subcomponent is a JSON null, string, or numeric value.\n\n        The right-hand operand to the -> and ->> operators can be a well-formed\n        JSON path expression.\n        This is the form used by MySQL.\n        For compatibility with PostgreSQL, the -> and ->> operators also accept\n        a text label or integer as their right-hand operand.\n        If the right operand is a text label X, then it is interpreted as the\n        JSON path '$.X'.\n        If the right operand is an integer value N, then it is interpreted as\n        the JSON path '$[N]'.\n        "),
        _Utils_Tuple3("json_insert(json, path, value, \u2026)", "https://www.sqlite.org/json1.html#jins", "\n        The json_insert(), json_replace, and `json_set()` functions all take a\n        single JSON value as their first argument followed by zero or more\n        pairs of\n        path and value arguments, and return a new JSON string formed by\n        updating the\n        input JSON by the path/value pairs.\n        The functions differ only in how they deal with creating new values and\n        overwriting preexisting values.\n\n        Function\tOverwrite if already exists?\tCreate if does not exist?\n        json_insert()\tNo\tYes\n        json_replace()\tYes\tNo\n        json_set()\tYes\tYes\n        The json_insert(), json_replace(), and `json_set()` functions always take\n        an odd number of arguments.\n        The first argument is always the original JSON to be edited.\n        Subsequent arguments occur in pairs with the first element of each pair\n        being a path and the second element being the value to insert or\n        replace or set\n        on that path.\n\n        Edits occur sequentially from left to right.\n        Changes caused by prior edits can affect the path search for subsequent\n        edits.\n\n        If the value of a path/value pair is an SQLite TEXT value, then it is\n        normally inserted as a quoted JSON string, even if the string looks\n        like valid\n        JSON.\n        However, if the value is the result of another json1 function (such as\n        `json()` or `json_array()` or json_object()) or if it is the result of the\n        ->\n        operator, then it is interpreted as JSON and is inserted as JSON\n        retaining all\n        of its substructure.\n        Values that are the result of the ->> operator are always interpreted\n        as TEXT and are inserted as a JSON string even if they look like valid\n        JSON.\n\n        These routines throw an error if the first JSON argument is not\n        well-formed or if any PATH argument is not well-formed or if any\n        argument is a\n        BLOB.\n        "),
        _Utils_Tuple3("json_object(label1, value1, \u2026)", "https://www.sqlite.org/json1.html#jobj", "\n        The `json_object()` SQL function accepts zero or more pairs of arguments\n        and returns a well-formed JSON object that is composed from those\n        arguments.\n        The first argument of each pair is the label and the second argument of\n        each pair is the value.\n        If any argument to `json_object()` is a BLOB then an error is thrown.\n\n        The `json_object()` function currently allows duplicate labels without\n        complaint, though this might change in a future enhancement.\n\n        An argument with SQL type TEXT it is normally converted into a quoted\n        JSON string even if the input text is well-formed JSON.\n        However, if the argument is the direct result from another JSON\n        function or the -> operator (but not the ->> operator), then it is\n        treated as\n        JSON and all of its JSON type information and substructure is preserved.\n        This allows calls to `json_object()` and `json_array()` to be nested.\n        The `json()` function can also be used to force strings to be recognized\n        as JSON.\n        "),
        _Utils_Tuple3("json_patch(json1, json2)", "https://www.sqlite.org/json1.html#jpatch", "\n        The json_patch(T,P) SQL function runs the RFC-7396 MergePatch algorithm\n        to apply patch P against input T.\n        The patched copy of T is returned.\n\n        MergePatch can add, modify, or delete elements of a JSON Object, and so\n        for JSON Objects, the `json_patch()` routine is a generalized replacement\n        for\n        `json_set()` and json_remove().\n        However, MergePatch treats JSON Array objects as atomic.\n        MergePatch cannot append to an Array nor modify individual elements of\n        an Array.\n        It can only insert, replace, or delete the whole Array as a single unit.\n        Hence, `json_patch()` is not as useful when dealing with JSON that\n        includes Arrays, especially Arrays with lots of substructure.\n        "),
        _Utils_Tuple3("json_remove(json, path, \u2026)", "https://www.sqlite.org/json1.html#jrm", "\n        The json_remove(X,P, \u2026) function takes a single JSON value as its\n        first argument followed by zero or more path arguments.\n        The json_remove(X,P, \u2026) function returns a copy of the X parameter\n        with all the elements identified by path arguments removed.\n        Paths that select elements not found in X are silently ignored.\n\n        Removals occurs sequentially from left to right.\n        Changes caused by prior removals can affect the path search for\n        subsequent arguments.\n\n        If the json_remove(X) function is called with no path arguments, then\n        it returns the input X reformatted, with excess whitespace removed.\n\n        The `json_remove()` function throws an error if the first argument is not\n        well-formed JSON or if any later argument is not a well-formed path, or\n        if any\n        argument is a BLOB.\n        "),
        _Utils_Tuple3("json_replace(json, path, value, \u2026)", "https://www.sqlite.org/json1.html#jrepl", "\n        The json_insert(), json_replace, and `json_set()` functions all take a\n        single JSON value as their first argument followed by zero or more\n        pairs of\n        path and value arguments, and return a new JSON string formed by\n        updating the\n        input JSON by the path/value pairs.\n        The functions differ only in how they deal with creating new values and\n        overwriting preexisting values.\n\n        Function\tOverwrite if already exists?\tCreate if does not exist?\n        json_insert()\tNo\tYes\n        json_replace()\tYes\tNo\n        json_set()\tYes\tYes\n        The json_insert(), json_replace(), and `json_set()` functions always take\n        an odd number of arguments.\n        The first argument is always the original JSON to be edited.\n        Subsequent arguments occur in pairs with the first element of each pair\n        being a path and the second element being the value to insert or\n        replace or set\n        on that path.\n\n        Edits occur sequentially from left to right.\n        Changes caused by prior edits can affect the path search for subsequent\n        edits.\n\n        If the value of a path/value pair is an SQLite TEXT value, then it is\n        normally inserted as a quoted JSON string, even if the string looks\n        like valid\n        JSON.\n        However, if the value is the result of another json1 function (such as\n        `json()` or `json_array()` or json_object()) or if it is the result of the\n        ->\n        operator, then it is interpreted as JSON and is inserted as JSON\n        retaining all\n        of its substructure.\n        Values that are the result of the ->> operator are always interpreted\n        as TEXT and are inserted as a JSON string even if they look like valid\n        JSON.\n\n        These routines throw an error if the first JSON argument is not\n        well-formed or if any PATH argument is not well-formed or if any\n        argument is a\n        BLOB.\n        "),
        _Utils_Tuple3("json_set(json, path, value, \u2026)", "https://www.sqlite.org/json1.html#jset", "\n        The json_insert(), json_replace, and `json_set()` functions all take a\n        single JSON value as their first argument followed by zero or more\n        pairs of\n        path and value arguments, and return a new JSON string formed by\n        updating the\n        input JSON by the path/value pairs.\n        The functions differ only in how they deal with creating new values and\n        overwriting preexisting values.\n\n        Function\tOverwrite if already exists?\tCreate if does not exist?\n        json_insert()\tNo\tYes\n        json_replace()\tYes\tNo\n        json_set()\tYes\tYes\n        The json_insert(), json_replace(), and `json_set()` functions always take\n        an odd number of arguments.\n        The first argument is always the original JSON to be edited.\n        Subsequent arguments occur in pairs with the first element of each pair\n        being a path and the second element being the value to insert or\n        replace or set\n        on that path.\n\n        Edits occur sequentially from left to right.\n        Changes caused by prior edits can affect the path search for subsequent\n        edits.\n\n        If the value of a path/value pair is an SQLite TEXT value, then it is\n        normally inserted as a quoted JSON string, even if the string looks\n        like valid\n        JSON.\n        However, if the value is the result of another json1 function (such as\n        `json()` or `json_array()` or json_object()) or if it is the result of the\n        ->\n        operator, then it is interpreted as JSON and is inserted as JSON\n        retaining all\n        of its substructure.\n        Values that are the result of the ->> operator are always interpreted\n        as TEXT and are inserted as a JSON string even if they look like valid\n        JSON.\n\n        These routines throw an error if the first JSON argument is not\n        well-formed or if any PATH argument is not well-formed or if any\n        argument is a\n        BLOB.\n        "),
        _Utils_Tuple3("json_type(json)", "https://www.sqlite.org/json1.html#jtype", "\n        The json_type(X) function returns the \"type\" of the outermost element\n        of X.\n        The json_type(X,P) function returns the \"type\" of the element in X that\n        is selected by path P.\n        The \"type\" returned by `json_type()` is one of the following SQL text\n        values: 'null', 'true', 'false', 'integer', 'real', 'text', 'array', or\n        'object'.\n        If the path P in json_type(X,P) selects an element that does not exist\n        in X, then this function returns `NULL`.\n\n        The `json_type()` function throws an error if any of its arguments is not\n        well-formed or is a BLOB.\n        "),
        _Utils_Tuple3("json_type(json, path)", "https://www.sqlite.org/json1.html#jtype", "\n        The json_type(X) function returns the \"type\" of the outermost element\n        of X.\n        The json_type(X,P) function returns the \"type\" of the element in X that\n        is selected by path P.\n        The \"type\" returned by `json_type()` is one of the following SQL text\n        values: 'null', 'true', 'false', 'integer', 'real', 'text', 'array', or\n        'object'.\n        If the path P in json_type(X,P) selects an element that does not exist\n        in X, then this function returns `NULL`.\n\n        The `json_type()` function throws an error if any of its arguments is not\n        well-formed or is a BLOB.\n        "),
        _Utils_Tuple3("json_valid(json)", "https://www.sqlite.org/json1.html#jvalid", "\n        The json_valid(X) function return 1\n        if the argument X is well-formed JSON\n        and return 0 if the argument X is not well-formed JSON.\n        "),
        _Utils_Tuple3("json_quote(value)", "https://www.sqlite.org/json1.html#jquote", "\n        The json_quote(X) function converts the SQL value X\n        (a number or a string) into its corresponding JSON representation.\n        If X is a JSON value returned by another JSON function,\n        then this function is a no-op.\n        ")
    ]);
    var $author$project$Components$SQLiteDocs$tableValuedFunctions = _List_fromArray([
        _Utils_Tuple3("json_each(json)", "https://www.sqlite.org/json1.html#jeach", "\n        The json_each(X) and json_tree(X) table-valued functions walk the JSON\n        value provided as their first argument\n        and return one row for each element.\n        The json_each(X) function only walks the immediate children of the\n        top-level array or object, or just the top-level element itself if the\n        top-level element is a primitive value.\n        "),
        _Utils_Tuple3("json_each(json, path)", "https://www.sqlite.org/json1.html#jeach", "\n        The json_each(X) and json_tree(X) table-valued functions walk the JSON\n        value provided as their first argument\n        and return one row for each element.\n        The json_each(X) function only walks the immediate children of the\n        top-level array or object, or just the top-level element itself if the\n        top-level element is a primitive value.\n        "),
        _Utils_Tuple3("json_tree(json)", "https://www.sqlite.org/json1.html#jtree", "\n        The json_each(X) and json_tree(X) table-valued functions walk the JSON\n        value provided as their first argument\n        and return one row for each element.\n        The json_tree(X) function recursively walks through the JSON\n        substructure starting with the top-level element.\n        "),
        _Utils_Tuple3("json_tree(json, path)", "https://www.sqlite.org/json1.html#jtree", "\n        The json_each(X) and json_tree(X) table-valued functions walk the JSON\n        value provided as their first argument\n        and return one row for each element.\n        The json_tree(X) function recursively walks through the JSON\n        substructure starting with the top-level element.\n        ")
    ]);
    var $author$project$Components$SQLiteDocs$windowFunctions = _List_fromArray([
        _Utils_Tuple3("row_number()", "https://www.sqlite.org/windowfunctions.html#row_number", "\n        The number of the row within the current partition.\n        Rows are numbered starting from 1 in the order defined by the ORDER BY\n        clause in the window definition, or in arbitrary order otherwise.\n        "),
        _Utils_Tuple3("rank()", "https://www.sqlite.org/windowfunctions.html#rank", "\n        The `row_number()` of the first peer in each group - the rank of the\n        current row with gaps.\n        If there is no ORDER BY clause, then all rows are considered peers and\n        this function always returns 1.\n        "),
        _Utils_Tuple3("dense_rank()", "https://www.sqlite.org/windowfunctions.html#dense_rank", "\n        The number of the current row's peer group within its partition - the\n        rank of the current row without gaps.\n        Rows are numbered starting from 1 in the order defined by the ORDER BY\n        clause in the window definition.\n        If there is no ORDER BY clause, then all rows are considered peers and\n        this function always returns 1.\n        "),
        _Utils_Tuple3("percent_rank()", "https://www.sqlite.org/windowfunctions.html#percent_rank", "\n        Despite the name, this function always returns a value between 0.0 and\n        1.0 equal to (rank - 1)/(partition-rows - 1),\n        where rank is the value returned\n        by built-in window function rank()\n        and partition-rows is the total number of\n        rows in the partition.\n        If the partition contains only one row, this function returns 0.0.\n        "),
        _Utils_Tuple3("cume_dist()", "https://www.sqlite.org/windowfunctions.html#cume_dist", "\n        The cumulative distribution.\n        Calculated as row-number/partition-rows, where row-number is the value\n        returned by `row_number()` for the last peer in the group\n        and partition-rows the number of rows in the partition.\n        "),
        _Utils_Tuple3("ntile(N)", "https://www.sqlite.org/windowfunctions.html#ntile", "\n        Argument N is handled as an integer.\n        This function divides the partition into N groups as evenly as possible\n        and assigns an integer between 1 and N to each group,\n        in the order defined by\n        the ORDER BY clause, or in arbitrary order otherwise.\n        If necessary, larger groups occur first.\n        This function returns the integer value assigned to the group that the\n        current row is a part of.\n        "),
        _Utils_Tuple3("lag(expr)", "https://www.sqlite.org/windowfunctions.html#lag", "\n        The first form of the `lag()` function returns the result of evaluating\n        expression expr against the previous row in the partition.\n        Or, if there is no previous row (because the current row is the first),\n        `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows before the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows before the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("lag(expr, offset)", "https://www.sqlite.org/windowfunctions.html#lag", "\n        The first form of the `lag()` function returns the result of evaluating\n        expression expr against the previous row in the partition.\n        Or, if there is no previous row (because the current row is the first),\n        `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows before the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows before the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("lag(expr, offset, default)", "https://www.sqlite.org/windowfunctions.html#lag", "\n        The first form of the `lag()` function returns the result of evaluating\n        expression expr against the previous row in the partition.\n        Or, if there is no previous row (because the current row is the first),\n        `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows before the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows before the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("lead(expr)", "https://www.sqlite.org/windowfunctions.html#lead", "\n        The first form of the `lead()` function returns the result of evaluating\n        expression expr against the next row in the partition.\n        Or, if there is no next row (because the current row is the last), `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows after the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows after the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("lead(expr, offset)", "https://www.sqlite.org/windowfunctions.html#lead", "\n        The first form of the `lead()` function returns the result of evaluating\n        expression expr against the next row in the partition.\n        Or, if there is no next row (because the current row is the last), `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows after the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows after the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("lead(expr, offset, default)", "https://www.sqlite.org/windowfunctions.html#lead", "\n        The first form of the `lead()` function returns the result of evaluating\n        expression expr against the next row in the partition.\n        Or, if there is no next row (because the current row is the last), `NULL`.\n\n        If the offset argument is provided, then it must be a non-negative\n        integer.\n        In this case the value returned is the result of evaluating expr\n        against the row offset rows after the current row within the partition.\n        If offset is 0, then expr is evaluated against the current row.\n        If there is no row offset rows after the current row, `NULL` is returned.\n\n        If default is also provided, then it is returned instead of `NULL` if the\n        row identified by offset does not exist.\n        "),
        _Utils_Tuple3("first_value(expr)", "https://www.sqlite.org/windowfunctions.html#first_value", "\n        The `first_value(X)` function returns the value of `X` in the first row\n        of the current row's partition.\n        "),
        _Utils_Tuple3("last_value(expr)", "https://www.sqlite.org/windowfunctions.html#last_value", "\n        The `last_value(X)` function returns the value of `X` in the last row\n        of the current row's partition.\n        "),
        _Utils_Tuple3("nth_value(expr, N)", "https://www.sqlite.org/windowfunctions.html#nth_value", "\n        The `nth_value(X, N)` function returns the value of `X` in the `N`th\n        row of the current row's partition.\n        If there is no `N`th row in the partition, then `nth_value(X, N)`\n        returns ``NULL``.\n        ")
    ]);
    var $author$project$Components$SQLiteDocs$sqlDocs = _List_fromArray([
        _Utils_Tuple2("Scalar Functions", $author$project$Components$SQLiteDocs$scalarFunctions),
        _Utils_Tuple2("Date and Time Functions", $author$project$Components$SQLiteDocs$dateAndTimeFunctions),
        _Utils_Tuple2("Aggregate Functions", $author$project$Components$SQLiteDocs$aggregateFunctions),
        _Utils_Tuple2("Table-Valued Functions", $author$project$Components$SQLiteDocs$tableValuedFunctions),
        _Utils_Tuple2("Window Functions", $author$project$Components$SQLiteDocs$windowFunctions),
        _Utils_Tuple2("Pragma Functions", $author$project$Components$SQLiteDocs$pragmaFunctions)
    ]);
    var $author$project$Components$SQLiteDocs$viewSqlDocs = function (cfg) {
        var sectionHasFunctions = A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
        var searchFilter = function (_v3) {
            var section_ = _v3.a;
            var description = _v3.c;
            return _String_contains_fn(cfg.oN, section_) || _String_contains_fn(cfg.oN, description);
        };
        var filterFunctions = A2($elm$core$Basics$composeR, $elm$core$List$filter, $elm$core$Tuple$mapSecond);
        var deadEndsToString = function (deadEnds) {
            return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
        };
        var viewFunction = function (_v2) {
            var name = _v2.a;
            var url = _v2.b;
            var description = _v2.c;
            var descriptionText = function () {
                var _v1 = $elm$core$Result$andThen_fn(function (ast) {
                    return $dillonkearns$elm_markdown$Markdown$Renderer$render_fn($dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, ast);
                }, $elm$core$Result$mapError_fn(deadEndsToString, $dillonkearns$elm_markdown$Markdown$Parser$parse($elm_community$string_extra$String$Extra$unindent(description))));
                if (!_v1.$) {
                    var rendered = _v1.a;
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$fromUnstyled, rendered));
                }
                else {
                    var errors = _v1.a;
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_Nil, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text("ERROR: " + errors)
                    ]));
                }
            }();
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$li_a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$details_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$summary_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_2]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text(name)
                        ]))
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "docs-description"),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                    ]), _List_fromArray([
                        descriptionText,
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$href(url)
                        ]), _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$text("Full "),
                            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$code_a0, _List_Nil, _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text(name)
                            ])),
                            $rtfeldman$elm_css$Html$Styled$text(" documentation")
                        ]))
                    ]))
                ]))
            ]));
        };
        var viewDocs = function (styles) {
            var toDocSection = function (_v0) {
                var sectionName = _v0.a;
                var functions = _v0.b;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$p_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$text(sectionName)
                    ])),
                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$ul_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$list_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_4]))
                    ]), $elm$core$List$map_fn(viewFunction, functions))
                ]));
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
            ]), $elm$core$List$map_fn(toDocSection, $elm$core$List$filter_fn(sectionHasFunctions, $elm$core$List$map_fn(filterFunctions(searchFilter), $author$project$Components$SQLiteDocs$sqlDocs))));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
            $author$project$Components$searchInput({
                cd: _Utils_eq($author$project$Components$SQLiteDocs$sqlDocs, _List_Nil),
                mO: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]),
                bC: cfg.hI(cfg.oN),
                hH: $elm$core$Maybe$Just(cfg.hI("")),
                cv: cfg.hI,
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_4]),
                pB: cfg.oN
            }),
            viewDocs(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_4,
                $rtfeldman$elm_css$Css$batch(cfg.m)
            ]))
        ]));
    };
    var $author$project$Pages$Queries$sidePanel = function (cfg) {
        var tabViewStyles = _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_hidden,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_auto,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_md,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_72,
            $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_96]))
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(cfg.m)
        ]), _List_fromArray([
            A5($author$project$Pages$Queries$toTabView, _List_Nil, _List_Nil, $elm$core$Maybe$Nothing, cfg.nu, _List_fromArray([
                {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: $elm$core$Basics$always(false),
                    fw: $elm$core$Basics$always(!_Utils_eq(cfg.hq, $elm$core$Maybe$Just("docs"))),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Queries_fn(cfg.i2, $elm$core$Maybe$Just("schema")))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Schema",
                    gl: $elm$core$Basics$always($krisajenkins$remotedata$RemoteData$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A5($author$project$Components$TableSchema$view, tabViewStyles, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$sticky, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0]), $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$Pages$Queries$EditView, $author$project$Pages$Queries$Selected(cfg.i2))), $author$project$Pages$Queries$TableSchemaMsgReceived, cfg.nu.eG), cfg.j))
                },
                {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: $elm$core$Basics$always(false),
                    fw: $elm$core$Basics$always(_Utils_eq(cfg.hq, $elm$core$Maybe$Just("docs"))),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Queries_fn(cfg.i2, $elm$core$Maybe$Just("docs")))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Docs",
                    gl: $elm$core$Basics$always($author$project$Components$SQLiteDocs$viewSqlDocs({ hI: $author$project$Pages$Queries$SetDocsSearch, oN: cfg.nu.ff, m: tabViewStyles }))
                }
            ]))
        ]));
    };
    var $author$project$Pages$Queries$statusBanner = function (status) {
        var successBanner = function (title) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$green_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_line
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($elm$core$Maybe$withDefault_fn($author$project$Util$zeroWidthString, $elm_community$string_extra$String$Extra$nonEmpty(title)))
            ]));
        };
        if (!status.$) {
            var successMessage = status.a;
            return successBanner(successMessage);
        }
        else {
            var errors = status.a;
            return $author$project$Components$wrapErrors(errors);
        }
    };
    var $author$project$Pages$Queries$QueryTabChosen = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Pages$Queries$QueryTabClosed = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Pages$Queries$tabChangeNotAllowed = function (model) {
        var activeTab = $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n);
        return activeTab.dC.gY || (activeTab.dC.gR || ($elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, function ($) {
            return $.la;
        }, model.cm) || model.la));
    };
    var $author$project$Pages$Queries$toViewTab_fn = function (idx, queryTab) {
        return {
            cd: $author$project$Pages$Queries$tabChangeNotAllowed,
            fq: false,
            fr: $elm$core$Basics$always(false),
            fw: A2($elm$core$Basics$composeR, function ($) {
                return $.n;
            }, A2($elm$core$Basics$composeR, $basti1302$elm_non_empty_array$Array$NonEmpty$selectedIndex, $elm$core$Basics$eq(idx))),
            a_: $elm$core$Basics$always($author$project$TabView$SendMsg($author$project$Pages$Queries$QueryTabChosen(idx))),
            ke: $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(!(!idx)), $elm$core$Maybe$Just($author$project$Pages$Queries$QueryTabClosed(idx))),
            eM: $elm$core$String$fromInt(idx),
            gl: function (_v0) {
                return A2($author$project$Components$AiEditor$view, $elm$core$Basics$identity, queryTab.dC);
            }
        };
    }, $author$project$Pages$Queries$toViewTab = F2($author$project$Pages$Queries$toViewTab_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4over12 = $rtfeldman$elm_css$Css$property_fn("width", "33.333333%");
    var $author$project$Pages$Queries$view_fn = function (dbId, database, maybeSelectedSidePanelTab, model) {
        var queryTabSelected = $basti1302$elm_non_empty_array$Array$NonEmpty$getSelected(model.n);
        var resultTableVisible = $elm$core$Basics$composeR_fn($author$project$Pages$Queries$QueryTab$queryReturnedRows_a0, $author$project$Pages$Queries$QueryTab$queryReturnedRows_a1, queryTabSelected);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center
            ]))
        ]), _List_fromArray([
            A2($author$project$Components$InputRequester$view, $elm$core$Basics$identity, model.cm),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "two-columns"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_row])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full
                ]))
            ]), _List_fromArray([
                $author$project$Pages$Queries$sidePanel({
                    j: database,
                    i2: dbId,
                    hq: maybeSelectedSidePanelTab,
                    nu: model,
                    m: _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4over12,
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 28))
                        ]))
                    ])
                }),
                A5($author$project$Pages$Queries$toTabView, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1]), $elm$core$Maybe$Just($author$project$Pages$Queries$QueryTabAdded), model, $elm$core$List$indexedMap_fn($author$project$Pages$Queries$toViewTab, $basti1302$elm_non_empty_array$Array$NonEmpty$toList(model.n)))
            ])),
            $author$project$Util$hideElement_fn($author$project$Pages$Queries$QueryTab$neverQueried(queryTabSelected), $author$project$Pages$Queries$runtimeStatsAndActionButtons_fn(resultTableVisible, database, dbId, model)),
            $author$project$Pages$Queries$statusBanner(queryTabSelected.oV),
            $author$project$Components$radioOptionsBar({
                M: "result-table-options",
                cx: _List_fromArray([
                    {
                        mD: A2($elm$core$Basics$composeR, function ($) {
                            return $.cN;
                        }, $elm$core$Basics$eq(0)),
                        hX: F2(function (options, _v0) {
                            return _Utils_update(options, { cN: 0 });
                        }),
                        eM: "No Wrap"
                    },
                    {
                        mD: A2($elm$core$Basics$composeR, function ($) {
                            return $.cN;
                        }, $elm$core$Basics$eq(1)),
                        hX: F2(function (options, _v1) {
                            return _Utils_update(options, { cN: 1 });
                        }),
                        eM: "Pre Wrap"
                    },
                    {
                        mD: A2($elm$core$Basics$composeR, function ($) {
                            return $.cN;
                        }, $elm$core$Basics$eq(2)),
                        hX: F2(function (options, _v2) {
                            return _Utils_update(options, { cN: 2 });
                        }),
                        eM: "Word Wrap"
                    }
                ]),
                hX: $author$project$Pages$Queries$ResultTableOptionUpdated,
                h7: queryTabSelected.kI,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mb_2,
                    $author$project$Util$styleIf_fn(!resultTableVisible, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden)
                ])
            }),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll]))
            ]), _List_fromArray([
                A3($author$project$Pages$Queries$dataTable, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_auto]), queryTabSelected.kI, $author$project$Pages$Queries$QueryTab$toSqlResult(queryTabSelected))
            ]))
        ]));
    }, $author$project$Pages$Queries$view = F4($author$project$Pages$Queries$view_fn);
    var $author$project$Pages$Settings$SettingsEditApplied = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Pages$Settings$VacuumDatabaseConfirmed = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Pages$Settings$databaseReassignmentDialog_fn = function (cfg, db) {
        var _v0 = _Utils_eq(db.ob, $elm$core$Maybe$Nothing) ? _Utils_Tuple2("Assign Database", cfg.nY(db.bR)) : _Utils_Tuple2("Reassign Database", function (teamName) {
            return cfg.oQ($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("reassign", A2(cfg.nY, db.bR, teamName), $author$project$Components$ConfirmDialog$DatabaseContext_fn(cfg.pf, db))));
        });
        var title = _v0.a;
        var onSubmit = _v0.b;
        return $author$project$Dialog$CustomizedDialog({
            cT: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_800)
            ]),
            bv: true,
            gB: $author$project$Components$assignDatabaseBanner({
                i6: "Choose a team to assign this database to.",
                j0: db.ob,
                hr: cfg.hr,
                hJ: onSubmit,
                m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_none])
            }),
            cj: $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_600,
            m: _List_Nil,
            eM: title,
            eO: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_50)
            ])
        });
    }, $author$project$Pages$Settings$databaseReassignmentDialog = F2($author$project$Pages$Settings$databaseReassignmentDialog_fn);
    var $author$project$Components$linkedDetail = function (_v0) {
        var styles = _v0.m;
        var leftOf = _v0.m5;
        var link = _v0.jY;
        var rightOf = _v0.oE;
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_xs,
                $rtfeldman$elm_css$Css$batch(styles)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text(leftOf),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$href(link.g),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, link.pa)
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(link.M)
            ])),
            $rtfeldman$elm_css$Html$Styled$text(rightOf)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_y_4 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-y", "-1rem"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $author$project$Pages$Settings$database_fn = function (cfg, db) {
        return _List_fromArray([
            $author$project$Components$buttonDetailed_fn("Regenerate Database ID", "\n        Regenerating the database ID will invalidate the current\n        Database ID and create a new one.\n        ", "Regenerate", cfg.h5, cfg.n_(db)),
            $author$project$Components$buttonDetailed_fn("Regenerate Read-Only ID", "\n        Regenerating the read-only ID will invalidate the current\n        read-only ID and create a new one.\n        ", "Regenerate", cfg.h5, cfg.n$(db)),
            $author$project$Components$buttonDetailed_fn("Replace Database", "\n        Replacing your database will replace all of its core data,\n        but keep the same ID, metadata, and settings.\n        ", "Replace", cfg.h5, cfg.n0(db)),
            function () {
                var _v0 = db.kR.pE;
                if (!_v0) {
                    return $author$project$Components$buttonDetailed_fn("Make Database Public", "\n                Making your database public will allow anyone who knows its ID\n                to read and modify data.\n                ", "Publish", cfg.h5, A2(cfg.n7, 1, db));
                }
                else {
                    return $author$project$Components$buttonDetailed_fn("Make Database Private", "\n                Making your database private will prevent anyone who is not\n                a team member of the owning team from accessing it.\n                ", "Unpublish", cfg.h5, A2(cfg.n7, 0, db));
                }
            }(),
            $author$project$Components$buttonDetailed_fn("Delete Database", "\n        Deleting your database will delete all of its data and its ID.\n        ", "Delete", cfg.h5, cfg.kg(db)),
            function () {
                var userHasAlternateTeam = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$neq(1), $elm$core$Maybe$map_fn($elm$core$List$length, $elm$core$Maybe$map_fn(function ($) {
                    return $.pc;
                }, cfg.hr))));
                var databaseIsUnassigned = _Utils_eq(db.ob, $elm$core$Maybe$Nothing);
                var _v1 = databaseIsUnassigned ? _Utils_Tuple3("Assign Database to a Team", "\n                Assigning your database to a team will prevent anyone from\n                accessing it unless they are a member of that team.\n                ", "Assign") : _Utils_Tuple3("Assign Database to Another Team", "\n                Reassigning your database to another team\n                will revoke the current team's access to it\n                and grant the selected team exclusive access.\n                ", "Reassign");
                var title = _v1.a;
                var description = _v1.b;
                var buttonTitle = _v1.c;
                return $author$project$Util$showElement_fn(databaseIsUnassigned || userHasAlternateTeam, $author$project$Components$buttonDetailed_fn(title, description, buttonTitle, cfg.h5, cfg.oQ($elm$core$Maybe$Just($author$project$Pages$Settings$databaseReassignmentDialog_fn(cfg, db)))));
            }(),
            $author$project$Components$contentDetailed_fn("Vacuum Database", "\n        Rebuild the database file and repack it into a minimal amount of disk\n        space. Also fully erases previously deleted table data.\n        ", _List_fromArray([
                $author$project$Components$linkedDetail({
                    m5: "This operation has potentially unwanted side effects." + " Please read the ",
                    jY: { M: "detailed documentation", pa: "_blank", g: "https://www.sqlite.org/lang_vacuum.html" },
                    oE: " first.",
                    m: _List_Nil
                }),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.o_, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, cfg.h5),
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(cfg.oQ($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("vacuum", cfg.gd($author$project$Pages$Settings$VacuumDatabaseConfirmed(db.bR)), $author$project$Components$ConfirmDialog$DatabaseContext_fn(cfg.pf, db)))))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Vacuum")
                ]))
            ])),
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (owner) {
                return $author$project$Components$contentDetailed_fn("API Tokens", "", _List_fromArray([
                    $author$project$Components$linkedDetail({
                        m5: "To manage API tokens, go to ",
                        jY: {
                            M: "team settings",
                            pa: "_self",
                            g: $author$project$Route$toUrlPath($author$project$Route$Teams($author$project$Pages$Teams$Route$Settings(owner)))
                        },
                        oE: ".",
                        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_y_4])
                    })
                ]));
            }, db.ob)
        ]);
    }, $author$project$Pages$Settings$database = F2($author$project$Pages$Settings$database_fn);
    var $author$project$Pages$Settings$EnvVarEditorOpened = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Pages$Settings$environment_fn = function (_v0, model) {
        var toMsg = _v0.gd;
        return _List_fromArray([
            $author$project$Components$contentDetailed_fn("Environment Variables", "\n        Manage environment variables for your database. They can then be\n        accessed in cloud functions like this:\n        ", _List_fromArray([
                $author$project$Components$codeView_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_2]), "console.log(process.env.MY_ENV_VAR)"),
                $author$project$Components$editableRows({
                    d9: _List_fromArray(["created utc", "key", "value"]),
                    mW: $elm$core$Basics$always(_List_Nil),
                    hh: function (_v1) {
                        var createdAt = _v1.iZ;
                        var name = _v1.M;
                        var value = _v1.pB;
                        return _List_fromArray([createdAt, name, value]);
                    },
                    aZ: _List_sortBy_fn(function ($) {
                        return $.iZ;
                    }, $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                        return $.gQ;
                    }, model.aL)),
                    nH: toMsg($author$project$Pages$Settings$EnvVarEditorOpened($elm$core$Maybe$Nothing)),
                    kg: $elm$core$Maybe$Just(function (envVar) {
                        return toMsg($author$project$Pages$Settings$SettingsEditModified($author$project$Types$DatabaseSettings$maybeSetEnvVars_fn(model.aL, $elm$core$List$filter_fn($elm$core$Basics$neq(envVar), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                            return $.gQ;
                        }, model.aL)))));
                    }),
                    ki: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Pages$Settings$EnvVarEditorOpened, toMsg)))
                })
            ]))
        ]);
    }, $author$project$Pages$Settings$environment = F2($author$project$Pages$Settings$environment_fn);
    var $author$project$Components$checkBoxDetailed_fn = function (title, description, msg, state) {
        var id_ = A2($author$project$Util$titleToId, "checkbox", title);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_start]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, state),
                $rtfeldman$elm_css$Html$Styled$Events$onCheck(msg),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_2]))
            ]), _List_Nil),
            $author$project$Components$toDetails_fn($elm$core$Maybe$Just(id_), title, description)
        ]));
    }, $author$project$Components$checkBoxDetailed = F4($author$project$Components$checkBoxDetailed_fn);
    var $author$project$Types$DatabaseSettings$setAuditing_fn = function (auditing, settings) {
        return _Utils_update(settings, { iH: auditing });
    }, $author$project$Types$DatabaseSettings$setAuditing = F2($author$project$Types$DatabaseSettings$setAuditing_fn);
    var $author$project$Types$DatabaseSettings$maybeSetAuditing_fn = function (maybeSettings, auditing) {
        return $elm$core$Maybe$map_fn($author$project$Types$DatabaseSettings$setAuditing(auditing), maybeSettings);
    }, $author$project$Types$DatabaseSettings$maybeSetAuditing = F2($author$project$Types$DatabaseSettings$maybeSetAuditing_fn);
    var $author$project$Types$DatabaseSettings$setEnvironment_fn = function (environment, settings) {
        return _Utils_update(settings, { mk: environment });
    }, $author$project$Types$DatabaseSettings$setEnvironment = F2($author$project$Types$DatabaseSettings$setEnvironment_fn);
    var $author$project$Types$DatabaseSettings$maybeSetEnvironment_fn = function (maybeSettings, environment) {
        return $elm$core$Maybe$map_fn($author$project$Types$DatabaseSettings$setEnvironment(environment), maybeSettings);
    }, $author$project$Types$DatabaseSettings$maybeSetEnvironment = F2($author$project$Types$DatabaseSettings$maybeSetEnvironment_fn);
    var $author$project$Types$DatabaseSettings$maybeSetSchemaLocked_fn = function (maybeSettings, schemaLocked) {
        return $elm$core$Maybe$map_fn(function (settings) {
            return _Utils_update(settings, { bj: schemaLocked });
        }, maybeSettings);
    }, $author$project$Types$DatabaseSettings$maybeSetSchemaLocked = F2($author$project$Types$DatabaseSettings$maybeSetSchemaLocked_fn);
    var $author$project$Types$DatabaseSettings$maybeSetViewsTab_fn = function (maybeSettings, viewsTab) {
        return $elm$core$Maybe$map_fn(function (settings) {
            return _Utils_update(settings, { pD: viewsTab });
        }, maybeSettings);
    }, $author$project$Types$DatabaseSettings$maybeSetViewsTab = F2($author$project$Types$DatabaseSettings$maybeSetViewsTab_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_32 = $rtfeldman$elm_css$Css$property_fn("width", "8rem");
    var $author$project$Components$stringSelectDetailed_fn = function (title, description, options, selected, msg, styles) {
        var id_ = A2($author$project$Util$titleToId, "checkbox", title);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$section_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4]))
        ]), _List_fromArray([
            $author$project$Components$toDetails_fn($elm$core$Maybe$Nothing, title, description),
            $author$project$Components$stringSelect({
                cP: _List_Nil,
                bR: $elm$core$Maybe$Just(id_),
                cv: $elm$core$Maybe$Just(msg),
                cx: options,
                df: "",
                ev: selected,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_32,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$batch(styles)
                ])
            })
        ]));
    }, $author$project$Components$stringSelectDetailed = F6($author$project$Components$stringSelectDetailed_fn);
    var $author$project$Pages$Settings$general_fn = function (cfg, model) {
        return $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
            ($author$project$Types$Edition$isShared(cfg.mx.ja) || (!cfg.mx.iH)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$checkBoxDetailed_fn("Auditing Mode", "Logs all executed queries to a database.", A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetAuditing(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, cfg.gd)), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, function ($) {
                return $.iH;
            }, model.aL))),
            $elm$core$Maybe$Just($author$project$Components$checkBoxDetailed_fn("Lock Schema", "Prevents any changes to the database schema.", A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetSchemaLocked(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, cfg.gd)), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, function ($) {
                return $.bj;
            }, model.aL))),
            $elm$core$Maybe$Just($author$project$Components$checkBoxDetailed_fn("Views Tab", "Shows views in a separate tab, instead of in the tables tab.", A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetViewsTab(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, cfg.gd)), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, function ($) {
                return $.pD;
            }, model.aL))),
            $elm$core$Maybe$Just($author$project$Components$stringSelectDetailed_fn("Database Environment", "Show a visual marker of the database environment as a reminder.", _List_fromArray(["", "Testing", "Staging", "Production", "Template"]), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
                return $.mk;
            }, model.aL), A2($elm$core$Basics$composeR, $author$project$Types$DatabaseSettings$maybeSetEnvironment(model.aL), A2($elm$core$Basics$composeR, $author$project$Pages$Settings$SettingsEditModified, cfg.gd)), _List_Nil))
        ]));
    }, $author$project$Pages$Settings$general = F2($author$project$Pages$Settings$general_fn);
    var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass("last-child");
    var $author$project$Pages$Settings$unsavedChanges = function (model) {
        return !_Utils_eq(model.aL, $elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.kR));
    };
    var $author$project$Pages$Settings$content_fn = function (cfg, model, db) {
        var toForm = A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([
            $author$project$Components$formSubmitFooter_fn($elm$core$Maybe$Just(cfg.gd($author$project$Pages$Settings$SettingsEditModified($elm$core$Basics$composeR_fn($krisajenkins$remotedata$RemoteData$toMaybe_a0, $krisajenkins$remotedata$RemoteData$toMaybe_a1, model.kR)))), !$author$project$Pages$Settings$unsavedChanges(model), model.eT)
        ])), $rtfeldman$elm_css$Html$Styled$form(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onSubmit(cfg.gd($author$project$Pages$Settings$SettingsEditApplied(db.bR))),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
        ]))));
        var separator = $author$project$Components$hairLine(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
            $rtfeldman$elm_css$Css$lastChild(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden]))
        ]));
        var toSections = A2($elm$core$Basics$composeR, $elm$core$List$intersperse(separator), $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_8, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full]))
        ])));
        var _v0 = cfg.dW;
        if (_v0.$ === 1) {
            return toForm(toSections($author$project$Pages$Settings$general_fn(cfg, model)));
        }
        else {
            switch (_v0.a) {
                case 0:
                    var _v1 = _v0.a;
                    return toForm(toSections($author$project$Pages$Settings$general_fn(cfg, model)));
                case 1:
                    var _v2 = _v0.a;
                    return toSections($author$project$Pages$Settings$database_fn(cfg, db));
                default:
                    var _v3 = _v0.a;
                    return cfg.mx.i0 ? toForm(toSections($author$project$Pages$Settings$environment_fn(cfg, model))) : $rtfeldman$elm_css$Html$Styled$text("");
            }
        }
    }, $author$project$Pages$Settings$content = F3($author$project$Pages$Settings$content_fn);
    var $author$project$Pages$Settings$view_fn = function (cfg, model) {
        var _v0 = cfg.j;
        switch (_v0.$) {
            case 2:
                var err = _v0.a;
                return $author$project$Components$wrapWithErrorDiv(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(err)
                ]));
            case 1:
                return $author$project$Components$pageSpinner;
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text("");
            default:
                var db = _v0.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
                ]), _List_fromArray([
                    A2($author$project$Components$EditorTitledOverlay$view, cfg.gd, model.cZ),
                    $author$project$Components$menuPage_fn($author$project$Components$menuPageSmall_a0, {
                        dM: 0,
                        gB: $author$project$Pages$Settings$content_fn(cfg, model, db),
                        dW: cfg.dW,
                        nl: _List_Nil,
                        nm: $author$project$Pages$Settings$unsavedChanges(model),
                        nn: _List_fromArray([
                            $elm_community$list_extra$List$Extra$filterNot_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, $elm$core$Basics$eq("Environment"), $elm$core$Basics$and(!cfg.mx.i0))), $elm_community$list_extra$List$Extra$filterNot_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, $elm$core$Basics$eq("Billing"), $elm$core$Basics$and(_Utils_eq($author$project$Types$Database$unwrapId(db.bR), $author$project$Config$exampleDbId) || (!cfg.mx.oh)))), _List_fromArray([
                                _Utils_Tuple2("General", 0),
                                _Utils_Tuple2("Database", 1),
                                _Utils_Tuple2("Environment", 2)
                            ])))
                        ]),
                        fL: $author$project$Pages$Settings$Navigated,
                        gd: cfg.gd
                    })
                ]));
        }
    }, $author$project$Pages$Settings$view = F2($author$project$Pages$Settings$view_fn);
    var $author$project$Pages$Tables$ToolbarMsgReceived = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Types$Database$hasLockedSchema_a0 = false, $author$project$Types$Database$hasLockedSchema_a1 = A2($elm$core$Basics$composeR, function ($) {
        return $.kR;
    }, function ($) {
        return $.bj;
    }), $author$project$Types$Database$hasLockedSchema = A2($krisajenkins$remotedata$RemoteData$unwrap, $author$project$Types$Database$hasLockedSchema_a0, $author$project$Types$Database$hasLockedSchema_a1);
    var $author$project$Types$Database$keepTablesIfViewsTabExists = function (database) {
        return $krisajenkins$remotedata$RemoteData$unwrap_fn(false, A2($elm$core$Basics$composeR, function ($) {
            return $.kR;
        }, function ($) {
            return $.pD;
        }), database) ? $krisajenkins$remotedata$RemoteData$map_fn($author$project$Types$Database$filterTables(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$Table$isView)), database) : database;
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_24 = $rtfeldman$elm_css$Css$property_fn("margin-top", "6rem");
    var $author$project$Overlay$onOverlay_fn = function (toMsg, maybeTrigger, maybeOverlay) {
        if (maybeOverlay.$ === 1) {
            return $elm$json$Json$Decode$fail("");
        }
        else {
            var overlay = maybeOverlay.a;
            var toResult = F2(function (pageX, pageY) {
                return toMsg($author$project$Overlay$SetOverlay_fn(maybeTrigger, $elm$core$Maybe$Just(_Utils_update(overlay, { pH: overlay.pH + pageX, pJ: overlay.pJ + pageY }))));
            });
            return _Json_map2_fn(toResult, _Json_decodeField_fn("pageX", $elm$json$Json$Decode$float), _Json_decodeField_fn("pageY", $elm$json$Json$Decode$float));
        }
    }, $author$project$Overlay$onOverlay = F3($author$project$Overlay$onOverlay_fn);
    var $author$project$Overlay$onTriggerEvent_fn = function (event, toMsg, model) {
        if (_Utils_eq(model.a$, $elm$core$Maybe$Nothing)) {
            return $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "");
        }
        else {
            var decoder = _Json_andThen_fn(function (_v0) {
                var offset = _v0.a;
                var trigger = _v0.b;
                return $author$project$Overlay$onOverlay_fn(A2($elm$core$Basics$composeL, toMsg, model.gd), $elm$core$Maybe$Just(trigger), $elm$core$Maybe$map_fn(function (overlay) {
                    return _Utils_update(overlay, { pH: overlay.pH - offset.pH, pJ: overlay.pJ - offset.pJ });
                }, model.a$));
            }, _Json_map2_fn($elm$core$Tuple$pair, _Json_map2_fn($author$project$Overlay$Position, _Json_decodeField_fn("offsetX", $elm$json$Json$Decode$float), _Json_decodeField_fn("offsetY", $elm$json$Json$Decode$float)), _Json_map2_fn($author$project$Overlay$Dimension, $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "clientWidth"]), $elm$json$Json$Decode$float), $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "clientHeight"]), $elm$json$Json$Decode$float))));
            return $rtfeldman$elm_css$Html$Styled$Events$on_fn(event, decoder);
        }
    }, $author$project$Overlay$onTriggerEvent = F3($author$project$Overlay$onTriggerEvent_fn);
    var $author$project$Components$Toolbar$styles = _List_fromArray([
        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, 2.5)),
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_50),
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
    ]);
    var $author$project$Components$Toolbar$placeholderView = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Cons($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse, $author$project$Components$Toolbar$styles))
    ]), _List_Nil);
    var $author$project$Pages$Tables$Csv = 1;
    var $author$project$Pages$Tables$EditDescription = function (a) {
        return { $: 31, a: a };
    };
    var $author$project$Pages$Tables$EditView = function (a) {
        return { $: 29, a: a };
    };
    var $author$project$Pages$Tables$GridTabClicked = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Pages$Tables$GridTabDragEnded = function (a) {
        return { $: 26, a: a };
    };
    var $author$project$Pages$Tables$GridTabDragStarted = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$Pages$Tables$Json = 0;
    var $author$project$Pages$Tables$ShowDescription = function (a) {
        return { $: 32, a: a };
    };
    var $author$project$Pages$Tables$TableDeleteIntended = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Pages$Tables$TableNameEditApplied = { $: 19 };
    var $author$project$Pages$Tables$TableNameEditCanceled = { $: 18 };
    var $author$project$Pages$Tables$TableNameEditStarted = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$Pages$Tables$TableNameEditUpdated = function (a) {
        return { $: 17, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move = $rtfeldman$elm_css$Css$property_fn("cursor", "move");
    var $author$project$Svg$drag = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 60"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z\n                m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z\n                m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                M11 36c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z\n                m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z\n                m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                M11 54c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z\n                m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z\n                m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_10 = $rtfeldman$elm_css$Css$property_fn("height", "2.5rem");
    var $author$project$Svg$infoOutlined = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M11 7h2v2h-2z\n                m0 4h2v6h-2z\n                m1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z\n                m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$TableEdit$isTableEdit_fn = function (table, tableEdit) {
        return _Utils_eq(tableEdit.kp, $elm$core$Maybe$Just(table));
    }, $author$project$Types$TableEdit$isTableEdit = F2($author$project$Types$TableEdit$isTableEdit_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_left_px = $rtfeldman$elm_css$Css$property_fn("left", "-1px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_px = $rtfeldman$elm_css$Css$property_fn("right", "-1px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_7 = $rtfeldman$elm_css$Css$property_fn("top", "-1.75rem");
    var $author$project$Overlay$onClick_fn = function (toMsg, model) {
        return _Utils_eq(model.a$, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "") : $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn_fn("click", _Json_map1_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, true), $author$project$Overlay$onOverlay_fn(A2($elm$core$Basics$composeL, toMsg, model.gd), $elm$core$Maybe$Nothing, model.a$)));
    }, $author$project$Overlay$onClick = F2($author$project$Overlay$onClick_fn);
    var $rtfeldman$elm_css$Html$Styled$Events$onMouseEnter = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mouseenter", $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Overlay$onMouseLeaveTooltipTrigger_fn = function (toMsg, model) {
        if (_Utils_eq(model.a$, $elm$core$Maybe$Nothing)) {
            return $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "");
        }
        else {
            var decoder = _Json_andThen_fn(function (targetId) {
                var maybeTooltipId = $elm$core$Maybe$map_fn(function ($) {
                    return $.bR;
                }, model.a$);
                var targetIsTooltipId = _Utils_eq($elm$core$Maybe$Just(targetId), maybeTooltipId);
                var targetIsTooltipWrapperId = function (_v0) {
                    var maybeTooltipWrapperId = $elm$core$Maybe$map_fn(A2($author$project$Util$flip, $elm$core$String$append, "-wrapper"), maybeTooltipId);
                    return _Utils_eq($elm$core$Maybe$Just(targetId), maybeTooltipWrapperId);
                };
                return targetIsTooltipId ? $elm$json$Json$Decode$fail("") : (targetIsTooltipWrapperId(0) ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed(toMsg(model.gd($author$project$Overlay$SetOverlay_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)))));
            }, $elm$json$Json$Decode$at_fn(_List_fromArray(["relatedTarget", "id"]), $elm$json$Json$Decode$string));
            return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mouseleave", decoder);
        }
    }, $author$project$Overlay$onMouseLeaveTooltipTrigger = F2($author$project$Overlay$onMouseLeaveTooltipTrigger_fn);
    var $rtfeldman$elm_css$Html$Styled$Events$onMouseUp = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mouseup", $elm$json$Json$Decode$succeed(msg));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_3 = $rtfeldman$elm_css$Css$property_fn("padding", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1 = $rtfeldman$elm_css$Css$property_fn("padding-top", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("right", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_lg = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("top", "0.125rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_1 = $rtfeldman$elm_css$Css$property_fn("width", "0.25rem");
    var $author$project$Pages$Tables$toTab_fn = function (toMsg, tables, shared, model, activeTable, schemaLocked, table) {
        var tableMenuButton = function (styles) {
            var options = function () {
                var isView = $author$project$Types$TableType$isView(table.o8);
                var isReadonly = $author$project$Types$TableType$isReadonly(table.o8);
                return $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                    (schemaLocked || isReadonly) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Rename", $author$project$Pages$Tables$TableNameEditStarted(table), false)),
                    (schemaLocked || (!isView)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Edit", $author$project$Pages$Tables$EditView(table), false)),
                    schemaLocked ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Delete", $author$project$Pages$Tables$TableDeleteIntended(table), false)),
                    (schemaLocked || (!shared.aQ.mx.o7)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Edit Description", $author$project$Pages$Tables$EditDescription(table), false)),
                    (!$author$project$Types$Table$countRows(table)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Export (JSON)", $author$project$Pages$Tables$ExportTable_fn(0, table), false)),
                    (!$author$project$Types$Table$countRows(table)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3("Export (CSV)", $author$project$Pages$Tables$ExportTable_fn(1, table), false))
                ]));
            }();
            return _Utils_eq(options, _List_Nil) ? $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_1]))
            ]), _List_Nil) : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "table-menu-button"),
                $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $author$project$Overlay$onClick_fn(toMsg, $author$project$Overlay$popupMenu_fn(model.a$, options))
            ]), _List_fromArray([
                $author$project$Svg$triangleDown(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3]))
                ]))
            ]));
        };
        var tableInfoIcon = function (styles) {
            return _Utils_eq(table.i6, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text("") : $author$project$Svg$infoOutlined(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
                $rtfeldman$elm_css$Html$Styled$Events$onMouseEnter(toMsg($author$project$Pages$Tables$ShowDescription(table))),
                $author$project$Overlay$onMouseLeaveTooltipTrigger_fn(toMsg, model.a$)
            ]));
        };
        var isDragging = !_Utils_eq(model.bz, $elm$core$Maybe$Nothing);
        var toDraggable = F2(function (containerStyles, element) {
            var dropIndicator = F2(function (id_, styles) {
                return (!isDragging) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_0_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                        $rtfeldman$elm_css$Css$batch(styles)
                    ]))
                ]), _List_Nil);
            });
            var dragStyles = F2(function (maybeIdxFrom, maybeIdxTo) {
                var style = isDragging ? $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn($rtfeldman$elm_css$Css$important_a0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none),
                        $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn($rtfeldman$elm_css$Css$important_a0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move)
                    ]))
                ])) : $rtfeldman$elm_css$Css$batch(_List_Nil);
                var hoverStyles = function () {
                    if (isDragging) {
                        var dragIndicatorId = function () {
                            var colDraggingRight = function (_v0) {
                                return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map2_fn($elm$core$Basics$gt, maybeIdxTo, maybeIdxFrom));
                            };
                            var colDraggingLeft = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map2_fn($elm$core$Basics$lt, maybeIdxTo, maybeIdxFrom));
                            return colDraggingLeft ? $elm$core$Maybe$Just("drop-indicator-left") : (colDraggingRight(0) ? $elm$core$Maybe$Just("drop-indicator-right") : $elm$core$Maybe$Nothing);
                        }();
                        return _List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Css$batch(_List_Nil), A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $rtfeldman$elm_css$Css$Global$id, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block])), A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Css$Global$children)), dragIndicatorId)
                        ]);
                    }
                    else {
                        return _List_fromArray([
                            $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                                $rtfeldman$elm_css$Css$Global$id_fn("table-drag-handle", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                            ]))
                        ]);
                    }
                }();
                return $rtfeldman$elm_css$Css$batch(_List_fromArray([
                    style,
                    $rtfeldman$elm_css$Css$hover(hoverStyles)
                ]));
            });
            var dragHandle = function (styles) {
                return schemaLocked ? $rtfeldman$elm_css$Html$Styled$text("") : $author$project$Svg$drag(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move,
                        $rtfeldman$elm_css$Css$property_fn("rotate", "90deg"),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                        $rtfeldman$elm_css$Css$batch(styles)
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "table-drag-handle"),
                    $rtfeldman$elm_css$Html$Styled$Events$onMouseDown(toMsg($author$project$Pages$Tables$GridTabDragStarted(table)))
                ]));
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                    A2(dragStyles, $elm$core$Maybe$andThen_fn($author$project$Types$Table$toIndex(tables), model.bz), $author$project$Types$Table$toIndex_fn(tables, table)),
                    $rtfeldman$elm_css$Css$batch(containerStyles)
                ]))
            ]), _List_fromArray([
                A2(dropIndicator, "drop-indicator-left", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_left_px, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1])),
                dragHandle(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_7])),
                element,
                A2(dropIndicator, "drop-indicator-right", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_px, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1]))
            ]));
        });
        var isActive = _Utils_eq(activeTable, table.M);
        var tabStyles = isActive ? _List_fromArray([
            $rtfeldman$elm_css$Css$borderColor($author$project$Theme$theme.dd),
            $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd)
        ]) : _List_Nil;
        var nameOrInput = function (styles) {
            var isEditing = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, $author$project$Types$TableEdit$isTableEdit(table), model.an);
            var input_ = function (inputStyles) {
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (tableNameEdit) {
                    return $author$project$Components$expandingInput_fn({
                        iE: true,
                        cP: _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "table-name-input"),
                            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0, $author$project$Config$dbObjectRegex),
                            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$required_a0, true)
                        ]),
                        iV: _List_Nil,
                        j3: false,
                        bC: $elm$core$Maybe$Just(toMsg($author$project$Pages$Tables$TableNameEditApplied)),
                        ek: toMsg($author$project$Pages$Tables$TableNameEditCanceled),
                        cv: A2($elm$core$Basics$composeR, $author$project$Types$TableEdit$setName(tableNameEdit), A2($elm$core$Basics$composeR, $author$project$Pages$Tables$TableNameEditUpdated, toMsg)),
                        m: inputStyles
                    }, tableNameEdit.M);
                }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(isEditing), model.an));
            };
            var columnsLoading = $elm$core$List$all_fn($author$project$Types$Column$isLoading, table.iT);
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden,
                    $rtfeldman$elm_css$Css$batch(styles),
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1]))
                    ]))
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $author$project$Util$stylesIf_fn(isEditing, _List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                        ]))
                    ]))
                ]), _List_fromArray([
                    $author$project$Components$wrapWithSpinner_fn(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4]), (!_Utils_eq(table.M, activeTable)) && columnsLoading, $rtfeldman$elm_css$Html$Styled$text(table.M))
                ])),
                input_(_List_fromArray([
                    $rtfeldman$elm_css$Css$batch(tabStyles),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                ]))
            ]));
        };
        var tableTypeIconStyle = $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0_dot_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0_dot_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_1,
            isActive ? $rtfeldman$elm_css$Css$color($author$project$Theme$theme.dd) : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
        ]));
        return A2(toDraggable, _List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_lg,
            $rtfeldman$elm_css$Css$hover(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
            ]))
        ]), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Util$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$id, A2($author$project$Types$Table$toHeaderId, tables, table)),
            $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$Pages$Tables$GridTabClicked(table.M))),
            $rtfeldman$elm_css$Html$Styled$Events$onMouseUp(toMsg($author$project$Pages$Tables$GridTabDragEnded(table))),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_10,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_3,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t_lg,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
            ]), tabStyles))
        ]), _List_fromArray([
            $author$project$Types$TableType$toIcon_fn(tableTypeIconStyle, table.o8),
            nameOrInput(_List_Nil),
            tableInfoIcon(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_0_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3])),
            tableMenuButton(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1]))
        ])));
    }, $author$project$Pages$Tables$toTab = F7($author$project$Pages$Tables$toTab_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_3over4 = $rtfeldman$elm_css$Css$property_fn("height", "75%");
    var $author$project$Components$Toolbar$FilterApplied = { $: 1 };
    var $author$project$Components$Toolbar$FilterUpdated = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Components$Toolbar$FiltersCleared = { $: 2 };
    var $author$project$Svg$filterOff = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M19.79 5.61C20.3 4.95 19.83 4 19 4H6.83l7.97 7.97 4.99-6.36z\n                M2.81 2.81 1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$TableFilter$setSearch_fn = function (filter, search) {
        return _Utils_update(filter, { oN: search });
    }, $author$project$Types$TableFilter$setSearch = F2($author$project$Types$TableFilter$setSearch_fn);
    var $author$project$Components$Toolbar$viewFilters = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2]))
        ]), _List_fromArray([
            $author$project$Components$searchInput({
                cd: model.dI,
                mO: _List_Nil,
                bC: $author$project$Components$Toolbar$FilterApplied,
                hH: $elm$core$Maybe$Just($author$project$Components$Toolbar$FilterUpdated($author$project$Types$TableFilter$setSearch_fn(model.ba, ""))),
                cv: A2($elm$core$Basics$composeR, $author$project$Types$TableFilter$setSearch(model.ba), $author$project$Components$Toolbar$FilterUpdated),
                m: _List_Nil,
                pB: model.ba.oN
            }),
            $author$project$Components$iconButton({
                bA: $author$project$Svg$filterOff,
                a_: $author$project$Components$Toolbar$FiltersCleared,
                m: _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5,
                    $author$project$Util$stylesIf_fn(_Utils_eq(model.dw, $elm$core$Maybe$Nothing), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse]))
                ]),
                bE: _List_Nil
            })
        ]));
    };
    var $author$project$Components$Toolbar$Refresh = { $: 3 };
    var $author$project$Svg$refresh = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Toolbar$viewTools = $author$project$Components$iconButton({
        bA: $author$project$Svg$refresh,
        a_: $author$project$Components$Toolbar$Refresh,
        m: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]),
        bE: _List_Nil
    });
    var $author$project$Components$Toolbar$view = function (model) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $rtfeldman$elm_css$Css$batch($author$project$Components$Toolbar$styles)
            ]))
        ]), _List_fromArray([
            $author$project$Components$Toolbar$viewFilters(model),
            $author$project$Components$hairBar(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mx_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_3over4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300)
            ])),
            $author$project$Components$Toolbar$viewTools
        ]));
    };
    var $author$project$Layout$error_banner_h = 2.5;
    var $author$project$GraphGrid$viewMessage_fn = function (maybeOnClick, title) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), $rtfeldman$elm_css$Html$Styled$Events$onClick, maybeOnClick),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_40, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                    $author$project$Theme$theme.of,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(title)
            ]))
        ]));
    }, $author$project$GraphGrid$viewMessage = F2($author$project$GraphGrid$viewMessage_fn);
    var $author$project$GraphGrid$maybeUploadProgress_a0 = $elm$core$Maybe$andThen(function ($) {
        return $.fT;
    }), $author$project$GraphGrid$maybeUploadProgress_a1 = $elm$core$Maybe$andThen(A2($elm$core$Basics$composeR, $author$project$Util$httpProgressToPercent, A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter($elm$core$Basics$neq(0)), A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$filter($elm$core$Basics$neq(100)), $elm$core$Maybe$map(function (percentage) {
        return $author$project$GraphGrid$viewMessage_fn($elm$core$Maybe$Nothing, "Uploading file... " + ($elm$core$String$fromInt(percentage) + "%"));
    }))))), $author$project$GraphGrid$maybeUploadProgress = A2($elm$core$Basics$composeR, $author$project$GraphGrid$maybeUploadProgress_a0, $author$project$GraphGrid$maybeUploadProgress_a1);
    var $author$project$EditGrid$RowAdded = { $: 13 };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$auto_cols_min = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("grid-auto-columns", "-webkit-min-content"),
        $rtfeldman$elm_css$Css$property_fn("grid-auto-columns", "min-content")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b = $rtfeldman$elm_css$Css$property_fn("border-bottom-width", "1px");
    var $author$project$EditGrid$CellEditCanceled = { $: 3 };
    var $author$project$EditGrid$CellFileUploaded = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$EditGrid$CellHovered = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$EditGrid$FocusEdit = function (a) {
        return { $: 31, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_not_allowed = $rtfeldman$elm_css$Css$property_fn("cursor", "not-allowed");
    var $author$project$Svg$infoFilled = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "16px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "1 2 21 21"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "16px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor")
        ]), attributes), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M0 0h21v21H0z"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "none")
            ]), _List_Nil),
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z\n                m1 15h-2v-6h2v6z\n                m0-8h-2V7h2v2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Overlay$onMouseEnterTooltipTrigger_fn = function (toMsg, model, toTooltip) {
        return (!_Utils_eq(model.a$, $elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "") : $author$project$Overlay$onTriggerEvent_fn("mouseenter", toMsg, toTooltip(model));
    }, $author$project$Overlay$onMouseEnterTooltipTrigger = F3($author$project$Overlay$onMouseEnterTooltipTrigger_fn);
    var $author$project$Overlay$tooltipTop_a0 = $elm$core$Maybe$Just(F2(function (tooltip_, trigger) {
        return $author$project$Overlay$Position_fn((tooltip_.pH + (trigger.bq / 2)) - (tooltip_.bq / 2), (tooltip_.pJ - tooltip_.ck) - 5);
    })), $author$project$Overlay$tooltipTop = $author$project$Overlay$tooltip($author$project$Overlay$tooltipTop_a0);
    var $author$project$EditGrid$errorIcon_fn = function (toMsg, overlay, error) {
        return $author$project$Svg$infoFilled(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_0_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_100),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full
            ])),
            $author$project$Overlay$onMouseLeaveTooltipTrigger_fn(toMsg, overlay),
            $author$project$Overlay$onMouseEnterTooltipTrigger_fn(toMsg, overlay, A2($author$project$Overlay$tooltipTop, _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_700),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$minWidth_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 20))
            ]), _List_fromArray([error])))
        ]));
    }, $author$project$EditGrid$errorIcon = F3($author$project$EditGrid$errorIcon_fn);
    var $rtfeldman$elm_css$Css$Structure$GeneralSibling = 1;
    var $rtfeldman$elm_css$Css$Global$generalSiblings_a0 = 1, $rtfeldman$elm_css$Css$Global$generalSiblings = $rtfeldman$elm_css$Css$Preprocess$NestSnippet($rtfeldman$elm_css$Css$Global$generalSiblings_a0);
    var $author$project$EditGrid$headerOffset = 1;
    var $author$project$EditGrid$indexOffset = 1;
    var $rl_king$elm_iso3166_country_codes$Iso3166$all = _List_fromArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248]);
    var $author$project$Types$InputElement$maybeAttr_a0 = function (_v0) {
        return $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "");
    }, $author$project$Types$InputElement$maybeAttr = $elm_community$maybe_extra$Maybe$Extra$unpack($author$project$Types$InputElement$maybeAttr_a0);
    var $author$project$Types$InputElement$onBlurToNonInput = function (msg) {
        var decoder_ = _Json_andThen_fn(function (tagName) {
            return $elm$core$List$member_fn(tagName, _List_fromArray(["INPUT", "INPUT-CONTAINER", "TEXTAREA", "SELECT"])) ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed(msg);
        }, $elm$json$Json$Decode$at_fn(_List_fromArray(["relatedTarget", "tagName"]), $elm$json$Json$Decode$string));
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("blur", decoder_);
    };
    var $author$project$Types$Edit$toBool = function (edit) {
        return edit.pB === "true";
    };
    var $author$project$Types$InputElement$booleanInput_fn = function (context, tableType, onCheck, onCancel, maybeOnBlurToNonInput, attributes, overlay, edit) {
        var wrapperStyles = function () {
            if (!context) {
                return _List_Nil;
            }
            else {
                return _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_start]);
            }
        }();
        var isReadonly = $author$project$Types$TableType$isReadonly(tableType);
        var commonStyles = _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn("input-container", _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
            $rtfeldman$elm_css$Css$batch(wrapperStyles)
        ])), attributes), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _Utils_ap(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, A2($author$project$Types$InputElement$idFromContext, context, edit)),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, $author$project$Types$Edit$toBool(edit)),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, isReadonly),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50]))
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(commonStyles),
                isReadonly ? $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "") : $rtfeldman$elm_css$Html$Styled$Events$onCheck(A2($elm$core$Basics$composeR, $author$project$Util$Bool$toString, A2($elm$core$Basics$composeR, $author$project$Types$Edit$setStringClearError(edit), onCheck))),
                isReadonly ? $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "") : $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $author$project$Types$InputElement$onBlurToNonInput, maybeOnBlurToNonInput),
                ($author$project$Types$Edit$hasError(edit) || isReadonly) ? $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("click", $elm$json$Json$Decode$succeed(_Utils_Tuple2(onCancel, true))) : $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "")
            ]), attributes), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(commonStyles)
            ]), _List_fromArray([
                $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), overlay)
            ]))
        ]));
    }, $author$project$Types$InputElement$booleanInput = F8($author$project$Types$InputElement$booleanInput_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$appearance_none = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-webkit-appearance", "none"),
        $rtfeldman$elm_css$Css$property_fn("-moz-appearance", "none"),
        $rtfeldman$elm_css$Css$property_fn("appearance", "none")
    ]));
    var $author$project$Types$InputElement$maxHeight = $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 5.5));
    var $author$project$Layout$content_px = 2;
    var $author$project$Types$InputElement$maxWidth = $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$maxWidth_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$vw_a0, $rtfeldman$elm_css$Css$vw_a1, 66), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, $author$project$Layout$content_px)));
    var $rtfeldman$elm_css$Html$Styled$Events$onBlur = function (msg) {
        return $rtfeldman$elm_css$Html$Styled$Events$on_fn("blur", $elm$json$Json$Decode$succeed(msg));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2_dot_5 = $rtfeldman$elm_css$Css$property_fn("padding-left", "0.625rem");
    var $rtfeldman$elm_css$Css$Structure$AttributeSelector = function (a) {
        return { $: 3, a: a };
    };
    var $rtfeldman$elm_css$Css$Global$withAttribute = function (attribute) {
        return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector($rtfeldman$elm_css$Css$Structure$AttributeSelector(attribute));
    };
    var $author$project$Types$InputElement$expandingInput_fn = function (cfg, attributes, overlay, edit) {
        var zeroWidthString = $elm$core$String$fromChar("\u200B");
        var styles = function () {
            var _v1 = cfg.bx;
            if (!_v1) {
                return $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]));
            }
            else {
                return $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ]));
            }
        }();
        var isInput = !_Utils_eq(cfg.gh, $elm$core$Maybe$Nothing);
        var node = isInput ? $rtfeldman$elm_css$Html$Styled$input : $rtfeldman$elm_css$Html$Styled$textarea;
        var commonStyles = $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2_dot_5,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
            $rtfeldman$elm_css$Css$property_fn("scroll-padding", "0 0 2em 2em"),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre,
            function () {
                var _v0 = cfg.bx;
                if (!_v0) {
                    return $rtfeldman$elm_css$Css$batch(_List_fromArray([
                        $author$project$Types$InputElement$maxWidth,
                        $author$project$Types$InputElement$maxHeight,
                        A2($rtfeldman$elm_css$Css$Global$withAttribute, "type=number", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right]))
                    ]));
                }
                else {
                    return $rtfeldman$elm_css$Css$batch(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                        isInput ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8 : $rtfeldman$elm_css$Css$batch(_List_Nil)
                    ]));
                }
            }(),
            $rtfeldman$elm_css$Css$batch(cfg.m)
        ]));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$span_a0, _List_fromArray([
                commonStyles,
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(_Utils_ap(edit.pB, zeroWidthString))
            ])),
            A2(node, _Utils_ap(_List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Attributes$type_, cfg.gh),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, edit.pB),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, A2($author$project$Types$InputElement$idFromContext, cfg.bx, edit)),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$readonly_a0, $author$project$Types$TableType$isReadonly(cfg.o8)),
                $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
                $rtfeldman$elm_css$Html$Styled$Attributes$size(1),
                $rtfeldman$elm_css$Html$Styled$Attributes$rows(1),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$resize_none,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400)
                    ])),
                    $rtfeldman$elm_css$Css$property_fn("overflow", "-moz-hidden-unscrollable"),
                    A2($rtfeldman$elm_css$Css$Global$withAttribute, "type=number", _List_fromArray([
                        A2($rtfeldman$elm_css$Css$pseudoElement, "-webkit-inner-spin-button", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$appearance_none])),
                        A2($rtfeldman$elm_css$Css$pseudoElement, "-webkit-outer-spin-button", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$appearance_none])),
                        $rtfeldman$elm_css$Css$property_fn("-moz-appearance", "textfield")
                    ]))
                ])),
                commonStyles,
                styles,
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onMouseLeave, cfg.nW),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onMouseEnter, $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(edit.eo), cfg.nV)),
                $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), $elm_community$maybe_extra$Maybe$Extra$or_fn($elm$core$Maybe$map_fn($rtfeldman$elm_css$Html$Styled$Events$onBlur, cfg.nL), $elm$core$Maybe$map_fn($author$project$Types$InputElement$onBlurToNonInput, cfg.nM))),
                $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $rtfeldman$elm_css$Html$Styled$Events$onInput, $elm$core$Maybe$map_fn(function (onInput) {
                    return A2($elm$core$Basics$composeR, $author$project$Types$Edit$setStringClearError(edit), onInput);
                }, cfg.cv)),
                $author$project$Util$onKeyDown({ kf: cfg.kf, kj: cfg.kj, hH: cfg.hH, kn: $elm$core$Maybe$Nothing })
            ]), _Utils_ap(cfg.cP, attributes)), _List_Nil),
            $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), overlay)
        ]));
    }, $author$project$Types$InputElement$expandingInput = F4($author$project$Types$InputElement$expandingInput_fn);
    var $author$project$Svg$upload = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$InputElement$fileInput_fn = function (context, onUpload, onCancel, attrs, _v0, edit) {
        var uploadButton = function (_v1) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Events$onClick(onUpload(edit)),
                $rtfeldman$elm_css$Html$Styled$Events$onBlur(onCancel),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent)
                ]))
            ]), _List_fromArray([
                $author$project$Svg$upload(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ]))
                    ]))
                ]))
            ]));
        };
        var editToFileUrl = function (edit_) {
            return $elm$core$Maybe$andThen_fn($elm_community$string_extra$String$Extra$nonEmpty, $elm$core$Result$toMaybe(_Json_runOnString_fn(_Json_decodeField_fn("url", $elm$json$Json$Decode$string), $author$project$Types$Edit$toString(edit_))));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn("input-container", _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                ($author$project$Types$Edit$toString(edit) === "") ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100) : $rtfeldman$elm_css$Css$batch(_List_Nil),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
                ]))
            ])),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "not-allowed")
        ]), attrs), _Utils_eq($author$project$Types$Edit$toString(edit), $author$project$Types$InputElement$defaultValue($author$project$Types$InputElement$InputFile)) ? _List_Nil : (($author$project$Types$Edit$toString(edit) === "") ? _List_fromArray([
            uploadButton(0)
        ]) : _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), function (fileUrl) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$href(fileUrl),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$target_a0, "_blank"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, A2($author$project$Types$InputElement$idFromContext, context, edit))
                ]), _List_fromArray([
                    $author$project$Svg$eye(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                            $rtfeldman$elm_css$Css$hover(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                            ]))
                        ]))
                    ]))
                ]));
            }, editToFileUrl(edit)),
            uploadButton(0)
        ])));
    }, $author$project$Types$InputElement$fileInput = F6($author$project$Types$InputElement$fileInput_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$hidden_a0 = "hidden", $rtfeldman$elm_css$Html$Styled$Attributes$hidden = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty($rtfeldman$elm_css$Html$Styled$Attributes$hidden_a0);
    var $author$project$Types$InputElement$singleSelectInput = function (context) {
        return function (tableType) {
            return function (vals) {
                return function (valToStr) {
                    return function (strToInput) {
                        return function (onSelect) {
                            return function (onCancel) {
                                return function (maybeOnBlurToNonInput) {
                                    return function (attrs) {
                                        return function (overlay) {
                                            return function (edit) {
                                                var selectStyles = function () {
                                                    if (!context) {
                                                        return _List_fromArray([
                                                            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$inherit)
                                                        ]);
                                                    }
                                                    else {
                                                        return _List_fromArray([
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                                                        ]);
                                                    }
                                                }();
                                                var commonStyles = _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1]);
                                                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn("input-container", _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                                                    function () {
                                                        if (!context) {
                                                            return $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center;
                                                        }
                                                        else {
                                                            return $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_items_start;
                                                        }
                                                    }()
                                                ])), attrs), _List_fromArray([
                                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$select_a0, _Utils_ap(_List_fromArray([
                                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$outline_none,
                                                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$appearance_none,
                                                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                                                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                                                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$inherit),
                                                            $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50])),
                                                            $rtfeldman$elm_css$Css$batch(selectStyles)
                                                        ])),
                                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(commonStyles),
                                                        $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, A2($author$project$Types$InputElement$idFromContext, context, edit)),
                                                        $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeR, strToInput, A2($elm$core$Basics$composeR, $author$project$Types$Edit$setStringClearError(edit), onSelect))),
                                                        $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, $author$project$Types$InputElement$onBlurToNonInput, maybeOnBlurToNonInput),
                                                        ($author$project$Types$Edit$hasError(edit) || $author$project$Types$TableType$isReadonly(tableType)) ? $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("mousedown", $elm$json$Json$Decode$succeed(_Utils_Tuple2(onCancel, true))) : $rtfeldman$elm_css$VirtualDom$Styled$style_fn("", "")
                                                    ]), attrs), $elm$core$List$append_fn(_List_fromArray([
                                                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                                                            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, edit.pB === ""),
                                                            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$hidden_a0, true)
                                                        ]), _List_fromArray([
                                                            $rtfeldman$elm_css$Html$Styled$text("")
                                                        ]))
                                                    ]), $elm$core$List$map_fn(function (val) {
                                                        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$option_a0, _List_fromArray([
                                                            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$selected_a0, _Utils_eq(edit.pB, strToInput(valToStr(val))))
                                                        ]), _List_fromArray([
                                                            $rtfeldman$elm_css$Html$Styled$text(valToStr(val))
                                                        ]));
                                                    }, vals))),
                                                    $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                                                        $rtfeldman$elm_css$Html$Styled$Attributes$css(commonStyles)
                                                    ]), _List_fromArray([
                                                        $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), overlay)
                                                    ]))
                                                ]));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$step = function (n) {
        return $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn("step", n);
    };
    var $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha3 = function (c) {
        switch (c) {
            case 0:
                return "and";
            case 1:
                return "are";
            case 2:
                return "afg";
            case 3:
                return "atg";
            case 4:
                return "aia";
            case 5:
                return "alb";
            case 6:
                return "arm";
            case 7:
                return "ago";
            case 8:
                return "ata";
            case 9:
                return "arg";
            case 10:
                return "asm";
            case 11:
                return "aut";
            case 12:
                return "aus";
            case 13:
                return "abw";
            case 14:
                return "ala";
            case 15:
                return "aze";
            case 16:
                return "bih";
            case 17:
                return "brb";
            case 18:
                return "bgd";
            case 19:
                return "bel";
            case 20:
                return "bfa";
            case 21:
                return "bgr";
            case 22:
                return "bhr";
            case 23:
                return "bdi";
            case 24:
                return "ben";
            case 25:
                return "blm";
            case 26:
                return "bmu";
            case 27:
                return "brn";
            case 28:
                return "bol";
            case 29:
                return "bes";
            case 30:
                return "bra";
            case 31:
                return "bhs";
            case 32:
                return "btn";
            case 33:
                return "bvt";
            case 34:
                return "bwa";
            case 35:
                return "blr";
            case 36:
                return "blz";
            case 37:
                return "can";
            case 38:
                return "cck";
            case 39:
                return "cod";
            case 40:
                return "caf";
            case 41:
                return "cog";
            case 42:
                return "che";
            case 43:
                return "civ";
            case 44:
                return "cok";
            case 45:
                return "chl";
            case 46:
                return "cmr";
            case 47:
                return "chn";
            case 48:
                return "col";
            case 49:
                return "cri";
            case 50:
                return "cub";
            case 51:
                return "cpv";
            case 52:
                return "cuw";
            case 53:
                return "cxr";
            case 54:
                return "cyp";
            case 55:
                return "cze";
            case 56:
                return "deu";
            case 57:
                return "dji";
            case 58:
                return "dnk";
            case 59:
                return "dma";
            case 60:
                return "dom";
            case 61:
                return "dza";
            case 62:
                return "ecu";
            case 63:
                return "est";
            case 64:
                return "egy";
            case 65:
                return "esh";
            case 66:
                return "eri";
            case 67:
                return "esp";
            case 68:
                return "eth";
            case 69:
                return "fin";
            case 70:
                return "fji";
            case 71:
                return "flk";
            case 72:
                return "fsm";
            case 73:
                return "fro";
            case 74:
                return "fra";
            case 75:
                return "gab";
            case 76:
                return "gbr";
            case 77:
                return "grd";
            case 78:
                return "geo";
            case 79:
                return "guf";
            case 80:
                return "ggy";
            case 81:
                return "gha";
            case 82:
                return "gib";
            case 83:
                return "grl";
            case 84:
                return "gmb";
            case 85:
                return "gin";
            case 86:
                return "glp";
            case 87:
                return "gnq";
            case 88:
                return "grc";
            case 89:
                return "sgs";
            case 90:
                return "gtm";
            case 91:
                return "gum";
            case 92:
                return "gnb";
            case 93:
                return "guy";
            case 94:
                return "hkg";
            case 95:
                return "hmd";
            case 96:
                return "hnd";
            case 97:
                return "hrv";
            case 98:
                return "hti";
            case 99:
                return "hun";
            case 100:
                return "idn";
            case 101:
                return "irl";
            case 102:
                return "isr";
            case 103:
                return "imn";
            case 104:
                return "ind";
            case 105:
                return "iot";
            case 106:
                return "irq";
            case 107:
                return "irn";
            case 108:
                return "isl";
            case 109:
                return "ita";
            case 110:
                return "jey";
            case 111:
                return "jam";
            case 112:
                return "jor";
            case 113:
                return "jpn";
            case 114:
                return "ken";
            case 115:
                return "kgz";
            case 116:
                return "khm";
            case 117:
                return "kir";
            case 118:
                return "com";
            case 119:
                return "kna";
            case 120:
                return "prk";
            case 121:
                return "kor";
            case 122:
                return "kwt";
            case 123:
                return "cym";
            case 124:
                return "kaz";
            case 125:
                return "lao";
            case 126:
                return "lbn";
            case 127:
                return "lca";
            case 128:
                return "lie";
            case 129:
                return "lka";
            case 130:
                return "lbr";
            case 131:
                return "lso";
            case 132:
                return "ltu";
            case 133:
                return "lux";
            case 134:
                return "lva";
            case 135:
                return "lby";
            case 136:
                return "mar";
            case 137:
                return "mco";
            case 138:
                return "mda";
            case 139:
                return "mne";
            case 140:
                return "maf";
            case 141:
                return "mdg";
            case 142:
                return "mhl";
            case 143:
                return "mkd";
            case 144:
                return "mli";
            case 145:
                return "mmr";
            case 146:
                return "mng";
            case 147:
                return "mac";
            case 148:
                return "mnp";
            case 149:
                return "mtq";
            case 150:
                return "mrt";
            case 151:
                return "msr";
            case 152:
                return "mlt";
            case 153:
                return "mus";
            case 154:
                return "mdv";
            case 155:
                return "mwi";
            case 156:
                return "mex";
            case 157:
                return "mys";
            case 158:
                return "moz";
            case 159:
                return "nam";
            case 160:
                return "ncl";
            case 161:
                return "ner";
            case 162:
                return "nfk";
            case 163:
                return "nga";
            case 164:
                return "nic";
            case 165:
                return "nld";
            case 166:
                return "nor";
            case 167:
                return "npl";
            case 168:
                return "nru";
            case 169:
                return "niu";
            case 170:
                return "nzl";
            case 171:
                return "omn";
            case 172:
                return "pan";
            case 173:
                return "per";
            case 174:
                return "pyf";
            case 175:
                return "png";
            case 176:
                return "phl";
            case 177:
                return "pak";
            case 178:
                return "pol";
            case 179:
                return "spm";
            case 180:
                return "pcn";
            case 181:
                return "pri";
            case 182:
                return "pse";
            case 183:
                return "prt";
            case 184:
                return "plw";
            case 185:
                return "pry";
            case 186:
                return "qat";
            case 187:
                return "reu";
            case 188:
                return "rou";
            case 189:
                return "srb";
            case 190:
                return "rus";
            case 191:
                return "rwa";
            case 192:
                return "sau";
            case 193:
                return "slb";
            case 194:
                return "syc";
            case 195:
                return "sdn";
            case 196:
                return "swe";
            case 197:
                return "sgp";
            case 198:
                return "shn";
            case 199:
                return "svn";
            case 200:
                return "sjm";
            case 201:
                return "svk";
            case 202:
                return "sle";
            case 203:
                return "smr";
            case 204:
                return "sen";
            case 205:
                return "som";
            case 206:
                return "sur";
            case 207:
                return "ssd";
            case 208:
                return "stp";
            case 209:
                return "slv";
            case 210:
                return "sxm";
            case 211:
                return "syr";
            case 212:
                return "swz";
            case 213:
                return "tca";
            case 214:
                return "tcd";
            case 215:
                return "atf";
            case 216:
                return "tgo";
            case 217:
                return "tha";
            case 218:
                return "tjk";
            case 219:
                return "tkl";
            case 220:
                return "tls";
            case 221:
                return "tkm";
            case 222:
                return "tun";
            case 223:
                return "ton";
            case 224:
                return "tur";
            case 225:
                return "tto";
            case 226:
                return "tuv";
            case 227:
                return "twn";
            case 228:
                return "tza";
            case 229:
                return "ukr";
            case 230:
                return "uga";
            case 231:
                return "umi";
            case 232:
                return "usa";
            case 233:
                return "ury";
            case 234:
                return "uzb";
            case 235:
                return "vat";
            case 236:
                return "vct";
            case 237:
                return "ven";
            case 238:
                return "vgb";
            case 239:
                return "vir";
            case 240:
                return "vnm";
            case 241:
                return "vut";
            case 242:
                return "wlf";
            case 243:
                return "wsm";
            case 244:
                return "yem";
            case 245:
                return "myt";
            case 246:
                return "zaf";
            case 247:
                return "zmb";
            default:
                return "zwe";
        }
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_4 = $rtfeldman$elm_css$Css$property_fn("height", "1rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_0_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-translate-x", "-0.125rem"),
        $rtfeldman$elm_css$Css$property_fn("transform", "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_12 = $rtfeldman$elm_css$Css$property_fn("width", "3rem");
    var $author$project$Types$InputElement$wrapWithColorPicker_fn = function (attrs, context, tableType, focusMsg, onUpdate, edit, inputElement) {
        var styles = function () {
            if (!context) {
                return _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]);
            }
            else {
                return _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ]);
            }
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_between,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
            $rtfeldman$elm_css$Css$batch(styles)
        ])), attrs), _List_fromArray([
            inputElement,
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "color"),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$value_a0, edit.pB),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, $author$project$Types$TableType$isReadonly(tableType)),
                $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeR, $author$project$Types$Edit$setStringClearError(edit), onUpdate)),
                $rtfeldman$elm_css$Html$Styled$Events$on_fn("change", $elm$json$Json$Decode$succeed(focusMsg(edit))),
                $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_12,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $rtfeldman$elm_css$Css$property_fn("clip-path", "circle(0.5rem)"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_1,
                    $author$project$Util$stylesIf_fn(!context, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$transform, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_translate_x_0_dot_5]))
                ]))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$right_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                ]))
            ]), _List_Nil)
        ]));
    }, $author$project$Types$InputElement$wrapWithColorPicker = F7($author$project$Types$InputElement$wrapWithColorPicker_fn);
    var $author$project$Svg$calender = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z\n                m0 16H5V10h14v10z\n                M9 14H7v-2h2v2z\n                m4 0h-2v-2h2v2z\n                m4 0h-2v-2h2v2z\n                m-8 4H7v-2h2v2z\n                m4 0h-2v-2h2v2z\n                m4 0h-2v-2h2v2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$InputElement$wrapWithDatePicker_fn = function (attrs, context, tableType, focusMsg, onUpdate, edit, inputElement) {
        var styles = function () {
            if (!context) {
                return _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                ]);
            }
            else {
                return _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ]);
            }
        }();
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
            $rtfeldman$elm_css$Css$batch(styles)
        ])), attrs), _List_fromArray([
            inputElement,
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mb_0_dot_5]))
            ]), _List_fromArray([
                $author$project$Svg$calender(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                    ]))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "date"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, $author$project$Types$TableType$isReadonly(tableType)),
                    $rtfeldman$elm_css$Html$Styled$Events$onInput(A2($elm$core$Basics$composeR, $author$project$Types$Edit$setStringClearError(edit), onUpdate)),
                    $rtfeldman$elm_css$Html$Styled$Events$on_fn("change", $elm$json$Json$Decode$succeed(focusMsg(edit))),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
                ]), _List_Nil)
            ]))
        ]));
    }, $author$project$Types$InputElement$wrapWithDatePicker = F7($author$project$Types$InputElement$wrapWithDatePicker_fn);
    var $author$project$Types$InputElement$view = function (context) {
        return function (focusMsg) {
            return function (onUpdate) {
                return function (onApply) {
                    return function (onCancel) {
                        return function (onUpload) {
                            return function (onMouseEnter) {
                                return function (onMouseLeave) {
                                    return function (tableType) {
                                        return function (element) {
                                            var onBlur = function () {
                                                if (!context) {
                                                    return $elm$core$Maybe$Nothing;
                                                }
                                                else {
                                                    return $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing));
                                                }
                                            }();
                                            var isGridContext = function () {
                                                if (!context) {
                                                    return true;
                                                }
                                                else {
                                                    return false;
                                                }
                                            }();
                                            var expandingInputMultiline = function (styles) {
                                                return $author$project$Types$InputElement$expandingInput({
                                                    cP: _List_Nil,
                                                    bx: context,
                                                    nL: onBlur,
                                                    nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                    kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                    kj: $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(isGridContext), $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing))),
                                                    hH: $elm$core$Maybe$Just(onCancel),
                                                    cv: $elm$core$Maybe$Just(onUpdate),
                                                    nV: onMouseEnter,
                                                    nW: onMouseLeave,
                                                    m: styles,
                                                    o8: tableType,
                                                    gh: $elm$core$Maybe$Nothing
                                                });
                                            };
                                            switch (element.$) {
                                                case 0:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Nothing,
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("number")
                                                    });
                                                case 1:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_fromArray([
                                                            $rtfeldman$elm_css$Html$Styled$Attributes$step("0.1")
                                                        ]),
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Nothing,
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("number")
                                                    });
                                                case 2:
                                                    return expandingInputMultiline(_List_Nil);
                                                case 3:
                                                    return A5($author$project$Types$InputElement$booleanInput, context, tableType, A2($elm$core$Basics$composeL, onApply, $elm$core$Maybe$Just), onCancel, $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)));
                                                case 4:
                                                    var values = element.a;
                                                    return A8($author$project$Types$InputElement$singleSelectInput, context, tableType, values, $elm$core$Basics$identity, $elm$core$Basics$identity, A2($elm$core$Basics$composeL, onApply, $elm$core$Maybe$Just), onCancel, $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)));
                                                case 5:
                                                    return F3(function (attrs, overlay, edit) {
                                                        return $author$project$Types$InputElement$wrapWithDatePicker_fn(attrs, context, tableType, focusMsg, onUpdate, edit, $author$project$Types$InputElement$expandingInput_fn({
                                                            cP: _List_Nil,
                                                            bx: context,
                                                            nL: onBlur,
                                                            nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            hH: $elm$core$Maybe$Just(onCancel),
                                                            cv: $elm$core$Maybe$Just(onUpdate),
                                                            nV: onMouseEnter,
                                                            nW: onMouseLeave,
                                                            m: _List_Nil,
                                                            o8: tableType,
                                                            gh: $elm$core$Maybe$Just("text")
                                                        }, attrs, overlay, edit));
                                                    });
                                                case 6:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("text")
                                                    });
                                                case 7:
                                                    return F3(function (attrs, overlay, edit) {
                                                        var onUpdatePreserveTime = function (editWithoutTime) {
                                                            var time = $elm$core$Maybe$withDefault_fn("00:00", $elm_community$string_extra$String$Extra$nonEmpty($elm_community$string_extra$String$Extra$rightOf_fn("T", $author$project$Types$Edit$toString(edit))));
                                                            return onUpdate($author$project$Types$Edit$mapString_fn(A2($author$project$Util$flip, $elm$core$String$append, "T" + time), editWithoutTime));
                                                        };
                                                        return $author$project$Types$InputElement$wrapWithDatePicker_fn(attrs, context, tableType, focusMsg, onUpdatePreserveTime, edit, $author$project$Types$InputElement$expandingInput_fn({
                                                            cP: _List_Nil,
                                                            bx: context,
                                                            nL: onBlur,
                                                            nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            hH: $elm$core$Maybe$Just(onCancel),
                                                            cv: $elm$core$Maybe$Just(onUpdate),
                                                            nV: onMouseEnter,
                                                            nW: onMouseLeave,
                                                            m: _List_Nil,
                                                            o8: tableType,
                                                            gh: $elm$core$Maybe$Just("text")
                                                        }, attrs, overlay, edit));
                                                    });
                                                case 8:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("text")
                                                    });
                                                case 9:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("text")
                                                    });
                                                case 10:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("url")
                                                    });
                                                case 11:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("email")
                                                    });
                                                case 12:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("tel")
                                                    });
                                                case 13:
                                                    return F3(function (attrs, overlay, edit) {
                                                        return $author$project$Types$InputElement$wrapWithColorPicker_fn(attrs, context, tableType, focusMsg, onUpdate, edit, $author$project$Types$InputElement$expandingInput_fn({
                                                            cP: _List_Nil,
                                                            bx: context,
                                                            nL: onBlur,
                                                            nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                            hH: $elm$core$Maybe$Just(onCancel),
                                                            cv: $elm$core$Maybe$Just(onUpdate),
                                                            nV: onMouseEnter,
                                                            nW: onMouseLeave,
                                                            m: _List_Nil,
                                                            o8: tableType,
                                                            gh: $elm$core$Maybe$Just("text")
                                                        }, attrs, overlay, edit));
                                                    });
                                                case 14:
                                                    return expandingInputMultiline(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]));
                                                case 15:
                                                    return expandingInputMultiline(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]));
                                                case 16:
                                                    return expandingInputMultiline(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]));
                                                case 17:
                                                    return expandingInputMultiline(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]));
                                                case 18:
                                                    return $author$project$Types$InputElement$expandingInput({
                                                        cP: _List_Nil,
                                                        bx: context,
                                                        nL: onBlur,
                                                        nM: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kf: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        kj: $elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)),
                                                        hH: $elm$core$Maybe$Just(onCancel),
                                                        cv: $elm$core$Maybe$Just(onUpdate),
                                                        nV: onMouseEnter,
                                                        nW: onMouseLeave,
                                                        m: _List_Nil,
                                                        o8: tableType,
                                                        gh: $elm$core$Maybe$Just("text")
                                                    });
                                                case 19:
                                                    return F3(function (attrs, overlay, edit) {
                                                        return $author$project$Types$InputElement$singleSelectInput(context)(tableType)($supermario$elm_countries$Countries$all)(function (country) {
                                                            return country.lS + (" " + country.fn);
                                                        })($elm_community$string_extra$String$Extra$leftOf(" "))(A2($elm$core$Basics$composeL, onApply, $elm$core$Maybe$Just))(onCancel)($elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)))(_List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right])), attrs))(overlay)(edit);
                                                    });
                                                case 20:
                                                    return F3(function (attrs, overlay, edit) {
                                                        var countryCodeToFlag = A2($elm$core$Basics$composeR, $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2, A2($elm$core$Basics$composeR, $elm$core$String$toUpper, A2($elm$core$Basics$composeR, $supermario$elm_countries$Countries$fromCode, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, "", function ($) {
                                                            return $.fn;
                                                        }))));
                                                        return $author$project$Types$InputElement$singleSelectInput(context)(tableType)($rl_king$elm_iso3166_country_codes$Iso3166$all)(function (countryCode) {
                                                            return $elm$core$String$toUpper($rl_king$elm_iso3166_country_codes$Iso3166$toAlpha3(countryCode)) + (" " + countryCodeToFlag(countryCode));
                                                        })($elm_community$string_extra$String$Extra$leftOf(" "))(A2($elm$core$Basics$composeL, onApply, $elm$core$Maybe$Just))(onCancel)($elm$core$Maybe$Just(onApply($elm$core$Maybe$Nothing)))(_List_Cons($rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right])), attrs))(overlay)(edit);
                                                    });
                                                default:
                                                    return A3($author$project$Types$InputElement$fileInput, context, onUpload, onCancel);
                                            }
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $rtfeldman$elm_css$Css$Global$withClass = function (str) {
        return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector($rtfeldman$elm_css$Css$Structure$ClassSelector(str));
    };
    var $author$project$EditGrid$editingCell_fn = function (toMsg, isReadonly, column, overlay, disabled_, edit) {
        var tableType = isReadonly ? 1 : 0;
        var regularCellSelector = "div > #cell-" + $elm$core$Basics$composeR_fn($author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1, edit.eo);
        var maybeErrorIcon = $elm$core$Maybe$map_fn(A2($author$project$EditGrid$errorIcon, toMsg, overlay), edit.fl);
        var insertStyles = edit.jJ ? _List_fromArray([
            A2($rtfeldman$elm_css$Css$Global$withClass, "not-allowed", _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_not_allowed,
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$button_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden]))
                ]))
            ]))
        ]) : _List_Nil;
        var inputErrorColor = (isReadonly || $author$project$Types$Column$isValidEdit_fn(column, edit)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300));
        var gridOffset = 1;
        var gridRow = ($author$project$Types$Edit$idxRowFromPos(edit.eo) + $author$project$EditGrid$headerOffset) + gridOffset;
        var gridCol = ($author$project$Types$Edit$idxColFromPos(edit.eo) + $author$project$EditGrid$indexOffset) + gridOffset;
        var errorColor = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($elm$core$Maybe$Nothing, $elm$core$Basics$always($elm$core$Maybe$Just($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500))), edit.fl);
        var bgColor = $elm_community$maybe_extra$Maybe$Extra$orElse_fn(edit.jJ ? $elm$core$Maybe$Just($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)) : $elm$core$Maybe$Nothing, $elm_community$maybe_extra$Maybe$Extra$orElse_fn(errorColor, inputErrorColor));
        var attributes = $author$project$Util$flip_fn($elm$core$List$cons, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, disabled_)
        ]), $rtfeldman$elm_css$Html$Styled$Attributes$css($elm$core$List$map_fn($rtfeldman$elm_css$Css$important, $elm$core$List$append_fn(insertStyles, $elm_community$maybe_extra$Maybe$Extra$toList(bgColor)))));
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$property_fn("grid-row", $elm$core$String$fromInt(gridRow)),
                $rtfeldman$elm_css$Css$property_fn("grid-column", $elm$core$String$fromInt(gridCol)),
                $rtfeldman$elm_css$Css$property_fn("overflow-anchor", "none"),
                $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$generalSiblings_a0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Global$selector_fn(regularCellSelector, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden]))
                ]))
            ]))
        ]), _List_fromArray([
            $author$project$Types$InputElement$view(0)(A2($elm$core$Basics$composeL, toMsg, $author$project$EditGrid$FocusEdit))(A2($elm$core$Basics$composeL, toMsg, $author$project$EditGrid$CellEditUpdated))(A2($elm$core$Basics$composeL, toMsg, $author$project$EditGrid$CellEditApplied))(toMsg($author$project$EditGrid$CellEditCanceled))(A2($elm$core$Basics$composeL, toMsg, $author$project$EditGrid$CellFileUploaded))($elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, toMsg, $author$project$EditGrid$CellHovered), $elm$core$Maybe$Just)))($elm$core$Maybe$Just(toMsg($author$project$EditGrid$CellHovered($elm$core$Maybe$Nothing))))(tableType)(column.mN)(attributes)(maybeErrorIcon)(edit)
        ]));
    }, $author$project$EditGrid$editingCell = F6($author$project$EditGrid$editingCell_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_px = $rtfeldman$elm_css$Css$property_fn("gap", "1px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_flow_col = $rtfeldman$elm_css$Css$property_fn("grid-auto-flow", "column");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_0 = $rtfeldman$elm_css$Css$property_fn("height", "0px");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_20 = $rtfeldman$elm_css$Css$property_fn("z-index", "20");
    var $author$project$EditGrid$headerStyles = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_10,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$sticky,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0,
        $author$project$Theme$theme.dT.hk,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_20,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b_2,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
        $author$project$Types$InputElement$maxWidth,
        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none
    ]));
    var $author$project$EditGrid$RowDragEnded = function (a) {
        return { $: 36, a: a };
    };
    var $author$project$EditGrid$RowDragStarted = function (a) {
        return { $: 35, a: a };
    };
    var $author$project$EditGrid$RowSelected_fn = function (a, b) {
        return { $: 10, a: a, b: b };
    }, $author$project$EditGrid$RowSelected = F2($author$project$EditGrid$RowSelected_fn);
    var $author$project$EditGrid$RowsSelected_fn = function (a, b, c) {
        return { $: 11, a: a, b: b, c: c };
    }, $author$project$EditGrid$RowsSelected = F3($author$project$EditGrid$RowsSelected_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_r_2 = $rtfeldman$elm_css$Css$property_fn("border-right-width", "2px");
    var $rtfeldman$elm_css$Svg$Styled$Attributes$points_a0 = "points", $rtfeldman$elm_css$Svg$Styled$Attributes$points = $rtfeldman$elm_css$VirtualDom$Styled$attribute($rtfeldman$elm_css$Svg$Styled$Attributes$points_a0);
    var $rtfeldman$elm_css$Svg$Styled$polygon = $rtfeldman$elm_css$Svg$Styled$node("polygon");
    var $author$project$Svg$expand = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$polygon, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$points_a0, "\n                21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71\n                17.71,7.71\n                ")
            ]), _List_Nil)
        ]));
    };
    var $elm_community$list_extra$List$Extra$initialize_fn = function (n, f) {
        var step = F2(function (i, acc) {
            step: while (true) {
                if (i < 0) {
                    return acc;
                }
                else {
                    var $temp$i = i - 1, $temp$acc = _List_Cons(f(i), acc);
                    i = $temp$i;
                    acc = $temp$acc;
                    continue step;
                }
            }
        });
        return A2(step, n - 1, _List_Nil);
    }, $elm_community$list_extra$List$Extra$initialize = F2($elm_community$list_extra$List$Extra$initialize_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_y_0 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("top", "0px"),
        $rtfeldman$elm_css$Css$property_fn("bottom", "0px")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_left_0_dot_5 = $rtfeldman$elm_css$Css$property_fn("left", "-0.125rem");
    var $author$project$EditGrid$onMouseEnterSetCellHovered = function (toMsg) {
        return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Html$Styled$Events$onMouseEnter, toMsg), $author$project$EditGrid$CellHovered), $elm$core$Maybe$Just);
    };
    var $author$project$EditGrid$onMouseLeaveClearCellHovered = function (toMsg) {
        return $rtfeldman$elm_css$Html$Styled$Events$onMouseLeave(toMsg($author$project$EditGrid$CellHovered($elm$core$Maybe$Nothing)));
    };
    var $author$project$EditGrid$indexCells_fn = function (numRows, subModel, cellHovered, rowDragging, moveRows, showRowNumber) {
        var toIndexCell = function (idxRow) {
            var selected = $elm$core$List$member_fn(idxRow, subModel.di);
            var rowHovered = _Utils_eq($elm$core$Maybe$map_fn($author$project$Types$Edit$idxRowFromPos, cellHovered), $elm$core$Maybe$Just(idxRow));
            var hasSelectedRows = function (_v3) {
                return !_Utils_eq(subModel.di, _List_Nil);
            };
            var focusViewButton = function (styles) {
                return $author$project$Svg$expand(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $rtfeldman$elm_css$Css$batch(styles)
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "focus-view-icon"),
                    $rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$EditGrid$FocusModeStarted_fn(idxRow, $elm$core$Maybe$Nothing))
                ]));
            };
            var dragRowButton = function (_v2) {
                return $author$project$Svg$drag(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_y_0,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_left_0_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Events$onMouseDown($author$project$EditGrid$RowDragStarted(idxRow))
                ]));
            };
            var checkBox = function (_v1) {
                var onCheck = $rtfeldman$elm_css$Html$Styled$Events$on_fn("click", _Json_map2_fn(F2(function (checked, shiftKey) {
                    var _v0 = _Utils_Tuple2(shiftKey, subModel.ix);
                    if (_v0.a && (!_v0.b.$)) {
                        var activeRow = _v0.b.a;
                        return $author$project$EditGrid$RowsSelected_fn(activeRow, idxRow, checked);
                    }
                    else {
                        return $author$project$EditGrid$RowSelected_fn(idxRow, checked);
                    }
                }), $rtfeldman$elm_css$Html$Styled$Events$targetChecked, _Json_decodeField_fn("shiftKey", $elm$json$Json$Decode$bool)));
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, selected),
                    onCheck,
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5]))
                ]), _List_Nil);
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                A2($author$project$EditGrid$onMouseEnterSetCellHovered, $elm$core$Basics$identity, _Utils_Tuple2(idxRow, -1)),
                $author$project$EditGrid$onMouseLeaveClearCellHovered($elm$core$Basics$identity),
                $rtfeldman$elm_css$Html$Styled$Events$onMouseUp($author$project$EditGrid$RowDragEnded(idxRow)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $author$project$Util$stylesIf_fn(subModel.f3, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$sticky, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_20])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$select_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_r_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $author$project$Theme$theme.dT.hk,
                    $rtfeldman$elm_css$Css$hover(rowDragging ? _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move
                    ]) : _List_Nil)
                ]))
            ]), subModel.bc ? _List_fromArray([
                $author$project$Util$collapseElement_fn(!rowHovered, focusViewButton(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mr_auto]))),
                $rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromInt(idxRow + 1))
            ]) : ((showRowNumber || ((!selected) && (!rowHovered))) ? _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text($elm$core$String$fromInt(idxRow + 1))
            ]) : _List_fromArray([
                (hasSelectedRows(0) || (!moveRows)) ? $rtfeldman$elm_css$Html$Styled$text("") : dragRowButton(0),
                (hasSelectedRows(0) || rowDragging) ? $rtfeldman$elm_css$Html$Styled$text("") : focusViewButton(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1])),
                rowDragging ? $rtfeldman$elm_css$Html$Styled$text("") : checkBox(0)
            ])));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), $elm_community$list_extra$List$Extra$initialize_fn(numRows, toIndexCell));
    }, $author$project$EditGrid$indexCells = F6($author$project$EditGrid$indexCells_fn);
    var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6_fn = function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A6(fn, arg1, arg2, arg3, arg4, arg5, arg6));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6_fn_unwrapped = function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2, arg3, arg4, arg5, arg6));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6 = F7($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy6_fn = function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy7_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6, fn, arg1, arg2, arg3, arg4, arg5, arg6));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy6 = F7($rtfeldman$elm_css$VirtualDom$Styled$lazy6_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy6 = $rtfeldman$elm_css$VirtualDom$Styled$lazy6;
    var $elm$virtual_dom$VirtualDom$lazy8 = _VirtualDom_lazy8;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp7_fn = function (fn, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A7(fn, arg1, arg2, arg3, arg4, arg5, arg6, arg7));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp7_fn_unwrapped = function (fn, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2, arg3, arg4, arg5, arg6, arg7));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp7 = F8($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp7_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy7_fn = function (fn, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy8_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp7, fn, arg1, arg2, arg3, arg4, arg5, arg6, arg7));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy7 = F8($rtfeldman$elm_css$VirtualDom$Styled$lazy7_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy7 = $rtfeldman$elm_css$VirtualDom$Styled$lazy7;
    var $rtfeldman$elm_css$VirtualDom$Styled$keyedNode = $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode;
    var $rtfeldman$elm_css$Html$Styled$Keyed$node = $rtfeldman$elm_css$VirtualDom$Styled$keyedNode;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_b = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-bottom-right-radius", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("border-bottom-left-radius", "0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_span_full = $rtfeldman$elm_css$Css$property_fn("grid-row", "1 / -1");
    var $author$project$EditGrid$CellEditStarted_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$EditGrid$CellEditStarted = F2($author$project$EditGrid$CellEditStarted_fn);
    var $author$project$EditGrid$CellMenuOpened_fn = function (a, b, c, d, e, f) {
        return { $: 6, a: a, b: b, c: c, d: d, e: e, f: f };
    }, $author$project$EditGrid$CellMenuOpened = F6($author$project$EditGrid$CellMenuOpened_fn);
    var $author$project$Types$Edit$empty_a0 = $author$project$Types$Edit$fromString, $author$project$Types$Edit$empty_a1 = "", $author$project$Types$Edit$empty = A2($author$project$Util$flip, $author$project$Types$Edit$empty_a0, $author$project$Types$Edit$empty_a1);
    var $author$project$Types$InputElement$isFocusable = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return true;
            case 1:
                return true;
            case 2:
                return true;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return true;
            case 6:
                return true;
            case 7:
                return true;
            case 8:
                return true;
            case 9:
                return true;
            case 10:
                return true;
            case 11:
                return true;
            case 12:
                return true;
            case 13:
                return true;
            case 14:
                return true;
            case 15:
                return true;
            case 16:
                return true;
            case 17:
                return true;
            case 18:
                return true;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Types$InputElement$isMultiline = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return true;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return false;
            case 14:
                return true;
            case 15:
                return true;
            case 16:
                return true;
            case 17:
                return true;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Types$InputElement$isNumeric = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return true;
            case 1:
                return true;
            case 2:
                return false;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 8:
                return false;
            case 9:
                return false;
            case 10:
                return false;
            case 11:
                return false;
            case 12:
                return false;
            case 13:
                return false;
            case 14:
                return false;
            case 15:
                return false;
            case 16:
                return false;
            case 17:
                return false;
            case 18:
                return false;
            case 19:
                return false;
            case 20:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Svg$menuDots = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _Utils_ap(_List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$height_a0, "24px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 12 24"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$width_a0, "12px"),
            $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor")
        ]), attributes), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "M6 0h12v24H0z"),
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "none")
            ]), _List_Nil),
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M6 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z\n                m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_0 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "0px"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "0px")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_auto = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "auto"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "auto")
    ]));
    var $author$project$EditGrid$nullCell_fn = function (inputElement, _v0) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$italic,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default,
                $author$project$Types$InputElement$isMultiline(inputElement) ? $rtfeldman$elm_css$Css$batch(_List_Nil) : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_auto
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$text("null")
        ]));
    }, $author$project$EditGrid$nullCell = F2($author$project$EditGrid$nullCell_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_12 = $rtfeldman$elm_css$Css$property_fn("padding-right", "3rem");
    var $author$project$Svg$code = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z\n                m5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
        return _String_startsWith_fn("#", str) ? str : _String_cons_fn("#", str);
    };
    var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
        return {
            dF: 1,
            dQ: 0,
            bw: 0,
            d8: 0,
            er: 0,
            pB: $rtfeldman$elm_css$Css$withPrecedingHash(str)
        };
    };
    var $rtfeldman$elm_css$Css$validHex_fn = function (str, _v0, _v1, _v2, _v3) {
        var r1 = _v0.a;
        var r2 = _v0.b;
        var g1 = _v1.a;
        var g2 = _v1.b;
        var b1 = _v2.a;
        var b2 = _v2.b;
        var a1 = _v3.a;
        var a2 = _v3.b;
        var toResult = A2($elm$core$Basics$composeR, $elm$core$String$fromList, A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
        var results = _Utils_Tuple2(_Utils_Tuple2(toResult(_List_fromArray([r1, r2])), toResult(_List_fromArray([g1, g2]))), _Utils_Tuple2(toResult(_List_fromArray([b1, b2])), toResult(_List_fromArray([a1, a2]))));
        if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
            var _v5 = results.a;
            var red = _v5.a.a;
            var green = _v5.b.a;
            var _v6 = results.b;
            var blue = _v6.a.a;
            var alpha = _v6.b.a;
            return {
                dF: alpha / 255,
                dQ: blue,
                bw: 0,
                d8: green,
                er: red,
                pB: $rtfeldman$elm_css$Css$withPrecedingHash(str)
            };
        }
        else {
            return $rtfeldman$elm_css$Css$erroneousHex(str);
        }
    }, $rtfeldman$elm_css$Css$validHex = F5($rtfeldman$elm_css$Css$validHex_fn);
    var $rtfeldman$elm_css$Css$hex = function (str) {
        var withoutHash = _String_startsWith_fn("#", str) ? $elm$core$String$dropLeft_fn(1, str) : str;
        var _v0 = $elm$core$String$toList(withoutHash);
        _v0$4: while (true) {
            if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
                if (!_v0.b.b.b.b) {
                    var r = _v0.a;
                    var _v1 = _v0.b;
                    var g = _v1.a;
                    var _v2 = _v1.b;
                    var b = _v2.a;
                    return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r, r), _Utils_Tuple2(g, g), _Utils_Tuple2(b, b), _Utils_Tuple2("f", "f"));
                }
                else {
                    if (!_v0.b.b.b.b.b) {
                        var r = _v0.a;
                        var _v3 = _v0.b;
                        var g = _v3.a;
                        var _v4 = _v3.b;
                        var b = _v4.a;
                        var _v5 = _v4.b;
                        var a = _v5.a;
                        return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r, r), _Utils_Tuple2(g, g), _Utils_Tuple2(b, b), _Utils_Tuple2(a, a));
                    }
                    else {
                        if (_v0.b.b.b.b.b.b) {
                            if (!_v0.b.b.b.b.b.b.b) {
                                var r1 = _v0.a;
                                var _v6 = _v0.b;
                                var r2 = _v6.a;
                                var _v7 = _v6.b;
                                var g1 = _v7.a;
                                var _v8 = _v7.b;
                                var g2 = _v8.a;
                                var _v9 = _v8.b;
                                var b1 = _v9.a;
                                var _v10 = _v9.b;
                                var b2 = _v10.a;
                                return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r1, r2), _Utils_Tuple2(g1, g2), _Utils_Tuple2(b1, b2), _Utils_Tuple2("f", "f"));
                            }
                            else {
                                if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
                                    var r1 = _v0.a;
                                    var _v11 = _v0.b;
                                    var r2 = _v11.a;
                                    var _v12 = _v11.b;
                                    var g1 = _v12.a;
                                    var _v13 = _v12.b;
                                    var g2 = _v13.a;
                                    var _v14 = _v13.b;
                                    var b1 = _v14.a;
                                    var _v15 = _v14.b;
                                    var b2 = _v15.a;
                                    var _v16 = _v15.b;
                                    var a1 = _v16.a;
                                    var _v17 = _v16.b;
                                    var a2 = _v17.a;
                                    return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r1, r2), _Utils_Tuple2(g1, g2), _Utils_Tuple2(b1, b2), _Utils_Tuple2(a1, a2));
                                }
                                else {
                                    break _v0$4;
                                }
                            }
                        }
                        else {
                            break _v0$4;
                        }
                    }
                }
            }
            else {
                break _v0$4;
            }
        }
        return $rtfeldman$elm_css$Css$erroneousHex(str);
    };
    var $author$project$Svg$json = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7z\n                m17 3c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z\"\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_12 = $rtfeldman$elm_css$Css$property_fn("right", "-3rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_2 = $rtfeldman$elm_css$Css$property_fn("right", "-0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_1_dot_5 = $rtfeldman$elm_css$Css$property_fn("top", "-0.375rem");
    var $elm$html$Html$Attributes$target_a0 = "target", $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$target_a0);
    var $author$project$Types$InputElement$preview_fn = function (tableType, onFocusMode, onLeaveTooltip, onEnterTooltip, inputElement) {
        var wrapWithTooltip = F3(function (icon, value, tooltip) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                            $rtfeldman$elm_css$Css$Global$typeSelector_fn($rtfeldman$elm_css$Css$Global$svg_a0, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                        ]))
                    ]))
                ]))
            ]), _List_fromArray([
                icon(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_1_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
                    ])),
                    $elm_community$maybe_extra$Maybe$Extra$unpack_fn($author$project$Types$InputElement$maybeAttr_a0, onEnterTooltip, tooltip),
                    onLeaveTooltip,
                    $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn_fn("click", $elm$json$Json$Decode$succeed(_Utils_Tuple2(onFocusMode, true)))
                ])),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_0_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(value)
                ]))
            ]));
        });
        var formatUrls = function (markdownInput) {
            var linkTargetBlank = F2(function (linkData, children) {
                return $elm$html$Html$a_fn(_Utils_ap(_List_fromArray([
                    $elm$html$Html$Attributes$href(linkData.mb),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$target_a0, "_blank")
                ]), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function (title) {
                    return _List_fromArray([
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, title)
                    ]);
                }, linkData.eM)), children);
            });
            var deadEndsToString = function (deadEnds) {
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
            };
            var _v2 = $elm$core$Result$andThen_fn(function (ast) {
                return $dillonkearns$elm_markdown$Markdown$Renderer$render_fn(_Utils_update($dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, { jY: linkTargetBlank }), ast);
            }, $elm$core$Result$mapError_fn(deadEndsToString, $dillonkearns$elm_markdown$Markdown$Parser$parse(markdownInput)));
            if (!_v2.$) {
                var rendered = _v2.a;
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, $elm$core$List$map_fn($rtfeldman$elm_css$Html$Styled$fromUnstyled, rendered));
            }
            else {
                var errors = _v2.a;
                return $rtfeldman$elm_css$Html$Styled$text(errors);
            }
        };
        var countryView = F2(function (value, flag) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$text(value),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text($elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $elm$core$String$append(" "), flag))
                ]))
            ]));
        });
        switch (inputElement.$) {
            case 0:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 1:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 2:
                return (tableType === 1) ? formatUrls : $rtfeldman$elm_css$Html$Styled$text;
            case 3:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 4:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 5:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 6:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 7:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 8:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 9:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 10:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 11:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 12:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 13:
                return function (value) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative]))
                    ]), _List_fromArray([
                        $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_12,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_4,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(value))
                            ]))
                        ]), _List_Nil),
                        $rtfeldman$elm_css$Html$Styled$text(value)
                    ]));
                };
            case 14:
                return A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_0_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_sm]))
                ]))));
            case 15:
                return function (value) {
                    var prettified = $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Encode$encode(2), $elm$core$List$singleton), $elm$core$Result$toMaybe(_Json_runOnString_fn($elm$json$Json$Decode$value, value)));
                    return A3(wrapWithTooltip, $author$project$Svg$json, value, prettified);
                };
            case 16:
                return function (value) {
                    var prettified = $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Encode$encode(2), $elm$core$List$singleton), $elm$core$Result$toMaybe(_Json_runOnString_fn($elm$json$Json$Decode$value, value)));
                    return A3(wrapWithTooltip, $author$project$Svg$json, value, prettified);
                };
            case 17:
                return function (value) {
                    return A3(wrapWithTooltip, $author$project$Svg$code, value, $elm$core$Maybe$Just(_List_fromArray([value])));
                };
            case 18:
                return $rtfeldman$elm_css$Html$Styled$text;
            case 19:
                return function (value) {
                    var flag = $elm$core$Maybe$map_fn(function ($) {
                        return $.fn;
                    }, $supermario$elm_countries$Countries$fromCode(value));
                    return A2(countryView, value, flag);
                };
            case 20:
                return function (value) {
                    var flag = $elm$core$Maybe$map_fn(function ($) {
                        return $.fn;
                    }, $elm$core$Maybe$andThen_fn($supermario$elm_countries$Countries$fromCode, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2, $elm$core$String$toUpper), $rl_king$elm_iso3166_country_codes$Iso3166$fromAlpha3($elm$core$String$toLower(value)))));
                    return A2(countryView, value, flag);
                };
            default:
                return function (_v1) {
                    return $rtfeldman$elm_css$Html$Styled$text("x");
                };
        }
    }, $author$project$Types$InputElement$preview = F5($author$project$Types$InputElement$preview_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2_dot_5 = $rtfeldman$elm_css$Css$property_fn("width", "0.625rem");
    var $author$project$EditGrid$regularCell_fn = function (column, cell, pos, subModel, toMsg, disabled_, overlay) {
        var tableType = subModel.bc ? 1 : 0;
        var onRightClickWithMousePos = function (msg) {
            return $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("contextmenu", _Json_map1_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, true), _Json_map1_fn(msg, _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("clientY", $elm$json$Json$Decode$float), _Json_map2_fn($elm_community$json_extra$Json$Decode$Extra$andMap_a0, _Json_decodeField_fn("clientX", $elm$json$Json$Decode$float), $elm$json$Json$Decode$succeed($elm$core$Tuple$pair))))));
        };
        var onClickMsg = function () {
            var isMarkdownUrl = A2($author$project$Types$Cell$unpack, $elm$core$Basics$always(false), $elm$regex$Regex$contains($elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("\\[([^\\]]+)\\]\\(([^)\"]+)(?: \\\"([^\\\"]+)\\\")?\\)"))));
            var cellIsNull = _Utils_eq($author$project$Types$Cell$isNull_a0, cell);
            return (subModel.bc && (cellIsNull || isMarkdownUrl(cell))) ? $elm$core$Basics$always($author$project$EditGrid$NoOp) : (disabled_ ? $elm$core$Basics$always($author$project$EditGrid$NoOp) : (column.cn ? $elm$core$Basics$always($author$project$EditGrid$NoOp) : ($author$project$Types$InputElement$isFocusable(column.mN) ? $author$project$EditGrid$CellEditStarted($author$project$Types$Cell$unpack_fn($elm$core$Basics$always($author$project$Util$flip_fn($author$project$Types$Edit$empty_a0, $author$project$Types$Edit$empty_a1, pos)), $author$project$Types$Edit$fromString(pos), cell)) : ((_Utils_eq(column.mN, $author$project$Types$InputElement$InputFile) && cellIsNull) ? $author$project$EditGrid$CellEditStarted($author$project$Util$flip_fn($author$project$Types$Edit$empty_a0, $author$project$Types$Edit$empty_a1, pos)) : $author$project$Types$Cell$unpack_fn($elm$core$Basics$always($elm$core$Basics$always($author$project$EditGrid$CellEditApplied($elm$core$Maybe$Just($author$project$Types$Edit$fromString_fn(pos, $author$project$Types$InputElement$defaultValue(column.mN)))))), $elm$core$Basics$always($elm$core$Basics$always($author$project$EditGrid$NoOp)), cell)))));
        }();
        var onClick = function (msg) {
            return _Json_map1_fn(A2($elm$core$Basics$composeL, toMsg, msg), subModel.hy ? _Json_decodeField_fn("shiftKey", $elm$json$Json$Decode$bool) : $elm$json$Json$Decode$succeed(false));
        };
        var menuButton = function () {
            var id_ = "cell-menu-button-" + $elm$core$Basics$composeR_fn($author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1, pos);
            return $author$project$Svg$menuDots(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                A2($author$project$Util$stopPropagationOn, "click", toMsg($author$project$EditGrid$CellMenuOpened_fn(id_, pos, tableType, cell, column, $elm$core$Maybe$Nothing))),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                ]))
            ]));
        }();
        var isSelected = $author$project$Util$flip_fn($elm$core$List$member, subModel.di, pos.a);
        var content = $author$project$Types$Cell$unpack_fn($author$project$EditGrid$nullCell(column.mN), function () {
            var toElement = $author$project$Types$InputElement$isFocusable(column.mN) ? $author$project$Types$InputElement$preview_fn(tableType, toMsg($author$project$EditGrid$FocusModeStarted_fn($author$project$Types$Edit$idxRowFromPos(pos), $elm$core$Maybe$Just($author$project$Types$Edit$idxColFromPos(pos)))), $author$project$Overlay$onMouseLeaveTooltipTrigger_fn(toMsg, overlay), A2($elm$core$Basics$composeL, A2($author$project$Overlay$onMouseEnterTooltipTrigger, toMsg, overlay), $author$project$Overlay$tooltipBottom(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_mono,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre_wrap
            ]))), column.mN) : A2($elm$core$Basics$composeR, $author$project$Types$Edit$fromString(pos), A5($author$project$EditGrid$editingCell, toMsg, subModel.bc, column, overlay, false));
            var styles = $author$project$Types$InputElement$isNumeric(column.mN) ? _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_right]) : ((_Utils_eq(column.mN, $author$project$Types$InputElement$InputDate) || _Utils_eq(column.mN, $author$project$Types$InputElement$InputDateTime)) ? _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_4]) : (_Utils_eq(column.mN, $author$project$Types$InputElement$InputColor) ? _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_12]) : ($author$project$Types$InputElement$isMultiline(column.mN) ? _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_0]) : _List_Nil)));
            return A2($elm$core$Basics$composeR, toElement, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$my_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]))));
        }(), cell);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_2,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pl_2_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_pre,
                $author$project$Types$InputElement$maxWidth,
                $author$project$Types$InputElement$maxHeight,
                $author$project$Theme$theme.dT.lN(isSelected),
                $rtfeldman$elm_css$Css$hover(_List_fromArray([
                    $author$project$Theme$theme.dT.lO(isSelected),
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$typeSelector_fn("svg", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                    ]))
                ])),
                $rtfeldman$elm_css$Css$batch(disabled_ ? _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden
                ]) : _List_Nil)
            ])),
            onRightClickWithMousePos(A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, A5($author$project$EditGrid$CellMenuOpened, "", pos, tableType, cell, column), toMsg))),
            A2($author$project$EditGrid$onMouseEnterSetCellHovered, toMsg, pos),
            $author$project$EditGrid$onMouseLeaveClearCellHovered(toMsg),
            $rtfeldman$elm_css$Html$Styled$Events$on_fn("click", onClick(onClickMsg)),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "cell-" + $elm$core$Basics$composeR_fn($author$project$Types$Edit$idFromPos_a0, $author$project$Types$Edit$idFromPos_a1, pos))
        ]), _List_fromArray([menuButton, content]));
    }, $author$project$EditGrid$regularCell = F7($author$project$EditGrid$regularCell_fn);
    var $author$project$EditGrid$toCell_fn = function (subModel, column, idxCol, overlay, disabled_, idxRow, cell) {
        var pos = _Utils_Tuple2(idxRow, idxCol);
        return $author$project$EditGrid$regularCell_fn(column, cell, pos, subModel, $elm$core$Basics$identity, disabled_, overlay);
    }, $author$project$EditGrid$toCell = F7($author$project$EditGrid$toCell_fn);
    var $author$project$EditGrid$ColDragCanceled = { $: 38 };
    var $author$project$EditGrid$ColDragEnded = function (a) {
        return { $: 39, a: a };
    };
    var $author$project$EditGrid$ColDragStarted = function (a) {
        return { $: 37, a: a };
    };
    var $author$project$EditGrid$ColMenuOpened_fn = function (a, b, c, d, e) {
        return { $: 7, a: a, b: b, c: c, d: d, e: e };
    }, $author$project$EditGrid$ColMenuOpened = F5($author$project$EditGrid$ColMenuOpened_fn);
    var $author$project$EditGrid$ColNameEditApplied = { $: 22 };
    var $author$project$EditGrid$ColNameEditCancelled = { $: 23 };
    var $author$project$EditGrid$ColNameEditUpdated = function (a) {
        return { $: 21, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_full = $rtfeldman$elm_css$Css$property_fn("bottom", "100%");
    var $author$project$Svg$sigma = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$blobFile = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6z\n                M6 20V4h7v5h5v11H6z\n                ")
            ]), _List_Nil),
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n                m0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$boolean = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\n                m0 16H5V5h14v14z\n                M17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$calenderSelected = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\n                m0 16H5V9h14v10z\n                m0-12H5V5h14v2z\n                M7 11h5v5H7z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$clock = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z\n                M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\n                m.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$customType = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z\n                m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z\n                m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$dataArray = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M15 4v2h3v12h-3v2h5V4z\n                M4 20h5v-2H6V6h3V4H4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$dataObject = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7z\n                m17 3c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$email = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10z\n                m0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$float = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M7.5 4C5.57 4 4 5.57 4 7.5S5.57 11 7.5 11 11 9.43 11 7.5 9.43 4 7.5 4z\n                m0 5C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9z\n                m9 4c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z\n                m0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z\n                M5.41 20 4 18.59 18.59 4 20 5.41 5.41 20z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$int = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                m20.5 10 .5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4z\n                m-7 4h-4l1-4h4l-1 4z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$link = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z\n                m-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2z\n                m-3-4h8v2H8z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$palette = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67 0 1.38-1.12 2.5-2.5 2.5z\n                m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$phone = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51\n                m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19\n                M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$place = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\n                m6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14z\n                M12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$string = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M21 11.01 3 11v2h18z\n                M3 16h12v2H3z\n                M21 6H3v2.01L21 8z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$timelapse = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M16.24 7.75c-1.17-1.17-2.7-1.76-4.24-1.76v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48z\n                M12 1.99c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10z\n                m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Types$InputElement$toIcon = function (inputElement) {
        switch (inputElement.$) {
            case 0:
                return $author$project$Svg$int;
            case 1:
                return $author$project$Svg$float;
            case 2:
                return $author$project$Svg$string;
            case 3:
                return $author$project$Svg$boolean;
            case 4:
                return $author$project$Svg$customType;
            case 5:
                return $author$project$Svg$calender;
            case 6:
                return $author$project$Svg$clock;
            case 7:
                return $author$project$Svg$calenderSelected;
            case 8:
                return $author$project$Svg$timelapse;
            case 9:
                return $author$project$Svg$timelapse;
            case 10:
                return $author$project$Svg$link;
            case 11:
                return $author$project$Svg$email;
            case 12:
                return $author$project$Svg$phone;
            case 13:
                return $author$project$Svg$palette;
            case 14:
                return $author$project$Svg$dataObject;
            case 15:
                return $author$project$Svg$dataObject;
            case 16:
                return $author$project$Svg$dataArray;
            case 17:
                return $author$project$Svg$code;
            case 18:
                return $author$project$Svg$place;
            case 19:
                return $author$project$Svg$globe;
            case 20:
                return $author$project$Svg$globe;
            default:
                return $author$project$Svg$blobFile;
        }
    };
    var $author$project$EditGrid$dataTypeIcon_fn = function (toMsg, overlay, column) {
        var tooltipLines = function () {
            var unique = column.hf ? $elm$core$Maybe$Just("Unique") : $elm$core$Maybe$Nothing;
            var primary = column.co ? $elm$core$Maybe$Just("Primary") : $elm$core$Maybe$Nothing;
            return $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$values_a0, $elm_community$maybe_extra$Maybe$Extra$values_a1, _List_fromArray([
                $elm$core$Maybe$Just($author$project$Types$SqliteDataType$toString(column.l0)),
                $author$project$Types$DataType$nullabilityToNotNullString($author$project$Types$DataType$toNullability(column.l$)),
                primary,
                unique
            ]));
        }();
        var isGeneratedIcon = column.cn ? $author$project$Svg$sigma(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
            ])),
            $author$project$Overlay$onMouseLeaveTooltipTrigger_fn(toMsg, overlay),
            $author$project$Overlay$onMouseEnterTooltipTrigger_fn(toMsg, overlay, A2($author$project$Overlay$tooltipBottom, _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
            ]), _List_fromArray(["Generated"])))
        ])) : $rtfeldman$elm_css$Html$Styled$text("");
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_px]))
        ]), _List_fromArray([
            isGeneratedIcon,
            A2($author$project$Types$InputElement$toIcon, column.mN, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                ])),
                $author$project$Overlay$onMouseLeaveTooltipTrigger_fn(toMsg, overlay),
                $author$project$Overlay$onMouseEnterTooltipTrigger_fn(toMsg, overlay, A2($author$project$Overlay$tooltipBottom, _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$white)
                ]), tooltipLines))
            ]))
        ]));
    }, $author$project$EditGrid$dataTypeIcon = F3($author$project$EditGrid$dataTypeIcon_fn);
    var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
    var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3_fn = function (fn, arg1, arg2, arg3) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(A3(fn, arg1, arg2, arg3));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3_fn_unwrapped = function (fn, arg1, arg2, arg3) {
        return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(fn(arg1, arg2, arg3));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3 = F4($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$lazy3_fn = function (fn, arg1, arg2, arg3) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(_VirtualDom_lazy4_fn($rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3, fn, arg1, arg2, arg3));
    }, $rtfeldman$elm_css$VirtualDom$Styled$lazy3 = F4($rtfeldman$elm_css$VirtualDom$Styled$lazy3_fn);
    var $rtfeldman$elm_css$Html$Styled$Lazy$lazy3 = $rtfeldman$elm_css$VirtualDom$Styled$lazy3;
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_2 = $rtfeldman$elm_css$Css$property_fn("margin-right", "-0.5rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mx_2_dot_5 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-left", "-0.625rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-right", "-0.625rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_my_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("margin-top", "-0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("margin-bottom", "-0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1 = $rtfeldman$elm_css$Css$property_fn("padding-right", "0.25rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_3 = $rtfeldman$elm_css$Css$property_fn("padding-top", "0.75rem");
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_8 = $rtfeldman$elm_css$Css$property_fn("width", "2rem");
    var $author$project$EditGrid$toHeader_fn = function (subModel, idxCol, column, colNameEdit, hasErrors_, overlay, noAdditions) {
        var underlineIfPrimary = column.co ? A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline]))
        ]))) : $elm$core$Basics$identity;
        var tableType = subModel.bc ? 1 : 0;
        var onMouseEnter = function (msg) {
            return $rtfeldman$elm_css$Html$Styled$Events$on_fn("mouseenter", _Json_andThen_fn(function (buttons) {
                var leftButtonDown = buttons === 1;
                return leftButtonDown ? $elm$json$Json$Decode$fail("") : $elm$json$Json$Decode$succeed(msg);
            }, _Json_decodeField_fn("buttons", $elm$json$Json$Decode$int)));
        };
        var nameOrInput = function (styles) {
            var input_ = function (inputStyles) {
                return $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(inputStyles)
                ]))), $elm$core$Maybe$map_fn(A3($author$project$Types$InputElement$expandingInput, {
                    cP: _List_Nil,
                    bx: 0,
                    nL: $elm$core$Maybe$Just($author$project$EditGrid$ColNameEditApplied),
                    nM: $elm$core$Maybe$Nothing,
                    kf: $elm$core$Maybe$Nothing,
                    kj: $elm$core$Maybe$Just($author$project$EditGrid$ColNameEditApplied),
                    hH: $elm$core$Maybe$Just($author$project$EditGrid$ColNameEditCancelled),
                    cv: $elm$core$Maybe$Just($author$project$EditGrid$ColNameEditUpdated),
                    nV: $elm$core$Maybe$Nothing,
                    nW: $elm$core$Maybe$Nothing,
                    m: _List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                        column.co ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$underline : $rtfeldman$elm_css$Css$batch(_List_Nil)
                    ]),
                    o8: tableType,
                    gh: $elm$core$Maybe$Just("text")
                }, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$spellcheck_a0, false),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$pattern_a0, $author$project$Config$dbObjectRegex)
                ]), $elm$core$Maybe$Nothing), $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, $elm$core$Basics$eq(idxCol)), colNameEdit)));
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_hidden,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1]))
                ]), _List_fromArray([
                    underlineIfPrimary($rtfeldman$elm_css$Html$Styled$text(column.jx))
                ])),
                $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), input_(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_my_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mx_2_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_2])))
            ]));
        };
        var dragHandle = function (styles) {
            return (subModel.bj || hasErrors_) ? $rtfeldman$elm_css$Html$Styled$text("") : $author$project$Svg$drag(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$inset_0,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move,
                    $rtfeldman$elm_css$Css$property_fn("rotate", "90deg"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "col-drag-handle"),
                $rtfeldman$elm_css$Html$Styled$Events$onMouseDown($author$project$EditGrid$ColDragStarted(idxCol))
            ]));
        };
        var colIsCollapsed = $elm$core$Set$member_fn(idxCol, subModel.cc);
        var columnMenuButton = function (styles) {
            var id_ = "column-menu-button-" + $elm$core$String$fromInt(idxCol);
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, hasErrors_),
                $rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$EditGrid$ColMenuOpened_fn(id_, tableType, column, idxCol, colIsCollapsed)),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $rtfeldman$elm_css$Css$hover(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                    ])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_50])),
                    $rtfeldman$elm_css$Css$batch(styles)
                ]))
            ]), _List_fromArray([
                $author$project$Svg$triangleDown(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3]))
                ]))
            ]));
        };
        var colDragging = !_Utils_eq(subModel.bK, $elm$core$Maybe$Nothing);
        var dragStyles = $rtfeldman$elm_css$Css$hover(function () {
            if (colDragging) {
                var dragIndicatorId = function () {
                    var colDraggingRight = function (_v0) {
                        return $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$gt(idxCol), subModel.bK));
                    };
                    var colDraggingLeft = $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$lt(idxCol), subModel.bK));
                    return colDraggingLeft ? $elm$core$Maybe$Just("drop-indicator-left") : (colDraggingRight(0) ? $elm$core$Maybe$Just("drop-indicator-right") : $elm$core$Maybe$Nothing);
                }();
                return _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_move,
                    $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Css$batch(_List_Nil), A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $rtfeldman$elm_css$Css$Global$id, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block])), A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Css$Global$children)), dragIndicatorId)
                ]);
            }
            else {
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Global$id_fn("col-drag-handle", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$block]))
                    ]))
                ]);
            }
        }());
        var dropIndicator = F2(function (id_, style) {
            return (!colDragging) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, id_),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_0_dot_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$hidden,
                    style
                ]))
            ]), _List_Nil);
        });
        var header = function (styles) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $author$project$EditGrid$headerStyles,
                    dragStyles,
                    $rtfeldman$elm_css$Css$batch(styles.it)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, $elm$core$Basics$composeR_fn($author$project$Types$Column$toHeaderIdFromIdx_a0, $author$project$Types$Column$toHeaderIdFromIdx_a1, idxCol)),
                onMouseEnter($author$project$EditGrid$ColDragCanceled),
                $rtfeldman$elm_css$Html$Styled$Events$onMouseUp($author$project$EditGrid$ColDragEnded(idxCol))
            ]), _List_fromArray([
                A2(dropIndicator, "drop-indicator-left", $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_left_px),
                dragHandle(styles.gN),
                $rtfeldman$elm_css$VirtualDom$Styled$lazy3_fn($author$project$EditGrid$dataTypeIcon, $elm$core$Basics$identity, overlay, column),
                nameOrInput(styles.M),
                columnMenuButton(styles.hs),
                A2(dropIndicator, "drop-indicator-right", $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_right_px)
            ]));
        };
        return (colIsCollapsed && noAdditions) ? header({
            gN: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bottom_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_1]),
            hs: _List_Nil,
            M: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_1,
                $rtfeldman$elm_css$Css$property_fn("writing-mode", "vertical-lr")
            ]),
            it: _List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_fit,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_8,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_3,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
            ])
        }) : header({
            gN: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_top_7]),
            hs: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_1_dot_5, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1]),
            M: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_0_dot_5]),
            it: _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pr_1])
        });
    }, $author$project$EditGrid$toHeader = F7($author$project$EditGrid$toHeader_fn);
    var $author$project$EditGrid$toColumn_fn = function (subModel, noAdditions, colNameEdit, overlay, disabled_, idxCol, column) {
        var header = _Utils_Tuple2("ch" + $elm$core$String$fromInt(idxCol), $author$project$EditGrid$toHeader_fn(subModel, idxCol, column, colNameEdit, disabled_, overlay, noAdditions));
        var cells = function (_v0) {
            return $elm$core$List$indexedMap_fn_unwrapped(function (idxRow, cell) {
                return _Utils_Tuple2("cc" + ($elm$core$String$fromInt(idxCol) + ("-" + $elm$core$String$fromInt(idxRow))), $author$project$EditGrid$toCell_fn(subModel, column, idxCol, overlay, disabled_, idxRow, cell));
            }, $elm$core$Basics$composeR_fn($author$project$Types$Column$getCells_a0, $author$project$Types$Column$getCells_a1, column));
        };
        return ($elm$core$Set$member_fn(idxCol, subModel.cc) && noAdditions) ? $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn("div", _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_span_full]))
        ]), _List_fromArray([header])) : $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn("div", _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$contents]))
        ]), _List_Cons(header, cells(0)));
    }, $author$project$EditGrid$toColumn = F7($author$project$EditGrid$toColumn_fn);
    var $author$project$EditGrid$RowsDeleted = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$EditGrid$SetSelectedRows = function (a) {
        return { $: 9, a: a };
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$space_x_1 = $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
        $rtfeldman$elm_css$Css$Global$selector_fn(":not([hidden]) ~ :not([hidden])", _List_fromArray([
            $rtfeldman$elm_css$Css$property_fn("--tw-space-x-reverse", "0"),
            $rtfeldman$elm_css$Css$property_fn("margin-right", "calc(0.25rem * var(--tw-space-x-reverse))"),
            $rtfeldman$elm_css$Css$property_fn("margin-left", "calc(0.25rem * calc(1 - var(--tw-space-x-reverse)))")
        ]))
    ]));
    var $author$project$EditGrid$topLeftSpacer_fn = function (toMsg, numRows, rowsSelected, hideCheckboxes, stickyIndexColumn) {
        var trashButton = F2(function (styles, msg) {
            return $author$project$Util$collapseElement_fn(_Utils_eq(rowsSelected, _List_Nil) || hideCheckboxes, $author$project$Components$toClickProtected_fn(toMsg($author$project$EditGrid$NoOp), msg, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "delete-rows-button"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
                ]))
            ]), _List_fromArray([
                $author$project$Svg$trash(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $rtfeldman$elm_css$Css$batch(styles)
                    ]))
                ]))
            ]))));
        });
        var hideIf = function (condition) {
            return condition ? $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$collapse])) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
        };
        var allRowsSelected = _Utils_eq($elm$core$List$length(rowsSelected), numRows);
        var toggleSelectAllRows = function (_v0) {
            return $author$project$EditGrid$SetSelectedRows(allRowsSelected ? _List_Nil : $elm$core$List$range_fn(0, numRows - 1));
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $author$project$Theme$theme.dT.hk,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_end,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tl,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_r_2,
                $author$project$EditGrid$headerStyles,
                $author$project$Util$stylesIf_fn(stickyIndexColumn, _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0,
                    $rtfeldman$elm_css$Css$property_fn("z-index", "21")
                ]))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$space_x_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
            ]), _List_fromArray([
                A2(trashButton, _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]), toMsg($author$project$EditGrid$RowsDeleted($elm$core$Maybe$Nothing))),
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$input_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "select-rows-checkbox"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$type__a0, "checkbox"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4])),
                    hideIf(hideCheckboxes),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$checked_a0, allRowsSelected),
                    $rtfeldman$elm_css$Html$Styled$Events$onCheck(A2($elm$core$Basics$composeL, toMsg, toggleSelectAllRows))
                ]), _List_Nil)
            ]))
        ]));
    }, $author$project$EditGrid$topLeftSpacer = F5($author$project$EditGrid$topLeftSpacer_fn);
    var $author$project$EditGrid$view_fn = function (tableType, columns, toMsg, model) {
        var plusButton = F3(function (attributes, styles, condition) {
            return (!condition) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _Utils_ap(_List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_lg,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                    $rtfeldman$elm_css$Css$disabled(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none])),
                    $rtfeldman$elm_css$Css$batch(styles)
                ])),
                $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, $author$project$EditGrid$hasErrors(model))
            ]), attributes), _List_fromArray([
                $author$project$Svg$plus(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                    ]))
                ]))
            ]));
        });
        var pairWithId = function (name) {
            return $elm$core$List$indexedMap(F2(function (idx, element) {
                return _Utils_Tuple2(_Utils_ap(name, $elm$core$String$fromInt(idx)), element);
            }));
        };
        var numRows = $author$project$EditGrid$rowCount_fn(columns, model);
        var noAdditions = _Utils_eq(model.K, _List_Nil);
        var indexColumn = function () {
            var topLeftSpacer_ = $rtfeldman$elm_css$VirtualDom$Styled$lazy5_fn($author$project$EditGrid$topLeftSpacer, toMsg, numRows, model.v.di, (!_Utils_eq(model.K, _List_Nil)) || ((!_Utils_eq(model.T, _List_Nil)) || (model.v.bc || ($author$project$EditGrid$hasErrors(model) || (!numRows)))), model.v.f3);
            var indexCells_ = $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $rtfeldman$elm_css$VirtualDom$Styled$lazy6_fn($author$project$EditGrid$indexCells, numRows, model.v, model.e3, !_Utils_eq(model.b3, $elm$core$Maybe$Nothing), model.fH, $author$project$EditGrid$hasErrors(model) || ((!_Utils_eq(model.K, _List_Nil)) || (!_Utils_eq(model.T, _List_Nil)))));
            return _List_fromArray([topLeftSpacer_, indexCells_]);
        }();
        var hideAddColumnButton = model.v.bj || model.v.bc;
        var editingCells = $elm$core$List$concat($elm$core$List$indexedMap_fn_unwrapped(function (idxCol, column) {
            return $elm$core$List$map_fn(A5($author$project$EditGrid$editingCell, toMsg, model.v.bc || column.cn, column, model.a$, false), $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toIdxCol, $elm$core$Basics$eq(idxCol)), $elm$core$List$concat(_List_Cons(model.T, model.K))));
        }, columns));
        var disabled_ = function () {
            var hasEditErrors_ = $author$project$EditGrid$hasEditErrors(model);
            var hasAdditionErrors_ = $author$project$EditGrid$hasAdditionErrors(model);
            var hasErrors_ = hasEditErrors_ || hasAdditionErrors_;
            return hasErrors_ || (!_Utils_eq(model.K, _List_Nil));
        }();
        var cellsLoaded = $elm$core$List$all_fn($author$project$Types$Column$isLoaded, columns);
        var addSpinner = function (condition) {
            return (!condition) ? $rtfeldman$elm_css$Html$Styled$text("") : $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_0]))
            ]), _List_fromArray([
                $author$project$Svg$spinner(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_5]))
                ]))
            ]));
        };
        var addRowButton = A3(plusButton, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$EditGrid$RowAdded)),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "add-row-button")
        ]), _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_b, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_t, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b]), $author$project$Types$TableType$isMutable(tableType) && ((noAdditions || model.fI) && cellsLoaded));
        var addColumnButton = function (condition) {
            return (!condition) ? $rtfeldman$elm_css$Html$Styled$text("") : A3(plusButton, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$EditGrid$headerStyles, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_tr, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_6])),
                $author$project$Overlay$onTriggerEvent_fn("click", toMsg, $author$project$Overlay$showBelow_fn($author$project$EditGrid$colEditOverlay_fn(numRows, _Utils_update(model, { a7: $author$project$Types$ColumnEdit$emptyCreation })), model.aC)),
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "add-column-button")
            ]), _List_Nil, model.eZ && cellsLoaded);
        };
        var addAdditions = F2(function (idx, column) {
            return function (asCells) {
                return $author$project$Types$Column$mapCells_fn(A2($author$project$Util$flip, $elm$core$List$append, asCells), column);
            }($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$Edit$toString, $author$project$Types$Cell$fromString($elm$core$Basics$composeR_fn($author$project$Types$Column$isNullable_a0, $author$project$Types$Column$isNullable_a1, column))), $elm$core$List$filterMap_fn($elm_community$list_extra$List$Extra$getAt(idx), model.K)));
        });
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "editgrid"),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_full,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode_fn("div", _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "editgrid-content"),
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_flow_col,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_px,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_auto,
                    $rtfeldman$elm_css$Css$batch(model.m),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$auto_cols_min,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-rows", "repeat(" + ($elm$core$String$fromInt(numRows + $author$project$EditGrid$headerOffset) + ", min-content)")),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_b,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200)
                ]))
            ]), _Utils_ap(A2(pairWithId, "ic", indexColumn), _Utils_ap(A2(pairWithId, "ec", editingCells), _Utils_ap($elm$core$List$indexedMap_fn_unwrapped(function (idxCol, column) {
                return _Utils_Tuple2("c" + $elm$core$String$fromInt(idxCol), $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $rtfeldman$elm_css$VirtualDom$Styled$lazy7_fn($author$project$EditGrid$toColumn, model.v, noAdditions, model.bL, model.a$, disabled_, idxCol, column)));
            }, (noAdditions ? $elm$core$Basics$identity : $elm$core$List$indexedMap(addAdditions))(columns)), _List_fromArray([
                _Utils_Tuple2("ac", addColumnButton(!hideAddColumnButton))
            ]))))),
            addRowButton,
            addSpinner(!cellsLoaded),
            $author$project$Overlay$view_fn(toMsg, model.a$),
            $author$project$Overlay$view_fn(toMsg, model.aC)
        ]));
    }, $author$project$EditGrid$view = F4($author$project$EditGrid$view_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_700 = $matheus23$elm_tailwind_modules_base$Tailwind$Color$Color_fn("rgb", "161", "98", "7", $matheus23$elm_tailwind_modules_base$Tailwind$Color$ViaVariable);
    var $author$project$Components$wrapWithWarningDiv_fn = function (styleOverwrites, body) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $rtfeldman$elm_css$Css$batch(_Utils_ap(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_300),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$font_bold,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$yellow_700),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4
                ]), styleOverwrites))
            ]))
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_x_scroll]))
            ]), body)
        ]));
    }, $author$project$Components$wrapWithWarningDiv = F2($author$project$Components$wrapWithWarningDiv_fn);
    var $author$project$GraphGrid$view = function (model) {
        var tableMessageBanner = function (_v1) {
            var _v0 = model.eF;
            if (_v0.$ === 1) {
                return $rtfeldman$elm_css$Html$Styled$text("");
            }
            else {
                var tableMessage = _v0.a;
                return $author$project$Components$wrapWithWarningDiv_fn(_List_fromArray([
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, $author$project$Layout$error_banner_h)),
                    $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$rem_a0, $rtfeldman$elm_css$Css$rem_a1, $author$project$Layout$error_banner_h))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text(tableMessage)
                ]));
            }
        };
        var editGrid = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0]))
        ]), _List_fromArray([
            $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), $elm$core$Basics$composeR_fn($author$project$GraphGrid$maybeUploadProgress_a0, $author$project$GraphGrid$maybeUploadProgress_a1, model.bp)),
            $author$project$EditGrid$view_fn(model.o8, model.iT, $author$project$GraphGrid$EditGridMsgReceived, model.s)
        ]));
        if (model.cs) {
            var loadingView = model.bT ? $author$project$GraphGrid$viewMessage_fn($elm$core$Maybe$Nothing, "Loading...") : $rtfeldman$elm_css$Html$Styled$text("");
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$min_h_0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
            ]), _List_fromArray([
                loadingView,
                editGrid,
                tableMessageBanner(0)
            ]));
        }
        else {
            return editGrid;
        }
    };
    var $author$project$GraphGrid$ClearRouteRowId = { $: 14 };
    var $author$project$FocusView$EditGridMsgReceived = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$FocusView$FieldEditCanceled = { $: 6 };
    var $author$project$FocusView$FieldEditStarted = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$FocusView$FieldEdited = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$FocusView$FieldFileUploaded = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$FocusView$FocusField = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$FocusView$MultiMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$EditGrid$RowExported = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$FocusView$ViewClosed = { $: 2 };
    var $author$project$Svg$download = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M5,20h14v-2H5V20z\n                M19,9h-4V3H9v6H5l7,7L19,9z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_1 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_2 = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("-moz-column-gap", "0.5rem"),
        $rtfeldman$elm_css$Css$property_fn("column-gap", "0.5rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_flow_row = $rtfeldman$elm_css$Css$property_fn("grid-auto-flow", "row");
    var $author$project$Types$Column$indexExists_fn = function (idxRow, column) {
        return (idxRow >= 0) && (_Utils_cmp(idxRow, $elm$core$List$length($elm$core$Basics$composeR_fn($author$project$Types$Column$getCells_a0, $author$project$Types$Column$getCells_a1, column)) - 1) < 1);
    }, $author$project$Types$Column$indexExists = F2($author$project$Types$Column$indexExists_fn);
    var $author$project$Svg$mail = function (attributes) {
        return A2($rtfeldman$elm_css$Svg$Styled$svg, _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "0 0 24 24"), _List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$fill_a0, "currentColor"), attributes)), _List_fromArray([
            A2($rtfeldman$elm_css$Svg$Styled$path, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$d_a0, "\n                M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z\n                m0 4l-8 5-8-5V6l8 5 8-5v2z\n                ")
            ]), _List_Nil)
        ]));
    };
    var $author$project$Svg$moveDown = function (attributes) {
        return $author$project$Svg$unfoldLess(_List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "6 12 12 12"), attributes));
    };
    var $author$project$Svg$moveUp = function (attributes) {
        return $author$project$Svg$unfoldLess(_List_Cons($rtfeldman$elm_css$VirtualDom$Styled$attribute_fn($rtfeldman$elm_css$Svg$Styled$Attributes$viewBox_a0, "6 0 12 12"), attributes));
    };
    var $author$project$Overlay$onContextMenu_fn = function (toMsg, model) {
        return _Utils_eq(model.a$, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("contextmenu", $elm$json$Json$Decode$succeed($author$project$Util$flip_fn($elm$core$Tuple$pair, true, toMsg(model.gd($author$project$Overlay$NoOp))))) : $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn_fn("contextmenu", _Json_map1_fn(A2($author$project$Util$flip, $elm$core$Tuple$pair, true), $author$project$Overlay$onOverlay_fn(A2($elm$core$Basics$composeL, toMsg, model.gd), $elm$core$Maybe$Nothing, model.a$)));
    }, $author$project$Overlay$onContextMenu = F2($author$project$Overlay$onContextMenu_fn);
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("border-top-left-radius", "0.25rem"),
        $rtfeldman$elm_css$Css$property_fn("border-top-right-radius", "0.25rem")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_inner = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow", "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow-colored", "inset 0 2px 4px 0 var(--tw-shadow-color)"),
        $rtfeldman$elm_css$Css$property_fn("box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ]));
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_none = $rtfeldman$elm_css$Css$batch(_List_fromArray([
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("--tw-shadow-colored", "0 0 #0000"),
        $rtfeldman$elm_css$Css$property_fn("box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ]));
    var $elm$core$List$unzip = function (pairs) {
        var aHead = _List_Cons(undefined, _List_Nil);
        var bHead = _List_Cons(undefined, _List_Nil);
        var aEnd = aHead;
        var bEnd = bHead;
        for (; pairs.b; pairs = pairs.b) {
            var tuple = pairs.a;
            var aNext = _List_Cons(tuple.a, _List_Nil);
            aEnd.b = aNext;
            aEnd = aNext;
            var bNext = _List_Cons(tuple.b, _List_Nil);
            bEnd.b = bNext;
            bEnd = bNext;
        }
        return _Utils_Tuple2(aHead.b, bHead.
            b);
    };
    var $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_10 = $rtfeldman$elm_css$Css$property_fn("z-index", "10");
    var $author$project$FocusView$view_fn = function (idxRow, tableType, columns, toMsg, model) {
        var background = $rtfeldman$elm_css$Html$Styled$div(_List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "focusview_bg"),
            $author$project$Util$onClickWithId_fn("focusview_bg", toMsg($author$project$FocusView$ViewClosed)),
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$absolute,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$top_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$left_0,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_30,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_1,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_5,
                $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_5])),
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center
            ]))
        ]));
        var _v0 = $elm$core$Tuple$mapSecond_fn($elm_community$maybe_extra$Maybe$Extra$values, $elm$core$List$unzip($elm$core$List$map_fn(function (column) {
            return _Utils_Tuple2(column.jx, A2($author$project$Types$Column$getCell, idxRow, column));
        }, columns)));
        var headers = _v0.a;
        var cells = _v0.b;
        var content = function () {
            var toHeader = function (header) {
                var dataTypeIcon = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($author$project$EditGrid$dataTypeIcon, toMsg, model.a$), A2($author$project$Types$Column$find, header, columns));
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$self_start,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_end,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_2,
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontFamily_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$fontSize_a0, $rtfeldman$elm_css$Css$inherit),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$lineHeight_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$em_a0, $rtfeldman$elm_css$Css$em_a1, 2)),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap
                    ]))
                ]), _List_fromArray([
                    dataTypeIcon,
                    $rtfeldman$elm_css$Html$Styled$text(header)
                ]));
            };
            var toCell = F2(function (idxCol, cell) {
                var pos = _Utils_Tuple2(idxRow, idxCol);
                var popupMenu = $author$project$FocusView$hasErrors(model) ? model.a$ : $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(model.a$, A2($elm$core$Basics$composeR, A3($author$project$EditGrid$cellMenuOptions, pos, tableType, cell), A2($elm$core$Basics$composeR, $elm$core$List$filter(function (_v2) {
                    var name = _v2.a;
                    return name !== "Focus";
                }), A2($elm$core$Basics$composeR, $elm$core$List$map(function (_v3) {
                    var a = _v3.a;
                    var b = _v3.b;
                    var c = _v3.c;
                    return _Utils_Tuple3(a, $author$project$FocusView$EditGridMsgReceived(b), c);
                }), $author$project$Overlay$popupMenu(model.a$)))), $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns));
                var onContextMenu = $author$project$Overlay$onContextMenu_fn(toMsg, popupMenu);
                var menuButton = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, "menu_button"),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, _Utils_eq(popupMenu.a$, $elm$core$Maybe$Nothing)),
                    $author$project$Overlay$onClick_fn(toMsg, popupMenu),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_2_dot_5,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0,
                        $rtfeldman$elm_css$Css$disabled(_List_fromArray([
                            $rtfeldman$elm_css$Css$Preprocess$mapProperties_fn($rtfeldman$elm_css$Css$important_a0, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_0),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none
                        ]))
                    ]))
                ]), _List_fromArray([
                    $author$project$Svg$menuDots(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ]))
                    ]))
                ]));
                var maybeInputElement = $author$project$Types$Column$getInputElement_fn(columns, idxCol);
                var maybeEdit = $elm_community$list_extra$List$Extra$find_fn($author$project$Types$Edit$samePos(pos), model.T);
                var maybeError = $elm$core$Maybe$andThen_fn(function ($) {
                    return $.fl;
                }, maybeEdit);
                var maybeErrorIcon = $elm$core$Maybe$map_fn(A2($author$project$EditGrid$errorIcon, toMsg, model.a$), maybeError);
                var isInputFile = _Utils_eq(maybeInputElement, $elm$core$Maybe$Just($author$project$Types$InputElement$InputFile));
                var isGenerated = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function ($) {
                    return $.cn;
                }, $elm_community$list_extra$List$Extra$getAt_fn(idxCol, columns)));
                var isFocusable = _Utils_eq($elm$core$Maybe$map_fn($author$project$Types$InputElement$isFocusable, maybeInputElement), $elm$core$Maybe$Just(true));
                var inputElement = $elm$core$Maybe$map_fn(A9($author$project$Types$InputElement$view, 1, A2($elm$core$Basics$composeL, toMsg, $author$project$FocusView$FocusField), A2($elm$core$Basics$composeL, toMsg, $author$project$FocusView$FieldEdited), A2($elm$core$Basics$composeL, toMsg, $author$project$FocusView$FieldEditApplied), toMsg($author$project$FocusView$FieldEditCanceled), A2($elm$core$Basics$composeL, toMsg, $author$project$FocusView$FieldFileUploaded), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, tableType), $author$project$Types$Column$getInputElement_fn(columns, idxCol));
                var errorColor = $elm$core$Maybe$map_fn($elm$core$Basics$always($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_500)), maybeError);
                var cellAsEdit = $author$project$Types$Edit$fromString_fn(pos, $elm$core$Maybe$withDefault_fn("", $author$project$Types$Cell$toMaybeString(cell)));
                var inputErrorColor = function () {
                    var isValid = $author$project$Types$Column$isValidEditAt_fn(columns, $elm$core$Maybe$withDefault_fn(cellAsEdit, maybeEdit));
                    return ($author$project$Types$TableType$isReadonly(tableType) || isValid) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300));
                }();
                var maybeBgColor = $elm_community$maybe_extra$Maybe$Extra$orElse_fn(errorColor, inputErrorColor);
                var inputAttributes = $author$project$Util$flip_fn($elm$core$List$cons, (($author$project$FocusView$hasErrors(model) && _Utils_eq(maybeError, $elm$core$Maybe$Nothing)) || isGenerated) ? _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$disabled_a0, true)
                ]) : _List_Nil, $rtfeldman$elm_css$Html$Styled$Attributes$css($elm$core$List$map_fn($rtfeldman$elm_css$Css$important, $elm_community$maybe_extra$Maybe$Extra$toList(maybeBgColor))));
                var addNullOverlay = function (element) {
                    var maybeNullOverlay = function () {
                        var baseStyles = function (_v1) {
                            return $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$italic,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_default,
                                $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$z_10,
                                isFocusable ? $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none : $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_auto
                            ]));
                        };
                        if (_Utils_eq(maybeEdit, $elm$core$Maybe$Nothing) && _Utils_eq($author$project$Types$Cell$isNull_a0, cell)) {
                            var attributes = isFocusable ? _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$FocusView$FieldEditStarted(cellAsEdit)))
                            ]) : (isInputFile ? _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                                ])),
                                $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$FocusView$MultiMsg(_List_fromArray([
                                    $author$project$FocusView$FieldEditStarted($author$project$Util$flip_fn($author$project$Types$Edit$empty_a0, $author$project$Types$Edit$empty_a1, pos)),
                                    $author$project$FocusView$FieldEdited($author$project$Util$flip_fn($author$project$Types$Edit$empty_a0, $author$project$Types$Edit$empty_a1, pos))
                                ]))))
                            ]) : _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100)
                                ])),
                                $rtfeldman$elm_css$Html$Styled$Events$onClick(toMsg($author$project$FocusView$FieldEditApplied($elm$core$Maybe$map_fn($author$project$Types$Edit$fromString(pos), $elm$core$Maybe$map_fn($author$project$Types$InputElement$defaultValue, maybeInputElement)))))
                            ]));
                            return $elm$core$Maybe$Just($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Cons(baseStyles(0), _List_Cons(onContextMenu, attributes)), _List_fromArray([
                                $rtfeldman$elm_css$Html$Styled$text("null")
                            ])));
                        }
                        else {
                            return $elm$core$Maybe$Nothing;
                        }
                    }();
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                            $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$children_a0, _List_fromArray([
                                $rtfeldman$elm_css$Css$Global$everything(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$col_start_1, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$row_start_1]))
                            ]))
                        ]))
                    ]), _List_fromArray([
                        element,
                        $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), maybeNullOverlay)
                    ]));
                };
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $rtfeldman$elm_css$Css$Preprocess$NestSnippet_fn($rtfeldman$elm_css$Css$Global$descendants_a0, _List_fromArray([
                                $rtfeldman$elm_css$Css$Global$selector_fn(".menu_button", _List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$opacity_100]))
                            ]))
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                        $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "auto 1fr")
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
                ]), _List_Cons(menuButton, $elm$core$List$singleton(addNullOverlay($elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm_community$maybe_extra$Maybe$Extra$or_fn(maybeEdit, $elm$core$Maybe$Just(cellAsEdit)), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(maybeErrorIcon), $elm$core$Maybe$map2_fn($elm_community$maybe_extra$Maybe$Extra$andMap_a0, $elm$core$Maybe$Just(inputAttributes), inputElement))))))));
            });
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_5])),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$py_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_5,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_cols_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$grid_flow_row,
                    $rtfeldman$elm_css$Css$property_fn("grid-template-columns", "min-content minmax(30ch, max-content)"),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$overflow_y_auto
                ]))
            ]), $elm$core$List$concat($elm_community$list_extra$List$Extra$transpose(_List_fromArray([
                $elm$core$List$map_fn(toHeader, headers),
                $elm$core$List$indexedMap_fn(toCell, cells)
            ]))));
        }();
        var toolBar = function () {
            var toButton = F4(function (hoverTitle, styles, msg, icon) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$title_a0, hoverTitle),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_6,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_6,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_full,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_inner,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_300),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500),
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$shadow_none
                        ])),
                        $rtfeldman$elm_css$Css$active(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ])),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $rtfeldman$elm_css$Css$batch(styles)
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
                ]), _List_fromArray([
                    icon(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_4]))
                    ]))
                ]));
            });
            var toLinkButton = F3(function (hoverTitle, url, icon) {
                return A4(toButton, hoverTitle, _List_Nil, $author$project$FocusView$NoOp, A2($elm$core$Basics$composeR, icon, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$a(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$href(url),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$m_auto
                    ]))
                ])))));
            });
            var mailtoLink = function () {
                var subject = $elm$url$Url$Builder$string_fn("subject", _String_append_fn("row_", $elm$core$String$fromInt(idxRow)));
                var body = $elm$url$Url$Builder$string_fn("body", $elm$core$String$join_fn("\n\n", $elm$core$List$map_fn($elm$core$String$join(":\n"), $elm_community$list_extra$List$Extra$transpose(_List_fromArray([
                    headers,
                    $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $author$project$Types$Cell$toMaybeString, $elm$core$Maybe$withDefault("null")), cells)
                ])))));
                return _String_append_fn("mailto:", $elm$url$Url$Builder$toQuery(_List_fromArray([subject, body])));
            }();
            return $rtfeldman$elm_css$VirtualDom$Styled$map_fn(toMsg, $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_1,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_x_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_2,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_600),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_200),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded_t
                ]))
            ]), _List_fromArray([
                A4(toButton, "Previous entry", _List_Nil, $author$project$FocusView$EditGridMsgReceived($author$project$EditGrid$FocusModeStarted_fn(idxRow - 1, $elm$core$Maybe$Nothing)), $author$project$Svg$moveUp),
                A4(toButton, "Next entry", _List_Nil, $author$project$FocusView$EditGridMsgReceived($author$project$EditGrid$FocusModeStarted_fn(idxRow + 1, $elm$core$Maybe$Nothing)), $author$project$Svg$moveDown),
                $author$project$Util$showElement_fn($author$project$Types$TableType$isMutable(tableType) && (!$elm$core$Set$member_fn(idxRow, model.bG)), A4(toButton, "Delete entry", _List_Nil, $author$project$FocusView$DeleteButtonToggled(idxRow), $author$project$Svg$trash)),
                $author$project$Util$showElement_fn($author$project$Types$TableType$isMutable(tableType) && $elm$core$Set$member_fn(idxRow, model.bG), A4(toButton, "Confirm delete entry", _List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$red_300)
                ]), function () {
                    var idxExists = A2($elm$core$Basics$composeR, $author$project$Types$Column$indexExists, A2($elm$core$Basics$composeR, A2($author$project$Util$flip, $elm$core$Maybe$map, $elm$core$List$head(columns)), $elm$core$Maybe$withDefault(false)));
                    var idxRowNext = idxExists(idxRow + 1) ? idxRow : (idxRow - 1);
                    return $author$project$FocusView$MultiMsg(_List_fromArray([
                        $author$project$FocusView$EditGridMsgReceived($author$project$EditGrid$FocusModeStarted_fn(idxRowNext, $elm$core$Maybe$Nothing)),
                        $author$project$FocusView$EditGridMsgReceived($author$project$EditGrid$RowsDeleted($elm$core$Maybe$Just(_List_fromArray([idxRow]))))
                    ]));
                }(), $author$project$Svg$trash)),
                A4(toButton, "Download entry as JSON", _List_Nil, $author$project$FocusView$EditGridMsgReceived($author$project$EditGrid$RowExported(idxRow)), $author$project$Svg$download),
                A3(toLinkButton, "Send entry via email", mailtoLink, $author$project$Svg$mail),
                $author$project$Svg$closeCircled(_List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$FocusView$ViewClosed),
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$ml_auto,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$neg_mr_1,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$black),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer
                    ]))
                ]))
            ])));
        }();
        return background(_List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_h_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_full,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$rounded,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_100),
                    $author$project$Theme$theme.of,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_solid,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$border_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                    $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col
                ]))
            ]), _List_fromArray([
                toolBar,
                content,
                $author$project$Overlay$view_fn(toMsg, model.a$)
            ]))
        ]));
    }, $author$project$FocusView$view = F5($author$project$FocusView$view_fn);
    var $author$project$GraphGrid$viewFocus_fn = function (maybeRouteRowId, toMsg, model) {
        var loadingView = function (_v0) {
            return (_Utils_eq(model.aq.ft, $elm$core$Maybe$Nothing) && (!_Utils_eq(maybeRouteRowId, $elm$core$Maybe$Nothing))) ? $author$project$GraphGrid$viewMessage_fn($elm$core$Maybe$Just(toMsg($author$project$GraphGrid$ClearRouteRowId)), model.bT ? "Loading..." : "Row not found") : $rtfeldman$elm_css$Html$Styled$text("");
        };
        return $elm$core$Maybe$withDefault_fn(loadingView(0), $elm$core$Maybe$map_fn(function (idxRow) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_Nil, _List_fromArray([
                $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), $elm$core$Basics$composeR_fn($author$project$GraphGrid$maybeUploadProgress_a0, $author$project$GraphGrid$maybeUploadProgress_a1, model.bp)),
                $author$project$FocusView$view_fn(idxRow, model.o8, model.iT, A2($elm$core$Basics$composeL, toMsg, $author$project$GraphGrid$FocusViewMsgReceived), model.aq)
            ]));
        }, $elm_community$maybe_extra$Maybe$Extra$orElse_fn(model.aq.ft, $elm$core$Maybe$andThen_fn($author$project$GraphGrid$findIdxRow(model), maybeRouteRowId))));
    }, $author$project$GraphGrid$viewFocus = F3($author$project$GraphGrid$viewFocus_fn);
    var $author$project$Pages$Tables$view_fn = function (route, database, toMsg, shared, model) {
        var tables = function () {
            var tablesViewsFilter = $author$project$Route$isTablesRoute(route) ? $author$project$Types$Database$keepTablesIfViewsTabExists : $author$project$Types$Database$keepViews;
            return $krisajenkins$remotedata$RemoteData$unwrap_fn(_List_Nil, function ($) {
                return $.eH;
            }, tablesViewsFilter(database));
        }();
        var tableView = $author$project$Route$isTablesRoute(route) ? "table" : "view";
        var focusView = function (_v2) {
            return _List_fromArray([
                $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($author$project$GraphGrid$viewFocus, $author$project$Route$toTableRow(route), A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Tables$GraphGridMsgReceived)), model.aH)
            ]);
        };
        var emptyStateView = function (_v1) {
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_24, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$gap_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center]))
            ]), _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h2_a0, _List_Nil, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("No " + (tableView + "s yet"))
                ])),
                $rtfeldman$elm_css$Html$Styled$text("Create a new " + (tableView + " to get started")),
                $author$project$Util$collapseElement_fn(!$author$project$Route$isTablesRoute(route), $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$author$project$Theme$theme.kX, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$whitespace_nowrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$max_w_min])),
                    $author$project$Overlay$onTriggerEvent_fn("click", toMsg, $author$project$Overlay$showBelow_fn($author$project$Pages$Tables$addTableOverlay(_Utils_update(model, { bm: $author$project$Types$TableEdit$empty })), model.aA))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("+ Create Table")
                ])))
            ]));
        };
        var activeTableView = $author$project$Route$isTablesRoute(route) ? model.dy : model.dz;
        var tableLoaded = $author$project$Types$Database$tableLoaded_fn(activeTableView, database);
        var tableLoading = $author$project$Types$Database$tableLoading_fn(activeTableView, database);
        var tabs = function () {
            var schemaLocked = $krisajenkins$remotedata$RemoteData$unwrap_fn($author$project$Types$Database$hasLockedSchema_a0, $author$project$Types$Database$hasLockedSchema_a1, database);
            var addTableViewButton = function (_v0) {
                var isViewsRoute = $author$project$Route$isViewsRoute(route);
                var onClick = isViewsRoute ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Overlay$onTriggerEvent_fn("click", toMsg, $author$project$Overlay$showBelow_fn($author$project$Pages$Tables$addTableOverlay(_Utils_update(model, { bm: $author$project$Types$TableEdit$empty })), model.aA)));
                var btn = $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$button_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_8,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$p_2,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$justify_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$cursor_pointer,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$bg_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$transparent),
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_400),
                        $rtfeldman$elm_css$Css$hover(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_color($matheus23$elm_default_tailwind_modules$Tailwind$Theme$gray_500)
                        ]))
                    ])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$id_a0, "add-" + (tableView + "-button")),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
                    $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$VirtualDom$Styled$style_fn("", ""), onClick)
                ]), _List_fromArray([
                    $author$project$Svg$plus(_List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_3, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pointer_events_none]))
                    ]))
                ]));
                return isViewsRoute ? $krisajenkins$remotedata$RemoteData$unwrap_fn(btn, function (db) {
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$a_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Route$toUrlPath($author$project$Route$Queries_fn(db.bR, $elm$core$Maybe$Nothing))),
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$mt_1_dot_5]))
                    ]), _List_fromArray([btn]));
                }, database) : btn;
            };
            return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_wrap, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$px_4]))
            ]), ((schemaLocked || $elm$core$List$isEmpty(tables)) ? $elm$core$Basics$identity : A2($author$project$Util$flip, $elm$core$List$append, _List_fromArray([
                addTableViewButton(0)
            ])))($elm$core$List$map_fn(A6($author$project$Pages$Tables$toTab, toMsg, tables, shared, model, activeTableView, schemaLocked), tables)));
        }();
        var toolbar = (shared.aQ.mx.pt && (!_Utils_eq(model.aH, $elm$core$Maybe$Nothing))) ? $rtfeldman$elm_css$VirtualDom$Styled$map_fn(A2($elm$core$Basics$composeR, $author$project$Pages$Tables$ToolbarMsgReceived, toMsg), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($author$project$Components$Toolbar$placeholderView, $author$project$Components$Toolbar$view, $elm$core$Dict$get_fn(activeTableView, model.Z))) : $rtfeldman$elm_css$Html$Styled$text("");
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$pt_4, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_full, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col]))
        ]), _Utils_ap(_List_fromArray([
            tabs,
            toolbar,
            $author$project$Overlay$view_fn(toMsg, model.aA),
            A2($author$project$Components$AiEditorOverlay$view, toMsg, model.ce),
            $author$project$Overlay$view_fn(toMsg, model.a$)
        ]), ($krisajenkins$remotedata$RemoteData$isLoading(database) || (tableLoaded || tableLoading)) ? $author$project$Util$flip_fn($elm$core$List$append, focusView(0), _List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($rtfeldman$elm_css$Html$Styled$text(""), A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Lazy$lazy($author$project$GraphGrid$view), $rtfeldman$elm_css$Html$Styled$map(A2($elm$core$Basics$composeL, toMsg, $author$project$Pages$Tables$GraphGridMsgReceived))), model.aH)
        ])) : (((activeTableView !== "") && (!_Utils_eq(model.dc, _List_Nil))) ? _List_fromArray([
            $author$project$Components$wrapErrors(model.dc)
        ]) : ($elm$core$List$isEmpty(tables) ? _List_fromArray([
            emptyStateView(0)
        ]) : _List_Nil))));
    }, $author$project$Pages$Tables$view = F5($author$project$Pages$Tables$view_fn);
    var $author$project$Main$viewTabs_fn = function (dbId, model) {
        return $author$project$Components$wrapTabsWithMain_fn(model.b.aQ, model.j, $author$project$TabView$tabView_fn({ gC: _List_Nil, mG: _List_Nil, nH: $elm$core$Maybe$Nothing, o5: _List_Nil, o6: _List_Nil }, model, _List_fromArray([
            function () {
                var viewDatabase = function (databasePageModel) {
                    return $author$project$Pages$Database$view({
                        j: model.j,
                        hr: model.p,
                        nu: databasePageModel,
                        b: model.b,
                        h5: !_Utils_eq(model.a3, $elm$core$Maybe$Nothing),
                        pf: model.pf,
                        gd: $author$project$Msg$DatabasePageMsgReceived,
                        bF: model.bF
                    });
                };
                return {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: $elm$core$Basics$always(false),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.b;
                    }, A2($elm$core$Basics$composeR, function ($) {
                        return $.eu;
                    }, $author$project$Route$isDatabaseRoute)),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Database(dbId))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Database",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.gF;
                    }, viewDatabase)
                };
            }(),
            {
                cd: $elm$core$Basics$always(false),
                fq: true,
                fr: $elm$core$Basics$always(false),
                fw: A2($elm$core$Basics$composeR, function ($) {
                    return $.b;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.eu;
                }, $author$project$Route$isTablesRoute)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Tables_fn(dbId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Tables",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.eI;
                }, A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Pages$Tables$view, model.b.eu, model.j, $author$project$Msg$TablesPageMsgReceived, model.b))
            },
            {
                cd: $elm$core$Basics$always(false),
                fq: true,
                fr: A2($elm$core$Basics$composeR, function ($) {
                    return $.j;
                }, A2($elm$core$Basics$composeR, A2($krisajenkins$remotedata$RemoteData$unwrap, false, A2($elm$core$Basics$composeR, function ($) {
                    return $.kR;
                }, function ($) {
                    return $.pD;
                })), $elm$core$Basics$not)),
                fw: A2($elm$core$Basics$composeR, function ($) {
                    return $.b;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.eu;
                }, $author$project$Route$isViewsRoute)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Views_fn(dbId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Views",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.eI;
                }, A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Pages$Tables$view, model.b.eu, model.j, $author$project$Msg$TablesPageMsgReceived, model.b))
            },
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always(false),
                fw: A2($elm$core$Basics$composeR, function ($) {
                    return $.b;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.eu;
                }, $author$project$Route$isQueriesRoute)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Queries_fn(dbId, $elm$core$Maybe$Nothing))),
                ke: $elm$core$Maybe$Nothing,
                eM: "SQL Queries",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.hQ;
                }, A2($elm$core$Basics$composeR, A3($author$project$Pages$Queries$view, dbId, model.j, $author$project$Route$getQueriesRouteTab(model.b.eu)), $rtfeldman$elm_css$Html$Styled$map($author$project$Msg$QueriesPageMsgReceived)))
            },
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always(false),
                fw: A2($elm$core$Basics$composeR, function ($) {
                    return $.b;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.eu;
                }, $author$project$Route$isGraphiQLRoute)),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$GraphiQL(dbId))),
                ke: $elm$core$Maybe$Nothing,
                eM: "GraphiQL",
                gl: function (_v0) {
                    var sessionToken = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", $author$project$Types$SessionToken$toString, model.b.k2);
                    return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                        $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                            $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_full,
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$calc_fn($rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100), $rtfeldman$elm_css$Css$minus, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 6)))
                        ]))
                    ]), _List_fromArray([
                        $author$project$Main$graphiqlPlayground_fn(sessionToken, $author$project$Types$Database$unwrapId(dbId))
                    ]));
                }
            },
            function () {
                var onDelete = function (app) {
                    return $author$project$Msg$SetDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", $author$project$Msg$AppsPageMsgReceived($author$project$Pages$Apps$DeleteApp(dbId)), $author$project$Components$ConfirmDialog$AppContext(app))));
                };
                return {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: A2($elm$core$Basics$composeR, $author$project$Model$featureApps, $elm$core$Basics$not),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.b;
                    }, A2($elm$core$Basics$composeR, function ($) {
                        return $.eu;
                    }, $author$project$Route$isAppsRoute)),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Apps_fn(dbId, $elm$core$Maybe$Nothing))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Apps",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.gp;
                    }, A5($author$project$Pages$Apps$view, $author$project$Msg$AppsPageMsgReceived, onDelete, model.b.eu, dbId, model.b.aQ.mx.ja))
                };
            }(),
            function () {
                var onDelete = function (_function) {
                    return $author$project$Msg$SetDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", $author$project$Msg$FunctionsPageMsgReceived($author$project$Pages$Functions$DeleteFunction(dbId)), $author$project$Components$ConfirmDialog$FunctionContext(_function))));
                };
                return {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: A2($elm$core$Basics$composeR, $author$project$Model$featureFunctions, $elm$core$Basics$not),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.b;
                    }, A2($elm$core$Basics$composeR, function ($) {
                        return $.eu;
                    }, $author$project$Route$isFunctionsRoute)),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Functions_fn(dbId, $author$project$Pages$Functions$Route$Overview))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Functions",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.gW;
                    }, A4($author$project$Pages$Functions$view, $author$project$Msg$FunctionsPageMsgReceived, onDelete, dbId, model.b))
                };
            }(),
            {
                cd: $elm$core$Basics$always(false),
                fq: false,
                fr: $elm$core$Basics$always(false),
                fw: A2($elm$core$Basics$composeR, function ($) {
                    return $.b;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.eu;
                }, A2($elm$core$Basics$composeR, $author$project$Route$getDashboardsRoute, $elm_community$maybe_extra$Maybe$Extra$isJust))),
                a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Dashboards_fn(dbId, $elm$core$Maybe$Nothing))),
                ke: $elm$core$Maybe$Nothing,
                eM: "Dashboards",
                gl: A2($elm$core$Basics$composeR, function ($) {
                    return $.gD;
                }, A2($author$project$Pages$Dashboards$view, {
                    i2: dbId,
                    ja: model.b.aQ.mx.ja,
                    eH: $krisajenkins$remotedata$RemoteData$unwrap_fn(_List_Nil, function ($) {
                        return $.eH;
                    }, model.j),
                    gd: $author$project$Msg$DashboardsPageMsgReceived
                }, $elm$core$Maybe$withDefault_fn($author$project$Pages$Dashboards$Route$Overview, $author$project$Route$getDashboardsRoute(model.b.eu))))
            },
            function () {
                var onVisibilityChange = F2(function (visibility, database) {
                    var action = function () {
                        if (!visibility) {
                            return "unpublish";
                        }
                        else {
                            return "publish";
                        }
                    }();
                    return $author$project$Msg$SetDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn(action, $author$project$Msg$DatabaseVisibilityModified_fn(visibility, database), $author$project$Components$ConfirmDialog$DatabaseContext_fn(model.pf, database))));
                });
                var onReplace = A2($elm$core$Basics$composeR, $author$project$Components$ConfirmDialog$DatabaseContext(model.pf), A2($elm$core$Basics$composeR, A2($author$project$Dialog$ConfirmDialog, "replace", $author$project$Msg$Pick_fn(1, $author$project$Types$UploadType$Replacement(0), $elm$core$Maybe$Nothing)), A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Msg$SetDialog)));
                var onRegenerateReadonlyId = A2($elm$core$Basics$composeR, $author$project$Components$ConfirmDialog$DatabaseReadonlyIDContext(model.pf), A2($elm$core$Basics$composeR, A2($author$project$Dialog$ConfirmDialog, "regenerate", $author$project$Msg$RegenerateReadonlyID(dbId)), A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Msg$SetDialog)));
                var onRegenerateDbId = A2($elm$core$Basics$composeR, $author$project$Components$ConfirmDialog$DatabaseIDContext(model.pf), A2($elm$core$Basics$composeR, A2($author$project$Dialog$ConfirmDialog, "regenerate", $author$project$Msg$RegenerateDatabaseID(dbId)), A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Msg$SetDialog)));
                var onDelete = function (database) {
                    return $author$project$Msg$SetDialog($elm$core$Maybe$Just($author$project$Dialog$ConfirmDialog_fn("delete", $author$project$Msg$DatabaseDeletionRequested(database), $author$project$Components$ConfirmDialog$DatabaseContext_fn(model.pf, database))));
                };
                var viewSettings = $author$project$Pages$Settings$view({
                    dW: $author$project$Route$getSettingsRoute(model.b.eu),
                    j: model.j,
                    mx: model.b.aQ.mx,
                    hr: model.p,
                    kg: onDelete,
                    nY: $author$project$Msg$DatabaseOwnerSubmitted($author$project$Msg$SetDialog($elm$core$Maybe$Nothing)),
                    n_: onRegenerateDbId,
                    n$: onRegenerateReadonlyId,
                    n0: onReplace,
                    n7: onVisibilityChange,
                    oQ: $author$project$Msg$SetDialog,
                    h5: !_Utils_eq(model.a3, $elm$core$Maybe$Nothing),
                    pf: model.pf,
                    gd: $author$project$Msg$SettingsPageMsgReceived,
                    bF: model.bF
                });
                return {
                    cd: $elm$core$Basics$always(false),
                    fq: false,
                    fr: $elm$core$Basics$always(false),
                    fw: A2($elm$core$Basics$composeR, function ($) {
                        return $.b;
                    }, A2($elm$core$Basics$composeR, function ($) {
                        return $.eu;
                    }, $author$project$Route$isSettingsRoute)),
                    a_: $elm$core$Basics$always($author$project$TabView$RouteTo($author$project$Route$Settings_fn(dbId, $author$project$Route$getSettingsRoute(model.b.eu)))),
                    ke: $elm$core$Maybe$Nothing,
                    eM: "Settings",
                    gl: A2($elm$core$Basics$composeR, function ($) {
                        return $.hY;
                    }, viewSettings)
                };
            }()
        ])));
    }, $author$project$Main$viewTabs = F2($author$project$Main$viewTabs_fn);
    var $author$project$Main$viewBody = function (model) {
        var notFoundView = $author$project$Components$fullScreen_fn(_List_Nil, _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$main__a0, _List_Nil, _List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$h1_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_2xl,
                        $matheus23$elm_default_tailwind_modules$Tailwind$Breakpoints$sm(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$text_3xl]))
                    ]))
                ]), _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$text("Error: This page does not exist")
                ]))
            ]))
        ]));
        var _v0 = model.b.eu;
        switch (_v0.$) {
            case 1:
                return $rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$HomePageMsgReceived, $author$project$Pages$Home$view_fn(model.a3, model.bF, model.p, model.b, model.g1));
            case 2:
                var _v1 = model.b.aQ.mx.ja;
                if (!_v1.$) {
                    return $author$project$Pages$Affiliate$view(model);
                }
                else {
                    return notFoundView;
                }
            case 3:
                var _v2 = model.b.aQ.mx.ja;
                if (!_v2.$) {
                    return $author$project$Pages$Pricing$view(model);
                }
                else {
                    return notFoundView;
                }
            case 4:
                var _v3 = model.b.aQ.mx.ja;
                if (!_v3.$) {
                    if (!_v3.a.$) {
                        var _v4 = _v3.a;
                        return $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$TrialPageMsgReceived, $author$project$Pages$Trial$view(model.im))));
                    }
                    else {
                        return notFoundView;
                    }
                }
                else {
                    return notFoundView;
                }
            case 5:
                return $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$SignupPageMsgReceived, $author$project$Pages$Signup$view(model.h_))));
            case 6:
                return $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$LoginPageMsgReceived, $author$project$Pages$Login$view(model.hn))));
            case 7:
                return $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$ForgotPasswordPageMsgReceived, $author$project$Pages$ForgotPassword$view(model.gU))));
            case 8:
                var maybeUsername = _v0.a;
                return (!model.b.aQ.mx.ip) ? notFoundView : $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$UsersPageMsgReceived, $author$project$Pages$Users$view_fn(maybeUsername, model.p, model.gj))));
            case 9:
                var subRoute = _v0.a;
                var _v5 = model.p;
                if (_v5.$ === 1) {
                    return notFoundView;
                }
                else {
                    var user = _v5.a;
                    return $author$project$Components$wrapWithMain_fn(model.b.eu, $elm$core$List$singleton($rtfeldman$elm_css$VirtualDom$Styled$map_fn($author$project$Msg$TeamsPageMsgReceived, $author$project$Pages$Teams$view_fn(model.a3, model.bF, user, subRoute, model.b, model.f9))));
                }
            case 10:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 11:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 12:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 13:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 14:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 15:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 16:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 17:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 18:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 19:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 20:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 21:
                var dbId = _v0.a;
                return $author$project$Model$featureApps(model) ? $author$project$Main$viewTabs_fn(dbId, model) : notFoundView;
            case 22:
                return $rtfeldman$elm_css$Html$Styled$text("");
            case 23:
                var dbId = _v0.a;
                return $author$project$Model$featureFunctions(model) ? $author$project$Main$viewTabs_fn(dbId, model) : notFoundView;
            case 24:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 25:
                var dbId = _v0.a;
                return $author$project$Main$viewTabs_fn(dbId, model);
            case 26:
                var subRoute = _v0.a;
                var isShared = $author$project$Types$Edition$isShared(model.b.aQ.mx.ja);
                var isBillingRoute = $author$project$Pages$Admin$Route$isBillingRoute(subRoute);
                var isAdmin = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, $author$project$Types$User$isAdmin, model.p);
                return (isAdmin && (!(isShared && isBillingRoute))) ? $author$project$Pages$Admin$view_fn($author$project$Msg$AdminPageMsgReceived, subRoute, model.b, model.gn) : notFoundView;
            default:
                return notFoundView;
        }
    };
    var $author$project$Main$view = function (model) {
        var userPreloader = function () {
            var userIsLoading = (!_Utils_eq(model.b.k2, $elm$core$Maybe$Nothing)) && _Utils_eq(model.p, $elm$core$Maybe$Nothing);
            return ((!userIsLoading) || $author$project$Route$isAuthFree(model.b.eu)) ? $rtfeldman$elm_css$Html$Styled$text("") : $author$project$Components$fullScreen_fn(_List_Nil, _List_fromArray([$author$project$Components$pageSpinner]));
        }();
        var userMenu = $rtfeldman$elm_css$VirtualDom$Styled$lazy2_fn($author$project$Overlay$view, $elm$core$Basics$identity, model.eU);
        var sessionStatus = $rtfeldman$elm_css$VirtualDom$Styled$lazy4_fn($author$project$Components$sessionStatus, $author$project$Msg$UserMenuOpened, model.b.eu, model.p, model.j);
        var notifications = $rtfeldman$elm_css$VirtualDom$Styled$lazy2_fn($author$project$Overlay$view, $elm$core$Basics$identity, model.a$);
        var maybeDialogs = $elm$core$Maybe$map_fn(A2($author$project$Dialog$view, $elm$core$Maybe$andThen_fn(function ($) {
            return $.fT;
        }, model.a3), $author$project$Msg$SetDialog($elm$core$Maybe$Nothing)), model.mc);
        var globalStyles = $rtfeldman$elm_css$VirtualDom$Styled$lazy_fn($rtfeldman$elm_css$Css$Global$global, $author$project$Styles$global);
        return {
            d: _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$toUnstyled($rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([$matheus23$elm_default_tailwind_modules$Tailwind$Utilities$relative, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$w_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$h_screen, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$flex_col, $matheus23$elm_default_tailwind_modules$Tailwind$Utilities$items_center])),
                    $rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
                ]), _List_fromArray([
                    globalStyles,
                    notifications,
                    userMenu,
                    sessionStatus,
                    $author$project$Main$viewBody(model),
                    $elm$core$Maybe$withDefault_fn($rtfeldman$elm_css$Html$Styled$text(""), maybeDialogs),
                    userPreloader
                ])))
            ]),
            eM: $krisajenkins$remotedata$RemoteData$unwrap_fn("Airsequel", function ($) {
                return $.mw;
            }, model.j)
        };
    };
    var $author$project$Main$main = $elm$browser$Browser$application({ mM: $author$project$Main$init, n5: $author$project$Msg$UrlChanged, n6: $author$project$Msg$LinkClicked, o4: $author$project$Main$subscriptions, pw: $author$project$Main$update, gl: $author$project$Main$view });
    _Platform_export({ "Main": { "init": $author$project$Main$main($elm$json$Json$Decode$value)(0) } });
}(this));
